
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9ef3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9ef3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.0-next-8a015b68cc-20240425"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.0-next-8a015b68cc-20240425";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("5Gn6I", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRegister("8RYFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $675256233f0d2ee0$export$2e2bcd8739ae039);

var $gvVBt = parcelRequire("gvVBt");
var $675256233f0d2ee0$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $675256233f0d2ee0$var$index = (0, $gvVBt.default)(function(prop) {
    return $675256233f0d2ee0$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $675256233f0d2ee0$export$2e2bcd8739ae039 = $675256233f0d2ee0$var$index;

});
parcelRegister("gvVBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05c3971f0aa92b4$export$2e2bcd8739ae039);
function $c05c3971f0aa92b4$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $c05c3971f0aa92b4$export$2e2bcd8739ae039 = $c05c3971f0aa92b4$var$memoize;

});


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $7d1154ab70079230$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $76500f1a9bc57c92$var$isBrowser = typeof document !== "undefined";
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($76500f1a9bc57c92$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-item-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "stretch") ? $76500f1a9bc57c92$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $7d1154ab70079230$export$2e2bcd8739ae039)(function() {
    return (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if ($76500f1a9bc57c92$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
            (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $e19976245606d3d7$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


var $72623ab6bcb0a33b$exports = {};
"use strict";
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};


var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== "undefined";
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, "-$&").toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}



var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== "undefined";
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;


var $0fe24a6591b39473$export$23f2a1d2818174ef = true;
var $0fe24a6591b39473$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $0fe24a6591b39473$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $76500f1a9bc57c92$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $0fe24a6591b39473$export$e7094788287c5e9b = $0fe24a6591b39473$var$EmotionCacheContext.Provider;
var $0fe24a6591b39473$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
};
var $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$0fe24a6591b39473$export$23f2a1d2818174ef) $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $76500f1a9bc57c92$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $0fe24a6591b39473$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $0fe24a6591b39473$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
};
var $0fe24a6591b39473$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $0fe24a6591b39473$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $0fe24a6591b39473$var$getTheme(outerTheme, theme);
    });
});
var $0fe24a6591b39473$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $0fe24a6591b39473$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $0fe24a6591b39473$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $0fe24a6591b39473$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]);
    return undefined;
};
var $0fe24a6591b39473$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $0fe24a6591b39473$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $0fe24a6591b39473$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($0fe24a6591b39473$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $0fe24a6591b39473$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $0fe24a6591b39473$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$0fe24a6591b39473$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $0fe24a6591b39473$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $5f1e384d41b6dbd9$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $1b59f2f50af460c0$export$db21c7ffa21794e7)(function() {
        return (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $0fe24a6591b39473$var$Emotion = /* #__PURE__ */ $0fe24a6591b39473$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$0fe24a6591b39473$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $5f1e384d41b6dbd9$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $0fe24a6591b39473$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $0fe24a6591b39473$export$a9c23c6ac3fc3eca = $0fe24a6591b39473$var$Emotion;



var $acw62 = parcelRequire("acw62");




var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    return $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;





var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $0fe24a6591b39473$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $0fe24a6591b39473$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $0fe24a6591b39473$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $acw62.createElement.apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7)));
    if (!(0, $0fe24a6591b39473$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $1b59f2f50af460c0$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $1b59f2f50af460c0$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $62578605b07c8dad$export$6321afa313b251b5)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $5f1e384d41b6dbd9$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $1b59f2f50af460c0$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $5f1e384d41b6dbd9$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isTestEnv, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;



"use client";
var $c3e440ef7c3cf4d3$var$css = String.raw;
var $c3e440ef7c3cf4d3$var$vhPolyfill = $c3e440ef7c3cf4d3$var$css`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`;
var $c3e440ef7c3cf4d3$export$43a6590e493ec44a = ()=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: $c3e440ef7c3cf4d3$var$vhPolyfill
    });
var $c3e440ef7c3cf4d3$export$b751feffed387621 = ({ scope: scope = "" })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: $c3e440ef7c3cf4d3$var$css`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${scope} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${scope} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${scope} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${scope} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${scope} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${scope} :where(b, strong) {
        font-weight: bold;
      }

      ${scope} small {
        font-size: 80%;
      }

      ${scope} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${scope} sub {
        bottom: -0.25em;
      }

      ${scope} sup {
        top: -0.5em;
      }

      ${scope} img {
        border-style: none;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${scope} :where(button, input) {
        overflow: visible;
      }

      ${scope} :where(button, select) {
        text-transform: none;
      }

      ${scope} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${scope} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${scope} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${scope} progress {
        vertical-align: baseline;
      }

      ${scope} textarea {
        overflow: auto;
      }

      ${scope} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${scope} input[type="number"]::-webkit-inner-spin-button,
      ${scope} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${scope} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${scope} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${scope} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${scope} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${scope} details {
        display: block;
      }

      ${scope} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${scope} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${scope} button {
        background: transparent;
        padding: 0;
      }

      ${scope} fieldset {
        margin: 0;
        padding: 0;
      }

      ${scope} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${scope} textarea {
        resize: vertical;
      }

      ${scope} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${scope} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${scope} table {
        border-collapse: collapse;
      }

      ${scope} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${scope} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${scope} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${scope} select::-ms-expand {
        display: none;
      }

      ${$c3e440ef7c3cf4d3$var$vhPolyfill}
    `
    });
var $c3e440ef7c3cf4d3$export$428e8dbfc1580f11 = $c3e440ef7c3cf4d3$export$b751feffed387621;



var $acw62 = parcelRequire("acw62");
"use client";
function $61ba61605ac0202a$var$getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function $61ba61605ac0202a$export$fd42f52fd3ae1109(options = {}) {
    const { name: name, strict: strict = true, hookName: hookName = "useContext", providerName: providerName = "Provider", errorMessage: errorMessage, defaultValue: defaultValue } = options;
    const Context = (0, $acw62.createContext)(defaultValue);
    Context.displayName = name;
    function useContext() {
        var _a;
        const context = (0, $acw62.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage != null ? errorMessage : $61ba61605ac0202a$var$getErrorMessage(hookName, providerName));
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}



"use client";
var [$cb17b1dba222b22e$var$PortalManagerContextProvider, $cb17b1dba222b22e$export$ef203b29c2cc1f5d] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalManagerContext"
});
function $cb17b1dba222b22e$export$52c7ef79917c2f38(props) {
    const { children: children, zIndex: zIndex } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($cb17b1dba222b22e$var$PortalManagerContextProvider, {
        value: {
            zIndex: zIndex
        },
        children: children
    });
}
$cb17b1dba222b22e$export$52c7ef79917c2f38.displayName = "PortalManager";



var $acw62 = parcelRequire("acw62");
"use client";
var $b80b1cf263c5808a$export$49ddd74a6729fdb0 = (0, $acw62.createContext)({});
$b80b1cf263c5808a$export$49ddd74a6729fdb0.displayName = "ColorModeContext";
function $b80b1cf263c5808a$export$20f3076712c8dfa() {
    const context = (0, $acw62.useContext)($b80b1cf263c5808a$export$49ddd74a6729fdb0);
    if (context === void 0) throw new Error("useColorMode must be used within a ColorModeProvider");
    return context;
}
function $b80b1cf263c5808a$export$d18f2ef57b0d7644(light, dark) {
    const { colorMode: colorMode } = $b80b1cf263c5808a$export$20f3076712c8dfa();
    return colorMode === "dark" ? dark : light;
}


"use client";
// src/color-mode.utils.ts
var $62ca5ae58df67fd2$var$classNames = {
    light: "chakra-ui-light",
    dark: "chakra-ui-dark"
};
function $62ca5ae58df67fd2$export$4bb933d353baa01c(options = {}) {
    const { preventTransition: preventTransition = true } = options;
    const utils = {
        setDataset: (value)=>{
            const cleanup = preventTransition ? utils.preventTransition() : void 0;
            document.documentElement.dataset.theme = value;
            document.documentElement.style.colorScheme = value;
            cleanup == null || cleanup();
        },
        setClassName (dark) {
            document.body.classList.add(dark ? $62ca5ae58df67fd2$var$classNames.dark : $62ca5ae58df67fd2$var$classNames.light);
            document.body.classList.remove(dark ? $62ca5ae58df67fd2$var$classNames.light : $62ca5ae58df67fd2$var$classNames.dark);
        },
        query () {
            return window.matchMedia("(prefers-color-scheme: dark)");
        },
        getSystemTheme (fallback) {
            var _a;
            const dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
            return dark ? "dark" : "light";
        },
        addListener (fn) {
            const mql = utils.query();
            const listener = (e)=>{
                fn(e.matches ? "dark" : "light");
            };
            if (typeof mql.addListener === "function") mql.addListener(listener);
            else mql.addEventListener("change", listener);
            return ()=>{
                if (typeof mql.removeListener === "function") mql.removeListener(listener);
                else mql.removeEventListener("change", listener);
            };
        },
        preventTransition () {
            const css = document.createElement("style");
            css.appendChild(document.createTextNode(`*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`));
            document.head.appendChild(css);
            return ()=>{
                (()=>window.getComputedStyle(document.body))();
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        document.head.removeChild(css);
                    });
                });
            };
        }
    };
    return utils;
}


"use client";
// src/storage-manager.ts
var $961ae7cfe6b3d4e3$export$86880b4b2e1a2384 = "chakra-ui-color-mode";
function $961ae7cfe6b3d4e3$export$cdf53b88b62eb393(key) {
    return {
        ssr: false,
        type: "localStorage",
        get (init) {
            if (!(globalThis == null ? void 0 : globalThis.document)) return init;
            let value;
            try {
                value = localStorage.getItem(key) || init;
            } catch (e) {}
            return value || init;
        },
        set (value) {
            try {
                localStorage.setItem(key, value);
            } catch (e) {}
        }
    };
}
var $961ae7cfe6b3d4e3$export$8e35886de8a54f45 = $961ae7cfe6b3d4e3$export$cdf53b88b62eb393($961ae7cfe6b3d4e3$export$86880b4b2e1a2384);
function $961ae7cfe6b3d4e3$var$parseCookie(cookie, key) {
    const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
    return match == null ? void 0 : match[2];
}
function $961ae7cfe6b3d4e3$export$df28b7d6efe2673c(key, cookie) {
    return {
        ssr: !!cookie,
        type: "cookie",
        get (init) {
            if (cookie) return $961ae7cfe6b3d4e3$var$parseCookie(cookie, key);
            if (!(globalThis == null ? void 0 : globalThis.document)) return init;
            return $961ae7cfe6b3d4e3$var$parseCookie(document.cookie, key) || init;
        },
        set (value) {
            document.cookie = `${key}=${value}; max-age=31536000; path=/`;
        }
    };
}
var $961ae7cfe6b3d4e3$export$2e2b0158437077e3 = $961ae7cfe6b3d4e3$export$df28b7d6efe2673c($961ae7cfe6b3d4e3$export$86880b4b2e1a2384);
var $961ae7cfe6b3d4e3$export$d76e8eed3e914fa0 = (cookie)=>$961ae7cfe6b3d4e3$export$df28b7d6efe2673c($961ae7cfe6b3d4e3$export$86880b4b2e1a2384, cookie);



var $acw62 = parcelRequire("acw62");
"use client";
var $79d69f59c8a92bff$export$deebe11a338de063 = Boolean(globalThis == null ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");

"use client";
var $78f995395c70cd91$var$noop = ()=>{};
function $78f995395c70cd91$var$getTheme(manager, fallback) {
    return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function $78f995395c70cd91$export$7a858aa3ff83dde7(props) {
    const { value: value, children: children, options: { useSystemColorMode: useSystemColorMode, initialColorMode: initialColorMode, disableTransitionOnChange: disableTransitionOnChange } = {}, colorModeManager: colorModeManager = (0, $961ae7cfe6b3d4e3$export$8e35886de8a54f45) } = props;
    const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
    const [colorMode, rawSetColorMode] = (0, $acw62.useState)(()=>$78f995395c70cd91$var$getTheme(colorModeManager, defaultColorMode));
    const [resolvedColorMode, setResolvedColorMode] = (0, $acw62.useState)(()=>$78f995395c70cd91$var$getTheme(colorModeManager));
    const { getSystemTheme: getSystemTheme, setClassName: setClassName, setDataset: setDataset, addListener: addListener } = (0, $acw62.useMemo)(()=>(0, $62ca5ae58df67fd2$export$4bb933d353baa01c)({
            preventTransition: disableTransitionOnChange
        }), [
        disableTransitionOnChange
    ]);
    const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
    const setColorMode = (0, $acw62.useCallback)((value2)=>{
        const resolved = value2 === "system" ? getSystemTheme() : value2;
        rawSetColorMode(resolved);
        setClassName(resolved === "dark");
        setDataset(resolved);
        colorModeManager.set(resolved);
    }, [
        colorModeManager,
        getSystemTheme,
        setClassName,
        setDataset
    ]);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (initialColorMode === "system") setResolvedColorMode(getSystemTheme());
    }, []);
    (0, $acw62.useEffect)(()=>{
        const managerValue = colorModeManager.get();
        if (managerValue) {
            setColorMode(managerValue);
            return;
        }
        if (initialColorMode === "system") {
            setColorMode("system");
            return;
        }
        setColorMode(defaultColorMode);
    }, [
        colorModeManager,
        defaultColorMode,
        initialColorMode,
        setColorMode
    ]);
    const toggleColorMode = (0, $acw62.useCallback)(()=>{
        setColorMode(resolvedValue === "dark" ? "light" : "dark");
    }, [
        resolvedValue,
        setColorMode
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!useSystemColorMode) return;
        return addListener(setColorMode);
    }, [
        useSystemColorMode,
        addListener,
        setColorMode
    ]);
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: value != null ? value : resolvedValue,
            toggleColorMode: value ? $78f995395c70cd91$var$noop : toggleColorMode,
            setColorMode: value ? $78f995395c70cd91$var$noop : setColorMode,
            forced: value !== void 0
        }), [
        resolvedValue,
        toggleColorMode,
        setColorMode,
        value
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b80b1cf263c5808a$export$49ddd74a6729fdb0).Provider, {
        value: context,
        children: children
    });
}
$78f995395c70cd91$export$7a858aa3ff83dde7.displayName = "ColorModeProvider";
function $78f995395c70cd91$export$8b41b18ed1f3731e(props) {
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: "dark",
            toggleColorMode: $78f995395c70cd91$var$noop,
            setColorMode: $78f995395c70cd91$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b80b1cf263c5808a$export$49ddd74a6729fdb0).Provider, {
        value: context,
        ...props
    });
}
$78f995395c70cd91$export$8b41b18ed1f3731e.displayName = "DarkMode";
function $78f995395c70cd91$export$cee2b1aa9166b2a3(props) {
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: "light",
            toggleColorMode: $78f995395c70cd91$var$noop,
            setColorMode: $78f995395c70cd91$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b80b1cf263c5808a$export$49ddd74a6729fdb0).Provider, {
        value: context,
        ...props
    });
}
$78f995395c70cd91$export$cee2b1aa9166b2a3.displayName = "LightMode";


// src/context.ts

var $acw62 = parcelRequire("acw62");
function $e54f09380e048946$export$fd42f52fd3ae1109(options = {}) {
    const { strict: strict = true, errorMessage: errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider", name: name } = options;
    const Context = (0, $acw62.createContext)(void 0);
    Context.displayName = name;
    function useContext() {
        var _a;
        const context = (0, $acw62.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage);
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}


// src/utils/create-transform.ts
// src/index.ts
var $abe97432afb3d989$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");
function $abe97432afb3d989$var$isDev() {
    return false;
}
function $abe97432afb3d989$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var $abe97432afb3d989$export$c106dd0671a0fc2d = (options)=>{
    const { condition: condition, message: message } = options;
    if (condition && $abe97432afb3d989$var$isDev()) console.warn(message);
};
function $abe97432afb3d989$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $abe97432afb3d989$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var $abe97432afb3d989$var$isFunction = (value)=>typeof value === "function";
var $abe97432afb3d989$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
var $abe97432afb3d989$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;
function $abe97432afb3d989$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $abe97432afb3d989$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}



var $5Gn6I = parcelRequire("5Gn6I");
var $47a6d9fbbf7ee42d$var$isImportant = (value)=>/!(important)?$/.test(value);
var $47a6d9fbbf7ee42d$var$withoutImportant = (value)=>typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
var $47a6d9fbbf7ee42d$export$92f5bb613cffac78 = (scale, value)=>(theme)=>{
        const valueStr = String(value);
        const important = $47a6d9fbbf7ee42d$var$isImportant(valueStr);
        const valueWithoutImportant = $47a6d9fbbf7ee42d$var$withoutImportant(valueStr);
        const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
        let transformed = (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
        transformed = $47a6d9fbbf7ee42d$var$withoutImportant(transformed);
        return important ? `${transformed} !important` : transformed;
    };
function $47a6d9fbbf7ee42d$var$createTransform(options) {
    const { scale: scale, transform: transform2, compose: compose } = options;
    const fn = (value, theme)=>{
        var _a;
        const _value = $47a6d9fbbf7ee42d$export$92f5bb613cffac78(scale, value)(theme);
        let result = (_a = transform2 == null ? void 0 : transform2(_value, theme)) != null ? _a : _value;
        if (compose) result = compose(result, theme);
        return result;
    };
    return fn;
}
// src/utils/pipe.ts
var $47a6d9fbbf7ee42d$var$pipe = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);
// src/utils/prop-config.ts
function $47a6d9fbbf7ee42d$var$toConfig(scale, transform2) {
    return (property)=>{
        const result = {
            property: property,
            scale: scale
        };
        result.transform = $47a6d9fbbf7ee42d$var$createTransform({
            scale: scale,
            transform: transform2
        });
        return result;
    };
}
var $47a6d9fbbf7ee42d$var$getRtl = ({ rtl: rtl, ltr: ltr })=>(theme)=>theme.direction === "rtl" ? rtl : ltr;
function $47a6d9fbbf7ee42d$var$logical(options) {
    const { property: property, scale: scale, transform: transform2 } = options;
    return {
        scale: scale,
        property: $47a6d9fbbf7ee42d$var$getRtl(property),
        transform: scale ? $47a6d9fbbf7ee42d$var$createTransform({
            scale: scale,
            compose: transform2
        }) : transform2
    };
}
// src/utils/templates.ts
var $47a6d9fbbf7ee42d$var$transformTemplate = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
];
function $47a6d9fbbf7ee42d$var$getTransformTemplate() {
    return [
        "translateX(var(--chakra-translate-x, 0))",
        "translateY(var(--chakra-translate-y, 0))",
        ...$47a6d9fbbf7ee42d$var$transformTemplate
    ].join(" ");
}
function $47a6d9fbbf7ee42d$var$getTransformGpuTemplate() {
    return [
        "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
        ...$47a6d9fbbf7ee42d$var$transformTemplate
    ].join(" ");
}
var $47a6d9fbbf7ee42d$var$filterTemplate = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
        "var(--chakra-blur)",
        "var(--chakra-brightness)",
        "var(--chakra-contrast)",
        "var(--chakra-grayscale)",
        "var(--chakra-hue-rotate)",
        "var(--chakra-invert)",
        "var(--chakra-saturate)",
        "var(--chakra-sepia)",
        "var(--chakra-drop-shadow)"
    ].join(" ")
};
var $47a6d9fbbf7ee42d$var$backdropFilterTemplate = {
    backdropFilter: [
        "var(--chakra-backdrop-blur)",
        "var(--chakra-backdrop-brightness)",
        "var(--chakra-backdrop-contrast)",
        "var(--chakra-backdrop-grayscale)",
        "var(--chakra-backdrop-hue-rotate)",
        "var(--chakra-backdrop-invert)",
        "var(--chakra-backdrop-opacity)",
        "var(--chakra-backdrop-saturate)",
        "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function $47a6d9fbbf7ee42d$var$getRingTemplate(value) {
    return {
        "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
        "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
        "--chakra-ring-width": value,
        boxShadow: [
            `var(--chakra-ring-offset-shadow)`,
            `var(--chakra-ring-shadow)`,
            `var(--chakra-shadow, 0 0 #0000)`
        ].join(", ")
    };
}
var $47a6d9fbbf7ee42d$var$flexDirectionTemplate = {
    "row-reverse": {
        space: "--chakra-space-x-reverse",
        divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
        space: "--chakra-space-y-reverse",
        divide: "--chakra-divide-y-reverse"
    }
};
// src/utils/parse-gradient.ts
var $47a6d9fbbf7ee42d$var$directionMap = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
};
var $47a6d9fbbf7ee42d$var$valueSet = new Set(Object.values($47a6d9fbbf7ee42d$var$directionMap));
var $47a6d9fbbf7ee42d$var$globalSet = /* @__PURE__ */ new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
var $47a6d9fbbf7ee42d$var$trimSpace = (str)=>str.trim();
function $47a6d9fbbf7ee42d$var$parseGradient(value, theme) {
    if (value == null || $47a6d9fbbf7ee42d$var$globalSet.has(value)) return value;
    const prevent = $47a6d9fbbf7ee42d$var$isCSSFunction(value) || $47a6d9fbbf7ee42d$var$globalSet.has(value);
    if (!prevent) return `url('${value}')`;
    const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
    const results = regex.exec(value);
    const type = results == null ? void 0 : results[1];
    const values = results == null ? void 0 : results[2];
    if (!type || !values) return value;
    const _type = type.includes("-gradient") ? type : `${type}-gradient`;
    const [maybeDirection, ...stops] = values.split(",").map($47a6d9fbbf7ee42d$var$trimSpace).filter(Boolean);
    if ((stops == null ? void 0 : stops.length) === 0) return value;
    const direction = maybeDirection in $47a6d9fbbf7ee42d$var$directionMap ? $47a6d9fbbf7ee42d$var$directionMap[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    const _values = stops.map((stop)=>{
        if ($47a6d9fbbf7ee42d$var$valueSet.has(stop)) return stop;
        const firstStop = stop.indexOf(" ");
        const [_color, _stop] = firstStop !== -1 ? [
            stop.substr(0, firstStop),
            stop.substr(firstStop + 1)
        ] : [
            stop
        ];
        const _stopOrFunc = $47a6d9fbbf7ee42d$var$isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");
        const key = `colors.${_color}`;
        const color2 = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
        return _stopOrFunc ? [
            color2,
            ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [
                _stopOrFunc
            ]
        ].join(" ") : color2;
    });
    return `${_type}(${_values.join(", ")})`;
}
var $47a6d9fbbf7ee42d$var$isCSSFunction = (value)=>{
    return typeof value === "string" && value.includes("(") && value.includes(")");
};
var $47a6d9fbbf7ee42d$var$gradientTransform = (value, theme)=>$47a6d9fbbf7ee42d$var$parseGradient(value, theme != null ? theme : {});
// src/utils/transform-functions.ts
function $47a6d9fbbf7ee42d$var$isCssVar(value) {
    return /^var\(--.+\)$/.test(value);
}
var $47a6d9fbbf7ee42d$var$analyzeCSSValue = (value)=>{
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
};
var $47a6d9fbbf7ee42d$var$wrap = (str)=>(value)=>`${str}(${value})`;
var $47a6d9fbbf7ee42d$var$transformFunctions = {
    filter (value) {
        return value !== "auto" ? value : $47a6d9fbbf7ee42d$var$filterTemplate;
    },
    backdropFilter (value) {
        return value !== "auto" ? value : $47a6d9fbbf7ee42d$var$backdropFilterTemplate;
    },
    ring (value) {
        return $47a6d9fbbf7ee42d$var$getRingTemplate($47a6d9fbbf7ee42d$var$transformFunctions.px(value));
    },
    bgClip (value) {
        return value === "text" ? {
            color: "transparent",
            backgroundClip: "text"
        } : {
            backgroundClip: value
        };
    },
    transform (value) {
        if (value === "auto") return $47a6d9fbbf7ee42d$var$getTransformTemplate();
        if (value === "auto-gpu") return $47a6d9fbbf7ee42d$var$getTransformGpuTemplate();
        return value;
    },
    vh (value) {
        return value === "$100vh" ? "var(--chakra-vh)" : value;
    },
    px (value) {
        if (value == null) return value;
        const { unitless: unitless } = $47a6d9fbbf7ee42d$var$analyzeCSSValue(value);
        return unitless || typeof value === "number" ? `${value}px` : value;
    },
    fraction (value) {
        return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
    },
    float (value, theme) {
        const map = {
            left: "right",
            right: "left"
        };
        return theme.direction === "rtl" ? map[value] : value;
    },
    degree (value) {
        if ($47a6d9fbbf7ee42d$var$isCssVar(value) || value == null) return value;
        const unitless = typeof value === "string" && !value.endsWith("deg");
        return typeof value === "number" || unitless ? `${value}deg` : value;
    },
    gradient: $47a6d9fbbf7ee42d$var$gradientTransform,
    blur: $47a6d9fbbf7ee42d$var$wrap("blur"),
    opacity: $47a6d9fbbf7ee42d$var$wrap("opacity"),
    brightness: $47a6d9fbbf7ee42d$var$wrap("brightness"),
    contrast: $47a6d9fbbf7ee42d$var$wrap("contrast"),
    dropShadow: $47a6d9fbbf7ee42d$var$wrap("drop-shadow"),
    grayscale: $47a6d9fbbf7ee42d$var$wrap("grayscale"),
    hueRotate: (value)=>$47a6d9fbbf7ee42d$var$wrap("hue-rotate")($47a6d9fbbf7ee42d$var$transformFunctions.degree(value)),
    invert: $47a6d9fbbf7ee42d$var$wrap("invert"),
    saturate: $47a6d9fbbf7ee42d$var$wrap("saturate"),
    sepia: $47a6d9fbbf7ee42d$var$wrap("sepia"),
    bgImage (value) {
        if (value == null) return value;
        const prevent = $47a6d9fbbf7ee42d$var$isCSSFunction(value) || $47a6d9fbbf7ee42d$var$globalSet.has(value);
        return !prevent ? `url(${value})` : value;
    },
    outline (value) {
        const isNoneOrZero = String(value) === "0" || String(value) === "none";
        return value !== null && isNoneOrZero ? {
            outline: "2px solid transparent",
            outlineOffset: "2px"
        } : {
            outline: value
        };
    },
    flexDirection (value) {
        var _a;
        const { space: space2, divide: divide2 } = (_a = $47a6d9fbbf7ee42d$var$flexDirectionTemplate[value]) != null ? _a : {};
        const result = {
            flexDirection: value
        };
        if (space2) result[space2] = 1;
        if (divide2) result[divide2] = 1;
        return result;
    }
};
// src/utils/index.ts
var $47a6d9fbbf7ee42d$var$t = {
    borderWidths: $47a6d9fbbf7ee42d$var$toConfig("borderWidths"),
    borderStyles: $47a6d9fbbf7ee42d$var$toConfig("borderStyles"),
    colors: $47a6d9fbbf7ee42d$var$toConfig("colors"),
    borders: $47a6d9fbbf7ee42d$var$toConfig("borders"),
    gradients: $47a6d9fbbf7ee42d$var$toConfig("gradients", $47a6d9fbbf7ee42d$var$transformFunctions.gradient),
    radii: $47a6d9fbbf7ee42d$var$toConfig("radii", $47a6d9fbbf7ee42d$var$transformFunctions.px),
    space: $47a6d9fbbf7ee42d$var$toConfig("space", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.px)),
    spaceT: $47a6d9fbbf7ee42d$var$toConfig("space", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.px)),
    degreeT (property) {
        return {
            property: property,
            transform: $47a6d9fbbf7ee42d$var$transformFunctions.degree
        };
    },
    prop (property, scale, transform2) {
        return {
            property: property,
            scale: scale,
            ...scale && {
                transform: $47a6d9fbbf7ee42d$var$createTransform({
                    scale: scale,
                    transform: transform2
                })
            }
        };
    },
    propT (property, transform2) {
        return {
            property: property,
            transform: transform2
        };
    },
    sizes: $47a6d9fbbf7ee42d$var$toConfig("sizes", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.px)),
    sizesT: $47a6d9fbbf7ee42d$var$toConfig("sizes", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.fraction)),
    shadows: $47a6d9fbbf7ee42d$var$toConfig("shadows"),
    logical: $47a6d9fbbf7ee42d$var$logical,
    blur: $47a6d9fbbf7ee42d$var$toConfig("blur", $47a6d9fbbf7ee42d$var$transformFunctions.blur)
};
// src/config/background.ts
var $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412 = {
    background: $47a6d9fbbf7ee42d$var$t.colors("background"),
    backgroundColor: $47a6d9fbbf7ee42d$var$t.colors("backgroundColor"),
    backgroundImage: $47a6d9fbbf7ee42d$var$t.gradients("backgroundImage"),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.bgClip
    },
    bgSize: $47a6d9fbbf7ee42d$var$t.prop("backgroundSize"),
    bgPosition: $47a6d9fbbf7ee42d$var$t.prop("backgroundPosition"),
    bg: $47a6d9fbbf7ee42d$var$t.colors("background"),
    bgColor: $47a6d9fbbf7ee42d$var$t.colors("backgroundColor"),
    bgPos: $47a6d9fbbf7ee42d$var$t.prop("backgroundPosition"),
    bgRepeat: $47a6d9fbbf7ee42d$var$t.prop("backgroundRepeat"),
    bgAttachment: $47a6d9fbbf7ee42d$var$t.prop("backgroundAttachment"),
    bgGradient: $47a6d9fbbf7ee42d$var$t.gradients("backgroundImage"),
    bgClip: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.bgClip
    }
};
Object.assign($47a6d9fbbf7ee42d$export$8ce1fd94bee2f412, {
    bgImage: $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412.backgroundImage,
    bgImg: $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412.backgroundImage
});
// src/config/border.ts
var $47a6d9fbbf7ee42d$export$1edee58a52776cd9 = {
    border: $47a6d9fbbf7ee42d$var$t.borders("border"),
    borderWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderWidth"),
    borderStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderStyle"),
    borderColor: $47a6d9fbbf7ee42d$var$t.colors("borderColor"),
    borderRadius: $47a6d9fbbf7ee42d$var$t.radii("borderRadius"),
    borderTop: $47a6d9fbbf7ee42d$var$t.borders("borderTop"),
    borderBlockStart: $47a6d9fbbf7ee42d$var$t.borders("borderBlockStart"),
    borderTopLeftRadius: $47a6d9fbbf7ee42d$var$t.radii("borderTopLeftRadius"),
    borderStartStartRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopLeftRadius",
            rtl: "borderTopRightRadius"
        }
    }),
    borderEndStartRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomLeftRadius",
            rtl: "borderBottomRightRadius"
        }
    }),
    borderTopRightRadius: $47a6d9fbbf7ee42d$var$t.radii("borderTopRightRadius"),
    borderStartEndRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopRightRadius",
            rtl: "borderTopLeftRadius"
        }
    }),
    borderEndEndRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomRightRadius",
            rtl: "borderBottomLeftRadius"
        }
    }),
    borderRight: $47a6d9fbbf7ee42d$var$t.borders("borderRight"),
    borderInlineEnd: $47a6d9fbbf7ee42d$var$t.borders("borderInlineEnd"),
    borderBottom: $47a6d9fbbf7ee42d$var$t.borders("borderBottom"),
    borderBlockEnd: $47a6d9fbbf7ee42d$var$t.borders("borderBlockEnd"),
    borderBottomLeftRadius: $47a6d9fbbf7ee42d$var$t.radii("borderBottomLeftRadius"),
    borderBottomRightRadius: $47a6d9fbbf7ee42d$var$t.radii("borderBottomRightRadius"),
    borderLeft: $47a6d9fbbf7ee42d$var$t.borders("borderLeft"),
    borderInlineStart: {
        property: "borderInlineStart",
        scale: "borders"
    },
    borderInlineStartRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ],
            rtl: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ]
        }
    }),
    borderInlineEndRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ],
            rtl: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ]
        }
    }),
    borderX: $47a6d9fbbf7ee42d$var$t.borders([
        "borderLeft",
        "borderRight"
    ]),
    borderInline: $47a6d9fbbf7ee42d$var$t.borders("borderInline"),
    borderY: $47a6d9fbbf7ee42d$var$t.borders([
        "borderTop",
        "borderBottom"
    ]),
    borderBlock: $47a6d9fbbf7ee42d$var$t.borders("borderBlock"),
    borderTopWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderTopWidth"),
    borderBlockStartWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderBlockStartWidth"),
    borderTopColor: $47a6d9fbbf7ee42d$var$t.colors("borderTopColor"),
    borderBlockStartColor: $47a6d9fbbf7ee42d$var$t.colors("borderBlockStartColor"),
    borderTopStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderTopStyle"),
    borderBlockStartStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderBlockStartStyle"),
    borderBottomWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderBottomWidth"),
    borderBlockEndWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderBlockEndWidth"),
    borderBottomColor: $47a6d9fbbf7ee42d$var$t.colors("borderBottomColor"),
    borderBlockEndColor: $47a6d9fbbf7ee42d$var$t.colors("borderBlockEndColor"),
    borderBottomStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderBottomStyle"),
    borderBlockEndStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderBlockEndStyle"),
    borderLeftWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderLeftWidth"),
    borderInlineStartWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderInlineStartWidth"),
    borderLeftColor: $47a6d9fbbf7ee42d$var$t.colors("borderLeftColor"),
    borderInlineStartColor: $47a6d9fbbf7ee42d$var$t.colors("borderInlineStartColor"),
    borderLeftStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderLeftStyle"),
    borderInlineStartStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderInlineStartStyle"),
    borderRightWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderRightWidth"),
    borderInlineEndWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderInlineEndWidth"),
    borderRightColor: $47a6d9fbbf7ee42d$var$t.colors("borderRightColor"),
    borderInlineEndColor: $47a6d9fbbf7ee42d$var$t.colors("borderInlineEndColor"),
    borderRightStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderRightStyle"),
    borderInlineEndStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderInlineEndStyle"),
    borderTopRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ]),
    borderBottomRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ]),
    borderLeftRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderTopLeftRadius",
        "borderBottomLeftRadius"
    ]),
    borderRightRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderTopRightRadius",
        "borderBottomRightRadius"
    ])
};
Object.assign($47a6d9fbbf7ee42d$export$1edee58a52776cd9, {
    rounded: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderRadius,
    roundedTop: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderTopRadius,
    roundedTopLeft: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderTopLeftRadius,
    roundedTopRight: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderTopRightRadius,
    roundedTopStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartStartRadius,
    roundedTopEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartEndRadius,
    roundedBottom: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderBottomRadius,
    roundedBottomLeft: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderBottomLeftRadius,
    roundedBottomRight: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderBottomRightRadius,
    roundedBottomStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndStartRadius,
    roundedBottomEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndEndRadius,
    roundedLeft: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderLeftRadius,
    roundedRight: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderRightRadius,
    roundedStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartRadius,
    roundedEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStart,
    borderEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEnd,
    borderTopStartRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartStartRadius,
    borderTopEndRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartEndRadius,
    borderBottomStartRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndStartRadius,
    borderBottomEndRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndEndRadius,
    borderStartRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartRadius,
    borderEndRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStartWidth: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartWidth,
    borderEndWidth: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndWidth,
    borderStartColor: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartColor,
    borderEndColor: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndColor,
    borderStartStyle: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartStyle,
    borderEndStyle: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndStyle
});
// src/config/color.ts
var $47a6d9fbbf7ee42d$export$35e9368ef982300f = {
    color: $47a6d9fbbf7ee42d$var$t.colors("color"),
    textColor: $47a6d9fbbf7ee42d$var$t.colors("color"),
    fill: $47a6d9fbbf7ee42d$var$t.colors("fill"),
    stroke: $47a6d9fbbf7ee42d$var$t.colors("stroke")
};
// src/config/effect.ts
var $47a6d9fbbf7ee42d$export$dc573d8a6576cdb3 = {
    boxShadow: $47a6d9fbbf7ee42d$var$t.shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: $47a6d9fbbf7ee42d$var$t.prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: $47a6d9fbbf7ee42d$var$t.prop("backgroundBlendMode"),
    opacity: true
};
Object.assign($47a6d9fbbf7ee42d$export$dc573d8a6576cdb3, {
    shadow: $47a6d9fbbf7ee42d$export$dc573d8a6576cdb3.boxShadow
});
// src/config/filter.ts
var $47a6d9fbbf7ee42d$export$3dea766d36a8935f = {
    filter: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.filter
    },
    blur: $47a6d9fbbf7ee42d$var$t.blur("--chakra-blur"),
    brightness: $47a6d9fbbf7ee42d$var$t.propT("--chakra-brightness", $47a6d9fbbf7ee42d$var$transformFunctions.brightness),
    contrast: $47a6d9fbbf7ee42d$var$t.propT("--chakra-contrast", $47a6d9fbbf7ee42d$var$transformFunctions.contrast),
    hueRotate: $47a6d9fbbf7ee42d$var$t.propT("--chakra-hue-rotate", $47a6d9fbbf7ee42d$var$transformFunctions.hueRotate),
    invert: $47a6d9fbbf7ee42d$var$t.propT("--chakra-invert", $47a6d9fbbf7ee42d$var$transformFunctions.invert),
    saturate: $47a6d9fbbf7ee42d$var$t.propT("--chakra-saturate", $47a6d9fbbf7ee42d$var$transformFunctions.saturate),
    dropShadow: $47a6d9fbbf7ee42d$var$t.propT("--chakra-drop-shadow", $47a6d9fbbf7ee42d$var$transformFunctions.dropShadow),
    backdropFilter: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.backdropFilter
    },
    backdropBlur: $47a6d9fbbf7ee42d$var$t.blur("--chakra-backdrop-blur"),
    backdropBrightness: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-brightness", $47a6d9fbbf7ee42d$var$transformFunctions.brightness),
    backdropContrast: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-contrast", $47a6d9fbbf7ee42d$var$transformFunctions.contrast),
    backdropHueRotate: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-hue-rotate", $47a6d9fbbf7ee42d$var$transformFunctions.hueRotate),
    backdropInvert: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-invert", $47a6d9fbbf7ee42d$var$transformFunctions.invert),
    backdropSaturate: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-saturate", $47a6d9fbbf7ee42d$var$transformFunctions.saturate)
};
// src/config/flexbox.ts
var $47a6d9fbbf7ee42d$export$feec61708a55c80e = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.flexDirection
    },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: $47a6d9fbbf7ee42d$var$t.sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true,
    gap: $47a6d9fbbf7ee42d$var$t.space("gap"),
    rowGap: $47a6d9fbbf7ee42d$var$t.space("rowGap"),
    columnGap: $47a6d9fbbf7ee42d$var$t.space("columnGap")
};
Object.assign($47a6d9fbbf7ee42d$export$feec61708a55c80e, {
    flexDir: $47a6d9fbbf7ee42d$export$feec61708a55c80e.flexDirection
});
// src/config/grid.ts
var $47a6d9fbbf7ee42d$export$85fc379452d91af0 = {
    gridGap: $47a6d9fbbf7ee42d$var$t.space("gridGap"),
    gridColumnGap: $47a6d9fbbf7ee42d$var$t.space("gridColumnGap"),
    gridRowGap: $47a6d9fbbf7ee42d$var$t.space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
};
// src/config/interactivity.ts
var $47a6d9fbbf7ee42d$export$2499a341a8256d68 = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.outline
    },
    outlineOffset: true,
    outlineColor: $47a6d9fbbf7ee42d$var$t.colors("outlineColor")
};
// src/config/layout.ts
var $47a6d9fbbf7ee42d$export$b3219800bda33a1f = {
    width: $47a6d9fbbf7ee42d$var$t.sizesT("width"),
    inlineSize: $47a6d9fbbf7ee42d$var$t.sizesT("inlineSize"),
    height: $47a6d9fbbf7ee42d$var$t.sizes("height"),
    blockSize: $47a6d9fbbf7ee42d$var$t.sizes("blockSize"),
    boxSize: $47a6d9fbbf7ee42d$var$t.sizes([
        "width",
        "height"
    ]),
    minWidth: $47a6d9fbbf7ee42d$var$t.sizes("minWidth"),
    minInlineSize: $47a6d9fbbf7ee42d$var$t.sizes("minInlineSize"),
    minHeight: $47a6d9fbbf7ee42d$var$t.sizes("minHeight"),
    minBlockSize: $47a6d9fbbf7ee42d$var$t.sizes("minBlockSize"),
    maxWidth: $47a6d9fbbf7ee42d$var$t.sizes("maxWidth"),
    maxInlineSize: $47a6d9fbbf7ee42d$var$t.sizes("maxInlineSize"),
    maxHeight: $47a6d9fbbf7ee42d$var$t.sizes("maxHeight"),
    maxBlockSize: $47a6d9fbbf7ee42d$var$t.sizes("maxBlockSize"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    aspectRatio: true,
    hideFrom: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            var _a, _b, _c;
            const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b.minW) != null ? _c : value;
            const mq = `@media screen and (min-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    hideBelow: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            var _a, _b, _c;
            const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b._minW) != null ? _c : value;
            const mq = `@media screen and (max-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    float: $47a6d9fbbf7ee42d$var$t.propT("float", $47a6d9fbbf7ee42d$var$transformFunctions.float),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
};
Object.assign($47a6d9fbbf7ee42d$export$b3219800bda33a1f, {
    w: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.width,
    h: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.height,
    minW: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.minWidth,
    maxW: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.maxWidth,
    minH: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.minHeight,
    maxH: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.maxHeight,
    overscroll: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.overscrollBehavior,
    overscrollX: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.overscrollBehaviorX,
    overscrollY: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.overscrollBehaviorY
});
// src/config/list.ts
var $47a6d9fbbf7ee42d$export$8837f4fc672e936d = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: $47a6d9fbbf7ee42d$var$t.prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: $47a6d9fbbf7ee42d$var$t.prop("listStyleImage")
};
// src/get.ts
function $47a6d9fbbf7ee42d$var$get(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
var $47a6d9fbbf7ee42d$var$memoize = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $47a6d9fbbf7ee42d$var$memoizedGet = $47a6d9fbbf7ee42d$var$memoize($47a6d9fbbf7ee42d$var$get);
// src/config/others.ts
var $47a6d9fbbf7ee42d$var$srOnly = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
var $47a6d9fbbf7ee42d$var$srFocusable = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
};
var $47a6d9fbbf7ee42d$var$getWithPriority = (theme, key, styles)=>{
    const result = {};
    const obj = $47a6d9fbbf7ee42d$var$memoizedGet(theme, key, {});
    for(const prop in obj){
        const isInStyles = prop in styles && styles[prop] != null;
        if (!isInStyles) result[prop] = obj[prop];
    }
    return result;
};
var $47a6d9fbbf7ee42d$export$36263e8f8d7ce3b1 = {
    srOnly: {
        transform (value) {
            if (value === true) return $47a6d9fbbf7ee42d$var$srOnly;
            if (value === "focusable") return $47a6d9fbbf7ee42d$var$srFocusable;
            return {};
        }
    },
    layerStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$47a6d9fbbf7ee42d$var$getWithPriority(theme, `layerStyles.${value}`, styles)
    },
    textStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$47a6d9fbbf7ee42d$var$getWithPriority(theme, `textStyles.${value}`, styles)
    },
    apply: {
        processResult: true,
        transform: (value, theme, styles)=>$47a6d9fbbf7ee42d$var$getWithPriority(theme, value, styles)
    }
};
// src/config/position.ts
var $47a6d9fbbf7ee42d$export$5880b8b5730aff45 = {
    position: true,
    pos: $47a6d9fbbf7ee42d$var$t.prop("position"),
    zIndex: $47a6d9fbbf7ee42d$var$t.prop("zIndex", "zIndices"),
    inset: $47a6d9fbbf7ee42d$var$t.spaceT("inset"),
    insetX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "left",
        "right"
    ]),
    insetInline: $47a6d9fbbf7ee42d$var$t.spaceT("insetInline"),
    insetY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "top",
        "bottom"
    ]),
    insetBlock: $47a6d9fbbf7ee42d$var$t.spaceT("insetBlock"),
    top: $47a6d9fbbf7ee42d$var$t.spaceT("top"),
    insetBlockStart: $47a6d9fbbf7ee42d$var$t.spaceT("insetBlockStart"),
    bottom: $47a6d9fbbf7ee42d$var$t.spaceT("bottom"),
    insetBlockEnd: $47a6d9fbbf7ee42d$var$t.spaceT("insetBlockEnd"),
    left: $47a6d9fbbf7ee42d$var$t.spaceT("left"),
    insetInlineStart: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "space",
        property: {
            ltr: "left",
            rtl: "right"
        }
    }),
    right: $47a6d9fbbf7ee42d$var$t.spaceT("right"),
    insetInlineEnd: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "space",
        property: {
            ltr: "right",
            rtl: "left"
        }
    })
};
Object.assign($47a6d9fbbf7ee42d$export$5880b8b5730aff45, {
    insetStart: $47a6d9fbbf7ee42d$export$5880b8b5730aff45.insetInlineStart,
    insetEnd: $47a6d9fbbf7ee42d$export$5880b8b5730aff45.insetInlineEnd
});
// src/config/ring.ts
var $47a6d9fbbf7ee42d$export$e7d0da6968da5dd = {
    ring: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.ring
    },
    ringColor: $47a6d9fbbf7ee42d$var$t.colors("--chakra-ring-color"),
    ringOffset: $47a6d9fbbf7ee42d$var$t.prop("--chakra-ring-offset-width"),
    ringOffsetColor: $47a6d9fbbf7ee42d$var$t.colors("--chakra-ring-offset-color"),
    ringInset: $47a6d9fbbf7ee42d$var$t.prop("--chakra-ring-inset")
};
// src/config/space.ts
var $47a6d9fbbf7ee42d$export$a941ed4b947d12f8 = {
    margin: $47a6d9fbbf7ee42d$var$t.spaceT("margin"),
    marginTop: $47a6d9fbbf7ee42d$var$t.spaceT("marginTop"),
    marginBlockStart: $47a6d9fbbf7ee42d$var$t.spaceT("marginBlockStart"),
    marginRight: $47a6d9fbbf7ee42d$var$t.spaceT("marginRight"),
    marginInlineEnd: $47a6d9fbbf7ee42d$var$t.spaceT("marginInlineEnd"),
    marginBottom: $47a6d9fbbf7ee42d$var$t.spaceT("marginBottom"),
    marginBlockEnd: $47a6d9fbbf7ee42d$var$t.spaceT("marginBlockEnd"),
    marginLeft: $47a6d9fbbf7ee42d$var$t.spaceT("marginLeft"),
    marginInlineStart: $47a6d9fbbf7ee42d$var$t.spaceT("marginInlineStart"),
    marginX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "marginInlineStart",
        "marginInlineEnd"
    ]),
    marginInline: $47a6d9fbbf7ee42d$var$t.spaceT("marginInline"),
    marginY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "marginTop",
        "marginBottom"
    ]),
    marginBlock: $47a6d9fbbf7ee42d$var$t.spaceT("marginBlock"),
    padding: $47a6d9fbbf7ee42d$var$t.space("padding"),
    paddingTop: $47a6d9fbbf7ee42d$var$t.space("paddingTop"),
    paddingBlockStart: $47a6d9fbbf7ee42d$var$t.space("paddingBlockStart"),
    paddingRight: $47a6d9fbbf7ee42d$var$t.space("paddingRight"),
    paddingBottom: $47a6d9fbbf7ee42d$var$t.space("paddingBottom"),
    paddingBlockEnd: $47a6d9fbbf7ee42d$var$t.space("paddingBlockEnd"),
    paddingLeft: $47a6d9fbbf7ee42d$var$t.space("paddingLeft"),
    paddingInlineStart: $47a6d9fbbf7ee42d$var$t.space("paddingInlineStart"),
    paddingInlineEnd: $47a6d9fbbf7ee42d$var$t.space("paddingInlineEnd"),
    paddingX: $47a6d9fbbf7ee42d$var$t.space([
        "paddingInlineStart",
        "paddingInlineEnd"
    ]),
    paddingInline: $47a6d9fbbf7ee42d$var$t.space("paddingInline"),
    paddingY: $47a6d9fbbf7ee42d$var$t.space([
        "paddingTop",
        "paddingBottom"
    ]),
    paddingBlock: $47a6d9fbbf7ee42d$var$t.space("paddingBlock")
};
Object.assign($47a6d9fbbf7ee42d$export$a941ed4b947d12f8, {
    m: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.margin,
    mt: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginTop,
    mr: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginRight,
    me: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineEnd,
    marginEnd: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineEnd,
    mb: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginBottom,
    ml: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginLeft,
    ms: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineStart,
    marginStart: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineStart,
    mx: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginX,
    my: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginY,
    p: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.padding,
    pt: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingTop,
    py: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingY,
    px: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingX,
    pb: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingBottom,
    pl: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingLeft,
    ps: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineStart,
    paddingStart: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineStart,
    pr: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingRight,
    pe: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineEnd,
    paddingEnd: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineEnd
});
// src/config/text-decoration.ts
var $47a6d9fbbf7ee42d$export$6b7f9af9aa033040 = {
    textDecorationColor: $47a6d9fbbf7ee42d$var$t.colors("textDecorationColor"),
    textDecoration: true,
    textDecor: {
        property: "textDecoration"
    },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: $47a6d9fbbf7ee42d$var$t.shadows("textShadow")
};
// src/config/transform.ts
var $47a6d9fbbf7ee42d$export$51186ad6e864892a = {
    clipPath: true,
    transform: $47a6d9fbbf7ee42d$var$t.propT("transform", $47a6d9fbbf7ee42d$var$transformFunctions.transform),
    transformOrigin: true,
    translateX: $47a6d9fbbf7ee42d$var$t.spaceT("--chakra-translate-x"),
    translateY: $47a6d9fbbf7ee42d$var$t.spaceT("--chakra-translate-y"),
    skewX: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-skew-x"),
    skewY: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-skew-y"),
    scaleX: $47a6d9fbbf7ee42d$var$t.prop("--chakra-scale-x"),
    scaleY: $47a6d9fbbf7ee42d$var$t.prop("--chakra-scale-y"),
    scale: $47a6d9fbbf7ee42d$var$t.prop([
        "--chakra-scale-x",
        "--chakra-scale-y"
    ]),
    rotate: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-rotate")
};
// src/config/transition.ts
var $47a6d9fbbf7ee42d$export$66bb15e2994e6a26 = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: $47a6d9fbbf7ee42d$var$t.prop("transitionDuration", "transition.duration"),
    transitionProperty: $47a6d9fbbf7ee42d$var$t.prop("transitionProperty", "transition.property"),
    transitionTimingFunction: $47a6d9fbbf7ee42d$var$t.prop("transitionTimingFunction", "transition.easing")
};
// src/config/typography.ts
var $47a6d9fbbf7ee42d$export$d846a084e680d8e = {
    fontFamily: $47a6d9fbbf7ee42d$var$t.prop("fontFamily", "fonts"),
    fontSize: $47a6d9fbbf7ee42d$var$t.prop("fontSize", "fontSizes", $47a6d9fbbf7ee42d$var$transformFunctions.px),
    fontWeight: $47a6d9fbbf7ee42d$var$t.prop("fontWeight", "fontWeights"),
    lineHeight: $47a6d9fbbf7ee42d$var$t.prop("lineHeight", "lineHeights"),
    letterSpacing: $47a6d9fbbf7ee42d$var$t.prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    textIndent: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    isTruncated: {
        transform (value) {
            if (value === true) return {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            };
        }
    },
    noOfLines: {
        static: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            //@ts-ignore
            WebkitLineClamp: "var(--chakra-line-clamp)"
        },
        property: "--chakra-line-clamp"
    }
};
// src/config/scroll.ts
var $47a6d9fbbf7ee42d$export$209876d7b1ac8f3 = {
    scrollBehavior: true,
    scrollSnapAlign: true,
    scrollSnapStop: true,
    scrollSnapType: true,
    // scroll margin
    scrollMargin: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMargin"),
    scrollMarginTop: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginTop"),
    scrollMarginBottom: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginBottom"),
    scrollMarginLeft: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginLeft"),
    scrollMarginRight: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginRight"),
    scrollMarginX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollMarginLeft",
        "scrollMarginRight"
    ]),
    scrollMarginY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollMarginTop",
        "scrollMarginBottom"
    ]),
    // scroll padding
    scrollPadding: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPadding"),
    scrollPaddingTop: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingTop"),
    scrollPaddingBottom: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingLeft"),
    scrollPaddingRight: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingRight"),
    scrollPaddingX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollPaddingLeft",
        "scrollPaddingRight"
    ]),
    scrollPaddingY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollPaddingTop",
        "scrollPaddingBottom"
    ])
};
function $47a6d9fbbf7ee42d$var$resolveReference(operand) {
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $47a6d9fbbf7ee42d$var$toExpression = (operator, ...operands)=>operands.map($47a6d9fbbf7ee42d$var$resolveReference).join(` ${operator} `).replace(/calc/g, "");
var $47a6d9fbbf7ee42d$var$add = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("+", ...operands)})`;
var $47a6d9fbbf7ee42d$var$subtract = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("-", ...operands)})`;
var $47a6d9fbbf7ee42d$var$multiply = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("*", ...operands)})`;
var $47a6d9fbbf7ee42d$var$divide = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("/", ...operands)})`;
var $47a6d9fbbf7ee42d$var$negate = (x)=>{
    const value = $47a6d9fbbf7ee42d$var$resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $47a6d9fbbf7ee42d$var$multiply(value, -1);
};
var $47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$add(x, ...operands)),
        subtract: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$subtract(x, ...operands)),
        multiply: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$multiply(x, ...operands)),
        divide: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$divide(x, ...operands)),
        negate: ()=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $47a6d9fbbf7ee42d$var$add,
    subtract: $47a6d9fbbf7ee42d$var$subtract,
    multiply: $47a6d9fbbf7ee42d$var$multiply,
    divide: $47a6d9fbbf7ee42d$var$divide,
    negate: $47a6d9fbbf7ee42d$var$negate
});
// src/create-theme-vars/css-var.ts
function $47a6d9fbbf7ee42d$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $47a6d9fbbf7ee42d$var$escape(value) {
    const valueStr = $47a6d9fbbf7ee42d$var$replaceWhiteSpace(value.toString());
    return $47a6d9fbbf7ee42d$var$escapeSymbol($47a6d9fbbf7ee42d$var$escapeDot(valueStr));
}
function $47a6d9fbbf7ee42d$var$escapeDot(value) {
    if (value.includes("\\.")) return value;
    const isDecimal = !Number.isInteger(parseFloat(value.toString()));
    return isDecimal ? value.replace(".", `\\.`) : value;
}
function $47a6d9fbbf7ee42d$var$escapeSymbol(value) {
    return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function $47a6d9fbbf7ee42d$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        value
    ].filter(Boolean).join("-");
}
function $47a6d9fbbf7ee42d$export$bb435e137b4b8e38(name, fallback) {
    return `var(${name}${fallback ? `, ${fallback}` : ""})`;
}
function $47a6d9fbbf7ee42d$export$3695bd65cc73dae9(value, prefix = "") {
    return $47a6d9fbbf7ee42d$var$escape(`--${$47a6d9fbbf7ee42d$export$9748efee331ec573(value, prefix)}`);
}
function $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(name, fallback, cssVarPrefix) {
    const cssVariable = $47a6d9fbbf7ee42d$export$3695bd65cc73dae9(name, cssVarPrefix);
    return {
        variable: cssVariable,
        reference: $47a6d9fbbf7ee42d$export$bb435e137b4b8e38(cssVariable, fallback)
    };
}
function $47a6d9fbbf7ee42d$export$bd40561c6c056841(scope, keys2) {
    const vars = {};
    for (const key of keys2){
        if (Array.isArray(key)) {
            const [name, fallback] = key;
            vars[name] = $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(`${scope}-${name}`, fallback);
            continue;
        }
        vars[key] = $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(`${scope}-${key}`);
    }
    return vars;
}
function $47a6d9fbbf7ee42d$var$getLastItem(array) {
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
}
function $47a6d9fbbf7ee42d$var$analyzeCSSValue2(value) {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $47a6d9fbbf7ee42d$var$px(value) {
    if (value == null) return value;
    const { unitless: unitless } = $47a6d9fbbf7ee42d$var$analyzeCSSValue2(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
}
var $47a6d9fbbf7ee42d$var$sortByBreakpointValue = (a, b)=>parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var $47a6d9fbbf7ee42d$var$sortBps = (breakpoints)=>Object.fromEntries(Object.entries(breakpoints).sort($47a6d9fbbf7ee42d$var$sortByBreakpointValue));
function $47a6d9fbbf7ee42d$var$normalize(breakpoints) {
    const sorted = $47a6d9fbbf7ee42d$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $47a6d9fbbf7ee42d$var$keys(breakpoints) {
    const value = Object.keys($47a6d9fbbf7ee42d$var$sortBps(breakpoints));
    return new Set(value);
}
function $47a6d9fbbf7ee42d$var$subtract2(value) {
    var _a;
    if (!value) return value;
    value = (_a = $47a6d9fbbf7ee42d$var$px(value)) != null ? _a : value;
    const OFFSET = -0.02;
    return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m)=>`${parseFloat(m) + OFFSET}`);
}
function $47a6d9fbbf7ee42d$var$toMediaQueryString(min, max) {
    const query = [
        "@media screen"
    ];
    if (min) query.push("and", `(min-width: ${$47a6d9fbbf7ee42d$var$px(min)})`);
    if (max) query.push("and", `(max-width: ${$47a6d9fbbf7ee42d$var$px(max)})`);
    return query.join(" ");
}
function $47a6d9fbbf7ee42d$var$analyzeBreakpoints(breakpoints) {
    var _a;
    if (!breakpoints) return null;
    breakpoints.base = (_a = breakpoints.base) != null ? _a : "0px";
    const normalized = $47a6d9fbbf7ee42d$var$normalize(breakpoints);
    const queries = Object.entries(breakpoints).sort($47a6d9fbbf7ee42d$var$sortByBreakpointValue).map(([breakpoint, minW], index, entry)=>{
        var _a2;
        let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
        maxW = parseFloat(maxW) > 0 ? $47a6d9fbbf7ee42d$var$subtract2(maxW) : void 0;
        return {
            _minW: $47a6d9fbbf7ee42d$var$subtract2(minW),
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $47a6d9fbbf7ee42d$var$toMediaQueryString(null, maxW),
            minWQuery: $47a6d9fbbf7ee42d$var$toMediaQueryString(minW),
            minMaxQuery: $47a6d9fbbf7ee42d$var$toMediaQueryString(minW, maxW)
        };
    });
    const _keys = $47a6d9fbbf7ee42d$var$keys(breakpoints);
    const _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive (test) {
            const keys2 = Object.keys(test);
            return keys2.length > 0 && keys2.every((key)=>_keys.has(key));
        },
        asObject: $47a6d9fbbf7ee42d$var$sortBps(breakpoints),
        asArray: $47a6d9fbbf7ee42d$var$normalize(breakpoints),
        details: queries,
        get (key) {
            return queries.find((q)=>q.breakpoint === key);
        },
        media: [
            null,
            ...normalized.map((minW)=>$47a6d9fbbf7ee42d$var$toMediaQueryString(minW)).slice(1)
        ],
        /**
     * Converts the object responsive syntax to array syntax
     *
     * @example
     * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
     */ toArrayValue (test) {
            if (!(0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(test)) throw new Error("toArrayValue: value must be an object");
            const result = _keysArr.map((bp)=>{
                var _a2;
                return (_a2 = test[bp]) != null ? _a2 : null;
            });
            while($47a6d9fbbf7ee42d$var$getLastItem(result) === null)result.pop();
            return result;
        },
        /**
     * Converts the array responsive syntax to object syntax
     *
     * @example
     * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
     */ toObjectValue (test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce((acc, value, index)=>{
                const key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}
// src/pseudos.ts
var $47a6d9fbbf7ee42d$var$state = {
    hover: (str, post)=>`${str}:hover ${post}, ${str}[data-hover] ${post}`,
    focus: (str, post)=>`${str}:focus ${post}, ${str}[data-focus] ${post}`,
    focusVisible: (str, post)=>`${str}:focus-visible ${post}`,
    focusWithin: (str, post)=>`${str}:focus-within ${post}`,
    active: (str, post)=>`${str}:active ${post}, ${str}[data-active] ${post}`,
    disabled: (str, post)=>`${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
    invalid: (str, post)=>`${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
    checked: (str, post)=>`${str}:checked ${post}, ${str}[data-checked] ${post}`,
    indeterminate: (str, post)=>`${str}:indeterminate ${post}, ${str}[aria-checked=mixed] ${post}, ${str}[data-indeterminate] ${post}`,
    readOnly: (str, post)=>`${str}:read-only ${post}, ${str}[readonly] ${post}, ${str}[data-read-only] ${post}`,
    expanded: (str, post)=>`${str}:read-only ${post}, ${str}[aria-expanded=true] ${post}, ${str}[data-expanded] ${post}`,
    placeholderShown: (str, post)=>`${str}:placeholder-shown ${post}`
};
var $47a6d9fbbf7ee42d$var$toGroup = (fn)=>$47a6d9fbbf7ee42d$var$merge((v)=>fn(v, "&"), "[role=group]", "[data-group]", ".group");
var $47a6d9fbbf7ee42d$var$toPeer = (fn)=>$47a6d9fbbf7ee42d$var$merge((v)=>fn(v, "~ &"), "[data-peer]", ".peer");
var $47a6d9fbbf7ee42d$var$merge = (fn, ...selectors)=>selectors.map(fn).join(", ");
var $47a6d9fbbf7ee42d$export$a36cf593fde2a546 = {
    /**
   * Styles for CSS selector `&:hover`
   */ _hover: "&:hover, &[data-hover]",
    /**
   * Styles for CSS Selector `&:active`
   */ _active: "&:active, &[data-active]",
    /**
   * Styles for CSS selector `&:focus`
   *
   */ _focus: "&:focus, &[data-focus]",
    /**
   * Styles for the highlighted state.
   */ _highlighted: "&[data-highlighted]",
    /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */ _focusWithin: "&:focus-within",
    /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */ _focusVisible: "&:focus-visible, &[data-focus-visible]",
    /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */ _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
    /**
   * Styles for CSS Selector `&:readonly`
   */ _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */ _before: "&::before",
    /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */ _after: "&::after",
    /**
   * Styles for CSS selector `&:empty`
   */ _empty: "&:empty",
    /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */ _expanded: "&[aria-expanded=true], &[data-expanded]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */ _checked: "&[aria-checked=true], &[data-checked]",
    /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */ _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */ _pressed: "&[aria-pressed=true], &[data-pressed]",
    /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */ _invalid: "&[aria-invalid=true], &[data-invalid]",
    /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */ _valid: "&[data-valid], &[data-state=valid]",
    /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */ _loading: "&[data-loading], &[aria-busy=true]",
    /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */ _selected: "&[aria-selected=true], &[data-selected]",
    /**
   * Styles for CSS Selector `[hidden=true]`
   */ _hidden: "&[hidden], &[data-hidden]",
    /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */ _autofill: "&:-webkit-autofill",
    /**
   * Styles for CSS Selector `&:nth-child(even)`
   */ _even: "&:nth-of-type(even)",
    /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */ _odd: "&:nth-of-type(odd)",
    /**
   * Styles for CSS Selector `&:first-of-type`
   */ _first: "&:first-of-type",
    /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */ _firstLetter: "&::first-letter",
    /**
   * Styles for CSS Selector `&:last-of-type`
   */ _last: "&:last-of-type",
    /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */ _notFirst: "&:not(:first-of-type)",
    /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */ _notLast: "&:not(:last-of-type)",
    /**
   * Styles for CSS Selector `&:visited`
   */ _visited: "&:visited",
    /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */ _activeLink: "&[aria-current=page]",
    /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */ _activeStep: "&[aria-current=step]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */ _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */ _groupHover: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.hover),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */ _peerHover: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.hover),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */ _groupFocus: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.focus),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */ _peerFocus: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.focus),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */ _groupFocusVisible: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.focusVisible),
    /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */ _peerFocusVisible: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.focusVisible),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */ _groupActive: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.active),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */ _peerActive: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.active),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */ _groupDisabled: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.disabled),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */ _peerDisabled: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.disabled),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */ _groupInvalid: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.invalid),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */ _peerInvalid: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.invalid),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */ _groupChecked: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.checked),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */ _peerChecked: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.checked),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */ _groupFocusWithin: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.focusWithin),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */ _peerFocusWithin: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.focusWithin),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */ _peerPlaceholderShown: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.placeholderShown),
    /**
   * Styles for CSS Selector `&::placeholder`.
   */ _placeholder: "&::placeholder",
    /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */ _placeholderShown: "&:placeholder-shown",
    /**
   * Styles for CSS Selector `&:fullscreen`.
   */ _fullScreen: "&:fullscreen",
    /**
   * Styles for CSS Selector `&::selection`
   */ _selection: "&::selection",
    /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */ _rtl: "[dir=rtl] &, &[dir=rtl]",
    /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */ _ltr: "[dir=ltr] &, &[dir=ltr]",
    /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */ _mediaDark: "@media (prefers-color-scheme: dark)",
    /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */ _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
    /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */ _horizontal: "&[data-orientation=horizontal]",
    /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */ _vertical: "&[data-orientation=vertical]"
};
var $47a6d9fbbf7ee42d$export$4ec9644154df43c2 = Object.keys($47a6d9fbbf7ee42d$export$a36cf593fde2a546);
function $47a6d9fbbf7ee42d$var$tokenToCssVar(token, prefix) {
    return $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(String(token).replace(/\./g, "-"), void 0, prefix);
}
function $47a6d9fbbf7ee42d$var$createThemeVars(flatTokens, options) {
    let cssVars = {};
    const cssMap = {};
    for (const [token, tokenValue] of Object.entries(flatTokens)){
        const { isSemantic: isSemantic, value: value } = tokenValue;
        const { variable: variable, reference: reference } = $47a6d9fbbf7ee42d$var$tokenToCssVar(token, options == null ? void 0 : options.cssVarPrefix);
        if (!isSemantic) {
            if (token.startsWith("space")) {
                const keys2 = token.split(".");
                const [firstKey, ...referenceKeys] = keys2;
                const negativeLookupKey = `${firstKey}.-${referenceKeys.join(".")}`;
                const negativeValue = $47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a.negate(value);
                const negatedReference = $47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a.negate(reference);
                cssMap[negativeLookupKey] = {
                    value: negativeValue,
                    var: variable,
                    varRef: negatedReference
                };
            }
            cssVars[variable] = value;
            cssMap[token] = {
                value: value,
                var: variable,
                varRef: reference
            };
            continue;
        }
        const lookupToken = (maybeToken)=>{
            const scale = String(token).split(".")[0];
            const withScale = [
                scale,
                maybeToken
            ].join(".");
            const resolvedTokenValue = flatTokens[withScale];
            if (!resolvedTokenValue) return maybeToken;
            const { reference: reference2 } = $47a6d9fbbf7ee42d$var$tokenToCssVar(withScale, options == null ? void 0 : options.cssVarPrefix);
            return reference2;
        };
        const normalizedValue = (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value) ? value : {
            default: value
        };
        cssVars = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(cssVars, Object.entries(normalizedValue).reduce((acc, [conditionAlias, conditionValue])=>{
            var _a, _b;
            if (!conditionValue) return acc;
            const tokenReference = lookupToken(`${conditionValue}`);
            if (conditionAlias === "default") {
                acc[variable] = tokenReference;
                return acc;
            }
            const conditionSelector = (_b = (_a = $47a6d9fbbf7ee42d$export$a36cf593fde2a546) == null ? void 0 : _a[conditionAlias]) != null ? _b : conditionAlias;
            acc[conditionSelector] = {
                [variable]: tokenReference
            };
            return acc;
        }, {}));
        cssMap[token] = {
            value: reference,
            var: variable,
            varRef: reference
        };
    }
    return {
        cssVars: cssVars,
        cssMap: cssMap
    };
}
// ../../utilities/object-utils/src/omit.ts
function $47a6d9fbbf7ee42d$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
// ../../utilities/object-utils/src/pick.ts
function $47a6d9fbbf7ee42d$var$pick(object, keysToPick) {
    const result = {};
    for (const key of keysToPick)if (key in object) result[key] = object[key];
    return result;
}
// ../../utilities/object-utils/src/walk-object.ts
function $47a6d9fbbf7ee42d$var$isObject5(value) {
    return typeof value === "object" && value != null && !Array.isArray(value);
}
function $47a6d9fbbf7ee42d$var$walkObject(target, predicate, options = {}) {
    const { stop: stop, getKey: getKey } = options;
    function inner(value, path = []) {
        var _a;
        if ($47a6d9fbbf7ee42d$var$isObject5(value) || Array.isArray(value)) {
            const result = {};
            for (const [prop, child] of Object.entries(value)){
                const key = (_a = getKey == null ? void 0 : getKey(prop)) != null ? _a : prop;
                const childPath = [
                    ...path,
                    key
                ];
                if (stop == null ? void 0 : stop(value, childPath)) return predicate(value, path);
                result[key] = inner(child, childPath);
            }
            return result;
        }
        return predicate(value, path);
    }
    return inner(target);
}
// src/create-theme-vars/theme-tokens.ts
var $47a6d9fbbf7ee42d$var$tokens = [
    "colors",
    "borders",
    "borderWidths",
    "borderStyles",
    "fonts",
    "fontSizes",
    "fontWeights",
    "gradients",
    "letterSpacings",
    "lineHeights",
    "radii",
    "space",
    "shadows",
    "sizes",
    "zIndices",
    "transition",
    "blur",
    "breakpoints"
];
function $47a6d9fbbf7ee42d$var$extractTokens(theme) {
    const _tokens = $47a6d9fbbf7ee42d$var$tokens;
    return $47a6d9fbbf7ee42d$var$pick(theme, _tokens);
}
function $47a6d9fbbf7ee42d$var$extractSemanticTokens(theme) {
    return theme.semanticTokens;
}
function $47a6d9fbbf7ee42d$var$omitVars(rawTheme) {
    const { __cssMap: __cssMap, __cssVars: __cssVars, __breakpoints: __breakpoints, ...cleanTheme } = rawTheme;
    return cleanTheme;
}
// src/create-theme-vars/flatten-tokens.ts
var $47a6d9fbbf7ee42d$var$isSemanticCondition = (key)=>$47a6d9fbbf7ee42d$export$4ec9644154df43c2.includes(key) || "default" === key;
function $47a6d9fbbf7ee42d$export$8f520cff3dbc4769({ tokens: tokens2, semanticTokens: semanticTokens }) {
    const result = {};
    $47a6d9fbbf7ee42d$var$walkObject(tokens2, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: false,
            value: value
        };
    });
    $47a6d9fbbf7ee42d$var$walkObject(semanticTokens, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: true,
            value: value
        };
    }, {
        stop: (value)=>Object.keys(value).every($47a6d9fbbf7ee42d$var$isSemanticCondition)
    });
    return result;
}
// src/create-theme-vars/to-css-var.ts
function $47a6d9fbbf7ee42d$export$d4e5dc2a444c0164(rawTheme) {
    var _a;
    const theme = $47a6d9fbbf7ee42d$var$omitVars(rawTheme);
    const tokens2 = $47a6d9fbbf7ee42d$var$extractTokens(theme);
    const semanticTokens = $47a6d9fbbf7ee42d$var$extractSemanticTokens(theme);
    const flatTokens = $47a6d9fbbf7ee42d$export$8f520cff3dbc4769({
        tokens: tokens2,
        semanticTokens: semanticTokens
    });
    const cssVarPrefix = (_a = theme.config) == null ? void 0 : _a.cssVarPrefix;
    const { cssMap: /**
     * This is more like a dictionary of tokens users will type `green.500`,
     * and their equivalent css variable.
     */ cssMap, cssVars: /**
     * The extracted css variables will be stored here, and used in
     * the emotion's <Global/> component to attach variables to `:root`
     */ cssVars } = $47a6d9fbbf7ee42d$var$createThemeVars(flatTokens, {
        cssVarPrefix: cssVarPrefix
    });
    const defaultCssVars = {
        "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
        "--chakra-ring-offset-width": "0px",
        "--chakra-ring-offset-color": "#fff",
        "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
        "--chakra-ring-offset-shadow": "0 0 #0000",
        "--chakra-ring-shadow": "0 0 #0000",
        "--chakra-space-x-reverse": "0",
        "--chakra-space-y-reverse": "0"
    };
    Object.assign(theme, {
        __cssVars: {
            ...defaultCssVars,
            ...cssVars
        },
        __cssMap: cssMap,
        __breakpoints: $47a6d9fbbf7ee42d$var$analyzeBreakpoints(theme.breakpoints)
    });
    return theme;
}
var $47a6d9fbbf7ee42d$export$30cfa87a708babfc = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412, $47a6d9fbbf7ee42d$export$1edee58a52776cd9, $47a6d9fbbf7ee42d$export$35e9368ef982300f, $47a6d9fbbf7ee42d$export$feec61708a55c80e, $47a6d9fbbf7ee42d$export$b3219800bda33a1f, $47a6d9fbbf7ee42d$export$3dea766d36a8935f, $47a6d9fbbf7ee42d$export$e7d0da6968da5dd, $47a6d9fbbf7ee42d$export$2499a341a8256d68, $47a6d9fbbf7ee42d$export$85fc379452d91af0, $47a6d9fbbf7ee42d$export$36263e8f8d7ce3b1, $47a6d9fbbf7ee42d$export$5880b8b5730aff45, $47a6d9fbbf7ee42d$export$dc573d8a6576cdb3, $47a6d9fbbf7ee42d$export$a941ed4b947d12f8, $47a6d9fbbf7ee42d$export$209876d7b1ac8f3, $47a6d9fbbf7ee42d$export$d846a084e680d8e, $47a6d9fbbf7ee42d$export$6b7f9af9aa033040, $47a6d9fbbf7ee42d$export$51186ad6e864892a, $47a6d9fbbf7ee42d$export$8837f4fc672e936d, $47a6d9fbbf7ee42d$export$66bb15e2994e6a26);
var $47a6d9fbbf7ee42d$var$layoutSystem = Object.assign({}, $47a6d9fbbf7ee42d$export$a941ed4b947d12f8, $47a6d9fbbf7ee42d$export$b3219800bda33a1f, $47a6d9fbbf7ee42d$export$feec61708a55c80e, $47a6d9fbbf7ee42d$export$85fc379452d91af0, $47a6d9fbbf7ee42d$export$5880b8b5730aff45);
var $47a6d9fbbf7ee42d$export$bccb7c6ca2f4f912 = Object.keys($47a6d9fbbf7ee42d$var$layoutSystem);
var $47a6d9fbbf7ee42d$export$332cc7004bcbb8b4 = [
    ...Object.keys($47a6d9fbbf7ee42d$export$30cfa87a708babfc),
    ...$47a6d9fbbf7ee42d$export$4ec9644154df43c2
];
var $47a6d9fbbf7ee42d$var$styleProps = {
    ...$47a6d9fbbf7ee42d$export$30cfa87a708babfc,
    ...$47a6d9fbbf7ee42d$export$a36cf593fde2a546
};
var $47a6d9fbbf7ee42d$export$95b76554d0cd12d6 = (prop)=>prop in $47a6d9fbbf7ee42d$var$styleProps;
var $47a6d9fbbf7ee42d$var$expandResponsive = (styles)=>(theme)=>{
        if (!theme.__breakpoints) return styles;
        const { isResponsive: isResponsive, toArrayValue: toArrayValue, media: medias } = theme.__breakpoints;
        const computedStyles = {};
        for(const key in styles){
            let value = (0, $abe97432afb3d989$export$624e501d81f5ffce)(styles[key], theme);
            if (value == null) continue;
            value = (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value) && isResponsive(value) ? toArrayValue(value) : value;
            if (!Array.isArray(value)) {
                computedStyles[key] = value;
                continue;
            }
            const queries = value.slice(0, medias.length).length;
            for(let index = 0; index < queries; index += 1){
                const media = medias == null ? void 0 : medias[index];
                if (!media) {
                    computedStyles[key] = value[index];
                    continue;
                }
                computedStyles[media] = computedStyles[media] || {};
                if (value[index] == null) continue;
                computedStyles[media][key] = value[index];
            }
        }
        return computedStyles;
    };
// src/utils/split-by-comma.ts
function $47a6d9fbbf7ee42d$var$splitByComma(value) {
    const chunks = [];
    let chunk = "";
    let inParens = false;
    for(let i = 0; i < value.length; i++){
        const char = value[i];
        if (char === "(") {
            inParens = true;
            chunk += char;
        } else if (char === ")") {
            inParens = false;
            chunk += char;
        } else if (char === "," && !inParens) {
            chunks.push(chunk);
            chunk = "";
        } else chunk += char;
    }
    chunk = chunk.trim();
    if (chunk) chunks.push(chunk);
    return chunks;
}
// src/css.ts
function $47a6d9fbbf7ee42d$var$isCssVar2(value) {
    return /^var\(--.+\)$/.test(value);
}
var $47a6d9fbbf7ee42d$var$isCSSVariableTokenValue = (key, value)=>key.startsWith("--") && typeof value === "string" && !$47a6d9fbbf7ee42d$var$isCssVar2(value);
var $47a6d9fbbf7ee42d$var$resolveTokenValue = (theme, value)=>{
    var _a, _b;
    if (value == null) return value;
    const getVar = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.varRef;
    };
    const getValue = (val)=>{
        var _a2;
        return (_a2 = getVar(val)) != null ? _a2 : val;
    };
    const [tokenValue, fallbackValue] = $47a6d9fbbf7ee42d$var$splitByComma(value);
    value = (_b = (_a = getVar(tokenValue)) != null ? _a : getValue(fallbackValue)) != null ? _b : getValue(value);
    return value;
};
function $47a6d9fbbf7ee42d$export$955358618f994a11(options) {
    const { configs: configs = {}, pseudos: pseudos = {}, theme: theme } = options;
    const css2 = (stylesOrFn, nested = false)=>{
        var _a, _b, _c;
        const _styles = (0, $abe97432afb3d989$export$624e501d81f5ffce)(stylesOrFn, theme);
        const styles = $47a6d9fbbf7ee42d$var$expandResponsive(_styles)(theme);
        let computedStyles = {};
        for(let key in styles){
            const valueOrFn = styles[key];
            let value = (0, $abe97432afb3d989$export$624e501d81f5ffce)(valueOrFn, theme);
            if (key in pseudos) key = pseudos[key];
            if ($47a6d9fbbf7ee42d$var$isCSSVariableTokenValue(key, value)) value = $47a6d9fbbf7ee42d$var$resolveTokenValue(theme, value);
            let config = configs[key];
            if (config === true) config = {
                property: key
            };
            if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value)) {
                computedStyles[key] = (_a = computedStyles[key]) != null ? _a : {};
                computedStyles[key] = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles[key], css2(value, true));
                continue;
            }
            let rawValue = (_c = (_b = config == null ? void 0 : config.transform) == null ? void 0 : _b.call(config, value, theme, _styles)) != null ? _c : value;
            rawValue = (config == null ? void 0 : config.processResult) ? css2(rawValue, true) : rawValue;
            const configProperty = (0, $abe97432afb3d989$export$624e501d81f5ffce)(config == null ? void 0 : config.property, theme);
            if (!nested && (config == null ? void 0 : config.static)) {
                const staticStyles = (0, $abe97432afb3d989$export$624e501d81f5ffce)(config.static, theme);
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, staticStyles);
            }
            if (configProperty && Array.isArray(configProperty)) {
                for (const property of configProperty)computedStyles[property] = rawValue;
                continue;
            }
            if (configProperty) {
                if (configProperty === "&" && (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(rawValue)) computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, rawValue);
                else computedStyles[configProperty] = rawValue;
                continue;
            }
            if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(rawValue)) {
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, rawValue);
                continue;
            }
            computedStyles[key] = rawValue;
        }
        return computedStyles;
    };
    return css2;
}
var $47a6d9fbbf7ee42d$export$dbf350e5966cf602 = (styles)=>(theme)=>{
        const cssFn = $47a6d9fbbf7ee42d$export$955358618f994a11({
            theme: theme,
            pseudos: $47a6d9fbbf7ee42d$export$a36cf593fde2a546,
            configs: $47a6d9fbbf7ee42d$export$30cfa87a708babfc
        });
        return cssFn(styles);
    };
// src/define-styles.ts
function $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839(styles) {
    return styles;
}
function $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4(config) {
    return config;
}
function $47a6d9fbbf7ee42d$export$d5f717dc145477b8(parts) {
    return {
        definePartsStyle (config) {
            return config;
        },
        defineMultiStyleConfig (config) {
            return {
                parts: parts,
                ...config
            };
        }
    };
}
function $47a6d9fbbf7ee42d$var$normalize2(value, toArray) {
    if (Array.isArray(value)) return value;
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value)) return toArray(value);
    if (value != null) return [
        value
    ];
}
function $47a6d9fbbf7ee42d$var$getNextIndex(values, i) {
    for(let j = i + 1; j < values.length; j++){
        if (values[j] != null) return j;
    }
    return -1;
}
function $47a6d9fbbf7ee42d$var$createResolver(theme) {
    const breakpointUtil = theme.__breakpoints;
    return function resolver(config, prop, value, props) {
        var _a, _b;
        if (!breakpointUtil) return;
        const result = {};
        const normalized = $47a6d9fbbf7ee42d$var$normalize2(value, breakpointUtil.toArrayValue);
        if (!normalized) return result;
        const len = normalized.length;
        const isSingle = len === 1;
        const isMultipart = !!config.parts;
        for(let i = 0; i < len; i++){
            const key = breakpointUtil.details[i];
            const nextKey = breakpointUtil.details[$47a6d9fbbf7ee42d$var$getNextIndex(normalized, i)];
            const query = $47a6d9fbbf7ee42d$var$toMediaQueryString(key.minW, nextKey == null ? void 0 : nextKey._minW);
            const styles = (0, $abe97432afb3d989$export$624e501d81f5ffce)((_a = config[prop]) == null ? void 0 : _a[normalized[i]], props);
            if (!styles) continue;
            if (isMultipart) {
                (_b = config.parts) == null || _b.forEach((part)=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(result, {
                        [part]: isSingle ? styles[part] : {
                            [query]: styles[part]
                        }
                    });
                });
                continue;
            }
            if (!isMultipart) {
                if (isSingle) (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(result, styles);
                else result[query] = styles;
                continue;
            }
            result[query] = styles;
        }
        return result;
    };
}
function $47a6d9fbbf7ee42d$export$f94106bbb00e81eb(config) {
    return (props)=>{
        var _a;
        const { variant: variant, size: size, theme: theme } = props;
        const recipe = $47a6d9fbbf7ee42d$var$createResolver(theme);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, (0, $abe97432afb3d989$export$624e501d81f5ffce)((_a = config.baseStyle) != null ? _a : {}, props), recipe(config, "sizes", size, props), recipe(config, "variants", variant, props));
    };
}
// src/get-css-var.ts
function $47a6d9fbbf7ee42d$export$93c8e06b7014dc33(theme, scale, value) {
    var _a, _b, _c;
    return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
}
// src/theming-props.ts
function $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785(props) {
    return $47a6d9fbbf7ee42d$var$omit(props, [
        "styleConfig",
        "size",
        "variant",
        "colorScheme"
    ]);
}


// src/object.ts

var $5Gn6I = parcelRequire("5Gn6I");
function $8cabe7dbd312f1c1$export$30a06c8d3562193f(object, keys) {
    const result = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) return;
        result[key] = object[key];
    });
    return result;
}
function $8cabe7dbd312f1c1$export$357523c63a2253b9(object, keys) {
    const result = {};
    keys.forEach((key)=>{
        if (key in object) result[key] = object[key];
    });
    return result;
}
function $8cabe7dbd312f1c1$export$65980d18b75784e2(object, keys) {
    const picked = {};
    const omitted = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) picked[key] = object[key];
        else omitted[key] = object[key];
    });
    return [
        picked,
        omitted
    ];
}
function $8cabe7dbd312f1c1$export$3988ae62b71be9a3(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
var $8cabe7dbd312f1c1$export$fc10aeed3a532e2a = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $8cabe7dbd312f1c1$export$1bb32d0c65da6059 = $8cabe7dbd312f1c1$export$fc10aeed3a532e2a($8cabe7dbd312f1c1$export$3988ae62b71be9a3);
function $8cabe7dbd312f1c1$export$73b8ef55a37133c7(path, scale) {
    return $8cabe7dbd312f1c1$export$1bb32d0c65da6059(scale, path, path);
}
function $8cabe7dbd312f1c1$export$3417cf6417437960(object, fn) {
    const result = {};
    Object.keys(object).forEach((key)=>{
        const value = object[key];
        const shouldPass = fn(value, key, object);
        if (shouldPass) result[key] = value;
    });
    return result;
}
var $8cabe7dbd312f1c1$export$2458ce75c8ef9806 = (object)=>$8cabe7dbd312f1c1$export$3417cf6417437960(object, (val)=>val !== null && val !== void 0);
var $8cabe7dbd312f1c1$export$259b4dd69e654a7a = (obj)=>Object.keys(obj);
var $8cabe7dbd312f1c1$export$5150077fc2e7c662 = (entries)=>entries.reduce((carry, [key, value])=>{
        carry[key] = value;
        return carry;
    }, {});
var $8cabe7dbd312f1c1$export$93c8e06b7014dc33 = (theme, scale, value)=>{
    var _a, _b, _c;
    return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
};

// src/assertion.ts
function $fbf5a7a3c8624538$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $fbf5a7a3c8624538$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $fbf5a7a3c8624538$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
}
function $fbf5a7a3c8624538$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $fbf5a7a3c8624538$export$4c0262a4f954db45(value) {
    return $fbf5a7a3c8624538$export$43bee75e5e14138e(value) && value.length === 0;
}
function $fbf5a7a3c8624538$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $fbf5a7a3c8624538$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== void 0;
}
function $fbf5a7a3c8624538$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === void 0;
}
function $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$fbf5a7a3c8624538$export$43bee75e5e14138e(value);
}
function $fbf5a7a3c8624538$export$83b788b1a3698c03(value) {
    return $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $fbf5a7a3c8624538$export$e0287cc73292b477(value) {
    return value && !$fbf5a7a3c8624538$export$83b788b1a3698c03(value);
}
function $fbf5a7a3c8624538$export$630801d484da15df(value) {
    return value == null;
}
function $fbf5a7a3c8624538$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $fbf5a7a3c8624538$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
}
function $fbf5a7a3c8624538$export$dd1bc94b04021eeb(value) {
    if ($fbf5a7a3c8624538$export$43bee75e5e14138e(value)) return $fbf5a7a3c8624538$export$4c0262a4f954db45(value);
    if ($fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value)) return $fbf5a7a3c8624538$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
var $fbf5a7a3c8624538$export$a866f231438cc228 = false;
var $fbf5a7a3c8624538$export$61cb32cff9a99948 = false;
function $fbf5a7a3c8624538$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $fbf5a7a3c8624538$export$4215e022093e324e(value) {
    return value && $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value) && $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value.target);
}


// src/function.ts
function $7e9e3a2462729b7f$export$624e501d81f5ffce(valueOrFn, ...args) {
    return (0, $fbf5a7a3c8624538$export$f6e2535fb5126e54)(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function $7e9e3a2462729b7f$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $7e9e3a2462729b7f$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}
var $7e9e3a2462729b7f$export$f672e0b6f7222cd7 = (fn1, ...fns)=>fns.reduce((f1, f2)=>(...args)=>f1(f2(...args)), fn1);
function $7e9e3a2462729b7f$export$d2de3aaeafa91619(fn) {
    let result;
    return function func(...args) {
        if (fn) {
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
var $7e9e3a2462729b7f$export$8793edee2d425525 = ()=>{};
var $7e9e3a2462729b7f$export$c106dd0671a0fc2d = /* @__PURE__ */ $7e9e3a2462729b7f$export$d2de3aaeafa91619((options)=>()=>{
        const { condition: condition, message: message } = options;
        if (condition && (0, $fbf5a7a3c8624538$export$a866f231438cc228)) console.warn(message);
    });
var $7e9e3a2462729b7f$export$a3bc9b8ed74fc = /* @__PURE__ */ $7e9e3a2462729b7f$export$d2de3aaeafa91619((options)=>()=>{
        const { condition: condition, message: message } = options;
        if (condition && (0, $fbf5a7a3c8624538$export$a866f231438cc228)) console.error(message);
    });
var $7e9e3a2462729b7f$export$a4627e546088548d = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);
var $7e9e3a2462729b7f$var$distance1D = (a, b)=>Math.abs(a - b);
var $7e9e3a2462729b7f$var$isPoint = (point)=>"x" in point && "y" in point;
function $7e9e3a2462729b7f$export$9f17032d917177de(a, b) {
    if ((0, $fbf5a7a3c8624538$export$7e4aa119212bc614)(a) && (0, $fbf5a7a3c8624538$export$7e4aa119212bc614)(b)) return $7e9e3a2462729b7f$var$distance1D(a, b);
    if ($7e9e3a2462729b7f$var$isPoint(a) && $7e9e3a2462729b7f$var$isPoint(b)) {
        const xDelta = $7e9e3a2462729b7f$var$distance1D(a.x, b.x);
        const yDelta = $7e9e3a2462729b7f$var$distance1D(a.y, b.y);
        return Math.sqrt(xDelta ** 2 + yDelta ** 2);
    }
    return 0;
}




var $acw62 = parcelRequire("acw62");

"use client";
function $c3f04b55c7a24011$export$d8964aec282183a3(props) {
    const { cssVarsRoot: cssVarsRoot, theme: theme, children: children } = props;
    const computedTheme = (0, $acw62.useMemo)(()=>(0, $47a6d9fbbf7ee42d$export$d4e5dc2a444c0164)(theme), [
        theme
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $0fe24a6591b39473$export$407448d2b89b1813), {
        theme: computedTheme,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c3f04b55c7a24011$export$d767872124667db6, {
                root: cssVarsRoot
            }),
            children
        ]
    });
}
function $c3f04b55c7a24011$export$d767872124667db6({ root: root = ":host, :root" }) {
    const selector = [
        root,
        `[data-theme]`
    ].join(",");
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: (theme)=>({
                [selector]: theme.__cssVars
            })
    });
}
var [$c3f04b55c7a24011$export$dc4c659861f00dbe, $c3f04b55c7a24011$export$28e6b9b82ee883c] = (0, $e54f09380e048946$export$fd42f52fd3ae1109)({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function $c3f04b55c7a24011$export$11d9f9905bcdc114(componentName) {
    return (0, $e54f09380e048946$export$fd42f52fd3ae1109)({
        name: `${componentName}StylesContext`,
        errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
    });
}
function $c3f04b55c7a24011$export$f05794e648629f6c() {
    const { colorMode: colorMode } = (0, $b80b1cf263c5808a$export$20f3076712c8dfa)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: (theme)=>{
            const styleObjectOrFn = (0, $8cabe7dbd312f1c1$export$1bb32d0c65da6059)(theme, "styles.global");
            const globalStyles = (0, $7e9e3a2462729b7f$export$624e501d81f5ffce)(styleObjectOrFn, {
                theme: theme,
                colorMode: colorMode
            });
            if (!globalStyles) return void 0;
            const styles = (0, $47a6d9fbbf7ee42d$export$dbf350e5966cf602)(globalStyles)(theme);
            return styles;
        }
    });
}




var $acw62 = parcelRequire("acw62");

"use client";
var $3a87268155f9f2cb$var$EnvironmentContext = (0, $acw62.createContext)({
    getDocument () {
        return document;
    },
    getWindow () {
        return window;
    }
});
$3a87268155f9f2cb$var$EnvironmentContext.displayName = "EnvironmentContext";
function $3a87268155f9f2cb$export$ea7ed2425832167d({ defer: defer } = {}) {
    const [, forceUpdate] = (0, $acw62.useReducer)((c)=>c + 1, 0);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!defer) return;
        forceUpdate();
    }, [
        defer
    ]);
    return (0, $acw62.useContext)($3a87268155f9f2cb$var$EnvironmentContext);
}
function $3a87268155f9f2cb$export$29a4c0b32fc9db42(props) {
    const { children: children, environment: environmentProp, disabled: disabled } = props;
    const ref = (0, $acw62.useRef)(null);
    const context = (0, $acw62.useMemo)(()=>{
        if (environmentProp) return environmentProp;
        return {
            getDocument: ()=>{
                var _a, _b;
                return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
            },
            getWindow: ()=>{
                var _a, _b;
                return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument.defaultView) != null ? _b : window;
            }
        };
    }, [
        environmentProp
    ]);
    const showSpan = !disabled || !environmentProp;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($3a87268155f9f2cb$var$EnvironmentContext.Provider, {
        value: context,
        children: [
            children,
            showSpan && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                id: "__chakra_env",
                hidden: true,
                ref: ref
            })
        ]
    });
}
$3a87268155f9f2cb$export$29a4c0b32fc9db42.displayName = "EnvironmentProvider";



"use client";
var $be3187ddebc65cb1$export$80dbe0482bcbd25a = (props)=>{
    const { children: children, colorModeManager: colorModeManager, portalZIndex: portalZIndex, resetScope: resetScope, resetCSS: resetCSS = true, theme: theme = {}, environment: environment, cssVarsRoot: cssVarsRoot, disableEnvironment: disableEnvironment, disableGlobalStyle: disableGlobalStyle } = props;
    const _children = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a87268155f9f2cb$export$29a4c0b32fc9db42), {
        environment: environment,
        disabled: disableEnvironment,
        children: children
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c3f04b55c7a24011$export$d8964aec282183a3), {
        theme: theme,
        cssVarsRoot: cssVarsRoot,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $78f995395c70cd91$export$7a858aa3ff83dde7), {
            colorModeManager: colorModeManager,
            options: theme.config,
            children: [
                resetCSS ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c3e440ef7c3cf4d3$export$b751feffed387621), {
                    scope: resetScope
                }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c3e440ef7c3cf4d3$export$43a6590e493ec44a), {}),
                !disableGlobalStyle && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c3f04b55c7a24011$export$f05794e648629f6c), {}),
                portalZIndex ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cb17b1dba222b22e$export$52c7ef79917c2f38), {
                    zIndex: portalZIndex,
                    children: _children
                }) : _children
            ]
        })
    });
};


// src/utils/is-chakra-theme.ts

var $aef2905091b67153$export$1fad0bb5bac74e8f = [
    "borders",
    "breakpoints",
    "colors",
    "components",
    "config",
    "direction",
    "fonts",
    "fontSizes",
    "fontWeights",
    "letterSpacings",
    "lineHeights",
    "radii",
    "shadows",
    "sizes",
    "space",
    "styles",
    "transition",
    "zIndices"
];
function $aef2905091b67153$export$73a6ae01926a4f0e(unit) {
    if (!(0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(unit)) return false;
    return $aef2905091b67153$export$1fad0bb5bac74e8f.every((propertyName)=>Object.prototype.hasOwnProperty.call(unit, propertyName));
}


// src/foundations/transition.ts
var $eb8fb47cfbaf0bb1$var$transitionProperty = {
    common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
    colors: "background-color, border-color, color, fill, stroke",
    dimensions: "width, height",
    position: "left, right, top, bottom",
    background: "background-color, background-image, background-position"
};
var $eb8fb47cfbaf0bb1$var$transitionTimingFunction = {
    "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
var $eb8fb47cfbaf0bb1$var$transitionDuration = {
    "ultra-fast": "50ms",
    faster: "100ms",
    fast: "150ms",
    normal: "200ms",
    slow: "300ms",
    slower: "400ms",
    "ultra-slow": "500ms"
};
var $eb8fb47cfbaf0bb1$var$transition = {
    property: $eb8fb47cfbaf0bb1$var$transitionProperty,
    easing: $eb8fb47cfbaf0bb1$var$transitionTimingFunction,
    duration: $eb8fb47cfbaf0bb1$var$transitionDuration
};
var $eb8fb47cfbaf0bb1$export$6b266f9cfc4b7bb8 = $eb8fb47cfbaf0bb1$var$transition;


// src/foundations/z-index.ts
var $5c128a6478f2f777$var$zIndices = {
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1e3,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
};
var $5c128a6478f2f777$export$d9d5ef55fed42171 = $5c128a6478f2f777$var$zIndices;


// src/foundations/borders.ts
var $8c29ebe7b5760de6$var$borders = {
    none: 0,
    "1px": "1px solid",
    "2px": "2px solid",
    "4px": "4px solid",
    "8px": "8px solid"
};
var $8c29ebe7b5760de6$export$196bfcf31ca4deb7 = $8c29ebe7b5760de6$var$borders;


// src/foundations/breakpoints.ts
var $3e302c9a7cffe64d$var$breakpoints = {
    base: "0em",
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em"
};
var $3e302c9a7cffe64d$export$d0717e75346b884a = $3e302c9a7cffe64d$var$breakpoints;


// src/foundations/colors.ts
var $f42a724eb45b3bb9$var$colors = {
    transparent: "transparent",
    current: "currentColor",
    black: "#000000",
    white: "#FFFFFF",
    whiteAlpha: {
        50: "rgba(255, 255, 255, 0.04)",
        100: "rgba(255, 255, 255, 0.06)",
        200: "rgba(255, 255, 255, 0.08)",
        300: "rgba(255, 255, 255, 0.16)",
        400: "rgba(255, 255, 255, 0.24)",
        500: "rgba(255, 255, 255, 0.36)",
        600: "rgba(255, 255, 255, 0.48)",
        700: "rgba(255, 255, 255, 0.64)",
        800: "rgba(255, 255, 255, 0.80)",
        900: "rgba(255, 255, 255, 0.92)"
    },
    blackAlpha: {
        50: "rgba(0, 0, 0, 0.04)",
        100: "rgba(0, 0, 0, 0.06)",
        200: "rgba(0, 0, 0, 0.08)",
        300: "rgba(0, 0, 0, 0.16)",
        400: "rgba(0, 0, 0, 0.24)",
        500: "rgba(0, 0, 0, 0.36)",
        600: "rgba(0, 0, 0, 0.48)",
        700: "rgba(0, 0, 0, 0.64)",
        800: "rgba(0, 0, 0, 0.80)",
        900: "rgba(0, 0, 0, 0.92)"
    },
    gray: {
        50: "#F7FAFC",
        100: "#EDF2F7",
        200: "#E2E8F0",
        300: "#CBD5E0",
        400: "#A0AEC0",
        500: "#718096",
        600: "#4A5568",
        700: "#2D3748",
        800: "#1A202C",
        900: "#171923"
    },
    red: {
        50: "#FFF5F5",
        100: "#FED7D7",
        200: "#FEB2B2",
        300: "#FC8181",
        400: "#F56565",
        500: "#E53E3E",
        600: "#C53030",
        700: "#9B2C2C",
        800: "#822727",
        900: "#63171B"
    },
    orange: {
        50: "#FFFAF0",
        100: "#FEEBC8",
        200: "#FBD38D",
        300: "#F6AD55",
        400: "#ED8936",
        500: "#DD6B20",
        600: "#C05621",
        700: "#9C4221",
        800: "#7B341E",
        900: "#652B19"
    },
    yellow: {
        50: "#FFFFF0",
        100: "#FEFCBF",
        200: "#FAF089",
        300: "#F6E05E",
        400: "#ECC94B",
        500: "#D69E2E",
        600: "#B7791F",
        700: "#975A16",
        800: "#744210",
        900: "#5F370E"
    },
    green: {
        50: "#F0FFF4",
        100: "#C6F6D5",
        200: "#9AE6B4",
        300: "#68D391",
        400: "#48BB78",
        500: "#38A169",
        600: "#2F855A",
        700: "#276749",
        800: "#22543D",
        900: "#1C4532"
    },
    teal: {
        50: "#E6FFFA",
        100: "#B2F5EA",
        200: "#81E6D9",
        300: "#4FD1C5",
        400: "#38B2AC",
        500: "#319795",
        600: "#2C7A7B",
        700: "#285E61",
        800: "#234E52",
        900: "#1D4044"
    },
    blue: {
        50: "#ebf8ff",
        100: "#bee3f8",
        200: "#90cdf4",
        300: "#63b3ed",
        400: "#4299e1",
        500: "#3182ce",
        600: "#2b6cb0",
        700: "#2c5282",
        800: "#2a4365",
        900: "#1A365D"
    },
    cyan: {
        50: "#EDFDFD",
        100: "#C4F1F9",
        200: "#9DECF9",
        300: "#76E4F7",
        400: "#0BC5EA",
        500: "#00B5D8",
        600: "#00A3C4",
        700: "#0987A0",
        800: "#086F83",
        900: "#065666"
    },
    purple: {
        50: "#FAF5FF",
        100: "#E9D8FD",
        200: "#D6BCFA",
        300: "#B794F4",
        400: "#9F7AEA",
        500: "#805AD5",
        600: "#6B46C1",
        700: "#553C9A",
        800: "#44337A",
        900: "#322659"
    },
    pink: {
        50: "#FFF5F7",
        100: "#FED7E2",
        200: "#FBB6CE",
        300: "#F687B3",
        400: "#ED64A6",
        500: "#D53F8C",
        600: "#B83280",
        700: "#97266D",
        800: "#702459",
        900: "#521B41"
    },
    linkedin: {
        50: "#E8F4F9",
        100: "#CFEDFB",
        200: "#9BDAF3",
        300: "#68C7EC",
        400: "#34B3E4",
        500: "#00A0DC",
        600: "#008CC9",
        700: "#0077B5",
        800: "#005E93",
        900: "#004471"
    },
    facebook: {
        50: "#E8F4F9",
        100: "#D9DEE9",
        200: "#B7C2DA",
        300: "#6482C0",
        400: "#4267B2",
        500: "#385898",
        600: "#314E89",
        700: "#29487D",
        800: "#223B67",
        900: "#1E355B"
    },
    messenger: {
        50: "#D0E6FF",
        100: "#B9DAFF",
        200: "#A2CDFF",
        300: "#7AB8FF",
        400: "#2E90FF",
        500: "#0078FF",
        600: "#0063D1",
        700: "#0052AC",
        800: "#003C7E",
        900: "#002C5C"
    },
    whatsapp: {
        50: "#dffeec",
        100: "#b9f5d0",
        200: "#90edb3",
        300: "#65e495",
        400: "#3cdd78",
        500: "#22c35e",
        600: "#179848",
        700: "#0c6c33",
        800: "#01421c",
        900: "#001803"
    },
    twitter: {
        50: "#E5F4FD",
        100: "#C8E9FB",
        200: "#A8DCFA",
        300: "#83CDF7",
        400: "#57BBF5",
        500: "#1DA1F2",
        600: "#1A94DA",
        700: "#1681BF",
        800: "#136B9E",
        900: "#0D4D71"
    },
    telegram: {
        50: "#E3F2F9",
        100: "#C5E4F3",
        200: "#A2D4EC",
        300: "#7AC1E4",
        400: "#47A9DA",
        500: "#0088CC",
        600: "#007AB8",
        700: "#006BA1",
        800: "#005885",
        900: "#003F5E"
    }
};
var $f42a724eb45b3bb9$export$59d2d4241383b416 = $f42a724eb45b3bb9$var$colors;


// src/foundations/radius.ts
var $beb2548c75cdd2c4$var$radii = {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
};
var $beb2548c75cdd2c4$export$9aaceac1356558f4 = $beb2548c75cdd2c4$var$radii;


// src/foundations/shadows.ts
var $a1d552cef6acc66c$var$shadows = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    none: "none",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
};
var $a1d552cef6acc66c$export$e70f92e6000288b2 = $a1d552cef6acc66c$var$shadows;


// src/foundations/blur.ts
var $f5367ce162a53076$var$blur = {
    none: 0,
    sm: "4px",
    base: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px"
};
var $f5367ce162a53076$export$6b4e890355bf1451 = $f5367ce162a53076$var$blur;


// src/foundations/typography.ts
var $bba87cd2f18bf49d$var$typography = {
    letterSpacings: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
    },
    lineHeights: {
        normal: "normal",
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: "2",
        "3": ".75rem",
        "4": "1rem",
        "5": "1.25rem",
        "6": "1.5rem",
        "7": "1.75rem",
        "8": "2rem",
        "9": "2.25rem",
        "10": "2.5rem"
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900
    },
    fonts: {
        heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    },
    fontSizes: {
        "3xs": "0.45rem",
        "2xs": "0.625rem",
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        "2xl": "1.5rem",
        "3xl": "1.875rem",
        "4xl": "2.25rem",
        "5xl": "3rem",
        "6xl": "3.75rem",
        "7xl": "4.5rem",
        "8xl": "6rem",
        "9xl": "8rem"
    }
};
var $bba87cd2f18bf49d$export$d7c5d8884f83c8db = $bba87cd2f18bf49d$var$typography;


// src/foundations/spacing.ts
var $143dd6fc2d04db62$export$5458b64234d1333c = {
    px: "1px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};


// src/foundations/sizes.ts
var $5013d2c172615a00$var$largeSizes = {
    max: "max-content",
    min: "min-content",
    full: "100%",
    "3xs": "14rem",
    "2xs": "16rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    "8xl": "90rem",
    prose: "60ch"
};
var $5013d2c172615a00$var$container = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px"
};
var $5013d2c172615a00$var$sizes = {
    ...(0, $143dd6fc2d04db62$export$5458b64234d1333c),
    ...$5013d2c172615a00$var$largeSizes,
    container: $5013d2c172615a00$var$container
};
var $5013d2c172615a00$export$d7d4c689520cc141 = $5013d2c172615a00$var$sizes;



// src/foundations/index.ts
var $0f31d8688ec7fbf0$export$651a0b7b10dae380 = {
    breakpoints: (0, $3e302c9a7cffe64d$export$d0717e75346b884a),
    zIndices: (0, $5c128a6478f2f777$export$d9d5ef55fed42171),
    radii: (0, $beb2548c75cdd2c4$export$9aaceac1356558f4),
    blur: (0, $f5367ce162a53076$export$6b4e890355bf1451),
    colors: (0, $f42a724eb45b3bb9$export$59d2d4241383b416),
    ...(0, $bba87cd2f18bf49d$export$d7c5d8884f83c8db),
    sizes: (0, $5013d2c172615a00$export$d7d4c689520cc141),
    shadows: (0, $a1d552cef6acc66c$export$e70f92e6000288b2),
    space: (0, $143dd6fc2d04db62$export$5458b64234d1333c),
    borders: (0, $8c29ebe7b5760de6$export$196bfcf31ca4deb7),
    transition: (0, $eb8fb47cfbaf0bb1$export$6b266f9cfc4b7bb8)
};










// src/components/stepper.ts

var { defineMultiStyleConfig: $b8eda56a5e8ca863$var$defineMultiStyleConfig, definePartsStyle: $b8eda56a5e8ca863$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)([
    "stepper",
    "step",
    "title",
    "description",
    "indicator",
    "separator",
    "icon",
    "number"
]);
var $b8eda56a5e8ca863$var$$size = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-indicator-size");
var $b8eda56a5e8ca863$var$$iconSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-icon-size");
var $b8eda56a5e8ca863$var$$titleFontSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-title-font-size");
var $b8eda56a5e8ca863$var$$descFontSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-description-font-size");
var $b8eda56a5e8ca863$var$$accentColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-accent-color");
var $b8eda56a5e8ca863$var$baseStyle = $b8eda56a5e8ca863$var$definePartsStyle(({ colorScheme: c })=>({
        stepper: {
            display: "flex",
            justifyContent: "space-between",
            gap: "4",
            "&[data-orientation=vertical]": {
                flexDirection: "column",
                alignItems: "flex-start"
            },
            "&[data-orientation=horizontal]": {
                flexDirection: "row",
                alignItems: "center"
            },
            [$b8eda56a5e8ca863$var$$accentColor.variable]: `colors.${c}.500`,
            _dark: {
                [$b8eda56a5e8ca863$var$$accentColor.variable]: `colors.${c}.200`
            }
        },
        title: {
            fontSize: $b8eda56a5e8ca863$var$$titleFontSize.reference,
            fontWeight: "medium"
        },
        description: {
            fontSize: $b8eda56a5e8ca863$var$$descFontSize.reference,
            color: "chakra-subtle-text"
        },
        number: {
            fontSize: $b8eda56a5e8ca863$var$$titleFontSize.reference
        },
        step: {
            flexShrink: 0,
            position: "relative",
            display: "flex",
            gap: "2",
            "&[data-orientation=horizontal]": {
                alignItems: "center"
            },
            flex: "1",
            "&:last-of-type:not([data-stretch])": {
                flex: "initial"
            }
        },
        icon: {
            flexShrink: 0,
            width: $b8eda56a5e8ca863$var$$iconSize.reference,
            height: $b8eda56a5e8ca863$var$$iconSize.reference
        },
        indicator: {
            flexShrink: 0,
            borderRadius: "full",
            width: $b8eda56a5e8ca863$var$$size.reference,
            height: $b8eda56a5e8ca863$var$$size.reference,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&[data-status=active]": {
                borderWidth: "2px",
                borderColor: $b8eda56a5e8ca863$var$$accentColor.reference
            },
            "&[data-status=complete]": {
                bg: $b8eda56a5e8ca863$var$$accentColor.reference,
                color: "chakra-inverse-text"
            },
            "&[data-status=incomplete]": {
                borderWidth: "2px"
            }
        },
        separator: {
            bg: "chakra-border-color",
            flex: "1",
            "&[data-status=complete]": {
                bg: $b8eda56a5e8ca863$var$$accentColor.reference
            },
            "&[data-orientation=horizontal]": {
                width: "100%",
                height: "2px",
                marginStart: "2"
            },
            "&[data-orientation=vertical]": {
                width: "2px",
                position: "absolute",
                height: "100%",
                maxHeight: `calc(100% - ${$b8eda56a5e8ca863$var$$size.reference} - 8px)`,
                top: `calc(${$b8eda56a5e8ca863$var$$size.reference} + 4px)`,
                insetStart: `calc(${$b8eda56a5e8ca863$var$$size.reference} / 2 - 1px)`
            }
        }
    }));
var $b8eda56a5e8ca863$export$54c84d54375c8d75 = $b8eda56a5e8ca863$var$defineMultiStyleConfig({
    baseStyle: $b8eda56a5e8ca863$var$baseStyle,
    sizes: {
        xs: $b8eda56a5e8ca863$var$definePartsStyle({
            stepper: {
                [$b8eda56a5e8ca863$var$$size.variable]: "sizes.4",
                [$b8eda56a5e8ca863$var$$iconSize.variable]: "sizes.3",
                [$b8eda56a5e8ca863$var$$titleFontSize.variable]: "fontSizes.xs",
                [$b8eda56a5e8ca863$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        sm: $b8eda56a5e8ca863$var$definePartsStyle({
            stepper: {
                [$b8eda56a5e8ca863$var$$size.variable]: "sizes.6",
                [$b8eda56a5e8ca863$var$$iconSize.variable]: "sizes.4",
                [$b8eda56a5e8ca863$var$$titleFontSize.variable]: "fontSizes.sm",
                [$b8eda56a5e8ca863$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        md: $b8eda56a5e8ca863$var$definePartsStyle({
            stepper: {
                [$b8eda56a5e8ca863$var$$size.variable]: "sizes.8",
                [$b8eda56a5e8ca863$var$$iconSize.variable]: "sizes.5",
                [$b8eda56a5e8ca863$var$$titleFontSize.variable]: "fontSizes.md",
                [$b8eda56a5e8ca863$var$$descFontSize.variable]: "fontSizes.sm"
            }
        }),
        lg: $b8eda56a5e8ca863$var$definePartsStyle({
            stepper: {
                [$b8eda56a5e8ca863$var$$size.variable]: "sizes.10",
                [$b8eda56a5e8ca863$var$$iconSize.variable]: "sizes.6",
                [$b8eda56a5e8ca863$var$$titleFontSize.variable]: "fontSizes.lg",
                [$b8eda56a5e8ca863$var$$descFontSize.variable]: "fontSizes.md"
            }
        })
    },
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/components/switch.ts
// src/anatomy.ts
function $113cb1d974d2c079$export$477202748c7242bf(name, map = {}) {
    let called = false;
    function assert() {
        if (!called) {
            called = true;
            return;
        }
        throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }
    function parts(...values) {
        assert();
        for (const part of values)map[part] = toPart(part);
        return $113cb1d974d2c079$export$477202748c7242bf(name, map);
    }
    function extend(...parts2) {
        for (const part of parts2){
            if (part in map) continue;
            map[part] = toPart(part);
        }
        return $113cb1d974d2c079$export$477202748c7242bf(name, map);
    }
    function selectors() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.selector
            ]));
        return value;
    }
    function classnames() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.className
            ]));
        return value;
    }
    function toPart(part) {
        const el = [
            "container",
            "root"
        ].includes(part != null ? part : "") ? [
            name
        ] : [
            name,
            part
        ];
        const attr = el.filter(Boolean).join("__");
        const className = `chakra-${attr}`;
        const partObj = {
            className: className,
            selector: `.${className}`,
            toString: ()=>part
        };
        return partObj;
    }
    const __type = {};
    return {
        parts: parts,
        toPart: toPart,
        extend: extend,
        selectors: selectors,
        classnames: classnames,
        get keys () {
            return Object.keys(map);
        },
        __type: __type
    };
}


// src/components.ts
var $598f0d250d88319f$export$377a77e99e7c73a5 = (0, $113cb1d974d2c079$export$477202748c7242bf)("accordion").parts("root", "container", "button", "panel").extend("icon");
var $598f0d250d88319f$export$fc51889fa4de265a = (0, $113cb1d974d2c079$export$477202748c7242bf)("alert").parts("title", "description", "container").extend("icon", "spinner");
var $598f0d250d88319f$export$60f8655d889e17c7 = (0, $113cb1d974d2c079$export$477202748c7242bf)("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var $598f0d250d88319f$export$2fb03f744a6ecf93 = (0, $113cb1d974d2c079$export$477202748c7242bf)("breadcrumb").parts("link", "item", "container").extend("separator");
var $598f0d250d88319f$export$1699c5cb20c07888 = (0, $113cb1d974d2c079$export$477202748c7242bf)("button").parts();
var $598f0d250d88319f$export$21946b04497ed6ac = (0, $113cb1d974d2c079$export$477202748c7242bf)("checkbox").parts("control", "icon", "container").extend("label");
var $598f0d250d88319f$export$2c953111278f3272 = (0, $113cb1d974d2c079$export$477202748c7242bf)("progress").parts("track", "filledTrack").extend("label");
var $598f0d250d88319f$export$d3f4aaa4b0f2907a = (0, $113cb1d974d2c079$export$477202748c7242bf)("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $598f0d250d88319f$export$2813c9511eeab082 = (0, $113cb1d974d2c079$export$477202748c7242bf)("editable").parts("preview", "input", "textarea");
var $598f0d250d88319f$export$4b243e3f209a7e5e = (0, $113cb1d974d2c079$export$477202748c7242bf)("form").parts("container", "requiredIndicator", "helperText");
var $598f0d250d88319f$export$bb18c440c00e82d9 = (0, $113cb1d974d2c079$export$477202748c7242bf)("formError").parts("text", "icon");
var $598f0d250d88319f$export$1ffeb100b532f46d = (0, $113cb1d974d2c079$export$477202748c7242bf)("input").parts("addon", "field", "element", "group");
var $598f0d250d88319f$export$12b3a655a94374ed = (0, $113cb1d974d2c079$export$477202748c7242bf)("list").parts("container", "item", "icon");
var $598f0d250d88319f$export$e251092a5dcb1329 = (0, $113cb1d974d2c079$export$477202748c7242bf)("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");
var $598f0d250d88319f$export$34e33beb8d992ac2 = (0, $113cb1d974d2c079$export$477202748c7242bf)("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $598f0d250d88319f$export$859cc7ca3200df97 = (0, $113cb1d974d2c079$export$477202748c7242bf)("numberinput").parts("root", "field", "stepperGroup", "stepper");
var $598f0d250d88319f$export$12bb869d7991ac50 = (0, $113cb1d974d2c079$export$477202748c7242bf)("pininput").parts("field");
var $598f0d250d88319f$export$afda07d12cd4337d = (0, $113cb1d974d2c079$export$477202748c7242bf)("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
var $598f0d250d88319f$export$ba6328c242bd649c = (0, $113cb1d974d2c079$export$477202748c7242bf)("progress").parts("label", "filledTrack", "track");
var $598f0d250d88319f$export$d28d06d0e29ef022 = (0, $113cb1d974d2c079$export$477202748c7242bf)("radio").parts("container", "control", "label");
var $598f0d250d88319f$export$17993f0be9538b5a = (0, $113cb1d974d2c079$export$477202748c7242bf)("select").parts("field", "icon");
var $598f0d250d88319f$export$c21b4b3f8b239f32 = (0, $113cb1d974d2c079$export$477202748c7242bf)("slider").parts("container", "track", "thumb", "filledTrack", "mark");
var $598f0d250d88319f$export$2cfbad67ae6ee421 = (0, $113cb1d974d2c079$export$477202748c7242bf)("stat").parts("container", "label", "helpText", "number", "icon");
var $598f0d250d88319f$export$921c1a2d1ce1e86a = (0, $113cb1d974d2c079$export$477202748c7242bf)("switch").parts("container", "track", "thumb", "label");
var $598f0d250d88319f$export$8b1b9cdd5db9f5fd = (0, $113cb1d974d2c079$export$477202748c7242bf)("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
var $598f0d250d88319f$export$97383552563be58d = (0, $113cb1d974d2c079$export$477202748c7242bf)("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
var $598f0d250d88319f$export$4c2f5f7f2ea94a8e = (0, $113cb1d974d2c079$export$477202748c7242bf)("tag").parts("container", "label", "closeButton");
var $598f0d250d88319f$export$487a447ffa5755b6 = (0, $113cb1d974d2c079$export$477202748c7242bf)("card").parts("container", "header", "body", "footer");
var $598f0d250d88319f$export$76976ae72ac68c27 = (0, $113cb1d974d2c079$export$477202748c7242bf)("stepper").parts("stepper", "step", "title", "description", "indicator", "separator", "icon", "number");



// src/css-calc.ts

function $2ef820b9f4ef8e93$var$toRef(operand) {
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $2ef820b9f4ef8e93$var$toExpr = (operator, ...operands)=>operands.map($2ef820b9f4ef8e93$var$toRef).join(` ${operator} `).replace(/calc/g, "");
var $2ef820b9f4ef8e93$var$add = (...operands)=>`calc(${$2ef820b9f4ef8e93$var$toExpr("+", ...operands)})`;
var $2ef820b9f4ef8e93$var$subtract = (...operands)=>`calc(${$2ef820b9f4ef8e93$var$toExpr("-", ...operands)})`;
var $2ef820b9f4ef8e93$var$multiply = (...operands)=>`calc(${$2ef820b9f4ef8e93$var$toExpr("*", ...operands)})`;
var $2ef820b9f4ef8e93$var$divide = (...operands)=>`calc(${$2ef820b9f4ef8e93$var$toExpr("/", ...operands)})`;
var $2ef820b9f4ef8e93$var$negate = (x)=>{
    const value = $2ef820b9f4ef8e93$var$toRef(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $2ef820b9f4ef8e93$var$multiply(value, -1);
};
var $2ef820b9f4ef8e93$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$2ef820b9f4ef8e93$export$42bfa9b2d4dad91a($2ef820b9f4ef8e93$var$add(x, ...operands)),
        subtract: (...operands)=>$2ef820b9f4ef8e93$export$42bfa9b2d4dad91a($2ef820b9f4ef8e93$var$subtract(x, ...operands)),
        multiply: (...operands)=>$2ef820b9f4ef8e93$export$42bfa9b2d4dad91a($2ef820b9f4ef8e93$var$multiply(x, ...operands)),
        divide: (...operands)=>$2ef820b9f4ef8e93$export$42bfa9b2d4dad91a($2ef820b9f4ef8e93$var$divide(x, ...operands)),
        negate: ()=>$2ef820b9f4ef8e93$export$42bfa9b2d4dad91a($2ef820b9f4ef8e93$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $2ef820b9f4ef8e93$var$add,
    subtract: $2ef820b9f4ef8e93$var$subtract,
    multiply: $2ef820b9f4ef8e93$var$multiply,
    divide: $2ef820b9f4ef8e93$var$divide,
    negate: $2ef820b9f4ef8e93$var$negate
});

// src/css-var.ts
function $591785a32740c673$export$2ad0182371401ea4(value) {
    return !Number.isInteger(parseFloat(value.toString()));
}
function $591785a32740c673$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $591785a32740c673$var$escape(value) {
    const valueStr = $591785a32740c673$var$replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\.")) return value;
    return $591785a32740c673$export$2ad0182371401ea4(value) ? valueStr.replace(".", `\\.`) : value;
}
function $591785a32740c673$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        $591785a32740c673$var$escape(value)
    ].filter(Boolean).join("-");
}
function $591785a32740c673$export$44410db3a43190e8(name, fallback) {
    return `var(${$591785a32740c673$var$escape(name)}${fallback ? `, ${fallback}` : ""})`;
}
function $591785a32740c673$export$e2ffa342f278b3a3(value, prefix = "") {
    return `--${$591785a32740c673$export$9748efee331ec573(value, prefix)}`;
}
function $591785a32740c673$export$8b4981022bd80a4e(name, options) {
    const cssVariable = $591785a32740c673$export$e2ffa342f278b3a3(name, options == null ? void 0 : options.prefix);
    return {
        variable: cssVariable,
        reference: $591785a32740c673$export$44410db3a43190e8(cssVariable, $591785a32740c673$var$getFallback(options == null ? void 0 : options.fallback))
    };
}
function $591785a32740c673$var$getFallback(fallback) {
    if (typeof fallback === "string") return fallback;
    return fallback == null ? void 0 : fallback.reference;
}


var { defineMultiStyleConfig: $994d42e36253a2ed$var$defineMultiStyleConfig, definePartsStyle: $994d42e36253a2ed$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$921c1a2d1ce1e86a).keys);
var $994d42e36253a2ed$var$$width = (0, $591785a32740c673$export$8b4981022bd80a4e)("switch-track-width");
var $994d42e36253a2ed$var$$height = (0, $591785a32740c673$export$8b4981022bd80a4e)("switch-track-height");
var $994d42e36253a2ed$var$$diff = (0, $591785a32740c673$export$8b4981022bd80a4e)("switch-track-diff");
var $994d42e36253a2ed$var$diffValue = (0, $2ef820b9f4ef8e93$export$42bfa9b2d4dad91a).subtract($994d42e36253a2ed$var$$width, $994d42e36253a2ed$var$$height);
var $994d42e36253a2ed$var$$translateX = (0, $591785a32740c673$export$8b4981022bd80a4e)("switch-thumb-x");
var $994d42e36253a2ed$var$$bg = (0, $591785a32740c673$export$8b4981022bd80a4e)("switch-bg");
var $994d42e36253a2ed$var$baseStyleTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        borderRadius: "full",
        p: "0.5",
        width: [
            $994d42e36253a2ed$var$$width.reference
        ],
        height: [
            $994d42e36253a2ed$var$$height.reference
        ],
        transitionProperty: "common",
        transitionDuration: "fast",
        [$994d42e36253a2ed$var$$bg.variable]: "colors.gray.300",
        _dark: {
            [$994d42e36253a2ed$var$$bg.variable]: "colors.whiteAlpha.400"
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        },
        _checked: {
            [$994d42e36253a2ed$var$$bg.variable]: `colors.${c}.500`,
            _dark: {
                [$994d42e36253a2ed$var$$bg.variable]: `colors.${c}.200`
            }
        },
        bg: $994d42e36253a2ed$var$$bg.reference
    };
});
var $994d42e36253a2ed$var$baseStyleThumb = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "white",
    transitionProperty: "transform",
    transitionDuration: "normal",
    borderRadius: "inherit",
    width: [
        $994d42e36253a2ed$var$$height.reference
    ],
    height: [
        $994d42e36253a2ed$var$$height.reference
    ],
    _checked: {
        transform: `translateX(${$994d42e36253a2ed$var$$translateX.reference})`
    }
});
var $994d42e36253a2ed$var$baseStyle = $994d42e36253a2ed$var$definePartsStyle((props)=>({
        container: {
            [$994d42e36253a2ed$var$$diff.variable]: $994d42e36253a2ed$var$diffValue,
            [$994d42e36253a2ed$var$$translateX.variable]: $994d42e36253a2ed$var$$diff.reference,
            _rtl: {
                [$994d42e36253a2ed$var$$translateX.variable]: (0, $2ef820b9f4ef8e93$export$42bfa9b2d4dad91a)($994d42e36253a2ed$var$$diff).negate().toString()
            }
        },
        track: $994d42e36253a2ed$var$baseStyleTrack(props),
        thumb: $994d42e36253a2ed$var$baseStyleThumb
    }));
var $994d42e36253a2ed$var$sizes = {
    sm: $994d42e36253a2ed$var$definePartsStyle({
        container: {
            [$994d42e36253a2ed$var$$width.variable]: "1.375rem",
            [$994d42e36253a2ed$var$$height.variable]: "sizes.3"
        }
    }),
    md: $994d42e36253a2ed$var$definePartsStyle({
        container: {
            [$994d42e36253a2ed$var$$width.variable]: "1.875rem",
            [$994d42e36253a2ed$var$$height.variable]: "sizes.4"
        }
    }),
    lg: $994d42e36253a2ed$var$definePartsStyle({
        container: {
            [$994d42e36253a2ed$var$$width.variable]: "2.875rem",
            [$994d42e36253a2ed$var$$height.variable]: "sizes.6"
        }
    })
};
var $994d42e36253a2ed$export$6856b73e98185bff = $994d42e36253a2ed$var$defineMultiStyleConfig({
    baseStyle: $994d42e36253a2ed$var$baseStyle,
    sizes: $994d42e36253a2ed$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/components/table.ts


// src/component.ts
function $6eb225f883147347$export$549ff81930776885(light, dark) {
    return (props)=>props.colorMode === "dark" ? dark : light;
}
function $6eb225f883147347$export$f3eec17ee6065eee(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    if (!orientation) return {};
    return orientation === "vertical" ? vertical : horizontal;
}


var { defineMultiStyleConfig: $2a4c99e2adafaa9d$var$defineMultiStyleConfig, definePartsStyle: $2a4c99e2adafaa9d$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$8b1b9cdd5db9f5fd).keys);
var $2a4c99e2adafaa9d$var$baseStyle = $2a4c99e2adafaa9d$var$definePartsStyle({
    table: {
        fontVariantNumeric: "lining-nums tabular-nums",
        borderCollapse: "collapse",
        width: "full"
    },
    th: {
        fontFamily: "heading",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "wider",
        textAlign: "start"
    },
    td: {
        textAlign: "start"
    },
    caption: {
        mt: 4,
        fontFamily: "heading",
        textAlign: "center",
        fontWeight: "medium"
    }
});
var $2a4c99e2adafaa9d$var$numericStyles = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    "&[data-is-numeric=true]": {
        textAlign: "end"
    }
});
var $2a4c99e2adafaa9d$var$variantSimple = $2a4c99e2adafaa9d$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $6eb225f883147347$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$2a4c99e2adafaa9d$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$2a4c99e2adafaa9d$var$numericStyles
        },
        caption: {
            color: (0, $6eb225f883147347$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
var $2a4c99e2adafaa9d$var$variantStripe = $2a4c99e2adafaa9d$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $6eb225f883147347$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$2a4c99e2adafaa9d$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$2a4c99e2adafaa9d$var$numericStyles
        },
        caption: {
            color: (0, $6eb225f883147347$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tbody: {
            tr: {
                "&:nth-of-type(odd)": {
                    "th, td": {
                        borderBottomWidth: "1px",
                        borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    },
                    td: {
                        background: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    }
                }
            }
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
var $2a4c99e2adafaa9d$var$variants = {
    simple: $2a4c99e2adafaa9d$var$variantSimple,
    striped: $2a4c99e2adafaa9d$var$variantStripe,
    unstyled: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({})
};
var $2a4c99e2adafaa9d$var$sizes = {
    sm: $2a4c99e2adafaa9d$var$definePartsStyle({
        th: {
            px: "4",
            py: "1",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "4",
            py: "2",
            fontSize: "sm",
            lineHeight: "4"
        },
        caption: {
            px: "4",
            py: "2",
            fontSize: "xs"
        }
    }),
    md: $2a4c99e2adafaa9d$var$definePartsStyle({
        th: {
            px: "6",
            py: "3",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "6",
            py: "4",
            lineHeight: "5"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "sm"
        }
    }),
    lg: $2a4c99e2adafaa9d$var$definePartsStyle({
        th: {
            px: "8",
            py: "4",
            lineHeight: "5",
            fontSize: "sm"
        },
        td: {
            px: "8",
            py: "5",
            lineHeight: "6"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "md"
        }
    })
};
var $2a4c99e2adafaa9d$export$3339219781bb5161 = $2a4c99e2adafaa9d$var$defineMultiStyleConfig({
    baseStyle: $2a4c99e2adafaa9d$var$baseStyle,
    variants: $2a4c99e2adafaa9d$var$variants,
    sizes: $2a4c99e2adafaa9d$var$sizes,
    defaultProps: {
        variant: "simple",
        size: "md",
        colorScheme: "gray"
    }
});


// src/components/tabs.ts


// src/color.ts

/**
 * A simple guard function:
 *
 * ```js
 * Math.min(Math.max(low, value), high)
 * ```
 */ function $82bd23a4eacb9716$export$864d727b48066337(low, high, value) {
    return Math.min(Math.max(low, value), high);
}
class $82bd23a4eacb9716$var$ColorError extends Error {
    constructor(color){
        super(`Failed to parse color: "${color}"`);
    }
}
var $82bd23a4eacb9716$export$21f8cadbc4af9bbf = $82bd23a4eacb9716$var$ColorError;
/**
 * Parses a color into red, gree, blue, alpha parts
 *
 * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
 */ function $82bd23a4eacb9716$export$88c26fe48243d749(color) {
    if (typeof color !== "string") throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
    if (color.trim().toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    let normalizedColor = color.trim();
    normalizedColor = $82bd23a4eacb9716$var$namedColorRegex.test(color) ? $82bd23a4eacb9716$var$nameToHex(color) : color;
    const reducedHexMatch = $82bd23a4eacb9716$var$reducedHexRegex.exec(normalizedColor);
    if (reducedHexMatch) {
        const arr = Array.from(reducedHexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt($82bd23a4eacb9716$var$r(x, 2), 16)),
            parseInt($82bd23a4eacb9716$var$r(arr[3] || "f", 2), 16) / 255
        ];
    }
    const hexMatch = $82bd23a4eacb9716$var$hexRegex.exec(normalizedColor);
    if (hexMatch) {
        const arr = Array.from(hexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 16)),
            parseInt(arr[3] || "ff", 16) / 255
        ];
    }
    const rgbaMatch = $82bd23a4eacb9716$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatch) {
        const arr = Array.from(rgbaMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 10)),
            parseFloat(arr[3] || "1")
        ];
    }
    const hslaMatch = $82bd23a4eacb9716$var$hslaRegex.exec(normalizedColor);
    if (hslaMatch) {
        const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
        if ($82bd23a4eacb9716$export$864d727b48066337(0, 100, s) !== s) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
        if ($82bd23a4eacb9716$export$864d727b48066337(0, 100, l) !== l) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
        return [
            ...$82bd23a4eacb9716$var$hslToRgb(h, s, l),
            Number.isNaN(a) ? 1 : a
        ];
    }
    throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
}
function $82bd23a4eacb9716$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return (hash >>> 0) % 2341;
}
const $82bd23a4eacb9716$var$colorToInt = (x)=>parseInt(x.replace(/_/g, ""), 36);
const $82bd23a4eacb9716$var$compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((acc, next)=>{
    const key = $82bd23a4eacb9716$var$colorToInt(next.substring(0, 3));
    const hex = $82bd23a4eacb9716$var$colorToInt(next.substring(3)).toString(16);
    // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351
    let prefix = "";
    for(let i = 0; i < 6 - hex.length; i++)prefix += "0";
    acc[key] = `${prefix}${hex}`;
    return acc;
}, {});
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 */ function $82bd23a4eacb9716$var$nameToHex(color) {
    const normalizedColorName = color.toLowerCase().trim();
    const result = $82bd23a4eacb9716$var$compressedColorMap[$82bd23a4eacb9716$var$hash(normalizedColorName)];
    if (!result) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
    return `#${result}`;
}
const $82bd23a4eacb9716$var$r = (str, amount)=>Array.from(Array(amount)).map(()=>str).join("");
const $82bd23a4eacb9716$var$reducedHexRegex = new RegExp(`^#${$82bd23a4eacb9716$var$r("([a-f0-9])", 3)}([a-f0-9])?$`, "i");
const $82bd23a4eacb9716$var$hexRegex = new RegExp(`^#${$82bd23a4eacb9716$var$r("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i");
const $82bd23a4eacb9716$var$rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${$82bd23a4eacb9716$var$r(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i");
const $82bd23a4eacb9716$var$hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
const $82bd23a4eacb9716$var$namedColorRegex = /^[a-z]+$/i;
const $82bd23a4eacb9716$var$roundColor = (color)=>{
    return Math.round(color * 255);
};
const $82bd23a4eacb9716$var$hslToRgb = (hue, saturation, lightness)=>{
    let l = lightness / 100;
    if (saturation === 0) // achromatic
    return [
        l,
        l,
        l
    ].map($82bd23a4eacb9716$var$roundColor);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    const huePrime = (hue % 360 + 360) % 360 / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    let red = 0;
    let green = 0;
    let blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    const finalRed = red + lightnessModification;
    const finalGreen = green + lightnessModification;
    const finalBlue = blue + lightnessModification;
    return [
        finalRed,
        finalGreen,
        finalBlue
    ].map($82bd23a4eacb9716$var$roundColor);
};
// taken from:
// https://github.com/styled-components/polished/blob/a23a6a2bb26802b3d922d9c3b67bac3f3a54a310/src/internalHelpers/_rgbToHsl.js
/**
 * Parses a color in hue, saturation, lightness, and the alpha channel.
 *
 * Hue is a number between 0 and 360, saturation, lightness, and alpha are
 * decimal percentages between 0 and 1
 */ function $82bd23a4eacb9716$export$c7d9b10ca8edee87(color) {
    const [red, green, blue, alpha] = $82bd23a4eacb9716$export$88c26fe48243d749(color).map((value, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? value : value / 255);
    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const lightness = (max + min) / 2;
    // achromatic
    if (max === min) return [
        0,
        0,
        lightness,
        alpha
    ];
    const delta = max - min;
    const saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    const hue = 60 * (red === max ? (green - blue) / delta + (green < blue ? 6 : 0) : green === max ? (blue - red) / delta + 2 : (red - green) / delta + 4);
    return [
        hue,
        saturation,
        lightness,
        alpha
    ];
}
/**
 * Takes in hsla parts and constructs an hsla string
 *
 * @param hue The color circle (from 0 to 360) - 0 (or 360) is red, 120 is green, 240 is blue
 * @param saturation Percentage of saturation, given as a decimal between 0 and 1
 * @param lightness Percentage of lightness, given as a decimal between 0 and 1
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$810b04175080204c(hue, saturation, lightness, alpha) {
    return `hsla(${(hue % 360).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 100, saturation * 100).toFixed()}%, ${$82bd23a4eacb9716$export$864d727b48066337(0, 100, lightness * 100).toFixed()}%, ${parseFloat($82bd23a4eacb9716$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Adjusts the current hue of the color by the given degrees. Wraps around when
 * over 360.
 *
 * @param color input color
 * @param degrees degrees to adjust the input color, accepts degree integers
 * (0 - 360) and wraps around on overflow
 */ function $82bd23a4eacb9716$export$2b372a09365374d6(color, degrees) {
    const [h, s, l, a] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(h + degrees, s, l, a);
}
/**
 * Darkens using lightness. This is equivalent to subtracting the lightness
 * from the L in HSL.
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$4b073707ff63303(color, amount) {
    const [hue, saturation, lightness, alpha] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(hue, saturation, lightness - amount, alpha);
}
/**
 * Desaturates the input color by the given amount via subtracting from the `s`
 * in `hsla`.
 *
 * @param amount The amount to desaturate, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$fb75607d98509d9(color, amount) {
    const [h, s, l, a] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(h, s - amount, l, a);
}
// taken from:
// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getLuminance.js
/**
 * Returns a number (float) representing the luminance of a color.
 */ function $82bd23a4eacb9716$export$c852d90bf7403b62(color) {
    if (color === "transparent") return 0;
    function f(x) {
        const channel = x / 255;
        return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    const [r, g, b] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}
// taken from:
// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getContrast.js
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 */ function $82bd23a4eacb9716$export$850ce485a60d103b(color1, color2) {
    const luminance1 = $82bd23a4eacb9716$export$c852d90bf7403b62(color1);
    const luminance2 = $82bd23a4eacb9716$export$c852d90bf7403b62(color2);
    return luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05);
}
/**
 * Takes in rgba parts and returns an rgba string
 *
 * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
 * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
 * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$4e46ac54fc82cf3b(red, green, blue, alpha) {
    return `rgba(${$82bd23a4eacb9716$export$864d727b48066337(0, 255, red).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 255, green).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 255, blue).toFixed()}, ${parseFloat($82bd23a4eacb9716$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Mixes two colors together. Taken from sass's implementation.
 */ function $82bd23a4eacb9716$export$2c9e8a9632a706b2(color1, color2, weight) {
    const normalize = (n, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? n : n / 255;
    const [r1, g1, b1, a1] = $82bd23a4eacb9716$export$88c26fe48243d749(color1).map(normalize);
    const [r2, g2, b2, a2] = $82bd23a4eacb9716$export$88c26fe48243d749(color2).map(normalize);
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    const alphaDelta = a2 - a1;
    const normalizedWeight = weight * 2 - 1;
    const combinedWeight = normalizedWeight * alphaDelta === -1 ? normalizedWeight : normalizedWeight + alphaDelta / (1 + normalizedWeight * alphaDelta);
    const weight2 = (combinedWeight + 1) / 2;
    const weight1 = 1 - weight2;
    const r = (r1 * weight1 + r2 * weight2) * 255;
    const g = (g1 * weight1 + g2 * weight2) * 255;
    const b = (b1 * weight1 + b2 * weight2) * 255;
    const a = a2 * weight + a1 * (1 - weight);
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(r, g, b, a);
}
/**
 * Given a series colors, this function will return a `scale(x)` function that
 * accepts a percentage as a decimal between 0 and 1 and returns the color at
 * that percentage in the scale.
 *
 * ```js
 * const scale = getScale('red', 'yellow', 'green');
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(0.5)); // rgba(255, 255, 0, 1)
 * console.log(scale(1)); // rgba(0, 128, 0, 1)
 * ```
 *
 * If you'd like to limit the domain and range like chroma-js, we recommend
 * wrapping scale again.
 *
 * ```js
 * const _scale = getScale('red', 'yellow', 'green');
 * const scale = x => _scale(x / 100);
 *
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(50)); // rgba(255, 255, 0, 1)
 * console.log(scale(100)); // rgba(0, 128, 0, 1)
 * ```
 */ function $82bd23a4eacb9716$export$5cdac61cf538712e(...colors) {
    return (n)=>{
        const lastIndex = colors.length - 1;
        const lowIndex = $82bd23a4eacb9716$export$864d727b48066337(0, lastIndex, Math.floor(n * lastIndex));
        const highIndex = $82bd23a4eacb9716$export$864d727b48066337(0, lastIndex, Math.ceil(n * lastIndex));
        const color1 = colors[lowIndex];
        const color2 = colors[highIndex];
        const unit = 1 / lastIndex;
        const weight = (n - unit * lowIndex) / unit;
        return $82bd23a4eacb9716$export$2c9e8a9632a706b2(color1, color2, weight);
    };
}
const $82bd23a4eacb9716$var$guidelines = {
    decorative: 1.5,
    readable: 3,
    aa: 4.5,
    aaa: 7
};
/**
 * Returns whether or not a color has bad contrast against a background
 * according to a given standard.
 */ function $82bd23a4eacb9716$export$f4ab80233a44f806(color, standard = "aa", background = "#fff") {
    return $82bd23a4eacb9716$export$850ce485a60d103b(color, background) < $82bd23a4eacb9716$var$guidelines[standard];
}
/**
 * Lightens a color by a given amount. This is equivalent to
 * `darken(color, -amount)`
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$c0816ed86df316af(color, amount) {
    return $82bd23a4eacb9716$export$4b073707ff63303(color, -amount);
}
/**
 * Takes in a color and makes it more transparent by convert to `rgba` and
 * decreasing the amount in the alpha channel.
 *
 * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$d11da87e55cc498f(color, amount) {
    const [r, g, b, a] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(r, g, b, a - amount);
}
/**
 * Takes a color and un-transparentizes it. Equivalent to
 * `transparentize(color, -amount)`
 *
 * @param amount The amount to increase the opacity by, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$f4f50e3877dd0530(color, amount) {
    return $82bd23a4eacb9716$export$d11da87e55cc498f(color, -amount);
}
/**
 * An alternative function to `readableColor`. Returns whether or not the 
 * readable color (i.e. the color to be place on top the input color) should be
 * black.
 */ function $82bd23a4eacb9716$export$dcb2d24cf045d06(color) {
    return $82bd23a4eacb9716$export$c852d90bf7403b62(color) > 0.179;
}
/**
 * Returns black or white for best contrast depending on the luminosity of the
 * given color.
 */ function $82bd23a4eacb9716$export$61654c1796c44811(color) {
    return $82bd23a4eacb9716$export$dcb2d24cf045d06(color) ? "#000" : "#fff";
}
/**
 * Saturates a color by converting it to `hsl` and increasing the saturation
 * amount. Equivalent to `desaturate(color, -amount)`
 * 
 * @param color Input color
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$5fcac96f5a87e3db(color, amount) {
    return $82bd23a4eacb9716$export$fb75607d98509d9(color, -amount);
}
/**
 * Takes in any color and returns it as a hex code.
 */ function $82bd23a4eacb9716$export$7ea66e3774a60b67(color) {
    const [r, g, b, a] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    let hex = (x)=>{
        const h = $82bd23a4eacb9716$export$864d727b48066337(0, 255, x).toString(16);
        // NOTE: padStart could be used here but it breaks Node 6 compat
        // https://github.com/ricokahler/color2k/issues/351
        return h.length === 1 ? `0${h}` : h;
    };
    return `#${hex(r)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ""}`;
}
/**
 * Takes in any color and returns it as an rgba string.
 */ function $82bd23a4eacb9716$export$5db297beaffffbfc(color) {
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(...$82bd23a4eacb9716$export$88c26fe48243d749(color));
}
/**
 * Takes in any color and returns it as an hsla string.
 */ function $82bd23a4eacb9716$export$b9678a7d4ac803cc(color) {
    return $82bd23a4eacb9716$export$810b04175080204c(...$82bd23a4eacb9716$export$c7d9b10ca8edee87(color));
}


// ../../../node_modules/.pnpm/dlv@1.1.3/node_modules/dlv/dist/dlv.es.js
function $a031d15006571f58$var$dlv_es_default(t, e, l, n, r) {
    for(e = e.split ? e.split(".") : e, n = 0; n < e.length; n++)t = t ? t[e[n]] : r;
    return t === r ? l : t;
}
// src/color.ts
var $a031d15006571f58$var$isEmptyObject = (obj)=>Object.keys(obj).length === 0;
var $a031d15006571f58$export$5551a2d24ff40153 = (theme, color, fallback)=>{
    const hex = $a031d15006571f58$var$dlv_es_default(theme, `colors.${color}`, color);
    try {
        (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)(hex);
        return hex;
    } catch  {
        return fallback != null ? fallback : "#000000";
    }
};
var $a031d15006571f58$export$fdaf813cf8a11246 = (theme, color, fallback)=>{
    var _a;
    return (_a = (0, $47a6d9fbbf7ee42d$export$93c8e06b7014dc33)(theme, "colors", color)) != null ? _a : fallback;
};
var $a031d15006571f58$var$getBrightness = (color)=>{
    const [r, g, b] = (0, $82bd23a4eacb9716$export$88c26fe48243d749)(color);
    return (r * 299 + g * 587 + b * 114) / 1e3;
};
var $a031d15006571f58$export$7297c25227171a1f = (color)=>(theme)=>{
        const hex = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        const brightness = $a031d15006571f58$var$getBrightness(hex);
        const isDark2 = brightness < 128;
        return isDark2 ? "dark" : "light";
    };
var $a031d15006571f58$export$a79ad82046afa44e = (color)=>(theme)=>$a031d15006571f58$export$7297c25227171a1f(color)(theme) === "dark";
var $a031d15006571f58$export$44af652f4cca9039 = (color)=>(theme)=>$a031d15006571f58$export$7297c25227171a1f(color)(theme) === "light";
var $a031d15006571f58$export$d11da87e55cc498f = (color, opacity)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$d11da87e55cc498f)(raw, 1 - opacity);
    };
var $a031d15006571f58$export$81525e9955aa80e8 = (color, amount)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$2c9e8a9632a706b2)(raw, "#fff", amount));
    };
var $a031d15006571f58$export$2b471577c483101c = (color, amount)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$2c9e8a9632a706b2)(raw, "#000", amount / 100));
    };
var $a031d15006571f58$export$4b073707ff63303 = (color, amount)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$4b073707ff63303)(raw, amount / 100));
    };
var $a031d15006571f58$export$c0816ed86df316af = (color, amount)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$c0816ed86df316af)(raw, amount / 100));
    };
var $a031d15006571f58$export$1ec78ac20028ebd4 = (fg, bg)=>(theme)=>(0, $82bd23a4eacb9716$export$850ce485a60d103b)($a031d15006571f58$export$5551a2d24ff40153(theme, bg), $a031d15006571f58$export$5551a2d24ff40153(theme, fg));
var $a031d15006571f58$export$cd41ae544cfc2a65 = (textColor, bgColor, options)=>(theme)=>$a031d15006571f58$export$3fe5b5ca1e6a6a28($a031d15006571f58$export$5551a2d24ff40153(theme, bgColor), $a031d15006571f58$export$5551a2d24ff40153(theme, textColor), options);
function $a031d15006571f58$export$3fe5b5ca1e6a6a28(color1, color2, wcag2 = {
    level: "AA",
    size: "small"
}) {
    var _a, _b;
    const readabilityLevel = $a031d15006571f58$export$b7b705aaad1c5b6a(color1, color2);
    switch(((_a = wcag2.level) != null ? _a : "AA") + ((_b = wcag2.size) != null ? _b : "small")){
        case "AAsmall":
        case "AAAlarge":
            return readabilityLevel >= 4.5;
        case "AAlarge":
            return readabilityLevel >= 3;
        case "AAAsmall":
            return readabilityLevel >= 7;
        default:
            return false;
    }
}
function $a031d15006571f58$export$b7b705aaad1c5b6a(color1, color2) {
    return (Math.max((0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color1), (0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color2)) + 0.05) / (Math.min((0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color1), (0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color2)) + 0.05);
}
var $a031d15006571f58$export$504efcfbebdbcaf = (color)=>(theme)=>{
        const raw = $a031d15006571f58$export$5551a2d24ff40153(theme, color);
        const hsl = (0, $82bd23a4eacb9716$export$c7d9b10ca8edee87)(raw);
        const complementHsl = Object.assign(hsl, [
            (hsl[0] + 180) % 360
        ]);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$810b04175080204c)(...complementHsl));
    };
function $a031d15006571f58$export$db0ffb03ee9f3080(size = "1rem", color = "rgba(255, 255, 255, 0.15)") {
    return {
        backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
        backgroundSize: `${size} ${size}`
    };
}
var $a031d15006571f58$var$randomHex = ()=>`#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function $a031d15006571f58$export$f3c6ed4330abfc18(opts) {
    const fallback = $a031d15006571f58$var$randomHex();
    if (!opts || $a031d15006571f58$var$isEmptyObject(opts)) return fallback;
    if (opts.string && opts.colors) return $a031d15006571f58$var$randomColorFromList(opts.string, opts.colors);
    if (opts.string && !opts.colors) return $a031d15006571f58$var$randomColorFromString(opts.string);
    if (opts.colors && !opts.string) return $a031d15006571f58$var$randomFromList(opts.colors);
    return fallback;
}
function $a031d15006571f58$var$randomColorFromString(str) {
    let hash = 0;
    if (str.length === 0) return hash.toString();
    for(let i = 0; i < str.length; i += 1){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    let color = "#";
    for(let j = 0; j < 3; j += 1){
        const value = hash >> j * 8 & 255;
        color += `00${value.toString(16)}`.substr(-2);
    }
    return color;
}
function $a031d15006571f58$var$randomColorFromList(str, list) {
    let index = 0;
    if (str.length === 0) return list[0];
    for(let i = 0; i < str.length; i += 1){
        index = str.charCodeAt(i) + ((index << 5) - index);
        index = index & index;
    }
    index = (index % list.length + list.length) % list.length;
    return list[index];
}
function $a031d15006571f58$var$randomFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
}


var $b12872ed3cae6b5f$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tabs-color");
var $b12872ed3cae6b5f$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tabs-bg");
var $b12872ed3cae6b5f$var$$border = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tabs-border-color");
var { defineMultiStyleConfig: $b12872ed3cae6b5f$var$defineMultiStyleConfig, definePartsStyle: $b12872ed3cae6b5f$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$97383552563be58d).keys);
var $b12872ed3cae6b5f$var$baseStyleRoot = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: orientation === "vertical" ? "flex" : "block"
    };
});
var $b12872ed3cae6b5f$var$baseStyleTab = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isFitted: isFitted } = props;
    return {
        flex: isFitted ? 1 : void 0,
        transitionProperty: "common",
        transitionDuration: "normal",
        _focusVisible: {
            zIndex: 1,
            boxShadow: "outline"
        },
        _disabled: {
            cursor: "not-allowed",
            opacity: 0.4
        }
    };
});
var $b12872ed3cae6b5f$var$baseStyleTablist = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { align: align = "start", orientation: orientation } = props;
    const alignments = {
        end: "flex-end",
        center: "center",
        start: "flex-start"
    };
    return {
        justifyContent: alignments[align],
        flexDirection: orientation === "vertical" ? "column" : "row"
    };
});
var $b12872ed3cae6b5f$var$baseStyleTabpanel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    p: 4
});
var $b12872ed3cae6b5f$var$baseStyle = $b12872ed3cae6b5f$var$definePartsStyle((props)=>({
        root: $b12872ed3cae6b5f$var$baseStyleRoot(props),
        tab: $b12872ed3cae6b5f$var$baseStyleTab(props),
        tablist: $b12872ed3cae6b5f$var$baseStyleTablist(props),
        tabpanel: $b12872ed3cae6b5f$var$baseStyleTabpanel
    }));
var $b12872ed3cae6b5f$var$sizes = {
    sm: $b12872ed3cae6b5f$var$definePartsStyle({
        tab: {
            py: 1,
            px: 4,
            fontSize: "sm"
        }
    }),
    md: $b12872ed3cae6b5f$var$definePartsStyle({
        tab: {
            fontSize: "md",
            py: 2,
            px: 4
        }
    }),
    lg: $b12872ed3cae6b5f$var$definePartsStyle({
        tab: {
            fontSize: "lg",
            py: 3,
            px: 4
        }
    })
};
var $b12872ed3cae6b5f$var$variantLine = $b12872ed3cae6b5f$var$definePartsStyle((props)=>{
    const { colorScheme: c, orientation: orientation } = props;
    const isVertical = orientation === "vertical";
    const borderProp = isVertical ? "borderStart" : "borderBottom";
    const marginProp = isVertical ? "marginStart" : "marginBottom";
    return {
        tablist: {
            [borderProp]: "2px solid",
            borderColor: "inherit"
        },
        tab: {
            [borderProp]: "2px solid",
            borderColor: "transparent",
            [marginProp]: "-2px",
            _selected: {
                [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "currentColor"
            },
            _active: {
                [$b12872ed3cae6b5f$var$$bg.variable]: "colors.gray.200",
                _dark: {
                    [$b12872ed3cae6b5f$var$$bg.variable]: "colors.whiteAlpha.300"
                }
            },
            _disabled: {
                _active: {
                    bg: "none"
                }
            },
            color: $b12872ed3cae6b5f$var$$fg.reference,
            bg: $b12872ed3cae6b5f$var$$bg.reference
        }
    };
});
var $b12872ed3cae6b5f$var$variantEnclosed = $b12872ed3cae6b5f$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderTopRadius: "md",
            border: "1px solid",
            borderColor: "transparent",
            mb: "-1px",
            [$b12872ed3cae6b5f$var$$border.variable]: "transparent",
            _selected: {
                [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.600`,
                [$b12872ed3cae6b5f$var$$border.variable]: `colors.white`,
                _dark: {
                    [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.300`,
                    [$b12872ed3cae6b5f$var$$border.variable]: `colors.gray.800`
                },
                borderColor: "inherit",
                borderBottomColor: $b12872ed3cae6b5f$var$$border.reference
            },
            color: $b12872ed3cae6b5f$var$$fg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
var $b12872ed3cae6b5f$var$variantEnclosedColored = $b12872ed3cae6b5f$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            border: "1px solid",
            borderColor: "inherit",
            [$b12872ed3cae6b5f$var$$bg.variable]: "colors.gray.50",
            _dark: {
                [$b12872ed3cae6b5f$var$$bg.variable]: "colors.whiteAlpha.50"
            },
            mb: "-1px",
            _notLast: {
                marginEnd: "-1px"
            },
            _selected: {
                [$b12872ed3cae6b5f$var$$bg.variable]: "colors.white",
                [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$b12872ed3cae6b5f$var$$bg.variable]: "colors.gray.800",
                    [$b12872ed3cae6b5f$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "inherit",
                borderTopColor: "currentColor",
                borderBottomColor: "transparent"
            },
            color: $b12872ed3cae6b5f$var$$fg.reference,
            bg: $b12872ed3cae6b5f$var$$bg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
var $b12872ed3cae6b5f$var$variantSoftRounded = $b12872ed3cae6b5f$var$definePartsStyle((props)=>{
    const { colorScheme: c, theme: theme } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            color: "gray.600",
            _selected: {
                color: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, `${c}.700`),
                bg: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, `${c}.100`)
            }
        }
    };
});
var $b12872ed3cae6b5f$var$variantSolidRounded = $b12872ed3cae6b5f$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            [$b12872ed3cae6b5f$var$$fg.variable]: "colors.gray.600",
            _dark: {
                [$b12872ed3cae6b5f$var$$fg.variable]: "inherit"
            },
            _selected: {
                [$b12872ed3cae6b5f$var$$fg.variable]: "colors.white",
                [$b12872ed3cae6b5f$var$$bg.variable]: `colors.${c}.600`,
                _dark: {
                    [$b12872ed3cae6b5f$var$$fg.variable]: "colors.gray.800",
                    [$b12872ed3cae6b5f$var$$bg.variable]: `colors.${c}.300`
                }
            },
            color: $b12872ed3cae6b5f$var$$fg.reference,
            bg: $b12872ed3cae6b5f$var$$bg.reference
        }
    };
});
var $b12872ed3cae6b5f$var$variantUnstyled = $b12872ed3cae6b5f$var$definePartsStyle({});
var $b12872ed3cae6b5f$var$variants = {
    line: $b12872ed3cae6b5f$var$variantLine,
    enclosed: $b12872ed3cae6b5f$var$variantEnclosed,
    "enclosed-colored": $b12872ed3cae6b5f$var$variantEnclosedColored,
    "soft-rounded": $b12872ed3cae6b5f$var$variantSoftRounded,
    "solid-rounded": $b12872ed3cae6b5f$var$variantSolidRounded,
    unstyled: $b12872ed3cae6b5f$var$variantUnstyled
};
var $b12872ed3cae6b5f$export$847a245e7ebce2a1 = $b12872ed3cae6b5f$var$defineMultiStyleConfig({
    baseStyle: $b12872ed3cae6b5f$var$baseStyle,
    sizes: $b12872ed3cae6b5f$var$sizes,
    variants: $b12872ed3cae6b5f$var$variants,
    defaultProps: {
        size: "md",
        variant: "line",
        colorScheme: "blue"
    }
});


// src/components/badge.ts


var $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4 = (0, $47a6d9fbbf7ee42d$export$bd40561c6c056841)("badge", [
    "bg",
    "color",
    "shadow"
]);
var $ef3cdcb3a868c7e9$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 1,
    textTransform: "uppercase",
    fontSize: "xs",
    borderRadius: "sm",
    fontWeight: "bold",
    bg: $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.bg.reference,
    color: $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.reference,
    boxShadow: $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.shadow.reference
});
var $ef3cdcb3a868c7e9$var$variantSolid = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const dark = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.500`, 0.6)(theme);
    return {
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.bg.variable]: `colors.${c}.500`,
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: `colors.white`,
        _dark: {
            [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.bg.variable]: dark,
            [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: `colors.whiteAlpha.800`
        }
    };
});
var $ef3cdcb3a868c7e9$var$variantSubtle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkBg = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.bg.variable]: `colors.${c}.100`,
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.800`,
        _dark: {
            [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.bg.variable]: darkBg,
            [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.200`
        }
    };
});
var $ef3cdcb3a868c7e9$var$variantOutline = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkColor = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.200`, 0.8)(theme);
    return {
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.500`,
        _dark: {
            [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.variable]: darkColor
        },
        [$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.shadow.variable]: `inset 0 0 0px 1px ${$ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4.color.reference}`
    };
});
var $ef3cdcb3a868c7e9$var$variants = {
    solid: $ef3cdcb3a868c7e9$var$variantSolid,
    subtle: $ef3cdcb3a868c7e9$var$variantSubtle,
    outline: $ef3cdcb3a868c7e9$var$variantOutline
};
var $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $ef3cdcb3a868c7e9$var$baseStyle,
    variants: $ef3cdcb3a868c7e9$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "gray"
    }
});




var { defineMultiStyleConfig: $8e37595eb187b127$var$defineMultiStyleConfig, definePartsStyle: $8e37595eb187b127$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$4c2f5f7f2ea94a8e).keys);
var $8e37595eb187b127$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-bg");
var $8e37595eb187b127$var$$color = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-color");
var $8e37595eb187b127$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-shadow");
var $8e37595eb187b127$var$$minH = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-min-height");
var $8e37595eb187b127$var$$minW = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-min-width");
var $8e37595eb187b127$var$$fontSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-font-size");
var $8e37595eb187b127$var$$paddingX = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-padding-inline");
var $8e37595eb187b127$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontWeight: "medium",
    lineHeight: 1.2,
    outline: 0,
    [$8e37595eb187b127$var$$color.variable]: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).color.reference,
    [$8e37595eb187b127$var$$bg.variable]: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).bg.reference,
    [$8e37595eb187b127$var$$shadow.variable]: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).shadow.reference,
    color: $8e37595eb187b127$var$$color.reference,
    bg: $8e37595eb187b127$var$$bg.reference,
    boxShadow: $8e37595eb187b127$var$$shadow.reference,
    borderRadius: "md",
    minH: $8e37595eb187b127$var$$minH.reference,
    minW: $8e37595eb187b127$var$$minW.reference,
    fontSize: $8e37595eb187b127$var$$fontSize.reference,
    px: $8e37595eb187b127$var$$paddingX.reference,
    _focusVisible: {
        [$8e37595eb187b127$var$$shadow.variable]: "shadows.outline"
    }
});
var $8e37595eb187b127$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    lineHeight: 1.2,
    overflow: "visible"
});
var $8e37595eb187b127$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: "lg",
    w: "5",
    h: "5",
    transitionProperty: "common",
    transitionDuration: "normal",
    borderRadius: "full",
    marginStart: "1.5",
    marginEnd: "-1",
    opacity: 0.5,
    _disabled: {
        opacity: 0.4
    },
    _focusVisible: {
        boxShadow: "outline",
        bg: "rgba(0, 0, 0, 0.14)"
    },
    _hover: {
        opacity: 0.8
    },
    _active: {
        opacity: 1
    }
});
var $8e37595eb187b127$var$baseStyle = $8e37595eb187b127$var$definePartsStyle({
    container: $8e37595eb187b127$var$baseStyleContainer,
    label: $8e37595eb187b127$var$baseStyleLabel,
    closeButton: $8e37595eb187b127$var$baseStyleCloseButton
});
var $8e37595eb187b127$var$sizes = {
    sm: $8e37595eb187b127$var$definePartsStyle({
        container: {
            [$8e37595eb187b127$var$$minH.variable]: "sizes.5",
            [$8e37595eb187b127$var$$minW.variable]: "sizes.5",
            [$8e37595eb187b127$var$$fontSize.variable]: "fontSizes.xs",
            [$8e37595eb187b127$var$$paddingX.variable]: "space.2"
        },
        closeButton: {
            marginEnd: "-2px",
            marginStart: "0.35rem"
        }
    }),
    md: $8e37595eb187b127$var$definePartsStyle({
        container: {
            [$8e37595eb187b127$var$$minH.variable]: "sizes.6",
            [$8e37595eb187b127$var$$minW.variable]: "sizes.6",
            [$8e37595eb187b127$var$$fontSize.variable]: "fontSizes.sm",
            [$8e37595eb187b127$var$$paddingX.variable]: "space.2"
        }
    }),
    lg: $8e37595eb187b127$var$definePartsStyle({
        container: {
            [$8e37595eb187b127$var$$minH.variable]: "sizes.8",
            [$8e37595eb187b127$var$$minW.variable]: "sizes.8",
            [$8e37595eb187b127$var$$fontSize.variable]: "fontSizes.md",
            [$8e37595eb187b127$var$$paddingX.variable]: "space.3"
        }
    })
};
var $8e37595eb187b127$var$variants = {
    subtle: $8e37595eb187b127$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.subtle(props)
        };
    }),
    solid: $8e37595eb187b127$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.solid(props)
        };
    }),
    outline: $8e37595eb187b127$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.outline(props)
        };
    })
};
var $8e37595eb187b127$export$f8ab9ac2a319695b = $8e37595eb187b127$var$defineMultiStyleConfig({
    variants: $8e37595eb187b127$var$variants,
    baseStyle: $8e37595eb187b127$var$baseStyle,
    sizes: $8e37595eb187b127$var$sizes,
    defaultProps: {
        size: "md",
        variant: "subtle",
        colorScheme: "gray"
    }
});


// src/components/input.ts



var { definePartsStyle: $732b2cb9e8ffdec6$var$definePartsStyle, defineMultiStyleConfig: $732b2cb9e8ffdec6$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$1ffeb100b532f46d).keys);
var $732b2cb9e8ffdec6$var$$height = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("input-height");
var $732b2cb9e8ffdec6$var$$fontSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("input-font-size");
var $732b2cb9e8ffdec6$var$$padding = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("input-padding");
var $732b2cb9e8ffdec6$var$$borderRadius = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("input-border-radius");
var $732b2cb9e8ffdec6$var$baseStyle = $732b2cb9e8ffdec6$var$definePartsStyle({
    addon: {
        height: $732b2cb9e8ffdec6$var$$height.reference,
        fontSize: $732b2cb9e8ffdec6$var$$fontSize.reference,
        px: $732b2cb9e8ffdec6$var$$padding.reference,
        borderRadius: $732b2cb9e8ffdec6$var$$borderRadius.reference
    },
    field: {
        width: "100%",
        height: $732b2cb9e8ffdec6$var$$height.reference,
        fontSize: $732b2cb9e8ffdec6$var$$fontSize.reference,
        px: $732b2cb9e8ffdec6$var$$padding.reference,
        borderRadius: $732b2cb9e8ffdec6$var$$borderRadius.reference,
        minWidth: 0,
        outline: 0,
        position: "relative",
        appearance: "none",
        transitionProperty: "common",
        transitionDuration: "normal",
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        }
    }
});
var $732b2cb9e8ffdec6$var$size = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$732b2cb9e8ffdec6$var$$fontSize.variable]: "fontSizes.lg",
        [$732b2cb9e8ffdec6$var$$padding.variable]: "space.4",
        [$732b2cb9e8ffdec6$var$$borderRadius.variable]: "radii.md",
        [$732b2cb9e8ffdec6$var$$height.variable]: "sizes.12"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$732b2cb9e8ffdec6$var$$fontSize.variable]: "fontSizes.md",
        [$732b2cb9e8ffdec6$var$$padding.variable]: "space.4",
        [$732b2cb9e8ffdec6$var$$borderRadius.variable]: "radii.md",
        [$732b2cb9e8ffdec6$var$$height.variable]: "sizes.10"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$732b2cb9e8ffdec6$var$$fontSize.variable]: "fontSizes.sm",
        [$732b2cb9e8ffdec6$var$$padding.variable]: "space.3",
        [$732b2cb9e8ffdec6$var$$borderRadius.variable]: "radii.sm",
        [$732b2cb9e8ffdec6$var$$height.variable]: "sizes.8"
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$732b2cb9e8ffdec6$var$$fontSize.variable]: "fontSizes.xs",
        [$732b2cb9e8ffdec6$var$$padding.variable]: "space.2",
        [$732b2cb9e8ffdec6$var$$borderRadius.variable]: "radii.sm",
        [$732b2cb9e8ffdec6$var$$height.variable]: "sizes.6"
    })
};
var $732b2cb9e8ffdec6$var$sizes = {
    lg: $732b2cb9e8ffdec6$var$definePartsStyle({
        field: $732b2cb9e8ffdec6$var$size.lg,
        group: $732b2cb9e8ffdec6$var$size.lg
    }),
    md: $732b2cb9e8ffdec6$var$definePartsStyle({
        field: $732b2cb9e8ffdec6$var$size.md,
        group: $732b2cb9e8ffdec6$var$size.md
    }),
    sm: $732b2cb9e8ffdec6$var$definePartsStyle({
        field: $732b2cb9e8ffdec6$var$size.sm,
        group: $732b2cb9e8ffdec6$var$size.sm
    }),
    xs: $732b2cb9e8ffdec6$var$definePartsStyle({
        field: $732b2cb9e8ffdec6$var$size.xs,
        group: $732b2cb9e8ffdec6$var$size.xs
    })
};
function $732b2cb9e8ffdec6$var$getDefaults(props) {
    const { focusBorderColor: fc, errorBorderColor: ec } = props;
    return {
        focusBorderColor: fc || (0, $6eb225f883147347$export$549ff81930776885)("blue.500", "blue.300")(props),
        errorBorderColor: ec || (0, $6eb225f883147347$export$549ff81930776885)("red.500", "red.300")(props)
    };
}
var $732b2cb9e8ffdec6$var$variantOutline = $732b2cb9e8ffdec6$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $732b2cb9e8ffdec6$var$getDefaults(props);
    return {
        field: {
            border: "1px solid",
            borderColor: "inherit",
            bg: "inherit",
            _hover: {
                borderColor: (0, $6eb225f883147347$export$549ff81930776885)("gray.300", "whiteAlpha.400")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, ec),
                boxShadow: `0 0 0 1px ${(0, $a031d15006571f58$export$5551a2d24ff40153)(theme, ec)}`
            },
            _focusVisible: {
                zIndex: 1,
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, fc),
                boxShadow: `0 0 0 1px ${(0, $a031d15006571f58$export$5551a2d24ff40153)(theme, fc)}`
            }
        },
        addon: {
            border: "1px solid",
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)("inherit", "whiteAlpha.50")(props),
            bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
        }
    };
});
var $732b2cb9e8ffdec6$var$variantFilled = $732b2cb9e8ffdec6$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $732b2cb9e8ffdec6$var$getDefaults(props);
    return {
        field: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props),
            _hover: {
                bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.200", "whiteAlpha.100")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, ec)
            },
            _focusVisible: {
                bg: "transparent",
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, fc)
            }
        },
        addon: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props)
        }
    };
});
var $732b2cb9e8ffdec6$var$variantFlushed = $732b2cb9e8ffdec6$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $732b2cb9e8ffdec6$var$getDefaults(props);
    return {
        field: {
            borderBottom: "1px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent",
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, ec),
                boxShadow: `0px 1px 0px 0px ${(0, $a031d15006571f58$export$5551a2d24ff40153)(theme, ec)}`
            },
            _focusVisible: {
                borderColor: (0, $a031d15006571f58$export$5551a2d24ff40153)(theme, fc),
                boxShadow: `0px 1px 0px 0px ${(0, $a031d15006571f58$export$5551a2d24ff40153)(theme, fc)}`
            }
        },
        addon: {
            borderBottom: "2px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent"
        }
    };
});
var $732b2cb9e8ffdec6$var$variantUnstyled = $732b2cb9e8ffdec6$var$definePartsStyle({
    field: {
        bg: "transparent",
        px: "0",
        height: "auto"
    },
    addon: {
        bg: "transparent",
        px: "0",
        height: "auto"
    }
});
var $732b2cb9e8ffdec6$var$variants = {
    outline: $732b2cb9e8ffdec6$var$variantOutline,
    filled: $732b2cb9e8ffdec6$var$variantFilled,
    flushed: $732b2cb9e8ffdec6$var$variantFlushed,
    unstyled: $732b2cb9e8ffdec6$var$variantUnstyled
};
var $732b2cb9e8ffdec6$export$b1b9f3bced726e54 = $732b2cb9e8ffdec6$var$defineMultiStyleConfig({
    baseStyle: $732b2cb9e8ffdec6$var$baseStyle,
    sizes: $732b2cb9e8ffdec6$var$sizes,
    variants: $732b2cb9e8ffdec6$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});



var $db4a338c74752624$var$_a;
var $db4a338c74752624$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    ...($db4a338c74752624$var$_a = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $db4a338c74752624$var$_a.field,
    paddingY: "2",
    minHeight: "20",
    lineHeight: "short",
    verticalAlign: "top"
});
var $db4a338c74752624$var$_a2, $db4a338c74752624$var$_b;
var $db4a338c74752624$var$variants = {
    outline: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.outline(props).field) != null ? _b3 : {};
    }),
    flushed: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.flushed(props).field) != null ? _b3 : {};
    }),
    filled: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.filled(props).field) != null ? _b3 : {};
    }),
    unstyled: ($db4a338c74752624$var$_b = ($db4a338c74752624$var$_a2 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : $db4a338c74752624$var$_a2.unstyled.field) != null ? $db4a338c74752624$var$_b : {}
};
var $db4a338c74752624$var$_a3, $db4a338c74752624$var$_b2, $db4a338c74752624$var$_c, $db4a338c74752624$var$_d, $db4a338c74752624$var$_e, $db4a338c74752624$var$_f, $db4a338c74752624$var$_g, $db4a338c74752624$var$_h;
var $db4a338c74752624$var$sizes = {
    xs: ($db4a338c74752624$var$_b2 = ($db4a338c74752624$var$_a3 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $db4a338c74752624$var$_a3.xs.field) != null ? $db4a338c74752624$var$_b2 : {},
    sm: ($db4a338c74752624$var$_d = ($db4a338c74752624$var$_c = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $db4a338c74752624$var$_c.sm.field) != null ? $db4a338c74752624$var$_d : {},
    md: ($db4a338c74752624$var$_f = ($db4a338c74752624$var$_e = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $db4a338c74752624$var$_e.md.field) != null ? $db4a338c74752624$var$_f : {},
    lg: ($db4a338c74752624$var$_h = ($db4a338c74752624$var$_g = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $db4a338c74752624$var$_g.lg.field) != null ? $db4a338c74752624$var$_h : {}
};
var $db4a338c74752624$export$394b8322fab774c1 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $db4a338c74752624$var$baseStyle,
    sizes: $db4a338c74752624$var$sizes,
    variants: $db4a338c74752624$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});


// src/components/tooltip.ts


var $fd7519f20c5c0006$var$$bg = (0, $591785a32740c673$export$8b4981022bd80a4e)("tooltip-bg");
var $fd7519f20c5c0006$var$$fg = (0, $591785a32740c673$export$8b4981022bd80a4e)("tooltip-fg");
var $fd7519f20c5c0006$var$$arrowBg = (0, $591785a32740c673$export$8b4981022bd80a4e)("popper-arrow-bg");
var $fd7519f20c5c0006$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: $fd7519f20c5c0006$var$$bg.reference,
    color: $fd7519f20c5c0006$var$$fg.reference,
    [$fd7519f20c5c0006$var$$bg.variable]: "colors.gray.700",
    [$fd7519f20c5c0006$var$$fg.variable]: "colors.whiteAlpha.900",
    _dark: {
        [$fd7519f20c5c0006$var$$bg.variable]: "colors.gray.300",
        [$fd7519f20c5c0006$var$$fg.variable]: "colors.gray.900"
    },
    [$fd7519f20c5c0006$var$$arrowBg.variable]: $fd7519f20c5c0006$var$$bg.reference,
    px: "2",
    py: "0.5",
    borderRadius: "sm",
    fontWeight: "medium",
    fontSize: "sm",
    boxShadow: "md",
    maxW: "xs",
    zIndex: "tooltip"
});
var $fd7519f20c5c0006$export$7472a7883840b563 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $fd7519f20c5c0006$var$baseStyle
});


// src/components/progress.ts



var { defineMultiStyleConfig: $924e305cbcea9b38$var$defineMultiStyleConfig, definePartsStyle: $924e305cbcea9b38$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$ba6328c242bd649c).keys);
var $924e305cbcea9b38$var$filledStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: t, isIndeterminate: isIndeterminate, hasStripe: hasStripe } = props;
    const stripeStyle = (0, $6eb225f883147347$export$549ff81930776885)((0, $a031d15006571f58$export$db0ffb03ee9f3080)(), (0, $a031d15006571f58$export$db0ffb03ee9f3080)("1rem", "rgba(0,0,0,0.1)"))(props);
    const bgColor = (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props);
    const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${(0, $a031d15006571f58$export$5551a2d24ff40153)(t, bgColor)} 50%,
    transparent 100%
  )`;
    const addStripe = !isIndeterminate && hasStripe;
    return {
        ...addStripe && stripeStyle,
        ...isIndeterminate ? {
            bgImage: gradient
        } : {
            bgColor: bgColor
        }
    };
});
var $924e305cbcea9b38$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    lineHeight: "1",
    fontSize: "0.25em",
    fontWeight: "bold",
    color: "white"
});
var $924e305cbcea9b38$var$baseStyleTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    return {
        bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
    };
});
var $924e305cbcea9b38$var$baseStyleFilledTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    return {
        transitionProperty: "common",
        transitionDuration: "slow",
        ...$924e305cbcea9b38$var$filledStyle(props)
    };
});
var $924e305cbcea9b38$var$baseStyle = $924e305cbcea9b38$var$definePartsStyle((props)=>({
        label: $924e305cbcea9b38$var$baseStyleLabel,
        filledTrack: $924e305cbcea9b38$var$baseStyleFilledTrack(props),
        track: $924e305cbcea9b38$var$baseStyleTrack(props)
    }));
var $924e305cbcea9b38$var$sizes = {
    xs: $924e305cbcea9b38$var$definePartsStyle({
        track: {
            h: "1"
        }
    }),
    sm: $924e305cbcea9b38$var$definePartsStyle({
        track: {
            h: "2"
        }
    }),
    md: $924e305cbcea9b38$var$definePartsStyle({
        track: {
            h: "3"
        }
    }),
    lg: $924e305cbcea9b38$var$definePartsStyle({
        track: {
            h: "4"
        }
    })
};
var $924e305cbcea9b38$export$dc04d8e6a17afea1 = $924e305cbcea9b38$var$defineMultiStyleConfig({
    sizes: $924e305cbcea9b38$var$sizes,
    baseStyle: $924e305cbcea9b38$var$baseStyle,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/utils/run-if-fn.ts
var $245fb38d8179b6d2$var$isFunction = (value)=>typeof value === "function";
function $245fb38d8179b6d2$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $245fb38d8179b6d2$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}





var { definePartsStyle: $3a660172b177ab9e$var$definePartsStyle, defineMultiStyleConfig: $3a660172b177ab9e$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$21946b04497ed6ac).keys);
var $3a660172b177ab9e$var$$size = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("checkbox-size");
var $3a660172b177ab9e$var$baseStyleControl = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        w: $3a660172b177ab9e$var$$size.reference,
        h: $3a660172b177ab9e$var$$size.reference,
        transitionProperty: "box-shadow",
        transitionDuration: "normal",
        border: "2px solid",
        borderRadius: "sm",
        borderColor: "inherit",
        color: "white",
        _checked: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $6eb225f883147347$export$549ff81930776885)("white", "gray.900")(props),
            _hover: {
                bg: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props),
                borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props)
            },
            _disabled: {
                borderColor: (0, $6eb225f883147347$export$549ff81930776885)("gray.200", "transparent")(props),
                bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props),
                color: (0, $6eb225f883147347$export$549ff81930776885)("gray.500", "whiteAlpha.500")(props)
            }
        },
        _indeterminate: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $6eb225f883147347$export$549ff81930776885)("white", "gray.900")(props)
        },
        _disabled: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "whiteAlpha.100")(props),
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)("gray.100", "transparent")(props)
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _invalid: {
            borderColor: (0, $6eb225f883147347$export$549ff81930776885)("red.500", "red.300")(props)
        }
    };
});
var $3a660172b177ab9e$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    _disabled: {
        cursor: "not-allowed"
    }
});
var $3a660172b177ab9e$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    userSelect: "none",
    _disabled: {
        opacity: 0.4
    }
});
var $3a660172b177ab9e$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "transform",
    transitionDuration: "normal"
});
var $3a660172b177ab9e$var$baseStyle = $3a660172b177ab9e$var$definePartsStyle((props)=>({
        icon: $3a660172b177ab9e$var$baseStyleIcon,
        container: $3a660172b177ab9e$var$baseStyleContainer,
        control: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($3a660172b177ab9e$var$baseStyleControl, props),
        label: $3a660172b177ab9e$var$baseStyleLabel
    }));
var $3a660172b177ab9e$var$sizes = {
    sm: $3a660172b177ab9e$var$definePartsStyle({
        control: {
            [$3a660172b177ab9e$var$$size.variable]: "sizes.3"
        },
        label: {
            fontSize: "sm"
        },
        icon: {
            fontSize: "3xs"
        }
    }),
    md: $3a660172b177ab9e$var$definePartsStyle({
        control: {
            [$3a660172b177ab9e$var$$size.variable]: "sizes.4"
        },
        label: {
            fontSize: "md"
        },
        icon: {
            fontSize: "2xs"
        }
    }),
    lg: $3a660172b177ab9e$var$definePartsStyle({
        control: {
            [$3a660172b177ab9e$var$$size.variable]: "sizes.5"
        },
        label: {
            fontSize: "lg"
        },
        icon: {
            fontSize: "2xs"
        }
    })
};
var $3a660172b177ab9e$export$86286d8c37984115 = $3a660172b177ab9e$var$defineMultiStyleConfig({
    baseStyle: $3a660172b177ab9e$var$baseStyle,
    sizes: $3a660172b177ab9e$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





var { defineMultiStyleConfig: $21c6841492ceabf9$var$defineMultiStyleConfig, definePartsStyle: $21c6841492ceabf9$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$d28d06d0e29ef022).keys);
var $21c6841492ceabf9$var$baseStyleControl = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    var _a;
    const controlStyle = (_a = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)((0, $3a660172b177ab9e$export$86286d8c37984115).baseStyle, props)) == null ? void 0 : _a.control;
    return {
        ...controlStyle,
        borderRadius: "full",
        _checked: {
            ...controlStyle == null ? void 0 : controlStyle["_checked"],
            _before: {
                content: `""`,
                display: "inline-block",
                pos: "relative",
                w: "50%",
                h: "50%",
                borderRadius: "50%",
                bg: "currentColor"
            }
        }
    };
});
var $21c6841492ceabf9$var$baseStyle = $21c6841492ceabf9$var$definePartsStyle((props)=>{
    var _a, _b, _c, _d;
    return {
        label: (_b = (_a = (0, $3a660172b177ab9e$export$86286d8c37984115)).baseStyle) == null ? void 0 : _b.call(_a, props).label,
        container: (_d = (_c = (0, $3a660172b177ab9e$export$86286d8c37984115)).baseStyle) == null ? void 0 : _d.call(_c, props).container,
        control: $21c6841492ceabf9$var$baseStyleControl(props)
    };
});
var $21c6841492ceabf9$var$sizes = {
    md: $21c6841492ceabf9$var$definePartsStyle({
        control: {
            w: "4",
            h: "4"
        },
        label: {
            fontSize: "md"
        }
    }),
    lg: $21c6841492ceabf9$var$definePartsStyle({
        control: {
            w: "5",
            h: "5"
        },
        label: {
            fontSize: "lg"
        }
    }),
    sm: $21c6841492ceabf9$var$definePartsStyle({
        control: {
            width: "3",
            height: "3"
        },
        label: {
            fontSize: "sm"
        }
    })
};
var $21c6841492ceabf9$export$f0b387b940941887 = $21c6841492ceabf9$var$defineMultiStyleConfig({
    baseStyle: $21c6841492ceabf9$var$baseStyle,
    sizes: $21c6841492ceabf9$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





var { defineMultiStyleConfig: $aba0b22b8ca9eec7$var$defineMultiStyleConfig, definePartsStyle: $aba0b22b8ca9eec7$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$17993f0be9538b5a).keys);
var $aba0b22b8ca9eec7$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("select-bg");
var $aba0b22b8ca9eec7$var$_a;
var $aba0b22b8ca9eec7$var$baseStyleField = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    ...($aba0b22b8ca9eec7$var$_a = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $aba0b22b8ca9eec7$var$_a.field,
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    bg: $aba0b22b8ca9eec7$var$$bg.reference,
    [$aba0b22b8ca9eec7$var$$bg.variable]: "colors.white",
    _dark: {
        [$aba0b22b8ca9eec7$var$$bg.variable]: "colors.gray.700"
    },
    "> option, > optgroup": {
        bg: $aba0b22b8ca9eec7$var$$bg.reference
    }
});
var $aba0b22b8ca9eec7$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    width: "6",
    height: "100%",
    insetEnd: "2",
    position: "relative",
    color: "currentColor",
    fontSize: "xl",
    _disabled: {
        opacity: 0.5
    }
});
var $aba0b22b8ca9eec7$var$baseStyle = $aba0b22b8ca9eec7$var$definePartsStyle({
    field: $aba0b22b8ca9eec7$var$baseStyleField,
    icon: $aba0b22b8ca9eec7$var$baseStyleIcon
});
var $aba0b22b8ca9eec7$var$iconSpacing = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    paddingInlineEnd: "8"
});
var $aba0b22b8ca9eec7$var$_a2, $aba0b22b8ca9eec7$var$_b, $aba0b22b8ca9eec7$var$_c, $aba0b22b8ca9eec7$var$_d, $aba0b22b8ca9eec7$var$_e, $aba0b22b8ca9eec7$var$_f, $aba0b22b8ca9eec7$var$_g, $aba0b22b8ca9eec7$var$_h;
var $aba0b22b8ca9eec7$var$sizes = {
    lg: {
        ...($aba0b22b8ca9eec7$var$_a2 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_a2.lg,
        field: {
            ...($aba0b22b8ca9eec7$var$_b = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_b.lg.field,
            ...$aba0b22b8ca9eec7$var$iconSpacing
        }
    },
    md: {
        ...($aba0b22b8ca9eec7$var$_c = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_c.md,
        field: {
            ...($aba0b22b8ca9eec7$var$_d = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_d.md.field,
            ...$aba0b22b8ca9eec7$var$iconSpacing
        }
    },
    sm: {
        ...($aba0b22b8ca9eec7$var$_e = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_e.sm,
        field: {
            ...($aba0b22b8ca9eec7$var$_f = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_f.sm.field,
            ...$aba0b22b8ca9eec7$var$iconSpacing
        }
    },
    xs: {
        ...($aba0b22b8ca9eec7$var$_g = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_g.xs,
        field: {
            ...($aba0b22b8ca9eec7$var$_h = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : $aba0b22b8ca9eec7$var$_h.xs.field,
            ...$aba0b22b8ca9eec7$var$iconSpacing
        },
        icon: {
            insetEnd: "1"
        }
    }
};
var $aba0b22b8ca9eec7$export$21af0fc3c16183e1 = $aba0b22b8ca9eec7$var$defineMultiStyleConfig({
    baseStyle: $aba0b22b8ca9eec7$var$baseStyle,
    sizes: $aba0b22b8ca9eec7$var$sizes,
    variants: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).defaultProps
});


// src/components/skeleton.ts

var $6eb62cdac4dee0fa$var$$startColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("skeleton-start-color");
var $6eb62cdac4dee0fa$var$$endColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("skeleton-end-color");
var $6eb62cdac4dee0fa$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$6eb62cdac4dee0fa$var$$startColor.variable]: "colors.gray.100",
    [$6eb62cdac4dee0fa$var$$endColor.variable]: "colors.gray.400",
    _dark: {
        [$6eb62cdac4dee0fa$var$$startColor.variable]: "colors.gray.800",
        [$6eb62cdac4dee0fa$var$$endColor.variable]: "colors.gray.600"
    },
    background: $6eb62cdac4dee0fa$var$$startColor.reference,
    borderColor: $6eb62cdac4dee0fa$var$$endColor.reference,
    opacity: 0.7,
    borderRadius: "sm"
});
var $6eb62cdac4dee0fa$export$7680371ad2d79142 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $6eb62cdac4dee0fa$var$baseStyle
});


// src/components/skip-link.ts

var $de81dc100e8decd2$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("skip-link-bg");
var $de81dc100e8decd2$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    fontWeight: "semibold",
    _focusVisible: {
        boxShadow: "outline",
        padding: "4",
        position: "fixed",
        top: "6",
        insetStart: "6",
        [$de81dc100e8decd2$var$$bg.variable]: "colors.white",
        _dark: {
            [$de81dc100e8decd2$var$$bg.variable]: "colors.gray.700"
        },
        bg: $de81dc100e8decd2$var$$bg.reference
    }
});
var $de81dc100e8decd2$export$a8cf3228ef52959 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $de81dc100e8decd2$var$baseStyle
});


// src/components/slider.ts



var { defineMultiStyleConfig: $8004dd2b97b58653$var$defineMultiStyleConfig, definePartsStyle: $8004dd2b97b58653$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$c21b4b3f8b239f32).keys);
var $8004dd2b97b58653$var$$thumbSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("slider-thumb-size");
var $8004dd2b97b58653$var$$trackSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("slider-track-size");
var $8004dd2b97b58653$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("slider-bg");
var $8004dd2b97b58653$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: "inline-block",
        position: "relative",
        cursor: "pointer",
        _disabled: {
            opacity: 0.6,
            cursor: "default",
            pointerEvents: "none"
        },
        ...(0, $6eb225f883147347$export$f3eec17ee6065eee)({
            orientation: orientation,
            vertical: {
                h: "100%"
            },
            horizontal: {
                w: "100%"
            }
        })
    };
});
var $8004dd2b97b58653$var$baseStyleTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const orientationStyles = (0, $6eb225f883147347$export$f3eec17ee6065eee)({
        orientation: props.orientation,
        horizontal: {
            h: $8004dd2b97b58653$var$$trackSize.reference
        },
        vertical: {
            w: $8004dd2b97b58653$var$$trackSize.reference
        }
    });
    return {
        ...orientationStyles,
        overflow: "hidden",
        borderRadius: "sm",
        [$8004dd2b97b58653$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$8004dd2b97b58653$var$$bg.variable]: "colors.whiteAlpha.200"
        },
        _disabled: {
            [$8004dd2b97b58653$var$$bg.variable]: "colors.gray.300",
            _dark: {
                [$8004dd2b97b58653$var$$bg.variable]: "colors.whiteAlpha.300"
            }
        },
        bg: $8004dd2b97b58653$var$$bg.reference
    };
});
var $8004dd2b97b58653$var$baseStyleThumb = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    const orientationStyle = (0, $6eb225f883147347$export$f3eec17ee6065eee)({
        orientation: orientation,
        vertical: {
            left: "50%",
            transform: `translateX(-50%)`,
            _active: {
                transform: `translateX(-50%) scale(1.15)`
            }
        },
        horizontal: {
            top: "50%",
            transform: `translateY(-50%)`,
            _active: {
                transform: `translateY(-50%) scale(1.15)`
            }
        }
    });
    return {
        ...orientationStyle,
        w: $8004dd2b97b58653$var$$thumbSize.reference,
        h: $8004dd2b97b58653$var$$thumbSize.reference,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        outline: 0,
        zIndex: 1,
        borderRadius: "full",
        bg: "white",
        boxShadow: "base",
        border: "1px solid",
        borderColor: "transparent",
        transitionProperty: "transform",
        transitionDuration: "normal",
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            bg: "gray.300"
        }
    };
});
var $8004dd2b97b58653$var$baseStyleFilledTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        width: "inherit",
        height: "inherit",
        [$8004dd2b97b58653$var$$bg.variable]: `colors.${c}.500`,
        _dark: {
            [$8004dd2b97b58653$var$$bg.variable]: `colors.${c}.200`
        },
        bg: $8004dd2b97b58653$var$$bg.reference
    };
});
var $8004dd2b97b58653$var$baseStyle = $8004dd2b97b58653$var$definePartsStyle((props)=>({
        container: $8004dd2b97b58653$var$baseStyleContainer(props),
        track: $8004dd2b97b58653$var$baseStyleTrack(props),
        thumb: $8004dd2b97b58653$var$baseStyleThumb(props),
        filledTrack: $8004dd2b97b58653$var$baseStyleFilledTrack(props)
    }));
var $8004dd2b97b58653$var$sizeLg = $8004dd2b97b58653$var$definePartsStyle({
    container: {
        [$8004dd2b97b58653$var$$thumbSize.variable]: `sizes.4`,
        [$8004dd2b97b58653$var$$trackSize.variable]: `sizes.1`
    }
});
var $8004dd2b97b58653$var$sizeMd = $8004dd2b97b58653$var$definePartsStyle({
    container: {
        [$8004dd2b97b58653$var$$thumbSize.variable]: `sizes.3.5`,
        [$8004dd2b97b58653$var$$trackSize.variable]: `sizes.1`
    }
});
var $8004dd2b97b58653$var$sizeSm = $8004dd2b97b58653$var$definePartsStyle({
    container: {
        [$8004dd2b97b58653$var$$thumbSize.variable]: `sizes.2.5`,
        [$8004dd2b97b58653$var$$trackSize.variable]: `sizes.0.5`
    }
});
var $8004dd2b97b58653$var$sizes = {
    lg: $8004dd2b97b58653$var$sizeLg,
    md: $8004dd2b97b58653$var$sizeMd,
    sm: $8004dd2b97b58653$var$sizeSm
};
var $8004dd2b97b58653$export$fff8df8fd8e1ed6f = $8004dd2b97b58653$var$defineMultiStyleConfig({
    baseStyle: $8004dd2b97b58653$var$baseStyle,
    sizes: $8004dd2b97b58653$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/components/spinner.ts


var $a4266c6ac9b1dc5e$var$$size = (0, $591785a32740c673$export$8b4981022bd80a4e)("spinner-size");
var $a4266c6ac9b1dc5e$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    width: [
        $a4266c6ac9b1dc5e$var$$size.reference
    ],
    height: [
        $a4266c6ac9b1dc5e$var$$size.reference
    ]
});
var $a4266c6ac9b1dc5e$var$sizes = {
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$a4266c6ac9b1dc5e$var$$size.variable]: "sizes.3"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$a4266c6ac9b1dc5e$var$$size.variable]: "sizes.4"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$a4266c6ac9b1dc5e$var$$size.variable]: "sizes.6"
    }),
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$a4266c6ac9b1dc5e$var$$size.variable]: "sizes.8"
    }),
    xl: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$a4266c6ac9b1dc5e$var$$size.variable]: "sizes.12"
    })
};
var $a4266c6ac9b1dc5e$export$d76156e68e556d3f = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $a4266c6ac9b1dc5e$var$baseStyle,
    sizes: $a4266c6ac9b1dc5e$var$sizes,
    defaultProps: {
        size: "md"
    }
});


// src/components/stat.ts


var { defineMultiStyleConfig: $17b9d17ea3bfb461$var$defineMultiStyleConfig, definePartsStyle: $17b9d17ea3bfb461$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$2cfbad67ae6ee421).keys);
var $17b9d17ea3bfb461$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontWeight: "medium"
});
var $17b9d17ea3bfb461$var$baseStyleHelpText = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    opacity: 0.8,
    marginBottom: "2"
});
var $17b9d17ea3bfb461$var$baseStyleNumber = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    verticalAlign: "baseline",
    fontWeight: "semibold"
});
var $17b9d17ea3bfb461$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginEnd: 1,
    w: "3.5",
    h: "3.5",
    verticalAlign: "middle"
});
var $17b9d17ea3bfb461$var$baseStyle = $17b9d17ea3bfb461$var$definePartsStyle({
    container: {},
    label: $17b9d17ea3bfb461$var$baseStyleLabel,
    helpText: $17b9d17ea3bfb461$var$baseStyleHelpText,
    number: $17b9d17ea3bfb461$var$baseStyleNumber,
    icon: $17b9d17ea3bfb461$var$baseStyleIcon
});
var $17b9d17ea3bfb461$var$sizes = {
    md: $17b9d17ea3bfb461$var$definePartsStyle({
        label: {
            fontSize: "sm"
        },
        helpText: {
            fontSize: "sm"
        },
        number: {
            fontSize: "2xl"
        }
    })
};
var $17b9d17ea3bfb461$export$f3301eb37a20f09e = $17b9d17ea3bfb461$var$defineMultiStyleConfig({
    baseStyle: $17b9d17ea3bfb461$var$baseStyle,
    sizes: $17b9d17ea3bfb461$var$sizes,
    defaultProps: {
        size: "md"
    }
});


// src/components/kbd.ts

var $99ce1a067887b061$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("kbd-bg");
var $99ce1a067887b061$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$99ce1a067887b061$var$$bg.variable]: "colors.gray.100",
    _dark: {
        [$99ce1a067887b061$var$$bg.variable]: "colors.whiteAlpha.100"
    },
    bg: $99ce1a067887b061$var$$bg.reference,
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
});
var $99ce1a067887b061$export$e193528a501e9a4a = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $99ce1a067887b061$var$baseStyle
});


// src/components/link.ts

var $33cdc3a44bd030c6$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    textDecoration: "none",
    outline: "none",
    color: "inherit",
    _hover: {
        textDecoration: "underline"
    },
    _focusVisible: {
        boxShadow: "outline"
    }
});
var $33cdc3a44bd030c6$export$af7f58b96695762e = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $33cdc3a44bd030c6$var$baseStyle
});


// src/components/list.ts


var { defineMultiStyleConfig: $7e7ecde49b12814e$var$defineMultiStyleConfig, definePartsStyle: $7e7ecde49b12814e$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$12b3a655a94374ed).keys);
var $7e7ecde49b12814e$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginEnd: "2",
    display: "inline",
    verticalAlign: "text-bottom"
});
var $7e7ecde49b12814e$var$baseStyle = $7e7ecde49b12814e$var$definePartsStyle({
    icon: $7e7ecde49b12814e$var$baseStyleIcon
});
var $7e7ecde49b12814e$export$ce840f8e8ef752d = $7e7ecde49b12814e$var$defineMultiStyleConfig({
    baseStyle: $7e7ecde49b12814e$var$baseStyle
});


// src/components/menu.ts


var { defineMultiStyleConfig: $0f90576fb7bd80ad$var$defineMultiStyleConfig, definePartsStyle: $0f90576fb7bd80ad$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$e251092a5dcb1329).keys);
var $0f90576fb7bd80ad$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("menu-bg");
var $0f90576fb7bd80ad$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("menu-shadow");
var $0f90576fb7bd80ad$var$baseStyleList = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$0f90576fb7bd80ad$var$$bg.variable]: "#fff",
    [$0f90576fb7bd80ad$var$$shadow.variable]: "shadows.sm",
    _dark: {
        [$0f90576fb7bd80ad$var$$bg.variable]: "colors.gray.700",
        [$0f90576fb7bd80ad$var$$shadow.variable]: "shadows.dark-lg"
    },
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: 1,
    borderRadius: "md",
    borderWidth: "1px",
    bg: $0f90576fb7bd80ad$var$$bg.reference,
    boxShadow: $0f90576fb7bd80ad$var$$shadow.reference
});
var $0f90576fb7bd80ad$var$baseStyleItem = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    py: "1.5",
    px: "3",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
        [$0f90576fb7bd80ad$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$0f90576fb7bd80ad$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$0f90576fb7bd80ad$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$0f90576fb7bd80ad$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _expanded: {
        [$0f90576fb7bd80ad$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$0f90576fb7bd80ad$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    bg: $0f90576fb7bd80ad$var$$bg.reference
});
var $0f90576fb7bd80ad$var$baseStyleGroupTitle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    mx: 4,
    my: 2,
    fontWeight: "semibold",
    fontSize: "sm"
});
var $0f90576fb7bd80ad$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $0f90576fb7bd80ad$var$baseStyleCommand = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    opacity: 0.6
});
var $0f90576fb7bd80ad$var$baseStyleDivider = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    border: 0,
    borderBottom: "1px solid",
    borderColor: "inherit",
    my: "2",
    opacity: 0.6
});
var $0f90576fb7bd80ad$var$baseStyleButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal"
});
var $0f90576fb7bd80ad$var$baseStyle = $0f90576fb7bd80ad$var$definePartsStyle({
    button: $0f90576fb7bd80ad$var$baseStyleButton,
    list: $0f90576fb7bd80ad$var$baseStyleList,
    item: $0f90576fb7bd80ad$var$baseStyleItem,
    groupTitle: $0f90576fb7bd80ad$var$baseStyleGroupTitle,
    icon: $0f90576fb7bd80ad$var$baseStyleIcon,
    command: $0f90576fb7bd80ad$var$baseStyleCommand,
    divider: $0f90576fb7bd80ad$var$baseStyleDivider
});
var $0f90576fb7bd80ad$export$687ce088075ea42b = $0f90576fb7bd80ad$var$defineMultiStyleConfig({
    baseStyle: $0f90576fb7bd80ad$var$baseStyle
});





var { defineMultiStyleConfig: $3966d8e51ac3bc1e$var$defineMultiStyleConfig, definePartsStyle: $3966d8e51ac3bc1e$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$34e33beb8d992ac2).keys);
var $3966d8e51ac3bc1e$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("modal-bg");
var $3966d8e51ac3bc1e$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("modal-shadow");
var $3966d8e51ac3bc1e$var$baseStyleOverlay = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
var $3966d8e51ac3bc1e$var$baseStyleDialogContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        display: "flex",
        zIndex: "modal",
        justifyContent: "center",
        alignItems: isCentered ? "center" : "flex-start",
        overflow: scrollBehavior === "inside" ? "hidden" : "auto",
        overscrollBehaviorY: "none"
    };
});
var $3966d8e51ac3bc1e$var$baseStyleDialog = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        borderRadius: "md",
        color: "inherit",
        my: isCentered ? "auto" : "16",
        mx: isCentered ? "auto" : void 0,
        zIndex: "modal",
        maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0,
        [$3966d8e51ac3bc1e$var$$bg.variable]: "colors.white",
        [$3966d8e51ac3bc1e$var$$shadow.variable]: "shadows.lg",
        _dark: {
            [$3966d8e51ac3bc1e$var$$bg.variable]: "colors.gray.700",
            [$3966d8e51ac3bc1e$var$$shadow.variable]: "shadows.dark-lg"
        },
        bg: $3966d8e51ac3bc1e$var$$bg.reference,
        boxShadow: $3966d8e51ac3bc1e$var$$shadow.reference
    };
});
var $3966d8e51ac3bc1e$var$baseStyleHeader = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
var $3966d8e51ac3bc1e$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
var $3966d8e51ac3bc1e$var$baseStyleBody = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { scrollBehavior: scrollBehavior } = props;
    return {
        px: "6",
        py: "2",
        flex: "1",
        overflow: scrollBehavior === "inside" ? "auto" : void 0
    };
});
var $3966d8e51ac3bc1e$var$baseStyleFooter = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
var $3966d8e51ac3bc1e$var$baseStyle = $3966d8e51ac3bc1e$var$definePartsStyle((props)=>({
        overlay: $3966d8e51ac3bc1e$var$baseStyleOverlay,
        dialogContainer: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($3966d8e51ac3bc1e$var$baseStyleDialogContainer, props),
        dialog: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($3966d8e51ac3bc1e$var$baseStyleDialog, props),
        header: $3966d8e51ac3bc1e$var$baseStyleHeader,
        closeButton: $3966d8e51ac3bc1e$var$baseStyleCloseButton,
        body: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($3966d8e51ac3bc1e$var$baseStyleBody, props),
        footer: $3966d8e51ac3bc1e$var$baseStyleFooter
    }));
function $3966d8e51ac3bc1e$var$getSize(value) {
    if (value === "full") return $3966d8e51ac3bc1e$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            minH: "$100vh",
            my: "0",
            borderRadius: "0"
        }
    });
    return $3966d8e51ac3bc1e$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
var $3966d8e51ac3bc1e$var$sizes = {
    xs: $3966d8e51ac3bc1e$var$getSize("xs"),
    sm: $3966d8e51ac3bc1e$var$getSize("sm"),
    md: $3966d8e51ac3bc1e$var$getSize("md"),
    lg: $3966d8e51ac3bc1e$var$getSize("lg"),
    xl: $3966d8e51ac3bc1e$var$getSize("xl"),
    "2xl": $3966d8e51ac3bc1e$var$getSize("2xl"),
    "3xl": $3966d8e51ac3bc1e$var$getSize("3xl"),
    "4xl": $3966d8e51ac3bc1e$var$getSize("4xl"),
    "5xl": $3966d8e51ac3bc1e$var$getSize("5xl"),
    "6xl": $3966d8e51ac3bc1e$var$getSize("6xl"),
    full: $3966d8e51ac3bc1e$var$getSize("full")
};
var $3966d8e51ac3bc1e$export$158ae9a07be41c05 = $3966d8e51ac3bc1e$var$defineMultiStyleConfig({
    baseStyle: $3966d8e51ac3bc1e$var$baseStyle,
    sizes: $3966d8e51ac3bc1e$var$sizes,
    defaultProps: {
        size: "md"
    }
});








var { defineMultiStyleConfig: $57684a561be679fe$var$defineMultiStyleConfig, definePartsStyle: $57684a561be679fe$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$859cc7ca3200df97).keys);
var $57684a561be679fe$var$$stepperWidth = (0, $591785a32740c673$export$8b4981022bd80a4e)("number-input-stepper-width");
var $57684a561be679fe$var$$inputPadding = (0, $591785a32740c673$export$8b4981022bd80a4e)("number-input-input-padding");
var $57684a561be679fe$var$inputPaddingValue = (0, $2ef820b9f4ef8e93$export$42bfa9b2d4dad91a)($57684a561be679fe$var$$stepperWidth).add("0.5rem").toString();
var $57684a561be679fe$var$$bg = (0, $591785a32740c673$export$8b4981022bd80a4e)("number-input-bg");
var $57684a561be679fe$var$$fg = (0, $591785a32740c673$export$8b4981022bd80a4e)("number-input-color");
var $57684a561be679fe$var$$border = (0, $591785a32740c673$export$8b4981022bd80a4e)("number-input-border-color");
var $57684a561be679fe$var$baseStyleRoot = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$57684a561be679fe$var$$stepperWidth.variable]: "sizes.6",
    [$57684a561be679fe$var$$inputPadding.variable]: $57684a561be679fe$var$inputPaddingValue
});
var $57684a561be679fe$var$baseStyleField = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    var _a, _b;
    return (_b = (_a = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)((0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).baseStyle, props)) == null ? void 0 : _a.field) != null ? _b : {};
});
var $57684a561be679fe$var$baseStyleStepperGroup = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    width: $57684a561be679fe$var$$stepperWidth.reference
});
var $57684a561be679fe$var$baseStyleStepper = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderStart: "1px solid",
    borderStartColor: $57684a561be679fe$var$$border.reference,
    color: $57684a561be679fe$var$$fg.reference,
    bg: $57684a561be679fe$var$$bg.reference,
    [$57684a561be679fe$var$$fg.variable]: "colors.chakra-body-text",
    [$57684a561be679fe$var$$border.variable]: "colors.chakra-border-color",
    _dark: {
        [$57684a561be679fe$var$$fg.variable]: "colors.whiteAlpha.800",
        [$57684a561be679fe$var$$border.variable]: "colors.whiteAlpha.300"
    },
    _active: {
        [$57684a561be679fe$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$57684a561be679fe$var$$bg.variable]: "colors.whiteAlpha.300"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    }
});
var $57684a561be679fe$var$baseStyle = $57684a561be679fe$var$definePartsStyle((props)=>{
    var _a;
    return {
        root: $57684a561be679fe$var$baseStyleRoot,
        field: (_a = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($57684a561be679fe$var$baseStyleField, props)) != null ? _a : {},
        stepperGroup: $57684a561be679fe$var$baseStyleStepperGroup,
        stepper: $57684a561be679fe$var$baseStyleStepper
    };
});
function $57684a561be679fe$var$getSize(size) {
    var _a, _b, _c;
    const sizeStyle = (_a = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).sizes) == null ? void 0 : _a[size];
    const radius = {
        lg: "md",
        md: "md",
        sm: "sm",
        xs: "sm"
    };
    const _fontSize = (_c = (_b = sizeStyle.field) == null ? void 0 : _b.fontSize) != null ? _c : "md";
    const fontSize = (0, $bba87cd2f18bf49d$export$d7c5d8884f83c8db).fontSizes[_fontSize];
    return $57684a561be679fe$var$definePartsStyle({
        field: {
            ...sizeStyle.field,
            paddingInlineEnd: $57684a561be679fe$var$$inputPadding.reference,
            verticalAlign: "top"
        },
        stepper: {
            fontSize: (0, $2ef820b9f4ef8e93$export$42bfa9b2d4dad91a)(fontSize).multiply(0.75).toString(),
            _first: {
                borderTopEndRadius: radius[size]
            },
            _last: {
                borderBottomEndRadius: radius[size],
                mt: "-1px",
                borderTopWidth: 1
            }
        }
    });
}
var $57684a561be679fe$var$sizes = {
    xs: $57684a561be679fe$var$getSize("xs"),
    sm: $57684a561be679fe$var$getSize("sm"),
    md: $57684a561be679fe$var$getSize("md"),
    lg: $57684a561be679fe$var$getSize("lg")
};
var $57684a561be679fe$export$b9bc5fa6e7f960a1 = $57684a561be679fe$var$defineMultiStyleConfig({
    baseStyle: $57684a561be679fe$var$baseStyle,
    sizes: $57684a561be679fe$var$sizes,
    variants: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).defaultProps
});





var $4565c07955136284$var$_a;
var $4565c07955136284$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    ...($4565c07955136284$var$_a = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $4565c07955136284$var$_a.field,
    textAlign: "center"
});
var $4565c07955136284$var$sizes = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "lg",
        w: 12,
        h: 12,
        borderRadius: "md"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "md",
        w: 10,
        h: 10,
        borderRadius: "md"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        w: 8,
        h: 8,
        borderRadius: "sm"
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "xs",
        w: 6,
        h: 6,
        borderRadius: "sm"
    })
};
var $4565c07955136284$var$_a2, $4565c07955136284$var$_b;
var $4565c07955136284$var$variants = {
    outline: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)((_a3 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.outline, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    flushed: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)((_a3 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.flushed, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    filled: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $245fb38d8179b6d2$export$624e501d81f5ffce)((_a3 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.filled, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    unstyled: ($4565c07955136284$var$_b = ($4565c07955136284$var$_a2 = (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).variants) == null ? void 0 : $4565c07955136284$var$_a2.unstyled.field) != null ? $4565c07955136284$var$_b : {}
};
var $4565c07955136284$export$8504c22c55a552e0 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $4565c07955136284$var$baseStyle,
    sizes: $4565c07955136284$var$sizes,
    variants: $4565c07955136284$var$variants,
    defaultProps: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54).defaultProps
});


// src/components/popover.ts



var { defineMultiStyleConfig: $dffd16657f8ddad5$var$defineMultiStyleConfig, definePartsStyle: $dffd16657f8ddad5$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$afda07d12cd4337d).keys);
var $dffd16657f8ddad5$var$$popperBg = (0, $591785a32740c673$export$8b4981022bd80a4e)("popper-bg");
var $dffd16657f8ddad5$var$$arrowBg = (0, $591785a32740c673$export$8b4981022bd80a4e)("popper-arrow-bg");
var $dffd16657f8ddad5$var$$arrowShadowColor = (0, $591785a32740c673$export$8b4981022bd80a4e)("popper-arrow-shadow-color");
var $dffd16657f8ddad5$var$baseStylePopper = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    zIndex: 10
});
var $dffd16657f8ddad5$var$baseStyleContent = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$dffd16657f8ddad5$var$$popperBg.variable]: `colors.white`,
    bg: $dffd16657f8ddad5$var$$popperBg.reference,
    [$dffd16657f8ddad5$var$$arrowBg.variable]: $dffd16657f8ddad5$var$$popperBg.reference,
    [$dffd16657f8ddad5$var$$arrowShadowColor.variable]: `colors.gray.200`,
    _dark: {
        [$dffd16657f8ddad5$var$$popperBg.variable]: `colors.gray.700`,
        [$dffd16657f8ddad5$var$$arrowShadowColor.variable]: `colors.whiteAlpha.300`
    },
    width: "xs",
    border: "1px solid",
    borderColor: "inherit",
    borderRadius: "md",
    boxShadow: "sm",
    zIndex: "inherit",
    _focusVisible: {
        outline: 0,
        boxShadow: "outline"
    }
});
var $dffd16657f8ddad5$var$baseStyleHeader = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderBottomWidth: "1px"
});
var $dffd16657f8ddad5$var$baseStyleBody = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2
});
var $dffd16657f8ddad5$var$baseStyleFooter = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderTopWidth: "1px"
});
var $dffd16657f8ddad5$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    position: "absolute",
    borderRadius: "md",
    top: 1,
    insetEnd: 2,
    padding: 2
});
var $dffd16657f8ddad5$var$baseStyle = $dffd16657f8ddad5$var$definePartsStyle({
    popper: $dffd16657f8ddad5$var$baseStylePopper,
    content: $dffd16657f8ddad5$var$baseStyleContent,
    header: $dffd16657f8ddad5$var$baseStyleHeader,
    body: $dffd16657f8ddad5$var$baseStyleBody,
    footer: $dffd16657f8ddad5$var$baseStyleFooter,
    closeButton: $dffd16657f8ddad5$var$baseStyleCloseButton
});
var $dffd16657f8ddad5$export$135f12f777be1ef7 = $dffd16657f8ddad5$var$defineMultiStyleConfig({
    baseStyle: $dffd16657f8ddad5$var$baseStyle
});





var { definePartsStyle: $58930da1c1c58005$var$definePartsStyle, defineMultiStyleConfig: $58930da1c1c58005$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$d3f4aaa4b0f2907a).keys);
var $58930da1c1c58005$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("drawer-bg");
var $58930da1c1c58005$var$$bs = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("drawer-box-shadow");
function $58930da1c1c58005$var$getSize(value) {
    if (value === "full") return $58930da1c1c58005$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            h: "100vh"
        }
    });
    return $58930da1c1c58005$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
var $58930da1c1c58005$var$baseStyleOverlay = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
var $58930da1c1c58005$var$baseStyleDialogContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    display: "flex",
    zIndex: "modal",
    justifyContent: "center"
});
var $58930da1c1c58005$var$baseStyleDialog = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isFullHeight: isFullHeight } = props;
    return {
        ...isFullHeight && {
            height: "100vh"
        },
        zIndex: "modal",
        maxH: "100vh",
        color: "inherit",
        [$58930da1c1c58005$var$$bg.variable]: "colors.white",
        [$58930da1c1c58005$var$$bs.variable]: "shadows.lg",
        _dark: {
            [$58930da1c1c58005$var$$bg.variable]: "colors.gray.700",
            [$58930da1c1c58005$var$$bs.variable]: "shadows.dark-lg"
        },
        bg: $58930da1c1c58005$var$$bg.reference,
        boxShadow: $58930da1c1c58005$var$$bs.reference
    };
});
var $58930da1c1c58005$var$baseStyleHeader = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
var $58930da1c1c58005$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
var $58930da1c1c58005$var$baseStyleBody = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "2",
    flex: "1",
    overflow: "auto"
});
var $58930da1c1c58005$var$baseStyleFooter = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
var $58930da1c1c58005$var$baseStyle = $58930da1c1c58005$var$definePartsStyle((props)=>({
        overlay: $58930da1c1c58005$var$baseStyleOverlay,
        dialogContainer: $58930da1c1c58005$var$baseStyleDialogContainer,
        dialog: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($58930da1c1c58005$var$baseStyleDialog, props),
        header: $58930da1c1c58005$var$baseStyleHeader,
        closeButton: $58930da1c1c58005$var$baseStyleCloseButton,
        body: $58930da1c1c58005$var$baseStyleBody,
        footer: $58930da1c1c58005$var$baseStyleFooter
    }));
var $58930da1c1c58005$var$sizes = {
    xs: $58930da1c1c58005$var$getSize("xs"),
    sm: $58930da1c1c58005$var$getSize("md"),
    md: $58930da1c1c58005$var$getSize("lg"),
    lg: $58930da1c1c58005$var$getSize("2xl"),
    xl: $58930da1c1c58005$var$getSize("4xl"),
    full: $58930da1c1c58005$var$getSize("full")
};
var $58930da1c1c58005$export$8057937c11129602 = $58930da1c1c58005$var$defineMultiStyleConfig({
    baseStyle: $58930da1c1c58005$var$baseStyle,
    sizes: $58930da1c1c58005$var$sizes,
    defaultProps: {
        size: "xs"
    }
});


// src/components/editable.ts


var { definePartsStyle: $7166b8ecd8c776bf$var$definePartsStyle, defineMultiStyleConfig: $7166b8ecd8c776bf$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$2813c9511eeab082).keys);
var $7166b8ecd8c776bf$var$baseStylePreview = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal"
});
var $7166b8ecd8c776bf$var$baseStyleInput = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
var $7166b8ecd8c776bf$var$baseStyleTextarea = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
var $7166b8ecd8c776bf$var$baseStyle = $7166b8ecd8c776bf$var$definePartsStyle({
    preview: $7166b8ecd8c776bf$var$baseStylePreview,
    input: $7166b8ecd8c776bf$var$baseStyleInput,
    textarea: $7166b8ecd8c776bf$var$baseStyleTextarea
});
var $7166b8ecd8c776bf$export$a09813cbe72349b1 = $7166b8ecd8c776bf$var$defineMultiStyleConfig({
    baseStyle: $7166b8ecd8c776bf$var$baseStyle
});


// src/components/form-control.ts


var { definePartsStyle: $e4c11848355b4c9a$var$definePartsStyle, defineMultiStyleConfig: $e4c11848355b4c9a$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$4b243e3f209a7e5e).keys);
var $e4c11848355b4c9a$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("form-control-color");
var $e4c11848355b4c9a$var$baseStyleRequiredIndicator = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginStart: "1",
    [$e4c11848355b4c9a$var$$fg.variable]: "colors.red.500",
    _dark: {
        [$e4c11848355b4c9a$var$$fg.variable]: "colors.red.300"
    },
    color: $e4c11848355b4c9a$var$$fg.reference
});
var $e4c11848355b4c9a$var$baseStyleHelperText = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    mt: "2",
    [$e4c11848355b4c9a$var$$fg.variable]: "colors.gray.600",
    _dark: {
        [$e4c11848355b4c9a$var$$fg.variable]: "colors.whiteAlpha.600"
    },
    color: $e4c11848355b4c9a$var$$fg.reference,
    lineHeight: "normal",
    fontSize: "sm"
});
var $e4c11848355b4c9a$var$baseStyle = $e4c11848355b4c9a$var$definePartsStyle({
    container: {
        width: "100%",
        position: "relative"
    },
    requiredIndicator: $e4c11848355b4c9a$var$baseStyleRequiredIndicator,
    helperText: $e4c11848355b4c9a$var$baseStyleHelperText
});
var $e4c11848355b4c9a$export$870bcc1d98fee0aa = $e4c11848355b4c9a$var$defineMultiStyleConfig({
    baseStyle: $e4c11848355b4c9a$var$baseStyle
});


// src/components/form-error.ts


var { definePartsStyle: $e978aa0d645b6189$var$definePartsStyle, defineMultiStyleConfig: $e978aa0d645b6189$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$bb18c440c00e82d9).keys);
var $e978aa0d645b6189$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("form-error-color");
var $e978aa0d645b6189$var$baseStyleText = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$e978aa0d645b6189$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$e978aa0d645b6189$var$$fg.variable]: `colors.red.300`
    },
    color: $e978aa0d645b6189$var$$fg.reference,
    mt: "2",
    fontSize: "sm",
    lineHeight: "normal"
});
var $e978aa0d645b6189$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginEnd: "0.5em",
    [$e978aa0d645b6189$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$e978aa0d645b6189$var$$fg.variable]: `colors.red.300`
    },
    color: $e978aa0d645b6189$var$$fg.reference
});
var $e978aa0d645b6189$var$baseStyle = $e978aa0d645b6189$var$definePartsStyle({
    text: $e978aa0d645b6189$var$baseStyleText,
    icon: $e978aa0d645b6189$var$baseStyleIcon
});
var $e978aa0d645b6189$export$b8d6747e16cd5f4d = $e978aa0d645b6189$var$defineMultiStyleConfig({
    baseStyle: $e978aa0d645b6189$var$baseStyle
});


// src/components/form-label.ts

var $854669f7a332f337$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: "md",
    marginEnd: "3",
    mb: "2",
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "normal",
    opacity: 1,
    _disabled: {
        opacity: 0.4
    }
});
var $854669f7a332f337$export$c49af69dbfc0c993 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $854669f7a332f337$var$baseStyle
});


// src/components/heading.ts

var $7303f6ef3f2c4190$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: "heading",
    fontWeight: "bold"
});
var $7303f6ef3f2c4190$var$sizes = {
    "4xl": (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "6xl",
            null,
            "7xl"
        ],
        lineHeight: 1
    }),
    "3xl": (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "5xl",
            null,
            "6xl"
        ],
        lineHeight: 1
    }),
    "2xl": (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "4xl",
            null,
            "5xl"
        ],
        lineHeight: [
            1.2,
            null,
            1
        ]
    }),
    xl: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "3xl",
            null,
            "4xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "2xl",
            null,
            "3xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "xl",
        lineHeight: 1.2
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "md",
        lineHeight: 1.2
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        lineHeight: 1.2
    })
};
var $7303f6ef3f2c4190$export$5f175074e0f09e7b = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $7303f6ef3f2c4190$var$baseStyle,
    sizes: $7303f6ef3f2c4190$var$sizes,
    defaultProps: {
        size: "xl"
    }
});



// src/components/breadcrumb.ts


var { defineMultiStyleConfig: $025e10043b87c3d1$var$defineMultiStyleConfig, definePartsStyle: $025e10043b87c3d1$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$2fb03f744a6ecf93).keys);
var $025e10043b87c3d1$var$$decor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("breadcrumb-link-decor");
var $025e10043b87c3d1$var$baseStyleLink = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    outline: "none",
    color: "inherit",
    textDecoration: $025e10043b87c3d1$var$$decor.reference,
    [$025e10043b87c3d1$var$$decor.variable]: "none",
    "&:not([aria-current=page])": {
        cursor: "pointer",
        _hover: {
            [$025e10043b87c3d1$var$$decor.variable]: "underline"
        },
        _focusVisible: {
            boxShadow: "outline"
        }
    }
});
var $025e10043b87c3d1$var$baseStyle = $025e10043b87c3d1$var$definePartsStyle({
    link: $025e10043b87c3d1$var$baseStyleLink
});
var $025e10043b87c3d1$export$e2d8c6f6af55009 = $025e10043b87c3d1$var$defineMultiStyleConfig({
    baseStyle: $025e10043b87c3d1$var$baseStyle
});





var $e1e879e804c8177d$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    lineHeight: "1.2",
    borderRadius: "md",
    fontWeight: "semibold",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
        boxShadow: "outline"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        _disabled: {
            bg: "initial"
        }
    }
});
var $e1e879e804c8177d$var$variantGhost = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    if (c === "gray") return {
        color: (0, $6eb225f883147347$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
        _hover: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props)
        },
        _active: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props)
        }
    };
    const darkHoverBg = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.200`, 0.12)(theme);
    const darkActiveBg = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.200`, 0.24)(theme);
    return {
        color: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.600`, `${c}.200`)(props),
        bg: "transparent",
        _hover: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.50`, darkHoverBg)(props)
        },
        _active: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.100`, darkActiveBg)(props)
        }
    };
});
var $e1e879e804c8177d$var$variantOutline = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    const borderColor = (0, $6eb225f883147347$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props);
    return {
        border: "1px solid",
        borderColor: c === "gray" ? borderColor : "currentColor",
        ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": {
            marginEnd: "-1px"
        },
        ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": {
            marginBottom: "-1px"
        },
        ...(0, $245fb38d8179b6d2$export$624e501d81f5ffce)($e1e879e804c8177d$var$variantGhost, props)
    };
});
var $e1e879e804c8177d$var$accessibleColorMap = {
    yellow: {
        bg: "yellow.400",
        color: "black",
        hoverBg: "yellow.500",
        activeBg: "yellow.600"
    },
    cyan: {
        bg: "cyan.400",
        color: "black",
        hoverBg: "cyan.500",
        activeBg: "cyan.600"
    }
};
var $e1e879e804c8177d$var$variantSolid = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    var _a;
    const { colorScheme: c } = props;
    if (c === "gray") {
        const bg2 = (0, $6eb225f883147347$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props);
        return {
            bg: bg2,
            color: (0, $6eb225f883147347$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
            _hover: {
                bg: (0, $6eb225f883147347$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props),
                _disabled: {
                    bg: bg2
                }
            },
            _active: {
                bg: (0, $6eb225f883147347$export$549ff81930776885)(`gray.300`, `whiteAlpha.400`)(props)
            }
        };
    }
    const { bg: bg = `${c}.500`, color: color = "white", hoverBg: hoverBg = `${c}.600`, activeBg: activeBg = `${c}.700` } = (_a = $e1e879e804c8177d$var$accessibleColorMap[c]) != null ? _a : {};
    const background = (0, $6eb225f883147347$export$549ff81930776885)(bg, `${c}.200`)(props);
    return {
        bg: background,
        color: (0, $6eb225f883147347$export$549ff81930776885)(color, `gray.800`)(props),
        _hover: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(hoverBg, `${c}.300`)(props),
            _disabled: {
                bg: background
            }
        },
        _active: {
            bg: (0, $6eb225f883147347$export$549ff81930776885)(activeBg, `${c}.400`)(props)
        }
    };
});
var $e1e879e804c8177d$var$variantLink = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        padding: 0,
        height: "auto",
        lineHeight: "normal",
        verticalAlign: "baseline",
        color: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
        _hover: {
            textDecoration: "underline",
            _disabled: {
                textDecoration: "none"
            }
        },
        _active: {
            color: (0, $6eb225f883147347$export$549ff81930776885)(`${c}.700`, `${c}.500`)(props)
        }
    };
});
var $e1e879e804c8177d$var$variantUnstyled = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "none",
    color: "inherit",
    display: "inline",
    lineHeight: "inherit",
    m: "0",
    p: "0"
});
var $e1e879e804c8177d$var$variants = {
    ghost: $e1e879e804c8177d$var$variantGhost,
    outline: $e1e879e804c8177d$var$variantOutline,
    solid: $e1e879e804c8177d$var$variantSolid,
    link: $e1e879e804c8177d$var$variantLink,
    unstyled: $e1e879e804c8177d$var$variantUnstyled
};
var $e1e879e804c8177d$var$sizes = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "12",
        minW: "12",
        fontSize: "lg",
        px: "6"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "10",
        minW: "10",
        fontSize: "md",
        px: "4"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "8",
        minW: "8",
        fontSize: "sm",
        px: "3"
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "6",
        minW: "6",
        fontSize: "xs",
        px: "2"
    })
};
var $e1e879e804c8177d$export$577deec5d331f6be = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $e1e879e804c8177d$var$baseStyle,
    variants: $e1e879e804c8177d$var$variants,
    sizes: $e1e879e804c8177d$var$sizes,
    defaultProps: {
        variant: "solid",
        size: "md",
        colorScheme: "gray"
    }
});


// src/components/card.ts


var { definePartsStyle: $f3eb9c88b5865555$var$definePartsStyle, defineMultiStyleConfig: $f3eb9c88b5865555$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$487a447ffa5755b6).keys);
var $f3eb9c88b5865555$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-bg");
var $f3eb9c88b5865555$var$$padding = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-padding");
var $f3eb9c88b5865555$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-shadow");
var $f3eb9c88b5865555$var$$radius = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-radius");
var $f3eb9c88b5865555$var$$border = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-border-width", "0");
var $f3eb9c88b5865555$var$$borderColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-border-color");
var $f3eb9c88b5865555$var$baseStyle = $f3eb9c88b5865555$var$definePartsStyle({
    container: {
        [$f3eb9c88b5865555$var$$bg.variable]: "colors.chakra-body-bg",
        backgroundColor: $f3eb9c88b5865555$var$$bg.reference,
        boxShadow: $f3eb9c88b5865555$var$$shadow.reference,
        borderRadius: $f3eb9c88b5865555$var$$radius.reference,
        color: "chakra-body-text",
        borderWidth: $f3eb9c88b5865555$var$$border.reference,
        borderColor: $f3eb9c88b5865555$var$$borderColor.reference
    },
    body: {
        padding: $f3eb9c88b5865555$var$$padding.reference,
        flex: "1 1 0%"
    },
    header: {
        padding: $f3eb9c88b5865555$var$$padding.reference
    },
    footer: {
        padding: $f3eb9c88b5865555$var$$padding.reference
    }
});
var $f3eb9c88b5865555$var$sizes = {
    sm: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$radius.variable]: "radii.base",
            [$f3eb9c88b5865555$var$$padding.variable]: "space.3"
        }
    }),
    md: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$radius.variable]: "radii.md",
            [$f3eb9c88b5865555$var$$padding.variable]: "space.5"
        }
    }),
    lg: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$radius.variable]: "radii.xl",
            [$f3eb9c88b5865555$var$$padding.variable]: "space.7"
        }
    })
};
var $f3eb9c88b5865555$var$variants = {
    elevated: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$shadow.variable]: "shadows.base",
            _dark: {
                [$f3eb9c88b5865555$var$$bg.variable]: "colors.gray.700"
            }
        }
    }),
    outline: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$border.variable]: "1px",
            [$f3eb9c88b5865555$var$$borderColor.variable]: "colors.chakra-border-color"
        }
    }),
    filled: $f3eb9c88b5865555$var$definePartsStyle({
        container: {
            [$f3eb9c88b5865555$var$$bg.variable]: "colors.chakra-subtle-bg"
        }
    }),
    unstyled: {
        body: {
            [$f3eb9c88b5865555$var$$padding.variable]: 0
        },
        header: {
            [$f3eb9c88b5865555$var$$padding.variable]: 0
        },
        footer: {
            [$f3eb9c88b5865555$var$$padding.variable]: 0
        }
    }
};
var $f3eb9c88b5865555$export$880f7b1201440c23 = $f3eb9c88b5865555$var$defineMultiStyleConfig({
    baseStyle: $f3eb9c88b5865555$var$baseStyle,
    variants: $f3eb9c88b5865555$var$variants,
    sizes: $f3eb9c88b5865555$var$sizes,
    defaultProps: {
        variant: "elevated",
        size: "md"
    }
});



// src/components/close-button.ts


var $d29ef2a66290cd2b$var$$size = (0, $591785a32740c673$export$8b4981022bd80a4e)("close-button-size");
var $d29ef2a66290cd2b$var$$bg = (0, $591785a32740c673$export$8b4981022bd80a4e)("close-button-bg");
var $d29ef2a66290cd2b$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    w: [
        $d29ef2a66290cd2b$var$$size.reference
    ],
    h: [
        $d29ef2a66290cd2b$var$$size.reference
    ],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        [$d29ef2a66290cd2b$var$$bg.variable]: "colors.blackAlpha.100",
        _dark: {
            [$d29ef2a66290cd2b$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$d29ef2a66290cd2b$var$$bg.variable]: "colors.blackAlpha.200",
        _dark: {
            [$d29ef2a66290cd2b$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _focusVisible: {
        boxShadow: "outline"
    },
    bg: $d29ef2a66290cd2b$var$$bg.reference
});
var $d29ef2a66290cd2b$var$sizes = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$d29ef2a66290cd2b$var$$size.variable]: "sizes.10",
        fontSize: "md"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$d29ef2a66290cd2b$var$$size.variable]: "sizes.8",
        fontSize: "xs"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$d29ef2a66290cd2b$var$$size.variable]: "sizes.6",
        fontSize: "2xs"
    })
};
var $d29ef2a66290cd2b$export$47615e5b7f7e315f = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $d29ef2a66290cd2b$var$baseStyle,
    sizes: $d29ef2a66290cd2b$var$sizes,
    defaultProps: {
        size: "md"
    }
});




var { variants: $c415241fb2714785$var$variants, defaultProps: $c415241fb2714785$var$defaultProps } = (0, $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b);
var $c415241fb2714785$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: "mono",
    fontSize: "sm",
    px: "0.2em",
    borderRadius: "sm",
    bg: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).bg.reference,
    color: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).color.reference,
    boxShadow: (0, $ef3cdcb3a868c7e9$export$3cb96c9f6c8d16a4).shadow.reference
});
var $c415241fb2714785$export$f9b9a8633a36e3c7 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $c415241fb2714785$var$baseStyle,
    variants: $c415241fb2714785$var$variants,
    defaultProps: $c415241fb2714785$var$defaultProps
});


// src/components/container.ts

var $f407a7e2828f8e3c$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    w: "100%",
    mx: "auto",
    maxW: "prose",
    px: "4"
});
var $f407a7e2828f8e3c$export$3ca0760d240fe5f4 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $f407a7e2828f8e3c$var$baseStyle
});


// src/components/divider.ts

var $67cebb6688951855$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    opacity: 0.6,
    borderColor: "inherit"
});
var $67cebb6688951855$var$variantSolid = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderStyle: "solid"
});
var $67cebb6688951855$var$variantDashed = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderStyle: "dashed"
});
var $67cebb6688951855$var$variants = {
    solid: $67cebb6688951855$var$variantSolid,
    dashed: $67cebb6688951855$var$variantDashed
};
var $67cebb6688951855$export$f0e91f779c5bb416 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $67cebb6688951855$var$baseStyle,
    variants: $67cebb6688951855$var$variants,
    defaultProps: {
        variant: "solid"
    }
});


// src/components/accordion.ts


var { definePartsStyle: $9008cb79ab92d9f9$var$definePartsStyle, defineMultiStyleConfig: $9008cb79ab92d9f9$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$377a77e99e7c73a5).keys);
var $9008cb79ab92d9f9$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderTopWidth: "1px",
    borderColor: "inherit",
    _last: {
        borderBottomWidth: "1px"
    }
});
var $9008cb79ab92d9f9$var$baseStyleButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal",
    fontSize: "md",
    _focusVisible: {
        boxShadow: "outline"
    },
    _hover: {
        bg: "blackAlpha.50"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    px: "4",
    py: "2"
});
var $9008cb79ab92d9f9$var$baseStylePanel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    pt: "2",
    px: "4",
    pb: "5"
});
var $9008cb79ab92d9f9$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: "1.25em"
});
var $9008cb79ab92d9f9$var$baseStyle = $9008cb79ab92d9f9$var$definePartsStyle({
    container: $9008cb79ab92d9f9$var$baseStyleContainer,
    button: $9008cb79ab92d9f9$var$baseStyleButton,
    panel: $9008cb79ab92d9f9$var$baseStylePanel,
    icon: $9008cb79ab92d9f9$var$baseStyleIcon
});
var $9008cb79ab92d9f9$export$20ec2254f76fa604 = $9008cb79ab92d9f9$var$defineMultiStyleConfig({
    baseStyle: $9008cb79ab92d9f9$var$baseStyle
});


// src/components/alert.ts



var { definePartsStyle: $52b5bcd521fcc6de$var$definePartsStyle, defineMultiStyleConfig: $52b5bcd521fcc6de$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$fc51889fa4de265a).keys);
var $52b5bcd521fcc6de$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("alert-fg");
var $52b5bcd521fcc6de$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("alert-bg");
var $52b5bcd521fcc6de$var$baseStyle = $52b5bcd521fcc6de$var$definePartsStyle({
    container: {
        bg: $52b5bcd521fcc6de$var$$bg.reference,
        px: "4",
        py: "3"
    },
    title: {
        fontWeight: "bold",
        lineHeight: "6",
        marginEnd: "2"
    },
    description: {
        lineHeight: "6"
    },
    icon: {
        color: $52b5bcd521fcc6de$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "6"
    },
    spinner: {
        color: $52b5bcd521fcc6de$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "5"
    }
});
function $52b5bcd521fcc6de$var$getBg(props) {
    const { theme: theme, colorScheme: c } = props;
    const darkBg = (0, $a031d15006571f58$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        light: `colors.${c}.100`,
        dark: darkBg
    };
}
var $52b5bcd521fcc6de$var$variantSubtle = $52b5bcd521fcc6de$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $52b5bcd521fcc6de$var$getBg(props);
    return {
        container: {
            [$52b5bcd521fcc6de$var$$fg.variable]: `colors.${c}.600`,
            [$52b5bcd521fcc6de$var$$bg.variable]: bg.light,
            _dark: {
                [$52b5bcd521fcc6de$var$$fg.variable]: `colors.${c}.200`,
                [$52b5bcd521fcc6de$var$$bg.variable]: bg.dark
            }
        }
    };
});
var $52b5bcd521fcc6de$var$variantLeftAccent = $52b5bcd521fcc6de$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $52b5bcd521fcc6de$var$getBg(props);
    return {
        container: {
            [$52b5bcd521fcc6de$var$$fg.variable]: `colors.${c}.600`,
            [$52b5bcd521fcc6de$var$$bg.variable]: bg.light,
            _dark: {
                [$52b5bcd521fcc6de$var$$fg.variable]: `colors.${c}.200`,
                [$52b5bcd521fcc6de$var$$bg.variable]: bg.dark
            },
            paddingStart: "3",
            borderStartWidth: "4px",
            borderStartColor: $52b5bcd521fcc6de$var$$fg.reference
        }
    };
});
var $52b5bcd521fcc6de$var$variantTopAccent = $52b5bcd521fcc6de$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $52b5bcd521fcc6de$var$getBg(props);
    return {
        container: {
            [$52b5bcd521fcc6de$var$$fg.variable]: `colors.${c}.600`,
            [$52b5bcd521fcc6de$var$$bg.variable]: bg.light,
            _dark: {
                [$52b5bcd521fcc6de$var$$fg.variable]: `colors.${c}.200`,
                [$52b5bcd521fcc6de$var$$bg.variable]: bg.dark
            },
            pt: "2",
            borderTopWidth: "4px",
            borderTopColor: $52b5bcd521fcc6de$var$$fg.reference
        }
    };
});
var $52b5bcd521fcc6de$var$variantSolid = $52b5bcd521fcc6de$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        container: {
            [$52b5bcd521fcc6de$var$$fg.variable]: `colors.white`,
            [$52b5bcd521fcc6de$var$$bg.variable]: `colors.${c}.600`,
            _dark: {
                [$52b5bcd521fcc6de$var$$fg.variable]: `colors.gray.900`,
                [$52b5bcd521fcc6de$var$$bg.variable]: `colors.${c}.200`
            },
            color: $52b5bcd521fcc6de$var$$fg.reference
        }
    };
});
var $52b5bcd521fcc6de$var$variants = {
    subtle: $52b5bcd521fcc6de$var$variantSubtle,
    "left-accent": $52b5bcd521fcc6de$var$variantLeftAccent,
    "top-accent": $52b5bcd521fcc6de$var$variantTopAccent,
    solid: $52b5bcd521fcc6de$var$variantSolid
};
var $52b5bcd521fcc6de$export$9d77d9665d829e89 = $52b5bcd521fcc6de$var$defineMultiStyleConfig({
    baseStyle: $52b5bcd521fcc6de$var$baseStyle,
    variants: $52b5bcd521fcc6de$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "blue"
    }
});







var { definePartsStyle: $6d15541177ae209c$var$definePartsStyle, defineMultiStyleConfig: $6d15541177ae209c$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $598f0d250d88319f$export$60f8655d889e17c7).keys);
var $6d15541177ae209c$var$$border = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-border-color");
var $6d15541177ae209c$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-bg");
var $6d15541177ae209c$var$$fs = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-font-size");
var $6d15541177ae209c$var$$size = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-size");
var $6d15541177ae209c$var$baseStyleBadge = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: $6d15541177ae209c$var$$border.reference,
    [$6d15541177ae209c$var$$border.variable]: "white",
    _dark: {
        [$6d15541177ae209c$var$$border.variable]: "colors.gray.800"
    }
});
var $6d15541177ae209c$var$baseStyleExcessLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: $6d15541177ae209c$var$$bg.reference,
    fontSize: $6d15541177ae209c$var$$fs.reference,
    width: $6d15541177ae209c$var$$size.reference,
    height: $6d15541177ae209c$var$$size.reference,
    lineHeight: "1",
    [$6d15541177ae209c$var$$bg.variable]: "colors.gray.200",
    _dark: {
        [$6d15541177ae209c$var$$bg.variable]: "colors.whiteAlpha.400"
    }
});
var $6d15541177ae209c$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { name: name, theme: theme } = props;
    const bg = name ? (0, $a031d15006571f58$export$f3c6ed4330abfc18)({
        string: name
    }) : "colors.gray.400";
    const isBgDark = (0, $a031d15006571f58$export$a79ad82046afa44e)(bg)(theme);
    let color = "white";
    if (!isBgDark) color = "gray.800";
    return {
        bg: $6d15541177ae209c$var$$bg.reference,
        fontSize: $6d15541177ae209c$var$$fs.reference,
        color: color,
        borderColor: $6d15541177ae209c$var$$border.reference,
        verticalAlign: "top",
        width: $6d15541177ae209c$var$$size.reference,
        height: $6d15541177ae209c$var$$size.reference,
        "&:not([data-loaded])": {
            [$6d15541177ae209c$var$$bg.variable]: bg
        },
        [$6d15541177ae209c$var$$border.variable]: "colors.white",
        _dark: {
            [$6d15541177ae209c$var$$border.variable]: "colors.gray.800"
        }
    };
});
var $6d15541177ae209c$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: $6d15541177ae209c$var$$fs.reference,
    lineHeight: "1"
});
var $6d15541177ae209c$var$baseStyle = $6d15541177ae209c$var$definePartsStyle((props)=>({
        badge: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($6d15541177ae209c$var$baseStyleBadge, props),
        excessLabel: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($6d15541177ae209c$var$baseStyleExcessLabel, props),
        container: (0, $245fb38d8179b6d2$export$624e501d81f5ffce)($6d15541177ae209c$var$baseStyleContainer, props),
        label: $6d15541177ae209c$var$baseStyleLabel
    }));
function $6d15541177ae209c$var$getSize(size) {
    const themeSize = size !== "100%" ? (0, $5013d2c172615a00$export$d7d4c689520cc141)[size] : void 0;
    return $6d15541177ae209c$var$definePartsStyle({
        container: {
            [$6d15541177ae209c$var$$size.variable]: themeSize != null ? themeSize : size,
            [$6d15541177ae209c$var$$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
        },
        excessLabel: {
            [$6d15541177ae209c$var$$size.variable]: themeSize != null ? themeSize : size,
            [$6d15541177ae209c$var$$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
        }
    });
}
var $6d15541177ae209c$var$sizes = {
    "2xs": $6d15541177ae209c$var$getSize(4),
    xs: $6d15541177ae209c$var$getSize(6),
    sm: $6d15541177ae209c$var$getSize(8),
    md: $6d15541177ae209c$var$getSize(12),
    lg: $6d15541177ae209c$var$getSize(16),
    xl: $6d15541177ae209c$var$getSize(24),
    "2xl": $6d15541177ae209c$var$getSize(32),
    full: $6d15541177ae209c$var$getSize("100%")
};
var $6d15541177ae209c$export$9975d21893c10e66 = $6d15541177ae209c$var$defineMultiStyleConfig({
    baseStyle: $6d15541177ae209c$var$baseStyle,
    sizes: $6d15541177ae209c$var$sizes,
    defaultProps: {
        size: "md"
    }
});



// src/components/index.ts
var $bb9612a6345bcf43$export$9b5ac10f59f76296 = {
    Accordion: (0, $9008cb79ab92d9f9$export$20ec2254f76fa604),
    Alert: (0, $52b5bcd521fcc6de$export$9d77d9665d829e89),
    Avatar: (0, $6d15541177ae209c$export$9975d21893c10e66),
    Badge: (0, $ef3cdcb3a868c7e9$export$eb6e7cbc82d0f88b),
    Breadcrumb: (0, $025e10043b87c3d1$export$e2d8c6f6af55009),
    Button: (0, $e1e879e804c8177d$export$577deec5d331f6be),
    Checkbox: (0, $3a660172b177ab9e$export$86286d8c37984115),
    CloseButton: (0, $d29ef2a66290cd2b$export$47615e5b7f7e315f),
    Code: (0, $c415241fb2714785$export$f9b9a8633a36e3c7),
    Container: (0, $f407a7e2828f8e3c$export$3ca0760d240fe5f4),
    Divider: (0, $67cebb6688951855$export$f0e91f779c5bb416),
    Drawer: (0, $58930da1c1c58005$export$8057937c11129602),
    Editable: (0, $7166b8ecd8c776bf$export$a09813cbe72349b1),
    Form: (0, $e4c11848355b4c9a$export$870bcc1d98fee0aa),
    FormError: (0, $e978aa0d645b6189$export$b8d6747e16cd5f4d),
    FormLabel: (0, $854669f7a332f337$export$c49af69dbfc0c993),
    Heading: (0, $7303f6ef3f2c4190$export$5f175074e0f09e7b),
    Input: (0, $732b2cb9e8ffdec6$export$b1b9f3bced726e54),
    Kbd: (0, $99ce1a067887b061$export$e193528a501e9a4a),
    Link: (0, $33cdc3a44bd030c6$export$af7f58b96695762e),
    List: (0, $7e7ecde49b12814e$export$ce840f8e8ef752d),
    Menu: (0, $0f90576fb7bd80ad$export$687ce088075ea42b),
    Modal: (0, $3966d8e51ac3bc1e$export$158ae9a07be41c05),
    NumberInput: (0, $57684a561be679fe$export$b9bc5fa6e7f960a1),
    PinInput: (0, $4565c07955136284$export$8504c22c55a552e0),
    Popover: (0, $dffd16657f8ddad5$export$135f12f777be1ef7),
    Progress: (0, $924e305cbcea9b38$export$dc04d8e6a17afea1),
    Radio: (0, $21c6841492ceabf9$export$f0b387b940941887),
    Select: (0, $aba0b22b8ca9eec7$export$21af0fc3c16183e1),
    Skeleton: (0, $6eb62cdac4dee0fa$export$7680371ad2d79142),
    SkipLink: (0, $de81dc100e8decd2$export$a8cf3228ef52959),
    Slider: (0, $8004dd2b97b58653$export$fff8df8fd8e1ed6f),
    Spinner: (0, $a4266c6ac9b1dc5e$export$d76156e68e556d3f),
    Stat: (0, $17b9d17ea3bfb461$export$f3301eb37a20f09e),
    Switch: (0, $994d42e36253a2ed$export$6856b73e98185bff),
    Table: (0, $2a4c99e2adafaa9d$export$3339219781bb5161),
    Tabs: (0, $b12872ed3cae6b5f$export$847a245e7ebce2a1),
    Tag: (0, $8e37595eb187b127$export$f8ab9ac2a319695b),
    Textarea: (0, $db4a338c74752624$export$394b8322fab774c1),
    Tooltip: (0, $fd7519f20c5c0006$export$7472a7883840b563),
    Card: (0, $f3eb9c88b5865555$export$880f7b1201440c23),
    Stepper: (0, $b8eda56a5e8ca863$export$54c84d54375c8d75)
};









































// src/semantic-tokens.ts
var $68f026b4ff22fdd7$export$c1b409c4e1d33fce = {
    colors: {
        "chakra-body-text": {
            _light: "gray.800",
            _dark: "whiteAlpha.900"
        },
        "chakra-body-bg": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-border-color": {
            _light: "gray.200",
            _dark: "whiteAlpha.300"
        },
        "chakra-inverse-text": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-subtle-bg": {
            _light: "gray.100",
            _dark: "gray.700"
        },
        "chakra-subtle-text": {
            _light: "gray.600",
            _dark: "gray.400"
        },
        "chakra-placeholder-color": {
            _light: "gray.500",
            _dark: "whiteAlpha.400"
        }
    }
};


// src/styles.ts
var $052daaab7bc9d2ca$export$9dd6ff9ea0189349 = {
    global: {
        body: {
            fontFamily: "body",
            color: "chakra-body-text",
            bg: "chakra-body-bg",
            transitionProperty: "background-color",
            transitionDuration: "normal",
            lineHeight: "base"
        },
        "*::placeholder": {
            color: "chakra-placeholder-color"
        },
        "*, *::before, &::after": {
            borderColor: "chakra-border-color"
        }
    }
};










// src/index.ts
var $fecf4860da5314d0$var$direction = "ltr";
var $fecf4860da5314d0$var$config = {
    useSystemColorMode: false,
    initialColorMode: "light",
    cssVarPrefix: "chakra"
};
var $fecf4860da5314d0$export$bca14c5b3b88a9c9 = {
    semanticTokens: $68f026b4ff22fdd7$export$c1b409c4e1d33fce,
    direction: $fecf4860da5314d0$var$direction,
    ...(0, $0f31d8688ec7fbf0$export$651a0b7b10dae380),
    components: $bb9612a6345bcf43$export$9b5ac10f59f76296,
    styles: $052daaab7bc9d2ca$export$9dd6ff9ea0189349,
    config: $fecf4860da5314d0$var$config
};
var $fecf4860da5314d0$export$9e955aef208055a6 = {
    semanticTokens: $68f026b4ff22fdd7$export$c1b409c4e1d33fce,
    direction: $fecf4860da5314d0$var$direction,
    components: {},
    ...(0, $0f31d8688ec7fbf0$export$651a0b7b10dae380),
    styles: $052daaab7bc9d2ca$export$9dd6ff9ea0189349,
    config: $fecf4860da5314d0$var$config
};


"use client";
// src/toast.utils.ts
var $13c58346a8d373ae$export$6486ede9e74d7d9d = (arr, id)=>arr.find((toast)=>toast.id === id);
function $13c58346a8d373ae$export$67080b9d5f0a62ea(toasts, id) {
    const position = $13c58346a8d373ae$export$500f52ac46324ec6(toasts, id);
    const index = position ? toasts[position].findIndex((toast)=>toast.id === id) : -1;
    return {
        position: position,
        index: index
    };
}
function $13c58346a8d373ae$export$500f52ac46324ec6(toasts, id) {
    for (const [position, values] of Object.entries(toasts)){
        if ($13c58346a8d373ae$export$6486ede9e74d7d9d(values, id)) return position;
    }
}
var $13c58346a8d373ae$export$795910f5f15a9633 = (toasts, id)=>!!$13c58346a8d373ae$export$500f52ac46324ec6(toasts, id);
function $13c58346a8d373ae$export$27777812cc6d52de(position) {
    const isRighty = position.includes("right");
    const isLefty = position.includes("left");
    let alignItems = "center";
    if (isRighty) alignItems = "flex-end";
    if (isLefty) alignItems = "flex-start";
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: alignItems
    };
}
function $13c58346a8d373ae$export$55dd410e8ef136e0(position) {
    const isTopOrBottom = position === "top" || position === "bottom";
    const margin = isTopOrBottom ? "0 auto" : void 0;
    const top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
    const bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
    const right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
    const left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
    return {
        position: "fixed",
        zIndex: "var(--toast-z-index, 5500)",
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        margin: margin,
        top: top,
        bottom: bottom,
        right: right,
        left: left
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
function $eeeb32c390fb7f0b$export$25bec8c6f54ee79a(callback, deps = []) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    });
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
    }, deps);
}


"use client";
function $3efd861ddab1b905$export$d8e6abf214c9ec0f(callback, delay) {
    const fn = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(callback);
    (0, $acw62.useEffect)(()=>{
        if (delay == null) return void 0;
        let timeoutId = null;
        timeoutId = window.setTimeout(()=>{
            fn();
        }, delay);
        return ()=>{
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [
        delay,
        fn
    ]);
}



var $acw62 = parcelRequire("acw62");
"use client";
function $9af20caeda6fe4e1$export$496315a1608d9602(callback, deps) {
    const renderCycleRef = (0, $acw62.useRef)(false);
    const effectCycleRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const mounted = renderCycleRef.current;
        const run = mounted && effectCycleRef.current;
        if (run) return callback();
        effectCycleRef.current = true;
    }, deps);
    (0, $acw62.useEffect)(()=>{
        renderCycleRef.current = true;
        return ()=>{
            renderCycleRef.current = false;
        };
    }, []);
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $3bbbde5b328b4154$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $acw62 = parcelRequire("acw62");
const $3ce32ada97cfc8f7$export$2285bbca2c666415 = (0, $acw62.createContext)({});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $dba5d94a982c4145$export$f224e4635b6f8ce2 = (0, $acw62.createContext)(null);




var $acw62 = parcelRequire("acw62");
const $784730508f12f72c$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $9c674755a93db746$export$700979bc83e7db82 = (0, $784730508f12f72c$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");
const $410b846e117db9e1$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});



function $7fb0f4644b9cc8ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
    const lazyContext = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171));
    const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $acw62.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $acw62.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const canHandoff = (0, $acw62.useRef)(Boolean(window.HandoffAppearAnimations));
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (canHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $acw62.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!canHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        /**
         * Once we've handed off animations we can delete HandoffAppearAnimations
         * so components added after the initial render can animate changes
         * in useEffect vs useLayoutEffect.
         */ window.HandoffAppearAnimations = undefined;
        canHandoff.current = false;
    });
    return visualElement;
}



var $acw62 = parcelRequire("acw62");
function $d157673547c2a934$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $88efa764bb00537b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $d157673547c2a934$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $acw62 = parcelRequire("acw62");

/**
 * Decides if the supplied variable is variant label
 */ function $a35be4d5814e7c66$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $1e5344c7f0db9c8f$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}



const $0172fb3d3512f551$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $0172fb3d3512f551$export$1405a65085f40b9 = [
    "initial",
    ...$0172fb3d3512f551$export$16e45afcc206d3a8
];


function $06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) {
    return (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(props.animate) || (0, $0172fb3d3512f551$export$1405a65085f40b9).some((name)=>(0, $a35be4d5814e7c66$export$720b90e312cea233)(props[name]));
}
function $06b1046bf0f33e63$export$ce46fa4165cdec40(props) {
    return Boolean($06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $9e57028cf0cad086$export$12fc32fc096a04a3(props, context) {
    if ((0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $a35be4d5814e7c66$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $a35be4d5814e7c66$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $4cb87fa0b981df8c$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $9e57028cf0cad086$export$12fc32fc096a04a3)(props, (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415)));
    return (0, $acw62.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(initial),
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(animate)
    ]);
}
function $4cb87fa0b981df8c$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $a8d82256030e9525$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a8d82256030e9525$export$65570e08d843624d = {};
for(const key in $a8d82256030e9525$var$featureProps)$a8d82256030e9525$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a8d82256030e9525$var$featureProps[key].some((name)=>!!props[name])
};


function $b9879783068c1762$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $a8d82256030e9525$export$65570e08d843624d)[key] = {
        ...(0, $a8d82256030e9525$export$65570e08d843624d)[key],
        ...features[key]
    };
}




var $acw62 = parcelRequire("acw62");
const $4ae202aab5791dbc$export$a3579ca508007a95 = (0, $acw62.createContext)({});




var $acw62 = parcelRequire("acw62");
/**
 * Internal, exported only for usage in Framer
 */ const $c612a166b65a9c69$export$da5f7b802957459a = (0, $acw62.createContext)({});


const $9b94ea54d3350cc1$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b40dad60036091a1$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $b9879783068c1762$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)),
            ...props,
            layoutId: $b40dad60036091a1$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $4cb87fa0b981df8c$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $784730508f12f72c$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7fb0f4644b9cc8ad$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a));
            const isStrict = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $acw62.createElement((0, $3ce32ada97cfc8f7$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $acw62.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $88efa764bb00537b$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $acw62.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $9b94ea54d3350cc1$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $b40dad60036091a1$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $16a09bb264d348bb$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $1d85745fbdd79bfa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $ca4ea6365adee72d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $1d85745fbdd79bfa$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $eced91e16bda42df$export$91ddd985b97788d1 = {};
function $eced91e16bda42df$export$de9e7791c71225fd(correctors) {
    Object.assign($eced91e16bda42df$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $ac502869c4d3e65a$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ac502869c4d3e65a$export$7b42a0094fb00b6e = new Set($ac502869c4d3e65a$export$280dc01950909d86);


function $443c859766df5778$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $eced91e16bda42df$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $55c3387a92452647$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $1724c99b9b724858$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $1724c99b9b724858$var$numTransforms = (0, $ac502869c4d3e65a$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1724c99b9b724858$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $1724c99b9b724858$var$numTransforms; i++){
        const key = (0, $ac502869c4d3e65a$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $1724c99b9b724858$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $f9c5e88311214d2a$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $f9c5e88311214d2a$export$9de1236619d9e756 = $f9c5e88311214d2a$var$checkStringStartsWith("--");
const $f9c5e88311214d2a$export$31f9caa2600b5723 = $f9c5e88311214d2a$var$checkStringStartsWith("var(--");
const $f9c5e88311214d2a$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $a19b1277e1098e3a$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $965bce4b5aab9d94$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $965bce4b5aab9d94$export$58f0f39f63f3cf42 = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    transform: (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $965bce4b5aab9d94$export$dcdf75081b88279d = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $9d068be114f1d873$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $9d068be114f1d873$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $9d068be114f1d873$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $9d068be114f1d873$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $9d068be114f1d873$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $25ca921ba8e55794$var$createUnitType = (unit)=>({
        test: (v)=>(0, $9d068be114f1d873$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $25ca921ba8e55794$export$41fc368e1a942b97 = $25ca921ba8e55794$var$createUnitType("deg");
const $25ca921ba8e55794$export$626336c2cd4b14de = $25ca921ba8e55794$var$createUnitType("%");
const $25ca921ba8e55794$export$91c0eda1d06bf008 = $25ca921ba8e55794$var$createUnitType("px");
const $25ca921ba8e55794$export$f91e8c45a95a32f2 = $25ca921ba8e55794$var$createUnitType("vh");
const $25ca921ba8e55794$export$aed3d7b7d206c196 = $25ca921ba8e55794$var$createUnitType("vw");
const $25ca921ba8e55794$export$44e2e1705876d7ed = {
    ...$25ca921ba8e55794$export$626336c2cd4b14de,
    parse: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.transform(v * 100)
};



const $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: Math.round
};


const $d5c56ef81d4ff9c2$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRightWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    radius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    height: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxHeight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    size: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    top: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    right: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    bottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    left: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    margin: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateZ: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    scale: $965bce4b5aab9d94$export$dcdf75081b88279d,
    scaleX: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleY: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleZ: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    skew: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    distance: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateX: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateY: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    x: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    y: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    z: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    perspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    transformPerspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    opacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    originX: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originY: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    numOctaves: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e)
};


function $a883e7c624291d03$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $a19b1277e1098e3a$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $1724c99b9b724858$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $57bb451bc3d87577$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $81d8dfeeb8038b0d$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $55c3387a92452647$export$605d60a2578142d3)(source[key]) && !(0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $81d8dfeeb8038b0d$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $acw62.useMemo)(()=>{
        const state = (0, $57bb451bc3d87577$export$8940b483cf52eeda)();
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81d8dfeeb8038b0d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81d8dfeeb8038b0d$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $81d8dfeeb8038b0d$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $c4bee6acbf082b7d$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c4bee6acbf082b7d$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || $c4bee6acbf082b7d$var$validMotionProps.has(key);
}


let $05db6db4ebcdf5f1$var$shouldForward = (key)=>!(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key);
function $05db6db4ebcdf5f1$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $05db6db4ebcdf5f1$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $05db6db4ebcdf5f1$export$59d6962c470509a5((parcelRequire("8RYFI")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $05db6db4ebcdf5f1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($05db6db4ebcdf5f1$var$shouldForward(key) || forwardMotionProps === true && (0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || !isDom && !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $acw62 = parcelRequire("acw62");



function $2860344bf6c6c49f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2860344bf6c6c49f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $2860344bf6c6c49f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $2860344bf6c6c49f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $f5fdba1fd96a9ba7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $f5fdba1fd96a9ba7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f5fdba1fd96a9ba7$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $f5fdba1fd96a9ba7$var$dashKeys : $f5fdba1fd96a9ba7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $59f141cfaf6fcabb$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $2860344bf6c6c49f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $f5fdba1fd96a9ba7$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $b7a2547211637b3c$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $57bb451bc3d87577$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $c139bf35362d2174$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $268dc116ac4d3a3d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $acw62.useMemo)(()=>{
        const state = (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9)();
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $81d8dfeeb8038b0d$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $dc80cb5954e76638$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $268dc116ac4d3a3d$export$84309c4f53cb1bd5) : (0, $81d8dfeeb8038b0d$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $05db6db4ebcdf5f1$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $acw62.useMemo)(()=>(0, $55c3387a92452647$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $acw62.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


/**
 * Convert camelCase to dash-case properties.
 */ const $9dc069bda924fd3f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


function $a52b6fc2f3af305f$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $ea3ecc5fb2887a0f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $9422342e44092cf6$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $a8ee53e44f8c4ac8$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $55c3387a92452647$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps.style[key]) || (0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $eac085b45c9e0925$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $55c3387a92452647$export$605d60a2578142d3)(props[key]) || (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $ac502869c4d3e65a$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $acw62 = parcelRequire("acw62");


function $abbf779fde460163$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



var $acw62 = parcelRequire("acw62");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $40f5fd83135889a9$export$fe4300aa8eebea86(init) {
    const ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


const $ef59b2359a289b82$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $21f654501c04362b$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $21f654501c04362b$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $18cbbcef55016eac$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $21f654501c04362b$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $5c26ebcca6422185$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $5c26ebcca6422185$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
        const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
        const make = ()=>$5c26ebcca6422185$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(make);
    };
function $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $448ce039afb5ec07$export$8793edee2d425525 = (any)=>any;


class $f4ac54c83388ba0d$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $f4ac54c83388ba0d$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $f4ac54c83388ba0d$var$Queue();
    let nextFrame = new $f4ac54c83388ba0d$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $d022ffbd5a1b0ae4$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $d022ffbd5a1b0ae4$var$maxElapsed = 40;
function $d022ffbd5a1b0ae4$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $f4ac54c83388ba0d$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $d022ffbd5a1b0ae4$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $d022ffbd5a1b0ae4$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$d022ffbd5a1b0ae4$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $9f96722ff12dbfe7$export$2cef06c20297c17d, cancel: $9f96722ff12dbfe7$export$ec99c0ef4978dccb, state: $9f96722ff12dbfe7$export$fff89137e9e818ce, steps: $9f96722ff12dbfe7$export$be3f796aed065412 } = (0, $d022ffbd5a1b0ae4$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $448ce039afb5ec07$export$8793edee2d425525), true);


const $fde6d634ecc7ed6c$export$44dabd3fae512e85 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $eac085b45c9e0925$export$16da615486abaa45),
        createRenderState: (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).render(()=>{
                (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $dcb38e10dcfb6316$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $a8ee53e44f8c4ac8$export$16da615486abaa45,
        createRenderState: (0, $57bb451bc3d87577$export$8940b483cf52eeda)
    })
};


function $73e3a8d89278ed7b$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $fde6d634ecc7ed6c$export$44dabd3fae512e85) : (0, $dcb38e10dcfb6316$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $dc80cb5954e76638$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $43ace1b5a11c3a40$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $6b2f8b101475710a$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $23ab615c547792c0$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $23ab615c547792c0$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event) && handler(event, $23ab615c547792c0$export$12f84bb882d06e1a(event));
};


function $7fd40e38993f1c69$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(target, eventName, (0, $23ab615c547792c0$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $21841eadb135946f$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $21841eadb135946f$export$a4627e546088548d = (...transformers)=>transformers.reduce($21841eadb135946f$var$combineFunctions);


function $df8cc4eab047d382$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $df8cc4eab047d382$var$globalHorizontalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragHorizontal");
const $df8cc4eab047d382$var$globalVerticalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragVertical");
function $df8cc4eab047d382$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $df8cc4eab047d382$var$globalVerticalLock();
    else if (drag === "x") lock = $df8cc4eab047d382$var$globalHorizontalLock();
    else {
        const openHorizontal = $df8cc4eab047d382$var$globalHorizontalLock();
        const openVertical = $df8cc4eab047d382$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $df8cc4eab047d382$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $df8cc4eab047d382$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $5b9241b1e863e695$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}



function $dfb80d799aa36175$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.type === "touch" || (0, $df8cc4eab047d382$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $dfb80d799aa36175$export$93a81ea037eac456 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)($dfb80d799aa36175$var$addHoverEvent(this.node, true), $dfb80d799aa36175$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $46d14c2f8ccf5da4$export$d4826db40d47595b extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)((0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $ae5289b89bf4fd95$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $ae5289b89bf4fd95$export$e841ada32ff745b(parent, child.parentElement);
};




function $b3902e3e20ea107a$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $23ab615c547792c0$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $b3902e3e20ea107a$export$f026abdbba7f0c9e extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeEndListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            this.removeEndListeners();
            if (this.isPressing) return;
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel } = this.node.getProps();
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !(0, $ae5289b89bf4fd95$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $b3902e3e20ea107a$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $df8cc4eab047d382$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $577133ec08d9e334$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $577133ec08d9e334$var$observers = new WeakMap();
const $577133ec08d9e334$var$fireObserverCallback = (entry)=>{
    const callback = $577133ec08d9e334$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $577133ec08d9e334$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($577133ec08d9e334$var$fireObserverCallback);
};
function $577133ec08d9e334$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$577133ec08d9e334$var$observers.has(lookupRoot)) $577133ec08d9e334$var$observers.set(lookupRoot, {});
    const rootObservers = $577133ec08d9e334$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($577133ec08d9e334$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $577133ec08d9e334$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $577133ec08d9e334$var$initIntersectionObserver(options);
    $577133ec08d9e334$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $577133ec08d9e334$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $3926a5d0685d183c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $3926a5d0685d183c$export$150851c8cc2f0c72 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $3926a5d0685d183c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $577133ec08d9e334$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($3926a5d0685d183c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $3926a5d0685d183c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $5e115984cd871deb$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $3926a5d0685d183c$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $b3902e3e20ea107a$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $46d14c2f8ccf5da4$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $dfb80d799aa36175$export$93a81ea037eac456)
    }
};





function $21ec58272207c53a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $58c1fda9d3891d8d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $58c1fda9d3891d8d$var$getCurrent(visualElement), $58c1fda9d3891d8d$var$getVelocity(visualElement));
}






const $5fd2b57c27674a98$export$ed7b8fa9dbf0105d = "framerAppearId";
const $5fd2b57c27674a98$export$8592e1c077c890a6 = "data-" + (0, $9dc069bda924fd3f$export$9fd24a634729c672)($5fd2b57c27674a98$export$ed7b8fa9dbf0105d);



let $bf99d85f7a843912$export$491112666e282270 = (0, $448ce039afb5ec07$export$8793edee2d425525);
let $bf99d85f7a843912$export$f5708dca728d7177 = (0, $448ce039afb5ec07$export$8793edee2d425525);
var $bf99d85f7a843912$var$check, $bf99d85f7a843912$var$message, $bf99d85f7a843912$var$check1, $bf99d85f7a843912$var$message1;


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $083454c8244247d6$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $083454c8244247d6$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $77818709e1bb6833$export$888a3d84909f9e3d = {
    current: false
};


const $8a5eba8ea233e901$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $877fa42e69510d34$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $877fa42e69510d34$export$2cf569f5e2221176[easing] || (0, $8a5eba8ea233e901$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($877fa42e69510d34$export$fcdd8f3f2160beda));
}
const $877fa42e69510d34$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $877fa42e69510d34$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $877fa42e69510d34$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $8a5eba8ea233e901$export$ff43f99925d7366b)(easing) ? $877fa42e69510d34$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($877fa42e69510d34$export$916ea73bcd3a6030) : $877fa42e69510d34$export$2cf569f5e2221176[easing];
}


function $db913f3e2f893030$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $877fa42e69510d34$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $b7455746a6cabbfe$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $cdee14e408821ec6$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $cdee14e408821ec6$var$subdivisionPrecision = 0.0000001;
const $cdee14e408821ec6$var$subdivisionMaxIterations = 12;
function $cdee14e408821ec6$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $cdee14e408821ec6$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $cdee14e408821ec6$var$subdivisionPrecision && ++i < $cdee14e408821ec6$var$subdivisionMaxIterations);
    return currentT;
}
function $cdee14e408821ec6$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $448ce039afb5ec07$export$8793edee2d425525;
    const getTForX = (aX)=>$cdee14e408821ec6$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $cdee14e408821ec6$var$calcBezier(getTForX(t), mY1, mY2);
}


const $c24ef35c6cea05c0$export$929e5a82286172a6 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $c24ef35c6cea05c0$export$57636bb43b1ccbb0 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $c24ef35c6cea05c0$export$c07234257a03d5e9 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $b8e36ee1e1d53e83$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $6fc2fca13a5370f0$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $daf16ad73b68faf0$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $66a2361fd99a4040$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $66a2361fd99a4040$export$c8d67a19199d1a50 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($66a2361fd99a4040$export$e444123e42d03385);
const $66a2361fd99a4040$export$30d3455eee55bed5 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($66a2361fd99a4040$export$c8d67a19199d1a50);





const $a7ddcde2a4282efd$export$77edfce482316a60 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $a7ddcde2a4282efd$export$b01116c84cdfe1a2 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($a7ddcde2a4282efd$export$77edfce482316a60);
const $a7ddcde2a4282efd$export$ddc5fd596f6c71b2 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($a7ddcde2a4282efd$export$b01116c84cdfe1a2);



const $5e5a5cfe1fa796ef$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $a7ddcde2a4282efd$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $15a4078bfbf4856a$var$easingLookup = {
    linear: (0, $448ce039afb5ec07$export$8793edee2d425525),
    easeIn: $c24ef35c6cea05c0$export$929e5a82286172a6,
    easeInOut: $c24ef35c6cea05c0$export$c07234257a03d5e9,
    easeOut: $c24ef35c6cea05c0$export$57636bb43b1ccbb0,
    circIn: $66a2361fd99a4040$export$e444123e42d03385,
    circInOut: $66a2361fd99a4040$export$30d3455eee55bed5,
    circOut: $66a2361fd99a4040$export$c8d67a19199d1a50,
    backIn: $a7ddcde2a4282efd$export$b01116c84cdfe1a2,
    backInOut: $a7ddcde2a4282efd$export$ddc5fd596f6c71b2,
    backOut: $a7ddcde2a4282efd$export$77edfce482316a60,
    anticipate: $5e5a5cfe1fa796ef$export$6b0af63b873d419e
};
const $15a4078bfbf4856a$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $bf99d85f7a843912$export$f5708dca728d7177)($15a4078bfbf4856a$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $15a4078bfbf4856a$var$easingLookup[definition];
    }
    return definition;
};








/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $ded99e01d9b518c0$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (0, $9d068be114f1d873$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $ded99e01d9b518c0$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $9d068be114f1d873$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $c79d1e7d77418d04$var$clampRgbUnit = (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 255, v);
const $c79d1e7d77418d04$export$7a99c86b5b1f4c9e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: (v)=>Math.round($c79d1e7d77418d04$var$clampRgbUnit(v))
};
const $c79d1e7d77418d04$export$4e46ac54fc82cf3b = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(red) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(green) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $875e9bff470aaa65$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $875e9bff470aaa65$export$834dfc94dde4b3d8 = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("#"),
    parse: $875e9bff470aaa65$var$parseHex,
    transform: (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform
};






const $8bf8a43b3506d305$export$810b04175080204c = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $d8fe6ea9e8bd3d9c$export$35e9368ef982300f = {
    test: (v)=>(0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v) || (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).test(v) || (0, $8bf8a43b3506d305$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v)) return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $8bf8a43b3506d305$export$810b04175080204c).test(v)) return (0, $8bf8a43b3506d305$export$810b04175080204c).parse(v);
        else return (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $9d068be114f1d873$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(v) : (0, $8bf8a43b3506d305$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $70c54e935a247717$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $fd6f5ba04ea8bac3$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue + 1 / 3);
        green = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue);
        blue = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $7691d9e96675321f$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $7691d9e96675321f$var$colorTypes = [
    (0, $875e9bff470aaa65$export$834dfc94dde4b3d8),
    (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b),
    (0, $8bf8a43b3506d305$export$810b04175080204c)
];
const $7691d9e96675321f$var$getColorType = (v)=>$7691d9e96675321f$var$colorTypes.find((type)=>type.test(v));
function $7691d9e96675321f$var$asRGBA(color) {
    const type = $7691d9e96675321f$var$getColorType(color);
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $8bf8a43b3506d305$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $7691d9e96675321f$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $7691d9e96675321f$var$asRGBA(from);
    const toRGBA = $7691d9e96675321f$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(blended);
    };
};












function $b7b50ce2c2d54405$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (((_a = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $9d068be114f1d873$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $b7b50ce2c2d54405$var$cssVarTokeniser = {
    regex: (0, $f9c5e88311214d2a$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $448ce039afb5ec07$export$8793edee2d425525)
};
const $b7b50ce2c2d54405$var$colorTokeniser = {
    regex: (0, $9d068be114f1d873$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).parse
};
const $b7b50ce2c2d54405$var$numberTokeniser = {
    regex: (0, $9d068be114f1d873$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $965bce4b5aab9d94$export$98e628dec113755e).parse
};
function $b7b50ce2c2d54405$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $b7b50ce2c2d54405$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$cssVarTokeniser);
    $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$colorTokeniser);
    $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$numberTokeniser);
    return info;
}
function $b7b50ce2c2d54405$var$parseComplexValue(v) {
    return $b7b50ce2c2d54405$export$b61fc7c44bf646d5(v).values;
}
function $b7b50ce2c2d54405$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $b7b50ce2c2d54405$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($b7b50ce2c2d54405$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($b7b50ce2c2d54405$var$colorTokeniser.token, (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($b7b50ce2c2d54405$var$numberTokeniser.token, (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $b7b50ce2c2d54405$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $b7b50ce2c2d54405$var$getAnimatableNone(v) {
    const parsed = $b7b50ce2c2d54405$var$parseComplexValue(v);
    const transformer = $b7b50ce2c2d54405$var$createTransformer(v);
    return transformer(parsed.map($b7b50ce2c2d54405$var$convertNumbersToZero));
}
const $b7b50ce2c2d54405$export$83a0e34f1302825b = {
    test: $b7b50ce2c2d54405$var$test,
    parse: $b7b50ce2c2d54405$var$parseComplexValue,
    createTransformer: $b7b50ce2c2d54405$var$createTransformer,
    getAnimatableNone: $b7b50ce2c2d54405$var$getAnimatableNone
};


const $6ec69123567a0d66$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $6ec69123567a0d66$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(origin)) return (0, $7691d9e96675321f$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $6ec69123567a0d66$var$mixImmediate(origin, target) : $6ec69123567a0d66$export$65516310a87d8205(origin, target);
}
const $6ec69123567a0d66$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$6ec69123567a0d66$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $6ec69123567a0d66$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $6ec69123567a0d66$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $6ec69123567a0d66$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $21841eadb135946f$export$a4627e546088548d)($6ec69123567a0d66$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $bf99d85f7a843912$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $6ec69123567a0d66$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $3a28fe0c82ae45f8$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $ec602dd05d6627bc$var$mixNumber = (from, to)=>(p)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(from, to, p);
function $ec602dd05d6627bc$var$detectMixerFactory(v) {
    if (typeof v === "number") return $ec602dd05d6627bc$var$mixNumber;
    else if (typeof v === "string") return (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(v) ? (0, $7691d9e96675321f$export$51e568cf5c039bac) : (0, $6ec69123567a0d66$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $6ec69123567a0d66$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $6ec69123567a0d66$export$ebc23b6840c51ba1;
    return $ec602dd05d6627bc$var$mixNumber;
}
function $ec602dd05d6627bc$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $ec602dd05d6627bc$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $448ce039afb5ec07$export$8793edee2d425525) : ease;
            mixer = (0, $21841eadb135946f$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $ec602dd05d6627bc$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $ec602dd05d6627bc$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $a4ecf42dec726852$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $481477152292f1a1$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $a4ecf42dec726852$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $d61eba3ef0284b9c$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c24ef35c6cea05c0$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $b8e36ee1e1d53e83$export$216948827bbdc797)(ease) ? ease.map((0, $15a4078bfbf4856a$export$ef97fe084f156ca4)) : (0, $15a4078bfbf4856a$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $d61eba3ef0284b9c$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $481477152292f1a1$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $acbc43562ac6dbd8$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $8896dd99c5adcd8e$var$velocitySampleDuration = 5; // ms
function $8896dd99c5adcd8e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $8896dd99c5adcd8e$var$velocitySampleDuration, 0);
    return (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $18564078b4b5453e$var$safeMin = 0.001;
const $18564078b4b5453e$export$a3cdb76e84ee608e = 0.01;
const $18564078b4b5453e$export$1824b851fad8862b = 10.0;
const $18564078b4b5453e$export$ff08f2d53484465 = 0.05;
const $18564078b4b5453e$export$201ca48e54038115 = 1;
function $18564078b4b5453e$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $bf99d85f7a843912$export$491112666e282270)(duration <= (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)($18564078b4b5453e$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($18564078b4b5453e$export$ff08f2d53484465, $18564078b4b5453e$export$201ca48e54038115, dampingRatio);
    duration = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($18564078b4b5453e$export$a3cdb76e84ee608e, $18564078b4b5453e$export$1824b851fad8862b, (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $18564078b4b5453e$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $18564078b4b5453e$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $18564078b4b5453e$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$18564078b4b5453e$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $18564078b4b5453e$var$rootIterations = 12;
function $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $18564078b4b5453e$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $74970353647274e4$var$durationKeys = [
    "duration",
    "bounce"
];
const $74970353647274e4$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $74970353647274e4$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $74970353647274e4$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$74970353647274e4$var$isSpringType(options, $74970353647274e4$var$physicsKeys) && $74970353647274e4$var$isSpringType(options, $74970353647274e4$var$durationKeys)) {
        const derived = (0, $18564078b4b5453e$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $74970353647274e4$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $74970353647274e4$var$getSpringOptions(options);
    const initialVelocity = velocity ? -(0, $083454c8244247d6$export$f64c3bfbc58eec0f)(velocity) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $18564078b4b5453e$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $8896dd99c5adcd8e$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $32590f88ff47d1eb$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $74970353647274e4$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $8896dd99c5adcd8e$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $cf38d8859c00efa2$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing ? (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $506ba0ac589a486f$export$f4ff70a5b4808fd8 = 20000;
function $506ba0ac589a486f$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $506ba0ac589a486f$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $506ba0ac589a486f$export$f4ff70a5b4808fd8 ? Infinity : duration;
}


const $f8b512b91d9f08e1$var$types = {
    decay: (0, $32590f88ff47d1eb$export$ee3ff3a17106998),
    inertia: $32590f88ff47d1eb$export$ee3ff3a17106998,
    tween: (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e),
    keyframes: (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e),
    spring: $74970353647274e4$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $f8b512b91d9f08e1$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $cf38d8859c00efa2$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $f8b512b91d9f08e1$var$types[type] || (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     * TODO: Support velocity for units and complex value types/
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $506ba0ac589a486f$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = currentTime / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = Boolean(currentIteration % 2);
            if (iterationIsOdd) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            let p = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress);
            if (currentTime > totalDuration) p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
            elapsed = p * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $506ba0ac589a486f$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



function $af0183976178f4ae$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}




const $132e6771f76a8482$var$supportsWaapi = (0, $af0183976178f4ae$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $132e6771f76a8482$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $132e6771f76a8482$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $132e6771f76a8482$var$maxDuration = 20000;
const $132e6771f76a8482$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $877fa42e69510d34$export$fcdd8f3f2160beda)(options.ease);
function $132e6771f76a8482$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $132e6771f76a8482$var$supportsWaapi() && $132e6771f76a8482$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($132e6771f76a8482$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $132e6771f76a8482$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $132e6771f76a8482$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $132e6771f76a8482$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $db913f3e2f893030$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    /**
     * WAAPI animations don't resolve startTime synchronously. But a blocked
     * thread could delay the startTime resolution by a noticeable amount.
     * For synching handoff animations with the new Motion animation we want
     * to ensure startTime is synchronously set.
     */ if (options.syncStart) animation.startTime = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing ? (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp : document.timeline ? document.timeline.currentTime : performance.now();
    const cancelAnimation = ()=>animation.cancel();
    const safeCancel = ()=>{
        (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set((0, $b7455746a6cabbfe$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $448ce039afb5ec07$export$8793edee2d425525;
        },
        get time () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $132e6771f76a8482$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $132e6771f76a8482$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>animation.finish(),
        cancel: safeCancel
    };
    return controls;
}




function $8aad9a13037709d9$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $448ce039afb5ec07$export$8793edee2d425525),
            pause: (0, $448ce039afb5ec07$export$8793edee2d425525),
            stop: (0, $448ce039afb5ec07$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $448ce039afb5ec07$export$8793edee2d425525),
            complete: (0, $448ce039afb5ec07$export$8793edee2d425525)
        };
    };
    return delay ? (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $5f1d5ca1d398e82d$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $5f1d5ca1d398e82d$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $5f1d5ca1d398e82d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $5f1d5ca1d398e82d$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $5f1d5ca1d398e82d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $5f1d5ca1d398e82d$var$keyframesTransition;
    else if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $5f1d5ca1d398e82d$var$criticallyDampedSpring(keyframes[1]) : $5f1d5ca1d398e82d$var$underDampedSpring;
    return $5f1d5ca1d398e82d$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ef4086713d7b0bdb$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $c55938f2e5f09a1e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c55938f2e5f09a1e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $9d068be114f1d873$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c55938f2e5f09a1e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c55938f2e5f09a1e$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $c55938f2e5f09a1e$export$3dea766d36a8935f = {
    ...(0, $b7b50ce2c2d54405$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($c55938f2e5f09a1e$var$functionRegex);
        return functions ? functions.map($c55938f2e5f09a1e$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb = {
    ...(0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b),
    color: // Color props
    $d8fe6ea9e8bd3d9c$export$35e9368ef982300f,
    backgroundColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    outlineColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    fill: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    stroke: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderTopColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderRightColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderBottomColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderLeftColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    filter: $c55938f2e5f09a1e$export$3dea766d36a8935f,
    WebkitFilter: (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $6da1de6e0a9a8c9d$export$67d1babe0338d23b = (key)=>$6da1de6e0a9a8c9d$export$98cd7c72c5a731fb[key];


function $ca0a3798777df465$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)) defaultValueType = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $933209bc9c035719$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $e0feaef7a76d9154$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value);
}


function $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $e0feaef7a76d9154$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $9e7a9f8af70c9aa6$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $ec9bae3b9c638c7a$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $bf99d85f7a843912$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $5f1d5ca1d398e82d$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $77818709e1bb6833$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $8aad9a13037709d9$export$6f34fc8ef6c42b70)((0, $77818709e1bb6833$export$888a3d84909f9e3d).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (value.owner && value.owner.current instanceof HTMLElement && !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $132e6771f76a8482$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)(options);
    };
};



function $d94f283b675f700d$export$98397f3adbf6259f(value) {
    return Boolean((0, $55c3387a92452647$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $d56714d1e4e43615$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);




function $f9c6cc6428ae273c$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $f9c6cc6428ae273c$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $f9c6cc6428ae273c$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $ad746ac6e5aa4783$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}





const $e32104bb79321603$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $e32104bb79321603$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $e32104bb79321603$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.16.4";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $e32104bb79321603$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($e32104bb79321603$export$67fcd818a264039d.current) $e32104bb79321603$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $e32104bb79321603$export$ce8bdc721e76545f(init, options) {
    return new $e32104bb79321603$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $a1e2618328995be8$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $c231a4375b038d3c$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $a90ec5e4ad59372f$export$d176691c1998a1f5 = [
    (0, $965bce4b5aab9d94$export$98e628dec113755e),
    (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    (0, $25ca921ba8e55794$export$626336c2cd4b14de),
    (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    (0, $25ca921ba8e55794$export$aed3d7b7d206c196),
    (0, $25ca921ba8e55794$export$f91e8c45a95a32f2),
    (0, $c231a4375b038d3c$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a90ec5e4ad59372f$export$eefdd52e3ccae428 = (v)=>$a90ec5e4ad59372f$export$d176691c1998a1f5.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $0bb49f6c51badae3$var$valueTypes = [
    ...(0, $a90ec5e4ad59372f$export$d176691c1998a1f5),
    (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    (0, $b7b50ce2c2d54405$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $0bb49f6c51badae3$export$950e7e59ea1ffed7 = (v)=>$0bb49f6c51badae3$var$valueTypes.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ea04fe669600292a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value));
}
function $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $21f654501c04362b$export$5485128c47bd48bb)(target[key]);
        $ea04fe669600292a$var$setMotionValue(visualElement, key, value);
    }
}
function $ea04fe669600292a$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $ea04fe669600292a$var$setVariants(child, variantLabels);
        });
    });
}
function $ea04fe669600292a$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $ea04fe669600292a$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $ea04fe669600292a$var$setVariants(visualElement, [
        definition
    ]);
    else $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition);
}
function $ea04fe669600292a$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $d56714d1e4e43615$export$65583ed5a868f2d9)(value) || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $0bb49f6c51badae3$export$950e7e59ea1ffed7)(value) && (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(targetValue)) value = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $ea04fe669600292a$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $ea04fe669600292a$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $ea04fe669600292a$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $14d5e29c1a7af8ca$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $14d5e29c1a7af8ca$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $14d5e29c1a7af8ca$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...transition
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $5fd2b57c27674a98$export$8592e1c077c890a6];
            if (appearId) {
                valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $9f96722ff12dbfe7$export$2cef06c20297c17d));
                valueTransition.syncStart = true;
            }
        }
        value.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $ea04fe669600292a$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}




function $697c3fc694c39c2d$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($697c3fc694c39c2d$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($697c3fc694c39c2d$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $697c3fc694c39c2d$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $7d7d5f8a14d3a662$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $351ff45a987b08cc$var$reversePriorityOrder = [
    ...(0, $0172fb3d3512f551$export$16e45afcc206d3a8)
].reverse();
const $351ff45a987b08cc$var$numAnimationTypes = (0, $0172fb3d3512f551$export$16e45afcc206d3a8).length;
function $351ff45a987b08cc$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $7d7d5f8a14d3a662$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $351ff45a987b08cc$export$bb53502b7a672aa8(visualElement) {
    let animate = $351ff45a987b08cc$var$animateList(visualElement);
    const state = $351ff45a987b08cc$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $351ff45a987b08cc$var$numAnimationTypes; i++){
            const type = $351ff45a987b08cc$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $a35be4d5814e7c66$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $351ff45a987b08cc$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(next) && (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $351ff45a987b08cc$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $351ff45a987b08cc$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $351ff45a987b08cc$var$createState() {
    return {
        animate: $351ff45a987b08cc$var$createTypeState(true),
        whileInView: $351ff45a987b08cc$var$createTypeState(),
        whileHover: $351ff45a987b08cc$var$createTypeState(),
        whileTap: $351ff45a987b08cc$var$createTypeState(),
        whileDrag: $351ff45a987b08cc$var$createTypeState(),
        whileFocus: $351ff45a987b08cc$var$createTypeState(),
        exit: $351ff45a987b08cc$var$createTypeState()
    };
}



class $bfc36aed86970b83$export$b45b3fe5caabdca extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $351ff45a987b08cc$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $7ad505f20eee7073$var$id = 0;
class $7ad505f20eee7073$export$4989d1eb6104cc6c extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $7ad505f20eee7073$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $03e8b675a1009b68$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bfc36aed86970b83$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $7ad505f20eee7073$export$4989d1eb6104cc6c)
    }
};









const $8eeaeb5692ba8175$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8eeaeb5692ba8175$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $2bb1a5b2e1002b2e$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $2bb1a5b2e1002b2e$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $8eeaeb5692ba8175$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $2bb1a5b2e1002b2e$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event)) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = (0, $23ab615c547792c0$export$12f84bb882d06e1a)(event);
        const initialInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $2bb1a5b2e1002b2e$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $21841eadb135946f$export$a4627e546088548d)((0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $2bb1a5b2e1002b2e$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $2bb1a5b2e1002b2e$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $2bb1a5b2e1002b2e$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$lastDevicePoint(history)),
        offset: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$startDevicePoint(history)),
        velocity: $2bb1a5b2e1002b2e$var$getVelocity(history, 0.1)
    };
}
function $2bb1a5b2e1002b2e$var$startDevicePoint(history) {
    return history[0];
}
function $2bb1a5b2e1002b2e$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $2bb1a5b2e1002b2e$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $2bb1a5b2e1002b2e$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $b352f7cdd42c49d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b352f7cdd42c49d7$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $b352f7cdd42c49d7$export$c1c127004b72a37(target) / $b352f7cdd42c49d7$export$c1c127004b72a37(source);
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $b352f7cdd42c49d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $b352f7cdd42c49d7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(relative);
}
function $b352f7cdd42c49d7$export$426154f9d100f99(target, relative, parent) {
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(layout);
}
function $b352f7cdd42c49d7$export$2785bfcc929c5650(target, layout, parent) {
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $2df0cf7aa8fef8fc$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $2df0cf7aa8fef8fc$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.x, left, right),
        y: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $2df0cf7aa8fef8fc$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $2df0cf7aa8fef8fc$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(source);
    const targetLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $2df0cf7aa8fef8fc$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22(dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    return {
        x: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $a3727e4e12b23353$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a3727e4e12b23353$export$3d227df54007d73a = ()=>({
        x: $a3727e4e12b23353$export$ff25708b37f72782(),
        y: $a3727e4e12b23353$export$ff25708b37f72782()
    });
const $a3727e4e12b23353$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a3727e4e12b23353$export$6459fc9e86be362e = ()=>({
        x: $a3727e4e12b23353$export$6db76765312617ac(),
        y: $a3727e4e12b23353$export$6db76765312617ac()
    });


function $247f90d2510fbc55$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0e0401fe38bd0bd1$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0e0401fe38bd0bd1$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0e0401fe38bd0bd1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $fe0ee806cd19fc1f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fe0ee806cd19fc1f$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fe0ee806cd19fc1f$var$isIdentityScale(scale) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleX) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleY);
}
function $fe0ee806cd19fc1f$export$a545127cf1fbb600(values) {
    return $fe0ee806cd19fc1f$export$bdf30dca883ea463(values) || $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) {
    return $fe0ee806cd19fc1f$var$is2DTranslate(values.x) || $fe0ee806cd19fc1f$var$is2DTranslate(values.y);
}
function $fe0ee806cd19fc1f$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d8332eb74969584e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d8332eb74969584e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d8332eb74969584e$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d8332eb74969584e$export$d80074982803af5c(box, { x: x, y: y }) {
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d8332eb74969584e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d8332eb74969584e$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d8332eb74969584e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) $d8332eb74969584e$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $d8332eb74969584e$var$snapToDefault(treeScale.x);
    treeScale.y = $d8332eb74969584e$var$snapToDefault(treeScale.y);
}
function $d8332eb74969584e$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $d8332eb74969584e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d8332eb74969584e$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d8332eb74969584e$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $d8332eb74969584e$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $d8332eb74969584e$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d8332eb74969584e$export$58b16271041fbfb(box, transform) {
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.x, transform, $d8332eb74969584e$var$xKeys);
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.y, transform, $d8332eb74969584e$var$yKeys);
}


function $4ca2f8055771ddf4$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)((0, $0e0401fe38bd0bd1$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $4ca2f8055771ddf4$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $4ca2f8055771ddf4$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}










const $59924ee873defaad$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $59924ee873defaad$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $23ab615c547792c0$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $df8cc4eab047d382$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $59924ee873defaad$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const { layout: layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $2df0cf7aa8fef8fc$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $d157673547c2a934$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $4ca2f8055771ddf4$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $2df0cf7aa8fef8fc$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $0e0401fe38bd0bd1$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $2df0cf7aa8fef8fc$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $59924ee873defaad$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $2df0cf7aa8fef8fc$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $59924ee873defaad$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $59924ee873defaad$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $abae7830ca84eed8$export$5d97dc2872682820 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.controls = new (0, $59924ee873defaad$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}







const $d43ff984f7bd7f1a$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint()
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanSessionStart),
            onStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $bc77fac60b5d77cc$export$2a8c16d82a0a0e26() {
    const context = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $acw62.useId)();
    (0, $acw62.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $bc77fac60b5d77cc$export$8249053f690ea39a() {
    return $bc77fac60b5d77cc$export$ee27c052bca048fb((0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2)));
}
function $bc77fac60b5d77cc$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $b29dc04080b74d0c$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $967b202c839557ef$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $967b202c839557ef$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $967b202c839557ef$export$fafff692be55225d(latest, node.target.x);
        const y = $967b202c839557ef$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $a42cd9e0ef50cb70$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};




class $cdf2a2ac04e7ce67$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $eced91e16bda42df$export$de9e7791c71225fd)($cdf2a2ac04e7ce67$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $cdf2a2ac04e7ce67$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cdf2a2ac04e7ce67$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $cdf2a2ac04e7ce67$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $967b202c839557ef$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    boxShadow: (0, $a42cd9e0ef50cb70$export$eb0bc629e74dcf8)
};








const $82b1c16a20b13fa0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $82b1c16a20b13fa0$var$numBorders = $82b1c16a20b13fa0$var$borders.length;
const $82b1c16a20b13fa0$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $82b1c16a20b13fa0$var$isPx = (value)=>typeof value === "number" || (0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(value);
function $82b1c16a20b13fa0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $82b1c16a20b13fa0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $82b1c16a20b13fa0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $82b1c16a20b13fa0$var$numBorders; i++){
        const borderLabel = `border${$82b1c16a20b13fa0$var$borders[i]}Radius`;
        let followRadius = $82b1c16a20b13fa0$var$getRadius(follow, borderLabel);
        let leadRadius = $82b1c16a20b13fa0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $82b1c16a20b13fa0$var$isPx(followRadius) === $82b1c16a20b13fa0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $70c54e935a247717$export$2c9e8a9632a706b2)($82b1c16a20b13fa0$var$asNumber(followRadius), $82b1c16a20b13fa0$var$asNumber(leadRadius), progress), 0);
            if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(leadRadius) || (0, $25ca921ba8e55794$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $82b1c16a20b13fa0$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $82b1c16a20b13fa0$var$easeCrossfadeIn = $82b1c16a20b13fa0$var$compress(0, 0.5, (0, $66a2361fd99a4040$export$c8d67a19199d1a50));
const $82b1c16a20b13fa0$var$easeCrossfadeOut = $82b1c16a20b13fa0$var$compress(0.5, 0.95, (0, $448ce039afb5ec07$export$8793edee2d425525));
function $82b1c16a20b13fa0$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$c53fd88f45d77e4b(box, originBox) {
    $5960d81994414d5a$export$a0230ae482601ae8(box.x, originBox.x);
    $5960d81994414d5a$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $db628fcc785b8b87$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $db628fcc785b8b87$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $db628fcc785b8b87$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $db628fcc785b8b87$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $db628fcc785b8b87$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.x, transforms, $db628fcc785b8b87$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.y, transforms, $db628fcc785b8b87$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $b070f9c5f268d45c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $b070f9c5f268d45c$export$a7ec7642fe550fb6(delta) {
    return $b070f9c5f268d45c$var$isAxisDeltaZero(delta.x) && $b070f9c5f268d45c$var$isAxisDeltaZero(delta.y);
}
function $b070f9c5f268d45c$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $b070f9c5f268d45c$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $b070f9c5f268d45c$export$c5706146bc63213(box) {
    return (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.x) / (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.y);
}



class $a040ab986103db06$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $0214cdf9d4bb801d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $8e214807702da081$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $e21f5e6c9473a18c$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $8e214807702da081$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $fab50a206e6cc096$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(checkElapsed);
}



function $0b58405220d0640d$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $c4715fe9f944e8b8$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $f5de8fc8cd768a38$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value : (0, $e32104bb79321603$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





const $d2ca41ba1b84bcfe$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $d2ca41ba1b84bcfe$var$animationTarget = 1000;
let $d2ca41ba1b84bcfe$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $d2ca41ba1b84bcfe$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $d2ca41ba1b84bcfe$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $d2ca41ba1b84bcfe$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $d2ca41ba1b84bcfe$var$projectionFrameData.totalNodes = $d2ca41ba1b84bcfe$var$projectionFrameData.resolvedTargetDeltas = $d2ca41ba1b84bcfe$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($d2ca41ba1b84bcfe$export$131f2f0cc5fe9609);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$resolveTargetDelta);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$calcProjection);
                this.nodes.forEach($d2ca41ba1b84bcfe$export$c2664f37bc951031);
                (0, $0b58405220d0640d$export$e5185e241753e543)($d2ca41ba1b84bcfe$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e21f5e6c9473a18c$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $c4715fe9f944e8b8$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $fab50a206e6cc096$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($d2ca41ba1b84bcfe$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $d2ca41ba1b84bcfe$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $b070f9c5f268d45c$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $ec9bae3b9c638c7a$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $d2ca41ba1b84bcfe$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($d2ca41ba1b84bcfe$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($d2ca41ba1b84bcfe$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($d2ca41ba1b84bcfe$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($d2ca41ba1b84bcfe$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($d2ca41ba1b84bcfe$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).delta = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp);
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp = now;
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing = true;
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).update.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).preRender.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).render.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($d2ca41ba1b84bcfe$var$clearSnapshot);
            this.sharedNodes.forEach($d2ca41ba1b84bcfe$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $d2ca41ba1b84bcfe$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $b352f7cdd42c49d7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d8332eb74969584e$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $d2ca41ba1b84bcfe$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d8332eb74969584e$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $d2ca41ba1b84bcfe$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d2ca41ba1b84bcfe$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $82b1c16a20b13fa0$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>{
                (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $f5de8fc8cd768a38$export$335a17c977067b99)(0, $d2ca41ba1b84bcfe$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($d2ca41ba1b84bcfe$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const xLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d8332eb74969584e$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $a040ab986103db06$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $d2ca41ba1b84bcfe$var$transformAxes.length; i++){
                const key = "rotate" + $d2ca41ba1b84bcfe$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $eced91e16bda42df$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $eced91e16bda42df$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $d2ca41ba1b84bcfe$var$updateLayout(node) {
    node.updateLayout();
}
function $d2ca41ba1b84bcfe$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        if (isShared) (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $b070f9c5f268d45c$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d2ca41ba1b84bcfe$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $d2ca41ba1b84bcfe$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $d2ca41ba1b84bcfe$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $d2ca41ba1b84bcfe$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d2ca41ba1b84bcfe$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d2ca41ba1b84bcfe$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $d2ca41ba1b84bcfe$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $d2ca41ba1b84bcfe$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $d2ca41ba1b84bcfe$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d2ca41ba1b84bcfe$var$calcProjection(node) {
    node.calcProjection();
}
function $d2ca41ba1b84bcfe$var$resetRotation(node) {
    node.resetRotation();
}
function $d2ca41ba1b84bcfe$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(output, from, to, p) {
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d2ca41ba1b84bcfe$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $d2ca41ba1b84bcfe$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $d2ca41ba1b84bcfe$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $d2ca41ba1b84bcfe$var$roundPoint = $d2ca41ba1b84bcfe$var$userAgentContains("applewebkit/") && !$d2ca41ba1b84bcfe$var$userAgentContains("chrome/") ? Math.round : (0, $448ce039afb5ec07$export$8793edee2d425525);
function $d2ca41ba1b84bcfe$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $d2ca41ba1b84bcfe$var$roundPoint(axis.min);
    axis.max = $d2ca41ba1b84bcfe$var$roundPoint(axis.max);
}
function $d2ca41ba1b84bcfe$var$roundBox(box) {
    $d2ca41ba1b84bcfe$var$roundAxis(box.x);
    $d2ca41ba1b84bcfe$var$roundAxis(box.y);
}
function $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $b352f7cdd42c49d7$export$28d0384c4b79bde2)((0, $b070f9c5f268d45c$export$c5706146bc63213)(snapshot), (0, $b070f9c5f268d45c$export$c5706146bc63213)(layout), 0.2);
}




const $6e97f3a9a89d5fc1$export$2d029a49a09b6177 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $a3289660bde9b219$export$b91509fcf893b648 = {
    current: undefined
};
const $a3289660bde9b219$export$b61a9eb3dbde8858 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$a3289660bde9b219$export$b91509fcf893b648.current) {
            const documentNode = new (0, $6e97f3a9a89d5fc1$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a3289660bde9b219$export$b91509fcf893b648.current = documentNode;
        }
        return $a3289660bde9b219$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $fc1974bcfc4fde1a$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $abae7830ca84eed8$export$5d97dc2872682820),
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};













/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ac0e5a3978f40f61$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current) {
    const match = $ac0e5a3978f40f61$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $ac0e5a3978f40f61$var$maxDepth = 4;
function $ac0e5a3978f40f61$var$getVariableValue(current, element, depth = 1) {
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(depth <= $ac0e5a3978f40f61$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $d56714d1e4e43615$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, $f9c5e88311214d2a$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $ac0e5a3978f40f61$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $ac0e5a3978f40f61$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $f9c5e88311214d2a$export$31f9caa2600b5723)(current)) return;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $f9c5e88311214d2a$export$31f9caa2600b5723)(current)) continue;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $a731b8aa4fe311d9$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $a731b8aa4fe311d9$var$isPositionalKey = (key)=>$a731b8aa4fe311d9$var$positionalKeys.has(key);
const $a731b8aa4fe311d9$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($a731b8aa4fe311d9$var$isPositionalKey);
};
const $a731b8aa4fe311d9$var$isNumOrPxType = (v)=>v === (0, $965bce4b5aab9d94$export$98e628dec113755e) || v === (0, $25ca921ba8e55794$export$91c0eda1d06bf008);
const $a731b8aa4fe311d9$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $a731b8aa4fe311d9$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $a731b8aa4fe311d9$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $a731b8aa4fe311d9$var$nonTranslationalTransformKeys = (0, $ac502869c4d3e65a$export$280dc01950909d86).filter((key)=>!$a731b8aa4fe311d9$var$transformKeys.has(key));
function $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $a731b8aa4fe311d9$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $a731b8aa4fe311d9$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $a731b8aa4fe311d9$var$getTranslateFromMatrix(4, 13),
    y: $a731b8aa4fe311d9$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateX = $a731b8aa4fe311d9$export$781d46a8aa670d52.x;
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateY = $a731b8aa4fe311d9$export$781d46a8aa670d52.y;
const $a731b8aa4fe311d9$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($a731b8aa4fe311d9$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]);
                    (0, $bf99d85f7a843912$export$f5708dca728d7177)(toType === fromType || $a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $bf99d85f7a843912$export$f5708dca728d7177)((0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $25ca921ba8e55794$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $a731b8aa4fe311d9$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $784730508f12f72c$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $a731b8aa4fe311d9$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $a731b8aa4fe311d9$var$hasPositionalKey(target) ? $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $d9a589b84d5ec1d1$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $ac0e5a3978f40f61$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $a731b8aa4fe311d9$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};






// Does this device prefer reduced motion? Returns `null` server-side.
const $5d1c3a7750a03ec7$export$ff7706047246b98b = {
    current: null
};
const $5d1c3a7750a03ec7$export$6476d16e2fd2d0db = {
    current: false
};


function $402b11b96c54cb2c$export$ca9f41fb23dded3d() {
    (0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current = true;
    if (!(0, $784730508f12f72c$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = false;
}














function $69635cdb8982f9d2$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $55c3387a92452647$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $a4ccbde0d696dfdf$export$bc2a978a17abfdde = new WeakMap();



const $e66750f3fb0f96bb$var$featureNames = Object.keys((0, $a8d82256030e9525$export$65570e08d843624d));
const $e66750f3fb0f96bb$var$numFeatures = $e66750f3fb0f96bb$var$featureNames.length;
const $e66750f3fb0f96bb$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $e66750f3fb0f96bb$var$numVariantProps = (0, $0172fb3d3512f551$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $e66750f3fb0f96bb$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $55c3387a92452647$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $a4ccbde0d696dfdf$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current) (0, $402b11b96c54cb2c$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $a4ccbde0d696dfdf$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $e66750f3fb0f96bb$var$numFeatures; i++){
            const name = $e66750f3fb0f96bb$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $a8d82256030e9525$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $e66750f3fb0f96bb$var$propEventHandlers.length; i++){
            const key = $e66750f3fb0f96bb$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $69635cdb8982f9d2$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $e66750f3fb0f96bb$var$numVariantProps; i++){
            const name = (0, $0172fb3d3512f551$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $a35be4d5814e7c66$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $e32104bb79321603$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $55c3387a92452647$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $28a1ebc4c0bc036f$export$e49735c2a366bdc7 extends (0, $e66750f3fb0f96bb$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $ea04fe669600292a$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $ea04fe669600292a$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $d9a589b84d5ec1d1$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $bce82b8bf0dbf6b7$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $bce82b8bf0dbf6b7$export$23fea75b03ac16b3 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $bce82b8bf0dbf6b7$export$3735103072e4a80(instance);
            const value = ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $4ca2f8055771ddf4$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $a0798b9f9973cb35$export$86bcdffbaf733d84 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $eac085b45c9e0925$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $2f8881102ac6dde9$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? new (0, $a0798b9f9973cb35$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $bce82b8bf0dbf6b7$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $2c407ffdaf3c120a$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};


const $a93b6401f922fd1e$var$preloadedFeatures = {
    ...(0, $03e8b675a1009b68$export$7f9953c70dacfd7f),
    ...(0, $5e115984cd871deb$export$e5b72898e5a201f1),
    ...(0, $fc1974bcfc4fde1a$export$d7d5d435647ed5a0),
    ...(0, $2c407ffdaf3c120a$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $a93b6401f922fd1e$export$e25e478948902b8b = /*@__PURE__*/ (0, $16a09bb264d348bb$export$a28d6df673050e18)((Component, config)=>(0, $73e3a8d89278ed7b$export$732916c0e88175fb)(Component, config, $a93b6401f922fd1e$var$preloadedFeatures, (0, $2f8881102ac6dde9$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $a93b6401f922fd1e$export$546614c4a05701f9(key) {
    return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)((0, $73e3a8d89278ed7b$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $a93b6401f922fd1e$var$preloadedFeatures, (0, $2f8881102ac6dde9$export$56ba0183203348f5)));
}



"use client";
var $f041f5bc425d9240$var$allPropNames = /* @__PURE__ */ new Set([
    ...(0, $47a6d9fbbf7ee42d$export$332cc7004bcbb8b4),
    "textStyle",
    "layerStyle",
    "apply",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
]);
var $f041f5bc425d9240$var$validHTMLProps = /* @__PURE__ */ new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize",
    "htmlTranslate"
]);
function $f041f5bc425d9240$export$3ba67b570e26eea0(prop) {
    return $f041f5bc425d9240$var$validHTMLProps.has(prop) || !$f041f5bc425d9240$var$allPropNames.has(prop);
}





// src/assign-after.ts
function $497654f4cc41b610$export$1ab078c80230a125(target, ...sources) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    const result = {
        ...target
    };
    for (const nextSource of sources){
        if (nextSource == null) continue;
        for(const nextKey in nextSource){
            if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey)) continue;
            if (nextKey in result) delete result[nextKey];
            result[nextKey] = nextSource[nextKey];
        }
    }
    return result;
}




var $acw62 = parcelRequire("acw62");

// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});






var $60e97af874e8cdaa$var$testOmitPropsOnStringTag = (0, $bcd4e42ca4163639$export$2e2bcd8739ae039);
var $60e97af874e8cdaa$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $60e97af874e8cdaa$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $60e97af874e8cdaa$var$testOmitPropsOnStringTag : $60e97af874e8cdaa$var$testOmitPropsOnComponent;
};
var $60e97af874e8cdaa$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $60e97af874e8cdaa$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $60e97af874e8cdaa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $5f1e384d41b6dbd9$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $1b59f2f50af460c0$export$db21c7ffa21794e7)(function() {
        return (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $60e97af874e8cdaa$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $60e97af874e8cdaa$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $60e97af874e8cdaa$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7));
            }
            if (typeof props.className === "string") className = (0, $5f1e384d41b6dbd9$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $60e97af874e8cdaa$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($60e97af874e8cdaa$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $60e97af874e8cdaa$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};



parcelRequire("acw62");





var $12ab803fa905d303$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $12ab803fa905d303$export$2e2bcd8739ae039 = (0, $60e97af874e8cdaa$export$2e2bcd8739ae039).bind();
$12ab803fa905d303$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $12ab803fa905d303$export$2e2bcd8739ae039[tagName] = $12ab803fa905d303$export$2e2bcd8739ae039(tagName);
});



var $acw62 = parcelRequire("acw62");
"use client";
var $279cd6dea0e062c7$var$_a;
var $279cd6dea0e062c7$var$emotion_styled = ($279cd6dea0e062c7$var$_a = (0, $12ab803fa905d303$export$2e2bcd8739ae039).default) != null ? $279cd6dea0e062c7$var$_a : (0, $12ab803fa905d303$export$2e2bcd8739ae039);
var $279cd6dea0e062c7$export$9dba07f3d84163bb = ({ baseStyle: baseStyle })=>(props)=>{
        const { theme: theme, css: cssProp, __css: __css, sx: sx, ...rest } = props;
        const styleProps = (0, $8cabe7dbd312f1c1$export$3417cf6417437960)(rest, (_, prop)=>(0, $47a6d9fbbf7ee42d$export$95b76554d0cd12d6)(prop));
        const finalBaseStyle = (0, $7e9e3a2462729b7f$export$624e501d81f5ffce)(baseStyle, props);
        const finalStyles = (0, $497654f4cc41b610$export$1ab078c80230a125)({}, __css, finalBaseStyle, (0, $8cabe7dbd312f1c1$export$2458ce75c8ef9806)(styleProps), sx);
        const computedCSS = (0, $47a6d9fbbf7ee42d$export$dbf350e5966cf602)(finalStyles)(props.theme);
        return cssProp ? [
            computedCSS,
            cssProp
        ] : computedCSS;
    };
function $279cd6dea0e062c7$export$3817b7a54a07cec7(component, options) {
    const { baseStyle: baseStyle, ...styledOptions } = options != null ? options : {};
    if (!styledOptions.shouldForwardProp) styledOptions.shouldForwardProp = (0, $f041f5bc425d9240$export$3ba67b570e26eea0);
    const styleObject = $279cd6dea0e062c7$export$9dba07f3d84163bb({
        baseStyle: baseStyle
    });
    const Component = $279cd6dea0e062c7$var$emotion_styled(component, styledOptions)(styleObject);
    const chakraComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ChakraComponent(props, ref) {
        const { colorMode: colorMode, forced: forced } = (0, $b80b1cf263c5808a$export$20f3076712c8dfa)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
            ref: ref,
            "data-theme": forced ? colorMode : void 0,
            ...props
        });
    });
    return chakraComponent;
}


"use client";
// src/factory.ts
function $7a77d8ad783bc3e2$var$factory() {
    const cache = /* @__PURE__ */ new Map();
    return new Proxy((0, $279cd6dea0e062c7$export$3817b7a54a07cec7), {
        /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */ apply (target, thisArg, argArray) {
            return (0, $279cd6dea0e062c7$export$3817b7a54a07cec7)(...argArray);
        },
        /**
     * @example
     * <chakra.div />
     */ get (_, element) {
            if (!cache.has(element)) cache.set(element, (0, $279cd6dea0e062c7$export$3817b7a54a07cec7)(element));
            return cache.get(element);
        }
    });
}
var $7a77d8ad783bc3e2$export$7cd122d781af9fa4 = $7a77d8ad783bc3e2$var$factory();



var $acw62 = parcelRequire("acw62");

"use client";
var $c6c69dab3415618a$var$toastMotionVariants = {
    initial: (props)=>{
        const { position: position } = props;
        const dir = [
            "top",
            "bottom"
        ].includes(position) ? "y" : "x";
        let factor = [
            "top-right",
            "bottom-right"
        ].includes(position) ? 1 : -1;
        if (position === "bottom") factor = 1;
        return {
            opacity: 0,
            [dir]: factor * 24
        };
    },
    animate: {
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1,
        transition: {
            duration: 0.4,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        opacity: 0,
        scale: 0.85,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    }
};
var $c6c69dab3415618a$export$8743ba3ef25f9582 = (0, $acw62.memo)((props)=>{
    const { id: id, message: message, onCloseComplete: onCloseComplete, onRequestRemove: onRequestRemove, requestClose: requestClose = false, position: position = "bottom", duration: duration = 5e3, containerStyle: containerStyle, motionVariants: motionVariants = $c6c69dab3415618a$var$toastMotionVariants, toastSpacing: toastSpacing = "0.5rem" } = props;
    const [delay, setDelay] = (0, $acw62.useState)(duration);
    const isPresent = (0, $bc77fac60b5d77cc$export$8249053f690ea39a)();
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (!isPresent) onCloseComplete == null || onCloseComplete();
    }, [
        isPresent
    ]);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        setDelay(duration);
    }, [
        duration
    ]);
    const onMouseEnter = ()=>setDelay(null);
    const onMouseLeave = ()=>setDelay(duration);
    const close = ()=>{
        if (isPresent) onRequestRemove();
    };
    (0, $acw62.useEffect)(()=>{
        if (isPresent && requestClose) onRequestRemove();
    }, [
        isPresent,
        requestClose,
        onRequestRemove
    ]);
    (0, $3efd861ddab1b905$export$d8e6abf214c9ec0f)(close, delay);
    const containerStyles = (0, $acw62.useMemo)(()=>({
            pointerEvents: "auto",
            maxWidth: 560,
            minWidth: 300,
            margin: toastSpacing,
            ...containerStyle
        }), [
        containerStyle,
        toastSpacing
    ]);
    const toastStyle = (0, $acw62.useMemo)(()=>(0, $13c58346a8d373ae$export$27777812cc6d52de)(position), [
        position
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
        layout: true,
        className: "chakra-toast",
        variants: motionVariants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        onHoverStart: onMouseEnter,
        onHoverEnd: onMouseLeave,
        custom: {
            position: position
        },
        style: toastStyle,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
            role: "status",
            "aria-atomic": "true",
            className: "chakra-toast__inner",
            __css: containerStyles,
            children: (0, $abe97432afb3d989$export$624e501d81f5ffce)(message, {
                id: id,
                onClose: close
            })
        })
    });
});
$c6c69dab3415618a$export$8743ba3ef25f9582.displayName = "ToastComponent";



"use client";
// src/toast.placement.ts
function $c13e78f3f75f793d$export$5b03f73d5fd4425(position, dir) {
    var _a;
    const computedPosition = position != null ? position : "bottom";
    const logicals = {
        "top-start": {
            ltr: "top-left",
            rtl: "top-right"
        },
        "top-end": {
            ltr: "top-right",
            rtl: "top-left"
        },
        "bottom-start": {
            ltr: "bottom-left",
            rtl: "bottom-right"
        },
        "bottom-end": {
            ltr: "bottom-right",
            rtl: "bottom-left"
        }
    };
    const logical = logicals[computedPosition];
    return (_a = logical == null ? void 0 : logical[dir]) != null ? _a : computedPosition;
}



var $acw62 = parcelRequire("acw62");
"use client";
function $b271d58d4d1ccb07$export$257a8862b851cb5b(component) {
    return (0, $acw62.forwardRef)(component);
}



var $acw62 = parcelRequire("acw62");
"use client";
function $5f6bf330f809db0e$export$93d4e7f90805808f() {
    const theme = (0, $acw62.useContext)((0, $0fe24a6591b39473$export$971d5caa766a69d7));
    if (!theme) throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
    return theme;
}



"use client";
function $d637f68b5e43da19$export$a513a93efd9ab8a7() {
    const colorModeResult = (0, $b80b1cf263c5808a$export$20f3076712c8dfa)();
    const theme = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    return {
        ...colorModeResult,
        theme: theme
    };
}
function $d637f68b5e43da19$var$getBreakpointValue(theme, value, fallback) {
    var _a, _b;
    if (value == null) return value;
    const getValue = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__breakpoints) == null ? void 0 : _a2.asArray) == null ? void 0 : _b2[val];
    };
    return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function $d637f68b5e43da19$var$getTokenValue(theme, value, fallback) {
    var _a, _b;
    if (value == null) return value;
    const getValue = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.value;
    };
    return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function $d637f68b5e43da19$export$31dcd79391e423fe(scale, token, fallback) {
    const theme = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    return $d637f68b5e43da19$export$257b2d10b709d8ef(scale, token, fallback)(theme);
}
function $d637f68b5e43da19$export$257b2d10b709d8ef(scale, token, fallback) {
    const _token = Array.isArray(token) ? token : [
        token
    ];
    const _fallback = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    return (theme)=>{
        const fallbackArr = _fallback.filter(Boolean);
        const result = _token.map((token2, index)=>{
            var _a, _b;
            if (scale === "breakpoints") return $d637f68b5e43da19$var$getBreakpointValue(theme, token2, (_a = fallbackArr[index]) != null ? _a : token2);
            const path = `${scale}.${token2}`;
            return $d637f68b5e43da19$var$getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
        });
        return Array.isArray(token) ? result : result[0];
    };
}



// src/extend-theme.ts


var $5Gn6I = parcelRequire("5Gn6I");
function $a0ae5775f52b77ad$var$isFunction(value) {
    return typeof value === "function";
}
function $a0ae5775f52b77ad$var$pipe(...fns) {
    return (v)=>fns.reduce((a, b)=>b(a), v);
}
var $a0ae5775f52b77ad$var$createExtendTheme = (theme2)=>{
    return function extendTheme2(...extensions) {
        let overrides = [
            ...extensions
        ];
        let activeTheme = extensions[extensions.length - 1];
        if ((0, $aef2905091b67153$export$73a6ae01926a4f0e)(activeTheme) && // this ensures backward compatibility
        // previously only `extendTheme(override, activeTheme?)` was allowed
        overrides.length > 1) overrides = overrides.slice(0, overrides.length - 1);
        else activeTheme = theme2;
        return $a0ae5775f52b77ad$var$pipe(...overrides.map((extension)=>(prevTheme)=>$a0ae5775f52b77ad$var$isFunction(extension) ? extension(prevTheme) : $a0ae5775f52b77ad$export$c42236daa9a25fdd(prevTheme, extension)))(activeTheme);
    };
};
var $a0ae5775f52b77ad$export$33a2b855d5b8731e = $a0ae5775f52b77ad$var$createExtendTheme((0, $fecf4860da5314d0$export$bca14c5b3b88a9c9));
var $a0ae5775f52b77ad$export$4c7add5200c9692a = $a0ae5775f52b77ad$var$createExtendTheme((0, $fecf4860da5314d0$export$9e955aef208055a6));
function $a0ae5775f52b77ad$export$c42236daa9a25fdd(...overrides) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, ...overrides, $a0ae5775f52b77ad$var$mergeThemeCustomizer);
}
function $a0ae5775f52b77ad$var$mergeThemeCustomizer(source, override, key, object) {
    if (($a0ae5775f52b77ad$var$isFunction(source) || $a0ae5775f52b77ad$var$isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) return (...args)=>{
        const sourceValue = $a0ae5775f52b77ad$var$isFunction(source) ? source(...args) : source;
        const overrideValue = $a0ae5775f52b77ad$var$isFunction(override) ? override(...args) : override;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, sourceValue, overrideValue, $a0ae5775f52b77ad$var$mergeThemeCustomizer);
    };
    return void 0;
}



var $5Gn6I = parcelRequire("5Gn6I");

var $acw62 = parcelRequire("acw62");
var $77ddc6be16b1d7de$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
var $77ddc6be16b1d7de$var$hasMap = typeof Map === "function";
var $77ddc6be16b1d7de$var$hasSet = typeof Set === "function";
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$77ddc6be16b1d7de$exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


"use client";
function $6225152922b2fd2b$var$useStyleConfigImpl(themeKey, props = {}) {
    var _a;
    const { styleConfig: styleConfigProp, ...rest } = props;
    const { theme: theme, colorMode: colorMode } = (0, $d637f68b5e43da19$export$a513a93efd9ab8a7)();
    const themeStyleConfig = themeKey ? (0, $8cabe7dbd312f1c1$export$1bb32d0c65da6059)(theme, `components.${themeKey}`) : void 0;
    const styleConfig = styleConfigProp || themeStyleConfig;
    const mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({
        theme: theme,
        colorMode: colorMode
    }, (_a = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a : {}, (0, $8cabe7dbd312f1c1$export$2458ce75c8ef9806)((0, $8cabe7dbd312f1c1$export$30a06c8d3562193f)(rest, [
        "children"
    ])));
    const stylesRef = (0, $acw62.useRef)({});
    if (styleConfig) {
        const getStyles = (0, $47a6d9fbbf7ee42d$export$f94106bbb00e81eb)(styleConfig);
        const styles = getStyles(mergedProps);
        const isStyleEqual = (0, (/*@__PURE__*/$parcel$interopDefault($77ddc6be16b1d7de$exports)))(stylesRef.current, styles);
        if (!isStyleEqual) stylesRef.current = styles;
    }
    return stylesRef.current;
}
function $6225152922b2fd2b$export$b863f77547fbcb03(themeKey, props = {}) {
    return $6225152922b2fd2b$var$useStyleConfigImpl(themeKey, props);
}
function $6225152922b2fd2b$export$31cdfe60c085d76f(themeKey, props = {}) {
    return $6225152922b2fd2b$var$useStyleConfigImpl(themeKey, props);
}
function $6225152922b2fd2b$export$d47b3683b351a542(themeKey, props) {
    var _a;
    const { baseConfig: baseConfig, ...restProps } = props;
    const { theme: theme } = (0, $d637f68b5e43da19$export$a513a93efd9ab8a7)();
    const overrides = (_a = theme.components) == null ? void 0 : _a[themeKey];
    const styleConfig = overrides ? (0, $a0ae5775f52b77ad$export$c42236daa9a25fdd)(overrides, baseConfig) : baseConfig;
    return $6225152922b2fd2b$var$useStyleConfigImpl(null, {
        ...restProps,
        styleConfig: styleConfig
    });
}




"use client";
var $6a96cde036d65913$var$fallbackIcon = {
    path: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                strokeLinecap: "round",
                fill: "none",
                d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                strokeLinecap: "round",
                d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                fill: "none",
                strokeMiterlimit: "10",
                cx: "12",
                cy: "12",
                r: "11.25"
            })
        ]
    }),
    viewBox: "0 0 24 24"
};
var $6a96cde036d65913$export$f04a61298a47a40f = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { as: element, viewBox: viewBox, color: color = "currentColor", focusable: focusable = false, children: children, className: className, __css: __css, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-icon", className);
    const customStyles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Icon", props);
    const styles = {
        w: "1em",
        h: "1em",
        display: "inline-block",
        lineHeight: "1em",
        flexShrink: 0,
        color: color,
        ...__css,
        ...customStyles
    };
    const shared = {
        ref: ref,
        focusable: focusable,
        className: _className,
        __css: styles
    };
    const _viewBox = viewBox != null ? viewBox : $6a96cde036d65913$var$fallbackIcon.viewBox;
    if (element && typeof element !== "string") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).svg, {
        as: element,
        ...shared,
        ...rest
    });
    const _path = children != null ? children : $6a96cde036d65913$var$fallbackIcon.path;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).svg, {
        verticalAlign: "middle",
        viewBox: _viewBox,
        ...shared,
        ...rest,
        children: _path
    });
});
$6a96cde036d65913$export$f04a61298a47a40f.displayName = "Icon";
var $6a96cde036d65913$export$21036209a317fcec = $6a96cde036d65913$export$f04a61298a47a40f;



"use client";
function $747925a80656aa47$export$7dd004358974b05d(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6a96cde036d65913$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
        })
    });
}
function $747925a80656aa47$export$2957fc44b3d2481(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6a96cde036d65913$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
        })
    });
}
function $747925a80656aa47$export$f7dc499a72baa103(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6a96cde036d65913$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        })
    });
}






"use client";
var $6c35780027222e0c$var$spin = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
var $6c35780027222e0c$export$7f7cbe89f1eacd2 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Spinner", props);
    const { label: label = "Loading...", thickness: thickness = "2px", speed: speed = "0.45s", emptyColor: emptyColor = "transparent", className: className, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-spinner", className);
    const spinnerStyles = {
        display: "inline-block",
        borderColor: "currentColor",
        borderStyle: "solid",
        borderRadius: "99999px",
        borderWidth: thickness,
        borderBottomColor: emptyColor,
        borderLeftColor: emptyColor,
        animation: `${$6c35780027222e0c$var$spin} ${speed} linear infinite`,
        ...styles
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: spinnerStyles,
        className: _className,
        ...rest,
        children: label && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
            srOnly: true,
            children: label
        })
    });
});
$6c35780027222e0c$export$7f7cbe89f1eacd2.displayName = "Spinner";


"use client";
var [$e8473bbab2974e87$export$a7901f7b4cce70b0, $e8473bbab2974e87$export$50b520f08832063d] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "AlertContext",
    hookName: "useAlertContext",
    providerName: "<Alert />"
});
var [$e8473bbab2974e87$export$17cf5063e294f385, $e8473bbab2974e87$export$167ececdbea67592] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `AlertStylesContext`,
    hookName: `useAlertStyles`,
    providerName: "<Alert />"
});
var $e8473bbab2974e87$var$STATUSES = {
    info: {
        icon: (0, $747925a80656aa47$export$2957fc44b3d2481),
        colorScheme: "blue"
    },
    warning: {
        icon: (0, $747925a80656aa47$export$f7dc499a72baa103),
        colorScheme: "orange"
    },
    success: {
        icon: (0, $747925a80656aa47$export$7dd004358974b05d),
        colorScheme: "green"
    },
    error: {
        icon: (0, $747925a80656aa47$export$f7dc499a72baa103),
        colorScheme: "red"
    },
    loading: {
        icon: (0, $6c35780027222e0c$export$7f7cbe89f1eacd2),
        colorScheme: "blue"
    }
};
function $e8473bbab2974e87$export$8df8f66d0469c54d(status) {
    return $e8473bbab2974e87$var$STATUSES[status].colorScheme;
}
function $e8473bbab2974e87$export$c742923ea4ac4c1c(status) {
    return $e8473bbab2974e87$var$STATUSES[status].icon;
}





"use client";
var $e6d3646647574d7b$export$caec2af78bcc877f = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Alert2(props, ref) {
    var _a;
    const { status: status = "info", addRole: addRole = true, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const colorScheme = (_a = props.colorScheme) != null ? _a : (0, $e8473bbab2974e87$export$8df8f66d0469c54d)(status);
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Alert", {
        ...props,
        colorScheme: colorScheme
    });
    const alertStyles = {
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        ...styles.container
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e8473bbab2974e87$export$a7901f7b4cce70b0), {
        value: {
            status: status
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e8473bbab2974e87$export$17cf5063e294f385), {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                "data-status": status,
                role: addRole ? "alert" : void 0,
                ref: ref,
                ...rest,
                className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert", props.className),
                __css: alertStyles
            })
        })
    });
});
$e6d3646647574d7b$export$caec2af78bcc877f.displayName = "Alert";





"use client";
var $47cb36091e93dfa4$export$d4feae172fccda11 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function AlertDescription2(props, ref) {
    const styles = (0, $e8473bbab2974e87$export$167ececdbea67592)();
    const { status: status } = (0, $e8473bbab2974e87$export$50b520f08832063d)();
    const descriptionStyles = {
        display: "inline",
        ...styles.description
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert__desc", props.className),
        __css: descriptionStyles
    });
});
$47cb36091e93dfa4$export$d4feae172fccda11.displayName = "AlertDescription";





"use client";
function $39514ae01177ad54$export$4a143c8822a09fb4(props) {
    const { status: status } = (0, $e8473bbab2974e87$export$50b520f08832063d)();
    const BaseIcon = (0, $e8473bbab2974e87$export$c742923ea4ac4c1c)(status);
    const styles = (0, $e8473bbab2974e87$export$167ececdbea67592)();
    const css = status === "loading" ? styles.spinner : styles.icon;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
        display: "inherit",
        "data-status": status,
        ...props,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert__icon", props.className),
        __css: css,
        children: props.children || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(BaseIcon, {
            h: "100%",
            w: "100%"
        })
    });
}
$39514ae01177ad54$export$4a143c8822a09fb4.displayName = "AlertIcon";





"use client";
var $1437852cd8382f03$export$4a7253439a300753 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function AlertTitle2(props, ref) {
    const styles = (0, $e8473bbab2974e87$export$167ececdbea67592)();
    const { status: status } = (0, $e8473bbab2974e87$export$50b520f08832063d)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert__title", props.className),
        __css: styles.title
    });
});
$1437852cd8382f03$export$4a7253439a300753.displayName = "AlertTitle";






"use client";
function $4a635bb7fe4595f6$var$CloseIcon(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6a96cde036d65913$export$f04a61298a47a40f), {
        focusable: "false",
        "aria-hidden": true,
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
        })
    });
}
var $4a635bb7fe4595f6$export$de65de8213222d10 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function CloseButton2(props, ref) {
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("CloseButton", props);
    const { children: children, isDisabled: isDisabled, __css: __css, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const baseStyle = {
        outline: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).button, {
        type: "button",
        "aria-label": "Close",
        ref: ref,
        disabled: isDisabled,
        __css: {
            ...baseStyle,
            ...styles,
            ...__css
        },
        ...rest,
        children: children || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4a635bb7fe4595f6$var$CloseIcon, {
            width: "1em",
            height: "1em"
        })
    });
});
$4a635bb7fe4595f6$export$de65de8213222d10.displayName = "CloseButton";




"use client";
// src/toast.store.ts
var $5d453eab4ae9d3d7$var$initialState = {
    top: [],
    "top-left": [],
    "top-right": [],
    "bottom-left": [],
    bottom: [],
    "bottom-right": []
};
var $5d453eab4ae9d3d7$export$e80fa18a42ed98ef = $5d453eab4ae9d3d7$var$createStore($5d453eab4ae9d3d7$var$initialState);
function $5d453eab4ae9d3d7$var$createStore(initialState2) {
    let state = initialState2;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (setStateFn)=>{
        state = setStateFn(state);
        listeners.forEach((l)=>l());
    };
    return {
        getState: ()=>state,
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                setState(()=>initialState2);
                listeners.delete(listener);
            };
        },
        /**
     * Delete a toast record at its position
     */ removeToast: (id, position)=>{
            setState((prevState)=>({
                    ...prevState,
                    // id may be string or number
                    // eslint-disable-next-line eqeqeq
                    [position]: prevState[position].filter((toast)=>toast.id != id)
                }));
        },
        notify: (message, options)=>{
            const toast = $5d453eab4ae9d3d7$var$createToast(message, options);
            const { position: position, id: id } = toast;
            setState((prevToasts)=>{
                var _a, _b;
                const isTop = position.includes("top");
                const toasts = isTop ? [
                    toast,
                    ...(_a = prevToasts[position]) != null ? _a : []
                ] : [
                    ...(_b = prevToasts[position]) != null ? _b : [],
                    toast
                ];
                return {
                    ...prevToasts,
                    [position]: toasts
                };
            });
            return id;
        },
        update: (id, options)=>{
            if (!id) return;
            setState((prevState)=>{
                const nextState = {
                    ...prevState
                };
                const { position: position, index: index } = (0, $13c58346a8d373ae$export$67080b9d5f0a62ea)(nextState, id);
                if (position && index !== -1) nextState[position][index] = {
                    ...nextState[position][index],
                    ...options,
                    message: $5d453eab4ae9d3d7$export$d9d796c483697359(options)
                };
                return nextState;
            });
        },
        closeAll: ({ positions: positions } = {})=>{
            setState((prev)=>{
                const allPositions = [
                    "bottom",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "top-left",
                    "top-right"
                ];
                const positionsToClose = positions != null ? positions : allPositions;
                return positionsToClose.reduce((acc, position)=>{
                    acc[position] = prev[position].map((toast)=>({
                            ...toast,
                            requestClose: true
                        }));
                    return acc;
                }, {
                    ...prev
                });
            });
        },
        close: (id)=>{
            setState((prevState)=>{
                const position = (0, $13c58346a8d373ae$export$500f52ac46324ec6)(prevState, id);
                if (!position) return prevState;
                return {
                    ...prevState,
                    [position]: prevState[position].map((toast)=>{
                        if (toast.id == id) return {
                            ...toast,
                            requestClose: true
                        };
                        return toast;
                    })
                };
            });
        },
        isActive: (id)=>Boolean((0, $13c58346a8d373ae$export$67080b9d5f0a62ea)($5d453eab4ae9d3d7$export$e80fa18a42ed98ef.getState(), id).position)
    };
}
var $5d453eab4ae9d3d7$var$counter = 0;
function $5d453eab4ae9d3d7$var$createToast(message, options = {}) {
    var _a, _b;
    $5d453eab4ae9d3d7$var$counter += 1;
    const id = (_a = options.id) != null ? _a : $5d453eab4ae9d3d7$var$counter;
    const position = (_b = options.position) != null ? _b : "bottom";
    return {
        id: id,
        message: message,
        position: position,
        duration: options.duration,
        onCloseComplete: options.onCloseComplete,
        onRequestRemove: ()=>$5d453eab4ae9d3d7$export$e80fa18a42ed98ef.removeToast(String(id), position),
        status: options.status,
        requestClose: false,
        containerStyle: options.containerStyle
    };
}
var $5d453eab4ae9d3d7$export$8d8dc7d5f743331b = (props)=>{
    const { status: status, variant: variant = "solid", id: id, title: title, isClosable: isClosable, onClose: onClose, description: description, colorScheme: colorScheme, icon: icon } = props;
    const ids = id ? {
        root: `toast-${id}`,
        title: `toast-${id}-title`,
        description: `toast-${id}-description`
    } : void 0;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $e6d3646647574d7b$export$caec2af78bcc877f), {
        addRole: false,
        status: status,
        variant: variant,
        id: ids == null ? void 0 : ids.root,
        alignItems: "start",
        borderRadius: "md",
        boxShadow: "lg",
        paddingEnd: 8,
        textAlign: "start",
        width: "auto",
        colorScheme: colorScheme,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $39514ae01177ad54$export$4a143c8822a09fb4), {
                children: icon
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                flex: "1",
                maxWidth: "100%",
                children: [
                    title && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $1437852cd8382f03$export$4a7253439a300753), {
                        id: ids == null ? void 0 : ids.title,
                        children: title
                    }),
                    description && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $47cb36091e93dfa4$export$d4feae172fccda11), {
                        id: ids == null ? void 0 : ids.description,
                        display: "block",
                        children: description
                    })
                ]
            }),
            isClosable && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4a635bb7fe4595f6$export$de65de8213222d10), {
                size: "sm",
                onClick: onClose,
                position: "absolute",
                insetEnd: 1,
                top: 1
            })
        ]
    });
};
function $5d453eab4ae9d3d7$export$d9d796c483697359(options = {}) {
    const { render: render, toastComponent: ToastComponent = $5d453eab4ae9d3d7$export$8d8dc7d5f743331b } = options;
    const renderToast = (props)=>{
        if (typeof render === "function") return render({
            ...props,
            ...options
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ToastComponent, {
            ...props,
            ...options
        });
    };
    return renderToast;
}
function $5d453eab4ae9d3d7$export$f3af62d19eb14261(dir, defaultOptions) {
    const normalizeToastOptions = (options)=>{
        var _a;
        return {
            ...defaultOptions,
            ...options,
            position: (0, $c13e78f3f75f793d$export$5b03f73d5fd4425)((_a = options == null ? void 0 : options.position) != null ? _a : defaultOptions == null ? void 0 : defaultOptions.position, dir)
        };
    };
    const toast = (options)=>{
        const normalizedToastOptions = normalizeToastOptions(options);
        const Message = $5d453eab4ae9d3d7$export$d9d796c483697359(normalizedToastOptions);
        return $5d453eab4ae9d3d7$export$e80fa18a42ed98ef.notify(Message, normalizedToastOptions);
    };
    toast.update = (id, options)=>{
        $5d453eab4ae9d3d7$export$e80fa18a42ed98ef.update(id, normalizeToastOptions(options));
    };
    toast.promise = (promise, options)=>{
        const id = toast({
            ...options.loading,
            status: "loading",
            duration: null
        });
        promise.then((data)=>toast.update(id, {
                status: "success",
                duration: 5e3,
                ...(0, $abe97432afb3d989$export$624e501d81f5ffce)(options.success, data)
            })).catch((error)=>toast.update(id, {
                status: "error",
                duration: 5e3,
                ...(0, $abe97432afb3d989$export$624e501d81f5ffce)(options.error, error)
            }));
    };
    toast.closeAll = $5d453eab4ae9d3d7$export$e80fa18a42ed98ef.closeAll;
    toast.close = $5d453eab4ae9d3d7$export$e80fa18a42ed98ef.close;
    toast.isActive = $5d453eab4ae9d3d7$export$e80fa18a42ed98ef.isActive;
    return toast;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $c0a2e592950340df$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}



function $0316e1262c81ebb4$export$91db9bc4f8ac944a() {
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $acw62.useState)(0);
    const forceRender = (0, $acw62.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $acw62.useCallback)(()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $6f8c626e496e1918$var$PopChildMeasure extends $acw62.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $6f8c626e496e1918$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $acw62.useId)();
    const ref = (0, $acw62.useRef)(null);
    const size = (0, $acw62.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $acw62.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $acw62.createElement($6f8c626e496e1918$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $acw62.cloneElement(children, {
        ref: ref
    }));
}


const $f57f9e9f321f3a7c$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)($f57f9e9f321f3a7c$var$newChildrenMap);
    const id = (0, $acw62.useId)();
    const context = (0, $acw62.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $acw62.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $acw62.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $acw62.createElement((0, $6f8c626e496e1918$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $acw62.createElement((0, $dba5d94a982c4145$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $f57f9e9f321f3a7c$var$newChildrenMap() {
    return new Map();
}





var $acw62 = parcelRequire("acw62");
function $7bbbf777b15ef7cf$export$f3a192d0cbd30b96(callback) {
    return (0, $acw62.useEffect)(()=>()=>callback(), []);
}



const $06516233abcfeeff$var$getChildKey = (child)=>child.key || "";
function $06516233abcfeeff$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $06516233abcfeeff$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $06516233abcfeeff$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $acw62.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $06516233abcfeeff$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).forceRender || (0, $0316e1262c81ebb4$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $06516233abcfeeff$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $acw62.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $acw62.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $acw62.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $acw62.useRef)(true);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $06516233abcfeeff$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $7bbbf777b15ef7cf$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $acw62.createElement($acw62.Fragment, null, childrenToRender.map((child)=>$acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($06516233abcfeeff$var$getChildKey);
    const targetKeys = filteredChildren.map($06516233abcfeeff$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                allChildren.delete(key);
                exitingChildren.delete(key);
                // Remove this child from the present children
                const removeIndex = presentChildren.current.findIndex((presentChild)=>presentChild.key === key);
                presentChildren.current.splice(removeIndex, 1);
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    presentChildren.current = filteredChildren;
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
                key: $06516233abcfeeff$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $acw62.createElement($acw62.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $acw62.cloneElement)(child)));
};







var $acw62 = parcelRequire("acw62");

"use client";
var [$b71276780b6a43df$var$PortalContextProvider, $b71276780b6a43df$var$usePortalContext] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalContext"
});
var $b71276780b6a43df$var$PORTAL_CLASSNAME = "chakra-portal";
var $b71276780b6a43df$var$PORTAL_SELECTOR = `.chakra-portal`;
var $b71276780b6a43df$var$Container = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "chakra-portal-zIndex",
        style: {
            position: "absolute",
            zIndex: props.zIndex,
            top: 0,
            left: 0,
            right: 0
        },
        children: props.children
    });
var $b71276780b6a43df$var$DefaultPortal = (props)=>{
    const { appendToParentPortal: appendToParentPortal, children: children } = props;
    const [tempNode, setTempNode] = (0, $acw62.useState)(null);
    const portal = (0, $acw62.useRef)(null);
    const [, forceUpdate] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>forceUpdate({}), []);
    const parentPortal = $b71276780b6a43df$var$usePortalContext();
    const manager = (0, $cb17b1dba222b22e$export$ef203b29c2cc1f5d)();
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!tempNode) return;
        const doc = tempNode.ownerDocument;
        const host = appendToParentPortal ? parentPortal != null ? parentPortal : doc.body : doc.body;
        if (!host) return;
        portal.current = doc.createElement("div");
        portal.current.className = $b71276780b6a43df$var$PORTAL_CLASSNAME;
        host.appendChild(portal.current);
        forceUpdate({});
        const portalNode = portal.current;
        return ()=>{
            if (host.contains(portalNode)) host.removeChild(portalNode);
        };
    }, [
        tempNode
    ]);
    const _children = (manager == null ? void 0 : manager.zIndex) ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b71276780b6a43df$var$Container, {
        zIndex: manager == null ? void 0 : manager.zIndex,
        children: children
    }) : children;
    return portal.current ? (0, $11492dca620dcaa5$exports.createPortal)(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b71276780b6a43df$var$PortalContextProvider, {
        value: portal.current,
        children: _children
    }), portal.current) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
        ref: (el)=>{
            if (el) setTempNode(el);
        }
    });
};
var $b71276780b6a43df$var$ContainerPortal = (props)=>{
    const { children: children, containerRef: containerRef, appendToParentPortal: appendToParentPortal } = props;
    const containerEl = containerRef.current;
    const host = containerEl != null ? containerEl : typeof window !== "undefined" ? document.body : void 0;
    const portal = (0, $acw62.useMemo)(()=>{
        const node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
        if (node) node.className = $b71276780b6a43df$var$PORTAL_CLASSNAME;
        return node;
    }, [
        containerEl
    ]);
    const [, forceUpdate] = (0, $acw62.useState)({});
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>forceUpdate({}), []);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!portal || !host) return;
        host.appendChild(portal);
        return ()=>{
            host.removeChild(portal);
        };
    }, [
        portal,
        host
    ]);
    if (host && portal) return (0, $11492dca620dcaa5$exports.createPortal)(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b71276780b6a43df$var$PortalContextProvider, {
        value: appendToParentPortal ? portal : null,
        children: children
    }), portal);
    return null;
};
function $b71276780b6a43df$export$602eac185826482c(props) {
    const portalProps = {
        appendToParentPortal: true,
        ...props
    };
    const { containerRef: containerRef, ...rest } = portalProps;
    return containerRef ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b71276780b6a43df$var$ContainerPortal, {
        containerRef: containerRef,
        ...rest
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b71276780b6a43df$var$DefaultPortal, {
        ...rest
    });
}
$b71276780b6a43df$export$602eac185826482c.className = $b71276780b6a43df$var$PORTAL_CLASSNAME;
$b71276780b6a43df$export$602eac185826482c.selector = $b71276780b6a43df$var$PORTAL_SELECTOR;
$b71276780b6a43df$export$602eac185826482c.displayName = "Portal";



var $acw62 = parcelRequire("acw62");


"use client";
var [$b203a87feae3819b$export$cfcc07abbe2e36a8, $b203a87feae3819b$export$7c4af276256dc908] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `ToastOptionsContext`,
    strict: false
});
var $b203a87feae3819b$export$f5d03d415824e0e = (props)=>{
    const state = (0, $acw62.useSyncExternalStore)((0, $5d453eab4ae9d3d7$export$e80fa18a42ed98ef).subscribe, (0, $5d453eab4ae9d3d7$export$e80fa18a42ed98ef).getState, (0, $5d453eab4ae9d3d7$export$e80fa18a42ed98ef).getState);
    const { motionVariants: motionVariants, component: Component = (0, $c6c69dab3415618a$export$8743ba3ef25f9582), portalProps: portalProps } = props;
    const stateKeys = Object.keys(state);
    const toastList = stateKeys.map((position)=>{
        const toasts = state[position];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "region",
            "aria-live": "polite",
            "aria-label": `Notifications-${position}`,
            id: `chakra-toast-manager-${position}`,
            style: (0, $13c58346a8d373ae$export$55dd410e8ef136e0)(position),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                initial: false,
                children: toasts.map((toast)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                        motionVariants: motionVariants,
                        ...toast
                    }, toast.id))
            })
        }, position);
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b71276780b6a43df$export$602eac185826482c), {
        ...portalProps,
        children: toastList
    });
};



"use client";
var $87af691840ea6fe4$var$createChakraProvider = (providerTheme)=>{
    return function ChakraProvider2({ children: children, theme: theme = providerTheme, toastOptions: toastOptions, ...restProps }) {
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $be3187ddebc65cb1$export$80dbe0482bcbd25a), {
            theme: theme,
            ...restProps,
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b203a87feae3819b$export$cfcc07abbe2e36a8), {
                    value: toastOptions == null ? void 0 : toastOptions.defaultOptions,
                    children: children
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b203a87feae3819b$export$f5d03d415824e0e), {
                    ...toastOptions
                })
            ]
        });
    };
};
var $87af691840ea6fe4$export$80dbe0482bcbd25a = $87af691840ea6fe4$var$createChakraProvider((0, $fecf4860da5314d0$export$bca14c5b3b88a9c9));
var $87af691840ea6fe4$export$39d642dd5c97e94c = $87af691840ea6fe4$var$createChakraProvider((0, $fecf4860da5314d0$export$9e955aef208055a6));


var $acw62 = parcelRequire("acw62");
"use client";
var $29f58e6f37544430$var$__defProp = Object.defineProperty;
var $29f58e6f37544430$var$__defNormalProp = (obj, key, value)=>key in obj ? $29f58e6f37544430$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $29f58e6f37544430$export$5cb848ba4d1f099 = (obj, key, value)=>{
    $29f58e6f37544430$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
function $29f58e6f37544430$export$96d07f33920abf3e(nodes) {
    return nodes.sort((a, b)=>{
        const compare = a.compareDocumentPosition(b);
        if (compare & Node.DOCUMENT_POSITION_FOLLOWING || compare & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
        if (compare & Node.DOCUMENT_POSITION_PRECEDING || compare & Node.DOCUMENT_POSITION_CONTAINS) return 1;
        if (compare & Node.DOCUMENT_POSITION_DISCONNECTED || compare & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC) throw Error("Cannot sort the given nodes.");
        else return 0;
    });
}
var $29f58e6f37544430$export$45a5e7f76e0caa8d = (el)=>typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
function $29f58e6f37544430$export$c42e0e80904d519(current, max, loop) {
    let next = current + 1;
    if (loop && next >= max) next = 0;
    return next;
}
function $29f58e6f37544430$export$1081b7170ed6e343(current, max, loop) {
    let next = current - 1;
    if (loop && next < 0) next = max;
    return next;
}
var $29f58e6f37544430$export$deebe11a338de063 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $29f58e6f37544430$export$f2db7d5238e1d23f = (value)=>value;


"use client";
// src/descendant.ts
var $85198008348cfbfe$export$e6418ef1851accd = class {
    constructor(){
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "descendants", /* @__PURE__ */ new Map());
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "register", (nodeOrOptions)=>{
            if (nodeOrOptions == null) return;
            if ((0, $29f58e6f37544430$export$45a5e7f76e0caa8d)(nodeOrOptions)) return this.registerNode(nodeOrOptions);
            return (node)=>{
                this.registerNode(node, nodeOrOptions);
            };
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "unregister", (node)=>{
            this.descendants.delete(node);
            const sorted = (0, $29f58e6f37544430$export$96d07f33920abf3e)(Array.from(this.descendants.keys()));
            this.assignIndex(sorted);
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "destroy", ()=>{
            this.descendants.clear();
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "assignIndex", (descendants)=>{
            this.descendants.forEach((descendant)=>{
                const index = descendants.indexOf(descendant.node);
                descendant.index = index;
                descendant.node.dataset["index"] = descendant.index.toString();
            });
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "count", ()=>this.descendants.size);
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "enabledCount", ()=>this.enabledValues().length);
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "values", ()=>{
            const values = Array.from(this.descendants.values());
            return values.sort((a, b)=>a.index - b.index);
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "enabledValues", ()=>{
            return this.values().filter((descendant)=>!descendant.disabled);
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "item", (index)=>{
            if (this.count() === 0) return void 0;
            return this.values()[index];
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "enabledItem", (index)=>{
            if (this.enabledCount() === 0) return void 0;
            return this.enabledValues()[index];
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "first", ()=>this.item(0));
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "firstEnabled", ()=>this.enabledItem(0));
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "last", ()=>this.item(this.descendants.size - 1));
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "lastEnabled", ()=>{
            const lastIndex = this.enabledValues().length - 1;
            return this.enabledItem(lastIndex);
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "indexOf", (node)=>{
            var _a, _b;
            if (!node) return -1;
            return (_b = (_a = this.descendants.get(node)) == null ? void 0 : _a.index) != null ? _b : -1;
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "enabledIndexOf", (node)=>{
            if (node == null) return -1;
            return this.enabledValues().findIndex((i)=>i.node.isSameNode(node));
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "next", (index, loop = true)=>{
            const next = (0, $29f58e6f37544430$export$c42e0e80904d519)(index, this.count(), loop);
            return this.item(next);
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "nextEnabled", (index, loop = true)=>{
            const item = this.item(index);
            if (!item) return;
            const enabledIndex = this.enabledIndexOf(item.node);
            const nextEnabledIndex = (0, $29f58e6f37544430$export$c42e0e80904d519)(enabledIndex, this.enabledCount(), loop);
            return this.enabledItem(nextEnabledIndex);
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "prev", (index, loop = true)=>{
            const prev = (0, $29f58e6f37544430$export$1081b7170ed6e343)(index, this.count() - 1, loop);
            return this.item(prev);
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "prevEnabled", (index, loop = true)=>{
            const item = this.item(index);
            if (!item) return;
            const enabledIndex = this.enabledIndexOf(item.node);
            const prevEnabledIndex = (0, $29f58e6f37544430$export$1081b7170ed6e343)(enabledIndex, this.enabledCount() - 1, loop);
            return this.enabledItem(prevEnabledIndex);
        });
        (0, $29f58e6f37544430$export$5cb848ba4d1f099)(this, "registerNode", (node, options)=>{
            if (!node || this.descendants.has(node)) return;
            const keys = Array.from(this.descendants.keys()).concat(node);
            const sorted = (0, $29f58e6f37544430$export$96d07f33920abf3e)(keys);
            if (options == null ? void 0 : options.disabled) options.disabled = !!options.disabled;
            const descendant = {
                node: node,
                index: -1,
                ...options
            };
            this.descendants.set(node, descendant);
            this.assignIndex(sorted);
        });
    }
};





var $acw62 = parcelRequire("acw62");
"use client";
function $457901a59fc0a4e6$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $457901a59fc0a4e6$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>{
            $457901a59fc0a4e6$export$d734136a7b018efe(ref, node);
        });
    };
}
function $457901a59fc0a4e6$export$74665b213cb5c4cf(...refs) {
    return (0, $acw62.useMemo)(()=>$457901a59fc0a4e6$export$c9058316764c140e(...refs), refs);
}



var $acw62 = parcelRequire("acw62");
"use client";
function $22443c9383de2d2c$var$useDescendants() {
    const descendants = (0, $acw62.useRef)(new (0, $85198008348cfbfe$export$e6418ef1851accd)());
    (0, $29f58e6f37544430$export$deebe11a338de063)(()=>{
        return ()=>descendants.current.destroy();
    });
    return descendants.current;
}
var [$22443c9383de2d2c$var$DescendantsContextProvider, $22443c9383de2d2c$var$useDescendantsContext] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "DescendantsProvider",
    errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function $22443c9383de2d2c$var$useDescendant(options) {
    const descendants = $22443c9383de2d2c$var$useDescendantsContext();
    const [index, setIndex] = (0, $acw62.useState)(-1);
    const ref = (0, $acw62.useRef)(null);
    (0, $29f58e6f37544430$export$deebe11a338de063)(()=>{
        return ()=>{
            if (!ref.current) return;
            descendants.unregister(ref.current);
        };
    }, []);
    (0, $29f58e6f37544430$export$deebe11a338de063)(()=>{
        if (!ref.current) return;
        const dataIndex = Number(ref.current.dataset["index"]);
        if (index != dataIndex && !Number.isNaN(dataIndex)) setIndex(dataIndex);
    });
    const refCallback = options ? (0, $29f58e6f37544430$export$f2db7d5238e1d23f)(descendants.register(options)) : (0, $29f58e6f37544430$export$f2db7d5238e1d23f)(descendants.register);
    return {
        descendants: descendants,
        index: index,
        enabledIndex: descendants.enabledIndexOf(ref.current),
        register: (0, $457901a59fc0a4e6$export$c9058316764c140e)(refCallback, ref)
    };
}
function $22443c9383de2d2c$export$126c4100f8947d7() {
    const ContextProvider = (0, $29f58e6f37544430$export$f2db7d5238e1d23f)($22443c9383de2d2c$var$DescendantsContextProvider);
    const _useDescendantsContext = ()=>(0, $29f58e6f37544430$export$f2db7d5238e1d23f)($22443c9383de2d2c$var$useDescendantsContext());
    const _useDescendant = (options)=>$22443c9383de2d2c$var$useDescendant(options);
    const _useDescendants = ()=>$22443c9383de2d2c$var$useDescendants();
    return [
        // context provider
        ContextProvider,
        // call this when you need to read from context
        _useDescendantsContext,
        // descendants state information, to be called and passed to `ContextProvider`
        _useDescendants,
        // descendant index information
        _useDescendant
    ];
}



"use client";
var [$9680d13bde45826d$export$566ad13fc8b01c3c, $9680d13bde45826d$export$d8716a81161bb5d8] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "AccordionStylesContext",
    hookName: "useAccordionStyles",
    providerName: "<Accordion />"
});
var [$9680d13bde45826d$export$460e63a7964f88ee, $9680d13bde45826d$export$26f4eabe9fa88f4f] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "AccordionItemContext",
    hookName: "useAccordionItemContext",
    providerName: "<AccordionItem />"
});
var [$9680d13bde45826d$export$295e8ce3a8defbe8, $9680d13bde45826d$export$25d3c2eb37694077, $9680d13bde45826d$export$ded2cc2705caf60e, $9680d13bde45826d$export$1d828a1944f739d3] = (0, $22443c9383de2d2c$export$126c4100f8947d7)();




var $acw62 = parcelRequire("acw62");

"use client";
function $4795b7ced84aa3c2$export$7301e09313e4cf1b(prop, state) {
    const controlled = typeof prop !== "undefined";
    const value = controlled ? prop : state;
    return (0, $acw62.useMemo)(()=>[
            controlled,
            value
        ], [
        controlled,
        value
    ]);
}
function $4795b7ced84aa3c2$export$6f32135080cb4c3(props) {
    const { value: valueProp, defaultValue: defaultValue, onChange: onChange, shouldUpdate: shouldUpdate = (prev, next)=>prev !== next } = props;
    const onChangeProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onChange);
    const shouldUpdateProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(shouldUpdate);
    const [uncontrolledState, setUncontrolledState] = (0, $acw62.useState)(defaultValue);
    const controlled = valueProp !== void 0;
    const value = controlled ? valueProp : uncontrolledState;
    const setValue = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)((next)=>{
        const setter = next;
        const nextValue = typeof next === "function" ? setter(value) : next;
        if (!shouldUpdateProp(value, nextValue)) return;
        if (!controlled) setUncontrolledState(nextValue);
        onChangeProp(nextValue);
    }, [
        controlled,
        onChangeProp,
        value,
        shouldUpdateProp
    ]);
    return [
        value,
        setValue
    ];
}





var $acw62 = parcelRequire("acw62");
"use client";
function $cc829c37e1308ee7$export$35e88b08325f7140(props) {
    const { onChange: onChange, defaultIndex: defaultIndex, index: indexProp, allowMultiple: allowMultiple, allowToggle: allowToggle, ...htmlProps } = props;
    $cc829c37e1308ee7$var$allowMultipleWarning(props);
    $cc829c37e1308ee7$var$allowMultipleAndAllowToggleWarning(props);
    const descendants = (0, $9680d13bde45826d$export$ded2cc2705caf60e)();
    const [focusedIndex, setFocusedIndex] = (0, $acw62.useState)(-1);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            setFocusedIndex(-1);
        };
    }, []);
    const [index, setIndex] = (0, $4795b7ced84aa3c2$export$6f32135080cb4c3)({
        value: indexProp,
        defaultValue () {
            if (allowMultiple) return defaultIndex != null ? defaultIndex : [];
            return defaultIndex != null ? defaultIndex : -1;
        },
        onChange: onChange
    });
    const getAccordionItemProps = (idx)=>{
        let isOpen = false;
        if (idx !== null) isOpen = Array.isArray(index) ? index.includes(idx) : index === idx;
        const onChange2 = (isOpen2)=>{
            if (idx === null) return;
            if (allowMultiple && Array.isArray(index)) {
                const nextState = isOpen2 ? index.concat(idx) : index.filter((i)=>i !== idx);
                setIndex(nextState);
            } else if (isOpen2) setIndex(idx);
            else if (allowToggle) setIndex(-1);
        };
        return {
            isOpen: isOpen,
            onChange: onChange2
        };
    };
    return {
        index: index,
        setIndex: setIndex,
        htmlProps: htmlProps,
        getAccordionItemProps: getAccordionItemProps,
        focusedIndex: focusedIndex,
        setFocusedIndex: setFocusedIndex,
        descendants: descendants
    };
}
var [$cc829c37e1308ee7$export$a7339cf504e447d7, $cc829c37e1308ee7$export$33b38874135ce337] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "AccordionContext",
    hookName: "useAccordionContext",
    providerName: "Accordion"
});
function $cc829c37e1308ee7$export$dfe72e7a237bd184(props) {
    const { isDisabled: isDisabled, isFocusable: isFocusable, id: id, ...htmlProps } = props;
    const { getAccordionItemProps: getAccordionItemProps, setFocusedIndex: setFocusedIndex } = $cc829c37e1308ee7$export$33b38874135ce337();
    const buttonRef = (0, $acw62.useRef)(null);
    const reactId = (0, $acw62.useId)();
    const uid = id != null ? id : reactId;
    const buttonId = `accordion-button-${uid}`;
    const panelId = `accordion-panel-${uid}`;
    $cc829c37e1308ee7$var$focusableNotDisabledWarning(props);
    const { register: register, index: index, descendants: descendants } = (0, $9680d13bde45826d$export$1d828a1944f739d3)({
        disabled: isDisabled && !isFocusable
    });
    const { isOpen: isOpen, onChange: onChange } = getAccordionItemProps(index === -1 ? null : index);
    $cc829c37e1308ee7$var$warnIfOpenAndDisabled({
        isOpen: isOpen,
        isDisabled: isDisabled
    });
    const onOpen = ()=>{
        onChange == null || onChange(true);
    };
    const onClose = ()=>{
        onChange == null || onChange(false);
    };
    const onClick = (0, $acw62.useCallback)(()=>{
        onChange == null || onChange(!isOpen);
        setFocusedIndex(index);
    }, [
        index,
        setFocusedIndex,
        isOpen,
        onChange
    ]);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        const keyMap = {
            ArrowDown: ()=>{
                const next = descendants.nextEnabled(index);
                next == null || next.node.focus();
            },
            ArrowUp: ()=>{
                const prev = descendants.prevEnabled(index);
                prev == null || prev.node.focus();
            },
            Home: ()=>{
                const first = descendants.firstEnabled();
                first == null || first.node.focus();
            },
            End: ()=>{
                const last = descendants.lastEnabled();
                last == null || last.node.focus();
            }
        };
        const action = keyMap[event.key];
        if (action) {
            event.preventDefault();
            action(event);
        }
    }, [
        descendants,
        index
    ]);
    const onFocus = (0, $acw62.useCallback)(()=>{
        setFocusedIndex(index);
    }, [
        setFocusedIndex,
        index
    ]);
    const getButtonProps = (0, $acw62.useCallback)(function getButtonProps2(props2 = {}, ref = null) {
        return {
            ...props2,
            type: "button",
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(register, buttonRef, ref),
            id: buttonId,
            disabled: !!isDisabled,
            "aria-expanded": !!isOpen,
            "aria-controls": panelId,
            onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onClick, onClick),
            onFocus: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onFocus, onFocus),
            onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown)
        };
    }, [
        buttonId,
        isDisabled,
        isOpen,
        onClick,
        onFocus,
        onKeyDown,
        panelId,
        register
    ]);
    const getPanelProps = (0, $acw62.useCallback)(function getPanelProps2(props2 = {}, ref = null) {
        return {
            ...props2,
            ref: ref,
            role: "region",
            id: panelId,
            "aria-labelledby": buttonId,
            hidden: !isOpen
        };
    }, [
        buttonId,
        isOpen,
        panelId
    ]);
    return {
        isOpen: isOpen,
        isDisabled: isDisabled,
        isFocusable: isFocusable,
        onOpen: onOpen,
        onClose: onClose,
        getButtonProps: getButtonProps,
        getPanelProps: getPanelProps,
        htmlProps: htmlProps
    };
}
function $cc829c37e1308ee7$var$allowMultipleWarning(props) {
    const index = props.index || props.defaultIndex;
    const condition = index != null && !Array.isArray(index) && props.allowMultiple;
    (0, $abe97432afb3d989$export$c106dd0671a0fc2d)({
        condition: !!condition,
        message: `If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ${typeof index},`
    });
}
function $cc829c37e1308ee7$var$allowMultipleAndAllowToggleWarning(props) {
    (0, $abe97432afb3d989$export$c106dd0671a0fc2d)({
        condition: !!(props.allowMultiple && props.allowToggle),
        message: `If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not`
    });
}
function $cc829c37e1308ee7$var$focusableNotDisabledWarning(props) {
    (0, $abe97432afb3d989$export$c106dd0671a0fc2d)({
        condition: !!(props.isFocusable && !props.isDisabled),
        message: `Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.
    `
    });
}
function $cc829c37e1308ee7$var$warnIfOpenAndDisabled(props) {
    (0, $abe97432afb3d989$export$c106dd0671a0fc2d)({
        condition: props.isOpen && !!props.isDisabled,
        message: "Cannot open a disabled accordion item"
    });
}






var $acw62 = parcelRequire("acw62");

"use client";
var $ab20c29d51326b95$export$a766cd26d0d69044 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Accordion2({ children: children, reduceMotion: reduceMotion, ...props }, ref) {
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Accordion", props);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const { htmlProps: htmlProps, descendants: descendants, ...context } = (0, $cc829c37e1308ee7$export$35e88b08325f7140)(ownProps);
    const ctx = (0, $acw62.useMemo)(()=>({
            ...context,
            reduceMotion: !!reduceMotion
        }), [
        context,
        reduceMotion
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9680d13bde45826d$export$295e8ce3a8defbe8), {
        value: descendants,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cc829c37e1308ee7$export$a7339cf504e447d7), {
            value: ctx,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9680d13bde45826d$export$566ad13fc8b01c3c), {
                value: styles,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                    ref: ref,
                    ...htmlProps,
                    className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-accordion", props.className),
                    __css: styles.root,
                    children: children
                })
            })
        })
    });
});
$ab20c29d51326b95$export$a766cd26d0d69044.displayName = "Accordion";





"use client";
var $90560ec3a7c6c43d$export$b9675c0bae9f505a = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function AccordionButton2(props, ref) {
    const { getButtonProps: getButtonProps } = (0, $9680d13bde45826d$export$26f4eabe9fa88f4f)();
    const buttonProps = getButtonProps(props, ref);
    const styles = (0, $9680d13bde45826d$export$d8716a81161bb5d8)();
    const buttonStyles = {
        display: "flex",
        alignItems: "center",
        width: "100%",
        outline: 0,
        ...styles.button
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).button, {
        ...buttonProps,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-accordion__button", props.className),
        __css: buttonStyles
    });
});
$90560ec3a7c6c43d$export$b9675c0bae9f505a.displayName = "AccordionButton";






var $acw62 = parcelRequire("acw62");

"use client";
var $4aa76a7ca27e9270$export$d99097c13d4dac9f = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function AccordionItem2(props, ref) {
    const { children: children, className: className } = props;
    const { htmlProps: htmlProps, ...context } = (0, $cc829c37e1308ee7$export$dfe72e7a237bd184)(props);
    const styles = (0, $9680d13bde45826d$export$d8716a81161bb5d8)();
    const containerStyles = {
        ...styles.container,
        overflowAnchor: "none"
    };
    const ctx = (0, $acw62.useMemo)(()=>context, [
        context
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9680d13bde45826d$export$460e63a7964f88ee), {
        value: ctx,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
            ref: ref,
            ...htmlProps,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-accordion__item", className),
            __css: containerStyles,
            children: typeof children === "function" ? children({
                isExpanded: !!context.isOpen,
                isDisabled: !!context.isDisabled
            }) : children
        })
    });
});
$4aa76a7ca27e9270$export$d99097c13d4dac9f.displayName = "AccordionItem";




"use client";
// src/transition-utils.ts
var $e53c11b120069459$export$9ee1d08bb6db426f = {
    ease: [
        0.25,
        0.1,
        0.25,
        1
    ],
    easeIn: [
        0.4,
        0,
        1,
        1
    ],
    easeOut: [
        0,
        0,
        0.2,
        1
    ],
    easeInOut: [
        0.4,
        0,
        0.2,
        1
    ]
};
var $e53c11b120069459$export$55b7325ba41bb523 = {
    scale: {
        enter: {
            scale: 1
        },
        exit: {
            scale: 0.95
        }
    },
    fade: {
        enter: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    },
    pushLeft: {
        enter: {
            x: "100%"
        },
        exit: {
            x: "-30%"
        }
    },
    pushRight: {
        enter: {
            x: "-100%"
        },
        exit: {
            x: "30%"
        }
    },
    pushUp: {
        enter: {
            y: "100%"
        },
        exit: {
            y: "-30%"
        }
    },
    pushDown: {
        enter: {
            y: "-100%"
        },
        exit: {
            y: "30%"
        }
    },
    slideLeft: {
        position: {
            left: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: "-100%",
            y: 0
        }
    },
    slideRight: {
        position: {
            right: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: "100%",
            y: 0
        }
    },
    slideUp: {
        position: {
            top: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: 0,
            y: "-100%"
        }
    },
    slideDown: {
        position: {
            bottom: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: 0,
            y: "100%"
        }
    }
};
function $e53c11b120069459$export$76af7f35258e628d(options) {
    var _a;
    const side = (_a = options == null ? void 0 : options.direction) != null ? _a : "right";
    switch(side){
        case "right":
            return $e53c11b120069459$export$55b7325ba41bb523.slideRight;
        case "left":
            return $e53c11b120069459$export$55b7325ba41bb523.slideLeft;
        case "bottom":
            return $e53c11b120069459$export$55b7325ba41bb523.slideDown;
        case "top":
            return $e53c11b120069459$export$55b7325ba41bb523.slideUp;
        default:
            return $e53c11b120069459$export$55b7325ba41bb523.slideRight;
    }
}
var $e53c11b120069459$export$f995eb860f745cb = {
    enter: {
        duration: 0.2,
        ease: $e53c11b120069459$export$9ee1d08bb6db426f.easeOut
    },
    exit: {
        duration: 0.1,
        ease: $e53c11b120069459$export$9ee1d08bb6db426f.easeIn
    }
};
var $e53c11b120069459$export$fc492bd0f1c91c = {
    enter: (transition, delay)=>({
            ...transition,
            delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["enter"]
        }),
    exit: (transition, delay)=>({
            ...transition,
            delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["exit"]
        })
};





var $acw62 = parcelRequire("acw62");

"use client";
var $cb476d4702afcfc2$var$isNumeric = (value)=>value != null && parseInt(value.toString(), 10) > 0;
var $cb476d4702afcfc2$var$defaultTransitions = {
    exit: {
        height: {
            duration: 0.2,
            ease: (0, $e53c11b120069459$export$9ee1d08bb6db426f).ease
        },
        opacity: {
            duration: 0.3,
            ease: (0, $e53c11b120069459$export$9ee1d08bb6db426f).ease
        }
    },
    enter: {
        height: {
            duration: 0.3,
            ease: (0, $e53c11b120069459$export$9ee1d08bb6db426f).ease
        },
        opacity: {
            duration: 0.4,
            ease: (0, $e53c11b120069459$export$9ee1d08bb6db426f).ease
        }
    }
};
var $cb476d4702afcfc2$var$variants = {
    exit: ({ animateOpacity: animateOpacity, startingHeight: startingHeight, transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        return {
            ...animateOpacity && {
                opacity: $cb476d4702afcfc2$var$isNumeric(startingHeight) ? 1 : 0
            },
            height: startingHeight,
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).exit($cb476d4702afcfc2$var$defaultTransitions.exit, delay)
        };
    },
    enter: ({ animateOpacity: animateOpacity, endingHeight: endingHeight, transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        return {
            ...animateOpacity && {
                opacity: 1
            },
            height: endingHeight,
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).enter($cb476d4702afcfc2$var$defaultTransitions.enter, delay)
        };
    }
};
var $cb476d4702afcfc2$export$78768a9af065a7b = (0, $acw62.forwardRef)((props, ref)=>{
    const { in: isOpen, unmountOnExit: unmountOnExit, animateOpacity: animateOpacity = true, startingHeight: startingHeight = 0, endingHeight: endingHeight = "auto", style: style, className: className, transition: transition, transitionEnd: transitionEnd, ...rest } = props;
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setMounted(true);
        });
        return ()=>clearTimeout(timeout);
    }, []);
    (0, $abe97432afb3d989$export$c106dd0671a0fc2d)({
        condition: Number(startingHeight) > 0 && !!unmountOnExit,
        message: `startingHeight and unmountOnExit are mutually exclusive. You can't use them together`
    });
    const hasStartingHeight = parseFloat(startingHeight.toString()) > 0;
    const custom = {
        startingHeight: startingHeight,
        endingHeight: endingHeight,
        animateOpacity: animateOpacity,
        transition: !mounted ? {
            enter: {
                duration: 0
            }
        } : transition,
        transitionEnd: {
            enter: transitionEnd == null ? void 0 : transitionEnd.enter,
            exit: unmountOnExit ? transitionEnd == null ? void 0 : transitionEnd.exit : {
                ...transitionEnd == null ? void 0 : transitionEnd.exit,
                display: hasStartingHeight ? "block" : "none"
            }
        }
    };
    const show = unmountOnExit ? isOpen : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        initial: false,
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            ...rest,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-collapse", className),
            style: {
                overflow: "hidden",
                display: "block",
                ...style
            },
            custom: custom,
            variants: $cb476d4702afcfc2$var$variants,
            initial: unmountOnExit ? "exit" : false,
            animate: animate,
            exit: "exit"
        })
    });
});
$cb476d4702afcfc2$export$78768a9af065a7b.displayName = "Collapse";




"use client";
var $7ddf2a6aa068c6d3$export$7cad6f17fd6e117b = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function AccordionPanel2(props, ref) {
    const { className: className, motionProps: motionProps, ...rest } = props;
    const { reduceMotion: reduceMotion } = (0, $cc829c37e1308ee7$export$33b38874135ce337)();
    const { getPanelProps: getPanelProps, isOpen: isOpen } = (0, $9680d13bde45826d$export$26f4eabe9fa88f4f)();
    const panelProps = getPanelProps(rest, ref);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-accordion__panel", className);
    const styles = (0, $9680d13bde45826d$export$d8716a81161bb5d8)();
    if (!reduceMotion) delete panelProps.hidden;
    const child = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...panelProps,
        __css: styles.panel,
        className: _className
    });
    if (!reduceMotion) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cb476d4702afcfc2$export$78768a9af065a7b), {
        in: isOpen,
        ...motionProps,
        children: child
    });
    return child;
});
$7ddf2a6aa068c6d3$export$7cad6f17fd6e117b.displayName = "AccordionPanel";


"use client";
var [$cdd8a3cf700da934$export$459c44ebaee7a992, $cdd8a3cf700da934$export$8c19fa467c621c61] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `BreadcrumbStylesContext`,
    errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
});



// src/index.ts

var $acw62 = parcelRequire("acw62");
function $197fffec5094e9ee$export$b2c43d7d050b2e63(children) {
    return (0, $acw62.Children).toArray(children).filter((child)=>(0, $acw62.isValidElement)(child));
}




var $acw62 = parcelRequire("acw62");

"use client";
var $2bafe6f699b1942c$export$dabcc1ec9dd9d1cc = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Breadcrumb2(props, ref) {
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Breadcrumb", props);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const { children: children, spacing: spacing = "0.5rem", separator: separator = "/", className: className, listProps: listProps, ...rest } = ownProps;
    const validChildren = (0, $197fffec5094e9ee$export$b2c43d7d050b2e63)(children);
    const count = validChildren.length;
    const clones = validChildren.map((child, index)=>(0, $acw62.cloneElement)(child, {
            separator: separator,
            spacing: spacing,
            isLastChild: count === index + 1
        }));
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-breadcrumb", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).nav, {
        ref: ref,
        "aria-label": "breadcrumb",
        className: _className,
        __css: styles.container,
        ...rest,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cdd8a3cf700da934$export$459c44ebaee7a992), {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).ol, {
                className: "chakra-breadcrumb__list",
                ...listProps,
                __css: {
                    display: "flex",
                    alignItems: "center",
                    ...styles.list
                },
                children: clones
            })
        })
    });
});
$2bafe6f699b1942c$export$dabcc1ec9dd9d1cc.displayName = "Breadcrumb";





"use client";
var $869a1a6e30ba82b2$export$ca871f5ef145e138 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function BreadcrumbLink2(props, ref) {
    const { isCurrentPage: isCurrentPage, as: as, className: className, href: href, ...rest } = props;
    const styles = (0, $cdd8a3cf700da934$export$8c19fa467c621c61)();
    const sharedProps = {
        ref: ref,
        as: as,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-breadcrumb__link", className),
        ...rest
    };
    if (isCurrentPage) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
        "aria-current": "page",
        __css: styles.link,
        ...sharedProps
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).a, {
        __css: styles.link,
        href: href,
        ...sharedProps
    });
});
$869a1a6e30ba82b2$export$ca871f5ef145e138.displayName = "BreadcrumbLink";





"use client";
var $c1dae6e6407b31e4$export$10bb7d797ee5079f = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function BreadcrumbSeparator2(props, ref) {
    const { spacing: spacing, ...rest } = props;
    const styles = (0, $cdd8a3cf700da934$export$8c19fa467c621c61)();
    const separatorStyles = {
        mx: spacing,
        ...styles.separator
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
        ref: ref,
        role: "presentation",
        ...rest,
        __css: separatorStyles
    });
});
$c1dae6e6407b31e4$export$10bb7d797ee5079f.displayName = "BreadcrumbSeparator";







var $acw62 = parcelRequire("acw62");

"use client";
var $2bea20c9a7276351$export$c13f210c706eb549 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function BreadcrumbItem2(props, ref) {
    const { isCurrentPage: isCurrentPage, separator: separator, isLastChild: isLastChild, spacing: spacing, children: children, className: className, ...rest } = props;
    const validChildren = (0, $197fffec5094e9ee$export$b2c43d7d050b2e63)(children);
    const clones = validChildren.map((child)=>{
        if (child.type === (0, $869a1a6e30ba82b2$export$ca871f5ef145e138)) return (0, $acw62.cloneElement)(child, {
            isCurrentPage: isCurrentPage
        });
        if (child.type === (0, $c1dae6e6407b31e4$export$10bb7d797ee5079f)) return (0, $acw62.cloneElement)(child, {
            spacing: spacing,
            children: child.props.children || separator
        });
        return child;
    });
    const styles = (0, $cdd8a3cf700da934$export$8c19fa467c621c61)();
    const itemStyles = {
        display: "inline-flex",
        alignItems: "center",
        ...styles.item
    };
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-breadcrumb__list-item", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).li, {
        ref: ref,
        className: _className,
        ...rest,
        __css: itemStyles,
        children: [
            clones,
            !isLastChild && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c1dae6e6407b31e4$export$10bb7d797ee5079f), {
                spacing: spacing,
                children: separator
            })
        ]
    });
});
$2bea20c9a7276351$export$c13f210c706eb549.displayName = "BreadcrumbItem";


var $acw62 = parcelRequire("acw62");
"use client";
function $5efc0ab8376c922b$export$867b668ad7ef61e5(value) {
    const [isButton, setIsButton] = (0, $acw62.useState)(!value);
    const refCallback = (0, $acw62.useCallback)((node)=>{
        if (!node) return;
        setIsButton(node.tagName === "BUTTON");
    }, []);
    const type = isButton ? "button" : void 0;
    return {
        ref: refCallback,
        type: type
    };
}



"use client";
var [$7e55cb64d43f1645$export$85041a2bb9328e33, $7e55cb64d43f1645$export$749e21be8b14b968] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "ButtonGroupContext"
});





var $acw62 = parcelRequire("acw62");

"use client";
function $3033a23dbf9db859$export$e1c22a2ee2645e36(props) {
    const { children: children, className: className, ...rest } = props;
    const _children = (0, $acw62.isValidElement)(children) ? (0, $acw62.cloneElement)(children, {
        "aria-hidden": true,
        focusable: false
    }) : children;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-button__icon", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
        display: "inline-flex",
        alignSelf: "center",
        flexShrink: 0,
        ...rest,
        className: _className,
        children: _children
    });
}
$3033a23dbf9db859$export$e1c22a2ee2645e36.displayName = "ButtonIcon";






var $acw62 = parcelRequire("acw62");

"use client";
function $444db0b46076cf5f$export$f2c034885dd3ba7b(props) {
    const { label: label, placement: placement, spacing: spacing = "0.5rem", children: children = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6c35780027222e0c$export$7f7cbe89f1eacd2), {
        color: "currentColor",
        width: "1em",
        height: "1em"
    }), className: className, __css: __css, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-button__spinner", className);
    const marginProp = placement === "start" ? "marginEnd" : "marginStart";
    const spinnerStyles = (0, $acw62.useMemo)(()=>({
            display: "flex",
            alignItems: "center",
            position: label ? "relative" : "absolute",
            [marginProp]: label ? spacing : 0,
            fontSize: "1em",
            lineHeight: "normal",
            ...__css
        }), [
        __css,
        label,
        marginProp,
        spacing
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        className: _className,
        ...rest,
        __css: spinnerStyles,
        children: children
    });
}
$444db0b46076cf5f$export$f2c034885dd3ba7b.displayName = "ButtonSpinner";






var $acw62 = parcelRequire("acw62");

"use client";
var $df191e1c46987458$export$353f5b6fc5456de1 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const group = (0, $7e55cb64d43f1645$export$749e21be8b14b968)();
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Button", {
        ...group,
        ...props
    });
    const { isDisabled: isDisabled = group == null ? void 0 : group.isDisabled, isLoading: isLoading, isActive: isActive, children: children, leftIcon: leftIcon, rightIcon: rightIcon, loadingText: loadingText, iconSpacing: iconSpacing = "0.5rem", type: type, spinner: spinner, spinnerPlacement: spinnerPlacement = "start", className: className, as: as, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const buttonStyles = (0, $acw62.useMemo)(()=>{
        const _focus = {
            ...styles == null ? void 0 : styles["_focus"],
            zIndex: 1
        };
        return {
            display: "inline-flex",
            appearance: "none",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none",
            position: "relative",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            outline: "none",
            ...styles,
            ...!!group && {
                _focus: _focus
            }
        };
    }, [
        styles,
        group
    ]);
    const { ref: _ref, type: defaultType } = (0, $5efc0ab8376c922b$export$867b668ad7ef61e5)(as);
    const contentProps = {
        rightIcon: rightIcon,
        leftIcon: leftIcon,
        iconSpacing: iconSpacing,
        children: children
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).button, {
        ref: (0, $457901a59fc0a4e6$export$74665b213cb5c4cf)(ref, _ref),
        as: as,
        type: type != null ? type : defaultType,
        "data-active": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isActive),
        "data-loading": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isLoading),
        __css: buttonStyles,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-button", className),
        ...rest,
        disabled: isDisabled || isLoading,
        children: [
            isLoading && spinnerPlacement === "start" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $444db0b46076cf5f$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--start",
                label: loadingText,
                placement: "start",
                spacing: iconSpacing,
                children: spinner
            }),
            isLoading ? loadingText || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
                opacity: 0,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($df191e1c46987458$var$ButtonContent, {
                    ...contentProps
                })
            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($df191e1c46987458$var$ButtonContent, {
                ...contentProps
            }),
            isLoading && spinnerPlacement === "end" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $444db0b46076cf5f$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--end",
                label: loadingText,
                placement: "end",
                spacing: iconSpacing,
                children: spinner
            })
        ]
    });
});
$df191e1c46987458$export$353f5b6fc5456de1.displayName = "Button";
function $df191e1c46987458$var$ButtonContent(props) {
    const { leftIcon: leftIcon, rightIcon: rightIcon, children: children, iconSpacing: iconSpacing } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            leftIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3033a23dbf9db859$export$e1c22a2ee2645e36), {
                marginEnd: iconSpacing,
                children: leftIcon
            }),
            children,
            rightIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3033a23dbf9db859$export$e1c22a2ee2645e36), {
                marginStart: iconSpacing,
                children: rightIcon
            })
        ]
    });
}


var $acw62 = parcelRequire("acw62");
"use client";
function $ffc8e0be6163a375$export$c4008d6206288921(isChecked) {
    const [previousIsChecked, setPreviousIsChecked] = (0, $acw62.useState)(isChecked);
    const [shouldAnimate, setShouldAnimate] = (0, $acw62.useState)(false);
    if (isChecked !== previousIsChecked) {
        setShouldAnimate(true);
        setPreviousIsChecked(isChecked);
    }
    return shouldAnimate;
}



"use client";
var [$ce509139dd486c93$export$95a3c27e07a551c3, $ce509139dd486c93$export$5575526870d5c2ae] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "CheckboxGroupContext",
    strict: false
});




"use client";
function $9153ea510dde82a0$var$CheckIcon(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).svg, {
        width: "1.2em",
        viewBox: "0 0 12 10",
        style: {
            fill: "none",
            strokeWidth: 2,
            stroke: "currentColor",
            strokeDasharray: 16
        },
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polyline", {
            points: "1.5 6 4.5 9 10.5 1"
        })
    });
}
function $9153ea510dde82a0$var$IndeterminateIcon(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).svg, {
        width: "1.2em",
        viewBox: "0 0 24 24",
        style: {
            stroke: "currentColor",
            strokeWidth: 4
        },
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("line", {
            x1: "21",
            x2: "3",
            y1: "12",
            y2: "12"
        })
    });
}
function $9153ea510dde82a0$export$c0a1936901b0e55(props) {
    const { isIndeterminate: isIndeterminate, isChecked: isChecked, ...rest } = props;
    const BaseIcon = isIndeterminate ? $9153ea510dde82a0$var$IndeterminateIcon : $9153ea510dde82a0$var$CheckIcon;
    return isChecked || isIndeterminate ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%"
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(BaseIcon, {
            ...rest
        })
    }) : null;
}







var $acw62 = parcelRequire("acw62");

"use client";
var [$9937ca16e333eb3d$var$FormControlStylesProvider, $9937ca16e333eb3d$export$2824197c2cd75b1e] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `FormControlStylesContext`,
    errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
});
var [$9937ca16e333eb3d$var$FormControlProvider, $9937ca16e333eb3d$export$97a2352498389516] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "FormControlContext"
});
function $9937ca16e333eb3d$var$useFormControlProvider(props) {
    const { id: idProp, isRequired: isRequired, isInvalid: isInvalid, isDisabled: isDisabled, isReadOnly: isReadOnly, ...htmlProps } = props;
    const uuid = (0, $acw62.useId)();
    const id = idProp || `field-${uuid}`;
    const labelId = `${id}-label`;
    const feedbackId = `${id}-feedback`;
    const helpTextId = `${id}-helptext`;
    const [hasFeedbackText, setHasFeedbackText] = (0, $acw62.useState)(false);
    const [hasHelpText, setHasHelpText] = (0, $acw62.useState)(false);
    const [isFocused, setFocus] = (0, $acw62.useState)(false);
    const getHelpTextProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            id: helpTextId,
            ...props2,
            /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */ ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setHasHelpText(true);
            })
        }), [
        helpTextId
    ]);
    const getLabelProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            "data-focus": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isFocused),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isReadOnly),
            id: props2.id !== void 0 ? props2.id : labelId,
            htmlFor: props2.htmlFor !== void 0 ? props2.htmlFor : id
        }), [
        id,
        isDisabled,
        isFocused,
        isInvalid,
        isReadOnly,
        labelId
    ]);
    const getErrorMessageProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            id: feedbackId,
            ...props2,
            /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */ ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setHasFeedbackText(true);
            }),
            "aria-live": "polite"
        }), [
        feedbackId
    ]);
    const getRootProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ...htmlProps,
            ref: forwardedRef,
            role: "group",
            "data-focus": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isFocused),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isReadOnly)
        }), [
        htmlProps,
        isDisabled,
        isFocused,
        isInvalid,
        isReadOnly
    ]);
    const getRequiredIndicatorProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            role: "presentation",
            "aria-hidden": true,
            children: props2.children || "*"
        }), []);
    return {
        isRequired: !!isRequired,
        isInvalid: !!isInvalid,
        isReadOnly: !!isReadOnly,
        isDisabled: !!isDisabled,
        isFocused: !!isFocused,
        onFocus: ()=>setFocus(true),
        onBlur: ()=>setFocus(false),
        hasFeedbackText: hasFeedbackText,
        setHasFeedbackText: setHasFeedbackText,
        hasHelpText: hasHelpText,
        setHasHelpText: setHasHelpText,
        id: id,
        labelId: labelId,
        feedbackId: feedbackId,
        helpTextId: helpTextId,
        htmlProps: htmlProps,
        getHelpTextProps: getHelpTextProps,
        getErrorMessageProps: getErrorMessageProps,
        getRootProps: getRootProps,
        getLabelProps: getLabelProps,
        getRequiredIndicatorProps: getRequiredIndicatorProps
    };
}
var $9937ca16e333eb3d$export$fe5d99d8691b3f62 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function FormControl2(props, ref) {
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Form", props);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const { getRootProps: getRootProps, htmlProps: _, ...context } = $9937ca16e333eb3d$var$useFormControlProvider(ownProps);
    const className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-form-control", props.className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9937ca16e333eb3d$var$FormControlProvider, {
        value: context,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9937ca16e333eb3d$var$FormControlStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                ...getRootProps({}, ref),
                className: className,
                __css: styles["container"]
            })
        })
    });
});
$9937ca16e333eb3d$export$fe5d99d8691b3f62.displayName = "FormControl";
var $9937ca16e333eb3d$export$75f9ed82f6172e27 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function FormHelperText2(props, ref) {
    const field = $9937ca16e333eb3d$export$97a2352498389516();
    const styles = $9937ca16e333eb3d$export$2824197c2cd75b1e();
    const className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-form__helper-text", props.className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...field == null ? void 0 : field.getHelpTextProps(props, ref),
        __css: styles.helperText,
        className: className
    });
});
$9937ca16e333eb3d$export$75f9ed82f6172e27.displayName = "FormHelperText";



"use client";
function $95e8035d7d1d6064$export$62ecd8ad1bbe1a18(props) {
    const { isDisabled: isDisabled, isInvalid: isInvalid, isReadOnly: isReadOnly, isRequired: isRequired, ...rest } = $95e8035d7d1d6064$export$1819803dd567b95f(props);
    return {
        ...rest,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        "aria-invalid": (0, $abe97432afb3d989$export$91a6105db3d4be7b)(isInvalid),
        "aria-required": (0, $abe97432afb3d989$export$91a6105db3d4be7b)(isRequired),
        "aria-readonly": (0, $abe97432afb3d989$export$91a6105db3d4be7b)(isReadOnly)
    };
}
function $95e8035d7d1d6064$export$1819803dd567b95f(props) {
    var _a, _b, _c;
    const field = (0, $9937ca16e333eb3d$export$97a2352498389516)();
    const { id: id, disabled: disabled, readOnly: readOnly, required: required, isRequired: isRequired, isInvalid: isInvalid, isReadOnly: isReadOnly, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, ...rest } = props;
    const labelIds = props["aria-describedby"] ? [
        props["aria-describedby"]
    ] : [];
    if ((field == null ? void 0 : field.hasFeedbackText) && (field == null ? void 0 : field.isInvalid)) labelIds.push(field.feedbackId);
    if (field == null ? void 0 : field.hasHelpText) labelIds.push(field.helpTextId);
    return {
        ...rest,
        "aria-describedby": labelIds.join(" ") || void 0,
        id: id != null ? id : field == null ? void 0 : field.id,
        isDisabled: (_a = disabled != null ? disabled : isDisabled) != null ? _a : field == null ? void 0 : field.isDisabled,
        isReadOnly: (_b = readOnly != null ? readOnly : isReadOnly) != null ? _b : field == null ? void 0 : field.isReadOnly,
        isRequired: (_c = required != null ? required : isRequired) != null ? _c : field == null ? void 0 : field.isRequired,
        isInvalid: isInvalid != null ? isInvalid : field == null ? void 0 : field.isInvalid,
        onFocus: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(field == null ? void 0 : field.onFocus, onFocus),
        onBlur: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(field == null ? void 0 : field.onBlur, onBlur)
    };
}







"use client";
// src/visually-hidden.style.ts
var $c50ae480a15f8344$export$8fecac46448b5689 = {
    border: "0",
    clip: "rect(0, 0, 0, 0)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};


// src/index.ts
// src/attrs.ts
var $b06ec5ff205338e5$export$5cc3b7b83e34ade7 = (guard)=>{
    return guard ? "" : void 0;
};
var $b06ec5ff205338e5$export$91a6105db3d4be7b = (guard)=>{
    return guard ? "true" : void 0;
};
// src/is-html-element.ts
function $b06ec5ff205338e5$export$1b3bfaa9684536aa(value) {
    return typeof value === "object" && value?.nodeType === Node.ELEMENT_NODE && typeof value?.nodeName === "string";
}
// src/contains.ts
function $b06ec5ff205338e5$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    if (!$b06ec5ff205338e5$export$1b3bfaa9684536aa(parent) || !$b06ec5ff205338e5$export$1b3bfaa9684536aa(child)) return false;
    return parent === child || parent.contains(child);
}
var $b06ec5ff205338e5$export$245b4e23316e2551 = (event)=>$b06ec5ff205338e5$export$2344b14b097df817(event.currentTarget, event.target);
// src/create-scope.ts
var $b06ec5ff205338e5$var$getDocument = (node)=>{
    if (node.nodeType === Node.DOCUMENT_NODE) return node;
    return node.ownerDocument ?? document;
};
function $b06ec5ff205338e5$export$41a9651decfe2bde(methods) {
    const screen = {
        getRootNode: (ctx)=>ctx.getRootNode?.() ?? document,
        getDoc: (ctx)=>$b06ec5ff205338e5$var$getDocument(screen.getRootNode(ctx)),
        getWin: (ctx)=>screen.getDoc(ctx).defaultView ?? window,
        getActiveElement: (ctx)=>screen.getDoc(ctx).activeElement,
        getById: (ctx, id)=>screen.getRootNode(ctx).getElementById(id)
    };
    return {
        ...screen,
        ...methods
    };
}
// src/env.ts
var $b06ec5ff205338e5$var$isDocument = (el)=>el.nodeType === Node.DOCUMENT_NODE;
function $b06ec5ff205338e5$export$f65ca476c09acec0(el) {
    if ($b06ec5ff205338e5$var$isDocument(el)) return el;
    return el?.ownerDocument ?? document;
}
function $b06ec5ff205338e5$export$38b2d434cce3ea22(el) {
    return el?.ownerDocument.defaultView ?? window;
}
// src/get-active-element.ts
function $b06ec5ff205338e5$export$cd4e5573fbe2b576(el) {
    let activeElement = el.ownerDocument.activeElement;
    while(activeElement?.shadowRoot){
        const el2 = activeElement.shadowRoot.activeElement;
        if (el2 === activeElement) break;
        else activeElement = el2;
    }
    return activeElement;
}
// src/get-by-id.ts
function $b06ec5ff205338e5$export$9c576e34c0103ac9(v, id) {
    return v.find((node)=>node.id === id);
}
function $b06ec5ff205338e5$export$b3919dc3604f191c(v, id) {
    const item = $b06ec5ff205338e5$export$9c576e34c0103ac9(v, id);
    return item ? v.indexOf(item) : -1;
}
function $b06ec5ff205338e5$export$f3d559454b8c0d00(v, id, loop = true) {
    let idx = $b06ec5ff205338e5$export$b3919dc3604f191c(v, id);
    idx = loop ? (idx + 1) % v.length : Math.min(idx + 1, v.length - 1);
    return v[idx];
}
function $b06ec5ff205338e5$export$326274ae311c62fd(v, id, loop = true) {
    let idx = $b06ec5ff205338e5$export$b3919dc3604f191c(v, id);
    if (idx === -1) return loop ? v[v.length - 1] : null;
    idx = loop ? (idx - 1 + v.length) % v.length : Math.max(0, idx - 1);
    return v[idx];
}
// src/get-by-text.ts
var $b06ec5ff205338e5$var$getValueText = (item)=>item.dataset.valuetext ?? item.textContent ?? "";
var $b06ec5ff205338e5$var$match = (valueText, query2)=>valueText.toLowerCase().startsWith(query2.toLowerCase());
var $b06ec5ff205338e5$var$wrap = (v, idx)=>{
    return v.map((_, index)=>v[(Math.max(idx, 0) + index) % v.length]);
};
function $b06ec5ff205338e5$export$cade8123d3662a60(v, text, currentId) {
    const index = currentId ? $b06ec5ff205338e5$export$b3919dc3604f191c(v, currentId) : -1;
    let items = currentId ? $b06ec5ff205338e5$var$wrap(v, index) : v;
    const isSingleKey = text.length === 1;
    if (isSingleKey) items = items.filter((item)=>item.id !== currentId);
    return items.find((item)=>$b06ec5ff205338e5$var$match($b06ec5ff205338e5$var$getValueText(item), text));
}
// src/get-by-typeahead.ts
function $b06ec5ff205338e5$var$getByTypeaheadImpl(_items, options) {
    const { state: state, activeId: activeId, key: key, timeout: timeout = 350 } = options;
    const search = state.keysSoFar + key;
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const query2 = isRepeated ? search[0] : search;
    let items = _items.slice();
    const next = $b06ec5ff205338e5$export$cade8123d3662a60(items, query2, activeId);
    function cleanup() {
        clearTimeout(state.timer);
        state.timer = -1;
    }
    function update(value) {
        state.keysSoFar = value;
        cleanup();
        if (value !== "") state.timer = +setTimeout(()=>{
            update("");
            cleanup();
        }, timeout);
    }
    update(search);
    return next;
}
var $b06ec5ff205338e5$export$ec2dfd1ac255c804 = /* @__PURE__ */ Object.assign($b06ec5ff205338e5$var$getByTypeaheadImpl, {
    defaultOptions: {
        keysSoFar: "",
        timer: -1
    },
    isValidEvent: $b06ec5ff205338e5$var$isValidTypeaheadEvent
});
function $b06ec5ff205338e5$var$isValidTypeaheadEvent(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
// src/get-computed-style.ts
var $b06ec5ff205338e5$var$styleCache = /* @__PURE__ */ new WeakMap();
function $b06ec5ff205338e5$export$3735103072e4a80(el) {
    if (!$b06ec5ff205338e5$var$styleCache.has(el)) {
        const win = el.ownerDocument.defaultView || window;
        $b06ec5ff205338e5$var$styleCache.set(el, win.getComputedStyle(el));
    }
    return $b06ec5ff205338e5$var$styleCache.get(el);
}
// src/get-event-target.ts
function $b06ec5ff205338e5$export$e58f029f0fbfdb29(event) {
    return event.composedPath?.()[0] ?? event.target;
}
// src/get-scroll-parent.ts
function $b06ec5ff205338e5$var$isScrollParent(el) {
    const win = el.ownerDocument.defaultView || window;
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = win.getComputedStyle(el);
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function $b06ec5ff205338e5$export$58081aedf094d85b(el) {
    if (el.localName === "html") return el;
    return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function $b06ec5ff205338e5$export$cfa2225e87938781(el) {
    if ([
        "html",
        "body",
        "#document"
    ].includes(el.localName)) return el.ownerDocument.body;
    if ($b06ec5ff205338e5$export$1b3bfaa9684536aa(el) && $b06ec5ff205338e5$var$isScrollParent(el)) return el;
    return $b06ec5ff205338e5$export$cfa2225e87938781($b06ec5ff205338e5$export$58081aedf094d85b(el));
}
function $b06ec5ff205338e5$export$94ed1c92c7beeb22(el, list = []) {
    const parent = $b06ec5ff205338e5$export$cfa2225e87938781(el);
    const isBody = parent === el.ownerDocument.body;
    const win = parent.ownerDocument.defaultView || window;
    const target = isBody ? [
        win
    ].concat(win.visualViewport || [], $b06ec5ff205338e5$var$isScrollParent(parent) ? parent : []) : parent;
    const parents = list.concat(target);
    return isBody ? parents : parents.concat($b06ec5ff205338e5$export$94ed1c92c7beeb22($b06ec5ff205338e5$export$58081aedf094d85b(target)));
}
// src/is-editable-element.ts
function $b06ec5ff205338e5$export$2780cb57de98fa3a(el) {
    if (el == null || !$b06ec5ff205338e5$export$1b3bfaa9684536aa(el)) return false;
    try {
        const win = el.ownerDocument.defaultView || window;
        return el instanceof win.HTMLInputElement && el.selectionStart != null || /(textarea|select)/.test(el.localName) || el.isContentEditable;
    } catch  {
        return false;
    }
}
// src/platform.ts
var $b06ec5ff205338e5$export$9f57505b7bd8dae = ()=>typeof document !== "undefined";
function $b06ec5ff205338e5$export$867a782338812cb4() {
    const agent = navigator.userAgentData;
    return agent?.platform ?? navigator.platform;
}
var $b06ec5ff205338e5$var$pt = (v)=>$b06ec5ff205338e5$export$9f57505b7bd8dae() && v.test($b06ec5ff205338e5$export$867a782338812cb4());
var $b06ec5ff205338e5$var$ua = (v)=>$b06ec5ff205338e5$export$9f57505b7bd8dae() && v.test(navigator.userAgent);
var $b06ec5ff205338e5$var$vn = (v)=>$b06ec5ff205338e5$export$9f57505b7bd8dae() && v.test(navigator.vendor);
var $b06ec5ff205338e5$export$a1d0d20ee9546562 = ()=>$b06ec5ff205338e5$export$9f57505b7bd8dae() && !!navigator.maxTouchPoints;
var $b06ec5ff205338e5$export$9ac100e40613ea10 = ()=>$b06ec5ff205338e5$var$pt(/^Mac/) && !$b06ec5ff205338e5$export$a1d0d20ee9546562();
var $b06ec5ff205338e5$export$186c6964ca17d99 = ()=>$b06ec5ff205338e5$var$pt(/^iPhone/);
var $b06ec5ff205338e5$export$95df08bae54cb4df = ()=>$b06ec5ff205338e5$export$5231b1f790f5c149() && $b06ec5ff205338e5$var$vn(/apple/i);
var $b06ec5ff205338e5$export$b7d78993b74f766d = ()=>$b06ec5ff205338e5$var$ua(/firefox\//i);
var $b06ec5ff205338e5$export$5231b1f790f5c149 = ()=>$b06ec5ff205338e5$var$pt(/mac|iphone|ipad|ipod/i);
var $b06ec5ff205338e5$export$41a665f744414057 = ()=>$b06ec5ff205338e5$export$5231b1f790f5c149() && !$b06ec5ff205338e5$export$9ac100e40613ea10();
// src/query.ts
function $b06ec5ff205338e5$export$dcd0d083aa86c355(root, selector) {
    return Array.from(root?.querySelectorAll(selector) ?? []);
}
function $b06ec5ff205338e5$export$2fa187e846a241c4(root, selector) {
    return root?.querySelector(selector);
}
// src/raf.ts
function $b06ec5ff205338e5$export$bdd553fddd433dcb(fn) {
    const set = /* @__PURE__ */ new Set();
    function raf2(fn2) {
        const id = globalThis.requestAnimationFrame(fn2);
        set.add(()=>globalThis.cancelAnimationFrame(id));
    }
    raf2(()=>raf2(fn));
    return function cleanup() {
        set.forEach((fn2)=>fn2());
    };
}
function $b06ec5ff205338e5$export$27f233d61a9e2fa4(fn) {
    const id = globalThis.requestAnimationFrame(fn);
    return ()=>{
        globalThis.cancelAnimationFrame(id);
    };
}
// src/index.ts
var $b06ec5ff205338e5$export$e2f9a725ee199e81 = 2147483647;


var $10f5b85675c7b32e$var$hasSetup = false;
var $10f5b85675c7b32e$var$modality = null;
var $10f5b85675c7b32e$var$hasEventBeforeFocus = false;
var $10f5b85675c7b32e$var$hasBlurredWindowRecently = false;
var $10f5b85675c7b32e$var$handlers = /* @__PURE__ */ new Set();
function $10f5b85675c7b32e$var$trigger(modality2, event) {
    $10f5b85675c7b32e$var$handlers.forEach((handler)=>handler(modality2, event));
}
var $10f5b85675c7b32e$var$isMac = typeof window !== "undefined" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : false;
function $10f5b85675c7b32e$var$isValidKey(e) {
    return !(e.metaKey || !$10f5b85675c7b32e$var$isMac && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $10f5b85675c7b32e$var$onKeyboardEvent(event) {
    $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
    if ($10f5b85675c7b32e$var$isValidKey(event)) {
        $10f5b85675c7b32e$var$modality = "keyboard";
        $10f5b85675c7b32e$var$trigger("keyboard", event);
    }
}
function $10f5b85675c7b32e$var$onPointerEvent(event) {
    $10f5b85675c7b32e$var$modality = "pointer";
    if (event.type === "mousedown" || event.type === "pointerdown") {
        $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
        const target = event.composedPath ? event.composedPath()[0] : event.target;
        let matches = false;
        try {
            matches = target.matches(":focus-visible");
        } catch  {}
        if (matches) return;
        $10f5b85675c7b32e$var$trigger("pointer", event);
    }
}
function $10f5b85675c7b32e$var$isVirtualClick(event) {
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    return event.detail === 0 && !event.pointerType;
}
function $10f5b85675c7b32e$var$onClickEvent(e) {
    if ($10f5b85675c7b32e$var$isVirtualClick(e)) {
        $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
        $10f5b85675c7b32e$var$modality = "virtual";
    }
}
function $10f5b85675c7b32e$var$onWindowFocus(event) {
    if (event.target === window || event.target === document) return;
    if (!$10f5b85675c7b32e$var$hasEventBeforeFocus && !$10f5b85675c7b32e$var$hasBlurredWindowRecently) {
        $10f5b85675c7b32e$var$modality = "virtual";
        $10f5b85675c7b32e$var$trigger("virtual", event);
    }
    $10f5b85675c7b32e$var$hasEventBeforeFocus = false;
    $10f5b85675c7b32e$var$hasBlurredWindowRecently = false;
}
function $10f5b85675c7b32e$var$onWindowBlur() {
    $10f5b85675c7b32e$var$hasEventBeforeFocus = false;
    $10f5b85675c7b32e$var$hasBlurredWindowRecently = true;
}
function $10f5b85675c7b32e$var$isFocusVisible() {
    return $10f5b85675c7b32e$var$modality !== "pointer";
}
function $10f5b85675c7b32e$var$setupGlobalFocusEvents() {
    if (!(0, $b06ec5ff205338e5$export$9f57505b7bd8dae)() || $10f5b85675c7b32e$var$hasSetup) return;
    const { focus: focus } = HTMLElement.prototype;
    HTMLElement.prototype.focus = function focusElement(...args) {
        $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
        focus.apply(this, args);
    };
    document.addEventListener("keydown", $10f5b85675c7b32e$var$onKeyboardEvent, true);
    document.addEventListener("keyup", $10f5b85675c7b32e$var$onKeyboardEvent, true);
    document.addEventListener("click", $10f5b85675c7b32e$var$onClickEvent, true);
    window.addEventListener("focus", $10f5b85675c7b32e$var$onWindowFocus, true);
    window.addEventListener("blur", $10f5b85675c7b32e$var$onWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        document.addEventListener("pointerdown", $10f5b85675c7b32e$var$onPointerEvent, true);
        document.addEventListener("pointermove", $10f5b85675c7b32e$var$onPointerEvent, true);
        document.addEventListener("pointerup", $10f5b85675c7b32e$var$onPointerEvent, true);
    } else {
        document.addEventListener("mousedown", $10f5b85675c7b32e$var$onPointerEvent, true);
        document.addEventListener("mousemove", $10f5b85675c7b32e$var$onPointerEvent, true);
        document.addEventListener("mouseup", $10f5b85675c7b32e$var$onPointerEvent, true);
    }
    $10f5b85675c7b32e$var$hasSetup = true;
}
function $10f5b85675c7b32e$export$920b4983565c6f4d(fn) {
    $10f5b85675c7b32e$var$setupGlobalFocusEvents();
    fn($10f5b85675c7b32e$var$isFocusVisible());
    const handler = ()=>fn($10f5b85675c7b32e$var$isFocusVisible());
    $10f5b85675c7b32e$var$handlers.add(handler);
    return ()=>{
        $10f5b85675c7b32e$var$handlers.delete(handler);
    };
}
function $10f5b85675c7b32e$export$1238a82db5699f92(fn) {
    $10f5b85675c7b32e$var$setupGlobalFocusEvents();
    fn($10f5b85675c7b32e$var$modality);
    const handler = ()=>fn($10f5b85675c7b32e$var$modality);
    $10f5b85675c7b32e$var$handlers.add(handler);
    return ()=>{
        $10f5b85675c7b32e$var$handlers.delete(handler);
    };
}
function $10f5b85675c7b32e$export$8397ddfc504fdb9a(value) {
    $10f5b85675c7b32e$var$modality = value;
    $10f5b85675c7b32e$var$trigger(value, null);
}
function $10f5b85675c7b32e$export$630ff653c5ada6a9() {
    return $10f5b85675c7b32e$var$modality;
}



var $acw62 = parcelRequire("acw62");
"use client";
// ../../utilities/object-utils/src/omit.ts
function $28d15a1dba5741c2$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
function $28d15a1dba5741c2$export$e375f10ce42261c5(props = {}) {
    const formControlProps = (0, $95e8035d7d1d6064$export$1819803dd567b95f)(props);
    const { isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, isInvalid: isInvalid, id: id, onBlur: onBlur, onFocus: onFocus, "aria-describedby": ariaDescribedBy } = formControlProps;
    const { defaultChecked: defaultChecked, isChecked: checkedProp, isFocusable: isFocusable, onChange: onChange, isIndeterminate: isIndeterminate, name: name, value: value, tabIndex: tabIndex, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-invalid": ariaInvalid, ...rest } = props;
    const htmlProps = $28d15a1dba5741c2$var$omit(rest, [
        "isDisabled",
        "isReadOnly",
        "isRequired",
        "isInvalid",
        "id",
        "onBlur",
        "onFocus",
        "aria-describedby"
    ]);
    const onChangeProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onChange);
    const onBlurProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onBlur);
    const onFocusProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onFocus);
    const [isFocusVisible, setIsFocusVisible] = (0, $acw62.useState)(false);
    const [isFocused, setFocused] = (0, $acw62.useState)(false);
    const [isHovered, setHovered] = (0, $acw62.useState)(false);
    const [isActive, setActive] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        return (0, $10f5b85675c7b32e$export$920b4983565c6f4d)(setIsFocusVisible);
    }, []);
    const inputRef = (0, $acw62.useRef)(null);
    const [rootIsLabelElement, setRootIsLabelElement] = (0, $acw62.useState)(true);
    const [checkedState, setCheckedState] = (0, $acw62.useState)(!!defaultChecked);
    const isControlled = checkedProp !== void 0;
    const isChecked = isControlled ? checkedProp : checkedState;
    const handleChange = (0, $acw62.useCallback)((event)=>{
        if (isReadOnly || isDisabled) {
            event.preventDefault();
            return;
        }
        if (!isControlled) {
            if (isChecked) setCheckedState(event.target.checked);
            else setCheckedState(isIndeterminate ? true : event.target.checked);
        }
        onChangeProp == null || onChangeProp(event);
    }, [
        isReadOnly,
        isDisabled,
        isChecked,
        isControlled,
        isIndeterminate,
        onChangeProp
    ]);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (inputRef.current) inputRef.current.indeterminate = Boolean(isIndeterminate);
    }, [
        isIndeterminate
    ]);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (isDisabled) setFocused(false);
    }, [
        isDisabled,
        setFocused
    ]);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        const el = inputRef.current;
        if (!(el == null ? void 0 : el.form)) return;
        const formResetListener = ()=>{
            setCheckedState(!!defaultChecked);
        };
        el.form.addEventListener("reset", formResetListener);
        return ()=>{
            var _a;
            return (_a = el.form) == null ? void 0 : _a.removeEventListener("reset", formResetListener);
        };
    }, []);
    const trulyDisabled = isDisabled && !isFocusable;
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.key === " ") setActive(true);
    }, [
        setActive
    ]);
    const onKeyUp = (0, $acw62.useCallback)((event)=>{
        if (event.key === " ") setActive(false);
    }, [
        setActive
    ]);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!inputRef.current) return;
        const notInSync = inputRef.current.checked !== isChecked;
        if (notInSync) setCheckedState(inputRef.current.checked);
    }, [
        inputRef.current
    ]);
    const getCheckboxProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>{
        const onPressDown = (event)=>{
            if (isFocused) event.preventDefault();
            setActive(true);
        };
        return {
            ...props2,
            ref: forwardedRef,
            "data-active": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isActive),
            "data-hover": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isHovered),
            "data-checked": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isChecked),
            "data-focus": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isFocused && isFocusVisible),
            "data-indeterminate": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isIndeterminate),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isReadOnly),
            "aria-hidden": true,
            onMouseDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseDown, onPressDown),
            onMouseUp: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseUp, ()=>setActive(false)),
            onMouseEnter: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>setHovered(true)),
            onMouseLeave: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseLeave, ()=>setHovered(false))
        };
    }, [
        isActive,
        isChecked,
        isDisabled,
        isFocused,
        isFocusVisible,
        isHovered,
        isIndeterminate,
        isInvalid,
        isReadOnly
    ]);
    const getIndicatorProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            "data-active": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isActive),
            "data-hover": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isHovered),
            "data-checked": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isChecked),
            "data-focus": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isFocused && isFocusVisible),
            "data-indeterminate": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isIndeterminate),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isReadOnly)
        }), [
        isActive,
        isChecked,
        isDisabled,
        isFocused,
        isFocusVisible,
        isHovered,
        isIndeterminate,
        isInvalid,
        isReadOnly
    ]);
    const getRootProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...htmlProps,
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setRootIsLabelElement(node.tagName === "LABEL");
            }),
            onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onClick, ()=>{
                var _a;
                if (!rootIsLabelElement) {
                    (_a = inputRef.current) == null || _a.click();
                    requestAnimationFrame(()=>{
                        var _a2;
                        (_a2 = inputRef.current) == null || _a2.focus({
                            preventScroll: true
                        });
                    });
                }
            }),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid)
        }), [
        htmlProps,
        isDisabled,
        isChecked,
        isInvalid,
        rootIsLabelElement
    ]);
    const getInputProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>{
        return {
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(inputRef, forwardedRef),
            type: "checkbox",
            name: name,
            value: value,
            id: id,
            tabIndex: tabIndex,
            onChange: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onChange, handleChange),
            onBlur: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onBlur, onBlurProp, ()=>setFocused(false)),
            onFocus: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onFocus, onFocusProp, ()=>setFocused(true)),
            onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onKeyUp: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyUp, onKeyUp),
            required: isRequired,
            checked: isChecked,
            disabled: trulyDisabled,
            readOnly: isReadOnly,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-invalid": ariaInvalid ? Boolean(ariaInvalid) : isInvalid,
            "aria-describedby": ariaDescribedBy,
            "aria-disabled": isDisabled,
            style: (0, $c50ae480a15f8344$export$8fecac46448b5689)
        };
    }, [
        name,
        value,
        id,
        handleChange,
        onBlurProp,
        onFocusProp,
        onKeyDown,
        onKeyUp,
        isRequired,
        isChecked,
        trulyDisabled,
        isReadOnly,
        ariaLabel,
        ariaLabelledBy,
        ariaInvalid,
        isInvalid,
        ariaDescribedBy,
        isDisabled,
        tabIndex
    ]);
    const getLabelProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            onMouseDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseDown, $28d15a1dba5741c2$var$stopEvent),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid)
        }), [
        isChecked,
        isDisabled,
        isInvalid
    ]);
    const state = {
        isInvalid: isInvalid,
        isFocused: isFocused,
        isChecked: isChecked,
        isActive: isActive,
        isHovered: isHovered,
        isIndeterminate: isIndeterminate,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired
    };
    return {
        state: state,
        getRootProps: getRootProps,
        getCheckboxProps: getCheckboxProps,
        getIndicatorProps: getIndicatorProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        htmlProps: htmlProps
    };
}
function $28d15a1dba5741c2$var$stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}





var $acw62 = parcelRequire("acw62");

"use client";
var $73e9428c5f13ea0d$var$controlStyles = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "top",
    userSelect: "none",
    flexShrink: 0
};
var $73e9428c5f13ea0d$var$rootStyles = {
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "top",
    position: "relative"
};
var $73e9428c5f13ea0d$var$checkAnim = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    from: {
        opacity: 0,
        strokeDashoffset: 16,
        transform: "scale(0.95)"
    },
    to: {
        opacity: 1,
        strokeDashoffset: 0,
        transform: "scale(1)"
    }
});
var $73e9428c5f13ea0d$var$indeterminateOpacityAnim = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
var $73e9428c5f13ea0d$var$indeterminateScaleAnim = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    from: {
        transform: "scaleX(0.65)"
    },
    to: {
        transform: "scaleX(1)"
    }
});
var $73e9428c5f13ea0d$export$48513f6b9f8ce62d = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Checkbox2(props, ref) {
    const group = (0, $ce509139dd486c93$export$5575526870d5c2ae)();
    const mergedProps = {
        ...group,
        ...props
    };
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Checkbox", mergedProps);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const { spacing: spacing = "0.5rem", className: className, children: children, iconColor: iconColor, iconSize: iconSize, icon: icon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9153ea510dde82a0$export$c0a1936901b0e55), {}), isChecked: isCheckedProp, isDisabled: isDisabled = group == null ? void 0 : group.isDisabled, onChange: onChangeProp, inputProps: inputProps, ...rest } = ownProps;
    let isChecked = isCheckedProp;
    if ((group == null ? void 0 : group.value) && ownProps.value) isChecked = group.value.includes(ownProps.value);
    let onChange = onChangeProp;
    if ((group == null ? void 0 : group.onChange) && ownProps.value) onChange = (0, $abe97432afb3d989$export$9dd9a52f2dd5b9ce)(group.onChange, onChangeProp);
    const { state: state, getInputProps: getInputProps, getCheckboxProps: getCheckboxProps, getLabelProps: getLabelProps, getRootProps: getRootProps } = (0, $28d15a1dba5741c2$export$e375f10ce42261c5)({
        ...rest,
        isDisabled: isDisabled,
        isChecked: isChecked,
        onChange: onChange
    });
    const shouldAnimate = (0, $ffc8e0be6163a375$export$c4008d6206288921)(state.isChecked);
    const iconStyles = (0, $acw62.useMemo)(()=>({
            animation: !shouldAnimate ? void 0 : state.isIndeterminate ? `${$73e9428c5f13ea0d$var$indeterminateOpacityAnim} 20ms linear, ${$73e9428c5f13ea0d$var$indeterminateScaleAnim} 200ms linear` : `${$73e9428c5f13ea0d$var$checkAnim} 200ms linear`,
            fontSize: iconSize,
            color: iconColor,
            ...styles.icon
        }), [
        iconColor,
        iconSize,
        shouldAnimate,
        state.isIndeterminate,
        styles.icon
    ]);
    const clonedIcon = (0, $acw62.cloneElement)(icon, {
        __css: iconStyles,
        isIndeterminate: state.isIndeterminate,
        isChecked: state.isChecked
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).label, {
        __css: {
            ...$73e9428c5f13ea0d$var$rootStyles,
            ...styles.container
        },
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-checkbox", className),
        ...getRootProps(),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "chakra-checkbox__input",
                ...getInputProps(inputProps, ref)
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
                __css: {
                    ...$73e9428c5f13ea0d$var$controlStyles,
                    ...styles.control
                },
                className: "chakra-checkbox__control",
                ...getCheckboxProps(),
                children: clonedIcon
            }),
            children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
                className: "chakra-checkbox__label",
                ...getLabelProps(),
                __css: {
                    marginStart: spacing,
                    ...styles.label
                },
                children: children
            })
        ]
    });
});
$73e9428c5f13ea0d$export$48513f6b9f8ce62d.displayName = "Checkbox";






var $acw62 = parcelRequire("acw62");
"use client";
function $0e3487639c9f0f70$var$isInputEvent(value) {
    return value && (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value) && (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value.target);
}
function $0e3487639c9f0f70$export$49ff6f28c54f1cbe(props = {}) {
    const { defaultValue: defaultValue, value: valueProp, onChange: onChange, isDisabled: isDisabled, isNative: isNative } = props;
    const onChangeProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onChange);
    const [value, setValue] = (0, $4795b7ced84aa3c2$export$6f32135080cb4c3)({
        value: valueProp,
        defaultValue: defaultValue || [],
        onChange: onChangeProp
    });
    const handleChange = (0, $acw62.useCallback)((eventOrValue)=>{
        if (!value) return;
        const isChecked = $0e3487639c9f0f70$var$isInputEvent(eventOrValue) ? eventOrValue.target.checked : !value.includes(eventOrValue);
        const selectedValue = $0e3487639c9f0f70$var$isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
        const nextValue = isChecked ? [
            ...value,
            selectedValue
        ] : value.filter((v)=>String(v) !== String(selectedValue));
        setValue(nextValue);
    }, [
        setValue,
        value
    ]);
    const getCheckboxProps = (0, $acw62.useCallback)((props2 = {})=>{
        const checkedKey = isNative ? "checked" : "isChecked";
        return {
            ...props2,
            [checkedKey]: value.some((val)=>String(props2.value) === String(val)),
            onChange: handleChange
        };
    }, [
        handleChange,
        isNative,
        value
    ]);
    return {
        value: value,
        isDisabled: isDisabled,
        onChange: handleChange,
        setValue: setValue,
        getCheckboxProps: getCheckboxProps
    };
}



var $acw62 = parcelRequire("acw62");

"use client";
function $93764e9c0d6168cd$export$4aa08d5625cb8ead(props) {
    const { colorScheme: colorScheme, size: size, variant: variant, children: children, isDisabled: isDisabled } = props;
    const { value: value, onChange: onChange } = (0, $0e3487639c9f0f70$export$49ff6f28c54f1cbe)(props);
    const group = (0, $acw62.useMemo)(()=>({
            size: size,
            onChange: onChange,
            colorScheme: colorScheme,
            value: value,
            variant: variant,
            isDisabled: isDisabled
        }), [
        size,
        onChange,
        colorScheme,
        value,
        variant,
        isDisabled
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ce509139dd486c93$export$95a3c27e07a551c3), {
        value: group,
        children: children
    });
}
$93764e9c0d6168cd$export$4aa08d5625cb8ead.displayName = "CheckboxGroup";


var $acw62 = parcelRequire("acw62");
"use client";
function $ce14011db4e17e58$export$f680877a34711e37(idProp, prefix) {
    const id = (0, $acw62.useId)();
    return (0, $acw62.useMemo)(()=>idProp || [
            prefix,
            id
        ].filter(Boolean).join("-"), [
        idProp,
        prefix,
        id
    ]);
}
function $ce14011db4e17e58$export$365c04e2f432779(idProp, ...prefixes) {
    const id = $ce14011db4e17e58$export$f680877a34711e37(idProp);
    return (0, $acw62.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}
function $ce14011db4e17e58$export$bc294ecf36b44bfb(partId) {
    const [id, setId] = (0, $acw62.useState)(null);
    const ref = (0, $acw62.useCallback)((node)=>{
        setId(node ? partId : null);
    }, [
        partId
    ]);
    return {
        ref: ref,
        id: id,
        isRendered: Boolean(id)
    };
}


// src/dom.ts
function $a1c7b8cf646d4454$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $a1c7b8cf646d4454$export$1b3bfaa9684536aa(el) {
    var _a;
    if (!$a1c7b8cf646d4454$export$45a5e7f76e0caa8d(el)) return false;
    const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
    return el instanceof win.HTMLElement;
}
function $a1c7b8cf646d4454$export$f21a1ffae260145a(node) {
    var _a, _b;
    return $a1c7b8cf646d4454$export$45a5e7f76e0caa8d(node) ? (_b = (_a = $a1c7b8cf646d4454$export$b204af158042fbac(node)) == null ? void 0 : _a.defaultView) != null ? _b : window : window;
}
function $a1c7b8cf646d4454$export$b204af158042fbac(node) {
    var _a;
    return $a1c7b8cf646d4454$export$45a5e7f76e0caa8d(node) ? (_a = node.ownerDocument) != null ? _a : document : document;
}
function $a1c7b8cf646d4454$export$8d16348623687f6(event) {
    var _a;
    return (_a = event.view) != null ? _a : window;
}
function $a1c7b8cf646d4454$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $a1c7b8cf646d4454$export$4e09c449d6c407f7 = /* @__PURE__ */ $a1c7b8cf646d4454$export$71594e8a50f746f4();
var $a1c7b8cf646d4454$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
var $a1c7b8cf646d4454$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;
var $a1c7b8cf646d4454$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");
function $a1c7b8cf646d4454$export$cd4e5573fbe2b576(node) {
    const doc = $a1c7b8cf646d4454$export$b204af158042fbac(node);
    return doc == null ? void 0 : doc.activeElement;
}
function $a1c7b8cf646d4454$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}
function $a1c7b8cf646d4454$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return ()=>{
        target.removeEventListener(eventName, handler, options);
    };
}
function $a1c7b8cf646d4454$export$17948c8429b9b73a(event) {
    const { key: key, keyCode: keyCode } = event;
    const isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
    const eventKey = isArrowKey ? `Arrow${key}` : key;
    return eventKey;
}
function $a1c7b8cf646d4454$export$a7a83d2a1d2d9e91(event) {
    var _a, _b;
    const target = (_a = event.target) != null ? _a : event.currentTarget;
    const activeElement = $a1c7b8cf646d4454$export$cd4e5573fbe2b576(target);
    return (_b = event.relatedTarget) != null ? _b : activeElement;
}
function $a1c7b8cf646d4454$export$189689d1febf0166(event) {
    return event.button !== 0;
}



var $acw62 = parcelRequire("acw62");
"use client";
var $45157ab301125bc7$export$deebe11a338de063 = (0, $a1c7b8cf646d4454$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");
"use client";
function $1c499373c234ef17$export$25bec8c6f54ee79a(fn, deps = []) {
    const ref = (0, $acw62.useRef)(fn);
    (0, $45157ab301125bc7$export$deebe11a338de063)(()=>{
        ref.current = fn;
    });
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, deps);
}




var $acw62 = parcelRequire("acw62");
"use client";
function $147ea746fc385b52$export$7301e09313e4cf1b(prop, state) {
    const isControlled = prop !== void 0;
    const value = isControlled && typeof prop !== "undefined" ? prop : state;
    return [
        isControlled,
        value
    ];
}
function $147ea746fc385b52$export$6f32135080cb4c3(props) {
    const { value: valueProp, defaultValue: defaultValue, onChange: onChange, shouldUpdate: shouldUpdate = (prev, next)=>prev !== next } = props;
    const onChangeProp = (0, $1c499373c234ef17$export$25bec8c6f54ee79a)(onChange);
    const shouldUpdateProp = (0, $1c499373c234ef17$export$25bec8c6f54ee79a)(shouldUpdate);
    const [valueState, setValue] = (0, $acw62.useState)(defaultValue);
    const isControlled = valueProp !== void 0;
    const value = isControlled ? valueProp : valueState;
    const updateValue = (0, $acw62.useCallback)((next)=>{
        const nextValue = (0, $7e9e3a2462729b7f$export$624e501d81f5ffce)(next, value);
        if (!shouldUpdateProp(value, nextValue)) return;
        if (!isControlled) setValue(nextValue);
        onChangeProp(nextValue);
    }, [
        isControlled,
        onChangeProp,
        value,
        shouldUpdateProp
    ]);
    return [
        value,
        updateValue
    ];
}





var $acw62 = parcelRequire("acw62");
"use client";
function $8b7bde38f2a271a2$export$6e3e27031a30522f(props = {}) {
    const { onClose: onCloseProp, onOpen: onOpenProp, isOpen: isOpenProp, id: idProp } = props;
    const onOpenPropCallbackRef = (0, $1c499373c234ef17$export$25bec8c6f54ee79a)(onOpenProp);
    const onClosePropCallbackRef = (0, $1c499373c234ef17$export$25bec8c6f54ee79a)(onCloseProp);
    const [isOpenState, setIsOpen] = (0, $acw62.useState)(props.defaultIsOpen || false);
    const [isControlled, isOpen] = (0, $147ea746fc385b52$export$7301e09313e4cf1b)(isOpenProp, isOpenState);
    const id = (0, $ce14011db4e17e58$export$f680877a34711e37)(idProp, "disclosure");
    const onClose = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(false);
        onClosePropCallbackRef == null || onClosePropCallbackRef();
    }, [
        isControlled,
        onClosePropCallbackRef
    ]);
    const onOpen = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(true);
        onOpenPropCallbackRef == null || onOpenPropCallbackRef();
    }, [
        isControlled,
        onOpenPropCallbackRef
    ]);
    const onToggle = (0, $acw62.useCallback)(()=>{
        const action = isOpen ? onClose : onOpen;
        action();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    return {
        isOpen: !!isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
        isControlled: isControlled,
        getButtonProps: (props2 = {})=>({
                ...props2,
                "aria-expanded": isOpen,
                "aria-controls": id,
                onClick: (0, $7e9e3a2462729b7f$export$5bdd3f730ec2c47e)(props2.onClick, onToggle)
            }),
        getDisclosureProps: (props2 = {})=>({
                ...props2,
                hidden: !isOpen,
                id: id
            })
    };
}


var $acw62 = parcelRequire("acw62");
"use client";
function $a122a84052a653dd$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $a122a84052a653dd$export$74665b213cb5c4cf(...refs) {
    return (0, $acw62.useMemo)(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (node)=>{
            refs.forEach((ref)=>{
                if (ref) $a122a84052a653dd$export$d734136a7b018efe(ref, node);
            });
        };
    }, refs);
}




var $acw62 = parcelRequire("acw62");
"use client";
function $6d85c847103c013b$export$71b2224f1ce5e08e(props) {
    const { ref: ref, handler: handler, enabled: enabled = true } = props;
    const savedHandler = (0, $1c499373c234ef17$export$25bec8c6f54ee79a)(handler);
    const stateRef = (0, $acw62.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    const state = stateRef.current;
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return;
        const onPointerDown = (e)=>{
            if ($6d85c847103c013b$var$isValidEvent(e, ref)) state.isPointerDown = true;
        };
        const onMouseUp = (event)=>{
            if (state.ignoreEmulatedMouseEvents) {
                state.ignoreEmulatedMouseEvents = false;
                return;
            }
            if (state.isPointerDown && handler && $6d85c847103c013b$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        const onTouchEnd = (event)=>{
            state.ignoreEmulatedMouseEvents = true;
            if (handler && state.isPointerDown && $6d85c847103c013b$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        const doc = (0, $a1c7b8cf646d4454$export$b204af158042fbac)(ref.current);
        doc.addEventListener("mousedown", onPointerDown, true);
        doc.addEventListener("mouseup", onMouseUp, true);
        doc.addEventListener("touchstart", onPointerDown, true);
        doc.addEventListener("touchend", onTouchEnd, true);
        return ()=>{
            doc.removeEventListener("mousedown", onPointerDown, true);
            doc.removeEventListener("mouseup", onMouseUp, true);
            doc.removeEventListener("touchstart", onPointerDown, true);
            doc.removeEventListener("touchend", onTouchEnd, true);
        };
    }, [
        handler,
        ref,
        savedHandler,
        state,
        enabled
    ]);
}
function $6d85c847103c013b$var$isValidEvent(event, ref) {
    var _a;
    const target = event.target;
    if (target) {
        const doc = (0, $a1c7b8cf646d4454$export$b204af158042fbac)(target);
        if (!doc.contains(target)) return false;
    }
    return !((_a = ref.current) == null ? void 0 : _a.contains(target));
}





"use client";
var $846965fabe96e3f8$export$f5b8910cec6cf069 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Input2(props, ref) {
    const { htmlSize: htmlSize, ...rest } = props;
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Input", rest);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(rest);
    const input = (0, $95e8035d7d1d6064$export$62ecd8ad1bbe1a18)(ownProps);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-input", props.className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).input, {
        size: htmlSize,
        ...input,
        __css: styles.field,
        ref: ref,
        className: _className
    });
});
$846965fabe96e3f8$export$f5b8910cec6cf069.displayName = "Input";
$846965fabe96e3f8$export$f5b8910cec6cf069.id = "Input";



"use client";
var $2032f24e0e9145ee$export$e71c4d32a2263218 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)("div");
$2032f24e0e9145ee$export$e71c4d32a2263218.displayName = "Box";
var $2032f24e0e9145ee$export$b09fb900337259de = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Square2(props, ref) {
    const { size: size, centerContent: centerContent = true, ...rest } = props;
    const styles = centerContent ? {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    } : {};
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($2032f24e0e9145ee$export$e71c4d32a2263218, {
        ref: ref,
        boxSize: size,
        __css: {
            ...styles,
            flexShrink: 0,
            flexGrow: 0
        },
        ...rest
    });
});
$2032f24e0e9145ee$export$b09fb900337259de.displayName = "Square";
var $2032f24e0e9145ee$export$c89a927ffc67e6fa = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Circle2(props, ref) {
    const { size: size, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($2032f24e0e9145ee$export$b09fb900337259de, {
        size: size,
        ref: ref,
        borderRadius: "9999px",
        ...rest
    });
});
$2032f24e0e9145ee$export$c89a927ffc67e6fa.displayName = "Circle";



"use client";
var $2231dd843a1dfd59$export$f51f4c4ede09e011 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Flex2(props, ref) {
    const { direction: direction, align: align, justify: justify, wrap: wrap, basis: basis, grow: grow, shrink: shrink, ...rest } = props;
    const styles = {
        display: "flex",
        flexDirection: direction,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap,
        flexBasis: basis,
        flexGrow: grow,
        flexShrink: shrink
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$2231dd843a1dfd59$export$f51f4c4ede09e011.displayName = "Flex";




"use client";
var $eb70b29933175d72$export$a8a3e93435678ff9 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Heading2(props, ref) {
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Heading", props);
    const { className: className, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).h2, {
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-heading", props.className),
        ...rest,
        __css: styles
    });
});
$eb70b29933175d72$export$a8a3e93435678ff9.displayName = "Heading";



"use client";
var $1e675b0524633ecf$export$50d5391cd1a018c6 = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        className: "chakra-stack__item",
        ...props,
        __css: {
            display: "inline-block",
            flex: "0 0 auto",
            minWidth: 0,
            ...props["__css"]
        }
    });
$1e675b0524633ecf$export$50d5391cd1a018c6.displayName = "StackItem";


// src/responsive.ts

var $37c1adb04c994149$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $37c1adb04c994149$export$eca1915781c2aaca(prop, mapper) {
    if (Array.isArray(prop)) return prop.map((item)=>item === null ? null : mapper(item));
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(prop)) return Object.keys(prop).reduce((result, key)=>{
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $37c1adb04c994149$export$d9dcf045f3ec145e(obj, bps = $37c1adb04c994149$export$d07517a676ce386f) {
    const result = bps.map((br)=>{
        var _a;
        return (_a = obj[br]) != null ? _a : null;
    });
    const lastItem = result[result.length - 1];
    while(lastItem === null)result.pop();
    return result;
}
function $37c1adb04c994149$export$60476530468641e7(values, bps = $37c1adb04c994149$export$d07517a676ce386f) {
    const result = {};
    values.forEach((value, index)=>{
        const key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $37c1adb04c994149$export$2f4b3062f5f33794(obj, bps = $37c1adb04c994149$export$d07517a676ce386f) {
    const keys = Object.keys(obj);
    return keys.length > 0 && keys.every((key)=>bps.includes(key));
}
var $37c1adb04c994149$export$4cdfc817e07de39e = (v)=>Number.isNaN(Number(v));


"use client";
function $89adde6ec4368b45$export$d4a6a5cc582519a5(options) {
    const { spacing: spacing, direction: direction } = options;
    const dividerStyles = {
        column: {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        "column-reverse": {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        row: {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        },
        "row-reverse": {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        }
    };
    return {
        "&": (0, $37c1adb04c994149$export$eca1915781c2aaca)(direction, (value)=>dividerStyles[value])
    };
}






var $acw62 = parcelRequire("acw62");

"use client";
var $ec37ab1d016e4ce2$export$694e0d28c7ffc90c = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { isInline: isInline, direction: directionProp, align: align, justify: justify, spacing: spacing = "0.5rem", wrap: wrap, children: children, divider: divider, className: className, shouldWrapChildren: shouldWrapChildren, ...rest } = props;
    const direction = isInline ? "row" : directionProp != null ? directionProp : "column";
    const dividerStyle = (0, $acw62.useMemo)(()=>(0, $89adde6ec4368b45$export$d4a6a5cc582519a5)({
            spacing: spacing,
            direction: direction
        }), [
        spacing,
        direction
    ]);
    const hasDivider = !!divider;
    const shouldUseChildren = !shouldWrapChildren && !hasDivider;
    const clones = (0, $acw62.useMemo)(()=>{
        const validChildren = (0, $197fffec5094e9ee$export$b2c43d7d050b2e63)(children);
        return shouldUseChildren ? validChildren : validChildren.map((child, index)=>{
            const key = typeof child.key !== "undefined" ? child.key : index;
            const isLast = index + 1 === validChildren.length;
            const wrappedChild = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $1e675b0524633ecf$export$50d5391cd1a018c6), {
                children: child
            }, key);
            const _child = shouldWrapChildren ? wrappedChild : child;
            if (!hasDivider) return _child;
            const clonedDivider = (0, $acw62.cloneElement)(divider, {
                __css: dividerStyle
            });
            const _divider = isLast ? null : clonedDivider;
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                children: [
                    _child,
                    _divider
                ]
            }, key);
        });
    }, [
        divider,
        dividerStyle,
        hasDivider,
        shouldUseChildren,
        shouldWrapChildren,
        children
    ]);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-stack", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        display: "flex",
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction,
        flexWrap: wrap,
        gap: hasDivider ? void 0 : spacing,
        className: _className,
        ...rest,
        children: clones
    });
});
$ec37ab1d016e4ce2$export$694e0d28c7ffc90c.displayName = "Stack";




"use client";
var $5e01b023a0ac6ac7$export$15e411dc07b9c834 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
        align: "center",
        ...props,
        direction: "row",
        ref: ref
    }));
$5e01b023a0ac6ac7$export$15e411dc07b9c834.displayName = "HStack";




"use client";
var $e314e25282bef023$export$a6c7ac8248d6e38a = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Link2(props, ref) {
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Link", props);
    const { className: className, isExternal: isExternal, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).a, {
        target: isExternal ? "_blank" : void 0,
        rel: isExternal ? "noopener" : void 0,
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-link", className),
        ...rest,
        __css: styles
    });
});
$e314e25282bef023$export$a6c7ac8248d6e38a.displayName = "Link";




"use client";
var $e547ec39c1fbf140$export$155d86d4b6139452 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function LinkOverlay2(props, ref) {
    const { isExternal: isExternal, target: target, rel: rel, className: className, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).a, {
        ...rest,
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-linkbox__overlay", className),
        rel: isExternal ? "noopener noreferrer" : rel,
        target: isExternal ? "_blank" : target,
        __css: {
            position: "static",
            "&::before": {
                content: "''",
                cursor: "inherit",
                display: "block",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 0,
                width: "100%",
                height: "100%"
            }
        }
    });
});
var $e547ec39c1fbf140$export$d79f4543fbc1d78a = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function LinkBox2(props, ref) {
    const { className: className, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        position: "relative",
        ...rest,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-linkbox", className),
        __css: {
            /* Elevate the links and abbreviations up */ "a[href]:not(.chakra-linkbox__overlay), abbr[title]": {
                position: "relative",
                zIndex: 1
            }
        }
    });
});



"use client";
var $b0febb55f7ef24c7$export$ef2184bd89960b14 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Grid2(props, ref) {
    const { templateAreas: templateAreas, gap: gap, rowGap: rowGap, columnGap: columnGap, column: column, row: row, autoFlow: autoFlow, autoRows: autoRows, templateRows: templateRows, autoColumns: autoColumns, templateColumns: templateColumns, ...rest } = props;
    const styles = {
        display: "grid",
        gridTemplateAreas: templateAreas,
        gridGap: gap,
        gridRowGap: rowGap,
        gridColumnGap: columnGap,
        gridAutoColumns: autoColumns,
        gridColumn: column,
        gridRow: row,
        gridAutoFlow: autoFlow,
        gridAutoRows: autoRows,
        gridTemplateRows: templateRows,
        gridTemplateColumns: templateColumns
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$b0febb55f7ef24c7$export$ef2184bd89960b14.displayName = "Grid";





"use client";
var $604fa8b7d7b4fd04$export$de97fecb6d4b30a5 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function SimpleGrid2(props, ref) {
    const { columns: columns, spacingX: spacingX, spacingY: spacingY, spacing: spacing, minChildWidth: minChildWidth, ...rest } = props;
    const theme = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    const templateColumns = minChildWidth ? $604fa8b7d7b4fd04$var$widthToColumns(minChildWidth, theme) : $604fa8b7d7b4fd04$var$countToColumns(columns);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b0febb55f7ef24c7$export$ef2184bd89960b14), {
        ref: ref,
        gap: spacing,
        columnGap: spacingX,
        rowGap: spacingY,
        templateColumns: templateColumns,
        ...rest
    });
});
$604fa8b7d7b4fd04$export$de97fecb6d4b30a5.displayName = "SimpleGrid";
function $604fa8b7d7b4fd04$var$toPx(n) {
    return typeof n === "number" ? `${n}px` : n;
}
function $604fa8b7d7b4fd04$var$widthToColumns(width, theme) {
    return (0, $37c1adb04c994149$export$eca1915781c2aaca)(width, (value)=>{
        const _value = (0, $d637f68b5e43da19$export$257b2d10b709d8ef)("sizes", value, $604fa8b7d7b4fd04$var$toPx(value))(theme);
        return value === null ? null : `repeat(auto-fit, minmax(${_value}, 1fr))`;
    });
}
function $604fa8b7d7b4fd04$var$countToColumns(count) {
    return (0, $37c1adb04c994149$export$eca1915781c2aaca)(count, (value)=>value === null ? null : `repeat(${value}, minmax(0, 1fr))`);
}


"use client";
var $405d81ccc3b181e4$export$d7a54cba636a8cd6 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        flex: 1,
        justifySelf: "stretch",
        alignSelf: "stretch"
    }
});
$405d81ccc3b181e4$export$d7a54cba636a8cd6.displayName = "Spacer";



// src/compact.ts
function $6bc154251470a415$export$8e16b83750b44988(object) {
    const clone = Object.assign({}, object);
    for(let key in clone)if (clone[key] === void 0) delete clone[key];
    return clone;
}



"use client";
var $7a2900ce3f78a504$export$5f1af8db9871e1d6 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Text2(props, ref) {
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Text", props);
    const { className: className, align: align, decoration: decoration, casing: casing, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const aliasedProps = (0, $6bc154251470a415$export$8e16b83750b44988)({
        textAlign: props.align,
        textDecoration: props.decoration,
        textTransform: props.casing
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).p, {
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-text", props.className),
        ...aliasedProps,
        ...rest,
        __css: styles
    });
});
$7a2900ce3f78a504$export$5f1af8db9871e1d6.displayName = "Text";




"use client";
var $f85d52b2d7cbb881$export$e6c02a6dccfa2120 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
        align: "center",
        ...props,
        direction: "column",
        ref: ref
    }));
$f85d52b2d7cbb881$export$e6c02a6dccfa2120.displayName = "VStack";



var $acw62 = parcelRequire("acw62");
"use client";
function $63be06194fb9f91c$export$32d5543ab307c01(query, options = {}) {
    const { ssr: ssr = true, fallback: fallback } = options;
    const { getWindow: getWindow } = (0, $3a87268155f9f2cb$export$ea7ed2425832167d)();
    const queries = Array.isArray(query) ? query : [
        query
    ];
    let fallbackValues = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    fallbackValues = fallbackValues.filter((v)=>v != null);
    const [value, setValue] = (0, $acw62.useState)(()=>{
        return queries.map((query2, index)=>({
                media: query2,
                matches: ssr ? !!fallbackValues[index] : getWindow().matchMedia(query2).matches
            }));
    });
    (0, $acw62.useEffect)(()=>{
        const win = getWindow();
        setValue(queries.map((query2)=>({
                media: query2,
                matches: win.matchMedia(query2).matches
            })));
        const mql = queries.map((query2)=>win.matchMedia(query2));
        const handler = (evt)=>{
            setValue((prev)=>{
                return prev.slice().map((item)=>{
                    if (item.media === evt.media) return {
                        ...item,
                        matches: evt.matches
                    };
                    return item;
                });
            });
        };
        mql.forEach((mql2)=>{
            if (typeof mql2.addListener === "function") mql2.addListener(handler);
            else mql2.addEventListener("change", handler);
        });
        return ()=>{
            mql.forEach((mql2)=>{
                if (typeof mql2.removeListener === "function") mql2.removeListener(handler);
                else mql2.removeEventListener("change", handler);
            });
        };
    }, [
        getWindow
    ]);
    return value.map((item)=>item.matches);
}


var $acw62 = parcelRequire("acw62");
"use client";
function $37b472694c13be1a$var$isPrintableCharacter(event) {
    const { key: key } = event;
    return key.length === 1 || key.length > 1 && /[^a-zA-Z0-9]/.test(key);
}
function $37b472694c13be1a$export$b0ebbe7904d8d94a(props = {}) {
    const { timeout: timeout = 300, preventDefault: preventDefault = ()=>true } = props;
    const [keys, setKeys] = (0, $acw62.useState)([]);
    const timeoutRef = (0, $acw62.useRef)();
    const flush = ()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };
    const clearKeysAfterDelay = ()=>{
        flush();
        timeoutRef.current = setTimeout(()=>{
            setKeys([]);
            timeoutRef.current = null;
        }, timeout);
    };
    (0, $acw62.useEffect)(()=>flush, []);
    function onKeyDown(fn) {
        return (event)=>{
            if (event.key === "Backspace") {
                const keysCopy = [
                    ...keys
                ];
                keysCopy.pop();
                setKeys(keysCopy);
                return;
            }
            if ($37b472694c13be1a$var$isPrintableCharacter(event)) {
                const keysCopy = keys.concat(event.key);
                if (preventDefault(event)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                setKeys(keysCopy);
                fn(keysCopy.join(""));
                clearKeysAfterDelay();
            }
        };
    }
    return onKeyDown;
}


"use client";
// src/get-next-item-from-search.ts
function $6bc3ab6099e47e10$export$18ed781d9da46f95(items, searchString, itemToString, currentItem) {
    if (searchString == null) return currentItem;
    if (!currentItem) {
        const foundItem = items.find((item)=>itemToString(item).toLowerCase().startsWith(searchString.toLowerCase()));
        return foundItem;
    }
    const matchingItems = items.filter((item)=>itemToString(item).toLowerCase().startsWith(searchString.toLowerCase()));
    if (matchingItems.length > 0) {
        let nextIndex;
        if (matchingItems.includes(currentItem)) {
            const currentIndex = matchingItems.indexOf(currentItem);
            nextIndex = currentIndex + 1;
            if (nextIndex === matchingItems.length) nextIndex = 0;
            return matchingItems[nextIndex];
        }
        nextIndex = items.indexOf(matchingItems[0]);
        return items[nextIndex];
    }
    return currentItem;
}



var $acw62 = parcelRequire("acw62");
"use client";
function $17fdbfdec67bdd4b$export$43d26308f6d75a57() {
    const listeners = (0, $acw62.useRef)(/* @__PURE__ */ new Map());
    const currentListeners = listeners.current;
    const add = (0, $acw62.useCallback)((el, type, listener, options)=>{
        listeners.current.set(listener, {
            type: type,
            el: el,
            options: options
        });
        el.addEventListener(type, listener, options);
    }, []);
    const remove = (0, $acw62.useCallback)((el, type, listener, options)=>{
        el.removeEventListener(type, listener, options);
        listeners.current.delete(listener);
    }, []);
    (0, $acw62.useEffect)(()=>()=>{
            currentListeners.forEach((value, key)=>{
                remove(value.el, value.type, key, value.options);
            });
        }, [
        remove,
        currentListeners
    ]);
    return {
        add: add,
        remove: remove
    };
}





var $acw62 = parcelRequire("acw62");
"use client";
function $8dec279e09834157$var$isValidElement(event) {
    const element = event.target;
    const { tagName: tagName, isContentEditable: isContentEditable } = element;
    return tagName !== "INPUT" && tagName !== "TEXTAREA" && isContentEditable !== true;
}
function $8dec279e09834157$export$ed213cc82e426b1a(props = {}) {
    const { ref: htmlRef, isDisabled: isDisabled, isFocusable: isFocusable, clickOnEnter: clickOnEnter = true, clickOnSpace: clickOnSpace = true, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, tabIndex: tabIndexProp, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, ...htmlProps } = props;
    const [isButton, setIsButton] = (0, $acw62.useState)(true);
    const [isPressed, setIsPressed] = (0, $acw62.useState)(false);
    const listeners = (0, $17fdbfdec67bdd4b$export$43d26308f6d75a57)();
    const refCallback = (node)=>{
        if (!node) return;
        if (node.tagName !== "BUTTON") setIsButton(false);
    };
    const tabIndex = isButton ? tabIndexProp : tabIndexProp || 0;
    const trulyDisabled = isDisabled && !isFocusable;
    const handleClick = (0, $acw62.useCallback)((event)=>{
        if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        const self = event.currentTarget;
        self.focus();
        onClick == null || onClick(event);
    }, [
        isDisabled,
        onClick
    ]);
    const onDocumentKeyUp = (0, $acw62.useCallback)((e)=>{
        if (isPressed && $8dec279e09834157$var$isValidElement(e)) {
            e.preventDefault();
            e.stopPropagation();
            setIsPressed(false);
            listeners.remove(document, "keyup", onDocumentKeyUp, false);
        }
    }, [
        isPressed,
        listeners
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        onKeyDown == null || onKeyDown(event);
        if (isDisabled || event.defaultPrevented || event.metaKey) return;
        if (!$8dec279e09834157$var$isValidElement(event.nativeEvent) || isButton) return;
        const shouldClickOnEnter = clickOnEnter && event.key === "Enter";
        const shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
            event.preventDefault();
            setIsPressed(true);
        }
        if (shouldClickOnEnter) {
            event.preventDefault();
            const self = event.currentTarget;
            self.click();
        }
        listeners.add(document, "keyup", onDocumentKeyUp, false);
    }, [
        isDisabled,
        isButton,
        onKeyDown,
        clickOnEnter,
        clickOnSpace,
        listeners,
        onDocumentKeyUp
    ]);
    const handleKeyUp = (0, $acw62.useCallback)((event)=>{
        onKeyUp == null || onKeyUp(event);
        if (isDisabled || event.defaultPrevented || event.metaKey) return;
        if (!$8dec279e09834157$var$isValidElement(event.nativeEvent) || isButton) return;
        const shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
            event.preventDefault();
            setIsPressed(false);
            const self = event.currentTarget;
            self.click();
        }
    }, [
        clickOnSpace,
        isButton,
        isDisabled,
        onKeyUp
    ]);
    const onDocumentMouseUp = (0, $acw62.useCallback)((event)=>{
        if (event.button !== 0) return;
        setIsPressed(false);
        listeners.remove(document, "mouseup", onDocumentMouseUp, false);
    }, [
        listeners
    ]);
    const handleMouseDown = (0, $acw62.useCallback)((event)=>{
        if (event.button !== 0) return;
        if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        if (!isButton) setIsPressed(true);
        const target = event.currentTarget;
        target.focus({
            preventScroll: true
        });
        listeners.add(document, "mouseup", onDocumentMouseUp, false);
        onMouseDown == null || onMouseDown(event);
    }, [
        isDisabled,
        isButton,
        onMouseDown,
        listeners,
        onDocumentMouseUp
    ]);
    const handleMouseUp = (0, $acw62.useCallback)((event)=>{
        if (event.button !== 0) return;
        if (!isButton) setIsPressed(false);
        onMouseUp == null || onMouseUp(event);
    }, [
        onMouseUp,
        isButton
    ]);
    const handleMouseOver = (0, $acw62.useCallback)((event)=>{
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        onMouseOver == null || onMouseOver(event);
    }, [
        isDisabled,
        onMouseOver
    ]);
    const handleMouseLeave = (0, $acw62.useCallback)((event)=>{
        if (isPressed) {
            event.preventDefault();
            setIsPressed(false);
        }
        onMouseLeave == null || onMouseLeave(event);
    }, [
        isPressed,
        onMouseLeave
    ]);
    const ref = (0, $457901a59fc0a4e6$export$c9058316764c140e)(htmlRef, refCallback);
    if (isButton) return {
        ...htmlProps,
        ref: ref,
        type: "button",
        "aria-disabled": trulyDisabled ? void 0 : isDisabled,
        disabled: trulyDisabled,
        onClick: handleClick,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
    };
    return {
        ...htmlProps,
        ref: ref,
        role: "button",
        "data-active": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isPressed),
        "aria-disabled": isDisabled ? "true" : void 0,
        tabIndex: trulyDisabled ? void 0 : tabIndex,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp,
        onKeyUp: handleKeyUp,
        onKeyDown: handleKeyDown,
        onMouseOver: handleMouseOver,
        onMouseLeave: handleMouseLeave
    };
}



// src/dom.ts
function $534108a0b0d3445d$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $534108a0b0d3445d$export$1b3bfaa9684536aa(el) {
    var _a;
    if (!$534108a0b0d3445d$export$45a5e7f76e0caa8d(el)) return false;
    const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
    return el instanceof win.HTMLElement;
}
function $534108a0b0d3445d$export$f21a1ffae260145a(node) {
    var _a, _b;
    return (_b = (_a = $534108a0b0d3445d$export$b204af158042fbac(node)) == null ? void 0 : _a.defaultView) != null ? _b : window;
}
function $534108a0b0d3445d$export$b204af158042fbac(node) {
    return $534108a0b0d3445d$export$45a5e7f76e0caa8d(node) ? node.ownerDocument : document;
}
function $534108a0b0d3445d$export$8d16348623687f6(event) {
    var _a;
    return (_a = event.view) != null ? _a : window;
}
function $534108a0b0d3445d$export$4e09c449d6c407f7() {
    return Boolean(globalThis == null ? void 0 : globalThis.document);
}
function $534108a0b0d3445d$export$cd4e5573fbe2b576(node) {
    return $534108a0b0d3445d$export$b204af158042fbac(node).activeElement;
}
function $534108a0b0d3445d$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}


// src/scroll.ts
function $7edd2f86c6e30f94$var$isScrollParent(el) {
    const win = el.ownerDocument.defaultView || window;
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = win.getComputedStyle(el);
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function $7edd2f86c6e30f94$var$getParent(el) {
    if (el.localName === "html") return el;
    return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function $7edd2f86c6e30f94$export$cfa2225e87938781(el) {
    if ([
        "html",
        "body",
        "#document"
    ].includes(el.localName)) return el.ownerDocument.body;
    if ((0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(el) && $7edd2f86c6e30f94$var$isScrollParent(el)) return el;
    return $7edd2f86c6e30f94$export$cfa2225e87938781($7edd2f86c6e30f94$var$getParent(el));
}



// src/tabbable.ts
var $2d4b29ebc030a42a$export$f5f22eac728522fd = (element)=>window.getComputedStyle(element).display === "none";
var $2d4b29ebc030a42a$export$54209d29bacd2cb9 = (element)=>element.hasAttribute("tabindex");
var $2d4b29ebc030a42a$export$87df0ed37d24dd13 = (element)=>$2d4b29ebc030a42a$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
function $2d4b29ebc030a42a$export$30e0dc115df457ed(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function $2d4b29ebc030a42a$export$63ed1d20cf8213cf(element) {
    return (0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) && element.localName === "input" && "select" in element;
}
function $2d4b29ebc030a42a$export$8a2eb51c14bb8899(element) {
    const doc = (0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) ? (0, $534108a0b0d3445d$export$b204af158042fbac)(element) : document;
    return doc.activeElement === element;
}
function $2d4b29ebc030a42a$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $2d4b29ebc030a42a$export$ee695c13482bb5dd(element) {
    if (element.parentElement && $2d4b29ebc030a42a$export$ee695c13482bb5dd(element.parentElement)) return true;
    return element.hidden;
}
function $2d4b29ebc030a42a$export$3453cc819780f652(element) {
    const value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $2d4b29ebc030a42a$export$4c063cf1350e6fed(element) {
    if (!(0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) || $2d4b29ebc030a42a$export$ee695c13482bb5dd(element) || $2d4b29ebc030a42a$export$30e0dc115df457ed(element)) return false;
    const { localName: localName } = element;
    const focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    const others = {
        a: ()=>element.hasAttribute("href"),
        audio: ()=>element.hasAttribute("controls"),
        video: ()=>element.hasAttribute("controls")
    };
    if (localName in others) return others[localName]();
    if ($2d4b29ebc030a42a$export$3453cc819780f652(element)) return true;
    return $2d4b29ebc030a42a$export$54209d29bacd2cb9(element);
}
function $2d4b29ebc030a42a$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return (0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) && $2d4b29ebc030a42a$export$4c063cf1350e6fed(element) && !$2d4b29ebc030a42a$export$87df0ed37d24dd13(element);
}



// src/index.ts
var $2858cbef67902129$var$focusableElList = [
    "input:not(:disabled):not([disabled])",
    "select:not(:disabled):not([disabled])",
    "textarea:not(:disabled):not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not(:disabled):not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
var $2858cbef67902129$var$focusableElSelector = $2858cbef67902129$var$focusableElList.join();
var $2858cbef67902129$var$isVisible = (el)=>el.offsetWidth > 0 && el.offsetHeight > 0;
function $2858cbef67902129$export$4ae682d253b556eb(container) {
    const focusableEls = Array.from(container.querySelectorAll($2858cbef67902129$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter((el)=>(0, $2d4b29ebc030a42a$export$4c063cf1350e6fed)(el) && $2858cbef67902129$var$isVisible(el));
}
function $2858cbef67902129$export$748138f04a69bf21(container) {
    const allFocusable = $2858cbef67902129$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $2858cbef67902129$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    const allFocusable = Array.from(container.querySelectorAll($2858cbef67902129$var$focusableElSelector));
    const allTabbable = allFocusable.filter((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d));
    if ((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $2858cbef67902129$export$168b663469d4c75e(container, fallbackToFocusable) {
    const [first] = $2858cbef67902129$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return first || null;
}
function $2858cbef67902129$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    const allTabbable = $2858cbef67902129$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $2858cbef67902129$export$28f33206776129a7(container, fallbackToFocusable) {
    const allFocusable = $2858cbef67902129$export$4ae682d253b556eb(container);
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || allFocusable.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}
function $2858cbef67902129$export$2e5518c3303f364a(container, fallbackToFocusable) {
    const allFocusable = $2858cbef67902129$export$4ae682d253b556eb(container).reverse();
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || allFocusable.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}



var $acw62 = parcelRequire("acw62");

"use client";
function $3bc081da2876e6e9$export$7080b3e976bc91ab(target, event, handler, options) {
    const listener = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(handler);
    (0, $acw62.useEffect)(()=>{
        const node = typeof target === "function" ? target() : target != null ? target : document;
        if (!handler || !node) return;
        node.addEventListener(event, listener, options);
        return ()=>{
            node.removeEventListener(event, listener, options);
        };
    }, [
        event,
        target,
        options,
        listener,
        handler
    ]);
    return ()=>{
        const node = typeof target === "function" ? target() : target != null ? target : document;
        node == null || node.removeEventListener(event, listener, options);
    };
}





var $acw62 = parcelRequire("acw62");
"use client";
function $96ef6c3784d3cdb8$var$preventReturnFocus(containerRef) {
    const el = containerRef.current;
    if (!el) return false;
    const activeElement = (0, $534108a0b0d3445d$export$cd4e5573fbe2b576)(el);
    if (!activeElement) return false;
    if (el.contains(activeElement)) return false;
    if ((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)(activeElement)) return true;
    return false;
}
function $96ef6c3784d3cdb8$export$68b323438c1fbb28(containerRef, options) {
    const { shouldFocus: shouldFocusProp, visible: visible, focusRef: focusRef } = options;
    const shouldFocus = shouldFocusProp && !visible;
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (!shouldFocus) return;
        if ($96ef6c3784d3cdb8$var$preventReturnFocus(containerRef)) return;
        const el = (focusRef == null ? void 0 : focusRef.current) || containerRef.current;
        let rafId;
        if (el) {
            rafId = requestAnimationFrame(()=>{
                el.focus({
                    preventScroll: true
                });
            });
            return ()=>{
                cancelAnimationFrame(rafId);
            };
        }
    }, [
        shouldFocus,
        containerRef,
        focusRef
    ]);
}
var $96ef6c3784d3cdb8$var$defaultOptions = {
    preventScroll: true,
    shouldFocus: false
};
function $96ef6c3784d3cdb8$export$54b5c2a5755195e7(target, options = $96ef6c3784d3cdb8$var$defaultOptions) {
    const { focusRef: focusRef, preventScroll: preventScroll, shouldFocus: shouldFocus, visible: visible } = options;
    const element = $96ef6c3784d3cdb8$var$isRefObject(target) ? target.current : target;
    const autoFocusValue = shouldFocus && visible;
    const autoFocusRef = (0, $acw62.useRef)(autoFocusValue);
    const lastVisibleRef = (0, $acw62.useRef)(visible);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!lastVisibleRef.current && visible) autoFocusRef.current = autoFocusValue;
        lastVisibleRef.current = visible;
    }, [
        visible,
        autoFocusValue
    ]);
    const onFocus = (0, $acw62.useCallback)(()=>{
        if (!visible || !element || !autoFocusRef.current) return;
        autoFocusRef.current = false;
        if (element.contains(document.activeElement)) return;
        if (focusRef == null ? void 0 : focusRef.current) requestAnimationFrame(()=>{
            var _a;
            (_a = focusRef.current) == null || _a.focus({
                preventScroll: preventScroll
            });
        });
        else {
            const tabbableEls = (0, $2858cbef67902129$export$4ae682d253b556eb)(element);
            if (tabbableEls.length > 0) requestAnimationFrame(()=>{
                tabbableEls[0].focus({
                    preventScroll: preventScroll
                });
            });
        }
    }, [
        visible,
        preventScroll,
        element,
        focusRef
    ]);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        onFocus();
    }, [
        onFocus
    ]);
    (0, $3bc081da2876e6e9$export$7080b3e976bc91ab)(element, "transitionend", onFocus);
}
function $96ef6c3784d3cdb8$var$isRefObject(val) {
    return "current" in val;
}


"use client";
// src/utils.ts
var $49cad064bf4d553f$var$toVar = (value, fallback)=>({
        var: value,
        varRef: fallback ? `var(${value}, ${fallback})` : `var(${value})`
    });
var $49cad064bf4d553f$export$fd62969fb0b7081c = {
    arrowShadowColor: $49cad064bf4d553f$var$toVar("--popper-arrow-shadow-color"),
    arrowSize: $49cad064bf4d553f$var$toVar("--popper-arrow-size", "8px"),
    arrowSizeHalf: $49cad064bf4d553f$var$toVar("--popper-arrow-size-half"),
    arrowBg: $49cad064bf4d553f$var$toVar("--popper-arrow-bg"),
    transformOrigin: $49cad064bf4d553f$var$toVar("--popper-transform-origin"),
    arrowOffset: $49cad064bf4d553f$var$toVar("--popper-arrow-offset")
};
function $49cad064bf4d553f$export$bba5a971afe05444(placement) {
    if (placement.includes("top")) return `1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("bottom")) return `-1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("right")) return `-1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("left")) return `1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
}
var $49cad064bf4d553f$var$transforms = {
    top: "bottom center",
    "top-start": "bottom left",
    "top-end": "bottom right",
    bottom: "top center",
    "bottom-start": "top left",
    "bottom-end": "top right",
    left: "right center",
    "left-start": "right top",
    "left-end": "right bottom",
    right: "left center",
    "right-start": "left top",
    "right-end": "left bottom"
};
var $49cad064bf4d553f$export$4b94194e48e4ec29 = (placement)=>$49cad064bf4d553f$var$transforms[placement];
var $49cad064bf4d553f$var$defaultEventListeners = {
    scroll: true,
    resize: true
};
function $49cad064bf4d553f$export$fafd30a196ad8838(value) {
    let eventListeners;
    if (typeof value === "object") eventListeners = {
        enabled: true,
        options: {
            ...$49cad064bf4d553f$var$defaultEventListeners,
            ...value
        }
    };
    else eventListeners = {
        enabled: value,
        options: $49cad064bf4d553f$var$defaultEventListeners
    };
    return eventListeners;
}


"use client";
// src/modifiers.ts
var $5a0cdca50d778174$export$45d38cc6268103c7 = {
    name: "matchWidth",
    enabled: true,
    phase: "beforeWrite",
    requires: [
        "computeStyles"
    ],
    fn: ({ state: state })=>{
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state: state })=>()=>{
            const reference = state.elements.reference;
            state.elements.popper.style.width = `${reference.offsetWidth}px`;
        }
};
var $5a0cdca50d778174$export$bd7bb1bc943e0611 = {
    name: "transformOrigin",
    enabled: true,
    phase: "write",
    fn: ({ state: state })=>{
        $5a0cdca50d778174$var$setTransformOrigin(state);
    },
    effect: ({ state: state })=>()=>{
            $5a0cdca50d778174$var$setTransformOrigin(state);
        }
};
var $5a0cdca50d778174$var$setTransformOrigin = (state)=>{
    state.elements.popper.style.setProperty((0, $49cad064bf4d553f$export$fd62969fb0b7081c).transformOrigin.var, (0, $49cad064bf4d553f$export$4b94194e48e4ec29)(state.placement));
};
var $5a0cdca50d778174$export$36f2614d91c73bb6 = {
    name: "positionArrow",
    enabled: true,
    phase: "afterWrite",
    fn: ({ state: state })=>{
        $5a0cdca50d778174$var$setArrowStyles(state);
    }
};
var $5a0cdca50d778174$var$setArrowStyles = (state)=>{
    var _a;
    if (!state.placement) return;
    const overrides = $5a0cdca50d778174$var$getArrowStyle(state.placement);
    if (((_a = state.elements) == null ? void 0 : _a.arrow) && overrides) {
        Object.assign(state.elements.arrow.style, {
            [overrides.property]: overrides.value,
            width: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSize.varRef,
            height: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSize.varRef,
            zIndex: -1
        });
        const vars = {
            [(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSizeHalf.var]: `calc(${(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSize.varRef} / 2 - 1px)`,
            [(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowOffset.var]: `calc(${(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSizeHalf.varRef} * -1)`
        };
        for(const property in vars)state.elements.arrow.style.setProperty(property, vars[property]);
    }
};
var $5a0cdca50d778174$var$getArrowStyle = (placement)=>{
    if (placement.startsWith("top")) return {
        property: "bottom",
        value: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("bottom")) return {
        property: "top",
        value: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("left")) return {
        property: "right",
        value: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("right")) return {
        property: "left",
        value: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
};
var $5a0cdca50d778174$export$616f7fc4ffce8510 = {
    name: "innerArrow",
    enabled: true,
    phase: "main",
    requires: [
        "arrow"
    ],
    fn: ({ state: state })=>{
        $5a0cdca50d778174$var$setInnerArrowStyles(state);
    },
    effect: ({ state: state })=>()=>{
            $5a0cdca50d778174$var$setInnerArrowStyles(state);
        }
};
var $5a0cdca50d778174$var$setInnerArrowStyles = (state)=>{
    if (!state.elements.arrow) return;
    const inner = state.elements.arrow.querySelector("[data-popper-arrow-inner]");
    if (!inner) return;
    const boxShadow = (0, $49cad064bf4d553f$export$bba5a971afe05444)(state.placement);
    if (boxShadow) inner.style.setProperty("--popper-arrow-default-shadow", boxShadow);
    Object.assign(inner.style, {
        transform: "rotate(45deg)",
        background: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowBg.varRef,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: "inherit",
        boxShadow: `var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))`
    });
};


"use client";
// src/popper.placement.ts
var $0e4d0230e74cb517$var$logicals = {
    "start-start": {
        ltr: "left-start",
        rtl: "right-start"
    },
    "start-end": {
        ltr: "left-end",
        rtl: "right-end"
    },
    "end-start": {
        ltr: "right-start",
        rtl: "left-start"
    },
    "end-end": {
        ltr: "right-end",
        rtl: "left-end"
    },
    start: {
        ltr: "left",
        rtl: "right"
    },
    end: {
        ltr: "right",
        rtl: "left"
    }
};
var $0e4d0230e74cb517$var$opposites = {
    "auto-start": "auto-end",
    "auto-end": "auto-start",
    "top-start": "top-end",
    "top-end": "top-start",
    "bottom-start": "bottom-end",
    "bottom-end": "bottom-start"
};
function $0e4d0230e74cb517$export$833b022d5a236f09(placement, dir = "ltr") {
    var _a, _b;
    const value = ((_a = $0e4d0230e74cb517$var$logicals[placement]) == null ? void 0 : _a[dir]) || placement;
    if (dir === "ltr") return value;
    return (_b = $0e4d0230e74cb517$var$opposites[placement]) != null ? _b : value;
}




function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules



var $acw62 = parcelRequire("acw62");
"use client";
function $5f2d029a715100c2$export$f4d5bf230a36dd6e(props = {}) {
    const { enabled: enabled = true, modifiers: modifiers, placement: placementProp = "bottom", strategy: strategy = "absolute", arrowPadding: arrowPadding = 8, eventListeners: eventListeners = true, offset: offset, gutter: gutter = 8, flip: flip = true, boundary: boundary = "clippingParents", preventOverflow: preventOverflow = true, matchWidth: matchWidth2, direction: direction = "ltr" } = props;
    const reference = (0, $acw62.useRef)(null);
    const popper = (0, $acw62.useRef)(null);
    const instance = (0, $acw62.useRef)(null);
    const placement = (0, $0e4d0230e74cb517$export$833b022d5a236f09)(placementProp, direction);
    const cleanup = (0, $acw62.useRef)(()=>{});
    const setupPopper = (0, $acw62.useCallback)(()=>{
        var _a;
        if (!enabled || !reference.current || !popper.current) return;
        (_a = cleanup.current) == null || _a.call(cleanup);
        instance.current = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(reference.current, popper.current, {
            placement: placement,
            modifiers: [
                (0, $5a0cdca50d778174$export$616f7fc4ffce8510),
                (0, $5a0cdca50d778174$export$36f2614d91c73bb6),
                (0, $5a0cdca50d778174$export$bd7bb1bc943e0611),
                {
                    ...(0, $5a0cdca50d778174$export$45d38cc6268103c7),
                    enabled: !!matchWidth2
                },
                {
                    name: "eventListeners",
                    ...(0, $49cad064bf4d553f$export$fafd30a196ad8838)(eventListeners)
                },
                {
                    name: "arrow",
                    options: {
                        padding: arrowPadding
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: offset != null ? offset : [
                            0,
                            gutter
                        ]
                    }
                },
                {
                    name: "flip",
                    enabled: !!flip,
                    options: {
                        padding: 8
                    }
                },
                {
                    name: "preventOverflow",
                    enabled: !!preventOverflow,
                    options: {
                        boundary: boundary
                    }
                },
                // allow users override internal modifiers
                ...modifiers != null ? modifiers : []
            ],
            strategy: strategy
        });
        instance.current.forceUpdate();
        cleanup.current = instance.current.destroy;
    }, [
        placement,
        enabled,
        modifiers,
        matchWidth2,
        eventListeners,
        arrowPadding,
        offset,
        gutter,
        flip,
        preventOverflow,
        boundary,
        strategy
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            var _a;
            if (!reference.current && !popper.current) {
                (_a = instance.current) == null || _a.destroy();
                instance.current = null;
            }
        };
    }, []);
    const referenceRef = (0, $acw62.useCallback)((node)=>{
        reference.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    const getReferenceProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(referenceRef, ref)
        }), [
        referenceRef
    ]);
    const popperRef = (0, $acw62.useCallback)((node)=>{
        popper.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    const getPopperProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(popperRef, ref),
            style: {
                ...props2.style,
                position: strategy,
                minWidth: matchWidth2 ? void 0 : "max-content",
                inset: "0 auto auto 0"
            }
        }), [
        strategy,
        popperRef,
        matchWidth2
    ]);
    const getArrowProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        const { size: size, shadowColor: shadowColor, bg: bg, style: style, ...rest } = props2;
        return {
            ...rest,
            ref: ref,
            "data-popper-arrow": "",
            style: $5f2d029a715100c2$var$getArrowStyle(props2)
        };
    }, []);
    const getArrowInnerProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: ref,
            "data-popper-arrow-inner": ""
        }), []);
    return {
        update () {
            var _a;
            (_a = instance.current) == null || _a.update();
        },
        forceUpdate () {
            var _a;
            (_a = instance.current) == null || _a.forceUpdate();
        },
        transformOrigin: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).transformOrigin.varRef,
        referenceRef: referenceRef,
        popperRef: popperRef,
        getPopperProps: getPopperProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps,
        getReferenceProps: getReferenceProps
    };
}
function $5f2d029a715100c2$var$getArrowStyle(props) {
    const { size: size, shadowColor: shadowColor, bg: bg, style: style } = props;
    const computedStyle = {
        ...style,
        position: "absolute"
    };
    if (size) computedStyle["--popper-arrow-size"] = size;
    if (shadowColor) computedStyle["--popper-arrow-shadow-color"] = shadowColor;
    if (bg) computedStyle["--popper-arrow-bg"] = bg;
    return computedStyle;
}




var $acw62 = parcelRequire("acw62");
"use client";
function $7bea845a3dd58b1a$export$6e3e27031a30522f(props = {}) {
    const { onClose: onCloseProp, onOpen: onOpenProp, isOpen: isOpenProp, id: idProp } = props;
    const handleOpen = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onOpenProp);
    const handleClose = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onCloseProp);
    const [isOpenState, setIsOpen] = (0, $acw62.useState)(props.defaultIsOpen || false);
    const isOpen = isOpenProp !== void 0 ? isOpenProp : isOpenState;
    const isControlled = isOpenProp !== void 0;
    const uid = (0, $acw62.useId)();
    const id = idProp != null ? idProp : `disclosure-${uid}`;
    const onClose = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(false);
        handleClose == null || handleClose();
    }, [
        isControlled,
        handleClose
    ]);
    const onOpen = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(true);
        handleOpen == null || handleOpen();
    }, [
        isControlled,
        handleOpen
    ]);
    const onToggle = (0, $acw62.useCallback)(()=>{
        if (isOpen) onClose();
        else onOpen();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    function getButtonProps(props2 = {}) {
        return {
            ...props2,
            "aria-expanded": isOpen,
            "aria-controls": id,
            onClick (event) {
                var _a;
                (_a = props2.onClick) == null || _a.call(props2, event);
                onToggle();
            }
        };
    }
    function getDisclosureProps(props2 = {}) {
        return {
            ...props2,
            hidden: !isOpen,
            id: id
        };
    }
    return {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
        isControlled: isControlled,
        getButtonProps: getButtonProps,
        getDisclosureProps: getDisclosureProps
    };
}



var $acw62 = parcelRequire("acw62");

"use client";
function $61adfc4b64394725$export$71b2224f1ce5e08e(props) {
    const { ref: ref, handler: handler, enabled: enabled = true } = props;
    const savedHandler = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(handler);
    const stateRef = (0, $acw62.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    const state = stateRef.current;
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return;
        const onPointerDown = (e)=>{
            if ($61adfc4b64394725$var$isValidEvent(e, ref)) state.isPointerDown = true;
        };
        const onMouseUp = (event)=>{
            if (state.ignoreEmulatedMouseEvents) {
                state.ignoreEmulatedMouseEvents = false;
                return;
            }
            if (state.isPointerDown && handler && $61adfc4b64394725$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        const onTouchEnd = (event)=>{
            state.ignoreEmulatedMouseEvents = true;
            if (handler && state.isPointerDown && $61adfc4b64394725$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        const doc = $61adfc4b64394725$var$getOwnerDocument(ref.current);
        doc.addEventListener("mousedown", onPointerDown, true);
        doc.addEventListener("mouseup", onMouseUp, true);
        doc.addEventListener("touchstart", onPointerDown, true);
        doc.addEventListener("touchend", onTouchEnd, true);
        return ()=>{
            doc.removeEventListener("mousedown", onPointerDown, true);
            doc.removeEventListener("mouseup", onMouseUp, true);
            doc.removeEventListener("touchstart", onPointerDown, true);
            doc.removeEventListener("touchend", onTouchEnd, true);
        };
    }, [
        handler,
        ref,
        savedHandler,
        state,
        enabled
    ]);
}
function $61adfc4b64394725$var$isValidEvent(event, ref) {
    var _a;
    const target = event.target;
    if (target) {
        const doc = $61adfc4b64394725$var$getOwnerDocument(target);
        if (!doc.contains(target)) return false;
    }
    return !((_a = ref.current) == null ? void 0 : _a.contains(target));
}
function $61adfc4b64394725$var$getOwnerDocument(node) {
    var _a;
    return (_a = node == null ? void 0 : node.ownerDocument) != null ? _a : document;
}



var $acw62 = parcelRequire("acw62");


"use client";
function $ed3c43d27f5556ee$export$7ee548861327febe(props) {
    const { isOpen: isOpen, ref: ref } = props;
    const [mounted, setMounted] = (0, $acw62.useState)(isOpen);
    const [once, setOnce] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!once) {
            setMounted(isOpen);
            setOnce(true);
        }
    }, [
        isOpen,
        once,
        mounted
    ]);
    (0, $3bc081da2876e6e9$export$7080b3e976bc91ab)(()=>ref.current, "animationend", ()=>{
        setMounted(isOpen);
    });
    const hidden = isOpen ? false : !mounted;
    return {
        present: !hidden,
        onComplete () {
            var _a;
            const win = (0, $534108a0b0d3445d$export$f21a1ffae260145a)(ref.current);
            const evt = new win.CustomEvent("animationend", {
                bubbles: true
            });
            (_a = ref.current) == null || _a.dispatchEvent(evt);
        }
    };
}








// src/index.ts
function $d3159b9260b16e67$export$76655e7dd9ffc0ba(options) {
    const { wasSelected: wasSelected, enabled: enabled, isSelected: isSelected, mode: mode = "unmount" } = options;
    if (!enabled) return true;
    if (isSelected) return true;
    if (mode === "keepMounted" && wasSelected) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");
"use client";
var [$936f91341562b8bb$export$6bd12c048acae948, $936f91341562b8bb$export$fb081774625c317c, $936f91341562b8bb$export$c383d7d91778257e, $936f91341562b8bb$export$e44adeffd1a0865c] = (0, $22443c9383de2d2c$export$126c4100f8947d7)();
var [$936f91341562b8bb$export$62b22d151866115d, $936f91341562b8bb$export$21c7ab35b39f78ec] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "MenuContext"
});
function $936f91341562b8bb$var$useIds(idProp, ...prefixes) {
    const reactId = (0, $acw62.useId)();
    const id = idProp || reactId;
    return (0, $acw62.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}
function $936f91341562b8bb$var$getOwnerDocument(node) {
    var _a;
    return (_a = node == null ? void 0 : node.ownerDocument) != null ? _a : document;
}
function $936f91341562b8bb$var$isActiveElement(element) {
    const doc = $936f91341562b8bb$var$getOwnerDocument(element);
    return doc.activeElement === element;
}
function $936f91341562b8bb$export$38eaa17faae8f579(props = {}) {
    const { id: id, closeOnSelect: closeOnSelect = true, closeOnBlur: closeOnBlur = true, initialFocusRef: initialFocusRef, autoSelect: autoSelect = true, isLazy: isLazy, isOpen: isOpenProp, defaultIsOpen: defaultIsOpen, onClose: onCloseProp, onOpen: onOpenProp, placement: placement = "bottom-start", lazyBehavior: lazyBehavior = "unmount", direction: direction, computePositionOnMount: computePositionOnMount = false, ...popperProps } = props;
    const menuRef = (0, $acw62.useRef)(null);
    const buttonRef = (0, $acw62.useRef)(null);
    const descendants = $936f91341562b8bb$export$c383d7d91778257e();
    const focusMenu = (0, $acw62.useCallback)(()=>{
        requestAnimationFrame(()=>{
            var _a;
            (_a = menuRef.current) == null || _a.focus({
                preventScroll: false
            });
        });
    }, []);
    const focusFirstItem = (0, $acw62.useCallback)(()=>{
        const id2 = setTimeout(()=>{
            var _a;
            if (initialFocusRef) (_a = initialFocusRef.current) == null || _a.focus();
            else {
                const first = descendants.firstEnabled();
                if (first) setFocusedIndex(first.index);
            }
        });
        timeoutIds.current.add(id2);
    }, [
        descendants,
        initialFocusRef
    ]);
    const focusLastItem = (0, $acw62.useCallback)(()=>{
        const id2 = setTimeout(()=>{
            const last = descendants.lastEnabled();
            if (last) setFocusedIndex(last.index);
        });
        timeoutIds.current.add(id2);
    }, [
        descendants
    ]);
    const onOpenInternal = (0, $acw62.useCallback)(()=>{
        onOpenProp == null || onOpenProp();
        if (autoSelect) focusFirstItem();
        else focusMenu();
    }, [
        autoSelect,
        focusFirstItem,
        focusMenu,
        onOpenProp
    ]);
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose, onToggle: onToggle } = (0, $7bea845a3dd58b1a$export$6e3e27031a30522f)({
        isOpen: isOpenProp,
        defaultIsOpen: defaultIsOpen,
        onClose: onCloseProp,
        onOpen: onOpenInternal
    });
    (0, $61adfc4b64394725$export$71b2224f1ce5e08e)({
        enabled: isOpen && closeOnBlur,
        ref: menuRef,
        handler: (event)=>{
            var _a;
            if (!((_a = buttonRef.current) == null ? void 0 : _a.contains(event.target))) onClose();
        }
    });
    const popper = (0, $5f2d029a715100c2$export$f4d5bf230a36dd6e)({
        ...popperProps,
        enabled: isOpen || computePositionOnMount,
        placement: placement,
        direction: direction
    });
    const [focusedIndex, setFocusedIndex] = (0, $acw62.useState)(-1);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (!isOpen) setFocusedIndex(-1);
    }, [
        isOpen
    ]);
    (0, $96ef6c3784d3cdb8$export$68b323438c1fbb28)(menuRef, {
        focusRef: buttonRef,
        visible: isOpen,
        shouldFocus: true
    });
    const animationState = (0, $ed3c43d27f5556ee$export$7ee548861327febe)({
        isOpen: isOpen,
        ref: menuRef
    });
    const [buttonId, menuId] = $936f91341562b8bb$var$useIds(id, `menu-button`, `menu-list`);
    const openAndFocusMenu = (0, $acw62.useCallback)(()=>{
        onOpen();
        focusMenu();
    }, [
        onOpen,
        focusMenu
    ]);
    const timeoutIds = (0, $acw62.useRef)(/* @__PURE__ */ new Set([]));
    (0, $acw62.useEffect)(()=>{
        const ids = timeoutIds.current;
        return ()=>{
            ids.forEach((id2)=>clearTimeout(id2));
            ids.clear();
        };
    }, []);
    const openAndFocusFirstItem = (0, $acw62.useCallback)(()=>{
        onOpen();
        focusFirstItem();
    }, [
        focusFirstItem,
        onOpen
    ]);
    const openAndFocusLastItem = (0, $acw62.useCallback)(()=>{
        onOpen();
        focusLastItem();
    }, [
        onOpen,
        focusLastItem
    ]);
    const refocus = (0, $acw62.useCallback)(()=>{
        var _a, _b;
        const doc = $936f91341562b8bb$var$getOwnerDocument(menuRef.current);
        const hasFocusWithin = (_a = menuRef.current) == null ? void 0 : _a.contains(doc.activeElement);
        const shouldRefocus = isOpen && !hasFocusWithin;
        if (!shouldRefocus) return;
        const node = (_b = descendants.item(focusedIndex)) == null ? void 0 : _b.node;
        node == null || node.focus({
            preventScroll: true
        });
    }, [
        isOpen,
        focusedIndex,
        descendants
    ]);
    const rafId = (0, $acw62.useRef)(null);
    return {
        openAndFocusMenu: openAndFocusMenu,
        openAndFocusFirstItem: openAndFocusFirstItem,
        openAndFocusLastItem: openAndFocusLastItem,
        onTransitionEnd: refocus,
        unstable__animationState: animationState,
        descendants: descendants,
        popper: popper,
        buttonId: buttonId,
        menuId: menuId,
        forceUpdate: popper.forceUpdate,
        orientation: "vertical",
        isOpen: isOpen,
        onToggle: onToggle,
        onOpen: onOpen,
        onClose: onClose,
        menuRef: menuRef,
        buttonRef: buttonRef,
        focusedIndex: focusedIndex,
        closeOnSelect: closeOnSelect,
        closeOnBlur: closeOnBlur,
        autoSelect: autoSelect,
        setFocusedIndex: setFocusedIndex,
        isLazy: isLazy,
        lazyBehavior: lazyBehavior,
        initialFocusRef: initialFocusRef,
        rafId: rafId
    };
}
function $936f91341562b8bb$export$660510f872408795(props = {}, externalRef = null) {
    const menu = $936f91341562b8bb$export$21c7ab35b39f78ec();
    const { onToggle: onToggle, popper: popper, openAndFocusFirstItem: openAndFocusFirstItem, openAndFocusLastItem: openAndFocusLastItem } = menu;
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        const eventKey = event.key;
        const keyMap = {
            Enter: openAndFocusFirstItem,
            ArrowDown: openAndFocusFirstItem,
            ArrowUp: openAndFocusLastItem
        };
        const action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            event.stopPropagation();
            action(event);
        }
    }, [
        openAndFocusFirstItem,
        openAndFocusLastItem
    ]);
    return {
        ...props,
        ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(menu.buttonRef, externalRef, popper.referenceRef),
        id: menu.buttonId,
        "data-active": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(menu.isOpen),
        "aria-expanded": menu.isOpen,
        "aria-haspopup": "menu",
        "aria-controls": menu.menuId,
        onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props.onClick, onToggle),
        onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    };
}
function $936f91341562b8bb$var$isTargetMenuItem(target) {
    var _a;
    return $936f91341562b8bb$var$isHTMLElement(target) && !!((_a = target == null ? void 0 : target.getAttribute("role")) == null ? void 0 : _a.startsWith("menuitem"));
}
function $936f91341562b8bb$export$8dcac42583be8292(props = {}, ref = null) {
    const menu = $936f91341562b8bb$export$21c7ab35b39f78ec();
    if (!menu) throw new Error(`useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>`);
    const { focusedIndex: focusedIndex, setFocusedIndex: setFocusedIndex, menuRef: menuRef, isOpen: isOpen, onClose: onClose, menuId: menuId, isLazy: isLazy, lazyBehavior: lazyBehavior, unstable__animationState: animated } = menu;
    const descendants = $936f91341562b8bb$export$fb081774625c317c();
    const createTypeaheadHandler = (0, $37b472694c13be1a$export$b0ebbe7904d8d94a)({
        preventDefault: (event)=>event.key !== " " && $936f91341562b8bb$var$isTargetMenuItem(event.target)
    });
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (!event.currentTarget.contains(event.target)) return;
        const eventKey = event.key;
        const keyMap = {
            Tab: (event2)=>event2.preventDefault(),
            Escape: onClose,
            ArrowDown: ()=>{
                const next = descendants.nextEnabled(focusedIndex);
                if (next) setFocusedIndex(next.index);
            },
            ArrowUp: ()=>{
                const prev = descendants.prevEnabled(focusedIndex);
                if (prev) setFocusedIndex(prev.index);
            }
        };
        const fn = keyMap[eventKey];
        if (fn) {
            event.preventDefault();
            fn(event);
            return;
        }
        const onTypeahead = createTypeaheadHandler((character)=>{
            const nextItem = (0, $6bc3ab6099e47e10$export$18ed781d9da46f95)(descendants.values(), character, (item)=>{
                var _a, _b;
                return (_b = (_a = item == null ? void 0 : item.node) == null ? void 0 : _a.textContent) != null ? _b : "";
            }, descendants.item(focusedIndex));
            if (nextItem) {
                const index = descendants.indexOf(nextItem.node);
                setFocusedIndex(index);
            }
        });
        if ($936f91341562b8bb$var$isTargetMenuItem(event.target)) onTypeahead(event);
    }, [
        descendants,
        focusedIndex,
        createTypeaheadHandler,
        onClose,
        setFocusedIndex
    ]);
    const hasBeenOpened = (0, $acw62.useRef)(false);
    if (isOpen) hasBeenOpened.current = true;
    const shouldRenderChildren = (0, $d3159b9260b16e67$export$76655e7dd9ffc0ba)({
        wasSelected: hasBeenOpened.current,
        enabled: isLazy,
        mode: lazyBehavior,
        isSelected: animated.present
    });
    return {
        ...props,
        ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(menuRef, ref),
        children: shouldRenderChildren ? props.children : null,
        tabIndex: -1,
        role: "menu",
        id: menuId,
        style: {
            ...props.style,
            transformOrigin: "var(--popper-transform-origin)"
        },
        "aria-orientation": "vertical",
        onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    };
}
function $936f91341562b8bb$export$5149508ab5f84d86(props = {}) {
    const { popper: popper, isOpen: isOpen } = $936f91341562b8bb$export$21c7ab35b39f78ec();
    return popper.getPopperProps({
        ...props,
        style: {
            visibility: isOpen ? "visible" : "hidden",
            ...props.style
        }
    });
}
function $936f91341562b8bb$export$9d32628fc2aea7da(props = {}, externalRef = null) {
    const { onMouseEnter: onMouseEnterProp, onMouseMove: onMouseMoveProp, onMouseLeave: onMouseLeaveProp, onClick: onClickProp, onFocus: onFocusProp, isDisabled: isDisabled, isFocusable: isFocusable, closeOnSelect: closeOnSelect, type: typeProp, ...htmlProps } = props;
    const menu = $936f91341562b8bb$export$21c7ab35b39f78ec();
    const { setFocusedIndex: setFocusedIndex, focusedIndex: focusedIndex, closeOnSelect: menuCloseOnSelect, onClose: onClose, menuRef: menuRef, isOpen: isOpen, menuId: menuId, rafId: rafId } = menu;
    const ref = (0, $acw62.useRef)(null);
    const id = `${menuId}-menuitem-${(0, $acw62.useId)()}`;
    const { index: index, register: register } = $936f91341562b8bb$export$e44adeffd1a0865c({
        disabled: isDisabled && !isFocusable
    });
    const onMouseEnter = (0, $acw62.useCallback)((event)=>{
        onMouseEnterProp == null || onMouseEnterProp(event);
        if (isDisabled) return;
        setFocusedIndex(index);
    }, [
        setFocusedIndex,
        index,
        isDisabled,
        onMouseEnterProp
    ]);
    const onMouseMove = (0, $acw62.useCallback)((event)=>{
        onMouseMoveProp == null || onMouseMoveProp(event);
        if (ref.current && !$936f91341562b8bb$var$isActiveElement(ref.current)) onMouseEnter(event);
    }, [
        onMouseEnter,
        onMouseMoveProp
    ]);
    const onMouseLeave = (0, $acw62.useCallback)((event)=>{
        onMouseLeaveProp == null || onMouseLeaveProp(event);
        if (isDisabled) return;
        setFocusedIndex(-1);
    }, [
        setFocusedIndex,
        isDisabled,
        onMouseLeaveProp
    ]);
    const onClick = (0, $acw62.useCallback)((event)=>{
        onClickProp == null || onClickProp(event);
        if (!$936f91341562b8bb$var$isTargetMenuItem(event.currentTarget)) return;
        if (closeOnSelect != null ? closeOnSelect : menuCloseOnSelect) onClose();
    }, [
        onClose,
        onClickProp,
        menuCloseOnSelect,
        closeOnSelect
    ]);
    const onFocus = (0, $acw62.useCallback)((event)=>{
        onFocusProp == null || onFocusProp(event);
        setFocusedIndex(index);
    }, [
        setFocusedIndex,
        onFocusProp,
        index
    ]);
    const isFocused = index === focusedIndex;
    const trulyDisabled = isDisabled && !isFocusable;
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (!isOpen) return;
        if (isFocused && !trulyDisabled && ref.current) {
            if (rafId.current) cancelAnimationFrame(rafId.current);
            rafId.current = requestAnimationFrame(()=>{
                var _a;
                (_a = ref.current) == null || _a.focus({
                    preventScroll: true
                });
                rafId.current = null;
            });
        } else if (menuRef.current && !$936f91341562b8bb$var$isActiveElement(menuRef.current)) menuRef.current.focus({
            preventScroll: true
        });
        return ()=>{
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, [
        isFocused,
        trulyDisabled,
        menuRef,
        isOpen
    ]);
    const clickableProps = (0, $8dec279e09834157$export$ed213cc82e426b1a)({
        onClick: onClick,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeave,
        ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(register, ref, externalRef),
        isDisabled: isDisabled,
        isFocusable: isFocusable
    });
    return {
        ...htmlProps,
        ...clickableProps,
        type: typeProp != null ? typeProp : clickableProps.type,
        id: id,
        role: "menuitem",
        tabIndex: isFocused ? 0 : -1
    };
}
function $936f91341562b8bb$export$8ca3fd7c19c454af(props = {}, ref = null) {
    const { type: type = "radio", isChecked: isChecked, ...rest } = props;
    const ownProps = $936f91341562b8bb$export$9d32628fc2aea7da(rest, ref);
    return {
        ...ownProps,
        role: `menuitem${type}`,
        "aria-checked": isChecked
    };
}
function $936f91341562b8bb$export$9dcb3089500f52be(props = {}) {
    const { children: children, type: type = "radio", value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, ...htmlProps } = props;
    const isRadio = type === "radio";
    const fallback = isRadio ? "" : [];
    const [value, setValue] = (0, $4795b7ced84aa3c2$export$6f32135080cb4c3)({
        defaultValue: defaultValue != null ? defaultValue : fallback,
        value: valueProp,
        onChange: onChangeProp
    });
    const onChange = (0, $acw62.useCallback)((selectedValue)=>{
        if (type === "radio" && typeof value === "string") setValue(selectedValue);
        if (type === "checkbox" && Array.isArray(value)) {
            const nextValue = value.includes(selectedValue) ? value.filter((item)=>item !== selectedValue) : value.concat(selectedValue);
            setValue(nextValue);
        }
    }, [
        value,
        setValue,
        type
    ]);
    const validChildren = (0, $197fffec5094e9ee$export$b2c43d7d050b2e63)(children);
    const clones = validChildren.map((child)=>{
        if (child.type.id !== "MenuItemOption") return child;
        const onClick = (event)=>{
            var _a, _b;
            onChange(child.props.value);
            (_b = (_a = child.props).onClick) == null || _b.call(_a, event);
        };
        const isChecked = type === "radio" ? child.props.value === value : value.includes(child.props.value);
        return (0, $acw62.cloneElement)(child, {
            type: type,
            onClick: onClick,
            isChecked: isChecked
        });
    });
    return {
        ...htmlProps,
        children: clones
    };
}
function $936f91341562b8bb$export$8091e3849c182a6() {
    const { isOpen: isOpen, onClose: onClose } = $936f91341562b8bb$export$21c7ab35b39f78ec();
    return {
        isOpen: isOpen,
        onClose: onClose
    };
}
function $936f91341562b8bb$var$isHTMLElement(el) {
    var _a;
    if (!$936f91341562b8bb$var$isElement(el)) return false;
    const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
    return el instanceof win.HTMLElement;
}
function $936f91341562b8bb$var$isElement(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}






var $acw62 = parcelRequire("acw62");

"use client";
var [$ecb323b85332da3d$var$MenuStylesProvider, $ecb323b85332da3d$export$e7aea412cbc2ca01] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `MenuStylesContext`,
    errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
});
var $ecb323b85332da3d$export$d9b273488cd8ce6f = (props)=>{
    const { children: children } = props;
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Menu", props);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const { direction: direction } = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    const { descendants: descendants, ...ctx } = (0, $936f91341562b8bb$export$38eaa17faae8f579)({
        ...ownProps,
        direction: direction
    });
    const context = (0, $acw62.useMemo)(()=>ctx, [
        ctx
    ]);
    const { isOpen: isOpen, onClose: onClose, forceUpdate: forceUpdate } = context;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $936f91341562b8bb$export$6bd12c048acae948), {
        value: descendants,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $936f91341562b8bb$export$62b22d151866115d), {
            value: context,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ecb323b85332da3d$var$MenuStylesProvider, {
                value: styles,
                children: (0, $abe97432afb3d989$export$624e501d81f5ffce)(children, {
                    isOpen: isOpen,
                    onClose: onClose,
                    forceUpdate: forceUpdate
                })
            })
        })
    });
};
$ecb323b85332da3d$export$d9b273488cd8ce6f.displayName = "Menu";






"use client";
var $a5c35d2b61ef6439$var$StyledMenuButton = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $ecb323b85332da3d$export$e7aea412cbc2ca01)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).button, {
        ref: ref,
        ...props,
        __css: {
            display: "inline-flex",
            appearance: "none",
            alignItems: "center",
            outline: 0,
            ...styles.button
        }
    });
});
var $a5c35d2b61ef6439$export$266a769812832828 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { children: children, as: As, ...rest } = props;
    const buttonProps = (0, $936f91341562b8bb$export$660510f872408795)(rest, ref);
    const Element = As || $a5c35d2b61ef6439$var$StyledMenuButton;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Element, {
        ...buttonProps,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__menu-button", props.className),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
            __css: {
                pointerEvents: "none",
                flex: "1 1 auto",
                minW: 0
            },
            children: props.children
        })
    });
});
$a5c35d2b61ef6439$export$266a769812832828.displayName = "MenuButton";





"use client";
var $c13511f8b7e83bea$export$acb07b4664ac227c = (props)=>{
    const { className: className, ...rest } = props;
    const styles = (0, $ecb323b85332da3d$export$e7aea412cbc2ca01)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).hr, {
        "aria-orientation": "horizontal",
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__divider", className),
        ...rest,
        __css: styles.divider
    });
};
$c13511f8b7e83bea$export$acb07b4664ac227c.displayName = "MenuDivider";





"use client";
var $2663798dec8fa87a$export$22a631d1f72787bb = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { title: title, children: children, className: className, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__group__title", className);
    const styles = (0, $ecb323b85332da3d$export$e7aea412cbc2ca01)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        className: "chakra-menu__group",
        role: "group",
        children: [
            title && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).p, {
                className: _className,
                ...rest,
                __css: styles.groupTitle,
                children: title
            }),
            children
        ]
    });
});
$2663798dec8fa87a$export$22a631d1f72787bb.displayName = "MenuGroup";




"use client";
var $887ff33134b41a08$export$1fab7891e4a3c1fd = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $ecb323b85332da3d$export$e7aea412cbc2ca01)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
        ref: ref,
        ...props,
        __css: styles.command,
        className: "chakra-menu__command"
    });
});
$887ff33134b41a08$export$1fab7891e4a3c1fd.displayName = "MenuCommand";





var $acw62 = parcelRequire("acw62");

"use client";
var $72de4f72cb1e9a20$export$cae703c457e46f23 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { type: type, ...rest } = props;
    const styles = (0, $ecb323b85332da3d$export$e7aea412cbc2ca01)();
    const btnType = rest.as || type ? type != null ? type : void 0 : "button";
    const buttonStyles = (0, $acw62.useMemo)(()=>({
            textDecoration: "none",
            color: "inherit",
            userSelect: "none",
            display: "flex",
            width: "100%",
            alignItems: "center",
            textAlign: "start",
            flex: "0 0 auto",
            outline: 0,
            ...styles.item
        }), [
        styles.item
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).button, {
        ref: ref,
        type: btnType,
        ...rest,
        __css: buttonStyles
    });
});






var $acw62 = parcelRequire("acw62");

"use client";
var $dfbfeaa9dc56b181$export$46e1d66043f363e6 = (props)=>{
    const { className: className, children: children, ...rest } = props;
    const styles = (0, $ecb323b85332da3d$export$e7aea412cbc2ca01)();
    const child = (0, $acw62.Children).only(children);
    const clone = (0, $acw62.isValidElement)(child) ? (0, $acw62.cloneElement)(child, {
        focusable: "false",
        "aria-hidden": true,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__icon", child.props.className)
    }) : null;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__icon-wrapper", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
        className: _className,
        ...rest,
        __css: styles.icon,
        children: clone
    });
};
$dfbfeaa9dc56b181$export$46e1d66043f363e6.displayName = "MenuIcon";






"use client";
var $598b741191098976$export$2ce376c2cc3355c8 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { icon: icon, iconSpacing: iconSpacing = "0.75rem", command: command, commandSpacing: commandSpacing = "0.75rem", children: children, ...rest } = props;
    const menuitemProps = (0, $936f91341562b8bb$export$9d32628fc2aea7da)(rest, ref);
    const shouldWrap = icon || command;
    const _children = shouldWrap ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            pointerEvents: "none",
            flex: 1
        },
        children: children
    }) : children;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $72de4f72cb1e9a20$export$cae703c457e46f23), {
        ...menuitemProps,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__menuitem", menuitemProps.className),
        children: [
            icon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dfbfeaa9dc56b181$export$46e1d66043f363e6), {
                fontSize: "0.8em",
                marginEnd: iconSpacing,
                children: icon
            }),
            _children,
            command && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $887ff33134b41a08$export$1fab7891e4a3c1fd), {
                marginStart: commandSpacing,
                children: command
            })
        ]
    });
});
$598b741191098976$export$2ce376c2cc3355c8.displayName = "MenuItem";







"use client";
var $ce1d48c66e9cd398$var$motionVariants = {
    enter: {
        visibility: "visible",
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        transitionEnd: {
            visibility: "hidden"
        },
        opacity: 0,
        scale: 0.8,
        transition: {
            duration: 0.1,
            easings: "easeOut"
        }
    }
};
var $ce1d48c66e9cd398$var$MenuTransition = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div);
var $ce1d48c66e9cd398$export$d4c4e98c5044dc8 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function MenuList2(props, ref) {
    var _a, _b;
    const { rootProps: rootProps, motionProps: motionProps, ...rest } = props;
    const { isOpen: isOpen, onTransitionEnd: onTransitionEnd, unstable__animationState: animated } = (0, $936f91341562b8bb$export$21c7ab35b39f78ec)();
    const listProps = (0, $936f91341562b8bb$export$8dcac42583be8292)(rest, ref);
    const positionerProps = (0, $936f91341562b8bb$export$5149508ab5f84d86)(rootProps);
    const styles = (0, $ecb323b85332da3d$export$e7aea412cbc2ca01)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...positionerProps,
        __css: {
            zIndex: (_b = props.zIndex) != null ? _b : (_a = styles.list) == null ? void 0 : _a.zIndex
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ce1d48c66e9cd398$var$MenuTransition, {
            variants: $ce1d48c66e9cd398$var$motionVariants,
            initial: false,
            animate: isOpen ? "enter" : "exit",
            __css: {
                outline: 0,
                ...styles.list
            },
            ...motionProps,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__menu-list", listProps.className),
            ...listProps,
            onUpdate: onTransitionEnd,
            onAnimationComplete: (0, $abe97432afb3d989$export$9dd9a52f2dd5b9ce)(animated.onComplete, listProps.onAnimationComplete)
        })
    });
});
$ce1d48c66e9cd398$export$d4c4e98c5044dc8.displayName = "MenuList";

"use client";
var $1ecb8f4b9f1b6b98$var$__defProp = Object.defineProperty;
var $1ecb8f4b9f1b6b98$var$__defNormalProp = (obj, key, value)=>key in obj ? $1ecb8f4b9f1b6b98$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1ecb8f4b9f1b6b98$export$5cb848ba4d1f099 = (obj, key, value)=>{
    $1ecb8f4b9f1b6b98$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};



var $acw62 = parcelRequire("acw62");
"use client";
var $b09f0d09ca2d779f$var$ModalManager = class {
    constructor(){
        (0, $1ecb8f4b9f1b6b98$export$5cb848ba4d1f099)(this, "modals");
        this.modals = /* @__PURE__ */ new Map();
    }
    add(modal) {
        this.modals.set(modal, this.modals.size + 1);
        return this.modals.size;
    }
    remove(modal) {
        this.modals.delete(modal);
    }
    isTopModal(modal) {
        if (!modal) return false;
        return this.modals.get(modal) === this.modals.size;
    }
};
var $b09f0d09ca2d779f$export$78d35f50a4fd5552 = new $b09f0d09ca2d779f$var$ModalManager();
function $b09f0d09ca2d779f$export$8557a94b9bb25060(ref, isOpen) {
    const [index, setIndex] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (!node) return;
        if (isOpen) {
            const index2 = $b09f0d09ca2d779f$export$78d35f50a4fd5552.add(node);
            setIndex(index2);
        }
        return ()=>{
            $b09f0d09ca2d779f$export$78d35f50a4fd5552.remove(node);
            setIndex(0);
        };
    }, [
        isOpen,
        ref
    ]);
    return index;
}




var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $acw62 = parcelRequire("acw62");
"use client";
function $fa7450baa69baf87$export$33ffd74ebf07f060(props) {
    const { isOpen: isOpen, onClose: onClose, id: id, closeOnOverlayClick: closeOnOverlayClick = true, closeOnEsc: closeOnEsc = true, useInert: useInert = true, onOverlayClick: onOverlayClickProp, onEsc: onEsc } = props;
    const dialogRef = (0, $acw62.useRef)(null);
    const overlayRef = (0, $acw62.useRef)(null);
    const [dialogId, headerId, bodyId] = $fa7450baa69baf87$var$useIds(id, `chakra-modal`, `chakra-modal--header`, `chakra-modal--body`);
    $fa7450baa69baf87$export$bf01aaa71a18e30b(dialogRef, isOpen && useInert);
    const index = (0, $b09f0d09ca2d779f$export$8557a94b9bb25060)(dialogRef, isOpen);
    const mouseDownTarget = (0, $acw62.useRef)(null);
    const onMouseDown = (0, $acw62.useCallback)((event)=>{
        mouseDownTarget.current = event.target;
    }, []);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.key === "Escape") {
            event.stopPropagation();
            if (closeOnEsc) onClose == null || onClose();
            onEsc == null || onEsc();
        }
    }, [
        closeOnEsc,
        onClose,
        onEsc
    ]);
    const [headerMounted, setHeaderMounted] = (0, $acw62.useState)(false);
    const [bodyMounted, setBodyMounted] = (0, $acw62.useState)(false);
    const getDialogProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            role: "dialog",
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, dialogRef),
            id: dialogId,
            tabIndex: -1,
            "aria-modal": true,
            "aria-labelledby": headerMounted ? headerId : void 0,
            "aria-describedby": bodyMounted ? bodyId : void 0,
            onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onClick, (event)=>event.stopPropagation())
        }), [
        bodyId,
        bodyMounted,
        dialogId,
        headerId,
        headerMounted
    ]);
    const onOverlayClick = (0, $acw62.useCallback)((event)=>{
        event.stopPropagation();
        if (mouseDownTarget.current !== event.target) return;
        if (!(0, $b09f0d09ca2d779f$export$78d35f50a4fd5552).isTopModal(dialogRef.current)) return;
        if (closeOnOverlayClick) onClose == null || onClose();
        onOverlayClickProp == null || onOverlayClickProp();
    }, [
        onClose,
        closeOnOverlayClick,
        onOverlayClickProp
    ]);
    const getDialogContainerProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, overlayRef),
            onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onClick, onOverlayClick),
            onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onMouseDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseDown, onMouseDown)
        }), [
        onKeyDown,
        onMouseDown,
        onOverlayClick
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        headerId: headerId,
        bodyId: bodyId,
        setBodyMounted: setBodyMounted,
        setHeaderMounted: setHeaderMounted,
        dialogRef: dialogRef,
        overlayRef: overlayRef,
        getDialogProps: getDialogProps,
        getDialogContainerProps: getDialogContainerProps,
        index: index
    };
}
function $fa7450baa69baf87$export$bf01aaa71a18e30b(ref, shouldHide) {
    const currentElement = ref.current;
    (0, $acw62.useEffect)(()=>{
        if (!ref.current || !shouldHide) return void 0;
        return (0, $4a7537e072260c10$export$6e33d16126ed003c)(ref.current);
    }, [
        shouldHide,
        ref,
        currentElement
    ]);
}
function $fa7450baa69baf87$var$useIds(idProp, ...prefixes) {
    const reactId = (0, $acw62.useId)();
    const id = idProp || reactId;
    return (0, $acw62.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}







"use client";
var [$4410258333ca5546$var$ModalStylesProvider, $4410258333ca5546$export$c540eec2ed4454a2] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `ModalStylesContext`,
    errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
});
var [$4410258333ca5546$export$7c9538f5f3c365e9, $4410258333ca5546$export$4cc1699d46f42cae] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: true,
    name: "ModalContext",
    errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
});
var $4410258333ca5546$export$2b77a92f1a5ad772 = (props)=>{
    const modalProps = {
        scrollBehavior: "outside",
        autoFocus: true,
        trapFocus: true,
        returnFocusOnClose: true,
        blockScrollOnMount: true,
        allowPinchZoom: false,
        motionPreset: "scale",
        lockFocusAcrossFrames: true,
        ...props
    };
    const { portalProps: portalProps, children: children, autoFocus: autoFocus, trapFocus: trapFocus, initialFocusRef: initialFocusRef, finalFocusRef: finalFocusRef, returnFocusOnClose: returnFocusOnClose, blockScrollOnMount: blockScrollOnMount, allowPinchZoom: allowPinchZoom, preserveScrollBarGap: preserveScrollBarGap, motionPreset: motionPreset, lockFocusAcrossFrames: lockFocusAcrossFrames, onCloseComplete: onCloseComplete } = modalProps;
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Modal", modalProps);
    const modal = (0, $fa7450baa69baf87$export$33ffd74ebf07f060)(modalProps);
    const context = {
        ...modal,
        autoFocus: autoFocus,
        trapFocus: trapFocus,
        initialFocusRef: initialFocusRef,
        finalFocusRef: finalFocusRef,
        returnFocusOnClose: returnFocusOnClose,
        blockScrollOnMount: blockScrollOnMount,
        allowPinchZoom: allowPinchZoom,
        preserveScrollBarGap: preserveScrollBarGap,
        motionPreset: motionPreset,
        lockFocusAcrossFrames: lockFocusAcrossFrames
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4410258333ca5546$export$7c9538f5f3c365e9, {
        value: context,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4410258333ca5546$var$ModalStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                onExitComplete: onCloseComplete,
                children: context.isOpen && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b71276780b6a43df$export$602eac185826482c), {
                    ...portalProps,
                    children: children
                })
            })
        })
    });
};
$4410258333ca5546$export$2b77a92f1a5ad772.displayName = "Modal";





"use client";
var [$2c5be1008fbfcbeb$var$DrawerContextProvider, $2c5be1008fbfcbeb$export$cc200cef0c88a66f] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)();
var $2c5be1008fbfcbeb$var$placementMap = {
    start: {
        ltr: "left",
        rtl: "right"
    },
    end: {
        ltr: "right",
        rtl: "left"
    }
};
function $2c5be1008fbfcbeb$var$getDrawerPlacement(placement, dir) {
    var _a, _b;
    if (!placement) return;
    return (_b = (_a = $2c5be1008fbfcbeb$var$placementMap[placement]) == null ? void 0 : _a[dir]) != null ? _b : placement;
}
function $2c5be1008fbfcbeb$export$4071300121a182f5(props) {
    var _a;
    const { isOpen: isOpen, onClose: onClose, placement: placementProp = "right", children: children, ...rest } = props;
    const theme = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    const drawerStyleConfig = (_a = theme.components) == null ? void 0 : _a.Drawer;
    const placement = $2c5be1008fbfcbeb$var$getDrawerPlacement(placementProp, theme.direction);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($2c5be1008fbfcbeb$var$DrawerContextProvider, {
        value: {
            placement: placement
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4410258333ca5546$export$2b77a92f1a5ad772), {
            isOpen: isOpen,
            onClose: onClose,
            styleConfig: drawerStyleConfig,
            ...rest,
            children: children
        })
    });
}




function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $34f6623b57e1a1c8$exports = {};

$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_GROUP", () => $34f6623b57e1a1c8$export$4f9a06cb7441a087);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_DISABLED", () => $34f6623b57e1a1c8$export$aeda8252e54b50f7);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_ALLOW", () => $34f6623b57e1a1c8$export$54ecf528c58f9ef6);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_AUTO", () => $34f6623b57e1a1c8$export$70e9b4a1820af101);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_NO_AUTOFOCUS", () => $34f6623b57e1a1c8$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $34f6623b57e1a1c8$export$4f9a06cb7441a087 = "data-focus-lock";
var $34f6623b57e1a1c8$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $34f6623b57e1a1c8$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $34f6623b57e1a1c8$export$70e9b4a1820af101 = "data-autofocus-inside";
var $34f6623b57e1a1c8$export$134ebef29fd94853 = "data-no-autofocus";



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $acw62 = parcelRequire("acw62");

var $119d56c93ccd46db$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $119d56c93ccd46db$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $acw62.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }));
};
$119d56c93ccd46db$var$InFocusGuard.propTypes = {};
var $119d56c93ccd46db$export$2e2bcd8739ae039 = $119d56c93ccd46db$var$InFocusGuard;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};


function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $292937b69072d1e6$export$5733e022b1d538cb = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $292937b69072d1e6$export$b3e9a9312f73723c = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$3a1d52767cbc07b8 = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$892cbf28e5518020 = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)({
    async: true,
    ssr: typeof document !== "undefined"
});



var $acw62 = parcelRequire("acw62");
var $8e648ed3a7dabece$export$f5272e9b1168239c = /*#__PURE__*/ (0, $acw62.createContext)(undefined);


var $e86725766b4cde33$var$emptyArray = [];
var $e86725766b4cde33$var$FocusLock = /*#__PURE__*/ $acw62.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $acw62.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $acw62.useRef();
    var isActive = $acw62.useRef(false);
    var originalFocusedElement = $acw62.useRef(null);
    var _React$useState2 = $acw62.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $e86725766b4cde33$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $acw62.useState({}), id = _React$useState3[0];
    var onActivation = $acw62.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $acw62.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $acw62.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === "function" ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $acw62.useCallback(function(event) {
        if (isActive.current) (0, $292937b69072d1e6$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $292937b69072d1e6$export$b3e9a9312f73723c).useMedium;
    var setObserveNode = $acw62.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[$34f6623b57e1a1c8$export$aeda8252e54b50f7] = disabled && "disabled", _extends2[$34f6623b57e1a1c8$export$4f9a06cb7441a087] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $acw62.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $acw62.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $acw62.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }) : null
    ], !disabled && /*#__PURE__*/ $acw62.createElement(SideCar, {
        id: id,
        sideCar: (0, $292937b69072d1e6$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $acw62.createElement(Container, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $acw62.createElement((0, $8e648ed3a7dabece$export$f5272e9b1168239c).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $acw62.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
    }));
});
$e86725766b4cde33$var$FocusLock.propTypes = {};
var $e86725766b4cde33$export$2e2bcd8739ae039 = $e86725766b4cde33$var$FocusLock;



var $acw62 = parcelRequire("acw62");

function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}


function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $acw62 = parcelRequire("acw62");
function $bec73a156e960f78$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $acw62.PureComponent));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $bec73a156e960f78$export$2e2bcd8739ae039 = $bec73a156e960f78$var$withSideEffect;


/*
IE11 support
 */ var $c2cb5aa387a37a50$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $c2cb5aa387a37a50$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $c2cb5aa387a37a50$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};



var $2cff22612808ae96$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $2cff22612808ae96$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $2cff22612808ae96$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $2cff22612808ae96$var$isInert = function(node) {
    return node.hasAttribute("inert");
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $2cff22612808ae96$var$isVisibleUncached = function(node, checkParent) {
    return !node || $2cff22612808ae96$var$isTopNode(node) || !$2cff22612808ae96$var$isElementHidden(node) && !$2cff22612808ae96$var$isInert(node) && checkParent($2cff22612808ae96$var$getParentNode(node));
};
var $2cff22612808ae96$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isVisibleUncached(node, $2cff22612808ae96$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $2cff22612808ae96$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$2cff22612808ae96$var$isTopNode(node) ? $2cff22612808ae96$export$b8550e27de209d85(node) ? checkParent($2cff22612808ae96$var$getParentNode(node)) : false : true;
};
var $2cff22612808ae96$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isAutoFocusAllowedUncached(node, $2cff22612808ae96$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $2cff22612808ae96$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $2cff22612808ae96$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === "BUTTON";
};
var $2cff22612808ae96$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === "INPUT";
};
var $2cff22612808ae96$export$9d74f6fbc6f469d0 = function(node) {
    return $2cff22612808ae96$export$88a6ceeed5737ba3(node) && node.type === "radio";
};
var $2cff22612808ae96$export$8197b0ea56b3b055 = function(node) {
    return !(($2cff22612808ae96$export$88a6ceeed5737ba3(node) || $2cff22612808ae96$export$65aad1b6bc934b11(node)) && (node.type === "hidden" || node.disabled));
};
var $2cff22612808ae96$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $34f6623b57e1a1c8$export$134ebef29fd94853));
    return ![
        true,
        "true",
        ""
    ].includes(attribute);
};
var $2cff22612808ae96$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $2cff22612808ae96$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $2cff22612808ae96$export$602e5a0d338d7750 = function(node) {
    return !$2cff22612808ae96$export$d94b8b58ec2f30eb(node);
};
var $2cff22612808ae96$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};



var $e6301f5798625d25$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $e6301f5798625d25$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute("tabindex")) return 0;
    }
    return node.tabIndex;
};
var $e6301f5798625d25$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).map(function(node, index) {
        var tabIndex = $e6301f5798625d25$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($e6301f5798625d25$export$350ee6c095d98996);
};




/**
 * list of the object to be considered as focusable
 */ var $9fc4580037f02fd3$export$8555f4622e95784 = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];


var $c85a3cad3fc06f20$var$queryTabbables = (0, $9fc4580037f02fd3$export$8555f4622e95784).join(",");
var $c85a3cad3fc06f20$var$queryGuardTabbables = "".concat($c85a3cad3fc06f20$var$queryTabbables, ", [data-focus-guard]");
var $c85a3cad3fc06f20$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $c85a3cad3fc06f20$var$queryGuardTabbables : $c85a3cad3fc06f20$var$queryTabbables) ? [
            child
        ] : [], $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $c85a3cad3fc06f20$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $c85a3cad3fc06f20$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $c85a3cad3fc06f20$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $c85a3cad3fc06f20$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $c2cb5aa387a37a50$export$45b10814cc054894)(parent.parentNode.querySelectorAll($c85a3cad3fc06f20$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $c85a3cad3fc06f20$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$70e9b4a1820af101), "]"));
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(parentFocus).map(function(node) {
        return $c85a3cad3fc06f20$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};


var $9b74641517b143d6$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $2cff22612808ae96$export$3c9dc299685ad160)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $2cff22612808ae96$export$8197b0ea56b3b055)(node);
    });
};
var $9b74641517b143d6$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $2cff22612808ae96$export$bcaa50628f6a736e)(cache, node);
    });
};
var $9b74641517b143d6$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $e6301f5798625d25$export$cb40ee071f0d5226)($9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$f6768025e418420e)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $9b74641517b143d6$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $e6301f5798625d25$export$cb40ee071f0d5226)($9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$f6768025e418420e)(topNodes), visibilityCache), false);
};
var $9b74641517b143d6$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$853fa94d922e78b9)(topNode), visibilityCache);
};
var $9b74641517b143d6$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $9b74641517b143d6$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $9b74641517b143d6$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $9b74641517b143d6$export$2344b14b097df817(child, element);
        });
    }
};


function $e8393b55a6e31e11$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === "undefined") return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $e8393b55a6e31e11$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $e8393b55a6e31e11$var$weakRef(currentElement),
            parent: $e8393b55a6e31e11$var$weakRef(currentElement.parentElement),
            left: $e8393b55a6e31e11$var$weakRef(currentElement.previousElementSibling),
            right: $e8393b55a6e31e11$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $e8393b55a6e31e11$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $e8393b55a6e31e11$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $9b74641517b143d6$export$3738e313571e2ad2)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $e8393b55a6e31e11$export$d357db6e554ff59a = function(targetElement) {
    var location = $e8393b55a6e31e11$export$5061a7725be48ff9(targetElement);
    return function() {
        return $e8393b55a6e31e11$var$restoreFocusTo(location);
    };
};



/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $7bf194f892d90e1b$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $7bf194f892d90e1b$var$getTopParent = function(node) {
    return node.parentNode ? $7bf194f892d90e1b$var$getTopParent(node.parentNode) : node;
};
var $7bf194f892d90e1b$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $34f6623b57e1a1c8$export$4f9a06cb7441a087));
        acc.push.apply(acc, group ? $7bf194f892d90e1b$var$filterNested((0, $c2cb5aa387a37a50$export$45b10814cc054894)($7bf194f892d90e1b$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$4f9a06cb7441a087), '="').concat(group, '"]:not([').concat((0, $34f6623b57e1a1c8$export$aeda8252e54b50f7), '="disabled"])')))) : [
            currentNode
        ]);
        return acc;
    }, []);
};





var $51d90458d728fe34$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $51d90458d728fe34$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $51d90458d728fe34$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $51d90458d728fe34$var$getParents(nodeA);
    var parentsB = $51d90458d728fe34$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $51d90458d728fe34$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(baseActiveElement);
    var leftEntries = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $51d90458d728fe34$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $51d90458d728fe34$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $9b74641517b143d6$export$2344b14b097df817)(common, topCommon)) topCommon = common;
                else topCommon = $51d90458d728fe34$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $51d90458d728fe34$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $9b74641517b143d6$export$dc26309a71d1ce47)(node, visibilityCache));
    }, []);
};




var $3f73a80c2e676402$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).filter((0, $2cff22612808ae96$export$602e5a0d338d7750));
    var commonParent = (0, $51d90458d728fe34$export$a9a7252b5f2e280e)(topNode, topNode, entries);
    var outerNodes = (0, $e6301f5798625d25$export$cb40ee071f0d5226)((0, $c85a3cad3fc06f20$export$f6768025e418420e)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $c85a3cad3fc06f20$export$f6768025e418420e)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $2cff22612808ae96$export$d94b8b58ec2f30eb)(node)
        };
    });
};

var $2bf5fb6846f8e2c5$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ("focus" in target) target.focus(focusOptions);
    if ("contentWindow" in target && target.contentWindow) target.contentWindow.focus();
};




var $b394242c3b6cfaf1$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error("no element or scope given");
        return {};
    }
    var shards = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(scope);
    if (shards.every(function(shard) {
        return !(0, $9b74641517b143d6$export$2344b14b097df817)(shard, element);
    })) {
        console.error("Active element is not contained in the scope");
        return {};
    }
    var focusables = useTabbables ? (0, $9b74641517b143d6$export$3738e313571e2ad2)(shards, new Map()) : (0, $9b74641517b143d6$export$493d05a3a8e6532d)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $b394242c3b6cfaf1$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $9b74641517b143d6$export$3738e313571e2ad2)((0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(shards), new Map()) : (0, $9b74641517b143d6$export$493d05a3a8e6532d)((0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $b394242c3b6cfaf1$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $b394242c3b6cfaf1$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $b394242c3b6cfaf1$var$defaultOptions(options);
    var solution = $b394242c3b6cfaf1$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $2bf5fb6846f8e2c5$export$c12b3da842c43a8)(target.node, newOptions.focusOptions);
};
var $b394242c3b6cfaf1$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $b394242c3b6cfaf1$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $b394242c3b6cfaf1$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $b394242c3b6cfaf1$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $2bf5fb6846f8e2c5$export$c12b3da842c43a8)(node.node, options.focusOptions);
};
var $b394242c3b6cfaf1$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$pickBoundary(scope, options, "first");
};
var $b394242c3b6cfaf1$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$pickBoundary(scope, options, "last");
};




/**
 * returns active element from document or from nested shadowdoms
 */ var $f296cb52f860ecc3$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};


var $b5783d59678393a3$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $f296cb52f860ecc3$export$78d20aae35adef88)(function() {
        return activeElement.contentWindow.document;
    }) ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};


var $eec3e0cab722c011$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $eec3e0cab722c011$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $c2cb5aa387a37a50$export$45b10814cc054894)(topNode.querySelectorAll("iframe")).some(function(node) {
        return $eec3e0cab722c011$var$focusInFrame(node, activeElement);
    }));
};
var $eec3e0cab722c011$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)((0, $c2cb5aa387a37a50$export$bcd7afcd904dce14)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).some(function(node) {
        return (0, $9b74641517b143d6$export$2344b14b097df817)(node, activeElement) || $eec3e0cab722c011$var$focusInsideIframe(node, activeElement);
    });
};





var $4a4957b2dfe49f02$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(inDocument.querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$54ecf528c58f9ef6), "]"))).some(function(node) {
        return (0, $9b74641517b143d6$export$2344b14b097df817)(node, activeElement);
    });
};








var $3315685220e94b72$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $2cff22612808ae96$export$9d74f6fbc6f469d0)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $3315685220e94b72$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $2cff22612808ae96$export$9d74f6fbc6f469d0)(node) && node.name) return $3315685220e94b72$var$findSelectedRadio(node, nodes);
    return node;
};
var $3315685220e94b72$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($3315685220e94b72$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};



var $550b7510239b204f$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $3315685220e94b72$export$5261662167ad7ced)(nodes[0], nodes);
    return nodes[0];
};
var $550b7510239b204f$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $3315685220e94b72$export$5261662167ad7ced)(node, nodes));
};



var $5f30961e5fc5285a$export$85710b12cf912438 = "NEW_FOCUS";
var $5f30961e5fc5285a$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $2cff22612808ae96$export$d94b8b58ec2f30eb)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $5f30961e5fc5285a$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $5f30961e5fc5285a$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $3315685220e94b72$export$4a5a72a7124e45f9)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $550b7510239b204f$export$e06728ee87c96122)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $550b7510239b204f$export$e06728ee87c96122)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};








var $0a6fd98cd390fe5b$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $2cff22612808ae96$export$698b339b0c8edae3)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== "false" || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $0a6fd98cd390fe5b$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $9b74641517b143d6$export$2f70373d403a5d2b)(nodes.filter($0a6fd98cd390fe5b$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $550b7510239b204f$export$f4e86cfa0679b9cc)(autoFocusable);
    return (0, $550b7510239b204f$export$f4e86cfa0679b9cc)((0, $9b74641517b143d6$export$2f70373d403a5d2b)(orderedNodes));
};





var $d862fa039a3b3c25$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $2cff22612808ae96$export$4e62c701997796c1));
};
var $d862fa039a3b3c25$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)((0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(topNode).length > 0 ? document : (0, $c2cb5aa387a37a50$export$bcd7afcd904dce14)(topNode).ownerDocument);
    var entries = (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).filter((0, $2cff22612808ae96$export$602e5a0d338d7750));
    var commonParent = (0, $51d90458d728fe34$export$a9a7252b5f2e280e)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $9b74641517b143d6$export$493d05a3a8e6532d)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $2cff22612808ae96$export$602e5a0d338d7750)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $9b74641517b143d6$export$493d05a3a8e6532d)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $d862fa039a3b3c25$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $5f30961e5fc5285a$export$65842178e9bb4205)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $5f30961e5fc5285a$export$85710b12cf912438)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $0a6fd98cd390fe5b$export$cfb742983e257555)(anyFocusable, innerTabbable, (0, $51d90458d728fe34$export$8f99714c70a37db1)(entries, visibilityCache)) || (0, $0a6fd98cd390fe5b$export$cfb742983e257555)(anyFocusable, innerFocusables, (0, $51d90458d728fe34$export$8f99714c70a37db1)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn("focus-lock: cannot find any node to move focus into");
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};


var $7698a7d35ed86651$var$guardCount = 0;
var $7698a7d35ed86651$var$lockDisabled = false;
var $7698a7d35ed86651$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $d862fa039a3b3c25$export$305758c744b57f6f)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($7698a7d35ed86651$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($7698a7d35ed86651$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $7698a7d35ed86651$var$lockDisabled = true;
            setTimeout(function() {
                $7698a7d35ed86651$var$lockDisabled = false;
            }, 1);
            return;
        }
        $7698a7d35ed86651$var$guardCount++;
        (0, $2bf5fb6846f8e2c5$export$c12b3da842c43a8)(focusable.node, options.focusOptions);
        $7698a7d35ed86651$var$guardCount--;
    }
};





/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $db815af593127be9$export$1a988e7317c65621 = $34f6623b57e1a1c8$exports;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $db815af593127be9$var$deprecated_default_moveFocusInside = (0, $7698a7d35ed86651$export$cd599851e879a025);
var $db815af593127be9$export$2e2bcd8739ae039 //
 = $db815af593127be9$var$deprecated_default_moveFocusInside;


function $de7ba2c6b170eb4f$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $de7ba2c6b170eb4f$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $de7ba2c6b170eb4f$export$c613fed06e332533 = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};



var $00df5dbe84bcea91$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $00df5dbe84bcea91$var$isFreeFocus = function isFreeFocus() {
    return $00df5dbe84bcea91$var$focusOnBody() || (0, $4a4957b2dfe49f02$export$be6b21806d3fd485)();
};
var $00df5dbe84bcea91$var$lastActiveTrap = null;
var $00df5dbe84bcea91$var$lastActiveFocus = null;
var $00df5dbe84bcea91$var$lastPortaledElement = null;
var $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
var $00df5dbe84bcea91$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $00df5dbe84bcea91$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($00df5dbe84bcea91$var$lastActiveTrap.whiteList || $00df5dbe84bcea91$var$defaultWhitelist)(activeElement);
};
var $00df5dbe84bcea91$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $00df5dbe84bcea91$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $00df5dbe84bcea91$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement === element;
};
function $00df5dbe84bcea91$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $00df5dbe84bcea91$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($00df5dbe84bcea91$var$focusWasOutsideWindow);
    return $00df5dbe84bcea91$var$focusWasOutsideWindow === "meanwhile";
};
var $00df5dbe84bcea91$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $00df5dbe84bcea91$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $00df5dbe84bcea91$var$checkInHost(activeElement, area, area);
    });
};
var $00df5dbe84bcea91$var$activateTrap = function activateTrap() {
    var result = false;
    if ($00df5dbe84bcea91$var$lastActiveTrap) {
        var _lastActiveTrap = $00df5dbe84bcea91$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $de7ba2c6b170eb4f$export$c613fed06e332533)).filter(Boolean));
            if (!activeElement || $00df5dbe84bcea91$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $00df5dbe84bcea91$var$focusWasOutside(crossFrame) || !$00df5dbe84bcea91$var$isFreeFocus() || !$00df5dbe84bcea91$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $eec3e0cab722c011$export$20115f8da7baa6fa)(workingArea) || activeElement && $00df5dbe84bcea91$var$withinHost(activeElement, workingArea) || $00df5dbe84bcea91$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$00df5dbe84bcea91$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $7698a7d35ed86651$export$cd599851e879a025)(workingArea, $00df5dbe84bcea91$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $00df5dbe84bcea91$var$lastPortaledElement = {};
                        }
                    }
                    $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
                    $00df5dbe84bcea91$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $3f73a80c2e676402$export$f89ac71e91767111)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $00df5dbe84bcea91$var$onTrap = function onTrap(event) {
    if ($00df5dbe84bcea91$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $00df5dbe84bcea91$var$onBlur = function onBlur() {
    return (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
};
var $00df5dbe84bcea91$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $00df5dbe84bcea91$var$recordPortal(currentNode, source);
};
var $00df5dbe84bcea91$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $00df5dbe84bcea91$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        onBlur: $00df5dbe84bcea91$var$onBlur,
        onFocus: $00df5dbe84bcea91$var$onFocus
    }, children);
};
$00df5dbe84bcea91$var$FocusTrap.propTypes = {};
var $00df5dbe84bcea91$var$onWindowBlur = function onWindowBlur() {
    $00df5dbe84bcea91$var$focusWasOutsideWindow = "just";
    (0, $de7ba2c6b170eb4f$export$6523025722806278)(function() {
        $00df5dbe84bcea91$var$focusWasOutsideWindow = "meanwhile";
    });
};
var $00df5dbe84bcea91$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.addEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.addEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
var $00df5dbe84bcea91$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.removeEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.removeEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
function $00df5dbe84bcea91$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $00df5dbe84bcea91$var$focusLockAPI = {
    moveFocusInside: (0, $7698a7d35ed86651$export$cd599851e879a025),
    focusInside: (0, $eec3e0cab722c011$export$20115f8da7baa6fa),
    focusNextElement: (0, $b394242c3b6cfaf1$export$3b0237e8566c8d65),
    focusPrevElement: (0, $b394242c3b6cfaf1$export$33b47db07a82b2fb),
    focusFirstElement: (0, $b394242c3b6cfaf1$export$2a791d8097a66406),
    focusLastElement: (0, $b394242c3b6cfaf1$export$6a79073ddabfd6c3),
    captureFocusRestore: (0, $e8393b55a6e31e11$export$d357db6e554ff59a)
};
function $00df5dbe84bcea91$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$00df5dbe84bcea91$var$lastActiveTrap) $00df5dbe84bcea91$var$attachHandler();
    var lastTrap = $00df5dbe84bcea91$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $00df5dbe84bcea91$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $00df5dbe84bcea91$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($00df5dbe84bcea91$var$focusLockAPI);
        $00df5dbe84bcea91$var$activateTrap(true);
        (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
    } else {
        $00df5dbe84bcea91$var$detachHandler();
        $00df5dbe84bcea91$var$lastActiveFocus = null;
    }
}
(0, $292937b69072d1e6$export$5733e022b1d538cb).assignSyncMedium($00df5dbe84bcea91$var$onFocus);
(0, $292937b69072d1e6$export$b3e9a9312f73723c).assignMedium($00df5dbe84bcea91$var$onBlur);
(0, $292937b69072d1e6$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb($00df5dbe84bcea91$var$focusLockAPI);
});
var $00df5dbe84bcea91$export$2e2bcd8739ae039 = (0, $bec73a156e960f78$export$2e2bcd8739ae039)($00df5dbe84bcea91$var$reducePropsToState, $00df5dbe84bcea91$var$handleStateChangeOnClient)($00df5dbe84bcea91$var$FocusWatcher);


var $afd3cd9c4d0274d7$var$FocusLockCombination = /*#__PURE__*/ $acw62.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $e86725766b4cde33$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        sideCar: (0, $00df5dbe84bcea91$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $afd3cd9c4d0274d7$var$_ref = (0, $e86725766b4cde33$export$2e2bcd8739ae039).propTypes || {}, $afd3cd9c4d0274d7$var$sideCar = $afd3cd9c4d0274d7$var$_ref.sideCar, $afd3cd9c4d0274d7$var$propTypes = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)($afd3cd9c4d0274d7$var$_ref, [
    "sideCar"
]);
$afd3cd9c4d0274d7$var$FocusLockCombination.propTypes = {};
var $afd3cd9c4d0274d7$export$2e2bcd8739ae039 = $afd3cd9c4d0274d7$var$FocusLockCombination;



var $9962412629625ccb$export$2e2bcd8739ae039 = (0, $afd3cd9c4d0274d7$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");

"use client";
var $33e99d423fc5385f$var$_a;
var $33e99d423fc5385f$var$FocusTrap = ($33e99d423fc5385f$var$_a = (0, $9962412629625ccb$export$2e2bcd8739ae039).default) != null ? $33e99d423fc5385f$var$_a : (0, $9962412629625ccb$export$2e2bcd8739ae039);
var $33e99d423fc5385f$export$ae70e1f3be7e1299 = (props)=>{
    const { initialFocusRef: initialFocusRef, finalFocusRef: finalFocusRef, contentRef: contentRef, restoreFocus: restoreFocus, children: children, isDisabled: isDisabled, autoFocus: autoFocus, persistentFocus: persistentFocus, lockFocusAcrossFrames: lockFocusAcrossFrames } = props;
    const onActivation = (0, $acw62.useCallback)(()=>{
        if (initialFocusRef == null ? void 0 : initialFocusRef.current) initialFocusRef.current.focus();
        else if (contentRef == null ? void 0 : contentRef.current) {
            const focusables = (0, $2858cbef67902129$export$4ae682d253b556eb)(contentRef.current);
            if (focusables.length === 0) requestAnimationFrame(()=>{
                var _a2;
                (_a2 = contentRef.current) == null || _a2.focus();
            });
        }
    }, [
        initialFocusRef,
        contentRef
    ]);
    const onDeactivation = (0, $acw62.useCallback)(()=>{
        var _a2;
        (_a2 = finalFocusRef == null ? void 0 : finalFocusRef.current) == null || _a2.focus();
    }, [
        finalFocusRef
    ]);
    const returnFocus = restoreFocus && !finalFocusRef;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($33e99d423fc5385f$var$FocusTrap, {
        crossFrame: lockFocusAcrossFrames,
        persistentFocus: persistentFocus,
        autoFocus: autoFocus,
        disabled: isDisabled,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        children: children
    });
};
$33e99d423fc5385f$export$ae70e1f3be7e1299.displayName = "FocusLock";
var $33e99d423fc5385f$export$5cc412d51d00246f = $33e99d423fc5385f$export$ae70e1f3be7e1299;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";




var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $acw62.createElement(Target, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowY");
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowX");
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;



"use client";
function $a4bb24df8dc40781$export$ffa1d90344e68399(props) {
    const { autoFocus: autoFocus, trapFocus: trapFocus, dialogRef: dialogRef, initialFocusRef: initialFocusRef, blockScrollOnMount: blockScrollOnMount, allowPinchZoom: allowPinchZoom, finalFocusRef: finalFocusRef, returnFocusOnClose: returnFocusOnClose, preserveScrollBarGap: preserveScrollBarGap, lockFocusAcrossFrames: lockFocusAcrossFrames, isOpen: isOpen } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    (0, $acw62.useEffect)(()=>{
        if (!isPresent && safeToRemove) setTimeout(safeToRemove);
    }, [
        isPresent,
        safeToRemove
    ]);
    const index = (0, $b09f0d09ca2d779f$export$8557a94b9bb25060)(dialogRef, isOpen);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $33e99d423fc5385f$export$ae70e1f3be7e1299), {
        autoFocus: autoFocus,
        isDisabled: !trapFocus,
        initialFocusRef: initialFocusRef,
        finalFocusRef: finalFocusRef,
        restoreFocus: returnFocusOnClose,
        contentRef: dialogRef,
        lockFocusAcrossFrames: lockFocusAcrossFrames,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
            removeScrollBar: !preserveScrollBarGap,
            allowPinchZoom: allowPinchZoom,
            enabled: index === 1 && blockScrollOnMount,
            forwardProps: true,
            children: props.children
        })
    });
}









var $acw62 = parcelRequire("acw62");

"use client";
var $fd46c561f9dcf861$var$defaultTransition = {
    exit: {
        duration: 0.15,
        ease: (0, $e53c11b120069459$export$9ee1d08bb6db426f).easeInOut
    },
    enter: {
        type: "spring",
        damping: 25,
        stiffness: 180
    }
};
var $fd46c561f9dcf861$var$variants = {
    exit: ({ direction: direction, transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        const { exit: exitStyles } = (0, $e53c11b120069459$export$76af7f35258e628d)({
            direction: direction
        });
        return {
            ...exitStyles,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).exit($fd46c561f9dcf861$var$defaultTransition.exit, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        };
    },
    enter: ({ direction: direction, transitionEnd: transitionEnd, transition: transition, delay: delay })=>{
        var _a;
        const { enter: enterStyles } = (0, $e53c11b120069459$export$76af7f35258e628d)({
            direction: direction
        });
        return {
            ...enterStyles,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).enter($fd46c561f9dcf861$var$defaultTransition.enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    }
};
var $fd46c561f9dcf861$export$d8dc01b5c85a37b9 = (0, $acw62.forwardRef)(function Slide2(props, ref) {
    const { direction: direction = "right", style: style, unmountOnExit: unmountOnExit, in: isOpen, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay, motionProps: motionProps, ...rest } = props;
    const transitionStyles = (0, $e53c11b120069459$export$76af7f35258e628d)({
        direction: direction
    });
    const computedStyle = Object.assign({
        position: "fixed"
    }, transitionStyles.position, style);
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const custom = {
        transitionEnd: transitionEnd,
        transition: transition,
        direction: direction,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ...rest,
            ref: ref,
            initial: "exit",
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-slide", className),
            animate: animate,
            exit: "exit",
            custom: custom,
            variants: $fd46c561f9dcf861$var$variants,
            style: computedStyle,
            ...motionProps
        })
    });
});
$fd46c561f9dcf861$export$d8dc01b5c85a37b9.displayName = "Slide";



"use client";
var $de1928e3734003a6$var$MotionDiv = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $fd46c561f9dcf861$export$d8dc01b5c85a37b9));
var $de1928e3734003a6$export$57ca055474bc0056 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, children: children, motionProps: motionProps, containerProps: rootProps, ...rest } = props;
    const { getDialogProps: getDialogProps, getDialogContainerProps: getDialogContainerProps, isOpen: isOpen } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    const dialogProps = getDialogProps(rest, ref);
    const containerProps = getDialogContainerProps(rootProps);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__content", className);
    const styles = (0, $4410258333ca5546$export$c540eec2ed4454a2)();
    const dialogStyles = {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
        outline: 0,
        ...styles.dialog
    };
    const dialogContainerStyles = {
        display: "flex",
        width: "100vw",
        height: "$100vh",
        position: "fixed",
        left: 0,
        top: 0,
        ...styles.dialogContainer
    };
    const { placement: placement } = (0, $2c5be1008fbfcbeb$export$cc200cef0c88a66f)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a4bb24df8dc40781$export$ffa1d90344e68399), {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
            ...containerProps,
            className: "chakra-modal__content-container",
            __css: dialogContainerStyles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($de1928e3734003a6$var$MotionDiv, {
                motionProps: motionProps,
                direction: placement,
                in: isOpen,
                className: _className,
                ...dialogProps,
                __css: dialogStyles,
                children: children
            })
        })
    });
});
$de1928e3734003a6$export$57ca055474bc0056.displayName = "DrawerContent";





"use client";
var $c1a0e057d30d876e$export$519437715052e656 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__footer", className);
    const styles = (0, $4410258333ca5546$export$c540eec2ed4454a2)();
    const footerStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        ...styles.footer
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).footer, {
        ref: ref,
        ...rest,
        __css: footerStyles,
        className: _className
    });
});
$c1a0e057d30d876e$export$519437715052e656.displayName = "ModalFooter";





var $acw62 = parcelRequire("acw62");

"use client";
var $fae03f3c1cb3a345$export$f50a68e3694789ee = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, ...rest } = props;
    const { headerId: headerId, setHeaderMounted: setHeaderMounted } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    (0, $acw62.useEffect)(()=>{
        setHeaderMounted(true);
        return ()=>setHeaderMounted(false);
    }, [
        setHeaderMounted
    ]);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__header", className);
    const styles = (0, $4410258333ca5546$export$c540eec2ed4454a2)();
    const headerStyles = {
        flex: 0,
        ...styles.header
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).header, {
        ref: ref,
        className: _className,
        id: headerId,
        ...rest,
        __css: headerStyles
    });
});
$fae03f3c1cb3a345$export$f50a68e3694789ee.displayName = "ModalHeader";








var $acw62 = parcelRequire("acw62");

"use client";
var $9ba9961d8b5e5518$var$variants = {
    enter: ({ transition: transition, transitionEnd: transitionEnd, delay: delay } = {})=>{
        var _a;
        return {
            opacity: 1,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).enter((0, $e53c11b120069459$export$f995eb860f745cb).enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    },
    exit: ({ transition: transition, transitionEnd: transitionEnd, delay: delay } = {})=>{
        var _a;
        return {
            opacity: 0,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).exit((0, $e53c11b120069459$export$f995eb860f745cb).exit, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        };
    }
};
var $9ba9961d8b5e5518$export$4342735ea5c231d = {
    initial: "exit",
    animate: "enter",
    exit: "exit",
    variants: $9ba9961d8b5e5518$var$variants
};
var $9ba9961d8b5e5518$export$c983850c6c9d8b0e = (0, $acw62.forwardRef)(function Fade2(props, ref) {
    const { unmountOnExit: unmountOnExit, in: isOpen, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay, ...rest } = props;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const custom = {
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-fade", className),
            custom: custom,
            ...$9ba9961d8b5e5518$export$4342735ea5c231d,
            animate: animate,
            ...rest
        })
    });
});
$9ba9961d8b5e5518$export$c983850c6c9d8b0e.displayName = "Fade";




"use client";
var $006bfa297e893b21$var$MotionDiv = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div);
var $006bfa297e893b21$export$8948f78d83984c69 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, transition: transition, motionProps: _motionProps, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__overlay", className);
    const styles = (0, $4410258333ca5546$export$c540eec2ed4454a2)();
    const overlayStyle = {
        pos: "fixed",
        left: "0",
        top: "0",
        w: "100vw",
        h: "100vh",
        ...styles.overlay
    };
    const { motionPreset: motionPreset } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    const defaultMotionProps = motionPreset === "none" ? {} : (0, $9ba9961d8b5e5518$export$4342735ea5c231d);
    const motionProps = _motionProps || defaultMotionProps;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($006bfa297e893b21$var$MotionDiv, {
        ...motionProps,
        __css: overlayStyle,
        ref: ref,
        className: _className,
        ...rest
    });
});
$006bfa297e893b21$export$8948f78d83984c69.displayName = "ModalOverlay";





var $acw62 = parcelRequire("acw62");

"use client";
var $0caf763c70514c51$export$cb540d8b0ef7906c = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, ...rest } = props;
    const { bodyId: bodyId, setBodyMounted: setBodyMounted } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    (0, $acw62.useEffect)(()=>{
        setBodyMounted(true);
        return ()=>setBodyMounted(false);
    }, [
        setBodyMounted
    ]);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__body", className);
    const styles = (0, $4410258333ca5546$export$c540eec2ed4454a2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: _className,
        id: bodyId,
        ...rest,
        __css: styles.body
    });
});
$0caf763c70514c51$export$cb540d8b0ef7906c.displayName = "ModalBody";






"use client";
var $2e9ac767eb870fd0$export$edf9108895ba774f = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { onClick: onClick, className: className, ...rest } = props;
    const { onClose: onClose } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__close-btn", className);
    const styles = (0, $4410258333ca5546$export$c540eec2ed4454a2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4a635bb7fe4595f6$export$de65de8213222d10), {
        ref: ref,
        __css: styles.closeButton,
        className: _className,
        onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(onClick, (event)=>{
            event.stopPropagation();
            onClose();
        }),
        ...rest
    });
});
$2e9ac767eb870fd0$export$edf9108895ba774f.displayName = "ModalCloseButton";






var $acw62 = parcelRequire("acw62");

"use client";
var $f8b9d42c4edd11ff$var$variants = {
    exit: ({ reverse: reverse, initialScale: initialScale, transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        return {
            opacity: 0,
            ...reverse ? {
                scale: initialScale,
                transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
            } : {
                transitionEnd: {
                    scale: initialScale,
                    ...transitionEnd == null ? void 0 : transitionEnd.exit
                }
            },
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).exit((0, $e53c11b120069459$export$f995eb860f745cb).exit, delay)
        };
    },
    enter: ({ transitionEnd: transitionEnd, transition: transition, delay: delay })=>{
        var _a;
        return {
            opacity: 1,
            scale: 1,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).enter((0, $e53c11b120069459$export$f995eb860f745cb).enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    }
};
var $f8b9d42c4edd11ff$export$9f21bb05021be18d = {
    initial: "exit",
    animate: "enter",
    exit: "exit",
    variants: $f8b9d42c4edd11ff$var$variants
};
var $f8b9d42c4edd11ff$export$c9ef45b298456c94 = (0, $acw62.forwardRef)(function ScaleFade2(props, ref) {
    const { unmountOnExit: unmountOnExit, in: isOpen, reverse: reverse = true, initialScale: initialScale = 0.95, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay, ...rest } = props;
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const custom = {
        initialScale: initialScale,
        reverse: reverse,
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-offset-slide", className),
            ...$f8b9d42c4edd11ff$export$9f21bb05021be18d,
            animate: animate,
            custom: custom,
            ...rest
        })
    });
});
$f8b9d42c4edd11ff$export$c9ef45b298456c94.displayName = "ScaleFade";





var $acw62 = parcelRequire("acw62");

"use client";
var $c27741b79d37bf97$var$variants = {
    initial: ({ offsetX: offsetX, offsetY: offsetY, transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        return {
            opacity: 0,
            x: offsetX,
            y: offsetY,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).exit((0, $e53c11b120069459$export$f995eb860f745cb).exit, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        };
    },
    enter: ({ transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        return {
            opacity: 1,
            x: 0,
            y: 0,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).enter((0, $e53c11b120069459$export$f995eb860f745cb).enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    },
    exit: ({ offsetY: offsetY, offsetX: offsetX, transition: transition, transitionEnd: transitionEnd, reverse: reverse, delay: delay })=>{
        var _a;
        const offset = {
            x: offsetX,
            y: offsetY
        };
        return {
            opacity: 0,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $e53c11b120069459$export$fc492bd0f1c91c).exit((0, $e53c11b120069459$export$f995eb860f745cb).exit, delay),
            ...reverse ? {
                ...offset,
                transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
            } : {
                transitionEnd: {
                    ...offset,
                    ...transitionEnd == null ? void 0 : transitionEnd.exit
                }
            }
        };
    }
};
var $c27741b79d37bf97$export$153404f46b1af630 = {
    initial: "initial",
    animate: "enter",
    exit: "exit",
    variants: $c27741b79d37bf97$var$variants
};
var $c27741b79d37bf97$export$2c57c541d078cf9c = (0, $acw62.forwardRef)(function SlideFade2(props, ref) {
    const { unmountOnExit: unmountOnExit, in: isOpen, reverse: reverse = true, className: className, offsetX: offsetX = 0, offsetY: offsetY = 8, transition: transition, transitionEnd: transitionEnd, delay: delay, ...rest } = props;
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const custom = {
        offsetX: offsetX,
        offsetY: offsetY,
        reverse: reverse,
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-offset-slide", className),
            custom: custom,
            ...$c27741b79d37bf97$export$153404f46b1af630,
            animate: animate,
            ...rest
        })
    });
});
$c27741b79d37bf97$export$2c57c541d078cf9c.displayName = "SlideFade";




var $acw62 = parcelRequire("acw62");

"use client";
var $8c47acdc20f5f09c$var$transitions = {
    slideInBottom: {
        ...(0, $c27741b79d37bf97$export$153404f46b1af630),
        custom: {
            offsetY: 16,
            reverse: true
        }
    },
    slideInRight: {
        ...(0, $c27741b79d37bf97$export$153404f46b1af630),
        custom: {
            offsetX: 16,
            reverse: true
        }
    },
    slideInTop: {
        ...(0, $c27741b79d37bf97$export$153404f46b1af630),
        custom: {
            offsetY: -16,
            reverse: true
        }
    },
    slideInLeft: {
        ...(0, $c27741b79d37bf97$export$153404f46b1af630),
        custom: {
            offsetX: -16,
            reverse: true
        }
    },
    scale: {
        ...(0, $f8b9d42c4edd11ff$export$9f21bb05021be18d),
        custom: {
            initialScale: 0.95,
            reverse: true
        }
    },
    none: {}
};
var $8c47acdc20f5f09c$var$MotionSection = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $a93b6401f922fd1e$export$e25e478948902b8b).section);
var $8c47acdc20f5f09c$var$getMotionProps = (preset)=>{
    return $8c47acdc20f5f09c$var$transitions[preset || "none"];
};
var $8c47acdc20f5f09c$export$f0a3ab1cc2e7e9a6 = (0, $acw62.forwardRef)((props, ref)=>{
    const { preset: preset, motionProps: motionProps = $8c47acdc20f5f09c$var$getMotionProps(preset), ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8c47acdc20f5f09c$var$MotionSection, {
        ref: ref,
        ...motionProps,
        ...rest
    });
});
$8c47acdc20f5f09c$export$f0a3ab1cc2e7e9a6.displayName = "ModalTransition";







"use client";
var $d3f1b418b5859157$export$6da19a24bf249f17 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, children: children, containerProps: rootProps, motionProps: motionProps, ...rest } = props;
    const { getDialogProps: getDialogProps, getDialogContainerProps: getDialogContainerProps } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    const dialogProps = getDialogProps(rest, ref);
    const containerProps = getDialogContainerProps(rootProps);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__content", className);
    const styles = (0, $4410258333ca5546$export$c540eec2ed4454a2)();
    const dialogStyles = {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
        outline: 0,
        ...styles.dialog
    };
    const dialogContainerStyles = {
        display: "flex",
        width: "100vw",
        height: "$100vh",
        position: "fixed",
        left: 0,
        top: 0,
        ...styles.dialogContainer
    };
    const { motionPreset: motionPreset } = (0, $4410258333ca5546$export$4cc1699d46f42cae)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a4bb24df8dc40781$export$ffa1d90344e68399), {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
            ...containerProps,
            className: "chakra-modal__content-container",
            tabIndex: -1,
            __css: dialogContainerStyles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8c47acdc20f5f09c$export$f0a3ab1cc2e7e9a6), {
                preset: motionPreset,
                motionProps: motionProps,
                className: _className,
                ...dialogProps,
                __css: dialogStyles,
                children: children
            })
        })
    });
});
$d3f1b418b5859157$export$6da19a24bf249f17.displayName = "ModalContent";




"use client";
var $87b7ea3235556ea9$export$c89a927ffc67e6fa = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).circle, {
        cx: 50,
        cy: 50,
        r: 42,
        fill: "transparent",
        ...props
    });
$87b7ea3235556ea9$export$c89a927ffc67e6fa.displayName = "Circle";



"use client";
function $e3620c1604a24294$var$valueToPercent(value, min, max) {
    return (value - min) * 100 / (max - min);
}
var $e3620c1604a24294$export$c82e186cf428d56d = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    "0%": {
        strokeDasharray: "1, 400",
        strokeDashoffset: "0"
    },
    "50%": {
        strokeDasharray: "400, 400",
        strokeDashoffset: "-100"
    },
    "100%": {
        strokeDasharray: "400, 400",
        strokeDashoffset: "-260"
    }
});
var $e3620c1604a24294$export$bb628a54ab399bc9 = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
var $e3620c1604a24294$export$504d7abb21fa8c9 = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    "0%": {
        left: "-40%"
    },
    "100%": {
        left: "100%"
    }
});
var $e3620c1604a24294$export$735606310a3da449 = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    from: {
        backgroundPosition: "1rem 0"
    },
    to: {
        backgroundPosition: "0 0"
    }
});
function $e3620c1604a24294$export$c5752331c2d05cd(options) {
    const { value: value = 0, min: min, max: max, valueText: valueText, getValueText: getValueText, isIndeterminate: isIndeterminate, role: role = "progressbar" } = options;
    const percent = $e3620c1604a24294$var$valueToPercent(value, min, max);
    const getAriaValueText = ()=>{
        if (value == null) return void 0;
        return typeof getValueText === "function" ? getValueText(value, percent) : valueText;
    };
    return {
        bind: {
            "data-indeterminate": isIndeterminate ? "" : void 0,
            "aria-valuemax": max,
            "aria-valuemin": min,
            "aria-valuenow": isIndeterminate ? void 0 : value,
            "aria-valuetext": getAriaValueText(),
            role: role
        },
        percent: percent,
        value: value
    };
}




"use client";
var $491feeb8c5fd6f5b$export$6428a7f2611ef1fa = (props)=>{
    const { size: size, isIndeterminate: isIndeterminate, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 100 100",
        __css: {
            width: size,
            height: size,
            animation: isIndeterminate ? `${0, $e3620c1604a24294$export$bb628a54ab399bc9} 2s linear infinite` : void 0
        },
        ...rest
    });
};
$491feeb8c5fd6f5b$export$6428a7f2611ef1fa.displayName = "Shape";





"use client";
var $c7f03658e6c561bf$export$9e72f56a493060bf = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { size: size = "48px", max: max = 100, min: min = 0, valueText: valueText, getValueText: getValueText, value: value, capIsRound: capIsRound, children: children, thickness: thickness = "10px", color: color = "#0078d4", trackColor: trackColor = "#edebe9", isIndeterminate: isIndeterminate, ...rest } = props;
    const progress = (0, $e3620c1604a24294$export$c5752331c2d05cd)({
        min: min,
        max: max,
        value: value,
        valueText: valueText,
        getValueText: getValueText,
        isIndeterminate: isIndeterminate
    });
    const determinant = isIndeterminate ? void 0 : ((_a = progress.percent) != null ? _a : 0) * 2.64;
    const strokeDasharray = determinant == null ? void 0 : `${determinant} ${264 - determinant}`;
    const indicatorProps = isIndeterminate ? {
        css: {
            animation: `${0, $e3620c1604a24294$export$c82e186cf428d56d} 1.5s linear infinite`
        }
    } : {
        strokeDashoffset: 66,
        strokeDasharray: strokeDasharray,
        transitionProperty: "stroke-dasharray, stroke",
        transitionDuration: "0.6s",
        transitionTimingFunction: "ease"
    };
    const rootStyles = {
        display: "inline-block",
        position: "relative",
        verticalAlign: "middle",
        fontSize: size
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: "chakra-progress",
        ...progress.bind,
        ...rest,
        __css: rootStyles,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $491feeb8c5fd6f5b$export$6428a7f2611ef1fa), {
                size: size,
                isIndeterminate: isIndeterminate,
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $87b7ea3235556ea9$export$c89a927ffc67e6fa), {
                        stroke: trackColor,
                        strokeWidth: thickness,
                        className: "chakra-progress__track"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $87b7ea3235556ea9$export$c89a927ffc67e6fa), {
                        stroke: color,
                        strokeWidth: thickness,
                        className: "chakra-progress__indicator",
                        strokeLinecap: capIsRound ? "round" : void 0,
                        opacity: progress.value === 0 && !isIndeterminate ? 0 : void 0,
                        ...indicatorProps
                    })
                ]
            }),
            children
        ]
    });
});
$c7f03658e6c561bf$export$9e72f56a493060bf.displayName = "CircularProgress";


"use client";
var $100bfeedca20d10e$export$9a43740be2ad09b0 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        fontSize: "0.24em",
        top: "50%",
        left: "50%",
        width: "100%",
        textAlign: "center",
        position: "absolute",
        transform: "translate(-50%, -50%)"
    }
});
$100bfeedca20d10e$export$9a43740be2ad09b0.displayName = "CircularProgressLabel";





"use client";
var [$2f26c604918a6e30$var$ProgressStylesProvider, $2f26c604918a6e30$export$47e08dbe93d2e76f] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `ProgressStylesContext`,
    errorMessage: `useProgressStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Progress />" `
});
var $2f26c604918a6e30$var$ProgressFilledTrack = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { min: min, max: max, value: value, isIndeterminate: isIndeterminate, role: role, ...rest } = props;
    const progress2 = (0, $e3620c1604a24294$export$c5752331c2d05cd)({
        value: value,
        min: min,
        max: max,
        isIndeterminate: isIndeterminate,
        role: role
    });
    const styles = $2f26c604918a6e30$export$47e08dbe93d2e76f();
    const trackStyles = {
        height: "100%",
        ...styles.filledTrack
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        style: {
            width: `${progress2.percent}%`,
            ...rest.style
        },
        ...progress2.bind,
        ...rest,
        __css: trackStyles
    });
});
var $2f26c604918a6e30$export$b25a304ec7d746bb = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { value: value, min: min = 0, max: max = 100, hasStripe: hasStripe, isAnimated: isAnimated, children: children, borderRadius: propBorderRadius, isIndeterminate: isIndeterminate, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-valuetext": ariaValueText, title: title, role: role, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Progress", props);
    const borderRadius = propBorderRadius != null ? propBorderRadius : (_a = styles.track) == null ? void 0 : _a.borderRadius;
    const stripeAnimation = {
        animation: `${(0, $e3620c1604a24294$export$735606310a3da449)} 1s linear infinite`
    };
    const shouldAddStripe = !isIndeterminate && hasStripe;
    const shouldAnimateStripe = shouldAddStripe && isAnimated;
    const css = {
        ...shouldAnimateStripe && stripeAnimation,
        ...isIndeterminate && {
            position: "absolute",
            willChange: "left",
            minWidth: "50%",
            animation: `${0, $e3620c1604a24294$export$504d7abb21fa8c9} 1s ease infinite normal none running`
        }
    };
    const trackStyles = {
        overflow: "hidden",
        position: "relative",
        ...styles.track
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ref: ref,
        borderRadius: borderRadius,
        __css: trackStyles,
        ...rest,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($2f26c604918a6e30$var$ProgressStylesProvider, {
            value: styles,
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($2f26c604918a6e30$var$ProgressFilledTrack, {
                    "aria-label": ariaLabel,
                    "aria-labelledby": ariaLabelledBy,
                    "aria-valuetext": ariaValueText,
                    min: min,
                    max: max,
                    value: value,
                    isIndeterminate: isIndeterminate,
                    css: css,
                    borderRadius: borderRadius,
                    title: title,
                    role: role
                }),
                children
            ]
        })
    });
});
$2f26c604918a6e30$export$b25a304ec7d746bb.displayName = "Progress";




var $acw62 = parcelRequire("acw62");
"use client";
function $eac9b727de9b58f5$var$isInputEvent(value) {
    return value && (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value) && (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value.target);
}
function $eac9b727de9b58f5$export$62b9571f283ff5c2(props = {}) {
    const { onChange: onChangeProp, value: valueProp, defaultValue: defaultValue, name: nameProp, isDisabled: isDisabled, isFocusable: isFocusable, isNative: isNative, ...htmlProps } = props;
    const [valueState, setValue] = (0, $acw62.useState)(defaultValue || "");
    const isControlled = typeof valueProp !== "undefined";
    const value = isControlled ? valueProp : valueState;
    const ref = (0, $acw62.useRef)(null);
    const focus = (0, $acw62.useCallback)(()=>{
        const rootNode = ref.current;
        if (!rootNode) return;
        let query = `input:not(:disabled):checked`;
        const firstEnabledAndCheckedInput = rootNode.querySelector(query);
        if (firstEnabledAndCheckedInput) {
            firstEnabledAndCheckedInput.focus();
            return;
        }
        query = `input:not(:disabled)`;
        const firstEnabledInput = rootNode.querySelector(query);
        firstEnabledInput == null || firstEnabledInput.focus();
    }, []);
    const uuid = (0, $acw62.useId)();
    const fallbackName = `radio-${uuid}`;
    const name = nameProp || fallbackName;
    const onChange = (0, $acw62.useCallback)((eventOrValue)=>{
        const nextValue = $eac9b727de9b58f5$var$isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
        if (!isControlled) setValue(nextValue);
        onChangeProp == null || onChangeProp(String(nextValue));
    }, [
        onChangeProp,
        isControlled
    ]);
    const getRootProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(forwardedRef, ref),
            role: "radiogroup"
        }), []);
    const getRadioProps = (0, $acw62.useCallback)((props2 = {}, ref2 = null)=>{
        const checkedKey = isNative ? "checked" : "isChecked";
        return {
            ...props2,
            ref: ref2,
            name: name,
            [checkedKey]: value != null ? props2.value === value : void 0,
            onChange (event) {
                onChange(event);
            },
            "data-radiogroup": true
        };
    }, [
        isNative,
        name,
        onChange,
        value
    ]);
    return {
        getRootProps: getRootProps,
        getRadioProps: getRadioProps,
        name: name,
        ref: ref,
        focus: focus,
        setValue: setValue,
        value: value,
        onChange: onChange,
        isDisabled: isDisabled,
        isFocusable: isFocusable,
        htmlProps: htmlProps
    };
}






var $acw62 = parcelRequire("acw62");

"use client";
var [$e94b26ac5efe9b2e$var$RadioGroupProvider, $e94b26ac5efe9b2e$export$7bea016dc7ad2ddf] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "RadioGroupContext",
    strict: false
});
var $e94b26ac5efe9b2e$export$a98f0dcb43a68a25 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { colorScheme: colorScheme, size: size, variant: variant, children: children, className: className, isDisabled: isDisabled, isFocusable: isFocusable, ...rest } = props;
    const { value: value, onChange: onChange, getRootProps: getRootProps, name: name, htmlProps: htmlProps } = (0, $eac9b727de9b58f5$export$62b9571f283ff5c2)(rest);
    const group = (0, $acw62.useMemo)(()=>({
            name: name,
            size: size,
            onChange: onChange,
            colorScheme: colorScheme,
            value: value,
            variant: variant,
            isDisabled: isDisabled,
            isFocusable: isFocusable
        }), [
        name,
        size,
        onChange,
        colorScheme,
        value,
        variant,
        isDisabled,
        isFocusable
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($e94b26ac5efe9b2e$var$RadioGroupProvider, {
        value: group,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
            ...getRootProps(htmlProps, ref),
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-radio-group", className),
            children: children
        })
    });
});
$e94b26ac5efe9b2e$export$a98f0dcb43a68a25.displayName = "RadioGroup";






var $acw62 = parcelRequire("acw62");
"use client";
// ../visually-hidden/src/visually-hidden.style.ts
var $6e5b5c94e792a1aa$var$visuallyHiddenStyle = {
    border: "0",
    clip: "rect(0, 0, 0, 0)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
function $6e5b5c94e792a1aa$export$37b0961d2f4751e2(props = {}) {
    const { defaultChecked: defaultChecked, isChecked: isCheckedProp, isFocusable: isFocusable, isDisabled: isDisabledProp, isReadOnly: isReadOnlyProp, isRequired: isRequiredProp, onChange: onChange, isInvalid: isInvalidProp, name: name, value: value, id: idProp, "data-radiogroup": dataRadioGroup, "aria-describedby": ariaDescribedBy, ...htmlProps } = props;
    const uuid = `radio-${(0, $acw62.useId)()}`;
    const formControl = (0, $9937ca16e333eb3d$export$97a2352498389516)();
    const group = (0, $e94b26ac5efe9b2e$export$7bea016dc7ad2ddf)();
    const isWithinRadioGroup = !!group || !!dataRadioGroup;
    const isWithinFormControl = !!formControl;
    let id = isWithinFormControl && !isWithinRadioGroup ? formControl.id : uuid;
    id = idProp != null ? idProp : id;
    const isDisabled = isDisabledProp != null ? isDisabledProp : formControl == null ? void 0 : formControl.isDisabled;
    const isReadOnly = isReadOnlyProp != null ? isReadOnlyProp : formControl == null ? void 0 : formControl.isReadOnly;
    const isRequired = isRequiredProp != null ? isRequiredProp : formControl == null ? void 0 : formControl.isRequired;
    const isInvalid = isInvalidProp != null ? isInvalidProp : formControl == null ? void 0 : formControl.isInvalid;
    const [isFocusVisible, setIsFocusVisible] = (0, $acw62.useState)(false);
    const [isFocused, setFocused] = (0, $acw62.useState)(false);
    const [isHovered, setHovering] = (0, $acw62.useState)(false);
    const [isActive, setActive] = (0, $acw62.useState)(false);
    const [isCheckedState, setChecked] = (0, $acw62.useState)(Boolean(defaultChecked));
    const isControlled = typeof isCheckedProp !== "undefined";
    const isChecked = isControlled ? isCheckedProp : isCheckedState;
    (0, $acw62.useEffect)(()=>{
        return (0, $10f5b85675c7b32e$export$920b4983565c6f4d)(setIsFocusVisible);
    }, []);
    const handleChange = (0, $acw62.useCallback)((event)=>{
        if (isReadOnly || isDisabled) {
            event.preventDefault();
            return;
        }
        if (!isControlled) setChecked(event.target.checked);
        onChange == null || onChange(event);
    }, [
        isControlled,
        isDisabled,
        isReadOnly,
        onChange
    ]);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.key === " ") setActive(true);
    }, [
        setActive
    ]);
    const onKeyUp = (0, $acw62.useCallback)((event)=>{
        if (event.key === " ") setActive(false);
    }, [
        setActive
    ]);
    const getRadioProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: ref,
            "data-active": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isActive),
            "data-hover": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isHovered),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid),
            "data-checked": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isChecked),
            "data-focus": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isFocused && isFocusVisible),
            "data-readonly": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isReadOnly),
            "aria-hidden": true,
            onMouseDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseDown, ()=>setActive(true)),
            onMouseUp: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseUp, ()=>setActive(false)),
            onMouseEnter: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>setHovering(true)),
            onMouseLeave: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseLeave, ()=>setHovering(false))
        }), [
        isActive,
        isHovered,
        isDisabled,
        isInvalid,
        isChecked,
        isFocused,
        isReadOnly,
        isFocusVisible
    ]);
    const { onFocus: onFocus, onBlur: onBlur } = formControl != null ? formControl : {};
    const getInputProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        const trulyDisabled = isDisabled && !isFocusable;
        return {
            ...props2,
            id: id,
            ref: ref,
            type: "radio",
            name: name,
            value: value,
            onChange: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onChange, handleChange),
            onBlur: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(onBlur, props2.onBlur, ()=>setFocused(false)),
            onFocus: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(onFocus, props2.onFocus, ()=>setFocused(true)),
            onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onKeyUp: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyUp, onKeyUp),
            checked: isChecked,
            disabled: trulyDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            "aria-invalid": (0, $abe97432afb3d989$export$91a6105db3d4be7b)(isInvalid),
            "aria-disabled": (0, $abe97432afb3d989$export$91a6105db3d4be7b)(trulyDisabled),
            "aria-required": (0, $abe97432afb3d989$export$91a6105db3d4be7b)(isRequired),
            "data-readonly": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isReadOnly),
            "aria-describedby": ariaDescribedBy,
            style: $6e5b5c94e792a1aa$var$visuallyHiddenStyle
        };
    }, [
        isDisabled,
        isFocusable,
        id,
        name,
        value,
        handleChange,
        onBlur,
        onFocus,
        onKeyDown,
        onKeyUp,
        isChecked,
        isReadOnly,
        isRequired,
        isInvalid,
        ariaDescribedBy
    ]);
    const getLabelProps = (props2 = {}, ref = null)=>({
            ...props2,
            ref: ref,
            onMouseDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseDown, $6e5b5c94e792a1aa$var$stopEvent),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid)
        });
    const getRootProps = (props2, ref = null)=>({
            ...props2,
            ref: ref,
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid)
        });
    const state = {
        isInvalid: isInvalid,
        isFocused: isFocused,
        isChecked: isChecked,
        isActive: isActive,
        isHovered: isHovered,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired
    };
    return {
        state: state,
        /**
     * @deprecated - use `getRadioProps` instead
     */ getCheckboxProps: getRadioProps,
        getRadioProps: getRadioProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        getRootProps: getRootProps,
        htmlProps: htmlProps
    };
}
function $6e5b5c94e792a1aa$var$stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}






"use client";
// ../../utilities/object-utils/src/split.ts
function $f521c6bceffd8e4c$var$split(object, keys) {
    const picked = {};
    const omitted = {};
    for (const [key, value] of Object.entries(object))if (keys.includes(key)) picked[key] = value;
    else omitted[key] = value;
    return [
        picked,
        omitted
    ];
}
var $f521c6bceffd8e4c$export$d7b12c4107be0d61 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const group = (0, $e94b26ac5efe9b2e$export$7bea016dc7ad2ddf)();
    const { onChange: onChangeProp, value: valueProp } = props;
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Radio", {
        ...group,
        ...props
    });
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const { spacing: spacing = "0.5rem", children: children, isDisabled: isDisabled = group == null ? void 0 : group.isDisabled, isFocusable: isFocusable = group == null ? void 0 : group.isFocusable, inputProps: htmlInputProps, ...rest } = ownProps;
    let isChecked = props.isChecked;
    if ((group == null ? void 0 : group.value) != null && valueProp != null) isChecked = group.value === valueProp;
    let onChange = onChangeProp;
    if ((group == null ? void 0 : group.onChange) && valueProp != null) onChange = (0, $abe97432afb3d989$export$9dd9a52f2dd5b9ce)(group.onChange, onChangeProp);
    const name = (_a = props == null ? void 0 : props.name) != null ? _a : group == null ? void 0 : group.name;
    const { getInputProps: getInputProps, getCheckboxProps: getCheckboxProps, getLabelProps: getLabelProps, getRootProps: getRootProps, htmlProps: htmlProps } = (0, $6e5b5c94e792a1aa$export$37b0961d2f4751e2)({
        ...rest,
        isChecked: isChecked,
        isFocusable: isFocusable,
        isDisabled: isDisabled,
        onChange: onChange,
        name: name
    });
    const [layoutProps, otherProps] = $f521c6bceffd8e4c$var$split(htmlProps, (0, $47a6d9fbbf7ee42d$export$bccb7c6ca2f4f912));
    const checkboxProps = getCheckboxProps(otherProps);
    const inputProps = getInputProps(htmlInputProps, ref);
    const labelProps = getLabelProps();
    const rootProps = Object.assign({}, layoutProps, getRootProps());
    const rootStyles = {
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "top",
        cursor: "pointer",
        position: "relative",
        ...styles.container
    };
    const checkboxStyles = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        ...styles.control
    };
    const labelStyles = {
        userSelect: "none",
        marginStart: spacing,
        ...styles.label
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).label, {
        className: "chakra-radio",
        ...rootProps,
        __css: rootStyles,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "chakra-radio__input",
                ...inputProps
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
                className: "chakra-radio__control",
                ...checkboxProps,
                __css: checkboxStyles
            }),
            children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
                className: "chakra-radio__label",
                ...labelProps,
                __css: labelStyles,
                children: children
            })
        ]
    });
});
$f521c6bceffd8e4c$export$d7b12c4107be0d61.displayName = "Radio";




"use client";
var $ce1323988135d10b$export$d55b50a564d0b931 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function SelectField2(props, ref) {
    const { children: children, placeholder: placeholder, className: className, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).select, {
        ...rest,
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-select", className),
        children: [
            placeholder && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("option", {
                value: "",
                children: placeholder
            }),
            children
        ]
    });
});
$ce1323988135d10b$export$d55b50a564d0b931.displayName = "SelectField";






var $acw62 = parcelRequire("acw62");

"use client";
// ../../utilities/object-utils/src/split.ts
function $27de7712fe1667a2$var$split(object, keys) {
    const picked = {};
    const omitted = {};
    for (const [key, value] of Object.entries(object))if (keys.includes(key)) picked[key] = value;
    else omitted[key] = value;
    return [
        picked,
        omitted
    ];
}
var $27de7712fe1667a2$export$ef9b1a59e592288f = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Select", props);
    const { rootProps: rootProps, placeholder: placeholder, icon: icon, color: color, height: height, h: h, minH: minH, minHeight: minHeight, iconColor: iconColor, iconSize: iconSize, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const [layoutProps, otherProps] = $27de7712fe1667a2$var$split(rest, (0, $47a6d9fbbf7ee42d$export$bccb7c6ca2f4f912));
    const ownProps = (0, $95e8035d7d1d6064$export$62ecd8ad1bbe1a18)(otherProps);
    const rootStyles = {
        width: "100%",
        height: "fit-content",
        position: "relative",
        color: color
    };
    const fieldStyles = {
        paddingEnd: "2rem",
        ...styles.field,
        _focus: {
            zIndex: "unset",
            ...(_a = styles.field) == null ? void 0 : _a["_focus"]
        }
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        className: "chakra-select__wrapper",
        __css: rootStyles,
        ...layoutProps,
        ...rootProps,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ce1323988135d10b$export$d55b50a564d0b931), {
                ref: ref,
                height: h != null ? h : height,
                minH: minH != null ? minH : minHeight,
                placeholder: placeholder,
                ...ownProps,
                __css: fieldStyles,
                children: props.children
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($27de7712fe1667a2$var$SelectIcon, {
                "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(ownProps.disabled),
                ...(iconColor || color) && {
                    color: iconColor || color
                },
                __css: styles.icon,
                ...iconSize && {
                    fontSize: iconSize
                },
                children: icon
            })
        ]
    });
});
$27de7712fe1667a2$export$ef9b1a59e592288f.displayName = "Select";
var $27de7712fe1667a2$export$d206ce4c12e8ddf6 = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
        })
    });
var $27de7712fe1667a2$var$IconWrapper = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        position: "absolute",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        top: "50%",
        transform: "translateY(-50%)"
    }
});
var $27de7712fe1667a2$var$SelectIcon = (props)=>{
    const { children: children = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($27de7712fe1667a2$export$d206ce4c12e8ddf6, {}), ...rest } = props;
    const clone = (0, $acw62.cloneElement)(children, {
        role: "presentation",
        className: "chakra-select__icon",
        focusable: false,
        "aria-hidden": true,
        // force icon to adhere to `IconWrapper` styles
        style: {
            width: "1em",
            height: "1em",
            color: "currentColor"
        }
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($27de7712fe1667a2$var$IconWrapper, {
        ...rest,
        className: "chakra-select__icon-wrapper",
        children: (0, $acw62.isValidElement)(children) ? clone : null
    });
};
$27de7712fe1667a2$var$SelectIcon.displayName = "SelectIcon";


var $acw62 = parcelRequire("acw62");
"use client";
function $157344aa2b6e9cfb$export$5964c316e853650f() {
    const isFirstRender = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        isFirstRender.current = false;
    }, []);
    return isFirstRender.current;
}



var $acw62 = parcelRequire("acw62");
"use client";
function $c8e8252663f34f3f$export$5cae361ad82dce8b(value) {
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}





"use client";
var $11a53ac53074bf5a$var$StyledSkeleton = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        boxShadow: "none",
        backgroundClip: "padding-box",
        cursor: "default",
        color: "transparent",
        pointerEvents: "none",
        userSelect: "none",
        "&::before, &::after, *": {
            visibility: "hidden"
        }
    }
});
var $11a53ac53074bf5a$var$$startColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("skeleton-start-color");
var $11a53ac53074bf5a$var$$endColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("skeleton-end-color");
var $11a53ac53074bf5a$var$fade = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
var $11a53ac53074bf5a$var$bgFade = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    from: {
        borderColor: $11a53ac53074bf5a$var$$startColor.reference,
        background: $11a53ac53074bf5a$var$$startColor.reference
    },
    to: {
        borderColor: $11a53ac53074bf5a$var$$endColor.reference,
        background: $11a53ac53074bf5a$var$$endColor.reference
    }
});
var $11a53ac53074bf5a$export$8f31e4c4a37b8e9c = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const skeletonProps = {
        ...props,
        fadeDuration: typeof props.fadeDuration === "number" ? props.fadeDuration : 0.4,
        speed: typeof props.speed === "number" ? props.speed : 0.8
    };
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Skeleton", skeletonProps);
    const isFirstRender = (0, $157344aa2b6e9cfb$export$5964c316e853650f)();
    const { startColor: startColor = "", endColor: endColor = "", isLoaded: isLoaded, fadeDuration: fadeDuration, speed: speed, className: className, fitContent: fitContent, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(skeletonProps);
    const [startColorVar, endColorVar] = (0, $d637f68b5e43da19$export$31dcd79391e423fe)("colors", [
        startColor,
        endColor
    ]);
    const wasPreviouslyLoaded = (0, $c8e8252663f34f3f$export$5cae361ad82dce8b)(isLoaded);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-skeleton", className);
    const cssVarStyles = {
        ...startColorVar && {
            [$11a53ac53074bf5a$var$$startColor.variable]: startColorVar
        },
        ...endColorVar && {
            [$11a53ac53074bf5a$var$$endColor.variable]: endColorVar
        }
    };
    if (isLoaded) {
        const animation = isFirstRender || wasPreviouslyLoaded ? "none" : `${$11a53ac53074bf5a$var$fade} ${fadeDuration}s`;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
            ref: ref,
            className: _className,
            __css: {
                animation: animation
            },
            ...rest
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($11a53ac53074bf5a$var$StyledSkeleton, {
        ref: ref,
        className: _className,
        ...rest,
        __css: {
            width: fitContent ? "fit-content" : void 0,
            ...styles,
            ...cssVarStyles,
            _dark: {
                ...styles["_dark"],
                ...cssVarStyles
            },
            animation: `${speed}s linear infinite alternate ${$11a53ac53074bf5a$var$bgFade}`
        }
    });
});
$11a53ac53074bf5a$export$8f31e4c4a37b8e9c.displayName = "Skeleton";

"use client";
// ../../legacy/utils/src/dom.ts
var $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
var $fe0b3525ffcb2f27$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;
var $fe0b3525ffcb2f27$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");
// ../../legacy/utils/src/function.ts
function $fe0b3525ffcb2f27$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}


"use client";
// src/slider-utils.ts
function $5a5132e81e443d52$export$24b60fe7179439bc(id) {
    return {
        root: `slider-root-${id}`,
        getThumb: (i)=>`slider-thumb-${id}-${i}`,
        getInput: (i)=>`slider-input-${id}-${i}`,
        track: `slider-track-${id}`,
        innerTrack: `slider-filled-track-${id}`,
        getMarker: (i)=>`slider-marker-${id}-${i}`,
        output: `slider-output-${id}`
    };
}
function $5a5132e81e443d52$export$f3eec17ee6065eee(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    return orientation === "vertical" ? vertical : horizontal;
}
var $5a5132e81e443d52$var$zeroSize = {
    width: 0,
    height: 0
};
var $5a5132e81e443d52$var$normalize = (a)=>a || $5a5132e81e443d52$var$zeroSize;
function $5a5132e81e443d52$export$ffd58b7f6f099a57(options) {
    const { orientation: orientation, thumbPercents: thumbPercents, thumbRects: thumbRects, isReversed: isReversed } = options;
    const getThumbStyle = (i)=>{
        var _a;
        const rect = (_a = thumbRects[i]) != null ? _a : $5a5132e81e443d52$var$zeroSize;
        return {
            position: "absolute",
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
            touchAction: "none",
            ...$5a5132e81e443d52$export$f3eec17ee6065eee({
                orientation: orientation,
                vertical: {
                    bottom: `calc(${thumbPercents[i]}% - ${rect.height / 2}px)`
                },
                horizontal: {
                    left: `calc(${thumbPercents[i]}% - ${rect.width / 2}px)`
                }
            })
        };
    };
    const size = orientation === "vertical" ? thumbRects.reduce((a, b)=>$5a5132e81e443d52$var$normalize(a).height > $5a5132e81e443d52$var$normalize(b).height ? a : b, $5a5132e81e443d52$var$zeroSize) : thumbRects.reduce((a, b)=>$5a5132e81e443d52$var$normalize(a).width > $5a5132e81e443d52$var$normalize(b).width ? a : b, $5a5132e81e443d52$var$zeroSize);
    const rootStyle = {
        position: "relative",
        touchAction: "none",
        WebkitTapHighlightColor: "rgba(0,0,0,0)",
        userSelect: "none",
        outline: 0,
        ...$5a5132e81e443d52$export$f3eec17ee6065eee({
            orientation: orientation,
            vertical: size ? {
                paddingLeft: size.width / 2,
                paddingRight: size.width / 2
            } : {},
            horizontal: size ? {
                paddingTop: size.height / 2,
                paddingBottom: size.height / 2
            } : {}
        })
    };
    const trackStyle = {
        position: "absolute",
        ...$5a5132e81e443d52$export$f3eec17ee6065eee({
            orientation: orientation,
            vertical: {
                left: "50%",
                transform: "translateX(-50%)",
                height: "100%"
            },
            horizontal: {
                top: "50%",
                transform: "translateY(-50%)",
                width: "100%"
            }
        })
    };
    const isSingleThumb = thumbPercents.length === 1;
    const fallback = [
        0,
        isReversed ? 100 - thumbPercents[0] : thumbPercents[0]
    ];
    const range = isSingleThumb ? fallback : thumbPercents;
    let start = range[0];
    if (!isSingleThumb && isReversed) start = 100 - start;
    const percent = Math.abs(range[range.length - 1] - range[0]);
    const innerTrackStyle = {
        ...trackStyle,
        ...$5a5132e81e443d52$export$f3eec17ee6065eee({
            orientation: orientation,
            vertical: isReversed ? {
                height: `${percent}%`,
                top: `${start}%`
            } : {
                height: `${percent}%`,
                bottom: `${start}%`
            },
            horizontal: isReversed ? {
                width: `${percent}%`,
                right: `${start}%`
            } : {
                width: `${percent}%`,
                left: `${start}%`
            }
        })
    };
    return {
        trackStyle: trackStyle,
        innerTrackStyle: innerTrackStyle,
        rootStyle: rootStyle,
        getThumbStyle: getThumbStyle
    };
}
function $5a5132e81e443d52$export$4cb40dd77883f9(options) {
    const { isReversed: isReversed, direction: direction, orientation: orientation } = options;
    if (direction === "ltr" || orientation === "vertical") return isReversed;
    return !isReversed;
}


// src/add-dom-event.ts
function $e3489b456c03c680$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return ()=>{
        target.removeEventListener(eventName, handler, options);
    };
}


// src/assertion.ts
function $e517a1b891f36c11$export$764db16956f554f8(event) {
    const win = $e517a1b891f36c11$export$8d16348623687f6(event);
    if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof win.MouseEvent;
}
function $e517a1b891f36c11$export$c4dfce035d43d1e0(event) {
    const hasTouches = !!event.touches;
    return hasTouches;
}
function $e517a1b891f36c11$export$d06464d6b74eedc4(event) {
    return $e517a1b891f36c11$export$c4dfce035d43d1e0(event) && event.touches.length > 1;
}
function $e517a1b891f36c11$export$8d16348623687f6(event) {
    var _a;
    return (_a = event.view) != null ? _a : window;
}


// src/get-event-point.ts
function $0e3fa559b1a01dc4$var$pointFromTouch(e, type = "page") {
    const point = e.touches[0] || e.changedTouches[0];
    return {
        x: point[`${type}X`],
        y: point[`${type}Y`]
    };
}
function $0e3fa559b1a01dc4$var$pointFromMouse(point, type = "page") {
    return {
        x: point[`${type}X`],
        y: point[`${type}Y`]
    };
}
function $0e3fa559b1a01dc4$export$a8637644cbd23a7b(event, type = "page") {
    return (0, $e517a1b891f36c11$export$c4dfce035d43d1e0)(event) ? $0e3fa559b1a01dc4$var$pointFromTouch(event, type) : $0e3fa559b1a01dc4$var$pointFromMouse(event, type);
}



// src/add-pointer-event.ts
function $19a854d73663838a$var$filter(cb) {
    return (event)=>{
        const isMouse = (0, $e517a1b891f36c11$export$764db16956f554f8)(event);
        if (!isMouse || isMouse && event.button === 0) cb(event);
    };
}
function $19a854d73663838a$var$wrap(cb, filterPrimary = false) {
    function listener(event) {
        cb(event, {
            point: (0, $0e3fa559b1a01dc4$export$a8637644cbd23a7b)(event)
        });
    }
    const fn = filterPrimary ? $19a854d73663838a$var$filter(listener) : listener;
    return fn;
}
function $19a854d73663838a$export$fcff2e64e6676b81(target, type, cb, options) {
    return (0, $e3489b456c03c680$export$b1d829ddf82884aa)(target, type, $19a854d73663838a$var$wrap(cb, type === "pointerdown"), options);
}


const $1c49e3de0f86bd12$export$f8caf8121275292d = 1 / 60 * 1000;
const $1c49e3de0f86bd12$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $1c49e3de0f86bd12$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($1c49e3de0f86bd12$var$getCurrentTime()), $1c49e3de0f86bd12$export$f8caf8121275292d);


function $56b75657d7530209$export$b995e5e85f5c8289(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData)=>{
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $741aad569b766a4c$var$maxElapsed = 40;
let $741aad569b766a4c$var$useDefaultElapsed = true;
let $741aad569b766a4c$var$runNextFrame = false;
let $741aad569b766a4c$var$isProcessing = false;
const $741aad569b766a4c$var$frame = {
    delta: 0,
    timestamp: 0
};
const $741aad569b766a4c$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $741aad569b766a4c$var$steps = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $56b75657d7530209$export$b995e5e85f5c8289)(()=>$741aad569b766a4c$var$runNextFrame = true);
    return acc;
}, {});
const $741aad569b766a4c$var$sync = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    const step = $741aad569b766a4c$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$741aad569b766a4c$var$runNextFrame) $741aad569b766a4c$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $741aad569b766a4c$export$d93e9c1fe0553512 = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $741aad569b766a4c$var$steps[key].cancel;
    return acc;
}, {});
const $741aad569b766a4c$export$cd75ccfd720a3cd4 = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$741aad569b766a4c$var$steps[key].process($741aad569b766a4c$var$frame);
    return acc;
}, {});
const $741aad569b766a4c$var$processStep = (stepId)=>$741aad569b766a4c$var$steps[stepId].process($741aad569b766a4c$var$frame);
const $741aad569b766a4c$var$processFrame = (timestamp)=>{
    $741aad569b766a4c$var$runNextFrame = false;
    $741aad569b766a4c$var$frame.delta = $741aad569b766a4c$var$useDefaultElapsed ? (0, $1c49e3de0f86bd12$export$f8caf8121275292d) : Math.max(Math.min(timestamp - $741aad569b766a4c$var$frame.timestamp, $741aad569b766a4c$var$maxElapsed), 1);
    $741aad569b766a4c$var$frame.timestamp = timestamp;
    $741aad569b766a4c$var$isProcessing = true;
    $741aad569b766a4c$var$stepsOrder.forEach($741aad569b766a4c$var$processStep);
    $741aad569b766a4c$var$isProcessing = false;
    if ($741aad569b766a4c$var$runNextFrame) {
        $741aad569b766a4c$var$useDefaultElapsed = false;
        (0, $1c49e3de0f86bd12$export$4fdea63ab5513fd5)($741aad569b766a4c$var$processFrame);
    }
};
const $741aad569b766a4c$var$startLoop = ()=>{
    $741aad569b766a4c$var$runNextFrame = true;
    $741aad569b766a4c$var$useDefaultElapsed = true;
    if (!$741aad569b766a4c$var$isProcessing) (0, $1c49e3de0f86bd12$export$4fdea63ab5513fd5)($741aad569b766a4c$var$processFrame);
};
const $741aad569b766a4c$export$7244445918e670ed = ()=>$741aad569b766a4c$var$frame;
var $741aad569b766a4c$export$2e2bcd8739ae039 = $741aad569b766a4c$var$sync;


"use client";
var $943cb164cb664fbd$var$__defProp = Object.defineProperty;
var $943cb164cb664fbd$var$__defNormalProp = (obj, key, value)=>key in obj ? $943cb164cb664fbd$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $943cb164cb664fbd$var$__publicField = (obj, key, value)=>{
    $943cb164cb664fbd$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $943cb164cb664fbd$export$3a7c8887437719ed = class {
    constructor(event, handlers, threshold){
        /**
     * We use this to keep track of the `x` and `y` pan session history
     * as the pan event happens. It helps to calculate the `offset` and `delta`
     */ $943cb164cb664fbd$var$__publicField(this, "history", []);
        // The pointer event that started the pan session
        $943cb164cb664fbd$var$__publicField(this, "startEvent", null);
        // The current pointer event for the pan session
        $943cb164cb664fbd$var$__publicField(this, "lastEvent", null);
        // The current pointer event info for the pan session
        $943cb164cb664fbd$var$__publicField(this, "lastEventInfo", null);
        $943cb164cb664fbd$var$__publicField(this, "handlers", {});
        $943cb164cb664fbd$var$__publicField(this, "removeListeners", ()=>{});
        /**
     * Minimal pan distance required before recognizing the pan.
     * @default "3px"
     */ $943cb164cb664fbd$var$__publicField(this, "threshold", 3);
        $943cb164cb664fbd$var$__publicField(this, "win");
        $943cb164cb664fbd$var$__publicField(this, "updatePoint", ()=>{
            if (!(this.lastEvent && this.lastEventInfo)) return;
            const info = $943cb164cb664fbd$var$getPanInfo(this.lastEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            const isDistancePastThreshold = $943cb164cb664fbd$export$9f17032d917177de(info.offset, {
                x: 0,
                y: 0
            }) >= this.threshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { timestamp: timestamp } = (0, $741aad569b766a4c$export$7244445918e670ed)();
            this.history.push({
                ...info.point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart == null || onStart(this.lastEvent, info);
                this.startEvent = this.lastEvent;
            }
            onMove == null || onMove(this.lastEvent, info);
        });
        $943cb164cb664fbd$var$__publicField(this, "onPointerMove", (event, info)=>{
            this.lastEvent = event;
            this.lastEventInfo = info;
            (0, $741aad569b766a4c$export$2e2bcd8739ae039).update(this.updatePoint, true);
        });
        $943cb164cb664fbd$var$__publicField(this, "onPointerUp", (event, info)=>{
            const panInfo = $943cb164cb664fbd$var$getPanInfo(info, this.history);
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            onSessionEnd == null || onSessionEnd(event, panInfo);
            this.end();
            if (!onEnd || !this.startEvent) return;
            onEnd == null || onEnd(event, panInfo);
        });
        var _a;
        this.win = (_a = event.view) != null ? _a : window;
        if ((0, $e517a1b891f36c11$export$d06464d6b74eedc4)(event)) return;
        this.handlers = handlers;
        if (threshold) this.threshold = threshold;
        event.stopPropagation();
        event.preventDefault();
        const info = {
            point: (0, $0e3fa559b1a01dc4$export$a8637644cbd23a7b)(event)
        };
        const { timestamp: timestamp } = (0, $741aad569b766a4c$export$7244445918e670ed)();
        this.history = [
            {
                ...info.point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart == null || onSessionStart(event, $943cb164cb664fbd$var$getPanInfo(info, this.history));
        this.removeListeners = $943cb164cb664fbd$var$pipe((0, $19a854d73663838a$export$fcff2e64e6676b81)(this.win, "pointermove", this.onPointerMove), (0, $19a854d73663838a$export$fcff2e64e6676b81)(this.win, "pointerup", this.onPointerUp), (0, $19a854d73663838a$export$fcff2e64e6676b81)(this.win, "pointercancel", this.onPointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        var _a;
        (_a = this.removeListeners) == null || _a.call(this);
        (0, $741aad569b766a4c$export$d93e9c1fe0553512).update(this.updatePoint);
    }
};
function $943cb164cb664fbd$var$subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $943cb164cb664fbd$var$getPanInfo(info, history) {
    return {
        point: info.point,
        delta: $943cb164cb664fbd$var$subtract(info.point, history[history.length - 1]),
        offset: $943cb164cb664fbd$var$subtract(info.point, history[0]),
        velocity: $943cb164cb664fbd$var$getVelocity(history, 0.1)
    };
}
var $943cb164cb664fbd$var$toMilliseconds = (v)=>v * 1e3;
function $943cb164cb664fbd$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = history[history.length - 1];
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > $943cb164cb664fbd$var$toMilliseconds(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1e3;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}
function $943cb164cb664fbd$var$pipe(...fns) {
    return (v)=>fns.reduce((a, b)=>b(a), v);
}
function $943cb164cb664fbd$var$distance1D(a, b) {
    return Math.abs(a - b);
}
function $943cb164cb664fbd$var$isPoint(point) {
    return "x" in point && "y" in point;
}
function $943cb164cb664fbd$export$9f17032d917177de(a, b) {
    if (typeof a === "number" && typeof b === "number") return $943cb164cb664fbd$var$distance1D(a, b);
    if ($943cb164cb664fbd$var$isPoint(a) && $943cb164cb664fbd$var$isPoint(b)) {
        const xDelta = $943cb164cb664fbd$var$distance1D(a.x, b.x);
        const yDelta = $943cb164cb664fbd$var$distance1D(a.y, b.y);
        return Math.sqrt(xDelta ** 2 + yDelta ** 2);
    }
    return 0;
}




var $acw62 = parcelRequire("acw62");
"use client";
function $7bee2e7066206447$export$bcd07ba85a740103(value) {
    const ref = (0, $acw62.useRef)(null);
    ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
"use client";
function $479b6de02438f6b8$export$9ad22d853bfe2640(ref, options) {
    const { onPan: onPan, onPanStart: onPanStart, onPanEnd: onPanEnd, onPanSessionStart: onPanSessionStart, onPanSessionEnd: onPanSessionEnd, threshold: threshold } = options;
    const hasPanEvents = Boolean(onPan || onPanStart || onPanEnd || onPanSessionStart || onPanSessionEnd);
    const panSession = (0, $acw62.useRef)(null);
    const handlersRef = (0, $7bee2e7066206447$export$bcd07ba85a740103)({
        onSessionStart: onPanSessionStart,
        onSessionEnd: onPanSessionEnd,
        onStart: onPanStart,
        onMove: onPan,
        onEnd (event, info) {
            panSession.current = null;
            onPanEnd == null || onPanEnd(event, info);
        }
    });
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = panSession.current) == null || _a.updateHandlers(handlersRef.current);
    });
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (!node || !hasPanEvents) return;
        function onPointerDown(event) {
            panSession.current = new (0, $943cb164cb664fbd$export$3a7c8887437719ed)(event, handlersRef.current, threshold);
        }
        return (0, $19a854d73663838a$export$fcff2e64e6676b81)(node, "pointerdown", onPointerDown);
    }, [
        ref,
        hasPanEvents,
        handlersRef,
        threshold
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            var _a;
            (_a = panSession.current) == null || _a.end();
            panSession.current = null;
        };
    }, []);
}






// src/index.ts
function $14fb920778dda918$var$toNumber(value) {
    const num = parseFloat(value);
    return typeof num !== "number" || Number.isNaN(num) ? 0 : num;
}
function $14fb920778dda918$export$3e91a10e66078270(value, precision) {
    let nextValue = $14fb920778dda918$var$toNumber(value);
    const scaleFactor = 10 ** (precision != null ? precision : 10);
    nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
    return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
function $14fb920778dda918$export$a42544f265f8403(value) {
    if (!Number.isFinite(value)) return 0;
    let e = 1;
    let p = 0;
    while(Math.round(value * e) / e !== value){
        e *= 10;
        p += 1;
    }
    return p;
}
function $14fb920778dda918$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $14fb920778dda918$export$7a6e99933c50b5b2(percent, min, max) {
    return (max - min) * percent + min;
}
function $14fb920778dda918$export$3e1fe053092824a3(value, from, step) {
    const nextValue = Math.round((value - from) / step) * step + from;
    const precision = $14fb920778dda918$export$a42544f265f8403(step);
    return $14fb920778dda918$export$3e91a10e66078270(nextValue, precision);
}
function $14fb920778dda918$export$31ee16100cde6ce2(value, min, max) {
    if (value == null) return value;
    if (max < min) console.warn("clamp: max cannot be less than min");
    return Math.min(Math.max(value, min), max);
}



var $acw62 = parcelRequire("acw62");
function $733a6f5dffb576aa$export$6bfdefed991d4198(element, callback) {
    if (!element) {
        callback(void 0);
        return;
    }
    callback({
        width: element.offsetWidth,
        height: element.offsetHeight
    });
    const win = element.ownerDocument.defaultView ?? window;
    const observer = new win.ResizeObserver((entries)=>{
        if (!Array.isArray(entries) || !entries.length) return;
        const [entry] = entries;
        let width;
        let height;
        if ("borderBoxSize" in entry) {
            const borderSizeEntry = entry["borderBoxSize"];
            const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
            width = borderSize["inlineSize"];
            height = borderSize["blockSize"];
        } else {
            width = element.offsetWidth;
            height = element.offsetHeight;
        }
        callback({
            width: width,
            height: height
        });
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>observer.unobserve(element);
}



var $acw62 = parcelRequire("acw62");
"use client";
var $09713d4458d6cfbc$var$useSafeLayoutEffect = Boolean(globalThis == null ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $09713d4458d6cfbc$var$trackMutation(el, cb) {
    var _a, _b;
    if (!el || !el.parentElement) return;
    const win = (_b = (_a = el.ownerDocument) == null ? void 0 : _a.defaultView) != null ? _b : window;
    const observer = new win.MutationObserver(()=>{
        cb();
    });
    observer.observe(el.parentElement, {
        childList: true
    });
    return ()=>{
        observer.disconnect();
    };
}
function $09713d4458d6cfbc$export$b45c235b0389f404({ getNodes: getNodes, observeMutation: observeMutation = true }) {
    const [sizes, setSizes] = (0, $acw62.useState)([]);
    const [count, setCount] = (0, $acw62.useState)(0);
    $09713d4458d6cfbc$var$useSafeLayoutEffect(()=>{
        const elements = getNodes();
        const cleanups = elements.map((element, index)=>(0, $733a6f5dffb576aa$export$6bfdefed991d4198)(element, (size)=>{
                setSizes((sizes2)=>{
                    return [
                        ...sizes2.slice(0, index),
                        size,
                        ...sizes2.slice(index + 1)
                    ];
                });
            }));
        if (observeMutation) {
            const firstNode = elements[0];
            cleanups.push($09713d4458d6cfbc$var$trackMutation(firstNode, ()=>{
                setCount((count2)=>count2 + 1);
            }));
        }
        return ()=>{
            cleanups.forEach((cleanup)=>{
                cleanup == null || cleanup();
            });
        };
    }, [
        count
    ]);
    return sizes;
}
function $09713d4458d6cfbc$var$isRef(ref) {
    return typeof ref === "object" && ref !== null && "current" in ref;
}
function $09713d4458d6cfbc$export$1ab7ae714698c4b8(subject) {
    const [size] = $09713d4458d6cfbc$export$b45c235b0389f404({
        observeMutation: false,
        getNodes () {
            const node = $09713d4458d6cfbc$var$isRef(subject) ? subject.current : subject;
            return [
                node
            ];
        }
    });
    return size;
}


"use client";
function $997a20ac215b3a36$export$d15455cfeca19795(props) {
    const { min: min = 0, max: max = 100, onChange: onChange, value: valueProp, defaultValue: defaultValue, isReversed: isReversedProp, direction: direction = "ltr", orientation: orientation = "horizontal", id: idProp, isDisabled: isDisabled, isReadOnly: isReadOnly, onChangeStart: onChangeStartProp, onChangeEnd: onChangeEndProp, step: step = 1, getAriaValueText: getAriaValueTextProp, "aria-valuetext": ariaValueText, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, name: name, focusThumbOnChange: focusThumbOnChange = true, minStepsBetweenThumbs: minStepsBetweenThumbs = 0, ...htmlProps } = props;
    const onChangeStart = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onChangeStartProp);
    const onChangeEnd = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onChangeEndProp);
    const getAriaValueText = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(getAriaValueTextProp);
    const isReversed = (0, $5a5132e81e443d52$export$4cb40dd77883f9)({
        isReversed: isReversedProp,
        direction: direction,
        orientation: orientation
    });
    const [valueState, setValue] = (0, $4795b7ced84aa3c2$export$6f32135080cb4c3)({
        value: valueProp,
        defaultValue: defaultValue != null ? defaultValue : [
            25,
            75
        ],
        onChange: onChange
    });
    if (!Array.isArray(valueState)) throw new TypeError(`[range-slider] You passed an invalid value for \`value\` or \`defaultValue\`, expected \`Array\` but got \`${typeof valueState}\``);
    const [isDragging, setDragging] = (0, $acw62.useState)(false);
    const [isFocused, setFocused] = (0, $acw62.useState)(false);
    const [activeIndex, setActiveIndex] = (0, $acw62.useState)(-1);
    const isInteractive = !(isDisabled || isReadOnly);
    const initialValue = (0, $acw62.useRef)(valueState);
    const value = valueState.map((val)=>(0, $14fb920778dda918$export$31ee16100cde6ce2)(val, min, max));
    const spacing = minStepsBetweenThumbs * step;
    const valueBounds = $997a20ac215b3a36$var$getValueBounds(value, min, max, spacing);
    const stateRef = (0, $acw62.useRef)({
        eventSource: null,
        value: [],
        valueBounds: []
    });
    stateRef.current.value = value;
    stateRef.current.valueBounds = valueBounds;
    const reversedValue = value.map((val)=>max - val + min);
    const thumbValues = isReversed ? reversedValue : value;
    const thumbPercents = thumbValues.map((val)=>(0, $14fb920778dda918$export$83ce4bc8280540e6)(val, min, max));
    const isVertical = orientation === "vertical";
    const trackRef = (0, $acw62.useRef)(null);
    const rootRef = (0, $acw62.useRef)(null);
    const thumbRects = (0, $09713d4458d6cfbc$export$b45c235b0389f404)({
        getNodes () {
            const rootNode = rootRef.current;
            const thumbNodes = rootNode == null ? void 0 : rootNode.querySelectorAll("[role=slider]");
            return thumbNodes ? Array.from(thumbNodes) : [];
        }
    });
    const reactId = (0, $acw62.useId)();
    const uuid = idProp != null ? idProp : reactId;
    const ids = (0, $5a5132e81e443d52$export$24b60fe7179439bc)(uuid);
    const getValueFromPointer = (0, $acw62.useCallback)((event)=>{
        var _a, _b;
        if (!trackRef.current) return;
        stateRef.current.eventSource = "pointer";
        const rect = trackRef.current.getBoundingClientRect();
        const { clientX: clientX, clientY: clientY } = (_b = (_a = event.touches) == null ? void 0 : _a[0]) != null ? _b : event;
        const diff = isVertical ? rect.bottom - clientY : clientX - rect.left;
        const length = isVertical ? rect.height : rect.width;
        let percent = diff / length;
        if (isReversed) percent = 1 - percent;
        return (0, $14fb920778dda918$export$7a6e99933c50b5b2)(percent, min, max);
    }, [
        isVertical,
        isReversed,
        max,
        min
    ]);
    const tenSteps = (max - min) / 10;
    const oneStep = step || (max - min) / 100;
    const actions = (0, $acw62.useMemo)(()=>({
            setValueAtIndex (index, val) {
                if (!isInteractive) return;
                const bounds = stateRef.current.valueBounds[index];
                val = parseFloat((0, $14fb920778dda918$export$3e1fe053092824a3)(val, bounds.min, oneStep));
                val = (0, $14fb920778dda918$export$31ee16100cde6ce2)(val, bounds.min, bounds.max);
                const next = [
                    ...stateRef.current.value
                ];
                next[index] = val;
                setValue(next);
            },
            setActiveIndex: setActiveIndex,
            stepUp (index, step2 = oneStep) {
                const valueAtIndex = stateRef.current.value[index];
                const next = isReversed ? valueAtIndex - step2 : valueAtIndex + step2;
                actions.setValueAtIndex(index, next);
            },
            stepDown (index, step2 = oneStep) {
                const valueAtIndex = stateRef.current.value[index];
                const next = isReversed ? valueAtIndex + step2 : valueAtIndex - step2;
                actions.setValueAtIndex(index, next);
            },
            reset () {
                setValue(initialValue.current);
            }
        }), [
        oneStep,
        isReversed,
        setValue,
        isInteractive
    ]);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        const eventKey = event.key;
        const keyMap = {
            ArrowRight: ()=>actions.stepUp(activeIndex),
            ArrowUp: ()=>actions.stepUp(activeIndex),
            ArrowLeft: ()=>actions.stepDown(activeIndex),
            ArrowDown: ()=>actions.stepDown(activeIndex),
            PageUp: ()=>actions.stepUp(activeIndex, tenSteps),
            PageDown: ()=>actions.stepDown(activeIndex, tenSteps),
            Home: ()=>{
                const { min: value2 } = valueBounds[activeIndex];
                actions.setValueAtIndex(activeIndex, value2);
            },
            End: ()=>{
                const { max: value2 } = valueBounds[activeIndex];
                actions.setValueAtIndex(activeIndex, value2);
            }
        };
        const action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            event.stopPropagation();
            action(event);
            stateRef.current.eventSource = "keyboard";
        }
    }, [
        actions,
        activeIndex,
        tenSteps,
        valueBounds
    ]);
    const { getThumbStyle: getThumbStyle, rootStyle: rootStyle, trackStyle: trackStyle, innerTrackStyle: innerTrackStyle } = (0, $acw62.useMemo)(()=>(0, $5a5132e81e443d52$export$ffd58b7f6f099a57)({
            isReversed: isReversed,
            orientation: orientation,
            thumbRects: thumbRects,
            thumbPercents: thumbPercents
        }), [
        isReversed,
        orientation,
        thumbPercents,
        thumbRects
    ]);
    const focusThumb = (0, $acw62.useCallback)((index)=>{
        var _a;
        const idx = index != null ? index : activeIndex;
        if (idx !== -1 && focusThumbOnChange) {
            const id = ids.getThumb(idx);
            const thumb = (_a = rootRef.current) == null ? void 0 : _a.ownerDocument.getElementById(id);
            if (thumb) setTimeout(()=>thumb.focus());
        }
    }, [
        focusThumbOnChange,
        activeIndex,
        ids
    ]);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (stateRef.current.eventSource === "keyboard") onChangeEnd == null || onChangeEnd(stateRef.current.value);
    }, [
        value,
        onChangeEnd
    ]);
    const onPanSessionStart = (event)=>{
        const pointValue = getValueFromPointer(event) || 0;
        const distances = stateRef.current.value.map((val)=>Math.abs(val - pointValue));
        const closest = Math.min(...distances);
        let index = distances.indexOf(closest);
        const thumbsAtPosition = distances.filter((distance)=>distance === closest);
        const isThumbStacked = thumbsAtPosition.length > 1;
        if (isThumbStacked && pointValue > stateRef.current.value[index]) index = index + thumbsAtPosition.length - 1;
        setActiveIndex(index);
        actions.setValueAtIndex(index, pointValue);
        focusThumb(index);
    };
    const onPan = (event)=>{
        if (activeIndex == -1) return;
        const pointValue = getValueFromPointer(event) || 0;
        setActiveIndex(activeIndex);
        actions.setValueAtIndex(activeIndex, pointValue);
        focusThumb(activeIndex);
    };
    (0, $479b6de02438f6b8$export$9ad22d853bfe2640)(rootRef, {
        onPanSessionStart (event) {
            if (!isInteractive) return;
            setDragging(true);
            onPanSessionStart(event);
            onChangeStart == null || onChangeStart(stateRef.current.value);
        },
        onPanSessionEnd () {
            if (!isInteractive) return;
            setDragging(false);
            onChangeEnd == null || onChangeEnd(stateRef.current.value);
        },
        onPan (event) {
            if (!isInteractive) return;
            onPan(event);
        }
    });
    const getRootProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ...htmlProps,
            id: ids.root,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, rootRef),
            tabIndex: -1,
            "aria-disabled": (0, $fe0b3525ffcb2f27$export$91a6105db3d4be7b)(isDisabled),
            "data-focused": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(isFocused),
            style: {
                ...props2.style,
                ...rootStyle
            }
        };
    }, [
        htmlProps,
        isDisabled,
        isFocused,
        rootStyle,
        ids
    ]);
    const getTrackProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, trackRef),
            id: ids.track,
            "data-disabled": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(isDisabled),
            style: {
                ...props2.style,
                ...trackStyle
            }
        };
    }, [
        isDisabled,
        trackStyle,
        ids
    ]);
    const getInnerTrackProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: ref,
            id: ids.innerTrack,
            style: {
                ...props2.style,
                ...innerTrackStyle
            }
        };
    }, [
        innerTrackStyle,
        ids
    ]);
    const getThumbProps = (0, $acw62.useCallback)((props2, ref = null)=>{
        var _a;
        const { index: index, ...rest } = props2;
        const valueAtIndex = value[index];
        if (valueAtIndex == null) throw new TypeError(`[range-slider > thumb] Cannot find value at index \`${index}\`. The \`value\` or \`defaultValue\` length is : ${value.length}`);
        const bounds = valueBounds[index];
        return {
            ...rest,
            ref: ref,
            role: "slider",
            tabIndex: isInteractive ? 0 : void 0,
            id: ids.getThumb(index),
            "data-active": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(isDragging && activeIndex === index),
            "aria-valuetext": (_a = getAriaValueText == null ? void 0 : getAriaValueText(valueAtIndex)) != null ? _a : ariaValueText == null ? void 0 : ariaValueText[index],
            "aria-valuemin": bounds.min,
            "aria-valuemax": bounds.max,
            "aria-valuenow": valueAtIndex,
            "aria-orientation": orientation,
            "aria-disabled": (0, $fe0b3525ffcb2f27$export$91a6105db3d4be7b)(isDisabled),
            "aria-readonly": (0, $fe0b3525ffcb2f27$export$91a6105db3d4be7b)(isReadOnly),
            "aria-label": ariaLabel == null ? void 0 : ariaLabel[index],
            "aria-labelledby": (ariaLabel == null ? void 0 : ariaLabel[index]) ? void 0 : ariaLabelledBy == null ? void 0 : ariaLabelledBy[index],
            style: {
                ...props2.style,
                ...getThumbStyle(index)
            },
            onKeyDown: (0, $fe0b3525ffcb2f27$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onFocus: (0, $fe0b3525ffcb2f27$export$5bdd3f730ec2c47e)(props2.onFocus, ()=>{
                setFocused(true);
                setActiveIndex(index);
            }),
            onBlur: (0, $fe0b3525ffcb2f27$export$5bdd3f730ec2c47e)(props2.onBlur, ()=>{
                setFocused(false);
                setActiveIndex(-1);
            })
        };
    }, [
        ids,
        value,
        valueBounds,
        isInteractive,
        isDragging,
        activeIndex,
        getAriaValueText,
        ariaValueText,
        orientation,
        isDisabled,
        isReadOnly,
        ariaLabel,
        ariaLabelledBy,
        getThumbStyle,
        onKeyDown,
        setFocused
    ]);
    const getOutputProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: ref,
            id: ids.output,
            htmlFor: value.map((v, i)=>ids.getThumb(i)).join(" "),
            "aria-live": "off"
        };
    }, [
        ids,
        value
    ]);
    const getMarkerProps = (0, $acw62.useCallback)((props2, ref = null)=>{
        const { value: v, ...rest } = props2;
        const isInRange = !(v < min || v > max);
        const isHighlighted = v >= value[0] && v <= value[value.length - 1];
        let percent = (0, $14fb920778dda918$export$83ce4bc8280540e6)(v, min, max);
        percent = isReversed ? 100 - percent : percent;
        const markerStyle = {
            position: "absolute",
            pointerEvents: "none",
            ...(0, $5a5132e81e443d52$export$f3eec17ee6065eee)({
                orientation: orientation,
                vertical: {
                    bottom: `${percent}%`
                },
                horizontal: {
                    left: `${percent}%`
                }
            })
        };
        return {
            ...rest,
            ref: ref,
            id: ids.getMarker(props2.value),
            role: "presentation",
            "aria-hidden": true,
            "data-disabled": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(!isInRange),
            "data-highlighted": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(isHighlighted),
            style: {
                ...props2.style,
                ...markerStyle
            }
        };
    }, [
        isDisabled,
        isReversed,
        max,
        min,
        orientation,
        value,
        ids
    ]);
    const getInputProps = (0, $acw62.useCallback)((props2, ref = null)=>{
        const { index: index, ...rest } = props2;
        return {
            ...rest,
            ref: ref,
            id: ids.getInput(index),
            type: "hidden",
            value: value[index],
            name: Array.isArray(name) ? name[index] : `${name}-${index}`
        };
    }, [
        name,
        value,
        ids
    ]);
    const state = {
        value: value,
        isFocused: isFocused,
        isDragging: isDragging,
        getThumbPercent: (index)=>thumbPercents[index],
        getThumbMinValue: (index)=>valueBounds[index].min,
        getThumbMaxValue: (index)=>valueBounds[index].max
    };
    return {
        state: state,
        actions: actions,
        getRootProps: getRootProps,
        getTrackProps: getTrackProps,
        getInnerTrackProps: getInnerTrackProps,
        getThumbProps: getThumbProps,
        getMarkerProps: getMarkerProps,
        getInputProps: getInputProps,
        getOutputProps: getOutputProps
    };
}
function $997a20ac215b3a36$var$getValueBounds(arr, min, max, spacing) {
    return arr.map((v, i)=>{
        const _min = i === 0 ? min : arr[i - 1] + spacing;
        const _max = i === arr.length - 1 ? max : arr[i + 1] - spacing;
        return {
            min: _min,
            max: _max
        };
    });
}






var $acw62 = parcelRequire("acw62");

"use client";
var [$82cc94754f1df116$export$2e29a4624de7f74b, $82cc94754f1df116$export$9860cdd53f69e186] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "SliderContext",
    errorMessage: "useSliderContext: `context` is undefined. Seems you forgot to wrap all slider components within <RangeSlider />"
});
var [$82cc94754f1df116$var$RangeSliderStylesProvider, $82cc94754f1df116$export$9bcc35675cf6bbd6] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `RangeSliderStylesContext`,
    errorMessage: `useRangeSliderStyles returned is 'undefined'. Seems you forgot to wrap the components in "<RangeSlider />" `
});
var $82cc94754f1df116$export$826424dabc3dd705 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function RangeSlider2(props, ref) {
    const sliderProps = {
        orientation: "horizontal",
        ...props
    };
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Slider", sliderProps);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(sliderProps);
    const { direction: direction } = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    ownProps.direction = direction;
    const { getRootProps: getRootProps, ...context } = (0, $997a20ac215b3a36$export$d15455cfeca19795)(ownProps);
    const ctx = (0, $acw62.useMemo)(()=>({
            ...context,
            name: sliderProps.name
        }), [
        context,
        sliderProps.name
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82cc94754f1df116$export$2e29a4624de7f74b, {
        value: ctx,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82cc94754f1df116$var$RangeSliderStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                ...getRootProps({}, ref),
                className: "chakra-slider",
                __css: styles.container,
                children: sliderProps.children
            })
        })
    });
});
$82cc94754f1df116$export$826424dabc3dd705.displayName = "RangeSlider";
var $82cc94754f1df116$export$99fcec41170e54d4 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function RangeSliderThumb2(props, ref) {
    const { getThumbProps: getThumbProps, getInputProps: getInputProps, name: name } = $82cc94754f1df116$export$9860cdd53f69e186();
    const styles = $82cc94754f1df116$export$9bcc35675cf6bbd6();
    const thumbProps = getThumbProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...thumbProps,
        className: (0, $fe0b3525ffcb2f27$export$a274e22fb40f762e)("chakra-slider__thumb", props.className),
        __css: styles.thumb,
        children: [
            thumbProps.children,
            name && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                ...getInputProps({
                    index: props.index
                })
            })
        ]
    });
});
$82cc94754f1df116$export$99fcec41170e54d4.displayName = "RangeSliderThumb";
var $82cc94754f1df116$export$e77a5f64f3997375 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function RangeSliderTrack2(props, ref) {
    const { getTrackProps: getTrackProps } = $82cc94754f1df116$export$9860cdd53f69e186();
    const styles = $82cc94754f1df116$export$9bcc35675cf6bbd6();
    const trackProps = getTrackProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...trackProps,
        className: (0, $fe0b3525ffcb2f27$export$a274e22fb40f762e)("chakra-slider__track", props.className),
        __css: styles.track,
        "data-testid": "chakra-range-slider-track"
    });
});
$82cc94754f1df116$export$e77a5f64f3997375.displayName = "RangeSliderTrack";
var $82cc94754f1df116$export$8f071f12eca431ca = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function RangeSliderFilledTrack2(props, ref) {
    const { getInnerTrackProps: getInnerTrackProps } = $82cc94754f1df116$export$9860cdd53f69e186();
    const styles = $82cc94754f1df116$export$9bcc35675cf6bbd6();
    const trackProps = getInnerTrackProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...trackProps,
        className: "chakra-slider__filled-track",
        __css: styles.filledTrack
    });
});
$82cc94754f1df116$export$8f071f12eca431ca.displayName = "RangeSliderFilledTrack";
var $82cc94754f1df116$export$e6955330e98f54e8 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function RangeSliderMark2(props, ref) {
    const { getMarkerProps: getMarkerProps } = $82cc94754f1df116$export$9860cdd53f69e186();
    const styles = $82cc94754f1df116$export$9bcc35675cf6bbd6();
    const markProps = getMarkerProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...markProps,
        className: (0, $fe0b3525ffcb2f27$export$a274e22fb40f762e)("chakra-slider__marker", props.className),
        __css: styles.mark
    });
});
$82cc94754f1df116$export$e6955330e98f54e8.displayName = "RangeSliderMark";












var $acw62 = parcelRequire("acw62");
"use client";
function $b916c7d6c5956576$export$56b2c08e277f365(props) {
    var _a;
    const { min: min = 0, max: max = 100, onChange: onChange, value: valueProp, defaultValue: defaultValue, isReversed: isReversedProp, direction: direction = "ltr", orientation: orientation = "horizontal", id: idProp, isDisabled: isDisabled, isReadOnly: isReadOnly, onChangeStart: onChangeStartProp, onChangeEnd: onChangeEndProp, step: step = 1, getAriaValueText: getAriaValueTextProp, "aria-valuetext": ariaValueText, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, name: name, focusThumbOnChange: focusThumbOnChange = true, ...htmlProps } = props;
    const onChangeStart = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onChangeStartProp);
    const onChangeEnd = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onChangeEndProp);
    const getAriaValueText = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(getAriaValueTextProp);
    const isReversed = (0, $5a5132e81e443d52$export$4cb40dd77883f9)({
        isReversed: isReversedProp,
        direction: direction,
        orientation: orientation
    });
    const [computedValue, setValue] = (0, $4795b7ced84aa3c2$export$6f32135080cb4c3)({
        value: valueProp,
        defaultValue: defaultValue != null ? defaultValue : $b916c7d6c5956576$var$getDefaultValue(min, max),
        onChange: onChange
    });
    const [isDragging, setDragging] = (0, $acw62.useState)(false);
    const [isFocused, setFocused] = (0, $acw62.useState)(false);
    const isInteractive = !(isDisabled || isReadOnly);
    const tenSteps = (max - min) / 10;
    const oneStep = step || (max - min) / 100;
    const value = (0, $14fb920778dda918$export$31ee16100cde6ce2)(computedValue, min, max);
    const reversedValue = max - value + min;
    const trackValue = isReversed ? reversedValue : value;
    const thumbPercent = (0, $14fb920778dda918$export$83ce4bc8280540e6)(trackValue, min, max);
    const isVertical = orientation === "vertical";
    const stateRef = (0, $7bee2e7066206447$export$bcd07ba85a740103)({
        min: min,
        max: max,
        step: step,
        isDisabled: isDisabled,
        value: value,
        isInteractive: isInteractive,
        isReversed: isReversed,
        isVertical: isVertical,
        eventSource: null,
        focusThumbOnChange: focusThumbOnChange,
        orientation: orientation
    });
    const trackRef = (0, $acw62.useRef)(null);
    const thumbRef = (0, $acw62.useRef)(null);
    const rootRef = (0, $acw62.useRef)(null);
    const reactId = (0, $acw62.useId)();
    const uuid = idProp != null ? idProp : reactId;
    const [thumbId, trackId] = [
        `slider-thumb-${uuid}`,
        `slider-track-${uuid}`
    ];
    const getValueFromPointer = (0, $acw62.useCallback)((event)=>{
        var _a2, _b;
        if (!trackRef.current) return;
        const state2 = stateRef.current;
        state2.eventSource = "pointer";
        const trackRect = trackRef.current.getBoundingClientRect();
        const { clientX: clientX, clientY: clientY } = (_b = (_a2 = event.touches) == null ? void 0 : _a2[0]) != null ? _b : event;
        const diff = isVertical ? trackRect.bottom - clientY : clientX - trackRect.left;
        const length = isVertical ? trackRect.height : trackRect.width;
        let percent = diff / length;
        if (isReversed) percent = 1 - percent;
        let nextValue = (0, $14fb920778dda918$export$7a6e99933c50b5b2)(percent, state2.min, state2.max);
        if (state2.step) nextValue = parseFloat((0, $14fb920778dda918$export$3e1fe053092824a3)(nextValue, state2.min, state2.step));
        nextValue = (0, $14fb920778dda918$export$31ee16100cde6ce2)(nextValue, state2.min, state2.max);
        return nextValue;
    }, [
        isVertical,
        isReversed,
        stateRef
    ]);
    const constrain = (0, $acw62.useCallback)((value2)=>{
        const state2 = stateRef.current;
        if (!state2.isInteractive) return;
        value2 = parseFloat((0, $14fb920778dda918$export$3e1fe053092824a3)(value2, state2.min, oneStep));
        value2 = (0, $14fb920778dda918$export$31ee16100cde6ce2)(value2, state2.min, state2.max);
        setValue(value2);
    }, [
        oneStep,
        setValue,
        stateRef
    ]);
    const actions = (0, $acw62.useMemo)(()=>({
            stepUp (step2 = oneStep) {
                const next = isReversed ? value - step2 : value + step2;
                constrain(next);
            },
            stepDown (step2 = oneStep) {
                const next = isReversed ? value + step2 : value - step2;
                constrain(next);
            },
            reset () {
                constrain(defaultValue || 0);
            },
            stepTo (value2) {
                constrain(value2);
            }
        }), [
        constrain,
        isReversed,
        value,
        oneStep,
        defaultValue
    ]);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        const state2 = stateRef.current;
        const keyMap = {
            ArrowRight: ()=>actions.stepUp(),
            ArrowUp: ()=>actions.stepUp(),
            ArrowLeft: ()=>actions.stepDown(),
            ArrowDown: ()=>actions.stepDown(),
            PageUp: ()=>actions.stepUp(tenSteps),
            PageDown: ()=>actions.stepDown(tenSteps),
            Home: ()=>constrain(state2.min),
            End: ()=>constrain(state2.max)
        };
        const action = keyMap[event.key];
        if (action) {
            event.preventDefault();
            event.stopPropagation();
            action(event);
            state2.eventSource = "keyboard";
        }
    }, [
        actions,
        constrain,
        tenSteps,
        stateRef
    ]);
    const valueText = (_a = getAriaValueText == null ? void 0 : getAriaValueText(value)) != null ? _a : ariaValueText;
    const thumbSize = (0, $09713d4458d6cfbc$export$1ab7ae714698c4b8)(thumbRef);
    const { getThumbStyle: getThumbStyle, rootStyle: rootStyle, trackStyle: trackStyle, innerTrackStyle: innerTrackStyle } = (0, $acw62.useMemo)(()=>{
        const state2 = stateRef.current;
        const thumbRect = thumbSize != null ? thumbSize : {
            width: 0,
            height: 0
        };
        return (0, $5a5132e81e443d52$export$ffd58b7f6f099a57)({
            isReversed: isReversed,
            orientation: state2.orientation,
            thumbRects: [
                thumbRect
            ],
            thumbPercents: [
                thumbPercent
            ]
        });
    }, [
        isReversed,
        thumbSize,
        thumbPercent,
        stateRef
    ]);
    const focusThumb = (0, $acw62.useCallback)(()=>{
        const state2 = stateRef.current;
        if (state2.focusThumbOnChange) setTimeout(()=>{
            var _a2;
            return (_a2 = thumbRef.current) == null ? void 0 : _a2.focus();
        });
    }, [
        stateRef
    ]);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        const state2 = stateRef.current;
        focusThumb();
        if (state2.eventSource === "keyboard") onChangeEnd == null || onChangeEnd(state2.value);
    }, [
        value,
        onChangeEnd
    ]);
    function setValueFromPointer(event) {
        const nextValue = getValueFromPointer(event);
        if (nextValue != null && nextValue !== stateRef.current.value) setValue(nextValue);
    }
    (0, $479b6de02438f6b8$export$9ad22d853bfe2640)(rootRef, {
        onPanSessionStart (event) {
            const state2 = stateRef.current;
            if (!state2.isInteractive) return;
            setDragging(true);
            focusThumb();
            setValueFromPointer(event);
            onChangeStart == null || onChangeStart(state2.value);
        },
        onPanSessionEnd () {
            const state2 = stateRef.current;
            if (!state2.isInteractive) return;
            setDragging(false);
            onChangeEnd == null || onChangeEnd(state2.value);
        },
        onPan (event) {
            const state2 = stateRef.current;
            if (!state2.isInteractive) return;
            setValueFromPointer(event);
        }
    });
    const getRootProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ...htmlProps,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, rootRef),
            tabIndex: -1,
            "aria-disabled": (0, $fe0b3525ffcb2f27$export$91a6105db3d4be7b)(isDisabled),
            "data-focused": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(isFocused),
            style: {
                ...props2.style,
                ...rootStyle
            }
        };
    }, [
        htmlProps,
        isDisabled,
        isFocused,
        rootStyle
    ]);
    const getTrackProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, trackRef),
            id: trackId,
            "data-disabled": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(isDisabled),
            style: {
                ...props2.style,
                ...trackStyle
            }
        };
    }, [
        isDisabled,
        trackId,
        trackStyle
    ]);
    const getInnerTrackProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: ref,
            style: {
                ...props2.style,
                ...innerTrackStyle
            }
        };
    }, [
        innerTrackStyle
    ]);
    const getThumbProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, thumbRef),
            role: "slider",
            tabIndex: isInteractive ? 0 : void 0,
            id: thumbId,
            "data-active": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(isDragging),
            "aria-valuetext": valueText,
            "aria-valuemin": min,
            "aria-valuemax": max,
            "aria-valuenow": value,
            "aria-orientation": orientation,
            "aria-disabled": (0, $fe0b3525ffcb2f27$export$91a6105db3d4be7b)(isDisabled),
            "aria-readonly": (0, $fe0b3525ffcb2f27$export$91a6105db3d4be7b)(isReadOnly),
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabel ? void 0 : ariaLabelledBy,
            style: {
                ...props2.style,
                ...getThumbStyle(0)
            },
            onKeyDown: (0, $fe0b3525ffcb2f27$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onFocus: (0, $fe0b3525ffcb2f27$export$5bdd3f730ec2c47e)(props2.onFocus, ()=>setFocused(true)),
            onBlur: (0, $fe0b3525ffcb2f27$export$5bdd3f730ec2c47e)(props2.onBlur, ()=>setFocused(false))
        };
    }, [
        isInteractive,
        thumbId,
        isDragging,
        valueText,
        min,
        max,
        value,
        orientation,
        isDisabled,
        isReadOnly,
        ariaLabel,
        ariaLabelledBy,
        getThumbStyle,
        onKeyDown
    ]);
    const getMarkerProps = (0, $acw62.useCallback)((props2, ref = null)=>{
        const isInRange = !(props2.value < min || props2.value > max);
        const isHighlighted = value >= props2.value;
        const markerPercent = (0, $14fb920778dda918$export$83ce4bc8280540e6)(props2.value, min, max);
        const markerStyle = {
            position: "absolute",
            pointerEvents: "none",
            ...$b916c7d6c5956576$var$orient({
                orientation: orientation,
                vertical: {
                    bottom: isReversed ? `${100 - markerPercent}%` : `${markerPercent}%`
                },
                horizontal: {
                    left: isReversed ? `${100 - markerPercent}%` : `${markerPercent}%`
                }
            })
        };
        return {
            ...props2,
            ref: ref,
            role: "presentation",
            "aria-hidden": true,
            "data-disabled": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(!isInRange),
            "data-highlighted": (0, $fe0b3525ffcb2f27$export$5cc3b7b83e34ade7)(isHighlighted),
            style: {
                ...props2.style,
                ...markerStyle
            }
        };
    }, [
        isDisabled,
        isReversed,
        max,
        min,
        orientation,
        value
    ]);
    const getInputProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: ref,
            type: "hidden",
            value: value,
            name: name
        };
    }, [
        name,
        value
    ]);
    const state = {
        value: value,
        isFocused: isFocused,
        isDragging: isDragging
    };
    return {
        state: state,
        actions: actions,
        getRootProps: getRootProps,
        getTrackProps: getTrackProps,
        getInnerTrackProps: getInnerTrackProps,
        getThumbProps: getThumbProps,
        getMarkerProps: getMarkerProps,
        getInputProps: getInputProps
    };
}
function $b916c7d6c5956576$var$orient(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    return orientation === "vertical" ? vertical : horizontal;
}
function $b916c7d6c5956576$var$getDefaultValue(min, max) {
    return max < min ? min : min + (max - min) / 2;
}






"use client";
var [$ebf149b92c8644d9$export$d1709061ba4d965f, $ebf149b92c8644d9$export$65ed0685dbd65652] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "SliderContext",
    hookName: "useSliderContext",
    providerName: "<Slider />"
});
var [$ebf149b92c8644d9$var$SliderStylesProvider, $ebf149b92c8644d9$export$8db8bb766e6e05f9] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `SliderStylesContext`,
    hookName: `useSliderStyles`,
    providerName: "<Slider />"
});
var $ebf149b92c8644d9$export$472062a354075cee = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const sliderProps = {
        ...props,
        orientation: (_a = props == null ? void 0 : props.orientation) != null ? _a : "horizontal"
    };
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Slider", sliderProps);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(sliderProps);
    const { direction: direction } = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    ownProps.direction = direction;
    const { getInputProps: getInputProps, getRootProps: getRootProps, ...context } = (0, $b916c7d6c5956576$export$56b2c08e277f365)(ownProps);
    const rootProps = getRootProps();
    const inputProps = getInputProps({}, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ebf149b92c8644d9$export$d1709061ba4d965f, {
        value: context,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ebf149b92c8644d9$var$SliderStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                ...rootProps,
                className: (0, $fe0b3525ffcb2f27$export$a274e22fb40f762e)("chakra-slider", sliderProps.className),
                __css: styles.container,
                children: [
                    sliderProps.children,
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                        ...inputProps
                    })
                ]
            })
        })
    });
});
$ebf149b92c8644d9$export$472062a354075cee.displayName = "Slider";
var $ebf149b92c8644d9$export$2c1b491743890dec = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { getThumbProps: getThumbProps } = $ebf149b92c8644d9$export$65ed0685dbd65652();
    const styles = $ebf149b92c8644d9$export$8db8bb766e6e05f9();
    const thumbProps = getThumbProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...thumbProps,
        className: (0, $fe0b3525ffcb2f27$export$a274e22fb40f762e)("chakra-slider__thumb", props.className),
        __css: styles.thumb
    });
});
$ebf149b92c8644d9$export$2c1b491743890dec.displayName = "SliderThumb";
var $ebf149b92c8644d9$export$105594979f116971 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { getTrackProps: getTrackProps } = $ebf149b92c8644d9$export$65ed0685dbd65652();
    const styles = $ebf149b92c8644d9$export$8db8bb766e6e05f9();
    const trackProps = getTrackProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...trackProps,
        className: (0, $fe0b3525ffcb2f27$export$a274e22fb40f762e)("chakra-slider__track", props.className),
        __css: styles.track
    });
});
$ebf149b92c8644d9$export$105594979f116971.displayName = "SliderTrack";
var $ebf149b92c8644d9$export$73137d74280e0c3e = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { getInnerTrackProps: getInnerTrackProps } = $ebf149b92c8644d9$export$65ed0685dbd65652();
    const styles = $ebf149b92c8644d9$export$8db8bb766e6e05f9();
    const trackProps = getInnerTrackProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...trackProps,
        className: (0, $fe0b3525ffcb2f27$export$a274e22fb40f762e)("chakra-slider__filled-track", props.className),
        __css: styles.filledTrack
    });
});
$ebf149b92c8644d9$export$73137d74280e0c3e.displayName = "SliderFilledTrack";
var $ebf149b92c8644d9$export$6f85f6a3c5da6f62 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { getMarkerProps: getMarkerProps } = $ebf149b92c8644d9$export$65ed0685dbd65652();
    const styles = $ebf149b92c8644d9$export$8db8bb766e6e05f9();
    const markProps = getMarkerProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...markProps,
        className: (0, $fe0b3525ffcb2f27$export$a274e22fb40f762e)("chakra-slider__marker", props.className),
        __css: styles.mark
    });
});
$ebf149b92c8644d9$export$6f85f6a3c5da6f62.displayName = "SliderMark";





var $acw62 = parcelRequire("acw62");

"use client";
var $674e168e57385803$export$b5d5cf8927ab7262 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Switch2(props, ref) {
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Switch", props);
    const { spacing: spacing = "0.5rem", children: children, ...ownProps } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const { getIndicatorProps: getIndicatorProps, getInputProps: getInputProps, getCheckboxProps: getCheckboxProps, getRootProps: getRootProps, getLabelProps: getLabelProps } = (0, $28d15a1dba5741c2$export$e375f10ce42261c5)(ownProps);
    const containerStyles = (0, $acw62.useMemo)(()=>({
            display: "inline-block",
            position: "relative",
            verticalAlign: "middle",
            lineHeight: 0,
            ...styles.container
        }), [
        styles.container
    ]);
    const trackStyles = (0, $acw62.useMemo)(()=>({
            display: "inline-flex",
            flexShrink: 0,
            justifyContent: "flex-start",
            boxSizing: "content-box",
            cursor: "pointer",
            ...styles.track
        }), [
        styles.track
    ]);
    const labelStyles = (0, $acw62.useMemo)(()=>({
            userSelect: "none",
            marginStart: spacing,
            ...styles.label
        }), [
        spacing,
        styles.label
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).label, {
        ...getRootProps(),
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-switch", props.className),
        __css: containerStyles,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "chakra-switch__input",
                ...getInputProps({}, ref)
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
                ...getCheckboxProps(),
                className: "chakra-switch__track",
                __css: trackStyles,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
                    __css: styles.thumb,
                    className: "chakra-switch__thumb",
                    ...getIndicatorProps()
                })
            }),
            children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
                className: "chakra-switch__label",
                ...getLabelProps(),
                __css: labelStyles,
                children: children
            })
        ]
    });
});
$674e168e57385803$export$b5d5cf8927ab7262.displayName = "Switch";





"use client";
var [$e712627fd3084ab1$var$TableStylesProvider, $e712627fd3084ab1$export$2975c3d3b5f0252a] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `TableStylesContext`,
    errorMessage: `useTableStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Table />" `
});
var $e712627fd3084ab1$export$54ec01a60f47d33d = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Table", props);
    const { className: className, layout: layout, ...tableProps } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($e712627fd3084ab1$var$TableStylesProvider, {
        value: styles,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).table, {
            ref: ref,
            __css: {
                tableLayout: layout,
                ...styles.table
            },
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-table", className),
            ...tableProps
        })
    });
});
$e712627fd3084ab1$export$54ec01a60f47d33d.displayName = "Table";




"use client";
var $a9ae7f9b183649d4$export$35468a455d619eb3 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const { placement: placement = "bottom", ...rest } = props;
    const styles = (0, $e712627fd3084ab1$export$2975c3d3b5f0252a)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).caption, {
        ...rest,
        ref: ref,
        __css: {
            ...styles.caption,
            captionSide: placement
        }
    });
});
$a9ae7f9b183649d4$export$35468a455d619eb3.displayName = "TableCaption";




"use client";
var $09ab4539f9138387$export$e4d84274604d936d = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $e712627fd3084ab1$export$2975c3d3b5f0252a)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).tbody, {
        ...props,
        ref: ref,
        __css: styles.tbody
    });
});




"use client";
var $e16b8042114e7e75$export$8f04ceab90eac988 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(({ isNumeric: isNumeric, ...rest }, ref)=>{
    const styles = (0, $e712627fd3084ab1$export$2975c3d3b5f0252a)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).td, {
        ...rest,
        ref: ref,
        __css: styles.td,
        "data-is-numeric": isNumeric
    });
});




"use client";
var $04b44620787a4a6f$export$478f015b832c0fb2 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(({ isNumeric: isNumeric, ...rest }, ref)=>{
    const styles = (0, $e712627fd3084ab1$export$2975c3d3b5f0252a)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).th, {
        ...rest,
        ref: ref,
        __css: styles.th,
        "data-is-numeric": isNumeric
    });
});




"use client";
var $11888b100e285bcc$export$5de8fa06af5ae15a = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $e712627fd3084ab1$export$2975c3d3b5f0252a)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).thead, {
        ...props,
        ref: ref,
        __css: styles.thead
    });
});




"use client";
var $0a8ed41bdf8d449b$export$3be148b8762ca608 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $e712627fd3084ab1$export$2975c3d3b5f0252a)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).tr, {
        ...props,
        ref: ref,
        __css: styles.tr
    });
});











var $acw62 = parcelRequire("acw62");
"use client";
var [$48a6506e98eeba08$export$29ffb0a76b0529f5, $48a6506e98eeba08$export$41df96b51c5f5358, $48a6506e98eeba08$export$82af15abb0e12d09, $48a6506e98eeba08$export$48a1e112587310fb] = (0, $22443c9383de2d2c$export$126c4100f8947d7)();
function $48a6506e98eeba08$export$d2589202ac9c89c3(props) {
    var _a;
    const { defaultIndex: defaultIndex, onChange: onChange, index: index, isManual: isManual, isLazy: isLazy, lazyBehavior: lazyBehavior = "unmount", orientation: orientation = "horizontal", direction: direction = "ltr", ...htmlProps } = props;
    const [focusedIndex, setFocusedIndex] = (0, $acw62.useState)(defaultIndex != null ? defaultIndex : 0);
    const [selectedIndex, setSelectedIndex] = (0, $4795b7ced84aa3c2$export$6f32135080cb4c3)({
        defaultValue: defaultIndex != null ? defaultIndex : 0,
        value: index,
        onChange: onChange
    });
    (0, $acw62.useEffect)(()=>{
        if (index != null) setFocusedIndex(index);
    }, [
        index
    ]);
    const descendants = $48a6506e98eeba08$export$82af15abb0e12d09();
    const uuid = (0, $acw62.useId)();
    const uid = (_a = props.id) != null ? _a : uuid;
    const id = `tabs-${uid}`;
    return {
        id: id,
        selectedIndex: selectedIndex,
        focusedIndex: focusedIndex,
        setSelectedIndex: setSelectedIndex,
        setFocusedIndex: setFocusedIndex,
        isManual: isManual,
        isLazy: isLazy,
        lazyBehavior: lazyBehavior,
        orientation: orientation,
        descendants: descendants,
        direction: direction,
        htmlProps: htmlProps
    };
}
var [$48a6506e98eeba08$export$aea4e5437b3b752e, $48a6506e98eeba08$export$5c3d36c3adf0ba92] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "TabsContext",
    errorMessage: "useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />"
});
function $48a6506e98eeba08$export$773e389e644c5874(props) {
    const { focusedIndex: focusedIndex, orientation: orientation, direction: direction } = $48a6506e98eeba08$export$5c3d36c3adf0ba92();
    const descendants = $48a6506e98eeba08$export$41df96b51c5f5358();
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        const nextTab = ()=>{
            var _a;
            const next = descendants.nextEnabled(focusedIndex);
            if (next) (_a = next.node) == null || _a.focus();
        };
        const prevTab = ()=>{
            var _a;
            const prev = descendants.prevEnabled(focusedIndex);
            if (prev) (_a = prev.node) == null || _a.focus();
        };
        const firstTab = ()=>{
            var _a;
            const first = descendants.firstEnabled();
            if (first) (_a = first.node) == null || _a.focus();
        };
        const lastTab = ()=>{
            var _a;
            const last = descendants.lastEnabled();
            if (last) (_a = last.node) == null || _a.focus();
        };
        const isHorizontal = orientation === "horizontal";
        const isVertical = orientation === "vertical";
        const eventKey = event.key;
        const ArrowStart = direction === "ltr" ? "ArrowLeft" : "ArrowRight";
        const ArrowEnd = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
        const keyMap = {
            [ArrowStart]: ()=>isHorizontal && prevTab(),
            [ArrowEnd]: ()=>isHorizontal && nextTab(),
            ArrowDown: ()=>isVertical && nextTab(),
            ArrowUp: ()=>isVertical && prevTab(),
            Home: firstTab,
            End: lastTab
        };
        const action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            action(event);
        }
    }, [
        descendants,
        focusedIndex,
        orientation,
        direction
    ]);
    return {
        ...props,
        role: "tablist",
        "aria-orientation": orientation,
        onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    };
}
function $48a6506e98eeba08$export$fdf4756d5b8ef90a(props) {
    const { isDisabled: isDisabled = false, isFocusable: isFocusable = false, ...htmlProps } = props;
    const { setSelectedIndex: setSelectedIndex, isManual: isManual, id: id, setFocusedIndex: setFocusedIndex, selectedIndex: selectedIndex } = $48a6506e98eeba08$export$5c3d36c3adf0ba92();
    const { index: index, register: register } = $48a6506e98eeba08$export$48a1e112587310fb({
        disabled: isDisabled && !isFocusable
    });
    const isSelected = index === selectedIndex;
    const onClick = ()=>{
        setSelectedIndex(index);
    };
    const onFocus = ()=>{
        setFocusedIndex(index);
        const isDisabledButFocusable = isDisabled && isFocusable;
        const shouldSelect = !isManual && !isDisabledButFocusable;
        if (shouldSelect) setSelectedIndex(index);
    };
    const clickableProps = (0, $8dec279e09834157$export$ed213cc82e426b1a)({
        ...htmlProps,
        ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(register, props.ref),
        isDisabled: isDisabled,
        isFocusable: isFocusable,
        onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props.onClick, onClick)
    });
    const type = "button";
    return {
        ...clickableProps,
        id: $48a6506e98eeba08$var$makeTabId(id, index),
        role: "tab",
        tabIndex: isSelected ? 0 : -1,
        type: type,
        "aria-selected": isSelected,
        "aria-controls": $48a6506e98eeba08$var$makeTabPanelId(id, index),
        onFocus: isDisabled ? void 0 : (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props.onFocus, onFocus)
    };
}
var [$48a6506e98eeba08$var$TabPanelProvider, $48a6506e98eeba08$var$useTabPanelContext] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({});
function $48a6506e98eeba08$export$a7a84e09564ff6eb(props) {
    const context = $48a6506e98eeba08$export$5c3d36c3adf0ba92();
    const { id: id, selectedIndex: selectedIndex } = context;
    const validChildren = (0, $197fffec5094e9ee$export$b2c43d7d050b2e63)(props.children);
    const children = validChildren.map((child, index)=>(0, $acw62.createElement)($48a6506e98eeba08$var$TabPanelProvider, {
            key: index,
            value: {
                isSelected: index === selectedIndex,
                id: $48a6506e98eeba08$var$makeTabPanelId(id, index),
                tabId: $48a6506e98eeba08$var$makeTabId(id, index),
                selectedIndex: selectedIndex
            }
        }, child));
    return {
        ...props,
        children: children
    };
}
function $48a6506e98eeba08$export$fae0121b5afe572d(props) {
    const { children: children, ...htmlProps } = props;
    const { isLazy: isLazy, lazyBehavior: lazyBehavior } = $48a6506e98eeba08$export$5c3d36c3adf0ba92();
    const { isSelected: isSelected, id: id, tabId: tabId } = $48a6506e98eeba08$var$useTabPanelContext();
    const hasBeenSelected = (0, $acw62.useRef)(false);
    if (isSelected) hasBeenSelected.current = true;
    const shouldRenderChildren = (0, $d3159b9260b16e67$export$76655e7dd9ffc0ba)({
        wasSelected: hasBeenSelected.current,
        isSelected: isSelected,
        enabled: isLazy,
        mode: lazyBehavior
    });
    return {
        // Puts the tabpanel in the page `Tab` sequence.
        tabIndex: 0,
        ...htmlProps,
        children: shouldRenderChildren ? children : null,
        role: "tabpanel",
        "aria-labelledby": tabId,
        hidden: !isSelected,
        id: id
    };
}
function $48a6506e98eeba08$export$99e5024a51e009d8() {
    const context = $48a6506e98eeba08$export$5c3d36c3adf0ba92();
    const descendants = $48a6506e98eeba08$export$41df96b51c5f5358();
    const { selectedIndex: selectedIndex, orientation: orientation } = context;
    const isHorizontal = orientation === "horizontal";
    const isVertical = orientation === "vertical";
    const [rect, setRect] = (0, $acw62.useState)(()=>{
        if (isHorizontal) return {
            left: 0,
            width: 0
        };
        if (isVertical) return {
            top: 0,
            height: 0
        };
        return void 0;
    });
    const [hasMeasured, setHasMeasured] = (0, $acw62.useState)(false);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (selectedIndex == null) return;
        const tab = descendants.item(selectedIndex);
        if (tab == null) return;
        if (isHorizontal) setRect({
            left: tab.node.offsetLeft,
            width: tab.node.offsetWidth
        });
        if (isVertical) setRect({
            top: tab.node.offsetTop,
            height: tab.node.offsetHeight
        });
        const id = requestAnimationFrame(()=>{
            setHasMeasured(true);
        });
        return ()=>{
            if (id) cancelAnimationFrame(id);
        };
    }, [
        selectedIndex,
        isHorizontal,
        isVertical,
        descendants
    ]);
    return {
        position: "absolute",
        transitionProperty: "left, right, top, bottom, height, width",
        transitionDuration: hasMeasured ? "200ms" : "0ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        ...rect
    };
}
function $48a6506e98eeba08$var$makeTabId(id, index) {
    return `${id}--tab-${index}`;
}
function $48a6506e98eeba08$var$makeTabPanelId(id, index) {
    return `${id}--tabpanel-${index}`;
}






var $acw62 = parcelRequire("acw62");

"use client";
var [$ebab1f9480413523$var$TabsStylesProvider, $ebab1f9480413523$export$ab005bc413ad22f0] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `TabsStylesContext`,
    errorMessage: `useTabsStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tabs />" `
});
var $ebab1f9480413523$export$b2539bed5023c21c = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Tabs2(props, ref) {
    const styles = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Tabs", props);
    const { children: children, className: className, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const { htmlProps: htmlProps, descendants: descendants, ...ctx } = (0, $48a6506e98eeba08$export$d2589202ac9c89c3)(rest);
    const context = (0, $acw62.useMemo)(()=>ctx, [
        ctx
    ]);
    const { isFitted: _, ...rootProps } = htmlProps;
    const tabsStyles = {
        position: "relative",
        ...styles.root
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $48a6506e98eeba08$export$29ffb0a76b0529f5), {
        value: descendants,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $48a6506e98eeba08$export$aea4e5437b3b752e), {
            value: context,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ebab1f9480413523$var$TabsStylesProvider, {
                value: styles,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                    className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-tabs", className),
                    ref: ref,
                    ...rootProps,
                    __css: tabsStyles,
                    children: children
                })
            })
        })
    });
});
$ebab1f9480413523$export$b2539bed5023c21c.displayName = "Tabs";






"use client";
var $1a8ec37cc1f6cf4a$export$3e41faf802a29e71 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function Tab2(props, ref) {
    const styles = (0, $ebab1f9480413523$export$ab005bc413ad22f0)();
    const tabProps = (0, $48a6506e98eeba08$export$fdf4756d5b8ef90a)({
        ...props,
        ref: ref
    });
    const tabStyles = {
        outline: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...styles.tab
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).button, {
        ...tabProps,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-tabs__tab", props.className),
        __css: tabStyles
    });
});
$1a8ec37cc1f6cf4a$export$3e41faf802a29e71.displayName = "Tab";






"use client";
var $55182a1454ef598e$export$e51a686c67fdaa2d = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function TabList2(props, ref) {
    const tablistProps = (0, $48a6506e98eeba08$export$773e389e644c5874)({
        ...props,
        ref: ref
    });
    const styles = (0, $ebab1f9480413523$export$ab005bc413ad22f0)();
    const tablistStyles = {
        display: "flex",
        ...styles.tablist
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...tablistProps,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-tabs__tablist", props.className),
        __css: tablistStyles
    });
});
$55182a1454ef598e$export$e51a686c67fdaa2d.displayName = "TabList";






"use client";
var $4febbf79f6d1a688$export$3d96ec278d3efce4 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function TabPanel2(props, ref) {
    const panelProps = (0, $48a6506e98eeba08$export$fae0121b5afe572d)({
        ...props,
        ref: ref
    });
    const styles = (0, $ebab1f9480413523$export$ab005bc413ad22f0)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        outline: "0",
        ...panelProps,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-tabs__tab-panel", props.className),
        __css: styles.tabpanel
    });
});
$4febbf79f6d1a688$export$3d96ec278d3efce4.displayName = "TabPanel";






"use client";
var $291041ce3d9db291$export$5dae8d435677f210 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)(function TabPanels2(props, ref) {
    const panelsProps = (0, $48a6506e98eeba08$export$a7a84e09564ff6eb)(props);
    const styles = (0, $ebab1f9480413523$export$ab005bc413ad22f0)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
        ...panelsProps,
        width: "100%",
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-tabs__tab-panels", props.className),
        __css: styles.tabpanels
    });
});
$291041ce3d9db291$export$5dae8d435677f210.displayName = "TabPanels";





"use client";
// ../../utilities/object-utils/src/omit.ts
function $0dd05211a0356948$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
var $0dd05211a0356948$var$omitted = [
    "h",
    "minH",
    "height",
    "minHeight"
];
var $0dd05211a0356948$export$379139ebc1c2b235 = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Textarea", props);
    const { className: className, rows: rows, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const textareaProps = (0, $95e8035d7d1d6064$export$62ecd8ad1bbe1a18)(rest);
    const textareaStyles = rows ? $0dd05211a0356948$var$omit(styles, $0dd05211a0356948$var$omitted) : styles;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).textarea, {
        ref: ref,
        rows: rows,
        ...textareaProps,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-textarea", className),
        __css: textareaStyles
    });
});
$0dd05211a0356948$export$379139ebc1c2b235.displayName = "Textarea";

"use client";
// src/tooltip.transition.tsx
var $239d5462a58a5164$export$dcdf75081b88279d = {
    exit: {
        scale: 0.85,
        opacity: 0,
        transition: {
            opacity: {
                duration: 0.15,
                easings: "easeInOut"
            },
            scale: {
                duration: 0.2,
                easings: "easeInOut"
            }
        }
    },
    enter: {
        scale: 1,
        opacity: 1,
        transition: {
            opacity: {
                easings: "easeOut",
                duration: 0.2
            },
            scale: {
                duration: 0.2,
                ease: [
                    0.175,
                    0.885,
                    0.4,
                    1.1
                ]
            }
        }
    }
};









var $acw62 = parcelRequire("acw62");
"use client";
var $6165af4287c9cf3b$var$getDoc = (ref)=>{
    var _a;
    return ((_a = ref.current) == null ? void 0 : _a.ownerDocument) || document;
};
var $6165af4287c9cf3b$var$getWin = (ref)=>{
    var _a, _b;
    return ((_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) == null ? void 0 : _b.defaultView) || window;
};
function $6165af4287c9cf3b$export$1c4b08e0eca38426(props = {}) {
    const { openDelay: openDelay = 0, closeDelay: closeDelay = 0, closeOnClick: closeOnClick = true, closeOnMouseDown: closeOnMouseDown, closeOnScroll: closeOnScroll, closeOnPointerDown: closeOnPointerDown = closeOnMouseDown, closeOnEsc: closeOnEsc = true, onOpen: onOpenProp, onClose: onCloseProp, placement: placement, id: id, isOpen: isOpenProp, defaultIsOpen: defaultIsOpen, arrowSize: arrowSize = 10, arrowShadowColor: arrowShadowColor, arrowPadding: arrowPadding, modifiers: modifiers, isDisabled: isDisabled, gutter: gutter, offset: offset, direction: direction, ...htmlProps } = props;
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $7bea845a3dd58b1a$export$6e3e27031a30522f)({
        isOpen: isOpenProp,
        defaultIsOpen: defaultIsOpen,
        onOpen: onOpenProp,
        onClose: onCloseProp
    });
    const { referenceRef: referenceRef, getPopperProps: getPopperProps, getArrowInnerProps: getArrowInnerProps, getArrowProps: getArrowProps } = (0, $5f2d029a715100c2$export$f4d5bf230a36dd6e)({
        enabled: isOpen,
        placement: placement,
        arrowPadding: arrowPadding,
        modifiers: modifiers,
        gutter: gutter,
        offset: offset,
        direction: direction
    });
    const uuid = (0, $acw62.useId)();
    const uid = id != null ? id : uuid;
    const tooltipId = `tooltip-${uid}`;
    const ref = (0, $acw62.useRef)(null);
    const enterTimeout = (0, $acw62.useRef)();
    const clearEnterTimeout = (0, $acw62.useCallback)(()=>{
        if (enterTimeout.current) {
            clearTimeout(enterTimeout.current);
            enterTimeout.current = void 0;
        }
    }, []);
    const exitTimeout = (0, $acw62.useRef)();
    const clearExitTimeout = (0, $acw62.useCallback)(()=>{
        if (exitTimeout.current) {
            clearTimeout(exitTimeout.current);
            exitTimeout.current = void 0;
        }
    }, []);
    const closeNow = (0, $acw62.useCallback)(()=>{
        clearExitTimeout();
        onClose();
    }, [
        onClose,
        clearExitTimeout
    ]);
    const dispatchCloseEvent = $6165af4287c9cf3b$var$useCloseEvent(ref, closeNow);
    const openWithDelay = (0, $acw62.useCallback)(()=>{
        if (!isDisabled && !enterTimeout.current) {
            if (isOpen) dispatchCloseEvent();
            const win = $6165af4287c9cf3b$var$getWin(ref);
            enterTimeout.current = win.setTimeout(onOpen, openDelay);
        }
    }, [
        dispatchCloseEvent,
        isDisabled,
        isOpen,
        onOpen,
        openDelay
    ]);
    const closeWithDelay = (0, $acw62.useCallback)(()=>{
        clearEnterTimeout();
        const win = $6165af4287c9cf3b$var$getWin(ref);
        exitTimeout.current = win.setTimeout(closeNow, closeDelay);
    }, [
        closeDelay,
        closeNow,
        clearEnterTimeout
    ]);
    const onClick = (0, $acw62.useCallback)(()=>{
        if (isOpen && closeOnClick) closeWithDelay();
    }, [
        closeOnClick,
        closeWithDelay,
        isOpen
    ]);
    const onPointerDown = (0, $acw62.useCallback)(()=>{
        if (isOpen && closeOnPointerDown) closeWithDelay();
    }, [
        closeOnPointerDown,
        closeWithDelay,
        isOpen
    ]);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (isOpen && event.key === "Escape") closeWithDelay();
    }, [
        isOpen,
        closeWithDelay
    ]);
    (0, $3bc081da2876e6e9$export$7080b3e976bc91ab)(()=>$6165af4287c9cf3b$var$getDoc(ref), "keydown", closeOnEsc ? onKeyDown : void 0);
    (0, $3bc081da2876e6e9$export$7080b3e976bc91ab)(()=>{
        if (!closeOnScroll) return null;
        const node = ref.current;
        if (!node) return null;
        const scrollParent = (0, $7edd2f86c6e30f94$export$cfa2225e87938781)(node);
        return scrollParent.localName === "body" ? $6165af4287c9cf3b$var$getWin(ref) : scrollParent;
    }, "scroll", ()=>{
        if (isOpen && closeOnScroll) closeNow();
    }, {
        passive: true,
        capture: true
    });
    (0, $acw62.useEffect)(()=>{
        if (!isDisabled) return;
        clearEnterTimeout();
        if (isOpen) onClose();
    }, [
        isDisabled,
        isOpen,
        onClose,
        clearEnterTimeout
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            clearEnterTimeout();
            clearExitTimeout();
        };
    }, [
        clearEnterTimeout,
        clearExitTimeout
    ]);
    (0, $3bc081da2876e6e9$export$7080b3e976bc91ab)(()=>ref.current, "pointerleave", closeWithDelay);
    const getTriggerProps = (0, $acw62.useCallback)((props2 = {}, _ref = null)=>{
        const triggerProps = {
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, _ref, referenceRef),
            onPointerEnter: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onPointerEnter, (e)=>{
                if (e.pointerType === "touch") return;
                openWithDelay();
            }),
            onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onClick, onClick),
            onPointerDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onPointerDown, onPointerDown),
            onFocus: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onFocus, openWithDelay),
            onBlur: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onBlur, closeWithDelay),
            "aria-describedby": isOpen ? tooltipId : void 0
        };
        return triggerProps;
    }, [
        openWithDelay,
        closeWithDelay,
        onPointerDown,
        isOpen,
        tooltipId,
        onClick,
        referenceRef
    ]);
    const getTooltipPositionerProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>getPopperProps({
            ...props2,
            style: {
                ...props2.style,
                [(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowSize.var]: arrowSize ? `${arrowSize}px` : void 0,
                [(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowShadowColor.var]: arrowShadowColor
            }
        }, forwardedRef), [
        getPopperProps,
        arrowSize,
        arrowShadowColor
    ]);
    const getTooltipProps = (0, $acw62.useCallback)((props2 = {}, ref2 = null)=>{
        const styles = {
            ...props2.style,
            position: "relative",
            transformOrigin: (0, $49cad064bf4d553f$export$fd62969fb0b7081c).transformOrigin.varRef
        };
        return {
            ref: ref2,
            ...htmlProps,
            ...props2,
            id: tooltipId,
            role: "tooltip",
            style: styles
        };
    }, [
        htmlProps,
        tooltipId
    ]);
    return {
        isOpen: isOpen,
        show: openWithDelay,
        hide: closeWithDelay,
        getTriggerProps: getTriggerProps,
        getTooltipProps: getTooltipProps,
        getTooltipPositionerProps: getTooltipPositionerProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps
    };
}
var $6165af4287c9cf3b$var$closeEventName = "chakra-ui:close-tooltip";
function $6165af4287c9cf3b$var$useCloseEvent(ref, close) {
    (0, $acw62.useEffect)(()=>{
        const doc = $6165af4287c9cf3b$var$getDoc(ref);
        doc.addEventListener($6165af4287c9cf3b$var$closeEventName, close);
        return ()=>doc.removeEventListener($6165af4287c9cf3b$var$closeEventName, close);
    }, [
        close,
        ref
    ]);
    return ()=>{
        const doc = $6165af4287c9cf3b$var$getDoc(ref);
        const win = $6165af4287c9cf3b$var$getWin(ref);
        doc.dispatchEvent(new win.CustomEvent($6165af4287c9cf3b$var$closeEventName));
    };
}







var $acw62 = parcelRequire("acw62");

"use client";
// ../../utilities/object-utils/src/omit.ts
function $00c5933d235d85a4$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
// ../../utilities/object-utils/src/pick.ts
function $00c5933d235d85a4$var$pick(object, keysToPick) {
    const result = {};
    for (const key of keysToPick)if (key in object) result[key] = object[key];
    return result;
}
var $00c5933d235d85a4$var$MotionDiv = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div);
var $00c5933d235d85a4$export$28c660c63b792dea = (0, $b271d58d4d1ccb07$export$257a8862b851cb5b)((props, ref)=>{
    var _a, _b;
    const styles = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Tooltip", props);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const theme = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    const { children: children, label: label, shouldWrapChildren: shouldWrapChildren, "aria-label": ariaLabel, hasArrow: hasArrow, bg: bg, portalProps: portalProps, background: background, backgroundColor: backgroundColor, bgColor: bgColor, motionProps: motionProps, ...rest } = ownProps;
    const userDefinedBg = (_b = (_a = background != null ? background : backgroundColor) != null ? _a : bg) != null ? _b : bgColor;
    if (userDefinedBg) {
        styles.bg = userDefinedBg;
        const bgVar = (0, $47a6d9fbbf7ee42d$export$93c8e06b7014dc33)(theme, "colors", userDefinedBg);
        styles[(0, $49cad064bf4d553f$export$fd62969fb0b7081c).arrowBg.var] = bgVar;
    }
    const tooltip = (0, $6165af4287c9cf3b$export$1c4b08e0eca38426)({
        ...rest,
        direction: theme.direction
    });
    const shouldWrap = typeof children === "string" || shouldWrapChildren;
    let trigger;
    if (shouldWrap) trigger = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
        display: "inline-block",
        tabIndex: 0,
        ...tooltip.getTriggerProps(),
        children: children
    });
    else {
        const child = (0, $acw62.Children).only(children);
        trigger = (0, $acw62.cloneElement)(child, tooltip.getTriggerProps(child.props, child.ref));
    }
    const hasAriaLabel = !!ariaLabel;
    const _tooltipProps = tooltip.getTooltipProps({}, ref);
    const tooltipProps = hasAriaLabel ? $00c5933d235d85a4$var$omit(_tooltipProps, [
        "role",
        "id"
    ]) : _tooltipProps;
    const srOnlyProps = $00c5933d235d85a4$var$pick(_tooltipProps, [
        "role",
        "id"
    ]);
    if (!label) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            trigger,
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                children: tooltip.isOpen && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b71276780b6a43df$export$602eac185826482c), {
                    ...portalProps,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                        ...tooltip.getTooltipPositionerProps(),
                        __css: {
                            zIndex: styles.zIndex,
                            pointerEvents: "none"
                        },
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($00c5933d235d85a4$var$MotionDiv, {
                            variants: (0, $239d5462a58a5164$export$dcdf75081b88279d),
                            initial: "exit",
                            animate: "enter",
                            exit: "exit",
                            ...motionProps,
                            ...tooltipProps,
                            __css: styles,
                            children: [
                                label,
                                hasAriaLabel && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).span, {
                                    srOnly: true,
                                    ...srOnlyProps,
                                    children: ariaLabel
                                }),
                                hasArrow && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                                    "data-popper-arrow": true,
                                    className: "chakra-tooltip__arrow-wrapper",
                                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4).div, {
                                        "data-popper-arrow-inner": true,
                                        className: "chakra-tooltip__arrow",
                                        __css: {
                                            bg: styles.bg
                                        }
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
});
$00c5933d235d85a4$export$28c660c63b792dea.displayName = "Tooltip";



var $ee5oK = parcelRequire("ee5oK");

var $acw62 = parcelRequire("acw62");

var $0422a6ce4ea03acc$var$NS = Object.defineProperty;
var $0422a6ce4ea03acc$var$PS = (r, a, o)=>a in r ? $0422a6ce4ea03acc$var$NS(r, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }) : r[a] = o;
var $0422a6ce4ea03acc$var$Nu = (r, a, o)=>($0422a6ce4ea03acc$var$PS(r, typeof a != "symbol" ? a + "" : a, o), o);
var $0422a6ce4ea03acc$var$Pu = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $0422a6ce4ea03acc$var$zo(r) {
    return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var $0422a6ce4ea03acc$var$zp = {
    exports: {}
}, $0422a6ce4ea03acc$var$go = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0422a6ce4ea03acc$var$Ny;
function $0422a6ce4ea03acc$var$Yk() {
    if ($0422a6ce4ea03acc$var$Ny) return $0422a6ce4ea03acc$var$go;
    $0422a6ce4ea03acc$var$Ny = 1;
    var r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))), a = Symbol.for("react.element"), o = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, i = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
    };
    function C(v, y, L) {
        var M, E = {}, k = null, _ = null;
        L !== void 0 && (k = "" + L), y.key !== void 0 && (k = "" + y.key), y.ref !== void 0 && (_ = y.ref);
        for(M in y)s.call(y, M) && !p.hasOwnProperty(M) && (E[M] = y[M]);
        if (v && v.defaultProps) for(M in y = v.defaultProps, y)E[M] === void 0 && (E[M] = y[M]);
        return {
            $$typeof: a,
            type: v,
            key: k,
            ref: _,
            props: E,
            _owner: i.current
        };
    }
    return $0422a6ce4ea03acc$var$go.Fragment = o, $0422a6ce4ea03acc$var$go.jsx = C, $0422a6ce4ea03acc$var$go.jsxs = C, $0422a6ce4ea03acc$var$go;
}
var $0422a6ce4ea03acc$var$yo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0422a6ce4ea03acc$var$Py;
function $0422a6ce4ea03acc$var$Wk() {
    return $0422a6ce4ea03acc$var$Py || ($0422a6ce4ea03acc$var$Py = 1), $0422a6ce4ea03acc$var$yo;
}
$0422a6ce4ea03acc$var$zp.exports = $0422a6ce4ea03acc$var$Yk();
var $0422a6ce4ea03acc$var$x = $0422a6ce4ea03acc$var$zp.exports;
const $0422a6ce4ea03acc$var$Qk = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.257 0h15.485C17.434 0 18 .566 18 1.257v15.486c0 .692-.566 1.257-1.258 1.257H1.257A1.26 1.26 0 010 16.743V1.257C0 .566.566 0 1.257 0z",
        fill: "#155196"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.055 4.195a1.336 1.336 0 001.201-1.326c0-.733-.597-1.33-1.33-1.33a1.333 1.333 0 00-1.165 1.975l.475 6.671 4.883.002 2.003 4.692 2.629-1.031-.407-.97-1.472.531-1.938-4.473-4.54.03-.062-.845 3.287.001v-1.25l-3.412-.001-.152-2.676z",
        fill: "#fff"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.967 13.763a4.973 4.973 0 01-4.39 2.702 4.917 4.917 0 01-4.907-4.907c0-1.897 1.15-3.66 2.867-4.442l.111 1.449a3.571 3.571 0 00-1.641 3.004c0 1.96 1.6 3.559 3.56 3.559 1.794 0 3.323-1.377 3.532-3.143l.868 1.778z",
        fill: "#fff"
    })), $0422a6ce4ea03acc$var$qk = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.257 0h15.485C17.434 0 18 .566 18 1.257v15.485c0 .692-.566 1.258-1.258 1.258H1.257A1.26 1.26 0 010 16.742V1.257C0 .566.566 0 1.257 0z",
        fill: "#EFEDEB"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.055 4.194A1.336 1.336 0 008.256 2.87c0-.733-.597-1.33-1.33-1.33a1.333 1.333 0 00-1.165 1.975l.475 6.67 4.883.003 2.003 4.692 2.629-1.031-.407-.97-1.472.531-1.938-4.473-4.54.03-.062-.845 3.287.001v-1.25l-3.412-.001-.152-2.677z",
        fill: "#000"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.967 13.762a4.973 4.973 0 01-4.39 2.703 4.917 4.917 0 01-4.907-4.907c0-1.897 1.15-3.66 2.867-4.443l.111 1.45a3.571 3.571 0 00-1.641 3.003c0 1.96 1.6 3.56 3.56 3.56 1.794 0 3.323-1.377 3.532-3.143l.868 1.777z",
        fill: "#000"
    })), $0422a6ce4ea03acc$var$Gk = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM10 14.17L16.59 7.58L18 9L10 17L6 13L7.41 11.59L10 14.17Z"
    })), $0422a6ce4ea03acc$var$Xk = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    })), $0422a6ce4ea03acc$var$Kk = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM16 9V19H8V9H16ZM6 7H18V19C18 20.1 17.1 21 16 21H8C6.9 21 6 20.1 6 19V7Z"
    })), $0422a6ce4ea03acc$var$Jk = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V15H5V19H19V5H5V9H3V5C3 3.9 3.89 3 5 3ZM11.5 17L10.09 15.59L12.67 13H3V11H12.67L10.09 8.41L11.5 7L16.5 12L11.5 17Z"
    })), $0422a6ce4ea03acc$var$eT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19V17H13V19H11ZM14.17 12.17L15.07 11.25C15.64 10.68 16 9.88 16 9C16 6.79 14.21 5 12 5C9.79 5 8 6.79 8 9H10C10 7.9 10.9 7 12 7C13.1 7 14 7.9 14 9C14 9.55 13.78 10.05 13.41 10.41L12.17 11.67C11.45 12.4 11 13.4 11 14.5V15H13C13 13.5 13.45 12.9 14.17 12.17Z"
    })), $0422a6ce4ea03acc$var$tT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM13 16V18H11V16H13ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM8 10C8 7.79 9.79 6 12 6C14.21 6 16 7.79 16 10C16 11.2829 15.21 11.9733 14.4408 12.6455C13.711 13.2833 13 13.9046 13 15H11C11 13.1787 11.9421 12.4566 12.7704 11.8217C13.4202 11.3236 14 10.8792 14 10C14 8.9 13.1 8 12 8C10.9 8 10 8.9 10 10H8Z"
    })), $0422a6ce4ea03acc$var$nT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        id: "icon/action/home_24px",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 12.5H2L12 3.5L22 12.5H19V20.5H13V14.5H11V20.5H5V12.5ZM17 10.69L12 6.19L7 10.69V18.5H9V12.5H15V18.5H17V10.69Z"
    })), $0422a6ce4ea03acc$var$rT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM14 8C14 6.9 13.1 6 12 6C10.9 6 10 6.9 10 8C10 9.1 10.9 10 12 10C13.1 10 14 9.1 14 8ZM18 17C17.8 16.29 14.7 15 12 15C9.3 15 6.2 16.29 6 17.01V18H18V17ZM4 17C4 14.34 9.33 13 12 13C14.67 13 20 14.34 20 17V20H4V17Z"
    })), $0422a6ce4ea03acc$var$aT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8ZM4 17C4 14.34 9.33 13 12 13C14.67 13 20 14.34 20 17V20H4V17Z"
    })), $0422a6ce4ea03acc$var$iT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 5V19H19V12H21V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.89 3 5 3H12V5H5ZM14 5V3H21V10H19V6.41L9.17 16.24L7.76 14.83L17.59 5H14Z"
    })), $0422a6ce4ea03acc$var$oT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C8.14 2 5 5.14 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.14 15.86 2 12 2ZM9 21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9V21ZM14 13.7L14.85 13.1C16.2 12.16 17 10.63 17 9C17 6.24 14.76 4 12 4C9.24 4 7 6.24 7 9C7 10.63 7.8 12.16 9.15 13.1L10 13.7V16H14V13.7Z"
    })), $0422a6ce4ea03acc$var$lT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 8.5H18C19.1 8.5 20 9.4 20 10.5V20.5C20 21.6 19.1 22.5 18 22.5H6C4.9 22.5 4 21.6 4 20.5V10.5C4 9.4 4.9 8.5 6 8.5H7V6.5C7 3.74 9.24 1.5 12 1.5C14.76 1.5 17 3.74 17 6.5V8.5ZM12 3.5C10.34 3.5 9 4.84 9 6.5V8.5H15V6.5C15 4.84 13.66 3.5 12 3.5ZM6 20.5V10.5H18V20.5H6ZM14 15.5C14 16.6 13.1 17.5 12 17.5C10.9 17.5 10 16.6 10 15.5C10 14.4 10.9 13.5 12 13.5C13.1 13.5 14 14.4 14 15.5Z"
    })), $0422a6ce4ea03acc$var$sT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        id: "icon/action/payment_24px",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM4 8H20V6H4V8Z"
    })), $0422a6ce4ea03acc$var$uT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 3H13V13H11V3ZM16.41 6.59L17.83 5.17C19.77 6.82 21 9.26 21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 9.26 4.23 6.82 6.17 5.17L7.58 6.58C6.01 7.86 5 9.81 5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12C19 9.81 17.99 7.86 16.41 6.59Z"
    })), $0422a6ce4ea03acc$var$cT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M10 4H14V8H10V4ZM4 16H8V20H4V16ZM4 10H8V14H4V10ZM4 4H8V8H4V4ZM14 12.42V10H10V14H12.42L14 12.42ZM20.88 11.29L19.71 10.12C19.55 9.96 19.29 9.96 19.13 10.12L18.25 11L20 12.75L20.88 11.87C21.04 11.71 21.04 11.45 20.88 11.29ZM11 18.25V20H12.75L19.42 13.33L17.67 11.58L11 18.25ZM16 4H20V8H16V4Z"
    })), $0422a6ce4ea03acc$var$dT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        id: "icon/action/search_24px",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.9659 14.2549H15.7559L20.7459 19.2549L19.2559 20.7449L14.2559 15.7549V14.9649L13.9859 14.6849C12.8459 15.6649 11.3659 16.2549 9.75586 16.2549C6.16586 16.2549 3.25586 13.3449 3.25586 9.75488C3.25586 6.16488 6.16586 3.25488 9.75586 3.25488C13.3459 3.25488 16.2559 6.16488 16.2559 9.75488C16.2559 11.3649 15.6659 12.8449 14.6859 13.9849L14.9659 14.2549ZM5.25586 9.75488C5.25586 12.2449 7.26586 14.2549 9.75586 14.2549C12.2459 14.2549 14.2559 12.2449 14.2559 9.75488C14.2559 7.26488 12.2459 5.25488 9.75586 5.25488C7.26586 5.25488 5.25586 7.26488 5.25586 9.75488Z"
    })), $0422a6ce4ea03acc$var$CT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.5023 12C19.5023 12.34 19.4723 12.66 19.4323 12.98L21.5423 14.63C21.7323 14.78 21.7823 15.05 21.6623 15.27L19.6623 18.73C19.5723 18.89 19.4023 18.98 19.2323 18.98C19.1723 18.98 19.1123 18.97 19.0523 18.95L16.5623 17.95C16.0423 18.34 15.4823 18.68 14.8723 18.93L14.4923 21.58C14.4623 21.82 14.2523 22 14.0023 22H10.0023C9.75228 22 9.54228 21.82 9.51228 21.58L9.13228 18.93C8.52228 18.68 7.96228 18.35 7.44228 17.95L4.95228 18.95C4.90228 18.97 4.84228 18.98 4.78228 18.98C4.60228 18.98 4.43228 18.89 4.34228 18.73L2.34228 15.27C2.22228 15.05 2.27228 14.78 2.46228 14.63L4.57228 12.98C4.53228 12.66 4.50228 12.33 4.50228 12C4.50228 11.67 4.53228 11.34 4.57228 11.02L2.46228 9.37C2.27228 9.22 2.21228 8.95 2.34228 8.73L4.34228 5.27C4.43228 5.11 4.60228 5.02 4.77228 5.02C4.83228 5.02 4.89228 5.03 4.95228 5.05L7.44228 6.05C7.96228 5.66 8.52228 5.32 9.13228 5.07L9.51228 2.42C9.54228 2.18 9.75228 2 10.0023 2H14.0023C14.2523 2 14.4623 2.18 14.4923 2.42L14.8723 5.07C15.4823 5.32 16.0423 5.65 16.5623 6.05L19.0523 5.05C19.1023 5.03 19.1623 5.02 19.2223 5.02C19.4023 5.02 19.5723 5.11 19.6623 5.27L21.6623 8.73C21.7823 8.95 21.7323 9.22 21.5423 9.37L19.4323 11.02C19.4723 11.34 19.5023 11.66 19.5023 12ZM17.5023 12C17.5023 11.79 17.4923 11.58 17.4523 11.27L17.3123 10.14L18.2023 9.44L19.2723 8.59L18.5723 7.38L17.3023 7.89L16.2423 8.32L15.3323 7.62C14.9323 7.32 14.5323 7.09 14.1023 6.91L13.0423 6.48L12.8823 5.35L12.6923 4H11.3023L11.1023 5.35L10.9423 6.48L9.88228 6.91C9.47228 7.08 9.06228 7.32 8.63228 7.64L7.73228 8.32L6.69228 7.9L5.42228 7.39L4.72228 8.6L5.80228 9.44L6.69228 10.14L6.55228 11.27C6.52228 11.57 6.50228 11.8 6.50228 12C6.50228 12.2 6.52228 12.43 6.55228 12.74L6.69228 13.87L5.80228 14.57L4.72228 15.41L5.42228 16.62L6.69228 16.11L7.75228 15.68L8.66228 16.38C9.06228 16.68 9.46228 16.91 9.89228 17.09L10.9523 17.52L11.1123 18.65L11.3023 20H12.7023L12.9023 18.65L13.0623 17.52L14.1223 17.09C14.5323 16.92 14.9423 16.68 15.3723 16.36L16.2723 15.68L17.3123 16.1L18.5823 16.61L19.2823 15.4L18.2023 14.56L17.3123 13.86L17.4523 12.73C17.4823 12.43 17.5023 12.21 17.5023 12ZM12.0023 8C9.79228 8 8.00228 9.79 8.00228 12C8.00228 14.21 9.79228 16 12.0023 16C14.2123 16 16.0023 14.21 16.0023 12C16.0023 9.79 14.2123 8 12.0023 8ZM10.0023 12C10.0023 13.1 10.9023 14 12.0023 14C13.1023 14 14.0023 13.1 14.0023 12C14.0023 10.9 13.1023 10 12.0023 10C10.9023 10 10.0023 10.9 10.0023 12Z"
    })), $0422a6ce4ea03acc$var$fT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 2.75C10.5 1.92 11.17 1.25 12 1.25C12.83 1.25 13.5 1.92 13.5 2.75V3.92C16.64 4.6 19 7.4 19 10.75V16.75L21 18.75V19.75H3V18.75L5 16.75V10.75C5 7.4 7.36 4.6 10.5 3.92V2.75ZM12 5.75C14.76 5.75 17 7.99 17 10.75V17.75H7V10.75C7 7.99 9.24 5.75 12 5.75ZM10.01 20.76C10.01 21.86 10.9 22.75 12 22.75C13.1 22.75 13.99 21.86 13.99 20.76H10.01ZM13 7.75V11.75H11V7.75H13ZM13 15.75V13.75H11V15.75H13Z"
    })), $0422a6ce4ea03acc$var$pT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23 21.5L12 2.5L1 21.5H23ZM11 18.5V16.5H13V18.5H11ZM11 14.5H13V10.5H11V14.5Z"
    })), $0422a6ce4ea03acc$var$hT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 21.5L12 2.5L23 21.5H1ZM19.53 19.5L12 6.49L4.47 19.5H19.53ZM11 16.5V18.5H13V16.5H11ZM11 10.5H13V14.5H11V10.5Z"
    })), $0422a6ce4ea03acc$var$mT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 14",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.526 12.871L.263 1.676 1.737.324 12 11.52 22.263.324l1.474 1.352L13.474 12.87a2 2 0 01-2.948 0z"
    })), $0422a6ce4ea03acc$var$vT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 26 26",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M7.32625 7.08462C7.47508 7.08446 7.62096 7.04315 7.74776 6.96527L12.9951 3.75656L18.2424 6.96527C18.3331 7.0207 18.4337 7.05774 18.5387 7.07428C18.6437 7.09082 18.7509 7.08654 18.8542 7.06166C18.9575 7.03679 19.0549 6.99182 19.1409 6.92933C19.2268 6.86683 19.2996 6.78802 19.355 6.69742C19.4105 6.60681 19.4476 6.50617 19.4641 6.40124C19.4807 6.29632 19.4764 6.18916 19.4515 6.08589C19.4266 5.98262 19.3816 5.88527 19.3191 5.79938C19.2566 5.71349 19.1777 5.64075 19.0871 5.58531L13.4171 2.11866C13.2899 2.04106 13.1438 2 12.9948 2C12.8458 2 12.6997 2.04106 12.5725 2.11866L6.9031 5.58531C6.75209 5.6771 6.63532 5.81579 6.57062 5.98018C6.50593 6.14457 6.49689 6.32561 6.54487 6.49563C6.59285 6.66564 6.69523 6.81527 6.83633 6.92164C6.97744 7.028 7.14952 7.08524 7.32625 7.08462V7.08462ZM25.2 22.34H24.3393V13.0439H25.1224C25.3374 13.036 25.5409 12.9452 25.6903 12.7904C25.8396 12.6356 25.923 12.4289 25.923 12.2139C25.923 11.9989 25.8396 11.7922 25.6903 11.6374C25.5409 11.4827 25.3374 11.3918 25.1224 11.384H21.9215C21.7065 11.3918 21.5029 11.4827 21.3536 11.6374C21.2043 11.7922 21.1208 11.9989 21.1208 12.2139C21.1208 12.4289 21.2043 12.6356 21.3536 12.7904C21.5029 12.9452 21.7065 13.036 21.9215 13.0439H22.6786V22.34H3.41332V13.0439H4.4038C4.61879 13.036 4.82236 12.9452 4.97169 12.7904C5.12102 12.6356 5.20446 12.4289 5.20446 12.2139C5.20446 11.9989 5.12102 11.7922 4.97169 11.6374C4.82236 11.4827 4.61879 11.3918 4.4038 11.384H1.20346C0.988468 11.3918 0.784894 11.4827 0.635565 11.6374C0.486236 11.7922 0.402794 11.9989 0.402794 12.2139C0.402794 12.4289 0.486236 12.6356 0.635565 12.7904C0.784894 12.9452 0.988468 13.036 1.20346 13.0439H1.75207V22.34H0.800665C0.585674 22.3478 0.3821 22.4387 0.232771 22.5935C0.0834419 22.7482 0 22.9549 0 23.1699C0 23.385 0.0834419 23.5916 0.232771 23.7464C0.3821 23.9012 0.585674 23.992 0.800665 23.9999H25.2C25.4149 23.992 25.6185 23.9012 25.7678 23.7464C25.9172 23.5916 26.0006 23.385 26.0006 23.1699C26.0006 22.9549 25.9172 22.7482 25.7678 22.5935C25.6185 22.4387 25.4149 22.3478 25.2 22.34V22.34Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M11.5593 21.3202C11.7761 21.321 11.9845 21.2367 12.1397 21.0855C12.295 20.9344 12.3847 20.7283 12.3896 20.5117V14.3814C12.4005 13.9822 12.3312 13.5848 12.1858 13.2128C12.0404 12.8408 11.822 12.5017 11.5433 12.2155C11.2646 11.9293 10.9314 11.7018 10.5633 11.5464C10.1951 11.3911 9.79963 11.3111 9.40005 11.3111C9.00048 11.3111 8.60496 11.3911 8.23685 11.5464C7.86874 11.7018 7.53551 11.9293 7.25683 12.2155C6.97815 12.5017 6.75967 12.8408 6.61431 13.2128C6.46894 13.5848 6.39963 13.9822 6.41047 14.3814V20.5117C6.41604 20.7282 6.506 20.9339 6.66117 21.0851C6.81633 21.2362 7.02443 21.3208 7.24109 21.3208C7.45776 21.3208 7.66585 21.2362 7.82102 21.0851C7.97618 20.9339 8.06614 20.7282 8.07172 20.5117V14.3814C8.05534 14.1971 8.07753 14.0114 8.13686 13.8362C8.19619 13.6609 8.29137 13.4999 8.41633 13.3634C8.5413 13.2269 8.69333 13.1179 8.86273 13.0434C9.03214 12.9688 9.21522 12.9303 9.40033 12.9303C9.58544 12.9303 9.76852 12.9688 9.93792 13.0434C10.1073 13.1179 10.2594 13.2269 10.3843 13.3634C10.5093 13.4999 10.6045 13.6609 10.6638 13.8362C10.7231 14.0114 10.7453 14.1971 10.7289 14.3814V20.5117C10.7338 20.7283 10.8236 20.9344 10.9788 21.0855C11.1341 21.2367 11.3425 21.321 11.5593 21.3202ZM18.8668 21.3202C19.0836 21.321 19.292 21.2367 19.4473 21.0855C19.6025 20.9344 19.6923 20.7283 19.6972 20.5117V14.3814C19.708 13.9822 19.6387 13.5848 19.4933 13.2128C19.348 12.8408 19.1295 12.5017 18.8508 12.2155C18.5721 11.9293 18.2389 11.7018 17.8708 11.5464C17.5027 11.3911 17.1071 11.3111 16.7076 11.3111C16.308 11.3111 15.9125 11.3911 15.5444 11.5464C15.1763 11.7018 14.843 11.9293 14.5643 12.2155C14.2857 12.5017 14.0672 12.8408 13.9218 13.2128C13.7765 13.5848 13.7071 13.9822 13.718 14.3814V20.5117C13.7236 20.7282 13.8135 20.9339 13.9687 21.0851C14.1238 21.2362 14.3319 21.3208 14.5486 21.3208C14.7653 21.3208 14.9734 21.2362 15.1285 21.0851C15.2837 20.9339 15.3737 20.7282 15.3792 20.5117V14.3814C15.3629 14.1971 15.385 14.0114 15.4444 13.8362C15.5037 13.6609 15.5989 13.4999 15.7238 13.3634C15.8488 13.2269 16.0008 13.1179 16.1702 13.0434C16.3397 12.9688 16.5227 12.9303 16.7078 12.9303C16.893 12.9303 17.076 12.9688 17.2454 13.0434C17.4148 13.1179 17.5669 13.2269 17.6918 13.3634C17.8168 13.4999 17.912 13.6609 17.9713 13.8362C18.0306 14.0114 18.0528 14.1971 18.0365 14.3814V20.5117C18.0414 20.7283 18.1311 20.9344 18.2864 21.0855C18.4416 21.2367 18.65 21.321 18.8668 21.3202ZM1.13343 10.0557H25.1321C25.3471 10.0478 25.5507 9.95696 25.7 9.80217C25.8493 9.64738 25.9328 9.44073 25.9328 9.2257C25.9328 9.01067 25.8493 8.80402 25.7 8.64923C25.5507 8.49444 25.3471 8.40358 25.1321 8.39575H1.13343C0.918438 8.40358 0.714863 8.49444 0.565535 8.64923C0.416206 8.80402 0.332764 9.01067 0.332764 9.2257C0.332764 9.44073 0.416206 9.64738 0.565535 9.80217C0.714863 9.95696 0.918438 10.0478 1.13343 10.0557V10.0557Z"
    })), $0422a6ce4ea03acc$var$gT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.61 14.99 15.86 14.89 16.12 14.89C16.22 14.89 16.33 14.9 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3ZM6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02Z"
    })), $0422a6ce4ea03acc$var$yT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H6L2 22V4C2 2.9 2.9 2 4 2ZM6 16H20V4H4V18L6 16Z"
    })), $0422a6ce4ea03acc$var$LT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM12 13L4 8V18H20V8L12 13Z"
    })), $0422a6ce4ea03acc$var$bT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M8.795 15.875l-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41-10.59 10.58z"
    })), $0422a6ce4ea03acc$var$wT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zM11 7h1.5v5.25l4.5 2.67-.75 1.23L11 13V7z"
    })), $0422a6ce4ea03acc$var$HT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
    })), $0422a6ce4ea03acc$var$xT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 68 68",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M65.2403 60.1447H2.75967C2.399 60.1465 2.0415 60.0773 1.7076 59.941C1.37369 59.8046 1.06992 59.6038 0.813646 59.3501C0.557368 59.0963 0.353604 58.7945 0.213995 58.462C0.0743867 58.1294 0.00167011 57.7726 0 57.4119L0 10.5854C0.0018552 10.225 0.0747187 9.86837 0.214428 9.53606C0.354136 9.20375 0.557952 8.90222 0.814231 8.64871C1.07051 8.39519 1.37423 8.19465 1.70803 8.05855C2.04184 7.92246 2.39919 7.85346 2.75967 7.85551H65.2403C65.9682 7.85175 66.6679 8.1372 67.1854 8.64912C67.7029 9.16104 67.9959 9.85752 68 10.5854V57.4133C67.9959 58.1413 67.7029 58.8377 67.1854 59.3497C66.6679 59.8616 65.9682 60.147 65.2403 60.1433V60.1447ZM5.51933 54.682H62.4807V13.3153H5.51933V54.682Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M33.9996 43.2812C33.3964 43.2818 32.8101 43.0814 32.3336 42.7117L15.4327 29.6061C14.8599 29.1642 14.4861 28.5129 14.3935 27.7955C14.3009 27.078 14.4972 26.3532 14.939 25.7804C15.3809 25.2076 16.0322 24.8338 16.7496 24.7412C17.4671 24.6486 18.1919 24.8448 18.7647 25.2867L33.9996 37.1003L49.2344 25.2867C49.8072 24.8448 50.532 24.6486 51.2495 24.7412C51.967 24.8338 52.6182 25.2076 53.0601 25.7804C53.5019 26.3532 53.6982 27.078 53.6056 27.7955C53.513 28.5129 53.1392 29.1642 52.5664 29.6061L35.6656 42.7103C35.1891 43.0803 34.6029 43.2812 33.9996 43.2812V43.2812Z"
    })), $0422a6ce4ea03acc$var$VT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 68 68",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M61.2146 57.0131H6.78638C4.98665 57.011 3.26128 56.2949 1.98896 55.0221C0.716635 53.7492 0.0013159 52.0235 0 50.2238L0 17.7747C0.0023687 15.9754 0.718257 14.2504 1.99065 12.9782C3.26305 11.706 4.98807 10.9904 6.78737 10.9883H61.2146C63.0138 10.9907 64.7386 11.7066 66.0107 12.979C67.2827 14.2514 67.9982 15.9764 68 17.7757V50.2257C67.9979 52.0248 67.2824 53.7496 66.0103 55.0218C64.7383 56.294 63.0137 57.0098 61.2146 57.0121V57.0131ZM6.78638 14.28C5.86003 14.2816 4.97207 14.6503 4.31704 15.3053C3.66202 15.9604 3.29333 16.8483 3.29175 17.7747V50.2248C3.29307 51.1516 3.66191 52.0401 4.3174 52.6954C4.97288 53.3507 5.8615 53.7193 6.78836 53.7204H61.2156C62.1424 53.7191 63.0308 53.3502 63.6859 52.6947C64.3411 52.0391 64.7094 51.1505 64.7102 50.2238V17.7747C64.7092 16.8481 64.3407 15.9597 63.6856 15.3044C63.0305 14.6491 62.1422 14.2804 61.2156 14.279L6.78638 14.28Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M52.3261 24.3672H39.1369C38.9277 24.3723 38.7197 24.3354 38.525 24.2589C38.3303 24.1824 38.1529 24.0677 38.0032 23.9216C37.8535 23.7755 37.7346 23.6009 37.6534 23.4081C37.5721 23.2153 37.5303 23.0082 37.5303 22.7991C37.5303 22.5899 37.5721 22.3828 37.6534 22.19C37.7346 21.9973 37.8535 21.8227 38.0032 21.6766C38.1529 21.5304 38.3303 21.4157 38.525 21.3392C38.7197 21.2627 38.9277 21.2259 39.1369 21.2309H52.3261C52.7354 21.2408 53.1247 21.4104 53.4106 21.7034C53.6966 21.9964 53.8567 22.3896 53.8567 22.7991C53.8567 23.2085 53.6966 23.6017 53.4106 23.8947C53.1247 24.1877 52.7354 24.3573 52.3261 24.3672V24.3672ZM52.3261 30.2584H39.1369C38.9277 30.2635 38.7197 30.2266 38.525 30.1501C38.3303 30.0736 38.1529 29.9589 38.0032 29.8128C37.8535 29.6666 37.7346 29.4921 37.6534 29.2993C37.5721 29.1065 37.5303 28.8994 37.5303 28.6903C37.5303 28.4811 37.5721 28.274 37.6534 28.0812C37.7346 27.8884 37.8535 27.7139 38.0032 27.5677C38.1529 27.4216 38.3303 27.3069 38.525 27.2304C38.7197 27.1539 38.9277 27.1171 39.1369 27.1221H52.3261C52.5352 27.1171 52.7433 27.1539 52.9379 27.2304C53.1326 27.3069 53.31 27.4216 53.4597 27.5677C53.6094 27.7139 53.7284 27.8884 53.8096 28.0812C53.8908 28.274 53.9327 28.4811 53.9327 28.6903C53.9327 28.8994 53.8908 29.1065 53.8096 29.2993C53.7284 29.4921 53.6094 29.6666 53.4597 29.8128C53.31 29.9589 53.1326 30.0736 52.9379 30.1501C52.7433 30.2266 52.5352 30.2635 52.3261 30.2584ZM52.3261 36.1496H39.1369C38.7208 36.1496 38.3219 35.9843 38.0277 35.6901C37.7335 35.396 37.5683 34.997 37.5683 34.581C37.5683 34.165 37.7335 33.766 38.0277 33.4718C38.3219 33.1776 38.7208 33.0124 39.1369 33.0124H52.3261C52.7421 33.0124 53.1411 33.1776 53.4353 33.4718C53.7294 33.766 53.8947 34.165 53.8947 34.581C53.8947 34.997 53.7294 35.396 53.4353 35.6901C53.1411 35.9843 52.7421 36.1496 52.3261 36.1496V36.1496ZM20.6491 24.1604C21.5708 24.1604 22.3501 25.1979 22.3501 26.4256C22.3501 27.6533 21.5708 28.6898 20.6501 28.6898C19.7293 28.6898 18.9482 27.6533 18.9482 26.4256C18.9482 25.1979 19.7275 24.1604 20.6491 24.1604V24.1604ZM20.6491 21.3017C18.2627 21.3017 16.3275 23.5953 16.3275 26.4256C16.3275 29.2558 18.2627 31.5495 20.6491 31.5495C23.0356 31.5495 24.9708 29.2549 24.9708 26.4256C24.9708 23.5962 23.0356 21.3017 20.6491 21.3017ZM20.5866 33.6244C18.4072 33.655 16.2329 33.8432 14.0807 34.1877C13.6315 34.2651 13.2106 34.459 12.8598 34.7501C12.5091 35.0411 12.2409 35.4191 12.0821 35.8463L10.0053 41.2661C9.8532 41.6551 9.79835 42.0754 9.84552 42.4905C9.89268 42.9055 10.0404 43.3027 10.2759 43.6477C10.5115 43.9927 10.8276 44.275 11.197 44.4701C11.5663 44.6652 11.9777 44.7672 12.3954 44.7672H16.1685C16.6056 44.7672 17.0248 44.5936 17.3339 44.2845C17.6429 43.9754 17.8166 43.5562 17.8166 43.1191C17.8166 42.682 17.6429 42.2628 17.3339 41.9537C17.0248 41.6447 16.6056 41.471 16.1685 41.471L13.4724 41.4288L15.0033 37.4315C16.8507 37.1346 18.7161 36.9635 20.5866 36.9196C22.4208 36.9416 24.2512 37.0921 26.0643 37.3699L27.6357 41.471H24.9782C24.5412 41.471 24.1221 41.6446 23.8131 41.9536C23.5041 42.2626 23.3305 42.6817 23.3305 43.1187C23.3305 43.5556 23.5041 43.9747 23.8131 44.2837C24.1221 44.5927 24.5412 44.7663 24.9782 44.7663H28.7503C29.1686 44.7662 29.5804 44.664 29.9502 44.4685C30.3199 44.273 30.6363 43.9901 30.8718 43.6445C31.1072 43.2988 31.2547 42.9009 31.3014 42.4853C31.3481 42.0697 31.2925 41.6489 31.1395 41.2597L29.0095 35.8454C28.8423 35.4157 28.5671 35.0363 28.2106 34.7438C27.8541 34.4513 27.4282 34.2557 26.9741 34.1757C24.8617 33.8352 22.7271 33.651 20.5876 33.6244H20.5866Z"
    })), $0422a6ce4ea03acc$var$MT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 68 68",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M60.4664 59.0967L53.194 21.3402C52.7959 19.5465 51.7878 17.9465 50.3415 16.8132C48.8952 15.68 47.1005 15.0838 45.2637 15.1263H45.1814V7.34288C45.1814 6.3785 44.9915 5.42357 44.6224 4.53261C44.2533 3.64166 43.7123 2.83213 43.0303 2.15027C42.3484 1.4684 41.5388 0.927552 40.6477 0.558607C39.7567 0.189661 38.8018 -0.000154207 37.8374 9.39976e-08H30.2008C28.2533 9.39976e-08 26.3856 0.773623 25.0086 2.15068C23.6315 3.52774 22.8579 5.39543 22.8579 7.34288V15.1263H22.7381C20.9012 15.0838 19.1065 15.68 17.6602 16.8132C16.214 17.9465 15.2058 19.5465 14.8077 21.3402L7.53535 59.0955C7.35991 60.2215 7.43605 61.3724 7.75829 62.4655C8.08054 63.5586 8.6409 64.5668 9.39911 65.4175C10.1573 66.2683 11.0946 66.9406 12.1435 67.386C13.1924 67.8315 14.327 68.0391 15.4657 67.9939H52.5337C53.6724 68.0391 54.807 67.8315 55.8559 67.386C56.9048 66.9406 57.8421 66.2683 58.6003 65.4175C59.3585 64.5668 59.9188 63.5586 60.2411 62.4655C60.5633 61.3724 60.6395 60.2215 60.464 59.0955L60.4664 59.0967ZM28.18 7.8375C28.1803 7.1415 28.457 6.47409 28.9491 5.98194C29.4412 5.4898 30.1087 5.21317 30.8047 5.21286H37.3052C38.0014 5.21317 38.669 5.48996 39.1611 5.98236C39.6533 6.47476 39.9298 7.14247 39.9298 7.83868V15.1263H28.18V7.8375ZM55.1137 62.4592C54.7897 62.821 54.3918 63.1091 53.9469 63.3041C53.5021 63.499 53.0206 63.5963 52.5349 63.5894H15.468C14.9823 63.5964 14.5008 63.4992 14.0559 63.3042C13.6111 63.1092 13.2132 62.821 12.8892 62.4592C12.5746 62.116 12.3448 61.7038 12.2183 61.2558C12.0918 60.8077 12.0721 60.3362 12.1608 59.8792L19.4332 22.1226C19.5988 21.3747 20.019 20.7074 20.622 20.2349C21.225 19.7624 21.9734 19.514 22.7392 19.5321H22.8579V26.0761C22.858 26.4216 22.9264 26.7637 23.059 27.0827C23.1916 27.4018 23.3859 27.6915 23.6307 27.9354C23.8755 28.1792 24.1661 28.3723 24.4856 28.5036C24.8052 28.635 25.1476 28.7019 25.4931 28.7007H25.5636C26.2582 28.6982 26.9235 28.4206 27.4138 27.9287C27.9042 27.4368 28.1797 26.7706 28.18 26.0761V19.5321H39.9298V26.015C39.9298 26.7114 40.2065 27.3793 40.6989 27.8717C41.1913 28.3641 41.8592 28.6408 42.5556 28.6408C43.252 28.6408 43.9199 28.3641 44.4124 27.8717C44.9048 27.3793 45.1814 26.7114 45.1814 26.015V19.5321H45.2637C46.0296 19.514 46.7779 19.7624 47.3809 20.2349C47.984 20.7074 48.4042 21.3747 48.5697 22.1226L55.8421 59.8792C55.9308 60.3362 55.9111 60.8077 55.7846 61.2558C55.6581 61.7038 55.4283 62.116 55.1137 62.4592V62.4592Z"
    })), $0422a6ce4ea03acc$var$ET = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 14 18",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 6.684h-4v-6H4v6H0l7 7 7-7zm-8 2v-6h2v6h1.17L7 10.854l-2.17-2.17H6zm8 9v-2H0v2h14z"
    })), $0422a6ce4ea03acc$var$ST = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.659 3C17.409 3 17.149 3.1 16.959 3.29L15.129 5.12L18.879 8.87L20.709 7.04C21.099 6.65 21.099 6.02 20.709 5.63L18.369 3.29C18.169 3.09 17.919 3 17.659 3ZM14.059 9.02L14.979 9.94L5.91902 19H4.99902V18.08L14.059 9.02ZM2.99902 17.25L14.059 6.19L17.809 9.94L6.74902 21H2.99902V17.25Z"
    })), $0422a6ce4ea03acc$var$kT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.003 13H11.003V7H13.003V13ZM11.003 16.9985H13.003V14.9985H11.003V16.9985Z"
    })), $0422a6ce4ea03acc$var$TT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM13.003 7H11.003V13H13.003V7ZM13.003 14.9985H11.003V16.9985H13.003V14.9985ZM4.00149 12.0015C4.00149 16.4215 7.58149 20.0015 12.0015 20.0015C16.4215 20.0015 20.0015 16.4215 20.0015 12.0015C20.0015 7.58149 16.4215 4.00149 12.0015 4.00149C7.58149 4.00149 4.00149 7.58149 4.00149 12.0015Z"
    })), $0422a6ce4ea03acc$var$_T = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2C3 1.44772 3.44772 1 4 1H16C16.2664 1 16.5218 1.10632 16.7096 1.29537L20.7096 5.3234C20.8956 5.51073 21 5.76402 21 6.02803V22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22V2ZM5 3V21H19V6.4402L15.5837 3H5Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 6V2H16V6H20V8H16C14.8954 8 14 7.10457 14 6Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M7.5 12.5V15.5H9.5L12 18V9.99999L9.5 12.5H7.5ZM14.25 14C14.25 13.115 13.74 12.355 13 11.985V16.01C13.74 15.645 14.25 14.885 14.25 14ZM13 9.61499V10.645C14.445 11.075 15.5 12.415 15.5 14C15.5 15.585 14.445 16.925 13 17.355V18.385C15.005 17.93 16.5 16.14 16.5 14C16.5 11.86 15.005 10.07 13 9.61499Z"
    })), $0422a6ce4ea03acc$var$DT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2.1875C3 1.63522 3.44772 1.1875 4 1.1875H16C16.2664 1.1875 16.5218 1.29382 16.7096 1.48287L20.7096 5.5109C20.8956 5.69823 21 5.95152 21 6.21553V22.1875C21 22.7398 20.5523 23.1875 20 23.1875H4C3.44772 23.1875 3 22.7398 3 22.1875V2.1875ZM5 3.1875V21.1875H19V6.6277L15.5837 3.1875H5Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 6.1875V2.1875H16V6.1875H20V8.1875H16C14.8954 8.1875 14 7.29207 14 6.1875Z"
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        x: 7,
        y: 11.1875,
        width: 10,
        height: 2
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        x: 7,
        y: 15.1875,
        width: 10,
        height: 2
    })), $0422a6ce4ea03acc$var$RT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2C3 1.44772 3.44772 1 4 1H16C16.2664 1 16.5218 1.10632 16.7096 1.29537L20.7096 5.3234C20.8956 5.51073 21 5.76402 21 6.02803V22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22V2ZM5 3V21H19V6.4402L15.5837 3H5Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 6V2H16V6H20V8H16C14.8954 8 14 7.10457 14 6Z"
    })), $0422a6ce4ea03acc$var$ZT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2C3 1.44772 3.44772 1 4 1H16C16.2664 1 16.5218 1.10632 16.7096 1.29537L20.7096 5.3234C20.8956 5.51073 21 5.76402 21 6.02803V22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22V2ZM5 3V21H19V6.4402L15.5837 3H5Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 6V2H16V6H20V8H16C14.8954 8 14 7.10457 14 6Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M14 11L11.1689 15L9.33333 12.4737L6 18H18L14 11Z"
    }), /* @__PURE__ */ $acw62.createElement("circle", {
        cx: 9.375,
        cy: 10.125,
        r: 1.125
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 6V2H16V6H20V8H16C14.8954 8 14 7.10457 14 6Z"
    })), $0422a6ce4ea03acc$var$OT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2C3 1.44772 3.44772 1 4 1H16C16.2664 1 16.5218 1.10632 16.7096 1.29537L20.7096 5.3234C20.8956 5.51073 21 5.76402 21 6.02803V22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22V2ZM5 3V21H19V6.4402L15.5837 3H5Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 6V2H16V6H20V8H16C14.8954 8 14 7.10457 14 6Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M13.6828 13.8743C13.2704 13.4142 12.863 12.9001 12.4962 12.4376C12.3232 12.219 12.1577 12.0106 12.0029 11.8212L11.9915 11.8074C12.2182 11.1612 12.3478 10.6324 12.3767 10.2353C12.4502 9.22357 12.3372 8.57191 12.0318 8.24344C11.8255 8.02117 11.5157 7.94372 11.2243 8.0418C11.0156 8.11179 10.733 8.29939 10.5714 8.79483C10.3306 9.53339 10.4473 10.8413 11.1318 11.9231C10.8264 12.7235 10.4006 13.6433 9.93027 14.519C9.03462 14.8332 8.32073 15.2463 7.80833 15.7475C7.13895 16.4013 6.86685 17.0504 7.06155 17.5278C7.18148 17.8236 7.45884 18 7.80329 18C8.04315 18 8.30253 17.9133 8.55358 17.7496C9.18744 17.3349 10.0151 15.9533 10.4591 15.1526C11.3776 14.8656 12.2844 14.7483 12.7453 14.7037C12.9538 14.6835 13.1608 14.6675 13.3601 14.6563C14.1667 15.5087 14.8264 15.9583 15.4342 16.0705C15.5566 16.0933 15.6789 16.1047 15.7984 16.1047C16.2937 16.1047 16.703 15.907 16.894 15.5759C17.0381 15.3258 17.0352 15.0339 16.8859 14.775C16.5487 14.1907 15.5309 13.8691 14.02 13.8691C13.9113 13.8693 13.799 13.8708 13.6828 13.8743ZM8.13305 17.1068C8.01311 17.1851 7.88989 17.2318 7.80307 17.2318C7.78663 17.2318 7.77544 17.2301 7.76909 17.2285C7.75396 17.152 7.80833 16.8209 8.34441 16.2967C8.59611 16.0505 8.91447 15.8258 9.29137 15.627C8.8158 16.3928 8.38782 16.9402 8.13305 17.1068ZM11.3006 9.03334C11.3565 8.86197 11.4258 8.78452 11.469 8.77004C11.4701 8.76982 11.471 8.76938 11.4718 8.76916C11.5135 8.81612 11.6907 9.08446 11.6113 10.1802C11.5975 10.3713 11.551 10.6129 11.4727 10.8999C11.2166 10.2399 11.1463 9.50662 11.3006 9.03334ZM12.6712 13.9397C12.2629 13.979 11.6411 14.0599 10.9474 14.2243C11.2164 13.6867 11.4655 13.1419 11.6736 12.637C11.7457 12.7274 11.8196 12.8202 11.8946 12.9153C12.1456 13.2319 12.4276 13.5878 12.7198 13.9353L12.6712 13.9397ZM16.2207 15.1592C16.2321 15.179 16.2319 15.1869 16.229 15.1921C16.1968 15.2481 16.051 15.3369 15.7973 15.3369C15.7265 15.3369 15.6511 15.3297 15.5732 15.3152C15.2566 15.2566 14.8874 15.0377 14.4473 14.6471C15.6414 14.7041 16.124 14.9922 16.2207 15.1592Z"
    })), $0422a6ce4ea03acc$var$NT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2C3 1.44772 3.44772 1 4 1H16C16.2664 1 16.5218 1.10632 16.7096 1.29537L20.7096 5.3234C20.8956 5.51073 21 5.76402 21 6.02803V22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22V2ZM5 3V21H19V6.4402L15.5837 3H5Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 6V2H16V6H20V8H16C14.8954 8 14 7.10457 14 6Z"
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        x: 7,
        y: 11,
        width: 4,
        height: 2
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        x: 13,
        y: 11,
        width: 4,
        height: 2
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        x: 7,
        y: 15,
        width: 4,
        height: 2
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        x: 13,
        y: 15,
        width: 4,
        height: 2
    })), $0422a6ce4ea03acc$var$PT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2C3 1.44772 3.44772 1 4 1H16C16.2664 1 16.5218 1.10632 16.7096 1.29537L20.7096 5.3234C20.8956 5.51073 21 5.76402 21 6.02803V22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22V2ZM5 3V21H19V6.4402L15.5837 3H5Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 6V2H16V6H20V8H16C14.8954 8 14 7.10457 14 6Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.33333 10.5H14.3333C14.6542 10.5 14.9167 10.7625 14.9167 11.0833V13.125L17.25 10.7917V17.2083L14.9167 14.875V16.9167C14.9167 17.2375 14.6542 17.5 14.3333 17.5H7.33333C7.0125 17.5 6.75 17.2375 6.75 16.9167V11.0833C6.75 10.7625 7.0125 10.5 7.33333 10.5ZM13.75 16.3333V11.6667H7.91667V16.3333H13.75Z"
    })), $0422a6ce4ea03acc$var$BT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M9 0C4.03 0 0 4.03 0 9V16C0 17.66 1.34 19 3 19H6V11H2V9C2 5.13 5.13 2 9 2C12.87 2 16 5.13 16 9V11H12V19H15C16.66 19 18 17.66 18 16V9C18 4.03 13.97 0 9 0Z"
    })), $0422a6ce4ea03acc$var$FT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 32 33",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M16.1062 13.7323C19.3005 13.7323 21.8899 10.6582 21.8899 6.86615C21.8899 3.07408 19.3005 0 16.1062 0C12.912 0 10.3225 3.07408 10.3225 6.86615C10.3225 10.6582 12.912 13.7323 16.1062 13.7323Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M29.0871 32.0027L2.73962 31.9916C2.31341 31.9677 1.89772 31.85 1.52217 31.6468C1.14663 31.4436 0.820479 31.16 0.566992 30.8161C0.313505 30.4722 0.138921 30.0766 0.0556894 29.6574C-0.0275417 29.2382 -0.0173696 28.8057 0.0854806 28.3909L3.56402 19.1916C3.73971 18.7901 4.00118 18.4319 4.33003 18.1425C4.65887 17.853 5.04709 17.6392 5.46735 17.5162C8.73821 16.9525 12.0475 16.6417 15.366 16.5867C19.5318 16.5867 23.658 17.2262 25.3845 17.3497C25.9474 17.3346 26.5039 17.4726 26.9947 17.7491C27.4855 18.0256 27.8922 18.4302 28.1716 18.9198L31.8785 28.3236C32.0085 28.7551 32.0346 29.2112 31.9548 29.6547C31.8749 30.0982 31.6913 30.5165 31.4191 30.8754C31.1468 31.2342 30.7935 31.5234 30.3882 31.7194C29.9829 31.9153 29.537 32.0124 29.0871 32.0027Z"
    })), $0422a6ce4ea03acc$var$AT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 33 33",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M16.7773 3.27073C18.5337 3.27073 20.0175 5.24892 20.0175 7.59046C20.0175 9.932 18.5337 11.9102 16.7773 11.9102C15.0209 11.9102 13.5371 9.93198 13.5371 7.59044C13.5371 5.2489 15.0209 3.27072 16.7773 3.27072M16.7773 0.724121C13.5832 0.724121 10.9939 3.79828 10.9939 7.59044C10.9939 11.3826 13.5832 14.4568 16.7773 14.4568C19.9714 14.4568 22.5607 11.3826 22.5607 7.59044C22.5607 3.79828 19.9714 0.724121 16.7773 0.724121V0.724121Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M29.7889 32.726H23.7401C23.3654 32.726 23.006 32.577 22.741 32.3117C22.476 32.0463 22.3272 31.6865 22.3272 31.3113C22.3272 30.936 22.476 30.5762 22.741 30.3109C23.006 30.0455 23.3654 29.8965 23.7401 29.8965H29.7889L26.4305 21.1191C26.3972 21.051 26.3456 20.9936 26.2815 20.9533C23.1111 20.4459 19.9081 20.1693 16.6977 20.1256C13.4048 20.1752 10.1198 20.4629 6.86832 20.9864C6.9035 20.9864 6.86556 21.0347 6.83727 21.1066L3.50995 29.8012L9.6113 29.8965C9.98602 29.8965 10.3454 30.0455 10.6104 30.3109C10.8753 30.5762 11.0242 30.936 11.0242 31.3113C11.0242 31.6865 10.8753 32.0463 10.6104 32.3117C10.3454 32.577 9.98602 32.726 9.6113 32.726H3.56173C3.09138 32.7261 2.62813 32.6111 2.21232 32.391C1.7965 32.1708 1.44072 31.8523 1.17595 31.463C0.911181 31.0737 0.745446 30.6255 0.693172 30.1575C0.640897 29.6894 0.70367 29.2156 0.876024 28.7774L4.20335 20.0829C4.37716 19.6001 4.6742 19.1714 5.0649 18.8393C5.4556 18.5072 5.92635 18.2834 6.43028 18.1901C9.82675 17.6443 13.2582 17.3456 16.6978 17.2961C20.067 17.339 23.4284 17.6304 26.7549 18.1679C27.2696 18.2657 27.7512 18.4926 28.1544 18.8275C28.5577 19.1624 28.8694 19.5944 29.0605 20.0829L32.4754 28.7774C32.6473 29.2157 32.7097 29.6894 32.6572 30.1574C32.6047 30.6253 32.4389 31.0733 32.1741 31.4625C31.9094 31.8517 31.5537 32.1702 31.138 32.3904C30.7223 32.6106 30.2592 32.7258 29.7889 32.726Z"
    })), $0422a6ce4ea03acc$var$jT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M11.5961 6.44469V11.0255H8.24243V16.6277H11.5961V32H18.4849V16.6277H23.107C23.107 16.6277 23.5403 13.9417 23.7495 11.0044H18.511V7.17463C18.5738 6.81581 18.7551 6.48847 19.0259 6.24504C19.2966 6.0016 19.6412 5.85615 20.0044 5.83198H23.7576V0H18.6548C11.4259 0 11.5961 5.60745 11.5961 6.44469Z"
    })), $0422a6ce4ea03acc$var$zT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M32 27.8956C31.9946 28.9826 31.5604 30.0234 30.7919 30.7921C30.0234 31.5607 28.9826 31.995 27.8956 32.0007H4.10437C3.01744 31.995 1.97664 31.5607 1.20812 30.7921C0.439601 30.0234 0.00544922 28.9826 0 27.8956L0 4.10437C0.00562488 3.01755 0.439854 1.97686 1.20836 1.20836C1.97686 0.439854 3.01755 0.00562488 4.10437 0L27.8956 0C28.9824 0.00562488 30.0231 0.439854 30.7916 1.20836C31.5601 1.97686 31.9944 3.01755 32 4.10437V27.8956ZM28.3753 13.5421H25.5628C25.8392 14.4253 25.9795 15.3455 25.9789 16.2709C25.9586 17.5582 25.6849 18.8289 25.1734 20.0104C24.662 21.1918 23.9227 22.261 22.998 23.1567C22.0732 24.0524 20.9811 24.7572 19.7839 25.2308C18.5867 25.7043 17.308 25.9374 16.0207 25.9167C13.4242 25.9542 10.9189 24.9594 9.05554 23.1507C7.19216 21.342 6.1231 18.8675 6.08329 16.2709C6.08277 15.3452 6.22331 14.4248 6.50008 13.5414H3.56247V27.042C3.5614 27.2092 3.59355 27.375 3.65705 27.5297C3.72056 27.6844 3.81415 27.8249 3.93239 27.9432C4.05064 28.0614 4.19119 28.155 4.34589 28.2185C4.50059 28.282 4.66636 28.3142 4.83358 28.3131H27.1049C27.2721 28.3142 27.4378 28.282 27.5925 28.2185C27.7471 28.155 27.8876 28.0614 28.0058 27.9431C28.124 27.8249 28.2175 27.6843 28.281 27.5296C28.3444 27.3749 28.3765 27.2092 28.3753 27.042V13.5421ZM16.0207 9.70865C14.3442 9.68522 12.727 10.328 11.5239 11.4959C10.3209 12.6638 9.63053 14.2613 9.60428 15.9378C9.6307 17.6141 10.3212 19.2115 11.5242 20.3792C12.7272 21.547 14.3444 22.1897 16.0207 22.1662C16.8525 22.1802 17.6788 22.0301 18.4525 21.7246C19.2262 21.419 19.9321 20.9641 20.53 20.3857C21.1278 19.8073 21.6059 19.1168 21.9368 18.3536C22.2677 17.5904 22.445 16.7695 22.4586 15.9378C22.4451 15.106 22.2678 14.285 21.937 13.5218C21.6061 12.7585 21.1281 12.0679 20.5302 11.4894C19.9324 10.911 19.2264 10.456 18.4526 10.1504C17.6789 9.84485 16.8525 9.69474 16.0207 9.70865V9.70865ZM28.3753 5.00017C28.3744 4.61908 28.2226 4.25388 27.953 3.98454C27.6834 3.7152 27.318 3.56367 26.9369 3.56314H23.3123C22.9314 3.56402 22.5664 3.71571 22.2971 3.98501C22.0278 4.25431 21.8761 4.61931 21.8752 5.00017V8.43753C21.8758 8.81862 22.0273 9.18396 22.2966 9.45355C22.566 9.72315 22.9312 9.87501 23.3123 9.8759H26.9376C27.3188 9.87519 27.6842 9.7234 27.9537 9.45379C28.2232 9.18418 28.3748 8.81873 28.3753 8.43753V5.00017Z"
    })), $0422a6ce4ea03acc$var$UT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M32 6.1334C30.8013 6.66196 29.5304 7.00873 28.2293 7.16227C29.5986 6.3479 30.6248 5.06293 31.116 3.54732C29.8265 4.30883 28.4167 4.84506 26.947 5.13297C25.9614 4.07664 24.6546 3.3752 23.2296 3.1375C21.8045 2.89981 20.3409 3.13916 19.0657 3.81841C17.7906 4.49765 16.7754 5.5788 16.1776 6.89407C15.5798 8.20933 15.4328 9.68514 15.7596 11.0925C13.152 10.964 10.6005 10.29 8.26961 9.11408C5.93877 7.93815 3.88049 6.2864 2.2277 4.26552C1.38825 5.70402 1.13105 7.4092 1.50885 9.0313C1.88665 10.6534 2.87082 12.0695 4.25949 12.989C3.21742 12.9567 2.19806 12.6765 1.28584 12.1717C1.28537 12.199 1.28528 12.2263 1.28528 12.2539C1.28819 13.7657 1.81433 15.2299 2.77433 16.3978C3.73433 17.5657 5.06901 18.3653 6.55168 18.6609C5.58463 18.9223 4.57082 18.9606 3.58681 18.7728C4.00937 20.0735 4.82743 21.2099 5.92686 22.0234C7.02628 22.8369 8.35222 23.2869 9.71967 23.3106C7.39091 25.1282 4.52022 26.1129 1.56612 26.1076C1.04275 26.1077 0.519815 26.0773 0 26.0163C3.00487 27.9371 6.49752 28.9559 10.0638 28.9519C22.1396 28.9519 28.7431 18.9955 28.7431 10.3611C28.7431 10.0778 28.7368 9.79604 28.7241 9.51581C30.0085 8.59202 31.1178 7.44663 32 6.1334V6.1334Z"
    })), $0422a6ce4ea03acc$var$IT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M31.3319 8.27117C31.1465 7.60661 30.7927 7.00113 30.3048 6.51325C29.8169 6.02538 29.2115 5.67161 28.5469 5.48614C26.0526 4.81789 16.0142 4.81789 16.0142 4.81789C16.0142 4.81789 6.00118 4.80455 3.48158 5.48614C2.81702 5.67161 2.21154 6.02538 1.72366 6.51325C1.23579 7.00113 0.882017 7.60661 0.696547 8.27117C0.223732 10.8248 -0.00936809 13.417 0.000288097 16.014C-0.00754264 18.6013 0.22555 21.1836 0.696547 23.7276C0.882017 24.3921 1.23579 24.9976 1.72366 25.4855C2.21154 25.9734 2.81702 26.3271 3.48158 26.5126C5.97317 27.1822 16.0142 27.1822 16.0142 27.1822C16.0142 27.1822 26.026 27.1822 28.5469 26.5126C29.2115 26.3271 29.8169 25.9734 30.3048 25.4855C30.7927 24.9976 31.1465 24.3921 31.3319 23.7276C31.7931 21.1827 32.0164 18.6003 31.9988 16.014C32.0182 13.418 31.7949 10.8257 31.3319 8.27117V8.27117ZM12.8104 20.8038V11.2096L21.1655 16.014L12.8104 20.8038Z"
    })), $0422a6ce4ea03acc$var$$T = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M15.9996,11.594a2.00366,2.00366,0,1,1-2.00366,2.00366A2.00388,2.00388,0,0,1,15.9996,11.594m0-1.68708a3.69114,3.69114,0,1,0,3.69074,3.69074A3.69513,3.69513,0,0,0,15.9996,9.90695"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M27.23733,10.69471a11.53736,11.53736,0,0,0-2.931-5.21513c-0.03126-.03206-0.0577-0.06732-0.089-0.09938-0.03286-.03286-0.06973-0.06011-0.10259-0.093a11.5287,11.5287,0,0,0-5.22074-2.935,11.3323,11.3323,0,0,0-5.789,0,11.52609,11.52609,0,0,0-5.21994,2.935c-0.03366.03286-.06973,0.06011-0.10259,0.093-0.03206.03206-.05851,0.06732-0.08976,0.09938a11.52831,11.52831,0,0,0-2.93015,5.21513,11.69294,11.69294,0,0,0,0,5.80581,11.52676,11.52676,0,0,0,2.93015,5.21593c0.03126,0.03206.05771,0.06732,0.08976,0.09858,0.03286,0.03366.06893,0.06091,0.10259,0.09377L16,30.02362l8.11482-8.11482c0.03286-.03286.06973-0.06011,0.10259-0.09377,0.03126-.03126.05771-0.06652,0.089-0.09858a11.5358,11.5358,0,0,0,2.931-5.21593,11.693,11.693,0,0,0,0-5.80581M22.79321,20.94463l-3.89912,3.89912L16,27.73784l-2.89489-2.89409L9.206,20.94383l-0.55221-.55221A10.00247,10.00247,0,0,1,8.653,6.8044l0.55381-.553a9.97128,9.97128,0,0,1,13.58562-.0008L23.347,6.8052a10.00228,10.00228,0,0,1-.0008,13.58642Z"
    }))), $0422a6ce4ea03acc$var$YT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9ZM9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C12.8932 6.5 13.7185 6.9765 14.1651 7.75C14.6116 8.5235 14.6116 9.4765 14.1651 10.25C13.7185 11.0235 12.8932 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9Z"
    })), $0422a6ce4ea03acc$var$WT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 -11 24 24",
        width: 24,
        height: 2,
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("rect", {
        width: 24,
        height: 2,
        rx: 1
    })), $0422a6ce4ea03acc$var$QT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.5 3.35C5.97 2.5 7.68 2 9.5 2C15.02 2 19.5 6.48 19.5 12C19.5 17.52 15.02 22 9.5 22C7.68 22 5.97 21.5 4.5 20.65C7.49 18.92 9.5 15.7 9.5 12C9.5 8.3 7.49 5.08 4.5 3.35ZM17.5 12C17.5 7.59 13.91 4 9.5 4C9.16 4 8.82 4.02 8.49 4.07C10.4 6.23 11.5 9.05 11.5 12C11.5 14.95 10.4 17.77 8.49 19.93C8.82 19.98 9.16 20 9.5 20C13.91 20 17.5 16.41 17.5 12Z"
    })), $0422a6ce4ea03acc$var$qT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        id: "icon/navigation/more_vert_24px",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 8.1875C13.1 8.1875 14 7.2875 14 6.1875C14 5.0875 13.1 4.1875 12 4.1875C10.9 4.1875 10 5.0875 10 6.1875C10 7.2875 10.9 8.1875 12 8.1875ZM12 10.1875C10.9 10.1875 10 11.0875 10 12.1875C10 13.2875 10.9 14.1875 12 14.1875C13.1 14.1875 14 13.2875 14 12.1875C14 11.0875 13.1 10.1875 12 10.1875ZM10 18.1875C10 17.0875 10.9 16.1875 12 16.1875C13.1 16.1875 14 17.0875 14 18.1875C14 19.2875 13.1 20.1875 12 20.1875C10.9 20.1875 10 19.2875 10 18.1875Z"
    })), $0422a6ce4ea03acc$var$GT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 23 23",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("rect", {
        x: 11,
        y: 24,
        width: 24,
        height: 2,
        rx: 1,
        transform: "rotate(-90 11 24)"
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        y: 11,
        width: 24,
        height: 2,
        rx: 1
    })), $0422a6ce4ea03acc$var$By = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-1.671 7.743A9.958 9.958 0 0110 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10a9.958 9.958 0 01-2.257 6.329l5.96 5.96a1 1 0 01-1.414 1.414l-5.96-5.96z"
    })), $0422a6ce4ea03acc$var$XT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 36 36",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.2288 36H1.98692C0.889254 36 0 35.1102 0 34.013V1.98691C0 0.889391 0.889394 0 1.98692 0H34.0132C35.1105 0 36 0.889391 36 1.98691V34.013C36 35.1103 35.1103 36 34.0132 36H24.8395V22.0588H29.5189L30.2196 16.6257H24.8395V13.157C24.8395 11.584 25.2763 10.512 27.532 10.512L30.409 10.5107V5.65132C29.9114 5.58511 28.2036 5.43718 26.2167 5.43718C22.0686 5.43718 19.2288 7.96915 19.2288 12.6189V16.6257H14.5373V22.0588H19.2288V36Z"
    })), $0422a6ce4ea03acc$var$KT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 37 37",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_17226_335)"
    }, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip1_17226_335)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.209 0.684814C13.3205 0.684814 12.7075 0.705534 10.7876 0.793133C8.87174 0.880517 7.56323 1.18482 6.4183 1.62982C5.23464 2.08975 4.23083 2.70523 3.23009 3.70591C2.22941 4.70665 1.61392 5.71047 1.15399 6.89413C0.708994 8.03906 0.404698 9.34755 0.317314 11.2634C0.229715 13.1833 0.208984 13.7963 0.208984 18.6848C0.208984 23.5733 0.229715 24.1863 0.317314 26.1062C0.404698 28.0221 0.708994 29.3306 1.15399 30.4755C1.61392 31.6592 2.22941 32.663 3.23009 33.6637C4.23083 34.6644 5.23464 35.2799 6.4183 35.7399C7.56323 36.1848 8.87174 36.4891 10.7876 36.5765C12.7075 36.6641 13.3205 36.6848 18.209 36.6848C23.0975 36.6848 23.7104 36.6641 25.6303 36.5765C27.5462 36.4891 28.8547 36.1848 29.9996 35.7399C31.1833 35.2799 32.1871 34.6644 33.1879 33.6637C34.1886 32.663 34.804 31.6592 35.264 30.4755C35.709 29.3306 36.0133 28.0221 36.1007 26.1062C36.1883 24.1863 36.209 23.5733 36.209 18.6848C36.209 13.7963 36.1883 13.1833 36.1007 11.2634C36.0133 9.34755 35.709 8.03906 35.264 6.89413C34.804 5.71047 34.1886 4.70665 33.1879 3.70591C32.1871 2.70523 31.1833 2.08975 29.9996 1.62982C28.8547 1.18482 27.5462 0.880517 25.6303 0.793133C23.7104 0.705534 23.0975 0.684814 18.209 0.684814ZM18.209 3.92805C23.0152 3.92805 23.5845 3.94641 25.4825 4.03301C27.2375 4.11304 28.1906 4.40627 28.8249 4.65278C29.6651 4.97931 30.2647 5.36937 30.8945 5.99928C31.5244 6.62912 31.9145 7.22874 32.241 8.06893C32.4875 8.7032 32.7807 9.65629 32.8608 11.4113C32.9474 13.3093 32.9657 13.8786 32.9657 18.6848C32.9657 23.491 32.9474 24.0603 32.8608 25.9584C32.7807 27.7133 32.4875 28.6664 32.241 29.3007C31.9145 30.1409 31.5244 30.7405 30.8945 31.3703C30.2647 32.0003 29.6651 32.3903 28.8249 32.7169C28.1906 32.9634 27.2375 33.2566 25.4825 33.3366C23.5848 33.4232 23.0155 33.4416 18.209 33.4416C13.4024 33.4416 12.8333 33.4232 10.9354 33.3366C9.18046 33.2566 8.22737 32.9634 7.5931 32.7169C6.75291 32.3903 6.15328 32.0003 5.52344 31.3703C4.8936 30.7405 4.50348 30.1409 4.17695 29.3007C3.93044 28.6664 3.63721 27.7133 3.55718 25.9584C3.47058 24.0603 3.45222 23.491 3.45222 18.6848C3.45222 13.8786 3.47058 13.3093 3.55718 11.4113C3.63721 9.65629 3.93044 8.7032 4.17695 8.06893C4.50348 7.22874 4.89352 6.62912 5.52344 5.99928C6.15328 5.36937 6.75291 4.97931 7.5931 4.65278C8.22737 4.40627 9.18046 4.11304 10.9354 4.03301C12.8335 3.94641 13.4028 3.92805 18.209 3.92805ZM18.209 9.44158C13.1041 9.44158 8.96575 13.5799 8.96575 18.6848C8.96575 23.7897 13.1041 27.928 18.209 27.928C23.3139 27.928 27.4522 23.7897 27.4522 18.6848C27.4522 13.5799 23.3139 9.44158 18.209 9.44158ZM18.209 24.6848C14.8953 24.6848 12.209 21.9985 12.209 18.6848C12.209 15.3711 14.8953 12.6848 18.209 12.6848C21.5227 12.6848 24.209 15.3711 24.209 18.6848C24.209 21.9985 21.5227 24.6848 18.209 24.6848ZM29.9774 9.07639C29.9774 10.2693 29.0103 11.2364 27.8174 11.2364C26.6245 11.2364 25.6574 10.2693 25.6574 9.07639C25.6574 7.88344 26.6245 6.91635 27.8174 6.91635C29.0103 6.91635 29.9774 7.88344 29.9774 9.07639Z"
    })))), $0422a6ce4ea03acc$var$JT = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_77652_129156)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0 18.0003C0 25.371 4.43222 31.7031 10.7745 34.487C10.7239 33.2301 10.7655 31.7212 11.0879 30.3536C11.4339 28.8924 13.404 20.5453 13.404 20.5453C13.404 20.5453 12.8289 19.396 12.8289 17.6974C12.8289 15.0299 14.375 13.0376 16.3004 13.0376C17.9377 13.0376 18.7287 14.2674 18.7287 15.74C18.7287 17.3859 17.679 19.8478 17.1391 22.128C16.6881 24.0374 18.0965 25.5949 19.9801 25.5949C23.3906 25.5949 25.6875 21.2145 25.6875 16.0246C25.6875 12.0795 23.0304 9.1267 18.1976 9.1267C12.7374 9.1267 9.33581 13.1986 9.33581 17.747C9.33581 19.3153 9.79819 20.4211 10.5224 21.2775C10.8554 21.6709 10.9017 21.8291 10.7812 22.2808C10.6948 22.6119 10.4965 23.4093 10.4144 23.7253C10.2946 24.1812 9.92517 24.3442 9.51314 24.1758C6.9982 23.1491 5.82694 20.395 5.82694 17.299C5.82694 12.1857 10.1393 6.05447 18.6916 6.05447C25.5639 6.05447 30.0871 11.0275 30.0871 16.3658C30.0871 23.427 26.1615 28.7023 20.3747 28.7023C18.4314 28.7023 16.6035 27.6518 15.9772 26.4586C15.9772 26.4586 14.9323 30.6059 14.7109 31.4068C14.3293 32.7946 13.5823 34.1817 12.8992 35.2628C14.5181 35.7407 16.2283 36.001 18.0007 36.001C27.9406 36.001 36.0001 27.9419 36.0001 18.0003C36.0001 8.05908 27.9406 0 18.0007 0C8.05978 0 0 8.05908 0 18.0003Z"
    }))), $0422a6ce4ea03acc$var$e_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_77654_130801)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0 24.3856C0 24.8324 0.161959 25.1702 0.485807 25.3991C0.80969 25.6281 1.15589 25.709 1.52443 25.642C1.87062 25.575 2.11353 25.4522 2.25317 25.2735C2.39275 25.0948 2.46257 24.7989 2.46257 24.3856V19.5276C2.46257 19.1813 2.34253 18.8882 2.10241 18.6481C1.86232 18.408 1.56916 18.2879 1.22293 18.2879C0.887888 18.2879 0.600324 18.408 0.360202 18.6481C0.120079 18.8882 0 19.1813 0 19.5276V24.3856ZM3.85295 26.4629C3.85295 26.7868 3.96743 27.0297 4.19637 27.1916C4.42533 27.3536 4.71849 27.4345 5.07584 27.4345C5.44439 27.4345 5.74311 27.3536 5.97207 27.1916C6.20101 27.0297 6.31549 26.7868 6.31549 26.4629V15.1386C6.31549 14.8035 6.19541 14.5159 5.95532 14.2758C5.7152 14.0357 5.42204 13.9157 5.07584 13.9157C4.74081 13.9157 4.45321 14.0357 4.21312 14.2758C3.973 14.516 3.85295 14.8035 3.85295 15.1386V26.4629ZM7.68915 26.999C7.68915 27.3228 7.80642 27.5657 8.04094 27.7277C8.27547 27.8896 8.577 27.9706 8.94558 27.9706C9.30293 27.9706 9.59609 27.8896 9.82503 27.7277C10.054 27.5657 10.1685 27.3228 10.1685 26.999V16.663C10.1685 16.3168 10.0484 16.0208 9.80831 15.7751C9.56819 15.5295 9.28062 15.4066 8.94558 15.4066C8.59935 15.4066 8.30341 15.5295 8.05773 15.7751C7.81204 16.0208 7.68919 16.3168 7.68919 16.663L7.68915 26.999ZM11.5421 27.0492C11.5421 27.6635 11.9553 27.9706 12.7817 27.9706C13.6082 27.9706 14.0214 27.6635 14.0214 27.0492V10.2972C14.0214 9.35914 13.7366 8.82867 13.167 8.70581C12.7985 8.61646 12.4355 8.72256 12.0781 9.0241C11.7207 9.32563 11.5421 9.74999 11.5421 10.2972V27.0492H11.5421ZM15.4621 27.535V9.30888C15.4621 8.72816 15.6352 8.38196 15.9814 8.27026C16.7297 8.09158 17.4723 8.00223 18.2094 8.00223C19.9181 8.00223 21.5096 8.40427 22.9837 9.20837C24.4579 10.0125 25.6501 11.1097 26.5602 12.5001C27.4704 13.8906 27.9981 15.4233 28.1433 17.0986C28.8245 16.8082 29.5504 16.663 30.321 16.663C31.8845 16.663 33.2219 17.2158 34.3331 18.3215C35.4443 19.4271 36 20.7561 36 22.3085C36 23.872 35.4443 25.2066 34.3331 26.3122C33.2219 27.4178 31.8901 27.9706 30.3378 27.9706L15.7636 27.9539C15.663 27.9204 15.5876 27.8589 15.5374 27.7696C15.4871 27.6803 15.4621 27.602 15.4621 27.535Z"
    }))), $0422a6ce4ea03acc$var$t_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 36 36",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M18 0C8.1 0 0 8.1 0 18C0 27.9 8.1 36 18 36C27.9 36 36 27.9 36 18C36 8.1 27.9 0 18 0ZM25.3026 25.9308C24.9642 25.9308 24.795 25.7616 24.4566 25.5924C21.9168 24.0678 18.7002 23.2218 15.3144 23.2218C13.4514 23.2218 11.421 23.5602 9.7272 23.8986C9.3888 23.8986 9.0504 24.0678 8.8812 24.0678C8.2044 24.0678 7.6968 23.5602 7.6968 22.8834C7.6968 22.2066 8.0352 21.699 8.712 21.699C10.9134 21.1914 13.1148 20.853 15.4854 20.853C19.3788 20.853 22.9356 21.8682 25.983 23.562C26.3214 23.9004 26.6598 24.0696 26.6598 24.7464C26.3178 25.5924 25.8102 25.9308 25.3026 25.9308ZM27.1638 21.1914C26.8254 21.1914 26.487 21.0222 26.1486 20.853C23.2704 18.99 19.206 17.9748 14.805 17.9748C12.6036 17.9748 10.5714 18.3132 9.0486 18.6516C8.7102 18.8208 8.541 18.8208 8.2026 18.8208C7.3566 18.8208 6.8472 18.144 6.8472 17.4654C6.8472 16.6194 7.1856 16.281 8.0316 15.9408C10.0638 15.4332 12.096 14.9256 14.9742 14.9256C19.7154 14.9256 24.1164 16.11 27.8424 18.3114C28.35 18.6498 28.6884 19.1574 28.6884 19.6668C28.5192 20.5128 28.0116 21.1914 27.1638 21.1914ZM29.3652 15.7716C29.0268 15.7716 28.8576 15.6024 28.35 15.4332C24.9642 13.5702 20.0538 12.3858 15.3126 12.3858C12.942 12.3858 10.4022 12.7242 8.2008 13.2318C7.8624 13.2318 7.6932 13.401 7.1856 13.401C6.1704 13.572 5.4918 12.7242 5.4918 11.709C5.4918 10.6938 5.9994 10.1844 6.6762 10.0152C9.387 9.3384 12.2652 9 15.3126 9C20.5614 9 25.9794 10.1844 30.213 12.3858C30.7206 12.7242 31.2282 13.2318 31.2282 14.0796C31.059 15.0948 30.3804 15.7716 29.3652 15.7716Z"
    })), $0422a6ce4ea03acc$var$n_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 36 36",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_80207_143160)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M29.473 7.53646C29.2286 7.41016 28.9907 7.2717 28.7602 7.12161C28.0898 6.67844 27.4752 6.15625 26.9296 5.5663C25.5643 4.0042 25.0544 2.41947 24.8666 1.30993H24.8742C24.7173 0.388967 24.7821 -0.206909 24.792 -0.206909H18.5737V23.8378C18.5737 24.1606 18.5737 24.4797 18.5602 24.795C18.5602 24.8342 18.5564 24.8704 18.5541 24.9126C18.5541 24.93 18.5541 24.9481 18.5503 24.9662C18.5503 24.9707 18.5503 24.9753 18.5503 24.9798C18.4848 25.8425 18.2082 26.6759 17.745 27.4066C17.2818 28.1374 16.6461 28.7431 15.8938 29.1705C15.1098 29.6166 14.223 29.8505 13.321 29.8494C10.4238 29.8494 8.07575 27.487 8.07575 24.5695C8.07575 21.6519 10.4238 19.2895 13.321 19.2895C13.8694 19.289 14.4144 19.3753 14.9359 19.5452L14.9434 13.2139C13.3605 13.0094 11.7523 13.1352 10.2204 13.5833C8.68854 14.0315 7.26615 14.7922 6.04299 15.8176C4.97122 16.7488 4.07017 17.86 3.3804 19.101C3.11792 19.5535 2.12756 21.3721 2.00763 24.3236C1.9322 25.9988 2.4353 27.7344 2.67516 28.4517V28.4668C2.82601 28.8892 3.41057 30.3306 4.36322 31.5457C5.1314 32.5204 6.03898 33.3767 7.05673 34.0869V34.0718L7.07182 34.0869C10.0821 36.1325 13.4198 35.9982 13.4198 35.9982C13.9976 35.9748 15.933 35.9982 18.131 34.9565C20.5688 33.8018 21.9566 32.0813 21.9566 32.0813C22.8433 31.0532 23.5483 29.8817 24.0414 28.6169C24.6041 27.1378 24.792 25.3637 24.792 24.6547V11.8984C24.8674 11.9437 25.8721 12.6082 25.8721 12.6082C25.8721 12.6082 27.3195 13.5359 29.5778 14.1401C31.198 14.5701 33.3809 14.6606 33.3809 14.6606V8.4876C32.616 8.57057 31.063 8.3292 29.473 7.53646Z"
    }))), $0422a6ce4ea03acc$var$r_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 36 36",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_17226_338)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.5555 28.7555C25.9003 29.0748 24.6474 29.3526 23.7131 29.3765C20.8923 29.4536 20.3448 27.352 20.3221 25.8285V14.6215H27.3978V9.17054H20.3466V0H15.1867C15.1017 0 14.9535 0.0759761 14.9325 0.268753C14.6306 3.0754 13.3455 8.00148 8 9.97119V14.6213H11.566V26.3834C11.566 30.411 14.4735 36.1327 22.149 35.9976C24.7387 35.9523 27.6149 34.8448 28.25 33.8886L26.5555 28.7555Z"
    }))), $0422a6ce4ea03acc$var$a_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 36 36",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M36 6.55147C34.6772 7.15385 33.253 7.56122 31.7591 7.74323C33.2847 6.80715 34.4554 5.32287 35.0069 3.55472C33.5784 4.42146 32 5.052 30.3138 5.39003C28.9699 3.91874 27.0491 3 24.9234 3C20.8473 3 17.5404 6.39111 17.5404 10.5731C17.5404 11.1668 17.6038 11.7432 17.7306 12.2979C11.5922 11.9816 6.15108 8.96966 2.50607 4.38245C1.87005 5.50487 1.50659 6.80715 1.50659 8.19394C1.50659 10.8202 2.81036 13.1387 4.7924 14.4973C3.58373 14.4605 2.44268 14.1159 1.44532 13.5526V13.6457C1.44532 17.3164 3.99154 20.3781 7.37242 21.0715C6.7533 21.2492 6.10037 21.338 5.42631 21.338C4.95087 21.338 4.486 21.2925 4.03592 21.2037C4.97623 24.2113 7.70205 26.402 10.935 26.4605C8.40781 28.493 5.22134 29.7042 1.76228 29.7042C1.1664 29.7042 0.576862 29.6696 0 29.6002C3.26889 31.7454 7.15267 33 11.3217 33C24.9086 33 32.336 21.4615 32.336 11.4529C32.336 11.1235 32.3296 10.7941 32.3169 10.4713C33.7602 9.40303 35.0132 8.07043 36 6.55147Z"
    })), $0422a6ce4ea03acc$var$i_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 36 36",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M35.9818 10.0262C35.8271 13.4487 33.373 18.1241 28.6406 24.0663C23.7465 30.2744 19.6047 33.375 16.2154 33.375C14.1199 33.375 12.3408 31.4853 10.8923 27.7058C9.9219 24.2412 8.95854 20.7767 7.98815 17.3122C6.91228 13.5327 5.75203 11.643 4.52146 11.643C4.24722 11.643 3.30496 12.1959 1.69467 13.2947L0 11.167C1.77905 9.64823 3.52998 8.12244 5.25277 6.60365C7.6225 4.60192 9.40155 3.55206 10.5899 3.44708C13.3886 3.18111 15.1184 5.04986 15.7653 9.05331C16.4615 13.3647 16.9467 16.0524 17.2139 17.1022C18.0226 20.6787 18.9156 22.4635 19.886 22.4635C20.6384 22.4635 21.7705 21.3086 23.2824 18.985C24.7872 16.6613 25.5958 14.8975 25.7013 13.6797C25.9193 11.678 25.1106 10.6701 23.2824 10.6701C22.4174 10.6701 21.5314 10.8661 20.6173 11.251C22.3823 5.59578 25.7646 2.85216 30.7572 3.00614C34.4559 3.11112 36.1998 5.44881 35.9818 10.0262Z"
    })), $0422a6ce4ea03acc$var$o_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 36 36",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_17226_337)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.283 22.4524L14.2819 12.2658L24.0086 17.3767L14.283 22.4524ZM35.64 10.5006C35.64 10.5006 35.2879 8.00241 34.209 6.90228C32.8399 5.45773 31.3054 5.45092 30.6022 5.36708C25.5645 4.99999 18.0079 5 18.0079 5H17.9921C17.9921 5 10.4355 4.99999 5.39775 5.36708C4.6935 5.45092 3.16013 5.45773 1.78988 6.90228C0.711004 8.00241 0.359997 10.5006 0.359997 10.5006C0.359997 10.5006 0 13.435 0 16.3683V19.1192C0 22.0536 0.359997 24.9869 0.359997 24.9869C0.359997 24.9869 0.711004 27.4851 1.78988 28.5853C3.16013 30.0298 4.95899 29.9845 5.75999 30.1352C8.63999 30.4139 18 30.5 18 30.5C18 30.5 25.5645 30.4887 30.6022 30.1216C31.3054 30.0366 32.8399 30.0298 34.209 28.5853C35.2879 27.4851 35.64 24.9869 35.64 24.9869C35.64 24.9869 36 22.0536 36 19.1192V16.3683C36 13.435 35.64 10.5006 35.64 10.5006Z"
    }))), $0422a6ce4ea03acc$var$l_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H6L2 22L2.01 4C2.01 2.9 2.9 2 4 2ZM5.17 16H20V4H4V17.17L4.58 16.59L5.17 16ZM6 12H8V14H6V12ZM8 9H6V11H8V9ZM6 6H8V8H6V6ZM15 12H10V14H15V12ZM10 9H18V11H10V9ZM18 6H10V8H18V6Z"
    })), $0422a6ce4ea03acc$var$s_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.0004 4V8.69L23.3104 12L20.0004 15.31V20H15.3104L12.0004 23.31L8.69043 20H4.00043V15.31L0.69043 12L4.00043 8.69V4H8.69043L12.0004 0.690002L15.3104 4H20.0004ZM18.0004 18V14.48L20.4804 12L18.0004 9.52V6H14.4804L12.0004 3.52L9.52043 6H6.00043V9.52L3.52043 12L6.00043 14.48V18H9.52043L12.0004 20.48L14.4804 18H18.0004ZM12.0004 6.5C8.97043 6.5 6.50043 8.97 6.50043 12C6.50043 15.03 8.97043 17.5 12.0004 17.5C15.0304 17.5 17.5004 15.03 17.5004 12C17.5004 8.97 15.0304 6.5 12.0004 6.5ZM8.50043 12C8.50043 13.93 10.0704 15.5 12.0004 15.5C13.9304 15.5 15.5004 13.93 15.5004 12C15.5004 10.07 13.9304 8.5 12.0004 8.5C10.0704 8.5 8.50043 10.07 8.50043 12Z"
    })), $0422a6ce4ea03acc$var$u_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.25 7.86581C18.25 11.0019 15.4518 13.5441 12 13.5441C8.54822 13.5441 5.75 11.0019 5.75 7.86581C5.75 4.72977 8.54822 2.1875 12 2.1875C15.4518 2.1875 18.25 4.72977 18.25 7.86581Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.2249 12.9931C4.98033 13.4589 2.25055 18.7558 1.99414 22.1989H21.9941C21.9941 22.1989 18.9172 12.4193 11.2249 12.9931Z"
    })), $0422a6ce4ea03acc$var$c_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.8 7.80705C17.8 10.6767 15.2421 13.0704 12 13.0704C8.75787 13.0704 6.2 10.6767 6.2 7.80705C6.2 4.93739 8.75787 2.54375 12 2.54375C15.2421 2.54375 17.8 4.93739 17.8 7.80705Z",
        fill: "white",
        stroke: "black",
        strokeWidth: 1
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.2249 13.0712C4.98033 13.537 2.25055 18.8343 1.99414 22.2775H21.9941C21.9941 22.2775 18.9172 12.4974 11.2249 13.0712Z",
        fill: "white",
        stroke: "black",
        strokeWidth: 1
    })), $0422a6ce4ea03acc$var$d_ = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 17C3 16.4477 3.44772 16 4 16H20C20.5523 16 21 16.4477 21 17C21 17.5523 20.5523 18 20 18H4C3.44772 18 3 17.5523 3 17Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 7C3 6.44772 3.44772 6 4 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H4C3.44772 8 3 7.55228 3 7Z"
    })), $0422a6ce4ea03acc$var$C_ = {
    accessibilityFull: $0422a6ce4ea03acc$var$Qk,
    accessibilityPartial: $0422a6ce4ea03acc$var$qk,
    actionCheckCircle: $0422a6ce4ea03acc$var$Gk,
    actionCheckCircleFilled: $0422a6ce4ea03acc$var$Xk,
    actionDelete: $0422a6ce4ea03acc$var$Kk,
    actionExit: $0422a6ce4ea03acc$var$Jk,
    actionHelpDefault: $0422a6ce4ea03acc$var$eT,
    actionHelpOutline: $0422a6ce4ea03acc$var$tT,
    actionHome: $0422a6ce4ea03acc$var$nT,
    actionIdentity: $0422a6ce4ea03acc$var$rT,
    actionIdentityFilled: $0422a6ce4ea03acc$var$aT,
    actionLaunch: $0422a6ce4ea03acc$var$iT,
    actionLightbulb: $0422a6ce4ea03acc$var$oT,
    actionLockClosed: $0422a6ce4ea03acc$var$lT,
    actionPayment: $0422a6ce4ea03acc$var$sT,
    actionPower: $0422a6ce4ea03acc$var$uT,
    actionRegistration: $0422a6ce4ea03acc$var$cT,
    actionSearch: $0422a6ce4ea03acc$var$dT,
    actionSettings: $0422a6ce4ea03acc$var$CT,
    alertNotificationImportant: $0422a6ce4ea03acc$var$fT,
    alertWarningFilled: $0422a6ce4ea03acc$var$pT,
    alertWarningOutline: $0422a6ce4ea03acc$var$hT,
    arrow: $0422a6ce4ea03acc$var$mT,
    building: $0422a6ce4ea03acc$var$vT,
    check: $0422a6ce4ea03acc$var$bT,
    clock: $0422a6ce4ea03acc$var$wT,
    close: $0422a6ce4ea03acc$var$HT,
    communicationCall: $0422a6ce4ea03acc$var$gT,
    communicationChatBubble: $0422a6ce4ea03acc$var$yT,
    communicationEmail: $0422a6ce4ea03acc$var$LT,
    decorativeEnvelope: $0422a6ce4ea03acc$var$xT,
    decorativeLibraryCard: $0422a6ce4ea03acc$var$VT,
    decorativeShoppingBag: $0422a6ce4ea03acc$var$MT,
    download: $0422a6ce4ea03acc$var$ET,
    editorMode: $0422a6ce4ea03acc$var$ST,
    errorFilled: $0422a6ce4ea03acc$var$kT,
    errorOutline: $0422a6ce4ea03acc$var$TT,
    fileTypeAudio: $0422a6ce4ea03acc$var$_T,
    fileTypeDoc: $0422a6ce4ea03acc$var$DT,
    fileTypeGenericDoc: $0422a6ce4ea03acc$var$RT,
    fileTypeImage: $0422a6ce4ea03acc$var$ZT,
    fileTypePdf: $0422a6ce4ea03acc$var$OT,
    fileTypeSpreadsheet: $0422a6ce4ea03acc$var$NT,
    fileTypeVideo: $0422a6ce4ea03acc$var$PT,
    headset: $0422a6ce4ea03acc$var$BT,
    legacyAccountFilled: $0422a6ce4ea03acc$var$FT,
    legacyAccountUnfilled: $0422a6ce4ea03acc$var$AT,
    legacySocialFacebook: $0422a6ce4ea03acc$var$jT,
    legacySocialInstagram: $0422a6ce4ea03acc$var$zT,
    legacySocialTwitter: $0422a6ce4ea03acc$var$UT,
    legacySocialYoutube: $0422a6ce4ea03acc$var$IT,
    locator: $0422a6ce4ea03acc$var$$T,
    mapsPlace: $0422a6ce4ea03acc$var$YT,
    minus: $0422a6ce4ea03acc$var$WT,
    moonCrescent: $0422a6ce4ea03acc$var$QT,
    navigationMoreVert: $0422a6ce4ea03acc$var$qT,
    plus: $0422a6ce4ea03acc$var$GT,
    search: $0422a6ce4ea03acc$var$By,
    socialFacebook: $0422a6ce4ea03acc$var$XT,
    socialInstagram: $0422a6ce4ea03acc$var$KT,
    socialPinterest: $0422a6ce4ea03acc$var$JT,
    socialSoundCloud: $0422a6ce4ea03acc$var$e_,
    socialSpotify: $0422a6ce4ea03acc$var$t_,
    socialTikTok: $0422a6ce4ea03acc$var$n_,
    socialTumblr: $0422a6ce4ea03acc$var$r_,
    socialTwitter: $0422a6ce4ea03acc$var$a_,
    socialVimeo: $0422a6ce4ea03acc$var$i_,
    socialYoutube: $0422a6ce4ea03acc$var$o_,
    speakerNotes: $0422a6ce4ea03acc$var$l_,
    sunFull: $0422a6ce4ea03acc$var$s_,
    utilityAccountFilled: $0422a6ce4ea03acc$var$u_,
    utilityAccountUnfilled: $0422a6ce4ea03acc$var$c_,
    utilityHamburger: $0422a6ce4ea03acc$var$d_,
    utilitySearch: $0422a6ce4ea03acc$var$By
}, $0422a6ce4ea03acc$export$f04a61298a47a40f = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    var z, I;
    const { align: o = "none", children: s, className: i, color: p = "ui.black", decorative: C = !0, iconRotation: v = "rotate0", id: y, name: L, size: M = "default", title: E = `${L} icon`, type: k = "default", ..._ } = r, Z = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("ReservoirIcon", {
        align: o,
        color: p,
        iconRotation: v,
        size: M,
        variant: k
    }), O = {
        "aria-hidden": C,
        className: i,
        id: y,
        role: "img",
        title: E,
        ..._
    };
    let B = null;
    if (L && s) return console.warn("NYPL Reservoir Icon: Pass in either a `name` prop or an `svg` element child. Do not pass both."), null;
    if (!L && !s) return console.warn("NYPL Reservoir Icon: Pass an icon `name` prop or an SVG child to ensure an icon appears."), null;
    if (L) {
        const P = $0422a6ce4ea03acc$var$C_[L];
        return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $6a96cde036d65913$export$f04a61298a47a40f), {
            as: P,
            ref: a,
            ...O,
            __css: Z
        });
    }
    return s.type === "svg" || ((z = s.props) == null ? void 0 : z.type) === "svg" || ((I = s.props) == null ? void 0 : I.mdxType) === "svg" ? B = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(s, {
        ...O,
        ref: a
    }) : console.warn("NYPL Reservoir Icon: An `svg` element must be passed to the `Icon` component as its child."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        ref: a,
        __css: Z,
        children: B
    });
}), // Pass all custom props to Chakra and override, e.g. we want the
// DS color value set and not color strings.
{
    shouldForwardProp: ()=>!0
}), $0422a6ce4ea03acc$var$f_ = (r = !1, a, o, s)=>{
    const i = r ? "minus" : "plus";
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
        id: `accordion-${o}-icon-${a}`,
        name: i,
        size: "small",
        color: s
    });
}, $0422a6ce4ea03acc$var$p_ = (r = [], a, o, s = !1, i, p)=>{
    const C = i ? {
        default: "ui.white",
        warning: "ui.status.primary",
        error: "dark.ui.error.primary"
    } : {
        default: "ui.white",
        warning: "ui.status.primary",
        error: "ui.status.secondary"
    }, v = (r == null ? void 0 : r.length) > 1 ? "desktop.body.body1" : "desktop.body.body2", y = (r == null ? void 0 : r.length) > 1 ? "17.5px" : "xs s";
    return r.map((L, M)=>{
        const E = typeof L.panel == "string" ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $7ddf2a6aa068c6d3$export$7cad6f17fd6e117b), {
            id: `${o}-panel-${M}`,
            dangerouslySetInnerHTML: {
                __html: L.panel
            },
            maxHeight: p,
            overflow: "auto"
        }, M) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $7ddf2a6aa068c6d3$export$7cad6f17fd6e117b), {
            id: `${o}-panel-${M}`,
            maxHeight: p,
            overflow: "auto",
            children: L.panel
        }, M), k = L.ariaLabel ? L.ariaLabel : a;
        return L.ariaLabel && a && console.warn("NYPL Reservoir Accordion: An ariaLabel value has been passed for the overall component and as part of the accordionData prop. Both can not be used, so the value in the accordionData prop will be used."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $4aa76a7ca27e9270$export$d99097c13d4dac9f), {
            id: `${o}-item-${M}`,
            children: ({ isExpanded: _ })=>{
                const Z = C[L.accordionType];
                return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                    children: [
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $90560ec3a7c6c43d$export$b9675c0bae9f505a), {
                            "aria-label": k,
                            id: `${o}-button-${M}`,
                            borderColor: i ? "dark.ui.border.default" : "ui.gray.medium",
                            padding: y,
                            ref: L.buttonInteractionRef,
                            bg: L.accordionType ? Z : C.default,
                            _expanded: {
                                bg: !L.accordionType || L.accordionType === "default" ? "ui.gray.light-cool" : Z
                            },
                            _hover: {
                                bg: !L.accordionType || L.accordionType === "default" ? "transparent" : Z,
                                borderColor: "ui.gray.dark"
                            },
                            _dark: {
                                _expanded: {
                                    bg: "dark.ui.bg.active"
                                },
                                bg: "dark.ui.bg.default",
                                color: "dark.ui.typography.heading",
                                borderStart: "4px solid",
                                borderStartColor: !L.accordionType || L.accordionType === "default" ? "dark.ui.border.hover" : Z
                            },
                            children: [
                                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                                    as: "span",
                                    flex: "1",
                                    fontSize: v,
                                    textAlign: "start",
                                    children: L.label
                                }),
                                $0422a6ce4ea03acc$var$f_(_, M, o, i ? "dark.ui.typography.heading" : "ui.black")
                            ]
                        }),
                        (s || _) && E
                    ]
                });
            }
        }, M);
    });
}, $0422a6ce4ea03acc$export$a766cd26d0d69044 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { accordionData: o, ariaLabel: s, id: i, isDefaultOpen: p = !1, isAlwaysRendered: C = !1, panelMaxHeight: v, userClickedOutside: y, ...L } = r, M = (0, $b80b1cf263c5808a$export$20f3076712c8dfa)().colorMode === "dark", [E, k] = (0, $acw62.useState)(p ? [
        0
    ] : []), _ = o.map((O)=>({
            ...O,
            buttonInteractionRef: O.buttonInteractionRef || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef()
        })), Z = (O)=>{
        if (O.code === "Escape") {
            let B;
            O.target.dataset.index ? B = Number(O.target.dataset.index) : B = Number(O.target.closest("[role='region']").id.split("-").pop()), k(E.filter((z)=>z !== B)), _[B].buttonInteractionRef && _[B].buttonInteractionRef.current.focus();
        }
    };
    return (0, $acw62.useEffect)(()=>{
        y && k([]);
    }, [
        y
    ]), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $ab20c29d51326b95$export$a766cd26d0d69044), {
        allowMultiple: !0,
        index: E,
        onChange: (O)=>k(O),
        onKeyDown: Z,
        id: i,
        ref: a,
        ...L,
        children: $0422a6ce4ea03acc$var$p_(_, s, i, C, M, v)
    });
})), $0422a6ce4ea03acc$export$353f5b6fc5456de1 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { buttonType: o = "primary", children: s, className: i = "", id: p, isDisabled: C = !1, mouseDown: v = !1, onClick: y, screenreaderOnlyText: L, size: M = "medium", type: E = "button", ...k } = r, _ = v ? {
        onMouseDown: y
    } : {
        onClick: y
    };
    let Z = 0, O = !1, B = o, z = {};
    return p || console.warn("NYPL Reservoir Button: This component's required `id` prop was not passed."), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(s, (I)=>{
        var P;
        Z++, I != null && (I.type === $0422a6ce4ea03acc$export$f04a61298a47a40f || ((P = I == null ? void 0 : I.props) == null ? void 0 : P.mdxType) === "Icon") && (O = !0);
    }), Z === 1 && O && (B = "iconOnly"), z = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("CustomButton", {
        variant: B,
        buttonSize: M
    }), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $df191e1c46987458$export$353f5b6fc5456de1), {
        className: i,
        gap: O ? "xxs" : null,
        id: p,
        isDisabled: C,
        ref: a,
        type: E,
        ..._,
        __css: z.base,
        ...k,
        children: [
            s,
            L && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                as: "span",
                __css: z.screenreaderOnly,
                children: L
            })
        ]
    });
}), // Chakra uses different values for its own `size` prop. We
// want to override the values and use our own.
{
    shouldForwardProp: ()=>!0
}), $0422a6ce4ea03acc$var$m_ = (r, a, o = 1)=>r ? Array(Math.ceil((a - r) / o)).fill(r).map((s, i)=>s + i * o) : [], $0422a6ce4ea03acc$var$Uo = ({ additionalAriaLabel: r, footnote: a, id: o, labelText: s, name: i, additionalHelperTextIds: p, showLabel: C })=>{
    let v = {};
    return r && (v["aria-label"] = `${s}, ${r}`), C || (typeof s != "string" && console.warn(`NYPL Reservoir ${i}: \`labelText\` must be a string when \`showLabel\` is false.`), "aria-label" in v || (v["aria-label"] = s)), a && (v["aria-describedby"] = `${p ? p + " " : ""}${o}-helperText`), v;
}, $0422a6ce4ea03acc$var$P1 = (r, a)=>{
    const o = r.length === 4, s = o ? r.slice(1, 2).repeat(2) : r.slice(1, 3), i = o ? r.slice(2, 3).repeat(2) : r.slice(3, 5), p = o ? r.slice(3, 4).repeat(2) : r.slice(5, 7), C = parseInt(s, 16), v = parseInt(i, 16), y = parseInt(p, 16), L = `${C}, ${v}, ${y}`;
    return a ? `rgba(${L},${a})` : `rgb(${L})`;
}, $0422a6ce4ea03acc$var$v_ = (r, a = 60)=>{
    const o = r.substring(0, a - 1);
    return `${o.substring(0, o.lastIndexOf(" "))}...`;
}, $0422a6ce4ea03acc$var$g_ = (r)=>r.replace(/[^a-z0-9]/gi, "-").toLowerCase();
function $0422a6ce4ea03acc$var$y_(r, a, o) {
    const s = {
        align: void 0,
        iconRotation: void 0,
        id: `${o}-direction-icon`
    };
    let i;
    return a === "backwards" ? (s.align = "left", s.iconRotation = "rotate90") : a === "forwards" && (s.align = "right", s.iconRotation = "rotate270"), i = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
        name: "arrow",
        size: "medium",
        ...s
    }), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
        children: [
            a === "backwards" && i,
            r,
            a === "forwards" && i
        ]
    });
}
function $0422a6ce4ea03acc$var$L_(r, a, o) {
    const s = `${a}-external-icon`, i = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                as: "span",
                __css: o,
                children: "This link opens in a new window"
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                align: "right",
                id: s,
                name: "actionLaunch",
                size: "medium",
                title: "External link"
            })
        ]
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
        children: [
            r,
            i
        ]
    });
}
function $0422a6ce4ea03acc$var$b_(r, a) {
    const o = `${a}-standalone-icon`, s = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
        align: "right",
        iconRotation: "rotate270",
        id: o,
        name: "arrow",
        size: "xsmall",
        title: "Navigation arrow"
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
        children: [
            r,
            s
        ]
    });
}
const $0422a6ce4ea03acc$export$a6c7ac8248d6e38a = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { as: o = "a", children: s, className: i, hasVisitedState: p = !0, href: C, id: v, isUnderlined: y = !0, onClick: L, screenreaderOnlyText: M, target: E, type: k = "default", ..._ } = r, Z = k === "backwards" || k === "forwards" || k === "standalone" ? !1 : y, z = {
        id: v,
        href: C,
        onClick: L,
        rel: k === "external" ? "nofollow noopener noreferrer" : null,
        ref: a,
        target: k === "external" ? "_blank" : E || null,
        ..._
    };
    let I = "link";
    k === "action" || k === "backwards" || k === "external" || k === "forwards" || k === "standalone" ? I = "moreLink" : k.includes("button") && (I = k);
    const P = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Link", {
        finalIsUnderlined: Z,
        hasVisitedState: p,
        variant: I
    }), $ = v || $0422a6ce4ea03acc$var$g_(`link-${s}`), W = (k === "forwards" || k === "backwards") && $0422a6ce4ea03acc$var$y_(s, k, $) || k === "external" && $0422a6ce4ea03acc$var$L_(s, $, P.screenreaderOnly) || k === "standalone" && $0422a6ce4ea03acc$var$b_(s, $) || s, l1 = M ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "span",
        __css: P.screenreaderOnly,
        children: M
    }) : null;
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $e314e25282bef023$export$a6c7ac8248d6e38a), {
        as: o,
        className: i,
        ...z,
        sx: P.base,
        ..._,
        children: [
            W,
            l1
        ]
    });
}), {
    shouldForwardProp: ()=>!0
}), $0422a6ce4ea03acc$export$5f1af8db9871e1d6 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { children: o, className: s = "", id: i, isBold: p, isItalic: C, isCapitalized: v, isUppercase: y, isLowercase: L, noSpace: M, role: E, size: k = "default", ..._ } = r, Z = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Text", {
        variant: k,
        isBold: p,
        isItalic: C,
        isCapitalized: v,
        isUppercase: y,
        isLowercase: L,
        noSpace: M
    });
    o || console.warn("NYPL Reservoir Text: No children were passed and the `Text` component will not render correctly."), p && k === "caption" && console.warn("NYPL Reservoir Text: The `isBold` prop does not work with caption text."), p && (k === "overline1" || k === "overline2") && console.warn("NYPL Reservoir Text: The `isBold` prop does not work with overline text."), p && (k === "subtitle1" || k === "subtitle2") && console.warn("NYPL Reservoir Text: The `isBold` prop does not work with subtitle text."), p && k === "tag" && console.warn("NYPL Reservoir Text: The `isBold` prop does not work with tag text."), p && k === "mini" && console.warn("NYPL Reservoir Text: The `isBold` prop does not work with mini text.");
    let O = 0;
    return v && O++, y && O++, L && O++, O > 1 && console.warn("NYPL Reservoir Text: Multiple text case props have been passed and the component will not render properly."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $7a2900ce3f78a504$export$5f1af8db9871e1d6), {
        className: s,
        id: i,
        ref: a,
        role: E,
        sx: Z,
        ..._,
        children: o
    });
})), $0422a6ce4ea03acc$var$w_ = (r = "two")=>({
        h1: "h1",
        h2: "h2",
        h3: "h3",
        h4: "h4",
        h5: "h5",
        h6: "h6",
        one: "h1",
        two: "h2",
        three: "h3",
        four: "h4",
        five: "h5",
        six: "h6"
    })[r] || "h2", $0422a6ce4ea03acc$export$a8a3e93435678ff9 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { className: o, id: s, isCapitalized: i, isUppercase: p, isLowercase: C, level: v = "h2", noSpace: y, overline: L, size: M, subtitle: E, text: k, url: _, urlClass: Z, ...O } = r, B = $0422a6ce4ea03acc$var$w_(v), z = M || v, I = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Heading", {
        variant: z,
        isCapitalized: i,
        isUppercase: p,
        isLowercase: C,
        noSpace: y,
        url: _
    }), P = B;
    if (!r.children && !k) throw new Error("NYPL Reservoir Heading: No children or value was passed to the `text` prop.");
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(r.children) > 1) throw new Error("NYPL Reservoir Heading: Only pass one child into Heading.");
    let $ = 0;
    i && $++, p && $++, C && $++, $ > 1 && console.warn("NYPL Reservoir Heading: Multiple text case props have been passed and the component will not render properly.");
    const W = r.children ? r.children : k, l1 = _ ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$a6c7ac8248d6e38a, {
        className: Z,
        href: _,
        id: `${s}-link`,
        children: W
    }) : W, u1 = [
        "display1",
        "heading1",
        "heading2",
        "h1",
        "h2"
    ], m1 = u1.includes(z) ? "overline1" : "overline2", L1 = u1.includes(z) ? "subtitle1" : "subtitle2", E1 = I.headingWrapper, H1 = L || E ? {
        ...I.base
    } : {
        ...I.base,
        ...E1
    }, B1 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
        children: [
            L && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
                "aria-roledescription": "Subtitle",
                mb: "xxs",
                role: "paragraph",
                size: m1,
                children: L
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $eb70b29933175d72$export$a8a3e93435678ff9), {
                as: P,
                className: o,
                id: s,
                ref: a,
                sx: {
                    ...H1
                },
                ...O,
                children: l1
            }),
            E && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
                "aria-roledescription": "Subtitle",
                mt: "xs",
                noSpace: !0,
                role: "paragraph",
                size: L1,
                children: E
            })
        ]
    });
    return L || E ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "hgroup",
        role: "group",
        "aria-roledescription": "Heading group",
        sx: {
            ...E1
        },
        ...O,
        children: B1
    }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$x.Fragment, {
        children: B1
    });
})), $0422a6ce4ea03acc$var$H_ = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
];
function $0422a6ce4ea03acc$var$Yr({ title: r = "", id: a = "", customDefaultHeading: o, additionalStyles: s, headingSize: i }) {
    const p = a ? `${a}-heading` : void 0;
    let C = null;
    return r ? typeof r == "string" ? C = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$a8a3e93435678ff9, {
        size: i,
        id: p,
        __css: s,
        children: r
    }) : typeof r == "object" && (r.type === $0422a6ce4ea03acc$export$a8a3e93435678ff9 ? C = s ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(r, {
        __css: s
    }) : r : $0422a6ce4ea03acc$var$H_.includes(r.type) ? (C = r, console.warn("NYPL Reservoir useDSHeading: An HTML heading element was passed for the `title` or `headingText` prop in a Reservoir component. The heading will render without DS-specific styling.")) : console.warn("NYPL Reservoir useDSHeading: An unsupported heading element was passed to the `title` or `headingText` prop in a Reservoir component, so that component's title will not be rendered. Instead, a DS `Heading` component or an HTML heading element should be passed.")) : o && (C = o), C;
}
const $0422a6ce4ea03acc$export$75f76bb17920f318 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)(({ ariaAtomic: r = !0, ariaLive: a = "polite", className: o = "", id: s, isInvalid: i = !1, isRenderedText: p = !0, text: C, ...v }, y)=>{
    const L = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("HelperErrorText", {
        isInvalid: i
    }), M = {
        "aria-atomic": r,
        "aria-live": a === "off" ? void 0 : a,
        className: o,
        "data-isinvalid": i,
        id: s,
        ref: y,
        __css: L,
        ...v
    };
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        ...M,
        children: p ? typeof C == "string" ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            dangerouslySetInnerHTML: {
                __html: C
            },
            __css: L.innerChild
        }) : C : null
    });
})), $0422a6ce4ea03acc$var$g7 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { children: o, className: s, descriptionText: i, headingText: p, helperText: C, helperTextStyles: v = {}, id: y, invalidText: L, isInvalid: M = !1, showHelperInvalidText: E = !0, ...k } = r, _ = !!o, Z = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("ComponentWrapper", {
        hasChildren: _
    }), O = M ? L : C, B = $0422a6ce4ea03acc$var$Yr({
        id: y,
        title: p
    });
    return _ || console.warn("NYPL Reservoir ComponentWrapper: No children were passed."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        className: s,
        id: `${y}-wrapper`,
        ref: a,
        __css: Z,
        ...k,
        children: [
            B,
            i && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
                children: i
            }),
            o,
            O && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$75f76bb17920f318, {
                id: `${y}-helperText`,
                isInvalid: M,
                isRenderedText: E,
                text: O,
                __css: {
                    ...Z.helperErrorText,
                    ...v
                }
            })
        ]
    });
})), $0422a6ce4ea03acc$export$c78705ce95ea9726 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { activeLetters: o, className: s, currentLetter: i, descriptionText: p, headingText: C, id: v, isDisabled: y, onClick: L, ...M } = r, E = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("AlphabetFilter", {}), k = [
        {
            text: "#",
            value: "#"
        },
        {
            text: "A",
            value: "a"
        },
        {
            text: "B",
            value: "b"
        },
        {
            text: "C",
            value: "c"
        },
        {
            text: "D",
            value: "d"
        },
        {
            text: "E",
            value: "e"
        },
        {
            text: "F",
            value: "f"
        },
        {
            text: "G",
            value: "g"
        },
        {
            text: "H",
            value: "h"
        },
        {
            text: "I",
            value: "i"
        },
        {
            text: "J",
            value: "j"
        },
        {
            text: "K",
            value: "k"
        },
        {
            text: "L",
            value: "l"
        },
        {
            text: "M",
            value: "m"
        },
        {
            text: "N",
            value: "n"
        },
        {
            text: "O",
            value: "o"
        },
        {
            text: "P",
            value: "p"
        },
        {
            text: "Q",
            value: "q"
        },
        {
            text: "R",
            value: "r"
        },
        {
            text: "S",
            value: "s"
        },
        {
            text: "T",
            value: "t"
        },
        {
            text: "U",
            value: "u"
        },
        {
            text: "V",
            value: "v"
        },
        {
            text: "W",
            value: "w"
        },
        {
            text: "X",
            value: "x"
        },
        {
            text: "Y",
            value: "y"
        },
        {
            text: "Z",
            value: "z"
        },
        {
            text: "Show All",
            value: "showAll"
        }
    ], _ = (0, $acw62.useRef)(i), [Z, O] = (0, $acw62.useState)(i);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        i && i !== _.current && (O(i), _.current = i);
    }, [
        i,
        L
    ]);
    const B = ($, W)=>{
        $.preventDefault && $.preventDefault(), Z !== W && (O(W), L && L(W));
    }, z = (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("ui.gray.dark", "ui.gray.medium"), I = ($)=>{
        const W = Z === $.value && $.value !== "showAll", l1 = $.value === "showAll", u1 = y || o && !o.includes($.value) && !l1, m1 = W ? {
            ...E.button,
            border: "1px solid",
            borderColor: z
        } : {
            ...E.button,
            border: "1px solid transparent"
        };
        return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
            "aria-current": W ? "page" : null,
            "aria-label": $.text === "Show All" ? $.text : "Page " + $.text,
            buttonType: "text",
            id: `filter-${$.value}`,
            isDisabled: u1,
            sx: m1,
            onClick: (L1)=>{
                B(L1, $.value);
            },
            children: $.text
        }, $.value);
    }, P = ()=>k.map(($)=>I($));
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "nav",
        ref: a,
        "aria-label": "Filter by letter",
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$g7, {
            id: v,
            className: s,
            __css: E,
            ...M,
            headingText: C || void 0,
            descriptionText: p || void 0,
            children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2231dd843a1dfd59$export$f51f4c4ede09e011), {
                wrap: "wrap",
                children: P()
            })
        })
    });
})), $0422a6ce4ea03acc$var$x_ = [
    "libsyn",
    "soundcloud",
    "spotify"
], $0422a6ce4ea03acc$export$832cc5475f11d8b4 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { audioType: o, className: s, descriptionText: i, embedCode: p, headingText: C, helperText: v, id: y, iframeTitle: L = null, ...M } = r, [E, k] = (0, $acw62.useState)(!1), [_, Z] = (0, $acw62.useState)(void 0);
    (0, $acw62.useEffect)(()=>{
        const $ = $0422a6ce4ea03acc$var$V_(p);
        let W = !p || !$ || !B(o, $);
        $ && !$.title && ($.title = L || "Embedded audio player"), !!$0422a6ce4ea03acc$var$x_.find((m1)=>m1 === o) && !p && (console.warn("NYPL Reservoir AudioPlayer: The `embedCode` prop is required when using a 3rd party streaming service."), W = !0), k(W), Z($);
    }, [
        p,
        o,
        L
    ]);
    const O = "<strong>Error: </strong>This audio player has not been configured properly. Please contact the site administrator.";
    function B($, W) {
        var l1;
        return $ !== "file" && ((l1 = W == null ? void 0 : W.src) == null ? void 0 : l1.includes(`${$}.com`));
    }
    const z = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("AudioPlayer", {});
    function I() {
        return _ ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            dangerouslySetInnerHTML: {
                __html: _.outerHTML
            }
        }) : null;
    }
    const P = I();
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$g7, {
        className: `audioplayer ${s}`,
        headingText: C,
        descriptionText: i,
        helperText: v,
        id: `${y}-componentWrapper`,
        "data-testid": "audio-player-component",
        ref: a,
        __css: z.base,
        ...M,
        children: E ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            dangerouslySetInnerHTML: {
                __html: O
            },
            __css: z.invalid
        }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$x.Fragment, {
            children: P
        })
    });
}));
function $0422a6ce4ea03acc$var$V_(r) {
    var a, o;
    try {
        const s = new DOMParser().parseFromString(r, "text/html");
        if (((o = (a = s == null ? void 0 : s.body) == null ? void 0 : a.firstChild) == null ? void 0 : o.nodeName) === "IFRAME") return s.body.firstChild;
    } catch (s) {
        console.error(s);
    }
}
const $0422a6ce4ea03acc$var$M_ = {
    neutral: {
        name: "errorOutline",
        title: "Banner neutral icon",
        iconRotation: "rotate180"
    },
    informative: {
        name: "errorOutline",
        title: "Banner informative icon",
        iconRotation: "rotate180"
    },
    positive: {
        name: "actionCheckCircle",
        title: "Banner positive icon"
    },
    negative: {
        name: "errorOutline",
        title: "Banner negative icon"
    },
    warning: {
        name: "alertNotificationImportant",
        title: "Banner warning icon"
    },
    recommendation: {
        name: "actionLightbulb",
        title: "Banner recommendation icon"
    }
}, $0422a6ce4ea03acc$export$3b4e64e77073e307 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { ariaLabel: o, backgroundColor: s, className: i, content: p, heading: C, highlightColor: v, icon: y, id: L, isDismissible: M = !1, type: E = "neutral", ...k } = r, [_, Z] = (0, $acw62.useState)(!0), O = ()=>Z(!1), B = !!(s && v), z = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Banner", {
        // Only set the custom `backgroundColor` and `highlightColor` values
        // if they are both set.
        backgroundColor: B ? s : void 0,
        highlightColor: B ? v : void 0,
        // If `backgroundColor` and `highlightColor` are set, then it
        // overrides the Banner types.
        variant: B ? void 0 : E
    }), I = {
        size: "heading6",
        noSpace: !0,
        color: E === "negative" ? "ui.error.primary" : null,
        _dark: {
            color: E === "negative" ? "dark.ui.error.primary" : null
        }
    }, P = C ? typeof C == "string" ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$a8a3e93435678ff9, {
        level: "h2",
        text: C,
        ...I
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(C, I) : null, $ = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
        "aria-label": "Close the banner",
        buttonType: "text",
        id: `${L}-dismissible-button`,
        onClick: O,
        __css: z.dismissibleButton,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
            "data-testid": `${L}-dismissible-icon`,
            name: "close",
            size: "large",
            title: "Banner close icon"
        })
    }), W = y || /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
        className: "banner-icon",
        "data-testid": `${L}-banner-icon`,
        title: "Banner announcement icon",
        size: "large",
        ...$0422a6ce4ea03acc$var$M_[E],
        __css: P ? {
            marginTop: "xxxs"
        } : {}
    });
    return _ ? (s && !v && console.warn("NYPL Reservoir Banner: The `backgroundColor` prop has been passed, but the `highlightColor` prop has not been passed. Because of this, the `backgroundColor` prop will be ignored."), v && !s && console.warn("NYPL Reservoir Banner: The `highlightColor` prop has been passed, but the `backgroundColor` prop has not been passed. Because of this, the `highlightColor` prop will be ignored."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        "aria-label": o,
        as: "aside",
        className: i,
        "data-type": E,
        id: L,
        ref: a,
        __css: z.base,
        ...k,
        children: [
            W,
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                maxWidth: "800px",
                children: [
                    C && P,
                    p
                ]
            }),
            M && $
        ]
    })) : null;
}), {
    shouldForwardProp: ()=>!0
});
var $0422a6ce4ea03acc$var$Lo = void 0;
function $0422a6ce4ea03acc$var$E_() {
    var r = (0, $acw62.useState)($0422a6ce4ea03acc$var$Lo), a = r[0], o = r[1];
    return (0, $acw62.useEffect)(function() {
        $0422a6ce4ea03acc$var$Lo === void 0 && ($0422a6ce4ea03acc$var$Lo = "loading" in HTMLImageElement.prototype), o($0422a6ce4ea03acc$var$Lo);
    }, []), a;
}
var $0422a6ce4ea03acc$var$Up = /* @__PURE__ */ new Map(), $0422a6ce4ea03acc$var$Bu = /* @__PURE__ */ new WeakMap(), $0422a6ce4ea03acc$var$Fy = 0, $0422a6ce4ea03acc$var$S_ = void 0;
function $0422a6ce4ea03acc$var$k_(r) {
    return r ? ($0422a6ce4ea03acc$var$Bu.has(r) || ($0422a6ce4ea03acc$var$Fy += 1, $0422a6ce4ea03acc$var$Bu.set(r, $0422a6ce4ea03acc$var$Fy.toString())), $0422a6ce4ea03acc$var$Bu.get(r)) : "0";
}
function $0422a6ce4ea03acc$var$T_(r) {
    return Object.keys(r).sort().filter(function(a) {
        return r[a] !== void 0;
    }).map(function(a) {
        return a + "_" + (a === "root" ? $0422a6ce4ea03acc$var$k_(r.root) : r[a]);
    }).toString();
}
function $0422a6ce4ea03acc$var$__(r) {
    var a = $0422a6ce4ea03acc$var$T_(r), o = $0422a6ce4ea03acc$var$Up.get(a);
    if (!o) {
        var s = /* @__PURE__ */ new Map(), i, p = new IntersectionObserver(function(C) {
            C.forEach(function(v) {
                var y, L = v.isIntersecting && i.some(function(M) {
                    return v.intersectionRatio >= M;
                });
                r.trackVisibility && typeof v.isVisible > "u" && (v.isVisible = L), (y = s.get(v.target)) == null || y.forEach(function(M) {
                    M(L, v);
                });
            });
        }, r);
        i = p.thresholds || (Array.isArray(r.threshold) ? r.threshold : [
            r.threshold || 0
        ]), o = {
            id: a,
            observer: p,
            elements: s
        }, $0422a6ce4ea03acc$var$Up.set(a, o);
    }
    return o;
}
function $0422a6ce4ea03acc$var$D_(r, a, o, s) {
    if (o === void 0 && (o = {}), s === void 0 && (s = $0422a6ce4ea03acc$var$S_), typeof window.IntersectionObserver > "u" && s !== void 0) {
        var i = r.getBoundingClientRect();
        return a(s, {
            isIntersecting: s,
            target: r,
            intersectionRatio: typeof o.threshold == "number" ? o.threshold : 0,
            time: 0,
            boundingClientRect: i,
            intersectionRect: i,
            rootBounds: i
        }), function() {};
    }
    var p = $0422a6ce4ea03acc$var$__(o), C = p.id, v = p.observer, y = p.elements, L = y.get(r) || [];
    return y.has(r) || y.set(r, L), L.push(a), v.observe(r), function() {
        L.splice(L.indexOf(a), 1), L.length === 0 && (y.delete(r), v.unobserve(r)), y.size === 0 && (v.disconnect(), $0422a6ce4ea03acc$var$Up.delete(C));
    };
}
function $0422a6ce4ea03acc$var$R_(r) {
    var a = r === void 0 ? {} : r, o = a.threshold, s = a.delay, i = a.trackVisibility, p = a.rootMargin, C = a.root, v = a.triggerOnce, y = a.skip, L = a.initialInView, M = a.fallbackInView, E = a.onChange, k = $acw62.useRef(), _ = $acw62.useRef(), Z = $acw62.useState({
        inView: !!L
    }), O = Z[0], B = Z[1];
    _.current = E;
    var z = $acw62.useCallback(function(P) {
        k.current !== void 0 && (k.current(), k.current = void 0), !y && P && (k.current = $0422a6ce4ea03acc$var$D_(P, function($, W) {
            B({
                inView: $,
                entry: W
            }), _.current && _.current($, W), W.isIntersecting && v && k.current && (k.current(), k.current = void 0);
        }, {
            root: C,
            rootMargin: p,
            threshold: o,
            // @ts-ignore
            trackVisibility: i,
            // @ts-ignore
            delay: s
        }, M));
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string so it won't change between renders.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(o) ? o.toString() : o,
        C,
        p,
        v,
        y,
        i,
        M,
        s
    ]);
    $acw62.useEffect(function() {
        !k.current && O.entry && !v && !y && B({
            inView: !!L
        });
    });
    var I = [
        z,
        O.inView,
        O.entry
    ];
    return I.ref = I[0], I.inView = I[1], I.entry = I[2], I;
}
const $0422a6ce4ea03acc$var$Z_ = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((r)=>{
    const { additionalWrapperStyles: a = {}, className: o = "", children: s, ratio: i = "original", size: p = "default", sizeBasedOn: C = "width", ...v } = r, y = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("ReservoirImageWrapper", {
        ratio: i,
        size: p,
        sizeBasedOn: C
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        className: `the-wrap ${o}`,
        __css: {
            ...y.base,
            ...a
        },
        ...v,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            className: "the-crop",
            __css: y.crop,
            children: s
        })
    });
}), $0422a6ce4ea03acc$export$3e431a229df88919 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { additionalFigureStyles: o = {}, additionalImageStyles: s = {}, additionalWrapperStyles: i = {}, alt: p, aspectRatio: C = "original", caption: v, className: y = "", component: L, credit: M, fallbackSrc: E, imageType: k = "default", isLazy: _ = !1, onError: Z, size: O = "default", sizeBasedOn: B = "width", src: z, ...I } = r, P = $0422a6ce4ea03acc$var$E_(), [$, W] = $0422a6ce4ea03acc$var$R_({
        triggerOnce: !0,
        skip: P
    }), l1 = C !== "original", u1 = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("ReservoirImage", {
        variant: k,
        ratio: C,
        size: O,
        sizeBasedOn: B
    }), m1 = (k1)=>{
        console.warn("NYPL Reservoir Image: The initial image failed to load in the browser. The fallback image source will now be used."), k1.target.src = E || "", Z && Z(k1);
    };
    let L1 = null, E1, H1, B1 = _ ? {} : {
        src: z
    };
    if (p && p.length > 300) throw new Error("NYPL Reservoir Image: Alt text must be less than 300 characters.");
    _ && (W || P) && (E1 = $, B1 = {
        src: z
    }), H1 = (0, $a122a84052a653dd$export$74665b213cb5c4cf)(E1, a), L1 = L || /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "img",
        alt: p,
        loading: _ ? "lazy" : void 0,
        onError: m1,
        ...B1,
        __css: {
            ...u1.img,
            ...s
        },
        ...I
    });
    const h1 = l1 ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$Z_, {
        additionalWrapperStyles: i,
        ratio: C,
        className: y,
        size: O,
        sizeBasedOn: B,
        ...v || M ? {} : I,
        children: L1
    }) : L1;
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        ref: H1,
        children: v || M ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            as: "figure",
            __css: {
                ...u1.figure,
                ...o
            },
            children: [
                h1,
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                    as: "figcaption",
                    __css: u1.figcaption,
                    children: [
                        v && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$75f76bb17920f318, {
                            ariaLive: "off",
                            ariaAtomic: !1,
                            text: v
                        }),
                        M && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$75f76bb17920f318, {
                            ariaLive: "off",
                            ariaAtomic: !1,
                            text: M
                        })
                    ]
                })
            ]
        }) : h1
    });
}), {
    shouldForwardProp: ()=>!0
}), $0422a6ce4ea03acc$export$28c660c63b792dea = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { children: o, className: s, content: i, id: p, isDisabled: C, shouldWrapChildren: v, ...y } = r;
    typeof i != "string" && typeof i != "number" && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(i, (E)=>{
        (E.type !== $0422a6ce4ea03acc$export$f04a61298a47a40f || E.type !== $0422a6ce4ea03acc$export$3e431a229df88919) && console.warn("NYPL Reservoir Tooltip: Pass in a string, number, DS Icon, or DS Image into the 'content' prop.");
    });
    const L = v ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$g7, {
        width: "fit-content",
        children: o
    }) : o, M = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Tooltip", {});
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $00c5933d235d85a4$export$28c660c63b792dea), {
        "aria-label": typeof i != "string" ? "Tooltip" : void 0,
        closeDelay: 750,
        closeOnClick: !0,
        closeOnEsc: !0,
        closeOnMouseDown: !0,
        hasArrow: !0,
        isDisabled: C,
        label: i,
        openDelay: 500,
        placement: "top",
        ref: a,
        __css: M,
        ...y,
        children: L
    });
})), $0422a6ce4ea03acc$var$sp = 40, $0422a6ce4ea03acc$var$O_ = (r, a, o = !1, s = !1)=>{
    const i = r.text.length, p = i >= $0422a6ce4ea03acc$var$sp, C = i <= $0422a6ce4ea03acc$var$sp ? r.text : $0422a6ce4ea03acc$var$v_(r.text, $0422a6ce4ea03acc$var$sp), v = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $869a1a6e30ba82b2$export$ca871f5ef145e138), {
        href: r.url,
        "aria-current": s ? "page" : void 0,
        children: [
            o && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                name: "arrow",
                size: "small",
                iconRotation: "rotate90",
                id: `${a}__backarrow`,
                className: "breadcrumbs-icon",
                type: "breadcrumbs"
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                className: "breadcrumb-label",
                children: C
            })
        ]
    });
    return p ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$28c660c63b792dea, {
        content: r.text,
        id: `breadcrumb-${a}-tooltip`,
        children: v
    }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$x.Fragment, {
        children: v
    });
}, $0422a6ce4ea03acc$var$N_ = (r, a)=>r != null && r.length ? r.map((s, i)=>{
        const p = i === r.length - 2, C = i === r.length - 1;
        return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2bea20c9a7276351$export$c13f210c706eb549), {
            children: $0422a6ce4ea03acc$var$O_(s, a, p, C)
        }, i);
    }) : null, $0422a6ce4ea03acc$export$2dc68d50d56fbbd = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { breadcrumbsData: o, breadcrumbsType: s = "whatsOn", className: i, id: p, ...C } = r;
    if (!o || o.length === 0) throw new Error("NYPL Reservoir Breadcrumbs: No data was passed to the `breadcrumbsData` prop.");
    const v = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("CustomBreadcrumb", {
        variant: s
    }), y = $0422a6ce4ea03acc$var$N_(o, p);
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2bafe6f699b1942c$export$dabcc1ec9dd9d1cc), {
        "aria-label": "Breadcrumb",
        className: i,
        id: p,
        ref: a,
        __css: v,
        ...C,
        children: y
    });
})), $0422a6ce4ea03acc$export$69b1032f2ecdf404 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { buttonWidth: o = "default", children: s, className: i = "", id: p, isDisabled: C = !1, layout: v = "row", ...y } = r, L = [], M = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("ButtonGroup", {
        buttonWidth: o
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(s, (E, k)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(E)) {
            if (E.type !== $0422a6ce4ea03acc$export$353f5b6fc5456de1 && !(E.props.mdxType && E.props.mdxType === "Button")) {
                console.warn("NYPL Reservoir ButtonGroup: Only Button components can be children of ButtonGroup.");
                return;
            }
            const _ = C ? {
                isDisabled: C
            } : {};
            L.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(E, {
                key: k,
                ..._
            }));
        }
    }), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
        className: i,
        direction: {
            base: "column",
            md: v
        },
        id: p,
        ref: a,
        spacing: "xs",
        sx: M,
        ...y,
        children: L
    });
}));
function $0422a6ce4ea03acc$var$P_(r) {
    const { alt: a, aspectRatio: o, caption: s, component: i, credit: p, id: C, isAtEnd: v, isCentered: y, isLazy: L, layout: M, size: E, src: k } = r, _ = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("CardImage", {
        imageIsAtEnd: v,
        isCentered: y,
        layout: M,
        size: E
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: _,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$3e431a229df88919, {
            alt: a,
            aspectRatio: o,
            caption: s,
            component: i,
            credit: p,
            id: C,
            isLazy: L,
            size: E,
            src: k
        })
    });
}
const $0422a6ce4ea03acc$export$d7df4bcb9a53fba5 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)($0422a6ce4ea03acc$export$a8a3e93435678ff9), $0422a6ce4ea03acc$export$64ef9b8c11710c47 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((r)=>{
    const { children: a, ...o } = r, s = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("CardContent");
    return a ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: s,
        ...o,
        children: a
    }) : null;
}), $0422a6ce4ea03acc$export$9b6a647253f61c5f = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((r)=>{
    const { bottomBorder: a, children: o, isCentered: s, layout: i, topBorder: p, ...C } = r, v = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("CardActions", {
        bottomBorder: a,
        isCentered: s,
        layout: i,
        topBorder: p
    });
    return o ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: v,
        ...C,
        children: o
    }) : null;
}), $0422a6ce4ea03acc$var$j_ = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)(({ className: r, children: a, id: o, mainActionLink: s, styles: i, ...p }, C)=>s ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $e547ec39c1fbf140$export$d79f4543fbc1d78a), {
        id: o,
        className: r,
        ref: C,
        sx: i,
        ...p,
        children: a
    }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        id: o,
        className: r,
        ref: C,
        sx: i,
        ...p,
        children: a
    })));
function $0422a6ce4ea03acc$var$z_({ children: r, mainActionLink: a }) {
    return a ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $e547ec39c1fbf140$export$155d86d4b6139452), {
        href: a,
        children: r
    }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$x.Fragment, {
        children: r
    });
}
const $0422a6ce4ea03acc$export$60332b2344f7fe41 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { backgroundColor: o, children: s, className: i, foregroundColor: p, id: C, imageProps: v = {
        alt: "",
        aspectRatio: "square",
        caption: void 0,
        component: void 0,
        credit: void 0,
        id: void 0,
        isAtEnd: !1,
        isLazy: !1,
        size: "default",
        src: ""
    }, isAlignedRightActions: y = !1, isBordered: L, isCentered: M = !1, layout: E = "column", mainActionLink: k, ..._ } = r, Z = v.src || v.component, O = v.component ? "original" : v.aspectRatio, B = {}, z = [], I = [];
    let P = 0;
    v.component && v.aspectRatio && console.warn("NYPL Reservoir Card: Both the `imageProps.component` and `imageProps.aspectRatio` props were set but `imageProps.aspectRatio` will be ignored in favor of the aspect ratio on `imageProps.component` prop."), o && (B.backgroundColor = o), p && (B.color = p);
    const $ = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("ReservoirCard", {
        hasImage: Z,
        imageIsAtEnd: v.isAtEnd,
        isAlignedRightActions: y,
        isBordered: L,
        isCentered: M,
        layout: E,
        mainActionLink: k
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(s, (W, l1)=>{
        const u1 = W.type === $0422a6ce4ea03acc$export$9b6a647253f61c5f || W.props.mdxType === "CardActions";
        if (W.type === $0422a6ce4ea03acc$export$d7df4bcb9a53fba5 || W.props.mdxType === "CardHeading") {
            const m1 = P === 0 ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$z_, {
                mainActionLink: k,
                children: W.props.children
            }) : W.props.children, L1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(W, {
                key: l1,
                // Override the child text with the potential `CardLinkOverlay`.
                children: m1,
                layout: E,
                __css: $.heading
            });
            z.push(L1), P++;
        } else if (W.type === $0422a6ce4ea03acc$export$64ef9b8c11710c47 || W.props.mdxType === "CardContent") {
            const m1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(W, {
                key: l1
            });
            z.push(m1);
        } else if (u1) {
            const m1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(W, {
                key: l1,
                isCentered: M,
                layout: E
            });
            y && E === "row" ? I.push(m1) : z.push(m1);
        }
    }), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$j_, {
        id: C,
        className: i,
        mainActionLink: k,
        ref: a,
        styles: {
            ...$.base,
            ...B
        },
        ..._,
        children: [
            Z && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$P_, {
                alt: v.alt,
                aspectRatio: O,
                caption: v.caption,
                component: v.component,
                credit: v.credit,
                id: v.id,
                isAtEnd: v.isAtEnd,
                isLazy: v.isLazy,
                layout: E,
                size: v.size,
                src: v.src ? v.src : void 0
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                className: "card-body",
                __css: $.body,
                children: z
            }),
            I.length ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                className: "card-right",
                __css: {
                    ...$.body,
                    ...$.actions
                },
                children: I
            }) : null
        ]
    });
}));
function $0422a6ce4ea03acc$var$U_(r) {
    const { isIndeterminate: a, isChecked: o, ...s } = r;
    return o || a ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $6a96cde036d65913$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...s,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("path", {
            fill: "currentColor",
            d: "M8.795 15.875l-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41-10.59 10.58z"
        })
    }) : null;
}
const $0422a6ce4ea03acc$export$48513f6b9f8ce62d = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { className: o, helperText: s, id: i, invalidText: p, isChecked: C, isDisabled: v = !1, isIndeterminate: y = !1, isInvalid: L = !1, isRequired: M = !1, labelText: E, name: k, onChange: _, showHelperInvalidText: Z = !0, showLabel: O = !0, value: B, ...z } = r, I = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Checkbox", {}), P = L ? p : s, $ = y ? void 0 : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$U_, {}), W = $0422a6ce4ea03acc$var$Uo({
        footnote: P,
        id: i,
        labelText: E,
        name: "Checkbox",
        showLabel: O
    });
    return i || console.warn("NYPL Reservoir Checkbox: This component's required `id` prop was not passed."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$g7, {
        helperText: s,
        helperTextStyles: I.helperErrorText,
        id: i,
        invalidText: p,
        isInvalid: L,
        showHelperInvalidText: Z,
        ...z,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $73e9428c5f13ea0d$export$48513f6b9f8ce62d), {
            className: o,
            icon: $,
            id: i,
            isDisabled: v,
            isIndeterminate: y,
            isInvalid: L,
            isRequired: M,
            name: k || "default",
            ref: a,
            value: B,
            ...C !== void 0 ? {
                isChecked: C,
                onChange: _
            } : {
                defaultChecked: !1
            },
            __css: I.base,
            ...W,
            children: O && E
        })
    });
})), $0422a6ce4ea03acc$export$e154be390aa0e14 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)(({ children: r, className: a, id: o, isLegendHidden: s = !1, isRequired: i = !1, legendText: p, showRequiredLabel: C = !0, ...v }, y)=>{
    const L = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Fieldset", {
        isLegendHidden: s
    });
    return o || console.warn("NYPL Reservoir Fieldset: This component's required `id` prop was not passed."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "fieldset",
        id: o,
        className: a,
        ref: y,
        __css: L,
        ...v,
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("legend", {
                children: [
                    p,
                    C && i && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                        children: " (Required)"
                    })
                ]
            }),
            r
        ]
    });
})), $0422a6ce4ea03acc$var$I_ = {
    px: "1px",
    0: "0",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
}, $0422a6ce4ea03acc$var$r3 = {
    xxxs: "0.125rem",
    // 2px
    xxs: "0.25rem",
    // 4px
    xs: "0.5rem",
    // 8px
    s: "1rem",
    // 16px
    m: "1.5rem",
    // 24px
    l: "2rem",
    // 32px
    xl: "3rem",
    // 48px
    xxl: "4rem",
    // 64px
    xxxl: "6rem"
}, $0422a6ce4ea03acc$var$$_ = {
    // Reservoir generic tokens
    xxxs: $0422a6ce4ea03acc$var$r3.xxxs,
    xxs: $0422a6ce4ea03acc$var$r3.xxs,
    xs: $0422a6ce4ea03acc$var$r3.xs,
    s: $0422a6ce4ea03acc$var$r3.s,
    m: $0422a6ce4ea03acc$var$r3.m,
    l: $0422a6ce4ea03acc$var$r3.l,
    xl: $0422a6ce4ea03acc$var$r3.xl,
    xxl: $0422a6ce4ea03acc$var$r3.xxl,
    xxxl: $0422a6ce4ea03acc$var$r3.xxxl,
    // Reservoir semantic tokens
    button: {
        small: {
            px: $0422a6ce4ea03acc$var$r3.xs,
            py: $0422a6ce4ea03acc$var$r3.xxs
        },
        medium: {
            px: $0422a6ce4ea03acc$var$r3.s,
            py: $0422a6ce4ea03acc$var$r3.xs
        },
        large: {
            px: $0422a6ce4ea03acc$var$r3.l,
            py: $0422a6ce4ea03acc$var$r3.s
        }
    },
    input: {
        group: {
            button: {
                hstack: $0422a6ce4ea03acc$var$r3.xs,
                vstack: $0422a6ce4ea03acc$var$r3.xs
            },
            default: {
                hstack: $0422a6ce4ea03acc$var$r3.l,
                vstack: $0422a6ce4ea03acc$var$r3.s
            }
        }
    },
    inset: {
        default: $0422a6ce4ea03acc$var$r3.s,
        extranarrow: $0422a6ce4ea03acc$var$r3.xxs,
        extrawide: $0422a6ce4ea03acc$var$r3.xl,
        narrow: $0422a6ce4ea03acc$var$r3.xs,
        wide: $0422a6ce4ea03acc$var$r3.l
    },
    grid: {
        default: $0422a6ce4ea03acc$var$r3.l,
        xxs: $0422a6ce4ea03acc$var$r3.xxs,
        xs: $0422a6ce4ea03acc$var$r3.xs,
        s: $0422a6ce4ea03acc$var$r3.s,
        m: $0422a6ce4ea03acc$var$r3.m,
        l: $0422a6ce4ea03acc$var$r3.l,
        xl: $0422a6ce4ea03acc$var$r3.xl,
        xxl: $0422a6ce4ea03acc$var$r3.xxl
    },
    page: {
        hstack: $0422a6ce4ea03acc$var$r3.l,
        vstack: $0422a6ce4ea03acc$var$r3.l
    },
    table: {
        column: $0422a6ce4ea03acc$var$r3.m,
        row: $0422a6ce4ea03acc$var$r3.l
    }
}, $0422a6ce4ea03acc$var$No = {
    ...$0422a6ce4ea03acc$var$I_,
    ...$0422a6ce4ea03acc$var$$_
}, $0422a6ce4ea03acc$export$4aa08d5625cb8ead = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { children: o, defaultValue: s = [], helperText: i, id: p, invalidText: C, isDisabled: v = !1, isFullWidth: y = !1, isInvalid: L = !1, isRequired: M = !1, labelText: E, layout: k = "column", name: _, onChange: Z, showHelperInvalidText: O = !0, showLabel: B = !0, showRequiredLabel: z = !0, value: I, ...P } = r, $ = L ? C : i, W = [], l1 = k === "column" ? $0422a6ce4ea03acc$var$No.input.group.default.vstack : $0422a6ce4ea03acc$var$No.input.group.default.hstack, u1 = s && Z ? {
        defaultValue: s,
        onChange: Z
    } : {};
    I && (u1.value = I), p || console.warn("NYPL Reservoir CheckboxGroup: This component's required `id` prop was not passed."), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(o, (L1, E1)=>{
        if (L1 != null) {
            const H1 = {
                key: E1,
                id: `${p}-${E1}`,
                name: _,
                isDisabled: v,
                isInvalid: L,
                isRequired: M
            };
            W.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(L1, H1));
        }
    });
    const m1 = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("CheckboxGroup", {
        isFullWidth: y
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$e154be390aa0e14, {
        id: `${p}-checkbox-group`,
        isLegendHidden: !B,
        isRequired: M,
        legendText: E,
        showRequiredLabel: z,
        ...P,
        __css: m1,
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $93764e9c0d6168cd$export$4aa08d5625cb8ead), {
                ...u1,
                children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
                    id: p,
                    "data-testid": "checkbox-group",
                    direction: [
                        k
                    ],
                    spacing: l1,
                    ref: a,
                    children: W
                })
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$75f76bb17920f318, {
                id: `${p}-helperErrorText`,
                isInvalid: L,
                isRenderedText: O,
                text: $,
                __css: m1.helperErrorText
            })
        ]
    });
})), $0422a6ce4ea03acc$export$54ec01a60f47d33d = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { className: o, columnHeaders: s = [], columnHeadersBackgroundColor: i, columnHeadersTextColor: p, id: C, showRowDividers: v = !1, tableData: y, titleText: L, useRowHeaders: M = !1, ...E } = r, k = {};
    i && (k.backgroundColor = i), p && (k.color = p);
    const _ = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("CustomTable", {
        columnHeadersBackgroundColor: i,
        columnHeadersTextColor: p,
        showRowDividers: v,
        useRowHeaders: M
    }), Z = L && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $a9ae7f9b183649d4$export$35468a455d619eb3), {
        children: L
    }), O = s.length > 0 ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $11888b100e285bcc$export$5de8fa06af5ae15a), {
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $0a8ed41bdf8d449b$export$3be148b8762ca608), {
            children: s.map((z, I)=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $04b44620787a4a6f$export$478f015b832c0fb2), {
                    scope: "col",
                    sx: k,
                    children: z
                }, I))
        })
    }) : console.warn("NYPL Reservoir Table: Column headers have not been set. For improved accessibility, column headers are required."), B = ()=>{
        if (!Array.isArray(y) || y.length <= 0 || y[0].constructor !== Array) return console.warn("NYPL Reservoir Table: Data in the `tableData` prop must be a two dimensional array."), null;
        for(let I = 1; I < y.length; I++)if (y[0].length !== y[I].length) {
            console.warn("NYPL Reservoir Table: The number of columns in each row of the data table are not identical. The `Table` component may not render properly.");
            break;
        }
        const z = (I, P)=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                children: [
                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                        as: "span",
                        display: {
                            base: "block",
                            md: "none"
                        },
                        children: s[I]
                    }),
                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                        children: P
                    })
                ]
            });
        return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $09ab4539f9138387$export$e4d84274604d936d), {
            children: y.map((I, P)=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $0a8ed41bdf8d449b$export$3be148b8762ca608), {
                    children: I.map(($, W)=>W === 0 && M ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $04b44620787a4a6f$export$478f015b832c0fb2), {
                            scope: "row",
                            children: z(W, $)
                        }, W) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $e16b8042114e7e75$export$8f04ceab90eac988), {
                            children: z(W, $)
                        }, W))
                }, P))
        });
    };
    for(let z = 0; z < y.length; z++)if (s.length && s.length !== y[z].length) {
        console.warn("NYPL Reservoir Table: The number of column headers in the `columnHeaders` prop is not equal to the number of columns in the data table. The `Table` component may not render properly.");
        break;
    }
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $e712627fd3084ab1$export$54ec01a60f47d33d), {
        className: o,
        id: C,
        ref: a,
        sx: _,
        ...E,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                Z,
                O,
                B()
            ]
        })
    });
})), $0422a6ce4ea03acc$var$o8 = (r)=>{
    const { backgroundColor: a, border: o, darkBorder: s } = r;
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
        style: {
            backgroundColor: a,
            border: !o && !s ? null : s ? "1px solid #191919" : "1px solid #E9E9E9",
            display: "inline-block",
            height: "1rem",
            marginRight: ".5rem",
            verticalAlign: "middle",
            width: "1rem"
        }
    });
}, $0422a6ce4ea03acc$var$Q_ = (r)=>{
    const { dataBgPageColor: a, dataBgDefaultColor: o, dataDarkBgPageColor: s, dataDarkBgDefaultColor: i, dataBlackColor: p = [
        "--",
        "--",
        "--"
    ], dataDarkHeadingColor: C, dataDarkBodyColor: v, dataWhiteColor: y = [
        "--",
        "--",
        "--"
    ], dataBrandPrimaryColor: L, dataBrandSecondaryColor: M, textColor: E = "ui.white" } = r, k = ()=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
            color: E,
            decorative: !0,
            marginStart: "xxs",
            name: "check",
            size: "medium",
            type: "default",
            verticalAlign: "text-bottom"
        }), _ = (G1, R1 = "small")=>{
        const E2 = R1 === "small" ? 1 : 2;
        return (G1[E2] === "AA" || G1[E2] === "AAA") && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx(k, {});
    }, Z = [
        "Color",
        "Ratio",
        "16px",
        "36px"
    ], O = _(y), B = _(y, "large"), z = _(p), I = _(p, "large"), P = L && _(L), $ = L && _(L, "large"), W = M && _(M), l1 = M && _(M, "large"), u1 = a && _(a), m1 = a && _(a, "large"), L1 = o && _(o), E1 = o && _(o, "large"), H1 = s && _(s), B1 = s && _(s, "large"), h1 = i && _(i), k1 = i && _(i, "large"), I1 = C && _(C), D1 = C && _(C, "large"), s2 = v && _(v), f1 = v && _(v, "large"), M1 = [
        [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
                style: {
                    padding: 0
                },
                children: [
                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$o8, {
                        backgroundColor: "white",
                        border: !0
                    }),
                    "ui.white"
                ]
            }, "colorUiWhite"),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                children: `${y[0]}:1`
            }, "colorUiWhiteRatio"),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                children: [
                    y[1],
                    O
                ]
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                children: [
                    y[2],
                    B
                ]
            })
        ],
        [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
                style: {
                    padding: 0
                },
                children: [
                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$o8, {
                        backgroundColor: "black",
                        darkBorder: !0
                    }),
                    "ui.black"
                ]
            }, "colorUiBlack"),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                children: `${p[0]}:1`
            }, "colorUiBlackRatio"),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                children: [
                    p[1],
                    z
                ]
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                children: [
                    p[2],
                    I
                ]
            })
        ]
    ], g1 = {
        borderColor: E === "ui.white" ? "white !important" : "black !important",
        fontSize: "text.tag",
        fontWeight: "medium",
        py: "xs"
    }, K1 = {
        tbody: {
            td: {
                ...g1,
                borderBottom: `1px solid ${g1.borderColor}`,
                color: E === "ui.white" ? "#FFF !important" : "#000 !important",
                // This is a hack to override other color assignments
                span: {
                    color: E === "ui.white" ? "#FFF !important" : "#000 !important"
                }
            },
            th: {
                borderBottom: `1px solid ${g1.borderColor}`,
                textTransform: "none",
                ...g1,
                _first: {
                    span: {
                        color: E
                    }
                }
            }
        },
        thead: {
            th: {
                color: E,
                borderBottom: "1px solid !important",
                textTransform: "uppercase",
                ...g1
            }
        }
    };
    return L && L.length > 0 && M1.push([
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
            style: {
                padding: 0
            },
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$o8, {
                    backgroundColor: "var(--nypl-colors-brand-primary)"
                }),
                "brand.primary"
            ]
        }, "colorBrandPrimaryPage"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
            children: `${L[0]}:1`
        }, "colorBrandPrimaryPageRatio"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                L[1],
                P
            ]
        }),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                L[2],
                $
            ]
        })
    ]), M && M.length > 0 && M1.push([
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
            style: {
                padding: 0
            },
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$o8, {
                    backgroundColor: "var(--nypl-colors-brand-secondary)"
                }),
                "brand.secondary"
            ]
        }, "colorBrandSecondaryPage"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
            children: `${M[0]}:1`
        }, "colorBrandSecondaryPageRatio"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                M[1],
                W
            ]
        }),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                M[2],
                l1
            ]
        })
    ]), a && a.length > 0 && M1.push([
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
            style: {
                padding: 0
            },
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$o8, {
                    backgroundColor: "var(--nypl-colors-ui-bg-page)",
                    border: !0
                }),
                "ui.bg.page"
            ]
        }, "colorBgPage"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
            children: `${a[0]}:1`
        }, "colorBgPageRatio"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                a[1],
                u1
            ]
        }),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                a[2],
                m1
            ]
        })
    ]), o && o.length > 0 && M1.push([
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
            style: {
                padding: 0
            },
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$o8, {
                    backgroundColor: "var(--nypl-colors-ui-bg-default)"
                }),
                "ui.bg.default"
            ]
        }, "colorBgDefault"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
            children: `${o[0]}:1`
        }, "colorBgDefaultRatio"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                o[1],
                L1
            ]
        }),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                o[2],
                E1
            ]
        })
    ]), s && s.length > 0 && M1.push([
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
            style: {
                padding: 0
            },
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$o8, {
                    backgroundColor: "var(--nypl-colors-dark-ui-bg-page)"
                }),
                "dark.ui.bg.page"
            ]
        }, "colorDarkBgPage"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
            children: `${s[0]}:1`
        }, "colorDarkBgPageRatio"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                s[1],
                H1
            ]
        }),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                s[2],
                B1
            ]
        })
    ]), i && i.length > 0 && M1.push([
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
            style: {
                padding: 0
            },
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$o8, {
                    backgroundColor: "var(--nypl-colors-dark-ui-bg-default)"
                }),
                "dark.ui.bg.default"
            ]
        }, "colorDarkBgDefault"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
            children: `${i[0]}:1`
        }, "colorDarkBgDefaultRatio"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                i[1],
                h1
            ]
        }),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                i[2],
                k1
            ]
        })
    ]), C && C.length > 0 && M1.push([
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
            style: {
                padding: 0
            },
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$o8, {
                    backgroundColor: "var(--nypl-colors-ui-typography-heading)"
                }),
                "ui.typography.heading"
            ]
        }, "colorDarkHeading"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
            children: `${C[0]}:1`
        }, "colorDarkHeadingRatio"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                C[1],
                I1
            ]
        }),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                C[2],
                D1
            ]
        })
    ]), v && v.length > 0 && M1.push([
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
            style: {
                padding: 0
            },
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$o8, {
                    backgroundColor: "var(--nypl-colors-ui-typography-body)"
                }),
                "ui.typography.body"
            ]
        }, "colorDarkText"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
            children: `${v[0]}:1`
        }, "colorDarkTextRatio"),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                v[1],
                s2
            ]
        }),
        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                v[2],
                f1
            ]
        })
    ]), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$54ec01a60f47d33d, {
        className: "storybook-colors-example",
        columnHeaders: Z,
        showRowDividers: !0,
        sx: K1,
        tableData: M1,
        useRowHeaders: !0
    });
}, $0422a6ce4ea03acc$export$e262a8b4626d113b = (r)=>{
    const { backgroundColor: a, dataBgPageColor: o, dataBgDefaultColor: s, dataDarkBgPageColor: i, dataDarkBgDefaultColor: p, colorName: C = "", colorSource: v, dataBlackColor: y = [
        "--",
        "--",
        "--"
    ], dataDarkHeadingColor: L, dataDarkBodyColor: M, dataWhiteColor: E = [
        "--",
        "--",
        "--"
    ], dataBrandPrimaryColor: k, dataBrandSecondaryColor: _, notes: Z, textColor: O = "ui.white" } = r, B = `--nypl-colors-${C.replace(/\./g, "-")}`, z = a === "ui.white" || a === "ui.typography.inverse.heading" || a === "ui.typography.inverse.body" ? "1px solid var(--nypl-colors-ui-gray-light-cool)" : void 0;
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        bg: a,
        color: O,
        px: "m",
        paddingBottom: "m",
        paddingTop: "s",
        border: z,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $5e01b023a0ac6ac7$export$15e411dc07b9c834), {
            alignItems: "top",
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                    width: "80%",
                    children: [
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$a8a3e93435678ff9, {
                            noSpace: !0,
                            size: "heading5",
                            border: "none",
                            color: O,
                            pb: "0",
                            children: a
                        }),
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
                            fontWeight: "medium",
                            lineHeight: "20px",
                            noSpace: !0,
                            size: "tag",
                            m: "0",
                            color: O,
                            children: [
                                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                                    style: {
                                        fontWeight: "bold"
                                    },
                                    children: "CSS:"
                                }),
                                " ",
                                `var(${B})`
                            ]
                        }),
                        v && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
                            color: O,
                            fontWeight: "medium",
                            lineHeight: "20px",
                            m: "0",
                            noSpace: !0,
                            size: "tag",
                            children: [
                                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                                    style: {
                                        fontWeight: "bold"
                                    },
                                    children: "Source:"
                                }),
                                " ",
                                v
                            ]
                        }),
                        Z && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
                            color: O,
                            fontWeight: "medium",
                            lineHeight: "20px",
                            noSpace: !0,
                            size: "tag",
                            children: [
                                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                                    style: {
                                        fontWeight: "bold"
                                    },
                                    children: "Notes:"
                                }),
                                " ",
                                Z
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$Q_, {
                    dataBgPageColor: o,
                    dataBgDefaultColor: s,
                    dataDarkBgPageColor: i,
                    dataDarkBgDefaultColor: p,
                    dataBlackColor: y,
                    dataDarkHeadingColor: L,
                    dataDarkBodyColor: M,
                    dataWhiteColor: E,
                    dataBrandPrimaryColor: k,
                    dataBrandSecondaryColor: _,
                    textColor: O
                })
            ]
        })
    });
};
var $0422a6ce4ea03acc$var$fb = {
    exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ (function(r) {
    (function() {
        var a = {}.hasOwnProperty;
        function o() {
            for(var p = "", C = 0; C < arguments.length; C++){
                var v = arguments[C];
                v && (p = i(p, s(v)));
            }
            return p;
        }
        function s(p) {
            if (typeof p == "string" || typeof p == "number") return p;
            if (typeof p != "object") return "";
            if (Array.isArray(p)) return o.apply(null, p);
            if (p.toString !== Object.prototype.toString && !p.toString.toString().includes("[native code]")) return p.toString();
            var C = "";
            for(var v in p)a.call(p, v) && p[v] && (C = i(C, v));
            return C;
        }
        function i(p, C) {
            return C ? p ? p + " " + C : p + C : p;
        }
        r.exports ? (o.default = o, r.exports = o) : window.classNames = o;
    })();
})($0422a6ce4ea03acc$var$fb);
var $0422a6ce4ea03acc$var$q_ = $0422a6ce4ea03acc$var$fb.exports;
const $0422a6ce4ea03acc$var$L5 = /* @__PURE__ */ $0422a6ce4ea03acc$var$zo($0422a6ce4ea03acc$var$q_);
function $0422a6ce4ea03acc$var$D6(r) {
    "@babel/helpers - typeof";
    return $0422a6ce4ea03acc$var$D6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
    } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, $0422a6ce4ea03acc$var$D6(r);
}
function $0422a6ce4ea03acc$var$F1(r, a) {
    if (a.length < r) throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + a.length + " present");
}
function $0422a6ce4ea03acc$var$yh(r) {
    return $0422a6ce4ea03acc$var$F1(1, arguments), r instanceof Date || $0422a6ce4ea03acc$var$D6(r) === "object" && Object.prototype.toString.call(r) === "[object Date]";
}
function $0422a6ce4ea03acc$var$a2(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = Object.prototype.toString.call(r);
    return r instanceof Date || $0422a6ce4ea03acc$var$D6(r) === "object" && a === "[object Date]" ? new Date(r.getTime()) : typeof r == "number" || a === "[object Number]" ? new Date(r) : ((typeof r == "string" || a === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function $0422a6ce4ea03acc$var$nc(r) {
    if ($0422a6ce4ea03acc$var$F1(1, arguments), !$0422a6ce4ea03acc$var$yh(r) && typeof r != "number") return !1;
    var a = $0422a6ce4ea03acc$var$a2(r);
    return !isNaN(Number(a));
}
function $0422a6ce4ea03acc$var$q2(r) {
    if (r === null || r === !0 || r === !1) return NaN;
    var a = Number(r);
    return isNaN(a) ? a : a < 0 ? Math.ceil(a) : Math.floor(a);
}
function $0422a6ce4ea03acc$var$Lh(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r).getTime(), s = $0422a6ce4ea03acc$var$q2(a);
    return new Date(o + s);
}
function $0422a6ce4ea03acc$var$pb(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a);
    return $0422a6ce4ea03acc$var$Lh(r, -o);
}
var $0422a6ce4ea03acc$var$G_ = 864e5;
function $0422a6ce4ea03acc$var$X_(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getTime();
    a.setUTCMonth(0, 1), a.setUTCHours(0, 0, 0, 0);
    var s = a.getTime(), i = o - s;
    return Math.floor(i / $0422a6ce4ea03acc$var$G_) + 1;
}
function $0422a6ce4ea03acc$var$Qr(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = 1, o = $0422a6ce4ea03acc$var$a2(r), s = o.getUTCDay(), i = (s < a ? 7 : 0) + s - a;
    return o.setUTCDate(o.getUTCDate() - i), o.setUTCHours(0, 0, 0, 0), o;
}
function $0422a6ce4ea03acc$var$hb(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getUTCFullYear(), s = /* @__PURE__ */ new Date(0);
    s.setUTCFullYear(o + 1, 0, 4), s.setUTCHours(0, 0, 0, 0);
    var i = $0422a6ce4ea03acc$var$Qr(s), p = /* @__PURE__ */ new Date(0);
    p.setUTCFullYear(o, 0, 4), p.setUTCHours(0, 0, 0, 0);
    var C = $0422a6ce4ea03acc$var$Qr(p);
    return a.getTime() >= i.getTime() ? o + 1 : a.getTime() >= C.getTime() ? o : o - 1;
}
function $0422a6ce4ea03acc$var$K_(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$hb(r), o = /* @__PURE__ */ new Date(0);
    o.setUTCFullYear(a, 0, 4), o.setUTCHours(0, 0, 0, 0);
    var s = $0422a6ce4ea03acc$var$Qr(o);
    return s;
}
var $0422a6ce4ea03acc$var$J_ = 6048e5;
function $0422a6ce4ea03acc$var$mb(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = $0422a6ce4ea03acc$var$Qr(a).getTime() - $0422a6ce4ea03acc$var$K_(a).getTime();
    return Math.round(o / $0422a6ce4ea03acc$var$J_) + 1;
}
var $0422a6ce4ea03acc$var$eD = {};
function $0422a6ce4ea03acc$var$Rt() {
    return $0422a6ce4ea03acc$var$eD;
}
function $0422a6ce4ea03acc$var$_t(r, a) {
    var o, s, i, p, C, v, y, L;
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var M = $0422a6ce4ea03acc$var$Rt(), E = $0422a6ce4ea03acc$var$q2((o = (s = (i = (p = a == null ? void 0 : a.weekStartsOn) !== null && p !== void 0 ? p : a == null || (C = a.locale) === null || C === void 0 || (v = C.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && i !== void 0 ? i : M.weekStartsOn) !== null && s !== void 0 ? s : (y = M.locale) === null || y === void 0 || (L = y.options) === null || L === void 0 ? void 0 : L.weekStartsOn) !== null && o !== void 0 ? o : 0);
    if (!(E >= 0 && E <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var k = $0422a6ce4ea03acc$var$a2(r), _ = k.getUTCDay(), Z = (_ < E ? 7 : 0) + _ - E;
    return k.setUTCDate(k.getUTCDate() - Z), k.setUTCHours(0, 0, 0, 0), k;
}
function $0422a6ce4ea03acc$var$bh(r, a) {
    var o, s, i, p, C, v, y, L;
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var M = $0422a6ce4ea03acc$var$a2(r), E = M.getUTCFullYear(), k = $0422a6ce4ea03acc$var$Rt(), _ = $0422a6ce4ea03acc$var$q2((o = (s = (i = (p = a == null ? void 0 : a.firstWeekContainsDate) !== null && p !== void 0 ? p : a == null || (C = a.locale) === null || C === void 0 || (v = C.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && i !== void 0 ? i : k.firstWeekContainsDate) !== null && s !== void 0 ? s : (y = k.locale) === null || y === void 0 || (L = y.options) === null || L === void 0 ? void 0 : L.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
    if (!(_ >= 1 && _ <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var Z = /* @__PURE__ */ new Date(0);
    Z.setUTCFullYear(E + 1, 0, _), Z.setUTCHours(0, 0, 0, 0);
    var O = $0422a6ce4ea03acc$var$_t(Z, a), B = /* @__PURE__ */ new Date(0);
    B.setUTCFullYear(E, 0, _), B.setUTCHours(0, 0, 0, 0);
    var z = $0422a6ce4ea03acc$var$_t(B, a);
    return M.getTime() >= O.getTime() ? E + 1 : M.getTime() >= z.getTime() ? E : E - 1;
}
function $0422a6ce4ea03acc$var$tD(r, a) {
    var o, s, i, p, C, v, y, L;
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var M = $0422a6ce4ea03acc$var$Rt(), E = $0422a6ce4ea03acc$var$q2((o = (s = (i = (p = a == null ? void 0 : a.firstWeekContainsDate) !== null && p !== void 0 ? p : a == null || (C = a.locale) === null || C === void 0 || (v = C.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && i !== void 0 ? i : M.firstWeekContainsDate) !== null && s !== void 0 ? s : (y = M.locale) === null || y === void 0 || (L = y.options) === null || L === void 0 ? void 0 : L.firstWeekContainsDate) !== null && o !== void 0 ? o : 1), k = $0422a6ce4ea03acc$var$bh(r, a), _ = /* @__PURE__ */ new Date(0);
    _.setUTCFullYear(k, 0, E), _.setUTCHours(0, 0, 0, 0);
    var Z = $0422a6ce4ea03acc$var$_t(_, a);
    return Z;
}
var $0422a6ce4ea03acc$var$nD = 6048e5;
function $0422a6ce4ea03acc$var$vb(r, a) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$_t(o, a).getTime() - $0422a6ce4ea03acc$var$tD(o, a).getTime();
    return Math.round(s / $0422a6ce4ea03acc$var$nD) + 1;
}
function $0422a6ce4ea03acc$var$N3(r, a) {
    for(var o = r < 0 ? "-" : "", s = Math.abs(r).toString(); s.length < a;)s = "0" + s;
    return o + s;
}
var $0422a6ce4ea03acc$var$f0 = {
    // Year
    y: function(a, o) {
        var s = a.getUTCFullYear(), i = s > 0 ? s : 1 - s;
        return $0422a6ce4ea03acc$var$N3(o === "yy" ? i % 100 : i, o.length);
    },
    // Month
    M: function(a, o) {
        var s = a.getUTCMonth();
        return o === "M" ? String(s + 1) : $0422a6ce4ea03acc$var$N3(s + 1, 2);
    },
    // Day of the month
    d: function(a, o) {
        return $0422a6ce4ea03acc$var$N3(a.getUTCDate(), o.length);
    },
    // AM or PM
    a: function(a, o) {
        var s = a.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(o){
            case "a":
            case "aa":
                return s.toUpperCase();
            case "aaa":
                return s;
            case "aaaaa":
                return s[0];
            case "aaaa":
            default:
                return s === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function(a, o) {
        return $0422a6ce4ea03acc$var$N3(a.getUTCHours() % 12 || 12, o.length);
    },
    // Hour [0-23]
    H: function(a, o) {
        return $0422a6ce4ea03acc$var$N3(a.getUTCHours(), o.length);
    },
    // Minute
    m: function(a, o) {
        return $0422a6ce4ea03acc$var$N3(a.getUTCMinutes(), o.length);
    },
    // Second
    s: function(a, o) {
        return $0422a6ce4ea03acc$var$N3(a.getUTCSeconds(), o.length);
    },
    // Fraction of second
    S: function(a, o) {
        var s = o.length, i = a.getUTCMilliseconds(), p = Math.floor(i * Math.pow(10, s - 3));
        return $0422a6ce4ea03acc$var$N3(p, o.length);
    }
}, $0422a6ce4ea03acc$var$kr = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
}, $0422a6ce4ea03acc$var$rD = {
    // Era
    G: function(a, o, s) {
        var i = a.getUTCFullYear() > 0 ? 1 : 0;
        switch(o){
            case "G":
            case "GG":
            case "GGG":
                return s.era(i, {
                    width: "abbreviated"
                });
            case "GGGGG":
                return s.era(i, {
                    width: "narrow"
                });
            case "GGGG":
            default:
                return s.era(i, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(a, o, s) {
        if (o === "yo") {
            var i = a.getUTCFullYear(), p = i > 0 ? i : 1 - i;
            return s.ordinalNumber(p, {
                unit: "year"
            });
        }
        return $0422a6ce4ea03acc$var$f0.y(a, o);
    },
    // Local week-numbering year
    Y: function(a, o, s, i) {
        var p = $0422a6ce4ea03acc$var$bh(a, i), C = p > 0 ? p : 1 - p;
        if (o === "YY") {
            var v = C % 100;
            return $0422a6ce4ea03acc$var$N3(v, 2);
        }
        return o === "Yo" ? s.ordinalNumber(C, {
            unit: "year"
        }) : $0422a6ce4ea03acc$var$N3(C, o.length);
    },
    // ISO week-numbering year
    R: function(a, o) {
        var s = $0422a6ce4ea03acc$var$hb(a);
        return $0422a6ce4ea03acc$var$N3(s, o.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(a, o) {
        var s = a.getUTCFullYear();
        return $0422a6ce4ea03acc$var$N3(s, o.length);
    },
    // Quarter
    Q: function(a, o, s) {
        var i = Math.ceil((a.getUTCMonth() + 1) / 3);
        switch(o){
            case "Q":
                return String(i);
            case "QQ":
                return $0422a6ce4ea03acc$var$N3(i, 2);
            case "Qo":
                return s.ordinalNumber(i, {
                    unit: "quarter"
                });
            case "QQQ":
                return s.quarter(i, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "QQQQQ":
                return s.quarter(i, {
                    width: "narrow",
                    context: "formatting"
                });
            case "QQQQ":
            default:
                return s.quarter(i, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(a, o, s) {
        var i = Math.ceil((a.getUTCMonth() + 1) / 3);
        switch(o){
            case "q":
                return String(i);
            case "qq":
                return $0422a6ce4ea03acc$var$N3(i, 2);
            case "qo":
                return s.ordinalNumber(i, {
                    unit: "quarter"
                });
            case "qqq":
                return s.quarter(i, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "qqqqq":
                return s.quarter(i, {
                    width: "narrow",
                    context: "standalone"
                });
            case "qqqq":
            default:
                return s.quarter(i, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(a, o, s) {
        var i = a.getUTCMonth();
        switch(o){
            case "M":
            case "MM":
                return $0422a6ce4ea03acc$var$f0.M(a, o);
            case "Mo":
                return s.ordinalNumber(i + 1, {
                    unit: "month"
                });
            case "MMM":
                return s.month(i, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "MMMMM":
                return s.month(i, {
                    width: "narrow",
                    context: "formatting"
                });
            case "MMMM":
            default:
                return s.month(i, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(a, o, s) {
        var i = a.getUTCMonth();
        switch(o){
            case "L":
                return String(i + 1);
            case "LL":
                return $0422a6ce4ea03acc$var$N3(i + 1, 2);
            case "Lo":
                return s.ordinalNumber(i + 1, {
                    unit: "month"
                });
            case "LLL":
                return s.month(i, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "LLLLL":
                return s.month(i, {
                    width: "narrow",
                    context: "standalone"
                });
            case "LLLL":
            default:
                return s.month(i, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(a, o, s, i) {
        var p = $0422a6ce4ea03acc$var$vb(a, i);
        return o === "wo" ? s.ordinalNumber(p, {
            unit: "week"
        }) : $0422a6ce4ea03acc$var$N3(p, o.length);
    },
    // ISO week of year
    I: function(a, o, s) {
        var i = $0422a6ce4ea03acc$var$mb(a);
        return o === "Io" ? s.ordinalNumber(i, {
            unit: "week"
        }) : $0422a6ce4ea03acc$var$N3(i, o.length);
    },
    // Day of the month
    d: function(a, o, s) {
        return o === "do" ? s.ordinalNumber(a.getUTCDate(), {
            unit: "date"
        }) : $0422a6ce4ea03acc$var$f0.d(a, o);
    },
    // Day of year
    D: function(a, o, s) {
        var i = $0422a6ce4ea03acc$var$X_(a);
        return o === "Do" ? s.ordinalNumber(i, {
            unit: "dayOfYear"
        }) : $0422a6ce4ea03acc$var$N3(i, o.length);
    },
    // Day of week
    E: function(a, o, s) {
        var i = a.getUTCDay();
        switch(o){
            case "E":
            case "EE":
            case "EEE":
                return s.day(i, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "EEEEE":
                return s.day(i, {
                    width: "narrow",
                    context: "formatting"
                });
            case "EEEEEE":
                return s.day(i, {
                    width: "short",
                    context: "formatting"
                });
            case "EEEE":
            default:
                return s.day(i, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(a, o, s, i) {
        var p = a.getUTCDay(), C = (p - i.weekStartsOn + 8) % 7 || 7;
        switch(o){
            case "e":
                return String(C);
            case "ee":
                return $0422a6ce4ea03acc$var$N3(C, 2);
            case "eo":
                return s.ordinalNumber(C, {
                    unit: "day"
                });
            case "eee":
                return s.day(p, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "eeeee":
                return s.day(p, {
                    width: "narrow",
                    context: "formatting"
                });
            case "eeeeee":
                return s.day(p, {
                    width: "short",
                    context: "formatting"
                });
            case "eeee":
            default:
                return s.day(p, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(a, o, s, i) {
        var p = a.getUTCDay(), C = (p - i.weekStartsOn + 8) % 7 || 7;
        switch(o){
            case "c":
                return String(C);
            case "cc":
                return $0422a6ce4ea03acc$var$N3(C, o.length);
            case "co":
                return s.ordinalNumber(C, {
                    unit: "day"
                });
            case "ccc":
                return s.day(p, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "ccccc":
                return s.day(p, {
                    width: "narrow",
                    context: "standalone"
                });
            case "cccccc":
                return s.day(p, {
                    width: "short",
                    context: "standalone"
                });
            case "cccc":
            default:
                return s.day(p, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(a, o, s) {
        var i = a.getUTCDay(), p = i === 0 ? 7 : i;
        switch(o){
            case "i":
                return String(p);
            case "ii":
                return $0422a6ce4ea03acc$var$N3(p, o.length);
            case "io":
                return s.ordinalNumber(p, {
                    unit: "day"
                });
            case "iii":
                return s.day(i, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "iiiii":
                return s.day(i, {
                    width: "narrow",
                    context: "formatting"
                });
            case "iiiiii":
                return s.day(i, {
                    width: "short",
                    context: "formatting"
                });
            case "iiii":
            default:
                return s.day(i, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(a, o, s) {
        var i = a.getUTCHours(), p = i / 12 >= 1 ? "pm" : "am";
        switch(o){
            case "a":
            case "aa":
                return s.dayPeriod(p, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return s.dayPeriod(p, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return s.dayPeriod(p, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return s.dayPeriod(p, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(a, o, s) {
        var i = a.getUTCHours(), p;
        switch(i === 12 ? p = $0422a6ce4ea03acc$var$kr.noon : i === 0 ? p = $0422a6ce4ea03acc$var$kr.midnight : p = i / 12 >= 1 ? "pm" : "am", o){
            case "b":
            case "bb":
                return s.dayPeriod(p, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return s.dayPeriod(p, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return s.dayPeriod(p, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return s.dayPeriod(p, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(a, o, s) {
        var i = a.getUTCHours(), p;
        switch(i >= 17 ? p = $0422a6ce4ea03acc$var$kr.evening : i >= 12 ? p = $0422a6ce4ea03acc$var$kr.afternoon : i >= 4 ? p = $0422a6ce4ea03acc$var$kr.morning : p = $0422a6ce4ea03acc$var$kr.night, o){
            case "B":
            case "BB":
            case "BBB":
                return s.dayPeriod(p, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return s.dayPeriod(p, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return s.dayPeriod(p, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(a, o, s) {
        if (o === "ho") {
            var i = a.getUTCHours() % 12;
            return i === 0 && (i = 12), s.ordinalNumber(i, {
                unit: "hour"
            });
        }
        return $0422a6ce4ea03acc$var$f0.h(a, o);
    },
    // Hour [0-23]
    H: function(a, o, s) {
        return o === "Ho" ? s.ordinalNumber(a.getUTCHours(), {
            unit: "hour"
        }) : $0422a6ce4ea03acc$var$f0.H(a, o);
    },
    // Hour [0-11]
    K: function(a, o, s) {
        var i = a.getUTCHours() % 12;
        return o === "Ko" ? s.ordinalNumber(i, {
            unit: "hour"
        }) : $0422a6ce4ea03acc$var$N3(i, o.length);
    },
    // Hour [1-24]
    k: function(a, o, s) {
        var i = a.getUTCHours();
        return i === 0 && (i = 24), o === "ko" ? s.ordinalNumber(i, {
            unit: "hour"
        }) : $0422a6ce4ea03acc$var$N3(i, o.length);
    },
    // Minute
    m: function(a, o, s) {
        return o === "mo" ? s.ordinalNumber(a.getUTCMinutes(), {
            unit: "minute"
        }) : $0422a6ce4ea03acc$var$f0.m(a, o);
    },
    // Second
    s: function(a, o, s) {
        return o === "so" ? s.ordinalNumber(a.getUTCSeconds(), {
            unit: "second"
        }) : $0422a6ce4ea03acc$var$f0.s(a, o);
    },
    // Fraction of second
    S: function(a, o) {
        return $0422a6ce4ea03acc$var$f0.S(a, o);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(a, o, s, i) {
        var p = i._originalDate || a, C = p.getTimezoneOffset();
        if (C === 0) return "Z";
        switch(o){
            case "X":
                return $0422a6ce4ea03acc$var$jy(C);
            case "XXXX":
            case "XX":
                return $0422a6ce4ea03acc$var$Mt(C);
            case "XXXXX":
            case "XXX":
            default:
                return $0422a6ce4ea03acc$var$Mt(C, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(a, o, s, i) {
        var p = i._originalDate || a, C = p.getTimezoneOffset();
        switch(o){
            case "x":
                return $0422a6ce4ea03acc$var$jy(C);
            case "xxxx":
            case "xx":
                return $0422a6ce4ea03acc$var$Mt(C);
            case "xxxxx":
            case "xxx":
            default:
                return $0422a6ce4ea03acc$var$Mt(C, ":");
        }
    },
    // Timezone (GMT)
    O: function(a, o, s, i) {
        var p = i._originalDate || a, C = p.getTimezoneOffset();
        switch(o){
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $0422a6ce4ea03acc$var$Ay(C, ":");
            case "OOOO":
            default:
                return "GMT" + $0422a6ce4ea03acc$var$Mt(C, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(a, o, s, i) {
        var p = i._originalDate || a, C = p.getTimezoneOffset();
        switch(o){
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $0422a6ce4ea03acc$var$Ay(C, ":");
            case "zzzz":
            default:
                return "GMT" + $0422a6ce4ea03acc$var$Mt(C, ":");
        }
    },
    // Seconds timestamp
    t: function(a, o, s, i) {
        var p = i._originalDate || a, C = Math.floor(p.getTime() / 1e3);
        return $0422a6ce4ea03acc$var$N3(C, o.length);
    },
    // Milliseconds timestamp
    T: function(a, o, s, i) {
        var p = i._originalDate || a, C = p.getTime();
        return $0422a6ce4ea03acc$var$N3(C, o.length);
    }
};
function $0422a6ce4ea03acc$var$Ay(r, a) {
    var o = r > 0 ? "-" : "+", s = Math.abs(r), i = Math.floor(s / 60), p = s % 60;
    if (p === 0) return o + String(i);
    var C = a;
    return o + String(i) + C + $0422a6ce4ea03acc$var$N3(p, 2);
}
function $0422a6ce4ea03acc$var$jy(r, a) {
    if (r % 60 === 0) {
        var o = r > 0 ? "-" : "+";
        return o + $0422a6ce4ea03acc$var$N3(Math.abs(r) / 60, 2);
    }
    return $0422a6ce4ea03acc$var$Mt(r, a);
}
function $0422a6ce4ea03acc$var$Mt(r, a) {
    var o = a || "", s = r > 0 ? "-" : "+", i = Math.abs(r), p = $0422a6ce4ea03acc$var$N3(Math.floor(i / 60), 2), C = $0422a6ce4ea03acc$var$N3(i % 60, 2);
    return s + p + o + C;
}
var $0422a6ce4ea03acc$var$zy = function(a, o) {
    switch(a){
        case "P":
            return o.date({
                width: "short"
            });
        case "PP":
            return o.date({
                width: "medium"
            });
        case "PPP":
            return o.date({
                width: "long"
            });
        case "PPPP":
        default:
            return o.date({
                width: "full"
            });
    }
}, $0422a6ce4ea03acc$var$gb = function(a, o) {
    switch(a){
        case "p":
            return o.time({
                width: "short"
            });
        case "pp":
            return o.time({
                width: "medium"
            });
        case "ppp":
            return o.time({
                width: "long"
            });
        case "pppp":
        default:
            return o.time({
                width: "full"
            });
    }
}, $0422a6ce4ea03acc$var$aD = function(a, o) {
    var s = a.match(/(P+)(p+)?/) || [], i = s[1], p = s[2];
    if (!p) return $0422a6ce4ea03acc$var$zy(a, o);
    var C;
    switch(i){
        case "P":
            C = o.dateTime({
                width: "short"
            });
            break;
        case "PP":
            C = o.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            C = o.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            C = o.dateTime({
                width: "full"
            });
            break;
    }
    return C.replace("{{date}}", $0422a6ce4ea03acc$var$zy(i, o)).replace("{{time}}", $0422a6ce4ea03acc$var$gb(p, o));
}, $0422a6ce4ea03acc$var$Ip = {
    p: $0422a6ce4ea03acc$var$gb,
    P: $0422a6ce4ea03acc$var$aD
};
function $0422a6ce4ea03acc$var$rc(r) {
    var a = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return a.setUTCFullYear(r.getFullYear()), r.getTime() - a.getTime();
}
var $0422a6ce4ea03acc$var$iD = [
    "D",
    "DD"
], $0422a6ce4ea03acc$var$oD = [
    "YY",
    "YYYY"
];
function $0422a6ce4ea03acc$var$yb(r) {
    return $0422a6ce4ea03acc$var$iD.indexOf(r) !== -1;
}
function $0422a6ce4ea03acc$var$Lb(r) {
    return $0422a6ce4ea03acc$var$oD.indexOf(r) !== -1;
}
function $0422a6ce4ea03acc$var$ac(r, a, o) {
    if (r === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(a, "`) for formatting years to the input `").concat(o, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if (r === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(a, "`) for formatting years to the input `").concat(o, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if (r === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(a, "`) for formatting days of the month to the input `").concat(o, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if (r === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(a, "`) for formatting days of the month to the input `").concat(o, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var $0422a6ce4ea03acc$var$lD = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
}, $0422a6ce4ea03acc$var$sD = function(a, o, s) {
    var i, p = $0422a6ce4ea03acc$var$lD[a];
    return typeof p == "string" ? i = p : o === 1 ? i = p.one : i = p.other.replace("{{count}}", o.toString()), s != null && s.addSuffix ? s.comparison && s.comparison > 0 ? "in " + i : i + " ago" : i;
};
function $0422a6ce4ea03acc$var$cp(r) {
    return function() {
        var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = a.width ? String(a.width) : r.defaultWidth, s = r.formats[o] || r.formats[r.defaultWidth];
        return s;
    };
}
var $0422a6ce4ea03acc$var$uD = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
}, $0422a6ce4ea03acc$var$cD = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
}, $0422a6ce4ea03acc$var$dD = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
}, $0422a6ce4ea03acc$var$CD = {
    date: $0422a6ce4ea03acc$var$cp({
        formats: $0422a6ce4ea03acc$var$uD,
        defaultWidth: "full"
    }),
    time: $0422a6ce4ea03acc$var$cp({
        formats: $0422a6ce4ea03acc$var$cD,
        defaultWidth: "full"
    }),
    dateTime: $0422a6ce4ea03acc$var$cp({
        formats: $0422a6ce4ea03acc$var$dD,
        defaultWidth: "full"
    })
}, $0422a6ce4ea03acc$var$fD = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
}, $0422a6ce4ea03acc$var$pD = function(a, o, s, i) {
    return $0422a6ce4ea03acc$var$fD[a];
};
function $0422a6ce4ea03acc$var$bo(r) {
    return function(a, o) {
        var s = o != null && o.context ? String(o.context) : "standalone", i;
        if (s === "formatting" && r.formattingValues) {
            var p = r.defaultFormattingWidth || r.defaultWidth, C = o != null && o.width ? String(o.width) : p;
            i = r.formattingValues[C] || r.formattingValues[p];
        } else {
            var v = r.defaultWidth, y = o != null && o.width ? String(o.width) : r.defaultWidth;
            i = r.values[y] || r.values[v];
        }
        var L = r.argumentCallback ? r.argumentCallback(a) : a;
        return i[L];
    };
}
var $0422a6ce4ea03acc$var$hD = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
}, $0422a6ce4ea03acc$var$mD = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
}, $0422a6ce4ea03acc$var$vD = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
}, $0422a6ce4ea03acc$var$gD = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
}, $0422a6ce4ea03acc$var$yD = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
}, $0422a6ce4ea03acc$var$LD = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
}, $0422a6ce4ea03acc$var$bD = function(a, o) {
    var s = Number(a), i = s % 100;
    if (i > 20 || i < 10) switch(i % 10){
        case 1:
            return s + "st";
        case 2:
            return s + "nd";
        case 3:
            return s + "rd";
    }
    return s + "th";
}, $0422a6ce4ea03acc$var$wD = {
    ordinalNumber: $0422a6ce4ea03acc$var$bD,
    era: $0422a6ce4ea03acc$var$bo({
        values: $0422a6ce4ea03acc$var$hD,
        defaultWidth: "wide"
    }),
    quarter: $0422a6ce4ea03acc$var$bo({
        values: $0422a6ce4ea03acc$var$mD,
        defaultWidth: "wide",
        argumentCallback: function(a) {
            return a - 1;
        }
    }),
    month: $0422a6ce4ea03acc$var$bo({
        values: $0422a6ce4ea03acc$var$vD,
        defaultWidth: "wide"
    }),
    day: $0422a6ce4ea03acc$var$bo({
        values: $0422a6ce4ea03acc$var$gD,
        defaultWidth: "wide"
    }),
    dayPeriod: $0422a6ce4ea03acc$var$bo({
        values: $0422a6ce4ea03acc$var$yD,
        defaultWidth: "wide",
        formattingValues: $0422a6ce4ea03acc$var$LD,
        defaultFormattingWidth: "wide"
    })
};
function $0422a6ce4ea03acc$var$wo(r) {
    return function(a) {
        var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = o.width, i = s && r.matchPatterns[s] || r.matchPatterns[r.defaultMatchWidth], p = a.match(i);
        if (!p) return null;
        var C = p[0], v = s && r.parsePatterns[s] || r.parsePatterns[r.defaultParseWidth], y = Array.isArray(v) ? $0422a6ce4ea03acc$var$xD(v, function(E) {
            return E.test(C);
        }) : $0422a6ce4ea03acc$var$HD(v, function(E) {
            return E.test(C);
        }), L;
        L = r.valueCallback ? r.valueCallback(y) : y, L = o.valueCallback ? o.valueCallback(L) : L;
        var M = a.slice(C.length);
        return {
            value: L,
            rest: M
        };
    };
}
function $0422a6ce4ea03acc$var$HD(r, a) {
    for(var o in r)if (r.hasOwnProperty(o) && a(r[o])) return o;
}
function $0422a6ce4ea03acc$var$xD(r, a) {
    for(var o = 0; o < r.length; o++)if (a(r[o])) return o;
}
function $0422a6ce4ea03acc$var$VD(r) {
    return function(a) {
        var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = a.match(r.matchPattern);
        if (!s) return null;
        var i = s[0], p = a.match(r.parsePattern);
        if (!p) return null;
        var C = r.valueCallback ? r.valueCallback(p[0]) : p[0];
        C = o.valueCallback ? o.valueCallback(C) : C;
        var v = a.slice(i.length);
        return {
            value: C,
            rest: v
        };
    };
}
var $0422a6ce4ea03acc$var$MD = /^(\d+)(th|st|nd|rd)?/i, $0422a6ce4ea03acc$var$ED = /\d+/i, $0422a6ce4ea03acc$var$SD = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
}, $0422a6ce4ea03acc$var$kD = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
}, $0422a6ce4ea03acc$var$TD = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
}, $0422a6ce4ea03acc$var$_D = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
}, $0422a6ce4ea03acc$var$DD = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, $0422a6ce4ea03acc$var$RD = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
}, $0422a6ce4ea03acc$var$ZD = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, $0422a6ce4ea03acc$var$OD = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
}, $0422a6ce4ea03acc$var$ND = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, $0422a6ce4ea03acc$var$PD = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
}, $0422a6ce4ea03acc$var$BD = {
    ordinalNumber: $0422a6ce4ea03acc$var$VD({
        matchPattern: $0422a6ce4ea03acc$var$MD,
        parsePattern: $0422a6ce4ea03acc$var$ED,
        valueCallback: function(a) {
            return parseInt(a, 10);
        }
    }),
    era: $0422a6ce4ea03acc$var$wo({
        matchPatterns: $0422a6ce4ea03acc$var$SD,
        defaultMatchWidth: "wide",
        parsePatterns: $0422a6ce4ea03acc$var$kD,
        defaultParseWidth: "any"
    }),
    quarter: $0422a6ce4ea03acc$var$wo({
        matchPatterns: $0422a6ce4ea03acc$var$TD,
        defaultMatchWidth: "wide",
        parsePatterns: $0422a6ce4ea03acc$var$_D,
        defaultParseWidth: "any",
        valueCallback: function(a) {
            return a + 1;
        }
    }),
    month: $0422a6ce4ea03acc$var$wo({
        matchPatterns: $0422a6ce4ea03acc$var$DD,
        defaultMatchWidth: "wide",
        parsePatterns: $0422a6ce4ea03acc$var$RD,
        defaultParseWidth: "any"
    }),
    day: $0422a6ce4ea03acc$var$wo({
        matchPatterns: $0422a6ce4ea03acc$var$ZD,
        defaultMatchWidth: "wide",
        parsePatterns: $0422a6ce4ea03acc$var$OD,
        defaultParseWidth: "any"
    }),
    dayPeriod: $0422a6ce4ea03acc$var$wo({
        matchPatterns: $0422a6ce4ea03acc$var$ND,
        defaultMatchWidth: "any",
        parsePatterns: $0422a6ce4ea03acc$var$PD,
        defaultParseWidth: "any"
    })
}, $0422a6ce4ea03acc$var$bb = {
    code: "en-US",
    formatDistance: $0422a6ce4ea03acc$var$sD,
    formatLong: $0422a6ce4ea03acc$var$CD,
    formatRelative: $0422a6ce4ea03acc$var$pD,
    localize: $0422a6ce4ea03acc$var$wD,
    match: $0422a6ce4ea03acc$var$BD,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
}, $0422a6ce4ea03acc$var$FD = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $0422a6ce4ea03acc$var$AD = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $0422a6ce4ea03acc$var$jD = /^'([^]*?)'?$/, $0422a6ce4ea03acc$var$zD = /''/g, $0422a6ce4ea03acc$var$UD = /[a-zA-Z]/;
function $0422a6ce4ea03acc$var$Uy(r, a, o) {
    var s, i, p, C, v, y, L, M, E, k, _, Z, O, B, z, I, P, $;
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var W = String(a), l1 = $0422a6ce4ea03acc$var$Rt(), u1 = (s = (i = o == null ? void 0 : o.locale) !== null && i !== void 0 ? i : l1.locale) !== null && s !== void 0 ? s : $0422a6ce4ea03acc$var$bb, m1 = $0422a6ce4ea03acc$var$q2((p = (C = (v = (y = o == null ? void 0 : o.firstWeekContainsDate) !== null && y !== void 0 ? y : o == null || (L = o.locale) === null || L === void 0 || (M = L.options) === null || M === void 0 ? void 0 : M.firstWeekContainsDate) !== null && v !== void 0 ? v : l1.firstWeekContainsDate) !== null && C !== void 0 ? C : (E = l1.locale) === null || E === void 0 || (k = E.options) === null || k === void 0 ? void 0 : k.firstWeekContainsDate) !== null && p !== void 0 ? p : 1);
    if (!(m1 >= 1 && m1 <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var L1 = $0422a6ce4ea03acc$var$q2((_ = (Z = (O = (B = o == null ? void 0 : o.weekStartsOn) !== null && B !== void 0 ? B : o == null || (z = o.locale) === null || z === void 0 || (I = z.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && O !== void 0 ? O : l1.weekStartsOn) !== null && Z !== void 0 ? Z : (P = l1.locale) === null || P === void 0 || ($ = P.options) === null || $ === void 0 ? void 0 : $.weekStartsOn) !== null && _ !== void 0 ? _ : 0);
    if (!(L1 >= 0 && L1 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!u1.localize) throw new RangeError("locale must contain localize property");
    if (!u1.formatLong) throw new RangeError("locale must contain formatLong property");
    var E1 = $0422a6ce4ea03acc$var$a2(r);
    if (!$0422a6ce4ea03acc$var$nc(E1)) throw new RangeError("Invalid time value");
    var H1 = $0422a6ce4ea03acc$var$rc(E1), B1 = $0422a6ce4ea03acc$var$pb(E1, H1), h1 = {
        firstWeekContainsDate: m1,
        weekStartsOn: L1,
        locale: u1,
        _originalDate: E1
    }, k1 = W.match($0422a6ce4ea03acc$var$AD).map(function(I1) {
        var D1 = I1[0];
        if (D1 === "p" || D1 === "P") {
            var s2 = $0422a6ce4ea03acc$var$Ip[D1];
            return s2(I1, u1.formatLong);
        }
        return I1;
    }).join("").match($0422a6ce4ea03acc$var$FD).map(function(I1) {
        if (I1 === "''") return "'";
        var D1 = I1[0];
        if (D1 === "'") return $0422a6ce4ea03acc$var$ID(I1);
        var s2 = $0422a6ce4ea03acc$var$rD[D1];
        if (s2) return !(o != null && o.useAdditionalWeekYearTokens) && $0422a6ce4ea03acc$var$Lb(I1) && $0422a6ce4ea03acc$var$ac(I1, a, String(r)), !(o != null && o.useAdditionalDayOfYearTokens) && $0422a6ce4ea03acc$var$yb(I1) && $0422a6ce4ea03acc$var$ac(I1, a, String(r)), s2(B1, I1, u1.localize, h1);
        if (D1.match($0422a6ce4ea03acc$var$UD)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + D1 + "`");
        return I1;
    }).join("");
    return k1;
}
function $0422a6ce4ea03acc$var$ID(r) {
    var a = r.match($0422a6ce4ea03acc$var$jD);
    return a ? a[1].replace($0422a6ce4ea03acc$var$zD, "'") : r;
}
var $0422a6ce4ea03acc$var$$D = 6e4;
function $0422a6ce4ea03acc$var$$p(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a);
    return $0422a6ce4ea03acc$var$Lh(r, o * $0422a6ce4ea03acc$var$$D);
}
var $0422a6ce4ea03acc$var$YD = 36e5;
function $0422a6ce4ea03acc$var$WD(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a);
    return $0422a6ce4ea03acc$var$Lh(r, o * $0422a6ce4ea03acc$var$YD);
}
function $0422a6ce4ea03acc$var$ia(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$q2(a);
    return isNaN(s) ? /* @__PURE__ */ new Date(NaN) : (s && o.setDate(o.getDate() + s), o);
}
function $0422a6ce4ea03acc$var$wh(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a), s = o * 7;
    return $0422a6ce4ea03acc$var$ia(r, s);
}
function $0422a6ce4ea03acc$var$v7(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$q2(a);
    if (isNaN(s)) return /* @__PURE__ */ new Date(NaN);
    if (!s) return o;
    var i = o.getDate(), p = new Date(o.getTime());
    p.setMonth(o.getMonth() + s + 1, 0);
    var C = p.getDate();
    return i >= C ? p : (o.setFullYear(p.getFullYear(), p.getMonth(), i), o);
}
function $0422a6ce4ea03acc$var$wb(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a), s = o * 3;
    return $0422a6ce4ea03acc$var$v7(r, s);
}
function $0422a6ce4ea03acc$var$qr(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a);
    return $0422a6ce4ea03acc$var$v7(r, o * 12);
}
function $0422a6ce4ea03acc$var$QD(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a);
    return $0422a6ce4ea03acc$var$ia(r, -o);
}
function $0422a6ce4ea03acc$var$qD(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a);
    return $0422a6ce4ea03acc$var$wh(r, -o);
}
function $0422a6ce4ea03acc$var$Gr(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a);
    return $0422a6ce4ea03acc$var$v7(r, -o);
}
function $0422a6ce4ea03acc$var$GD(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a);
    return $0422a6ce4ea03acc$var$wb(r, -o);
}
function $0422a6ce4ea03acc$var$Po(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a);
    return $0422a6ce4ea03acc$var$qr(r, -o);
}
function $0422a6ce4ea03acc$var$dp(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getSeconds();
    return o;
}
function $0422a6ce4ea03acc$var$a6(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getMinutes();
    return o;
}
function $0422a6ce4ea03acc$var$i6(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getHours();
    return o;
}
function $0422a6ce4ea03acc$var$XD(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getDay();
    return o;
}
function $0422a6ce4ea03acc$var$Iy(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getDate();
    return o;
}
function $0422a6ce4ea03acc$var$Hb(r, a) {
    var o, s, i, p, C, v, y, L;
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var M = $0422a6ce4ea03acc$var$Rt(), E = $0422a6ce4ea03acc$var$q2((o = (s = (i = (p = a == null ? void 0 : a.weekStartsOn) !== null && p !== void 0 ? p : a == null || (C = a.locale) === null || C === void 0 || (v = C.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && i !== void 0 ? i : M.weekStartsOn) !== null && s !== void 0 ? s : (y = M.locale) === null || y === void 0 || (L = y.options) === null || L === void 0 ? void 0 : L.weekStartsOn) !== null && o !== void 0 ? o : 0);
    if (!(E >= 0 && E <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var k = $0422a6ce4ea03acc$var$a2(r), _ = k.getDay(), Z = (_ < E ? 7 : 0) + _ - E;
    return k.setDate(k.getDate() - Z), k.setHours(0, 0, 0, 0), k;
}
function $0422a6ce4ea03acc$var$ic(r) {
    return $0422a6ce4ea03acc$var$F1(1, arguments), $0422a6ce4ea03acc$var$Hb(r, {
        weekStartsOn: 1
    });
}
function $0422a6ce4ea03acc$var$KD(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getFullYear(), s = /* @__PURE__ */ new Date(0);
    s.setFullYear(o + 1, 0, 4), s.setHours(0, 0, 0, 0);
    var i = $0422a6ce4ea03acc$var$ic(s), p = /* @__PURE__ */ new Date(0);
    p.setFullYear(o, 0, 4), p.setHours(0, 0, 0, 0);
    var C = $0422a6ce4ea03acc$var$ic(p);
    return a.getTime() >= i.getTime() ? o + 1 : a.getTime() >= C.getTime() ? o : o - 1;
}
function $0422a6ce4ea03acc$var$JD(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$KD(r), o = /* @__PURE__ */ new Date(0);
    o.setFullYear(a, 0, 4), o.setHours(0, 0, 0, 0);
    var s = $0422a6ce4ea03acc$var$ic(o);
    return s;
}
var $0422a6ce4ea03acc$var$eR = 6048e5;
function $0422a6ce4ea03acc$var$tR(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = $0422a6ce4ea03acc$var$ic(a).getTime() - $0422a6ce4ea03acc$var$JD(a).getTime();
    return Math.round(o / $0422a6ce4ea03acc$var$eR) + 1;
}
function $0422a6ce4ea03acc$var$a5(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getMonth();
    return o;
}
function $0422a6ce4ea03acc$var$zr(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = Math.floor(a.getMonth() / 3) + 1;
    return o;
}
function $0422a6ce4ea03acc$var$K2(r) {
    return $0422a6ce4ea03acc$var$F1(1, arguments), $0422a6ce4ea03acc$var$a2(r).getFullYear();
}
function $0422a6ce4ea03acc$var$Yp(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getTime();
    return o;
}
function $0422a6ce4ea03acc$var$nR(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$q2(a);
    return o.setSeconds(s), o;
}
function $0422a6ce4ea03acc$var$So(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$q2(a);
    return o.setMinutes(s), o;
}
function $0422a6ce4ea03acc$var$ko(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$q2(a);
    return o.setHours(s), o;
}
function $0422a6ce4ea03acc$var$rR(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getFullYear(), s = a.getMonth(), i = /* @__PURE__ */ new Date(0);
    return i.setFullYear(o, s + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function $0422a6ce4ea03acc$var$g5(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$q2(a), i = o.getFullYear(), p = o.getDate(), C = /* @__PURE__ */ new Date(0);
    C.setFullYear(i, s, 15), C.setHours(0, 0, 0, 0);
    var v = $0422a6ce4ea03acc$var$rR(C);
    return o.setMonth(s, Math.min(p, v)), o;
}
function $0422a6ce4ea03acc$var$Fr(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$q2(a), i = Math.floor(o.getMonth() / 3) + 1, p = s - i;
    return $0422a6ce4ea03acc$var$g5(o, o.getMonth() + p * 3);
}
function $0422a6ce4ea03acc$var$i9(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$q2(a);
    return isNaN(o.getTime()) ? /* @__PURE__ */ new Date(NaN) : (o.setFullYear(s), o);
}
function $0422a6ce4ea03acc$var$$y(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a;
    if (r && typeof r.forEach == "function") a = r;
    else if ($0422a6ce4ea03acc$var$D6(r) === "object" && r !== null) a = Array.prototype.slice.call(r);
    else return /* @__PURE__ */ new Date(NaN);
    var o;
    return a.forEach(function(s) {
        var i = $0422a6ce4ea03acc$var$a2(s);
        (o === void 0 || o > i || isNaN(i.getDate())) && (o = i);
    }), o || /* @__PURE__ */ new Date(NaN);
}
function $0422a6ce4ea03acc$var$Yy(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a;
    if (r && typeof r.forEach == "function") a = r;
    else if ($0422a6ce4ea03acc$var$D6(r) === "object" && r !== null) a = Array.prototype.slice.call(r);
    else return /* @__PURE__ */ new Date(NaN);
    var o;
    return a.forEach(function(s) {
        var i = $0422a6ce4ea03acc$var$a2(s);
        (o === void 0 || o < i || isNaN(Number(i))) && (o = i);
    }), o || /* @__PURE__ */ new Date(NaN);
}
function $0422a6ce4ea03acc$var$d8(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r);
    return a.setHours(0, 0, 0, 0), a;
}
var $0422a6ce4ea03acc$var$aR = 864e5;
function $0422a6ce4ea03acc$var$oc(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$d8(r), s = $0422a6ce4ea03acc$var$d8(a), i = o.getTime() - $0422a6ce4ea03acc$var$rc(o), p = s.getTime() - $0422a6ce4ea03acc$var$rc(s);
    return Math.round((i - p) / $0422a6ce4ea03acc$var$aR);
}
function $0422a6ce4ea03acc$var$lc(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$a2(a), i = o.getFullYear() - s.getFullYear(), p = o.getMonth() - s.getMonth();
    return i * 12 + p;
}
function $0422a6ce4ea03acc$var$sc(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$a2(a);
    return o.getFullYear() - s.getFullYear();
}
function $0422a6ce4ea03acc$var$xb(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r);
    return a.setDate(1), a.setHours(0, 0, 0, 0), a;
}
function $0422a6ce4ea03acc$var$Wp(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getMonth(), s = o - o % 3;
    return a.setMonth(s, 1), a.setHours(0, 0, 0, 0), a;
}
function $0422a6ce4ea03acc$var$Vb(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = /* @__PURE__ */ new Date(0);
    return o.setFullYear(a.getFullYear(), 0, 1), o.setHours(0, 0, 0, 0), o;
}
function $0422a6ce4ea03acc$var$Qp(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r);
    return a.setHours(23, 59, 59, 999), a;
}
function $0422a6ce4ea03acc$var$iR(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getMonth();
    return a.setFullYear(a.getFullYear(), o + 1, 0), a.setHours(23, 59, 59, 999), a;
}
function $0422a6ce4ea03acc$var$oR(r) {
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var a = $0422a6ce4ea03acc$var$a2(r), o = a.getFullYear();
    return a.setFullYear(o + 1, 0, 0), a.setHours(23, 59, 59, 999), a;
}
function $0422a6ce4ea03acc$var$lR(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$a2(a);
    return o.getTime() === s.getTime();
}
function $0422a6ce4ea03acc$var$sR(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$d8(r), s = $0422a6ce4ea03acc$var$d8(a);
    return o.getTime() === s.getTime();
}
function $0422a6ce4ea03acc$var$uR(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$a2(a);
    return o.getFullYear() === s.getFullYear() && o.getMonth() === s.getMonth();
}
function $0422a6ce4ea03acc$var$cR(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$a2(a);
    return o.getFullYear() === s.getFullYear();
}
function $0422a6ce4ea03acc$var$dR(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$Wp(r), s = $0422a6ce4ea03acc$var$Wp(a);
    return o.getTime() === s.getTime();
}
function $0422a6ce4ea03acc$var$y0(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$a2(a);
    return o.getTime() > s.getTime();
}
function $0422a6ce4ea03acc$var$l9(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$a2(a);
    return o.getTime() < s.getTime();
}
function $0422a6ce4ea03acc$var$Bo(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r).getTime(), s = $0422a6ce4ea03acc$var$a2(a.start).getTime(), i = $0422a6ce4ea03acc$var$a2(a.end).getTime();
    if (!(s <= i)) throw new RangeError("Invalid interval");
    return o >= s && o <= i;
}
function $0422a6ce4ea03acc$var$Wy(r, a) {
    (a == null || a > r.length) && (a = r.length);
    for(var o = 0, s = Array(a); o < a; o++)s[o] = r[o];
    return s;
}
function $0422a6ce4ea03acc$var$CR(r, a) {
    if (r) {
        if (typeof r == "string") return $0422a6ce4ea03acc$var$Wy(r, a);
        var o = ({}).toString.call(r).slice(8, -1);
        return o === "Object" && r.constructor && (o = r.constructor.name), o === "Map" || o === "Set" ? Array.from(r) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? $0422a6ce4ea03acc$var$Wy(r, a) : void 0;
    }
}
function $0422a6ce4ea03acc$var$Qy(r, a) {
    var o = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
    if (!o) {
        if (Array.isArray(r) || (o = $0422a6ce4ea03acc$var$CR(r)) || a) {
            o && (r = o);
            var s = 0, i = function() {};
            return {
                s: i,
                n: function() {
                    return s >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[s++]
                    };
                },
                e: function(L) {
                    throw L;
                },
                f: i
            };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var p, C = !0, v = !1;
    return {
        s: function() {
            o = o.call(r);
        },
        n: function() {
            var L = o.next();
            return C = L.done, L;
        },
        e: function(L) {
            v = !0, p = L;
        },
        f: function() {
            try {
                C || o.return == null || o.return();
            } finally{
                if (v) throw p;
            }
        }
    };
}
function $0422a6ce4ea03acc$var$fR(r, a) {
    if (r == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var o in a)Object.prototype.hasOwnProperty.call(a, o) && (r[o] = a[o]);
    return r;
}
function $0422a6ce4ea03acc$var$e2(r) {
    if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return r;
}
function $0422a6ce4ea03acc$var$qp(r, a) {
    return $0422a6ce4ea03acc$var$qp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, s) {
        return o.__proto__ = s, o;
    }, $0422a6ce4ea03acc$var$qp(r, a);
}
function $0422a6ce4ea03acc$var$L3(r, a) {
    if (typeof a != "function" && a !== null) throw new TypeError("Super expression must either be null or a function");
    r.prototype = Object.create(a && a.prototype, {
        constructor: {
            value: r,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(r, "prototype", {
        writable: !1
    }), a && $0422a6ce4ea03acc$var$qp(r, a);
}
function $0422a6ce4ea03acc$var$uc(r) {
    return $0422a6ce4ea03acc$var$uc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(a) {
        return a.__proto__ || Object.getPrototypeOf(a);
    }, $0422a6ce4ea03acc$var$uc(r);
}
function $0422a6ce4ea03acc$var$Mb() {
    try {
        var r = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch  {}
    return ($0422a6ce4ea03acc$var$Mb = function() {
        return !!r;
    })();
}
function $0422a6ce4ea03acc$var$pR(r, a) {
    if (a && ($0422a6ce4ea03acc$var$D6(a) == "object" || typeof a == "function")) return a;
    if (a !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0422a6ce4ea03acc$var$e2(r);
}
function $0422a6ce4ea03acc$var$b3(r) {
    var a = $0422a6ce4ea03acc$var$Mb();
    return function() {
        var o, s = $0422a6ce4ea03acc$var$uc(r);
        if (a) {
            var i = $0422a6ce4ea03acc$var$uc(this).constructor;
            o = Reflect.construct(s, arguments, i);
        } else o = s.apply(this, arguments);
        return $0422a6ce4ea03acc$var$pR(this, o);
    };
}
function $0422a6ce4ea03acc$var$u3(r, a) {
    if (!(r instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function $0422a6ce4ea03acc$var$hR(r, a) {
    if ($0422a6ce4ea03acc$var$D6(r) != "object" || !r) return r;
    var o = r[Symbol.toPrimitive];
    if (o !== void 0) {
        var s = o.call(r, a || "default");
        if ($0422a6ce4ea03acc$var$D6(s) != "object") return s;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (a === "string" ? String : Number)(r);
}
function $0422a6ce4ea03acc$var$Eb(r) {
    var a = $0422a6ce4ea03acc$var$hR(r, "string");
    return $0422a6ce4ea03acc$var$D6(a) == "symbol" ? a : a + "";
}
function $0422a6ce4ea03acc$var$mR(r, a) {
    for(var o = 0; o < a.length; o++){
        var s = a[o];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(r, $0422a6ce4ea03acc$var$Eb(s.key), s);
    }
}
function $0422a6ce4ea03acc$var$c3(r, a, o) {
    return a && $0422a6ce4ea03acc$var$mR(r.prototype, a), Object.defineProperty(r, "prototype", {
        writable: !1
    }), r;
}
function $0422a6ce4ea03acc$var$W1(r, a, o) {
    return (a = $0422a6ce4ea03acc$var$Eb(a)) in r ? Object.defineProperty(r, a, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : r[a] = o, r;
}
var $0422a6ce4ea03acc$var$vR = 10, $0422a6ce4ea03acc$var$Sb = /* @__PURE__ */ function() {
    function r() {
        $0422a6ce4ea03acc$var$u3(this, r), $0422a6ce4ea03acc$var$W1(this, "priority", void 0), $0422a6ce4ea03acc$var$W1(this, "subPriority", 0);
    }
    return $0422a6ce4ea03acc$var$c3(r, [
        {
            key: "validate",
            value: function(o, s) {
                return !0;
            }
        }
    ]), r;
}(), $0422a6ce4ea03acc$var$gR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o(s, i, p, C, v) {
        var y;
        return $0422a6ce4ea03acc$var$u3(this, o), y = a.call(this), y.value = s, y.validateValue = i, y.setValue = p, y.priority = C, v && (y.subPriority = v), y;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "validate",
            value: function(i, p) {
                return this.validateValue(i, this.value, p);
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return this.setValue(i, p, this.value, C);
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$Sb), $0422a6ce4ea03acc$var$yR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", $0422a6ce4ea03acc$var$vR), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "subPriority", -1), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "set",
            value: function(i, p) {
                if (p.timestampIsSet) return i;
                var C = /* @__PURE__ */ new Date(0);
                return C.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), C.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), C;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$Sb), $0422a6ce4ea03acc$var$E3 = /* @__PURE__ */ function() {
    function r() {
        $0422a6ce4ea03acc$var$u3(this, r), $0422a6ce4ea03acc$var$W1(this, "incompatibleTokens", void 0), $0422a6ce4ea03acc$var$W1(this, "priority", void 0), $0422a6ce4ea03acc$var$W1(this, "subPriority", void 0);
    }
    return $0422a6ce4ea03acc$var$c3(r, [
        {
            key: "run",
            value: function(o, s, i, p) {
                var C = this.parse(o, s, i, p);
                return C ? {
                    setter: new $0422a6ce4ea03acc$var$gR(C.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: C.rest
                } : null;
            }
        },
        {
            key: "validate",
            value: function(o, s, i) {
                return !0;
            }
        }
    ]), r;
}(), $0422a6ce4ea03acc$var$LR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 140), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "G":
                    case "GG":
                    case "GGG":
                        return C.era(i, {
                            width: "abbreviated"
                        }) || C.era(i, {
                            width: "narrow"
                        });
                    case "GGGGG":
                        return C.era(i, {
                            width: "narrow"
                        });
                    case "GGGG":
                    default:
                        return C.era(i, {
                            width: "wide"
                        }) || C.era(i, {
                            width: "abbreviated"
                        }) || C.era(i, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return p.era = C, i.setUTCFullYear(C, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$Hh = 6e4, $0422a6ce4ea03acc$var$xh = 36e5, $0422a6ce4ea03acc$var$bR = 1e3, $0422a6ce4ea03acc$var$Pe = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/
}, $0422a6ce4ea03acc$var$u8 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function $0422a6ce4ea03acc$var$Be(r, a) {
    return r && {
        value: a(r.value),
        rest: r.rest
    };
}
function $0422a6ce4ea03acc$var$we(r, a) {
    var o = a.match(r);
    return o ? {
        value: parseInt(o[0], 10),
        rest: a.slice(o[0].length)
    } : null;
}
function $0422a6ce4ea03acc$var$c8(r, a) {
    var o = a.match(r);
    if (!o) return null;
    if (o[0] === "Z") return {
        value: 0,
        rest: a.slice(1)
    };
    var s = o[1] === "+" ? 1 : -1, i = o[2] ? parseInt(o[2], 10) : 0, p = o[3] ? parseInt(o[3], 10) : 0, C = o[5] ? parseInt(o[5], 10) : 0;
    return {
        value: s * (i * $0422a6ce4ea03acc$var$xh + p * $0422a6ce4ea03acc$var$Hh + C * $0422a6ce4ea03acc$var$bR),
        rest: a.slice(o[0].length)
    };
}
function $0422a6ce4ea03acc$var$kb(r) {
    return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.anyDigitsSigned, r);
}
function $0422a6ce4ea03acc$var$Se(r, a) {
    switch(r){
        case 1:
            return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.singleDigit, a);
        case 2:
            return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.twoDigits, a);
        case 3:
            return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.threeDigits, a);
        case 4:
            return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.fourDigits, a);
        default:
            return $0422a6ce4ea03acc$var$we(new RegExp("^\\d{1," + r + "}"), a);
    }
}
function $0422a6ce4ea03acc$var$cc(r, a) {
    switch(r){
        case 1:
            return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.singleDigitSigned, a);
        case 2:
            return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.twoDigitsSigned, a);
        case 3:
            return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.threeDigitsSigned, a);
        case 4:
            return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.fourDigitsSigned, a);
        default:
            return $0422a6ce4ea03acc$var$we(new RegExp("^-?\\d{1," + r + "}"), a);
    }
}
function $0422a6ce4ea03acc$var$Vh(r) {
    switch(r){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $0422a6ce4ea03acc$var$Tb(r, a) {
    var o = a > 0, s = o ? a : 1 - a, i;
    if (s <= 50) i = r || 100;
    else {
        var p = s + 50, C = Math.floor(p / 100) * 100, v = r >= p % 100;
        i = r + C - (v ? 100 : 0);
    }
    return o ? i : 1 - i;
}
function $0422a6ce4ea03acc$var$_b(r) {
    return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
var $0422a6ce4ea03acc$var$wR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 130), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                var v = function(L) {
                    return {
                        year: L,
                        isTwoDigitYear: p === "yy"
                    };
                };
                switch(p){
                    case "y":
                        return $0422a6ce4ea03acc$var$Be($0422a6ce4ea03acc$var$Se(4, i), v);
                    case "yo":
                        return $0422a6ce4ea03acc$var$Be(C.ordinalNumber(i, {
                            unit: "year"
                        }), v);
                    default:
                        return $0422a6ce4ea03acc$var$Be($0422a6ce4ea03acc$var$Se(p.length, i), v);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p.isTwoDigitYear || p.year > 0;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                var v = i.getUTCFullYear();
                if (C.isTwoDigitYear) {
                    var y = $0422a6ce4ea03acc$var$Tb(C.year, v);
                    return i.setUTCFullYear(y, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
                }
                var L = !("era" in p) || p.era === 1 ? C.year : 1 - C.year;
                return i.setUTCFullYear(L, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$HR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 130), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                var v = function(L) {
                    return {
                        year: L,
                        isTwoDigitYear: p === "YY"
                    };
                };
                switch(p){
                    case "Y":
                        return $0422a6ce4ea03acc$var$Be($0422a6ce4ea03acc$var$Se(4, i), v);
                    case "Yo":
                        return $0422a6ce4ea03acc$var$Be(C.ordinalNumber(i, {
                            unit: "year"
                        }), v);
                    default:
                        return $0422a6ce4ea03acc$var$Be($0422a6ce4ea03acc$var$Se(p.length, i), v);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p.isTwoDigitYear || p.year > 0;
            }
        },
        {
            key: "set",
            value: function(i, p, C, v) {
                var y = $0422a6ce4ea03acc$var$bh(i, v);
                if (C.isTwoDigitYear) {
                    var L = $0422a6ce4ea03acc$var$Tb(C.year, y);
                    return i.setUTCFullYear(L, 0, v.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), $0422a6ce4ea03acc$var$_t(i, v);
                }
                var M = !("era" in p) || p.era === 1 ? C.year : 1 - C.year;
                return i.setUTCFullYear(M, 0, v.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), $0422a6ce4ea03acc$var$_t(i, v);
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$xR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 130), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p) {
                return $0422a6ce4ea03acc$var$cc(p === "R" ? 4 : p.length, i);
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                var v = /* @__PURE__ */ new Date(0);
                return v.setUTCFullYear(C, 0, 4), v.setUTCHours(0, 0, 0, 0), $0422a6ce4ea03acc$var$Qr(v);
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$VR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 130), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p) {
                return $0422a6ce4ea03acc$var$cc(p === "u" ? 4 : p.length, i);
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCFullYear(C, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$MR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 120), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "Q":
                    case "QQ":
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                    case "Qo":
                        return C.ordinalNumber(i, {
                            unit: "quarter"
                        });
                    case "QQQ":
                        return C.quarter(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.quarter(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "QQQQQ":
                        return C.quarter(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "QQQQ":
                    default:
                        return C.quarter(i, {
                            width: "wide",
                            context: "formatting"
                        }) || C.quarter(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.quarter(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 1 && p <= 4;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCMonth((C - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$ER = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 120), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "q":
                    case "qq":
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                    case "qo":
                        return C.ordinalNumber(i, {
                            unit: "quarter"
                        });
                    case "qqq":
                        return C.quarter(i, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || C.quarter(i, {
                            width: "narrow",
                            context: "standalone"
                        });
                    case "qqqqq":
                        return C.quarter(i, {
                            width: "narrow",
                            context: "standalone"
                        });
                    case "qqqq":
                    default:
                        return C.quarter(i, {
                            width: "wide",
                            context: "standalone"
                        }) || C.quarter(i, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || C.quarter(i, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 1 && p <= 4;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCMonth((C - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$SR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 110), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                var v = function(L) {
                    return L - 1;
                };
                switch(p){
                    case "M":
                        return $0422a6ce4ea03acc$var$Be($0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.month, i), v);
                    case "MM":
                        return $0422a6ce4ea03acc$var$Be($0422a6ce4ea03acc$var$Se(2, i), v);
                    case "Mo":
                        return $0422a6ce4ea03acc$var$Be(C.ordinalNumber(i, {
                            unit: "month"
                        }), v);
                    case "MMM":
                        return C.month(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.month(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "MMMMM":
                        return C.month(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "MMMM":
                    default:
                        return C.month(i, {
                            width: "wide",
                            context: "formatting"
                        }) || C.month(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.month(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 0 && p <= 11;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCMonth(C, 1), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$kR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 110), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                var v = function(L) {
                    return L - 1;
                };
                switch(p){
                    case "L":
                        return $0422a6ce4ea03acc$var$Be($0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.month, i), v);
                    case "LL":
                        return $0422a6ce4ea03acc$var$Be($0422a6ce4ea03acc$var$Se(2, i), v);
                    case "Lo":
                        return $0422a6ce4ea03acc$var$Be(C.ordinalNumber(i, {
                            unit: "month"
                        }), v);
                    case "LLL":
                        return C.month(i, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || C.month(i, {
                            width: "narrow",
                            context: "standalone"
                        });
                    case "LLLLL":
                        return C.month(i, {
                            width: "narrow",
                            context: "standalone"
                        });
                    case "LLLL":
                    default:
                        return C.month(i, {
                            width: "wide",
                            context: "standalone"
                        }) || C.month(i, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || C.month(i, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 0 && p <= 11;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCMonth(C, 1), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3);
function $0422a6ce4ea03acc$var$TR(r, a, o) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var s = $0422a6ce4ea03acc$var$a2(r), i = $0422a6ce4ea03acc$var$q2(a), p = $0422a6ce4ea03acc$var$vb(s, o) - i;
    return s.setUTCDate(s.getUTCDate() - p * 7), s;
}
var $0422a6ce4ea03acc$var$_R = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 100), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "w":
                        return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.week, i);
                    case "wo":
                        return C.ordinalNumber(i, {
                            unit: "week"
                        });
                    default:
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 1 && p <= 53;
            }
        },
        {
            key: "set",
            value: function(i, p, C, v) {
                return $0422a6ce4ea03acc$var$_t($0422a6ce4ea03acc$var$TR(i, C, v), v);
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3);
function $0422a6ce4ea03acc$var$DR(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$a2(r), s = $0422a6ce4ea03acc$var$q2(a), i = $0422a6ce4ea03acc$var$mb(o) - s;
    return o.setUTCDate(o.getUTCDate() - i * 7), o;
}
var $0422a6ce4ea03acc$var$RR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 100), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "I":
                        return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.week, i);
                    case "Io":
                        return C.ordinalNumber(i, {
                            unit: "week"
                        });
                    default:
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 1 && p <= 53;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return $0422a6ce4ea03acc$var$Qr($0422a6ce4ea03acc$var$DR(i, C));
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$ZR = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], $0422a6ce4ea03acc$var$OR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], $0422a6ce4ea03acc$var$NR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 90), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "subPriority", 1), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "d":
                        return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.date, i);
                    case "do":
                        return C.ordinalNumber(i, {
                            unit: "date"
                        });
                    default:
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                var C = i.getUTCFullYear(), v = $0422a6ce4ea03acc$var$_b(C), y = i.getUTCMonth();
                return v ? p >= 1 && p <= $0422a6ce4ea03acc$var$OR[y] : p >= 1 && p <= $0422a6ce4ea03acc$var$ZR[y];
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCDate(C), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$PR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 90), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "subpriority", 1), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "D":
                    case "DD":
                        return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.dayOfYear, i);
                    case "Do":
                        return C.ordinalNumber(i, {
                            unit: "date"
                        });
                    default:
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                var C = i.getUTCFullYear(), v = $0422a6ce4ea03acc$var$_b(C);
                return v ? p >= 1 && p <= 366 : p >= 1 && p <= 365;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCMonth(0, C), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3);
function $0422a6ce4ea03acc$var$Mh(r, a, o) {
    var s, i, p, C, v, y, L, M;
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var E = $0422a6ce4ea03acc$var$Rt(), k = $0422a6ce4ea03acc$var$q2((s = (i = (p = (C = o == null ? void 0 : o.weekStartsOn) !== null && C !== void 0 ? C : o == null || (v = o.locale) === null || v === void 0 || (y = v.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && p !== void 0 ? p : E.weekStartsOn) !== null && i !== void 0 ? i : (L = E.locale) === null || L === void 0 || (M = L.options) === null || M === void 0 ? void 0 : M.weekStartsOn) !== null && s !== void 0 ? s : 0);
    if (!(k >= 0 && k <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var _ = $0422a6ce4ea03acc$var$a2(r), Z = $0422a6ce4ea03acc$var$q2(a), O = _.getUTCDay(), B = Z % 7, z = (B + 7) % 7, I = (z < k ? 7 : 0) + Z - O;
    return _.setUTCDate(_.getUTCDate() + I), _;
}
var $0422a6ce4ea03acc$var$BR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 90), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "E":
                    case "EE":
                    case "EEE":
                        return C.day(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "short",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "EEEEE":
                        return C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "EEEEEE":
                        return C.day(i, {
                            width: "short",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "EEEE":
                    default:
                        return C.day(i, {
                            width: "wide",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "short",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 0 && p <= 6;
            }
        },
        {
            key: "set",
            value: function(i, p, C, v) {
                return i = $0422a6ce4ea03acc$var$Mh(i, C, v), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$FR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 90), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C, v) {
                var y = function(M) {
                    var E = Math.floor((M - 1) / 7) * 7;
                    return (M + v.weekStartsOn + 6) % 7 + E;
                };
                switch(p){
                    case "e":
                    case "ee":
                        return $0422a6ce4ea03acc$var$Be($0422a6ce4ea03acc$var$Se(p.length, i), y);
                    case "eo":
                        return $0422a6ce4ea03acc$var$Be(C.ordinalNumber(i, {
                            unit: "day"
                        }), y);
                    case "eee":
                        return C.day(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "short",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "eeeee":
                        return C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "eeeeee":
                        return C.day(i, {
                            width: "short",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "eeee":
                    default:
                        return C.day(i, {
                            width: "wide",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "short",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 0 && p <= 6;
            }
        },
        {
            key: "set",
            value: function(i, p, C, v) {
                return i = $0422a6ce4ea03acc$var$Mh(i, C, v), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$AR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 90), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C, v) {
                var y = function(M) {
                    var E = Math.floor((M - 1) / 7) * 7;
                    return (M + v.weekStartsOn + 6) % 7 + E;
                };
                switch(p){
                    case "c":
                    case "cc":
                        return $0422a6ce4ea03acc$var$Be($0422a6ce4ea03acc$var$Se(p.length, i), y);
                    case "co":
                        return $0422a6ce4ea03acc$var$Be(C.ordinalNumber(i, {
                            unit: "day"
                        }), y);
                    case "ccc":
                        return C.day(i, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || C.day(i, {
                            width: "short",
                            context: "standalone"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "standalone"
                        });
                    case "ccccc":
                        return C.day(i, {
                            width: "narrow",
                            context: "standalone"
                        });
                    case "cccccc":
                        return C.day(i, {
                            width: "short",
                            context: "standalone"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "standalone"
                        });
                    case "cccc":
                    default:
                        return C.day(i, {
                            width: "wide",
                            context: "standalone"
                        }) || C.day(i, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || C.day(i, {
                            width: "short",
                            context: "standalone"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 0 && p <= 6;
            }
        },
        {
            key: "set",
            value: function(i, p, C, v) {
                return i = $0422a6ce4ea03acc$var$Mh(i, C, v), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3);
function $0422a6ce4ea03acc$var$jR(r, a) {
    $0422a6ce4ea03acc$var$F1(2, arguments);
    var o = $0422a6ce4ea03acc$var$q2(a);
    o % 7 === 0 && (o = o - 7);
    var s = 1, i = $0422a6ce4ea03acc$var$a2(r), p = i.getUTCDay(), C = o % 7, v = (C + 7) % 7, y = (v < s ? 7 : 0) + o - p;
    return i.setUTCDate(i.getUTCDate() + y), i;
}
var $0422a6ce4ea03acc$var$zR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 90), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                var v = function(L) {
                    return L === 0 ? 7 : L;
                };
                switch(p){
                    case "i":
                    case "ii":
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                    case "io":
                        return C.ordinalNumber(i, {
                            unit: "day"
                        });
                    case "iii":
                        return $0422a6ce4ea03acc$var$Be(C.day(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "short",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        }), v);
                    case "iiiii":
                        return $0422a6ce4ea03acc$var$Be(C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        }), v);
                    case "iiiiii":
                        return $0422a6ce4ea03acc$var$Be(C.day(i, {
                            width: "short",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        }), v);
                    case "iiii":
                    default:
                        return $0422a6ce4ea03acc$var$Be(C.day(i, {
                            width: "wide",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "short",
                            context: "formatting"
                        }) || C.day(i, {
                            width: "narrow",
                            context: "formatting"
                        }), v);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 1 && p <= 7;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i = $0422a6ce4ea03acc$var$jR(i, C), i.setUTCHours(0, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$UR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 80), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "a":
                    case "aa":
                    case "aaa":
                        return C.dayPeriod(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.dayPeriod(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return C.dayPeriod(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return C.dayPeriod(i, {
                            width: "wide",
                            context: "formatting"
                        }) || C.dayPeriod(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.dayPeriod(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCHours($0422a6ce4ea03acc$var$Vh(C), 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$IR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 80), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "b":
                    case "bb":
                    case "bbb":
                        return C.dayPeriod(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.dayPeriod(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return C.dayPeriod(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return C.dayPeriod(i, {
                            width: "wide",
                            context: "formatting"
                        }) || C.dayPeriod(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.dayPeriod(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCHours($0422a6ce4ea03acc$var$Vh(C), 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$$R = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 80), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "B":
                    case "BB":
                    case "BBB":
                        return C.dayPeriod(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.dayPeriod(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return C.dayPeriod(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return C.dayPeriod(i, {
                            width: "wide",
                            context: "formatting"
                        }) || C.dayPeriod(i, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || C.dayPeriod(i, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCHours($0422a6ce4ea03acc$var$Vh(C), 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$YR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 70), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "h":
                        return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.hour12h, i);
                    case "ho":
                        return C.ordinalNumber(i, {
                            unit: "hour"
                        });
                    default:
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 1 && p <= 12;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                var v = i.getUTCHours() >= 12;
                return v && C < 12 ? i.setUTCHours(C + 12, 0, 0, 0) : !v && C === 12 ? i.setUTCHours(0, 0, 0, 0) : i.setUTCHours(C, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$WR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 70), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "H":
                        return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.hour23h, i);
                    case "Ho":
                        return C.ordinalNumber(i, {
                            unit: "hour"
                        });
                    default:
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 0 && p <= 23;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCHours(C, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$QR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 70), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "K":
                        return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.hour11h, i);
                    case "Ko":
                        return C.ordinalNumber(i, {
                            unit: "hour"
                        });
                    default:
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 0 && p <= 11;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                var v = i.getUTCHours() >= 12;
                return v && C < 12 ? i.setUTCHours(C + 12, 0, 0, 0) : i.setUTCHours(C, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$qR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 70), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "k":
                        return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.hour24h, i);
                    case "ko":
                        return C.ordinalNumber(i, {
                            unit: "hour"
                        });
                    default:
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 1 && p <= 24;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                var v = C <= 24 ? C % 24 : C;
                return i.setUTCHours(v, 0, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$GR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 60), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "m":
                        return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.minute, i);
                    case "mo":
                        return C.ordinalNumber(i, {
                            unit: "minute"
                        });
                    default:
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 0 && p <= 59;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCMinutes(C, 0, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$XR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 50), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p, C) {
                switch(p){
                    case "s":
                        return $0422a6ce4ea03acc$var$we($0422a6ce4ea03acc$var$Pe.second, i);
                    case "so":
                        return C.ordinalNumber(i, {
                            unit: "second"
                        });
                    default:
                        return $0422a6ce4ea03acc$var$Se(p.length, i);
                }
            }
        },
        {
            key: "validate",
            value: function(i, p) {
                return p >= 0 && p <= 59;
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCSeconds(C, 0), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$KR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 30), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "t",
            "T"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p) {
                var C = function(y) {
                    return Math.floor(y * Math.pow(10, -p.length + 3));
                };
                return $0422a6ce4ea03acc$var$Be($0422a6ce4ea03acc$var$Se(p.length, i), C);
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return i.setUTCMilliseconds(C), i;
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$JR = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 10), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p) {
                switch(p){
                    case "X":
                        return $0422a6ce4ea03acc$var$c8($0422a6ce4ea03acc$var$u8.basicOptionalMinutes, i);
                    case "XX":
                        return $0422a6ce4ea03acc$var$c8($0422a6ce4ea03acc$var$u8.basic, i);
                    case "XXXX":
                        return $0422a6ce4ea03acc$var$c8($0422a6ce4ea03acc$var$u8.basicOptionalSeconds, i);
                    case "XXXXX":
                        return $0422a6ce4ea03acc$var$c8($0422a6ce4ea03acc$var$u8.extendedOptionalSeconds, i);
                    case "XXX":
                    default:
                        return $0422a6ce4ea03acc$var$c8($0422a6ce4ea03acc$var$u8.extended, i);
                }
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return p.timestampIsSet ? i : new Date(i.getTime() - C);
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$eZ = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 10), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i, p) {
                switch(p){
                    case "x":
                        return $0422a6ce4ea03acc$var$c8($0422a6ce4ea03acc$var$u8.basicOptionalMinutes, i);
                    case "xx":
                        return $0422a6ce4ea03acc$var$c8($0422a6ce4ea03acc$var$u8.basic, i);
                    case "xxxx":
                        return $0422a6ce4ea03acc$var$c8($0422a6ce4ea03acc$var$u8.basicOptionalSeconds, i);
                    case "xxxxx":
                        return $0422a6ce4ea03acc$var$c8($0422a6ce4ea03acc$var$u8.extendedOptionalSeconds, i);
                    case "xxx":
                    default:
                        return $0422a6ce4ea03acc$var$c8($0422a6ce4ea03acc$var$u8.extended, i);
                }
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return p.timestampIsSet ? i : new Date(i.getTime() - C);
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$tZ = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 40), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", "*"), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i) {
                return $0422a6ce4ea03acc$var$kb(i);
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return [
                    new Date(C * 1e3),
                    {
                        timestampIsSet: !0
                    }
                ];
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$nZ = /* @__PURE__ */ function(r) {
    $0422a6ce4ea03acc$var$L3(o, r);
    var a = $0422a6ce4ea03acc$var$b3(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$u3(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return s = a.call.apply(a, [
            this
        ].concat(p)), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "priority", 20), $0422a6ce4ea03acc$var$W1($0422a6ce4ea03acc$var$e2(s), "incompatibleTokens", "*"), s;
    }
    return $0422a6ce4ea03acc$var$c3(o, [
        {
            key: "parse",
            value: function(i) {
                return $0422a6ce4ea03acc$var$kb(i);
            }
        },
        {
            key: "set",
            value: function(i, p, C) {
                return [
                    new Date(C),
                    {
                        timestampIsSet: !0
                    }
                ];
            }
        }
    ]), o;
}($0422a6ce4ea03acc$var$E3), $0422a6ce4ea03acc$var$rZ = {
    G: new $0422a6ce4ea03acc$var$LR(),
    y: new $0422a6ce4ea03acc$var$wR(),
    Y: new $0422a6ce4ea03acc$var$HR(),
    R: new $0422a6ce4ea03acc$var$xR(),
    u: new $0422a6ce4ea03acc$var$VR(),
    Q: new $0422a6ce4ea03acc$var$MR(),
    q: new $0422a6ce4ea03acc$var$ER(),
    M: new $0422a6ce4ea03acc$var$SR(),
    L: new $0422a6ce4ea03acc$var$kR(),
    w: new $0422a6ce4ea03acc$var$_R(),
    I: new $0422a6ce4ea03acc$var$RR(),
    d: new $0422a6ce4ea03acc$var$NR(),
    D: new $0422a6ce4ea03acc$var$PR(),
    E: new $0422a6ce4ea03acc$var$BR(),
    e: new $0422a6ce4ea03acc$var$FR(),
    c: new $0422a6ce4ea03acc$var$AR(),
    i: new $0422a6ce4ea03acc$var$zR(),
    a: new $0422a6ce4ea03acc$var$UR(),
    b: new $0422a6ce4ea03acc$var$IR(),
    B: new $0422a6ce4ea03acc$var$$R(),
    h: new $0422a6ce4ea03acc$var$YR(),
    H: new $0422a6ce4ea03acc$var$WR(),
    K: new $0422a6ce4ea03acc$var$QR(),
    k: new $0422a6ce4ea03acc$var$qR(),
    m: new $0422a6ce4ea03acc$var$GR(),
    s: new $0422a6ce4ea03acc$var$XR(),
    S: new $0422a6ce4ea03acc$var$KR(),
    X: new $0422a6ce4ea03acc$var$JR(),
    x: new $0422a6ce4ea03acc$var$eZ(),
    t: new $0422a6ce4ea03acc$var$tZ(),
    T: new $0422a6ce4ea03acc$var$nZ()
}, $0422a6ce4ea03acc$var$aZ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $0422a6ce4ea03acc$var$iZ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $0422a6ce4ea03acc$var$oZ = /^'([^]*?)'?$/, $0422a6ce4ea03acc$var$lZ = /''/g, $0422a6ce4ea03acc$var$sZ = /\S/, $0422a6ce4ea03acc$var$uZ = /[a-zA-Z]/;
function $0422a6ce4ea03acc$var$Cp(r, a, o, s) {
    var i, p, C, v, y, L, M, E, k, _, Z, O, B, z, I, P, $, W;
    $0422a6ce4ea03acc$var$F1(3, arguments);
    var l1 = String(r), u1 = String(a), m1 = $0422a6ce4ea03acc$var$Rt(), L1 = (i = (p = s == null ? void 0 : s.locale) !== null && p !== void 0 ? p : m1.locale) !== null && i !== void 0 ? i : $0422a6ce4ea03acc$var$bb;
    if (!L1.match) throw new RangeError("locale must contain match property");
    var E1 = $0422a6ce4ea03acc$var$q2((C = (v = (y = (L = s == null ? void 0 : s.firstWeekContainsDate) !== null && L !== void 0 ? L : s == null || (M = s.locale) === null || M === void 0 || (E = M.options) === null || E === void 0 ? void 0 : E.firstWeekContainsDate) !== null && y !== void 0 ? y : m1.firstWeekContainsDate) !== null && v !== void 0 ? v : (k = m1.locale) === null || k === void 0 || (_ = k.options) === null || _ === void 0 ? void 0 : _.firstWeekContainsDate) !== null && C !== void 0 ? C : 1);
    if (!(E1 >= 1 && E1 <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var H1 = $0422a6ce4ea03acc$var$q2((Z = (O = (B = (z = s == null ? void 0 : s.weekStartsOn) !== null && z !== void 0 ? z : s == null || (I = s.locale) === null || I === void 0 || (P = I.options) === null || P === void 0 ? void 0 : P.weekStartsOn) !== null && B !== void 0 ? B : m1.weekStartsOn) !== null && O !== void 0 ? O : ($ = m1.locale) === null || $ === void 0 || (W = $.options) === null || W === void 0 ? void 0 : W.weekStartsOn) !== null && Z !== void 0 ? Z : 0);
    if (!(H1 >= 0 && H1 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (u1 === "") return l1 === "" ? $0422a6ce4ea03acc$var$a2(o) : /* @__PURE__ */ new Date(NaN);
    var B1 = {
        firstWeekContainsDate: E1,
        weekStartsOn: H1,
        locale: L1
    }, h1 = [
        new $0422a6ce4ea03acc$var$yR()
    ], k1 = u1.match($0422a6ce4ea03acc$var$iZ).map(function(u2) {
        var o2 = u2[0];
        if (o2 in $0422a6ce4ea03acc$var$Ip) {
            var P2 = $0422a6ce4ea03acc$var$Ip[o2];
            return P2(u2, L1.formatLong);
        }
        return u2;
    }).join("").match($0422a6ce4ea03acc$var$aZ), I1 = [], D1 = $0422a6ce4ea03acc$var$Qy(k1), s2;
    try {
        var f1 = function() {
            var o2 = s2.value;
            !(s != null && s.useAdditionalWeekYearTokens) && $0422a6ce4ea03acc$var$Lb(o2) && $0422a6ce4ea03acc$var$ac(o2, u1, r), !(s != null && s.useAdditionalDayOfYearTokens) && $0422a6ce4ea03acc$var$yb(o2) && $0422a6ce4ea03acc$var$ac(o2, u1, r);
            var P2 = o2[0], G2 = $0422a6ce4ea03acc$var$rZ[P2];
            if (G2) {
                var V3 = G2.incompatibleTokens;
                if (Array.isArray(V3)) {
                    var I2 = I1.find(function(j1) {
                        return V3.includes(j1.token) || j1.token === P2;
                    });
                    if (I2) throw new RangeError("The format string mustn't contain `".concat(I2.fullToken, "` and `").concat(o2, "` at the same time"));
                } else if (G2.incompatibleTokens === "*" && I1.length > 0) throw new RangeError("The format string mustn't contain `".concat(o2, "` and any other token at the same time"));
                I1.push({
                    token: P2,
                    fullToken: o2
                });
                var T1 = G2.run(l1, o2, L1.match, B1);
                if (!T1) return {
                    v: /* @__PURE__ */ new Date(NaN)
                };
                h1.push(T1.setter), l1 = T1.rest;
            } else {
                if (P2.match($0422a6ce4ea03acc$var$uZ)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + P2 + "`");
                if (o2 === "''" ? o2 = "'" : P2 === "'" && (o2 = $0422a6ce4ea03acc$var$cZ(o2)), l1.indexOf(o2) === 0) l1 = l1.slice(o2.length);
                else return {
                    v: /* @__PURE__ */ new Date(NaN)
                };
            }
        };
        for(D1.s(); !(s2 = D1.n()).done;){
            var M1 = f1();
            if ($0422a6ce4ea03acc$var$D6(M1) === "object") return M1.v;
        }
    } catch (u2) {
        D1.e(u2);
    } finally{
        D1.f();
    }
    if (l1.length > 0 && $0422a6ce4ea03acc$var$sZ.test(l1)) return /* @__PURE__ */ new Date(NaN);
    var g1 = h1.map(function(u2) {
        return u2.priority;
    }).sort(function(u2, o2) {
        return o2 - u2;
    }).filter(function(u2, o2, P2) {
        return P2.indexOf(u2) === o2;
    }).map(function(u2) {
        return h1.filter(function(o2) {
            return o2.priority === u2;
        }).sort(function(o2, P2) {
            return P2.subPriority - o2.subPriority;
        });
    }).map(function(u2) {
        return u2[0];
    }), K1 = $0422a6ce4ea03acc$var$a2(o);
    if (isNaN(K1.getTime())) return /* @__PURE__ */ new Date(NaN);
    var G1 = $0422a6ce4ea03acc$var$pb(K1, $0422a6ce4ea03acc$var$rc(K1)), R1 = {}, E2 = $0422a6ce4ea03acc$var$Qy(g1), a3;
    try {
        for(E2.s(); !(a3 = E2.n()).done;){
            var H2 = a3.value;
            if (!H2.validate(G1, B1)) return /* @__PURE__ */ new Date(NaN);
            var A2 = H2.set(G1, R1, B1);
            Array.isArray(A2) ? (G1 = A2[0], $0422a6ce4ea03acc$var$fR(R1, A2[1])) : G1 = A2;
        }
    } catch (u2) {
        E2.e(u2);
    } finally{
        E2.f();
    }
    return G1;
}
function $0422a6ce4ea03acc$var$cZ(r) {
    return r.match($0422a6ce4ea03acc$var$oZ)[1].replace($0422a6ce4ea03acc$var$lZ, "'");
}
function $0422a6ce4ea03acc$var$dZ(r, a) {
    var o;
    $0422a6ce4ea03acc$var$F1(1, arguments);
    var s = $0422a6ce4ea03acc$var$q2((o = void 0, o !== void 0) ? o : 2);
    if (s !== 2 && s !== 1 && s !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof r == "string" || Object.prototype.toString.call(r) === "[object String]")) return /* @__PURE__ */ new Date(NaN);
    var i = $0422a6ce4ea03acc$var$hZ(r), p;
    if (i.date) {
        var C = $0422a6ce4ea03acc$var$mZ(i.date, s);
        p = $0422a6ce4ea03acc$var$vZ(C.restDateString, C.year);
    }
    if (!p || isNaN(p.getTime())) return /* @__PURE__ */ new Date(NaN);
    var v = p.getTime(), y = 0, L;
    if (i.time && (y = $0422a6ce4ea03acc$var$gZ(i.time), isNaN(y))) return /* @__PURE__ */ new Date(NaN);
    if (i.timezone) {
        if (L = $0422a6ce4ea03acc$var$yZ(i.timezone), isNaN(L)) return /* @__PURE__ */ new Date(NaN);
    } else {
        var M = new Date(v + y), E = /* @__PURE__ */ new Date(0);
        return E.setFullYear(M.getUTCFullYear(), M.getUTCMonth(), M.getUTCDate()), E.setHours(M.getUTCHours(), M.getUTCMinutes(), M.getUTCSeconds(), M.getUTCMilliseconds()), E;
    }
    return new Date(v + y + L);
}
var $0422a6ce4ea03acc$var$Fu = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
}, $0422a6ce4ea03acc$var$CZ = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, $0422a6ce4ea03acc$var$fZ = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, $0422a6ce4ea03acc$var$pZ = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $0422a6ce4ea03acc$var$hZ(r) {
    var a = {}, o = r.split($0422a6ce4ea03acc$var$Fu.dateTimeDelimiter), s;
    if (o.length > 2) return a;
    if (/:/.test(o[0]) ? s = o[0] : (a.date = o[0], s = o[1], $0422a6ce4ea03acc$var$Fu.timeZoneDelimiter.test(a.date) && (a.date = r.split($0422a6ce4ea03acc$var$Fu.timeZoneDelimiter)[0], s = r.substr(a.date.length, r.length))), s) {
        var i = $0422a6ce4ea03acc$var$Fu.timezone.exec(s);
        i ? (a.time = s.replace(i[1], ""), a.timezone = i[1]) : a.time = s;
    }
    return a;
}
function $0422a6ce4ea03acc$var$mZ(r, a) {
    var o = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + a) + "})|(\\d{2}|[+-]\\d{" + (2 + a) + "})$)"), s = r.match(o);
    if (!s) return {
        year: NaN,
        restDateString: ""
    };
    var i = s[1] ? parseInt(s[1]) : null, p = s[2] ? parseInt(s[2]) : null;
    return {
        year: p === null ? i : p * 100,
        restDateString: r.slice((s[1] || s[2]).length)
    };
}
function $0422a6ce4ea03acc$var$vZ(r, a) {
    if (a === null) return /* @__PURE__ */ new Date(NaN);
    var o = r.match($0422a6ce4ea03acc$var$CZ);
    if (!o) return /* @__PURE__ */ new Date(NaN);
    var s = !!o[4], i = $0422a6ce4ea03acc$var$Ho(o[1]), p = $0422a6ce4ea03acc$var$Ho(o[2]) - 1, C = $0422a6ce4ea03acc$var$Ho(o[3]), v = $0422a6ce4ea03acc$var$Ho(o[4]), y = $0422a6ce4ea03acc$var$Ho(o[5]) - 1;
    if (s) return $0422a6ce4ea03acc$var$xZ(a, v, y) ? $0422a6ce4ea03acc$var$LZ(a, v, y) : /* @__PURE__ */ new Date(NaN);
    var L = /* @__PURE__ */ new Date(0);
    return !$0422a6ce4ea03acc$var$wZ(a, p, C) || !$0422a6ce4ea03acc$var$HZ(a, i) ? /* @__PURE__ */ new Date(NaN) : (L.setUTCFullYear(a, p, Math.max(i, C)), L);
}
function $0422a6ce4ea03acc$var$Ho(r) {
    return r ? parseInt(r) : 1;
}
function $0422a6ce4ea03acc$var$gZ(r) {
    var a = r.match($0422a6ce4ea03acc$var$fZ);
    if (!a) return NaN;
    var o = $0422a6ce4ea03acc$var$fp(a[1]), s = $0422a6ce4ea03acc$var$fp(a[2]), i = $0422a6ce4ea03acc$var$fp(a[3]);
    return $0422a6ce4ea03acc$var$VZ(o, s, i) ? o * $0422a6ce4ea03acc$var$xh + s * $0422a6ce4ea03acc$var$Hh + i * 1e3 : NaN;
}
function $0422a6ce4ea03acc$var$fp(r) {
    return r && parseFloat(r.replace(",", ".")) || 0;
}
function $0422a6ce4ea03acc$var$yZ(r) {
    if (r === "Z") return 0;
    var a = r.match($0422a6ce4ea03acc$var$pZ);
    if (!a) return 0;
    var o = a[1] === "+" ? -1 : 1, s = parseInt(a[2]), i = a[3] && parseInt(a[3]) || 0;
    return $0422a6ce4ea03acc$var$MZ(s, i) ? o * (s * $0422a6ce4ea03acc$var$xh + i * $0422a6ce4ea03acc$var$Hh) : NaN;
}
function $0422a6ce4ea03acc$var$LZ(r, a, o) {
    var s = /* @__PURE__ */ new Date(0);
    s.setUTCFullYear(r, 0, 4);
    var i = s.getUTCDay() || 7, p = (a - 1) * 7 + o + 1 - i;
    return s.setUTCDate(s.getUTCDate() + p), s;
}
var $0422a6ce4ea03acc$var$bZ = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $0422a6ce4ea03acc$var$Db(r) {
    return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
function $0422a6ce4ea03acc$var$wZ(r, a, o) {
    return a >= 0 && a <= 11 && o >= 1 && o <= ($0422a6ce4ea03acc$var$bZ[a] || ($0422a6ce4ea03acc$var$Db(r) ? 29 : 28));
}
function $0422a6ce4ea03acc$var$HZ(r, a) {
    return a >= 1 && a <= ($0422a6ce4ea03acc$var$Db(r) ? 366 : 365);
}
function $0422a6ce4ea03acc$var$xZ(r, a, o) {
    return a >= 1 && a <= 53 && o >= 0 && o <= 6;
}
function $0422a6ce4ea03acc$var$VZ(r, a, o) {
    return r === 24 ? a === 0 && o === 0 : o >= 0 && o < 60 && a >= 0 && a < 60 && r >= 0 && r < 25;
}
function $0422a6ce4ea03acc$var$MZ(r, a) {
    return a >= 0 && a <= 59;
}
var $0422a6ce4ea03acc$var$Gp = {
    exports: {}
}, $0422a6ce4ea03acc$var$A5 = {}, $0422a6ce4ea03acc$var$Au = {
    exports: {}
}, $0422a6ce4ea03acc$var$pp = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0422a6ce4ea03acc$var$qy;
function $0422a6ce4ea03acc$var$EZ() {
    return $0422a6ce4ea03acc$var$qy || ($0422a6ce4ea03acc$var$qy = 1, function(r) {
        function a(f1, M1) {
            var g1 = f1.length;
            f1.push(M1);
            e: for(; 0 < g1;){
                var K1 = g1 - 1 >>> 1, G1 = f1[K1];
                if (0 < i(G1, M1)) f1[K1] = M1, f1[g1] = G1, g1 = K1;
                else break e;
            }
        }
        function o(f1) {
            return f1.length === 0 ? null : f1[0];
        }
        function s(f1) {
            if (f1.length === 0) return null;
            var M1 = f1[0], g1 = f1.pop();
            if (g1 !== M1) {
                f1[0] = g1;
                e: for(var K1 = 0, G1 = f1.length, R1 = G1 >>> 1; K1 < R1;){
                    var E2 = 2 * (K1 + 1) - 1, a3 = f1[E2], H2 = E2 + 1, A2 = f1[H2];
                    if (0 > i(a3, g1)) H2 < G1 && 0 > i(A2, a3) ? (f1[K1] = A2, f1[H2] = g1, K1 = H2) : (f1[K1] = a3, f1[E2] = g1, K1 = E2);
                    else if (H2 < G1 && 0 > i(A2, g1)) f1[K1] = A2, f1[H2] = g1, K1 = H2;
                    else break e;
                }
            }
            return M1;
        }
        function i(f1, M1) {
            var g1 = f1.sortIndex - M1.sortIndex;
            return g1 !== 0 ? g1 : f1.id - M1.id;
        }
        if (typeof performance == "object" && typeof performance.now == "function") {
            var p = performance;
            r.unstable_now = function() {
                return p.now();
            };
        } else {
            var C = Date, v = C.now();
            r.unstable_now = function() {
                return C.now() - v;
            };
        }
        var y = [], L = [], M = 1, E = null, k = 3, _ = !1, Z = !1, O = !1, B = typeof setTimeout == "function" ? setTimeout : null, z = typeof clearTimeout == "function" ? clearTimeout : null, I = typeof setImmediate < "u" ? setImmediate : null;
        typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
        function P(f1) {
            for(var M1 = o(L); M1 !== null;){
                if (M1.callback === null) s(L);
                else if (M1.startTime <= f1) s(L), M1.sortIndex = M1.expirationTime, a(y, M1);
                else break;
                M1 = o(L);
            }
        }
        function $(f1) {
            if (O = !1, P(f1), !Z) {
                if (o(y) !== null) Z = !0, D1(W);
                else {
                    var M1 = o(L);
                    M1 !== null && s2($, M1.startTime - f1);
                }
            }
        }
        function W(f1, M1) {
            Z = !1, O && (O = !1, z(m1), m1 = -1), _ = !0;
            var g1 = k;
            try {
                for(P(M1), E = o(y); E !== null && (!(E.expirationTime > M1) || f1 && !H1());){
                    var K1 = E.callback;
                    if (typeof K1 == "function") {
                        E.callback = null, k = E.priorityLevel;
                        var G1 = K1(E.expirationTime <= M1);
                        M1 = r.unstable_now(), typeof G1 == "function" ? E.callback = G1 : E === o(y) && s(y), P(M1);
                    } else s(y);
                    E = o(y);
                }
                if (E !== null) var R1 = !0;
                else {
                    var E2 = o(L);
                    E2 !== null && s2($, E2.startTime - M1), R1 = !1;
                }
                return R1;
            } finally{
                E = null, k = g1, _ = !1;
            }
        }
        var l1 = !1, u1 = null, m1 = -1, L1 = 5, E1 = -1;
        function H1() {
            return !(r.unstable_now() - E1 < L1);
        }
        function B1() {
            if (u1 !== null) {
                var f1 = r.unstable_now();
                E1 = f1;
                var M1 = !0;
                try {
                    M1 = u1(!0, f1);
                } finally{
                    M1 ? h1() : (l1 = !1, u1 = null);
                }
            } else l1 = !1;
        }
        var h1;
        if (typeof I == "function") h1 = function() {
            I(B1);
        };
        else if (typeof MessageChannel < "u") {
            var k1 = new MessageChannel(), I1 = k1.port2;
            k1.port1.onmessage = B1, h1 = function() {
                I1.postMessage(null);
            };
        } else h1 = function() {
            B(B1, 0);
        };
        function D1(f1) {
            u1 = f1, l1 || (l1 = !0, h1());
        }
        function s2(f1, M1) {
            m1 = B(function() {
                f1(r.unstable_now());
            }, M1);
        }
        r.unstable_IdlePriority = 5, r.unstable_ImmediatePriority = 1, r.unstable_LowPriority = 4, r.unstable_NormalPriority = 3, r.unstable_Profiling = null, r.unstable_UserBlockingPriority = 2, r.unstable_cancelCallback = function(f1) {
            f1.callback = null;
        }, r.unstable_continueExecution = function() {
            Z || _ || (Z = !0, D1(W));
        }, r.unstable_forceFrameRate = function(f1) {
            0 > f1 || 125 < f1 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : L1 = 0 < f1 ? Math.floor(1e3 / f1) : 5;
        }, r.unstable_getCurrentPriorityLevel = function() {
            return k;
        }, r.unstable_getFirstCallbackNode = function() {
            return o(y);
        }, r.unstable_next = function(f1) {
            switch(k){
                case 1:
                case 2:
                case 3:
                    var M1 = 3;
                    break;
                default:
                    M1 = k;
            }
            var g1 = k;
            k = M1;
            try {
                return f1();
            } finally{
                k = g1;
            }
        }, r.unstable_pauseExecution = function() {}, r.unstable_requestPaint = function() {}, r.unstable_runWithPriority = function(f1, M1) {
            switch(f1){
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                default:
                    f1 = 3;
            }
            var g1 = k;
            k = f1;
            try {
                return M1();
            } finally{
                k = g1;
            }
        }, r.unstable_scheduleCallback = function(f1, M1, g1) {
            var K1 = r.unstable_now();
            switch(typeof g1 == "object" && g1 !== null ? (g1 = g1.delay, g1 = typeof g1 == "number" && 0 < g1 ? K1 + g1 : K1) : g1 = K1, f1){
                case 1:
                    var G1 = -1;
                    break;
                case 2:
                    G1 = 250;
                    break;
                case 5:
                    G1 = 1073741823;
                    break;
                case 4:
                    G1 = 1e4;
                    break;
                default:
                    G1 = 5e3;
            }
            return G1 = g1 + G1, f1 = {
                id: M++,
                callback: M1,
                priorityLevel: f1,
                startTime: g1,
                expirationTime: G1,
                sortIndex: -1
            }, g1 > K1 ? (f1.sortIndex = g1, a(L, f1), o(y) === null && f1 === o(L) && (O ? (z(m1), m1 = -1) : O = !0, s2($, g1 - K1))) : (f1.sortIndex = G1, a(y, f1), Z || _ || (Z = !0, D1(W))), f1;
        }, r.unstable_shouldYield = H1, r.unstable_wrapCallback = function(f1) {
            var M1 = k;
            return function() {
                var g1 = k;
                k = M1;
                try {
                    return f1.apply(this, arguments);
                } finally{
                    k = g1;
                }
            };
        };
    }($0422a6ce4ea03acc$var$pp)), $0422a6ce4ea03acc$var$pp;
}
var $0422a6ce4ea03acc$var$hp = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0422a6ce4ea03acc$var$Gy;
function $0422a6ce4ea03acc$var$SZ() {
    return $0422a6ce4ea03acc$var$Gy || ($0422a6ce4ea03acc$var$Gy = 1), $0422a6ce4ea03acc$var$hp;
}
var $0422a6ce4ea03acc$var$Xy;
function $0422a6ce4ea03acc$var$Rb() {
    return $0422a6ce4ea03acc$var$Xy || ($0422a6ce4ea03acc$var$Xy = 1, $0422a6ce4ea03acc$var$Au.exports = $0422a6ce4ea03acc$var$EZ()), $0422a6ce4ea03acc$var$Au.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0422a6ce4ea03acc$var$Ky;
function $0422a6ce4ea03acc$var$kZ() {
    if ($0422a6ce4ea03acc$var$Ky) return $0422a6ce4ea03acc$var$A5;
    $0422a6ce4ea03acc$var$Ky = 1;
    var r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))), a = $0422a6ce4ea03acc$var$Rb();
    function o(n) {
        for(var l = "https://reactjs.org/docs/error-decoder.html?invariant=" + n, f = 1; f < arguments.length; f++)l += "&args[]=" + encodeURIComponent(arguments[f]);
        return "Minified React error #" + n + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var s = /* @__PURE__ */ new Set(), i = {};
    function p(n, l) {
        C(n, l), C(n + "Capture", l);
    }
    function C(n, l) {
        for(i[n] = l, n = 0; n < l.length; n++)s.add(l[n]);
    }
    var v = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), y = Object.prototype.hasOwnProperty, L = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, M = {}, E = {};
    function k(n) {
        return y.call(E, n) ? !0 : y.call(M, n) ? !1 : L.test(n) ? E[n] = !0 : (M[n] = !0, !1);
    }
    function _(n, l, f, m) {
        if (f !== null && f.type === 0) return !1;
        switch(typeof l){
            case "function":
            case "symbol":
                return !0;
            case "boolean":
                return m ? !1 : f !== null ? !f.acceptsBooleans : (n = n.toLowerCase().slice(0, 5), n !== "data-" && n !== "aria-");
            default:
                return !1;
        }
    }
    function Z(n, l, f, m) {
        if (l === null || typeof l > "u" || _(n, l, f, m)) return !0;
        if (m) return !1;
        if (f !== null) switch(f.type){
            case 3:
                return !l;
            case 4:
                return l === !1;
            case 5:
                return isNaN(l);
            case 6:
                return isNaN(l) || 1 > l;
        }
        return !1;
    }
    function O(n, l, f, m, b, H, T) {
        this.acceptsBooleans = l === 2 || l === 3 || l === 4, this.attributeName = m, this.attributeNamespace = b, this.mustUseProperty = f, this.propertyName = n, this.type = l, this.sanitizeURL = H, this.removeEmptyString = T;
    }
    var B = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(n) {
        B[n] = new O(n, 0, !1, n, null, !1, !1);
    }), [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(n) {
        var l = n[0];
        B[l] = new O(l, 1, !1, n[1], null, !1, !1);
    }), [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(n) {
        B[n] = new O(n, 2, !1, n.toLowerCase(), null, !1, !1);
    }), [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(n) {
        B[n] = new O(n, 2, !1, n, null, !1, !1);
    }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(n) {
        B[n] = new O(n, 3, !1, n.toLowerCase(), null, !1, !1);
    }), [
        "checked",
        "multiple",
        "muted",
        "selected"
    ].forEach(function(n) {
        B[n] = new O(n, 3, !0, n, null, !1, !1);
    }), [
        "capture",
        "download"
    ].forEach(function(n) {
        B[n] = new O(n, 4, !1, n, null, !1, !1);
    }), [
        "cols",
        "rows",
        "size",
        "span"
    ].forEach(function(n) {
        B[n] = new O(n, 6, !1, n, null, !1, !1);
    }), [
        "rowSpan",
        "start"
    ].forEach(function(n) {
        B[n] = new O(n, 5, !1, n.toLowerCase(), null, !1, !1);
    });
    var z = /[\-:]([a-z])/g;
    function I(n) {
        return n[1].toUpperCase();
    }
    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(n) {
        var l = n.replace(z, I);
        B[l] = new O(l, 1, !1, n, null, !1, !1);
    }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(n) {
        var l = n.replace(z, I);
        B[l] = new O(l, 1, !1, n, "http://www.w3.org/1999/xlink", !1, !1);
    }), [
        "xml:base",
        "xml:lang",
        "xml:space"
    ].forEach(function(n) {
        var l = n.replace(z, I);
        B[l] = new O(l, 1, !1, n, "http://www.w3.org/XML/1998/namespace", !1, !1);
    }), [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(n) {
        B[n] = new O(n, 1, !1, n.toLowerCase(), null, !1, !1);
    }), B.xlinkHref = new O("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(n) {
        B[n] = new O(n, 1, !1, n.toLowerCase(), null, !0, !0);
    });
    function P(n, l, f, m) {
        var b = B.hasOwnProperty(l) ? B[l] : null;
        (b !== null ? b.type !== 0 : m || !(2 < l.length) || l[0] !== "o" && l[0] !== "O" || l[1] !== "n" && l[1] !== "N") && (Z(l, f, b, m) && (f = null), m || b === null ? k(l) && (f === null ? n.removeAttribute(l) : n.setAttribute(l, "" + f)) : b.mustUseProperty ? n[b.propertyName] = f === null ? b.type === 3 ? !1 : "" : f : (l = b.attributeName, m = b.attributeNamespace, f === null ? n.removeAttribute(l) : (b = b.type, f = b === 3 || b === 4 && f === !0 ? "" : "" + f, m ? n.setAttributeNS(m, l, f) : n.setAttribute(l, f))));
    }
    var $ = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, W = Symbol.for("react.element"), l1 = Symbol.for("react.portal"), u1 = Symbol.for("react.fragment"), m1 = Symbol.for("react.strict_mode"), L1 = Symbol.for("react.profiler"), E1 = Symbol.for("react.provider"), H1 = Symbol.for("react.context"), B1 = Symbol.for("react.forward_ref"), h1 = Symbol.for("react.suspense"), k1 = Symbol.for("react.suspense_list"), I1 = Symbol.for("react.memo"), D1 = Symbol.for("react.lazy"), s2 = Symbol.for("react.offscreen"), f1 = Symbol.iterator;
    function M1(n) {
        return n === null || typeof n != "object" ? null : (n = f1 && n[f1] || n["@@iterator"], typeof n == "function" ? n : null);
    }
    var g1 = Object.assign, K1;
    function G1(n) {
        if (K1 === void 0) try {
            throw Error();
        } catch (f) {
            var l = f.stack.trim().match(/\n( *(at )?)/);
            K1 = l && l[1] || "";
        }
        return `
` + K1 + n;
    }
    var R1 = !1;
    function E2(n, l) {
        if (!n || R1) return "";
        R1 = !0;
        var f = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (l) {
                if (l = function() {
                    throw Error();
                }, Object.defineProperty(l.prototype, "props", {
                    set: function() {
                        throw Error();
                    }
                }), typeof Reflect == "object" && Reflect.construct) {
                    try {
                        Reflect.construct(l, []);
                    } catch (o1) {
                        var m = o1;
                    }
                    Reflect.construct(n, [], l);
                } else {
                    try {
                        l.call();
                    } catch (o1) {
                        m = o1;
                    }
                    n.call(l.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (o1) {
                    m = o1;
                }
                n();
            }
        } catch (o1) {
            if (o1 && m && typeof o1.stack == "string") {
                for(var b = o1.stack.split(`
`), H = m.stack.split(`
`), T = b.length - 1, F = H.length - 1; 1 <= T && 0 <= F && b[T] !== H[F];)F--;
                for(; 1 <= T && 0 <= F; T--, F--)if (b[T] !== H[F]) {
                    if (T !== 1 || F !== 1) do if (T--, F--, 0 > F || b[T] !== H[F]) {
                        var Y = `
` + b[T].replace(" at new ", " at ");
                        return n.displayName && Y.includes("<anonymous>") && (Y = Y.replace("<anonymous>", n.displayName)), Y;
                    }
                    while (1 <= T && 0 <= F);
                    break;
                }
            }
        } finally{
            R1 = !1, Error.prepareStackTrace = f;
        }
        return (n = n ? n.displayName || n.name : "") ? G1(n) : "";
    }
    function a3(n) {
        switch(n.tag){
            case 5:
                return G1(n.type);
            case 16:
                return G1("Lazy");
            case 13:
                return G1("Suspense");
            case 19:
                return G1("SuspenseList");
            case 0:
            case 2:
            case 15:
                return n = E2(n.type, !1), n;
            case 11:
                return n = E2(n.type.render, !1), n;
            case 1:
                return n = E2(n.type, !0), n;
            default:
                return "";
        }
    }
    function H2(n) {
        if (n == null) return null;
        if (typeof n == "function") return n.displayName || n.name || null;
        if (typeof n == "string") return n;
        switch(n){
            case u1:
                return "Fragment";
            case l1:
                return "Portal";
            case L1:
                return "Profiler";
            case m1:
                return "StrictMode";
            case h1:
                return "Suspense";
            case k1:
                return "SuspenseList";
        }
        if (typeof n == "object") switch(n.$$typeof){
            case H1:
                return (n.displayName || "Context") + ".Consumer";
            case E1:
                return (n._context.displayName || "Context") + ".Provider";
            case B1:
                var l = n.render;
                return n = n.displayName, n || (n = l.displayName || l.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
            case I1:
                return l = n.displayName || null, l !== null ? l : H2(n.type) || "Memo";
            case D1:
                l = n._payload, n = n._init;
                try {
                    return H2(n(l));
                } catch  {}
        }
        return null;
    }
    function A2(n) {
        var l = n.type;
        switch(n.tag){
            case 24:
                return "Cache";
            case 9:
                return (l.displayName || "Context") + ".Consumer";
            case 10:
                return (l._context.displayName || "Context") + ".Provider";
            case 18:
                return "DehydratedFragment";
            case 11:
                return n = l.render, n = n.displayName || n.name || "", l.displayName || (n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 5:
                return l;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return H2(l);
            case 8:
                return l === m1 ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
                if (typeof l == "function") return l.displayName || l.name || null;
                if (typeof l == "string") return l;
        }
        return null;
    }
    function u2(n) {
        switch(typeof n){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return n;
            case "object":
                return n;
            default:
                return "";
        }
    }
    function o2(n) {
        var l = n.type;
        return (n = n.nodeName) && n.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
    }
    function P2(n) {
        var l = o2(n) ? "checked" : "value", f = Object.getOwnPropertyDescriptor(n.constructor.prototype, l), m = "" + n[l];
        if (!n.hasOwnProperty(l) && typeof f < "u" && typeof f.get == "function" && typeof f.set == "function") {
            var b = f.get, H = f.set;
            return Object.defineProperty(n, l, {
                configurable: !0,
                get: function() {
                    return b.call(this);
                },
                set: function(T) {
                    m = "" + T, H.call(this, T);
                }
            }), Object.defineProperty(n, l, {
                enumerable: f.enumerable
            }), {
                getValue: function() {
                    return m;
                },
                setValue: function(T) {
                    m = "" + T;
                },
                stopTracking: function() {
                    n._valueTracker = null, delete n[l];
                }
            };
        }
    }
    function G2(n) {
        n._valueTracker || (n._valueTracker = P2(n));
    }
    function V3(n) {
        if (!n) return !1;
        var l = n._valueTracker;
        if (!l) return !0;
        var f = l.getValue(), m = "";
        return n && (m = o2(n) ? n.checked ? "true" : "false" : n.value), n = m, n !== f ? (l.setValue(n), !0) : !1;
    }
    function I2(n) {
        if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
        try {
            return n.activeElement || n.body;
        } catch  {
            return n.body;
        }
    }
    function T1(n, l) {
        var f = l.checked;
        return g1({}, l, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: void 0,
            checked: f ?? n._wrapperState.initialChecked
        });
    }
    function j1(n, l) {
        var f = l.defaultValue == null ? "" : l.defaultValue, m = l.checked != null ? l.checked : l.defaultChecked;
        f = u2(l.value != null ? l.value : f), n._wrapperState = {
            initialChecked: m,
            initialValue: f,
            controlled: l.type === "checkbox" || l.type === "radio" ? l.checked != null : l.value != null
        };
    }
    function N2(n, l) {
        l = l.checked, l != null && P(n, "checked", l, !1);
    }
    function _2(n, l) {
        N2(n, l);
        var f = u2(l.value), m = l.type;
        if (f != null) m === "number" ? (f === 0 && n.value === "" || n.value != f) && (n.value = "" + f) : n.value !== "" + f && (n.value = "" + f);
        else if (m === "submit" || m === "reset") {
            n.removeAttribute("value");
            return;
        }
        l.hasOwnProperty("value") ? he(n, l.type, f) : l.hasOwnProperty("defaultValue") && he(n, l.type, u2(l.defaultValue)), l.checked == null && l.defaultChecked != null && (n.defaultChecked = !!l.defaultChecked);
    }
    function R3(n, l, f) {
        if (l.hasOwnProperty("value") || l.hasOwnProperty("defaultValue")) {
            var m = l.type;
            if (!(m !== "submit" && m !== "reset" || l.value !== void 0 && l.value !== null)) return;
            l = "" + n._wrapperState.initialValue, f || l === n.value || (n.value = l), n.defaultValue = l;
        }
        f = n.name, f !== "" && (n.name = ""), n.defaultChecked = !!n._wrapperState.initialChecked, f !== "" && (n.name = f);
    }
    function he(n, l, f) {
        (l !== "number" || I2(n.ownerDocument) !== n) && (f == null ? n.defaultValue = "" + n._wrapperState.initialValue : n.defaultValue !== "" + f && (n.defaultValue = "" + f));
    }
    var j3 = Array.isArray;
    function ee(n, l, f, m) {
        if (n = n.options, l) {
            l = {};
            for(var b = 0; b < f.length; b++)l["$" + f[b]] = !0;
            for(f = 0; f < n.length; f++)b = l.hasOwnProperty("$" + n[f].value), n[f].selected !== b && (n[f].selected = b), b && m && (n[f].defaultSelected = !0);
        } else {
            for(f = "" + u2(f), l = null, b = 0; b < n.length; b++){
                if (n[b].value === f) {
                    n[b].selected = !0, m && (n[b].defaultSelected = !0);
                    return;
                }
                l !== null || n[b].disabled || (l = n[b]);
            }
            l !== null && (l.selected = !0);
        }
    }
    function me(n, l) {
        if (l.dangerouslySetInnerHTML != null) throw Error(o(91));
        return g1({}, l, {
            value: void 0,
            defaultValue: void 0,
            children: "" + n._wrapperState.initialValue
        });
    }
    function D2(n, l) {
        var f = l.value;
        if (f == null) {
            if (f = l.children, l = l.defaultValue, f != null) {
                if (l != null) throw Error(o(92));
                if (j3(f)) {
                    if (1 < f.length) throw Error(o(93));
                    f = f[0];
                }
                l = f;
            }
            l == null && (l = ""), f = l;
        }
        n._wrapperState = {
            initialValue: u2(f)
        };
    }
    function z3(n, l) {
        var f = u2(l.value), m = u2(l.defaultValue);
        f != null && (f = "" + f, f !== n.value && (n.value = f), l.defaultValue == null && n.defaultValue !== f && (n.defaultValue = f)), m != null && (n.defaultValue = "" + m);
    }
    function se(n) {
        var l = n.textContent;
        l === n._wrapperState.initialValue && l !== "" && l !== null && (n.value = l);
    }
    function c4(n) {
        switch(n){
            case "svg":
                return "http://www.w3.org/2000/svg";
            case "math":
                return "http://www.w3.org/1998/Math/MathML";
            default:
                return "http://www.w3.org/1999/xhtml";
        }
    }
    function U3(n, l) {
        return n == null || n === "http://www.w3.org/1999/xhtml" ? c4(l) : n === "http://www.w3.org/2000/svg" && l === "foreignObject" ? "http://www.w3.org/1999/xhtml" : n;
    }
    var ve, Y5 = function(n) {
        return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(l, f, m, b) {
            MSApp.execUnsafeLocalFunction(function() {
                return n(l, f, m, b);
            });
        } : n;
    }(function(n, l) {
        if (n.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in n) n.innerHTML = l;
        else {
            for(ve = ve || document.createElement("div"), ve.innerHTML = "<svg>" + l.valueOf().toString() + "</svg>", l = ve.firstChild; n.firstChild;)n.removeChild(n.firstChild);
            for(; l.firstChild;)n.appendChild(l.firstChild);
        }
    });
    function F4(n, l) {
        if (l) {
            var f = n.firstChild;
            if (f && f === n.lastChild && f.nodeType === 3) {
                f.nodeValue = l;
                return;
            }
        }
        n.textContent = l;
    }
    var _1 = {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
    }, d2 = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ];
    Object.keys(_1).forEach(function(n) {
        d2.forEach(function(l) {
            l = l + n.charAt(0).toUpperCase() + n.substring(1), _1[l] = _1[n];
        });
    });
    function B2(n, l, f) {
        return l == null || typeof l == "boolean" || l === "" ? "" : f || typeof l != "number" || l === 0 || _1.hasOwnProperty(n) && _1[n] ? ("" + l).trim() : l + "px";
    }
    function m3(n, l) {
        n = n.style;
        for(var f in l)if (l.hasOwnProperty(f)) {
            var m = f.indexOf("--") === 0, b = B2(f, l[f], m);
            f === "float" && (f = "cssFloat"), m ? n.setProperty(f, b) : n[f] = b;
        }
    }
    var v3 = g1({
        menuitem: !0
    }, {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
    });
    function te(n, l) {
        if (l) {
            if (v3[n] && (l.children != null || l.dangerouslySetInnerHTML != null)) throw Error(o(137, n));
            if (l.dangerouslySetInnerHTML != null) {
                if (l.children != null) throw Error(o(60));
                if (typeof l.dangerouslySetInnerHTML != "object" || !("__html" in l.dangerouslySetInnerHTML)) throw Error(o(61));
            }
            if (l.style != null && typeof l.style != "object") throw Error(o(62));
        }
    }
    function ne(n, l) {
        if (n.indexOf("-") === -1) return typeof l.is == "string";
        switch(n){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return !1;
            default:
                return !0;
        }
    }
    var qe = null;
    function S3(n) {
        return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
    }
    var d4 = null, i3 = null, k3 = null;
    function A4(n) {
        if (n = F0(n)) {
            if (typeof d4 != "function") throw Error(o(280));
            var l = n.stateNode;
            l && (l = h2(l), d4(n.stateNode, n.type, l));
        }
    }
    function O6(n) {
        i3 ? k3 ? k3.push(n) : k3 = [
            n
        ] : i3 = n;
    }
    function y7() {
        if (i3) {
            var n = i3, l = k3;
            if (k3 = i3 = null, A4(n), l) for(n = 0; n < l.length; n++)A4(l[n]);
        }
    }
    function p8(n, l) {
        return n(l);
    }
    function C9() {}
    var N6 = !1;
    function C4(n, l, f) {
        if (N6) return n(l, f);
        N6 = !0;
        try {
            return p8(n, l, f);
        } finally{
            N6 = !1, (i3 !== null || k3 !== null) && (C9(), y7());
        }
    }
    function P6(n, l) {
        var f = n.stateNode;
        if (f === null) return null;
        var m = h2(f);
        if (m === null) return null;
        f = m[l];
        e: switch(l){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                (m = !m.disabled) || (n = n.type, m = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !m;
                break e;
            default:
                n = !1;
        }
        if (n) return null;
        if (f && typeof f != "function") throw Error(o(231, l, typeof f));
        return f;
    }
    var L7 = !1;
    if (v) try {
        var b5 = {};
        Object.defineProperty(b5, "passive", {
            get: function() {
                L7 = !0;
            }
        }), window.addEventListener("test", b5, b5), window.removeEventListener("test", b5, b5);
    } catch  {
        L7 = !1;
    }
    function l6(n, l, f, m, b, H, T, F, Y) {
        var o1 = Array.prototype.slice.call(arguments, 3);
        try {
            l.apply(f, o1);
        } catch (b1) {
            this.onError(b1);
        }
    }
    var E4 = !1, Ae = null, s6 = !1, j = null, w1 = {
        onError: function(n) {
            E4 = !0, Ae = n;
        }
    };
    function N1(n, l, f, m, b, H, T, F, Y) {
        E4 = !1, Ae = null, l6.apply(w1, arguments);
    }
    function p2(n, l, f, m, b, H, T, F, Y) {
        if (N1.apply(this, arguments), E4) {
            if (E4) {
                var o1 = Ae;
                E4 = !1, Ae = null;
            } else throw Error(o(198));
            s6 || (s6 = !0, j = o1);
        }
    }
    function x2(n) {
        var l = n, f = n;
        if (n.alternate) for(; l.return;)l = l.return;
        else {
            n = l;
            do l = n, l.flags & 4098 && (f = l.return), n = l.return;
            while (n);
        }
        return l.tag === 3 ? f : null;
    }
    function J2(n) {
        if (n.tag === 13) {
            var l = n.memoizedState;
            if (l === null && (n = n.alternate, n !== null && (l = n.memoizedState)), l !== null) return l.dehydrated;
        }
        return null;
    }
    function R2(n) {
        if (x2(n) !== n) throw Error(o(188));
    }
    function v2(n) {
        var l = n.alternate;
        if (!l) {
            if (l = x2(n), l === null) throw Error(o(188));
            return l !== n ? null : n;
        }
        for(var f = n, m = l;;){
            var b = f.return;
            if (b === null) break;
            var H = b.alternate;
            if (H === null) {
                if (m = b.return, m !== null) {
                    f = m;
                    continue;
                }
                break;
            }
            if (b.child === H.child) {
                for(H = b.child; H;){
                    if (H === f) return R2(b), n;
                    if (H === m) return R2(b), l;
                    H = H.sibling;
                }
                throw Error(o(188));
            }
            if (f.return !== m.return) f = b, m = H;
            else {
                for(var T = !1, F = b.child; F;){
                    if (F === f) {
                        T = !0, f = b, m = H;
                        break;
                    }
                    if (F === m) {
                        T = !0, m = b, f = H;
                        break;
                    }
                    F = F.sibling;
                }
                if (!T) {
                    for(F = H.child; F;){
                        if (F === f) {
                            T = !0, f = H, m = b;
                            break;
                        }
                        if (F === m) {
                            T = !0, m = H, f = b;
                            break;
                        }
                        F = F.sibling;
                    }
                    if (!T) throw Error(o(189));
                }
            }
            if (f.alternate !== m) throw Error(o(190));
        }
        if (f.tag !== 3) throw Error(o(188));
        return f.stateNode.current === f ? n : l;
    }
    function He(n) {
        return n = v2(n), n !== null ? B3(n) : null;
    }
    function B3(n) {
        if (n.tag === 5 || n.tag === 6) return n;
        for(n = n.child; n !== null;){
            var l = B3(n);
            if (l !== null) return l;
            n = n.sibling;
        }
        return null;
    }
    var F3 = a.unstable_scheduleCallback, ke = a.unstable_cancelCallback, u6 = a.unstable_shouldYield, B6 = a.unstable_requestPaint, X2 = a.unstable_now, la = a.unstable_getCurrentPriorityLevel, j4 = a.unstable_ImmediatePriority, j2 = a.unstable_UserBlockingPriority, c6 = a.unstable_NormalPriority, Ot = a.unstable_LowPriority, H0 = a.unstable_IdlePriority, b7 = null, i5 = null;
    function Nt(n) {
        if (i5 && typeof i5.onCommitFiberRoot == "function") try {
            i5.onCommitFiberRoot(b7, n, void 0, (n.current.flags & 128) === 128);
        } catch  {}
    }
    var z4 = Math.clz32 ? Math.clz32 : sa, Pt = Math.log, Bt = Math.LN2;
    function sa(n) {
        return n >>>= 0, n === 0 ? 32 : 31 - (Pt(n) / Bt | 0) | 0;
    }
    var f9 = 64, w7 = 4194304;
    function F6(n) {
        switch(n & -n){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return n & 4194240;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return n & 130023424;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 1073741824;
            default:
                return n;
        }
    }
    function o5(n, l) {
        var f = n.pendingLanes;
        if (f === 0) return 0;
        var m = 0, b = n.suspendedLanes, H = n.pingedLanes, T = f & 268435455;
        if (T !== 0) {
            var F = T & ~b;
            F !== 0 ? m = F6(F) : (H &= T, H !== 0 && (m = F6(H)));
        } else T = f & ~b, T !== 0 ? m = F6(T) : H !== 0 && (m = F6(H));
        if (m === 0) return 0;
        if (l !== 0 && l !== m && !(l & b) && (b = m & -m, H = l & -l, b >= H || b === 16 && (H & 4194240) !== 0)) return l;
        if (m & 4 && (m |= f & 16), l = n.entangledLanes, l !== 0) for(n = n.entanglements, l &= m; 0 < l;)f = 31 - z4(l), b = 1 << f, m |= n[f], l &= ~b;
        return m;
    }
    function H7(n, l) {
        switch(n){
            case 1:
            case 2:
            case 4:
                return l + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return l + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return -1;
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function x7(n, l) {
        for(var f = n.suspendedLanes, m = n.pingedLanes, b = n.expirationTimes, H = n.pendingLanes; 0 < H;){
            var T = 31 - z4(H), F = 1 << T, Y = b[T];
            Y === -1 ? (!(F & f) || F & m) && (b[T] = H7(F, l)) : Y <= l && (n.expiredLanes |= F), H &= ~F;
        }
    }
    function x0(n) {
        return n = n.pendingLanes & -1073741825, n !== 0 ? n : n & 1073741824 ? 1073741824 : 0;
    }
    function p9() {
        var n = f9;
        return f9 <<= 1, !(f9 & 4194240) && (f9 = 64), n;
    }
    function h9(n) {
        for(var l = [], f = 0; 31 > f; f++)l.push(n);
        return l;
    }
    function A6(n, l, f) {
        n.pendingLanes |= l, l !== 536870912 && (n.suspendedLanes = 0, n.pingedLanes = 0), n = n.eventTimes, l = 31 - z4(l), n[l] = f;
    }
    function ua(n, l) {
        var f = n.pendingLanes & ~l;
        n.pendingLanes = l, n.suspendedLanes = 0, n.pingedLanes = 0, n.expiredLanes &= l, n.mutableReadLanes &= l, n.entangledLanes &= l, l = n.entanglements;
        var m = n.eventTimes;
        for(n = n.expirationTimes; 0 < f;){
            var b = 31 - z4(f), H = 1 << b;
            l[b] = 0, m[b] = -1, n[b] = -1, f &= ~H;
        }
    }
    function h8(n, l) {
        var f = n.entangledLanes |= l;
        for(n = n.entanglements; f;){
            var m = 31 - z4(f), b = 1 << m;
            b & l | n[m] & l && (n[m] |= l), f &= ~b;
        }
    }
    var d3 = 0;
    function V0(n) {
        return n &= -n, 1 < n ? 4 < n ? n & 268435455 ? 16 : 536870912 : 4 : 1;
    }
    var Ft, m9, g3, At, M0, S2 = !1, d6 = [], G3 = null, f4 = null, p4 = null, m8 = /* @__PURE__ */ new Map(), ue = /* @__PURE__ */ new Map(), C3 = [], jt = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
    function Te(n, l) {
        switch(n){
            case "focusin":
            case "focusout":
                G3 = null;
                break;
            case "dragenter":
            case "dragleave":
                f4 = null;
                break;
            case "mouseover":
            case "mouseout":
                p4 = null;
                break;
            case "pointerover":
            case "pointerout":
                m8.delete(l.pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                ue.delete(l.pointerId);
        }
    }
    function ce(n, l, f, m, b, H) {
        return n === null || n.nativeEvent !== H ? (n = {
            blockedOn: l,
            domEventName: f,
            eventSystemFlags: m,
            nativeEvent: H,
            targetContainers: [
                b
            ]
        }, l !== null && (l = F0(l), l !== null && m9(l)), n) : (n.eventSystemFlags |= m, l = n.targetContainers, b !== null && l.indexOf(b) === -1 && l.push(b), n);
    }
    function C6(n, l, f, m, b) {
        switch(l){
            case "focusin":
                return G3 = ce(G3, n, l, f, m, b), !0;
            case "dragenter":
                return f4 = ce(f4, n, l, f, m, b), !0;
            case "mouseover":
                return p4 = ce(p4, n, l, f, m, b), !0;
            case "pointerover":
                var H = b.pointerId;
                return m8.set(H, ce(m8.get(H) || null, n, l, f, m, b)), !0;
            case "gotpointercapture":
                return H = b.pointerId, ue.set(H, ce(ue.get(H) || null, n, l, f, m, b)), !0;
        }
        return !1;
    }
    function E0(n) {
        var l = x5(n.target);
        if (l !== null) {
            var f = x2(l);
            if (f !== null) {
                if (l = f.tag, l === 13) {
                    if (l = J2(f), l !== null) {
                        n.blockedOn = l, M0(n.priority, function() {
                            g3(f);
                        });
                        return;
                    }
                } else if (l === 3 && f.stateNode.current.memoizedState.isDehydrated) {
                    n.blockedOn = f.tag === 3 ? f.stateNode.containerInfo : null;
                    return;
                }
            }
        }
        n.blockedOn = null;
    }
    function V7(n) {
        if (n.blockedOn !== null) return !1;
        for(var l = n.targetContainers; 0 < l.length;){
            var f = f3(n.domEventName, n.eventSystemFlags, l[0], n.nativeEvent);
            if (f === null) {
                f = n.nativeEvent;
                var m = new f.constructor(f.type, f);
                qe = m, f.target.dispatchEvent(m), qe = null;
            } else return l = F0(f), l !== null && m9(l), n.blockedOn = f, !1;
            l.shift();
        }
        return !0;
    }
    function v9(n, l, f) {
        V7(n) && f.delete(l);
    }
    function zt() {
        S2 = !1, G3 !== null && V7(G3) && (G3 = null), f4 !== null && V7(f4) && (f4 = null), p4 !== null && V7(p4) && (p4 = null), m8.forEach(v9), ue.forEach(v9);
    }
    function v8(n, l) {
        n.blockedOn === l && (n.blockedOn = null, S2 || (S2 = !0, a.unstable_scheduleCallback(a.unstable_NormalPriority, zt)));
    }
    function M7(n) {
        function l(b) {
            return v8(b, n);
        }
        if (0 < d6.length) {
            v8(d6[0], n);
            for(var f = 1; f < d6.length; f++){
                var m = d6[f];
                m.blockedOn === n && (m.blockedOn = null);
            }
        }
        for(G3 !== null && v8(G3, n), f4 !== null && v8(f4, n), p4 !== null && v8(p4, n), m8.forEach(l), ue.forEach(l), f = 0; f < C3.length; f++)m = C3[f], m.blockedOn === n && (m.blockedOn = null);
        for(; 0 < C3.length && (f = C3[0], f.blockedOn === null);)E0(f), f.blockedOn === null && C3.shift();
    }
    var E7 = $.ReactCurrentBatchConfig, N = !0;
    function X(n, l, f, m) {
        var b = d3, H = E7.transition;
        E7.transition = null;
        try {
            d3 = 1, X1(n, l, f, m);
        } finally{
            d3 = b, E7.transition = H;
        }
    }
    function s1(n, l, f, m) {
        var b = d3, H = E7.transition;
        E7.transition = null;
        try {
            d3 = 4, X1(n, l, f, m);
        } finally{
            d3 = b, E7.transition = H;
        }
    }
    function X1(n, l, f, m) {
        if (N) {
            var b = f3(n, l, f, m);
            if (b === null) en(n, l, m, z2, f), Te(n, m);
            else if (C6(b, n, l, f, m)) m.stopPropagation();
            else if (Te(n, m), l & 4 && -1 < jt.indexOf(n)) {
                for(; b !== null;){
                    var H = F0(b);
                    if (H !== null && Ft(H), H = f3(n, l, f, m), H === null && en(n, l, m, z2, f), H === b) break;
                    b = H;
                }
                b !== null && m.stopPropagation();
            } else en(n, l, m, null, f);
        }
    }
    var z2 = null;
    function f3(n, l, f, m) {
        if (z2 = null, n = S3(m), n = x5(n), n !== null) {
            if (l = x2(n), l === null) n = null;
            else if (f = l.tag, f === 13) {
                if (n = J2(l), n !== null) return n;
                n = null;
            } else if (f === 3) {
                if (l.stateNode.current.memoizedState.isDehydrated) return l.tag === 3 ? l.stateNode.containerInfo : null;
                n = null;
            } else l !== n && (n = null);
        }
        return z2 = n, null;
    }
    function T3(n) {
        switch(n){
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return 1;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return 4;
            case "message":
                switch(la()){
                    case j4:
                        return 1;
                    case j2:
                        return 4;
                    case c6:
                    case Ot:
                        return 16;
                    case H0:
                        return 536870912;
                    default:
                        return 16;
                }
            default:
                return 16;
        }
    }
    var F2 = null, w3 = null, Ge = null;
    function Xe() {
        if (Ge) return Ge;
        var n, l = w3, f = l.length, m, b = "value" in F2 ? F2.value : F2.textContent, H = b.length;
        for(n = 0; n < f && l[n] === b[n]; n++);
        var T = f - n;
        for(m = 1; m <= T && l[f - m] === b[H - m]; m++);
        return Ge = b.slice(n, 1 < m ? 1 - m : void 0);
    }
    function w5(n) {
        var l = n.keyCode;
        return "charCode" in n ? (n = n.charCode, n === 0 && l === 13 && (n = 13)) : n = l, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
    }
    function j6() {
        return !0;
    }
    function g9() {
        return !1;
    }
    function h4(n) {
        function l(f, m, b, H, T) {
            this._reactName = f, this._targetInst = b, this.type = m, this.nativeEvent = H, this.target = T, this.currentTarget = null;
            for(var F in n)n.hasOwnProperty(F) && (f = n[F], this[F] = f ? f(H) : H[F]);
            return this.isDefaultPrevented = (H.defaultPrevented != null ? H.defaultPrevented : H.returnValue === !1) ? j6 : g9, this.isPropagationStopped = g9, this;
        }
        return g1(l.prototype, {
            preventDefault: function() {
                this.defaultPrevented = !0;
                var f = this.nativeEvent;
                f && (f.preventDefault ? f.preventDefault() : typeof f.returnValue != "unknown" && (f.returnValue = !1), this.isDefaultPrevented = j6);
            },
            stopPropagation: function() {
                var f = this.nativeEvent;
                f && (f.stopPropagation ? f.stopPropagation() : typeof f.cancelBubble != "unknown" && (f.cancelBubble = !0), this.isPropagationStopped = j6);
            },
            persist: function() {},
            isPersistent: j6
        }), l;
    }
    var S7 = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(n) {
            return n.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    }, Ut = h4(S7), y9 = g1({}, S7, {
        view: 0,
        detail: 0
    }), Wo = h4(y9), It, ca, S0, je = g1({}, y9, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: pa,
        button: 0,
        buttons: 0,
        relatedTarget: function(n) {
            return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
        },
        movementX: function(n) {
            return "movementX" in n ? n.movementX : (n !== S0 && (S0 && n.type === "mousemove" ? (It = n.screenX - S0.screenX, ca = n.screenY - S0.screenY) : ca = It = 0, S0 = n), It);
        },
        movementY: function(n) {
            return "movementY" in n ? n.movementY : ca;
        }
    }), $t = h4(je), Qo = g1({}, je, {
        dataTransfer: 0
    }), qo = h4(Qo), Rc = g1({}, y9, {
        relatedTarget: 0
    }), k7 = h4(Rc), da = g1({}, S7, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), Go = h4(da), Zc = g1({}, S7, {
        clipboardData: function(n) {
            return "clipboardData" in n ? n.clipboardData : window.clipboardData;
        }
    }), Oc = h4(Zc), Nc = g1({}, S7, {
        data: 0
    }), Ca = h4(Nc), fa = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    }, Xo = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
    }, Ko = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    };
    function Jo(n) {
        var l = this.nativeEvent;
        return l.getModifierState ? l.getModifierState(n) : (n = Ko[n]) ? !!l[n] : !1;
    }
    function pa() {
        return Jo;
    }
    var z6 = g1({}, y9, {
        key: function(n) {
            if (n.key) {
                var l = fa[n.key] || n.key;
                if (l !== "Unidentified") return l;
            }
            return n.type === "keypress" ? (n = w5(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? Xo[n.keyCode] || "Unidentified" : "";
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: pa,
        charCode: function(n) {
            return n.type === "keypress" ? w5(n) : 0;
        },
        keyCode: function(n) {
            return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
        },
        which: function(n) {
            return n.type === "keypress" ? w5(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
        }
    }), Pc = h4(z6), ha = g1({}, je, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    }), Yt = h4(ha), ma = g1({}, y9, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: pa
    }), Bc = h4(ma), Wt = g1({}, S7, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), el = h4(Wt), U4 = g1({}, je, {
        deltaX: function(n) {
            return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
        },
        deltaY: function(n) {
            return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
    }), U6 = h4(U4), xe = [
        9,
        13,
        27,
        32
    ], W5 = v && "CompositionEvent" in window, g8 = null;
    v && "documentMode" in document && (g8 = document.documentMode);
    var Qt = v && "TextEvent" in window && !g8, tl = v && (!W5 || g8 && 8 < g8 && 11 >= g8), L9 = " ", nl = !1;
    function rl(n, l) {
        switch(n){
            case "keyup":
                return xe.indexOf(l.keyCode) !== -1;
            case "keydown":
                return l.keyCode !== 229;
            case "keypress":
            case "mousedown":
            case "focusout":
                return !0;
            default:
                return !1;
        }
    }
    function qt(n) {
        return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
    }
    var b9 = !1;
    function Fc(n, l) {
        switch(n){
            case "compositionend":
                return qt(l);
            case "keypress":
                return l.which !== 32 ? null : (nl = !0, L9);
            case "textInput":
                return n = l.data, n === L9 && nl ? null : n;
            default:
                return null;
        }
    }
    function Ac(n, l) {
        if (b9) return n === "compositionend" || !W5 && rl(n, l) ? (n = Xe(), Ge = w3 = F2 = null, b9 = !1, n) : null;
        switch(n){
            case "paste":
                return null;
            case "keypress":
                if (!(l.ctrlKey || l.altKey || l.metaKey) || l.ctrlKey && l.altKey) {
                    if (l.char && 1 < l.char.length) return l.char;
                    if (l.which) return String.fromCharCode(l.which);
                }
                return null;
            case "compositionend":
                return tl && l.locale !== "ko" ? null : l.data;
            default:
                return null;
        }
    }
    var al = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
    };
    function il(n) {
        var l = n && n.nodeName && n.nodeName.toLowerCase();
        return l === "input" ? !!al[n.type] : l === "textarea";
    }
    function ol(n, l, f, m) {
        O6(m), l = N0(l, "onChange"), 0 < l.length && (f = new Ut("onChange", "change", null, f, m), n.push({
            event: f,
            listeners: l
        }));
    }
    var k0 = null, w9 = null;
    function H9(n) {
        Jt(n, 0);
    }
    function x9(n) {
        var l = M9(n);
        if (V3(l)) return n;
    }
    function ll(n, l) {
        if (n === "change") return l;
    }
    var va = !1;
    if (v) {
        var ga;
        if (v) {
            var ya = "oninput" in document;
            if (!ya) {
                var sl = document.createElement("div");
                sl.setAttribute("oninput", "return;"), ya = typeof sl.oninput == "function";
            }
            ga = ya;
        } else ga = !1;
        va = ga && (!document.documentMode || 9 < document.documentMode);
    }
    function ul() {
        k0 && (k0.detachEvent("onpropertychange", cl), w9 = k0 = null);
    }
    function cl(n) {
        if (n.propertyName === "value" && x9(w9)) {
            var l = [];
            ol(l, w9, n, S3(n)), C4(H9, l);
        }
    }
    function jc(n, l, f) {
        n === "focusin" ? (ul(), k0 = l, w9 = f, k0.attachEvent("onpropertychange", cl)) : n === "focusout" && ul();
    }
    function zc(n) {
        if (n === "selectionchange" || n === "keyup" || n === "keydown") return x9(w9);
    }
    function Uc(n, l) {
        if (n === "click") return x9(l);
    }
    function dl(n, l) {
        if (n === "input" || n === "change") return x9(l);
    }
    function Ic(n, l) {
        return n === l && (n !== 0 || 1 / n === 1 / l) || n !== n && l !== l;
    }
    var H5 = typeof Object.is == "function" ? Object.is : Ic;
    function T0(n, l) {
        if (H5(n, l)) return !0;
        if (typeof n != "object" || n === null || typeof l != "object" || l === null) return !1;
        var f = Object.keys(n), m = Object.keys(l);
        if (f.length !== m.length) return !1;
        for(m = 0; m < f.length; m++){
            var b = f[m];
            if (!y.call(l, b) || !H5(n[b], l[b])) return !1;
        }
        return !0;
    }
    function Cl(n) {
        for(; n && n.firstChild;)n = n.firstChild;
        return n;
    }
    function fl(n, l) {
        var f = Cl(n);
        n = 0;
        for(var m; f;){
            if (f.nodeType === 3) {
                if (m = n + f.textContent.length, n <= l && m >= l) return {
                    node: f,
                    offset: l - n
                };
                n = m;
            }
            e: {
                for(; f;){
                    if (f.nextSibling) {
                        f = f.nextSibling;
                        break e;
                    }
                    f = f.parentNode;
                }
                f = void 0;
            }
            f = Cl(f);
        }
    }
    function pl(n, l) {
        return n && l ? n === l ? !0 : n && n.nodeType === 3 ? !1 : l && l.nodeType === 3 ? pl(n, l.parentNode) : "contains" in n ? n.contains(l) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(l) & 16) : !1 : !1;
    }
    function Gt() {
        for(var n = window, l = I2(); l instanceof n.HTMLIFrameElement;){
            try {
                var f = typeof l.contentWindow.location.href == "string";
            } catch  {
                f = !1;
            }
            if (f) n = l.contentWindow;
            else break;
            l = I2(n.document);
        }
        return l;
    }
    function I6(n) {
        var l = n && n.nodeName && n.nodeName.toLowerCase();
        return l && (l === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || l === "textarea" || n.contentEditable === "true");
    }
    function Xt(n) {
        var l = Gt(), f = n.focusedElem, m = n.selectionRange;
        if (l !== f && f && f.ownerDocument && pl(f.ownerDocument.documentElement, f)) {
            if (m !== null && I6(f)) {
                if (l = m.start, n = m.end, n === void 0 && (n = l), "selectionStart" in f) f.selectionStart = l, f.selectionEnd = Math.min(n, f.value.length);
                else if (n = (l = f.ownerDocument || document) && l.defaultView || window, n.getSelection) {
                    n = n.getSelection();
                    var b = f.textContent.length, H = Math.min(m.start, b);
                    m = m.end === void 0 ? H : Math.min(m.end, b), !n.extend && H > m && (b = m, m = H, H = b), b = fl(f, H);
                    var T = fl(f, m);
                    b && T && (n.rangeCount !== 1 || n.anchorNode !== b.node || n.anchorOffset !== b.offset || n.focusNode !== T.node || n.focusOffset !== T.offset) && (l = l.createRange(), l.setStart(b.node, b.offset), n.removeAllRanges(), H > m ? (n.addRange(l), n.extend(T.node, T.offset)) : (l.setEnd(T.node, T.offset), n.addRange(l)));
                }
            }
            for(l = [], n = f; n = n.parentNode;)n.nodeType === 1 && l.push({
                element: n,
                left: n.scrollLeft,
                top: n.scrollTop
            });
            for(typeof f.focus == "function" && f.focus(), f = 0; f < l.length; f++)n = l[f], n.element.scrollLeft = n.left, n.element.scrollTop = n.top;
        }
    }
    var hl = v && "documentMode" in document && 11 >= document.documentMode, Q5 = null, La = null, _0 = null, ba = !1;
    function ml(n, l, f) {
        var m = f.window === f ? f.document : f.nodeType === 9 ? f : f.ownerDocument;
        ba || Q5 == null || Q5 !== I2(m) || (m = Q5, "selectionStart" in m && I6(m) ? m = {
            start: m.selectionStart,
            end: m.selectionEnd
        } : (m = (m.ownerDocument && m.ownerDocument.defaultView || window).getSelection(), m = {
            anchorNode: m.anchorNode,
            anchorOffset: m.anchorOffset,
            focusNode: m.focusNode,
            focusOffset: m.focusOffset
        }), _0 && T0(_0, m) || (_0 = m, m = N0(La, "onSelect"), 0 < m.length && (l = new Ut("onSelect", "select", null, l, f), n.push({
            event: l,
            listeners: m
        }), l.target = Q5)));
    }
    function Kt(n, l) {
        var f = {};
        return f[n.toLowerCase()] = l.toLowerCase(), f["Webkit" + n] = "webkit" + l, f["Moz" + n] = "moz" + l, f;
    }
    var y8 = {
        animationend: Kt("Animation", "AnimationEnd"),
        animationiteration: Kt("Animation", "AnimationIteration"),
        animationstart: Kt("Animation", "AnimationStart"),
        transitionend: Kt("Transition", "TransitionEnd")
    }, wa = {}, Ha = {};
    v && (Ha = document.createElement("div").style, "AnimationEvent" in window || (delete y8.animationend.animation, delete y8.animationiteration.animation, delete y8.animationstart.animation), "TransitionEvent" in window || delete y8.transitionend.transition);
    function ze(n) {
        if (wa[n]) return wa[n];
        if (!y8[n]) return n;
        var l = y8[n], f;
        for(f in l)if (l.hasOwnProperty(f) && f in Ha) return wa[n] = l[f];
        return n;
    }
    var xa = ze("animationend"), vl = ze("animationiteration"), gl = ze("animationstart"), yl = ze("transitionend"), Ll = /* @__PURE__ */ new Map(), bl = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    function $6(n, l) {
        Ll.set(n, l), p(l, [
            n
        ]);
    }
    for(var D0 = 0; D0 < bl.length; D0++){
        var L8 = bl[D0], $c = L8.toLowerCase(), R0 = L8[0].toUpperCase() + L8.slice(1);
        $6($c, "on" + R0);
    }
    $6(xa, "onAnimationEnd"), $6(vl, "onAnimationIteration"), $6(gl, "onAnimationStart"), $6("dblclick", "onDoubleClick"), $6("focusin", "onFocus"), $6("focusout", "onBlur"), $6(yl, "onTransitionEnd"), C("onMouseEnter", [
        "mouseout",
        "mouseover"
    ]), C("onMouseLeave", [
        "mouseout",
        "mouseover"
    ]), C("onPointerEnter", [
        "pointerout",
        "pointerover"
    ]), C("onPointerLeave", [
        "pointerout",
        "pointerover"
    ]), p("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), p("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), p("onBeforeInput", [
        "compositionend",
        "keypress",
        "textInput",
        "paste"
    ]), p("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), p("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), p("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var Z0 = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Yc = new Set("cancel close invalid load scroll toggle".split(" ").concat(Z0));
    function wl(n, l, f) {
        var m = n.type || "unknown-event";
        n.currentTarget = f, p2(m, l, void 0, n), n.currentTarget = null;
    }
    function Jt(n, l) {
        l = (l & 4) !== 0;
        for(var f = 0; f < n.length; f++){
            var m = n[f], b = m.event;
            m = m.listeners;
            e: {
                var H = void 0;
                if (l) for(var T = m.length - 1; 0 <= T; T--){
                    var F = m[T], Y = F.instance, o1 = F.currentTarget;
                    if (F = F.listener, Y !== H && b.isPropagationStopped()) break e;
                    wl(b, F, o1), H = Y;
                }
                else for(T = 0; T < m.length; T++){
                    if (F = m[T], Y = F.instance, o1 = F.currentTarget, F = F.listener, Y !== H && b.isPropagationStopped()) break e;
                    wl(b, F, o1), H = Y;
                }
            }
        }
        if (s6) throw n = j, s6 = !1, j = null, n;
    }
    function Z3(n, l) {
        var f = l[_a];
        f === void 0 && (f = l[_a] = /* @__PURE__ */ new Set());
        var m = n + "__bubble";
        f.has(m) || (Hl(l, n, 2, !1), f.add(m));
    }
    function T7(n, l, f) {
        var m = 0;
        l && (m |= 4), Hl(f, n, m, l);
    }
    var Y6 = "_reactListening" + Math.random().toString(36).slice(2);
    function V9(n) {
        if (!n[Y6]) {
            n[Y6] = !0, s.forEach(function(f) {
                f !== "selectionchange" && (Yc.has(f) || T7(f, !1, n), T7(f, !0, n));
            });
            var l = n.nodeType === 9 ? n : n.ownerDocument;
            l === null || l[Y6] || (l[Y6] = !0, T7("selectionchange", !1, l));
        }
    }
    function Hl(n, l, f, m) {
        switch(T3(l)){
            case 1:
                var b = X;
                break;
            case 4:
                b = s1;
                break;
            default:
                b = X1;
        }
        f = b.bind(null, l, f, n), b = void 0, !L7 || l !== "touchstart" && l !== "touchmove" && l !== "wheel" || (b = !0), m ? b !== void 0 ? n.addEventListener(l, f, {
            capture: !0,
            passive: b
        }) : n.addEventListener(l, f, !0) : b !== void 0 ? n.addEventListener(l, f, {
            passive: b
        }) : n.addEventListener(l, f, !1);
    }
    function en(n, l, f, m, b) {
        var H = m;
        if (!(l & 1) && !(l & 2) && m !== null) e: for(;;){
            if (m === null) return;
            var T = m.tag;
            if (T === 3 || T === 4) {
                var F = m.stateNode.containerInfo;
                if (F === b || F.nodeType === 8 && F.parentNode === b) break;
                if (T === 4) for(T = m.return; T !== null;){
                    var Y = T.tag;
                    if ((Y === 3 || Y === 4) && (Y = T.stateNode.containerInfo, Y === b || Y.nodeType === 8 && Y.parentNode === b)) return;
                    T = T.return;
                }
                for(; F !== null;){
                    if (T = x5(F), T === null) return;
                    if (Y = T.tag, Y === 5 || Y === 6) {
                        m = H = T;
                        continue e;
                    }
                    F = F.parentNode;
                }
            }
            m = m.return;
        }
        C4(function() {
            var o1 = H, b1 = S3(f), x1 = [];
            e: {
                var y1 = Ll.get(n);
                if (y1 !== void 0) {
                    var z1 = Ut, t2 = n;
                    switch(n){
                        case "keypress":
                            if (w5(f) === 0) break e;
                        case "keydown":
                        case "keyup":
                            z1 = Pc;
                            break;
                        case "focusin":
                            t2 = "focus", z1 = k7;
                            break;
                        case "focusout":
                            t2 = "blur", z1 = k7;
                            break;
                        case "beforeblur":
                        case "afterblur":
                            z1 = k7;
                            break;
                        case "click":
                            if (f.button === 2) break e;
                        case "auxclick":
                        case "dblclick":
                        case "mousedown":
                        case "mousemove":
                        case "mouseup":
                        case "mouseout":
                        case "mouseover":
                        case "contextmenu":
                            z1 = $t;
                            break;
                        case "drag":
                        case "dragend":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "dragstart":
                        case "drop":
                            z1 = qo;
                            break;
                        case "touchcancel":
                        case "touchend":
                        case "touchmove":
                        case "touchstart":
                            z1 = Bc;
                            break;
                        case xa:
                        case vl:
                        case gl:
                            z1 = Go;
                            break;
                        case yl:
                            z1 = el;
                            break;
                        case "scroll":
                            z1 = Wo;
                            break;
                        case "wheel":
                            z1 = U6;
                            break;
                        case "copy":
                        case "cut":
                        case "paste":
                            z1 = Oc;
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "pointerup":
                            z1 = Yt;
                    }
                    var i2 = (l & 4) !== 0, ye = !i2 && n === "scroll", e1 = i2 ? y1 !== null ? y1 + "Capture" : null : y1;
                    i2 = [];
                    for(var q = o1, r1; q !== null;){
                        r1 = q;
                        var S1 = r1.stateNode;
                        if (r1.tag === 5 && S1 !== null && (r1 = S1, e1 !== null && (S1 = P6(q, e1), S1 != null && i2.push(O0(q, S1, r1)))), ye) break;
                        q = q.return;
                    }
                    0 < i2.length && (y1 = new z1(y1, t2, null, f, b1), x1.push({
                        event: y1,
                        listeners: i2
                    }));
                }
            }
            if (!(l & 7)) {
                e: {
                    if (y1 = n === "mouseover" || n === "pointerover", z1 = n === "mouseout" || n === "pointerout", y1 && f !== qe && (t2 = f.relatedTarget || f.fromElement) && (x5(t2) || t2[W6])) break e;
                    if ((z1 || y1) && (y1 = b1.window === b1 ? b1 : (y1 = b1.ownerDocument) ? y1.defaultView || y1.parentWindow : window, z1 ? (t2 = f.relatedTarget || f.toElement, z1 = o1, t2 = t2 ? x5(t2) : null, t2 !== null && (ye = x2(t2), t2 !== ye || t2.tag !== 5 && t2.tag !== 6) && (t2 = null)) : (z1 = null, t2 = o1), z1 !== t2)) {
                        if (i2 = $t, S1 = "onMouseLeave", e1 = "onMouseEnter", q = "mouse", (n === "pointerout" || n === "pointerover") && (i2 = Yt, S1 = "onPointerLeave", e1 = "onPointerEnter", q = "pointer"), ye = z1 == null ? y1 : M9(z1), r1 = t2 == null ? y1 : M9(t2), y1 = new i2(S1, q + "leave", z1, f, b1), y1.target = ye, y1.relatedTarget = r1, S1 = null, x5(b1) === o1 && (i2 = new i2(e1, q + "enter", t2, f, b1), i2.target = r1, i2.relatedTarget = ye, S1 = i2), ye = S1, z1 && t2) t: {
                            for(i2 = z1, e1 = t2, q = 0, r1 = i2; r1; r1 = b8(r1))q++;
                            for(r1 = 0, S1 = e1; S1; S1 = b8(S1))r1++;
                            for(; 0 < q - r1;)i2 = b8(i2), q--;
                            for(; 0 < r1 - q;)e1 = b8(e1), r1--;
                            for(; q--;){
                                if (i2 === e1 || e1 !== null && i2 === e1.alternate) break t;
                                i2 = b8(i2), e1 = b8(e1);
                            }
                            i2 = null;
                        }
                        else i2 = null;
                        z1 !== null && Va(x1, y1, z1, i2, !1), t2 !== null && ye !== null && Va(x1, ye, t2, i2, !0);
                    }
                }
                e: {
                    if (y1 = o1 ? M9(o1) : window, z1 = y1.nodeName && y1.nodeName.toLowerCase(), z1 === "select" || z1 === "input" && y1.type === "file") var l2 = ll;
                    else if (il(y1)) {
                        if (va) l2 = dl;
                        else {
                            l2 = zc;
                            var n2 = jc;
                        }
                    } else (z1 = y1.nodeName) && z1.toLowerCase() === "input" && (y1.type === "checkbox" || y1.type === "radio") && (l2 = Uc);
                    if (l2 && (l2 = l2(n, o1))) {
                        ol(x1, l2, f, b1);
                        break e;
                    }
                    n2 && n2(n, y1, o1), n === "focusout" && (n2 = y1._wrapperState) && n2.controlled && y1.type === "number" && he(y1, "number", y1.value);
                }
                switch(n2 = o1 ? M9(o1) : window, n){
                    case "focusin":
                        (il(n2) || n2.contentEditable === "true") && (Q5 = n2, La = o1, _0 = null);
                        break;
                    case "focusout":
                        _0 = La = Q5 = null;
                        break;
                    case "mousedown":
                        ba = !0;
                        break;
                    case "contextmenu":
                    case "mouseup":
                    case "dragend":
                        ba = !1, ml(x1, f, b1);
                        break;
                    case "selectionchange":
                        if (hl) break;
                    case "keydown":
                    case "keyup":
                        ml(x1, f, b1);
                }
                var f2;
                if (W5) e: {
                    switch(n){
                        case "compositionstart":
                            var M2 = "onCompositionStart";
                            break e;
                        case "compositionend":
                            M2 = "onCompositionEnd";
                            break e;
                        case "compositionupdate":
                            M2 = "onCompositionUpdate";
                            break e;
                    }
                    M2 = void 0;
                }
                else b9 ? rl(n, f) && (M2 = "onCompositionEnd") : n === "keydown" && f.keyCode === 229 && (M2 = "onCompositionStart");
                M2 && (tl && f.locale !== "ko" && (b9 || M2 !== "onCompositionStart" ? M2 === "onCompositionEnd" && b9 && (f2 = Xe()) : (F2 = b1, w3 = "value" in F2 ? F2.value : F2.textContent, b9 = !0)), n2 = N0(o1, M2), 0 < n2.length && (M2 = new Ca(M2, n, null, f, b1), x1.push({
                    event: M2,
                    listeners: n2
                }), f2 ? M2.data = f2 : (f2 = qt(f), f2 !== null && (M2.data = f2)))), (f2 = Qt ? Fc(n, f) : Ac(n, f)) && (o1 = N0(o1, "onBeforeInput"), 0 < o1.length && (b1 = new Ca("onBeforeInput", "beforeinput", null, f, b1), x1.push({
                    event: b1,
                    listeners: o1
                }), b1.data = f2));
            }
            Jt(x1, l);
        });
    }
    function O0(n, l, f) {
        return {
            instance: n,
            listener: l,
            currentTarget: f
        };
    }
    function N0(n, l) {
        for(var f = l + "Capture", m = []; n !== null;){
            var b = n, H = b.stateNode;
            b.tag === 5 && H !== null && (b = H, H = P6(n, f), H != null && m.unshift(O0(n, H, b)), H = P6(n, l), H != null && m.push(O0(n, H, b))), n = n.return;
        }
        return m;
    }
    function b8(n) {
        if (n === null) return null;
        do n = n.return;
        while (n && n.tag !== 5);
        return n || null;
    }
    function Va(n, l, f, m, b) {
        for(var H = l._reactName, T = []; f !== null && f !== m;){
            var F = f, Y = F.alternate, o1 = F.stateNode;
            if (Y !== null && Y === m) break;
            F.tag === 5 && o1 !== null && (F = o1, b ? (Y = P6(f, H), Y != null && T.unshift(O0(f, Y, F))) : b || (Y = P6(f, H), Y != null && T.push(O0(f, Y, F)))), f = f.return;
        }
        T.length !== 0 && n.push({
            event: l,
            listeners: T
        });
    }
    var Ma = /\r\n?/g, Wc = /\u0000|\uFFFD/g;
    function Ea(n) {
        return (typeof n == "string" ? n : "" + n).replace(Ma, `
`).replace(Wc, "");
    }
    function tn(n, l, f) {
        if (l = Ea(l), Ea(n) !== l && f) throw Error(o(425));
    }
    function nn() {}
    var Sa = null, w8 = null;
    function P0(n, l) {
        return n === "textarea" || n === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
    }
    var H8 = typeof setTimeout == "function" ? setTimeout : void 0, xl = typeof clearTimeout == "function" ? clearTimeout : void 0, ka = typeof Promise == "function" ? Promise : void 0, Ta = typeof queueMicrotask == "function" ? queueMicrotask : typeof ka < "u" ? function(n) {
        return ka.resolve(null).then(n).catch(Qc);
    } : H8;
    function Qc(n) {
        setTimeout(function() {
            throw n;
        });
    }
    function _7(n, l) {
        var f = l, m = 0;
        do {
            var b = f.nextSibling;
            if (n.removeChild(f), b && b.nodeType === 8) {
                if (f = b.data, f === "/$") {
                    if (m === 0) {
                        n.removeChild(b), M7(l);
                        return;
                    }
                    m--;
                } else f !== "$" && f !== "$?" && f !== "$!" || m++;
            }
            f = b;
        }while (f);
        M7(l);
    }
    function q5(n) {
        for(; n != null; n = n.nextSibling){
            var l = n.nodeType;
            if (l === 1 || l === 3) break;
            if (l === 8) {
                if (l = n.data, l === "$" || l === "$!" || l === "$?") break;
                if (l === "/$") return null;
            }
        }
        return n;
    }
    function B0(n) {
        n = n.previousSibling;
        for(var l = 0; n;){
            if (n.nodeType === 8) {
                var f = n.data;
                if (f === "$" || f === "$!" || f === "$?") {
                    if (l === 0) return n;
                    l--;
                } else f === "/$" && l++;
            }
            n = n.previousSibling;
        }
        return null;
    }
    var D7 = Math.random().toString(36).slice(2), f6 = "__reactFiber$" + D7, x8 = "__reactProps$" + D7, W6 = "__reactContainer$" + D7, _a = "__reactEvents$" + D7, qc = "__reactListeners$" + D7, Da = "__reactHandles$" + D7;
    function x5(n) {
        var l = n[f6];
        if (l) return l;
        for(var f = n.parentNode; f;){
            if (l = f[W6] || f[f6]) {
                if (f = l.alternate, l.child !== null || f !== null && f.child !== null) for(n = B0(n); n !== null;){
                    if (f = n[f6]) return f;
                    n = B0(n);
                }
                return l;
            }
            n = f, f = n.parentNode;
        }
        return null;
    }
    function F0(n) {
        return n = n[f6] || n[W6], !n || n.tag !== 5 && n.tag !== 6 && n.tag !== 13 && n.tag !== 3 ? null : n;
    }
    function M9(n) {
        if (n.tag === 5 || n.tag === 6) return n.stateNode;
        throw Error(o(33));
    }
    function h2(n) {
        return n[x8] || null;
    }
    var R7 = [], I3 = -1;
    function Z2(n) {
        return {
            current: n
        };
    }
    function y3(n) {
        0 > I3 || (n.current = R7[I3], R7[I3] = null, I3--);
    }
    function H3(n, l) {
        I3++, R7[I3] = n.current, n.current = l;
    }
    var p6 = {}, V2 = Z2(p6), de = Z2(!1), I4 = p6;
    function V5(n, l) {
        var f = n.type.contextTypes;
        if (!f) return p6;
        var m = n.stateNode;
        if (m && m.__reactInternalMemoizedUnmaskedChildContext === l) return m.__reactInternalMemoizedMaskedChildContext;
        var b = {}, H;
        for(H in f)b[H] = l[H];
        return m && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = l, n.__reactInternalMemoizedMaskedChildContext = b), b;
    }
    function X3(n) {
        return n = n.childContextTypes, n != null;
    }
    function M5() {
        y3(de), y3(V2);
    }
    function Z7(n, l, f) {
        if (V2.current !== p6) throw Error(o(168));
        H3(V2, l), H3(de, f);
    }
    function A0(n, l, f) {
        var m = n.stateNode;
        if (l = l.childContextTypes, typeof m.getChildContext != "function") return f;
        m = m.getChildContext();
        for(var b in m)if (!(b in l)) throw Error(o(108, A2(n) || "Unknown", b));
        return g1({}, f, m);
    }
    function rn(n) {
        return n = (n = n.stateNode) && n.__reactInternalMemoizedMergedChildContext || p6, I4 = V2.current, H3(V2, n), H3(de, de.current), !0;
    }
    function Vl(n, l, f) {
        var m = n.stateNode;
        if (!m) throw Error(o(169));
        f ? (n = A0(n, l, I4), m.__reactInternalMemoizedMergedChildContext = n, y3(de), y3(V2), H3(V2, n)) : y3(de), H3(de, f);
    }
    var l5 = null, Ue = !1, j0 = !1;
    function Ra(n) {
        l5 === null ? l5 = [
            n
        ] : l5.push(n);
    }
    function Za(n) {
        Ue = !0, Ra(n);
    }
    function $4() {
        if (!j0 && l5 !== null) {
            j0 = !0;
            var n = 0, l = d3;
            try {
                var f = l5;
                for(d3 = 1; n < f.length; n++){
                    var m = f[n];
                    do m = m(!0);
                    while (m !== null);
                }
                l5 = null, Ue = !1;
            } catch (b) {
                throw l5 !== null && (l5 = l5.slice(n + 1)), F3(j4, $4), b;
            } finally{
                d3 = l, j0 = !1;
            }
        }
        return null;
    }
    var O7 = [], Y4 = 0, V8 = null, E9 = 0, W4 = [], m4 = 0, E5 = null, Ke = 1, Q6 = "";
    function s5(n, l) {
        O7[Y4++] = E9, O7[Y4++] = V8, V8 = n, E9 = l;
    }
    function Oa(n, l, f) {
        W4[m4++] = Ke, W4[m4++] = Q6, W4[m4++] = E5, E5 = n;
        var m = Ke;
        n = Q6;
        var b = 32 - z4(m) - 1;
        m &= ~(1 << b), f += 1;
        var H = 32 - z4(l) + b;
        if (30 < H) {
            var T = b - b % 5;
            H = (m & (1 << T) - 1).toString(32), m >>= T, b -= T, Ke = 1 << 32 - z4(l) + b | f << b | m, Q6 = H + n;
        } else Ke = 1 << H | f << b | m, Q6 = n;
    }
    function an(n) {
        n.return !== null && (s5(n, 1), Oa(n, 1, 0));
    }
    function Na(n) {
        for(; n === V8;)V8 = O7[--Y4], O7[Y4] = null, E9 = O7[--Y4], O7[Y4] = null;
        for(; n === E5;)E5 = W4[--m4], W4[m4] = null, Q6 = W4[--m4], W4[m4] = null, Ke = W4[--m4], W4[m4] = null;
    }
    var u5 = null, Q4 = null, $3 = !1, S5 = null;
    function Pa(n, l) {
        var f = Z5(5, null, null, 0);
        f.elementType = "DELETED", f.stateNode = l, f.return = n, l = n.deletions, l === null ? (n.deletions = [
            f
        ], n.flags |= 16) : l.push(f);
    }
    function Ml(n, l) {
        switch(n.tag){
            case 5:
                var f = n.type;
                return l = l.nodeType !== 1 || f.toLowerCase() !== l.nodeName.toLowerCase() ? null : l, l !== null ? (n.stateNode = l, u5 = n, Q4 = q5(l.firstChild), !0) : !1;
            case 6:
                return l = n.pendingProps === "" || l.nodeType !== 3 ? null : l, l !== null ? (n.stateNode = l, u5 = n, Q4 = null, !0) : !1;
            case 13:
                return l = l.nodeType !== 8 ? null : l, l !== null ? (f = E5 !== null ? {
                    id: Ke,
                    overflow: Q6
                } : null, n.memoizedState = {
                    dehydrated: l,
                    treeContext: f,
                    retryLane: 1073741824
                }, f = Z5(18, null, null, 0), f.stateNode = l, f.return = n, n.child = f, u5 = n, Q4 = null, !0) : !1;
            default:
                return !1;
        }
    }
    function on(n) {
        return (n.mode & 1) !== 0 && (n.flags & 128) === 0;
    }
    function ln(n) {
        if ($3) {
            var l = Q4;
            if (l) {
                var f = l;
                if (!Ml(n, l)) {
                    if (on(n)) throw Error(o(418));
                    l = q5(f.nextSibling);
                    var m = u5;
                    l && Ml(n, l) ? Pa(m, f) : (n.flags = n.flags & -4097 | 2, $3 = !1, u5 = n);
                }
            } else {
                if (on(n)) throw Error(o(418));
                n.flags = n.flags & -4097 | 2, $3 = !1, u5 = n;
            }
        }
    }
    function El(n) {
        for(n = n.return; n !== null && n.tag !== 5 && n.tag !== 3 && n.tag !== 13;)n = n.return;
        u5 = n;
    }
    function sn(n) {
        if (n !== u5) return !1;
        if (!$3) return El(n), $3 = !0, !1;
        var l;
        if ((l = n.tag !== 3) && !(l = n.tag !== 5) && (l = n.type, l = l !== "head" && l !== "body" && !P0(n.type, n.memoizedProps)), l && (l = Q4)) {
            if (on(n)) throw Sl(), Error(o(418));
            for(; l;)Pa(n, l), l = q5(l.nextSibling);
        }
        if (El(n), n.tag === 13) {
            if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(o(317));
            e: {
                for(n = n.nextSibling, l = 0; n;){
                    if (n.nodeType === 8) {
                        var f = n.data;
                        if (f === "/$") {
                            if (l === 0) {
                                Q4 = q5(n.nextSibling);
                                break e;
                            }
                            l--;
                        } else f !== "$" && f !== "$!" && f !== "$?" || l++;
                    }
                    n = n.nextSibling;
                }
                Q4 = null;
            }
        } else Q4 = u5 ? q5(n.stateNode.nextSibling) : null;
        return !0;
    }
    function Sl() {
        for(var n = Q4; n;)n = q5(n.nextSibling);
    }
    function re() {
        Q4 = u5 = null, $3 = !1;
    }
    function Ba(n) {
        S5 === null ? S5 = [
            n
        ] : S5.push(n);
    }
    var un = $.ReactCurrentBatchConfig;
    function c5(n, l) {
        if (n && n.defaultProps) {
            l = g1({}, l), n = n.defaultProps;
            for(var f in n)l[f] === void 0 && (l[f] = n[f]);
            return l;
        }
        return l;
    }
    var h6 = Z2(null), cn = null, N7 = null, Fa = null;
    function Aa() {
        Fa = N7 = cn = null;
    }
    function P7(n) {
        var l = h6.current;
        y3(h6), n._currentValue = l;
    }
    function Ie(n, l, f) {
        for(; n !== null;){
            var m = n.alternate;
            if ((n.childLanes & l) !== l ? (n.childLanes |= l, m !== null && (m.childLanes |= l)) : m !== null && (m.childLanes & l) !== l && (m.childLanes |= l), n === f) break;
            n = n.return;
        }
    }
    function Z1(n, l) {
        cn = n, Fa = N7 = null, n = n.dependencies, n !== null && n.firstContext !== null && (n.lanes & l && (Ve = !0), n.firstContext = null);
    }
    function ge(n) {
        var l = n._currentValue;
        if (Fa !== n) {
            if (n = {
                context: n,
                memoizedValue: l,
                next: null
            }, N7 === null) {
                if (cn === null) throw Error(o(308));
                N7 = n, cn.dependencies = {
                    lanes: 0,
                    firstContext: n
                };
            } else N7 = N7.next = n;
        }
        return l;
    }
    var Je = null;
    function ja(n) {
        Je === null ? Je = [
            n
        ] : Je.push(n);
    }
    function kl(n, l, f, m) {
        var b = l.interleaved;
        return b === null ? (f.next = f, ja(l)) : (f.next = b.next, b.next = f), l.interleaved = f, q6(n, m);
    }
    function q6(n, l) {
        n.lanes |= l;
        var f = n.alternate;
        for(f !== null && (f.lanes |= l), f = n, n = n.return; n !== null;)n.childLanes |= l, f = n.alternate, f !== null && (f.childLanes |= l), f = n, n = n.return;
        return f.tag === 3 ? f.stateNode : null;
    }
    var B7 = !1;
    function za(n) {
        n.updateQueue = {
            baseState: n.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: 0
            },
            effects: null
        };
    }
    function _e(n, l) {
        n = n.updateQueue, l.updateQueue === n && (l.updateQueue = {
            baseState: n.baseState,
            firstBaseUpdate: n.firstBaseUpdate,
            lastBaseUpdate: n.lastBaseUpdate,
            shared: n.shared,
            effects: n.effects
        });
    }
    function G6(n, l) {
        return {
            eventTime: n,
            lane: l,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function F7(n, l, f) {
        var m = n.updateQueue;
        if (m === null) return null;
        if (m = m.shared, W2 & 2) {
            var b = m.pending;
            return b === null ? l.next = l : (l.next = b.next, b.next = l), m.pending = l, q6(n, f);
        }
        return b = m.interleaved, b === null ? (l.next = l, ja(m)) : (l.next = b.next, b.next = l), m.interleaved = l, q6(n, f);
    }
    function dn(n, l, f) {
        if (l = l.updateQueue, l !== null && (l = l.shared, (f & 4194240) !== 0)) {
            var m = l.lanes;
            m &= n.pendingLanes, f |= m, l.lanes = f, h8(n, f);
        }
    }
    function Ua(n, l) {
        var f = n.updateQueue, m = n.alternate;
        if (m !== null && (m = m.updateQueue, f === m)) {
            var b = null, H = null;
            if (f = f.firstBaseUpdate, f !== null) {
                do {
                    var T = {
                        eventTime: f.eventTime,
                        lane: f.lane,
                        tag: f.tag,
                        payload: f.payload,
                        callback: f.callback,
                        next: null
                    };
                    H === null ? b = H = T : H = H.next = T, f = f.next;
                }while (f !== null);
                H === null ? b = H = l : H = H.next = l;
            } else b = H = l;
            f = {
                baseState: m.baseState,
                firstBaseUpdate: b,
                lastBaseUpdate: H,
                shared: m.shared,
                effects: m.effects
            }, n.updateQueue = f;
            return;
        }
        n = f.lastBaseUpdate, n === null ? f.firstBaseUpdate = l : n.next = l, f.lastBaseUpdate = l;
    }
    function A7(n, l, f, m) {
        var b = n.updateQueue;
        B7 = !1;
        var H = b.firstBaseUpdate, T = b.lastBaseUpdate, F = b.shared.pending;
        if (F !== null) {
            b.shared.pending = null;
            var Y = F, o1 = Y.next;
            Y.next = null, T === null ? H = o1 : T.next = o1, T = Y;
            var b1 = n.alternate;
            b1 !== null && (b1 = b1.updateQueue, F = b1.lastBaseUpdate, F !== T && (F === null ? b1.firstBaseUpdate = o1 : F.next = o1, b1.lastBaseUpdate = Y));
        }
        if (H !== null) {
            var x1 = b.baseState;
            T = 0, b1 = o1 = Y = null, F = H;
            do {
                var y1 = F.lane, z1 = F.eventTime;
                if ((m & y1) === y1) {
                    b1 !== null && (b1 = b1.next = {
                        eventTime: z1,
                        lane: 0,
                        tag: F.tag,
                        payload: F.payload,
                        callback: F.callback,
                        next: null
                    });
                    e: {
                        var t2 = n, i2 = F;
                        switch(y1 = l, z1 = f, i2.tag){
                            case 1:
                                if (t2 = i2.payload, typeof t2 == "function") {
                                    x1 = t2.call(z1, x1, y1);
                                    break e;
                                }
                                x1 = t2;
                                break e;
                            case 3:
                                t2.flags = t2.flags & -65537 | 128;
                            case 0:
                                if (t2 = i2.payload, y1 = typeof t2 == "function" ? t2.call(z1, x1, y1) : t2, y1 == null) break e;
                                x1 = g1({}, x1, y1);
                                break e;
                            case 2:
                                B7 = !0;
                        }
                    }
                    F.callback !== null && F.lane !== 0 && (n.flags |= 64, y1 = b.effects, y1 === null ? b.effects = [
                        F
                    ] : y1.push(F));
                } else z1 = {
                    eventTime: z1,
                    lane: y1,
                    tag: F.tag,
                    payload: F.payload,
                    callback: F.callback,
                    next: null
                }, b1 === null ? (o1 = b1 = z1, Y = x1) : b1 = b1.next = z1, T |= y1;
                if (F = F.next, F === null) {
                    if (F = b.shared.pending, F === null) break;
                    y1 = F, F = y1.next, y1.next = null, b.lastBaseUpdate = y1, b.shared.pending = null;
                }
            }while (!0);
            if (b1 === null && (Y = x1), b.baseState = Y, b.firstBaseUpdate = o1, b.lastBaseUpdate = b1, l = b.shared.interleaved, l !== null) {
                b = l;
                do T |= b.lane, b = b.next;
                while (b !== l);
            } else H === null && (b.shared.lanes = 0);
            e7 |= T, n.lanes = T, n.memoizedState = x1;
        }
    }
    function M8(n, l, f) {
        if (n = l.effects, l.effects = null, n !== null) for(l = 0; l < n.length; l++){
            var m = n[l], b = m.callback;
            if (b !== null) {
                if (m.callback = null, m = f, typeof b != "function") throw Error(o(191, b));
                b.call(m);
            }
        }
    }
    var Tl = new r.Component().refs;
    function Ia(n, l, f, m) {
        l = n.memoizedState, f = f(m, l), f = f == null ? l : g1({}, l, f), n.memoizedState = f, n.lanes === 0 && (n.updateQueue.baseState = f);
    }
    var Cn = {
        isMounted: function(n) {
            return (n = n._reactInternals) ? x2(n) === n : !1;
        },
        enqueueSetState: function(n, l, f) {
            n = n._reactInternals;
            var m = L4(), b = Me(n), H = G6(m, b);
            H.payload = l, f != null && (H.callback = f), l = F7(n, H, b), l !== null && (b4(l, n, b, m), dn(l, n, b));
        },
        enqueueReplaceState: function(n, l, f) {
            n = n._reactInternals;
            var m = L4(), b = Me(n), H = G6(m, b);
            H.tag = 1, H.payload = l, f != null && (H.callback = f), l = F7(n, H, b), l !== null && (b4(l, n, b, m), dn(l, n, b));
        },
        enqueueForceUpdate: function(n, l) {
            n = n._reactInternals;
            var f = L4(), m = Me(n), b = G6(f, m);
            b.tag = 2, l != null && (b.callback = l), l = F7(n, b, m), l !== null && (b4(l, n, m, f), dn(l, n, m));
        }
    };
    function _l(n, l, f, m, b, H, T) {
        return n = n.stateNode, typeof n.shouldComponentUpdate == "function" ? n.shouldComponentUpdate(m, H, T) : l.prototype && l.prototype.isPureReactComponent ? !T0(f, m) || !T0(b, H) : !0;
    }
    function Dl(n, l, f) {
        var m = !1, b = p6, H = l.contextType;
        return typeof H == "object" && H !== null ? H = ge(H) : (b = X3(l) ? I4 : V2.current, m = l.contextTypes, H = (m = m != null) ? V5(n, b) : p6), l = new l(f, H), n.memoizedState = l.state !== null && l.state !== void 0 ? l.state : null, l.updater = Cn, n.stateNode = l, l._reactInternals = n, m && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = b, n.__reactInternalMemoizedMaskedChildContext = H), l;
    }
    function Rl(n, l, f, m) {
        n = l.state, typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(f, m), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(f, m), l.state !== n && Cn.enqueueReplaceState(l, l.state, null);
    }
    function fn(n, l, f, m) {
        var b = n.stateNode;
        b.props = f, b.state = n.memoizedState, b.refs = Tl, za(n);
        var H = l.contextType;
        typeof H == "object" && H !== null ? b.context = ge(H) : (H = X3(l) ? I4 : V2.current, b.context = V5(n, H)), b.state = n.memoizedState, H = l.getDerivedStateFromProps, typeof H == "function" && (Ia(n, l, H, f), b.state = n.memoizedState), typeof l.getDerivedStateFromProps == "function" || typeof b.getSnapshotBeforeUpdate == "function" || typeof b.UNSAFE_componentWillMount != "function" && typeof b.componentWillMount != "function" || (l = b.state, typeof b.componentWillMount == "function" && b.componentWillMount(), typeof b.UNSAFE_componentWillMount == "function" && b.UNSAFE_componentWillMount(), l !== b.state && Cn.enqueueReplaceState(b, b.state, null), A7(n, f, b, m), b.state = n.memoizedState), typeof b.componentDidMount == "function" && (n.flags |= 4194308);
    }
    function S9(n, l, f) {
        if (n = f.ref, n !== null && typeof n != "function" && typeof n != "object") {
            if (f._owner) {
                if (f = f._owner, f) {
                    if (f.tag !== 1) throw Error(o(309));
                    var m = f.stateNode;
                }
                if (!m) throw Error(o(147, n));
                var b = m, H = "" + n;
                return l !== null && l.ref !== null && typeof l.ref == "function" && l.ref._stringRef === H ? l.ref : (l = function(T) {
                    var F = b.refs;
                    F === Tl && (F = b.refs = {}), T === null ? delete F[H] : F[H] = T;
                }, l._stringRef = H, l);
            }
            if (typeof n != "string") throw Error(o(284));
            if (!f._owner) throw Error(o(290, n));
        }
        return n;
    }
    function pn(n, l) {
        throw n = Object.prototype.toString.call(l), Error(o(31, n === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : n));
    }
    function Zl(n) {
        var l = n._init;
        return l(n._payload);
    }
    function Ol(n) {
        function l(e1, q) {
            if (n) {
                var r1 = e1.deletions;
                r1 === null ? (e1.deletions = [
                    q
                ], e1.flags |= 16) : r1.push(q);
            }
        }
        function f(e1, q) {
            if (!n) return null;
            for(; q !== null;)l(e1, q), q = q.sibling;
            return null;
        }
        function m(e1, q) {
            for(e1 = /* @__PURE__ */ new Map(); q !== null;)q.key !== null ? e1.set(q.key, q) : e1.set(q.index, q), q = q.sibling;
            return e1;
        }
        function b(e1, q) {
            return e1 = Q7(e1, q), e1.index = 0, e1.sibling = null, e1;
        }
        function H(e1, q, r1) {
            return e1.index = r1, n ? (r1 = e1.alternate, r1 !== null ? (r1 = r1.index, r1 < q ? (e1.flags |= 2, q) : r1) : (e1.flags |= 2, q)) : (e1.flags |= 1048576, q);
        }
        function T(e1) {
            return n && e1.alternate === null && (e1.flags |= 2), e1;
        }
        function F(e1, q, r1, S1) {
            return q === null || q.tag !== 6 ? (q = ot(r1, e1.mode, S1), q.return = e1, q) : (q = b(q, r1), q.return = e1, q);
        }
        function Y(e1, q, r1, S1) {
            var l2 = r1.type;
            return l2 === u1 ? b1(e1, q, r1.props.children, S1, r1.key) : q !== null && (q.elementType === l2 || typeof l2 == "object" && l2 !== null && l2.$$typeof === D1 && Zl(l2) === q.type) ? (S1 = b(q, r1.props), S1.ref = S9(e1, q, r1), S1.return = e1, S1) : (S1 = Yn(r1.type, r1.key, r1.props, null, e1.mode, S1), S1.ref = S9(e1, q, r1), S1.return = e1, S1);
        }
        function o1(e1, q, r1, S1) {
            return q === null || q.tag !== 4 || q.stateNode.containerInfo !== r1.containerInfo || q.stateNode.implementation !== r1.implementation ? (q = $8(r1, e1.mode, S1), q.return = e1, q) : (q = b(q, r1.children || []), q.return = e1, q);
        }
        function b1(e1, q, r1, S1, l2) {
            return q === null || q.tag !== 7 ? (q = I8(r1, e1.mode, S1, l2), q.return = e1, q) : (q = b(q, r1), q.return = e1, q);
        }
        function x1(e1, q, r1) {
            if (typeof q == "string" && q !== "" || typeof q == "number") return q = ot("" + q, e1.mode, r1), q.return = e1, q;
            if (typeof q == "object" && q !== null) {
                switch(q.$$typeof){
                    case W:
                        return r1 = Yn(q.type, q.key, q.props, null, e1.mode, r1), r1.ref = S9(e1, null, q), r1.return = e1, r1;
                    case l1:
                        return q = $8(q, e1.mode, r1), q.return = e1, q;
                    case D1:
                        var S1 = q._init;
                        return x1(e1, S1(q._payload), r1);
                }
                if (j3(q) || M1(q)) return q = I8(q, e1.mode, r1, null), q.return = e1, q;
                pn(e1, q);
            }
            return null;
        }
        function y1(e1, q, r1, S1) {
            var l2 = q !== null ? q.key : null;
            if (typeof r1 == "string" && r1 !== "" || typeof r1 == "number") return l2 !== null ? null : F(e1, q, "" + r1, S1);
            if (typeof r1 == "object" && r1 !== null) {
                switch(r1.$$typeof){
                    case W:
                        return r1.key === l2 ? Y(e1, q, r1, S1) : null;
                    case l1:
                        return r1.key === l2 ? o1(e1, q, r1, S1) : null;
                    case D1:
                        return l2 = r1._init, y1(e1, q, l2(r1._payload), S1);
                }
                if (j3(r1) || M1(r1)) return l2 !== null ? null : b1(e1, q, r1, S1, null);
                pn(e1, r1);
            }
            return null;
        }
        function z1(e1, q, r1, S1, l2) {
            if (typeof S1 == "string" && S1 !== "" || typeof S1 == "number") return e1 = e1.get(r1) || null, F(q, e1, "" + S1, l2);
            if (typeof S1 == "object" && S1 !== null) {
                switch(S1.$$typeof){
                    case W:
                        return e1 = e1.get(S1.key === null ? r1 : S1.key) || null, Y(q, e1, S1, l2);
                    case l1:
                        return e1 = e1.get(S1.key === null ? r1 : S1.key) || null, o1(q, e1, S1, l2);
                    case D1:
                        var n2 = S1._init;
                        return z1(e1, q, r1, n2(S1._payload), l2);
                }
                if (j3(S1) || M1(S1)) return e1 = e1.get(r1) || null, b1(q, e1, S1, l2, null);
                pn(q, S1);
            }
            return null;
        }
        function t2(e1, q, r1, S1) {
            for(var l2 = null, n2 = null, f2 = q, M2 = q = 0, We = null; f2 !== null && M2 < r1.length; M2++){
                f2.index > M2 ? (We = f2, f2 = null) : We = f2.sibling;
                var o3 = y1(e1, f2, r1[M2], S1);
                if (o3 === null) {
                    f2 === null && (f2 = We);
                    break;
                }
                n && f2 && o3.alternate === null && l(e1, f2), q = H(o3, q, M2), n2 === null ? l2 = o3 : n2.sibling = o3, n2 = o3, f2 = We;
            }
            if (M2 === r1.length) return f(e1, f2), $3 && s5(e1, M2), l2;
            if (f2 === null) {
                for(; M2 < r1.length; M2++)f2 = x1(e1, r1[M2], S1), f2 !== null && (q = H(f2, q, M2), n2 === null ? l2 = f2 : n2.sibling = f2, n2 = f2);
                return $3 && s5(e1, M2), l2;
            }
            for(f2 = m(e1, f2); M2 < r1.length; M2++)We = z1(f2, e1, M2, r1[M2], S1), We !== null && (n && We.alternate !== null && f2.delete(We.key === null ? M2 : We.key), q = H(We, q, M2), n2 === null ? l2 = We : n2.sibling = We, n2 = We);
            return n && f2.forEach(function(q7) {
                return l(e1, q7);
            }), $3 && s5(e1, M2), l2;
        }
        function i2(e1, q, r1, S1) {
            var l2 = M1(r1);
            if (typeof l2 != "function") throw Error(o(150));
            if (r1 = l2.call(r1), r1 == null) throw Error(o(151));
            for(var n2 = l2 = null, f2 = q, M2 = q = 0, We = null, o3 = r1.next(); f2 !== null && !o3.done; M2++, o3 = r1.next()){
                f2.index > M2 ? (We = f2, f2 = null) : We = f2.sibling;
                var q7 = y1(e1, f2, o3.value, S1);
                if (q7 === null) {
                    f2 === null && (f2 = We);
                    break;
                }
                n && f2 && q7.alternate === null && l(e1, f2), q = H(q7, q, M2), n2 === null ? l2 = q7 : n2.sibling = q7, n2 = q7, f2 = We;
            }
            if (o3.done) return f(e1, f2), $3 && s5(e1, M2), l2;
            if (f2 === null) {
                for(; !o3.done; M2++, o3 = r1.next())o3 = x1(e1, o3.value, S1), o3 !== null && (q = H(o3, q, M2), n2 === null ? l2 = o3 : n2.sibling = o3, n2 = o3);
                return $3 && s5(e1, M2), l2;
            }
            for(f2 = m(e1, f2); !o3.done; M2++, o3 = r1.next())o3 = z1(f2, e1, M2, o3.value, S1), o3 !== null && (n && o3.alternate !== null && f2.delete(o3.key === null ? M2 : o3.key), q = H(o3, q, M2), n2 === null ? l2 = o3 : n2.sibling = o3, n2 = o3);
            return n && f2.forEach(function(hd) {
                return l(e1, hd);
            }), $3 && s5(e1, M2), l2;
        }
        function ye(e1, q, r1, S1) {
            if (typeof r1 == "object" && r1 !== null && r1.type === u1 && r1.key === null && (r1 = r1.props.children), typeof r1 == "object" && r1 !== null) {
                switch(r1.$$typeof){
                    case W:
                        e: {
                            for(var l2 = r1.key, n2 = q; n2 !== null;){
                                if (n2.key === l2) {
                                    if (l2 = r1.type, l2 === u1) {
                                        if (n2.tag === 7) {
                                            f(e1, n2.sibling), q = b(n2, r1.props.children), q.return = e1, e1 = q;
                                            break e;
                                        }
                                    } else if (n2.elementType === l2 || typeof l2 == "object" && l2 !== null && l2.$$typeof === D1 && Zl(l2) === n2.type) {
                                        f(e1, n2.sibling), q = b(n2, r1.props), q.ref = S9(e1, n2, r1), q.return = e1, e1 = q;
                                        break e;
                                    }
                                    f(e1, n2);
                                    break;
                                } else l(e1, n2);
                                n2 = n2.sibling;
                            }
                            r1.type === u1 ? (q = I8(r1.props.children, e1.mode, S1, r1.key), q.return = e1, e1 = q) : (S1 = Yn(r1.type, r1.key, r1.props, null, e1.mode, S1), S1.ref = S9(e1, q, r1), S1.return = e1, e1 = S1);
                        }
                        return T(e1);
                    case l1:
                        e: {
                            for(n2 = r1.key; q !== null;){
                                if (q.key === n2) {
                                    if (q.tag === 4 && q.stateNode.containerInfo === r1.containerInfo && q.stateNode.implementation === r1.implementation) {
                                        f(e1, q.sibling), q = b(q, r1.children || []), q.return = e1, e1 = q;
                                        break e;
                                    } else {
                                        f(e1, q);
                                        break;
                                    }
                                } else l(e1, q);
                                q = q.sibling;
                            }
                            q = $8(r1, e1.mode, S1), q.return = e1, e1 = q;
                        }
                        return T(e1);
                    case D1:
                        return n2 = r1._init, ye(e1, q, n2(r1._payload), S1);
                }
                if (j3(r1)) return t2(e1, q, r1, S1);
                if (M1(r1)) return i2(e1, q, r1, S1);
                pn(e1, r1);
            }
            return typeof r1 == "string" && r1 !== "" || typeof r1 == "number" ? (r1 = "" + r1, q !== null && q.tag === 6 ? (f(e1, q.sibling), q = b(q, r1), q.return = e1, e1 = q) : (f(e1, q), q = ot(r1, e1.mode, S1), q.return = e1, e1 = q), T(e1)) : f(e1, q);
        }
        return ye;
    }
    var k9 = Ol(!0), Nl = Ol(!1), z0 = {}, G5 = Z2(z0), U0 = Z2(z0), T9 = Z2(z0);
    function E8(n) {
        if (n === z0) throw Error(o(174));
        return n;
    }
    function $a(n, l) {
        switch(H3(T9, l), H3(U0, n), H3(G5, z0), n = l.nodeType, n){
            case 9:
            case 11:
                l = (l = l.documentElement) ? l.namespaceURI : U3(null, "");
                break;
            default:
                n = n === 8 ? l.parentNode : l, l = n.namespaceURI || null, n = n.tagName, l = U3(l, n);
        }
        y3(G5), H3(G5, l);
    }
    function j7() {
        y3(G5), y3(U0), y3(T9);
    }
    function y2(n) {
        E8(T9.current);
        var l = E8(G5.current), f = U3(l, n.type);
        l !== f && (H3(U0, n), H3(G5, f));
    }
    function U2(n) {
        U0.current === n && (y3(G5), y3(U0));
    }
    var L2 = Z2(0);
    function ae(n) {
        for(var l = n; l !== null;){
            if (l.tag === 13) {
                var f = l.memoizedState;
                if (f !== null && (f = f.dehydrated, f === null || f.data === "$?" || f.data === "$!")) return l;
            } else if (l.tag === 19 && l.memoizedProps.revealOrder !== void 0) {
                if (l.flags & 128) return l;
            } else if (l.child !== null) {
                l.child.return = l, l = l.child;
                continue;
            }
            if (l === n) break;
            for(; l.sibling === null;){
                if (l.return === null || l.return === n) return null;
                l = l.return;
            }
            l.sibling.return = l.return, l = l.sibling;
        }
        return null;
    }
    var k5 = [];
    function hn() {
        for(var n = 0; n < k5.length; n++)k5[n]._workInProgressVersionPrimary = null;
        k5.length = 0;
    }
    var mn = $.ReactCurrentDispatcher, Ya = $.ReactCurrentBatchConfig, S8 = 0, Y3 = null, C1 = null, e3 = null, b2 = !1, m6 = !1, d5 = 0, k8 = 0;
    function W3() {
        throw Error(o(321));
    }
    function T8(n, l) {
        if (l === null) return !1;
        for(var f = 0; f < l.length && f < n.length; f++)if (!H5(n[f], l[f])) return !1;
        return !0;
    }
    function z7(n, l, f, m, b, H) {
        if (S8 = H, Y3 = l, l.memoizedState = null, l.updateQueue = null, l.lanes = 0, mn.current = n === null || n.memoizedState === null ? Xc : Kc, n = f(m, b), m6) {
            H = 0;
            do {
                if (m6 = !1, d5 = 0, 25 <= H) throw Error(o(301));
                H += 1, e3 = C1 = null, l.updateQueue = null, mn.current = Qa, n = f(m, b);
            }while (m6);
        }
        if (mn.current = Dn, l = C1 !== null && C1.next !== null, S8 = 0, e3 = C1 = Y3 = null, b2 = !1, l) throw Error(o(300));
        return n;
    }
    function _8() {
        var n = d5 !== 0;
        return d5 = 0, n;
    }
    function T5() {
        var n = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        return e3 === null ? Y3.memoizedState = e3 = n : e3 = e3.next = n, e3;
    }
    function q4() {
        if (C1 === null) {
            var n = Y3.alternate;
            n = n !== null ? n.memoizedState : null;
        } else n = C1.next;
        var l = e3 === null ? Y3.memoizedState : e3.next;
        if (l !== null) e3 = l, C1 = n;
        else {
            if (n === null) throw Error(o(310));
            C1 = n, n = {
                memoizedState: C1.memoizedState,
                baseState: C1.baseState,
                baseQueue: C1.baseQueue,
                queue: C1.queue,
                next: null
            }, e3 === null ? Y3.memoizedState = e3 = n : e3 = e3.next = n;
        }
        return e3;
    }
    function D8(n, l) {
        return typeof l == "function" ? l(n) : l;
    }
    function I0(n) {
        var l = q4(), f = l.queue;
        if (f === null) throw Error(o(311));
        f.lastRenderedReducer = n;
        var m = C1, b = m.baseQueue, H = f.pending;
        if (H !== null) {
            if (b !== null) {
                var T = b.next;
                b.next = H.next, H.next = T;
            }
            m.baseQueue = b = H, f.pending = null;
        }
        if (b !== null) {
            H = b.next, m = m.baseState;
            var F = T = null, Y = null, o1 = H;
            do {
                var b1 = o1.lane;
                if ((S8 & b1) === b1) Y !== null && (Y = Y.next = {
                    lane: 0,
                    action: o1.action,
                    hasEagerState: o1.hasEagerState,
                    eagerState: o1.eagerState,
                    next: null
                }), m = o1.hasEagerState ? o1.eagerState : n(m, o1.action);
                else {
                    var x1 = {
                        lane: b1,
                        action: o1.action,
                        hasEagerState: o1.hasEagerState,
                        eagerState: o1.eagerState,
                        next: null
                    };
                    Y === null ? (F = Y = x1, T = m) : Y = Y.next = x1, Y3.lanes |= b1, e7 |= b1;
                }
                o1 = o1.next;
            }while (o1 !== null && o1 !== H);
            Y === null ? T = m : Y.next = F, H5(m, l.memoizedState) || (Ve = !0), l.memoizedState = m, l.baseState = T, l.baseQueue = Y, f.lastRenderedState = m;
        }
        if (n = f.interleaved, n !== null) {
            b = n;
            do H = b.lane, Y3.lanes |= H, e7 |= H, b = b.next;
            while (b !== n);
        } else b === null && (f.lanes = 0);
        return [
            l.memoizedState,
            f.dispatch
        ];
    }
    function $0(n) {
        var l = q4(), f = l.queue;
        if (f === null) throw Error(o(311));
        f.lastRenderedReducer = n;
        var m = f.dispatch, b = f.pending, H = l.memoizedState;
        if (b !== null) {
            f.pending = null;
            var T = b = b.next;
            do H = n(H, T.action), T = T.next;
            while (T !== b);
            H5(H, l.memoizedState) || (Ve = !0), l.memoizedState = H, l.baseQueue === null && (l.baseState = H), f.lastRenderedState = H;
        }
        return [
            H,
            m
        ];
    }
    function vn() {}
    function gn(n, l) {
        var f = Y3, m = q4(), b = l(), H = !H5(m.memoizedState, b);
        if (H && (m.memoizedState = b, Ve = !0), m = m.queue, Y0(bn.bind(null, f, m, n), [
            n
        ]), m.getSnapshot !== l || H || e3 !== null && e3.memoizedState.tag & 1) {
            if (f.flags |= 2048, R8(9, Ln.bind(null, f, m, b, l), void 0, null), ie === null) throw Error(o(349));
            S8 & 30 || yn(f, l, b);
        }
        return b;
    }
    function yn(n, l, f) {
        n.flags |= 16384, n = {
            getSnapshot: l,
            value: f
        }, l = Y3.updateQueue, l === null ? (l = {
            lastEffect: null,
            stores: null
        }, Y3.updateQueue = l, l.stores = [
            n
        ]) : (f = l.stores, f === null ? l.stores = [
            n
        ] : f.push(n));
    }
    function Ln(n, l, f, m) {
        l.value = f, l.getSnapshot = m, wn(l) && Hn(n);
    }
    function bn(n, l, f) {
        return f(function() {
            wn(l) && Hn(n);
        });
    }
    function wn(n) {
        var l = n.getSnapshot;
        n = n.value;
        try {
            var f = l();
            return !H5(n, f);
        } catch  {
            return !0;
        }
    }
    function Hn(n) {
        var l = q6(n, 1);
        l !== null && b4(l, n, 1, -1);
    }
    function xn(n) {
        var l = T5();
        return typeof n == "function" && (n = n()), l.memoizedState = l.baseState = n, n = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: D8,
            lastRenderedState: n
        }, l.queue = n, n = n.dispatch = _n.bind(null, Y3, n), [
            l.memoizedState,
            n
        ];
    }
    function R8(n, l, f, m) {
        return n = {
            tag: n,
            create: l,
            destroy: f,
            deps: m,
            next: null
        }, l = Y3.updateQueue, l === null ? (l = {
            lastEffect: null,
            stores: null
        }, Y3.updateQueue = l, l.lastEffect = n.next = n) : (f = l.lastEffect, f === null ? l.lastEffect = n.next = n : (m = f.next, f.next = n, n.next = m, l.lastEffect = n)), n;
    }
    function Vn() {
        return q4().memoizedState;
    }
    function Z8(n, l, f, m) {
        var b = T5();
        Y3.flags |= n, b.memoizedState = R8(1 | l, f, void 0, m === void 0 ? null : m);
    }
    function X6(n, l, f, m) {
        var b = q4();
        m = m === void 0 ? null : m;
        var H = void 0;
        if (C1 !== null) {
            var T = C1.memoizedState;
            if (H = T.destroy, m !== null && T8(m, T.deps)) {
                b.memoizedState = R8(l, f, H, m);
                return;
            }
        }
        Y3.flags |= n, b.memoizedState = R8(1 | l, f, H, m);
    }
    function Mn(n, l) {
        return Z8(8390656, 8, n, l);
    }
    function Y0(n, l) {
        return X6(2048, 8, n, l);
    }
    function En(n, l) {
        return X6(4, 2, n, l);
    }
    function Sn(n, l) {
        return X6(4, 4, n, l);
    }
    function Wa(n, l) {
        if (typeof l == "function") return n = n(), l(n), function() {
            l(null);
        };
        if (l != null) return n = n(), l.current = n, function() {
            l.current = null;
        };
    }
    function _9(n, l, f) {
        return f = f != null ? f.concat([
            n
        ]) : null, X6(4, 4, Wa.bind(null, l, n), f);
    }
    function kn() {}
    function D9(n, l) {
        var f = q4();
        l = l === void 0 ? null : l;
        var m = f.memoizedState;
        return m !== null && l !== null && T8(l, m[1]) ? m[0] : (f.memoizedState = [
            n,
            l
        ], n);
    }
    function U7(n, l) {
        var f = q4();
        l = l === void 0 ? null : l;
        var m = f.memoizedState;
        return m !== null && l !== null && T8(l, m[1]) ? m[0] : (n = n(), f.memoizedState = [
            n,
            l
        ], n);
    }
    function G4(n, l, f) {
        return S8 & 21 ? (H5(f, l) || (f = p9(), Y3.lanes |= f, e7 |= f, n.baseState = !0), l) : (n.baseState && (n.baseState = !1, Ve = !0), n.memoizedState = f);
    }
    function Gc(n, l) {
        var f = d3;
        d3 = f !== 0 && 4 > f ? f : 4, n(!0);
        var m = Ya.transition;
        Ya.transition = {};
        try {
            n(!1), l();
        } finally{
            d3 = f, Ya.transition = m;
        }
    }
    function O3() {
        return q4().memoizedState;
    }
    function Tn(n, l, f) {
        var m = Me(n);
        if (f = {
            lane: m,
            action: f,
            hasEagerState: !1,
            eagerState: null,
            next: null
        }, R9(n)) W0(l, f);
        else if (f = kl(n, l, f, m), f !== null) {
            var b = L4();
            b4(f, n, m, b), Pl(f, l, m);
        }
    }
    function _n(n, l, f) {
        var m = Me(n), b = {
            lane: m,
            action: f,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (R9(n)) W0(l, b);
        else {
            var H = n.alternate;
            if (n.lanes === 0 && (H === null || H.lanes === 0) && (H = l.lastRenderedReducer, H !== null)) try {
                var T = l.lastRenderedState, F = H(T, f);
                if (b.hasEagerState = !0, b.eagerState = F, H5(F, T)) {
                    var Y = l.interleaved;
                    Y === null ? (b.next = b, ja(l)) : (b.next = Y.next, Y.next = b), l.interleaved = b;
                    return;
                }
            } catch  {} finally{}
            f = kl(n, l, b, m), f !== null && (b = L4(), b4(f, n, m, b), Pl(f, l, m));
        }
    }
    function R9(n) {
        var l = n.alternate;
        return n === Y3 || l !== null && l === Y3;
    }
    function W0(n, l) {
        m6 = b2 = !0;
        var f = n.pending;
        f === null ? l.next = l : (l.next = f.next, f.next = l), n.pending = l;
    }
    function Pl(n, l, f) {
        if (f & 4194240) {
            var m = l.lanes;
            m &= n.pendingLanes, f |= m, l.lanes = f, h8(n, f);
        }
    }
    var Dn = {
        readContext: ge,
        useCallback: W3,
        useContext: W3,
        useEffect: W3,
        useImperativeHandle: W3,
        useInsertionEffect: W3,
        useLayoutEffect: W3,
        useMemo: W3,
        useReducer: W3,
        useRef: W3,
        useState: W3,
        useDebugValue: W3,
        useDeferredValue: W3,
        useTransition: W3,
        useMutableSource: W3,
        useSyncExternalStore: W3,
        useId: W3,
        unstable_isNewReconciler: !1
    }, Xc = {
        readContext: ge,
        useCallback: function(n, l) {
            return T5().memoizedState = [
                n,
                l === void 0 ? null : l
            ], n;
        },
        useContext: ge,
        useEffect: Mn,
        useImperativeHandle: function(n, l, f) {
            return f = f != null ? f.concat([
                n
            ]) : null, Z8(4194308, 4, Wa.bind(null, l, n), f);
        },
        useLayoutEffect: function(n, l) {
            return Z8(4194308, 4, n, l);
        },
        useInsertionEffect: function(n, l) {
            return Z8(4, 2, n, l);
        },
        useMemo: function(n, l) {
            var f = T5();
            return l = l === void 0 ? null : l, n = n(), f.memoizedState = [
                n,
                l
            ], n;
        },
        useReducer: function(n, l, f) {
            var m = T5();
            return l = f !== void 0 ? f(l) : l, m.memoizedState = m.baseState = l, n = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: n,
                lastRenderedState: l
            }, m.queue = n, n = n.dispatch = Tn.bind(null, Y3, n), [
                m.memoizedState,
                n
            ];
        },
        useRef: function(n) {
            var l = T5();
            return n = {
                current: n
            }, l.memoizedState = n;
        },
        useState: xn,
        useDebugValue: kn,
        useDeferredValue: function(n) {
            return T5().memoizedState = n;
        },
        useTransition: function() {
            var n = xn(!1), l = n[0];
            return n = Gc.bind(null, n[1]), T5().memoizedState = n, [
                l,
                n
            ];
        },
        useMutableSource: function() {},
        useSyncExternalStore: function(n, l, f) {
            var m = Y3, b = T5();
            if ($3) {
                if (f === void 0) throw Error(o(407));
                f = f();
            } else {
                if (f = l(), ie === null) throw Error(o(349));
                S8 & 30 || yn(m, l, f);
            }
            b.memoizedState = f;
            var H = {
                value: f,
                getSnapshot: l
            };
            return b.queue = H, Mn(bn.bind(null, m, H, n), [
                n
            ]), m.flags |= 2048, R8(9, Ln.bind(null, m, H, f, l), void 0, null), f;
        },
        useId: function() {
            var n = T5(), l = ie.identifierPrefix;
            if ($3) {
                var f = Q6, m = Ke;
                f = (m & ~(1 << 32 - z4(m) - 1)).toString(32) + f, l = ":" + l + "R" + f, f = d5++, 0 < f && (l += "H" + f.toString(32)), l += ":";
            } else f = k8++, l = ":" + l + "r" + f.toString(32) + ":";
            return n.memoizedState = l;
        },
        unstable_isNewReconciler: !1
    }, Kc = {
        readContext: ge,
        useCallback: D9,
        useContext: ge,
        useEffect: Y0,
        useImperativeHandle: _9,
        useInsertionEffect: En,
        useLayoutEffect: Sn,
        useMemo: U7,
        useReducer: I0,
        useRef: Vn,
        useState: function() {
            return I0(D8);
        },
        useDebugValue: kn,
        useDeferredValue: function(n) {
            var l = q4();
            return G4(l, C1.memoizedState, n);
        },
        useTransition: function() {
            var n = I0(D8)[0], l = q4().memoizedState;
            return [
                n,
                l
            ];
        },
        useMutableSource: vn,
        useSyncExternalStore: gn,
        useId: O3,
        unstable_isNewReconciler: !1
    }, Qa = {
        readContext: ge,
        useCallback: D9,
        useContext: ge,
        useEffect: Y0,
        useImperativeHandle: _9,
        useInsertionEffect: En,
        useLayoutEffect: Sn,
        useMemo: U7,
        useReducer: $0,
        useRef: Vn,
        useState: function() {
            return $0(D8);
        },
        useDebugValue: kn,
        useDeferredValue: function(n) {
            var l = q4();
            return C1 === null ? l.memoizedState = n : G4(l, C1.memoizedState, n);
        },
        useTransition: function() {
            var n = $0(D8)[0], l = q4().memoizedState;
            return [
                n,
                l
            ];
        },
        useMutableSource: vn,
        useSyncExternalStore: gn,
        useId: O3,
        unstable_isNewReconciler: !1
    };
    function Z9(n, l) {
        try {
            var f = "", m = l;
            do f += a3(m), m = m.return;
            while (m);
            var b = f;
        } catch (H) {
            b = `
Error generating stack: ` + H.message + `
` + H.stack;
        }
        return {
            value: n,
            source: l,
            stack: b,
            digest: null
        };
    }
    function Q0(n, l, f) {
        return {
            value: n,
            source: null,
            stack: f ?? null,
            digest: l ?? null
        };
    }
    function Rn(n, l) {
        try {
            console.error(l.value);
        } catch (f) {
            setTimeout(function() {
                throw f;
            });
        }
    }
    var Jc = typeof WeakMap == "function" ? WeakMap : Map;
    function Bl(n, l, f) {
        f = G6(-1, f), f.tag = 3, f.payload = {
            element: null
        };
        var m = l.value;
        return f.callback = function() {
            An || (An = !0, F8 = m), Rn(n, l);
        }, f;
    }
    function q0(n, l, f) {
        f = G6(-1, f), f.tag = 3;
        var m = n.type.getDerivedStateFromError;
        if (typeof m == "function") {
            var b = l.value;
            f.payload = function() {
                return m(b);
            }, f.callback = function() {
                Rn(n, l);
            };
        }
        var H = n.stateNode;
        return H !== null && typeof H.componentDidCatch == "function" && (f.callback = function() {
            Rn(n, l), typeof m != "function" && (y6 === null ? y6 = /* @__PURE__ */ new Set([
                this
            ]) : y6.add(this));
            var T = l.stack;
            this.componentDidCatch(l.value, {
                componentStack: T !== null ? T : ""
            });
        }), f;
    }
    function Fl(n, l, f) {
        var m = n.pingCache;
        if (m === null) {
            m = n.pingCache = new Jc();
            var b = /* @__PURE__ */ new Set();
            m.set(l, b);
        } else b = m.get(l), b === void 0 && (b = /* @__PURE__ */ new Set(), m.set(l, b));
        b.has(f) || (b.add(f), n = od.bind(null, n, l, f), l.then(n, n));
    }
    function qa(n) {
        do {
            var l;
            if ((l = n.tag === 13) && (l = n.memoizedState, l = l !== null ? l.dehydrated !== null : !0), l) return n;
            n = n.return;
        }while (n !== null);
        return null;
    }
    function Ga(n, l, f, m, b) {
        return n.mode & 1 ? (n.flags |= 65536, n.lanes = b, n) : (n === l ? n.flags |= 65536 : (n.flags |= 128, f.flags |= 131072, f.flags &= -52805, f.tag === 1 && (f.alternate === null ? f.tag = 17 : (l = G6(-1, 1), l.tag = 2, F7(f, l, 1))), f.lanes |= 1), n);
    }
    var ed = $.ReactCurrentOwner, Ve = !1;
    function De(n, l, f, m) {
        l.child = n === null ? Nl(l, null, f, m) : k9(l, n.child, f, m);
    }
    function I7(n, l, f, m, b) {
        f = f.render;
        var H = l.ref;
        return Z1(l, b), m = z7(n, l, f, m, H, b), f = _8(), n !== null && !Ve ? (l.updateQueue = n.updateQueue, l.flags &= -2053, n.lanes &= ~b, e4(n, l, b)) : ($3 && f && an(l), l.flags |= 1, De(n, l, m, b), l.child);
    }
    function Zn(n, l, f, m, b) {
        if (n === null) {
            var H = f.type;
            return typeof H == "function" && !hi(H) && H.defaultProps === void 0 && f.compare === null && f.defaultProps === void 0 ? (l.tag = 15, l.type = H, X4(n, l, H, m, b)) : (n = Yn(f.type, null, m, l, l.mode, b), n.ref = l.ref, n.return = l, l.child = n);
        }
        if (H = n.child, !(n.lanes & b)) {
            var T = H.memoizedProps;
            if (f = f.compare, f = f !== null ? f : T0, f(T, m) && n.ref === l.ref) return e4(n, l, b);
        }
        return l.flags |= 1, n = Q7(H, m), n.ref = l.ref, n.return = l, l.child = n;
    }
    function X4(n, l, f, m, b) {
        if (n !== null) {
            var H = n.memoizedProps;
            if (T0(H, m) && n.ref === l.ref) {
                if (Ve = !1, l.pendingProps = m = H, (n.lanes & b) !== 0) n.flags & 131072 && (Ve = !0);
                else return l.lanes = n.lanes, e4(n, l, b);
            }
        }
        return O9(n, l, f, m, b);
    }
    function O8(n, l, f) {
        var m = l.pendingProps, b = m.children, H = n !== null ? n.memoizedState : null;
        if (m.mode === "hidden") {
            if (!(l.mode & 1)) l.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            }, H3(j9, C5), C5 |= f;
            else {
                if (!(f & 1073741824)) return n = H !== null ? H.baseLanes | f : f, l.lanes = l.childLanes = 1073741824, l.memoizedState = {
                    baseLanes: n,
                    cachePool: null,
                    transitions: null
                }, l.updateQueue = null, H3(j9, C5), C5 |= n, null;
                l.memoizedState = {
                    baseLanes: 0,
                    cachePool: null,
                    transitions: null
                }, m = H !== null ? H.baseLanes : f, H3(j9, C5), C5 |= m;
            }
        } else H !== null ? (m = H.baseLanes | f, l.memoizedState = null) : m = f, H3(j9, C5), C5 |= m;
        return De(n, l, b, f), l.child;
    }
    function O2(n, l) {
        var f = l.ref;
        (n === null && f !== null || n !== null && n.ref !== f) && (l.flags |= 512, l.flags |= 2097152);
    }
    function O9(n, l, f, m, b) {
        var H = X3(f) ? I4 : V2.current;
        return H = V5(l, H), Z1(l, b), f = z7(n, l, f, m, H, b), m = _8(), n !== null && !Ve ? (l.updateQueue = n.updateQueue, l.flags &= -2053, n.lanes &= ~b, e4(n, l, b)) : ($3 && m && an(l), l.flags |= 1, De(n, l, f, b), l.child);
    }
    function Xa(n, l, f, m, b) {
        if (X3(f)) {
            var H = !0;
            rn(l);
        } else H = !1;
        if (Z1(l, b), l.stateNode === null) v4(n, l), Dl(l, f, m), fn(l, f, m, b), m = !0;
        else if (n === null) {
            var T = l.stateNode, F = l.memoizedProps;
            T.props = F;
            var Y = T.context, o1 = f.contextType;
            typeof o1 == "object" && o1 !== null ? o1 = ge(o1) : (o1 = X3(f) ? I4 : V2.current, o1 = V5(l, o1));
            var b1 = f.getDerivedStateFromProps, x1 = typeof b1 == "function" || typeof T.getSnapshotBeforeUpdate == "function";
            x1 || typeof T.UNSAFE_componentWillReceiveProps != "function" && typeof T.componentWillReceiveProps != "function" || (F !== m || Y !== o1) && Rl(l, T, m, o1), B7 = !1;
            var y1 = l.memoizedState;
            T.state = y1, A7(l, m, T, b), Y = l.memoizedState, F !== m || y1 !== Y || de.current || B7 ? (typeof b1 == "function" && (Ia(l, f, b1, m), Y = l.memoizedState), (F = B7 || _l(l, f, F, m, y1, Y, o1)) ? (x1 || typeof T.UNSAFE_componentWillMount != "function" && typeof T.componentWillMount != "function" || (typeof T.componentWillMount == "function" && T.componentWillMount(), typeof T.UNSAFE_componentWillMount == "function" && T.UNSAFE_componentWillMount()), typeof T.componentDidMount == "function" && (l.flags |= 4194308)) : (typeof T.componentDidMount == "function" && (l.flags |= 4194308), l.memoizedProps = m, l.memoizedState = Y), T.props = m, T.state = Y, T.context = o1, m = F) : (typeof T.componentDidMount == "function" && (l.flags |= 4194308), m = !1);
        } else {
            T = l.stateNode, _e(n, l), F = l.memoizedProps, o1 = l.type === l.elementType ? F : c5(l.type, F), T.props = o1, x1 = l.pendingProps, y1 = T.context, Y = f.contextType, typeof Y == "object" && Y !== null ? Y = ge(Y) : (Y = X3(f) ? I4 : V2.current, Y = V5(l, Y));
            var z1 = f.getDerivedStateFromProps;
            (b1 = typeof z1 == "function" || typeof T.getSnapshotBeforeUpdate == "function") || typeof T.UNSAFE_componentWillReceiveProps != "function" && typeof T.componentWillReceiveProps != "function" || (F !== x1 || y1 !== Y) && Rl(l, T, m, Y), B7 = !1, y1 = l.memoizedState, T.state = y1, A7(l, m, T, b);
            var t2 = l.memoizedState;
            F !== x1 || y1 !== t2 || de.current || B7 ? (typeof z1 == "function" && (Ia(l, f, z1, m), t2 = l.memoizedState), (o1 = B7 || _l(l, f, o1, m, y1, t2, Y) || !1) ? (b1 || typeof T.UNSAFE_componentWillUpdate != "function" && typeof T.componentWillUpdate != "function" || (typeof T.componentWillUpdate == "function" && T.componentWillUpdate(m, t2, Y), typeof T.UNSAFE_componentWillUpdate == "function" && T.UNSAFE_componentWillUpdate(m, t2, Y)), typeof T.componentDidUpdate == "function" && (l.flags |= 4), typeof T.getSnapshotBeforeUpdate == "function" && (l.flags |= 1024)) : (typeof T.componentDidUpdate != "function" || F === n.memoizedProps && y1 === n.memoizedState || (l.flags |= 4), typeof T.getSnapshotBeforeUpdate != "function" || F === n.memoizedProps && y1 === n.memoizedState || (l.flags |= 1024), l.memoizedProps = m, l.memoizedState = t2), T.props = m, T.state = t2, T.context = Y, m = o1) : (typeof T.componentDidUpdate != "function" || F === n.memoizedProps && y1 === n.memoizedState || (l.flags |= 4), typeof T.getSnapshotBeforeUpdate != "function" || F === n.memoizedProps && y1 === n.memoizedState || (l.flags |= 1024), m = !1);
        }
        return Al(n, l, f, m, H, b);
    }
    function Al(n, l, f, m, b, H) {
        O2(n, l);
        var T = (l.flags & 128) !== 0;
        if (!m && !T) return b && Vl(l, f, !1), e4(n, l, H);
        m = l.stateNode, ed.current = l;
        var F = T && typeof f.getDerivedStateFromError != "function" ? null : m.render();
        return l.flags |= 1, n !== null && T ? (l.child = k9(l, n.child, null, H), l.child = k9(l, null, F, H)) : De(n, l, F, H), l.memoizedState = m.state, b && Vl(l, f, !0), l.child;
    }
    function jl(n) {
        var l = n.stateNode;
        l.pendingContext ? Z7(n, l.pendingContext, l.pendingContext !== l.context) : l.context && Z7(n, l.context, !1), $a(n, l.containerInfo);
    }
    function On(n, l, f, m, b) {
        return re(), Ba(b), l.flags |= 256, De(n, l, f, m), l.child;
    }
    var N8 = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
    };
    function Ka(n) {
        return {
            baseLanes: n,
            cachePool: null,
            transitions: null
        };
    }
    function Ja(n, l, f) {
        var m = l.pendingProps, b = L2.current, H = !1, T = (l.flags & 128) !== 0, F;
        if ((F = T) || (F = n !== null && n.memoizedState === null ? !1 : (b & 2) !== 0), F ? (H = !0, l.flags &= -129) : (n === null || n.memoizedState !== null) && (b |= 1), H3(L2, b & 1), n === null) return ln(l), n = l.memoizedState, n !== null && (n = n.dehydrated, n !== null) ? (l.mode & 1 ? n.data === "$!" ? l.lanes = 8 : l.lanes = 1073741824 : l.lanes = 1, null) : (T = m.children, n = m.fallback, H ? (m = l.mode, H = l.child, T = {
            mode: "hidden",
            children: T
        }, !(m & 1) && H !== null ? (H.childLanes = 0, H.pendingProps = T) : H = it(T, m, 0, null), n = I8(n, m, f, null), H.return = l, n.return = l, H.sibling = n, l.child = H, l.child.memoizedState = Ka(f), l.memoizedState = N8, n) : ei(l, T));
        if (b = n.memoizedState, b !== null && (F = b.dehydrated, F !== null)) return td(n, l, T, m, F, b, f);
        if (H) {
            H = m.fallback, T = l.mode, b = n.child, F = b.sibling;
            var Y = {
                mode: "hidden",
                children: m.children
            };
            return !(T & 1) && l.child !== b ? (m = l.child, m.childLanes = 0, m.pendingProps = Y, l.deletions = null) : (m = Q7(b, Y), m.subtreeFlags = b.subtreeFlags & 14680064), F !== null ? H = Q7(F, H) : (H = I8(H, T, f, null), H.flags |= 2), H.return = l, m.return = l, m.sibling = H, l.child = m, m = H, H = l.child, T = n.child.memoizedState, T = T === null ? Ka(f) : {
                baseLanes: T.baseLanes | f,
                cachePool: null,
                transitions: T.transitions
            }, H.memoizedState = T, H.childLanes = n.childLanes & ~f, l.memoizedState = N8, m;
        }
        return H = n.child, n = H.sibling, m = Q7(H, {
            mode: "visible",
            children: m.children
        }), !(l.mode & 1) && (m.lanes = f), m.return = l, m.sibling = null, n !== null && (f = l.deletions, f === null ? (l.deletions = [
            n
        ], l.flags |= 16) : f.push(n)), l.child = m, l.memoizedState = null, m;
    }
    function ei(n, l) {
        return l = it({
            mode: "visible",
            children: l
        }, n.mode, 0, null), l.return = n, n.child = l;
    }
    function N9(n, l, f, m) {
        return m !== null && Ba(m), k9(l, n.child, null, f), n = ei(l, l.pendingProps.children), n.flags |= 2, l.memoizedState = null, n;
    }
    function td(n, l, f, m, b, H, T) {
        if (f) return l.flags & 256 ? (l.flags &= -257, m = Q0(Error(o(422))), N9(n, l, T, m)) : l.memoizedState !== null ? (l.child = n.child, l.flags |= 128, null) : (H = m.fallback, b = l.mode, m = it({
            mode: "visible",
            children: m.children
        }, b, 0, null), H = I8(H, b, T, null), H.flags |= 2, m.return = l, H.return = l, m.sibling = H, l.child = m, l.mode & 1 && k9(l, n.child, null, T), l.child.memoizedState = Ka(T), l.memoizedState = N8, H);
        if (!(l.mode & 1)) return N9(n, l, T, null);
        if (b.data === "$!") {
            if (m = b.nextSibling && b.nextSibling.dataset, m) var F = m.dgst;
            return m = F, H = Error(o(419)), m = Q0(H, m, void 0), N9(n, l, T, m);
        }
        if (F = (T & n.childLanes) !== 0, Ve || F) {
            if (m = ie, m !== null) {
                switch(T & -T){
                    case 4:
                        b = 2;
                        break;
                    case 16:
                        b = 8;
                        break;
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                        b = 32;
                        break;
                    case 536870912:
                        b = 268435456;
                        break;
                    default:
                        b = 0;
                }
                b = b & (m.suspendedLanes | T) ? 0 : b, b !== 0 && b !== H.retryLane && (H.retryLane = b, q6(n, b), b4(m, n, b, -1));
            }
            return Ci(), m = Q0(Error(o(421))), N9(n, l, T, m);
        }
        return b.data === "$?" ? (l.flags |= 128, l.child = n.child, l = ld.bind(null, n), b._reactRetry = l, null) : (n = H.treeContext, Q4 = q5(b.nextSibling), u5 = l, $3 = !0, S5 = null, n !== null && (W4[m4++] = Ke, W4[m4++] = Q6, W4[m4++] = E5, Ke = n.id, Q6 = n.overflow, E5 = l), l = ei(l, m.children), l.flags |= 4096, l);
    }
    function ti(n, l, f) {
        n.lanes |= l;
        var m = n.alternate;
        m !== null && (m.lanes |= l), Ie(n.return, l, f);
    }
    function Nn(n, l, f, m, b) {
        var H = n.memoizedState;
        H === null ? n.memoizedState = {
            isBackwards: l,
            rendering: null,
            renderingStartTime: 0,
            last: m,
            tail: f,
            tailMode: b
        } : (H.isBackwards = l, H.rendering = null, H.renderingStartTime = 0, H.last = m, H.tail = f, H.tailMode = b);
    }
    function ni(n, l, f) {
        var m = l.pendingProps, b = m.revealOrder, H = m.tail;
        if (De(n, l, m.children, f), m = L2.current, m & 2) m = m & 1 | 2, l.flags |= 128;
        else {
            if (n !== null && n.flags & 128) e: for(n = l.child; n !== null;){
                if (n.tag === 13) n.memoizedState !== null && ti(n, f, l);
                else if (n.tag === 19) ti(n, f, l);
                else if (n.child !== null) {
                    n.child.return = n, n = n.child;
                    continue;
                }
                if (n === l) break e;
                for(; n.sibling === null;){
                    if (n.return === null || n.return === l) break e;
                    n = n.return;
                }
                n.sibling.return = n.return, n = n.sibling;
            }
            m &= 1;
        }
        if (H3(L2, m), !(l.mode & 1)) l.memoizedState = null;
        else switch(b){
            case "forwards":
                for(f = l.child, b = null; f !== null;)n = f.alternate, n !== null && ae(n) === null && (b = f), f = f.sibling;
                f = b, f === null ? (b = l.child, l.child = null) : (b = f.sibling, f.sibling = null), Nn(l, !1, b, f, H);
                break;
            case "backwards":
                for(f = null, b = l.child, l.child = null; b !== null;){
                    if (n = b.alternate, n !== null && ae(n) === null) {
                        l.child = b;
                        break;
                    }
                    n = b.sibling, b.sibling = f, f = b, b = n;
                }
                Nn(l, !0, f, null, H);
                break;
            case "together":
                Nn(l, !1, null, null, void 0);
                break;
            default:
                l.memoizedState = null;
        }
        return l.child;
    }
    function v4(n, l) {
        !(l.mode & 1) && n !== null && (n.alternate = null, l.alternate = null, l.flags |= 2);
    }
    function e4(n, l, f) {
        if (n !== null && (l.dependencies = n.dependencies), e7 |= l.lanes, !(f & l.childLanes)) return null;
        if (n !== null && l.child !== n.child) throw Error(o(153));
        if (l.child !== null) {
            for(n = l.child, f = Q7(n, n.pendingProps), l.child = f, f.return = l; n.sibling !== null;)n = n.sibling, f = f.sibling = Q7(n, n.pendingProps), f.return = l;
            f.sibling = null;
        }
        return l.child;
    }
    function K6(n, l, f) {
        switch(l.tag){
            case 3:
                jl(l), re();
                break;
            case 5:
                y2(l);
                break;
            case 1:
                X3(l.type) && rn(l);
                break;
            case 4:
                $a(l, l.stateNode.containerInfo);
                break;
            case 10:
                var m = l.type._context, b = l.memoizedProps.value;
                H3(h6, m._currentValue), m._currentValue = b;
                break;
            case 13:
                if (m = l.memoizedState, m !== null) return m.dehydrated !== null ? (H3(L2, L2.current & 1), l.flags |= 128, null) : f & l.child.childLanes ? Ja(n, l, f) : (H3(L2, L2.current & 1), n = e4(n, l, f), n !== null ? n.sibling : null);
                H3(L2, L2.current & 1);
                break;
            case 19:
                if (m = (f & l.childLanes) !== 0, n.flags & 128) {
                    if (m) return ni(n, l, f);
                    l.flags |= 128;
                }
                if (b = l.memoizedState, b !== null && (b.rendering = null, b.tail = null, b.lastEffect = null), H3(L2, L2.current), m) break;
                return null;
            case 22:
            case 23:
                return l.lanes = 0, O8(n, l, f);
        }
        return e4(n, l, f);
    }
    var G0, P8, _5, Re;
    G0 = function(n, l) {
        for(var f = l.child; f !== null;){
            if (f.tag === 5 || f.tag === 6) n.appendChild(f.stateNode);
            else if (f.tag !== 4 && f.child !== null) {
                f.child.return = f, f = f.child;
                continue;
            }
            if (f === l) break;
            for(; f.sibling === null;){
                if (f.return === null || f.return === l) return;
                f = f.return;
            }
            f.sibling.return = f.return, f = f.sibling;
        }
    }, P8 = function() {}, _5 = function(n, l, f, m) {
        var b = n.memoizedProps;
        if (b !== m) {
            n = l.stateNode, E8(G5.current);
            var H = null;
            switch(f){
                case "input":
                    b = T1(n, b), m = T1(n, m), H = [];
                    break;
                case "select":
                    b = g1({}, b, {
                        value: void 0
                    }), m = g1({}, m, {
                        value: void 0
                    }), H = [];
                    break;
                case "textarea":
                    b = me(n, b), m = me(n, m), H = [];
                    break;
                default:
                    typeof b.onClick != "function" && typeof m.onClick == "function" && (n.onclick = nn);
            }
            te(f, m);
            var T;
            f = null;
            for(o1 in b)if (!m.hasOwnProperty(o1) && b.hasOwnProperty(o1) && b[o1] != null) {
                if (o1 === "style") {
                    var F = b[o1];
                    for(T in F)F.hasOwnProperty(T) && (f || (f = {}), f[T] = "");
                } else o1 !== "dangerouslySetInnerHTML" && o1 !== "children" && o1 !== "suppressContentEditableWarning" && o1 !== "suppressHydrationWarning" && o1 !== "autoFocus" && (i.hasOwnProperty(o1) ? H || (H = []) : (H = H || []).push(o1, null));
            }
            for(o1 in m){
                var Y = m[o1];
                if (F = b != null ? b[o1] : void 0, m.hasOwnProperty(o1) && Y !== F && (Y != null || F != null)) {
                    if (o1 === "style") {
                        if (F) {
                            for(T in F)!F.hasOwnProperty(T) || Y && Y.hasOwnProperty(T) || (f || (f = {}), f[T] = "");
                            for(T in Y)Y.hasOwnProperty(T) && F[T] !== Y[T] && (f || (f = {}), f[T] = Y[T]);
                        } else f || (H || (H = []), H.push(o1, f)), f = Y;
                    } else o1 === "dangerouslySetInnerHTML" ? (Y = Y ? Y.__html : void 0, F = F ? F.__html : void 0, Y != null && F !== Y && (H = H || []).push(o1, Y)) : o1 === "children" ? typeof Y != "string" && typeof Y != "number" || (H = H || []).push(o1, "" + Y) : o1 !== "suppressContentEditableWarning" && o1 !== "suppressHydrationWarning" && (i.hasOwnProperty(o1) ? (Y != null && o1 === "onScroll" && Z3("scroll", n), H || F === Y || (H = [])) : (H = H || []).push(o1, Y));
                }
            }
            f && (H = H || []).push("style", f);
            var o1 = H;
            (l.updateQueue = o1) && (l.flags |= 4);
        }
    }, Re = function(n, l, f, m) {
        f !== m && (l.flags |= 4);
    };
    function X0(n, l) {
        if (!$3) switch(n.tailMode){
            case "hidden":
                l = n.tail;
                for(var f = null; l !== null;)l.alternate !== null && (f = l), l = l.sibling;
                f === null ? n.tail = null : f.sibling = null;
                break;
            case "collapsed":
                f = n.tail;
                for(var m = null; f !== null;)f.alternate !== null && (m = f), f = f.sibling;
                m === null ? l || n.tail === null ? n.tail = null : n.tail.sibling = null : m.sibling = null;
        }
    }
    function g4(n) {
        var l = n.alternate !== null && n.alternate.child === n.child, f = 0, m = 0;
        if (l) for(var b = n.child; b !== null;)f |= b.lanes | b.childLanes, m |= b.subtreeFlags & 14680064, m |= b.flags & 14680064, b.return = n, b = b.sibling;
        else for(b = n.child; b !== null;)f |= b.lanes | b.childLanes, m |= b.subtreeFlags, m |= b.flags, b.return = n, b = b.sibling;
        return n.subtreeFlags |= m, n.childLanes = f, l;
    }
    function nd(n, l, f) {
        var m = l.pendingProps;
        switch(Na(l), l.tag){
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return g4(l), null;
            case 1:
                return X3(l.type) && M5(), g4(l), null;
            case 3:
                return m = l.stateNode, j7(), y3(de), y3(V2), hn(), m.pendingContext && (m.context = m.pendingContext, m.pendingContext = null), (n === null || n.child === null) && (sn(l) ? l.flags |= 4 : n === null || n.memoizedState.isDehydrated && !(l.flags & 256) || (l.flags |= 1024, S5 !== null && (at(S5), S5 = null))), P8(n, l), g4(l), null;
            case 5:
                U2(l);
                var b = E8(T9.current);
                if (f = l.type, n !== null && l.stateNode != null) _5(n, l, f, m, b), n.ref !== l.ref && (l.flags |= 512, l.flags |= 2097152);
                else {
                    if (!m) {
                        if (l.stateNode === null) throw Error(o(166));
                        return g4(l), null;
                    }
                    if (n = E8(G5.current), sn(l)) {
                        m = l.stateNode, f = l.type;
                        var H = l.memoizedProps;
                        switch(m[f6] = l, m[x8] = H, n = (l.mode & 1) !== 0, f){
                            case "dialog":
                                Z3("cancel", m), Z3("close", m);
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                Z3("load", m);
                                break;
                            case "video":
                            case "audio":
                                for(b = 0; b < Z0.length; b++)Z3(Z0[b], m);
                                break;
                            case "source":
                                Z3("error", m);
                                break;
                            case "img":
                            case "image":
                            case "link":
                                Z3("error", m), Z3("load", m);
                                break;
                            case "details":
                                Z3("toggle", m);
                                break;
                            case "input":
                                j1(m, H), Z3("invalid", m);
                                break;
                            case "select":
                                m._wrapperState = {
                                    wasMultiple: !!H.multiple
                                }, Z3("invalid", m);
                                break;
                            case "textarea":
                                D2(m, H), Z3("invalid", m);
                        }
                        te(f, H), b = null;
                        for(var T in H)if (H.hasOwnProperty(T)) {
                            var F = H[T];
                            T === "children" ? typeof F == "string" ? m.textContent !== F && (H.suppressHydrationWarning !== !0 && tn(m.textContent, F, n), b = [
                                "children",
                                F
                            ]) : typeof F == "number" && m.textContent !== "" + F && (H.suppressHydrationWarning !== !0 && tn(m.textContent, F, n), b = [
                                "children",
                                "" + F
                            ]) : i.hasOwnProperty(T) && F != null && T === "onScroll" && Z3("scroll", m);
                        }
                        switch(f){
                            case "input":
                                G2(m), R3(m, H, !0);
                                break;
                            case "textarea":
                                G2(m), se(m);
                                break;
                            case "select":
                            case "option":
                                break;
                            default:
                                typeof H.onClick == "function" && (m.onclick = nn);
                        }
                        m = b, l.updateQueue = m, m !== null && (l.flags |= 4);
                    } else {
                        T = b.nodeType === 9 ? b : b.ownerDocument, n === "http://www.w3.org/1999/xhtml" && (n = c4(f)), n === "http://www.w3.org/1999/xhtml" ? f === "script" ? (n = T.createElement("div"), n.innerHTML = "<script></script>", n = n.removeChild(n.firstChild)) : typeof m.is == "string" ? n = T.createElement(f, {
                            is: m.is
                        }) : (n = T.createElement(f), f === "select" && (T = n, m.multiple ? T.multiple = !0 : m.size && (T.size = m.size))) : n = T.createElementNS(n, f), n[f6] = l, n[x8] = m, G0(n, l, !1, !1), l.stateNode = n;
                        e: {
                            switch(T = ne(f, m), f){
                                case "dialog":
                                    Z3("cancel", n), Z3("close", n), b = m;
                                    break;
                                case "iframe":
                                case "object":
                                case "embed":
                                    Z3("load", n), b = m;
                                    break;
                                case "video":
                                case "audio":
                                    for(b = 0; b < Z0.length; b++)Z3(Z0[b], n);
                                    b = m;
                                    break;
                                case "source":
                                    Z3("error", n), b = m;
                                    break;
                                case "img":
                                case "image":
                                case "link":
                                    Z3("error", n), Z3("load", n), b = m;
                                    break;
                                case "details":
                                    Z3("toggle", n), b = m;
                                    break;
                                case "input":
                                    j1(n, m), b = T1(n, m), Z3("invalid", n);
                                    break;
                                case "option":
                                    b = m;
                                    break;
                                case "select":
                                    n._wrapperState = {
                                        wasMultiple: !!m.multiple
                                    }, b = g1({}, m, {
                                        value: void 0
                                    }), Z3("invalid", n);
                                    break;
                                case "textarea":
                                    D2(n, m), b = me(n, m), Z3("invalid", n);
                                    break;
                                default:
                                    b = m;
                            }
                            te(f, b), F = b;
                            for(H in F)if (F.hasOwnProperty(H)) {
                                var Y = F[H];
                                H === "style" ? m3(n, Y) : H === "dangerouslySetInnerHTML" ? (Y = Y ? Y.__html : void 0, Y != null && Y5(n, Y)) : H === "children" ? typeof Y == "string" ? (f !== "textarea" || Y !== "") && F4(n, Y) : typeof Y == "number" && F4(n, "" + Y) : H !== "suppressContentEditableWarning" && H !== "suppressHydrationWarning" && H !== "autoFocus" && (i.hasOwnProperty(H) ? Y != null && H === "onScroll" && Z3("scroll", n) : Y != null && P(n, H, Y, T));
                            }
                            switch(f){
                                case "input":
                                    G2(n), R3(n, m, !1);
                                    break;
                                case "textarea":
                                    G2(n), se(n);
                                    break;
                                case "option":
                                    m.value != null && n.setAttribute("value", "" + u2(m.value));
                                    break;
                                case "select":
                                    n.multiple = !!m.multiple, H = m.value, H != null ? ee(n, !!m.multiple, H, !1) : m.defaultValue != null && ee(n, !!m.multiple, m.defaultValue, !0);
                                    break;
                                default:
                                    typeof b.onClick == "function" && (n.onclick = nn);
                            }
                            switch(f){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    m = !!m.autoFocus;
                                    break e;
                                case "img":
                                    m = !0;
                                    break e;
                                default:
                                    m = !1;
                            }
                        }
                        m && (l.flags |= 4);
                    }
                    l.ref !== null && (l.flags |= 512, l.flags |= 2097152);
                }
                return g4(l), null;
            case 6:
                if (n && l.stateNode != null) Re(n, l, n.memoizedProps, m);
                else {
                    if (typeof m != "string" && l.stateNode === null) throw Error(o(166));
                    if (f = E8(T9.current), E8(G5.current), sn(l)) {
                        if (m = l.stateNode, f = l.memoizedProps, m[f6] = l, (H = m.nodeValue !== f) && (n = u5, n !== null)) switch(n.tag){
                            case 3:
                                tn(m.nodeValue, f, (n.mode & 1) !== 0);
                                break;
                            case 5:
                                n.memoizedProps.suppressHydrationWarning !== !0 && tn(m.nodeValue, f, (n.mode & 1) !== 0);
                        }
                        H && (l.flags |= 4);
                    } else m = (f.nodeType === 9 ? f : f.ownerDocument).createTextNode(m), m[f6] = l, l.stateNode = m;
                }
                return g4(l), null;
            case 13:
                if (y3(L2), m = l.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
                    if ($3 && Q4 !== null && l.mode & 1 && !(l.flags & 128)) Sl(), re(), l.flags |= 98560, H = !1;
                    else if (H = sn(l), m !== null && m.dehydrated !== null) {
                        if (n === null) {
                            if (!H) throw Error(o(318));
                            if (H = l.memoizedState, H = H !== null ? H.dehydrated : null, !H) throw Error(o(317));
                            H[f6] = l;
                        } else re(), !(l.flags & 128) && (l.memoizedState = null), l.flags |= 4;
                        g4(l), H = !1;
                    } else S5 !== null && (at(S5), S5 = null), H = !0;
                    if (!H) return l.flags & 65536 ? l : null;
                }
                return l.flags & 128 ? (l.lanes = f, l) : (m = m !== null, m !== (n !== null && n.memoizedState !== null) && m && (l.child.flags |= 8192, l.mode & 1 && (n === null || L2.current & 1 ? Oe === 0 && (Oe = 3) : Ci())), l.updateQueue !== null && (l.flags |= 4), g4(l), null);
            case 4:
                return j7(), P8(n, l), n === null && V9(l.stateNode.containerInfo), g4(l), null;
            case 10:
                return P7(l.type._context), g4(l), null;
            case 17:
                return X3(l.type) && M5(), g4(l), null;
            case 19:
                if (y3(L2), H = l.memoizedState, H === null) return g4(l), null;
                if (m = (l.flags & 128) !== 0, T = H.rendering, T === null) {
                    if (m) X0(H, !1);
                    else {
                        if (Oe !== 0 || n !== null && n.flags & 128) for(n = l.child; n !== null;){
                            if (T = ae(n), T !== null) {
                                for(l.flags |= 128, X0(H, !1), m = T.updateQueue, m !== null && (l.updateQueue = m, l.flags |= 4), l.subtreeFlags = 0, m = f, f = l.child; f !== null;)H = f, n = m, H.flags &= 14680066, T = H.alternate, T === null ? (H.childLanes = 0, H.lanes = n, H.child = null, H.subtreeFlags = 0, H.memoizedProps = null, H.memoizedState = null, H.updateQueue = null, H.dependencies = null, H.stateNode = null) : (H.childLanes = T.childLanes, H.lanes = T.lanes, H.child = T.child, H.subtreeFlags = 0, H.deletions = null, H.memoizedProps = T.memoizedProps, H.memoizedState = T.memoizedState, H.updateQueue = T.updateQueue, H.type = T.type, n = T.dependencies, H.dependencies = n === null ? null : {
                                    lanes: n.lanes,
                                    firstContext: n.firstContext
                                }), f = f.sibling;
                                return H3(L2, L2.current & 1 | 2), l.child;
                            }
                            n = n.sibling;
                        }
                        H.tail !== null && X2() > U9 && (l.flags |= 128, m = !0, X0(H, !1), l.lanes = 4194304);
                    }
                } else {
                    if (!m) {
                        if (n = ae(T), n !== null) {
                            if (l.flags |= 128, m = !0, f = n.updateQueue, f !== null && (l.updateQueue = f, l.flags |= 4), X0(H, !0), H.tail === null && H.tailMode === "hidden" && !T.alternate && !$3) return g4(l), null;
                        } else 2 * X2() - H.renderingStartTime > U9 && f !== 1073741824 && (l.flags |= 128, m = !0, X0(H, !1), l.lanes = 4194304);
                    }
                    H.isBackwards ? (T.sibling = l.child, l.child = T) : (f = H.last, f !== null ? f.sibling = T : l.child = T, H.last = T);
                }
                return H.tail !== null ? (l = H.tail, H.rendering = l, H.tail = l.sibling, H.renderingStartTime = X2(), l.sibling = null, f = L2.current, H3(L2, m ? f & 1 | 2 : f & 1), l) : (g4(l), null);
            case 22:
            case 23:
                return di(), m = l.memoizedState !== null, n !== null && n.memoizedState !== null !== m && (l.flags |= 8192), m && l.mode & 1 ? C5 & 1073741824 && (g4(l), l.subtreeFlags & 6 && (l.flags |= 8192)) : g4(l), null;
            case 24:
                return null;
            case 25:
                return null;
        }
        throw Error(o(156, l.tag));
    }
    function ri(n, l) {
        switch(Na(l), l.tag){
            case 1:
                return X3(l.type) && M5(), n = l.flags, n & 65536 ? (l.flags = n & -65537 | 128, l) : null;
            case 3:
                return j7(), y3(de), y3(V2), hn(), n = l.flags, n & 65536 && !(n & 128) ? (l.flags = n & -65537 | 128, l) : null;
            case 5:
                return U2(l), null;
            case 13:
                if (y3(L2), n = l.memoizedState, n !== null && n.dehydrated !== null) {
                    if (l.alternate === null) throw Error(o(340));
                    re();
                }
                return n = l.flags, n & 65536 ? (l.flags = n & -65537 | 128, l) : null;
            case 19:
                return y3(L2), null;
            case 4:
                return j7(), null;
            case 10:
                return P7(l.type._context), null;
            case 22:
            case 23:
                return di(), null;
            case 24:
                return null;
            default:
                return null;
        }
    }
    var K0 = !1, Ze = !1, zl = typeof WeakSet == "function" ? WeakSet : Set, J1 = null;
    function P9(n, l) {
        var f = n.ref;
        if (f !== null) {
            if (typeof f == "function") try {
                f(null);
            } catch (m) {
                fe(n, l, m);
            }
            else f.current = null;
        }
    }
    function J0(n, l, f) {
        try {
            f();
        } catch (m) {
            fe(n, l, m);
        }
    }
    var Ul = !1;
    function Il(n, l) {
        if (Sa = N, n = Gt(), I6(n)) {
            if ("selectionStart" in n) var f = {
                start: n.selectionStart,
                end: n.selectionEnd
            };
            else e: {
                f = (f = n.ownerDocument) && f.defaultView || window;
                var m = f.getSelection && f.getSelection();
                if (m && m.rangeCount !== 0) {
                    f = m.anchorNode;
                    var b = m.anchorOffset, H = m.focusNode;
                    m = m.focusOffset;
                    try {
                        f.nodeType, H.nodeType;
                    } catch  {
                        f = null;
                        break e;
                    }
                    var T = 0, F = -1, Y = -1, o1 = 0, b1 = 0, x1 = n, y1 = null;
                    t: for(;;){
                        for(var z1; x1 !== f || b !== 0 && x1.nodeType !== 3 || (F = T + b), x1 !== H || m !== 0 && x1.nodeType !== 3 || (Y = T + m), x1.nodeType === 3 && (T += x1.nodeValue.length), (z1 = x1.firstChild) !== null;)y1 = x1, x1 = z1;
                        for(;;){
                            if (x1 === n) break t;
                            if (y1 === f && ++o1 === b && (F = T), y1 === H && ++b1 === m && (Y = T), (z1 = x1.nextSibling) !== null) break;
                            x1 = y1, y1 = x1.parentNode;
                        }
                        x1 = z1;
                    }
                    f = F === -1 || Y === -1 ? null : {
                        start: F,
                        end: Y
                    };
                } else f = null;
            }
            f = f || {
                start: 0,
                end: 0
            };
        } else f = null;
        for(w8 = {
            focusedElem: n,
            selectionRange: f
        }, N = !1, J1 = l; J1 !== null;)if (l = J1, n = l.child, (l.subtreeFlags & 1028) !== 0 && n !== null) n.return = l, J1 = n;
        else for(; J1 !== null;){
            l = J1;
            try {
                var t2 = l.alternate;
                if (l.flags & 1024) switch(l.tag){
                    case 0:
                    case 11:
                    case 15:
                        break;
                    case 1:
                        if (t2 !== null) {
                            var i2 = t2.memoizedProps, ye = t2.memoizedState, e1 = l.stateNode, q = e1.getSnapshotBeforeUpdate(l.elementType === l.type ? i2 : c5(l.type, i2), ye);
                            e1.__reactInternalSnapshotBeforeUpdate = q;
                        }
                        break;
                    case 3:
                        var r1 = l.stateNode.containerInfo;
                        r1.nodeType === 1 ? r1.textContent = "" : r1.nodeType === 9 && r1.documentElement && r1.removeChild(r1.documentElement);
                        break;
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        break;
                    default:
                        throw Error(o(163));
                }
            } catch (S1) {
                fe(l, l.return, S1);
            }
            if (n = l.sibling, n !== null) {
                n.return = l.return, J1 = n;
                break;
            }
            J1 = l.return;
        }
        return t2 = Ul, Ul = !1, t2;
    }
    function et(n, l, f) {
        var m = l.updateQueue;
        if (m = m !== null ? m.lastEffect : null, m !== null) {
            var b = m = m.next;
            do {
                if ((b.tag & n) === n) {
                    var H = b.destroy;
                    b.destroy = void 0, H !== void 0 && J0(l, f, H);
                }
                b = b.next;
            }while (b !== m);
        }
    }
    function tt(n, l) {
        if (l = l.updateQueue, l = l !== null ? l.lastEffect : null, l !== null) {
            var f = l = l.next;
            do {
                if ((f.tag & n) === n) {
                    var m = f.create;
                    f.destroy = m();
                }
                f = f.next;
            }while (f !== l);
        }
    }
    function ai(n) {
        var l = n.ref;
        if (l !== null) {
            var f = n.stateNode;
            switch(n.tag){
                case 5:
                    n = f;
                    break;
                default:
                    n = f;
            }
            typeof l == "function" ? l(n) : l.current = n;
        }
    }
    function ii(n) {
        var l = n.alternate;
        l !== null && (n.alternate = null, ii(l)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (l = n.stateNode, l !== null && (delete l[f6], delete l[x8], delete l[_a], delete l[qc], delete l[Da])), n.stateNode = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
    }
    function $l(n) {
        return n.tag === 5 || n.tag === 3 || n.tag === 4;
    }
    function Pn(n) {
        e: for(;;){
            for(; n.sibling === null;){
                if (n.return === null || $l(n.return)) return null;
                n = n.return;
            }
            for(n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18;){
                if (n.flags & 2 || n.child === null || n.tag === 4) continue e;
                n.child.return = n, n = n.child;
            }
            if (!(n.flags & 2)) return n.stateNode;
        }
    }
    function B9(n, l, f) {
        var m = n.tag;
        if (m === 5 || m === 6) n = n.stateNode, l ? f.nodeType === 8 ? f.parentNode.insertBefore(n, l) : f.insertBefore(n, l) : (f.nodeType === 8 ? (l = f.parentNode, l.insertBefore(n, f)) : (l = f, l.appendChild(n)), f = f._reactRootContainer, f != null || l.onclick !== null || (l.onclick = nn));
        else if (m !== 4 && (n = n.child, n !== null)) for(B9(n, l, f), n = n.sibling; n !== null;)B9(n, l, f), n = n.sibling;
    }
    function v6(n, l, f) {
        var m = n.tag;
        if (m === 5 || m === 6) n = n.stateNode, l ? f.insertBefore(n, l) : f.appendChild(n);
        else if (m !== 4 && (n = n.child, n !== null)) for(v6(n, l, f), n = n.sibling; n !== null;)v6(n, l, f), n = n.sibling;
    }
    var K3 = null, $e = !1;
    function D5(n, l, f) {
        for(f = f.child; f !== null;)F9(n, l, f), f = f.sibling;
    }
    function F9(n, l, f) {
        if (i5 && typeof i5.onCommitFiberUnmount == "function") try {
            i5.onCommitFiberUnmount(b7, f);
        } catch  {}
        switch(f.tag){
            case 5:
                Ze || P9(f, l);
            case 6:
                var m = K3, b = $e;
                K3 = null, D5(n, l, f), K3 = m, $e = b, K3 !== null && ($e ? (n = K3, f = f.stateNode, n.nodeType === 8 ? n.parentNode.removeChild(f) : n.removeChild(f)) : K3.removeChild(f.stateNode));
                break;
            case 18:
                K3 !== null && ($e ? (n = K3, f = f.stateNode, n.nodeType === 8 ? _7(n.parentNode, f) : n.nodeType === 1 && _7(n, f), M7(n)) : _7(K3, f.stateNode));
                break;
            case 4:
                m = K3, b = $e, K3 = f.stateNode.containerInfo, $e = !0, D5(n, l, f), K3 = m, $e = b;
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                if (!Ze && (m = f.updateQueue, m !== null && (m = m.lastEffect, m !== null))) {
                    b = m = m.next;
                    do {
                        var H = b, T = H.destroy;
                        H = H.tag, T !== void 0 && (H & 2 || H & 4) && J0(f, l, T), b = b.next;
                    }while (b !== m);
                }
                D5(n, l, f);
                break;
            case 1:
                if (!Ze && (P9(f, l), m = f.stateNode, typeof m.componentWillUnmount == "function")) try {
                    m.props = f.memoizedProps, m.state = f.memoizedState, m.componentWillUnmount();
                } catch (F) {
                    fe(f, l, F);
                }
                D5(n, l, f);
                break;
            case 21:
                D5(n, l, f);
                break;
            case 22:
                f.mode & 1 ? (Ze = (m = Ze) || f.memoizedState !== null, D5(n, l, f), Ze = m) : D5(n, l, f);
                break;
            default:
                D5(n, l, f);
        }
    }
    function J6(n) {
        var l = n.updateQueue;
        if (l !== null) {
            n.updateQueue = null;
            var f = n.stateNode;
            f === null && (f = n.stateNode = new zl()), l.forEach(function(m) {
                var b = sd.bind(null, n, m);
                f.has(m) || (f.add(m), m.then(b, b));
            });
        }
    }
    function X5(n, l) {
        var f = l.deletions;
        if (f !== null) for(var m = 0; m < f.length; m++){
            var b = f[m];
            try {
                var H = n, T = l, F = T;
                e: for(; F !== null;){
                    switch(F.tag){
                        case 5:
                            K3 = F.stateNode, $e = !1;
                            break e;
                        case 3:
                            K3 = F.stateNode.containerInfo, $e = !0;
                            break e;
                        case 4:
                            K3 = F.stateNode.containerInfo, $e = !0;
                            break e;
                    }
                    F = F.return;
                }
                if (K3 === null) throw Error(o(160));
                F9(H, T, b), K3 = null, $e = !1;
                var Y = b.alternate;
                Y !== null && (Y.return = null), b.return = null;
            } catch (o1) {
                fe(b, l, o1);
            }
        }
        if (l.subtreeFlags & 12854) for(l = l.child; l !== null;)Yl(l, n), l = l.sibling;
    }
    function Yl(n, l) {
        var f = n.alternate, m = n.flags;
        switch(n.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                if (X5(l, n), g6(n), m & 4) {
                    try {
                        et(3, n, n.return), tt(3, n);
                    } catch (i2) {
                        fe(n, n.return, i2);
                    }
                    try {
                        et(5, n, n.return);
                    } catch (i2) {
                        fe(n, n.return, i2);
                    }
                }
                break;
            case 1:
                X5(l, n), g6(n), m & 512 && f !== null && P9(f, f.return);
                break;
            case 5:
                if (X5(l, n), g6(n), m & 512 && f !== null && P9(f, f.return), n.flags & 32) {
                    var b = n.stateNode;
                    try {
                        F4(b, "");
                    } catch (i2) {
                        fe(n, n.return, i2);
                    }
                }
                if (m & 4 && (b = n.stateNode, b != null)) {
                    var H = n.memoizedProps, T = f !== null ? f.memoizedProps : H, F = n.type, Y = n.updateQueue;
                    if (n.updateQueue = null, Y !== null) try {
                        F === "input" && H.type === "radio" && H.name != null && N2(b, H), ne(F, T);
                        var o1 = ne(F, H);
                        for(T = 0; T < Y.length; T += 2){
                            var b1 = Y[T], x1 = Y[T + 1];
                            b1 === "style" ? m3(b, x1) : b1 === "dangerouslySetInnerHTML" ? Y5(b, x1) : b1 === "children" ? F4(b, x1) : P(b, b1, x1, o1);
                        }
                        switch(F){
                            case "input":
                                _2(b, H);
                                break;
                            case "textarea":
                                z3(b, H);
                                break;
                            case "select":
                                var y1 = b._wrapperState.wasMultiple;
                                b._wrapperState.wasMultiple = !!H.multiple;
                                var z1 = H.value;
                                z1 != null ? ee(b, !!H.multiple, z1, !1) : y1 !== !!H.multiple && (H.defaultValue != null ? ee(b, !!H.multiple, H.defaultValue, !0) : ee(b, !!H.multiple, H.multiple ? [] : "", !1));
                        }
                        b[x8] = H;
                    } catch (i2) {
                        fe(n, n.return, i2);
                    }
                }
                break;
            case 6:
                if (X5(l, n), g6(n), m & 4) {
                    if (n.stateNode === null) throw Error(o(162));
                    b = n.stateNode, H = n.memoizedProps;
                    try {
                        b.nodeValue = H;
                    } catch (i2) {
                        fe(n, n.return, i2);
                    }
                }
                break;
            case 3:
                if (X5(l, n), g6(n), m & 4 && f !== null && f.memoizedState.isDehydrated) try {
                    M7(l.containerInfo);
                } catch (i2) {
                    fe(n, n.return, i2);
                }
                break;
            case 4:
                X5(l, n), g6(n);
                break;
            case 13:
                X5(l, n), g6(n), b = n.child, b.flags & 8192 && (H = b.memoizedState !== null, b.stateNode.isHidden = H, !H || b.alternate !== null && b.alternate.memoizedState !== null || (si = X2())), m & 4 && J6(n);
                break;
            case 22:
                if (b1 = f !== null && f.memoizedState !== null, n.mode & 1 ? (Ze = (o1 = Ze) || b1, X5(l, n), Ze = o1) : X5(l, n), g6(n), m & 8192) {
                    if (o1 = n.memoizedState !== null, (n.stateNode.isHidden = o1) && !b1 && n.mode & 1) for(J1 = n, b1 = n.child; b1 !== null;){
                        for(x1 = J1 = b1; J1 !== null;){
                            switch(y1 = J1, z1 = y1.child, y1.tag){
                                case 0:
                                case 11:
                                case 14:
                                case 15:
                                    et(4, y1, y1.return);
                                    break;
                                case 1:
                                    P9(y1, y1.return);
                                    var t2 = y1.stateNode;
                                    if (typeof t2.componentWillUnmount == "function") {
                                        m = y1, f = y1.return;
                                        try {
                                            l = m, t2.props = l.memoizedProps, t2.state = l.memoizedState, t2.componentWillUnmount();
                                        } catch (i2) {
                                            fe(m, f, i2);
                                        }
                                    }
                                    break;
                                case 5:
                                    P9(y1, y1.return);
                                    break;
                                case 22:
                                    if (y1.memoizedState !== null) {
                                        oi(x1);
                                        continue;
                                    }
                            }
                            z1 !== null ? (z1.return = y1, J1 = z1) : oi(x1);
                        }
                        b1 = b1.sibling;
                    }
                    e: for(b1 = null, x1 = n;;){
                        if (x1.tag === 5) {
                            if (b1 === null) {
                                b1 = x1;
                                try {
                                    b = x1.stateNode, o1 ? (H = b.style, typeof H.setProperty == "function" ? H.setProperty("display", "none", "important") : H.display = "none") : (F = x1.stateNode, Y = x1.memoizedProps.style, T = Y != null && Y.hasOwnProperty("display") ? Y.display : null, F.style.display = B2("display", T));
                                } catch (i2) {
                                    fe(n, n.return, i2);
                                }
                            }
                        } else if (x1.tag === 6) {
                            if (b1 === null) try {
                                x1.stateNode.nodeValue = o1 ? "" : x1.memoizedProps;
                            } catch (i2) {
                                fe(n, n.return, i2);
                            }
                        } else if ((x1.tag !== 22 && x1.tag !== 23 || x1.memoizedState === null || x1 === n) && x1.child !== null) {
                            x1.child.return = x1, x1 = x1.child;
                            continue;
                        }
                        if (x1 === n) break e;
                        for(; x1.sibling === null;){
                            if (x1.return === null || x1.return === n) break e;
                            b1 === x1 && (b1 = null), x1 = x1.return;
                        }
                        b1 === x1 && (b1 = null), x1.sibling.return = x1.return, x1 = x1.sibling;
                    }
                }
                break;
            case 19:
                X5(l, n), g6(n), m & 4 && J6(n);
                break;
            case 21:
                break;
            default:
                X5(l, n), g6(n);
        }
    }
    function g6(n) {
        var l = n.flags;
        if (l & 2) {
            try {
                e: {
                    for(var f = n.return; f !== null;){
                        if ($l(f)) {
                            var m = f;
                            break e;
                        }
                        f = f.return;
                    }
                    throw Error(o(160));
                }
                switch(m.tag){
                    case 5:
                        var b = m.stateNode;
                        m.flags & 32 && (F4(b, ""), m.flags &= -33);
                        var H = Pn(n);
                        v6(n, H, b);
                        break;
                    case 3:
                    case 4:
                        var T = m.stateNode.containerInfo, F = Pn(n);
                        B9(n, F, T);
                        break;
                    default:
                        throw Error(o(161));
                }
            } catch (Y) {
                fe(n, n.return, Y);
            }
            n.flags &= -3;
        }
        l & 4096 && (n.flags &= -4097);
    }
    function Wl(n, l, f) {
        J1 = n, A9(n);
    }
    function A9(n, l, f) {
        for(var m = (n.mode & 1) !== 0; J1 !== null;){
            var b = J1, H = b.child;
            if (b.tag === 22 && m) {
                var T = b.memoizedState !== null || K0;
                if (!T) {
                    var F = b.alternate, Y = F !== null && F.memoizedState !== null || Ze;
                    F = K0;
                    var o1 = Ze;
                    if (K0 = T, (Ze = Y) && !o1) for(J1 = b; J1 !== null;)T = J1, Y = T.child, T.tag === 22 && T.memoizedState !== null ? ql(b) : Y !== null ? (Y.return = T, J1 = Y) : ql(b);
                    for(; H !== null;)J1 = H, A9(H), H = H.sibling;
                    J1 = b, K0 = F, Ze = o1;
                }
                Ql(n);
            } else b.subtreeFlags & 8772 && H !== null ? (H.return = b, J1 = H) : Ql(n);
        }
    }
    function Ql(n) {
        for(; J1 !== null;){
            var l = J1;
            if (l.flags & 8772) {
                var f = l.alternate;
                try {
                    if (l.flags & 8772) switch(l.tag){
                        case 0:
                        case 11:
                        case 15:
                            Ze || tt(5, l);
                            break;
                        case 1:
                            var m = l.stateNode;
                            if (l.flags & 4 && !Ze) {
                                if (f === null) m.componentDidMount();
                                else {
                                    var b = l.elementType === l.type ? f.memoizedProps : c5(l.type, f.memoizedProps);
                                    m.componentDidUpdate(b, f.memoizedState, m.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var H = l.updateQueue;
                            H !== null && M8(l, H, m);
                            break;
                        case 3:
                            var T = l.updateQueue;
                            if (T !== null) {
                                if (f = null, l.child !== null) switch(l.child.tag){
                                    case 5:
                                        f = l.child.stateNode;
                                        break;
                                    case 1:
                                        f = l.child.stateNode;
                                }
                                M8(l, T, f);
                            }
                            break;
                        case 5:
                            var F = l.stateNode;
                            if (f === null && l.flags & 4) {
                                f = F;
                                var Y = l.memoizedProps;
                                switch(l.type){
                                    case "button":
                                    case "input":
                                    case "select":
                                    case "textarea":
                                        Y.autoFocus && f.focus();
                                        break;
                                    case "img":
                                        Y.src && (f.src = Y.src);
                                }
                            }
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            if (l.memoizedState === null) {
                                var o1 = l.alternate;
                                if (o1 !== null) {
                                    var b1 = o1.memoizedState;
                                    if (b1 !== null) {
                                        var x1 = b1.dehydrated;
                                        x1 !== null && M7(x1);
                                    }
                                }
                            }
                            break;
                        case 19:
                        case 17:
                        case 21:
                        case 22:
                        case 23:
                        case 25:
                            break;
                        default:
                            throw Error(o(163));
                    }
                    Ze || l.flags & 512 && ai(l);
                } catch (y1) {
                    fe(l, l.return, y1);
                }
            }
            if (l === n) {
                J1 = null;
                break;
            }
            if (f = l.sibling, f !== null) {
                f.return = l.return, J1 = f;
                break;
            }
            J1 = l.return;
        }
    }
    function oi(n) {
        for(; J1 !== null;){
            var l = J1;
            if (l === n) {
                J1 = null;
                break;
            }
            var f = l.sibling;
            if (f !== null) {
                f.return = l.return, J1 = f;
                break;
            }
            J1 = l.return;
        }
    }
    function ql(n) {
        for(; J1 !== null;){
            var l = J1;
            try {
                switch(l.tag){
                    case 0:
                    case 11:
                    case 15:
                        var f = l.return;
                        try {
                            tt(4, l);
                        } catch (Y) {
                            fe(l, f, Y);
                        }
                        break;
                    case 1:
                        var m = l.stateNode;
                        if (typeof m.componentDidMount == "function") {
                            var b = l.return;
                            try {
                                m.componentDidMount();
                            } catch (Y) {
                                fe(l, b, Y);
                            }
                        }
                        var H = l.return;
                        try {
                            ai(l);
                        } catch (Y) {
                            fe(l, H, Y);
                        }
                        break;
                    case 5:
                        var T = l.return;
                        try {
                            ai(l);
                        } catch (Y) {
                            fe(l, T, Y);
                        }
                }
            } catch (Y) {
                fe(l, l.return, Y);
            }
            if (l === n) {
                J1 = null;
                break;
            }
            var F = l.sibling;
            if (F !== null) {
                F.return = l.return, J1 = F;
                break;
            }
            J1 = l.return;
        }
    }
    var Bn = Math.ceil, nt = $.ReactCurrentDispatcher, li = $.ReactCurrentOwner, y4 = $.ReactCurrentBatchConfig, W2 = 0, ie = null, Ce = null, Ye = 0, C5 = 0, j9 = Z2(0), Oe = 0, rt = null, e7 = 0, Fn = 0, z9 = 0, B8 = null, S4 = null, si = 0, U9 = 1 / 0, t7 = null, An = !1, F8 = null, y6 = null, $7 = !1, Y7 = null, jn = 0, I9 = 0, zn = null, A8 = -1, j8 = 0;
    function L4() {
        return W2 & 6 ? X2() : A8 !== -1 ? A8 : A8 = X2();
    }
    function Me(n) {
        return n.mode & 1 ? W2 & 2 && Ye !== 0 ? Ye & -Ye : un.transition !== null ? (j8 === 0 && (j8 = p9()), j8) : (n = d3, n !== 0 || (n = window.event, n = n === void 0 ? 16 : T3(n.type)), n) : 1;
    }
    function b4(n, l, f, m) {
        if (50 < I9) throw I9 = 0, zn = null, Error(o(185));
        A6(n, f, m), (!(W2 & 2) || n !== ie) && (n === ie && (!(W2 & 2) && (Fn |= f), Oe === 4 && R5(n, Ye)), w4(n, m), f === 1 && W2 === 0 && !(l.mode & 1) && (U9 = X2() + 500, Ue && $4()));
    }
    function w4(n, l) {
        var f = n.callbackNode;
        x7(n, l);
        var m = o5(n, n === ie ? Ye : 0);
        if (m === 0) f !== null && ke(f), n.callbackNode = null, n.callbackPriority = 0;
        else if (l = m & -m, n.callbackPriority !== l) {
            if (f != null && ke(f), l === 1) n.tag === 0 ? Za(Gl.bind(null, n)) : Ra(Gl.bind(null, n)), Ta(function() {
                !(W2 & 6) && $4();
            }), f = null;
            else {
                switch(V0(m)){
                    case 1:
                        f = j4;
                        break;
                    case 4:
                        f = j2;
                        break;
                    case 16:
                        f = c6;
                        break;
                    case 536870912:
                        f = H0;
                        break;
                    default:
                        f = c6;
                }
                f = pi(f, $9.bind(null, n));
            }
            n.callbackPriority = l, n.callbackNode = f;
        }
    }
    function $9(n, l) {
        if (A8 = -1, j8 = 0, W2 & 6) throw Error(o(327));
        var f = n.callbackNode;
        if (W9() && n.callbackNode !== f) return null;
        var m = o5(n, n === ie ? Ye : 0);
        if (m === 0) return null;
        if (m & 30 || m & n.expiredLanes || l) l = In(n, m);
        else {
            l = m;
            var b = W2;
            W2 |= 2;
            var H = Un();
            (ie !== n || Ye !== l) && (t7 = null, U9 = X2() + 500, z8(n, l));
            for(;;)try {
                ad();
                break;
            } catch (F) {
                Xl(n, F);
            }
            Aa(), nt.current = H, W2 = b, Ce !== null ? l = 0 : (ie = null, Ye = 0, l = Oe);
        }
        if (l !== 0) {
            if (l === 2 && (b = x0(n), b !== 0 && (m = b, l = ui(n, b))), l === 1) throw f = rt, z8(n, 0), R5(n, m), w4(n, X2()), f;
            if (l === 6) R5(n, m);
            else {
                if (b = n.current.alternate, !(m & 30) && !ci(b) && (l = In(n, m), l === 2 && (H = x0(n), H !== 0 && (m = H, l = ui(n, H))), l === 1)) throw f = rt, z8(n, 0), R5(n, m), w4(n, X2()), f;
                switch(n.finishedWork = b, n.finishedLanes = m, l){
                    case 0:
                    case 1:
                        throw Error(o(345));
                    case 2:
                        U8(n, S4, t7);
                        break;
                    case 3:
                        if (R5(n, m), (m & 130023424) === m && (l = si + 500 - X2(), 10 < l)) {
                            if (o5(n, 0) !== 0) break;
                            if (b = n.suspendedLanes, (b & m) !== m) {
                                L4(), n.pingedLanes |= n.suspendedLanes & b;
                                break;
                            }
                            n.timeoutHandle = H8(U8.bind(null, n, S4, t7), l);
                            break;
                        }
                        U8(n, S4, t7);
                        break;
                    case 4:
                        if (R5(n, m), (m & 4194240) === m) break;
                        for(l = n.eventTimes, b = -1; 0 < m;){
                            var T = 31 - z4(m);
                            H = 1 << T, T = l[T], T > b && (b = T), m &= ~H;
                        }
                        if (m = b, m = X2() - m, m = (120 > m ? 120 : 480 > m ? 480 : 1080 > m ? 1080 : 1920 > m ? 1920 : 3e3 > m ? 3e3 : 4320 > m ? 4320 : 1960 * Bn(m / 1960)) - m, 10 < m) {
                            n.timeoutHandle = H8(U8.bind(null, n, S4, t7), m);
                            break;
                        }
                        U8(n, S4, t7);
                        break;
                    case 5:
                        U8(n, S4, t7);
                        break;
                    default:
                        throw Error(o(329));
                }
            }
        }
        return w4(n, X2()), n.callbackNode === f ? $9.bind(null, n) : null;
    }
    function ui(n, l) {
        var f = B8;
        return n.current.memoizedState.isDehydrated && (z8(n, l).flags |= 256), n = In(n, l), n !== 2 && (l = S4, S4 = f, l !== null && at(l)), n;
    }
    function at(n) {
        S4 === null ? S4 = n : S4.push.apply(S4, n);
    }
    function ci(n) {
        for(var l = n;;){
            if (l.flags & 16384) {
                var f = l.updateQueue;
                if (f !== null && (f = f.stores, f !== null)) for(var m = 0; m < f.length; m++){
                    var b = f[m], H = b.getSnapshot;
                    b = b.value;
                    try {
                        if (!H5(H(), b)) return !1;
                    } catch  {
                        return !1;
                    }
                }
            }
            if (f = l.child, l.subtreeFlags & 16384 && f !== null) f.return = l, l = f;
            else {
                if (l === n) break;
                for(; l.sibling === null;){
                    if (l.return === null || l.return === n) return !0;
                    l = l.return;
                }
                l.sibling.return = l.return, l = l.sibling;
            }
        }
        return !0;
    }
    function R5(n, l) {
        for(l &= ~z9, l &= ~Fn, n.suspendedLanes |= l, n.pingedLanes &= ~l, n = n.expirationTimes; 0 < l;){
            var f = 31 - z4(l), m = 1 << f;
            n[f] = -1, l &= ~m;
        }
    }
    function Gl(n) {
        if (W2 & 6) throw Error(o(327));
        W9();
        var l = o5(n, 0);
        if (!(l & 1)) return w4(n, X2()), null;
        var f = In(n, l);
        if (n.tag !== 0 && f === 2) {
            var m = x0(n);
            m !== 0 && (l = m, f = ui(n, m));
        }
        if (f === 1) throw f = rt, z8(n, 0), R5(n, l), w4(n, X2()), f;
        if (f === 6) throw Error(o(345));
        return n.finishedWork = n.current.alternate, n.finishedLanes = l, U8(n, S4, t7), w4(n, X2()), null;
    }
    function Y9(n, l) {
        var f = W2;
        W2 |= 1;
        try {
            return n(l);
        } finally{
            W2 = f, W2 === 0 && (U9 = X2() + 500, Ue && $4());
        }
    }
    function W7(n) {
        Y7 !== null && Y7.tag === 0 && !(W2 & 6) && W9();
        var l = W2;
        W2 |= 1;
        var f = y4.transition, m = d3;
        try {
            if (y4.transition = null, d3 = 1, n) return n();
        } finally{
            d3 = m, y4.transition = f, W2 = l, !(W2 & 6) && $4();
        }
    }
    function di() {
        C5 = j9.current, y3(j9);
    }
    function z8(n, l) {
        n.finishedWork = null, n.finishedLanes = 0;
        var f = n.timeoutHandle;
        if (f !== -1 && (n.timeoutHandle = -1, xl(f)), Ce !== null) for(f = Ce.return; f !== null;){
            var m = f;
            switch(Na(m), m.tag){
                case 1:
                    m = m.type.childContextTypes, m != null && M5();
                    break;
                case 3:
                    j7(), y3(de), y3(V2), hn();
                    break;
                case 5:
                    U2(m);
                    break;
                case 4:
                    j7();
                    break;
                case 13:
                    y3(L2);
                    break;
                case 19:
                    y3(L2);
                    break;
                case 10:
                    P7(m.type._context);
                    break;
                case 22:
                case 23:
                    di();
            }
            f = f.return;
        }
        if (ie = n, Ce = n = Q7(n.current, null), Ye = C5 = l, Oe = 0, rt = null, z9 = Fn = e7 = 0, S4 = B8 = null, Je !== null) {
            for(l = 0; l < Je.length; l++)if (f = Je[l], m = f.interleaved, m !== null) {
                f.interleaved = null;
                var b = m.next, H = f.pending;
                if (H !== null) {
                    var T = H.next;
                    H.next = b, m.next = T;
                }
                f.pending = m;
            }
            Je = null;
        }
        return n;
    }
    function Xl(n, l) {
        do {
            var f = Ce;
            try {
                if (Aa(), mn.current = Dn, b2) {
                    for(var m = Y3.memoizedState; m !== null;){
                        var b = m.queue;
                        b !== null && (b.pending = null), m = m.next;
                    }
                    b2 = !1;
                }
                if (S8 = 0, e3 = C1 = Y3 = null, m6 = !1, d5 = 0, li.current = null, f === null || f.return === null) {
                    Oe = 1, rt = l, Ce = null;
                    break;
                }
                e: {
                    var H = n, T = f.return, F = f, Y = l;
                    if (l = Ye, F.flags |= 32768, Y !== null && typeof Y == "object" && typeof Y.then == "function") {
                        var o1 = Y, b1 = F, x1 = b1.tag;
                        if (!(b1.mode & 1) && (x1 === 0 || x1 === 11 || x1 === 15)) {
                            var y1 = b1.alternate;
                            y1 ? (b1.updateQueue = y1.updateQueue, b1.memoizedState = y1.memoizedState, b1.lanes = y1.lanes) : (b1.updateQueue = null, b1.memoizedState = null);
                        }
                        var z1 = qa(T);
                        if (z1 !== null) {
                            z1.flags &= -257, Ga(z1, T, F, H, l), z1.mode & 1 && Fl(H, o1, l), l = z1, Y = o1;
                            var t2 = l.updateQueue;
                            if (t2 === null) {
                                var i2 = /* @__PURE__ */ new Set();
                                i2.add(Y), l.updateQueue = i2;
                            } else t2.add(Y);
                            break e;
                        } else {
                            if (!(l & 1)) {
                                Fl(H, o1, l), Ci();
                                break e;
                            }
                            Y = Error(o(426));
                        }
                    } else if ($3 && F.mode & 1) {
                        var ye = qa(T);
                        if (ye !== null) {
                            !(ye.flags & 65536) && (ye.flags |= 256), Ga(ye, T, F, H, l), Ba(Z9(Y, F));
                            break e;
                        }
                    }
                    H = Y = Z9(Y, F), Oe !== 4 && (Oe = 2), B8 === null ? B8 = [
                        H
                    ] : B8.push(H), H = T;
                    do {
                        switch(H.tag){
                            case 3:
                                H.flags |= 65536, l &= -l, H.lanes |= l;
                                var e1 = Bl(H, Y, l);
                                Ua(H, e1);
                                break e;
                            case 1:
                                F = Y;
                                var q = H.type, r1 = H.stateNode;
                                if (!(H.flags & 128) && (typeof q.getDerivedStateFromError == "function" || r1 !== null && typeof r1.componentDidCatch == "function" && (y6 === null || !y6.has(r1)))) {
                                    H.flags |= 65536, l &= -l, H.lanes |= l;
                                    var S1 = q0(H, F, l);
                                    Ua(H, S1);
                                    break e;
                                }
                        }
                        H = H.return;
                    }while (H !== null);
                }
                fi(f);
            } catch (l2) {
                l = l2, Ce === f && f !== null && (Ce = f = f.return);
                continue;
            }
            break;
        }while (!0);
    }
    function Un() {
        var n = nt.current;
        return nt.current = Dn, n === null ? Dn : n;
    }
    function Ci() {
        (Oe === 0 || Oe === 3 || Oe === 2) && (Oe = 4), ie === null || !(e7 & 268435455) && !(Fn & 268435455) || R5(ie, Ye);
    }
    function In(n, l) {
        var f = W2;
        W2 |= 2;
        var m = Un();
        (ie !== n || Ye !== l) && (t7 = null, z8(n, l));
        for(;;)try {
            rd();
            break;
        } catch (b) {
            Xl(n, b);
        }
        if (Aa(), W2 = f, nt.current = m, Ce !== null) throw Error(o(261));
        return ie = null, Ye = 0, Oe;
    }
    function rd() {
        for(; Ce !== null;)Kl(Ce);
    }
    function ad() {
        for(; Ce !== null && !u6();)Kl(Ce);
    }
    function Kl(n) {
        var l = es(n.alternate, n, C5);
        n.memoizedProps = n.pendingProps, l === null ? fi(n) : Ce = l, li.current = null;
    }
    function fi(n) {
        var l = n;
        do {
            var f = l.alternate;
            if (n = l.return, l.flags & 32768) {
                if (f = ri(f, l), f !== null) {
                    f.flags &= 32767, Ce = f;
                    return;
                }
                if (n !== null) n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null;
                else {
                    Oe = 6, Ce = null;
                    return;
                }
            } else if (f = nd(f, l, C5), f !== null) {
                Ce = f;
                return;
            }
            if (l = l.sibling, l !== null) {
                Ce = l;
                return;
            }
            Ce = l = n;
        }while (l !== null);
        Oe === 0 && (Oe = 5);
    }
    function U8(n, l, f) {
        var m = d3, b = y4.transition;
        try {
            y4.transition = null, d3 = 1, id(n, l, f, m);
        } finally{
            y4.transition = b, d3 = m;
        }
        return null;
    }
    function id(n, l, f, m) {
        do W9();
        while (Y7 !== null);
        if (W2 & 6) throw Error(o(327));
        f = n.finishedWork;
        var b = n.finishedLanes;
        if (f === null) return null;
        if (n.finishedWork = null, n.finishedLanes = 0, f === n.current) throw Error(o(177));
        n.callbackNode = null, n.callbackPriority = 0;
        var H = f.lanes | f.childLanes;
        if (ua(n, H), n === ie && (Ce = ie = null, Ye = 0), !(f.subtreeFlags & 2064) && !(f.flags & 2064) || $7 || ($7 = !0, pi(c6, function() {
            return W9(), null;
        })), H = (f.flags & 15990) !== 0, f.subtreeFlags & 15990 || H) {
            H = y4.transition, y4.transition = null;
            var T = d3;
            d3 = 1;
            var F = W2;
            W2 |= 4, li.current = null, Il(n, f), Yl(f, n), Xt(w8), N = !!Sa, w8 = Sa = null, n.current = f, Wl(f), B6(), W2 = F, d3 = T, y4.transition = H;
        } else n.current = f;
        if ($7 && ($7 = !1, Y7 = n, jn = b), H = n.pendingLanes, H === 0 && (y6 = null), Nt(f.stateNode), w4(n, X2()), l !== null) for(m = n.onRecoverableError, f = 0; f < l.length; f++)b = l[f], m(b.value, {
            componentStack: b.stack,
            digest: b.digest
        });
        if (An) throw An = !1, n = F8, F8 = null, n;
        return jn & 1 && n.tag !== 0 && W9(), H = n.pendingLanes, H & 1 ? n === zn ? I9++ : (I9 = 0, zn = n) : I9 = 0, $4(), null;
    }
    function W9() {
        if (Y7 !== null) {
            var n = V0(jn), l = y4.transition, f = d3;
            try {
                if (y4.transition = null, d3 = 16 > n ? 16 : n, Y7 === null) var m = !1;
                else {
                    if (n = Y7, Y7 = null, jn = 0, W2 & 6) throw Error(o(331));
                    var b = W2;
                    for(W2 |= 4, J1 = n.current; J1 !== null;){
                        var H = J1, T = H.child;
                        if (J1.flags & 16) {
                            var F = H.deletions;
                            if (F !== null) {
                                for(var Y = 0; Y < F.length; Y++){
                                    var o1 = F[Y];
                                    for(J1 = o1; J1 !== null;){
                                        var b1 = J1;
                                        switch(b1.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                et(8, b1, H);
                                        }
                                        var x1 = b1.child;
                                        if (x1 !== null) x1.return = b1, J1 = x1;
                                        else for(; J1 !== null;){
                                            b1 = J1;
                                            var y1 = b1.sibling, z1 = b1.return;
                                            if (ii(b1), b1 === o1) {
                                                J1 = null;
                                                break;
                                            }
                                            if (y1 !== null) {
                                                y1.return = z1, J1 = y1;
                                                break;
                                            }
                                            J1 = z1;
                                        }
                                    }
                                }
                                var t2 = H.alternate;
                                if (t2 !== null) {
                                    var i2 = t2.child;
                                    if (i2 !== null) {
                                        t2.child = null;
                                        do {
                                            var ye = i2.sibling;
                                            i2.sibling = null, i2 = ye;
                                        }while (i2 !== null);
                                    }
                                }
                                J1 = H;
                            }
                        }
                        if (H.subtreeFlags & 2064 && T !== null) T.return = H, J1 = T;
                        else e: for(; J1 !== null;){
                            if (H = J1, H.flags & 2048) switch(H.tag){
                                case 0:
                                case 11:
                                case 15:
                                    et(9, H, H.return);
                            }
                            var e1 = H.sibling;
                            if (e1 !== null) {
                                e1.return = H.return, J1 = e1;
                                break e;
                            }
                            J1 = H.return;
                        }
                    }
                    var q = n.current;
                    for(J1 = q; J1 !== null;){
                        T = J1;
                        var r1 = T.child;
                        if (T.subtreeFlags & 2064 && r1 !== null) r1.return = T, J1 = r1;
                        else e: for(T = q; J1 !== null;){
                            if (F = J1, F.flags & 2048) try {
                                switch(F.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        tt(9, F);
                                }
                            } catch (l2) {
                                fe(F, F.return, l2);
                            }
                            if (F === T) {
                                J1 = null;
                                break e;
                            }
                            var S1 = F.sibling;
                            if (S1 !== null) {
                                S1.return = F.return, J1 = S1;
                                break e;
                            }
                            J1 = F.return;
                        }
                    }
                    if (W2 = b, $4(), i5 && typeof i5.onPostCommitFiberRoot == "function") try {
                        i5.onPostCommitFiberRoot(b7, n);
                    } catch  {}
                    m = !0;
                }
                return m;
            } finally{
                d3 = f, y4.transition = l;
            }
        }
        return !1;
    }
    function Jl(n, l, f) {
        l = Z9(f, l), l = Bl(n, l, 1), n = F7(n, l, 1), l = L4(), n !== null && (A6(n, 1, l), w4(n, l));
    }
    function fe(n, l, f) {
        if (n.tag === 3) Jl(n, n, f);
        else for(; l !== null;){
            if (l.tag === 3) {
                Jl(l, n, f);
                break;
            } else if (l.tag === 1) {
                var m = l.stateNode;
                if (typeof l.type.getDerivedStateFromError == "function" || typeof m.componentDidCatch == "function" && (y6 === null || !y6.has(m))) {
                    n = Z9(f, n), n = q0(l, n, 1), l = F7(l, n, 1), n = L4(), l !== null && (A6(l, 1, n), w4(l, n));
                    break;
                }
            }
            l = l.return;
        }
    }
    function od(n, l, f) {
        var m = n.pingCache;
        m !== null && m.delete(l), l = L4(), n.pingedLanes |= n.suspendedLanes & f, ie === n && (Ye & f) === f && (Oe === 4 || Oe === 3 && (Ye & 130023424) === Ye && 500 > X2() - si ? z8(n, 0) : z9 |= f), w4(n, l);
    }
    function $n(n, l) {
        l === 0 && (n.mode & 1 ? (l = w7, w7 <<= 1, !(w7 & 130023424) && (w7 = 4194304)) : l = 1);
        var f = L4();
        n = q6(n, l), n !== null && (A6(n, l, f), w4(n, f));
    }
    function ld(n) {
        var l = n.memoizedState, f = 0;
        l !== null && (f = l.retryLane), $n(n, f);
    }
    function sd(n, l) {
        var f = 0;
        switch(n.tag){
            case 13:
                var m = n.stateNode, b = n.memoizedState;
                b !== null && (f = b.retryLane);
                break;
            case 19:
                m = n.stateNode;
                break;
            default:
                throw Error(o(314));
        }
        m !== null && m.delete(l), $n(n, f);
    }
    var es;
    es = function(n, l, f) {
        if (n !== null) {
            if (n.memoizedProps !== l.pendingProps || de.current) Ve = !0;
            else {
                if (!(n.lanes & f) && !(l.flags & 128)) return Ve = !1, K6(n, l, f);
                Ve = !!(n.flags & 131072);
            }
        } else Ve = !1, $3 && l.flags & 1048576 && Oa(l, E9, l.index);
        switch(l.lanes = 0, l.tag){
            case 2:
                var m = l.type;
                v4(n, l), n = l.pendingProps;
                var b = V5(l, V2.current);
                Z1(l, f), b = z7(null, l, m, n, b, f);
                var H = _8();
                return l.flags |= 1, typeof b == "object" && b !== null && typeof b.render == "function" && b.$$typeof === void 0 ? (l.tag = 1, l.memoizedState = null, l.updateQueue = null, X3(m) ? (H = !0, rn(l)) : H = !1, l.memoizedState = b.state !== null && b.state !== void 0 ? b.state : null, za(l), b.updater = Cn, l.stateNode = b, b._reactInternals = l, fn(l, m, n, f), l = Al(null, l, m, !0, H, f)) : (l.tag = 0, $3 && H && an(l), De(null, l, b, f), l = l.child), l;
            case 16:
                m = l.elementType;
                e: {
                    switch(v4(n, l), n = l.pendingProps, b = m._init, m = b(m._payload), l.type = m, b = l.tag = cd(m), n = c5(m, n), b){
                        case 0:
                            l = O9(null, l, m, n, f);
                            break e;
                        case 1:
                            l = Xa(null, l, m, n, f);
                            break e;
                        case 11:
                            l = I7(null, l, m, n, f);
                            break e;
                        case 14:
                            l = Zn(null, l, m, c5(m.type, n), f);
                            break e;
                    }
                    throw Error(o(306, m, ""));
                }
                return l;
            case 0:
                return m = l.type, b = l.pendingProps, b = l.elementType === m ? b : c5(m, b), O9(n, l, m, b, f);
            case 1:
                return m = l.type, b = l.pendingProps, b = l.elementType === m ? b : c5(m, b), Xa(n, l, m, b, f);
            case 3:
                e: {
                    if (jl(l), n === null) throw Error(o(387));
                    m = l.pendingProps, H = l.memoizedState, b = H.element, _e(n, l), A7(l, m, null, f);
                    var T = l.memoizedState;
                    if (m = T.element, H.isDehydrated) {
                        if (H = {
                            element: m,
                            isDehydrated: !1,
                            cache: T.cache,
                            pendingSuspenseBoundaries: T.pendingSuspenseBoundaries,
                            transitions: T.transitions
                        }, l.updateQueue.baseState = H, l.memoizedState = H, l.flags & 256) {
                            b = Z9(Error(o(423)), l), l = On(n, l, m, f, b);
                            break e;
                        } else if (m !== b) {
                            b = Z9(Error(o(424)), l), l = On(n, l, m, f, b);
                            break e;
                        } else for(Q4 = q5(l.stateNode.containerInfo.firstChild), u5 = l, $3 = !0, S5 = null, f = Nl(l, null, m, f), l.child = f; f;)f.flags = f.flags & -3 | 4096, f = f.sibling;
                    } else {
                        if (re(), m === b) {
                            l = e4(n, l, f);
                            break e;
                        }
                        De(n, l, m, f);
                    }
                    l = l.child;
                }
                return l;
            case 5:
                return y2(l), n === null && ln(l), m = l.type, b = l.pendingProps, H = n !== null ? n.memoizedProps : null, T = b.children, P0(m, b) ? T = null : H !== null && P0(m, H) && (l.flags |= 32), O2(n, l), De(n, l, T, f), l.child;
            case 6:
                return n === null && ln(l), null;
            case 13:
                return Ja(n, l, f);
            case 4:
                return $a(l, l.stateNode.containerInfo), m = l.pendingProps, n === null ? l.child = k9(l, null, m, f) : De(n, l, m, f), l.child;
            case 11:
                return m = l.type, b = l.pendingProps, b = l.elementType === m ? b : c5(m, b), I7(n, l, m, b, f);
            case 7:
                return De(n, l, l.pendingProps, f), l.child;
            case 8:
                return De(n, l, l.pendingProps.children, f), l.child;
            case 12:
                return De(n, l, l.pendingProps.children, f), l.child;
            case 10:
                e: {
                    if (m = l.type._context, b = l.pendingProps, H = l.memoizedProps, T = b.value, H3(h6, m._currentValue), m._currentValue = T, H !== null) {
                        if (H5(H.value, T)) {
                            if (H.children === b.children && !de.current) {
                                l = e4(n, l, f);
                                break e;
                            }
                        } else for(H = l.child, H !== null && (H.return = l); H !== null;){
                            var F = H.dependencies;
                            if (F !== null) {
                                T = H.child;
                                for(var Y = F.firstContext; Y !== null;){
                                    if (Y.context === m) {
                                        if (H.tag === 1) {
                                            Y = G6(-1, f & -f), Y.tag = 2;
                                            var o1 = H.updateQueue;
                                            if (o1 !== null) {
                                                o1 = o1.shared;
                                                var b1 = o1.pending;
                                                b1 === null ? Y.next = Y : (Y.next = b1.next, b1.next = Y), o1.pending = Y;
                                            }
                                        }
                                        H.lanes |= f, Y = H.alternate, Y !== null && (Y.lanes |= f), Ie(H.return, f, l), F.lanes |= f;
                                        break;
                                    }
                                    Y = Y.next;
                                }
                            } else if (H.tag === 10) T = H.type === l.type ? null : H.child;
                            else if (H.tag === 18) {
                                if (T = H.return, T === null) throw Error(o(341));
                                T.lanes |= f, F = T.alternate, F !== null && (F.lanes |= f), Ie(T, f, l), T = H.sibling;
                            } else T = H.child;
                            if (T !== null) T.return = H;
                            else for(T = H; T !== null;){
                                if (T === l) {
                                    T = null;
                                    break;
                                }
                                if (H = T.sibling, H !== null) {
                                    H.return = T.return, T = H;
                                    break;
                                }
                                T = T.return;
                            }
                            H = T;
                        }
                    }
                    De(n, l, b.children, f), l = l.child;
                }
                return l;
            case 9:
                return b = l.type, m = l.pendingProps.children, Z1(l, f), b = ge(b), m = m(b), l.flags |= 1, De(n, l, m, f), l.child;
            case 14:
                return m = l.type, b = c5(m, l.pendingProps), b = c5(m.type, b), Zn(n, l, m, b, f);
            case 15:
                return X4(n, l, l.type, l.pendingProps, f);
            case 17:
                return m = l.type, b = l.pendingProps, b = l.elementType === m ? b : c5(m, b), v4(n, l), l.tag = 1, X3(m) ? (n = !0, rn(l)) : n = !1, Z1(l, f), Dl(l, m, b), fn(l, m, b, f), Al(null, l, m, !0, n, f);
            case 19:
                return ni(n, l, f);
            case 22:
                return O8(n, l, f);
        }
        throw Error(o(156, l.tag));
    };
    function pi(n, l) {
        return F3(n, l);
    }
    function ud(n, l, f, m) {
        this.tag = n, this.key = f, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = l, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = m, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
    }
    function Z5(n, l, f, m) {
        return new ud(n, l, f, m);
    }
    function hi(n) {
        return n = n.prototype, !(!n || !n.isReactComponent);
    }
    function cd(n) {
        if (typeof n == "function") return hi(n) ? 1 : 0;
        if (n != null) {
            if (n = n.$$typeof, n === B1) return 11;
            if (n === I1) return 14;
        }
        return 2;
    }
    function Q7(n, l) {
        var f = n.alternate;
        return f === null ? (f = Z5(n.tag, l, n.key, n.mode), f.elementType = n.elementType, f.type = n.type, f.stateNode = n.stateNode, f.alternate = n, n.alternate = f) : (f.pendingProps = l, f.type = n.type, f.flags = 0, f.subtreeFlags = 0, f.deletions = null), f.flags = n.flags & 14680064, f.childLanes = n.childLanes, f.lanes = n.lanes, f.child = n.child, f.memoizedProps = n.memoizedProps, f.memoizedState = n.memoizedState, f.updateQueue = n.updateQueue, l = n.dependencies, f.dependencies = l === null ? null : {
            lanes: l.lanes,
            firstContext: l.firstContext
        }, f.sibling = n.sibling, f.index = n.index, f.ref = n.ref, f;
    }
    function Yn(n, l, f, m, b, H) {
        var T = 2;
        if (m = n, typeof n == "function") hi(n) && (T = 1);
        else if (typeof n == "string") T = 5;
        else e: switch(n){
            case u1:
                return I8(f.children, b, H, l);
            case m1:
                T = 8, b |= 8;
                break;
            case L1:
                return n = Z5(12, f, l, b | 2), n.elementType = L1, n.lanes = H, n;
            case h1:
                return n = Z5(13, f, l, b), n.elementType = h1, n.lanes = H, n;
            case k1:
                return n = Z5(19, f, l, b), n.elementType = k1, n.lanes = H, n;
            case s2:
                return it(f, b, H, l);
            default:
                if (typeof n == "object" && n !== null) switch(n.$$typeof){
                    case E1:
                        T = 10;
                        break e;
                    case H1:
                        T = 9;
                        break e;
                    case B1:
                        T = 11;
                        break e;
                    case I1:
                        T = 14;
                        break e;
                    case D1:
                        T = 16, m = null;
                        break e;
                }
                throw Error(o(130, n == null ? n : typeof n, ""));
        }
        return l = Z5(T, f, l, b), l.elementType = n, l.type = m, l.lanes = H, l;
    }
    function I8(n, l, f, m) {
        return n = Z5(7, n, m, l), n.lanes = f, n;
    }
    function it(n, l, f, m) {
        return n = Z5(22, n, m, l), n.elementType = s2, n.lanes = f, n.stateNode = {
            isHidden: !1
        }, n;
    }
    function ot(n, l, f) {
        return n = Z5(6, n, null, l), n.lanes = f, n;
    }
    function $8(n, l, f) {
        return l = Z5(4, n.children !== null ? n.children : [], n.key, l), l.lanes = f, l.stateNode = {
            containerInfo: n.containerInfo,
            pendingChildren: null,
            implementation: n.implementation
        }, l;
    }
    function dd(n, l, f, m, b) {
        this.tag = l, this.containerInfo = n, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = h9(0), this.expirationTimes = h9(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = h9(0), this.identifierPrefix = m, this.onRecoverableError = b, this.mutableSourceEagerHydrationData = null;
    }
    function Wn(n, l, f, m, b, H, T, F, Y) {
        return n = new dd(n, l, f, F, Y), l === 1 ? (l = 1, H === !0 && (l |= 8)) : l = 0, H = Z5(3, null, null, l), n.current = H, H.stateNode = n, H.memoizedState = {
            element: m,
            isDehydrated: f,
            cache: null,
            transitions: null,
            pendingSuspenseBoundaries: null
        }, za(H), n;
    }
    function ts(n, l, f) {
        var m = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
        return {
            $$typeof: l1,
            key: m == null ? null : "" + m,
            children: n,
            containerInfo: l,
            implementation: f
        };
    }
    function mi(n) {
        if (!n) return p6;
        n = n._reactInternals;
        e: {
            if (x2(n) !== n || n.tag !== 1) throw Error(o(170));
            var l = n;
            do {
                switch(l.tag){
                    case 3:
                        l = l.stateNode.context;
                        break e;
                    case 1:
                        if (X3(l.type)) {
                            l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                            break e;
                        }
                }
                l = l.return;
            }while (l !== null);
            throw Error(o(171));
        }
        if (n.tag === 1) {
            var f = n.type;
            if (X3(f)) return A0(n, f, l);
        }
        return l;
    }
    function ns(n, l, f, m, b, H, T, F, Y) {
        return n = Wn(f, m, !0, n, b, H, T, F, Y), n.context = mi(null), f = n.current, m = L4(), b = Me(f), H = G6(m, b), H.callback = l ?? null, F7(f, H, b), n.current.lanes = b, A6(n, b, m), w4(n, m), n;
    }
    function lt(n, l, f, m) {
        var b = l.current, H = L4(), T = Me(b);
        return f = mi(f), l.context === null ? l.context = f : l.pendingContext = f, l = G6(H, T), l.payload = {
            element: n
        }, m = m === void 0 ? null : m, m !== null && (l.callback = m), n = F7(b, l, T), n !== null && (b4(n, b, T, H), dn(n, b, T)), T;
    }
    function Qn(n) {
        if (n = n.current, !n.child) return null;
        switch(n.child.tag){
            case 5:
                return n.child.stateNode;
            default:
                return n.child.stateNode;
        }
    }
    function rs(n, l) {
        if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
            var f = n.retryLane;
            n.retryLane = f !== 0 && f < l ? f : l;
        }
    }
    function vi(n, l) {
        rs(n, l), (n = n.alternate) && rs(n, l);
    }
    function as() {
        return null;
    }
    var gi = typeof reportError == "function" ? reportError : function(n) {
        console.error(n);
    };
    function qn(n) {
        this._internalRoot = n;
    }
    n7.prototype.render = qn.prototype.render = function(n) {
        var l = this._internalRoot;
        if (l === null) throw Error(o(409));
        lt(n, l, null, null);
    }, n7.prototype.unmount = qn.prototype.unmount = function() {
        var n = this._internalRoot;
        if (n !== null) {
            this._internalRoot = null;
            var l = n.containerInfo;
            W7(function() {
                lt(null, n, null, null);
            }), l[W6] = null;
        }
    };
    function n7(n) {
        this._internalRoot = n;
    }
    n7.prototype.unstable_scheduleHydration = function(n) {
        if (n) {
            var l = At();
            n = {
                blockedOn: null,
                target: n,
                priority: l
            };
            for(var f = 0; f < C3.length && l !== 0 && l < C3[f].priority; f++);
            C3.splice(f, 0, n), f === 0 && E0(n);
        }
    };
    function yi(n) {
        return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
    }
    function Gn(n) {
        return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11 && (n.nodeType !== 8 || n.nodeValue !== " react-mount-point-unstable "));
    }
    function is() {}
    function Cd(n, l, f, m, b) {
        if (b) {
            if (typeof m == "function") {
                var H = m;
                m = function() {
                    var o1 = Qn(T);
                    H.call(o1);
                };
            }
            var T = ns(l, m, n, 0, null, !1, !1, "", is);
            return n._reactRootContainer = T, n[W6] = T.current, V9(n.nodeType === 8 ? n.parentNode : n), W7(), T;
        }
        for(; b = n.lastChild;)n.removeChild(b);
        if (typeof m == "function") {
            var F = m;
            m = function() {
                var o1 = Qn(Y);
                F.call(o1);
            };
        }
        var Y = Wn(n, 0, !1, null, null, !1, !1, "", is);
        return n._reactRootContainer = Y, n[W6] = Y.current, V9(n.nodeType === 8 ? n.parentNode : n), W7(function() {
            lt(l, Y, f, m);
        }), Y;
    }
    function Xn(n, l, f, m, b) {
        var H = f._reactRootContainer;
        if (H) {
            var T = H;
            if (typeof b == "function") {
                var F = b;
                b = function() {
                    var Y = Qn(T);
                    F.call(Y);
                };
            }
            lt(l, T, n, b);
        } else T = Cd(f, l, n, b, m);
        return Qn(T);
    }
    Ft = function(n) {
        switch(n.tag){
            case 3:
                var l = n.stateNode;
                if (l.current.memoizedState.isDehydrated) {
                    var f = F6(l.pendingLanes);
                    f !== 0 && (h8(l, f | 1), w4(l, X2()), !(W2 & 6) && (U9 = X2() + 500, $4()));
                }
                break;
            case 13:
                W7(function() {
                    var m = q6(n, 1);
                    if (m !== null) {
                        var b = L4();
                        b4(m, n, 1, b);
                    }
                }), vi(n, 1);
        }
    }, m9 = function(n) {
        if (n.tag === 13) {
            var l = q6(n, 134217728);
            if (l !== null) {
                var f = L4();
                b4(l, n, 134217728, f);
            }
            vi(n, 134217728);
        }
    }, g3 = function(n) {
        if (n.tag === 13) {
            var l = Me(n), f = q6(n, l);
            if (f !== null) {
                var m = L4();
                b4(f, n, l, m);
            }
            vi(n, l);
        }
    }, At = function() {
        return d3;
    }, M0 = function(n, l) {
        var f = d3;
        try {
            return d3 = n, l();
        } finally{
            d3 = f;
        }
    }, d4 = function(n, l, f) {
        switch(l){
            case "input":
                if (_2(n, f), l = f.name, f.type === "radio" && l != null) {
                    for(f = n; f.parentNode;)f = f.parentNode;
                    for(f = f.querySelectorAll("input[name=" + JSON.stringify("" + l) + '][type="radio"]'), l = 0; l < f.length; l++){
                        var m = f[l];
                        if (m !== n && m.form === n.form) {
                            var b = h2(m);
                            if (!b) throw Error(o(90));
                            V3(m), _2(m, b);
                        }
                    }
                }
                break;
            case "textarea":
                z3(n, f);
                break;
            case "select":
                l = f.value, l != null && ee(n, !!f.multiple, l, !1);
        }
    }, p8 = Y9, C9 = W7;
    var fd = {
        usingClientEntryPoint: !1,
        Events: [
            F0,
            M9,
            h2,
            O6,
            y7,
            Y9
        ]
    }, Q9 = {
        findFiberByHostInstance: x5,
        bundleType: 0,
        version: "18.2.0",
        rendererPackageName: "react-dom"
    }, pd = {
        bundleType: Q9.bundleType,
        version: Q9.version,
        rendererPackageName: Q9.rendererPackageName,
        rendererConfig: Q9.rendererConfig,
        overrideHookState: null,
        overrideHookStateDeletePath: null,
        overrideHookStateRenamePath: null,
        overrideProps: null,
        overridePropsDeletePath: null,
        overridePropsRenamePath: null,
        setErrorHandler: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: $.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(n) {
            return n = He(n), n === null ? null : n.stateNode;
        },
        findFiberByHostInstance: Q9.findFiberByHostInstance || as,
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null,
        reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
    };
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
        var Kn = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (!Kn.isDisabled && Kn.supportsFiber) try {
            b7 = Kn.inject(pd), i5 = Kn;
        } catch  {}
    }
    return $0422a6ce4ea03acc$var$A5.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fd, $0422a6ce4ea03acc$var$A5.createPortal = function(n, l) {
        var f = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
        if (!yi(l)) throw Error(o(200));
        return ts(n, l, null, f);
    }, $0422a6ce4ea03acc$var$A5.createRoot = function(n, l) {
        if (!yi(n)) throw Error(o(299));
        var f = !1, m = "", b = gi;
        return l != null && (l.unstable_strictMode === !0 && (f = !0), l.identifierPrefix !== void 0 && (m = l.identifierPrefix), l.onRecoverableError !== void 0 && (b = l.onRecoverableError)), l = Wn(n, 1, !1, null, null, f, !1, m, b), n[W6] = l.current, V9(n.nodeType === 8 ? n.parentNode : n), new qn(l);
    }, $0422a6ce4ea03acc$var$A5.findDOMNode = function(n) {
        if (n == null) return null;
        if (n.nodeType === 1) return n;
        var l = n._reactInternals;
        if (l === void 0) throw typeof n.render == "function" ? Error(o(188)) : (n = Object.keys(n).join(","), Error(o(268, n)));
        return n = He(l), n = n === null ? null : n.stateNode, n;
    }, $0422a6ce4ea03acc$var$A5.flushSync = function(n) {
        return W7(n);
    }, $0422a6ce4ea03acc$var$A5.hydrate = function(n, l, f) {
        if (!Gn(l)) throw Error(o(200));
        return Xn(null, n, l, !0, f);
    }, $0422a6ce4ea03acc$var$A5.hydrateRoot = function(n, l, f) {
        if (!yi(n)) throw Error(o(405));
        var m = f != null && f.hydratedSources || null, b = !1, H = "", T = gi;
        if (f != null && (f.unstable_strictMode === !0 && (b = !0), f.identifierPrefix !== void 0 && (H = f.identifierPrefix), f.onRecoverableError !== void 0 && (T = f.onRecoverableError)), l = ns(l, null, n, 1, f ?? null, b, !1, H, T), n[W6] = l.current, V9(n), m) for(n = 0; n < m.length; n++)f = m[n], b = f._getVersion, b = b(f._source), l.mutableSourceEagerHydrationData == null ? l.mutableSourceEagerHydrationData = [
            f,
            b
        ] : l.mutableSourceEagerHydrationData.push(f, b);
        return new n7(l);
    }, $0422a6ce4ea03acc$var$A5.render = function(n, l, f) {
        if (!Gn(l)) throw Error(o(200));
        return Xn(null, n, l, !1, f);
    }, $0422a6ce4ea03acc$var$A5.unmountComponentAtNode = function(n) {
        if (!Gn(n)) throw Error(o(40));
        return n._reactRootContainer ? (W7(function() {
            Xn(null, null, n, !1, function() {
                n._reactRootContainer = null, n[W6] = null;
            });
        }), !0) : !1;
    }, $0422a6ce4ea03acc$var$A5.unstable_batchedUpdates = Y9, $0422a6ce4ea03acc$var$A5.unstable_renderSubtreeIntoContainer = function(n, l, f, m) {
        if (!Gn(f)) throw Error(o(200));
        if (n == null || n._reactInternals === void 0) throw Error(o(38));
        return Xn(n, l, f, !1, m);
    }, $0422a6ce4ea03acc$var$A5.version = "18.2.0-next-9e3b772b8-20220608", $0422a6ce4ea03acc$var$A5;
}
var $0422a6ce4ea03acc$var$j5 = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0422a6ce4ea03acc$var$Jy;
function $0422a6ce4ea03acc$var$TZ() {
    return $0422a6ce4ea03acc$var$Jy || ($0422a6ce4ea03acc$var$Jy = 1), $0422a6ce4ea03acc$var$j5;
}
function $0422a6ce4ea03acc$var$Zb() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($0422a6ce4ea03acc$var$Zb);
    } catch (r) {
        console.error(r);
    }
}
$0422a6ce4ea03acc$var$Zb(), $0422a6ce4ea03acc$var$Gp.exports = $0422a6ce4ea03acc$var$kZ();
var $0422a6ce4ea03acc$var$Eh = $0422a6ce4ea03acc$var$Gp.exports;
const $0422a6ce4ea03acc$var$_Z = /* @__PURE__ */ $0422a6ce4ea03acc$var$zo($0422a6ce4ea03acc$var$Eh);
function $0422a6ce4ea03acc$var$DZ(r, a) {
    r.prototype = Object.create(a.prototype), r.prototype.constructor = r, $0422a6ce4ea03acc$var$Xp(r, a);
}
function $0422a6ce4ea03acc$var$Xp(r, a) {
    return $0422a6ce4ea03acc$var$Xp = Object.setPrototypeOf || function(s, i) {
        return s.__proto__ = i, s;
    }, $0422a6ce4ea03acc$var$Xp(r, a);
}
function $0422a6ce4ea03acc$var$RZ(r, a) {
    if (r == null) return {};
    var o = {}, s = Object.keys(r), i, p;
    for(p = 0; p < s.length; p++)i = s[p], !(a.indexOf(i) >= 0) && (o[i] = r[i]);
    return o;
}
function $0422a6ce4ea03acc$var$eL(r) {
    if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return r;
}
function $0422a6ce4ea03acc$var$ZZ(r, a, o) {
    return r === a ? !0 : r.correspondingElement ? r.correspondingElement.classList.contains(o) : r.classList.contains(o);
}
function $0422a6ce4ea03acc$var$OZ(r, a, o) {
    if (r === a) return !0;
    for(; r.parentNode || r.host;){
        if (r.parentNode && $0422a6ce4ea03acc$var$ZZ(r, a, o)) return !0;
        r = r.parentNode || r.host;
    }
    return r;
}
function $0422a6ce4ea03acc$var$NZ(r) {
    return document.documentElement.clientWidth <= r.clientX || document.documentElement.clientHeight <= r.clientY;
}
var $0422a6ce4ea03acc$var$PZ = function() {
    if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
        var a = !1, o = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        }), s = function() {};
        return window.addEventListener("testPassiveEventSupport", s, o), window.removeEventListener("testPassiveEventSupport", s, o), a;
    }
};
function $0422a6ce4ea03acc$var$BZ(r) {
    return r === void 0 && (r = 0), function() {
        return ++r;
    };
}
var $0422a6ce4ea03acc$var$FZ = $0422a6ce4ea03acc$var$BZ(), $0422a6ce4ea03acc$var$Kp, $0422a6ce4ea03acc$var$ju = {}, $0422a6ce4ea03acc$var$mp = {}, $0422a6ce4ea03acc$var$AZ = [
    "touchstart",
    "touchmove"
], $0422a6ce4ea03acc$var$jZ = "ignore-react-onclickoutside";
function $0422a6ce4ea03acc$var$tL(r, a) {
    var o = {}, s = $0422a6ce4ea03acc$var$AZ.indexOf(a) !== -1;
    return s && $0422a6ce4ea03acc$var$Kp && (o.passive = !r.props.preventDefault), o;
}
function $0422a6ce4ea03acc$var$wc(r, a) {
    var o, s, i = r.displayName || r.name || "Component";
    return s = o = /* @__PURE__ */ function(p) {
        $0422a6ce4ea03acc$var$DZ(C, p);
        function C(y) {
            var L;
            return L = p.call(this, y) || this, L.__outsideClickHandler = function(M) {
                if (typeof L.__clickOutsideHandlerProp == "function") {
                    L.__clickOutsideHandlerProp(M);
                    return;
                }
                var E = L.getInstance();
                if (typeof E.props.handleClickOutside == "function") {
                    E.props.handleClickOutside(M);
                    return;
                }
                if (typeof E.handleClickOutside == "function") {
                    E.handleClickOutside(M);
                    return;
                }
                throw new Error("WrappedComponent: " + i + " lacks a handleClickOutside(event) function for processing outside click events.");
            }, L.__getComponentNode = function() {
                var M = L.getInstance();
                return typeof M.setClickOutsideRef == "function" ? M.setClickOutsideRef() : $0422a6ce4ea03acc$var$Eh.findDOMNode(M);
            }, L.enableOnClickOutside = function() {
                if (!(typeof document > "u" || $0422a6ce4ea03acc$var$mp[L._uid])) {
                    typeof $0422a6ce4ea03acc$var$Kp > "u" && ($0422a6ce4ea03acc$var$Kp = $0422a6ce4ea03acc$var$PZ()), $0422a6ce4ea03acc$var$mp[L._uid] = !0;
                    var M = L.props.eventTypes;
                    M.forEach || (M = [
                        M
                    ]), $0422a6ce4ea03acc$var$ju[L._uid] = function(E) {
                        if (L.componentNode !== null && !(L.initTimeStamp > E.timeStamp) && (L.props.preventDefault && E.preventDefault(), L.props.stopPropagation && E.stopPropagation(), !(L.props.excludeScrollbar && $0422a6ce4ea03acc$var$NZ(E)))) {
                            var k = E.composed && E.composedPath && E.composedPath().shift() || E.target;
                            $0422a6ce4ea03acc$var$OZ(k, L.componentNode, L.props.outsideClickIgnoreClass) === document && L.__outsideClickHandler(E);
                        }
                    }, M.forEach(function(E) {
                        document.addEventListener(E, $0422a6ce4ea03acc$var$ju[L._uid], $0422a6ce4ea03acc$var$tL($0422a6ce4ea03acc$var$eL(L), E));
                    });
                }
            }, L.disableOnClickOutside = function() {
                delete $0422a6ce4ea03acc$var$mp[L._uid];
                var M = $0422a6ce4ea03acc$var$ju[L._uid];
                if (M && typeof document < "u") {
                    var E = L.props.eventTypes;
                    E.forEach || (E = [
                        E
                    ]), E.forEach(function(k) {
                        return document.removeEventListener(k, M, $0422a6ce4ea03acc$var$tL($0422a6ce4ea03acc$var$eL(L), k));
                    }), delete $0422a6ce4ea03acc$var$ju[L._uid];
                }
            }, L.getRef = function(M) {
                return L.instanceRef = M;
            }, L._uid = $0422a6ce4ea03acc$var$FZ(), L.initTimeStamp = performance.now(), L;
        }
        var v = C.prototype;
        return v.getInstance = function() {
            if (r.prototype && !r.prototype.isReactComponent) return this;
            var L = this.instanceRef;
            return L.getInstance ? L.getInstance() : L;
        }, v.componentDidMount = function() {
            typeof document > "u" || !document.createElement || (this.getInstance(), this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside());
        }, v.componentDidUpdate = function() {
            this.componentNode = this.__getComponentNode();
        }, v.componentWillUnmount = function() {
            this.disableOnClickOutside();
        }, v.render = function() {
            var L = this.props;
            L.excludeScrollbar;
            var M = $0422a6ce4ea03acc$var$RZ(L, [
                "excludeScrollbar"
            ]);
            return r.prototype && r.prototype.isReactComponent ? M.ref = this.getRef : M.wrappedRef = this.getRef, M.disableOnClickOutside = this.disableOnClickOutside, M.enableOnClickOutside = this.enableOnClickOutside, (0, $acw62.createElement)(r, M);
        }, C;
    }((0, $acw62.Component)), o.displayName = "OnClickOutside(" + i + ")", o.defaultProps = {
        eventTypes: [
            "mousedown",
            "touchstart"
        ],
        excludeScrollbar: !1,
        outsideClickIgnoreClass: $0422a6ce4ea03acc$var$jZ,
        preventDefault: !1,
        stopPropagation: !1
    }, o.getClass = function() {
        return r.getClass ? r.getClass() : r;
    }, s;
}
var $0422a6ce4ea03acc$var$Ob = $acw62.createContext(), $0422a6ce4ea03acc$var$Nb = $acw62.createContext();
function $0422a6ce4ea03acc$var$zZ(r) {
    var a = r.children, o = $acw62.useState(null), s = o[0], i = o[1], p = $acw62.useRef(!1);
    $acw62.useEffect(function() {
        return function() {
            p.current = !0;
        };
    }, []);
    var C = $acw62.useCallback(function(v) {
        p.current || i(v);
    }, []);
    return /* @__PURE__ */ $acw62.createElement($0422a6ce4ea03acc$var$Ob.Provider, {
        value: s
    }, /* @__PURE__ */ $acw62.createElement($0422a6ce4ea03acc$var$Nb.Provider, {
        value: C
    }, a));
}
var $0422a6ce4ea03acc$var$Pb = function(a) {
    return Array.isArray(a) ? a[0] : a;
}, $0422a6ce4ea03acc$var$Bb = function(a) {
    if (typeof a == "function") {
        for(var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)s[i - 1] = arguments[i];
        return a.apply(void 0, s);
    }
}, $0422a6ce4ea03acc$var$Jp = function(a, o) {
    if (typeof a == "function") return $0422a6ce4ea03acc$var$Bb(a, o);
    a != null && (a.current = o);
}, $0422a6ce4ea03acc$var$nL = function(a) {
    return a.reduce(function(o, s) {
        var i = s[0], p = s[1];
        return o[i] = p, o;
    }, {});
}, $0422a6ce4ea03acc$var$rL = typeof window < "u" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect, $0422a6ce4ea03acc$var$I5 = "top", $0422a6ce4ea03acc$var$R6 = "bottom", $0422a6ce4ea03acc$var$Z6 = "right", $0422a6ce4ea03acc$var$$5 = "left", $0422a6ce4ea03acc$var$Sh = "auto", $0422a6ce4ea03acc$var$Io = [
    $0422a6ce4ea03acc$var$I5,
    $0422a6ce4ea03acc$var$R6,
    $0422a6ce4ea03acc$var$Z6,
    $0422a6ce4ea03acc$var$$5
], $0422a6ce4ea03acc$var$Xr = "start", $0422a6ce4ea03acc$var$Fo = "end", $0422a6ce4ea03acc$var$UZ = "clippingParents", $0422a6ce4ea03acc$var$Fb = "viewport", $0422a6ce4ea03acc$var$xo = "popper", $0422a6ce4ea03acc$var$IZ = "reference", $0422a6ce4ea03acc$var$aL = /* @__PURE__ */ $0422a6ce4ea03acc$var$Io.reduce(function(r, a) {
    return r.concat([
        a + "-" + $0422a6ce4ea03acc$var$Xr,
        a + "-" + $0422a6ce4ea03acc$var$Fo
    ]);
}, []), $0422a6ce4ea03acc$var$Ab = /* @__PURE__ */ [].concat($0422a6ce4ea03acc$var$Io, [
    $0422a6ce4ea03acc$var$Sh
]).reduce(function(r, a) {
    return r.concat([
        a,
        a + "-" + $0422a6ce4ea03acc$var$Xr,
        a + "-" + $0422a6ce4ea03acc$var$Fo
    ]);
}, []), $0422a6ce4ea03acc$var$$Z = "beforeRead", $0422a6ce4ea03acc$var$YZ = "read", $0422a6ce4ea03acc$var$WZ = "afterRead", $0422a6ce4ea03acc$var$QZ = "beforeMain", $0422a6ce4ea03acc$var$qZ = "main", $0422a6ce4ea03acc$var$GZ = "afterMain", $0422a6ce4ea03acc$var$XZ = "beforeWrite", $0422a6ce4ea03acc$var$KZ = "write", $0422a6ce4ea03acc$var$JZ = "afterWrite", $0422a6ce4ea03acc$var$eO = [
    $0422a6ce4ea03acc$var$$Z,
    $0422a6ce4ea03acc$var$YZ,
    $0422a6ce4ea03acc$var$WZ,
    $0422a6ce4ea03acc$var$QZ,
    $0422a6ce4ea03acc$var$qZ,
    $0422a6ce4ea03acc$var$GZ,
    $0422a6ce4ea03acc$var$XZ,
    $0422a6ce4ea03acc$var$KZ,
    $0422a6ce4ea03acc$var$JZ
];
function $0422a6ce4ea03acc$var$f8(r) {
    return r ? (r.nodeName || "").toLowerCase() : null;
}
function $0422a6ce4ea03acc$var$o6(r) {
    if (r == null) return window;
    if (r.toString() !== "[object Window]") {
        var a = r.ownerDocument;
        return a && a.defaultView || window;
    }
    return r;
}
function $0422a6ce4ea03acc$var$Dt(r) {
    var a = $0422a6ce4ea03acc$var$o6(r).Element;
    return r instanceof a || r instanceof Element;
}
function $0422a6ce4ea03acc$var$_6(r) {
    var a = $0422a6ce4ea03acc$var$o6(r).HTMLElement;
    return r instanceof a || r instanceof HTMLElement;
}
function $0422a6ce4ea03acc$var$kh(r) {
    if (typeof ShadowRoot > "u") return !1;
    var a = $0422a6ce4ea03acc$var$o6(r).ShadowRoot;
    return r instanceof a || r instanceof ShadowRoot;
}
function $0422a6ce4ea03acc$var$tO(r) {
    var a = r.state;
    Object.keys(a.elements).forEach(function(o) {
        var s = a.styles[o] || {}, i = a.attributes[o] || {}, p = a.elements[o];
        !$0422a6ce4ea03acc$var$_6(p) || !$0422a6ce4ea03acc$var$f8(p) || (Object.assign(p.style, s), Object.keys(i).forEach(function(C) {
            var v = i[C];
            v === !1 ? p.removeAttribute(C) : p.setAttribute(C, v === !0 ? "" : v);
        }));
    });
}
function $0422a6ce4ea03acc$var$nO(r) {
    var a = r.state, o = {
        popper: {
            position: a.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    return Object.assign(a.elements.popper.style, o.popper), a.styles = o, a.elements.arrow && Object.assign(a.elements.arrow.style, o.arrow), function() {
        Object.keys(a.elements).forEach(function(s) {
            var i = a.elements[s], p = a.attributes[s] || {}, C = Object.keys(a.styles.hasOwnProperty(s) ? a.styles[s] : o[s]), v = C.reduce(function(y, L) {
                return y[L] = "", y;
            }, {});
            !$0422a6ce4ea03acc$var$_6(i) || !$0422a6ce4ea03acc$var$f8(i) || (Object.assign(i.style, v), Object.keys(p).forEach(function(y) {
                i.removeAttribute(y);
            }));
        });
    };
}
const $0422a6ce4ea03acc$var$rO = {
    name: "applyStyles",
    enabled: !0,
    phase: "write",
    fn: $0422a6ce4ea03acc$var$tO,
    effect: $0422a6ce4ea03acc$var$nO,
    requires: [
        "computeStyles"
    ]
};
function $0422a6ce4ea03acc$var$C8(r) {
    return r.split("-")[0];
}
var $0422a6ce4ea03acc$var$Et = Math.max, $0422a6ce4ea03acc$var$dc = Math.min, $0422a6ce4ea03acc$var$Kr = Math.round;
function $0422a6ce4ea03acc$var$eh() {
    var r = navigator.userAgentData;
    return r != null && r.brands && Array.isArray(r.brands) ? r.brands.map(function(a) {
        return a.brand + "/" + a.version;
    }).join(" ") : navigator.userAgent;
}
function $0422a6ce4ea03acc$var$jb() {
    return !/^((?!chrome|android).)*safari/i.test($0422a6ce4ea03acc$var$eh());
}
function $0422a6ce4ea03acc$var$Jr(r, a, o) {
    a === void 0 && (a = !1), o === void 0 && (o = !1);
    var s = r.getBoundingClientRect(), i = 1, p = 1;
    a && $0422a6ce4ea03acc$var$_6(r) && (i = r.offsetWidth > 0 && $0422a6ce4ea03acc$var$Kr(s.width) / r.offsetWidth || 1, p = r.offsetHeight > 0 && $0422a6ce4ea03acc$var$Kr(s.height) / r.offsetHeight || 1);
    var C = $0422a6ce4ea03acc$var$Dt(r) ? $0422a6ce4ea03acc$var$o6(r) : window, v = C.visualViewport, y = !$0422a6ce4ea03acc$var$jb() && o, L = (s.left + (y && v ? v.offsetLeft : 0)) / i, M = (s.top + (y && v ? v.offsetTop : 0)) / p, E = s.width / i, k = s.height / p;
    return {
        width: E,
        height: k,
        top: M,
        right: L + E,
        bottom: M + k,
        left: L,
        x: L,
        y: M
    };
}
function $0422a6ce4ea03acc$var$Th(r) {
    var a = $0422a6ce4ea03acc$var$Jr(r), o = r.offsetWidth, s = r.offsetHeight;
    return Math.abs(a.width - o) <= 1 && (o = a.width), Math.abs(a.height - s) <= 1 && (s = a.height), {
        x: r.offsetLeft,
        y: r.offsetTop,
        width: o,
        height: s
    };
}
function $0422a6ce4ea03acc$var$zb(r, a) {
    var o = a.getRootNode && a.getRootNode();
    if (r.contains(a)) return !0;
    if (o && $0422a6ce4ea03acc$var$kh(o)) {
        var s = a;
        do {
            if (s && r.isSameNode(s)) return !0;
            s = s.parentNode || s.host;
        }while (s);
    }
    return !1;
}
function $0422a6ce4ea03acc$var$s9(r) {
    return $0422a6ce4ea03acc$var$o6(r).getComputedStyle(r);
}
function $0422a6ce4ea03acc$var$aO(r) {
    return [
        "table",
        "td",
        "th"
    ].indexOf($0422a6ce4ea03acc$var$f8(r)) >= 0;
}
function $0422a6ce4ea03acc$var$L0(r) {
    return (($0422a6ce4ea03acc$var$Dt(r) ? r.ownerDocument : // $FlowFixMe[prop-missing]
    r.document) || window.document).documentElement;
}
function $0422a6ce4ea03acc$var$Hc(r) {
    return $0422a6ce4ea03acc$var$f8(r) === "html" ? r : // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    r.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    r.parentNode || // DOM Element detected
    ($0422a6ce4ea03acc$var$kh(r) ? r.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    $0422a6ce4ea03acc$var$L0(r);
}
function $0422a6ce4ea03acc$var$iL(r) {
    return !$0422a6ce4ea03acc$var$_6(r) || // https://github.com/popperjs/popper-core/issues/837
    $0422a6ce4ea03acc$var$s9(r).position === "fixed" ? null : r.offsetParent;
}
function $0422a6ce4ea03acc$var$iO(r) {
    var a = /firefox/i.test($0422a6ce4ea03acc$var$eh()), o = /Trident/i.test($0422a6ce4ea03acc$var$eh());
    if (o && $0422a6ce4ea03acc$var$_6(r)) {
        var s = $0422a6ce4ea03acc$var$s9(r);
        if (s.position === "fixed") return null;
    }
    var i = $0422a6ce4ea03acc$var$Hc(r);
    for($0422a6ce4ea03acc$var$kh(i) && (i = i.host); $0422a6ce4ea03acc$var$_6(i) && [
        "html",
        "body"
    ].indexOf($0422a6ce4ea03acc$var$f8(i)) < 0;){
        var p = $0422a6ce4ea03acc$var$s9(i);
        if (p.transform !== "none" || p.perspective !== "none" || p.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(p.willChange) !== -1 || a && p.willChange === "filter" || a && p.filter && p.filter !== "none") return i;
        i = i.parentNode;
    }
    return null;
}
function $0422a6ce4ea03acc$var$$o(r) {
    for(var a = $0422a6ce4ea03acc$var$o6(r), o = $0422a6ce4ea03acc$var$iL(r); o && $0422a6ce4ea03acc$var$aO(o) && $0422a6ce4ea03acc$var$s9(o).position === "static";)o = $0422a6ce4ea03acc$var$iL(o);
    return o && ($0422a6ce4ea03acc$var$f8(o) === "html" || $0422a6ce4ea03acc$var$f8(o) === "body" && $0422a6ce4ea03acc$var$s9(o).position === "static") ? a : o || $0422a6ce4ea03acc$var$iO(r) || a;
}
function $0422a6ce4ea03acc$var$_h(r) {
    return [
        "top",
        "bottom"
    ].indexOf(r) >= 0 ? "x" : "y";
}
function $0422a6ce4ea03acc$var$To(r, a, o) {
    return $0422a6ce4ea03acc$var$Et(r, $0422a6ce4ea03acc$var$dc(a, o));
}
function $0422a6ce4ea03acc$var$oO(r, a, o) {
    var s = $0422a6ce4ea03acc$var$To(r, a, o);
    return s > o ? o : s;
}
function $0422a6ce4ea03acc$var$Ub() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}
function $0422a6ce4ea03acc$var$Ib(r) {
    return Object.assign({}, $0422a6ce4ea03acc$var$Ub(), r);
}
function $0422a6ce4ea03acc$var$$b(r, a) {
    return a.reduce(function(o, s) {
        return o[s] = r, o;
    }, {});
}
var $0422a6ce4ea03acc$var$lO = function(a, o) {
    return a = typeof a == "function" ? a(Object.assign({}, o.rects, {
        placement: o.placement
    })) : a, $0422a6ce4ea03acc$var$Ib(typeof a != "number" ? a : $0422a6ce4ea03acc$var$$b(a, $0422a6ce4ea03acc$var$Io));
};
function $0422a6ce4ea03acc$var$sO(r) {
    var a, o = r.state, s = r.name, i = r.options, p = o.elements.arrow, C = o.modifiersData.popperOffsets, v = $0422a6ce4ea03acc$var$C8(o.placement), y = $0422a6ce4ea03acc$var$_h(v), L = [
        $0422a6ce4ea03acc$var$$5,
        $0422a6ce4ea03acc$var$Z6
    ].indexOf(v) >= 0, M = L ? "height" : "width";
    if (!(!p || !C)) {
        var E = $0422a6ce4ea03acc$var$lO(i.padding, o), k = $0422a6ce4ea03acc$var$Th(p), _ = y === "y" ? $0422a6ce4ea03acc$var$I5 : $0422a6ce4ea03acc$var$$5, Z = y === "y" ? $0422a6ce4ea03acc$var$R6 : $0422a6ce4ea03acc$var$Z6, O = o.rects.reference[M] + o.rects.reference[y] - C[y] - o.rects.popper[M], B = C[y] - o.rects.reference[y], z = $0422a6ce4ea03acc$var$$o(p), I = z ? y === "y" ? z.clientHeight || 0 : z.clientWidth || 0 : 0, P = O / 2 - B / 2, $ = E[_], W = I - k[M] - E[Z], l1 = I / 2 - k[M] / 2 + P, u1 = $0422a6ce4ea03acc$var$To($, l1, W), m1 = y;
        o.modifiersData[s] = (a = {}, a[m1] = u1, a.centerOffset = u1 - l1, a);
    }
}
function $0422a6ce4ea03acc$var$uO(r) {
    var a = r.state, o = r.options, s = o.element, i = s === void 0 ? "[data-popper-arrow]" : s;
    i != null && (typeof i == "string" && (i = a.elements.popper.querySelector(i), !i) || $0422a6ce4ea03acc$var$zb(a.elements.popper, i) && (a.elements.arrow = i));
}
const $0422a6ce4ea03acc$var$cO = {
    name: "arrow",
    enabled: !0,
    phase: "main",
    fn: $0422a6ce4ea03acc$var$sO,
    effect: $0422a6ce4ea03acc$var$uO,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};
function $0422a6ce4ea03acc$var$ea(r) {
    return r.split("-")[1];
}
var $0422a6ce4ea03acc$var$dO = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
};
function $0422a6ce4ea03acc$var$CO(r, a) {
    var o = r.x, s = r.y, i = a.devicePixelRatio || 1;
    return {
        x: $0422a6ce4ea03acc$var$Kr(o * i) / i || 0,
        y: $0422a6ce4ea03acc$var$Kr(s * i) / i || 0
    };
}
function $0422a6ce4ea03acc$var$oL(r) {
    var a, o = r.popper, s = r.popperRect, i = r.placement, p = r.variation, C = r.offsets, v = r.position, y = r.gpuAcceleration, L = r.adaptive, M = r.roundOffsets, E = r.isFixed, k = C.x, _ = k === void 0 ? 0 : k, Z = C.y, O = Z === void 0 ? 0 : Z, B = typeof M == "function" ? M({
        x: _,
        y: O
    }) : {
        x: _,
        y: O
    };
    _ = B.x, O = B.y;
    var z = C.hasOwnProperty("x"), I = C.hasOwnProperty("y"), P = $0422a6ce4ea03acc$var$$5, $ = $0422a6ce4ea03acc$var$I5, W = window;
    if (L) {
        var l1 = $0422a6ce4ea03acc$var$$o(o), u1 = "clientHeight", m1 = "clientWidth";
        if (l1 === $0422a6ce4ea03acc$var$o6(o) && (l1 = $0422a6ce4ea03acc$var$L0(o), $0422a6ce4ea03acc$var$s9(l1).position !== "static" && v === "absolute" && (u1 = "scrollHeight", m1 = "scrollWidth")), l1, i === $0422a6ce4ea03acc$var$I5 || (i === $0422a6ce4ea03acc$var$$5 || i === $0422a6ce4ea03acc$var$Z6) && p === $0422a6ce4ea03acc$var$Fo) {
            $ = $0422a6ce4ea03acc$var$R6;
            var L1 = E && l1 === W && W.visualViewport ? W.visualViewport.height : // $FlowFixMe[prop-missing]
            l1[u1];
            O -= L1 - s.height, O *= y ? 1 : -1;
        }
        if (i === $0422a6ce4ea03acc$var$$5 || (i === $0422a6ce4ea03acc$var$I5 || i === $0422a6ce4ea03acc$var$R6) && p === $0422a6ce4ea03acc$var$Fo) {
            P = $0422a6ce4ea03acc$var$Z6;
            var E1 = E && l1 === W && W.visualViewport ? W.visualViewport.width : // $FlowFixMe[prop-missing]
            l1[m1];
            _ -= E1 - s.width, _ *= y ? 1 : -1;
        }
    }
    var H1 = Object.assign({
        position: v
    }, L && $0422a6ce4ea03acc$var$dO), B1 = M === !0 ? $0422a6ce4ea03acc$var$CO({
        x: _,
        y: O
    }, $0422a6ce4ea03acc$var$o6(o)) : {
        x: _,
        y: O
    };
    if (_ = B1.x, O = B1.y, y) {
        var h1;
        return Object.assign({}, H1, (h1 = {}, h1[$] = I ? "0" : "", h1[P] = z ? "0" : "", h1.transform = (W.devicePixelRatio || 1) <= 1 ? "translate(" + _ + "px, " + O + "px)" : "translate3d(" + _ + "px, " + O + "px, 0)", h1));
    }
    return Object.assign({}, H1, (a = {}, a[$] = I ? O + "px" : "", a[P] = z ? _ + "px" : "", a.transform = "", a));
}
function $0422a6ce4ea03acc$var$fO(r) {
    var a = r.state, o = r.options, s = o.gpuAcceleration, i = s === void 0 ? !0 : s, p = o.adaptive, C = p === void 0 ? !0 : p, v = o.roundOffsets, y = v === void 0 ? !0 : v, L = {
        placement: $0422a6ce4ea03acc$var$C8(a.placement),
        variation: $0422a6ce4ea03acc$var$ea(a.placement),
        popper: a.elements.popper,
        popperRect: a.rects.popper,
        gpuAcceleration: i,
        isFixed: a.options.strategy === "fixed"
    };
    a.modifiersData.popperOffsets != null && (a.styles.popper = Object.assign({}, a.styles.popper, $0422a6ce4ea03acc$var$oL(Object.assign({}, L, {
        offsets: a.modifiersData.popperOffsets,
        position: a.options.strategy,
        adaptive: C,
        roundOffsets: y
    })))), a.modifiersData.arrow != null && (a.styles.arrow = Object.assign({}, a.styles.arrow, $0422a6ce4ea03acc$var$oL(Object.assign({}, L, {
        offsets: a.modifiersData.arrow,
        position: "absolute",
        adaptive: !1,
        roundOffsets: y
    })))), a.attributes.popper = Object.assign({}, a.attributes.popper, {
        "data-popper-placement": a.placement
    });
}
const $0422a6ce4ea03acc$var$pO = {
    name: "computeStyles",
    enabled: !0,
    phase: "beforeWrite",
    fn: $0422a6ce4ea03acc$var$fO,
    data: {}
};
var $0422a6ce4ea03acc$var$zu = {
    passive: !0
};
function $0422a6ce4ea03acc$var$hO(r) {
    var a = r.state, o = r.instance, s = r.options, i = s.scroll, p = i === void 0 ? !0 : i, C = s.resize, v = C === void 0 ? !0 : C, y = $0422a6ce4ea03acc$var$o6(a.elements.popper), L = [].concat(a.scrollParents.reference, a.scrollParents.popper);
    return p && L.forEach(function(M) {
        M.addEventListener("scroll", o.update, $0422a6ce4ea03acc$var$zu);
    }), v && y.addEventListener("resize", o.update, $0422a6ce4ea03acc$var$zu), function() {
        p && L.forEach(function(M) {
            M.removeEventListener("scroll", o.update, $0422a6ce4ea03acc$var$zu);
        }), v && y.removeEventListener("resize", o.update, $0422a6ce4ea03acc$var$zu);
    };
}
const $0422a6ce4ea03acc$var$mO = {
    name: "eventListeners",
    enabled: !0,
    phase: "write",
    fn: function() {},
    effect: $0422a6ce4ea03acc$var$hO,
    data: {}
};
var $0422a6ce4ea03acc$var$vO = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $0422a6ce4ea03acc$var$Qu(r) {
    return r.replace(/left|right|bottom|top/g, function(a) {
        return $0422a6ce4ea03acc$var$vO[a];
    });
}
var $0422a6ce4ea03acc$var$gO = {
    start: "end",
    end: "start"
};
function $0422a6ce4ea03acc$var$lL(r) {
    return r.replace(/start|end/g, function(a) {
        return $0422a6ce4ea03acc$var$gO[a];
    });
}
function $0422a6ce4ea03acc$var$Dh(r) {
    var a = $0422a6ce4ea03acc$var$o6(r), o = a.pageXOffset, s = a.pageYOffset;
    return {
        scrollLeft: o,
        scrollTop: s
    };
}
function $0422a6ce4ea03acc$var$Rh(r) {
    return $0422a6ce4ea03acc$var$Jr($0422a6ce4ea03acc$var$L0(r)).left + $0422a6ce4ea03acc$var$Dh(r).scrollLeft;
}
function $0422a6ce4ea03acc$var$yO(r, a) {
    var o = $0422a6ce4ea03acc$var$o6(r), s = $0422a6ce4ea03acc$var$L0(r), i = o.visualViewport, p = s.clientWidth, C = s.clientHeight, v = 0, y = 0;
    if (i) {
        p = i.width, C = i.height;
        var L = $0422a6ce4ea03acc$var$jb();
        (L || !L && a === "fixed") && (v = i.offsetLeft, y = i.offsetTop);
    }
    return {
        width: p,
        height: C,
        x: v + $0422a6ce4ea03acc$var$Rh(r),
        y: y
    };
}
function $0422a6ce4ea03acc$var$LO(r) {
    var a, o = $0422a6ce4ea03acc$var$L0(r), s = $0422a6ce4ea03acc$var$Dh(r), i = (a = r.ownerDocument) == null ? void 0 : a.body, p = $0422a6ce4ea03acc$var$Et(o.scrollWidth, o.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), C = $0422a6ce4ea03acc$var$Et(o.scrollHeight, o.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), v = -s.scrollLeft + $0422a6ce4ea03acc$var$Rh(r), y = -s.scrollTop;
    return $0422a6ce4ea03acc$var$s9(i || o).direction === "rtl" && (v += $0422a6ce4ea03acc$var$Et(o.clientWidth, i ? i.clientWidth : 0) - p), {
        width: p,
        height: C,
        x: v,
        y: y
    };
}
function $0422a6ce4ea03acc$var$Zh(r) {
    var a = $0422a6ce4ea03acc$var$s9(r), o = a.overflow, s = a.overflowX, i = a.overflowY;
    return /auto|scroll|overlay|hidden/.test(o + i + s);
}
function $0422a6ce4ea03acc$var$Yb(r) {
    return [
        "html",
        "body",
        "#document"
    ].indexOf($0422a6ce4ea03acc$var$f8(r)) >= 0 ? r.ownerDocument.body : $0422a6ce4ea03acc$var$_6(r) && $0422a6ce4ea03acc$var$Zh(r) ? r : $0422a6ce4ea03acc$var$Yb($0422a6ce4ea03acc$var$Hc(r));
}
function $0422a6ce4ea03acc$var$_o(r, a) {
    var o;
    a === void 0 && (a = []);
    var s = $0422a6ce4ea03acc$var$Yb(r), i = s === ((o = r.ownerDocument) == null ? void 0 : o.body), p = $0422a6ce4ea03acc$var$o6(s), C = i ? [
        p
    ].concat(p.visualViewport || [], $0422a6ce4ea03acc$var$Zh(s) ? s : []) : s, v = a.concat(C);
    return i ? v : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    v.concat($0422a6ce4ea03acc$var$_o($0422a6ce4ea03acc$var$Hc(C)));
}
function $0422a6ce4ea03acc$var$th(r) {
    return Object.assign({}, r, {
        left: r.x,
        top: r.y,
        right: r.x + r.width,
        bottom: r.y + r.height
    });
}
function $0422a6ce4ea03acc$var$bO(r, a) {
    var o = $0422a6ce4ea03acc$var$Jr(r, !1, a === "fixed");
    return o.top = o.top + r.clientTop, o.left = o.left + r.clientLeft, o.bottom = o.top + r.clientHeight, o.right = o.left + r.clientWidth, o.width = r.clientWidth, o.height = r.clientHeight, o.x = o.left, o.y = o.top, o;
}
function $0422a6ce4ea03acc$var$sL(r, a, o) {
    return a === $0422a6ce4ea03acc$var$Fb ? $0422a6ce4ea03acc$var$th($0422a6ce4ea03acc$var$yO(r, o)) : $0422a6ce4ea03acc$var$Dt(a) ? $0422a6ce4ea03acc$var$bO(a, o) : $0422a6ce4ea03acc$var$th($0422a6ce4ea03acc$var$LO($0422a6ce4ea03acc$var$L0(r)));
}
function $0422a6ce4ea03acc$var$wO(r) {
    var a = $0422a6ce4ea03acc$var$_o($0422a6ce4ea03acc$var$Hc(r)), o = [
        "absolute",
        "fixed"
    ].indexOf($0422a6ce4ea03acc$var$s9(r).position) >= 0, s = o && $0422a6ce4ea03acc$var$_6(r) ? $0422a6ce4ea03acc$var$$o(r) : r;
    return $0422a6ce4ea03acc$var$Dt(s) ? a.filter(function(i) {
        return $0422a6ce4ea03acc$var$Dt(i) && $0422a6ce4ea03acc$var$zb(i, s) && $0422a6ce4ea03acc$var$f8(i) !== "body";
    }) : [];
}
function $0422a6ce4ea03acc$var$HO(r, a, o, s) {
    var i = a === "clippingParents" ? $0422a6ce4ea03acc$var$wO(r) : [].concat(a), p = [].concat(i, [
        o
    ]), C = p[0], v = p.reduce(function(y, L) {
        var M = $0422a6ce4ea03acc$var$sL(r, L, s);
        return y.top = $0422a6ce4ea03acc$var$Et(M.top, y.top), y.right = $0422a6ce4ea03acc$var$dc(M.right, y.right), y.bottom = $0422a6ce4ea03acc$var$dc(M.bottom, y.bottom), y.left = $0422a6ce4ea03acc$var$Et(M.left, y.left), y;
    }, $0422a6ce4ea03acc$var$sL(r, C, s));
    return v.width = v.right - v.left, v.height = v.bottom - v.top, v.x = v.left, v.y = v.top, v;
}
function $0422a6ce4ea03acc$var$Wb(r) {
    var a = r.reference, o = r.element, s = r.placement, i = s ? $0422a6ce4ea03acc$var$C8(s) : null, p = s ? $0422a6ce4ea03acc$var$ea(s) : null, C = a.x + a.width / 2 - o.width / 2, v = a.y + a.height / 2 - o.height / 2, y;
    switch(i){
        case $0422a6ce4ea03acc$var$I5:
            y = {
                x: C,
                y: a.y - o.height
            };
            break;
        case $0422a6ce4ea03acc$var$R6:
            y = {
                x: C,
                y: a.y + a.height
            };
            break;
        case $0422a6ce4ea03acc$var$Z6:
            y = {
                x: a.x + a.width,
                y: v
            };
            break;
        case $0422a6ce4ea03acc$var$$5:
            y = {
                x: a.x - o.width,
                y: v
            };
            break;
        default:
            y = {
                x: a.x,
                y: a.y
            };
    }
    var L = i ? $0422a6ce4ea03acc$var$_h(i) : null;
    if (L != null) {
        var M = L === "y" ? "height" : "width";
        switch(p){
            case $0422a6ce4ea03acc$var$Xr:
                y[L] = y[L] - (a[M] / 2 - o[M] / 2);
                break;
            case $0422a6ce4ea03acc$var$Fo:
                y[L] = y[L] + (a[M] / 2 - o[M] / 2);
                break;
        }
    }
    return y;
}
function $0422a6ce4ea03acc$var$Ao(r, a) {
    a === void 0 && (a = {});
    var o = a, s = o.placement, i = s === void 0 ? r.placement : s, p = o.strategy, C = p === void 0 ? r.strategy : p, v = o.boundary, y = v === void 0 ? $0422a6ce4ea03acc$var$UZ : v, L = o.rootBoundary, M = L === void 0 ? $0422a6ce4ea03acc$var$Fb : L, E = o.elementContext, k = E === void 0 ? $0422a6ce4ea03acc$var$xo : E, _ = o.altBoundary, Z = _ === void 0 ? !1 : _, O = o.padding, B = O === void 0 ? 0 : O, z = $0422a6ce4ea03acc$var$Ib(typeof B != "number" ? B : $0422a6ce4ea03acc$var$$b(B, $0422a6ce4ea03acc$var$Io)), I = k === $0422a6ce4ea03acc$var$xo ? $0422a6ce4ea03acc$var$IZ : $0422a6ce4ea03acc$var$xo, P = r.rects.popper, $ = r.elements[Z ? I : k], W = $0422a6ce4ea03acc$var$HO($0422a6ce4ea03acc$var$Dt($) ? $ : $.contextElement || $0422a6ce4ea03acc$var$L0(r.elements.popper), y, M, C), l1 = $0422a6ce4ea03acc$var$Jr(r.elements.reference), u1 = $0422a6ce4ea03acc$var$Wb({
        reference: l1,
        element: P,
        strategy: "absolute",
        placement: i
    }), m1 = $0422a6ce4ea03acc$var$th(Object.assign({}, P, u1)), L1 = k === $0422a6ce4ea03acc$var$xo ? m1 : l1, E1 = {
        top: W.top - L1.top + z.top,
        bottom: L1.bottom - W.bottom + z.bottom,
        left: W.left - L1.left + z.left,
        right: L1.right - W.right + z.right
    }, H1 = r.modifiersData.offset;
    if (k === $0422a6ce4ea03acc$var$xo && H1) {
        var B1 = H1[i];
        Object.keys(E1).forEach(function(h1) {
            var k1 = [
                $0422a6ce4ea03acc$var$Z6,
                $0422a6ce4ea03acc$var$R6
            ].indexOf(h1) >= 0 ? 1 : -1, I1 = [
                $0422a6ce4ea03acc$var$I5,
                $0422a6ce4ea03acc$var$R6
            ].indexOf(h1) >= 0 ? "y" : "x";
            E1[h1] += B1[I1] * k1;
        });
    }
    return E1;
}
function $0422a6ce4ea03acc$var$xO(r, a) {
    a === void 0 && (a = {});
    var o = a, s = o.placement, i = o.boundary, p = o.rootBoundary, C = o.padding, v = o.flipVariations, y = o.allowedAutoPlacements, L = y === void 0 ? $0422a6ce4ea03acc$var$Ab : y, M = $0422a6ce4ea03acc$var$ea(s), E = M ? v ? $0422a6ce4ea03acc$var$aL : $0422a6ce4ea03acc$var$aL.filter(function(Z) {
        return $0422a6ce4ea03acc$var$ea(Z) === M;
    }) : $0422a6ce4ea03acc$var$Io, k = E.filter(function(Z) {
        return L.indexOf(Z) >= 0;
    });
    k.length === 0 && (k = E);
    var _ = k.reduce(function(Z, O) {
        return Z[O] = $0422a6ce4ea03acc$var$Ao(r, {
            placement: O,
            boundary: i,
            rootBoundary: p,
            padding: C
        })[$0422a6ce4ea03acc$var$C8(O)], Z;
    }, {});
    return Object.keys(_).sort(function(Z, O) {
        return _[Z] - _[O];
    });
}
function $0422a6ce4ea03acc$var$VO(r) {
    if ($0422a6ce4ea03acc$var$C8(r) === $0422a6ce4ea03acc$var$Sh) return [];
    var a = $0422a6ce4ea03acc$var$Qu(r);
    return [
        $0422a6ce4ea03acc$var$lL(r),
        a,
        $0422a6ce4ea03acc$var$lL(a)
    ];
}
function $0422a6ce4ea03acc$var$MO(r) {
    var a = r.state, o = r.options, s = r.name;
    if (!a.modifiersData[s]._skip) {
        for(var i = o.mainAxis, p = i === void 0 ? !0 : i, C = o.altAxis, v = C === void 0 ? !0 : C, y = o.fallbackPlacements, L = o.padding, M = o.boundary, E = o.rootBoundary, k = o.altBoundary, _ = o.flipVariations, Z = _ === void 0 ? !0 : _, O = o.allowedAutoPlacements, B = a.options.placement, z = $0422a6ce4ea03acc$var$C8(B), I = z === B, P = y || (I || !Z ? [
            $0422a6ce4ea03acc$var$Qu(B)
        ] : $0422a6ce4ea03acc$var$VO(B)), $ = [
            B
        ].concat(P).reduce(function(E2, a3) {
            return E2.concat($0422a6ce4ea03acc$var$C8(a3) === $0422a6ce4ea03acc$var$Sh ? $0422a6ce4ea03acc$var$xO(a, {
                placement: a3,
                boundary: M,
                rootBoundary: E,
                padding: L,
                flipVariations: Z,
                allowedAutoPlacements: O
            }) : a3);
        }, []), W = a.rects.reference, l1 = a.rects.popper, u1 = /* @__PURE__ */ new Map(), m1 = !0, L1 = $[0], E1 = 0; E1 < $.length; E1++){
            var H1 = $[E1], B1 = $0422a6ce4ea03acc$var$C8(H1), h1 = $0422a6ce4ea03acc$var$ea(H1) === $0422a6ce4ea03acc$var$Xr, k1 = [
                $0422a6ce4ea03acc$var$I5,
                $0422a6ce4ea03acc$var$R6
            ].indexOf(B1) >= 0, I1 = k1 ? "width" : "height", D1 = $0422a6ce4ea03acc$var$Ao(a, {
                placement: H1,
                boundary: M,
                rootBoundary: E,
                altBoundary: k,
                padding: L
            }), s2 = k1 ? h1 ? $0422a6ce4ea03acc$var$Z6 : $0422a6ce4ea03acc$var$$5 : h1 ? $0422a6ce4ea03acc$var$R6 : $0422a6ce4ea03acc$var$I5;
            W[I1] > l1[I1] && (s2 = $0422a6ce4ea03acc$var$Qu(s2));
            var f1 = $0422a6ce4ea03acc$var$Qu(s2), M1 = [];
            if (p && M1.push(D1[B1] <= 0), v && M1.push(D1[s2] <= 0, D1[f1] <= 0), M1.every(function(E2) {
                return E2;
            })) {
                L1 = H1, m1 = !1;
                break;
            }
            u1.set(H1, M1);
        }
        if (m1) for(var g1 = Z ? 3 : 1, K1 = function(a3) {
            var H2 = $.find(function(A2) {
                var u2 = u1.get(A2);
                if (u2) return u2.slice(0, a3).every(function(o2) {
                    return o2;
                });
            });
            if (H2) return L1 = H2, "break";
        }, G1 = g1; G1 > 0; G1--){
            var R1 = K1(G1);
            if (R1 === "break") break;
        }
        a.placement !== L1 && (a.modifiersData[s]._skip = !0, a.placement = L1, a.reset = !0);
    }
}
const $0422a6ce4ea03acc$var$EO = {
    name: "flip",
    enabled: !0,
    phase: "main",
    fn: $0422a6ce4ea03acc$var$MO,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: !1
    }
};
function $0422a6ce4ea03acc$var$uL(r, a, o) {
    return o === void 0 && (o = {
        x: 0,
        y: 0
    }), {
        top: r.top - a.height - o.y,
        right: r.right - a.width + o.x,
        bottom: r.bottom - a.height + o.y,
        left: r.left - a.width - o.x
    };
}
function $0422a6ce4ea03acc$var$cL(r) {
    return [
        $0422a6ce4ea03acc$var$I5,
        $0422a6ce4ea03acc$var$Z6,
        $0422a6ce4ea03acc$var$R6,
        $0422a6ce4ea03acc$var$$5
    ].some(function(a) {
        return r[a] >= 0;
    });
}
function $0422a6ce4ea03acc$var$SO(r) {
    var a = r.state, o = r.name, s = a.rects.reference, i = a.rects.popper, p = a.modifiersData.preventOverflow, C = $0422a6ce4ea03acc$var$Ao(a, {
        elementContext: "reference"
    }), v = $0422a6ce4ea03acc$var$Ao(a, {
        altBoundary: !0
    }), y = $0422a6ce4ea03acc$var$uL(C, s), L = $0422a6ce4ea03acc$var$uL(v, i, p), M = $0422a6ce4ea03acc$var$cL(y), E = $0422a6ce4ea03acc$var$cL(L);
    a.modifiersData[o] = {
        referenceClippingOffsets: y,
        popperEscapeOffsets: L,
        isReferenceHidden: M,
        hasPopperEscaped: E
    }, a.attributes.popper = Object.assign({}, a.attributes.popper, {
        "data-popper-reference-hidden": M,
        "data-popper-escaped": E
    });
}
const $0422a6ce4ea03acc$var$kO = {
    name: "hide",
    enabled: !0,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $0422a6ce4ea03acc$var$SO
};
function $0422a6ce4ea03acc$var$TO(r, a, o) {
    var s = $0422a6ce4ea03acc$var$C8(r), i = [
        $0422a6ce4ea03acc$var$$5,
        $0422a6ce4ea03acc$var$I5
    ].indexOf(s) >= 0 ? -1 : 1, p = typeof o == "function" ? o(Object.assign({}, a, {
        placement: r
    })) : o, C = p[0], v = p[1];
    return C = C || 0, v = (v || 0) * i, [
        $0422a6ce4ea03acc$var$$5,
        $0422a6ce4ea03acc$var$Z6
    ].indexOf(s) >= 0 ? {
        x: v,
        y: C
    } : {
        x: C,
        y: v
    };
}
function $0422a6ce4ea03acc$var$_O(r) {
    var a = r.state, o = r.options, s = r.name, i = o.offset, p = i === void 0 ? [
        0,
        0
    ] : i, C = $0422a6ce4ea03acc$var$Ab.reduce(function(M, E) {
        return M[E] = $0422a6ce4ea03acc$var$TO(E, a.rects, p), M;
    }, {}), v = C[a.placement], y = v.x, L = v.y;
    a.modifiersData.popperOffsets != null && (a.modifiersData.popperOffsets.x += y, a.modifiersData.popperOffsets.y += L), a.modifiersData[s] = C;
}
const $0422a6ce4ea03acc$var$DO = {
    name: "offset",
    enabled: !0,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $0422a6ce4ea03acc$var$_O
};
function $0422a6ce4ea03acc$var$RO(r) {
    var a = r.state, o = r.name;
    a.modifiersData[o] = $0422a6ce4ea03acc$var$Wb({
        reference: a.rects.reference,
        element: a.rects.popper,
        strategy: "absolute",
        placement: a.placement
    });
}
const $0422a6ce4ea03acc$var$ZO = {
    name: "popperOffsets",
    enabled: !0,
    phase: "read",
    fn: $0422a6ce4ea03acc$var$RO,
    data: {}
};
function $0422a6ce4ea03acc$var$OO(r) {
    return r === "x" ? "y" : "x";
}
function $0422a6ce4ea03acc$var$NO(r) {
    var a = r.state, o = r.options, s = r.name, i = o.mainAxis, p = i === void 0 ? !0 : i, C = o.altAxis, v = C === void 0 ? !1 : C, y = o.boundary, L = o.rootBoundary, M = o.altBoundary, E = o.padding, k = o.tether, _ = k === void 0 ? !0 : k, Z = o.tetherOffset, O = Z === void 0 ? 0 : Z, B = $0422a6ce4ea03acc$var$Ao(a, {
        boundary: y,
        rootBoundary: L,
        padding: E,
        altBoundary: M
    }), z = $0422a6ce4ea03acc$var$C8(a.placement), I = $0422a6ce4ea03acc$var$ea(a.placement), P = !I, $ = $0422a6ce4ea03acc$var$_h(z), W = $0422a6ce4ea03acc$var$OO($), l1 = a.modifiersData.popperOffsets, u1 = a.rects.reference, m1 = a.rects.popper, L1 = typeof O == "function" ? O(Object.assign({}, a.rects, {
        placement: a.placement
    })) : O, E1 = typeof L1 == "number" ? {
        mainAxis: L1,
        altAxis: L1
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, L1), H1 = a.modifiersData.offset ? a.modifiersData.offset[a.placement] : null, B1 = {
        x: 0,
        y: 0
    };
    if (l1) {
        if (p) {
            var h1, k1 = $ === "y" ? $0422a6ce4ea03acc$var$I5 : $0422a6ce4ea03acc$var$$5, I1 = $ === "y" ? $0422a6ce4ea03acc$var$R6 : $0422a6ce4ea03acc$var$Z6, D1 = $ === "y" ? "height" : "width", s2 = l1[$], f1 = s2 + B[k1], M1 = s2 - B[I1], g1 = _ ? -m1[D1] / 2 : 0, K1 = I === $0422a6ce4ea03acc$var$Xr ? u1[D1] : m1[D1], G1 = I === $0422a6ce4ea03acc$var$Xr ? -m1[D1] : -u1[D1], R1 = a.elements.arrow, E2 = _ && R1 ? $0422a6ce4ea03acc$var$Th(R1) : {
                width: 0,
                height: 0
            }, a3 = a.modifiersData["arrow#persistent"] ? a.modifiersData["arrow#persistent"].padding : $0422a6ce4ea03acc$var$Ub(), H2 = a3[k1], A2 = a3[I1], u2 = $0422a6ce4ea03acc$var$To(0, u1[D1], E2[D1]), o2 = P ? u1[D1] / 2 - g1 - u2 - H2 - E1.mainAxis : K1 - u2 - H2 - E1.mainAxis, P2 = P ? -u1[D1] / 2 + g1 + u2 + A2 + E1.mainAxis : G1 + u2 + A2 + E1.mainAxis, G2 = a.elements.arrow && $0422a6ce4ea03acc$var$$o(a.elements.arrow), V3 = G2 ? $ === "y" ? G2.clientTop || 0 : G2.clientLeft || 0 : 0, I2 = (h1 = H1 == null ? void 0 : H1[$]) != null ? h1 : 0, T1 = s2 + o2 - I2 - V3, j1 = s2 + P2 - I2, N2 = $0422a6ce4ea03acc$var$To(_ ? $0422a6ce4ea03acc$var$dc(f1, T1) : f1, s2, _ ? $0422a6ce4ea03acc$var$Et(M1, j1) : M1);
            l1[$] = N2, B1[$] = N2 - s2;
        }
        if (v) {
            var _2, R3 = $ === "x" ? $0422a6ce4ea03acc$var$I5 : $0422a6ce4ea03acc$var$$5, he = $ === "x" ? $0422a6ce4ea03acc$var$R6 : $0422a6ce4ea03acc$var$Z6, j3 = l1[W], ee = W === "y" ? "height" : "width", me = j3 + B[R3], D2 = j3 - B[he], z3 = [
                $0422a6ce4ea03acc$var$I5,
                $0422a6ce4ea03acc$var$$5
            ].indexOf(z) !== -1, se = (_2 = H1 == null ? void 0 : H1[W]) != null ? _2 : 0, c4 = z3 ? me : j3 - u1[ee] - m1[ee] - se + E1.altAxis, U3 = z3 ? j3 + u1[ee] + m1[ee] - se - E1.altAxis : D2, ve = _ && z3 ? $0422a6ce4ea03acc$var$oO(c4, j3, U3) : $0422a6ce4ea03acc$var$To(_ ? c4 : me, j3, _ ? U3 : D2);
            l1[W] = ve, B1[W] = ve - j3;
        }
        a.modifiersData[s] = B1;
    }
}
const $0422a6ce4ea03acc$var$PO = {
    name: "preventOverflow",
    enabled: !0,
    phase: "main",
    fn: $0422a6ce4ea03acc$var$NO,
    requiresIfExists: [
        "offset"
    ]
};
function $0422a6ce4ea03acc$var$BO(r) {
    return {
        scrollLeft: r.scrollLeft,
        scrollTop: r.scrollTop
    };
}
function $0422a6ce4ea03acc$var$FO(r) {
    return r === $0422a6ce4ea03acc$var$o6(r) || !$0422a6ce4ea03acc$var$_6(r) ? $0422a6ce4ea03acc$var$Dh(r) : $0422a6ce4ea03acc$var$BO(r);
}
function $0422a6ce4ea03acc$var$AO(r) {
    var a = r.getBoundingClientRect(), o = $0422a6ce4ea03acc$var$Kr(a.width) / r.offsetWidth || 1, s = $0422a6ce4ea03acc$var$Kr(a.height) / r.offsetHeight || 1;
    return o !== 1 || s !== 1;
}
function $0422a6ce4ea03acc$var$jO(r, a, o) {
    o === void 0 && (o = !1);
    var s = $0422a6ce4ea03acc$var$_6(a), i = $0422a6ce4ea03acc$var$_6(a) && $0422a6ce4ea03acc$var$AO(a), p = $0422a6ce4ea03acc$var$L0(a), C = $0422a6ce4ea03acc$var$Jr(r, i, o), v = {
        scrollLeft: 0,
        scrollTop: 0
    }, y = {
        x: 0,
        y: 0
    };
    return (s || !s && !o) && (($0422a6ce4ea03acc$var$f8(a) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
    $0422a6ce4ea03acc$var$Zh(p)) && (v = $0422a6ce4ea03acc$var$FO(a)), $0422a6ce4ea03acc$var$_6(a) ? (y = $0422a6ce4ea03acc$var$Jr(a, !0), y.x += a.clientLeft, y.y += a.clientTop) : p && (y.x = $0422a6ce4ea03acc$var$Rh(p))), {
        x: C.left + v.scrollLeft - y.x,
        y: C.top + v.scrollTop - y.y,
        width: C.width,
        height: C.height
    };
}
function $0422a6ce4ea03acc$var$zO(r) {
    var a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set(), s = [];
    r.forEach(function(p) {
        a.set(p.name, p);
    });
    function i(p) {
        o.add(p.name);
        var C = [].concat(p.requires || [], p.requiresIfExists || []);
        C.forEach(function(v) {
            if (!o.has(v)) {
                var y = a.get(v);
                y && i(y);
            }
        }), s.push(p);
    }
    return r.forEach(function(p) {
        o.has(p.name) || i(p);
    }), s;
}
function $0422a6ce4ea03acc$var$UO(r) {
    var a = $0422a6ce4ea03acc$var$zO(r);
    return $0422a6ce4ea03acc$var$eO.reduce(function(o, s) {
        return o.concat(a.filter(function(i) {
            return i.phase === s;
        }));
    }, []);
}
function $0422a6ce4ea03acc$var$IO(r) {
    var a;
    return function() {
        return a || (a = new Promise(function(o) {
            Promise.resolve().then(function() {
                a = void 0, o(r());
            });
        })), a;
    };
}
function $0422a6ce4ea03acc$var$$O(r) {
    var a = r.reduce(function(o, s) {
        var i = o[s.name];
        return o[s.name] = i ? Object.assign({}, i, s, {
            options: Object.assign({}, i.options, s.options),
            data: Object.assign({}, i.data, s.data)
        }) : s, o;
    }, {});
    return Object.keys(a).map(function(o) {
        return a[o];
    });
}
var $0422a6ce4ea03acc$var$dL = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $0422a6ce4ea03acc$var$CL() {
    for(var r = arguments.length, a = new Array(r), o = 0; o < r; o++)a[o] = arguments[o];
    return !a.some(function(s) {
        return !(s && typeof s.getBoundingClientRect == "function");
    });
}
function $0422a6ce4ea03acc$var$YO(r) {
    r === void 0 && (r = {});
    var a = r, o = a.defaultModifiers, s = o === void 0 ? [] : o, i = a.defaultOptions, p = i === void 0 ? $0422a6ce4ea03acc$var$dL : i;
    return function(v, y, L) {
        L === void 0 && (L = p);
        var M = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $0422a6ce4ea03acc$var$dL, p),
            modifiersData: {},
            elements: {
                reference: v,
                popper: y
            },
            attributes: {},
            styles: {}
        }, E = [], k = !1, _ = {
            state: M,
            setOptions: function(z) {
                var I = typeof z == "function" ? z(M.options) : z;
                O(), M.options = Object.assign({}, p, M.options, I), M.scrollParents = {
                    reference: $0422a6ce4ea03acc$var$Dt(v) ? $0422a6ce4ea03acc$var$_o(v) : v.contextElement ? $0422a6ce4ea03acc$var$_o(v.contextElement) : [],
                    popper: $0422a6ce4ea03acc$var$_o(y)
                };
                var P = $0422a6ce4ea03acc$var$UO($0422a6ce4ea03acc$var$$O([].concat(s, M.options.modifiers)));
                return M.orderedModifiers = P.filter(function($) {
                    return $.enabled;
                }), Z(), _.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function() {
                if (!k) {
                    var z = M.elements, I = z.reference, P = z.popper;
                    if ($0422a6ce4ea03acc$var$CL(I, P)) {
                        M.rects = {
                            reference: $0422a6ce4ea03acc$var$jO(I, $0422a6ce4ea03acc$var$$o(P), M.options.strategy === "fixed"),
                            popper: $0422a6ce4ea03acc$var$Th(P)
                        }, M.reset = !1, M.placement = M.options.placement, M.orderedModifiers.forEach(function(E1) {
                            return M.modifiersData[E1.name] = Object.assign({}, E1.data);
                        });
                        for(var $ = 0; $ < M.orderedModifiers.length; $++){
                            if (M.reset === !0) {
                                M.reset = !1, $ = -1;
                                continue;
                            }
                            var W = M.orderedModifiers[$], l1 = W.fn, u1 = W.options, m1 = u1 === void 0 ? {} : u1, L1 = W.name;
                            typeof l1 == "function" && (M = l1({
                                state: M,
                                options: m1,
                                name: L1,
                                instance: _
                            }) || M);
                        }
                    }
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: $0422a6ce4ea03acc$var$IO(function() {
                return new Promise(function(B) {
                    _.forceUpdate(), B(M);
                });
            }),
            destroy: function() {
                O(), k = !0;
            }
        };
        if (!$0422a6ce4ea03acc$var$CL(v, y)) return _;
        _.setOptions(L).then(function(B) {
            !k && L.onFirstUpdate && L.onFirstUpdate(B);
        });
        function Z() {
            M.orderedModifiers.forEach(function(B) {
                var z = B.name, I = B.options, P = I === void 0 ? {} : I, $ = B.effect;
                if (typeof $ == "function") {
                    var W = $({
                        state: M,
                        name: z,
                        instance: _,
                        options: P
                    }), l1 = function() {};
                    E.push(W || l1);
                }
            });
        }
        function O() {
            E.forEach(function(B) {
                return B();
            }), E = [];
        }
        return _;
    };
}
var $0422a6ce4ea03acc$var$WO = [
    $0422a6ce4ea03acc$var$mO,
    $0422a6ce4ea03acc$var$ZO,
    $0422a6ce4ea03acc$var$pO,
    $0422a6ce4ea03acc$var$rO,
    $0422a6ce4ea03acc$var$DO,
    $0422a6ce4ea03acc$var$EO,
    $0422a6ce4ea03acc$var$PO,
    $0422a6ce4ea03acc$var$cO,
    $0422a6ce4ea03acc$var$kO
], $0422a6ce4ea03acc$var$QO = /* @__PURE__ */ $0422a6ce4ea03acc$var$YO({
    defaultModifiers: $0422a6ce4ea03acc$var$WO
}), $0422a6ce4ea03acc$var$qO = typeof Element < "u", $0422a6ce4ea03acc$var$GO = typeof Map == "function", $0422a6ce4ea03acc$var$XO = typeof Set == "function", $0422a6ce4ea03acc$var$KO = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function $0422a6ce4ea03acc$var$qu(r, a) {
    if (r === a) return !0;
    if (r && a && typeof r == "object" && typeof a == "object") {
        if (r.constructor !== a.constructor) return !1;
        var o, s, i;
        if (Array.isArray(r)) {
            if (o = r.length, o != a.length) return !1;
            for(s = o; s-- !== 0;)if (!$0422a6ce4ea03acc$var$qu(r[s], a[s])) return !1;
            return !0;
        }
        var p;
        if ($0422a6ce4ea03acc$var$GO && r instanceof Map && a instanceof Map) {
            if (r.size !== a.size) return !1;
            for(p = r.entries(); !(s = p.next()).done;)if (!a.has(s.value[0])) return !1;
            for(p = r.entries(); !(s = p.next()).done;)if (!$0422a6ce4ea03acc$var$qu(s.value[1], a.get(s.value[0]))) return !1;
            return !0;
        }
        if ($0422a6ce4ea03acc$var$XO && r instanceof Set && a instanceof Set) {
            if (r.size !== a.size) return !1;
            for(p = r.entries(); !(s = p.next()).done;)if (!a.has(s.value[0])) return !1;
            return !0;
        }
        if ($0422a6ce4ea03acc$var$KO && ArrayBuffer.isView(r) && ArrayBuffer.isView(a)) {
            if (o = r.length, o != a.length) return !1;
            for(s = o; s-- !== 0;)if (r[s] !== a[s]) return !1;
            return !0;
        }
        if (r.constructor === RegExp) return r.source === a.source && r.flags === a.flags;
        if (r.valueOf !== Object.prototype.valueOf && typeof r.valueOf == "function" && typeof a.valueOf == "function") return r.valueOf() === a.valueOf();
        if (r.toString !== Object.prototype.toString && typeof r.toString == "function" && typeof a.toString == "function") return r.toString() === a.toString();
        if (i = Object.keys(r), o = i.length, o !== Object.keys(a).length) return !1;
        for(s = o; s-- !== 0;)if (!Object.prototype.hasOwnProperty.call(a, i[s])) return !1;
        if ($0422a6ce4ea03acc$var$qO && r instanceof Element) return !1;
        for(s = o; s-- !== 0;)if (!((i[s] === "_owner" || i[s] === "__v" || i[s] === "__o") && r.$$typeof) && !$0422a6ce4ea03acc$var$qu(r[i[s]], a[i[s]])) return !1;
        return !0;
    }
    return r !== r && a !== a;
}
var $0422a6ce4ea03acc$var$JO = function(a, o) {
    try {
        return $0422a6ce4ea03acc$var$qu(a, o);
    } catch (s) {
        if ((s.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
        throw s;
    }
};
const $0422a6ce4ea03acc$var$eN = /* @__PURE__ */ $0422a6ce4ea03acc$var$zo($0422a6ce4ea03acc$var$JO);
var $0422a6ce4ea03acc$var$tN = [], $0422a6ce4ea03acc$var$nN = function(a, o, s) {
    s === void 0 && (s = {});
    var i = $acw62.useRef(null), p = {
        onFirstUpdate: s.onFirstUpdate,
        placement: s.placement || "bottom",
        strategy: s.strategy || "absolute",
        modifiers: s.modifiers || $0422a6ce4ea03acc$var$tN
    }, C = $acw62.useState({
        styles: {
            popper: {
                position: p.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), v = C[0], y = C[1], L = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: !0,
            phase: "write",
            fn: function(_) {
                var Z = _.state, O = Object.keys(Z.elements);
                $0422a6ce4ea03acc$var$Eh.flushSync(function() {
                    y({
                        styles: $0422a6ce4ea03acc$var$nL(O.map(function(B) {
                            return [
                                B,
                                Z.styles[B] || {}
                            ];
                        })),
                        attributes: $0422a6ce4ea03acc$var$nL(O.map(function(B) {
                            return [
                                B,
                                Z.attributes[B]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []), M = $acw62.useMemo(function() {
        var k = {
            onFirstUpdate: p.onFirstUpdate,
            placement: p.placement,
            strategy: p.strategy,
            modifiers: [].concat(p.modifiers, [
                L,
                {
                    name: "applyStyles",
                    enabled: !1
                }
            ])
        };
        return $0422a6ce4ea03acc$var$eN(i.current, k) ? i.current || k : (i.current = k, k);
    }, [
        p.onFirstUpdate,
        p.placement,
        p.strategy,
        p.modifiers,
        L
    ]), E = $acw62.useRef();
    return $0422a6ce4ea03acc$var$rL(function() {
        E.current && E.current.setOptions(M);
    }, [
        M
    ]), $0422a6ce4ea03acc$var$rL(function() {
        if (!(a == null || o == null)) {
            var k = s.createPopper || $0422a6ce4ea03acc$var$QO, _ = k(a, o, M);
            return E.current = _, function() {
                _.destroy(), E.current = null;
            };
        }
    }, [
        a,
        o,
        s.createPopper
    ]), {
        state: E.current ? E.current.state : null,
        styles: v.styles,
        attributes: v.attributes,
        update: E.current ? E.current.update : null,
        forceUpdate: E.current ? E.current.forceUpdate : null
    };
}, $0422a6ce4ea03acc$var$rN = function() {}, $0422a6ce4ea03acc$var$aN = function() {
    return Promise.resolve(null);
}, $0422a6ce4ea03acc$var$iN = [];
function $0422a6ce4ea03acc$var$oN(r) {
    var a = r.placement, o = a === void 0 ? "bottom" : a, s = r.strategy, i = s === void 0 ? "absolute" : s, p = r.modifiers, C = p === void 0 ? $0422a6ce4ea03acc$var$iN : p, v = r.referenceElement, y = r.onFirstUpdate, L = r.innerRef, M = r.children, E = $acw62.useContext($0422a6ce4ea03acc$var$Ob), k = $acw62.useState(null), _ = k[0], Z = k[1], O = $acw62.useState(null), B = O[0], z = O[1];
    $acw62.useEffect(function() {
        $0422a6ce4ea03acc$var$Jp(L, _);
    }, [
        L,
        _
    ]);
    var I = $acw62.useMemo(function() {
        return {
            placement: o,
            strategy: i,
            onFirstUpdate: y,
            modifiers: [].concat(C, [
                {
                    name: "arrow",
                    enabled: B != null,
                    options: {
                        element: B
                    }
                }
            ])
        };
    }, [
        o,
        i,
        y,
        C,
        B
    ]), P = $0422a6ce4ea03acc$var$nN(v || E, _, I), $ = P.state, W = P.styles, l1 = P.forceUpdate, u1 = P.update, m1 = $acw62.useMemo(function() {
        return {
            ref: Z,
            style: W.popper,
            placement: $ ? $.placement : o,
            hasPopperEscaped: $ && $.modifiersData.hide ? $.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: $ && $.modifiersData.hide ? $.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: W.arrow,
                ref: z
            },
            forceUpdate: l1 || $0422a6ce4ea03acc$var$rN,
            update: u1 || $0422a6ce4ea03acc$var$aN
        };
    }, [
        Z,
        z,
        o,
        $,
        W,
        u1,
        l1
    ]);
    return $0422a6ce4ea03acc$var$Pb(M)(m1);
}
var $0422a6ce4ea03acc$var$lN = false, $0422a6ce4ea03acc$var$Qb = function() {};
if ($0422a6ce4ea03acc$var$lN) {
    var $0422a6ce4ea03acc$var$sN = function(a, o) {
        var s = arguments.length;
        o = new Array(s > 1 ? s - 1 : 0);
        for(var i = 1; i < s; i++)o[i - 1] = arguments[i];
        var p = 0, C = "Warning: " + a.replace(/%s/g, function() {
            return o[p++];
        });
        typeof console < "u" && console.error(C);
        try {
            throw new Error(C);
        } catch  {}
    };
    $0422a6ce4ea03acc$var$Qb = function(r, a, o) {
        var s = arguments.length;
        o = new Array(s > 2 ? s - 2 : 0);
        for(var i = 2; i < s; i++)o[i - 2] = arguments[i];
        if (a === void 0) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        r || $0422a6ce4ea03acc$var$sN.apply(null, [
            a
        ].concat(o));
    };
}
var $0422a6ce4ea03acc$var$uN = $0422a6ce4ea03acc$var$Qb;
const $0422a6ce4ea03acc$var$cN = /* @__PURE__ */ $0422a6ce4ea03acc$var$zo($0422a6ce4ea03acc$var$uN);
function $0422a6ce4ea03acc$var$dN(r) {
    var a = r.children, o = r.innerRef, s = $acw62.useContext($0422a6ce4ea03acc$var$Nb), i = $acw62.useCallback(function(p) {
        $0422a6ce4ea03acc$var$Jp(o, p), $0422a6ce4ea03acc$var$Bb(s, p);
    }, [
        o,
        s
    ]);
    return $acw62.useEffect(function() {
        return function() {
            return $0422a6ce4ea03acc$var$Jp(o, null);
        };
    }, []), $acw62.useEffect(function() {
        $0422a6ce4ea03acc$var$cN(!!s, "`Reference` should not be used outside of a `Manager` component.");
    }, [
        s
    ]), $0422a6ce4ea03acc$var$Pb(a)({
        ref: i
    });
}
function $0422a6ce4ea03acc$var$CN(r, a) {
    if ($0422a6ce4ea03acc$var$F1(2, arguments), $0422a6ce4ea03acc$var$D6(a) !== "object" || a === null) throw new RangeError("values parameter must be an object");
    var o = $0422a6ce4ea03acc$var$a2(r);
    return isNaN(o.getTime()) ? /* @__PURE__ */ new Date(NaN) : (a.year != null && o.setFullYear(a.year), a.month != null && (o = $0422a6ce4ea03acc$var$g5(o, a.month)), a.date != null && o.setDate($0422a6ce4ea03acc$var$q2(a.date)), a.hours != null && o.setHours($0422a6ce4ea03acc$var$q2(a.hours)), a.minutes != null && o.setMinutes($0422a6ce4ea03acc$var$q2(a.minutes)), a.seconds != null && o.setSeconds($0422a6ce4ea03acc$var$q2(a.seconds)), a.milliseconds != null && o.setMilliseconds($0422a6ce4ea03acc$var$q2(a.milliseconds)), o);
}
function $0422a6ce4ea03acc$var$fL(r, a) {
    var o = Object.keys(r);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(r);
        a && (s = s.filter(function(i) {
            return Object.getOwnPropertyDescriptor(r, i).enumerable;
        })), o.push.apply(o, s);
    }
    return o;
}
function $0422a6ce4ea03acc$var$pL(r) {
    for(var a = 1; a < arguments.length; a++){
        var o = arguments[a] != null ? arguments[a] : {};
        a % 2 ? $0422a6ce4ea03acc$var$fL(Object(o), !0).forEach(function(s) {
            $0422a6ce4ea03acc$var$A(r, s, o[s]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : $0422a6ce4ea03acc$var$fL(Object(o)).forEach(function(s) {
            Object.defineProperty(r, s, Object.getOwnPropertyDescriptor(o, s));
        });
    }
    return r;
}
function $0422a6ce4ea03acc$var$qb(r) {
    return ($0422a6ce4ea03acc$var$qb = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
    } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    })(r);
}
function $0422a6ce4ea03acc$var$H4(r, a) {
    if (!(r instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function $0422a6ce4ea03acc$var$hL(r, a) {
    for(var o = 0; o < a.length; o++){
        var s = a[o];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(r, $0422a6ce4ea03acc$var$Xb(s.key), s);
    }
}
function $0422a6ce4ea03acc$var$x4(r, a, o) {
    return a && $0422a6ce4ea03acc$var$hL(r.prototype, a), o && $0422a6ce4ea03acc$var$hL(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
    }), r;
}
function $0422a6ce4ea03acc$var$A(r, a, o) {
    return (a = $0422a6ce4ea03acc$var$Xb(a)) in r ? Object.defineProperty(r, a, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : r[a] = o, r;
}
function $0422a6ce4ea03acc$var$xc() {
    return ($0422a6ce4ea03acc$var$xc = Object.assign ? Object.assign.bind() : function(r) {
        for(var a = 1; a < arguments.length; a++){
            var o = arguments[a];
            for(var s in o)Object.prototype.hasOwnProperty.call(o, s) && (r[s] = o[s]);
        }
        return r;
    }).apply(this, arguments);
}
function $0422a6ce4ea03acc$var$V4(r, a) {
    if (typeof a != "function" && a !== null) throw new TypeError("Super expression must either be null or a function");
    r.prototype = Object.create(a && a.prototype, {
        constructor: {
            value: r,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(r, "prototype", {
        writable: !1
    }), a && $0422a6ce4ea03acc$var$Gb(r, a);
}
function $0422a6ce4ea03acc$var$nh(r) {
    return ($0422a6ce4ea03acc$var$nh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(a) {
        return a.__proto__ || Object.getPrototypeOf(a);
    })(r);
}
function $0422a6ce4ea03acc$var$Gb(r, a) {
    return ($0422a6ce4ea03acc$var$Gb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, s) {
        return o.__proto__ = s, o;
    })(r, a);
}
function $0422a6ce4ea03acc$var$U(r) {
    if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return r;
}
function $0422a6ce4ea03acc$var$fN(r, a) {
    if (a && (typeof a == "object" || typeof a == "function")) return a;
    if (a !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0422a6ce4ea03acc$var$U(r);
}
function $0422a6ce4ea03acc$var$M4(r) {
    var a = function() {
        if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
        if (typeof Proxy == "function") return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch  {
            return !1;
        }
    }();
    return function() {
        var o, s = $0422a6ce4ea03acc$var$nh(r);
        if (a) {
            var i = $0422a6ce4ea03acc$var$nh(this).constructor;
            o = Reflect.construct(s, arguments, i);
        } else o = s.apply(this, arguments);
        return $0422a6ce4ea03acc$var$fN(this, o);
    };
}
function $0422a6ce4ea03acc$var$rh(r) {
    return function(a) {
        if (Array.isArray(a)) return $0422a6ce4ea03acc$var$vp(a);
    }(r) || function(a) {
        if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
    }(r) || function(a, o) {
        if (a) {
            if (typeof a == "string") return $0422a6ce4ea03acc$var$vp(a, o);
            var s = Object.prototype.toString.call(a).slice(8, -1);
            if (s === "Object" && a.constructor && (s = a.constructor.name), s === "Map" || s === "Set") return Array.from(a);
            if (s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s)) return $0422a6ce4ea03acc$var$vp(a, o);
        }
    }(r) || function() {
        throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }();
}
function $0422a6ce4ea03acc$var$vp(r, a) {
    (a == null || a > r.length) && (a = r.length);
    for(var o = 0, s = new Array(a); o < a; o++)s[o] = r[o];
    return s;
}
function $0422a6ce4ea03acc$var$Xb(r) {
    var a = function(o, s) {
        if (typeof o != "object" || o === null) return o;
        var i = o[Symbol.toPrimitive];
        if (i !== void 0) {
            var p = i.call(o, s || "default");
            if (typeof p != "object") return p;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (s === "string" ? String : Number)(o);
    }(r, "string");
    return typeof a == "symbol" ? a : String(a);
}
function $0422a6ce4ea03acc$var$mL(r, a) {
    switch(r){
        case "P":
            return a.date({
                width: "short"
            });
        case "PP":
            return a.date({
                width: "medium"
            });
        case "PPP":
            return a.date({
                width: "long"
            });
        case "PPPP":
        default:
            return a.date({
                width: "full"
            });
    }
}
function $0422a6ce4ea03acc$var$vL(r, a) {
    switch(r){
        case "p":
            return a.time({
                width: "short"
            });
        case "pp":
            return a.time({
                width: "medium"
            });
        case "ppp":
            return a.time({
                width: "long"
            });
        case "pppp":
        default:
            return a.time({
                width: "full"
            });
    }
}
var $0422a6ce4ea03acc$var$pN = {
    p: $0422a6ce4ea03acc$var$vL,
    P: function(r, a) {
        var o, s = r.match(/(P+)(p+)?/) || [], i = s[1], p = s[2];
        if (!p) return $0422a6ce4ea03acc$var$mL(r, a);
        switch(i){
            case "P":
                o = a.dateTime({
                    width: "short"
                });
                break;
            case "PP":
                o = a.dateTime({
                    width: "medium"
                });
                break;
            case "PPP":
                o = a.dateTime({
                    width: "long"
                });
                break;
            case "PPPP":
            default:
                o = a.dateTime({
                    width: "full"
                });
        }
        return o.replace("{{date}}", $0422a6ce4ea03acc$var$mL(i, a)).replace("{{time}}", $0422a6ce4ea03acc$var$vL(p, a));
    }
}, $0422a6ce4ea03acc$var$hN = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function $0422a6ce4ea03acc$var$A3(r) {
    var a = r ? typeof r == "string" || r instanceof String ? $0422a6ce4ea03acc$var$dZ(r) : $0422a6ce4ea03acc$var$a2(r) : /* @__PURE__ */ new Date();
    return $0422a6ce4ea03acc$var$h0(a) ? a : null;
}
function $0422a6ce4ea03acc$var$mN(r, a, o, s, i) {
    var p = null, C = $0422a6ce4ea03acc$var$kt(o) || $0422a6ce4ea03acc$var$kt($0422a6ce4ea03acc$var$St()), v = !0;
    return Array.isArray(a) ? (a.forEach(function(y) {
        var L = $0422a6ce4ea03acc$var$Cp(r, y, /* @__PURE__ */ new Date(), {
            locale: C
        });
        s && (v = $0422a6ce4ea03acc$var$h0(L, i) && r === $0422a6ce4ea03acc$var$Fe(L, y, o)), $0422a6ce4ea03acc$var$h0(L, i) && v && (p = L);
    }), p) : (p = $0422a6ce4ea03acc$var$Cp(r, a, /* @__PURE__ */ new Date(), {
        locale: C
    }), s ? v = $0422a6ce4ea03acc$var$h0(p) && r === $0422a6ce4ea03acc$var$Fe(p, a, o) : $0422a6ce4ea03acc$var$h0(p) || (a = a.match($0422a6ce4ea03acc$var$hN).map(function(y) {
        var L = y[0];
        return L === "p" || L === "P" ? C ? (0, $0422a6ce4ea03acc$var$pN[L])(y, C.formatLong) : L : y;
    }).join(""), r.length > 0 && (p = $0422a6ce4ea03acc$var$Cp(r, a.slice(0, r.length), /* @__PURE__ */ new Date())), $0422a6ce4ea03acc$var$h0(p) || (p = new Date(r))), $0422a6ce4ea03acc$var$h0(p) && v ? p : null);
}
function $0422a6ce4ea03acc$var$h0(r, a) {
    return a = a || /* @__PURE__ */ new Date("1/1/1000"), $0422a6ce4ea03acc$var$nc(r) && !$0422a6ce4ea03acc$var$l9(r, a);
}
function $0422a6ce4ea03acc$var$Fe(r, a, o) {
    if (o === "en") return $0422a6ce4ea03acc$var$Uy(r, a, {
        awareOfUnicodeTokens: !0
    });
    var s = $0422a6ce4ea03acc$var$kt(o);
    return o && !s && console.warn('A locale object was not found for the provided string ["'.concat(o, '"].')), !s && $0422a6ce4ea03acc$var$St() && $0422a6ce4ea03acc$var$kt($0422a6ce4ea03acc$var$St()) && (s = $0422a6ce4ea03acc$var$kt($0422a6ce4ea03acc$var$St())), $0422a6ce4ea03acc$var$Uy(r, a, {
        locale: s || null,
        awareOfUnicodeTokens: !0
    });
}
function $0422a6ce4ea03acc$var$l8(r, a) {
    var o = a.dateFormat, s = a.locale;
    return r && $0422a6ce4ea03acc$var$Fe(r, Array.isArray(o) ? o[0] : o, s) || "";
}
function $0422a6ce4ea03acc$var$gL(r, a) {
    var o = a.hour, s = o === void 0 ? 0 : o, i = a.minute, p = i === void 0 ? 0 : i, C = a.second;
    return $0422a6ce4ea03acc$var$ko($0422a6ce4ea03acc$var$So($0422a6ce4ea03acc$var$nR(r, C === void 0 ? 0 : C), p), s);
}
function $0422a6ce4ea03acc$var$vN(r, a) {
    var o = $0422a6ce4ea03acc$var$St() && $0422a6ce4ea03acc$var$kt($0422a6ce4ea03acc$var$St());
    return $0422a6ce4ea03acc$var$tR(r, o ? {
        locale: o
    } : null);
}
function $0422a6ce4ea03acc$var$gN(r, a) {
    return $0422a6ce4ea03acc$var$Fe(r, "ddd", a);
}
function $0422a6ce4ea03acc$var$yN(r) {
    return $0422a6ce4ea03acc$var$d8(r);
}
function $0422a6ce4ea03acc$var$Oh(r, a, o) {
    var s = $0422a6ce4ea03acc$var$kt(a || $0422a6ce4ea03acc$var$St());
    return $0422a6ce4ea03acc$var$Hb(r, {
        locale: s,
        weekStartsOn: o
    });
}
function $0422a6ce4ea03acc$var$g0(r) {
    return $0422a6ce4ea03acc$var$xb(r);
}
function $0422a6ce4ea03acc$var$Mo(r) {
    return $0422a6ce4ea03acc$var$Vb(r);
}
function $0422a6ce4ea03acc$var$yL(r) {
    return $0422a6ce4ea03acc$var$Wp(r);
}
function $0422a6ce4ea03acc$var$LL() {
    return $0422a6ce4ea03acc$var$d8($0422a6ce4ea03acc$var$A3());
}
function $0422a6ce4ea03acc$var$m0(r, a) {
    return r && a ? $0422a6ce4ea03acc$var$cR(r, a) : !r && !a;
}
function $0422a6ce4ea03acc$var$h7(r, a) {
    return r && a ? $0422a6ce4ea03acc$var$uR(r, a) : !r && !a;
}
function $0422a6ce4ea03acc$var$Cc(r, a) {
    return r && a ? $0422a6ce4ea03acc$var$dR(r, a) : !r && !a;
}
function $0422a6ce4ea03acc$var$y5(r, a) {
    return r && a ? $0422a6ce4ea03acc$var$sR(r, a) : !r && !a;
}
function $0422a6ce4ea03acc$var$v0(r, a) {
    return r && a ? $0422a6ce4ea03acc$var$lR(r, a) : !r && !a;
}
function $0422a6ce4ea03acc$var$Gu(r, a, o) {
    var s, i = $0422a6ce4ea03acc$var$d8(a), p = $0422a6ce4ea03acc$var$Qp(o);
    try {
        s = $0422a6ce4ea03acc$var$Bo(r, {
            start: i,
            end: p
        });
    } catch  {
        s = !1;
    }
    return s;
}
function $0422a6ce4ea03acc$var$St() {
    return (typeof window < "u" ? window : globalThis).__localeId__;
}
function $0422a6ce4ea03acc$var$kt(r) {
    if (typeof r == "string") {
        var a = typeof window < "u" ? window : globalThis;
        return a.__localeData__ ? a.__localeData__[r] : null;
    }
    return r;
}
function $0422a6ce4ea03acc$var$Nh(r, a) {
    return $0422a6ce4ea03acc$var$Fe($0422a6ce4ea03acc$var$g5($0422a6ce4ea03acc$var$A3(), r), "LLLL", a);
}
function $0422a6ce4ea03acc$var$Kb(r, a) {
    return $0422a6ce4ea03acc$var$Fe($0422a6ce4ea03acc$var$g5($0422a6ce4ea03acc$var$A3(), r), "LLL", a);
}
function $0422a6ce4ea03acc$var$LN(r, a) {
    return $0422a6ce4ea03acc$var$Fe($0422a6ce4ea03acc$var$Fr($0422a6ce4ea03acc$var$A3(), r), "QQQ", a);
}
function $0422a6ce4ea03acc$var$Vc(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.minDate, s = a.maxDate, i = a.excludeDates, p = a.excludeDateIntervals, C = a.includeDates, v = a.includeDateIntervals, y = a.filterDate;
    return $0422a6ce4ea03acc$var$Mc(r, {
        minDate: o,
        maxDate: s
    }) || i && i.some(function(L) {
        return $0422a6ce4ea03acc$var$y5(r, L);
    }) || p && p.some(function(L) {
        var M = L.start, E = L.end;
        return $0422a6ce4ea03acc$var$Bo(r, {
            start: M,
            end: E
        });
    }) || C && !C.some(function(L) {
        return $0422a6ce4ea03acc$var$y5(r, L);
    }) || v && !v.some(function(L) {
        var M = L.start, E = L.end;
        return $0422a6ce4ea03acc$var$Bo(r, {
            start: M,
            end: E
        });
    }) || y && !y($0422a6ce4ea03acc$var$A3(r)) || !1;
}
function $0422a6ce4ea03acc$var$Ph(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.excludeDates, s = a.excludeDateIntervals;
    return s && s.length > 0 ? s.some(function(i) {
        var p = i.start, C = i.end;
        return $0422a6ce4ea03acc$var$Bo(r, {
            start: p,
            end: C
        });
    }) : o && o.some(function(i) {
        return $0422a6ce4ea03acc$var$y5(r, i);
    }) || !1;
}
function $0422a6ce4ea03acc$var$Jb(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.minDate, s = a.maxDate, i = a.excludeDates, p = a.includeDates, C = a.filterDate;
    return $0422a6ce4ea03acc$var$Mc(r, {
        minDate: $0422a6ce4ea03acc$var$xb(o),
        maxDate: $0422a6ce4ea03acc$var$iR(s)
    }) || i && i.some(function(v) {
        return $0422a6ce4ea03acc$var$h7(r, v);
    }) || p && !p.some(function(v) {
        return $0422a6ce4ea03acc$var$h7(r, v);
    }) || C && !C($0422a6ce4ea03acc$var$A3(r)) || !1;
}
function $0422a6ce4ea03acc$var$gp(r, a, o, s) {
    var i = $0422a6ce4ea03acc$var$K2(r), p = $0422a6ce4ea03acc$var$a5(r), C = $0422a6ce4ea03acc$var$K2(a), v = $0422a6ce4ea03acc$var$a5(a), y = $0422a6ce4ea03acc$var$K2(s);
    return i === C && i === y ? p <= o && o <= v : i < C ? y === i && p <= o || y === C && v >= o || y < C && y > i : void 0;
}
function $0422a6ce4ea03acc$var$bN(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.minDate, s = a.maxDate, i = a.excludeDates, p = a.includeDates, C = a.filterDate;
    return $0422a6ce4ea03acc$var$Mc(r, {
        minDate: o,
        maxDate: s
    }) || i && i.some(function(v) {
        return $0422a6ce4ea03acc$var$Cc(r, v);
    }) || p && !p.some(function(v) {
        return $0422a6ce4ea03acc$var$Cc(r, v);
    }) || C && !C($0422a6ce4ea03acc$var$A3(r)) || !1;
}
function $0422a6ce4ea03acc$var$yp(r, a, o) {
    if (!$0422a6ce4ea03acc$var$nc(a) || !$0422a6ce4ea03acc$var$nc(o)) return !1;
    var s = $0422a6ce4ea03acc$var$K2(a), i = $0422a6ce4ea03acc$var$K2(o);
    return s <= r && i >= r;
}
function $0422a6ce4ea03acc$var$ew(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.minDate, s = a.maxDate, i = a.excludeDates, p = a.includeDates, C = a.filterDate, v = new Date(r, 0, 1);
    return $0422a6ce4ea03acc$var$Mc(v, {
        minDate: $0422a6ce4ea03acc$var$Vb(o),
        maxDate: $0422a6ce4ea03acc$var$oR(s)
    }) || i && i.some(function(y) {
        return $0422a6ce4ea03acc$var$m0(v, y);
    }) || p && !p.some(function(y) {
        return $0422a6ce4ea03acc$var$m0(v, y);
    }) || C && !C($0422a6ce4ea03acc$var$A3(v)) || !1;
}
function $0422a6ce4ea03acc$var$Lp(r, a, o, s) {
    var i = $0422a6ce4ea03acc$var$K2(r), p = $0422a6ce4ea03acc$var$zr(r), C = $0422a6ce4ea03acc$var$K2(a), v = $0422a6ce4ea03acc$var$zr(a), y = $0422a6ce4ea03acc$var$K2(s);
    return i === C && i === y ? p <= o && o <= v : i < C ? y === i && p <= o || y === C && v >= o || y < C && y > i : void 0;
}
function $0422a6ce4ea03acc$var$Mc(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.minDate, s = a.maxDate;
    return o && $0422a6ce4ea03acc$var$oc(r, o) < 0 || s && $0422a6ce4ea03acc$var$oc(r, s) > 0;
}
function $0422a6ce4ea03acc$var$bL(r, a) {
    return a.some(function(o) {
        return $0422a6ce4ea03acc$var$i6(o) === $0422a6ce4ea03acc$var$i6(r) && $0422a6ce4ea03acc$var$a6(o) === $0422a6ce4ea03acc$var$a6(r);
    });
}
function $0422a6ce4ea03acc$var$wL(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.excludeTimes, s = a.includeTimes, i = a.filterTime;
    return o && $0422a6ce4ea03acc$var$bL(r, o) || s && !$0422a6ce4ea03acc$var$bL(r, s) || i && !i(r) || !1;
}
function $0422a6ce4ea03acc$var$HL(r, a) {
    var o = a.minTime, s = a.maxTime;
    if (!o || !s) throw new Error("Both minTime and maxTime props required");
    var i, p = $0422a6ce4ea03acc$var$A3(), C = $0422a6ce4ea03acc$var$ko($0422a6ce4ea03acc$var$So(p, $0422a6ce4ea03acc$var$a6(r)), $0422a6ce4ea03acc$var$i6(r)), v = $0422a6ce4ea03acc$var$ko($0422a6ce4ea03acc$var$So(p, $0422a6ce4ea03acc$var$a6(o)), $0422a6ce4ea03acc$var$i6(o)), y = $0422a6ce4ea03acc$var$ko($0422a6ce4ea03acc$var$So(p, $0422a6ce4ea03acc$var$a6(s)), $0422a6ce4ea03acc$var$i6(s));
    try {
        i = !$0422a6ce4ea03acc$var$Bo(C, {
            start: v,
            end: y
        });
    } catch  {
        i = !1;
    }
    return i;
}
function $0422a6ce4ea03acc$var$xL(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.minDate, s = a.includeDates, i = $0422a6ce4ea03acc$var$Gr(r, 1);
    return o && $0422a6ce4ea03acc$var$lc(o, i) > 0 || s && s.every(function(p) {
        return $0422a6ce4ea03acc$var$lc(p, i) > 0;
    }) || !1;
}
function $0422a6ce4ea03acc$var$VL(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.maxDate, s = a.includeDates, i = $0422a6ce4ea03acc$var$v7(r, 1);
    return o && $0422a6ce4ea03acc$var$lc(i, o) > 0 || s && s.every(function(p) {
        return $0422a6ce4ea03acc$var$lc(i, p) > 0;
    }) || !1;
}
function $0422a6ce4ea03acc$var$ML(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.minDate, s = a.includeDates, i = $0422a6ce4ea03acc$var$Po(r, 1);
    return o && $0422a6ce4ea03acc$var$sc(o, i) > 0 || s && s.every(function(p) {
        return $0422a6ce4ea03acc$var$sc(p, i) > 0;
    }) || !1;
}
function $0422a6ce4ea03acc$var$EL(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.maxDate, s = a.includeDates, i = $0422a6ce4ea03acc$var$qr(r, 1);
    return o && $0422a6ce4ea03acc$var$sc(i, o) > 0 || s && s.every(function(p) {
        return $0422a6ce4ea03acc$var$sc(i, p) > 0;
    }) || !1;
}
function $0422a6ce4ea03acc$var$tw(r) {
    var a = r.minDate, o = r.includeDates;
    if (o && a) {
        var s = o.filter(function(i) {
            return $0422a6ce4ea03acc$var$oc(i, a) >= 0;
        });
        return $0422a6ce4ea03acc$var$$y(s);
    }
    return o ? $0422a6ce4ea03acc$var$$y(o) : a;
}
function $0422a6ce4ea03acc$var$nw(r) {
    var a = r.maxDate, o = r.includeDates;
    if (o && a) {
        var s = o.filter(function(i) {
            return $0422a6ce4ea03acc$var$oc(i, a) <= 0;
        });
        return $0422a6ce4ea03acc$var$Yy(s);
    }
    return o ? $0422a6ce4ea03acc$var$Yy(o) : a;
}
function $0422a6ce4ea03acc$var$SL() {
    for(var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", o = /* @__PURE__ */ new Map(), s = 0, i = r.length; s < i; s++){
        var p = r[s];
        if ($0422a6ce4ea03acc$var$yh(p)) {
            var C = $0422a6ce4ea03acc$var$Fe(p, "MM.dd.yyyy"), v = o.get(C) || [];
            v.includes(a) || (v.push(a), o.set(C, v));
        } else if ($0422a6ce4ea03acc$var$qb(p) === "object") {
            var y = Object.keys(p), L = y[0], M = p[y[0]];
            if (typeof L == "string" && M.constructor === Array) for(var E = 0, k = M.length; E < k; E++){
                var _ = $0422a6ce4ea03acc$var$Fe(M[E], "MM.dd.yyyy"), Z = o.get(_) || [];
                Z.includes(L) || (Z.push(L), o.set(_, Z));
            }
        }
    }
    return o;
}
function $0422a6ce4ea03acc$var$wN(r, a, o, s, i) {
    for(var p = i.length, C = [], v = 0; v < p; v++){
        var y = $0422a6ce4ea03acc$var$$p($0422a6ce4ea03acc$var$WD(r, $0422a6ce4ea03acc$var$i6(i[v])), $0422a6ce4ea03acc$var$a6(i[v])), L = $0422a6ce4ea03acc$var$$p(r, (o + 1) * s);
        $0422a6ce4ea03acc$var$y0(y, a) && $0422a6ce4ea03acc$var$l9(y, L) && C.push(i[v]);
    }
    return C;
}
function $0422a6ce4ea03acc$var$kL(r) {
    return r < 10 ? "0".concat(r) : "".concat(r);
}
function $0422a6ce4ea03acc$var$Ur(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12, o = Math.ceil($0422a6ce4ea03acc$var$K2(r) / a) * a, s = o - (a - 1);
    return {
        startPeriod: s,
        endPeriod: o
    };
}
function $0422a6ce4ea03acc$var$HN(r, a, o, s) {
    for(var i = [], p = 0; p < 2 * a + 1; p++){
        var C = r + a - p, v = !0;
        o && (v = $0422a6ce4ea03acc$var$K2(o) <= C), s && v && (v = $0422a6ce4ea03acc$var$K2(s) >= C), v && i.push(C);
    }
    return i;
}
var $0422a6ce4ea03acc$var$xN = $0422a6ce4ea03acc$var$wc(function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o(s) {
        var i;
        $0422a6ce4ea03acc$var$H4(this, o), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i = a.call(this, s)), "renderOptions", function() {
            var y = i.props.year, L = i.state.yearsList.map(function(k) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: y === k ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                    key: k,
                    onClick: i.onChange.bind($0422a6ce4ea03acc$var$U(i), k),
                    "aria-selected": y === k ? "true" : void 0
                }, y === k ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "react-datepicker__year-option--selected"
                }, "\u2713") : "", k);
            }), M = i.props.minDate ? $0422a6ce4ea03acc$var$K2(i.props.minDate) : null, E = i.props.maxDate ? $0422a6ce4ea03acc$var$K2(i.props.maxDate) : null;
            return E && i.state.yearsList.find(function(k) {
                return k === E;
            }) || L.unshift((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "upcoming",
                onClick: i.incrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
            }))), M && i.state.yearsList.find(function(k) {
                return k === M;
            }) || L.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "previous",
                onClick: i.decrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
            }))), L;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "onChange", function(y) {
            i.props.onChange(y);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleClickOutside", function() {
            i.props.onCancel();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "shiftYears", function(y) {
            var L = i.state.yearsList.map(function(M) {
                return M + y;
            });
            i.setState({
                yearsList: L
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "incrementYears", function() {
            return i.shiftYears(1);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "decrementYears", function() {
            return i.shiftYears(-1);
        });
        var p = s.yearDropdownItemNumber, C = s.scrollableYearDropdown, v = p || (C ? 10 : 5);
        return i.state = {
            yearsList: $0422a6ce4ea03acc$var$HN(i.props.year, v, i.props.minDate, i.props.maxDate)
        }, i.dropdownRef = (0, $acw62.createRef)(), i;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "componentDidMount",
            value: function() {
                var s = this.dropdownRef.current;
                if (s) {
                    var i = s.children ? Array.from(s.children) : null, p = i ? i.find(function(C) {
                        return C.ariaSelected;
                    }) : null;
                    s.scrollTop = p ? p.offsetTop + (p.clientHeight - s.clientHeight) / 2 : (s.scrollHeight - s.clientHeight) / 2;
                }
            }
        },
        {
            key: "render",
            value: function() {
                var s = $0422a6ce4ea03acc$var$L5({
                    "react-datepicker__year-dropdown": !0,
                    "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: s,
                    ref: this.dropdownRef
                }, this.renderOptions());
            }
        }
    ]), o;
}()), $0422a6ce4ea03acc$var$VN = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$H4(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s = a.call.apply(a, [
            this
        ].concat(p))), "state", {
            dropdownVisible: !1
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderSelectOptions", function() {
            for(var v = s.props.minDate ? $0422a6ce4ea03acc$var$K2(s.props.minDate) : 1900, y = s.props.maxDate ? $0422a6ce4ea03acc$var$K2(s.props.maxDate) : 2100, L = [], M = v; M <= y; M++)L.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                key: M,
                value: M
            }, M));
            return L;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onSelectChange", function(v) {
            s.onChange(v.target.value);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderSelectMode", function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
                value: s.props.year,
                className: "react-datepicker__year-select",
                onChange: s.onSelectChange
            }, s.renderSelectOptions());
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderReadView", function(v) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: "read",
                style: {
                    visibility: v ? "visible" : "hidden"
                },
                className: "react-datepicker__year-read-view",
                onClick: function(y) {
                    return s.toggleDropdown(y);
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__year-read-view--selected-year"
            }, s.props.year));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderDropdown", function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$xN, {
                key: "dropdown",
                year: s.props.year,
                onChange: s.onChange,
                onCancel: s.toggleDropdown,
                minDate: s.props.minDate,
                maxDate: s.props.maxDate,
                scrollableYearDropdown: s.props.scrollableYearDropdown,
                yearDropdownItemNumber: s.props.yearDropdownItemNumber
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderScrollMode", function() {
            var v = s.state.dropdownVisible, y = [
                s.renderReadView(!v)
            ];
            return v && y.unshift(s.renderDropdown()), y;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onChange", function(v) {
            s.toggleDropdown(), v !== s.props.year && s.props.onChange(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "toggleDropdown", function(v) {
            s.setState({
                dropdownVisible: !s.state.dropdownVisible
            }, function() {
                s.props.adjustDateOnChange && s.handleYearChange(s.props.date, v);
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleYearChange", function(v, y) {
            s.onSelect(v, y), s.setOpen();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onSelect", function(v, y) {
            s.props.onSelect && s.props.onSelect(v, y);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "setOpen", function() {
            s.props.setOpen && s.props.setOpen(!0);
        }), s;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                var s;
                switch(this.props.dropdownMode){
                    case "scroll":
                        s = this.renderScrollMode();
                        break;
                    case "select":
                        s = this.renderSelectMode();
                }
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                }, s);
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$MN = $0422a6ce4ea03acc$var$wc(function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$H4(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s = a.call.apply(a, [
            this
        ].concat(p))), "isSelectedMonth", function(v) {
            return s.props.month === v;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderOptions", function() {
            return s.props.monthNames.map(function(v, y) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: s.isSelectedMonth(y) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                    key: v,
                    onClick: s.onChange.bind($0422a6ce4ea03acc$var$U(s), y),
                    "aria-selected": s.isSelectedMonth(y) ? "true" : void 0
                }, s.isSelectedMonth(y) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "react-datepicker__month-option--selected"
                }, "\u2713") : "", v);
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onChange", function(v) {
            return s.props.onChange(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleClickOutside", function() {
            return s.props.onCancel();
        }), s;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__month-dropdown"
                }, this.renderOptions());
            }
        }
    ]), o;
}()), $0422a6ce4ea03acc$var$EN = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$H4(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s = a.call.apply(a, [
            this
        ].concat(p))), "state", {
            dropdownVisible: !1
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderSelectOptions", function(v) {
            return v.map(function(y, L) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                    key: L,
                    value: L
                }, y);
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderSelectMode", function(v) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
                value: s.props.month,
                className: "react-datepicker__month-select",
                onChange: function(y) {
                    return s.onChange(y.target.value);
                }
            }, s.renderSelectOptions(v));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderReadView", function(v, y) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: "read",
                style: {
                    visibility: v ? "visible" : "hidden"
                },
                className: "react-datepicker__month-read-view",
                onClick: s.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__month-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__month-read-view--selected-month"
            }, y[s.props.month]));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderDropdown", function(v) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$MN, {
                key: "dropdown",
                month: s.props.month,
                monthNames: v,
                onChange: s.onChange,
                onCancel: s.toggleDropdown
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderScrollMode", function(v) {
            var y = s.state.dropdownVisible, L = [
                s.renderReadView(!y, v)
            ];
            return y && L.unshift(s.renderDropdown(v)), L;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onChange", function(v) {
            s.toggleDropdown(), v !== s.props.month && s.props.onChange(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "toggleDropdown", function() {
            return s.setState({
                dropdownVisible: !s.state.dropdownVisible
            });
        }), s;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                var s, i = this, p = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11
                ].map(this.props.useShortMonthInDropdown ? function(C) {
                    return $0422a6ce4ea03acc$var$Kb(C, i.props.locale);
                } : function(C) {
                    return $0422a6ce4ea03acc$var$Nh(C, i.props.locale);
                });
                switch(this.props.dropdownMode){
                    case "scroll":
                        s = this.renderScrollMode(p);
                        break;
                    case "select":
                        s = this.renderSelectMode(p);
                }
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                }, s);
            }
        }
    ]), o;
}();
function $0422a6ce4ea03acc$var$SN(r, a) {
    for(var o = [], s = $0422a6ce4ea03acc$var$g0(r), i = $0422a6ce4ea03acc$var$g0(a); !$0422a6ce4ea03acc$var$y0(s, i);)o.push($0422a6ce4ea03acc$var$A3(s)), s = $0422a6ce4ea03acc$var$v7(s, 1);
    return o;
}
var $0422a6ce4ea03acc$var$Uu, $0422a6ce4ea03acc$var$kN = $0422a6ce4ea03acc$var$wc(function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o(s) {
        var i;
        return $0422a6ce4ea03acc$var$H4(this, o), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i = a.call(this, s)), "renderOptions", function() {
            return i.state.monthYearsList.map(function(p) {
                var C = $0422a6ce4ea03acc$var$Yp(p), v = $0422a6ce4ea03acc$var$m0(i.props.date, p) && $0422a6ce4ea03acc$var$h7(i.props.date, p);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: v ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                    key: C,
                    onClick: i.onChange.bind($0422a6ce4ea03acc$var$U(i), C),
                    "aria-selected": v ? "true" : void 0
                }, v ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "react-datepicker__month-year-option--selected"
                }, "\u2713") : "", $0422a6ce4ea03acc$var$Fe(p, i.props.dateFormat, i.props.locale));
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "onChange", function(p) {
            return i.props.onChange(p);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleClickOutside", function() {
            i.props.onCancel();
        }), i.state = {
            monthYearsList: $0422a6ce4ea03acc$var$SN(i.props.minDate, i.props.maxDate)
        }, i;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                var s = $0422a6ce4ea03acc$var$L5({
                    "react-datepicker__month-year-dropdown": !0,
                    "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: s
                }, this.renderOptions());
            }
        }
    ]), o;
}()), $0422a6ce4ea03acc$var$TN = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$H4(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s = a.call.apply(a, [
            this
        ].concat(p))), "state", {
            dropdownVisible: !1
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderSelectOptions", function() {
            for(var v = $0422a6ce4ea03acc$var$g0(s.props.minDate), y = $0422a6ce4ea03acc$var$g0(s.props.maxDate), L = []; !$0422a6ce4ea03acc$var$y0(v, y);){
                var M = $0422a6ce4ea03acc$var$Yp(v);
                L.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                    key: M,
                    value: M
                }, $0422a6ce4ea03acc$var$Fe(v, s.props.dateFormat, s.props.locale))), v = $0422a6ce4ea03acc$var$v7(v, 1);
            }
            return L;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onSelectChange", function(v) {
            s.onChange(v.target.value);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderSelectMode", function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
                value: $0422a6ce4ea03acc$var$Yp($0422a6ce4ea03acc$var$g0(s.props.date)),
                className: "react-datepicker__month-year-select",
                onChange: s.onSelectChange
            }, s.renderSelectOptions());
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderReadView", function(v) {
            var y = $0422a6ce4ea03acc$var$Fe(s.props.date, s.props.dateFormat, s.props.locale);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: "read",
                style: {
                    visibility: v ? "visible" : "hidden"
                },
                className: "react-datepicker__month-year-read-view",
                onClick: function(L) {
                    return s.toggleDropdown(L);
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__month-year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__month-year-read-view--selected-month-year"
            }, y));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderDropdown", function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$kN, {
                key: "dropdown",
                date: s.props.date,
                dateFormat: s.props.dateFormat,
                onChange: s.onChange,
                onCancel: s.toggleDropdown,
                minDate: s.props.minDate,
                maxDate: s.props.maxDate,
                scrollableMonthYearDropdown: s.props.scrollableMonthYearDropdown,
                locale: s.props.locale
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderScrollMode", function() {
            var v = s.state.dropdownVisible, y = [
                s.renderReadView(!v)
            ];
            return v && y.unshift(s.renderDropdown()), y;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onChange", function(v) {
            s.toggleDropdown();
            var y = $0422a6ce4ea03acc$var$A3(parseInt(v));
            $0422a6ce4ea03acc$var$m0(s.props.date, y) && $0422a6ce4ea03acc$var$h7(s.props.date, y) || s.props.onChange(y);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "toggleDropdown", function() {
            return s.setState({
                dropdownVisible: !s.state.dropdownVisible
            });
        }), s;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                var s;
                switch(this.props.dropdownMode){
                    case "scroll":
                        s = this.renderScrollMode();
                        break;
                    case "select":
                        s = this.renderSelectMode();
                }
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                }, s);
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$_N = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$H4(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s = a.call.apply(a, [
            this
        ].concat(p))), "dayEl", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef()), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleClick", function(v) {
            !s.isDisabled() && s.props.onClick && s.props.onClick(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleMouseEnter", function(v) {
            !s.isDisabled() && s.props.onMouseEnter && s.props.onMouseEnter(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleOnKeyDown", function(v) {
            v.key === " " && (v.preventDefault(), v.key = "Enter"), s.props.handleOnKeyDown(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isSameDay", function(v) {
            return $0422a6ce4ea03acc$var$y5(s.props.day, v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isKeyboardSelected", function() {
            return !s.props.disabledKeyboardNavigation && !s.isSameDay(s.props.selected) && s.isSameDay(s.props.preSelection);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isDisabled", function() {
            return $0422a6ce4ea03acc$var$Vc(s.props.day, s.props);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isExcluded", function() {
            return $0422a6ce4ea03acc$var$Ph(s.props.day, s.props);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "getHighLightedClass", function(v) {
            var y = s.props, L = y.day, M = y.highlightDates;
            if (!M) return !1;
            var E = $0422a6ce4ea03acc$var$Fe(L, "MM.dd.yyyy");
            return M.get(E);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isInRange", function() {
            var v = s.props, y = v.day, L = v.startDate, M = v.endDate;
            return !(!L || !M) && $0422a6ce4ea03acc$var$Gu(y, L, M);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isInSelectingRange", function() {
            var v, y = s.props, L = y.day, M = y.selectsStart, E = y.selectsEnd, k = y.selectsRange, _ = y.selectsDisabledDaysInRange, Z = y.startDate, O = y.endDate, B = (v = s.props.selectingDate) !== null && v !== void 0 ? v : s.props.preSelection;
            return !(!(M || E || k) || !B || !_ && s.isDisabled()) && (M && O && ($0422a6ce4ea03acc$var$l9(B, O) || $0422a6ce4ea03acc$var$v0(B, O)) ? $0422a6ce4ea03acc$var$Gu(L, B, O) : (E && Z && ($0422a6ce4ea03acc$var$y0(B, Z) || $0422a6ce4ea03acc$var$v0(B, Z)) || !(!k || !Z || O || !$0422a6ce4ea03acc$var$y0(B, Z) && !$0422a6ce4ea03acc$var$v0(B, Z))) && $0422a6ce4ea03acc$var$Gu(L, Z, B));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isSelectingRangeStart", function() {
            var v;
            if (!s.isInSelectingRange()) return !1;
            var y = s.props, L = y.day, M = y.startDate, E = y.selectsStart, k = (v = s.props.selectingDate) !== null && v !== void 0 ? v : s.props.preSelection;
            return $0422a6ce4ea03acc$var$y5(L, E ? k : M);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isSelectingRangeEnd", function() {
            var v;
            if (!s.isInSelectingRange()) return !1;
            var y = s.props, L = y.day, M = y.endDate, E = y.selectsEnd, k = y.selectsRange, _ = (v = s.props.selectingDate) !== null && v !== void 0 ? v : s.props.preSelection;
            return $0422a6ce4ea03acc$var$y5(L, E || k ? _ : M);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isRangeStart", function() {
            var v = s.props, y = v.day, L = v.startDate, M = v.endDate;
            return !(!L || !M) && $0422a6ce4ea03acc$var$y5(L, y);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isRangeEnd", function() {
            var v = s.props, y = v.day, L = v.startDate, M = v.endDate;
            return !(!L || !M) && $0422a6ce4ea03acc$var$y5(M, y);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isWeekend", function() {
            var v = $0422a6ce4ea03acc$var$XD(s.props.day);
            return v === 0 || v === 6;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isAfterMonth", function() {
            return s.props.month !== void 0 && (s.props.month + 1) % 12 === $0422a6ce4ea03acc$var$a5(s.props.day);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isBeforeMonth", function() {
            return s.props.month !== void 0 && ($0422a6ce4ea03acc$var$a5(s.props.day) + 1) % 12 === s.props.month;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isCurrentDay", function() {
            return s.isSameDay($0422a6ce4ea03acc$var$A3());
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isSelected", function() {
            return s.isSameDay(s.props.selected);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "getClassNames", function(v) {
            var y = s.props.dayClassName ? s.props.dayClassName(v) : void 0;
            return $0422a6ce4ea03acc$var$L5("react-datepicker__day", y, "react-datepicker__day--" + $0422a6ce4ea03acc$var$gN(s.props.day), {
                "react-datepicker__day--disabled": s.isDisabled(),
                "react-datepicker__day--excluded": s.isExcluded(),
                "react-datepicker__day--selected": s.isSelected(),
                "react-datepicker__day--keyboard-selected": s.isKeyboardSelected(),
                "react-datepicker__day--range-start": s.isRangeStart(),
                "react-datepicker__day--range-end": s.isRangeEnd(),
                "react-datepicker__day--in-range": s.isInRange(),
                "react-datepicker__day--in-selecting-range": s.isInSelectingRange(),
                "react-datepicker__day--selecting-range-start": s.isSelectingRangeStart(),
                "react-datepicker__day--selecting-range-end": s.isSelectingRangeEnd(),
                "react-datepicker__day--today": s.isCurrentDay(),
                "react-datepicker__day--weekend": s.isWeekend(),
                "react-datepicker__day--outside-month": s.isAfterMonth() || s.isBeforeMonth()
            }, s.getHighLightedClass("react-datepicker__day--highlighted"));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "getAriaLabel", function() {
            var v = s.props, y = v.day, L = v.ariaLabelPrefixWhenEnabled, M = L === void 0 ? "Choose" : L, E = v.ariaLabelPrefixWhenDisabled, k = E === void 0 ? "Not available" : E, _ = s.isDisabled() || s.isExcluded() ? k : M;
            return "".concat(_, " ").concat($0422a6ce4ea03acc$var$Fe(y, "PPPP", s.props.locale));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "getTabIndex", function(v, y) {
            var L = v || s.props.selected, M = y || s.props.preSelection;
            return s.isKeyboardSelected() || s.isSameDay(L) && $0422a6ce4ea03acc$var$y5(M, L) ? 0 : -1;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleFocusDay", function() {
            var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, y = !1;
            s.getTabIndex() === 0 && !v.isInputFocused && s.isSameDay(s.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (y = !0), s.props.inline && !s.props.shouldFocusDayInline && (y = !1), s.props.containerRef && s.props.containerRef.current && s.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (y = !0), s.props.monthShowsDuplicateDaysEnd && s.isAfterMonth() && (y = !1), s.props.monthShowsDuplicateDaysStart && s.isBeforeMonth() && (y = !1)), y && s.dayEl.current.focus({
                preventScroll: !0
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderDayContents", function() {
            return s.props.monthShowsDuplicateDaysEnd && s.isAfterMonth() || s.props.monthShowsDuplicateDaysStart && s.isBeforeMonth() ? null : s.props.renderDayContents ? s.props.renderDayContents($0422a6ce4ea03acc$var$Iy(s.props.day), s.props.day) : $0422a6ce4ea03acc$var$Iy(s.props.day);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "render", function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                ref: s.dayEl,
                className: s.getClassNames(s.props.day),
                onKeyDown: s.handleOnKeyDown,
                onClick: s.handleClick,
                onMouseEnter: s.handleMouseEnter,
                tabIndex: s.getTabIndex(),
                "aria-label": s.getAriaLabel(),
                role: "option",
                "aria-disabled": s.isDisabled(),
                "aria-current": s.isCurrentDay() ? "date" : void 0,
                "aria-selected": s.isSelected() || s.isInRange()
            }, s.renderDayContents());
        }), s;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "componentDidMount",
            value: function() {
                this.handleFocusDay();
            }
        },
        {
            key: "componentDidUpdate",
            value: function(s) {
                this.handleFocusDay(s);
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$DN = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$H4(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s = a.call.apply(a, [
            this
        ].concat(p))), "handleClick", function(v) {
            s.props.onClick && s.props.onClick(v);
        }), s;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                var s = this.props, i = s.weekNumber, p = s.ariaLabelPrefix, C = p === void 0 ? "week " : p, v = {
                    "react-datepicker__week-number": !0,
                    "react-datepicker__week-number--clickable": !!s.onClick
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: $0422a6ce4ea03acc$var$L5(v),
                    "aria-label": "".concat(C, " ").concat(this.props.weekNumber),
                    onClick: this.handleClick
                }, i);
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$RN = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$H4(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s = a.call.apply(a, [
            this
        ].concat(p))), "handleDayClick", function(v, y) {
            s.props.onDayClick && s.props.onDayClick(v, y);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleDayMouseEnter", function(v) {
            s.props.onDayMouseEnter && s.props.onDayMouseEnter(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleWeekClick", function(v, y, L) {
            typeof s.props.onWeekSelect == "function" && s.props.onWeekSelect(v, y, L), s.props.shouldCloseOnSelect && s.props.setOpen(!1);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "formatWeekNumber", function(v) {
            return s.props.formatWeekNumber ? s.props.formatWeekNumber(v) : $0422a6ce4ea03acc$var$vN(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderDays", function() {
            var v = $0422a6ce4ea03acc$var$Oh(s.props.day, s.props.locale, s.props.calendarStartDay), y = [], L = s.formatWeekNumber(v);
            if (s.props.showWeekNumber) {
                var M = s.props.onWeekSelect ? s.handleWeekClick.bind($0422a6ce4ea03acc$var$U(s), v, L) : void 0;
                y.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$DN, {
                    key: "W",
                    weekNumber: L,
                    onClick: M,
                    ariaLabelPrefix: s.props.ariaLabelPrefix
                }));
            }
            return y.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(E) {
                var k = $0422a6ce4ea03acc$var$ia(v, E);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$_N, {
                    ariaLabelPrefixWhenEnabled: s.props.chooseDayAriaLabelPrefix,
                    ariaLabelPrefixWhenDisabled: s.props.disabledDayAriaLabelPrefix,
                    key: k.valueOf(),
                    day: k,
                    month: s.props.month,
                    onClick: s.handleDayClick.bind($0422a6ce4ea03acc$var$U(s), k),
                    onMouseEnter: s.handleDayMouseEnter.bind($0422a6ce4ea03acc$var$U(s), k),
                    minDate: s.props.minDate,
                    maxDate: s.props.maxDate,
                    excludeDates: s.props.excludeDates,
                    excludeDateIntervals: s.props.excludeDateIntervals,
                    includeDates: s.props.includeDates,
                    includeDateIntervals: s.props.includeDateIntervals,
                    highlightDates: s.props.highlightDates,
                    selectingDate: s.props.selectingDate,
                    filterDate: s.props.filterDate,
                    preSelection: s.props.preSelection,
                    selected: s.props.selected,
                    selectsStart: s.props.selectsStart,
                    selectsEnd: s.props.selectsEnd,
                    selectsRange: s.props.selectsRange,
                    selectsDisabledDaysInRange: s.props.selectsDisabledDaysInRange,
                    startDate: s.props.startDate,
                    endDate: s.props.endDate,
                    dayClassName: s.props.dayClassName,
                    renderDayContents: s.props.renderDayContents,
                    disabledKeyboardNavigation: s.props.disabledKeyboardNavigation,
                    handleOnKeyDown: s.props.handleOnKeyDown,
                    isInputFocused: s.props.isInputFocused,
                    containerRef: s.props.containerRef,
                    inline: s.props.inline,
                    shouldFocusDayInline: s.props.shouldFocusDayInline,
                    monthShowsDuplicateDaysEnd: s.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: s.props.monthShowsDuplicateDaysStart,
                    locale: s.props.locale
                });
            }));
        }), s;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__week"
                }, this.renderDays());
            }
        }
    ], [
        {
            key: "defaultProps",
            get: function() {
                return {
                    shouldCloseOnSelect: !0
                };
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$rw = "two_columns", $0422a6ce4ea03acc$var$aw = "three_columns", $0422a6ce4ea03acc$var$iw = "four_columns", $0422a6ce4ea03acc$var$bp = ($0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$Uu = {}, $0422a6ce4ea03acc$var$rw, {
    grid: [
        [
            0,
            1
        ],
        [
            2,
            3
        ],
        [
            4,
            5
        ],
        [
            6,
            7
        ],
        [
            8,
            9
        ],
        [
            10,
            11
        ]
    ],
    verticalNavigationOffset: 2
}), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$Uu, $0422a6ce4ea03acc$var$aw, {
    grid: [
        [
            0,
            1,
            2
        ],
        [
            3,
            4,
            5
        ],
        [
            6,
            7,
            8
        ],
        [
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 3
}), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$Uu, $0422a6ce4ea03acc$var$iw, {
    grid: [
        [
            0,
            1,
            2,
            3
        ],
        [
            4,
            5,
            6,
            7
        ],
        [
            8,
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 4
}), $0422a6ce4ea03acc$var$Uu);
function $0422a6ce4ea03acc$var$TL(r, a) {
    return r ? $0422a6ce4ea03acc$var$iw : a ? $0422a6ce4ea03acc$var$rw : $0422a6ce4ea03acc$var$aw;
}
var $0422a6ce4ea03acc$var$ZN = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$H4(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s = a.call.apply(a, [
            this
        ].concat(p))), "MONTH_REFS", $0422a6ce4ea03acc$var$rh(Array(12)).map(function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
        })), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "QUARTER_REFS", $0422a6ce4ea03acc$var$rh(Array(4)).map(function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
        })), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isDisabled", function(v) {
            return $0422a6ce4ea03acc$var$Vc(v, s.props);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isExcluded", function(v) {
            return $0422a6ce4ea03acc$var$Ph(v, s.props);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleDayClick", function(v, y) {
            s.props.onDayClick && s.props.onDayClick(v, y, s.props.orderInDisplay);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleDayMouseEnter", function(v) {
            s.props.onDayMouseEnter && s.props.onDayMouseEnter(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleMouseLeave", function() {
            s.props.onMouseLeave && s.props.onMouseLeave();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isRangeStartMonth", function(v) {
            var y = s.props, L = y.day, M = y.startDate, E = y.endDate;
            return !(!M || !E) && $0422a6ce4ea03acc$var$h7($0422a6ce4ea03acc$var$g5(L, v), M);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isRangeStartQuarter", function(v) {
            var y = s.props, L = y.day, M = y.startDate, E = y.endDate;
            return !(!M || !E) && $0422a6ce4ea03acc$var$Cc($0422a6ce4ea03acc$var$Fr(L, v), M);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isRangeEndMonth", function(v) {
            var y = s.props, L = y.day, M = y.startDate, E = y.endDate;
            return !(!M || !E) && $0422a6ce4ea03acc$var$h7($0422a6ce4ea03acc$var$g5(L, v), E);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isRangeEndQuarter", function(v) {
            var y = s.props, L = y.day, M = y.startDate, E = y.endDate;
            return !(!M || !E) && $0422a6ce4ea03acc$var$Cc($0422a6ce4ea03acc$var$Fr(L, v), E);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isInSelectingRangeMonth", function(v) {
            var y, L = s.props, M = L.day, E = L.selectsStart, k = L.selectsEnd, _ = L.selectsRange, Z = L.startDate, O = L.endDate, B = (y = s.props.selectingDate) !== null && y !== void 0 ? y : s.props.preSelection;
            return !(!(E || k || _) || !B) && (E && O ? $0422a6ce4ea03acc$var$gp(B, O, v, M) : (k && Z || !(!_ || !Z || O)) && $0422a6ce4ea03acc$var$gp(Z, B, v, M));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isSelectingMonthRangeStart", function(v) {
            var y;
            if (!s.isInSelectingRangeMonth(v)) return !1;
            var L = s.props, M = L.day, E = L.startDate, k = L.selectsStart, _ = $0422a6ce4ea03acc$var$g5(M, v), Z = (y = s.props.selectingDate) !== null && y !== void 0 ? y : s.props.preSelection;
            return $0422a6ce4ea03acc$var$h7(_, k ? Z : E);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isSelectingMonthRangeEnd", function(v) {
            var y;
            if (!s.isInSelectingRangeMonth(v)) return !1;
            var L = s.props, M = L.day, E = L.endDate, k = L.selectsEnd, _ = L.selectsRange, Z = $0422a6ce4ea03acc$var$g5(M, v), O = (y = s.props.selectingDate) !== null && y !== void 0 ? y : s.props.preSelection;
            return $0422a6ce4ea03acc$var$h7(Z, k || _ ? O : E);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isInSelectingRangeQuarter", function(v) {
            var y, L = s.props, M = L.day, E = L.selectsStart, k = L.selectsEnd, _ = L.selectsRange, Z = L.startDate, O = L.endDate, B = (y = s.props.selectingDate) !== null && y !== void 0 ? y : s.props.preSelection;
            return !(!(E || k || _) || !B) && (E && O ? $0422a6ce4ea03acc$var$Lp(B, O, v, M) : (k && Z || !(!_ || !Z || O)) && $0422a6ce4ea03acc$var$Lp(Z, B, v, M));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isWeekInMonth", function(v) {
            var y = s.props.day, L = $0422a6ce4ea03acc$var$ia(v, 6);
            return $0422a6ce4ea03acc$var$h7(v, y) || $0422a6ce4ea03acc$var$h7(L, y);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isCurrentMonth", function(v, y) {
            return $0422a6ce4ea03acc$var$K2(v) === $0422a6ce4ea03acc$var$K2($0422a6ce4ea03acc$var$A3()) && y === $0422a6ce4ea03acc$var$a5($0422a6ce4ea03acc$var$A3());
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isCurrentQuarter", function(v, y) {
            return $0422a6ce4ea03acc$var$K2(v) === $0422a6ce4ea03acc$var$K2($0422a6ce4ea03acc$var$A3()) && y === $0422a6ce4ea03acc$var$zr($0422a6ce4ea03acc$var$A3());
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isSelectedMonth", function(v, y, L) {
            return $0422a6ce4ea03acc$var$a5(v) === y && $0422a6ce4ea03acc$var$K2(v) === $0422a6ce4ea03acc$var$K2(L);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isSelectedQuarter", function(v, y, L) {
            return $0422a6ce4ea03acc$var$zr(v) === y && $0422a6ce4ea03acc$var$K2(v) === $0422a6ce4ea03acc$var$K2(L);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderWeeks", function() {
            for(var v = [], y = s.props.fixedHeight, L = 0, M = !1, E = $0422a6ce4ea03acc$var$Oh($0422a6ce4ea03acc$var$g0(s.props.day), s.props.locale, s.props.calendarStartDay); v.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$RN, {
                ariaLabelPrefix: s.props.weekAriaLabelPrefix,
                chooseDayAriaLabelPrefix: s.props.chooseDayAriaLabelPrefix,
                disabledDayAriaLabelPrefix: s.props.disabledDayAriaLabelPrefix,
                key: L,
                day: E,
                month: $0422a6ce4ea03acc$var$a5(s.props.day),
                onDayClick: s.handleDayClick,
                onDayMouseEnter: s.handleDayMouseEnter,
                onWeekSelect: s.props.onWeekSelect,
                formatWeekNumber: s.props.formatWeekNumber,
                locale: s.props.locale,
                minDate: s.props.minDate,
                maxDate: s.props.maxDate,
                excludeDates: s.props.excludeDates,
                excludeDateIntervals: s.props.excludeDateIntervals,
                includeDates: s.props.includeDates,
                includeDateIntervals: s.props.includeDateIntervals,
                inline: s.props.inline,
                shouldFocusDayInline: s.props.shouldFocusDayInline,
                highlightDates: s.props.highlightDates,
                selectingDate: s.props.selectingDate,
                filterDate: s.props.filterDate,
                preSelection: s.props.preSelection,
                selected: s.props.selected,
                selectsStart: s.props.selectsStart,
                selectsEnd: s.props.selectsEnd,
                selectsRange: s.props.selectsRange,
                selectsDisabledDaysInRange: s.props.selectsDisabledDaysInRange,
                showWeekNumber: s.props.showWeekNumbers,
                startDate: s.props.startDate,
                endDate: s.props.endDate,
                dayClassName: s.props.dayClassName,
                setOpen: s.props.setOpen,
                shouldCloseOnSelect: s.props.shouldCloseOnSelect,
                disabledKeyboardNavigation: s.props.disabledKeyboardNavigation,
                renderDayContents: s.props.renderDayContents,
                handleOnKeyDown: s.props.handleOnKeyDown,
                isInputFocused: s.props.isInputFocused,
                containerRef: s.props.containerRef,
                calendarStartDay: s.props.calendarStartDay,
                monthShowsDuplicateDaysEnd: s.props.monthShowsDuplicateDaysEnd,
                monthShowsDuplicateDaysStart: s.props.monthShowsDuplicateDaysStart
            })), !M;){
                L++, E = $0422a6ce4ea03acc$var$wh(E, 1);
                var k = y && L >= 6, _ = !y && !s.isWeekInMonth(E);
                if (k || _) {
                    if (!s.props.peekNextMonth) break;
                    M = !0;
                }
            }
            return v;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onMonthClick", function(v, y) {
            s.handleDayClick($0422a6ce4ea03acc$var$g0($0422a6ce4ea03acc$var$g5(s.props.day, y)), v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onMonthMouseEnter", function(v) {
            s.handleDayMouseEnter($0422a6ce4ea03acc$var$g0($0422a6ce4ea03acc$var$g5(s.props.day, v)));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleMonthNavigation", function(v, y) {
            s.isDisabled(y) || s.isExcluded(y) || (s.props.setPreSelection(y), s.MONTH_REFS[v].current && s.MONTH_REFS[v].current.focus());
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onMonthKeyDown", function(v, y) {
            var L = s.props, M = L.selected, E = L.preSelection, k = L.disabledKeyboardNavigation, _ = L.showTwoColumnMonthYearPicker, Z = L.showFourColumnMonthYearPicker, O = L.setPreSelection, B = v.key;
            if (B !== "Tab" && v.preventDefault(), !k) {
                var z = $0422a6ce4ea03acc$var$TL(Z, _), I = $0422a6ce4ea03acc$var$bp[z].verticalNavigationOffset, P = $0422a6ce4ea03acc$var$bp[z].grid;
                switch(B){
                    case "Enter":
                        s.onMonthClick(v, y), O(M);
                        break;
                    case "ArrowRight":
                        s.handleMonthNavigation(y === 11 ? 0 : y + 1, $0422a6ce4ea03acc$var$v7(E, 1));
                        break;
                    case "ArrowLeft":
                        s.handleMonthNavigation(y === 0 ? 11 : y - 1, $0422a6ce4ea03acc$var$Gr(E, 1));
                        break;
                    case "ArrowUp":
                        s.handleMonthNavigation(P[0].includes(y) ? y + 12 - I : y - I, $0422a6ce4ea03acc$var$Gr(E, I));
                        break;
                    case "ArrowDown":
                        s.handleMonthNavigation(P[P.length - 1].includes(y) ? y - 12 + I : y + I, $0422a6ce4ea03acc$var$v7(E, I));
                }
            }
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onQuarterClick", function(v, y) {
            s.handleDayClick($0422a6ce4ea03acc$var$yL($0422a6ce4ea03acc$var$Fr(s.props.day, y)), v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onQuarterMouseEnter", function(v) {
            s.handleDayMouseEnter($0422a6ce4ea03acc$var$yL($0422a6ce4ea03acc$var$Fr(s.props.day, v)));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleQuarterNavigation", function(v, y) {
            s.isDisabled(y) || s.isExcluded(y) || (s.props.setPreSelection(y), s.QUARTER_REFS[v - 1].current && s.QUARTER_REFS[v - 1].current.focus());
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "onQuarterKeyDown", function(v, y) {
            var L = v.key;
            if (!s.props.disabledKeyboardNavigation) switch(L){
                case "Enter":
                    s.onQuarterClick(v, y), s.props.setPreSelection(s.props.selected);
                    break;
                case "ArrowRight":
                    s.handleQuarterNavigation(y === 4 ? 1 : y + 1, $0422a6ce4ea03acc$var$wb(s.props.preSelection, 1));
                    break;
                case "ArrowLeft":
                    s.handleQuarterNavigation(y === 1 ? 4 : y - 1, $0422a6ce4ea03acc$var$GD(s.props.preSelection, 1));
            }
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "getMonthClassNames", function(v) {
            var y = s.props, L = y.day, M = y.startDate, E = y.endDate, k = y.selected, _ = y.minDate, Z = y.maxDate, O = y.preSelection, B = y.monthClassName, z = y.excludeDates, I = y.includeDates, P = B ? B($0422a6ce4ea03acc$var$g5(L, v)) : void 0, $ = $0422a6ce4ea03acc$var$g5(L, v);
            return $0422a6ce4ea03acc$var$L5("react-datepicker__month-text", "react-datepicker__month-".concat(v), P, {
                "react-datepicker__month-text--disabled": (_ || Z || z || I) && $0422a6ce4ea03acc$var$Jb($, s.props),
                "react-datepicker__month-text--selected": s.isSelectedMonth(L, v, k),
                "react-datepicker__month-text--keyboard-selected": !s.props.disabledKeyboardNavigation && $0422a6ce4ea03acc$var$a5(O) === v,
                "react-datepicker__month-text--in-selecting-range": s.isInSelectingRangeMonth(v),
                "react-datepicker__month-text--in-range": $0422a6ce4ea03acc$var$gp(M, E, v, L),
                "react-datepicker__month-text--range-start": s.isRangeStartMonth(v),
                "react-datepicker__month-text--range-end": s.isRangeEndMonth(v),
                "react-datepicker__month-text--selecting-range-start": s.isSelectingMonthRangeStart(v),
                "react-datepicker__month-text--selecting-range-end": s.isSelectingMonthRangeEnd(v),
                "react-datepicker__month-text--today": s.isCurrentMonth(L, v)
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "getTabIndex", function(v) {
            var y = $0422a6ce4ea03acc$var$a5(s.props.preSelection);
            return s.props.disabledKeyboardNavigation || v !== y ? "-1" : "0";
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "getQuarterTabIndex", function(v) {
            var y = $0422a6ce4ea03acc$var$zr(s.props.preSelection);
            return s.props.disabledKeyboardNavigation || v !== y ? "-1" : "0";
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "getAriaLabel", function(v) {
            var y = s.props, L = y.chooseDayAriaLabelPrefix, M = L === void 0 ? "Choose" : L, E = y.disabledDayAriaLabelPrefix, k = E === void 0 ? "Not available" : E, _ = y.day, Z = $0422a6ce4ea03acc$var$g5(_, v), O = s.isDisabled(Z) || s.isExcluded(Z) ? k : M;
            return "".concat(O, " ").concat($0422a6ce4ea03acc$var$Fe(Z, "MMMM yyyy"));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "getQuarterClassNames", function(v) {
            var y = s.props, L = y.day, M = y.startDate, E = y.endDate, k = y.selected, _ = y.minDate, Z = y.maxDate, O = y.preSelection;
            return $0422a6ce4ea03acc$var$L5("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(v), {
                "react-datepicker__quarter-text--disabled": (_ || Z) && $0422a6ce4ea03acc$var$bN($0422a6ce4ea03acc$var$Fr(L, v), s.props),
                "react-datepicker__quarter-text--selected": s.isSelectedQuarter(L, v, k),
                "react-datepicker__quarter-text--keyboard-selected": $0422a6ce4ea03acc$var$zr(O) === v,
                "react-datepicker__quarter-text--in-selecting-range": s.isInSelectingRangeQuarter(v),
                "react-datepicker__quarter-text--in-range": $0422a6ce4ea03acc$var$Lp(M, E, v, L),
                "react-datepicker__quarter-text--range-start": s.isRangeStartQuarter(v),
                "react-datepicker__quarter-text--range-end": s.isRangeEndQuarter(v)
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderMonths", function() {
            var v = s.props, y = v.showFullMonthYearPicker, L = v.showTwoColumnMonthYearPicker, M = v.showFourColumnMonthYearPicker, E = v.locale, k = v.day, _ = v.selected;
            return $0422a6ce4ea03acc$var$bp[$0422a6ce4ea03acc$var$TL(M, L)].grid.map(function(Z, O) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__month-wrapper",
                    key: O
                }, Z.map(function(B, z) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        ref: s.MONTH_REFS[B],
                        key: z,
                        onClick: function(I) {
                            s.onMonthClick(I, B);
                        },
                        onKeyDown: function(I) {
                            s.onMonthKeyDown(I, B);
                        },
                        onMouseEnter: function() {
                            return s.onMonthMouseEnter(B);
                        },
                        tabIndex: s.getTabIndex(B),
                        className: s.getMonthClassNames(B),
                        role: "option",
                        "aria-label": s.getAriaLabel(B),
                        "aria-current": s.isCurrentMonth(k, B) ? "date" : void 0,
                        "aria-selected": s.isSelectedMonth(k, B, _)
                    }, y ? $0422a6ce4ea03acc$var$Nh(B, E) : $0422a6ce4ea03acc$var$Kb(B, E));
                }));
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderQuarters", function() {
            var v = s.props, y = v.day, L = v.selected;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__quarter-wrapper"
            }, [
                1,
                2,
                3,
                4
            ].map(function(M, E) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: E,
                    ref: s.QUARTER_REFS[E],
                    role: "option",
                    onClick: function(k) {
                        s.onQuarterClick(k, M);
                    },
                    onKeyDown: function(k) {
                        s.onQuarterKeyDown(k, M);
                    },
                    onMouseEnter: function() {
                        return s.onQuarterMouseEnter(M);
                    },
                    className: s.getQuarterClassNames(M),
                    "aria-selected": s.isSelectedQuarter(y, M, L),
                    tabIndex: s.getQuarterTabIndex(M),
                    "aria-current": s.isCurrentQuarter(y, M) ? "date" : void 0
                }, $0422a6ce4ea03acc$var$LN(M, s.props.locale));
            }));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "getClassNames", function() {
            var v = s.props;
            v.day;
            var y = v.selectingDate, L = v.selectsStart, M = v.selectsEnd, E = v.showMonthYearPicker, k = v.showQuarterYearPicker;
            return $0422a6ce4ea03acc$var$L5("react-datepicker__month", {
                "react-datepicker__month--selecting-range": y && (L || M)
            }, {
                "react-datepicker__monthPicker": E
            }, {
                "react-datepicker__quarterPicker": k
            });
        }), s;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                var s = this.props, i = s.showMonthYearPicker, p = s.showQuarterYearPicker, C = s.day, v = s.ariaLabelPrefix, y = v === void 0 ? "month " : v;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: this.getClassNames(),
                    onMouseLeave: this.handleMouseLeave,
                    "aria-label": "".concat(y, " ").concat($0422a6ce4ea03acc$var$Fe(C, "yyyy-MM")),
                    role: "listbox"
                }, i ? this.renderMonths() : p ? this.renderQuarters() : this.renderWeeks());
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$ow = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o() {
        var s;
        $0422a6ce4ea03acc$var$H4(this, o);
        for(var i = arguments.length, p = new Array(i), C = 0; C < i; C++)p[C] = arguments[C];
        return $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s = a.call.apply(a, [
            this
        ].concat(p))), "state", {
            height: null
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleClick", function(v) {
            (s.props.minTime || s.props.maxTime) && $0422a6ce4ea03acc$var$HL(v, s.props) || (s.props.excludeTimes || s.props.includeTimes || s.props.filterTime) && $0422a6ce4ea03acc$var$wL(v, s.props) || s.props.onChange(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "isSelectedTime", function(v, y, L) {
            return s.props.selected && y === $0422a6ce4ea03acc$var$i6(v) && L === $0422a6ce4ea03acc$var$a6(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "liClasses", function(v, y, L) {
            var M = [
                "react-datepicker__time-list-item",
                s.props.timeClassName ? s.props.timeClassName(v, y, L) : void 0
            ];
            return s.isSelectedTime(v, y, L) && M.push("react-datepicker__time-list-item--selected"), ((s.props.minTime || s.props.maxTime) && $0422a6ce4ea03acc$var$HL(v, s.props) || (s.props.excludeTimes || s.props.includeTimes || s.props.filterTime) && $0422a6ce4ea03acc$var$wL(v, s.props)) && M.push("react-datepicker__time-list-item--disabled"), s.props.injectTimes && (60 * $0422a6ce4ea03acc$var$i6(v) + $0422a6ce4ea03acc$var$a6(v)) % s.props.intervals != 0 && M.push("react-datepicker__time-list-item--injected"), M.join(" ");
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "handleOnKeyDown", function(v, y) {
            v.key === " " && (v.preventDefault(), v.key = "Enter"), v.key === "Enter" && s.handleClick(y), s.props.handleOnKeyDown(v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(s), "renderTimes", function() {
            for(var v = [], y = s.props.format ? s.props.format : "p", L = s.props.intervals, M = $0422a6ce4ea03acc$var$yN($0422a6ce4ea03acc$var$A3(s.props.selected)), E = 1440 / L, k = s.props.injectTimes && s.props.injectTimes.sort(function($, W) {
                return $ - W;
            }), _ = s.props.selected || s.props.openToDate || $0422a6ce4ea03acc$var$A3(), Z = $0422a6ce4ea03acc$var$i6(_), O = $0422a6ce4ea03acc$var$a6(_), B = $0422a6ce4ea03acc$var$ko($0422a6ce4ea03acc$var$So(M, O), Z), z = 0; z < E; z++){
                var I = $0422a6ce4ea03acc$var$$p(M, z * L);
                if (v.push(I), k) {
                    var P = $0422a6ce4ea03acc$var$wN(M, I, z, L, k);
                    v = v.concat(P);
                }
            }
            return v.map(function($, W) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    key: W,
                    onClick: s.handleClick.bind($0422a6ce4ea03acc$var$U(s), $),
                    className: s.liClasses($, Z, O),
                    ref: function(l1) {
                        ($0422a6ce4ea03acc$var$l9($, B) || $0422a6ce4ea03acc$var$v0($, B)) && (s.centerLi = l1);
                    },
                    onKeyDown: function(l1) {
                        s.handleOnKeyDown(l1, $);
                    },
                    tabIndex: "0",
                    "aria-selected": s.isSelectedTime($, Z, O) ? "true" : void 0
                }, $0422a6ce4ea03acc$var$Fe($, y, s.props.locale));
            });
        }), s;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "componentDidMount",
            value: function() {
                this.list.scrollTop = this.centerLi && o.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
                    height: this.props.monthRef.clientHeight - this.header.clientHeight
                });
            }
        },
        {
            key: "render",
            value: function() {
                var s = this, i = this.state.height;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                    ref: function(p) {
                        s.header = p;
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker-time__header"
                }, this.props.timeCaption)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__time"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__time-box"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
                    className: "react-datepicker__time-list",
                    ref: function(p) {
                        s.list = p;
                    },
                    style: i ? {
                        height: i
                    } : {},
                    tabIndex: "0"
                }, this.renderTimes()))));
            }
        }
    ], [
        {
            key: "defaultProps",
            get: function() {
                return {
                    intervals: 30,
                    onTimeChange: function() {},
                    todayButton: null,
                    timeCaption: "Time"
                };
            }
        }
    ]), o;
}();
$0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$ow, "calcCenterPosition", function(r, a) {
    return a.offsetTop - (r / 2 - a.clientHeight / 2);
});
var $0422a6ce4ea03acc$var$ON = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o(s) {
        var i;
        return $0422a6ce4ea03acc$var$H4(this, o), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i = a.call(this, s)), "YEAR_REFS", $0422a6ce4ea03acc$var$rh(Array(i.props.yearItemNumber)).map(function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
        })), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isDisabled", function(p) {
            return $0422a6ce4ea03acc$var$Vc(p, i.props);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isExcluded", function(p) {
            return $0422a6ce4ea03acc$var$Ph(p, i.props);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "selectingDate", function() {
            var p;
            return (p = i.props.selectingDate) !== null && p !== void 0 ? p : i.props.preSelection;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "updateFocusOnPaginate", function(p) {
            var C = (function() {
                this.YEAR_REFS[p].current.focus();
            }).bind($0422a6ce4ea03acc$var$U(i));
            window.requestAnimationFrame(C);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleYearClick", function(p, C) {
            i.props.onDayClick && i.props.onDayClick(p, C);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleYearNavigation", function(p, C) {
            var v = i.props, y = v.date, L = v.yearItemNumber, M = $0422a6ce4ea03acc$var$Ur(y, L).startPeriod;
            i.isDisabled(C) || i.isExcluded(C) || (i.props.setPreSelection(C), p - M == -1 ? i.updateFocusOnPaginate(L - 1) : p - M === L ? i.updateFocusOnPaginate(0) : i.YEAR_REFS[p - M].current.focus());
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isSameDay", function(p, C) {
            return $0422a6ce4ea03acc$var$y5(p, C);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isCurrentYear", function(p) {
            return p === $0422a6ce4ea03acc$var$K2($0422a6ce4ea03acc$var$A3());
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isRangeStart", function(p) {
            return i.props.startDate && i.props.endDate && $0422a6ce4ea03acc$var$m0($0422a6ce4ea03acc$var$i9($0422a6ce4ea03acc$var$A3(), p), i.props.startDate);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isRangeEnd", function(p) {
            return i.props.startDate && i.props.endDate && $0422a6ce4ea03acc$var$m0($0422a6ce4ea03acc$var$i9($0422a6ce4ea03acc$var$A3(), p), i.props.endDate);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isInRange", function(p) {
            return $0422a6ce4ea03acc$var$yp(p, i.props.startDate, i.props.endDate);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isInSelectingRange", function(p) {
            var C = i.props, v = C.selectsStart, y = C.selectsEnd, L = C.selectsRange, M = C.startDate, E = C.endDate;
            return !(!(v || y || L) || !i.selectingDate()) && (v && E ? $0422a6ce4ea03acc$var$yp(p, i.selectingDate(), E) : (y && M || !(!L || !M || E)) && $0422a6ce4ea03acc$var$yp(p, M, i.selectingDate()));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isSelectingRangeStart", function(p) {
            if (!i.isInSelectingRange(p)) return !1;
            var C = i.props, v = C.startDate, y = C.selectsStart, L = $0422a6ce4ea03acc$var$i9($0422a6ce4ea03acc$var$A3(), p);
            return $0422a6ce4ea03acc$var$m0(L, y ? i.selectingDate() : v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isSelectingRangeEnd", function(p) {
            if (!i.isInSelectingRange(p)) return !1;
            var C = i.props, v = C.endDate, y = C.selectsEnd, L = C.selectsRange, M = $0422a6ce4ea03acc$var$i9($0422a6ce4ea03acc$var$A3(), p);
            return $0422a6ce4ea03acc$var$m0(M, y || L ? i.selectingDate() : v);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isKeyboardSelected", function(p) {
            var C = $0422a6ce4ea03acc$var$Mo($0422a6ce4ea03acc$var$i9(i.props.date, p));
            return !i.props.disabledKeyboardNavigation && !i.props.inline && !$0422a6ce4ea03acc$var$y5(C, $0422a6ce4ea03acc$var$Mo(i.props.selected)) && $0422a6ce4ea03acc$var$y5(C, $0422a6ce4ea03acc$var$Mo(i.props.preSelection));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "onYearClick", function(p, C) {
            var v = i.props.date;
            i.handleYearClick($0422a6ce4ea03acc$var$Mo($0422a6ce4ea03acc$var$i9(v, C)), p);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "onYearKeyDown", function(p, C) {
            var v = p.key;
            if (!i.props.disabledKeyboardNavigation) switch(v){
                case "Enter":
                    i.onYearClick(p, C), i.props.setPreSelection(i.props.selected);
                    break;
                case "ArrowRight":
                    i.handleYearNavigation(C + 1, $0422a6ce4ea03acc$var$qr(i.props.preSelection, 1));
                    break;
                case "ArrowLeft":
                    i.handleYearNavigation(C - 1, $0422a6ce4ea03acc$var$Po(i.props.preSelection, 1));
            }
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "getYearClassNames", function(p) {
            var C = i.props, v = C.minDate, y = C.maxDate, L = C.selected, M = C.excludeDates, E = C.includeDates, k = C.filterDate;
            return $0422a6ce4ea03acc$var$L5("react-datepicker__year-text", {
                "react-datepicker__year-text--selected": p === $0422a6ce4ea03acc$var$K2(L),
                "react-datepicker__year-text--disabled": (v || y || M || E || k) && $0422a6ce4ea03acc$var$ew(p, i.props),
                "react-datepicker__year-text--keyboard-selected": i.isKeyboardSelected(p),
                "react-datepicker__year-text--range-start": i.isRangeStart(p),
                "react-datepicker__year-text--range-end": i.isRangeEnd(p),
                "react-datepicker__year-text--in-range": i.isInRange(p),
                "react-datepicker__year-text--in-selecting-range": i.isInSelectingRange(p),
                "react-datepicker__year-text--selecting-range-start": i.isSelectingRangeStart(p),
                "react-datepicker__year-text--selecting-range-end": i.isSelectingRangeEnd(p),
                "react-datepicker__year-text--today": i.isCurrentYear(p)
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "getYearTabIndex", function(p) {
            return i.props.disabledKeyboardNavigation ? "-1" : p === $0422a6ce4ea03acc$var$K2(i.props.preSelection) ? "0" : "-1";
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "getYearContainerClassNames", function() {
            var p = i.props, C = p.selectingDate, v = p.selectsStart, y = p.selectsEnd, L = p.selectsRange;
            return $0422a6ce4ea03acc$var$L5("react-datepicker__year", {
                "react-datepicker__year--selecting-range": C && (v || y || L)
            });
        }), i;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                for(var s = this, i = [], p = this.props, C = p.date, v = p.yearItemNumber, y = p.onYearMouseEnter, L = p.onYearMouseLeave, M = $0422a6ce4ea03acc$var$Ur(C, v), E = M.startPeriod, k = M.endPeriod, _ = function(O) {
                    i.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        ref: s.YEAR_REFS[O - E],
                        onClick: function(B) {
                            s.onYearClick(B, O);
                        },
                        onKeyDown: function(B) {
                            s.onYearKeyDown(B, O);
                        },
                        tabIndex: s.getYearTabIndex(O),
                        className: s.getYearClassNames(O),
                        onMouseEnter: function(B) {
                            return y(B, O);
                        },
                        onMouseLeave: function(B) {
                            return L(B, O);
                        },
                        key: O,
                        "aria-current": s.isCurrentYear(O) ? "date" : void 0
                    }, O));
                }, Z = E; Z <= k; Z++)_(Z);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: this.getYearContainerClassNames()
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__year-wrapper",
                    onMouseLeave: this.props.clearSelectingDate
                }, i));
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$NN = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o(s) {
        var i;
        return $0422a6ce4ea03acc$var$H4(this, o), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i = a.call(this, s)), "onTimeChange", function(p) {
            i.setState({
                time: p
            });
            var C = /* @__PURE__ */ new Date();
            C.setHours(p.split(":")[0]), C.setMinutes(p.split(":")[1]), i.props.onChange(C);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderTimeInput", function() {
            var p = i.state.time, C = i.props, v = C.date, y = C.timeString, L = C.customTimeInput;
            return L ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(L, {
                date: v,
                value: p,
                onChange: i.onTimeChange
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                type: "time",
                className: "react-datepicker-time__input",
                placeholder: "Time",
                name: "time-input",
                required: !0,
                value: p,
                onChange: function(M) {
                    i.onTimeChange(M.target.value || y);
                }
            });
        }), i.state = {
            time: i.props.timeString
        }, i;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__input-time-container"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker-time__caption"
                }, this.props.timeInputLabel), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker-time__input-container"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker-time__input"
                }, this.renderTimeInput())));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function(s, i) {
                return s.timeString !== i.time ? {
                    time: s.timeString
                } : null;
            }
        }
    ]), o;
}();
function $0422a6ce4ea03acc$var$PN(r) {
    var a = r.className, o = r.children, s = r.showPopperArrow, i = r.arrowProps, p = i === void 0 ? {} : i;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: a
    }, s && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $0422a6ce4ea03acc$var$xc({
        className: "react-datepicker__triangle"
    }, p)), o);
}
var $0422a6ce4ea03acc$var$BN = [
    "react-datepicker__year-select",
    "react-datepicker__month-select",
    "react-datepicker__month-year-select"
], $0422a6ce4ea03acc$var$FN = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o(s) {
        var i;
        return $0422a6ce4ea03acc$var$H4(this, o), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i = a.call(this, s)), "handleClickOutside", function(p) {
            i.props.onClickOutside(p);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "setClickOutsideRef", function() {
            return i.containerRef.current;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleDropdownFocus", function(p) {
            (function() {
                var C = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
                return $0422a6ce4ea03acc$var$BN.some(function(v) {
                    return C.indexOf(v) >= 0;
                });
            })(p.target) && i.props.onDropdownFocus();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "getDateInView", function() {
            var p = i.props, C = p.preSelection, v = p.selected, y = p.openToDate, L = $0422a6ce4ea03acc$var$tw(i.props), M = $0422a6ce4ea03acc$var$nw(i.props), E = $0422a6ce4ea03acc$var$A3(), k = y || v || C;
            return k || (L && $0422a6ce4ea03acc$var$l9(E, L) ? L : M && $0422a6ce4ea03acc$var$y0(E, M) ? M : E);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "increaseMonth", function() {
            i.setState(function(p) {
                var C = p.date;
                return {
                    date: $0422a6ce4ea03acc$var$v7(C, 1)
                };
            }, function() {
                return i.handleMonthChange(i.state.date);
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "decreaseMonth", function() {
            i.setState(function(p) {
                var C = p.date;
                return {
                    date: $0422a6ce4ea03acc$var$Gr(C, 1)
                };
            }, function() {
                return i.handleMonthChange(i.state.date);
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleDayClick", function(p, C, v) {
            i.props.onSelect(p, C, v), i.props.setPreSelection && i.props.setPreSelection(p);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleDayMouseEnter", function(p) {
            i.setState({
                selectingDate: p
            }), i.props.onDayMouseEnter && i.props.onDayMouseEnter(p);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleMonthMouseLeave", function() {
            i.setState({
                selectingDate: null
            }), i.props.onMonthMouseLeave && i.props.onMonthMouseLeave();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleYearMouseEnter", function(p, C) {
            i.setState({
                selectingDate: $0422a6ce4ea03acc$var$i9($0422a6ce4ea03acc$var$A3(), C)
            }), i.props.onYearMouseEnter && i.props.onYearMouseEnter(p, C);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleYearMouseLeave", function(p, C) {
            i.props.onYearMouseLeave && i.props.onYearMouseLeave(p, C);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleYearChange", function(p) {
            i.props.onYearChange && (i.props.onYearChange(p), i.setState({
                isRenderAriaLiveMessage: !0
            })), i.props.adjustDateOnChange && (i.props.onSelect && i.props.onSelect(p), i.props.setOpen && i.props.setOpen(!0)), i.props.setPreSelection && i.props.setPreSelection(p);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleMonthChange", function(p) {
            i.handleCustomMonthChange(p), i.props.adjustDateOnChange && (i.props.onSelect && i.props.onSelect(p), i.props.setOpen && i.props.setOpen(!0)), i.props.setPreSelection && i.props.setPreSelection(p);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleCustomMonthChange", function(p) {
            i.props.onMonthChange && (i.props.onMonthChange(p), i.setState({
                isRenderAriaLiveMessage: !0
            }));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleMonthYearChange", function(p) {
            i.handleYearChange(p), i.handleMonthChange(p);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "changeYear", function(p) {
            i.setState(function(C) {
                var v = C.date;
                return {
                    date: $0422a6ce4ea03acc$var$i9(v, p)
                };
            }, function() {
                return i.handleYearChange(i.state.date);
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "changeMonth", function(p) {
            i.setState(function(C) {
                var v = C.date;
                return {
                    date: $0422a6ce4ea03acc$var$g5(v, p)
                };
            }, function() {
                return i.handleMonthChange(i.state.date);
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "changeMonthYear", function(p) {
            i.setState(function(C) {
                var v = C.date;
                return {
                    date: $0422a6ce4ea03acc$var$i9($0422a6ce4ea03acc$var$g5(v, $0422a6ce4ea03acc$var$a5(p)), $0422a6ce4ea03acc$var$K2(p))
                };
            }, function() {
                return i.handleMonthYearChange(i.state.date);
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "header", function() {
            var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i.state.date, C = $0422a6ce4ea03acc$var$Oh(p, i.props.locale, i.props.calendarStartDay), v = [];
            return i.props.showWeekNumbers && v.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: "W",
                className: "react-datepicker__day-name"
            }, i.props.weekLabel || "#")), v.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(y) {
                var L = $0422a6ce4ea03acc$var$ia(C, y), M = i.formatWeekday(L, i.props.locale), E = i.props.weekDayClassName ? i.props.weekDayClassName(L) : void 0;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: y,
                    className: $0422a6ce4ea03acc$var$L5("react-datepicker__day-name", E)
                }, M);
            }));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "formatWeekday", function(p, C) {
            return i.props.formatWeekDay ? function(v, y, L) {
                return y($0422a6ce4ea03acc$var$Fe(v, "EEEE", L));
            }(p, i.props.formatWeekDay, C) : i.props.useWeekdaysShort ? function(v, y) {
                return $0422a6ce4ea03acc$var$Fe(v, "EEE", y);
            }(p, C) : function(v, y) {
                return $0422a6ce4ea03acc$var$Fe(v, "EEEEEE", y);
            }(p, C);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "decreaseYear", function() {
            i.setState(function(p) {
                var C = p.date;
                return {
                    date: $0422a6ce4ea03acc$var$Po(C, i.props.showYearPicker ? i.props.yearItemNumber : 1)
                };
            }, function() {
                return i.handleYearChange(i.state.date);
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "clearSelectingDate", function() {
            i.setState({
                selectingDate: null
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderPreviousButton", function() {
            if (!i.props.renderCustomHeader) {
                var p;
                switch(!0){
                    case i.props.showMonthYearPicker:
                        p = $0422a6ce4ea03acc$var$ML(i.state.date, i.props);
                        break;
                    case i.props.showYearPicker:
                        p = function(z) {
                            var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, P = I.minDate, $ = I.yearItemNumber, W = $ === void 0 ? 12 : $, l1 = $0422a6ce4ea03acc$var$Ur($0422a6ce4ea03acc$var$Mo($0422a6ce4ea03acc$var$Po(z, W)), W).endPeriod, u1 = P && $0422a6ce4ea03acc$var$K2(P);
                            return u1 && u1 > l1 || !1;
                        }(i.state.date, i.props);
                        break;
                    default:
                        p = $0422a6ce4ea03acc$var$xL(i.state.date, i.props);
                }
                if ((i.props.forceShowMonthNavigation || i.props.showDisabledMonthNavigation || !p) && !i.props.showTimeSelectOnly) {
                    var C = [
                        "react-datepicker__navigation",
                        "react-datepicker__navigation--previous"
                    ], v = i.decreaseMonth;
                    (i.props.showMonthYearPicker || i.props.showQuarterYearPicker || i.props.showYearPicker) && (v = i.decreaseYear), p && i.props.showDisabledMonthNavigation && (C.push("react-datepicker__navigation--previous--disabled"), v = null);
                    var y = i.props.showMonthYearPicker || i.props.showQuarterYearPicker || i.props.showYearPicker, L = i.props, M = L.previousMonthButtonLabel, E = L.previousYearButtonLabel, k = i.props, _ = k.previousMonthAriaLabel, Z = _ === void 0 ? typeof M == "string" ? M : "Previous Month" : _, O = k.previousYearAriaLabel, B = O === void 0 ? typeof E == "string" ? E : "Previous Year" : O;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                        type: "button",
                        className: C.join(" "),
                        onClick: v,
                        onKeyDown: i.props.handleOnKeyDown,
                        "aria-label": y ? B : Z
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        className: [
                            "react-datepicker__navigation-icon",
                            "react-datepicker__navigation-icon--previous"
                        ].join(" ")
                    }, y ? i.props.previousYearButtonLabel : i.props.previousMonthButtonLabel));
                }
            }
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "increaseYear", function() {
            i.setState(function(p) {
                var C = p.date;
                return {
                    date: $0422a6ce4ea03acc$var$qr(C, i.props.showYearPicker ? i.props.yearItemNumber : 1)
                };
            }, function() {
                return i.handleYearChange(i.state.date);
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderNextButton", function() {
            if (!i.props.renderCustomHeader) {
                var p;
                switch(!0){
                    case i.props.showMonthYearPicker:
                        p = $0422a6ce4ea03acc$var$EL(i.state.date, i.props);
                        break;
                    case i.props.showYearPicker:
                        p = function(z) {
                            var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, P = I.maxDate, $ = I.yearItemNumber, W = $ === void 0 ? 12 : $, l1 = $0422a6ce4ea03acc$var$Ur($0422a6ce4ea03acc$var$qr(z, W), W).startPeriod, u1 = P && $0422a6ce4ea03acc$var$K2(P);
                            return u1 && u1 < l1 || !1;
                        }(i.state.date, i.props);
                        break;
                    default:
                        p = $0422a6ce4ea03acc$var$VL(i.state.date, i.props);
                }
                if ((i.props.forceShowMonthNavigation || i.props.showDisabledMonthNavigation || !p) && !i.props.showTimeSelectOnly) {
                    var C = [
                        "react-datepicker__navigation",
                        "react-datepicker__navigation--next"
                    ];
                    i.props.showTimeSelect && C.push("react-datepicker__navigation--next--with-time"), i.props.todayButton && C.push("react-datepicker__navigation--next--with-today-button");
                    var v = i.increaseMonth;
                    (i.props.showMonthYearPicker || i.props.showQuarterYearPicker || i.props.showYearPicker) && (v = i.increaseYear), p && i.props.showDisabledMonthNavigation && (C.push("react-datepicker__navigation--next--disabled"), v = null);
                    var y = i.props.showMonthYearPicker || i.props.showQuarterYearPicker || i.props.showYearPicker, L = i.props, M = L.nextMonthButtonLabel, E = L.nextYearButtonLabel, k = i.props, _ = k.nextMonthAriaLabel, Z = _ === void 0 ? typeof M == "string" ? M : "Next Month" : _, O = k.nextYearAriaLabel, B = O === void 0 ? typeof E == "string" ? E : "Next Year" : O;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                        type: "button",
                        className: C.join(" "),
                        onClick: v,
                        onKeyDown: i.props.handleOnKeyDown,
                        "aria-label": y ? B : Z
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        className: [
                            "react-datepicker__navigation-icon",
                            "react-datepicker__navigation-icon--next"
                        ].join(" ")
                    }, y ? i.props.nextYearButtonLabel : i.props.nextMonthButtonLabel));
                }
            }
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderCurrentMonth", function() {
            var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i.state.date, C = [
                "react-datepicker__current-month"
            ];
            return i.props.showYearDropdown && C.push("react-datepicker__current-month--hasYearDropdown"), i.props.showMonthDropdown && C.push("react-datepicker__current-month--hasMonthDropdown"), i.props.showMonthYearDropdown && C.push("react-datepicker__current-month--hasMonthYearDropdown"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: C.join(" ")
            }, $0422a6ce4ea03acc$var$Fe(p, i.props.dateFormat, i.props.locale));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderYearDropdown", function() {
            var p = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
            if (i.props.showYearDropdown && !p) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$VN, {
                adjustDateOnChange: i.props.adjustDateOnChange,
                date: i.state.date,
                onSelect: i.props.onSelect,
                setOpen: i.props.setOpen,
                dropdownMode: i.props.dropdownMode,
                onChange: i.changeYear,
                minDate: i.props.minDate,
                maxDate: i.props.maxDate,
                year: $0422a6ce4ea03acc$var$K2(i.state.date),
                scrollableYearDropdown: i.props.scrollableYearDropdown,
                yearDropdownItemNumber: i.props.yearDropdownItemNumber
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderMonthDropdown", function() {
            var p = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
            if (i.props.showMonthDropdown && !p) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$EN, {
                dropdownMode: i.props.dropdownMode,
                locale: i.props.locale,
                onChange: i.changeMonth,
                month: $0422a6ce4ea03acc$var$a5(i.state.date),
                useShortMonthInDropdown: i.props.useShortMonthInDropdown
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderMonthYearDropdown", function() {
            var p = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
            if (i.props.showMonthYearDropdown && !p) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$TN, {
                dropdownMode: i.props.dropdownMode,
                locale: i.props.locale,
                dateFormat: i.props.dateFormat,
                onChange: i.changeMonthYear,
                minDate: i.props.minDate,
                maxDate: i.props.maxDate,
                date: i.state.date,
                scrollableMonthYearDropdown: i.props.scrollableMonthYearDropdown
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleTodayButtonClick", function(p) {
            i.props.onSelect($0422a6ce4ea03acc$var$LL(), p), i.props.setPreSelection && i.props.setPreSelection($0422a6ce4ea03acc$var$LL());
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderTodayButton", function() {
            if (i.props.todayButton && !i.props.showTimeSelectOnly) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__today-button",
                onClick: function(p) {
                    return i.handleTodayButtonClick(p);
                }
            }, i.props.todayButton);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderDefaultHeader", function(p) {
            var C = p.monthDate, v = p.i;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__header ".concat(i.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
            }, i.renderCurrentMonth(C), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(i.props.dropdownMode),
                onFocus: i.handleDropdownFocus
            }, i.renderMonthDropdown(v !== 0), i.renderMonthYearDropdown(v !== 0), i.renderYearDropdown(v !== 0)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__day-names"
            }, i.header(C)));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderCustomHeader", function() {
            var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, C = p.monthDate, v = p.i;
            if (i.props.showTimeSelect && !i.state.monthContainer || i.props.showTimeSelectOnly) return null;
            var y = $0422a6ce4ea03acc$var$xL(i.state.date, i.props), L = $0422a6ce4ea03acc$var$VL(i.state.date, i.props), M = $0422a6ce4ea03acc$var$ML(i.state.date, i.props), E = $0422a6ce4ea03acc$var$EL(i.state.date, i.props), k = !i.props.showMonthYearPicker && !i.props.showQuarterYearPicker && !i.props.showYearPicker;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--custom",
                onFocus: i.props.onDropdownFocus
            }, i.props.renderCustomHeader($0422a6ce4ea03acc$var$pL($0422a6ce4ea03acc$var$pL({}, i.state), {}, {
                customHeaderCount: v,
                monthDate: C,
                changeMonth: i.changeMonth,
                changeYear: i.changeYear,
                decreaseMonth: i.decreaseMonth,
                increaseMonth: i.increaseMonth,
                decreaseYear: i.decreaseYear,
                increaseYear: i.increaseYear,
                prevMonthButtonDisabled: y,
                nextMonthButtonDisabled: L,
                prevYearButtonDisabled: M,
                nextYearButtonDisabled: E
            })), k && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__day-names"
            }, i.header(C)));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderYearHeader", function() {
            var p = i.state.date, C = i.props, v = C.showYearPicker, y = $0422a6ce4ea03acc$var$Ur(p, C.yearItemNumber), L = y.startPeriod, M = y.endPeriod;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__header react-datepicker-year-header"
            }, v ? "".concat(L, " - ").concat(M) : $0422a6ce4ea03acc$var$K2(p));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderHeader", function(p) {
            switch(!0){
                case i.props.renderCustomHeader !== void 0:
                    return i.renderCustomHeader(p);
                case i.props.showMonthYearPicker || i.props.showQuarterYearPicker || i.props.showYearPicker:
                    return i.renderYearHeader(p);
                default:
                    return i.renderDefaultHeader(p);
            }
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderMonths", function() {
            if (!i.props.showTimeSelectOnly && !i.props.showYearPicker) {
                for(var p = [], C = i.props.showPreviousMonths ? i.props.monthsShown - 1 : 0, v = $0422a6ce4ea03acc$var$Gr(i.state.date, C), y = 0; y < i.props.monthsShown; ++y){
                    var L = y - i.props.monthSelectedIn, M = $0422a6ce4ea03acc$var$v7(v, L), E = "month-".concat(y), k = y < i.props.monthsShown - 1, _ = y > 0;
                    p.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        key: E,
                        ref: function(Z) {
                            i.monthContainer = Z;
                        },
                        className: "react-datepicker__month-container"
                    }, i.renderHeader({
                        monthDate: M,
                        i: y
                    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$ZN, {
                        chooseDayAriaLabelPrefix: i.props.chooseDayAriaLabelPrefix,
                        disabledDayAriaLabelPrefix: i.props.disabledDayAriaLabelPrefix,
                        weekAriaLabelPrefix: i.props.weekAriaLabelPrefix,
                        ariaLabelPrefix: i.props.monthAriaLabelPrefix,
                        onChange: i.changeMonthYear,
                        day: M,
                        dayClassName: i.props.dayClassName,
                        calendarStartDay: i.props.calendarStartDay,
                        monthClassName: i.props.monthClassName,
                        onDayClick: i.handleDayClick,
                        handleOnKeyDown: i.props.handleOnDayKeyDown,
                        onDayMouseEnter: i.handleDayMouseEnter,
                        onMouseLeave: i.handleMonthMouseLeave,
                        onWeekSelect: i.props.onWeekSelect,
                        orderInDisplay: y,
                        formatWeekNumber: i.props.formatWeekNumber,
                        locale: i.props.locale,
                        minDate: i.props.minDate,
                        maxDate: i.props.maxDate,
                        excludeDates: i.props.excludeDates,
                        excludeDateIntervals: i.props.excludeDateIntervals,
                        highlightDates: i.props.highlightDates,
                        selectingDate: i.state.selectingDate,
                        includeDates: i.props.includeDates,
                        includeDateIntervals: i.props.includeDateIntervals,
                        inline: i.props.inline,
                        shouldFocusDayInline: i.props.shouldFocusDayInline,
                        fixedHeight: i.props.fixedHeight,
                        filterDate: i.props.filterDate,
                        preSelection: i.props.preSelection,
                        setPreSelection: i.props.setPreSelection,
                        selected: i.props.selected,
                        selectsStart: i.props.selectsStart,
                        selectsEnd: i.props.selectsEnd,
                        selectsRange: i.props.selectsRange,
                        selectsDisabledDaysInRange: i.props.selectsDisabledDaysInRange,
                        showWeekNumbers: i.props.showWeekNumbers,
                        startDate: i.props.startDate,
                        endDate: i.props.endDate,
                        peekNextMonth: i.props.peekNextMonth,
                        setOpen: i.props.setOpen,
                        shouldCloseOnSelect: i.props.shouldCloseOnSelect,
                        renderDayContents: i.props.renderDayContents,
                        disabledKeyboardNavigation: i.props.disabledKeyboardNavigation,
                        showMonthYearPicker: i.props.showMonthYearPicker,
                        showFullMonthYearPicker: i.props.showFullMonthYearPicker,
                        showTwoColumnMonthYearPicker: i.props.showTwoColumnMonthYearPicker,
                        showFourColumnMonthYearPicker: i.props.showFourColumnMonthYearPicker,
                        showYearPicker: i.props.showYearPicker,
                        showQuarterYearPicker: i.props.showQuarterYearPicker,
                        isInputFocused: i.props.isInputFocused,
                        containerRef: i.containerRef,
                        monthShowsDuplicateDaysEnd: k,
                        monthShowsDuplicateDaysStart: _
                    })));
                }
                return p;
            }
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderYears", function() {
            if (!i.props.showTimeSelectOnly) return i.props.showYearPicker ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__year--container"
            }, i.renderHeader(), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$ON, $0422a6ce4ea03acc$var$xc({
                onDayClick: i.handleDayClick,
                selectingDate: i.state.selectingDate,
                clearSelectingDate: i.clearSelectingDate,
                date: i.state.date
            }, i.props, {
                onYearMouseEnter: i.handleYearMouseEnter,
                onYearMouseLeave: i.handleYearMouseLeave
            }))) : void 0;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderTimeSection", function() {
            if (i.props.showTimeSelect && (i.state.monthContainer || i.props.showTimeSelectOnly)) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$ow, {
                selected: i.props.selected,
                openToDate: i.props.openToDate,
                onChange: i.props.onTimeChange,
                timeClassName: i.props.timeClassName,
                format: i.props.timeFormat,
                includeTimes: i.props.includeTimes,
                intervals: i.props.timeIntervals,
                minTime: i.props.minTime,
                maxTime: i.props.maxTime,
                excludeTimes: i.props.excludeTimes,
                filterTime: i.props.filterTime,
                timeCaption: i.props.timeCaption,
                todayButton: i.props.todayButton,
                showMonthDropdown: i.props.showMonthDropdown,
                showMonthYearDropdown: i.props.showMonthYearDropdown,
                showYearDropdown: i.props.showYearDropdown,
                withPortal: i.props.withPortal,
                monthRef: i.state.monthContainer,
                injectTimes: i.props.injectTimes,
                locale: i.props.locale,
                handleOnKeyDown: i.props.handleOnKeyDown,
                showTimeSelectOnly: i.props.showTimeSelectOnly
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderInputTimeSection", function() {
            var p = new Date(i.props.selected), C = $0422a6ce4ea03acc$var$h0(p) && i.props.selected ? "".concat($0422a6ce4ea03acc$var$kL(p.getHours()), ":").concat($0422a6ce4ea03acc$var$kL(p.getMinutes())) : "";
            if (i.props.showTimeInput) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$NN, {
                date: p,
                timeString: C,
                timeInputLabel: i.props.timeInputLabel,
                onChange: i.props.onTimeChange,
                customTimeInput: i.props.customTimeInput
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderAriaLiveRegion", function() {
            var p, C = $0422a6ce4ea03acc$var$Ur(i.state.date, i.props.yearItemNumber), v = C.startPeriod, y = C.endPeriod;
            return p = i.props.showYearPicker ? "".concat(v, " - ").concat(y) : i.props.showMonthYearPicker || i.props.showQuarterYearPicker ? $0422a6ce4ea03acc$var$K2(i.state.date) : "".concat($0422a6ce4ea03acc$var$Nh($0422a6ce4ea03acc$var$a5(i.state.date), i.props.locale), " ").concat($0422a6ce4ea03acc$var$K2(i.state.date)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, i.state.isRenderAriaLiveMessage && p);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderChildren", function() {
            if (i.props.children) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__children-container"
            }, i.props.children);
        }), i.containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(), i.state = {
            date: i.getDateInView(),
            selectingDate: null,
            monthContainer: null,
            isRenderAriaLiveMessage: !1
        }, i;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "componentDidMount",
            value: function() {
                var s = this;
                this.props.showTimeSelect && (this.assignMonthContainer = void s.setState({
                    monthContainer: s.monthContainer
                }));
            }
        },
        {
            key: "componentDidUpdate",
            value: function(s) {
                var i = this;
                if (!this.props.preSelection || $0422a6ce4ea03acc$var$y5(this.props.preSelection, s.preSelection) && this.props.monthSelectedIn === s.monthSelectedIn) this.props.openToDate && !$0422a6ce4ea03acc$var$y5(this.props.openToDate, s.openToDate) && this.setState({
                    date: this.props.openToDate
                });
                else {
                    var p = !$0422a6ce4ea03acc$var$h7(this.state.date, this.props.preSelection);
                    this.setState({
                        date: this.props.preSelection
                    }, function() {
                        return p && i.handleCustomMonthChange(i.state.date);
                    });
                }
            }
        },
        {
            key: "render",
            value: function() {
                var s = this.props.container || $0422a6ce4ea03acc$var$PN;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    ref: this.containerRef
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(s, {
                    className: $0422a6ce4ea03acc$var$L5("react-datepicker", this.props.className, {
                        "react-datepicker--time-only": this.props.showTimeSelectOnly
                    }),
                    showPopperArrow: this.props.showPopperArrow,
                    arrowProps: this.props.arrowProps
                }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
            }
        }
    ], [
        {
            key: "defaultProps",
            get: function() {
                return {
                    onDropdownFocus: function() {},
                    monthsShown: 1,
                    monthSelectedIn: 0,
                    forceShowMonthNavigation: !1,
                    timeCaption: "Time",
                    previousYearButtonLabel: "Previous Year",
                    nextYearButtonLabel: "Next Year",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthButtonLabel: "Next Month",
                    customTimeInput: null,
                    yearItemNumber: 12
                };
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$lw = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o(s) {
        var i;
        return $0422a6ce4ea03acc$var$H4(this, o), (i = a.call(this, s)).el = document.createElement("div"), i;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "componentDidMount",
            value: function() {
                this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                this.portalRoot.removeChild(this.el);
            }
        },
        {
            key: "render",
            value: function() {
                return $0422a6ce4ea03acc$var$_Z.createPortal(this.props.children, this.el);
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$AN = function(r) {
    return !r.disabled && r.tabIndex !== -1;
}, $0422a6ce4ea03acc$var$sw = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o(s) {
        var i;
        return $0422a6ce4ea03acc$var$H4(this, o), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i = a.call(this, s)), "getTabChildren", function() {
            return Array.prototype.slice.call(i.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter($0422a6ce4ea03acc$var$AN);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleFocusStart", function(p) {
            var C = i.getTabChildren();
            C && C.length > 1 && C[C.length - 1].focus();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleFocusEnd", function(p) {
            var C = i.getTabChildren();
            C && C.length > 1 && C[0].focus();
        }), i.tabLoopRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(), i;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                return this.props.enableTabLoop ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__tab-loop",
                    ref: this.tabLoopRef
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__tab-loop__start",
                    tabIndex: "0",
                    onFocus: this.handleFocusStart
                }), this.props.children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__tab-loop__end",
                    tabIndex: "0",
                    onFocus: this.handleFocusEnd
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "defaultProps",
            get: function() {
                return {
                    enableTabLoop: !0
                };
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$jN = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o() {
        return $0422a6ce4ea03acc$var$H4(this, o), a.apply(this, arguments);
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "render",
            value: function() {
                var s, i = this.props, p = i.className, C = i.wrapperClassName, v = i.hidePopper, y = i.popperComponent, L = i.popperModifiers, M = i.popperPlacement, E = i.popperProps, k = i.targetComponent, _ = i.enableTabLoop, Z = i.popperOnKeyDown, O = i.portalId, B = i.portalHost;
                if (!v) {
                    var z = $0422a6ce4ea03acc$var$L5("react-datepicker-popper", p);
                    s = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$oN, $0422a6ce4ea03acc$var$xc({
                        modifiers: L,
                        placement: M
                    }, E), function(P) {
                        var $ = P.ref, W = P.style, l1 = P.placement, u1 = P.arrowProps;
                        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$sw, {
                            enableTabLoop: _
                        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            ref: $,
                            style: W,
                            className: z,
                            "data-placement": l1,
                            onKeyDown: Z
                        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(y, {
                            arrowProps: u1
                        })));
                    });
                }
                this.props.popperContainer && (s = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(this.props.popperContainer, {}, s)), O && !v && (s = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$lw, {
                    portalId: O,
                    portalHost: B
                }, s));
                var I = $0422a6ce4ea03acc$var$L5("react-datepicker-wrapper", C);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$zZ, {
                    className: "react-datepicker-manager"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$dN, null, function(P) {
                    var $ = P.ref;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        ref: $,
                        className: I
                    }, k);
                }), s);
            }
        }
    ], [
        {
            key: "defaultProps",
            get: function() {
                return {
                    hidePopper: !0,
                    popperModifiers: [],
                    popperProps: {},
                    popperPlacement: "bottom-start"
                };
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$zN = $0422a6ce4ea03acc$var$wc($0422a6ce4ea03acc$var$FN), $0422a6ce4ea03acc$var$_L = function(r) {
    $0422a6ce4ea03acc$var$V4(o, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var a = $0422a6ce4ea03acc$var$M4(o);
    function o(s) {
        var i;
        return $0422a6ce4ea03acc$var$H4(this, o), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i = a.call(this, s)), "getPreSelection", function() {
            return i.props.openToDate ? i.props.openToDate : i.props.selectsEnd && i.props.startDate ? i.props.startDate : i.props.selectsStart && i.props.endDate ? i.props.endDate : $0422a6ce4ea03acc$var$A3();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "calcInitialState", function() {
            var p, C = i.getPreSelection(), v = $0422a6ce4ea03acc$var$tw(i.props), y = $0422a6ce4ea03acc$var$nw(i.props), L = v && $0422a6ce4ea03acc$var$l9(C, $0422a6ce4ea03acc$var$d8(v)) ? v : y && $0422a6ce4ea03acc$var$y0(C, $0422a6ce4ea03acc$var$Qp(y)) ? y : C;
            return {
                open: i.props.startOpen || !1,
                preventFocus: !1,
                preSelection: (p = i.props.selectsRange ? i.props.startDate : i.props.selected) !== null && p !== void 0 ? p : L,
                highlightDates: $0422a6ce4ea03acc$var$SL(i.props.highlightDates),
                focused: !1,
                shouldFocusDayInline: !1,
                isRenderAriaLiveMessage: !1
            };
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "clearPreventFocusTimeout", function() {
            i.preventFocusTimeout && clearTimeout(i.preventFocusTimeout);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "setFocus", function() {
            i.input && i.input.focus && i.input.focus({
                preventScroll: !0
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "setBlur", function() {
            i.input && i.input.blur && i.input.blur(), i.cancelFocusInput();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "setOpen", function(p) {
            var C = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
            i.setState({
                open: p,
                preSelection: p && i.state.open ? i.state.preSelection : i.calcInitialState().preSelection,
                lastPreSelectChange: $0422a6ce4ea03acc$var$wp
            }, function() {
                p || i.setState(function(v) {
                    return {
                        focused: !!C && v.focused
                    };
                }, function() {
                    !C && i.setBlur(), i.setState({
                        inputValue: null
                    });
                });
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "inputOk", function() {
            return $0422a6ce4ea03acc$var$yh(i.state.preSelection);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "isCalendarOpen", function() {
            return i.props.open === void 0 ? i.state.open && !i.props.disabled && !i.props.readOnly : i.props.open;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleFocus", function(p) {
            i.state.preventFocus || (i.props.onFocus(p), i.props.preventOpenOnFocus || i.props.readOnly || i.setOpen(!0)), i.setState({
                focused: !0
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "cancelFocusInput", function() {
            clearTimeout(i.inputFocusTimeout), i.inputFocusTimeout = null;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "deferFocusInput", function() {
            i.cancelFocusInput(), i.inputFocusTimeout = setTimeout(function() {
                return i.setFocus();
            }, 1);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleDropdownFocus", function() {
            i.cancelFocusInput();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleBlur", function(p) {
            (!i.state.open || i.props.withPortal || i.props.showTimeInput) && i.props.onBlur(p), i.setState({
                focused: !1
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleCalendarClickOutside", function(p) {
            i.props.inline || i.setOpen(!1), i.props.onClickOutside(p), i.props.withPortal && p.preventDefault();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleChange", function() {
            for(var p = arguments.length, C = new Array(p), v = 0; v < p; v++)C[v] = arguments[v];
            var y = C[0];
            if (!i.props.onChangeRaw || (i.props.onChangeRaw.apply($0422a6ce4ea03acc$var$U(i), C), typeof y.isDefaultPrevented == "function" && !y.isDefaultPrevented())) {
                i.setState({
                    inputValue: y.target.value,
                    lastPreSelectChange: $0422a6ce4ea03acc$var$UN
                });
                var L = $0422a6ce4ea03acc$var$mN(y.target.value, i.props.dateFormat, i.props.locale, i.props.strictParsing, i.props.minDate);
                i.props.showTimeSelectOnly && i.props.selected && !$0422a6ce4ea03acc$var$y5(L, i.props.selected) && (L = $0422a6ce4ea03acc$var$CN(i.props.selected, L == null ? {
                    hours: $0422a6ce4ea03acc$var$i6(i.props.selected),
                    minutes: $0422a6ce4ea03acc$var$a6(i.props.selected),
                    seconds: $0422a6ce4ea03acc$var$dp(i.props.selected)
                } : {
                    hours: $0422a6ce4ea03acc$var$i6(L),
                    minutes: $0422a6ce4ea03acc$var$a6(L),
                    seconds: $0422a6ce4ea03acc$var$dp(L)
                })), !L && y.target.value || i.setSelected(L, y, !0);
            }
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleSelect", function(p, C, v) {
            if (i.setState({
                preventFocus: !0
            }, function() {
                return i.preventFocusTimeout = setTimeout(function() {
                    return i.setState({
                        preventFocus: !1
                    });
                }, 50), i.preventFocusTimeout;
            }), i.props.onChangeRaw && i.props.onChangeRaw(C), i.setSelected(p, C, !1, v), i.setState({
                isRenderAriaLiveMessage: !0
            }), !i.props.shouldCloseOnSelect || i.props.showTimeSelect) i.setPreSelection(p);
            else if (!i.props.inline) {
                i.props.selectsRange || i.setOpen(!1);
                var y = i.props, L = y.startDate, M = y.endDate;
                !L || M || $0422a6ce4ea03acc$var$l9(p, L) || i.setOpen(!1);
            }
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "setSelected", function(p, C, v, y) {
            var L = p;
            if (i.props.showYearPicker) {
                if (L !== null && $0422a6ce4ea03acc$var$ew($0422a6ce4ea03acc$var$K2(L), i.props)) return;
            } else if (i.props.showMonthYearPicker) {
                if (L !== null && $0422a6ce4ea03acc$var$Jb(L, i.props)) return;
            } else if (L !== null && $0422a6ce4ea03acc$var$Vc(L, i.props)) return;
            var M = i.props, E = M.onChange, k = M.selectsRange, _ = M.startDate, Z = M.endDate;
            if (!$0422a6ce4ea03acc$var$v0(i.props.selected, L) || i.props.allowSameDay || k) {
                if (L !== null && (!i.props.selected || v && (i.props.showTimeSelect || i.props.showTimeSelectOnly || i.props.showTimeInput) || (L = $0422a6ce4ea03acc$var$gL(L, {
                    hour: $0422a6ce4ea03acc$var$i6(i.props.selected),
                    minute: $0422a6ce4ea03acc$var$a6(i.props.selected),
                    second: $0422a6ce4ea03acc$var$dp(i.props.selected)
                })), i.props.inline || i.setState({
                    preSelection: L
                }), i.props.focusSelectedMonth || i.setState({
                    monthSelectedIn: y
                })), k) {
                    var O = _ && !Z, B = _ && Z;
                    !_ && !Z ? E([
                        L,
                        null
                    ], C) : O && ($0422a6ce4ea03acc$var$l9(L, _) ? E([
                        L,
                        null
                    ], C) : E([
                        _,
                        L
                    ], C)), B && E([
                        L,
                        null
                    ], C);
                } else E(L, C);
            }
            v || (i.props.onSelect(L, C), i.setState({
                inputValue: null
            }));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "setPreSelection", function(p) {
            var C = i.props.minDate !== void 0, v = i.props.maxDate !== void 0, y = !0;
            if (p) {
                var L = $0422a6ce4ea03acc$var$d8(p);
                if (C && v) y = $0422a6ce4ea03acc$var$Gu(p, i.props.minDate, i.props.maxDate);
                else if (C) {
                    var M = $0422a6ce4ea03acc$var$d8(i.props.minDate);
                    y = $0422a6ce4ea03acc$var$y0(p, M) || $0422a6ce4ea03acc$var$v0(L, M);
                } else if (v) {
                    var E = $0422a6ce4ea03acc$var$Qp(i.props.maxDate);
                    y = $0422a6ce4ea03acc$var$l9(p, E) || $0422a6ce4ea03acc$var$v0(L, E);
                }
            }
            y && i.setState({
                preSelection: p
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "handleTimeChange", function(p) {
            var C = $0422a6ce4ea03acc$var$gL(i.props.selected ? i.props.selected : i.getPreSelection(), {
                hour: $0422a6ce4ea03acc$var$i6(p),
                minute: $0422a6ce4ea03acc$var$a6(p)
            });
            i.setState({
                preSelection: C
            }), i.props.onChange(C), i.props.shouldCloseOnSelect && i.setOpen(!1), i.props.showTimeInput && i.setOpen(!0), (i.props.showTimeSelectOnly || i.props.showTimeSelect) && i.setState({
                isRenderAriaLiveMessage: !0
            }), i.setState({
                inputValue: null
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "onInputClick", function() {
            i.props.disabled || i.props.readOnly || i.setOpen(!0), i.props.onInputClick();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "onInputKeyDown", function(p) {
            i.props.onKeyDown(p);
            var C = p.key;
            if (i.state.open || i.props.inline || i.props.preventOpenOnFocus) {
                if (i.state.open) {
                    if (C === "ArrowDown" || C === "ArrowUp") {
                        p.preventDefault();
                        var v = i.calendar.componentNode && i.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
                        return void (v && v.focus({
                            preventScroll: !0
                        }));
                    }
                    var y = $0422a6ce4ea03acc$var$A3(i.state.preSelection);
                    C === "Enter" ? (p.preventDefault(), i.inputOk() && i.state.lastPreSelectChange === $0422a6ce4ea03acc$var$wp ? (i.handleSelect(y, p), !i.props.shouldCloseOnSelect && i.setPreSelection(y)) : i.setOpen(!1)) : C === "Escape" ? (p.preventDefault(), i.setOpen(!1)) : C === "Tab" && p.shiftKey && i.setOpen(!1), i.inputOk() || i.props.onInputError({
                        code: 1,
                        msg: "Date input not valid."
                    });
                }
            } else C !== "ArrowDown" && C !== "ArrowUp" && C !== "Enter" || i.onInputClick();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "onPortalKeyDown", function(p) {
            p.key === "Escape" && (p.preventDefault(), i.setState({
                preventFocus: !0
            }, function() {
                i.setOpen(!1), setTimeout(function() {
                    i.setFocus(), i.setState({
                        preventFocus: !1
                    });
                });
            }));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "onDayKeyDown", function(p) {
            i.props.onKeyDown(p);
            var C = p.key, v = $0422a6ce4ea03acc$var$A3(i.state.preSelection);
            if (C === "Enter") p.preventDefault(), i.handleSelect(v, p), !i.props.shouldCloseOnSelect && i.setPreSelection(v);
            else if (C === "Escape") p.preventDefault(), i.setOpen(!1), i.inputOk() || i.props.onInputError({
                code: 1,
                msg: "Date input not valid."
            });
            else if (!i.props.disabledKeyboardNavigation) {
                var y;
                switch(C){
                    case "ArrowLeft":
                        y = $0422a6ce4ea03acc$var$QD(v, 1);
                        break;
                    case "ArrowRight":
                        y = $0422a6ce4ea03acc$var$ia(v, 1);
                        break;
                    case "ArrowUp":
                        y = $0422a6ce4ea03acc$var$qD(v, 1);
                        break;
                    case "ArrowDown":
                        y = $0422a6ce4ea03acc$var$wh(v, 1);
                        break;
                    case "PageUp":
                        y = $0422a6ce4ea03acc$var$Gr(v, 1);
                        break;
                    case "PageDown":
                        y = $0422a6ce4ea03acc$var$v7(v, 1);
                        break;
                    case "Home":
                        y = $0422a6ce4ea03acc$var$Po(v, 1);
                        break;
                    case "End":
                        y = $0422a6ce4ea03acc$var$qr(v, 1);
                }
                if (!y) return void (i.props.onInputError && i.props.onInputError({
                    code: 1,
                    msg: "Date input not valid."
                }));
                if (p.preventDefault(), i.setState({
                    lastPreSelectChange: $0422a6ce4ea03acc$var$wp
                }), i.props.adjustDateOnChange && i.setSelected(y), i.setPreSelection(y), i.props.inline) {
                    var L = $0422a6ce4ea03acc$var$a5(v), M = $0422a6ce4ea03acc$var$a5(y), E = $0422a6ce4ea03acc$var$K2(v), k = $0422a6ce4ea03acc$var$K2(y);
                    L !== M || E !== k ? i.setState({
                        shouldFocusDayInline: !0
                    }) : i.setState({
                        shouldFocusDayInline: !1
                    });
                }
            }
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "onPopperKeyDown", function(p) {
            p.key === "Escape" && (p.preventDefault(), i.setState({
                preventFocus: !0
            }, function() {
                i.setOpen(!1), setTimeout(function() {
                    i.setFocus(), i.setState({
                        preventFocus: !1
                    });
                });
            }));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "onClearClick", function(p) {
            p && p.preventDefault && p.preventDefault(), i.props.selectsRange ? i.props.onChange([
                null,
                null
            ], p) : i.props.onChange(null, p), i.setState({
                inputValue: null
            });
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "clear", function() {
            i.onClearClick();
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "onScroll", function(p) {
            typeof i.props.closeOnScroll == "boolean" && i.props.closeOnScroll ? p.target !== document && p.target !== document.documentElement && p.target !== document.body || i.setOpen(!1) : typeof i.props.closeOnScroll == "function" && i.props.closeOnScroll(p) && i.setOpen(!1);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderCalendar", function() {
            return i.props.inline || i.isCalendarOpen() ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$zN, {
                ref: function(p) {
                    i.calendar = p;
                },
                locale: i.props.locale,
                calendarStartDay: i.props.calendarStartDay,
                chooseDayAriaLabelPrefix: i.props.chooseDayAriaLabelPrefix,
                disabledDayAriaLabelPrefix: i.props.disabledDayAriaLabelPrefix,
                weekAriaLabelPrefix: i.props.weekAriaLabelPrefix,
                monthAriaLabelPrefix: i.props.monthAriaLabelPrefix,
                adjustDateOnChange: i.props.adjustDateOnChange,
                setOpen: i.setOpen,
                shouldCloseOnSelect: i.props.shouldCloseOnSelect,
                dateFormat: i.props.dateFormatCalendar,
                useWeekdaysShort: i.props.useWeekdaysShort,
                formatWeekDay: i.props.formatWeekDay,
                dropdownMode: i.props.dropdownMode,
                selected: i.props.selected,
                preSelection: i.state.preSelection,
                onSelect: i.handleSelect,
                onWeekSelect: i.props.onWeekSelect,
                openToDate: i.props.openToDate,
                minDate: i.props.minDate,
                maxDate: i.props.maxDate,
                selectsStart: i.props.selectsStart,
                selectsEnd: i.props.selectsEnd,
                selectsRange: i.props.selectsRange,
                startDate: i.props.startDate,
                endDate: i.props.endDate,
                excludeDates: i.props.excludeDates,
                excludeDateIntervals: i.props.excludeDateIntervals,
                filterDate: i.props.filterDate,
                onClickOutside: i.handleCalendarClickOutside,
                formatWeekNumber: i.props.formatWeekNumber,
                highlightDates: i.state.highlightDates,
                includeDates: i.props.includeDates,
                includeDateIntervals: i.props.includeDateIntervals,
                includeTimes: i.props.includeTimes,
                injectTimes: i.props.injectTimes,
                inline: i.props.inline,
                shouldFocusDayInline: i.state.shouldFocusDayInline,
                peekNextMonth: i.props.peekNextMonth,
                showMonthDropdown: i.props.showMonthDropdown,
                showPreviousMonths: i.props.showPreviousMonths,
                useShortMonthInDropdown: i.props.useShortMonthInDropdown,
                showMonthYearDropdown: i.props.showMonthYearDropdown,
                showWeekNumbers: i.props.showWeekNumbers,
                showYearDropdown: i.props.showYearDropdown,
                withPortal: i.props.withPortal,
                forceShowMonthNavigation: i.props.forceShowMonthNavigation,
                showDisabledMonthNavigation: i.props.showDisabledMonthNavigation,
                scrollableYearDropdown: i.props.scrollableYearDropdown,
                scrollableMonthYearDropdown: i.props.scrollableMonthYearDropdown,
                todayButton: i.props.todayButton,
                weekLabel: i.props.weekLabel,
                outsideClickIgnoreClass: "react-datepicker-ignore-onclickoutside",
                fixedHeight: i.props.fixedHeight,
                monthsShown: i.props.monthsShown,
                monthSelectedIn: i.state.monthSelectedIn,
                onDropdownFocus: i.handleDropdownFocus,
                onMonthChange: i.props.onMonthChange,
                onYearChange: i.props.onYearChange,
                dayClassName: i.props.dayClassName,
                weekDayClassName: i.props.weekDayClassName,
                monthClassName: i.props.monthClassName,
                timeClassName: i.props.timeClassName,
                showTimeSelect: i.props.showTimeSelect,
                showTimeSelectOnly: i.props.showTimeSelectOnly,
                onTimeChange: i.handleTimeChange,
                timeFormat: i.props.timeFormat,
                timeIntervals: i.props.timeIntervals,
                minTime: i.props.minTime,
                maxTime: i.props.maxTime,
                excludeTimes: i.props.excludeTimes,
                filterTime: i.props.filterTime,
                timeCaption: i.props.timeCaption,
                className: i.props.calendarClassName,
                container: i.props.calendarContainer,
                yearItemNumber: i.props.yearItemNumber,
                yearDropdownItemNumber: i.props.yearDropdownItemNumber,
                previousMonthAriaLabel: i.props.previousMonthAriaLabel,
                previousMonthButtonLabel: i.props.previousMonthButtonLabel,
                nextMonthAriaLabel: i.props.nextMonthAriaLabel,
                nextMonthButtonLabel: i.props.nextMonthButtonLabel,
                previousYearAriaLabel: i.props.previousYearAriaLabel,
                previousYearButtonLabel: i.props.previousYearButtonLabel,
                nextYearAriaLabel: i.props.nextYearAriaLabel,
                nextYearButtonLabel: i.props.nextYearButtonLabel,
                timeInputLabel: i.props.timeInputLabel,
                disabledKeyboardNavigation: i.props.disabledKeyboardNavigation,
                renderCustomHeader: i.props.renderCustomHeader,
                popperProps: i.props.popperProps,
                renderDayContents: i.props.renderDayContents,
                onDayMouseEnter: i.props.onDayMouseEnter,
                onMonthMouseLeave: i.props.onMonthMouseLeave,
                onYearMouseEnter: i.props.onYearMouseEnter,
                onYearMouseLeave: i.props.onYearMouseLeave,
                selectsDisabledDaysInRange: i.props.selectsDisabledDaysInRange,
                showTimeInput: i.props.showTimeInput,
                showMonthYearPicker: i.props.showMonthYearPicker,
                showFullMonthYearPicker: i.props.showFullMonthYearPicker,
                showTwoColumnMonthYearPicker: i.props.showTwoColumnMonthYearPicker,
                showFourColumnMonthYearPicker: i.props.showFourColumnMonthYearPicker,
                showYearPicker: i.props.showYearPicker,
                showQuarterYearPicker: i.props.showQuarterYearPicker,
                showPopperArrow: i.props.showPopperArrow,
                excludeScrollbar: i.props.excludeScrollbar,
                handleOnKeyDown: i.props.onKeyDown,
                handleOnDayKeyDown: i.onDayKeyDown,
                isInputFocused: i.state.focused,
                customTimeInput: i.props.customTimeInput,
                setPreSelection: i.setPreSelection
            }, i.props.children) : null;
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderAriaLiveRegion", function() {
            var p, C = i.props, v = C.dateFormat, y = C.locale, L = i.props.showTimeInput || i.props.showTimeSelect ? "PPPPp" : "PPPP";
            return p = i.props.selectsRange ? "Selected start date: ".concat($0422a6ce4ea03acc$var$l8(i.props.startDate, {
                dateFormat: L,
                locale: y
            }), ". ").concat(i.props.endDate ? "End date: " + $0422a6ce4ea03acc$var$l8(i.props.endDate, {
                dateFormat: L,
                locale: y
            }) : "") : i.props.showTimeSelectOnly ? "Selected time: ".concat($0422a6ce4ea03acc$var$l8(i.props.selected, {
                dateFormat: v,
                locale: y
            })) : i.props.showYearPicker ? "Selected year: ".concat($0422a6ce4ea03acc$var$l8(i.props.selected, {
                dateFormat: "yyyy",
                locale: y
            })) : i.props.showMonthYearPicker ? "Selected month: ".concat($0422a6ce4ea03acc$var$l8(i.props.selected, {
                dateFormat: "MMMM yyyy",
                locale: y
            })) : i.props.showQuarterYearPicker ? "Selected quarter: ".concat($0422a6ce4ea03acc$var$l8(i.props.selected, {
                dateFormat: "yyyy, QQQ",
                locale: y
            })) : "Selected date: ".concat($0422a6ce4ea03acc$var$l8(i.props.selected, {
                dateFormat: L,
                locale: y
            })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, i.state.isRenderAriaLiveMessage && p);
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderDateInput", function() {
            var p, C = $0422a6ce4ea03acc$var$L5(i.props.className, $0422a6ce4ea03acc$var$A({}, "react-datepicker-ignore-onclickoutside", i.state.open)), v = i.props.customInput || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                type: "text"
            }), y = i.props.customInputRef || "ref", L = typeof i.props.value == "string" ? i.props.value : typeof i.state.inputValue == "string" ? i.state.inputValue : i.props.selectsRange ? function(M, E, k) {
                if (!M) return "";
                var _ = $0422a6ce4ea03acc$var$l8(M, k), Z = E ? $0422a6ce4ea03acc$var$l8(E, k) : "";
                return "".concat(_, " - ").concat(Z);
            }(i.props.startDate, i.props.endDate, i.props) : $0422a6ce4ea03acc$var$l8(i.props.selected, i.props);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(v, ($0422a6ce4ea03acc$var$A(p = {}, y, function(M) {
                i.input = M;
            }), $0422a6ce4ea03acc$var$A(p, "value", L), $0422a6ce4ea03acc$var$A(p, "onBlur", i.handleBlur), $0422a6ce4ea03acc$var$A(p, "onChange", i.handleChange), $0422a6ce4ea03acc$var$A(p, "onClick", i.onInputClick), $0422a6ce4ea03acc$var$A(p, "onFocus", i.handleFocus), $0422a6ce4ea03acc$var$A(p, "onKeyDown", i.onInputKeyDown), $0422a6ce4ea03acc$var$A(p, "id", i.props.id), $0422a6ce4ea03acc$var$A(p, "name", i.props.name), $0422a6ce4ea03acc$var$A(p, "form", i.props.form), $0422a6ce4ea03acc$var$A(p, "autoFocus", i.props.autoFocus), $0422a6ce4ea03acc$var$A(p, "placeholder", i.props.placeholderText), $0422a6ce4ea03acc$var$A(p, "disabled", i.props.disabled), $0422a6ce4ea03acc$var$A(p, "autoComplete", i.props.autoComplete), $0422a6ce4ea03acc$var$A(p, "className", $0422a6ce4ea03acc$var$L5(v.props.className, C)), $0422a6ce4ea03acc$var$A(p, "title", i.props.title), $0422a6ce4ea03acc$var$A(p, "readOnly", i.props.readOnly), $0422a6ce4ea03acc$var$A(p, "required", i.props.required), $0422a6ce4ea03acc$var$A(p, "tabIndex", i.props.tabIndex), $0422a6ce4ea03acc$var$A(p, "aria-describedby", i.props.ariaDescribedBy), $0422a6ce4ea03acc$var$A(p, "aria-invalid", i.props.ariaInvalid), $0422a6ce4ea03acc$var$A(p, "aria-labelledby", i.props.ariaLabelledBy), $0422a6ce4ea03acc$var$A(p, "aria-required", i.props.ariaRequired), p));
        }), $0422a6ce4ea03acc$var$A($0422a6ce4ea03acc$var$U(i), "renderClearButton", function() {
            var p = i.props, C = p.isClearable, v = p.selected, y = p.startDate, L = p.endDate, M = p.clearButtonTitle, E = p.clearButtonClassName, k = E === void 0 ? "" : E, _ = p.ariaLabelClose, Z = _ === void 0 ? "Close" : _;
            return !C || v == null && y == null && L == null ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                type: "button",
                className: "react-datepicker__close-icon ".concat(k).trim(),
                "aria-label": Z,
                onClick: i.onClearClick,
                title: M,
                tabIndex: -1
            });
        }), i.state = i.calcInitialState(), i;
    }
    return $0422a6ce4ea03acc$var$x4(o, [
        {
            key: "componentDidMount",
            value: function() {
                window.addEventListener("scroll", this.onScroll, !0);
            }
        },
        {
            key: "componentDidUpdate",
            value: function(s, i) {
                var p, C;
                s.inline && (p = s.selected, C = this.props.selected, p && C ? $0422a6ce4ea03acc$var$a5(p) !== $0422a6ce4ea03acc$var$a5(C) || $0422a6ce4ea03acc$var$K2(p) !== $0422a6ce4ea03acc$var$K2(C) : p !== C) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && s.monthsShown !== this.props.monthsShown && this.setState({
                    monthSelectedIn: 0
                }), s.highlightDates !== this.props.highlightDates && this.setState({
                    highlightDates: $0422a6ce4ea03acc$var$SL(this.props.highlightDates)
                }), i.focused || $0422a6ce4ea03acc$var$v0(s.selected, this.props.selected) || this.setState({
                    inputValue: null
                }), i.open !== this.state.open && (i.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), i.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
            }
        },
        {
            key: "renderInputContainer",
            value: function() {
                var s = this.props.showIcon;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__input-container ".concat(s ? "react-datepicker__view-calendar-icon" : "")
                }, s && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
                    className: "react-datepicker__calendar-icon",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                    d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
                })), this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
            }
        },
        {
            key: "render",
            value: function() {
                var s = this.renderCalendar();
                if (this.props.inline) return s;
                if (this.props.withPortal) {
                    var i = this.state.open ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$sw, {
                        enableTabLoop: this.props.enableTabLoop
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        className: "react-datepicker__portal",
                        tabIndex: -1,
                        onKeyDown: this.onPortalKeyDown
                    }, s)) : null;
                    return this.state.open && this.props.portalId && (i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$lw, {
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost
                    }, i)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, this.renderInputContainer(), i);
                }
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0422a6ce4ea03acc$var$jN, {
                    className: this.props.popperClassName,
                    wrapperClassName: this.props.wrapperClassName,
                    hidePopper: !this.isCalendarOpen(),
                    portalId: this.props.portalId,
                    portalHost: this.props.portalHost,
                    popperModifiers: this.props.popperModifiers,
                    targetComponent: this.renderInputContainer(),
                    popperContainer: this.props.popperContainer,
                    popperComponent: s,
                    popperPlacement: this.props.popperPlacement,
                    popperProps: this.props.popperProps,
                    popperOnKeyDown: this.onPopperKeyDown,
                    enableTabLoop: this.props.enableTabLoop
                });
            }
        }
    ], [
        {
            key: "defaultProps",
            get: function() {
                return {
                    allowSameDay: !1,
                    dateFormat: "MM/dd/yyyy",
                    dateFormatCalendar: "LLLL yyyy",
                    onChange: function() {},
                    disabled: !1,
                    disabledKeyboardNavigation: !1,
                    dropdownMode: "scroll",
                    onFocus: function() {},
                    onBlur: function() {},
                    onKeyDown: function() {},
                    onInputClick: function() {},
                    onSelect: function() {},
                    onClickOutside: function() {},
                    onMonthChange: function() {},
                    onCalendarOpen: function() {},
                    onCalendarClose: function() {},
                    preventOpenOnFocus: !1,
                    onYearChange: function() {},
                    onInputError: function() {},
                    monthsShown: 1,
                    readOnly: !1,
                    withPortal: !1,
                    selectsDisabledDaysInRange: !1,
                    shouldCloseOnSelect: !0,
                    showTimeSelect: !1,
                    showTimeInput: !1,
                    showPreviousMonths: !1,
                    showMonthYearPicker: !1,
                    showFullMonthYearPicker: !1,
                    showTwoColumnMonthYearPicker: !1,
                    showFourColumnMonthYearPicker: !1,
                    showYearPicker: !1,
                    showQuarterYearPicker: !1,
                    strictParsing: !1,
                    timeIntervals: 30,
                    timeCaption: "Time",
                    previousMonthAriaLabel: "Previous Month",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthAriaLabel: "Next Month",
                    nextMonthButtonLabel: "Next Month",
                    previousYearAriaLabel: "Previous Year",
                    previousYearButtonLabel: "Previous Year",
                    nextYearAriaLabel: "Next Year",
                    nextYearButtonLabel: "Next Year",
                    timeInputLabel: "Time",
                    enableTabLoop: !0,
                    yearItemNumber: 12,
                    renderDayContents: function(s) {
                        return s;
                    },
                    focusSelectedMonth: !1,
                    showPopperArrow: !0,
                    excludeScrollbar: !0,
                    customTimeInput: null,
                    calendarStartDay: void 0
                };
            }
        }
    ]), o;
}(), $0422a6ce4ea03acc$var$UN = "input", $0422a6ce4ea03acc$var$wp = "navigate";
const $0422a6ce4ea03acc$export$de97fecb6d4b30a5 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { children: o, columns: s, className: i, gap: p = "grid.l", id: C, ...v } = r, y = s ? {
        base: 1,
        md: s
    } : {
        base: 1,
        md: 2,
        lg: 3
    };
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $604fa8b7d7b4fd04$export$de97fecb6d4b30a5), {
        className: i,
        columns: y,
        gap: p,
        id: C,
        ref: a,
        ...v,
        children: o
    });
}), {
    shouldForwardProp: ()=>!0
}), $0422a6ce4ea03acc$export$b534bc812df080fd = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((r)=>{
    const { children: a, className: o, gap: s, id: i, ...p } = r, C = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(a), v = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(a, (y, L)=>y ? y.type === $0422a6ce4ea03acc$export$56e87bf42978147a || y.props.mdxType === "FormField" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(y, {
            id: `${i}-grandchild${L}`
        }) : (console.warn("NYPL Reservoir FormRow: Children must be `FormField` components."), null) : null);
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$de97fecb6d4b30a5, {
        columns: C,
        className: o,
        gap: s,
        id: i,
        ...p,
        children: v
    });
}), $0422a6ce4ea03acc$export$56e87bf42978147a = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((r)=>{
    const { children: a, className: o, gap: s, id: i, ...p } = r;
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$de97fecb6d4b30a5, {
        columns: 1,
        className: o,
        gap: s,
        id: i,
        ...p,
        children: a
    });
}), $0422a6ce4ea03acc$export$a7fed597f4b8afd8 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { action: o, children: s, className: i, gap: p = "grid.l", id: C, method: v, onSubmit: y, ...L } = r;
    C || console.warn("NYPL Reservoir Form: This component's required `id` prop was not passed.");
    const M = {};
    o && (M.action = o), v && (v === "get" || v === "post") && (M.method = v);
    const E = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(s, (k, _)=>k && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(k, {
            gap: p,
            id: `${C}-child${_}`
        }));
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "form",
        "aria-label": "form",
        className: i,
        id: C,
        onSubmit: y,
        ref: a,
        ...M,
        ...L,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$de97fecb6d4b30a5, {
            columns: 1,
            gap: p,
            id: `${C}-parent`,
            children: E
        })
    });
}), {
    shouldForwardProp: ()=>!0
}), $0422a6ce4ea03acc$export$b04be29aa201d4f5 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { children: o, className: s, htmlFor: i, id: p, isInlined: C = !1, isRequired: v = !1, requiredLabelText: y, ...L } = r, M = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Label", {
        isInlined: C
    });
    return p || console.warn("NYPL Reservoir Label: This component's required `id` prop was not passed."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "label",
        id: p,
        className: s,
        htmlFor: i,
        ref: a,
        __css: M,
        ...L,
        children: [
            o,
            v && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                children: y ? ` (${y})` : " (Required)"
            })
        ]
    });
}));
function $0422a6ce4ea03acc$var$fc(r) {
    const [a, o] = (0, $acw62.useState)(r);
    return (0, $acw62.useEffect)(()=>{
        o(r);
    }, [
        r
    ]), [
        a,
        o
    ];
}
const $0422a6ce4ea03acc$var$YN = {
    email: "jdoe@domain.com",
    hidden: "",
    password: "",
    text: "",
    tel: "(123) 123-1234",
    textarea: "",
    url: "https://domain.com"
}, $0422a6ce4ea03acc$export$c86715117507e8e5 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { additionalAriaLabel: o, additionalHelperTextIds: s, ["aria-describedby"]: i, autoComplete: p, className: C, defaultValue: v, helperText: y, id: L, invalidText: M, isClearable: E = !1, isClearableCallback: k, isDisabled: _ = !1, isInvalid: Z = !1, isRequired: O = !1, labelText: B, max: z, maxLength: I, min: P, name: $, onChange: W, onClick: l1, onFocus: u1, pattern: m1, placeholder: L1, showHelperInvalidText: E1 = !0, showLabel: H1 = !0, showRequiredLabel: B1 = !0, requiredLabelText: h1, step: k1 = 1, textInputType: I1 = "default", type: D1 = "text", value: s2, ...f1 } = r, [M1, g1] = $0422a6ce4ea03acc$var$fc(s2), K1 = (0, $acw62.useRef)(), G1 = (0, $a122a84052a653dd$export$74665b213cb5c4cf)(K1, a), R1 = a ? G1 : K1, E2 = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("TextInput", {
        showLabel: H1,
        variant: I1
    }), a3 = D1 === "textarea", H2 = D1 === "hidden";
    let A2 = !!p;
    const u2 = M || "There is an error related to this field.", o2 = (_2)=>{
        g1(_2.target.value), W && W(_2);
    };
    let P2 = Z ? u2 : y;
    if (D1 === "tel" || D1 === "url" || D1 === "email") {
        A2 = !0;
        const _2 = $0422a6ce4ea03acc$var$YN[D1] || "";
        P2 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                "Ex: ",
                _2,
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("br", {}),
                P2
            ]
        });
    }
    const G2 = {
        ...$0422a6ce4ea03acc$var$Uo({
            additionalAriaLabel: o,
            additionalHelperTextIds: s,
            footnote: P2,
            id: L,
            labelText: B,
            name: "TextInput",
            showLabel: H1
        }),
        // getAriaAttrs returns an object with the key `aria-describedby`,
        // but if we need to override it, we can do so here.
        ...i ? {
            "aria-describedby": i
        } : {}
    }, V3 = ()=>{
        g1(""), k && k(), R1.current.focus();
    };
    let I2 = Z, T1, j1, N2;
    return L || console.warn("NYPL Reservoir TextInput: This component's required `id` prop was not passed."), D1 === "number" && z && P && P > z && (I2 = !0, console.warn("NYPL Reservoir TextInput: The `min` prop is greater than the `max` prop.")), N2 = H2 ? {
        defaultValue: v,
        id: L,
        "aria-hidden": H2,
        name: $,
        onChange: o2,
        ref: R1
    } : {
        "aria-required": O,
        /** If the `autoComplete` prop is passed, that value will take
         * precedence and will be used here. Otherwise, a value will be set
         * based on the `type` prop. Lastly, if `autoComplete` is not passed
         * and a default value is not set based on the `type` prop, then
         * `autoComplete` will not be set for the input. */ autoComplete: A2 ? p || D1 : null,
        defaultValue: v,
        id: L,
        isDisabled: _,
        isRequired: O,
        isInvalid: I2,
        max: z,
        maxLength: I,
        min: P,
        name: $,
        onChange: o2,
        onClick: l1,
        onFocus: u1,
        pattern: m1,
        placeholder: L1,
        ref: R1,
        // The `step` attribute is useful for the number type.
        step: D1 === "number" ? k1 : null,
        ...f1,
        ...G2
    }, a3 ? (E && console.warn("NYPL Reservoir TextInput: The `isClearable` prop cannot be used with the `textarea` type."), T1 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $0dd05211a0356948$export$379139ebc1c2b235), {
        ...N2,
        __css: E2.textarea,
        children: s2
    })) : (N2 = {
        type: D1,
        value: M1,
        ...N2
    }, T1 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $846965fabe96e3f8$export$f5b8910cec6cf069), {
        ...N2,
        __css: E2.input
    }), E && !H2 && (j1 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
        buttonType: "text",
        id: `${L}-clear-btn`,
        onClick: V3,
        sx: E2.clearButton,
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                color: "ui.black",
                name: "close",
                size: "medium"
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
                children: [
                    "Clear ",
                    B
                ]
            })
        ]
    }))), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$g7, {
        className: C,
        helperText: I2 ? y : P2,
        id: L,
        invalidText: u2,
        isInvalid: I2,
        showHelperInvalidText: E1 && !H2,
        __css: E2,
        ...f1,
        children: [
            B && H1 && !H2 && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$b04be29aa201d4f5, {
                htmlFor: L,
                id: `${L}-label`,
                isRequired: B1 && O,
                requiredLabelText: h1,
                children: B
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                position: "relative",
                children: [
                    T1,
                    !H2 && (M1 == null ? void 0 : M1.length) > 0 && j1
                ]
            })
        ]
    });
})), $0422a6ce4ea03acc$var$DL = (0, $acw62.forwardRef)(({ dsRef: r, helperText: a, id: o, invalidText: s, isDisabled: i, isInvalid: p, isRequired: C, labelText: v, name: y, onChange: L, onClick: M, showLabel: E, showHelperInvalidText: k, showRequiredLabel: _, value: Z, ...O }, B)=>(delete O.disabled, /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$c86715117507e8e5, {
        additionalAriaLabel: "Press tab to access the calendar.",
        helperText: a,
        id: o,
        invalidText: s,
        isDisabled: i,
        isInvalid: p,
        isRequired: C,
        labelText: v,
        name: y,
        onChange: L,
        onClick: M,
        showHelperInvalidText: k,
        showLabel: E,
        showRequiredLabel: _,
        value: Z,
        ref: r || B,
        ...O
    }))), $0422a6ce4ea03acc$var$WN = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)(({ children: r, className: a, id: o, isDateRange: s, isRequired: i, labelText: p, showLabel: C, showRequiredLabel: v, ...y })=>{
    const L = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("DatePicker", {});
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$56e87bf42978147a, {
        id: `${o}-form-field`,
        ...y,
        children: s ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$e154be390aa0e14, {
            className: a,
            id: o,
            isLegendHidden: !C,
            isRequired: i,
            legendText: p,
            showRequiredLabel: v,
            __css: L.fieldset,
            children: r
        }) : r
    });
}, {
    shouldForwardProp: ()=>!0
}), $0422a6ce4ea03acc$var$QN = ({ id: r, isDateRange: a, children: o })=>a ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$b534bc812df080fd, {
        id: `${r}-form-row`,
        gap: "grid.xs",
        children: o
    }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$x.Fragment, {
        children: o
    }), $0422a6ce4ea03acc$export$5109c6dd95d8fb00 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { className: o, dateFormat: s = "yyyy-MM-dd", dateType: i = "full", helperText: p, helperTextFrom: C, helperTextTo: v, id: y, initialDate: L, initialDateTo: M, invalidText: E, isDateRange: k = !1, isDisabled: _, isInvalid: Z, isRequired: O, labelText: B = "From", maxDate: z, minDate: I, nameFrom: P, nameTo: $, onChange: W, placeholder: l1, placeholderTo: u1, refTo: m1, showHelperInvalidText: L1 = !0, showLabel: E1 = !0, showRequiredLabel: H1 = !0, ...B1 } = r, h1 = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("DatePicker", {}), k1 = k ? h1 : {}, I1 = L ? new Date(L) : L === "" ? null : /* @__PURE__ */ new Date(), D1 = M ? new Date(M) : M === "" ? null : /* @__PURE__ */ new Date(), s2 = (0, $acw62.useRef)(null), f1 = (0, $acw62.useRef)(null), M1 = {
        startDate: s2,
        endDate: f1
    }, g1 = (0, $a122a84052a653dd$export$74665b213cb5c4cf)(s2, a), K1 = (0, $a122a84052a653dd$export$74665b213cb5c4cf)(f1, m1);
    let G1 = {
        startDate: I1
    };
    k && (G1 = {
        ...G1,
        endDate: D1
    });
    const [R1, E2] = (0, $acw62.useState)(G1), a3 = (T1, j1)=>{
        E2({
            ...R1,
            [j1]: T1
        }), W && W({
            ...R1,
            [j1]: T1
        }), M1[j1].current.focus();
    }, H2 = 12;
    let A2 = {
        popperClassName: "date-picker-calendar",
        popperPlacement: "bottom-start",
        popperModifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        -8
                    ]
                }
            }
        ],
        minDate: I ? new Date(I) : null,
        maxDate: z ? new Date(z) : null,
        dateFormat: s
    }, u2 = {
        isRequired: O,
        // In the date range type, don't display the "(Required)" text in
        // individual input labels. It'll display in the legend element.
        showRequiredLabel: k ? !1 : H1,
        // Always display the labels for the input fields when
        // the DatePicker component is a date range type.
        showLabel: k ? !0 : E1,
        isDisabled: _,
        isInvalid: Z,
        helperText: k ? C : p,
        showHelperInvalidText: L1,
        invalidText: E,
        __css: k1.subLabels
    }, o2 = {}, P2 = {}, G2 = null, V3 = B;
    if (i === "month" ? (A2.showMonthYearPicker = !0, A2.dateFormat = "MM-yyyy") : i === "year" && (A2.showYearPicker = !0, A2.yearItemNumber = H2, A2.dateFormat = "yyyy"), y || console.warn("NYPL Reservoir DatePicker: This component's required `id` prop was not passed."), (a && !P || m1 && !$) && console.warn("NYPL Reservoir DatePicker: A `ref` or `refTo` prop was passed but not the equivalent `nameFrom` or `nameTo` prop."), W && (a || m1 || P || $) && console.warn("NYPL Reservoir DatePicker: A `ref`, `refTo`, `nameFrom`, or `nameTo` prop was passed and an `onChange` prop as well. Use whichever is best for your app but not both."), o2 = {
        ...A2
    }, k) {
        const T1 = {
            ...u2,
            helperText: v
        };
        o2 = {
            ...o2,
            selectsStart: !0,
            startDate: R1.startDate,
            endDate: R1.endDate
        }, P2 = {
            ...A2,
            selectsEnd: !0,
            minDate: R1.startDate,
            startDate: R1.startDate,
            endDate: R1.endDate
        }, V3 = "From", G2 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$_L, {
            customInput: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$DL, {
                dsRef: K1,
                labelText: "To",
                ...v && p ? {
                    additionalHelperTextIds: `${y}-helper-text`
                } : {},
                ...T1
            }),
            id: `${y}-end`,
            name: $,
            onChange: (j1)=>a3(j1, "endDate"),
            placeholderText: u1,
            selected: R1.endDate,
            ...P2
        });
    }
    const I2 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$_L, {
        customInput: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$DL, {
            dsRef: g1,
            labelText: V3,
            ...k && C && p ? {
                additionalHelperTextIds: `${y}-helper-text`
            } : {},
            ...u2
        }),
        id: `${y}-start`,
        name: P,
        onChange: (T1)=>a3(T1, "startDate"),
        placeholderText: l1,
        selected: R1.startDate,
        ...o2
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$WN, {
        id: y,
        isDateRange: k,
        showLabel: E1,
        labelText: B,
        className: o,
        isRequired: O,
        showRequiredLabel: H1,
        ...B1,
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$QN, {
                id: y,
                isDateRange: k,
                children: [
                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$56e87bf42978147a, {
                        id: `${y}-start-form`,
                        children: I2
                    }),
                    G2 && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$56e87bf42978147a, {
                        id: `${y}-end-form`,
                        children: G2
                    })
                ]
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$75f76bb17920f318, {
                id: `${y}-helper-text`,
                isInvalid: !1,
                isRenderedText: k && L1,
                text: p
            })
        ]
    });
}), {
    shouldForwardProp: ()=>!0
});
var $0422a6ce4ea03acc$var$pc = {
    exports: {}
};
$0422a6ce4ea03acc$var$pc.exports;
(function(r, a) {
    var o = 200, s = "__lodash_hash_undefined__", i = 800, p = 16, C = 9007199254740991, v = "[object Arguments]", y = "[object Array]", L = "[object AsyncFunction]", M = "[object Boolean]", E = "[object Date]", k = "[object Error]", _ = "[object Function]", Z = "[object GeneratorFunction]", O = "[object Map]", B = "[object Number]", z = "[object Null]", I = "[object Object]", P = "[object Proxy]", $ = "[object RegExp]", W = "[object Set]", l1 = "[object String]", u1 = "[object Undefined]", m1 = "[object WeakMap]", L1 = "[object ArrayBuffer]", E1 = "[object DataView]", H1 = "[object Float32Array]", B1 = "[object Float64Array]", h1 = "[object Int8Array]", k1 = "[object Int16Array]", I1 = "[object Int32Array]", D1 = "[object Uint8Array]", s2 = "[object Uint8ClampedArray]", f1 = "[object Uint16Array]", M1 = "[object Uint32Array]", g1 = /[\\^$.*+?()[\]{}|]/g, K1 = /^\[object .+?Constructor\]$/, G1 = /^(?:0|[1-9]\d*)$/, R1 = {};
    R1[H1] = R1[B1] = R1[h1] = R1[k1] = R1[I1] = R1[D1] = R1[s2] = R1[f1] = R1[M1] = !0, R1[v] = R1[y] = R1[L1] = R1[M] = R1[E1] = R1[E] = R1[k] = R1[_] = R1[O] = R1[B] = R1[I] = R1[$] = R1[W] = R1[l1] = R1[m1] = !1;
    var E2 = typeof $0422a6ce4ea03acc$var$Pu == "object" && $0422a6ce4ea03acc$var$Pu && $0422a6ce4ea03acc$var$Pu.Object === Object && $0422a6ce4ea03acc$var$Pu, a3 = typeof self == "object" && self && self.Object === Object && self, H2 = E2 || a3 || Function("return this")(), A2 = a && !a.nodeType && a, u2 = A2 && !0 && r && !r.nodeType && r, o2 = u2 && u2.exports === A2, P2 = o2 && E2.process, G2 = function() {
        try {
            var N = u2 && u2.require && u2.require("util").types;
            return N || P2 && P2.binding && P2.binding("util");
        } catch  {}
    }(), V3 = G2 && G2.isTypedArray;
    function I2(N, X, s1) {
        switch(s1.length){
            case 0:
                return N.call(X);
            case 1:
                return N.call(X, s1[0]);
            case 2:
                return N.call(X, s1[0], s1[1]);
            case 3:
                return N.call(X, s1[0], s1[1], s1[2]);
        }
        return N.apply(X, s1);
    }
    function T1(N, X) {
        for(var s1 = -1, X1 = Array(N); ++s1 < N;)X1[s1] = X(s1);
        return X1;
    }
    function j1(N) {
        return function(X) {
            return N(X);
        };
    }
    function N2(N, X) {
        return N == null ? void 0 : N[X];
    }
    function _2(N, X) {
        return function(s1) {
            return N(X(s1));
        };
    }
    var R3 = Array.prototype, he = Function.prototype, j3 = Object.prototype, ee = H2["__core-js_shared__"], me = he.toString, D2 = j3.hasOwnProperty, z3 = function() {
        var N = /[^.]+$/.exec(ee && ee.keys && ee.keys.IE_PROTO || "");
        return N ? "Symbol(src)_1." + N : "";
    }(), se = j3.toString, c4 = me.call(Object), U3 = RegExp("^" + me.call(D2).replace(g1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), ve = o2 ? H2.Buffer : void 0, Y5 = H2.Symbol, F4 = H2.Uint8Array;
    ve && ve.allocUnsafe;
    var _1 = _2(Object.getPrototypeOf, Object), d2 = Object.create, B2 = j3.propertyIsEnumerable, m3 = R3.splice, v3 = Y5 ? Y5.toStringTag : void 0, te = function() {
        try {
            var N = x7(Object, "defineProperty");
            return N({}, "", {}), N;
        } catch  {}
    }(), ne = ve ? ve.isBuffer : void 0, qe = Math.max, S3 = Date.now, d4 = x7(H2, "Map"), i3 = x7(Object, "create"), k3 = /* @__PURE__ */ function() {
        function N() {}
        return function(X) {
            if (!Te(X)) return {};
            if (d2) return d2(X);
            N.prototype = X;
            var s1 = new N();
            return N.prototype = void 0, s1;
        };
    }();
    function A4(N) {
        var X = -1, s1 = N == null ? 0 : N.length;
        for(this.clear(); ++X < s1;){
            var X1 = N[X];
            this.set(X1[0], X1[1]);
        }
    }
    function O6() {
        this.__data__ = i3 ? i3(null) : {}, this.size = 0;
    }
    function y7(N) {
        var X = this.has(N) && delete this.__data__[N];
        return this.size -= X ? 1 : 0, X;
    }
    function p8(N) {
        var X = this.__data__;
        if (i3) {
            var s1 = X[N];
            return s1 === s ? void 0 : s1;
        }
        return D2.call(X, N) ? X[N] : void 0;
    }
    function C9(N) {
        var X = this.__data__;
        return i3 ? X[N] !== void 0 : D2.call(X, N);
    }
    function N6(N, X) {
        var s1 = this.__data__;
        return this.size += this.has(N) ? 0 : 1, s1[N] = i3 && X === void 0 ? s : X, this;
    }
    A4.prototype.clear = O6, A4.prototype.delete = y7, A4.prototype.get = p8, A4.prototype.has = C9, A4.prototype.set = N6;
    function C4(N) {
        var X = -1, s1 = N == null ? 0 : N.length;
        for(this.clear(); ++X < s1;){
            var X1 = N[X];
            this.set(X1[0], X1[1]);
        }
    }
    function P6() {
        this.__data__ = [], this.size = 0;
    }
    function L7(N) {
        var X = this.__data__, s1 = B6(X, N);
        if (s1 < 0) return !1;
        var X1 = X.length - 1;
        return s1 == X1 ? X.pop() : m3.call(X, s1, 1), --this.size, !0;
    }
    function b5(N) {
        var X = this.__data__, s1 = B6(X, N);
        return s1 < 0 ? void 0 : X[s1][1];
    }
    function l6(N) {
        return B6(this.__data__, N) > -1;
    }
    function E4(N, X) {
        var s1 = this.__data__, X1 = B6(s1, N);
        return X1 < 0 ? (++this.size, s1.push([
            N,
            X
        ])) : s1[X1][1] = X, this;
    }
    C4.prototype.clear = P6, C4.prototype.delete = L7, C4.prototype.get = b5, C4.prototype.has = l6, C4.prototype.set = E4;
    function Ae(N) {
        var X = -1, s1 = N == null ? 0 : N.length;
        for(this.clear(); ++X < s1;){
            var X1 = N[X];
            this.set(X1[0], X1[1]);
        }
    }
    function s6() {
        this.size = 0, this.__data__ = {
            hash: new A4(),
            map: new (d4 || C4)(),
            string: new A4()
        };
    }
    function j(N) {
        var X = H7(this, N).delete(N);
        return this.size -= X ? 1 : 0, X;
    }
    function w1(N) {
        return H7(this, N).get(N);
    }
    function N1(N) {
        return H7(this, N).has(N);
    }
    function p2(N, X) {
        var s1 = H7(this, N), X1 = s1.size;
        return s1.set(N, X), this.size += s1.size == X1 ? 0 : 1, this;
    }
    Ae.prototype.clear = s6, Ae.prototype.delete = j, Ae.prototype.get = w1, Ae.prototype.has = N1, Ae.prototype.set = p2;
    function x2(N) {
        var X = this.__data__ = new C4(N);
        this.size = X.size;
    }
    function J2() {
        this.__data__ = new C4(), this.size = 0;
    }
    function R2(N) {
        var X = this.__data__, s1 = X.delete(N);
        return this.size = X.size, s1;
    }
    function v2(N) {
        return this.__data__.get(N);
    }
    function He(N) {
        return this.__data__.has(N);
    }
    function B3(N, X) {
        var s1 = this.__data__;
        if (s1 instanceof C4) {
            var X1 = s1.__data__;
            if (!d4 || X1.length < o - 1) return X1.push([
                N,
                X
            ]), this.size = ++s1.size, this;
            s1 = this.__data__ = new Ae(X1);
        }
        return s1.set(N, X), this.size = s1.size, this;
    }
    x2.prototype.clear = J2, x2.prototype.delete = R2, x2.prototype.get = v2, x2.prototype.has = He, x2.prototype.set = B3;
    function F3(N, X) {
        var s1 = f4(N), X1 = !s1 && G3(N), z2 = !s1 && !X1 && ue(N), f3 = !s1 && !X1 && !z2 && E0(N), T3 = s1 || X1 || z2 || f3, F2 = T3 ? T1(N.length, String) : [], w3 = F2.length;
        for(var Ge in N)T3 && // Safari 9 has enumerable `arguments.length` in strict mode.
        (Ge == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        z2 && (Ge == "offset" || Ge == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        f3 && (Ge == "buffer" || Ge == "byteLength" || Ge == "byteOffset") || // Skip index properties.
        h9(Ge, w3)) || F2.push(Ge);
        return F2;
    }
    function ke(N, X, s1) {
        (s1 !== void 0 && !d6(N[X], s1) || s1 === void 0 && !(X in N)) && X2(N, X, s1);
    }
    function u6(N, X, s1) {
        var X1 = N[X];
        (!(D2.call(N, X) && d6(X1, s1)) || s1 === void 0 && !(X in N)) && X2(N, X, s1);
    }
    function B6(N, X) {
        for(var s1 = N.length; s1--;)if (d6(N[s1][0], X)) return s1;
        return -1;
    }
    function X2(N, X, s1) {
        X == "__proto__" && te ? te(N, X, {
            configurable: !0,
            enumerable: !0,
            value: s1,
            writable: !0
        }) : N[X] = s1;
    }
    var la = o5();
    function j4(N) {
        return N == null ? N === void 0 ? u1 : z : v3 && v3 in Object(N) ? x0(N) : Ft(N);
    }
    function j2(N) {
        return ce(N) && j4(N) == v;
    }
    function c6(N) {
        if (!Te(N) || h8(N)) return !1;
        var X = C3(N) ? U3 : K1;
        return X.test(S2(N));
    }
    function Ot(N) {
        return ce(N) && jt(N.length) && !!R1[j4(N)];
    }
    function H0(N) {
        if (!Te(N)) return V0(N);
        var X = d3(N), s1 = [];
        for(var X1 in N)X1 == "constructor" && (X || !D2.call(N, X1)) || s1.push(X1);
        return s1;
    }
    function b7(N, X, s1, X1, z2) {
        N !== X && la(X, function(f3, T3) {
            if (z2 || (z2 = new x2()), Te(f3)) i5(N, X, T3, s1, b7, X1, z2);
            else {
                var F2 = X1 ? X1(g3(N, T3), f3, T3 + "", N, X, z2) : void 0;
                F2 === void 0 && (F2 = f3), ke(N, T3, F2);
            }
        }, v9);
    }
    function i5(N, X, s1, X1, z2, f3, T3) {
        var F2 = g3(N, s1), w3 = g3(X, s1), Ge = T3.get(w3);
        if (Ge) {
            ke(N, s1, Ge);
            return;
        }
        var Xe = f3 ? f3(F2, w3, s1 + "", N, X, T3) : void 0, w5 = Xe === void 0;
        if (w5) {
            var j6 = f4(w3), g9 = !j6 && ue(w3), h4 = !j6 && !g9 && E0(w3);
            Xe = w3, j6 || g9 || h4 ? f4(F2) ? Xe = F2 : m8(F2) ? Xe = f9(F2) : g9 ? (w5 = !1, Xe = Pt(w3)) : h4 ? (w5 = !1, Xe = sa(w3)) : Xe = [] : C6(w3) || G3(w3) ? (Xe = F2, G3(F2) ? Xe = V7(F2) : (!Te(F2) || C3(F2)) && (Xe = p9(w3))) : w5 = !1;
        }
        w5 && (T3.set(w3, Xe), z2(Xe, w3, X1, f3, T3), T3.delete(w3)), ke(N, s1, Xe);
    }
    function Nt(N, X) {
        return At(m9(N, X, M7), N + "");
    }
    var z4 = te ? function(N, X) {
        return te(N, "toString", {
            configurable: !0,
            enumerable: !1,
            value: v8(X),
            writable: !0
        });
    } : M7;
    function Pt(N, X) {
        return N.slice();
    }
    function Bt(N) {
        var X = new N.constructor(N.byteLength);
        return new F4(X).set(new F4(N)), X;
    }
    function sa(N, X) {
        var s1 = Bt(N.buffer);
        return new N.constructor(s1, N.byteOffset, N.length);
    }
    function f9(N, X) {
        var s1 = -1, X1 = N.length;
        for(X || (X = Array(X1)); ++s1 < X1;)X[s1] = N[s1];
        return X;
    }
    function w7(N, X, s1, X1) {
        var z2 = !s1;
        s1 || (s1 = {});
        for(var f3 = -1, T3 = X.length; ++f3 < T3;){
            var F2 = X[f3], w3 = void 0;
            w3 === void 0 && (w3 = N[F2]), z2 ? X2(s1, F2, w3) : u6(s1, F2, w3);
        }
        return s1;
    }
    function F6(N) {
        return Nt(function(X, s1) {
            var X1 = -1, z2 = s1.length, f3 = z2 > 1 ? s1[z2 - 1] : void 0, T3 = z2 > 2 ? s1[2] : void 0;
            for(f3 = N.length > 3 && typeof f3 == "function" ? (z2--, f3) : void 0, T3 && A6(s1[0], s1[1], T3) && (f3 = z2 < 3 ? void 0 : f3, z2 = 1), X = Object(X); ++X1 < z2;){
                var F2 = s1[X1];
                F2 && N(X, F2, X1, f3);
            }
            return X;
        });
    }
    function o5(N) {
        return function(X, s1, X1) {
            for(var z2 = -1, f3 = Object(X), T3 = X1(X), F2 = T3.length; F2--;){
                var w3 = T3[++z2];
                if (s1(f3[w3], w3, f3) === !1) break;
            }
            return X;
        };
    }
    function H7(N, X) {
        var s1 = N.__data__;
        return ua(X) ? s1[typeof X == "string" ? "string" : "hash"] : s1.map;
    }
    function x7(N, X) {
        var s1 = N2(N, X);
        return c6(s1) ? s1 : void 0;
    }
    function x0(N) {
        var X = D2.call(N, v3), s1 = N[v3];
        try {
            N[v3] = void 0;
            var X1 = !0;
        } catch  {}
        var z2 = se.call(N);
        return X1 && (X ? N[v3] = s1 : delete N[v3]), z2;
    }
    function p9(N) {
        return typeof N.constructor == "function" && !d3(N) ? k3(_1(N)) : {};
    }
    function h9(N, X) {
        var s1 = typeof N;
        return X = X ?? C, !!X && (s1 == "number" || s1 != "symbol" && G1.test(N)) && N > -1 && N % 1 == 0 && N < X;
    }
    function A6(N, X, s1) {
        if (!Te(s1)) return !1;
        var X1 = typeof X;
        return (X1 == "number" ? p4(s1) && h9(X, s1.length) : X1 == "string" && X in s1) ? d6(s1[X], N) : !1;
    }
    function ua(N) {
        var X = typeof N;
        return X == "string" || X == "number" || X == "symbol" || X == "boolean" ? N !== "__proto__" : N === null;
    }
    function h8(N) {
        return !!z3 && z3 in N;
    }
    function d3(N) {
        var X = N && N.constructor, s1 = typeof X == "function" && X.prototype || j3;
        return N === s1;
    }
    function V0(N) {
        var X = [];
        if (N != null) for(var s1 in Object(N))X.push(s1);
        return X;
    }
    function Ft(N) {
        return se.call(N);
    }
    function m9(N, X, s1) {
        return X = qe(X === void 0 ? N.length - 1 : X, 0), function() {
            for(var X1 = arguments, z2 = -1, f3 = qe(X1.length - X, 0), T3 = Array(f3); ++z2 < f3;)T3[z2] = X1[X + z2];
            z2 = -1;
            for(var F2 = Array(X + 1); ++z2 < X;)F2[z2] = X1[z2];
            return F2[X] = s1(T3), I2(N, this, F2);
        };
    }
    function g3(N, X) {
        if (!(X === "constructor" && typeof N[X] == "function") && X != "__proto__") return N[X];
    }
    var At = M0(z4);
    function M0(N) {
        var X = 0, s1 = 0;
        return function() {
            var X1 = S3(), z2 = p - (X1 - s1);
            if (s1 = X1, z2 > 0) {
                if (++X >= i) return arguments[0];
            } else X = 0;
            return N.apply(void 0, arguments);
        };
    }
    function S2(N) {
        if (N != null) {
            try {
                return me.call(N);
            } catch  {}
            try {
                return N + "";
            } catch  {}
        }
        return "";
    }
    function d6(N, X) {
        return N === X || N !== N && X !== X;
    }
    var G3 = j2(/* @__PURE__ */ function() {
        return arguments;
    }()) ? j2 : function(N) {
        return ce(N) && D2.call(N, "callee") && !B2.call(N, "callee");
    }, f4 = Array.isArray;
    function p4(N) {
        return N != null && jt(N.length) && !C3(N);
    }
    function m8(N) {
        return ce(N) && p4(N);
    }
    var ue = ne || E7;
    function C3(N) {
        if (!Te(N)) return !1;
        var X = j4(N);
        return X == _ || X == Z || X == L || X == P;
    }
    function jt(N) {
        return typeof N == "number" && N > -1 && N % 1 == 0 && N <= C;
    }
    function Te(N) {
        var X = typeof N;
        return N != null && (X == "object" || X == "function");
    }
    function ce(N) {
        return N != null && typeof N == "object";
    }
    function C6(N) {
        if (!ce(N) || j4(N) != I) return !1;
        var X = _1(N);
        if (X === null) return !0;
        var s1 = D2.call(X, "constructor") && X.constructor;
        return typeof s1 == "function" && s1 instanceof s1 && me.call(s1) == c4;
    }
    var E0 = V3 ? j1(V3) : Ot;
    function V7(N) {
        return w7(N, v9(N));
    }
    function v9(N) {
        return p4(N) ? F3(N) : H0(N);
    }
    var zt = F6(function(N, X, s1, X1) {
        b7(N, X, s1, X1);
    });
    function v8(N) {
        return function() {
            return N;
        };
    }
    function M7(N) {
        return N;
    }
    function E7() {
        return !1;
    }
    r.exports = zt;
})($0422a6ce4ea03acc$var$pc, $0422a6ce4ea03acc$var$pc.exports);
var $0422a6ce4ea03acc$var$qN = $0422a6ce4ea03acc$var$pc.exports;
const $0422a6ce4ea03acc$var$uw = /* @__PURE__ */ $0422a6ce4ea03acc$var$zo($0422a6ce4ea03acc$var$qN), $0422a6ce4ea03acc$var$u9 = (r = !1)=>({
        clip: "rect(1px, 1px, 1px, 1px)",
        height: {
            base: "1px",
            md: r ? "auto" : void 0
        },
        overflow: "hidden",
        position: {
            base: "absolute !important",
            md: r ? "relative !important" : void 0
        },
        width: {
            base: "1px",
            md: r ? "100%" : void 0
        },
        wordWrap: "normal"
    }), $0422a6ce4ea03acc$var$Ec = {
    marginY: "0",
    marginX: "auto",
    maxWidth: "1280px",
    padding: "0",
    width: "100%"
}, $0422a6ce4ea03acc$var$Sc = (r, a)=>({
        boxShadow: "none",
        outline: "2px solid",
        outlineOffset: "2px",
        outlineColor: r,
        zIndex: "9999",
        _dark: {
            outlineColor: a
        }
    }), $0422a6ce4ea03acc$var$na = (r = !1)=>({
        boxShadow: "none",
        outline: "2px solid",
        outlineOffset: "2px",
        outlineColor: r ? "dark.ui.focus" : "ui.focus",
        zIndex: "9999",
        _dark: {
            outlineColor: "dark.ui.focus"
        }
    }), $0422a6ce4ea03acc$var$cw = {
    userSelect: "none",
    fontWeight: "text.default",
    marginBottom: "0",
    marginStart: "xs",
    width: "100%",
    _disabled: {
        color: "ui.gray.dark",
        opacity: 1,
        fontStyle: "italic"
    },
    _invalid: {
        color: "ui.error.primary"
    },
    _dark: {
        _disabled: {
            color: "dark.ui.disabled.primary"
        },
        _invalid: {
            color: "dark.ui.error.primary"
        }
    }
}, $0422a6ce4ea03acc$var$dw = {
    h: "1.375rem",
    w: "1.375rem"
}, $0422a6ce4ea03acc$var$Cw = {
    marginStart: "30px",
    // calc(22px + var(--nypl-space-xs))
    _disabled: {
        color: "ui.gray.dark",
        fontStyle: "italic"
    }
}, $0422a6ce4ea03acc$var$fw = {
    _hover: {
        span: {
            _first: {
                borderColor: "ui.black"
            },
            _checked: {
                borderColor: "ui.focus"
            },
            _disabled: {
                borderColor: "ui.disabled.primary"
            },
            _invalid: {
                borderColor: "ui.error.primary"
            }
        },
        _dark: {
            span: {
                _first: {
                    borderColor: "dark.ui.border.hover"
                },
                _checked: {
                    borderColor: "dark.ui.focus"
                },
                _disabled: {
                    borderColor: "dark.ui.disabled.secondary"
                },
                _invalid: {
                    borderColor: "dark.ui.error.primary"
                }
            }
        }
    }
}, $0422a6ce4ea03acc$var$pw = (r = !1)=>({
        helperErrorText: {
            marginTop: "xs"
        },
        label: {
            display: "flex",
            width: r ? "100%" : "fit-content"
        }
    }), $0422a6ce4ea03acc$var$n6 = {
    mobileFieldHeight: "44px"
}, $0422a6ce4ea03acc$var$hw = {
    color: "ui.typography.heading",
    display: "inline-block",
    fontSize: "desktop.label.label1",
    fontWeight: "label.default",
    marginBottom: "xs",
    width: "100%",
    span: {
        fontWeight: "regular"
    },
    _dark: {
        color: "dark.ui.typography.heading"
    }
}, $0422a6ce4ea03acc$var$kc = {
    marginBottom: "xxxs"
}, $0422a6ce4ea03acc$var$ah = {
    bg: "ui.disabled.secondary",
    borderColor: "ui.disabled.primary",
    color: "ui.gray.dark",
    opacity: "1",
    _dark: {
        bg: "dark.ui.bg.default",
        borderColor: "dark.ui.disabled.secondary",
        color: "dark.ui.disabled.primary"
    }
}, $0422a6ce4ea03acc$var$Ir = {
    ...$0422a6ce4ea03acc$var$na(),
    borderColor: "ui.focus",
    _dark: {
        ...$0422a6ce4ea03acc$var$na(!0),
        borderColor: "dark.ui.focus"
    }
}, $0422a6ce4ea03acc$var$$r = {
    margin: "0",
    marginBottom: "s"
}, $0422a6ce4ea03acc$var$GN = {
    // styles for the `body` element
    body: {
        boxSizing: "border-box",
        bg: "ui.white",
        color: "ui.typography.body",
        fontFamily: "body",
        fontSize: "desktop.body.body1",
        fontWeight: "body.body1",
        lineHeight: "1.5",
        overflowX: "hidden",
        _dark: {
            bg: "dark.ui.bg.page",
            color: "dark.ui.typography.body"
        }
    },
    // styles for the `a` element
    a: {
        color: "ui.link.primary"
    },
    b: {
        fontWeight: "bold"
    },
    strong: {
        fontWeight: "bold"
    },
    svg: {
        display: "inline"
    },
    "button, select, input, textarea": {
        "&:not([disabled])": {
            _focus: $0422a6ce4ea03acc$var$na()
        }
    },
    "iframe, [href], [tabindex], [contentEditable='true']": {
        _focus: $0422a6ce4ea03acc$var$na()
    },
    p: $0422a6ce4ea03acc$var$$r,
    ul: $0422a6ce4ea03acc$var$$r,
    ol: $0422a6ce4ea03acc$var$$r,
    "*, *::before, &::after": {
        boxSizing: "inherit"
    }
}, $0422a6ce4ea03acc$var$XN = {
    sm: "20em",
    md: "37.5em",
    lg: "60em",
    xl: "80em",
    "2xl": "96em"
}, $0422a6ce4ea03acc$var$mw = "#000", $0422a6ce4ea03acc$var$vw = "#fff", $0422a6ce4ea03acc$var$Iu = "#191919", $0422a6ce4ea03acc$var$RL = "#252525", $0422a6ce4ea03acc$var$$u = "#2E2E2E", $0422a6ce4ea03acc$var$Hp = "#424242", $0422a6ce4ea03acc$var$xp = "#616161", $0422a6ce4ea03acc$var$ZL = "#8D8D8D", $0422a6ce4ea03acc$var$Ar = "#BDBDBD", $0422a6ce4ea03acc$var$OL = "#D9D9D9", $0422a6ce4ea03acc$var$o9 = "#E9E9E9", $0422a6ce4ea03acc$var$NL = "#F5F5F5", $0422a6ce4ea03acc$var$PL = "#FAFAFA", $0422a6ce4ea03acc$var$Vp = "#97272C", $0422a6ce4ea03acc$var$KN = "#6F0106", $0422a6ce4ea03acc$var$Mp = "#0069BF", $0422a6ce4ea03acc$var$JN = "#004B98", $0422a6ce4ea03acc$var$Ep = "#551A8B", $0422a6ce4ea03acc$var$Sp = "#F9E08E", $0422a6ce4ea03acc$var$eP = "#FBE7E1", $0422a6ce4ea03acc$var$kp = "#077719", $0422a6ce4ea03acc$var$tP = "#095212", $0422a6ce4ea03acc$var$Tp = "#F88820", $0422a6ce4ea03acc$var$nP = "#E36D17", $0422a6ce4ea03acc$var$rP = "#CD4D05", $0422a6ce4ea03acc$var$_p = "#E1767B", $0422a6ce4ea03acc$var$aP = "#F08F93", $0422a6ce4ea03acc$var$Dp = "#79B7EB", $0422a6ce4ea03acc$var$iP = "#95CFFF", $0422a6ce4ea03acc$var$oP = "#B583E1", $0422a6ce4ea03acc$var$Rp = "#B69C46", $0422a6ce4ea03acc$var$lP = "#CB8E7C", $0422a6ce4ea03acc$var$Zp = "#52AA60", $0422a6ce4ea03acc$var$sP = "#81C88A", $0422a6ce4ea03acc$var$Op = "#DC8034", $0422a6ce4ea03acc$var$uP = "#EC7B1F", $0422a6ce4ea03acc$var$Tr = "#C60917", $0422a6ce4ea03acc$var$ih = "#760000", $0422a6ce4ea03acc$var$_r = $0422a6ce4ea03acc$var$o9, $0422a6ce4ea03acc$var$BL = $0422a6ce4ea03acc$var$Ar, $0422a6ce4ea03acc$var$Dr = "#737373", $0422a6ce4ea03acc$var$FL = "#565656", $0422a6ce4ea03acc$var$Rr = "#1D62E6", $0422a6ce4ea03acc$var$AL = "#2540A4", $0422a6ce4ea03acc$var$Zr = "#00838A", $0422a6ce4ea03acc$var$Or = "#006166", $0422a6ce4ea03acc$var$Nr = "#005D53", $0422a6ce4ea03acc$var$Pr = "#A03E31", $0422a6ce4ea03acc$var$Br = $0422a6ce4ea03acc$var$ih, $0422a6ce4ea03acc$var$Np = "#242424", $0422a6ce4ea03acc$var$cP = $0422a6ce4ea03acc$var$mw, $0422a6ce4ea03acc$var$ra = {
    light: {
        primary: $0422a6ce4ea03acc$var$Tr,
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Tr, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Tr, 0.1),
        secondary: $0422a6ce4ea03acc$var$ih
    },
    dark: {
        primary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Tr, 0.2),
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Tr, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Tr, 0.1),
        secondary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$ih, 0.2)
    }
}, $0422a6ce4ea03acc$var$jL = {
    light: {
        primary: $0422a6ce4ea03acc$var$_r,
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$_r, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$_r, 0.1),
        secondary: $0422a6ce4ea03acc$var$BL
    },
    dark: {
        primary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$_r, 0.2),
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$_r, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$_r, 0.1),
        secondary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$BL, 0.2)
    }
}, $0422a6ce4ea03acc$var$zL = {
    light: $0422a6ce4ea03acc$var$ra.light,
    dark: $0422a6ce4ea03acc$var$ra.dark
}, $0422a6ce4ea03acc$var$UL = {
    light: {
        primary: $0422a6ce4ea03acc$var$Dr,
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Dr, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Dr, 0.1),
        secondary: $0422a6ce4ea03acc$var$FL
    },
    dark: {
        primary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Dr, 0.4),
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Dr, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Dr, 0.1),
        secondary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$FL, 0.4)
    }
}, $0422a6ce4ea03acc$var$IL = {
    light: {
        primary: $0422a6ce4ea03acc$var$Rr,
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Rr, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Rr, 0.1),
        secondary: $0422a6ce4ea03acc$var$AL
    },
    dark: {
        primary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Rr, 0.2),
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Rr, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Rr, 0.1),
        secondary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$AL, 0.2)
    }
}, $0422a6ce4ea03acc$var$$L = {
    light: $0422a6ce4ea03acc$var$ra.light,
    dark: $0422a6ce4ea03acc$var$ra.dark
}, $0422a6ce4ea03acc$var$YL = {
    light: {
        primary: $0422a6ce4ea03acc$var$Zr,
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Zr, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Zr, 0.1),
        secondary: $0422a6ce4ea03acc$var$Or,
        "secondary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Or, 0.05),
        "secondary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Or, 0.1)
    },
    dark: {
        primary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Zr, 0.2),
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Zr, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Zr, 0.1),
        secondary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Or, 0.2),
        "secondary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Or, 0.05),
        "secondary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Or, 0.1)
    }
}, $0422a6ce4ea03acc$var$WL = {
    light: {
        lpa: $0422a6ce4ea03acc$var$Nr,
        "lpa-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Nr, 0.05),
        "lpa-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Nr, 0.1),
        schomburg: $0422a6ce4ea03acc$var$Pr,
        "schomburg-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Pr, 0.05),
        "schomburg-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Pr, 0.1),
        schwarzman: $0422a6ce4ea03acc$var$Br,
        "schwarzman-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Br, 0.05),
        "schwarzman-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Br, 0.1)
    },
    dark: {
        lpa: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Nr, 0.2),
        "lpa-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Nr, 0.05),
        "lpa-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Nr, 0.1),
        schomburg: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Pr, 0.2),
        "schomburg-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Pr, 0.05),
        "schomburg-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Pr, 0.1),
        schwarzman: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Br, 0.2),
        "schwarzman-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Br, 0.05),
        "schwarzman-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Br, 0.1)
    }
}, $0422a6ce4ea03acc$var$QL = {
    light: {
        primary: $0422a6ce4ea03acc$var$Np,
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Np, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Np, 0.1),
        secondary: $0422a6ce4ea03acc$var$cP
    },
    dark: {
        primary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$o9, 0.2),
        "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$o9, 0.05),
        "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$o9, 0.1),
        secondary: $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$vw, 0.05)
    }
}, $0422a6ce4ea03acc$var$dP = {
    transparent: "transparent",
    // ui fills
    ui: {
        black: $0422a6ce4ea03acc$var$mw,
        white: $0422a6ce4ea03acc$var$vw,
        // State and link utilities
        disabled: {
            primary: $0422a6ce4ea03acc$var$o9,
            secondary: $0422a6ce4ea03acc$var$PL
        },
        error: {
            primary: $0422a6ce4ea03acc$var$Vp,
            "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Vp, 0.05),
            "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Vp, 0.1),
            secondary: $0422a6ce4ea03acc$var$KN
        },
        focus: "#4181F1",
        link: {
            primary: $0422a6ce4ea03acc$var$Mp,
            "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Mp, 0.05),
            "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Mp, 0.1),
            secondary: $0422a6ce4ea03acc$var$JN,
            tertiary: $0422a6ce4ea03acc$var$Ep,
            "tertiary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Ep, 0.05),
            "tertiary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Ep, 0.1)
        },
        status: {
            primary: $0422a6ce4ea03acc$var$Sp,
            "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Sp, 0.05),
            "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Sp, 0.1),
            secondary: $0422a6ce4ea03acc$var$eP
        },
        success: {
            primary: $0422a6ce4ea03acc$var$kp,
            "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$kp, 0.05),
            "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$kp, 0.1),
            secondary: $0422a6ce4ea03acc$var$tP
        },
        test: "#FF6347",
        warning: {
            primary: $0422a6ce4ea03acc$var$Tp,
            "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Tp, 0.05),
            "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Tp, 0.1),
            secondary: $0422a6ce4ea03acc$var$nP,
            tertiary: $0422a6ce4ea03acc$var$rP
        },
        // Semantic colors
        bg: {
            default: $0422a6ce4ea03acc$var$NL,
            hover: $0422a6ce4ea03acc$var$o9,
            active: $0422a6ce4ea03acc$var$Ar
        },
        border: {
            default: $0422a6ce4ea03acc$var$Ar,
            hover: $0422a6ce4ea03acc$var$xp
        },
        typography: {
            heading: $0422a6ce4ea03acc$var$Iu,
            body: $0422a6ce4ea03acc$var$$u,
            inverse: {
                heading: $0422a6ce4ea03acc$var$o9,
                body: $0422a6ce4ea03acc$var$Ar
            }
        },
        // Grayscale
        gray: {
            "xxxx-dark": $0422a6ce4ea03acc$var$Iu,
            "xxx-dark": $0422a6ce4ea03acc$var$RL,
            "xx-dark": $0422a6ce4ea03acc$var$$u,
            "x-dark": $0422a6ce4ea03acc$var$Hp,
            dark: $0422a6ce4ea03acc$var$xp,
            "semi-dark": $0422a6ce4ea03acc$var$ZL,
            medium: $0422a6ce4ea03acc$var$Ar,
            "semi-medium": $0422a6ce4ea03acc$var$OL,
            "light-cool": $0422a6ce4ea03acc$var$o9,
            "x-light-cool": $0422a6ce4ea03acc$var$NL,
            "xx-light-cool": $0422a6ce4ea03acc$var$PL,
            // Gray Alts
            "light-warm": "#EFEDEB",
            "x-light-warm": "#F8F8F7"
        }
    },
    // dark mode fills
    dark: {
        brand: $0422a6ce4ea03acc$var$ra.dark,
        section: {
            blogs: $0422a6ce4ea03acc$var$jL.dark,
            "books-and-more": $0422a6ce4ea03acc$var$zL.dark,
            connect: $0422a6ce4ea03acc$var$UL.dark,
            education: $0422a6ce4ea03acc$var$IL.dark,
            locations: $0422a6ce4ea03acc$var$$L.dark,
            research: $0422a6ce4ea03acc$var$YL.dark,
            "research-library": $0422a6ce4ea03acc$var$WL.dark,
            "whats-on": $0422a6ce4ea03acc$var$QL.dark
        },
        ui: {
            // State and link utilities
            disabled: {
                primary: $0422a6ce4ea03acc$var$xp,
                secondary: $0422a6ce4ea03acc$var$Hp
            },
            error: {
                primary: $0422a6ce4ea03acc$var$_p,
                "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$_p, 0.05),
                "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$_p, 0.1),
                secondary: $0422a6ce4ea03acc$var$aP
            },
            focus: "#6090E3",
            link: {
                primary: $0422a6ce4ea03acc$var$Dp,
                "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Dp, 0.05),
                "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Dp, 0.1),
                secondary: $0422a6ce4ea03acc$var$iP,
                tertiary: $0422a6ce4ea03acc$var$oP
            },
            status: {
                primary: $0422a6ce4ea03acc$var$Rp,
                "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Rp, 0.05),
                "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Rp, 0.1),
                secondary: $0422a6ce4ea03acc$var$lP
            },
            success: {
                primary: $0422a6ce4ea03acc$var$Zp,
                "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Zp, 0.05),
                "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Zp, 0.1),
                secondary: $0422a6ce4ea03acc$var$sP
            },
            test: "#592B22",
            warning: {
                primary: $0422a6ce4ea03acc$var$Op,
                "primary-05": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Op, 0.05),
                "primary-10": $0422a6ce4ea03acc$var$P1($0422a6ce4ea03acc$var$Op, 0.1),
                secondary: $0422a6ce4ea03acc$var$uP
            },
            // Semantic colors
            bg: {
                page: $0422a6ce4ea03acc$var$Iu,
                default: $0422a6ce4ea03acc$var$RL,
                hover: $0422a6ce4ea03acc$var$$u,
                active: $0422a6ce4ea03acc$var$Hp
            },
            border: {
                default: $0422a6ce4ea03acc$var$ZL,
                hover: $0422a6ce4ea03acc$var$OL
            },
            typography: {
                heading: $0422a6ce4ea03acc$var$o9,
                body: $0422a6ce4ea03acc$var$Ar,
                inverse: {
                    heading: $0422a6ce4ea03acc$var$Iu,
                    body: $0422a6ce4ea03acc$var$$u
                }
            }
        }
    },
    /** Brand fills are the NYPL primary and secondary colors. */ brand: $0422a6ce4ea03acc$var$ra.light,
    /** Brand fills for sections on NYPL pages. */ section: {
        /** Blogs is used for the Blogs section. */ blogs: $0422a6ce4ea03acc$var$jL.light,
        /** Books and More is used for the Catalog, Staff Picks, Recommendations,
     * New Arrivals, and E-Book Central. */ "books-and-more": $0422a6ce4ea03acc$var$zL.light,
        /** Connect is used for the Connect and Get Help section fronts. */ connect: $0422a6ce4ea03acc$var$UL.light,
        /** Education is used for the Education section front and associated
     * sub-sections. */ education: $0422a6ce4ea03acc$var$IL.light,
        /** Locations is used for Location Finder and all branch pages with
     * the exceptions of some research libraries. */ locations: $0422a6ce4ea03acc$var$$L.light,
        /** Research is used for the Research Catalog and SCC. */ research: $0422a6ce4ea03acc$var$YL.light,
        /** Research libraries with specific brand colors to adhere to. */ "research-library": $0422a6ce4ea03acc$var$WL.light,
        /** What's On is used for Exhibitions & Events. */ "whats-on": $0422a6ce4ea03acc$var$QL.light
    },
    /**
   * The following color scales are useful for color edge cases where a
   * distinct named ui or brand color doesn't quite work. These are used by
   * Chakra and have been generated through https://themera.vercel.app/.
   * While these colors are available, WE DO NOT RECOMMEND using them. Stick
   * with the utility colors declared above.
   * @Note If you do need to use a color variant, please contant the DS team.
   */ /** based on ui.gray.medium = #DBDBDB */ gray: {
        50: "#F2F2F2",
        100: "#DBDBDB",
        200: "#C4C4C4",
        300: "#ADADAD",
        400: "#969696",
        500: "#808080",
        600: "#666666",
        700: "#4D4D4D",
        800: "#333333",
        900: "#1A1A1A"
    },
    /** based on ui.brand.primary = #C60917 */ red: {
        50: "#FEE7E8",
        100: "#FCBBC0",
        200: "#FA8F97",
        300: "#F8636E",
        400: "#F63745",
        500: "#F40B1C",
        600: "#C30917",
        700: "#920711",
        800: "#62040B",
        900: "#310206"
    },
    /** based on ui.warning.secondary = #F0974E */ orange: {
        50: "#FDF1E7",
        100: "#F9D8BD",
        200: "#F6BF93",
        300: "#F2A769",
        400: "#EF8E3E",
        500: "#EB7514",
        600: "#BC5E10",
        700: "#8D460C",
        800: "#5E2F08",
        900: "#2F1704"
    },
    /** based on ui.status.primary = #F9E08E */ yellow: {
        50: "#FEF8E7",
        100: "#FBECBB",
        200: "#F9E090",
        300: "#F7D464",
        400: "#F4C938",
        500: "#F2BD0D",
        600: "#C2970A",
        700: "#917108",
        800: "#614B05",
        900: "#302603"
    },
    /** based on ui.success.primary = #077719 */ green: {
        50: "#E7FEEB",
        100: "#BCFBC6",
        200: "#90F8A1",
        300: "#65F67C",
        400: "#3AF357",
        500: "#0EF133",
        600: "#0BC128",
        700: "#08911E",
        800: "#066014",
        900: "#03300A"
    },
    /** based on ui.link.primary = #0069BF */ blue: {
        50: "#E6F0F9",
        100: "#ACCEEA",
        200: "#73ADDC",
        300: "#398BCD",
        400: "#0069BF",
        500: "#0058A0",
        600: "#004782",
        700: "#003763",
        800: "#002645",
        900: "#73ADDC"
    }
}, $0422a6ce4ea03acc$var$CP = {
    button: {
        default: "2px",
        pill: "20px"
    },
    checkbox: "3px",
    headerDonate: ".25rem",
    pill: "20px",
    round: "100%"
}, $0422a6ce4ea03acc$var$fP = {
    outline: "none"
}, $0422a6ce4ea03acc$var$Q1 = {
    "-3": "0.625rem",
    "-2": "0.75rem",
    "-1": "0.875rem",
    0: "1rem",
    1: "1.125rem",
    2: "1.375rem",
    3: "1.75rem",
    4: "2.25rem",
    desktop: {
        display1: "4.25rem",
        // 68px
        heading1: "3.375rem",
        // 54px
        heading2: "2.625rem",
        // 42px
        heading3: "2rem",
        // 32px
        heading4: "1.625rem",
        // 26px
        heading5: "1.375rem",
        // 22px
        heading6: "1.25rem",
        // 20px
        subtitle1: "1.125rem",
        // 18px
        subtitle2: "1rem",
        // 16px
        overline1: "0.75rem",
        // 12px
        overline2: "0.625rem",
        // 10px
        label1: "0.875rem",
        // 14px
        label2: "0.75rem",
        // 12px
        buttonDefault: "0.875rem",
        // 14px
        buttonSmall: "0.75rem",
        // 12px
        buttonLarge: "1rem",
        // 26px
        body1: "1rem",
        // 16px
        body2: "0.875rem",
        // 14px
        caption: "0.75rem",
        // 12px
        default: "1rem"
    },
    mobile: {
        display1: "3.25rem",
        // 52px
        heading1: "2.625rem",
        // 42px
        heading2: "2.125rem",
        // 34px
        heading3: "1.75rem",
        // 28px
        heading4: "1.5rem",
        // 24px
        heading5: "1.25rem",
        // 20px
        heading6: "1.125rem",
        // 18px
        subtitle1: "1rem",
        // 16px
        subtitle2: "0.875rem",
        // 14px
        overline1: "0.75rem",
        // 12px
        overline2: "0.625rem",
        // 10px
        label1: "0.875rem",
        // 14px
        label2: "0.75rem",
        // 12px
        buttonDefault: "0.875rem",
        // 14px
        buttonSmall: "0.75rem",
        // 12px
        buttonLarge: "1rem",
        // 26px
        body1: "1rem",
        // 16px
        body2: "0.875rem",
        // 14px
        caption: "0.75rem",
        // 12px
        default: "1rem"
    }
}, $0422a6ce4ea03acc$var$l3 = {
    thin: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
}, $0422a6ce4ea03acc$var$pP = {
    fonts: {
        body: "system-ui, sans-serif",
        heading: "system-ui, sans-serif"
    },
    fontSizes: {
        // generic tokens
        "-3": $0422a6ce4ea03acc$var$Q1[-3],
        "-2": $0422a6ce4ea03acc$var$Q1[-2],
        "-1": $0422a6ce4ea03acc$var$Q1[-1],
        0: $0422a6ce4ea03acc$var$Q1[0],
        1: $0422a6ce4ea03acc$var$Q1[1],
        2: $0422a6ce4ea03acc$var$Q1[2],
        3: $0422a6ce4ea03acc$var$Q1[3],
        4: $0422a6ce4ea03acc$var$Q1[4],
        // semantic tokens - desktop and mobile
        desktop: {
            body: {
                body1: $0422a6ce4ea03acc$var$Q1.desktop.body1,
                body2: $0422a6ce4ea03acc$var$Q1.desktop.body2
            },
            breadcrumbs: {
                default: $0422a6ce4ea03acc$var$Q1.desktop.body2
            },
            button: {
                small: $0422a6ce4ea03acc$var$Q1.desktop.buttonSmall,
                default: $0422a6ce4ea03acc$var$Q1.desktop.buttonDefault,
                large: $0422a6ce4ea03acc$var$Q1.desktop.buttonLarge
            },
            caption: $0422a6ce4ea03acc$var$Q1.desktop.caption,
            default: $0422a6ce4ea03acc$var$Q1.desktop.default,
            heading: {
                display1: $0422a6ce4ea03acc$var$Q1.desktop.display1,
                heading1: $0422a6ce4ea03acc$var$Q1.desktop.heading1,
                heading2: $0422a6ce4ea03acc$var$Q1.desktop.heading2,
                heading3: $0422a6ce4ea03acc$var$Q1.desktop.heading3,
                heading4: $0422a6ce4ea03acc$var$Q1.desktop.heading4,
                heading5: $0422a6ce4ea03acc$var$Q1.desktop.heading5,
                heading6: $0422a6ce4ea03acc$var$Q1.desktop.heading6
            },
            helper: {
                default: $0422a6ce4ea03acc$var$Q1.desktop.caption
            },
            label: {
                label1: $0422a6ce4ea03acc$var$Q1.desktop.label1,
                label2: $0422a6ce4ea03acc$var$Q1.desktop.label2
            },
            overline: {
                overline1: $0422a6ce4ea03acc$var$Q1.desktop.overline1,
                overline2: $0422a6ce4ea03acc$var$Q1.desktop.overline2
            },
            subtitle: {
                subtitle1: $0422a6ce4ea03acc$var$Q1.desktop.subtitle1,
                subtitle2: $0422a6ce4ea03acc$var$Q1.desktop.subtitle2
            }
        },
        mobile: {
            body: {
                body1: $0422a6ce4ea03acc$var$Q1.mobile.body1,
                body2: $0422a6ce4ea03acc$var$Q1.mobile.body2
            },
            breadcrumbs: {
                default: $0422a6ce4ea03acc$var$Q1.mobile.body2
            },
            button: {
                small: $0422a6ce4ea03acc$var$Q1.mobile.buttonSmall,
                default: $0422a6ce4ea03acc$var$Q1.mobile.buttonDefault,
                large: $0422a6ce4ea03acc$var$Q1.mobile.buttonLarge
            },
            caption: $0422a6ce4ea03acc$var$Q1.mobile.caption,
            default: $0422a6ce4ea03acc$var$Q1.mobile.default,
            heading: {
                display1: $0422a6ce4ea03acc$var$Q1.mobile.display1,
                heading1: $0422a6ce4ea03acc$var$Q1.mobile.heading1,
                heading2: $0422a6ce4ea03acc$var$Q1.mobile.heading2,
                heading3: $0422a6ce4ea03acc$var$Q1.mobile.heading3,
                heading4: $0422a6ce4ea03acc$var$Q1.mobile.heading4,
                heading5: $0422a6ce4ea03acc$var$Q1.mobile.heading5,
                heading6: $0422a6ce4ea03acc$var$Q1.mobile.heading6
            },
            helper: {
                default: $0422a6ce4ea03acc$var$Q1.mobile.caption
            },
            label: {
                label1: $0422a6ce4ea03acc$var$Q1.mobile.label1,
                label2: $0422a6ce4ea03acc$var$Q1.mobile.label2
            },
            overline: {
                overline1: $0422a6ce4ea03acc$var$Q1.mobile.overline1,
                overline2: $0422a6ce4ea03acc$var$Q1.mobile.overline2
            },
            subtitle: {
                subtitle1: $0422a6ce4ea03acc$var$Q1.mobile.subtitle1,
                subtitle2: $0422a6ce4ea03acc$var$Q1.mobile.subtitle2
            }
        },
        // deprecated semantic tokens
        breadcrumbs: {
            // The deprecated value is "caption" but we should use body2 instead
            // for backwards compatibility
            default: $0422a6ce4ea03acc$var$Q1.desktop.body2
        },
        button: {
            small: {
                base: $0422a6ce4ea03acc$var$Q1.desktop.buttonSmall,
                md: $0422a6ce4ea03acc$var$Q1.mobile.buttonSmall
            },
            default: {
                base: $0422a6ce4ea03acc$var$Q1.desktop.buttonDefault,
                md: $0422a6ce4ea03acc$var$Q1.mobile.buttonDefault
            },
            large: {
                base: $0422a6ce4ea03acc$var$Q1.desktop.buttonLarge,
                md: $0422a6ce4ea03acc$var$Q1.mobile.buttonLarge
            }
        },
        heading: {
            primary: $0422a6ce4ea03acc$var$Q1[4],
            secondary: $0422a6ce4ea03acc$var$Q1[3],
            tertiary: $0422a6ce4ea03acc$var$Q1[2],
            callout: $0422a6ce4ea03acc$var$Q1[1]
        },
        helper: {
            default: $0422a6ce4ea03acc$var$Q1[-2]
        },
        label: {
            default: $0422a6ce4ea03acc$var$Q1[-1],
            secondary: $0422a6ce4ea03acc$var$Q1[-2]
        },
        text: {
            default: $0422a6ce4ea03acc$var$Q1[0],
            caption: $0422a6ce4ea03acc$var$Q1[-1],
            tag: $0422a6ce4ea03acc$var$Q1[-2],
            mini: $0422a6ce4ea03acc$var$Q1[-3]
        }
    },
    fontWeights: {
        // generic tokens
        light: $0422a6ce4ea03acc$var$l3.light,
        regular: $0422a6ce4ea03acc$var$l3.regular,
        medium: $0422a6ce4ea03acc$var$l3.medium,
        semibold: $0422a6ce4ea03acc$var$l3.semibold,
        bold: $0422a6ce4ea03acc$var$l3.bold,
        // semantic tokens
        body: {
            default: $0422a6ce4ea03acc$var$l3.light,
            body1: $0422a6ce4ea03acc$var$l3.light,
            body2: $0422a6ce4ea03acc$var$l3.light
        },
        breadcrumbs: {
            default: $0422a6ce4ea03acc$var$l3.regular,
            lastChild: $0422a6ce4ea03acc$var$l3.bold
        },
        button: {
            default: $0422a6ce4ea03acc$var$l3.regular
        },
        caption: $0422a6ce4ea03acc$var$l3.regular,
        default: $0422a6ce4ea03acc$var$l3.light,
        heading: {
            display1: $0422a6ce4ea03acc$var$l3.thin,
            heading1: $0422a6ce4ea03acc$var$l3.thin,
            heading2: $0422a6ce4ea03acc$var$l3.thin,
            heading3: $0422a6ce4ea03acc$var$l3.light,
            heading4: $0422a6ce4ea03acc$var$l3.regular,
            heading5: $0422a6ce4ea03acc$var$l3.medium,
            heading6: $0422a6ce4ea03acc$var$l3.medium,
            // deprecated tokens
            primary: $0422a6ce4ea03acc$var$l3.light,
            secondary: $0422a6ce4ea03acc$var$l3.medium,
            tertiary: $0422a6ce4ea03acc$var$l3.medium,
            callout: $0422a6ce4ea03acc$var$l3.medium
        },
        helper: {
            default: $0422a6ce4ea03acc$var$l3.light
        },
        label: {
            default: $0422a6ce4ea03acc$var$l3.medium,
            secondary: $0422a6ce4ea03acc$var$l3.regular
        },
        overline: {
            overline1: $0422a6ce4ea03acc$var$l3.semibold,
            overline2: $0422a6ce4ea03acc$var$l3.semibold
        },
        subtitle: {
            subtitle1: $0422a6ce4ea03acc$var$l3.regular,
            subtitle2: $0422a6ce4ea03acc$var$l3.regular
        },
        text: {
            default: $0422a6ce4ea03acc$var$l3.light,
            caption: $0422a6ce4ea03acc$var$l3.light,
            tag: $0422a6ce4ea03acc$var$l3.regular,
            mini: $0422a6ce4ea03acc$var$l3.regular
        }
    }
};
function $0422a6ce4ea03acc$var$gw(r) {
    const a = typeof r;
    return r != null && (a === "object" || a === "function") && !Array.isArray(r);
}
var $0422a6ce4ea03acc$var$hP = (r)=>/!(important)?$/.test(r), $0422a6ce4ea03acc$var$qL = (r)=>typeof r == "string" ? r.replace(/!(important)?$/, "").trim() : r, $0422a6ce4ea03acc$var$mP = (r, a)=>(o)=>{
        const s = String(a), i = $0422a6ce4ea03acc$var$hP(s), p = $0422a6ce4ea03acc$var$qL(s), C = r ? `${r}.${p}` : p;
        let v = $0422a6ce4ea03acc$var$gw(o.__cssMap) && C in o.__cssMap ? o.__cssMap[C].varRef : a;
        return v = $0422a6ce4ea03acc$var$qL(v), i ? `${v} !important` : v;
    };
function $0422a6ce4ea03acc$var$Fh(r) {
    const { scale: a, transform: o, compose: s } = r;
    return (p, C)=>{
        var v;
        const y = $0422a6ce4ea03acc$var$mP(a, p)(C);
        let L = (v = o == null ? void 0 : o(y, C)) != null ? v : y;
        return s && (L = s(L, C)), L;
    };
}
var $0422a6ce4ea03acc$var$Yu = (...r)=>(a)=>r.reduce((o, s)=>s(o), a);
function $0422a6ce4ea03acc$var$E6(r, a) {
    return (o)=>{
        const s = {
            property: o,
            scale: r
        };
        return s.transform = $0422a6ce4ea03acc$var$Fh({
            scale: r,
            transform: a
        }), s;
    };
}
var $0422a6ce4ea03acc$var$vP = ({ rtl: r, ltr: a })=>(o)=>o.direction === "rtl" ? r : a;
function $0422a6ce4ea03acc$var$gP(r) {
    const { property: a, scale: o, transform: s } = r;
    return {
        scale: o,
        property: $0422a6ce4ea03acc$var$vP(a),
        transform: o ? $0422a6ce4ea03acc$var$Fh({
            scale: o,
            compose: s
        }) : s
    };
}
var $0422a6ce4ea03acc$var$yw = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
];
function $0422a6ce4ea03acc$var$yP() {
    return [
        "translateX(var(--chakra-translate-x, 0))",
        "translateY(var(--chakra-translate-y, 0))",
        ...$0422a6ce4ea03acc$var$yw
    ].join(" ");
}
function $0422a6ce4ea03acc$var$LP() {
    return [
        "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
        ...$0422a6ce4ea03acc$var$yw
    ].join(" ");
}
var $0422a6ce4ea03acc$var$bP = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
        "var(--chakra-blur)",
        "var(--chakra-brightness)",
        "var(--chakra-contrast)",
        "var(--chakra-grayscale)",
        "var(--chakra-hue-rotate)",
        "var(--chakra-invert)",
        "var(--chakra-saturate)",
        "var(--chakra-sepia)",
        "var(--chakra-drop-shadow)"
    ].join(" ")
}, $0422a6ce4ea03acc$var$wP = {
    backdropFilter: [
        "var(--chakra-backdrop-blur)",
        "var(--chakra-backdrop-brightness)",
        "var(--chakra-backdrop-contrast)",
        "var(--chakra-backdrop-grayscale)",
        "var(--chakra-backdrop-hue-rotate)",
        "var(--chakra-backdrop-invert)",
        "var(--chakra-backdrop-opacity)",
        "var(--chakra-backdrop-saturate)",
        "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function $0422a6ce4ea03acc$var$HP(r) {
    return {
        "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
        "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
        "--chakra-ring-width": r,
        boxShadow: [
            "var(--chakra-ring-offset-shadow)",
            "var(--chakra-ring-shadow)",
            "var(--chakra-shadow, 0 0 #0000)"
        ].join(", ")
    };
}
var $0422a6ce4ea03acc$var$xP = {
    "row-reverse": {
        space: "--chakra-space-x-reverse",
        divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
        space: "--chakra-space-y-reverse",
        divide: "--chakra-divide-y-reverse"
    }
}, $0422a6ce4ea03acc$var$oh = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
}, $0422a6ce4ea03acc$var$VP = new Set(Object.values($0422a6ce4ea03acc$var$oh)), $0422a6ce4ea03acc$var$lh = /* @__PURE__ */ new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
]), $0422a6ce4ea03acc$var$MP = (r)=>r.trim();
function $0422a6ce4ea03acc$var$EP(r, a) {
    if (r == null || $0422a6ce4ea03acc$var$lh.has(r)) return r;
    if (!($0422a6ce4ea03acc$var$sh(r) || $0422a6ce4ea03acc$var$lh.has(r))) return `url('${r}')`;
    const i = /(^[a-z-A-Z]+)\((.*)\)/g.exec(r), p = i == null ? void 0 : i[1], C = i == null ? void 0 : i[2];
    if (!p || !C) return r;
    const v = p.includes("-gradient") ? p : `${p}-gradient`, [y, ...L] = C.split(",").map($0422a6ce4ea03acc$var$MP).filter(Boolean);
    if ((L == null ? void 0 : L.length) === 0) return r;
    const M = y in $0422a6ce4ea03acc$var$oh ? $0422a6ce4ea03acc$var$oh[y] : y;
    L.unshift(M);
    const E = L.map((k)=>{
        if ($0422a6ce4ea03acc$var$VP.has(k)) return k;
        const _ = k.indexOf(" "), [Z, O] = _ !== -1 ? [
            k.substr(0, _),
            k.substr(_ + 1)
        ] : [
            k
        ], B = $0422a6ce4ea03acc$var$sh(O) ? O : O && O.split(" "), z = `colors.${Z}`, I = z in a.__cssMap ? a.__cssMap[z].varRef : Z;
        return B ? [
            I,
            ...Array.isArray(B) ? B : [
                B
            ]
        ].join(" ") : I;
    });
    return `${v}(${E.join(", ")})`;
}
var $0422a6ce4ea03acc$var$sh = (r)=>typeof r == "string" && r.includes("(") && r.includes(")"), $0422a6ce4ea03acc$var$SP = (r, a)=>$0422a6ce4ea03acc$var$EP(r, a ?? {});
function $0422a6ce4ea03acc$var$kP(r) {
    return /^var\(--.+\)$/.test(r);
}
var $0422a6ce4ea03acc$var$TP = (r)=>{
    const a = parseFloat(r.toString()), o = r.toString().replace(String(a), "");
    return {
        unitless: !o,
        value: a,
        unit: o
    };
}, $0422a6ce4ea03acc$var$s8 = (r)=>(a)=>`${r}(${a})`, $0422a6ce4ea03acc$var$s3 = {
    filter (r) {
        return r !== "auto" ? r : $0422a6ce4ea03acc$var$bP;
    },
    backdropFilter (r) {
        return r !== "auto" ? r : $0422a6ce4ea03acc$var$wP;
    },
    ring (r) {
        return $0422a6ce4ea03acc$var$HP($0422a6ce4ea03acc$var$s3.px(r));
    },
    bgClip (r) {
        return r === "text" ? {
            color: "transparent",
            backgroundClip: "text"
        } : {
            backgroundClip: r
        };
    },
    transform (r) {
        return r === "auto" ? $0422a6ce4ea03acc$var$yP() : r === "auto-gpu" ? $0422a6ce4ea03acc$var$LP() : r;
    },
    vh (r) {
        return r === "$100vh" ? "var(--chakra-vh)" : r;
    },
    px (r) {
        if (r == null) return r;
        const { unitless: a } = $0422a6ce4ea03acc$var$TP(r);
        return a || typeof r == "number" ? `${r}px` : r;
    },
    fraction (r) {
        return typeof r != "number" || r > 1 ? r : `${r * 100}%`;
    },
    float (r, a) {
        const o = {
            left: "right",
            right: "left"
        };
        return a.direction === "rtl" ? o[r] : r;
    },
    degree (r) {
        if ($0422a6ce4ea03acc$var$kP(r) || r == null) return r;
        const a = typeof r == "string" && !r.endsWith("deg");
        return typeof r == "number" || a ? `${r}deg` : r;
    },
    gradient: $0422a6ce4ea03acc$var$SP,
    blur: $0422a6ce4ea03acc$var$s8("blur"),
    opacity: $0422a6ce4ea03acc$var$s8("opacity"),
    brightness: $0422a6ce4ea03acc$var$s8("brightness"),
    contrast: $0422a6ce4ea03acc$var$s8("contrast"),
    dropShadow: $0422a6ce4ea03acc$var$s8("drop-shadow"),
    grayscale: $0422a6ce4ea03acc$var$s8("grayscale"),
    hueRotate: (r)=>$0422a6ce4ea03acc$var$s8("hue-rotate")($0422a6ce4ea03acc$var$s3.degree(r)),
    invert: $0422a6ce4ea03acc$var$s8("invert"),
    saturate: $0422a6ce4ea03acc$var$s8("saturate"),
    sepia: $0422a6ce4ea03acc$var$s8("sepia"),
    bgImage (r) {
        return r == null || $0422a6ce4ea03acc$var$sh(r) || $0422a6ce4ea03acc$var$lh.has(r) ? r : `url(${r})`;
    },
    outline (r) {
        const a = String(r) === "0" || String(r) === "none";
        return r !== null && a ? {
            outline: "2px solid transparent",
            outlineOffset: "2px"
        } : {
            outline: r
        };
    },
    flexDirection (r) {
        var a;
        const { space: o, divide: s } = (a = $0422a6ce4ea03acc$var$xP[r]) != null ? a : {}, i = {
            flexDirection: r
        };
        return o && (i[o] = 1), s && (i[s] = 1), i;
    }
}, $0422a6ce4ea03acc$var$K = {
    borderWidths: $0422a6ce4ea03acc$var$E6("borderWidths"),
    borderStyles: $0422a6ce4ea03acc$var$E6("borderStyles"),
    colors: $0422a6ce4ea03acc$var$E6("colors"),
    borders: $0422a6ce4ea03acc$var$E6("borders"),
    gradients: $0422a6ce4ea03acc$var$E6("gradients", $0422a6ce4ea03acc$var$s3.gradient),
    radii: $0422a6ce4ea03acc$var$E6("radii", $0422a6ce4ea03acc$var$s3.px),
    space: $0422a6ce4ea03acc$var$E6("space", $0422a6ce4ea03acc$var$Yu($0422a6ce4ea03acc$var$s3.vh, $0422a6ce4ea03acc$var$s3.px)),
    spaceT: $0422a6ce4ea03acc$var$E6("space", $0422a6ce4ea03acc$var$Yu($0422a6ce4ea03acc$var$s3.vh, $0422a6ce4ea03acc$var$s3.px)),
    degreeT (r) {
        return {
            property: r,
            transform: $0422a6ce4ea03acc$var$s3.degree
        };
    },
    prop (r, a, o) {
        return {
            property: r,
            scale: a,
            ...a && {
                transform: $0422a6ce4ea03acc$var$Fh({
                    scale: a,
                    transform: o
                })
            }
        };
    },
    propT (r, a) {
        return {
            property: r,
            transform: a
        };
    },
    sizes: $0422a6ce4ea03acc$var$E6("sizes", $0422a6ce4ea03acc$var$Yu($0422a6ce4ea03acc$var$s3.vh, $0422a6ce4ea03acc$var$s3.px)),
    sizesT: $0422a6ce4ea03acc$var$E6("sizes", $0422a6ce4ea03acc$var$Yu($0422a6ce4ea03acc$var$s3.vh, $0422a6ce4ea03acc$var$s3.fraction)),
    shadows: $0422a6ce4ea03acc$var$E6("shadows"),
    logical: $0422a6ce4ea03acc$var$gP,
    blur: $0422a6ce4ea03acc$var$E6("blur", $0422a6ce4ea03acc$var$s3.blur)
}, $0422a6ce4ea03acc$var$Xu = {
    background: $0422a6ce4ea03acc$var$K.colors("background"),
    backgroundColor: $0422a6ce4ea03acc$var$K.colors("backgroundColor"),
    backgroundImage: $0422a6ce4ea03acc$var$K.gradients("backgroundImage"),
    backgroundSize: !0,
    backgroundPosition: !0,
    backgroundRepeat: !0,
    backgroundAttachment: !0,
    backgroundClip: {
        transform: $0422a6ce4ea03acc$var$s3.bgClip
    },
    bgSize: $0422a6ce4ea03acc$var$K.prop("backgroundSize"),
    bgPosition: $0422a6ce4ea03acc$var$K.prop("backgroundPosition"),
    bg: $0422a6ce4ea03acc$var$K.colors("background"),
    bgColor: $0422a6ce4ea03acc$var$K.colors("backgroundColor"),
    bgPos: $0422a6ce4ea03acc$var$K.prop("backgroundPosition"),
    bgRepeat: $0422a6ce4ea03acc$var$K.prop("backgroundRepeat"),
    bgAttachment: $0422a6ce4ea03acc$var$K.prop("backgroundAttachment"),
    bgGradient: $0422a6ce4ea03acc$var$K.gradients("backgroundImage"),
    bgClip: {
        transform: $0422a6ce4ea03acc$var$s3.bgClip
    }
};
Object.assign($0422a6ce4ea03acc$var$Xu, {
    bgImage: $0422a6ce4ea03acc$var$Xu.backgroundImage,
    bgImg: $0422a6ce4ea03acc$var$Xu.backgroundImage
});
var $0422a6ce4ea03acc$var$M3 = {
    border: $0422a6ce4ea03acc$var$K.borders("border"),
    borderWidth: $0422a6ce4ea03acc$var$K.borderWidths("borderWidth"),
    borderStyle: $0422a6ce4ea03acc$var$K.borderStyles("borderStyle"),
    borderColor: $0422a6ce4ea03acc$var$K.colors("borderColor"),
    borderRadius: $0422a6ce4ea03acc$var$K.radii("borderRadius"),
    borderTop: $0422a6ce4ea03acc$var$K.borders("borderTop"),
    borderBlockStart: $0422a6ce4ea03acc$var$K.borders("borderBlockStart"),
    borderTopLeftRadius: $0422a6ce4ea03acc$var$K.radii("borderTopLeftRadius"),
    borderStartStartRadius: $0422a6ce4ea03acc$var$K.logical({
        scale: "radii",
        property: {
            ltr: "borderTopLeftRadius",
            rtl: "borderTopRightRadius"
        }
    }),
    borderEndStartRadius: $0422a6ce4ea03acc$var$K.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomLeftRadius",
            rtl: "borderBottomRightRadius"
        }
    }),
    borderTopRightRadius: $0422a6ce4ea03acc$var$K.radii("borderTopRightRadius"),
    borderStartEndRadius: $0422a6ce4ea03acc$var$K.logical({
        scale: "radii",
        property: {
            ltr: "borderTopRightRadius",
            rtl: "borderTopLeftRadius"
        }
    }),
    borderEndEndRadius: $0422a6ce4ea03acc$var$K.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomRightRadius",
            rtl: "borderBottomLeftRadius"
        }
    }),
    borderRight: $0422a6ce4ea03acc$var$K.borders("borderRight"),
    borderInlineEnd: $0422a6ce4ea03acc$var$K.borders("borderInlineEnd"),
    borderBottom: $0422a6ce4ea03acc$var$K.borders("borderBottom"),
    borderBlockEnd: $0422a6ce4ea03acc$var$K.borders("borderBlockEnd"),
    borderBottomLeftRadius: $0422a6ce4ea03acc$var$K.radii("borderBottomLeftRadius"),
    borderBottomRightRadius: $0422a6ce4ea03acc$var$K.radii("borderBottomRightRadius"),
    borderLeft: $0422a6ce4ea03acc$var$K.borders("borderLeft"),
    borderInlineStart: {
        property: "borderInlineStart",
        scale: "borders"
    },
    borderInlineStartRadius: $0422a6ce4ea03acc$var$K.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ],
            rtl: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ]
        }
    }),
    borderInlineEndRadius: $0422a6ce4ea03acc$var$K.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ],
            rtl: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ]
        }
    }),
    borderX: $0422a6ce4ea03acc$var$K.borders([
        "borderLeft",
        "borderRight"
    ]),
    borderInline: $0422a6ce4ea03acc$var$K.borders("borderInline"),
    borderY: $0422a6ce4ea03acc$var$K.borders([
        "borderTop",
        "borderBottom"
    ]),
    borderBlock: $0422a6ce4ea03acc$var$K.borders("borderBlock"),
    borderTopWidth: $0422a6ce4ea03acc$var$K.borderWidths("borderTopWidth"),
    borderBlockStartWidth: $0422a6ce4ea03acc$var$K.borderWidths("borderBlockStartWidth"),
    borderTopColor: $0422a6ce4ea03acc$var$K.colors("borderTopColor"),
    borderBlockStartColor: $0422a6ce4ea03acc$var$K.colors("borderBlockStartColor"),
    borderTopStyle: $0422a6ce4ea03acc$var$K.borderStyles("borderTopStyle"),
    borderBlockStartStyle: $0422a6ce4ea03acc$var$K.borderStyles("borderBlockStartStyle"),
    borderBottomWidth: $0422a6ce4ea03acc$var$K.borderWidths("borderBottomWidth"),
    borderBlockEndWidth: $0422a6ce4ea03acc$var$K.borderWidths("borderBlockEndWidth"),
    borderBottomColor: $0422a6ce4ea03acc$var$K.colors("borderBottomColor"),
    borderBlockEndColor: $0422a6ce4ea03acc$var$K.colors("borderBlockEndColor"),
    borderBottomStyle: $0422a6ce4ea03acc$var$K.borderStyles("borderBottomStyle"),
    borderBlockEndStyle: $0422a6ce4ea03acc$var$K.borderStyles("borderBlockEndStyle"),
    borderLeftWidth: $0422a6ce4ea03acc$var$K.borderWidths("borderLeftWidth"),
    borderInlineStartWidth: $0422a6ce4ea03acc$var$K.borderWidths("borderInlineStartWidth"),
    borderLeftColor: $0422a6ce4ea03acc$var$K.colors("borderLeftColor"),
    borderInlineStartColor: $0422a6ce4ea03acc$var$K.colors("borderInlineStartColor"),
    borderLeftStyle: $0422a6ce4ea03acc$var$K.borderStyles("borderLeftStyle"),
    borderInlineStartStyle: $0422a6ce4ea03acc$var$K.borderStyles("borderInlineStartStyle"),
    borderRightWidth: $0422a6ce4ea03acc$var$K.borderWidths("borderRightWidth"),
    borderInlineEndWidth: $0422a6ce4ea03acc$var$K.borderWidths("borderInlineEndWidth"),
    borderRightColor: $0422a6ce4ea03acc$var$K.colors("borderRightColor"),
    borderInlineEndColor: $0422a6ce4ea03acc$var$K.colors("borderInlineEndColor"),
    borderRightStyle: $0422a6ce4ea03acc$var$K.borderStyles("borderRightStyle"),
    borderInlineEndStyle: $0422a6ce4ea03acc$var$K.borderStyles("borderInlineEndStyle"),
    borderTopRadius: $0422a6ce4ea03acc$var$K.radii([
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ]),
    borderBottomRadius: $0422a6ce4ea03acc$var$K.radii([
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ]),
    borderLeftRadius: $0422a6ce4ea03acc$var$K.radii([
        "borderTopLeftRadius",
        "borderBottomLeftRadius"
    ]),
    borderRightRadius: $0422a6ce4ea03acc$var$K.radii([
        "borderTopRightRadius",
        "borderBottomRightRadius"
    ])
};
Object.assign($0422a6ce4ea03acc$var$M3, {
    rounded: $0422a6ce4ea03acc$var$M3.borderRadius,
    roundedTop: $0422a6ce4ea03acc$var$M3.borderTopRadius,
    roundedTopLeft: $0422a6ce4ea03acc$var$M3.borderTopLeftRadius,
    roundedTopRight: $0422a6ce4ea03acc$var$M3.borderTopRightRadius,
    roundedTopStart: $0422a6ce4ea03acc$var$M3.borderStartStartRadius,
    roundedTopEnd: $0422a6ce4ea03acc$var$M3.borderStartEndRadius,
    roundedBottom: $0422a6ce4ea03acc$var$M3.borderBottomRadius,
    roundedBottomLeft: $0422a6ce4ea03acc$var$M3.borderBottomLeftRadius,
    roundedBottomRight: $0422a6ce4ea03acc$var$M3.borderBottomRightRadius,
    roundedBottomStart: $0422a6ce4ea03acc$var$M3.borderEndStartRadius,
    roundedBottomEnd: $0422a6ce4ea03acc$var$M3.borderEndEndRadius,
    roundedLeft: $0422a6ce4ea03acc$var$M3.borderLeftRadius,
    roundedRight: $0422a6ce4ea03acc$var$M3.borderRightRadius,
    roundedStart: $0422a6ce4ea03acc$var$M3.borderInlineStartRadius,
    roundedEnd: $0422a6ce4ea03acc$var$M3.borderInlineEndRadius,
    borderStart: $0422a6ce4ea03acc$var$M3.borderInlineStart,
    borderEnd: $0422a6ce4ea03acc$var$M3.borderInlineEnd,
    borderTopStartRadius: $0422a6ce4ea03acc$var$M3.borderStartStartRadius,
    borderTopEndRadius: $0422a6ce4ea03acc$var$M3.borderStartEndRadius,
    borderBottomStartRadius: $0422a6ce4ea03acc$var$M3.borderEndStartRadius,
    borderBottomEndRadius: $0422a6ce4ea03acc$var$M3.borderEndEndRadius,
    borderStartRadius: $0422a6ce4ea03acc$var$M3.borderInlineStartRadius,
    borderEndRadius: $0422a6ce4ea03acc$var$M3.borderInlineEndRadius,
    borderStartWidth: $0422a6ce4ea03acc$var$M3.borderInlineStartWidth,
    borderEndWidth: $0422a6ce4ea03acc$var$M3.borderInlineEndWidth,
    borderStartColor: $0422a6ce4ea03acc$var$M3.borderInlineStartColor,
    borderEndColor: $0422a6ce4ea03acc$var$M3.borderInlineEndColor,
    borderStartStyle: $0422a6ce4ea03acc$var$M3.borderInlineStartStyle,
    borderEndStyle: $0422a6ce4ea03acc$var$M3.borderInlineEndStyle
});
var $0422a6ce4ea03acc$var$_P = {
    color: $0422a6ce4ea03acc$var$K.colors("color"),
    textColor: $0422a6ce4ea03acc$var$K.colors("color"),
    fill: $0422a6ce4ea03acc$var$K.colors("fill"),
    stroke: $0422a6ce4ea03acc$var$K.colors("stroke")
}, $0422a6ce4ea03acc$var$uh = {
    boxShadow: $0422a6ce4ea03acc$var$K.shadows("boxShadow"),
    mixBlendMode: !0,
    blendMode: $0422a6ce4ea03acc$var$K.prop("mixBlendMode"),
    backgroundBlendMode: !0,
    bgBlendMode: $0422a6ce4ea03acc$var$K.prop("backgroundBlendMode"),
    opacity: !0
};
Object.assign($0422a6ce4ea03acc$var$uh, {
    shadow: $0422a6ce4ea03acc$var$uh.boxShadow
});
var $0422a6ce4ea03acc$var$DP = {
    filter: {
        transform: $0422a6ce4ea03acc$var$s3.filter
    },
    blur: $0422a6ce4ea03acc$var$K.blur("--chakra-blur"),
    brightness: $0422a6ce4ea03acc$var$K.propT("--chakra-brightness", $0422a6ce4ea03acc$var$s3.brightness),
    contrast: $0422a6ce4ea03acc$var$K.propT("--chakra-contrast", $0422a6ce4ea03acc$var$s3.contrast),
    hueRotate: $0422a6ce4ea03acc$var$K.propT("--chakra-hue-rotate", $0422a6ce4ea03acc$var$s3.hueRotate),
    invert: $0422a6ce4ea03acc$var$K.propT("--chakra-invert", $0422a6ce4ea03acc$var$s3.invert),
    saturate: $0422a6ce4ea03acc$var$K.propT("--chakra-saturate", $0422a6ce4ea03acc$var$s3.saturate),
    dropShadow: $0422a6ce4ea03acc$var$K.propT("--chakra-drop-shadow", $0422a6ce4ea03acc$var$s3.dropShadow),
    backdropFilter: {
        transform: $0422a6ce4ea03acc$var$s3.backdropFilter
    },
    backdropBlur: $0422a6ce4ea03acc$var$K.blur("--chakra-backdrop-blur"),
    backdropBrightness: $0422a6ce4ea03acc$var$K.propT("--chakra-backdrop-brightness", $0422a6ce4ea03acc$var$s3.brightness),
    backdropContrast: $0422a6ce4ea03acc$var$K.propT("--chakra-backdrop-contrast", $0422a6ce4ea03acc$var$s3.contrast),
    backdropHueRotate: $0422a6ce4ea03acc$var$K.propT("--chakra-backdrop-hue-rotate", $0422a6ce4ea03acc$var$s3.hueRotate),
    backdropInvert: $0422a6ce4ea03acc$var$K.propT("--chakra-backdrop-invert", $0422a6ce4ea03acc$var$s3.invert),
    backdropSaturate: $0422a6ce4ea03acc$var$K.propT("--chakra-backdrop-saturate", $0422a6ce4ea03acc$var$s3.saturate)
}, $0422a6ce4ea03acc$var$hc = {
    alignItems: !0,
    alignContent: !0,
    justifyItems: !0,
    justifyContent: !0,
    flexWrap: !0,
    flexDirection: {
        transform: $0422a6ce4ea03acc$var$s3.flexDirection
    },
    flex: !0,
    flexFlow: !0,
    flexGrow: !0,
    flexShrink: !0,
    flexBasis: $0422a6ce4ea03acc$var$K.sizes("flexBasis"),
    justifySelf: !0,
    alignSelf: !0,
    order: !0,
    placeItems: !0,
    placeContent: !0,
    placeSelf: !0,
    gap: $0422a6ce4ea03acc$var$K.space("gap"),
    rowGap: $0422a6ce4ea03acc$var$K.space("rowGap"),
    columnGap: $0422a6ce4ea03acc$var$K.space("columnGap")
};
Object.assign($0422a6ce4ea03acc$var$hc, {
    flexDir: $0422a6ce4ea03acc$var$hc.flexDirection
});
var $0422a6ce4ea03acc$var$Lw = {
    gridGap: $0422a6ce4ea03acc$var$K.space("gridGap"),
    gridColumnGap: $0422a6ce4ea03acc$var$K.space("gridColumnGap"),
    gridRowGap: $0422a6ce4ea03acc$var$K.space("gridRowGap"),
    gridColumn: !0,
    gridRow: !0,
    gridAutoFlow: !0,
    gridAutoColumns: !0,
    gridColumnStart: !0,
    gridColumnEnd: !0,
    gridRowStart: !0,
    gridRowEnd: !0,
    gridAutoRows: !0,
    gridTemplate: !0,
    gridTemplateColumns: !0,
    gridTemplateRows: !0,
    gridTemplateAreas: !0,
    gridArea: !0
}, $0422a6ce4ea03acc$var$RP = {
    appearance: !0,
    cursor: !0,
    resize: !0,
    userSelect: !0,
    pointerEvents: !0,
    outline: {
        transform: $0422a6ce4ea03acc$var$s3.outline
    },
    outlineOffset: !0,
    outlineColor: $0422a6ce4ea03acc$var$K.colors("outlineColor")
}, $0422a6ce4ea03acc$var$S6 = {
    width: $0422a6ce4ea03acc$var$K.sizesT("width"),
    inlineSize: $0422a6ce4ea03acc$var$K.sizesT("inlineSize"),
    height: $0422a6ce4ea03acc$var$K.sizes("height"),
    blockSize: $0422a6ce4ea03acc$var$K.sizes("blockSize"),
    boxSize: $0422a6ce4ea03acc$var$K.sizes([
        "width",
        "height"
    ]),
    minWidth: $0422a6ce4ea03acc$var$K.sizes("minWidth"),
    minInlineSize: $0422a6ce4ea03acc$var$K.sizes("minInlineSize"),
    minHeight: $0422a6ce4ea03acc$var$K.sizes("minHeight"),
    minBlockSize: $0422a6ce4ea03acc$var$K.sizes("minBlockSize"),
    maxWidth: $0422a6ce4ea03acc$var$K.sizes("maxWidth"),
    maxInlineSize: $0422a6ce4ea03acc$var$K.sizes("maxInlineSize"),
    maxHeight: $0422a6ce4ea03acc$var$K.sizes("maxHeight"),
    maxBlockSize: $0422a6ce4ea03acc$var$K.sizes("maxBlockSize"),
    overflow: !0,
    overflowX: !0,
    overflowY: !0,
    overscrollBehavior: !0,
    overscrollBehaviorX: !0,
    overscrollBehaviorY: !0,
    display: !0,
    aspectRatio: !0,
    hideFrom: {
        scale: "breakpoints",
        transform: (r, a)=>{
            var o, s, i;
            return {
                [`@media screen and (min-width: ${(i = (s = (o = a.__breakpoints) == null ? void 0 : o.get(r)) == null ? void 0 : s.minW) != null ? i : r})`]: {
                    display: "none"
                }
            };
        }
    },
    hideBelow: {
        scale: "breakpoints",
        transform: (r, a)=>{
            var o, s, i;
            return {
                [`@media screen and (max-width: ${(i = (s = (o = a.__breakpoints) == null ? void 0 : o.get(r)) == null ? void 0 : s._minW) != null ? i : r})`]: {
                    display: "none"
                }
            };
        }
    },
    verticalAlign: !0,
    boxSizing: !0,
    boxDecorationBreak: !0,
    float: $0422a6ce4ea03acc$var$K.propT("float", $0422a6ce4ea03acc$var$s3.float),
    objectFit: !0,
    objectPosition: !0,
    visibility: !0,
    isolation: !0
};
Object.assign($0422a6ce4ea03acc$var$S6, {
    w: $0422a6ce4ea03acc$var$S6.width,
    h: $0422a6ce4ea03acc$var$S6.height,
    minW: $0422a6ce4ea03acc$var$S6.minWidth,
    maxW: $0422a6ce4ea03acc$var$S6.maxWidth,
    minH: $0422a6ce4ea03acc$var$S6.minHeight,
    maxH: $0422a6ce4ea03acc$var$S6.maxHeight,
    overscroll: $0422a6ce4ea03acc$var$S6.overscrollBehavior,
    overscrollX: $0422a6ce4ea03acc$var$S6.overscrollBehaviorX,
    overscrollY: $0422a6ce4ea03acc$var$S6.overscrollBehaviorY
});
var $0422a6ce4ea03acc$var$ZP = {
    listStyleType: !0,
    listStylePosition: !0,
    listStylePos: $0422a6ce4ea03acc$var$K.prop("listStylePosition"),
    listStyleImage: !0,
    listStyleImg: $0422a6ce4ea03acc$var$K.prop("listStyleImage")
};
function $0422a6ce4ea03acc$var$OP(r, a, o, s) {
    const i = typeof a == "string" ? a.split(".") : [
        a
    ];
    for(s = 0; s < i.length && r; s += 1)r = r[i[s]];
    return r === void 0 ? o : r;
}
var $0422a6ce4ea03acc$var$NP = (r)=>{
    const a = /* @__PURE__ */ new WeakMap();
    return (s, i, p, C)=>{
        if (typeof s > "u") return r(s, i, p);
        a.has(s) || a.set(s, /* @__PURE__ */ new Map());
        const v = a.get(s);
        if (v.has(i)) return v.get(i);
        const y = r(s, i, p, C);
        return v.set(i, y), y;
    };
}, $0422a6ce4ea03acc$var$PP = $0422a6ce4ea03acc$var$NP($0422a6ce4ea03acc$var$OP), $0422a6ce4ea03acc$var$BP = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
}, $0422a6ce4ea03acc$var$FP = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
}, $0422a6ce4ea03acc$var$Pp = (r, a, o)=>{
    const s = {}, i = $0422a6ce4ea03acc$var$PP(r, a, {});
    for(const p in i)p in o && o[p] != null || (s[p] = i[p]);
    return s;
}, $0422a6ce4ea03acc$var$AP = {
    srOnly: {
        transform (r) {
            return r === !0 ? $0422a6ce4ea03acc$var$BP : r === "focusable" ? $0422a6ce4ea03acc$var$FP : {};
        }
    },
    layerStyle: {
        processResult: !0,
        transform: (r, a, o)=>$0422a6ce4ea03acc$var$Pp(a, `layerStyles.${r}`, o)
    },
    textStyle: {
        processResult: !0,
        transform: (r, a, o)=>$0422a6ce4ea03acc$var$Pp(a, `textStyles.${r}`, o)
    },
    apply: {
        processResult: !0,
        transform: (r, a, o)=>$0422a6ce4ea03acc$var$Pp(a, r, o)
    }
}, $0422a6ce4ea03acc$var$Do = {
    position: !0,
    pos: $0422a6ce4ea03acc$var$K.prop("position"),
    zIndex: $0422a6ce4ea03acc$var$K.prop("zIndex", "zIndices"),
    inset: $0422a6ce4ea03acc$var$K.spaceT("inset"),
    insetX: $0422a6ce4ea03acc$var$K.spaceT([
        "left",
        "right"
    ]),
    insetInline: $0422a6ce4ea03acc$var$K.spaceT("insetInline"),
    insetY: $0422a6ce4ea03acc$var$K.spaceT([
        "top",
        "bottom"
    ]),
    insetBlock: $0422a6ce4ea03acc$var$K.spaceT("insetBlock"),
    top: $0422a6ce4ea03acc$var$K.spaceT("top"),
    insetBlockStart: $0422a6ce4ea03acc$var$K.spaceT("insetBlockStart"),
    bottom: $0422a6ce4ea03acc$var$K.spaceT("bottom"),
    insetBlockEnd: $0422a6ce4ea03acc$var$K.spaceT("insetBlockEnd"),
    left: $0422a6ce4ea03acc$var$K.spaceT("left"),
    insetInlineStart: $0422a6ce4ea03acc$var$K.logical({
        scale: "space",
        property: {
            ltr: "left",
            rtl: "right"
        }
    }),
    right: $0422a6ce4ea03acc$var$K.spaceT("right"),
    insetInlineEnd: $0422a6ce4ea03acc$var$K.logical({
        scale: "space",
        property: {
            ltr: "right",
            rtl: "left"
        }
    })
};
Object.assign($0422a6ce4ea03acc$var$Do, {
    insetStart: $0422a6ce4ea03acc$var$Do.insetInlineStart,
    insetEnd: $0422a6ce4ea03acc$var$Do.insetInlineEnd
});
var $0422a6ce4ea03acc$var$jP = {
    ring: {
        transform: $0422a6ce4ea03acc$var$s3.ring
    },
    ringColor: $0422a6ce4ea03acc$var$K.colors("--chakra-ring-color"),
    ringOffset: $0422a6ce4ea03acc$var$K.prop("--chakra-ring-offset-width"),
    ringOffsetColor: $0422a6ce4ea03acc$var$K.colors("--chakra-ring-offset-color"),
    ringInset: $0422a6ce4ea03acc$var$K.prop("--chakra-ring-inset")
}, $0422a6ce4ea03acc$var$le = {
    margin: $0422a6ce4ea03acc$var$K.spaceT("margin"),
    marginTop: $0422a6ce4ea03acc$var$K.spaceT("marginTop"),
    marginBlockStart: $0422a6ce4ea03acc$var$K.spaceT("marginBlockStart"),
    marginRight: $0422a6ce4ea03acc$var$K.spaceT("marginRight"),
    marginInlineEnd: $0422a6ce4ea03acc$var$K.spaceT("marginInlineEnd"),
    marginBottom: $0422a6ce4ea03acc$var$K.spaceT("marginBottom"),
    marginBlockEnd: $0422a6ce4ea03acc$var$K.spaceT("marginBlockEnd"),
    marginLeft: $0422a6ce4ea03acc$var$K.spaceT("marginLeft"),
    marginInlineStart: $0422a6ce4ea03acc$var$K.spaceT("marginInlineStart"),
    marginX: $0422a6ce4ea03acc$var$K.spaceT([
        "marginInlineStart",
        "marginInlineEnd"
    ]),
    marginInline: $0422a6ce4ea03acc$var$K.spaceT("marginInline"),
    marginY: $0422a6ce4ea03acc$var$K.spaceT([
        "marginTop",
        "marginBottom"
    ]),
    marginBlock: $0422a6ce4ea03acc$var$K.spaceT("marginBlock"),
    padding: $0422a6ce4ea03acc$var$K.space("padding"),
    paddingTop: $0422a6ce4ea03acc$var$K.space("paddingTop"),
    paddingBlockStart: $0422a6ce4ea03acc$var$K.space("paddingBlockStart"),
    paddingRight: $0422a6ce4ea03acc$var$K.space("paddingRight"),
    paddingBottom: $0422a6ce4ea03acc$var$K.space("paddingBottom"),
    paddingBlockEnd: $0422a6ce4ea03acc$var$K.space("paddingBlockEnd"),
    paddingLeft: $0422a6ce4ea03acc$var$K.space("paddingLeft"),
    paddingInlineStart: $0422a6ce4ea03acc$var$K.space("paddingInlineStart"),
    paddingInlineEnd: $0422a6ce4ea03acc$var$K.space("paddingInlineEnd"),
    paddingX: $0422a6ce4ea03acc$var$K.space([
        "paddingInlineStart",
        "paddingInlineEnd"
    ]),
    paddingInline: $0422a6ce4ea03acc$var$K.space("paddingInline"),
    paddingY: $0422a6ce4ea03acc$var$K.space([
        "paddingTop",
        "paddingBottom"
    ]),
    paddingBlock: $0422a6ce4ea03acc$var$K.space("paddingBlock")
};
Object.assign($0422a6ce4ea03acc$var$le, {
    m: $0422a6ce4ea03acc$var$le.margin,
    mt: $0422a6ce4ea03acc$var$le.marginTop,
    mr: $0422a6ce4ea03acc$var$le.marginRight,
    me: $0422a6ce4ea03acc$var$le.marginInlineEnd,
    marginEnd: $0422a6ce4ea03acc$var$le.marginInlineEnd,
    mb: $0422a6ce4ea03acc$var$le.marginBottom,
    ml: $0422a6ce4ea03acc$var$le.marginLeft,
    ms: $0422a6ce4ea03acc$var$le.marginInlineStart,
    marginStart: $0422a6ce4ea03acc$var$le.marginInlineStart,
    mx: $0422a6ce4ea03acc$var$le.marginX,
    my: $0422a6ce4ea03acc$var$le.marginY,
    p: $0422a6ce4ea03acc$var$le.padding,
    pt: $0422a6ce4ea03acc$var$le.paddingTop,
    py: $0422a6ce4ea03acc$var$le.paddingY,
    px: $0422a6ce4ea03acc$var$le.paddingX,
    pb: $0422a6ce4ea03acc$var$le.paddingBottom,
    pl: $0422a6ce4ea03acc$var$le.paddingLeft,
    ps: $0422a6ce4ea03acc$var$le.paddingInlineStart,
    paddingStart: $0422a6ce4ea03acc$var$le.paddingInlineStart,
    pr: $0422a6ce4ea03acc$var$le.paddingRight,
    pe: $0422a6ce4ea03acc$var$le.paddingInlineEnd,
    paddingEnd: $0422a6ce4ea03acc$var$le.paddingInlineEnd
});
var $0422a6ce4ea03acc$var$zP = {
    textDecorationColor: $0422a6ce4ea03acc$var$K.colors("textDecorationColor"),
    textDecoration: !0,
    textDecor: {
        property: "textDecoration"
    },
    textDecorationLine: !0,
    textDecorationStyle: !0,
    textDecorationThickness: !0,
    textUnderlineOffset: !0,
    textShadow: $0422a6ce4ea03acc$var$K.shadows("textShadow")
}, $0422a6ce4ea03acc$var$UP = {
    clipPath: !0,
    transform: $0422a6ce4ea03acc$var$K.propT("transform", $0422a6ce4ea03acc$var$s3.transform),
    transformOrigin: !0,
    translateX: $0422a6ce4ea03acc$var$K.spaceT("--chakra-translate-x"),
    translateY: $0422a6ce4ea03acc$var$K.spaceT("--chakra-translate-y"),
    skewX: $0422a6ce4ea03acc$var$K.degreeT("--chakra-skew-x"),
    skewY: $0422a6ce4ea03acc$var$K.degreeT("--chakra-skew-y"),
    scaleX: $0422a6ce4ea03acc$var$K.prop("--chakra-scale-x"),
    scaleY: $0422a6ce4ea03acc$var$K.prop("--chakra-scale-y"),
    scale: $0422a6ce4ea03acc$var$K.prop([
        "--chakra-scale-x",
        "--chakra-scale-y"
    ]),
    rotate: $0422a6ce4ea03acc$var$K.degreeT("--chakra-rotate")
}, $0422a6ce4ea03acc$var$IP = {
    transition: !0,
    transitionDelay: !0,
    animation: !0,
    willChange: !0,
    transitionDuration: $0422a6ce4ea03acc$var$K.prop("transitionDuration", "transition.duration"),
    transitionProperty: $0422a6ce4ea03acc$var$K.prop("transitionProperty", "transition.property"),
    transitionTimingFunction: $0422a6ce4ea03acc$var$K.prop("transitionTimingFunction", "transition.easing")
}, $0422a6ce4ea03acc$var$$P = {
    fontFamily: $0422a6ce4ea03acc$var$K.prop("fontFamily", "fonts"),
    fontSize: $0422a6ce4ea03acc$var$K.prop("fontSize", "fontSizes", $0422a6ce4ea03acc$var$s3.px),
    fontWeight: $0422a6ce4ea03acc$var$K.prop("fontWeight", "fontWeights"),
    lineHeight: $0422a6ce4ea03acc$var$K.prop("lineHeight", "lineHeights"),
    letterSpacing: $0422a6ce4ea03acc$var$K.prop("letterSpacing", "letterSpacings"),
    textAlign: !0,
    fontStyle: !0,
    textIndent: !0,
    wordBreak: !0,
    overflowWrap: !0,
    textOverflow: !0,
    textTransform: !0,
    whiteSpace: !0,
    isTruncated: {
        transform (r) {
            if (r === !0) return {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            };
        }
    },
    noOfLines: {
        static: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            //@ts-ignore
            WebkitLineClamp: "var(--chakra-line-clamp)"
        },
        property: "--chakra-line-clamp"
    }
}, $0422a6ce4ea03acc$var$YP = {
    scrollBehavior: !0,
    scrollSnapAlign: !0,
    scrollSnapStop: !0,
    scrollSnapType: !0,
    // scroll margin
    scrollMargin: $0422a6ce4ea03acc$var$K.spaceT("scrollMargin"),
    scrollMarginTop: $0422a6ce4ea03acc$var$K.spaceT("scrollMarginTop"),
    scrollMarginBottom: $0422a6ce4ea03acc$var$K.spaceT("scrollMarginBottom"),
    scrollMarginLeft: $0422a6ce4ea03acc$var$K.spaceT("scrollMarginLeft"),
    scrollMarginRight: $0422a6ce4ea03acc$var$K.spaceT("scrollMarginRight"),
    scrollMarginX: $0422a6ce4ea03acc$var$K.spaceT([
        "scrollMarginLeft",
        "scrollMarginRight"
    ]),
    scrollMarginY: $0422a6ce4ea03acc$var$K.spaceT([
        "scrollMarginTop",
        "scrollMarginBottom"
    ]),
    // scroll padding
    scrollPadding: $0422a6ce4ea03acc$var$K.spaceT("scrollPadding"),
    scrollPaddingTop: $0422a6ce4ea03acc$var$K.spaceT("scrollPaddingTop"),
    scrollPaddingBottom: $0422a6ce4ea03acc$var$K.spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: $0422a6ce4ea03acc$var$K.spaceT("scrollPaddingLeft"),
    scrollPaddingRight: $0422a6ce4ea03acc$var$K.spaceT("scrollPaddingRight"),
    scrollPaddingX: $0422a6ce4ea03acc$var$K.spaceT([
        "scrollPaddingLeft",
        "scrollPaddingRight"
    ]),
    scrollPaddingY: $0422a6ce4ea03acc$var$K.spaceT([
        "scrollPaddingTop",
        "scrollPaddingBottom"
    ])
};
function $0422a6ce4ea03acc$var$bw(r) {
    return $0422a6ce4ea03acc$var$gw(r) && r.reference ? r.reference : String(r);
}
var $0422a6ce4ea03acc$var$Tc = (r, ...a)=>a.map($0422a6ce4ea03acc$var$bw).join(` ${r} `).replace(/calc/g, ""), $0422a6ce4ea03acc$var$GL = (...r)=>`calc(${$0422a6ce4ea03acc$var$Tc("+", ...r)})`, $0422a6ce4ea03acc$var$XL = (...r)=>`calc(${$0422a6ce4ea03acc$var$Tc("-", ...r)})`, $0422a6ce4ea03acc$var$ch = (...r)=>`calc(${$0422a6ce4ea03acc$var$Tc("*", ...r)})`, $0422a6ce4ea03acc$var$KL = (...r)=>`calc(${$0422a6ce4ea03acc$var$Tc("/", ...r)})`, $0422a6ce4ea03acc$var$JL = (r)=>{
    const a = $0422a6ce4ea03acc$var$bw(r);
    return a != null && !Number.isNaN(parseFloat(a)) ? String(a).startsWith("-") ? String(a).slice(1) : `-${a}` : $0422a6ce4ea03acc$var$ch(a, -1);
}, $0422a6ce4ea03acc$var$Vo = Object.assign((r)=>({
        add: (...a)=>$0422a6ce4ea03acc$var$Vo($0422a6ce4ea03acc$var$GL(r, ...a)),
        subtract: (...a)=>$0422a6ce4ea03acc$var$Vo($0422a6ce4ea03acc$var$XL(r, ...a)),
        multiply: (...a)=>$0422a6ce4ea03acc$var$Vo($0422a6ce4ea03acc$var$ch(r, ...a)),
        divide: (...a)=>$0422a6ce4ea03acc$var$Vo($0422a6ce4ea03acc$var$KL(r, ...a)),
        negate: ()=>$0422a6ce4ea03acc$var$Vo($0422a6ce4ea03acc$var$JL(r)),
        toString: ()=>r.toString()
    }), {
    add: $0422a6ce4ea03acc$var$GL,
    subtract: $0422a6ce4ea03acc$var$XL,
    multiply: $0422a6ce4ea03acc$var$ch,
    divide: $0422a6ce4ea03acc$var$KL,
    negate: $0422a6ce4ea03acc$var$JL
}), $0422a6ce4ea03acc$var$B4 = {
    hover: (r, a)=>`${r}:hover ${a}, ${r}[data-hover] ${a}`,
    focus: (r, a)=>`${r}:focus ${a}, ${r}[data-focus] ${a}`,
    focusVisible: (r, a)=>`${r}:focus-visible ${a}`,
    focusWithin: (r, a)=>`${r}:focus-within ${a}`,
    active: (r, a)=>`${r}:active ${a}, ${r}[data-active] ${a}`,
    disabled: (r, a)=>`${r}:disabled ${a}, ${r}[data-disabled] ${a}`,
    invalid: (r, a)=>`${r}:invalid ${a}, ${r}[data-invalid] ${a}`,
    checked: (r, a)=>`${r}:checked ${a}, ${r}[data-checked] ${a}`,
    indeterminate: (r, a)=>`${r}:indeterminate ${a}, ${r}[aria-checked=mixed] ${a}, ${r}[data-indeterminate] ${a}`,
    readOnly: (r, a)=>`${r}:read-only ${a}, ${r}[readonly] ${a}, ${r}[data-read-only] ${a}`,
    expanded: (r, a)=>`${r}:read-only ${a}, ${r}[aria-expanded=true] ${a}, ${r}[data-expanded] ${a}`,
    placeholderShown: (r, a)=>`${r}:placeholder-shown ${a}`
}, $0422a6ce4ea03acc$var$p0 = (r)=>$0422a6ce4ea03acc$var$ww((a)=>r(a, "&"), "[role=group]", "[data-group]", ".group"), $0422a6ce4ea03acc$var$a9 = (r)=>$0422a6ce4ea03acc$var$ww((a)=>r(a, "~ &"), "[data-peer]", ".peer"), $0422a6ce4ea03acc$var$ww = (r, ...a)=>a.map(r).join(", "), $0422a6ce4ea03acc$var$Hw = {
    /**
   * Styles for CSS selector `&:hover`
   */ _hover: "&:hover, &[data-hover]",
    /**
   * Styles for CSS Selector `&:active`
   */ _active: "&:active, &[data-active]",
    /**
   * Styles for CSS selector `&:focus`
   *
   */ _focus: "&:focus, &[data-focus]",
    /**
   * Styles for the highlighted state.
   */ _highlighted: "&[data-highlighted]",
    /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */ _focusWithin: "&:focus-within",
    /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */ _focusVisible: "&:focus-visible, &[data-focus-visible]",
    /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */ _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
    /**
   * Styles for CSS Selector `&:readonly`
   */ _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */ _before: "&::before",
    /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */ _after: "&::after",
    /**
   * Styles for CSS selector `&:empty`
   */ _empty: "&:empty",
    /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */ _expanded: "&[aria-expanded=true], &[data-expanded]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */ _checked: "&[aria-checked=true], &[data-checked]",
    /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */ _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */ _pressed: "&[aria-pressed=true], &[data-pressed]",
    /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */ _invalid: "&[aria-invalid=true], &[data-invalid]",
    /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */ _valid: "&[data-valid], &[data-state=valid]",
    /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */ _loading: "&[data-loading], &[aria-busy=true]",
    /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */ _selected: "&[aria-selected=true], &[data-selected]",
    /**
   * Styles for CSS Selector `[hidden=true]`
   */ _hidden: "&[hidden], &[data-hidden]",
    /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */ _autofill: "&:-webkit-autofill",
    /**
   * Styles for CSS Selector `&:nth-child(even)`
   */ _even: "&:nth-of-type(even)",
    /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */ _odd: "&:nth-of-type(odd)",
    /**
   * Styles for CSS Selector `&:first-of-type`
   */ _first: "&:first-of-type",
    /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */ _firstLetter: "&::first-letter",
    /**
   * Styles for CSS Selector `&:last-of-type`
   */ _last: "&:last-of-type",
    /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */ _notFirst: "&:not(:first-of-type)",
    /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */ _notLast: "&:not(:last-of-type)",
    /**
   * Styles for CSS Selector `&:visited`
   */ _visited: "&:visited",
    /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */ _activeLink: "&[aria-current=page]",
    /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */ _activeStep: "&[aria-current=step]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */ _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */ _groupHover: $0422a6ce4ea03acc$var$p0($0422a6ce4ea03acc$var$B4.hover),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */ _peerHover: $0422a6ce4ea03acc$var$a9($0422a6ce4ea03acc$var$B4.hover),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */ _groupFocus: $0422a6ce4ea03acc$var$p0($0422a6ce4ea03acc$var$B4.focus),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */ _peerFocus: $0422a6ce4ea03acc$var$a9($0422a6ce4ea03acc$var$B4.focus),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */ _groupFocusVisible: $0422a6ce4ea03acc$var$p0($0422a6ce4ea03acc$var$B4.focusVisible),
    /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */ _peerFocusVisible: $0422a6ce4ea03acc$var$a9($0422a6ce4ea03acc$var$B4.focusVisible),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */ _groupActive: $0422a6ce4ea03acc$var$p0($0422a6ce4ea03acc$var$B4.active),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */ _peerActive: $0422a6ce4ea03acc$var$a9($0422a6ce4ea03acc$var$B4.active),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */ _groupDisabled: $0422a6ce4ea03acc$var$p0($0422a6ce4ea03acc$var$B4.disabled),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */ _peerDisabled: $0422a6ce4ea03acc$var$a9($0422a6ce4ea03acc$var$B4.disabled),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */ _groupInvalid: $0422a6ce4ea03acc$var$p0($0422a6ce4ea03acc$var$B4.invalid),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */ _peerInvalid: $0422a6ce4ea03acc$var$a9($0422a6ce4ea03acc$var$B4.invalid),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */ _groupChecked: $0422a6ce4ea03acc$var$p0($0422a6ce4ea03acc$var$B4.checked),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */ _peerChecked: $0422a6ce4ea03acc$var$a9($0422a6ce4ea03acc$var$B4.checked),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */ _groupFocusWithin: $0422a6ce4ea03acc$var$p0($0422a6ce4ea03acc$var$B4.focusWithin),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */ _peerFocusWithin: $0422a6ce4ea03acc$var$a9($0422a6ce4ea03acc$var$B4.focusWithin),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */ _peerPlaceholderShown: $0422a6ce4ea03acc$var$a9($0422a6ce4ea03acc$var$B4.placeholderShown),
    /**
   * Styles for CSS Selector `&::placeholder`.
   */ _placeholder: "&::placeholder",
    /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */ _placeholderShown: "&:placeholder-shown",
    /**
   * Styles for CSS Selector `&:fullscreen`.
   */ _fullScreen: "&:fullscreen",
    /**
   * Styles for CSS Selector `&::selection`
   */ _selection: "&::selection",
    /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */ _rtl: "[dir=rtl] &, &[dir=rtl]",
    /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */ _ltr: "[dir=ltr] &, &[dir=ltr]",
    /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */ _mediaDark: "@media (prefers-color-scheme: dark)",
    /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */ _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
    /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */ _horizontal: "&[data-orientation=horizontal]",
    /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */ _vertical: "&[data-orientation=vertical]"
}, $0422a6ce4ea03acc$var$WP = Object.keys($0422a6ce4ea03acc$var$Hw), $0422a6ce4ea03acc$var$xw = $0422a6ce4ea03acc$var$uw({}, $0422a6ce4ea03acc$var$Xu, $0422a6ce4ea03acc$var$M3, $0422a6ce4ea03acc$var$_P, $0422a6ce4ea03acc$var$hc, $0422a6ce4ea03acc$var$S6, $0422a6ce4ea03acc$var$DP, $0422a6ce4ea03acc$var$jP, $0422a6ce4ea03acc$var$RP, $0422a6ce4ea03acc$var$Lw, $0422a6ce4ea03acc$var$AP, $0422a6ce4ea03acc$var$Do, $0422a6ce4ea03acc$var$uh, $0422a6ce4ea03acc$var$le, $0422a6ce4ea03acc$var$YP, $0422a6ce4ea03acc$var$$P, $0422a6ce4ea03acc$var$zP, $0422a6ce4ea03acc$var$UP, $0422a6ce4ea03acc$var$ZP, $0422a6ce4ea03acc$var$IP);
Object.assign({}, $0422a6ce4ea03acc$var$le, $0422a6ce4ea03acc$var$S6, $0422a6ce4ea03acc$var$hc, $0422a6ce4ea03acc$var$Lw, $0422a6ce4ea03acc$var$Do);
[
    ...Object.keys($0422a6ce4ea03acc$var$xw),
    ...$0422a6ce4ea03acc$var$WP
];
({
    ...$0422a6ce4ea03acc$var$xw,
    ...$0422a6ce4ea03acc$var$Hw
});
function $0422a6ce4ea03acc$var$Y2(r) {
    return {
        definePartsStyle (a) {
            return a;
        },
        defineMultiStyleConfig (a) {
            return {
                parts: r,
                ...a
            };
        }
    };
}
const { defineMultiStyleConfig: $0422a6ce4ea03acc$var$QP, definePartsStyle: $0422a6ce4ea03acc$var$qP } = $0422a6ce4ea03acc$var$Y2([
    "container",
    "button",
    "panel"
]), $0422a6ce4ea03acc$var$GP = {
    border: "none",
    width: "100%",
    _dark: {
        bg: "dark.ui.bg.default",
        borderColor: "dark.ui.border.default"
    }
}, $0422a6ce4ea03acc$var$XP = {
    borderWidth: "1px",
    " > span ": {
        display: "flex",
        alignItems: "center",
        minHeight: "21px"
    },
    color: "ui.typography.heading",
    fontWeight: "medium",
    svg: {
        marginStart: "s"
    },
    _dark: {
        bg: "dark.ui.bg.default",
        color: "dark.ui.typography.heading"
    }
}, $0422a6ce4ea03acc$var$KP = {
    padding: "s",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderBottomWidth: "1px",
    _dark: {
        bg: "dark.ui.bg.default",
        color: "dark.ui.typography.body",
        borderColor: "dark.ui.border.default"
    }
}, $0422a6ce4ea03acc$var$JP = $0422a6ce4ea03acc$var$QP({
    baseStyle: $0422a6ce4ea03acc$var$qP({
        container: $0422a6ce4ea03acc$var$GP,
        button: $0422a6ce4ea03acc$var$XP,
        panel: $0422a6ce4ea03acc$var$KP
    })
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$eB, definePartsStyle: $0422a6ce4ea03acc$var$tB } = $0422a6ce4ea03acc$var$Y2([
    "button"
]), $0422a6ce4ea03acc$var$nB = $0422a6ce4ea03acc$var$eB({
    baseStyle: $0422a6ce4ea03acc$var$tB({
        button: {
            minWidth: {
                base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
                md: "auto"
            },
            height: {
                base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
                md: "auto"
            },
            padding: "1px 4px",
            margin: "2px 1px",
            fontWeight: "bold",
            fontSize: {
                base: "mobile.subtitle.subtitle1",
                md: "desktop.subtitle.subtitle1"
            },
            lineHeight: "1",
            _last: {
                fontSize: "desktop.button.default",
                fontWeight: "normal",
                px: {
                    base: "s",
                    md: "xs"
                },
                py: {
                    base: null,
                    md: "xxs"
                },
                whiteSpace: "nowrap"
            },
            _disabled: {
                color: "ui.gray.medium",
                cursor: "not-allowed"
            }
        }
    })
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$rB, definePartsStyle: $0422a6ce4ea03acc$var$aB } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "invalid"
]), $0422a6ce4ea03acc$var$iB = $0422a6ce4ea03acc$var$rB({
    baseStyle: $0422a6ce4ea03acc$var$aB({
        base: {},
        invalid: {
            backgroundColor: "ui.bg.default",
            border: "1px solid",
            borderColor: "ui.border.default",
            padding: "s",
            _dark: {
                bg: "dark.ui.bg.default",
                border: "1px solid",
                borderColor: "dark.ui.border.default"
            }
        }
    })
}), $0422a6ce4ea03acc$var$oB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    alignItems: "center",
    bgColor: "ui.bg.default",
    borderLeft: "4px solid",
    borderColor: "ui.gray.semi-dark",
    borderRadius: "base",
    color: "ui.typography.heading",
    display: "flex",
    fontSize: "desktop.body.body2",
    // slightly smaller than the default size
    fontWeight: "500",
    py: "inset.extranarrow",
    paddingInlineEnd: "inset.default",
    paddingInlineStart: ".75rem",
    whiteSpace: "nowrap",
    width: "fit-content",
    _dark: {
        backgroundColor: "dark.ui.bg.default",
        borderColor: "dark.ui.border.default",
        color: "dark.ui.typography.heading"
    }
}), $0422a6ce4ea03acc$var$lB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({}), $0422a6ce4ea03acc$var$sB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderColor: "ui.status.primary",
    _dark: {
        borderColor: "ui.status.primary"
    }
}), $0422a6ce4ea03acc$var$uB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderColor: "ui.error.primary",
    _dark: {
        borderColor: "dark.ui.error.primary"
    }
}), $0422a6ce4ea03acc$var$Vw = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderColor: "ui.gray.dark",
    _dark: {
        borderColor: "dark.ui.gray.semi-dark"
    }
}), $0422a6ce4ea03acc$var$Mw = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bgColor: "ui.link.primary-10",
    borderColor: "ui.link.primary",
    _dark: {
        bgColor: "dark.ui.link.primary-10",
        borderColor: "dark.ui.link.primary"
    }
}), $0422a6ce4ea03acc$var$Ew = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bgColor: "ui.success.primary-10",
    borderColor: "ui.success.primary",
    _dark: {
        bgColor: "dark.ui.success.primary-10",
        borderColor: "dark.ui.success.primary"
    }
}), $0422a6ce4ea03acc$var$Sw = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bgColor: "ui.error.primary-10",
    borderColor: "ui.error.primary",
    _dark: {
        bgColor: "dark.ui.error.primary-10",
        borderColor: "dark.ui.error.primary"
    }
}), $0422a6ce4ea03acc$var$kw = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bgColor: "ui.warning.primary-10",
    borderColor: "ui.warning.tertiary",
    _dark: {
        bgColor: "dark.ui.warning.primary-10",
        borderColor: "dark.ui.warning.primary"
    }
}), $0422a6ce4ea03acc$var$Tw = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bgColor: "ui.link.tertiary-10",
    borderColor: "ui.link.tertiary",
    _dark: {
        bgColor: "dark.ui.link.tertiary-10",
        borderColor: "dark.ui.link.tertiary"
    }
}), $0422a6ce4ea03acc$var$cB = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $0422a6ce4ea03acc$var$oB,
    variants: {
        low: $0422a6ce4ea03acc$var$lB,
        medium: $0422a6ce4ea03acc$var$sB,
        high: $0422a6ce4ea03acc$var$uB,
        neutral: $0422a6ce4ea03acc$var$Vw,
        informative: $0422a6ce4ea03acc$var$Mw,
        positive: $0422a6ce4ea03acc$var$Ew,
        negative: $0422a6ce4ea03acc$var$Sw,
        warning: $0422a6ce4ea03acc$var$kw,
        recommendation: $0422a6ce4ea03acc$var$Tw
    }
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$dB, definePartsStyle: $0422a6ce4ea03acc$var$Zt } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "dismissibleButton"
]), $0422a6ce4ea03acc$var$CB = $0422a6ce4ea03acc$var$Zt({
    base: {
        ...$0422a6ce4ea03acc$var$Vw,
        bgColor: "ui.bg.default",
        svg: {
            fill: "ui.border.hover",
            _dark: {
                fill: "dark.ui.border.hover"
            }
        },
        _dark: {
            bgColor: "dark.ui.bg.default"
        }
    }
}), $0422a6ce4ea03acc$var$fB = $0422a6ce4ea03acc$var$Zt({
    base: {
        ...$0422a6ce4ea03acc$var$Mw,
        svg: {
            fill: "ui.link.primary",
            _dark: {
                fill: "dark.ui.link.primary"
            }
        }
    }
}), $0422a6ce4ea03acc$var$pB = $0422a6ce4ea03acc$var$Zt({
    base: {
        ...$0422a6ce4ea03acc$var$Ew,
        svg: {
            fill: "ui.success.primary",
            _dark: {
                fill: "dark.ui.success.primary"
            }
        }
    }
}), $0422a6ce4ea03acc$var$hB = $0422a6ce4ea03acc$var$Zt({
    base: {
        ...$0422a6ce4ea03acc$var$Sw,
        color: "ui.error.primary",
        a: {
            color: "ui.error.primary",
            _hover: {
                color: "ui.error.secondary"
            },
            _visited: {
                color: "ui.error.primary"
            }
        },
        svg: {
            fill: "ui.error.primary",
            _hover: {
                fill: "ui.error.secondary"
            },
            _dark: {
                fill: "dark.ui.error.primary"
            }
        },
        _dark: {
            a: {
                color: "dark.ui.error.primary",
                _hover: {
                    color: "dark.ui.error.secondary"
                },
                _visited: {
                    color: "dark.ui.error.primary"
                }
            },
            color: "dark.ui.error.primary"
        }
    }
}), $0422a6ce4ea03acc$var$mB = $0422a6ce4ea03acc$var$Zt({
    base: {
        ...$0422a6ce4ea03acc$var$kw,
        svg: {
            fill: "ui.warning.tertiary",
            _dark: {
                fill: "dark.ui.warning.primary"
            }
        }
    }
}), $0422a6ce4ea03acc$var$vB = $0422a6ce4ea03acc$var$Zt({
    base: {
        ...$0422a6ce4ea03acc$var$Tw,
        svg: {
            fill: "ui.link.tertiary",
            _dark: {
                fill: "dark.ui.link.tertiary"
            }
        }
    }
}), $0422a6ce4ea03acc$var$gB = $0422a6ce4ea03acc$var$dB({
    baseStyle: $0422a6ce4ea03acc$var$Zt(({ backgroundColor: r, highlightColor: a })=>({
            base: {
                alignItems: "flex-start",
                backgroundColor: r || null,
                borderLeft: "4px",
                borderColor: a || null,
                display: "flex",
                fontSize: "desktop.body.body2",
                flexDirection: "row",
                gap: "xs",
                justifyContent: "flex-start",
                py: "s",
                paddingEnd: "l",
                paddingStart: {
                    base: "s",
                    md: "l"
                },
                position: "relative",
                width: "100%",
                a: {
                    color: "ui.typography.heading",
                    _hover: {
                        color: "ui.typography.heading"
                    }
                },
                svg: {
                    fill: a || null
                },
                _dark: {
                    a: {
                        color: "dark.ui.typography.heading",
                        _hover: {
                            color: "dark.ui.typography.heading"
                        }
                    }
                }
            },
            dismissibleButton: {
                alignItems: "center",
                border: "none",
                bgColor: "inherit",
                color: "ui.typography.heading",
                display: "flex",
                margin: "xs",
                minWidth: "0",
                position: "absolute",
                right: "0",
                top: "0",
                svg: {
                    fill: "ui.black",
                    _dark: {
                        fill: "dark.ui.typography.heading"
                    }
                },
                _hover: {
                    bg: "inherit"
                },
                _dark: {
                    color: "dark.ui.typography.heading"
                }
            }
        })),
    variants: {
        neutral: $0422a6ce4ea03acc$var$CB,
        informative: $0422a6ce4ea03acc$var$fB,
        positive: $0422a6ce4ea03acc$var$pB,
        negative: $0422a6ce4ea03acc$var$hB,
        warning: $0422a6ce4ea03acc$var$mB,
        recommendation: $0422a6ce4ea03acc$var$vB
    }
}), $0422a6ce4ea03acc$var$yB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "section.blogs.secondary",
    color: "ui.black",
    _dark: {
        bg: "dark.section.blogs.secondary"
    },
    a: {
        _hover: {
            color: "ui.gray.xx-dark"
        },
        _dark: {
            _hover: {
                color: "dark.ui.typography.heading"
            }
        },
        _focus: $0422a6ce4ea03acc$var$Sc("ui.black", "dark.ui.typography.body")
    },
    "li:last-child": {
        ".chakra-breadcrumb__link": {
            _hover: {
                // Override the default hover color.
                color: "ui.black"
            }
        }
    },
    svg: {
        fill: "ui.black"
    }
}), $0422a6ce4ea03acc$var$LB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "section.books-and-more.secondary",
    _dark: {
        bg: "dark.section.books-and-more.secondary"
    }
}), $0422a6ce4ea03acc$var$bB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "brand.secondary",
    _dark: {
        bg: "dark.brand.secondary"
    }
}), $0422a6ce4ea03acc$var$wB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "section.connect.secondary",
    _dark: {
        bg: "dark.section.connect.secondary"
    }
}), $0422a6ce4ea03acc$var$HB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "ui.gray.light-cool",
    color: "ui.black",
    _dark: {
        bg: "ui.gray.xx-dark"
    },
    a: {
        _hover: {
            color: "ui.gray.xx-dark"
        },
        _dark: {
            _hover: {
                color: "ui.white"
            }
        },
        _focus: $0422a6ce4ea03acc$var$Sc("ui.black", "dark.ui.typography.body")
    },
    "li:last-child": {
        ".chakra-breadcrumb__link": {
            _hover: {
                color: "ui.gray.xx-dark"
            },
            _dark: {
                _hover: {
                    color: "ui.white"
                }
            }
        }
    }
}), $0422a6ce4ea03acc$var$xB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "section.education.secondary",
    _dark: {
        bg: "dark.section.education.secondary"
    }
}), $0422a6ce4ea03acc$var$VB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "section.locations.primary",
    _dark: {
        bg: "dark.section.locations.primary"
    }
}), $0422a6ce4ea03acc$var$MB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "section.research.secondary",
    _dark: {
        bg: "dark.section.research.secondary"
    }
}), $0422a6ce4ea03acc$var$EB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "section.whats-on.secondary",
    _dark: {
        bg: "dark.section.whats-on.secondary"
    }
}), $0422a6ce4ea03acc$var$SB = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        bg: "ui.black",
        color: "ui.white",
        fontSize: "desktop.breadcrumbs.default",
        fontWeight: "breadcrumbs.default",
        paddingBottom: "xs",
        paddingTop: "xs",
        _dark: {
            bg: "dark.ui.bg.hover",
            color: "dark.ui.typography.heading"
        },
        ol: {
            alignItems: {
                base: "center",
                md: "unset"
            },
            display: {
                base: "flex",
                md: "block"
            },
            margin: "auto",
            maxWidth: "1280px",
            paddingStart: "s",
            paddingEnd: "s"
        },
        a: {
            _hover: {
                color: "ui.gray.light-cool",
                textDecoration: "none"
            },
            _focus: $0422a6ce4ea03acc$var$Sc("ui.white", "dark.ui.typography.heading")
        },
        "li:last-child": {
            fontWeight: {
                base: "breadcrumbs.default",
                md: "breadcrumbs.lastChild"
            },
            ".chakra-breadcrumb__link": {
                _hover: {
                    // Override the default hover color.
                    color: "ui.white",
                    cursor: "default",
                    textDecoration: "none"
                },
                _dark: {
                    _hover: {
                        color: "dark.ui.typography.heading"
                    }
                }
            },
            ".icon": {
                display: "none"
            }
        },
        "li:not(:last-child)": {
            display: {
                base: "none",
                md: "inline-block"
            },
            a: {
                marginEnd: {
                    base: "xs",
                    md: "0"
                }
            },
            ".icon": {
                display: {
                    base: "inline",
                    md: "none"
                }
            },
            "span:not(.breadcrumb-label)": {
                marginInlineEnd: "xxs",
                marginInlineStart: "xxs"
            }
        },
        "li:nth-last-of-type(2)": {
            display: "inline-block",
            span: {
                display: {
                    base: "none",
                    md: "inline"
                }
            }
        }
    }),
    // Available variants:
    variants: {
        blogs: $0422a6ce4ea03acc$var$yB,
        booksAndMore: $0422a6ce4ea03acc$var$LB,
        brand: $0422a6ce4ea03acc$var$bB,
        connect: $0422a6ce4ea03acc$var$wB,
        digitalCollections: $0422a6ce4ea03acc$var$HB,
        education: $0422a6ce4ea03acc$var$xB,
        locations: $0422a6ce4ea03acc$var$VB,
        research: $0422a6ce4ea03acc$var$MB,
        whatsOn: $0422a6ce4ea03acc$var$EB
    }
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$kB, definePartsStyle: $0422a6ce4ea03acc$var$c9 } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "screenreaderOnly"
]), $0422a6ce4ea03acc$var$_w = {
    alignItems: "center",
    borderRadius: "sm",
    display: "flex",
    cursor: "pointer",
    color: "ui.white",
    fontWeight: "button.default",
    height: "10",
    justifyContent: "center",
    lineHeight: "1.5",
    minWidth: "10",
    textDecoration: "none",
    wordWrap: "normal",
    svg: {
        fill: "currentColor"
    },
    _hover: {
        bg: "ui.link.secondary"
    },
    _visited: {
        color: "ui.white"
    },
    _disabled: {
        bg: "ui.gray.light-cool",
        color: "ui.gray.dark",
        opacity: "1",
        pointerEvents: "none"
    },
    _dark: {
        _disabled: {
            bg: "dark.ui.disabled.secondary",
            color: "dark.ui.disabled.primary"
        }
    }
}, $0422a6ce4ea03acc$var$TB = $0422a6ce4ea03acc$var$c9({
    base: $0422a6ce4ea03acc$var$_w,
    /** The element will handle descriptive text added to aid
   * screen readers. */ screenreaderOnly: $0422a6ce4ea03acc$var$u9()
}), $0422a6ce4ea03acc$var$Dw = {
    bg: "transparent",
    borderColor: "dark.ui.link.primary",
    color: "dark.ui.link.primary",
    _hover: {
        bg: "dark.ui.link.primary-10",
        borderColor: "dark.ui.link.secondary",
        color: "dark.ui.link.secondary"
    },
    _disabled: {
        bg: "dark.ui.bg.default",
        borderColor: "dark.ui.disabled.primary"
    }
}, $0422a6ce4ea03acc$var$b0 = (r = "medium", a = !1)=>({
        small: {
            fontSize: "desktop.button.small",
            height: "fit-content",
            minHeight: "auto",
            px: a ? "s" : "button.small.px",
            py: a ? "xxxs" : "button.small.py"
        },
        medium: {
            fontSize: "desktop.button.default",
            height: a ? "fit-content" : void 0,
            minHeight: a ? "auto" : {
                base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
                md: "auto"
            },
            px: a ? "m" : "button.medium.px",
            py: a ? "xxxs" : "button.medium.py"
        },
        large: {
            fontSize: "desktop.button.large",
            height: "fit-content",
            minHeight: "auto",
            px: a ? "l" : "button.large.px",
            py: a ? "xxs" : "button.large.py"
        }
    })[r], $0422a6ce4ea03acc$var$Ah = $0422a6ce4ea03acc$var$c9(({ buttonSize: r = "medium" })=>({
        base: {
            bg: "ui.link.primary",
            ...$0422a6ce4ea03acc$var$b0(r),
            _dark: {
                bg: "dark.ui.link.primary",
                color: "ui.gray.xxx-dark",
                _hover: {
                    bg: "dark.ui.link.secondary",
                    color: "ui.gray.xxx-dark"
                }
            }
        },
        screenreaderOnly: {}
    })), $0422a6ce4ea03acc$var$Rw = $0422a6ce4ea03acc$var$c9(({ buttonSize: r = "medium" })=>({
        base: {
            border: "1px solid",
            borderColor: "ui.link.primary",
            color: "ui.link.primary",
            ...$0422a6ce4ea03acc$var$b0(r),
            _hover: {
                bg: "ui.link.primary-05",
                borderColor: "ui.link.secondary",
                color: "ui.link.secondary"
            },
            _disabled: {
                bg: "transparent",
                borderColor: "ui.disabled.primary",
                color: "ui.disabled.primary"
            },
            _dark: {
                ...$0422a6ce4ea03acc$var$Dw
            }
        }
    })), $0422a6ce4ea03acc$var$_B = $0422a6ce4ea03acc$var$c9(({ buttonSize: r = "medium" })=>({
        base: {
            bg: "transparent",
            color: "ui.link.primary",
            textDecoration: "underline",
            ...$0422a6ce4ea03acc$var$b0(r),
            _disabled: {
                bg: "transparent"
            },
            _hover: {
                bg: "transparent",
                color: "ui.link.secondary"
            },
            _dark: {
                color: "dark.ui.link.primary",
                _disabled: {
                    bg: "transparent"
                },
                _hover: {
                    color: "dark.ui.link.secondary"
                }
            }
        }
    })), $0422a6ce4ea03acc$var$DB = $0422a6ce4ea03acc$var$c9(({ buttonSize: r = "medium" })=>({
        base: {
            bg: "transparent",
            color: "ui.link.primary",
            ...$0422a6ce4ea03acc$var$b0(r),
            _disabled: {
                bg: "transparent"
            },
            _hover: {
                bg: "ui.link.primary-05",
                color: "ui.link.secondary"
            },
            _dark: {
                color: "dark.ui.link.primary",
                _disabled: {
                    bg: "transparent"
                },
                _hover: {
                    bg: "ui.link.primary-10",
                    color: "dark.ui.link.secondary"
                }
            }
        }
    })), $0422a6ce4ea03acc$var$Zw = $0422a6ce4ea03acc$var$c9(({ buttonSize: r = "medium" })=>({
        base: {
            bg: "ui.white",
            border: "1px solid",
            borderColor: "ui.border.default",
            borderRadius: "button.pill",
            color: "ui.typography.heading",
            ...$0422a6ce4ea03acc$var$b0(r, !0),
            _hover: {
                bg: "ui.gray.xx-light-cool",
                borderColor: "ui.gray.medium"
            },
            _disabled: {
                bg: "ui.gray.x-light-cool"
            },
            _dark: {
                background: "transparent",
                borderColor: "dark.ui.border.default",
                color: "dark.ui.typography.heading",
                _hover: {
                    background: "dark.ui.bg.hover",
                    borderColor: "dark.ui.border.hover",
                    color: "dark.ui.typography.heading"
                }
            }
        }
    })), $0422a6ce4ea03acc$var$RB = $0422a6ce4ea03acc$var$c9(({ buttonSize: r = "medium" })=>({
        base: {
            bg: "ui.white",
            border: "1px solid",
            borderColor: "ui.link.primary",
            color: "ui.link.primary",
            ...$0422a6ce4ea03acc$var$b0(r),
            paddingInlineStart: "inset.narrow",
            paddingInlineEnd: "inset.narrow",
            _hover: {
                bg: "ui.link.primary-05",
                borderColor: "ui.link.secondary",
                color: "ui.link.secondary"
            },
            _dark: {
                ...$0422a6ce4ea03acc$var$Dw
            }
        }
    })), $0422a6ce4ea03acc$var$Ow = $0422a6ce4ea03acc$var$c9(({ buttonSize: r = "medium" })=>({
        base: {
            bg: "brand.primary",
            ...$0422a6ce4ea03acc$var$b0(r),
            _hover: {
                bg: "brand.secondary"
            },
            _active: {
                bg: "brand.secondary"
            },
            _dark: {
                bg: "brand.secondary",
                color: "ui.white",
                _hover: {
                    bg: "brand.primary",
                    color: "ui.white"
                }
            }
        }
    })), $0422a6ce4ea03acc$var$Nw = $0422a6ce4ea03acc$var$c9(({ buttonSize: r = "medium" })=>({
        base: {
            bg: "ui.black",
            color: "ui.white",
            ...$0422a6ce4ea03acc$var$b0(r),
            _hover: {
                bg: "ui.gray.xx-dark"
            },
            _dark: {
                bg: "ui.gray.xx-dark",
                color: "ui.white",
                _hover: {
                    bg: "ui.gray.x-dark",
                    color: "ui.white"
                }
            }
        }
    })), $0422a6ce4ea03acc$var$ZB = $0422a6ce4ea03acc$var$kB({
    baseStyle: $0422a6ce4ea03acc$var$TB,
    // Available variants:
    variants: {
        primary: $0422a6ce4ea03acc$var$Ah,
        secondary: $0422a6ce4ea03acc$var$Rw,
        text: $0422a6ce4ea03acc$var$DB,
        // Deprecated type. Use "text" instead.
        link: $0422a6ce4ea03acc$var$_B,
        pill: $0422a6ce4ea03acc$var$Zw,
        iconOnly: $0422a6ce4ea03acc$var$RB,
        callout: $0422a6ce4ea03acc$var$Ow,
        noBrand: $0422a6ce4ea03acc$var$Nw
    },
    // Default values
    defaultProps: {
        variant: "primary"
    }
}), $0422a6ce4ea03acc$var$OB = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)(({ buttonWidth: r })=>({
            width: {
                base: "100%",
                md: r === "default" ? "fit-content" : "100%"
            },
            button: {
                flexGrow: r === "default" ? void 0 : "1"
            }
        }))
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$NB, definePartsStyle: $0422a6ce4ea03acc$var$PB } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "helperErrorText",
    "icon",
    "control",
    "label",
    "container"
]), $0422a6ce4ea03acc$var$BB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    // Remove Chakra's default animation
    animation: null,
    width: "22px",
    height: "22px"
}), $0422a6ce4ea03acc$var$FB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "ui.gray.dark",
    backgroundColor: "ui.gray.xx-light-cool",
    color: "ui.black",
    cursor: "pointer",
    outline: "none",
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    _checked: {
        bg: "ui.white",
        borderColor: "ui.focus",
        color: "ui.focus",
        _hover: {
            bg: "ui.gray.xx-light-cool"
        },
        _disabled: {
            bg: "ui.disabled.secondary",
            borderColor: "ui.disabled.primary",
            svg: {
                color: "ui.disabled.primary"
            }
        },
        _indeterminate: {
            color: "ui.focus",
            borderColor: "ui.focus"
        }
    },
    _indeterminate: {
        color: "ui.focus",
        borderColor: "ui.focus"
    },
    _disabled: {
        bg: "ui.white",
        borderColor: "ui.disabled.primary"
    },
    _focus: {
        boxShadow: "none",
        outlineColor: "ui.focus"
    },
    _invalid: {
        borderColor: "ui.error.primary",
        color: "ui.error.primary"
    },
    _dark: {
        borderColor: "dark.ui.border.default",
        backgroundColor: "dark.ui.bg.default",
        color: "dark.ui.typography.body",
        _checked: {
            borderColor: "dark.ui.focus",
            color: "dark.ui.focus",
            _disabled: {
                backgroundColor: "dark.ui.bg.default",
                borderColor: "dark.ui.disabled.secondary",
                svg: {
                    color: "dark.ui.disabled.secondary"
                }
            },
            _indeterminate: {
                color: "dark.ui.focus",
                borderColor: "dark.ui.focus"
            },
            _invalid: {
                borderColor: "dark.ui.error.primary",
                color: "dark.ui.error.primary"
            }
        },
        _indeterminate: {
            color: "dark.ui.focus",
            borderColor: "dark.ui.focus"
        },
        _disabled: {
            backgroundColor: "dark.ui.bg.default",
            borderColor: "dark.ui.disabled.secondary",
            svg: {
                color: "dark.ui.disabled.secondary"
            }
        },
        _focus: {
            boxShadow: "none",
            outlineColor: "dark.ui.focus"
        },
        _invalid: {
            borderColor: "dark.ui.error.primary",
            color: "dark.ui.error.primary"
        }
    }
}), $0422a6ce4ea03acc$var$AB = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    cursor: "pointer",
    verticalAlign: "top",
    ...$0422a6ce4ea03acc$var$cw
}), $0422a6ce4ea03acc$var$jB = $0422a6ce4ea03acc$var$PB({
    // Style object for the Checkbox's helper text
    helperErrorText: $0422a6ce4ea03acc$var$Cw,
    icon: $0422a6ce4ea03acc$var$BB,
    base: {
        alignItems: "flex-start",
        position: "relative",
        ...$0422a6ce4ea03acc$var$fw
    },
    control: $0422a6ce4ea03acc$var$FB,
    label: $0422a6ce4ea03acc$var$AB
}), $0422a6ce4ea03acc$var$zB = {
    lg: {
        // Controls the width/height of the checkbox itself.
        control: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
            ...$0422a6ce4ea03acc$var$dw,
            borderRadius: "checkbox"
        }),
        // Controls the font-size of the label only.
        label: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
            fontSize: "desktop.label.label1"
        })
    }
}, $0422a6ce4ea03acc$var$UB = $0422a6ce4ea03acc$var$NB({
    baseStyle: $0422a6ce4ea03acc$var$jB,
    sizes: $0422a6ce4ea03acc$var$zB,
    // Default values
    defaultProps: {
        size: "lg",
        colorScheme: "white"
    }
}), $0422a6ce4ea03acc$var$IB = {
    parts: [
        "helperErrorText"
    ],
    baseStyle: ({ hasChildren: r })=>({
            helperErrorText: {
                marginTop: r ? null : "0"
            }
        })
}, { defineMultiStyleConfig: $0422a6ce4ea03acc$var$$B, definePartsStyle: $0422a6ce4ea03acc$var$YB } = $0422a6ce4ea03acc$var$Y2([
    "helperErrorText"
]), $0422a6ce4ea03acc$var$WB = $0422a6ce4ea03acc$var$$B({
    baseStyle: $0422a6ce4ea03acc$var$YB(({ isFullWidth: r = !1 })=>({
            ...$0422a6ce4ea03acc$var$pw(r)
        }))
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$QB, definePartsStyle: $0422a6ce4ea03acc$var$eb } = $0422a6ce4ea03acc$var$Y2([
    "helperText",
    "inline",
    "select"
]), $0422a6ce4ea03acc$var$qB = (r)=>({
        backgroundColor: "ui.white",
        borderRadius: "sm",
        borderColor: "ui.border.default",
        fontSize: "desktop.body.body2",
        minHeight: {
            base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
            md: "auto"
        },
        paddingTop: "inset.narrow",
        paddingEnd: "inset.extrawide",
        paddingBottom: "inset.narrow",
        paddingStart: "inset.default",
        flex: r === "inline" ? {
            md: "1"
        } : null,
        _hover: {
            borderColor: "ui.border.hover"
        },
        _active: $0422a6ce4ea03acc$var$Ir,
        _disabled: {
            ...$0422a6ce4ea03acc$var$ah
        },
        _focus: {
            ...$0422a6ce4ea03acc$var$Ir,
            // When the select is focused, the icon should be on top of the dropdown.
            // This should only be done when focused, otherswise the icon will render
            // above any other elements on the page.
            "+ .chakra-select__icon-wrapper": {
                zIndex: "9999"
            }
        },
        _invalid: {
            border: "1px solid",
            borderColor: "ui.error.primary",
            boxShadow: "none",
            color: "ui.error.primary"
        },
        _dark: {
            backgroundColor: "dark.ui.bg.default",
            borderColor: "dark.ui.border.default",
            color: "dark.ui.typography.body",
            _hover: {
                borderColor: "dark.ui.border.hover"
            },
            _invalid: {
                borderColor: "dark.ui.error.primary",
                color: "dark.ui.error.primary"
            }
        }
    }), $0422a6ce4ea03acc$var$GB = $0422a6ce4ea03acc$var$QB({
    baseStyle: $0422a6ce4ea03acc$var$eb(({ labelPosition: r })=>({
            inline: {
                display: {
                    md: "flex"
                },
                gap: {
                    md: "xs"
                },
                alignItems: {
                    md: "flex-end"
                }
            },
            label: $0422a6ce4ea03acc$var$kc,
            select: $0422a6ce4ea03acc$var$qB(r)
        })),
    variants: {
        searchbar: $0422a6ce4ea03acc$var$eb({
            select: {
                flex: "1 1 20%",
                borderRightColor: {
                    md: "transparent"
                },
                borderRightRadius: {
                    md: "none"
                }
            }
        })
    },
    defaultProps: {
        size: "md"
    }
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$XB, definePartsStyle: $0422a6ce4ea03acc$var$KB } = $0422a6ce4ea03acc$var$Y2([
    // Parts based on the Chakra Slider component.
    "container",
    "track",
    "thumb",
    "filledTrack",
    // Custom Parts
    "leftValue",
    "rightValue",
    "textInput",
    "sliderContainer"
]), $0422a6ce4ea03acc$var$tb = {
    marginTop: "xs",
    marginBottom: "xs",
    marginEnd: "s",
    marginStart: "0"
}, $0422a6ce4ea03acc$var$JB = $0422a6ce4ea03acc$var$XB({
    baseStyle: $0422a6ce4ea03acc$var$KB(({ isDarkMode: r, isDisabled: a, isInvalid: o, showBoxes: s, showValues: i })=>{
        const p = r ? "dark." : "";
        let C = `${p}ui.link.primary`;
        return o ? C = `${p}ui.error.primary` : a && (C = `${p}ui.disabled.primary`), {
            // Override the default Chakra Slider parts styles.
            container: {
                display: "flex",
                alignItems: "center"
            },
            label: $0422a6ce4ea03acc$var$kc,
            track: {
                bgColor: "ui.bg.hover",
                _disabled: {
                    bgColor: "ui.disabled.primary"
                },
                _dark: {
                    bgColor: "dark.ui.bg.active",
                    _disabled: {
                        bgColor: "dark.ui.disabled.primary"
                    }
                }
            },
            thumb: {
                border: "2px solid",
                // Thumb doesn't have an _invalid state...
                // so we manually do it through the props.
                borderColor: C,
                boxShadow: "none",
                _active: {
                    transform: "translateY(-50%) scale(1.0)"
                },
                _disabled: {
                    bgColor: "ui.disabled.secondary",
                    borderColor: "ui.disabled.primary"
                },
                _dark: {
                    bgColor: "dark.ui.bg.default",
                    _disabled: {
                        bgColor: "dark.ui.disabled.secondary",
                        borderColor: "dark.ui.disabled.primary"
                    }
                }
            },
            // Filled track doesn't have a _disabled or _invalid state...
            // so we manually do it through the props.
            filledTrack: {
                bgColor: C
            },
            // Custom parts styles
            leftValue: {
                ...$0422a6ce4ea03acc$var$tb,
                color: a ? "ui.disabled.primary" : null,
                _dark: {
                    color: a ? "dark.ui.disabled.primary" : null
                }
            },
            rightValue: {
                ...$0422a6ce4ea03acc$var$tb,
                marginStart: "s",
                // If the text input boxes are shown, then there already is
                // a margin, so we can set this static value to "0".
                marginEnd: s ? "0" : "s",
                color: a ? "ui.disabled.primary" : null,
                _dark: {
                    color: a ? "dark.ui.disabled.primary" : null
                }
            },
            textInput: {
                // Allows for three or more digits present in the
                // min or max value text input.
                minWidth: "65px"
            },
            // This is added to the container so that the slider thumbs don't
            // overflow past the container when the value boxes or min/max values
            // are not shown.
            sliderContainer: {
                marginStart: i ? null : "xs",
                marginEnd: !s && !i ? "xs" : null
            }
        };
    })
}), $0422a6ce4ea03acc$var$dh = ()=>(0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)({
        base: "ui.gray.light-cool",
        md: "ui.border.default"
    }, {
        base: "ui.gray.xx-dark",
        md: "dark.ui.border.default"
    }), $0422a6ce4ea03acc$var$eF = (r = "", a = !1, o = !1)=>({
        borderBottom: {
            base: "2px solid",
            md: 0
        },
        borderColor: "ui.gray.medium",
        display: {
            base: "block",
            md: "table-row"
        },
        paddingBottom: a || r ? 0 : {
            base: "s",
            md: "0"
        },
        paddingTop: a || r || o ? 0 : {
            base: "s",
            md: "0"
        },
        _first: {
            borderTop: {
                base: "2px solid",
                md: "0"
            },
            borderColor: "ui.gray.medium"
        },
        _dark: {
            borderColor: "dark.ui.border.default"
        }
    }), $0422a6ce4ea03acc$var$Pw = (r = "", a = "", o = !1, s = !1)=>({
        border: o ? void 0 : "none",
        borderBottom: o ? "1px solid" : "0",
        borderColor: $0422a6ce4ea03acc$var$dh(),
        display: {
            base: "flex",
            md: "table-cell"
        },
        fontSize: {
            base: "desktop.body.body2",
            md: "desktop.body.body1"
        },
        gap: "s",
        letterSpacing: "0",
        lineHeight: 1.5,
        paddingBottom: {
            base: "0",
            md: "s"
        },
        paddingStart: 0,
        paddingEnd: {
            base: "0",
            md: "m"
        },
        paddingTop: {
            base: "0",
            md: "s"
        },
        _first: {
            paddingStart: o ? {
                base: "0",
                md: "m"
            } : null,
            borderBottom: o ? {
                base: "1px solid var(--nypl-colors-ui-light-cool)",
                md: "1px solid var(--nypl-colors-ui-gray-medium)"
            } : "none"
        },
        _last: {
            paddingEnd: o ? {
                base: "0",
                md: "m"
            } : null,
            borderBottom: o ? "1px solid" : "none",
            borderColor: $0422a6ce4ea03acc$var$dh()
        },
        "> span": {
            flexBasis: "50%",
            paddingBottom: {
                base: "s",
                md: "0"
            },
            paddingEnd: o ? "s" : "0",
            paddingTop: {
                base: "s",
                md: "0"
            },
            _first: {
                bg: r || void 0,
                color: a || "ui.typography.heading",
                fontWeight: "medium",
                paddingStart: r || o || s ? "s" : void 0,
                _dark: {
                    color: a || "dark.ui.typography.heading"
                }
            }
        }
    }), $0422a6ce4ea03acc$var$Bw = (r = "", a = "", o = !1, s = !1)=>({
        ...$0422a6ce4ea03acc$var$Pw(r, a, o, s),
        color: a || "ui.typography.heading",
        fontWeight: "medium",
        textTransform: "capitalize",
        _first: {
            paddingStart: o || r ? {
                base: "0",
                md: "m"
            } : {
                base: "0",
                md: void 0
            }
        },
        _dark: {
            color: a || "dark.ui.typography.heading"
        }
    }), $0422a6ce4ea03acc$var$Fw = (r = "", a = "", o = !1, s = !1)=>({
        ...$0422a6ce4ea03acc$var$Pw(r, a, o, s),
        _first: {
            paddingStart: o && !s ? {
                base: "0",
                md: "m"
            } : r && !s ? {
                base: "0",
                md: "m"
            } : {
                base: "0",
                md: void 0
            }
        },
        _last: {
            borderBottom: o ? {
                base: 0,
                md: "1px solid"
            } : {
                base: 0,
                md: void 0
            },
            borderColor: $0422a6ce4ea03acc$var$dh()
        }
    }), $0422a6ce4ea03acc$var$tF = ({ columnHeadersBackgroundColor: r, columnHeadersTextColor: a, showRowDividers: o, useRowHeaders: s })=>({
        // Headers `th` can be rendered as the first cell in every row through the
        // `useRowHeaders`. Whereas the header `th` in the `thead` can be rendered
        // with a custom color, the row header `th` in the `tbody` should always have
        // text color `ui.typography.heading` for light color mode and
        // `dark.ui.typography.heading` for dark color mode.
        tbody: {
            th: {
                backgroundColor: s ? {
                    base: "ui.gray.x-light-cool",
                    md: "unset"
                } : void 0,
                color: "ui.typography.heading",
                verticalAlign: "top",
                _dark: {
                    backgroundColor: s ? {
                        base: "dark.ui.bg.default",
                        md: "unset"
                    } : void 0,
                    color: "dark.ui.typography.heading"
                }
            },
            td: {
                verticalAlign: "top"
            }
        },
        thead: {
            display: {
                base: "none",
                md: "table-header-group"
            }
        },
        tr: $0422a6ce4ea03acc$var$eF(r, o, s),
        th: $0422a6ce4ea03acc$var$Bw(r, a, o, s),
        td: $0422a6ce4ea03acc$var$Fw(r, a, o, s),
        caption: {
            captionSide: "top",
            color: "ui.typography.heading",
            fontSize: {
                base: "mobile.heading.heading2",
                md: "desktop.heading.heading2"
            },
            fontWeight: "heading.heading2",
            marginBottom: "s",
            marginStart: "0",
            marginEnd: "0",
            marginTop: "0",
            padding: "0",
            textAlign: "left",
            _dark: {
                color: "dark.ui.typography.heading"
            }
        }
    }), $0422a6ce4ea03acc$var$nF = {
    baseStyle: $0422a6ce4ea03acc$var$tF
}, { defineMultiStyleConfig: $0422a6ce4ea03acc$var$rF, definePartsStyle: $0422a6ce4ea03acc$var$aF } = $0422a6ce4ea03acc$var$Y2([
    "fieldset",
    "subLabels"
]), $0422a6ce4ea03acc$var$iF = $0422a6ce4ea03acc$var$rF({
    baseStyle: $0422a6ce4ea03acc$var$aF({
        fieldset: {
            legend: $0422a6ce4ea03acc$var$kc
        },
        subLabels: {
            label: {
                fontSize: "desktop.label.label2",
                fontWeight: "label.secondary",
                marginBottom: "0"
            }
        }
    })
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$oF, definePartsStyle: $0422a6ce4ea03acc$var$lF } = $0422a6ce4ea03acc$var$Y2([
    "closeButton",
    "drawerBody",
    "drawerContent",
    "drawerHeader",
    "openButton"
]), $0422a6ce4ea03acc$var$sF = $0422a6ce4ea03acc$var$oF({
    baseStyle: $0422a6ce4ea03acc$var$lF({
        closeButton: {
            /** This is overriding the default min-height value in order to keep the
       * button spacing symmetrical. */ minHeight: "40px",
            minWidth: "40px",
            right: "xs",
            p: "0",
            position: "absolute",
            span: $0422a6ce4ea03acc$var$u9(),
            top: "xs",
            _dark: {
                svg: {
                    fill: "dark.ui.typography.heading"
                }
            }
        },
        drawerBody: {
            borderLeft: {
                base: void 0,
                md: "1px solid"
            },
            borderColor: {
                base: void 0,
                md: "ui.border.default"
            },
            paddingTop: "m",
            paddingBottom: "m",
            _dark: {
                background: "dark.ui.bg.page",
                borderColor: {
                    base: void 0,
                    md: "dark.ui.border.default"
                }
            }
        },
        drawerContent: {
            marginStart: "auto",
            width: {
                base: "100%",
                md: "375px"
            },
            aside: {
                color: "ui.typography.heading",
                _dark: {
                    color: "dark.ui.typography.heading"
                }
            }
        },
        drawerHeader: {
            alignItems: "baseline",
            background: "ui.bg.hover",
            borderBottomWidth: "1px",
            borderLeftWidth: {
                base: void 0,
                md: "1px"
            },
            borderTopWidth: "1px",
            color: "ui.typography.heading",
            display: "flex",
            fontSize: "desktop.body.body1",
            px: "m",
            paddingTop: "s",
            paddingBottom: "s",
            p: {
                marginBottom: "0"
            },
            _dark: {
                background: "dark.ui.bg.hover",
                borderColor: "dark.ui.border.default",
                color: "dark.ui.typography.heading"
            }
        },
        openButton: {
            position: "fixed",
            borderRadius: "0",
            bottom: "0",
            right: "0",
            zIndex: "5",
            _focus: {
                boxShadow: "0 0 0 6px var(--nypl-colors-ui-white) !important"
            }
        }
    })
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$uF, definePartsStyle: $0422a6ce4ea03acc$var$cF } = $0422a6ce4ea03acc$var$Y2([
    "imgWrapper",
    "text",
    "wrapper"
]), $0422a6ce4ea03acc$var$dF = $0422a6ce4ea03acc$var$uF({
    baseStyle: $0422a6ce4ea03acc$var$cF(({ imagePosition: r, imageWidth: a, isFullWidth: o })=>{
        let s = r === "end", i = o === !0, p = "50%";
        return a === "oneQuarter" ? p = "25%" : a === "oneThird" ? p = "33%" : a === "twoThirds" ? p = "66%" : a === "threeQuarters" && (p = "75%"), {
            base: {
                bgColor: "ui.bg.default",
                left: i ? "50%" : "auto",
                marginLeft: i ? "-50vw" : "auto",
                marginRight: i ? "-50vw" : "auto",
                position: "relative",
                right: i ? "50%" : "auto",
                width: i ? "100vw" : "100%",
                _dark: {
                    bgColor: "dark.ui.bg.default"
                },
                img: $0422a6ce4ea03acc$var$u9()
            },
            wrapper: {
                ...$0422a6ce4ea03acc$var$Ec,
                alignItems: "stretch",
                display: "flex",
                flexDirection: s ? {
                    base: "column-reverse",
                    md: "row-reverse"
                } : {
                    base: "column",
                    md: "row"
                },
                maxWidth: i ? "1280px" : "100%",
                minHeight: "320px",
                paddingLeft: i ? {
                    base: null,
                    md: "s"
                } : null,
                paddingRight: i ? {
                    base: null,
                    md: "s"
                } : null
            },
            text: {
                display: "flex",
                flex: 1,
                flexDirection: "column",
                justifyContent: "center",
                padding: "l",
                /** The `paddingLeft` attribute is used to adjust the spacing around the
           * text when the image is positioned at the end. For aesthetic reasons,
           * we opted to not adjust the spacing around the text when the image is
           * positioned at the start.
           * */ paddingStart: i && s ? {
                    base: null,
                    md: 0
                } : null
            },
            imgWrapper: {
                backgroundPosition: "center",
                backgroundSize: "cover",
                height: {
                    base: "320px",
                    md: "auto"
                },
                width: {
                    base: "100%",
                    md: p
                }
            }
        };
    })
}), $0422a6ce4ea03acc$var$CF = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((r)=>{
        const a = r.isLegendHidden ? $0422a6ce4ea03acc$var$u9() : {};
        return {
            border: 0,
            padding: 0,
            legend: {
                color: "ui.typography.heading",
                ...$0422a6ce4ea03acc$var$hw,
                ...a,
                _dark: {
                    color: "dark.ui.typography.heading"
                }
            }
        };
    })
}), $0422a6ce4ea03acc$var$fF = {
    default: {
        width: {
            base: "100%",
            md: "265px"
        }
    },
    full: {
        width: "100%"
    }
}, $0422a6ce4ea03acc$var$pF = {
    parts: [
        "modalBody",
        "modalHeader",
        "modalFooter",
        "modalCloseButton",
        "globalButtonGroup",
        "globalButtonGroupWrapper"
    ],
    baseStyle: ({ width: r })=>({
            width: "full",
            modalBody: {
                _dark: {
                    background: "dark.ui.bg.page"
                }
            },
            modalHeader: {
                bg: "ui.bg.default",
                _dark: {
                    background: "dark.ui.bg.default",
                    borderBottom: "1px solid",
                    borderColor: "dark.ui.border.default"
                }
            },
            modalFooter: {
                bg: "ui.bg.default",
                _dark: {
                    background: "dark.ui.bg.default",
                    borderTop: "1px solid",
                    borderColor: "dark.ui.border.default",
                    color: "dark.ui.typography.heading"
                }
            },
            modalCloseButton: {
                mt: "8px"
            },
            globalButtonGroupWrapper: {
                ...$0422a6ce4ea03acc$var$fF[r]
            }
        })
}, { defineMultiStyleConfig: $0422a6ce4ea03acc$var$hF, definePartsStyle: $0422a6ce4ea03acc$var$d9 } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "screenreaderOnly"
]), $0422a6ce4ea03acc$var$Ch = {
    textDecoration: "underline",
    textDecorationStyle: "dotted",
    textDecorationThickness: "1px"
}, $0422a6ce4ea03acc$var$_c = {
    color: "ui.link.primary",
    textUnderlineOffset: "2px",
    ...$0422a6ce4ea03acc$var$Ch,
    _dark: {
        color: "dark.ui.link.primary"
    },
    _hover: {
        color: "ui.link.secondary",
        ...$0422a6ce4ea03acc$var$Ch,
        // The dark mode hover color is not being picked up properly down stream, so
        // it is being explicitly added here.
        _dark: {
            color: "dark.ui.link.secondary"
        }
    }
}, $0422a6ce4ea03acc$var$oa = {
    ...$0422a6ce4ea03acc$var$_w,
    display: "inline-flex"
}, $0422a6ce4ea03acc$var$mF = $0422a6ce4ea03acc$var$d9(({ hasVisitedState: r })=>({
        base: {
            alignItems: "center",
            display: "inline-flex",
            svg: {
                height: "s",
                width: "s",
                textDecoration: "none",
                fill: "currentColor"
            },
            _hover: {
                color: "ui.link.secondary",
                textDecoration: "underline",
                textDecorationStyle: "dotted !important",
                textDecorationThickness: "1px !important"
            },
            _visited: r ? {
                svg: {
                    fill: "ui.link.tertiary"
                },
                _dark: {
                    svg: {
                        fill: "dark.ui.link.tertiary"
                    }
                }
            } : {}
        }
    })), $0422a6ce4ea03acc$var$vF = $0422a6ce4ea03acc$var$d9({
    base: {
        width: "100px",
        borderRadius: "sm",
        lineHeight: "1.5",
        display: "flex",
        cursor: "pointer",
        color: "ui.white",
        justifyContent: "center",
        py: "xs",
        px: "xs",
        textDecoration: "none",
        fontWeight: "button.default",
        bg: "ui.link.primary",
        _dark: {
            color: "ui.gray.xxx-dark",
            bg: "dark.ui.link.primary"
        },
        _hover: {
            color: "ui.white",
            bg: "ui.link.secondary",
            textDecoration: "underline",
            textDecorationStyle: "dotted !important",
            textDecorationThickness: "1px !important",
            _dark: {
                color: "ui.gray.xxx-dark",
                bg: "dark.ui.link.secondary"
            }
        },
        _visited: {
            color: "ui.white",
            _dark: {
                _visited: {
                    color: "ui.gray.xxx-dark"
                }
            }
        }
    }
}), $0422a6ce4ea03acc$var$gF = $0422a6ce4ea03acc$var$d9(({ hasVisitedState: r })=>({
        base: {
            ...$0422a6ce4ea03acc$var$oa,
            ...$0422a6ce4ea03acc$var$Ah({}).base,
            _hover: {
                backgroundColor: "ui.link.secondary",
                color: "ui.white",
                textDecoration: "underline",
                textDecorationStyle: "dotted !important",
                textDecorationThickness: "1px !important",
                // The dark mode hover color is not being picked up properly down stream, so
                // it is being explicitly added here.
                _dark: {
                    color: "ui.gray.xxx-dark"
                }
            },
            _visited: r ? {
                color: "ui.white",
                _dark: {
                    color: "ui.gray.xxx-dark"
                }
            } : {}
        }
    })), $0422a6ce4ea03acc$var$yF = $0422a6ce4ea03acc$var$d9(({ hasVisitedState: r })=>({
        base: {
            ...$0422a6ce4ea03acc$var$oa,
            ...$0422a6ce4ea03acc$var$Rw({}).base,
            _hover: {
                backgroundColor: "ui.link.primary-05",
                textDecoration: "underline",
                textDecorationStyle: "dotted !important",
                textDecorationThickness: "1px !important"
            },
            _visited: r ? {
                color: "ui.link.primary",
                _dark: {
                    color: "dark.ui.link.primary"
                }
            } : {}
        }
    })), $0422a6ce4ea03acc$var$LF = $0422a6ce4ea03acc$var$d9(({ hasVisitedState: r })=>({
        base: {
            ...$0422a6ce4ea03acc$var$oa,
            ...$0422a6ce4ea03acc$var$Zw({}).base,
            _hover: {
                color: "ui.black",
                textDecoration: "underline",
                textDecorationStyle: "dotted !important",
                textDecorationThickness: "1px !important",
                // The dark mode hover color is not being picked up properly down stream, so
                // it is being explicitly added here.
                _dark: {
                    color: "dark.ui.typography.heading"
                }
            },
            _visited: r ? {
                color: "ui.black",
                _dark: {
                    color: "ui.white"
                }
            } : {}
        }
    })), $0422a6ce4ea03acc$var$bF = $0422a6ce4ea03acc$var$d9(({ hasVisitedState: r })=>({
        base: {
            ...$0422a6ce4ea03acc$var$oa,
            ...$0422a6ce4ea03acc$var$Ow({}).base,
            _hover: {
                color: "ui.white",
                textDecoration: "underline",
                textDecorationStyle: "dotted !important",
                textDecorationThickness: "1px !important",
                // The dark mode hover color is not being picked up properly down stream, so
                // it is being explicitly added here.
                _dark: {
                    color: "ui.white"
                }
            },
            _visited: r ? {
                color: "ui.white",
                _dark: {
                    color: "ui.white"
                }
            } : {}
        }
    })), $0422a6ce4ea03acc$var$wF = $0422a6ce4ea03acc$var$d9(({ hasVisitedState: r })=>({
        base: {
            ...$0422a6ce4ea03acc$var$oa,
            ...$0422a6ce4ea03acc$var$Nw({}).base,
            _hover: {
                color: "ui.white",
                textDecoration: "underline",
                textDecorationStyle: "dotted !important",
                textDecorationThickness: "1px !important",
                // The dark mode hover color is not being picked up properly down stream, so
                // it is being explicitly added here.
                _dark: {
                    color: "ui.white"
                }
            },
            _visited: r ? {
                color: "ui.white",
                _dark: {
                    color: "ui.white"
                }
            } : {}
        }
    })), $0422a6ce4ea03acc$var$HF = $0422a6ce4ea03acc$var$d9(({ hasVisitedState: r })=>({
        base: {
            ...$0422a6ce4ea03acc$var$oa,
            ...$0422a6ce4ea03acc$var$Ah({}).base,
            bg: "ui.gray.light-cool",
            color: "ui.gray.dark",
            opacity: "1",
            pointerEvents: "none",
            _visited: r ? {
                color: "ui.gray.dark",
                _dark: {
                    color: "dark.ui.disabled.primary"
                }
            } : {},
            _dark: {
                bg: "dark.ui.disabled.secondary",
                color: "dark.ui.disabled.primary"
            }
        }
    })), $0422a6ce4ea03acc$var$xF = $0422a6ce4ea03acc$var$hF({
    baseStyle: $0422a6ce4ea03acc$var$d9(({ finalIsUnderlined: r = !0, hasVisitedState: a })=>({
            base: {
                ...$0422a6ce4ea03acc$var$_c,
                _visited: a ? {
                    color: "ui.link.tertiary",
                    _dark: {
                        color: "dark.ui.link.tertiary"
                    }
                } : {},
                textDecoration: r ? "underline" : "none",
                /** This is needed for custom anchor elements or link components
         * that are passed as children to the `Link` component. */ a: {
                    _hover: {
                        color: "ui.link.secondary"
                    }
                }
            },
            /** The element will handle descriptive text added to aid
       * screen readers. */ screenreaderOnly: $0422a6ce4ea03acc$var$u9()
        })),
    variants: {
        button: $0422a6ce4ea03acc$var$vF,
        buttonCallout: $0422a6ce4ea03acc$var$bF,
        buttonDisabled: $0422a6ce4ea03acc$var$HF,
        buttonNoBrand: $0422a6ce4ea03acc$var$wF,
        buttonPill: $0422a6ce4ea03acc$var$LF,
        buttonPrimary: $0422a6ce4ea03acc$var$gF,
        buttonSecondary: $0422a6ce4ea03acc$var$yF,
        moreLink: $0422a6ce4ea03acc$var$mF
    }
}), $0422a6ce4ea03acc$var$jr = {
    marginTop: "0",
    marginStart: "0",
    marginEnd: "0"
}, { defineMultiStyleConfig: $0422a6ce4ea03acc$var$VF, definePartsStyle: $0422a6ce4ea03acc$var$t6 } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "headingWrapper"
]), $0422a6ce4ea03acc$var$pe = {
    one: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: "heading.primary",
            // var(--nypl-fontSizes-4);
            fontWeight: "heading.primary",
            letterSpacing: "0",
            lineHeight: "1.1",
            ...$0422a6ce4ea03acc$var$jr,
            width: "auto",
            a: {
                textUnderlineOffset: "4px"
            }
        }
    }),
    two: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: "heading.secondary",
            // var(--nypl-fontSizes-3);
            fontWeight: "heading.secondary",
            lineHeight: "1.25",
            ...$0422a6ce4ea03acc$var$jr,
            width: "auto",
            a: {
                textUnderlineOffset: "3px"
            }
        }
    }),
    three: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: "heading.tertiary",
            // var(--nypl-fontSizes-2);
            fontWeight: "heading.tertiary",
            lineHeight: "1.25",
            ...$0422a6ce4ea03acc$var$jr,
            width: "auto"
        }
    }),
    four: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: "heading.callout",
            // var(--nypl-fontSizes-1);
            fontWeight: "heading.callout",
            lineHeight: "1.15",
            ...$0422a6ce4ea03acc$var$jr,
            width: "auto"
        }
    }),
    fallback: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: "1",
            // var(--nypl-fontSizes-1);
            fontWeight: "regular",
            lineHeight: "1.15",
            ...$0422a6ce4ea03acc$var$jr,
            width: "auto"
        }
    }),
    display1: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: {
                base: "mobile.heading.display1",
                md: "desktop.heading.display1"
            },
            fontWeight: "heading.display1",
            letterSpacing: "0.0625rem",
            lineHeight: "1.10",
            width: "auto",
            a: {
                textUnderlineOffset: "7px"
            }
        }
    }),
    heading1: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: {
                base: "mobile.heading.heading1",
                md: "desktop.heading.heading1"
            },
            fontWeight: "heading.heading1",
            letterSpacing: "0.0625rem",
            lineHeight: "1.15",
            width: "auto",
            a: {
                textUnderlineOffset: "6px"
            }
        }
    }),
    heading2: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: {
                base: "mobile.heading.heading2",
                md: "desktop.heading.heading2"
            },
            fontWeight: "heading.heading2",
            letterSpacing: "0.0625rem",
            lineHeight: "1.20",
            width: "auto",
            a: {
                textUnderlineOffset: "5px"
            }
        }
    }),
    heading3: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: {
                base: "mobile.heading.heading3",
                md: "desktop.heading.heading3"
            },
            fontWeight: "heading.heading3",
            letterSpacing: "0",
            lineHeight: "1.25",
            width: "auto",
            a: {
                textUnderlineOffset: "4px"
            }
        }
    }),
    heading4: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: {
                base: "mobile.heading.heading4",
                md: "desktop.heading.heading4"
            },
            fontWeight: "heading.heading4",
            letterSpacing: "0",
            lineHeight: "1.30",
            width: "auto",
            a: {
                textUnderlineOffset: "3px"
            }
        }
    }),
    heading5: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: {
                base: "mobile.heading.heading5",
                md: "desktop.heading.heading5"
            },
            fontWeight: "heading.heading5",
            letterSpacing: "0",
            lineHeight: "1.35",
            width: "auto"
        }
    }),
    heading6: $0422a6ce4ea03acc$var$t6({
        base: {
            fontSize: {
                base: "mobile.heading.heading6",
                md: "desktop.heading.heading6"
            },
            fontWeight: "heading.heading6",
            letterSpacing: "0",
            lineHeight: "1.40",
            width: "auto"
        }
    })
}, $0422a6ce4ea03acc$var$MF = {
    // RECOMMENDED options for native heading element variants
    h1: $0422a6ce4ea03acc$var$pe.heading1,
    h2: $0422a6ce4ea03acc$var$pe.heading2,
    h3: $0422a6ce4ea03acc$var$pe.heading3,
    h4: $0422a6ce4ea03acc$var$pe.heading4,
    h5: $0422a6ce4ea03acc$var$pe.heading5,
    h6: $0422a6ce4ea03acc$var$pe.heading6,
    // DEPRECATED options for native heading elements variants
    one: $0422a6ce4ea03acc$var$pe.one,
    two: $0422a6ce4ea03acc$var$pe.two,
    three: $0422a6ce4ea03acc$var$pe.three,
    four: $0422a6ce4ea03acc$var$pe.four,
    five: $0422a6ce4ea03acc$var$pe.fallback,
    six: $0422a6ce4ea03acc$var$pe.fallback,
    // RECOMMENDED options for size variants
    display1: $0422a6ce4ea03acc$var$pe.display1,
    heading1: $0422a6ce4ea03acc$var$pe.heading1,
    heading2: $0422a6ce4ea03acc$var$pe.heading2,
    heading3: $0422a6ce4ea03acc$var$pe.heading3,
    heading4: $0422a6ce4ea03acc$var$pe.heading4,
    heading5: $0422a6ce4ea03acc$var$pe.heading5,
    heading6: $0422a6ce4ea03acc$var$pe.heading6,
    // DEPRECATED options for size variants
    primary: $0422a6ce4ea03acc$var$pe.one,
    secondary: $0422a6ce4ea03acc$var$pe.two,
    tertiary: $0422a6ce4ea03acc$var$pe.three,
    callout: $0422a6ce4ea03acc$var$pe.four
}, $0422a6ce4ea03acc$var$EF = $0422a6ce4ea03acc$var$VF({
    baseStyle: $0422a6ce4ea03acc$var$t6(({ isCapitalized: r, isUppercase: a, isLowercase: o, noSpace: s })=>({
            base: {
                "a:only-child": {
                    ...$0422a6ce4ea03acc$var$_c,
                    textDecoration: "none"
                },
                color: "ui.typography.heading",
                margin: "0",
                textTransform: r ? "capitalize" : a ? "uppercase" : o ? "lowercase" : null,
                _dark: {
                    color: "dark.ui.typography.heading"
                }
            },
            headingWrapper: {
                marginBottom: s ? "0" : "s",
                ...$0422a6ce4ea03acc$var$jr
            }
        })),
    // Available variants:
    // h1, h2, h3, h4, h5, h6
    // display1, heading1, heading2, heading3, heading4, heading5, heading6
    // DEPRECATED: one, two, three, four, five, six
    // DEPRECATED: primary, secondary, tertiary, callout
    variants: $0422a6ce4ea03acc$var$MF,
    defaultProps: {
        variant: "h2"
    }
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$SF, definePartsStyle: $0422a6ce4ea03acc$var$kF } = $0422a6ce4ea03acc$var$Y2([
    "innerChild"
]), $0422a6ce4ea03acc$var$TF = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginTop: "xxs",
    marginBottom: "0"
}), $0422a6ce4ea03acc$var$_F = $0422a6ce4ea03acc$var$kF(({ isInvalid: r })=>({
        fontSize: "desktop.helper.default",
        color: r ? "ui.error.primary" : null,
        _dark: {
            color: r ? "dark.ui.error.primary" : null
        },
        innerChild: $0422a6ce4ea03acc$var$TF
    })), $0422a6ce4ea03acc$var$DF = $0422a6ce4ea03acc$var$SF({
    baseStyle: $0422a6ce4ea03acc$var$_F
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$RF, definePartsStyle: $0422a6ce4ea03acc$var$w0 } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "bodyText",
    "content",
    "heading",
    "imgWrapper",
    "interior"
]), $0422a6ce4ea03acc$var$ZF = $0422a6ce4ea03acc$var$w0({
    base: {
        overflowX: "hidden",
        bgColor: "ui.bg.default",
        _dark: {
            bgColor: "dark.ui.bg.default"
        }
    },
    content: {
        ...$0422a6ce4ea03acc$var$Ec,
        paddingEnd: "inset.default",
        paddingStart: "inset.default",
        display: "flex",
        flexFlow: {
            base: "column nowrap",
            md: "row wrap"
        }
    },
    imgWrapper: {
        marginEnd: {
            base: "calc(-50vw + 50%)",
            md: "0"
        },
        marginStart: {
            base: "calc(-50vw + 50%)",
            md: "0"
        },
        flex: {
            base: "1 1 100%",
            md: "0 0 250px"
        },
        order: {
            base: "2",
            md: "3"
        },
        img: {
            height: "150px",
            minWidth: "0",
            // https://github.com/philipwalton/flexbugs/issues/41
            objectFit: "cover",
            width: "100%"
        }
    },
    bodyText: {
        paddingBottom: "inset.default",
        paddingEnd: {
            md: "inset.default"
        },
        paddingTop: "inset.default",
        flex: {
            md: "1 1 50%"
        },
        order: {
            base: "3",
            md: "2"
        }
    }
}), $0422a6ce4ea03acc$var$nb = {
    marginBottom: "0",
    color: "ui.typography.inverse.heading",
    flex: "1 1 100%",
    marginTop: "0",
    paddingBottom: "xxs",
    position: "relative",
    zIndex: "0",
    order: "1",
    _before: {
        content: '""',
        height: "100%",
        left: "-2000px",
        position: "absolute",
        width: "4000px",
        zIndex: "-1"
    },
    _dark: {
        color: "dark.ui.typography.heading"
    }
}, $0422a6ce4ea03acc$var$Yo = (r = "")=>{
    const a = {
        light: r || "ui.black",
        dark: r ? `dark.${r}` : "dark.ui.bg.active"
    };
    return {
        ...$0422a6ce4ea03acc$var$ZF,
        heading: {
            ...$0422a6ce4ea03acc$var$nb,
            color: r ? "ui.white" : "ui.typography.inverse.heading",
            _before: {
                ...$0422a6ce4ea03acc$var$nb._before,
                bg: a.light
            },
            _dark: {
                color: "dark.ui.typography.heading",
                _before: {
                    bg: a.dark
                }
            }
        }
    };
}, $0422a6ce4ea03acc$var$r6 = (r, a, o, s)=>{
    const i = a === "dark" ? "dark.ui." : "ui.", p = o || (s ? `${i}typography.${r}` : `${i}typography.inverse.${r}`), C = o || (s ? `${i}typography.inverse.${r}` : `${i}typography.${r}`);
    return a === "dark" ? C : p;
}, $0422a6ce4ea03acc$var$r5 = (r, a, o)=>{
    let s;
    switch(r){
        case "hover":
            s = a || (o ? "var(--nypl-colors-ui-link-secondary) !important" : "dark.ui.link.secondary");
            break;
        case "visited":
            s = a || (o ? "var(--nypl-colors-ui-link-tertiary) !important" : "dark.ui.link.tertiary");
            break;
        case "default":
        default:
            s = a || (o ? "var(--nypl-colors-ui-link-primary) !important" : "dark.ui.link.primary");
    }
    return s;
}, $0422a6ce4ea03acc$var$OF = $0422a6ce4ea03acc$var$w0(({ foregroundColor: r, isDarkText: a })=>({
        base: {
            alignItems: "center",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            flexFlow: {
                base: "column nowrap",
                md: "row nowrap"
            },
            justifyContent: "center",
            minHeight: "352px",
            p: "l"
        },
        content: {
            bg: "ui.black",
            color: $0422a6ce4ea03acc$var$r6("body", "light", r, a),
            flex: {
                base: "0 0 100%",
                md: "0 0 60%"
            },
            maxWidth: {
                md: "960px"
            },
            paddingTop: "inset.extrawide",
            paddingBottom: "inset.extrawide",
            paddingEnd: "inset.wide",
            paddingStart: "inset.wide",
            a: {
                color: "inherit",
                display: "inline-block"
            },
            bodyText: {
                marginBottom: "0"
            },
            ".chakra-heading": {
                color: $0422a6ce4ea03acc$var$r6("heading", "light", r, a)
            },
            _dark: {
                bgColor: "dark.ui.bg.default",
                color: $0422a6ce4ea03acc$var$r6("body", "dark", r, a),
                ".chakra-heading": {
                    color: $0422a6ce4ea03acc$var$r6("heading", "dark", r, a)
                }
            }
        },
        heading: {
            color: $0422a6ce4ea03acc$var$r6("heading", "dark", r, a)
        }
    })), $0422a6ce4ea03acc$var$NF = $0422a6ce4ea03acc$var$Yo(), $0422a6ce4ea03acc$var$PF = $0422a6ce4ea03acc$var$Yo("section.books-and-more.primary"), $0422a6ce4ea03acc$var$BF = $0422a6ce4ea03acc$var$w0($0422a6ce4ea03acc$var$Yo("section.locations.primary")), $0422a6ce4ea03acc$var$FF = $0422a6ce4ea03acc$var$w0($0422a6ce4ea03acc$var$Yo("section.research.primary")), $0422a6ce4ea03acc$var$AF = $0422a6ce4ea03acc$var$w0($0422a6ce4ea03acc$var$Yo("section.whats-on.primary")), $0422a6ce4ea03acc$var$jF = $0422a6ce4ea03acc$var$w0(({ foregroundColor: r, isDarkText: a })=>({
        base: {
            // Is this needed?
            p: {
                marginBottom: "0"
            }
        },
        content: {
            ...$0422a6ce4ea03acc$var$Ec,
            color: $0422a6ce4ea03acc$var$r6("body", "light", r, a),
            display: "flex",
            flexFlow: "column nowrap",
            px: "inset.default",
            py: {
                base: "inset.default",
                xl: "inset.wide"
            },
            a: {
                color: $0422a6ce4ea03acc$var$r5("default", r, a),
                _hover: {
                    color: $0422a6ce4ea03acc$var$r5("hover", r, a)
                },
                _visited: {
                    color: $0422a6ce4ea03acc$var$r5("visited", r, a),
                    svg: {
                        fill: $0422a6ce4ea03acc$var$r5("visited", r, a)
                    }
                }
            },
            p: {
                marginBottom: "0",
                marginTop: {
                    base: "xxs",
                    xl: "xs"
                }
            },
            ".chakra-heading": {
                color: $0422a6ce4ea03acc$var$r6("heading", "light", r, a)
            },
            _dark: {
                a: {
                    color: $0422a6ce4ea03acc$var$r5("default", r, a),
                    _hover: {
                        color: $0422a6ce4ea03acc$var$r5("hover", r, a)
                    },
                    _visited: {
                        color: $0422a6ce4ea03acc$var$r5("visited", r, a),
                        svg: {
                            fill: $0422a6ce4ea03acc$var$r5("visited", r, a)
                        }
                    }
                },
                p: {
                    color: $0422a6ce4ea03acc$var$r6("body", "dark", r, a)
                },
                ".chakra-heading": {
                    color: $0422a6ce4ea03acc$var$r6("heading", "dark", r, a)
                }
            }
        },
        heading: {
            color: "ui.typography.inverse.heading",
            marginBottom: "0",
            _lastChild: {
                marginBottom: "0"
            }
        }
    })), $0422a6ce4ea03acc$var$zF = $0422a6ce4ea03acc$var$w0(({ foregroundColor: r, isDarkText: a })=>({
        base: {
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            padding: {
                base: "inset.wide",
                md: "calc(var(--nypl-space-xxl) + var(--nypl-space-s)) var(--nypl-space-s) 0"
            },
            position: "relative",
            a: {
                color: "inherit",
                display: "inline-block"
            },
            img: $0422a6ce4ea03acc$var$u9()
        },
        content: {
            alignItems: "stretch",
            bg: "ui.black",
            color: $0422a6ce4ea03acc$var$r6("body", "light", r, a),
            display: "flex",
            flexFlow: {
                base: "column nowrap",
                lg: "row nowrap"
            },
            minHeight: "320px",
            flex: {
                md: "0 100%"
            },
            maxWidth: {
                md: "1248px"
            },
            position: {
                md: "relative"
            },
            zIndex: 2,
            a: {
                color: $0422a6ce4ea03acc$var$r5("default", r, a),
                _hover: {
                    color: $0422a6ce4ea03acc$var$r5("hover", r, a)
                },
                _visited: {
                    color: $0422a6ce4ea03acc$var$r5("visited", r, a),
                    svg: {
                        fill: $0422a6ce4ea03acc$var$r5("visited", r, a)
                    }
                }
            },
            ".chakra-heading": {
                color: $0422a6ce4ea03acc$var$r6("heading", "light", r, a)
            },
            _dark: {
                color: $0422a6ce4ea03acc$var$r6("body", "dark", r, a),
                a: {
                    color: $0422a6ce4ea03acc$var$r5("default", r, a),
                    _hover: {
                        color: $0422a6ce4ea03acc$var$r5("hover", r, a)
                    },
                    _visited: {
                        color: $0422a6ce4ea03acc$var$r5("visited", r, a),
                        svg: {
                            fill: $0422a6ce4ea03acc$var$r5("visited", r, a)
                        }
                    }
                },
                ".chakra-heading": {
                    color: $0422a6ce4ea03acc$var$r6("heading", "dark", r, a)
                }
            }
        },
        heading: {
            color: "ui.typography.inverse.heading"
        },
        imgWrapper: {
            backgroundPosition: "center",
            backgroundSize: "cover",
            minHeight: "230px",
            width: {
                base: "100%",
                lg: "50%"
            }
        },
        interior: {
            alignSelf: "center",
            maxWidth: {
                md: "960px"
            },
            padding: {
                base: "inset.default",
                md: "inset.wide"
            },
            width: {
                base: "100%",
                lg: "50%"
            }
        }
    })), $0422a6ce4ea03acc$var$UF = $0422a6ce4ea03acc$var$w0({
    base: {
        img: $0422a6ce4ea03acc$var$u9()
    },
    content: {
        ...$0422a6ce4ea03acc$var$Ec,
        alignItems: "stretch",
        display: "flex",
        flexFlow: {
            base: "column nowrap",
            lg: "row nowrap"
        }
    },
    imgWrapper: {
        backgroundPosition: "center",
        backgroundSize: "cover",
        minHeight: "160px",
        width: {
            base: "100%",
            lg: "50%"
        }
    },
    bodyText: {
        alignSelf: "center",
        maxWidth: {
            md: "960px"
        },
        padding: {
            base: "inset.default",
            md: "inset.wide"
        },
        width: {
            base: "100%",
            lg: "50%"
        }
    }
}), $0422a6ce4ea03acc$var$IF = $0422a6ce4ea03acc$var$RF({
    baseStyle: {},
    // Available variants:
    variants: {
        primary: $0422a6ce4ea03acc$var$OF,
        secondary: $0422a6ce4ea03acc$var$NF,
        secondaryBooksAndMore: $0422a6ce4ea03acc$var$PF,
        secondaryLocations: $0422a6ce4ea03acc$var$BF,
        secondaryResearch: $0422a6ce4ea03acc$var$FF,
        secondaryWhatsOn: $0422a6ce4ea03acc$var$AF,
        tertiary: $0422a6ce4ea03acc$var$jF,
        campaign: $0422a6ce4ea03acc$var$zF,
        fiftyFifty: $0422a6ce4ea03acc$var$UF
    }
}), $0422a6ce4ea03acc$var$$F = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((r)=>({
            bg: "ui.bg.hover",
            border: "0",
            height: "2px",
            marginBottom: "s",
            marginTop: "s",
            marginStart: r.align === "left" ? 0 : "auto",
            marginEnd: r.align === "right" ? 0 : "auto",
            _dark: {
                bg: "dark.ui.bg.active"
            }
        }))
}), $0422a6ce4ea03acc$var$YF = {
    display: "inline-block",
    fill: "currentColor",
    width: "auto",
    height: "100%"
}, $0422a6ce4ea03acc$var$WF = {
    none: {},
    left: {
        marginEnd: "xxs"
    },
    right: {
        marginStart: "xxs"
    }
}, $0422a6ce4ea03acc$var$QF = {
    rotate180: {
        transform: "rotate(180deg)"
    },
    rotate270: {
        transform: "rotate(270deg)"
    },
    rotate0: {
        transform: "rotate(0deg)"
    },
    rotate90: {
        transform: "rotate(90deg)"
    }
}, $0422a6ce4ea03acc$var$qF = {
    xxxlarge: {
        height: "var(--nypl-space-xxl)",
        width: "var(--nypl-space-xxl)"
    },
    xxlarge: {
        height: "var(--nypl-space-xl)",
        width: "var(--nypl-space-xl)"
    },
    xlarge: {
        height: "var(--nypl-space-l)",
        width: "var(--nypl-space-l)"
    },
    large: {
        height: "var(--nypl-space-m)",
        width: "var(--nypl-space-m)"
    },
    default: {
        width: "100%"
    },
    medium: {
        height: "1.125rem",
        width: "1.125rem"
    },
    small: {
        height: "0.875rem",
        width: "0.875rem"
    },
    xsmall: {
        height: "0.65rem",
        width: "0.65rem"
    }
}, $0422a6ce4ea03acc$var$GF = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((r)=>{
        const a = {
            ...$0422a6ce4ea03acc$var$YF,
            ...$0422a6ce4ea03acc$var$WF[r.align],
            fill: r.color,
            ...$0422a6ce4ea03acc$var$QF[r.iconRotation],
            ...$0422a6ce4ea03acc$var$qF[r.size]
        };
        return {
            ...a,
            // We still want to style any custom SVG element that was
            // passed to the `Icon` component.
            svg: {
                ...a
            }
        };
    }),
    variants: {
        default: {},
        breadcrumbs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
            fill: "var(--nypl-colors-ui-white)",
            display: {
                md: "none"
            }
        })
    }
}), $0422a6ce4ea03acc$var$XF = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((r)=>({
            ...$0422a6ce4ea03acc$var$hw,
            flex: r.isInlined ? "1" : null,
            whiteSpace: r.isInlined ? "nowrap" : null
        }))
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$KF, definePartsStyle: $0422a6ce4ea03acc$var$Wu } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "heading"
]), $0422a6ce4ea03acc$var$mc = (r = {})=>({
        // Browser automatically applies margin, so by default we unset it.
        margin: r.noStyling ? "0" : "unset",
        listStyle: r.noStyling ? "none" : null,
        marginInlineStart: "unset",
        paddingStart: r.noStyling ? "0" : "l",
        padding: r.noStyling ? "0" : null,
        display: r.inline ? "flex" : null,
        li: {
            marginEnd: r.inline ? "xs" : null,
            listStyleType: r.inline ? "none" : null,
            _notFirst: {
                marginTop: r.inline ? null : "xxs"
            }
        }
    }), $0422a6ce4ea03acc$var$Aw = (r = !0)=>({
        borderTop: r ? "3px solid" : "none",
        borderColor: "ui.border.default",
        margin: "0",
        padding: "var(--nypl-space-xs) 0 0",
        _dark: {
            borderColor: "dark.ui.border.default"
        }
    }), $0422a6ce4ea03acc$var$jw = (r = !0)=>({
        borderBottom: r ? "1px solid" : "none",
        borderColor: "ui.border.default",
        paddingStart: "0",
        h2: $0422a6ce4ea03acc$var$Aw(r),
        _dark: {
            borderColor: "dark.ui.border.default"
        }
    }), $0422a6ce4ea03acc$var$jh = (r = {})=>({
        ...$0422a6ce4ea03acc$var$$r,
        listStyle: "none",
        li: {
            _before: {
                color: "ui.border.hover",
                // \2022 is the CSS Code/unicode for a bullet.
                content: r.noStyling ? "unset" : '"\\2022"',
                // Needed to add space between the bullet and the text.
                display: "inline-block",
                fontWeight: "bold",
                fontSize: "2",
                lineHeight: "0.9",
                marginStart: "-1rem",
                width: "1rem"
            },
            _dark: {
                _before: {
                    color: "ui.gray.semi-dark"
                }
            }
        }
    }), $0422a6ce4ea03acc$var$Ku = (r = !0)=>({
        ...$0422a6ce4ea03acc$var$jw(r),
        dl: {
            display: "grid",
            gridTemplateColumns: {
                base: "100%",
                md: "max(250px) 1fr"
            },
            gridTemplateRows: "1fr",
            margin: "var(--nypl-space-xs) 0 0"
        },
        dt: {
            borderTop: r ? "1px solid" : "none",
            borderColor: "ui.border.default",
            color: "ui.typography.heading",
            fontWeight: "label.default",
            paddingBottom: {
                base: "0",
                md: "s"
            },
            paddingTop: "s",
            paddingEnd: {
                md: "table.column"
            },
            _dark: {
                borderColor: "dark.ui.border.default",
                color: "dark.ui.typography.heading"
            }
        },
        dd: {
            margin: "0",
            paddingBottom: "s",
            borderTop: {
                base: "none",
                md: r ? "1px solid" : "none"
            },
            borderColor: {
                md: "ui.border.default"
            },
            paddingTop: {
                md: "s"
            },
            _dark: {
                borderColor: {
                    md: "dark.ui.border.default"
                }
            }
        }
    }), $0422a6ce4ea03acc$var$JF = $0422a6ce4ea03acc$var$KF({
    baseStyle: $0422a6ce4ea03acc$var$Wu(({ inline: r, noStyling: a })=>({
            base: $0422a6ce4ea03acc$var$mc({
                inline: r,
                noStyling: a
            }),
            heading: $0422a6ce4ea03acc$var$Aw()
        })),
    variants: {
        ul: $0422a6ce4ea03acc$var$Wu((r)=>({
                base: $0422a6ce4ea03acc$var$jh(r)
            })),
        ol: $0422a6ce4ea03acc$var$Wu({
            base: $0422a6ce4ea03acc$var$$r
        }),
        dl: ({ showRowDividers: r })=>$0422a6ce4ea03acc$var$Wu({
                base: $0422a6ce4ea03acc$var$Ku(r)
            })
    }
}), $0422a6ce4ea03acc$var$eA = (r)=>({
        display: "inline-block",
        height: r === "width" ? "auto" : "100%",
        width: r === "width" ? "100%" : "auto"
    }), $0422a6ce4ea03acc$var$tA = {
    default: {
        maxWidth: "100%"
    },
    xxsmall: {
        maxWidth: "64px"
    },
    xsmall: {
        maxWidth: "96px"
    },
    small: {
        maxWidth: "165px"
    },
    medium: {
        maxWidth: "225px"
    },
    large: {
        maxWidth: "360px"
    },
    xlarge: {
        maxWidth: "360px"
    },
    xxlarge: {
        height: "var(--nypl-space-xl)",
        width: "var(--nypl-space-xl)"
    },
    xxxlarge: {
        height: "var(--nypl-space-xxl)",
        width: "var(--nypl-space-xxl)"
    }
}, $0422a6ce4ea03acc$var$nA = {
    default: {
        maxHeight: "100%"
    },
    xxsmall: {
        maxHeight: "64px"
    },
    xsmall: {
        maxHeight: "96px"
    },
    small: {
        maxHeight: "165px"
    },
    medium: {
        maxHeight: "225px"
    },
    large: {
        maxHeight: "360px"
    },
    xlarge: {
        maxHeight: "360px"
    },
    xxlarge: {
        height: "var(--nypl-space-xl)",
        width: "var(--nypl-space-xl)"
    },
    xxxlarge: {
        height: "var(--nypl-space-xxl)",
        width: "var(--nypl-space-xxl)"
    }
}, $0422a6ce4ea03acc$var$rA = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((r)=>{
        const a = {
            ...$0422a6ce4ea03acc$var$eA(r.sizeBasedOn),
            ...r.sizeBasedOn === "width" ? $0422a6ce4ea03acc$var$tA[r.size] : $0422a6ce4ea03acc$var$nA[r.size]
        };
        return {
            ...a,
            // We still want to style any custom SVG element that was
            // passed to the `Logo` component.
            svg: {
                ...a
            }
        };
    })
}), $0422a6ce4ea03acc$var$aA = {
    blogs: {
        primary: "section.blogs.primary",
        secondary: "section.blogs.secondary"
    },
    booksAndMore: {
        primary: "section.books-and-more.primary",
        secondary: "section.books-and-more.secondary"
    },
    brand: {
        primary: "brand.primary",
        secondary: "brand.secondary"
    },
    connect: {
        primary: "section.connect.primary",
        secondary: "section.connect.secondary"
    },
    education: {
        primary: "section.education.primary",
        secondary: "section.education.secondary"
    },
    locations: {
        primary: "section.locations.primary",
        secondary: "section.locations.secondary"
    },
    research: {
        primary: "section.research.primary",
        secondary: "section.research.secondary"
    },
    researchLibraryLpa: {
        primary: "section.research-library.lpa",
        secondary: null
    },
    researchLibrarySchomburg: {
        primary: "section.research-library.schomburg",
        secondary: null
    },
    researchLibrarySchwarzman: {
        primary: "section.research-library.schwarzman",
        secondary: null
    },
    whatsOn: {
        primary: "section.whats-on.primary",
        secondary: "section.whats-on.secondary"
    }
};
function $0422a6ce4ea03acc$var$Ju({ type: r, colorValue: a, isDark: o }) {
    let s = $0422a6ce4ea03acc$var$aA[r];
    return a && (s = o ? `dark.${s[a]}` : s[a]), s;
}
const { defineMultiStyleConfig: $0422a6ce4ea03acc$var$iA, definePartsStyle: $0422a6ce4ea03acc$var$oA } = $0422a6ce4ea03acc$var$Y2([
    "groupItem",
    "actionItem",
    "dividerItem",
    "selected",
    "menuButton",
    "menuList"
]), $0422a6ce4ea03acc$var$lA = $0422a6ce4ea03acc$var$iA({
    baseStyle: $0422a6ce4ea03acc$var$oA(({ highlightColor: r = "blogs", showBorder: a, showLabel: o })=>{
        const s = $0422a6ce4ea03acc$var$Ju({
            type: r,
            colorValue: r === "blogs" || r === "research" ? "secondary" : "primary"
        }), i = `${s}-05`, p = `dark.${s}-10`;
        return {
            groupItem: {
                paddingY: "xs",
                paddingX: "s",
                lineHeight: "18px",
                fontWeight: "510",
                fontSize: "desktop.caption",
                textColor: "ui.typography.heading",
                margin: "0px",
                _dark: {
                    textColor: "dark.ui.typography.body",
                    bg: "dark.ui.bg.default"
                }
            },
            dividerItem: {
                margin: "0px",
                _dark: {
                    textColor: "dark.ui.typography.body",
                    bg: "dark.ui.bg.default"
                }
            },
            actionItem: {
                outline: "none !important",
                textColor: "ui.typography.body",
                paddingY: "xs",
                paddingX: "s",
                fontSize: "desktop.body.body2",
                fontWeight: "body.body2",
                _hover: {
                    fontWeight: 510,
                    bg: "ui.bg.hover"
                },
                _focus: {
                    fontWeight: 510,
                    bg: "ui.bg.hover"
                },
                _dark: {
                    textColor: "dark.ui.typography.body",
                    bg: "dark.ui.bg.default",
                    "> div > svg": {
                        fill: "dark.ui.typography.body"
                    },
                    _hover: {
                        textColor: "dark.ui.typography.heading",
                        fontWeight: 510,
                        bg: "dark.ui.bg.active"
                    },
                    _focus: {
                        textColor: "dark.ui.typography.heading",
                        fontWeight: 510,
                        bg: "dark.ui.bg.active"
                    }
                }
            },
            selected: {
                fontWeight: 510,
                borderLeftColor: r === "blogs" ? "dark.ui.border.default" : r === "whatsOn" ? "dark.section.whatsOn.primary" : s,
                textColor: r === "blogs" || r === "connect" ? "ui.typography.heading" : s,
                borderWidth: "0px 0px 0px 2px",
                background: r === "blogs" ? "ui.bg.default" : i,
                _dark: {
                    textColor: "dark.ui.typography.heading",
                    _hover: {
                        textColor: "dark.ui.typography.heading",
                        fontWeight: 510,
                        background: r === "blogs" ? "ui.bg.hover" : i
                    },
                    _focus: {
                        textColor: "dark.ui.typography.heading",
                        fontWeight: 510,
                        bg: "dark.ui.bg.active"
                    },
                    background: r === "whatsOn" || r === "blogs" ? "dark.ui.bg.hover" : p
                }
            },
            menuButton: {
                minHeight: {
                    base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
                    md: "40px"
                },
                minWidth: {
                    base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
                    md: "40px"
                },
                whiteSpace: "nowrap",
                paddingY: o ? "xs" : "unset",
                paddingX: o ? "s" : "unset",
                borderRadius: "2px",
                fontSize: "desktop.button.default",
                textColor: a ? "ui.typography.heading" : "ui.link.primary",
                border: a ? "1px solid" : "unset",
                borderColor: "ui.border.default",
                _hover: {
                    bg: "ui.link.primary-05",
                    textColor: a ? "ui.typography.heading" : "ui.link.secondary",
                    borderColor: "ui.border.hover",
                    "> span > svg ": {
                        fill: a ? "ui.typography.heading" : o ? "ui.link.secondary" : "ui.black"
                    }
                },
                _active: {
                    bg: "ui.link.primary-05",
                    textColor: a ? "ui.typography.heading" : "ui.link.secondary",
                    borderColor: "ui.border.hover",
                    "> span > svg ": {
                        fill: a ? "ui.typography.heading" : o ? "ui.link.secondary" : "ui.black"
                    }
                },
                "> span ": {
                    alignItems: o ? void 0 : "center",
                    display: o ? void 0 : "flex",
                    justifyContent: o ? void 0 : "center"
                },
                "> span > svg ": {
                    fill: a ? "ui.typography.heading" : o ? "ui.link.primary" : "ui.typography.heading"
                },
                _dark: {
                    textColor: a ? "dark.ui.typography.heading" : "dark.ui.link.primary",
                    borderColor: a ? "dark.ui.border.default" : "unset",
                    _hover: {
                        bg: "dark.ui.link.primary-10",
                        borderColor: a ? "dark.ui.border.hover" : "unset",
                        textColor: a ? "dark.ui.typography.heading" : "dark.ui.link.secondary"
                    },
                    _active: {
                        bg: "dark.ui.link.primary-10"
                    },
                    "> span > svg": {
                        fill: "dark.ui.typography.heading"
                    }
                }
            },
            menuList: {
                minWidth: "200px",
                outline: "0px",
                maxWidth: "300px",
                padding: "0px",
                borderRadius: "2px",
                border: "1px solid",
                borderColor: "ui.gray.light-cool",
                _dark: {
                    borderColor: "dark.ui.border-default",
                    bgColor: "dark.ui.bg.default"
                },
                boxShadow: "none",
                overflowY: "auto",
                maxHeight: "320px"
            }
        };
    })
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$sA, definePartsStyle: $0422a6ce4ea03acc$var$uA } = $0422a6ce4ea03acc$var$Y2([
    "header",
    "overlay",
    "dialogContainer",
    "dialog",
    "closeButton",
    "body",
    "footer"
]), $0422a6ce4ea03acc$var$cA = $0422a6ce4ea03acc$var$sA({
    baseStyle: $0422a6ce4ea03acc$var$uA({
        dialog: {
            _dark: {
                bg: "dark.ui.bg.default"
            }
        },
        header: {
            color: "ui.typography.heading",
            fontWeight: "medium",
            _dark: {
                color: "dark.ui.typography.heading"
            }
        },
        body: {
            _dark: {
                color: "dark.ui.typography.body"
            }
        }
    })
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$dA, definePartsStyle: $0422a6ce4ea03acc$var$CA } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "accordionStyles",
    "buttonTextLabel",
    "menuChildren",
    "menuSearchInputBox",
    "viewAllButton"
]), $0422a6ce4ea03acc$var$fA = {
    fitContent: {
        width: {
            base: "100%",
            md: "fit-content"
        },
        minWidth: {
            md: "175px"
        },
        maxWidth: {
            md: "360px"
        }
    },
    full: {
        width: "100%"
    }
}, $0422a6ce4ea03acc$var$pA = $0422a6ce4ea03acc$var$dA({
    baseStyle: $0422a6ce4ea03acc$var$CA(({ isBlockElement: r, width: a = "full" })=>({
            base: {
                position: "relative"
            },
            menuChildren: {
                paddingLeft: "m",
                marginBottom: 0
            },
            viewAllButton: {
                color: "ui.link.primary",
                marginLeft: "-4px",
                px: "xs",
                py: "xxs",
                _hover: {
                    bg: "ui.link.primary-05"
                },
                _dark: {
                    color: "dark.ui.link.primary",
                    _hover: {
                        bg: "dark.ui.link.primary-10"
                    }
                }
            },
            buttonTextLabel: {
                marginBottom: 0,
                ...a === "fitContent" && {
                    textOverflow: "ellipsis",
                    overflow: "hidden"
                },
                marginLeft: "56px"
            },
            menuSearchInputBox: {
                input: {
                    backgroundColor: "ui.bg.default",
                    border: "none"
                }
            },
            accordionStyles: {
                ".chakra-accordion__item": {
                    _dark: {
                        bgColor: "transparent"
                    }
                },
                ".chakra-accordion__button": {
                    backgroundColor: "ui.white",
                    fontWeight: "default",
                    minWidth: a === "full" ? "100%" : "175px",
                    position: "relative",
                    width: a === "full" ? "100%" : {
                        base: "100%",
                        md: "fit-content"
                    },
                    overflow: "hidden",
                    zIndex: 1e4,
                    div: {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    },
                    span: {
                        overflow: "hidden"
                    },
                    _hover: {
                        backgroundColor: "ui.white"
                    },
                    _dark: {
                        backgroundColor: "dark.ui.bg.default",
                        borderStartColor: "dark.ui.border.default",
                        borderStartWidth: "1px",
                        _hover: {
                            borderStartColor: "ui.gray.dark"
                        }
                    },
                    _expanded: {
                        bgColor: "ui.link.primary-05",
                        _dark: {
                            bgColor: "dark.ui.link.primary-10"
                        }
                    }
                },
                ".chakra-collapse": {
                    bgColor: "ui.bg.page",
                    overflow: "unset !important",
                    borderTopWidth: "1px",
                    marginTop: "-1px",
                    position: r ? null : "absolute",
                    zIndex: 10001,
                    ...$0422a6ce4ea03acc$var$fA[a]
                },
                ".chakra-accordion__panel": {
                    bgColor: "ui.white",
                    _dark: {
                        bgColor: "dark.ui.bg.page"
                    }
                }
            }
        }))
}), $0422a6ce4ea03acc$var$hA = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)(({ isOpen: r = !1 })=>({
            alignItems: "center",
            backgroundColor: "ui.gray.light-cool",
            border: "1px",
            borderRadius: "20px",
            borderColor: r ? "ui.border.hover" : "ui.border.default",
            display: "flex",
            flexShrink: 0,
            fontSize: "desktop.caption",
            justifyContent: "flex-end",
            left: "15px",
            marginRight: "xs",
            position: "absolute",
            top: {
                base: "12px",
                md: "10px"
            },
            width: "46px",
            zIndex: 1e4,
            py: "xxxs",
            _focus: {
                // Give the count button a higher index so it can be
                // activated when it is focused.
                zIndex: "10001 !important"
            },
            _hover: {
                borderColor: r ? "ui.gray.xx-dark" : "ui.border.hover"
            },
            svg: {
                marginLeft: "xxs",
                marginRight: "6px",
                marginTop: "0"
            },
            _dark: {
                backgroundColor: "dark.ui.bg.hover",
                borderColor: r ? "dark.ui.border.hover" : "dark.ui.border.default",
                svg: {
                    fill: "dark.ui.typography.heading"
                },
                _hover: {
                    borderColor: r ? "ui.white" : "dark.ui.border.hover"
                }
            }
        }))
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$mA, definePartsStyle: $0422a6ce4ea03acc$var$vA } = $0422a6ce4ea03acc$var$Y2([
    "pitch",
    "privacy",
    "action"
]), $0422a6ce4ea03acc$var$gA = $0422a6ce4ea03acc$var$mA({
    baseStyle: $0422a6ce4ea03acc$var$vA(({ newsletterSignupType: r })=>({
            borderWidth: {
                base: "0px 1px 1px 1px",
                md: "1px 1px 1px 0px"
            },
            width: "100%",
            pitch: {
                alignItems: "flex-start",
                bg: "ui.bg.default",
                borderLeftColor: {
                    md: $0422a6ce4ea03acc$var$Ju({
                        type: r,
                        colorValue: r === "blogs" ? "secondary" : "primary"
                    })
                },
                borderTopColor: {
                    base: $0422a6ce4ea03acc$var$Ju({
                        type: r,
                        colorValue: r === "blogs" ? "secondary" : "primary"
                    }),
                    md: "ui.border.default"
                },
                borderWidth: {
                    base: ".75rem 0px 0px 0px",
                    md: "0px 0px 0px .75rem"
                },
                gap: "xs",
                justifyContent: "center",
                width: {
                    base: "100%",
                    md: "50%"
                },
                // It's a two-column layout >md
                _dark: {
                    bg: "dark.ui.bg.default",
                    borderTopColor: {
                        md: "dark.ui.border.default"
                    },
                    borderLeftColor: {
                        md: $0422a6ce4ea03acc$var$Ju({
                            type: r,
                            colorValue: r === "blogs" ? "secondary" : "primary",
                            isDark: !0
                        })
                    }
                },
                padding: {
                    base: "var(--nypl-space-s) var(--nypl-space-l) var(--nypl-space-l) var(--nypl-space-l)",
                    md: "l",
                    lg: "var(--nypl-space-l) var(--nypl-space-xxl) var(--nypl-space-l) var(--nypl-space-xl)"
                }
            },
            privacy: {
                fontSize: "desktop.caption",
                fontWeight: "caption"
            },
            action: {
                justifyContent: "center",
                padding: {
                    base: "l",
                    lg: "var(--nypl-space-l) var(--nypl-space-xxl)"
                },
                width: {
                    base: "100%",
                    md: "50%"
                }
            },
            form: {
                width: "100%"
            },
            // Overwrites the default styling of the Form component layout
            "#newsletter-form-parent": {
                // The button is 78px wide and must sit to the right of the input field >lg.
                gridTemplateColumns: {
                    base: null,
                    lg: "1fr 78px"
                },
                gap: {
                    base: "s",
                    lg: "xs"
                }
            },
            button: {
                // The button must align w/ the input field, but using {align-items: center} doesn't quite work due to the input field not being the literal v-center.
                marginTop: {
                    base: null,
                    lg: "31px"
                },
                height: "40px"
            }
        }))
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$yA, definePartsStyle: $0422a6ce4ea03acc$var$LA } = $0422a6ce4ea03acc$var$Y2([
    "container",
    "dismissibleButton"
]), $0422a6ce4ea03acc$var$bA = $0422a6ce4ea03acc$var$LA(({ isCentered: r, noMargin: a, notificationHeading: o, notificationType: s })=>{
    let i = "ui.status.primary";
    return (s === "announcement" || s === "warning") && (i = "ui.gray.x-light-cool"), {
        bg: i,
        borderRadius: a ? "0" : "4px",
        display: "flex",
        fontSize: "desktop.body.body2",
        // slightly smaller than the default size
        m: a ? "0" : "s",
        position: "relative",
        p: "inset.default",
        textAlign: r ? "center" : null,
        _dark: {
            bg: "dark.ui.bg.hover"
        },
        container: {
            display: "flex",
            flexDirection: r || o ? "column" : "row",
            m: "auto",
            maxWidth: "var(--nypl-breakpoint-xl)",
            paddingEnd: "s",
            paddingStart: "s",
            w: "100%"
        },
        dismissibleButton: {
            border: "none",
            bgColor: "inherit",
            alignItems: "center",
            color: "ui.typography.heading",
            display: "flex",
            h: "32px",
            w: "32px",
            minWidth: "0",
            position: "absolute",
            right: "0",
            top: "0",
            svg: {
                marginTop: "0"
            },
            _dark: {
                color: "dark.ui.typography.heading"
            },
            _focus: {
                // This pseudo-class selector is needed for overriding Chakra styles
                ":not([disabled])": $0422a6ce4ea03acc$var$Sc("ui.typography.heading", "dark.ui.typography.heading")
            },
            _hover: {
                bg: "inherit"
            }
        }
    };
}), $0422a6ce4ea03acc$var$wA = $0422a6ce4ea03acc$var$yA({
    baseStyle: $0422a6ce4ea03acc$var$bA
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$HA, definePartsStyle: $0422a6ce4ea03acc$var$xA } = $0422a6ce4ea03acc$var$Y2([
    "content"
]), $0422a6ce4ea03acc$var$VA = $0422a6ce4ea03acc$var$xA(({ isCentered: r, notificationHeading: a, notificationType: o, showIcon: s })=>({
        display: "flex",
        justifyContent: "center",
        content: {
            color: o === "warning" ? "brand.primary" : "currentColor",
            marginTop: s ? "xxxs" : "0",
            paddingStart: !r && s ? a ? "l" : "xs" : "0",
            pt: !r && a ? "xxs" : "0",
            w: "100%",
            _dark: {
                borderLeftColor: o === "standard" ? "ui.status.primary" : o === "announcement" ? "dark.ui.success.primary" : "dark.ui.error.primary",
                borderLeftStyle: r ? "none" : "solid",
                borderLeftWidth: "2px",
                marginTop: "0",
                paddingStart: r ? "0" : "xs",
                color: "dark.ui.typography.body",
                ml: !r && s ? a ? "l" : "xs" : "0"
            },
            // Links should always be underlined, and always be black if the
            // color mode is light.
            a: {
                color: "ui.black",
                textDecoration: "underline",
                _dark: {
                    color: "dark.ui.link.primary",
                    _hover: {
                        color: "dark.ui.link.secondary"
                    }
                }
            }
        }
    })), $0422a6ce4ea03acc$var$MA = $0422a6ce4ea03acc$var$HA({
    baseStyle: $0422a6ce4ea03acc$var$VA
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$EA, definePartsStyle: $0422a6ce4ea03acc$var$SA } = $0422a6ce4ea03acc$var$Y2([
    "heading"
]), $0422a6ce4ea03acc$var$kA = $0422a6ce4ea03acc$var$SA(({ icon: r, isCentered: a, notificationType: o })=>{
    let s = "ui.typography.heading";
    return o === "announcement" ? s = "section.research.secondary" : o === "warning" && (s = "brand.primary"), {
        display: "flex",
        flexDirection: a ? "column" : "row",
        m: a ? "auto" : "null",
        mb: a ? "xs" : "0",
        px: a ? "s" : "0",
        w: "fit-content",
        _dark: {
            borderBottomColor: o === "standard" ? "ui.status.primary" : o === "announcement" ? "dark.ui.success.primary" : "dark.ui.error.primary",
            borderBottomStyle: a ? "solid" : "none",
            borderBottomWidth: "2px",
            color: "dark.ui.typography.heading",
            paddingBottom: a ? "xs" : "0"
        },
        heading: {
            color: s,
            ml: r && !a ? "xs" : "0",
            mt: r ? "xxxs" : "0",
            _dark: {
                borderLeftColor: o === "standard" ? "ui.status.primary" : o === "announcement" ? "dark.ui.success.primary" : "dark.ui.error.primary",
                borderLeftStyle: a ? "none" : "solid",
                borderLeftWidth: "2px",
                paddingLeft: a ? "0" : "xs"
            }
        },
        svg: {
            mx: a ? "auto" : "",
            mb: a ? "xxs" : "0",
            mt: a ? void 0 : "xxxs"
        }
    };
}), $0422a6ce4ea03acc$var$TA = $0422a6ce4ea03acc$var$EA({
    baseStyle: $0422a6ce4ea03acc$var$kA
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$_A, definePartsStyle: $0422a6ce4ea03acc$var$DA } = $0422a6ce4ea03acc$var$Y2([
    "link"
]), $0422a6ce4ea03acc$var$RA = $0422a6ce4ea03acc$var$_A({
    baseStyle: $0422a6ce4ea03acc$var$DA({
        alignItems: "stretch",
        display: "flex",
        width: "100%",
        link: {
            lineHeight: "1.15",
            textDecoration: "none",
            _hover: {
                textDecoration: "none"
            }
        },
        ul: {
            marginBottom: "0"
        }
    })
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$ZA, definePartsStyle: $0422a6ce4ea03acc$var$OA } = $0422a6ce4ea03acc$var$Y2([
    "circular",
    "circularLabel",
    "linear",
    "linearContainer",
    "linearPercentage"
]), $0422a6ce4ea03acc$var$NA = $0422a6ce4ea03acc$var$ZA({
    baseStyle: $0422a6ce4ea03acc$var$OA(({ darkMode: r, size: a })=>({
            color: r ? "dark.ui.typography.heading" : "ui.typography.heading",
            fontSize: "desktop.body.body2",
            _dark: {
                color: "dark.ui.typography.heading"
            },
            circular: {
                // Note: we have to target the SVG HTMl elements in order
                // to override the default styles.
                svg: {
                    height: a === "default" ? "48px" : "24px",
                    width: a === "default" ? "48px" : "24px",
                    display: "block",
                    circle: {
                        _first: {
                            stroke: r ? "ui.gray.dark" : "ui.gray.light-cool",
                            _dark: {
                                stroke: "dark.ui.bg.hover"
                            }
                        },
                        _last: {
                            stroke: r ? "ui.white" : "ui.link.primary",
                            _dark: {
                                stroke: "dark.ui.link.primary"
                            }
                        }
                    }
                }
            },
            circularContainer: {
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                width: "fit-content"
            },
            linear: {
                // Hard to target this specific element without using
                // "Progress" as the key name in index.ts
                "> div": {
                    bg: r ? "ui.white" : "ui.link.primary",
                    _dark: {
                        bg: "dark.ui.link.primary"
                    }
                },
                flex: 25,
                bg: r ? "ui.gray.dark" : "ui.gray.light-cool",
                height: {
                    base: "4px",
                    md: a === "default" ? "8px" : "4px"
                },
                _dark: {
                    bg: "dark.ui.bg.hover",
                    color: "dark.ui.typography.heading"
                }
            },
            linearContainer: {
                display: "flex",
                alignItems: "center"
            },
            linearPercentage: {
                padding: "0 var(--nypl-space-xs)",
                flex: 1
            }
        }))
}), { definePartsStyle: $0422a6ce4ea03acc$var$PA, defineMultiStyleConfig: $0422a6ce4ea03acc$var$BA } = $0422a6ce4ea03acc$var$Y2([
    "label",
    "control",
    "container",
    "helperErrorText",
    "hiddenLabel"
]), $0422a6ce4ea03acc$var$FA = {
    control: {
        verticalAlign: "middle",
        transitionProperty: "box-shadow",
        transitionDuration: "normal",
        border: "2px solid",
        borderRadius: "round",
        borderColor: "ui.gray.dark",
        backgroundColor: "ui.gray.xx-light-cool",
        color: "ui.white",
        outline: "none",
        _checked: {
            bg: "ui.gray.xx-light-cool",
            borderColor: "ui.focus",
            color: "ui.white",
            _disabled: {
                borderColor: "ui.disabled.primary",
                bg: "ui.gray.xx-light-cool",
                _before: {
                    bg: "ui.disabled.primary"
                }
            },
            _invalid: {
                _hover: {
                    borderColor: "ui.error.primary"
                },
                _before: {
                    borderColor: "ui.error.primary",
                    bg: "ui.error.primary"
                }
            },
            _hover: {
                bg: "ui.gray.xx-light-cool"
            },
            _before: {
                content: '""',
                display: "block",
                w: "3",
                h: "3",
                borderRadius: "round",
                bg: "ui.focus"
            }
        },
        _disabled: {
            borderColor: "ui.disabled.primary",
            bg: "ui.gray.xx-light-cool"
        },
        _focus: {
            ...$0422a6ce4ea03acc$var$na(),
            boxShadow: "outline",
            borderColor: "ui.focus"
        },
        _invalid: {
            borderColor: "ui.error.primary"
        },
        _dark: {
            borderColor: "dark.ui.border.default",
            backgroundColor: "dark.ui.bg.default",
            _checked: {
                borderColor: "dark.ui.focus",
                _disabled: {
                    borderColor: "dark.ui.disabled.secondary",
                    _before: {
                        bg: "dark.ui.disabled.secondary"
                    }
                },
                _invalid: {
                    borderColor: "dark.ui.error.primary",
                    _before: {
                        borderColor: "dark.ui.error.primary",
                        bg: "dark.ui.error.primary"
                    }
                }
            },
            _disabled: {
                borderColor: "dark.ui.disabled.secondary",
                _before: {
                    bg: "dark.ui.disabled.secondary"
                }
            },
            _focus: {
                boxShadow: "none",
                outlineColor: "dark.ui.focus"
            },
            _invalid: {
                borderColor: "dark.ui.error.primary"
            },
            _before: {
                bg: "dark.ui.focus"
            }
        }
    }
}, $0422a6ce4ea03acc$var$AA = $0422a6ce4ea03acc$var$PA({
    // Chakra-inserted elements in the Chakra Radio component
    control: $0422a6ce4ea03acc$var$FA.control,
    label: $0422a6ce4ea03acc$var$cw,
    container: {},
    // Custom element in the DS Radio component.
    helperErrorText: $0422a6ce4ea03acc$var$Cw,
    hiddenLabel: $0422a6ce4ea03acc$var$u9()
}), $0422a6ce4ea03acc$var$jA = {
    md: {
        control: {
            ...$0422a6ce4ea03acc$var$dw
        },
        label: {
            fontSize: "desktop.label.label1"
        }
    }
}, $0422a6ce4ea03acc$var$zA = $0422a6ce4ea03acc$var$BA({
    baseStyle: $0422a6ce4ea03acc$var$AA,
    sizes: $0422a6ce4ea03acc$var$jA,
    // Default values
    defaultProps: {
        size: "md"
    }
}), $0422a6ce4ea03acc$var$UA = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: {
        label: {
            ...$0422a6ce4ea03acc$var$fw
        }
    }
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$IA, definePartsStyle: $0422a6ce4ea03acc$var$$A } = $0422a6ce4ea03acc$var$Y2([
    "helperErrorText",
    "stack"
]), $0422a6ce4ea03acc$var$YA = $0422a6ce4ea03acc$var$IA({
    baseStyle: $0422a6ce4ea03acc$var$$A(({ isFullWidth: r = !1 })=>({
            ...$0422a6ce4ea03acc$var$pw(r)
        }))
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$WA, definePartsStyle: $0422a6ce4ea03acc$var$QA } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "action",
    "body",
    "heading"
]), $0422a6ce4ea03acc$var$qA = {
    xxsmall: {
        flex: {
            base: "0 0 100%",
            md: "0 0 64px"
        },
        width: "100%"
    },
    xsmall: {
        flex: {
            md: "0 0 96px"
        }
    },
    small: {
        flex: {
            md: "0 0 165px"
        }
    },
    medium: {
        flex: {
            md: "0 0 225px"
        }
    },
    large: {
        flex: {
            md: "0 0 360px"
        }
    }
}, $0422a6ce4ea03acc$var$GA = ({ hasImage: r, imageIsAtEnd: a, isBordered: o, isRow: s })=>{
    let i = null;
    return o && (i = "inset.default", r && (i = "0 var(--nypl-space-inset-default) var(--nypl-space-inset-default)")), s && o && (i = "inset.default"), s && o && r && (i = {
        base: "0 var(--nypl-space-inset-default) var(--nypl-space-inset-default)",
        md: "var(--nypl-space-inset-default) var(--nypl-space-inset-default) var(--nypl-space-inset-default) 0"
    }, a && (i = {
        base: "var(--nypl-space-inset-default) var(--nypl-space-inset-default) 0",
        md: "var(--nypl-space-inset-default) 0 var(--nypl-space-inset-default) var(--nypl-space-inset-default)"
    })), i;
}, $0422a6ce4ea03acc$var$XA = $0422a6ce4ea03acc$var$WA({
    baseStyle: $0422a6ce4ea03acc$var$QA(({ hasImage: r, imageIsAtEnd: a, isAlignedRightActions: o, isBordered: s, isCentered: i, layout: p, mainActionLink: C })=>{
        const v = p === "row", y = v ? {
            display: "flex",
            flexFlow: {
                base: "column nowrap",
                md: "row"
            },
            maxWidth: "100%",
            textAlign: "left",
            alignItems: i ? "center" : null
        } : {}, L = s ? {
            border: "1px solid",
            borderColor: "ui.border.default",
            _dark: {
                borderColor: "dark.ui.border.default"
            }
        } : {}, M = $0422a6ce4ea03acc$var$GA({
            isBordered: s,
            hasImage: r,
            imageIsAtEnd: a,
            isRow: v
        });
        let E = null;
        return i && (E = "auto", v && (E = "0")), {
            base: {
                alignItems: "flex-start",
                display: "flex",
                flexFlow: "column wrap",
                textAlign: i ? "center" : null,
                ...L,
                ...y
            },
            actions: {
                flexShrink: {
                    base: o ? "0" : null,
                    md: "0"
                },
                marginStart: {
                    base: "0",
                    md: "m"
                },
                marginTop: {
                    base: "xs",
                    md: "0"
                },
                maxWidth: {
                    base: "100%",
                    md: "180px"
                },
                width: "100%"
            },
            body: {
                display: {
                    md: "block"
                },
                flexBasis: {
                    sm: v ? "100%" : null
                },
                flexFlow: {
                    md: "row nowrap"
                },
                margin: E,
                padding: M,
                width: {
                    base: "100%",
                    md: "auto"
                }
            },
            heading: {
                marginBottom: "xs",
                a: C ? {
                    ...$0422a6ce4ea03acc$var$_c,
                    textDecoration: "none"
                } : null
            }
        };
    })
}), $0422a6ce4ea03acc$var$KA = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)(({ bottomBorder: r, isCentered: a, layout: o, topBorder: s })=>{
        let i = null;
        return o === "row" ? i = "left" : a && (i = "center"), {
            marginBottom: "xs",
            columnGap: "var(--nypl-space-xs)",
            display: "flex",
            _last: {
                marginBottom: "0"
            },
            ...s ? {
                borderTop: "1px solid",
                paddingTop: "xs"
            } : {},
            ...r ? {
                borderBottom: "1px solid",
                paddingBottom: "xs"
            } : {},
            justifyContent: i,
            borderColor: "ui.border.default",
            _dark: {
                borderColor: "dark.ui.border.default"
            }
        };
    })
}), $0422a6ce4ea03acc$var$JA = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        marginBottom: "xs",
        _last: {
            marginBottom: "0"
        }
    })
}), $0422a6ce4ea03acc$var$ej = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)(({ imageIsAtEnd: r, isCentered: a, layout: o, size: s })=>{
        const i = s ? $0422a6ce4ea03acc$var$qA[s] : {}, p = o === "row" ? {
            flex: {
                md: "0 0 225px"
            },
            maxWidth: {
                base: "100%",
                md: "50%"
            },
            textAlign: "left",
            alignItems: a ? "center" : null,
            margin: {
                base: r ? "var(--nypl-space-m) 0 0" : null,
                md: r ? "0 0 0 var(--nypl-space-m)" : "0 var(--nypl-space-m) 0 0"
            },
            width: {
                base: "100%",
                md: null
            },
            marginBottom: [
                "xs",
                "xs"
            ],
            ...i
        } : {
            marginBottom: "xs",
            width: "100%"
        };
        return {
            ...r ? {
                marginBottom: "0",
                marginTop: "s",
                order: "2"
            } : {},
            ...p
        };
    })
}), $0422a6ce4ea03acc$var$tj = {
    ReservoirCard: $0422a6ce4ea03acc$var$XA,
    CardActions: $0422a6ce4ea03acc$var$KA,
    CardContent: $0422a6ce4ea03acc$var$JA,
    CardImage: $0422a6ce4ea03acc$var$ej
}, { defineMultiStyleConfig: $0422a6ce4ea03acc$var$nj, definePartsStyle: $0422a6ce4ea03acc$var$rb } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "img",
    "figcaption",
    "figure"
]), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$rj, definePartsStyle: $0422a6ce4ea03acc$var$aj } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "crop"
]), $0422a6ce4ea03acc$var$Ro = {
    xxxsmall: 32,
    xxsmall: 64,
    xsmall: 96,
    small: 165,
    medium: 225,
    large: 360
}, $0422a6ce4ea03acc$var$ij = (r)=>({
        position: "relative",
        width: r === "width" ? "100%" : "auto",
        height: r === "width" ? "auto" : "100%",
        overflow: "hidden"
    }), $0422a6ce4ea03acc$var$T6 = {
    marginStart: "auto",
    marginEnd: "auto"
}, $0422a6ce4ea03acc$var$fh = {
    default: {
        maxWidth: "100%"
    },
    xxxsmall: {
        ...$0422a6ce4ea03acc$var$T6,
        maxWidth: "32px"
    },
    xxsmall: {
        ...$0422a6ce4ea03acc$var$T6,
        maxWidth: "64px"
    },
    xsmall: {
        ...$0422a6ce4ea03acc$var$T6,
        maxWidth: "96px"
    },
    small: {
        ...$0422a6ce4ea03acc$var$T6,
        maxWidth: "165px"
    },
    medium: {
        ...$0422a6ce4ea03acc$var$T6,
        maxWidth: "225px"
    },
    large: {
        ...$0422a6ce4ea03acc$var$T6,
        maxWidth: "360px"
    }
}, $0422a6ce4ea03acc$var$ph = {
    default: {
        maxHeight: "100%",
        maxWidth: "100%",
        width: "100%"
    },
    xxxsmall: {
        ...$0422a6ce4ea03acc$var$T6,
        maxHeight: "32px"
    },
    xxsmall: {
        ...$0422a6ce4ea03acc$var$T6,
        maxHeight: "64px"
    },
    xsmall: {
        ...$0422a6ce4ea03acc$var$T6,
        maxHeight: "96px"
    },
    small: {
        ...$0422a6ce4ea03acc$var$T6,
        maxHeight: "165px"
    },
    medium: {
        ...$0422a6ce4ea03acc$var$T6,
        maxHeight: "225px"
    },
    large: {
        ...$0422a6ce4ea03acc$var$T6,
        maxHeight: "360px"
    }
}, $0422a6ce4ea03acc$var$oj = {
    fourByThree: {
        paddingBottom: "75%"
    },
    oneByTwo: {
        paddingBottom: "200%"
    },
    original: {},
    sixteenByNine: {
        paddingBottom: "56.25%"
    },
    square: {
        paddingBottom: "100%"
    },
    threeByFour: {
        paddingBottom: "133.33%"
    },
    threeByTwo: {
        paddingBottom: "66.66%"
    },
    twoByOne: {
        paddingBottom: "50%"
    }
}, $0422a6ce4ea03acc$var$vc = (r)=>({
        fourByThree: {
            maxWidth: `${4 / 3 * r}px`
        },
        oneByTwo: {
            maxWidth: `${r / 2}px`
        },
        original: {},
        sixteenByNine: {
            maxWidth: `${16 / 9 * r}px`
        },
        square: {
            maxWidth: `${r}px`
        },
        threeByFour: {
            maxWidth: `${3 / 4 * r}px`
        },
        threeByTwo: {
            maxWidth: `${1.5 * r}px`
        },
        twoByOne: {
            maxWidth: `${2 * r}px`
        }
    }), $0422a6ce4ea03acc$var$lj = $0422a6ce4ea03acc$var$nj({
    baseStyle: $0422a6ce4ea03acc$var$rb(({ ratio: r = "original", size: a = "default", sizeBasedOn: o = "width" })=>({
            figure: {
                margin: "auto",
                ...o === "width" ? {
                    ...$0422a6ce4ea03acc$var$fh[a],
                    width: "100%"
                } : {
                    ...$0422a6ce4ea03acc$var$ph[a],
                    ...$0422a6ce4ea03acc$var$vc($0422a6ce4ea03acc$var$Ro[a])[r],
                    height: r === "original" ? `${$0422a6ce4ea03acc$var$Ro[a]}px` : "100%",
                    width: r === "original" && a !== "default" ? "max-content" : "100%"
                },
                img: {
                    backgroundColor: "ui.bg.default",
                    marginBottom: "xxs",
                    _dark: {
                        backgroundColor: "dark.ui.bg.default"
                    }
                }
            },
            figcaption: {
                fontStyle: "italic"
            },
            img: {
                display: "block",
                backgroundColor: "ui.bg.default",
                boxSizing: "border-box",
                objectFit: "cover",
                position: "relative",
                ...o === "width" ? {
                    ...$0422a6ce4ea03acc$var$fh[a],
                    width: "100%"
                } : {
                    ...$0422a6ce4ea03acc$var$ph[a],
                    ...$0422a6ce4ea03acc$var$vc($0422a6ce4ea03acc$var$Ro[a])[r],
                    height: "100%"
                },
                _dark: {
                    backgroundColor: "dark.ui.bg.default"
                }
            }
        })),
    variants: {
        circle: $0422a6ce4ea03acc$var$rb({
            img: {
                borderRadius: "50%"
            }
        })
    }
}), $0422a6ce4ea03acc$var$sj = $0422a6ce4ea03acc$var$rj({
    baseStyle: $0422a6ce4ea03acc$var$aj(({ ratio: r = "original", size: a = "default", sizeBasedOn: o = "width" })=>({
            base: {
                marginStart: "auto",
                marginEnd: "auto",
                ...o === "width" ? {
                    ...$0422a6ce4ea03acc$var$fh[a],
                    width: "100%"
                } : {
                    ...$0422a6ce4ea03acc$var$ph[a],
                    ...$0422a6ce4ea03acc$var$vc($0422a6ce4ea03acc$var$Ro[a])[r],
                    height: "100%"
                },
                img: {
                    ...o === "width" ? {
                        maxWidth: "100%"
                    } : {
                        maxHeight: "100%"
                    },
                    backgroundColor: "ui.bg.default",
                    height: "100%",
                    left: "0",
                    width: "100%",
                    position: "absolute",
                    top: "0",
                    _dark: {
                        backgroundColor: "dark.ui.bg.default"
                    }
                }
            },
            crop: {
                ...$0422a6ce4ea03acc$var$ij(o),
                ...$0422a6ce4ea03acc$var$oj[r],
                ...o === "height" && {
                    ...$0422a6ce4ea03acc$var$vc($0422a6ce4ea03acc$var$Ro[a])[r]
                }
            }
        }))
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$uj, definePartsStyle: $0422a6ce4ea03acc$var$cj } = $0422a6ce4ea03acc$var$Y2([
    "select"
]), $0422a6ce4ea03acc$var$dj = $0422a6ce4ea03acc$var$uj({
    baseStyle: $0422a6ce4ea03acc$var$cj({
        display: "flex",
        marginBottom: {
            base: "xs",
            md: "auto"
        },
        flexFlow: {
            base: "column nowrap",
            md: "row nowrap"
        },
        ".textInput": {
            flexGrow: "1"
        },
        select: {
            flexShrink: "0",
            marginBottom: {
                base: "-1px",
                md: "0"
            },
            maxWidth: {
                base: void 0,
                md: "255px"
            },
            textOverflow: "ellipsis",
            marginRight: {
                base: void 0,
                md: "-1px"
            },
            _hover: {
                zIndex: "10",
                "+ .chakra-select__icon-wrapper": {
                    zIndex: "9999"
                }
            }
        }
    })
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$Cj, definePartsStyle: $0422a6ce4ea03acc$var$ab } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "button",
    "container",
    "content",
    "heading",
    "image",
    "loader",
    "section"
]), $0422a6ce4ea03acc$var$Bp = {
    borderRadius: "2px",
    boxSizing: "border-box",
    marginBottom: "xs"
}, $0422a6ce4ea03acc$var$fj = {
    border: "1px solid",
    borderColor: "ui.gray.x-light-cool",
    padding: "s",
    _dark: {
        borderColor: "ui.gray.xx-dark"
    }
}, $0422a6ce4ea03acc$var$pj = {
    landscape: "50%",
    portrait: "133%",
    square: "100%"
}, $0422a6ce4ea03acc$var$hj = {
    landscape: "110px",
    portrait: "294px",
    square: "220px"
}, $0422a6ce4ea03acc$var$mj = ()=>(0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
        from: {
            opacity: 0.9
        },
        "50%": {
            opacity: 0.7
        },
        to: {
            opacity: 0.9
        }
    }), $0422a6ce4ea03acc$var$vj = $0422a6ce4ea03acc$var$Cj({
    baseStyle: $0422a6ce4ea03acc$var$ab(({ imageAspectRatio: r, isBordered: a })=>({
            base: {
                margin: "auto",
                width: "100%",
                ...a ? {
                    ...$0422a6ce4ea03acc$var$fj
                } : {}
            },
            button: {
                height: "32px",
                margin: "auto",
                maxWidth: "160px",
                width: "100%"
            },
            container: {
                marginTop: "s",
                width: "100%"
            },
            content: {
                ...$0422a6ce4ea03acc$var$Bp,
                height: "20px"
            },
            heading: {
                ...$0422a6ce4ea03acc$var$Bp,
                height: "32px"
            },
            image: {
                ...$0422a6ce4ea03acc$var$Bp,
                boxSizing: "border-box",
                flexShrink: "0",
                height: "0",
                overflow: "hidden",
                paddingBottom: $0422a6ce4ea03acc$var$pj[r],
                position: "relative",
                width: "100%"
            },
            loader: {
                borderRadius: "2px",
                bg: "ui.gray.light-cool",
                animation: `${$0422a6ce4ea03acc$var$mj()} 1000ms cubic-bezier(0.25, -0.5, 1, 0) infinite`,
                _dark: {
                    bg: "dark.ui.bg.hover"
                }
            },
            section: {
                marginBottom: "s",
                _last: {
                    marginBottom: "0"
                }
            }
        })),
    variants: {
        row: $0422a6ce4ea03acc$var$ab(({ imageAspectRatio: r, showImage: a })=>({
                base: {
                    alignItems: "flex-start",
                    display: {
                        md: "flex"
                    }
                },
                button: {
                    margin: {
                        md: "0"
                    }
                },
                container: {
                    marginStart: a ? {
                        md: "m"
                    } : null,
                    marginTop: {
                        md: "0"
                    }
                },
                image: {
                    overflow: {
                        md: "visible"
                    },
                    paddingBottom: {
                        md: "0"
                    },
                    position: {
                        md: "relative"
                    },
                    width: {
                        md: "220px"
                    },
                    height: {
                        md: $0422a6ce4ea03acc$var$hj[r]
                    }
                }
            }))
    }
}), $0422a6ce4ea03acc$var$gj = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        ul: {
            margin: "0"
        },
        // Don't display links by default...
        a: {
            backgroundColor: "ui.white",
            height: "1px",
            left: "-10000px",
            overflow: "hidden",
            position: "absolute",
            top: "auto",
            width: "1px",
            // Only display when the user focuses on the links.
            _focus: {
                height: "auto",
                left: "1rem",
                paddingX: "inset.narrow",
                paddingY: "inset.extranarrow",
                top: "1rem",
                width: "auto"
            },
            _dark: {
                backgroundColor: "dark.ui.bg.page"
            }
        }
    })
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$yj, definePartsStyle: $0422a6ce4ea03acc$var$Lj } = $0422a6ce4ea03acc$var$Y2([
    "image",
    "imageFigure",
    "imageWrapper"
]), $0422a6ce4ea03acc$var$bj = $0422a6ce4ea03acc$var$yj({
    baseStyle: $0422a6ce4ea03acc$var$Lj(({ hasFigureImage: r, imageAspectRatio: a, imagePosition: o })=>{
        const s = {}, i = {
            float: [
                "none",
                "none",
                o !== "center" ? o : void 0
            ],
            marginStart: [
                "auto",
                "auto",
                o === "center" ? null : o === "left" ? "0" : "l"
            ],
            marginEnd: [
                "auto",
                "auto",
                o === "center" ? null : o === "left" ? "m" : "0"
            ],
            width: o !== "center" ? "100%" : void 0,
            ...s
        };
        return o === "center" && (s.maxWidth = "100%"), {
            imageFigure: {
                ...i,
                marginBottom: "m"
            },
            imageWrapper: {
                ...i,
                marginBottom: r ? null : "m"
            },
            image: {
                // To handle the case when the image does not have a container,
                // e.g. when there is no image caption or credit.
                float: [
                    "none",
                    "none",
                    o !== "center" ? o : void 0
                ],
                marginStart: [
                    "auto",
                    "auto",
                    o === "right" && a === "original" ? "m" : void 0
                ],
                marginEnd: [
                    "auto",
                    "auto",
                    o === "left" && a === "original" ? "m" : void 0
                ],
                marginBottom: !r || a === "original" ? "m" : null,
                ...s
            },
            /** The following styles are meant to target HTML elements that are
         * not rendered from the Reservoir DS. Typically, these HTML elements
         * are added from an API response.
         */ // This gives Chakra `Box` styles to divs inside the
            // main `StructuredContent` content area.
            ".structuredcontent-body > div": {
                marginTop: "var(--nypl-space-l)",
                marginInlineEnd: "var(--nypl-space-0)",
                marginBottom: "var(--nypl-space-0)",
                marginInlineStart: "var(--nypl-space-0)"
            },
            a: $0422a6ce4ea03acc$var$_c,
            ul: {
                ...$0422a6ce4ea03acc$var$mc(),
                listStyle: "none",
                ...$0422a6ce4ea03acc$var$jh()
            },
            ol: {
                ...$0422a6ce4ea03acc$var$mc(),
                ...$0422a6ce4ea03acc$var$$r
            },
            // For section, h2 in the definition list.
            section: $0422a6ce4ea03acc$var$jw(),
            dl: $0422a6ce4ea03acc$var$Ku().dl,
            dt: $0422a6ce4ea03acc$var$Ku().dt,
            dd: $0422a6ce4ea03acc$var$Ku().dd,
            table: {
                width: "100%",
                th: {
                    // These styles, except for `baseTHStyles`, are set from
                    // Chakra so they are copied explicitly.
                    textAlign: "start",
                    paddingInlineStart: "var(--nypl-space-6)",
                    paddingInlineEnd: "var(--nypl-space-6)",
                    paddingTop: "var(--nypl-space-3)",
                    paddingBottom: "var(--nypl-space-3)",
                    lineHeight: "var(--nypl-lineHeights-4)",
                    ...$0422a6ce4ea03acc$var$Bw()
                },
                td: {
                    // These styles, except for `baseTDStyles`, are set from
                    // Chakra so they are copied explicitly.
                    textAlign: "start",
                    paddingInlineStart: "var(--nypl-space-6)",
                    paddingInlineEnd: "var(--nypl-space-6)",
                    paddingTop: "var(--nypl-space-4)",
                    paddingBottom: "var(--nypl-space-4)",
                    lineHeight: "var(--nypl-lineHeights-5)",
                    ...$0422a6ce4ea03acc$var$Fw()
                }
            },
            // h1, h2, h3, h4, h5, h6
            ...$0422a6ce4ea03acc$var$pe
        };
    })
}), $0422a6ce4ea03acc$var$wj = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)(({ textSize: r = "default" })=>({
            fontSize: r === "tag" || r === "mini" ? `text.${r}` : r === "caption" || r === "default" ? `desktop.${r}` : `desktop.body.${r}`,
            ...$0422a6ce4ea03acc$var$mc({
                inline: !1,
                noStyling: !0
            }),
            ...$0422a6ce4ea03acc$var$jh({
                noStyling: !0
            })
        })),
    variants: {
        capped: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
            li: {
                borderStart: "1px solid",
                borderEnd: {
                    base: "1px solid",
                    md: "none"
                },
                borderColor: "ui.border.default",
                my: "xs",
                px: "xs"
            },
            _dark: {
                li: {
                    borderColor: "ui.gray.semi-dark"
                }
            }
        })
    }
});
function $0422a6ce4ea03acc$var$Hj(r) {
    let a = "xs";
    switch(r){
        case "medium":
            a = "0.75rem";
            break;
        case "large":
            a = "s";
            break;
    }
    return {
        paddingSize: a
    };
}
function $0422a6ce4ea03acc$var$Fp(r) {
    let a = "ui.typography.heading", o = "dark.ui.typography.heading";
    switch(r){
        case "link":
            a = "ui.link.primary", o = "dark.ui.link.primary";
            break;
        case "textInverse":
            a = "ui.typography.inverse.heading", o = "dark.ui.typography.inverse.heading";
            break;
    }
    return {
        ltColor: a,
        dkColor: o
    };
}
const $0422a6ce4ea03acc$var$xj = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    // The base styles for each part
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((r)=>{
        const { labelsOn: a, layout: o } = r;
        return {
            // ul styles should not specifically be identified as ul:
            display: "flex",
            alignItems: "flex-start",
            flexDirection: {
                base: a ? "column" : "row",
                md: o
            },
            justifyContent: {
                base: "center",
                md: "unset"
            },
            flexWrap: "wrap",
            gap: {
                base: "0",
                md: "s"
            },
            marginBottom: "unset",
            li: {
                marginInlineEnd: "0",
                marginTop: "0",
                width: {
                    base: a ? "100%" : "unset",
                    md: "unset"
                },
                _notFirst: {
                    marginTop: "0"
                }
            },
            a: {
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                flexWrap: "wrap",
                minWidth: {
                    base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
                    md: "unset"
                },
                minHeight: {
                    base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
                    md: "unset"
                },
                fontStyle: "normal",
                fontSize: "desktop.body.body2",
                textDecoration: "none",
                color: "ui.typography.heading",
                _hover: {
                    color: "ui.typography.heading",
                    textDecoration: "underline 1px dotted"
                },
                _visited: {
                    color: "ui.typography.heading"
                },
                _dark: {
                    color: "dark.ui.typography.heading",
                    _hover: {
                        color: "dark.ui.typography.heading"
                    },
                    _visited: {
                        color: "dark.ui.typography.heading"
                    }
                }
            },
            div: {
                display: "flex",
                alignItems: "center",
                gap: "xs",
                // .5rem / 8px
                alignSelf: "stretch",
                justifyContent: "center",
                width: "fit-content",
                height: "fit-content"
            },
            svg: {
                fill: "ui.typography.heading",
                _dark: {
                    fill: "dark.ui.typography.heading"
                }
            }
        };
    }),
    // The variants are based on border values
    variants: {
        // Each variant is a function that returns an object with styles for that variant.
        straight (r) {
            const { color: a, labelsOn: o } = r;
            let s = $0422a6ce4ea03acc$var$Fp(a);
            return {
                gap: "xs",
                // Borders require the gap to reduce from 1rem to .5rem / 8px.
                a: {
                    color: s.ltColor,
                    ".platLink": {
                        minHeight: {
                            base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
                            md: "0"
                        },
                        minWidth: {
                            base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
                            md: "0"
                        }
                    },
                    _hover: {
                        color: s.ltColor
                    },
                    _visited: {
                        color: s.ltColor
                    },
                    _dark: {
                        borderColor: s.dkColor,
                        color: s.dkColor,
                        _hover: {
                            color: s.dkColor
                        },
                        _visited: {
                            color: s.dkColor
                        }
                    }
                },
                div: {
                    padding: "xs",
                    borderRadius: "button.default",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor: s.ltColor,
                    width: o ? "100%" : "unset",
                    _dark: {
                        borderColor: s.dkColor
                    }
                },
                svg: {
                    fill: s.ltColor,
                    _dark: {
                        fill: s.dkColor,
                        borderColor: s.dkColor
                    }
                }
            };
        },
        circular (r) {
            const { color: a, size: o } = r;
            let s = $0422a6ce4ea03acc$var$Fp(a);
            return {
                gap: "xs",
                a: {
                    color: s.ltColor,
                    ".platLink": {
                        minHeight: {
                            base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
                            md: "0"
                        },
                        minWidth: {
                            base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
                            md: "0"
                        }
                    },
                    _hover: {
                        color: s.ltColor
                    },
                    _visited: {
                        color: s.ltColor
                    },
                    _dark: {
                        color: s.dkColor,
                        _hover: {
                            color: s.dkColor
                        },
                        _visited: {
                            color: s.dkColor
                        }
                    }
                },
                div: {
                    padding: $0422a6ce4ea03acc$var$Hj(o).paddingSize,
                    borderRadius: "100%",
                    borderColor: s.ltColor,
                    borderWidth: "0.0625rem",
                    borderStyle: "solid",
                    _dark: {
                        borderColor: s.dkColor
                    }
                },
                svg: {
                    fill: s.ltColor,
                    _dark: {
                        fill: s.dkColor
                    }
                }
            };
        },
        // Variant 3
        none (r) {
            const { color: a } = r;
            let o = $0422a6ce4ea03acc$var$Fp(a);
            return {
                a: {
                    color: o.ltColor,
                    _hover: {
                        color: o.ltColor
                    },
                    _visited: {
                        color: o.ltColor
                    },
                    _dark: {
                        color: o.dkColor,
                        _hover: {
                            color: o.dkColor
                        },
                        _visited: {
                            color: o.dkColor
                        }
                    }
                },
                svg: {
                    fill: o.ltColor,
                    _dark: {
                        fill: o.dkColor
                    }
                }
            };
        }
    },
    // The default `size` or `variant` values
    defaultProps: {
        variant: "none"
    }
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$Vj, definePartsStyle: $0422a6ce4ea03acc$var$Mj } = $0422a6ce4ea03acc$var$Y2([
    "root",
    "tab",
    "tabpanels",
    "tabpanel",
    "tablist",
    "buttonArrows",
    "tablistWrapper",
    "carouselParent"
]), $0422a6ce4ea03acc$var$Ej = {
    borderColor: "ui.black",
    width: "max-content"
}, $0422a6ce4ea03acc$var$Sj = {
    background: "transparent",
    border: "0",
    borderBottom: "1px solid",
    color: "ui.typography.heading",
    height: {
        base: "44px"
    },
    marginEnd: {
        base: "0",
        md: "1px"
    },
    paddingEnd: {
        base: "s",
        md: "l",
        lg: "xl"
    },
    paddingInlineStart: "s",
    paddingStart: "s",
    whiteSpace: "nowrap",
    _hover: {
        bg: "ui.gray.x-light-cool",
        borderTopRadius: "sm",
        borderBottom: "1px solid",
        borderBottomColor: "ui.black"
    },
    _selected: {
        fontWeight: "bold",
        bg: "ui.gray.light-cool",
        border: "0",
        borderTopRadius: "sm",
        borderBottom: "3px solid",
        borderBottomColor: "ui.black",
        paddingBottom: "5px"
    },
    _focus: {
        boxShadow: "0"
    },
    _dark: {
        color: "dark.ui.typography.heading",
        border: "1px solid transparent",
        borderBottom: "1px solid",
        borderBottomColor: "dark.ui.border.default",
        _hover: {
            bg: "dark.ui.bg.hover"
        },
        _selected: {
            color: "dark.ui.typography.heading",
            border: "0",
            bg: "dark.ui.bg.active",
            borderBottom: "3px solid"
        }
    }
}, $0422a6ce4ea03acc$var$kj = {
    bg: "transparent",
    color: "black",
    border: "0",
    borderRadius: "0",
    display: {
        // After 38em/600px, don't display the arrow button anymore.
        md: "none"
    },
    height: "44px",
    width: "44px !important",
    top: "8px",
    marginStart: "4px",
    marginEnd: "4px",
    // Code from https://codesandbox.io/s/fxjeo for the mobile carousel
    pos: "absolute",
    transition: "0.6s ease",
    zIndex: "9999",
    _hover: {
        bg: "unset",
        color: "unset",
        borderColor: "unset"
    },
    _disabled: {
        color: "ui.disabled.primary"
    },
    _dark: {
        color: "dark.ui.typography.heading",
        _disabled: {
            color: "dark.ui.disabled.primary"
        }
    }
}, $0422a6ce4ea03acc$var$Tj = {
    display: "flex",
    alignItems: "center",
    borderBottom: {
        base: "0",
        md: "1px solid black"
    },
    height: {
        base: "58px",
        md: "auto"
    },
    margin: "0",
    overflowX: {
        base: "auto",
        md: "visible"
    },
    paddingBottom: {
        base: "5px",
        md: "0"
    },
    paddingStart: {
        base: "4px",
        md: "0"
    },
    paddingEnd: {
        base: "4px",
        md: "0"
    },
    paddingTop: {
        base: "4px",
        md: "0"
    },
    position: "relative",
    _dark: {
        borderColor: "dark.ui.border.hover"
    }
}, $0422a6ce4ea03acc$var$_j = {
    paddingTop: "2px"
}, $0422a6ce4ea03acc$var$Dj = {
    position: {
        base: "absolute",
        md: "relative"
    },
    left: {
        base: "50px",
        md: "auto"
    },
    paddingBottom: {
        base: "5px",
        md: "4px"
    },
    paddingStart: "4px",
    paddingEnd: "4px",
    paddingTop: {
        base: "4px"
    },
    right: {
        base: "52px",
        md: "4px"
    },
    top: {
        base: "4px"
    },
    scrollbarWidth: "none",
    "::-webkit-scrollbar": {
        display: "none"
    },
    overflowY: "hidden",
    overflowX: "scroll"
}, $0422a6ce4ea03acc$var$Rj = $0422a6ce4ea03acc$var$Vj({
    // tablist, tab, and tabpanels are existing keys which are extended but
    // buttonArrows, tablistWrapper, and carouselParent are custom elements
    // in the `Tabs` component.
    baseStyle: $0422a6ce4ea03acc$var$Mj({
        tabpanel: {},
        root: {},
        tabpanels: $0422a6ce4ea03acc$var$_j,
        tablist: $0422a6ce4ea03acc$var$Ej,
        tab: $0422a6ce4ea03acc$var$Sj,
        // Only display the previous/next arrow buttons on mobile.
        buttonArrows: $0422a6ce4ea03acc$var$kj,
        // To better align the mobile arrow buttons with the tablist.
        tablistWrapper: $0422a6ce4ea03acc$var$Tj,
        carouselParent: $0422a6ce4ea03acc$var$Dj
    }),
    defaultProps: {
        colorScheme: "ui.black"
    }
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$Zj, definePartsStyle: $0422a6ce4ea03acc$var$Oj } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "clearAll"
]), $0422a6ce4ea03acc$var$zw = {
    transitionDuration: "normal",
    transitionTimingFunction: "ease-out"
}, $0422a6ce4ea03acc$var$Nj = $0422a6ce4ea03acc$var$Zj({
    baseStyle: $0422a6ce4ea03acc$var$Oj(({ isDismissible: r })=>({
            base: {
                alignItems: "center",
                bg: "ui.bg.default",
                border: "1px solid",
                borderColor: "ui.border.default",
                borderRadius: "pill",
                color: "ui.typography.body",
                cursor: r ? "pointer" : "auto",
                display: "flex",
                fontSize: "desktop.caption",
                height: {
                    base: "32px",
                    md: "22px"
                },
                justifyContent: "center",
                minHeight: "22px",
                maxWidth: "200px",
                py: "xxxs",
                paddingLeft: "s",
                paddingRight: r ? {
                    base: "8px",
                    md: "6px"
                } : "s",
                ...$0422a6ce4ea03acc$var$zw,
                "> span": {
                    display: "inline-block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                },
                _hover: {
                    bg: r ? "ui.bg.hover" : "ui.bg.default",
                    borderColor: r ? "ui.border.hover" : "ui.border.default"
                },
                _dark: {
                    bg: "dark.ui.bg.default",
                    borderColor: "dark.ui.border.default",
                    color: "dark.ui.typography.body",
                    _hover: {
                        bg: r ? "dark.ui.bg.hover" : "dark.ui.bg.default",
                        borderColor: r ? "dark.ui.border.active" : "dark.ui.border.default",
                        color: r ? "dark.ui.typography.heading" : "dark.ui.typography.body"
                    }
                }
            }
        }))
}), $0422a6ce4ea03acc$var$Pj = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bg: "ui.link.primary-05",
        border: "1px solid",
        borderColor: "ui.link.primary",
        borderRadius: "pill",
        color: "ui.link.primary",
        cursor: "pointer",
        fontSize: "desktop.caption",
        height: {
            base: "32px",
            md: "22px"
        },
        minHeight: "22px",
        maxWidth: "200px",
        py: "xxxs",
        px: "s",
        textUnderlineOffset: "2px",
        ...$0422a6ce4ea03acc$var$Ch,
        ...$0422a6ce4ea03acc$var$zw,
        _focusWithin: $0422a6ce4ea03acc$var$na(),
        a: {
            border: "0",
            _focus: {
                outline: "none"
            }
        },
        "> span": {
            display: "inline-block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        svg: {
            fill: "ui.link.primary"
        },
        _hover: {
            bg: "ui.link.primary-10",
            a: {
                color: "ui.link.secondary"
            },
            svg: {
                fill: "ui.link.secondary"
            },
            "> span": {
                color: "ui.link.secondary"
            }
        },
        _dark: {
            bg: "dark.ui.link.primary-05",
            borderColor: "dark.ui.link.primary",
            color: "dark.ui.link.primary",
            a: {
                color: "dark.ui.link.primary"
            },
            svg: {
                fill: "dark.ui.link.primary"
            },
            _hover: {
                bg: "dark.ui.link.primary-10",
                a: {
                    color: "dark.ui.link.secondary"
                },
                svg: {
                    fill: "dark.ui.link.secondary"
                },
                "> span": {
                    color: "dark.ui.link.secondary"
                }
            }
        }
    })
}), $0422a6ce4ea03acc$var$Bj = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        alignItems: "center",
        display: "inline-flex",
        flexWrap: "wrap",
        gap: "xs"
    })
}), $0422a6ce4ea03acc$var$Fj = {
    TagSet: $0422a6ce4ea03acc$var$Bj,
    TagSetExplore: $0422a6ce4ea03acc$var$Pj,
    TagSetFilter: $0422a6ce4ea03acc$var$Nj
}, $0422a6ce4ea03acc$var$Aj = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        boxSizing: "border-box",
        color: "ui.typography.body",
        display: "grid",
        gridTemplateColumns: `
      1fr
      min(1280px, 100%)
      1fr`,
        rowGap: "grid.l",
        _dark: {
            color: "dark.ui.typography.body"
        }
    }),
    sizes: {},
    defaultProps: {}
}), $0422a6ce4ea03acc$var$jj = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        width: "100%",
        // This could be "1 / 4" and it would mean the same. This is
        // "future-proof" the grid column assignment to the last column.
        gridColumn: "1 / -1"
    })
}), $0422a6ce4ea03acc$var$zj = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        // Set this element to start on the second 1280px grid column.
        gridColumn: "2",
        // But this element also contains its own grid system within.
        display: "grid",
        gridTemplateColumns: "1fr",
        paddingY: 0,
        paddingX: "s",
        gap: "grid.l"
    }),
    // With left or right sidebars, we need to set two grid columns and
    // the column for the sidebar is max 255px width.
    variants: {
        left: {
            gridTemplateColumns: {
                md: "255px 1fr"
            }
        },
        right: {
            gridTemplateColumns: {
                md: "1fr 255px"
            }
        }
    }
}), $0422a6ce4ea03acc$var$Uj = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        gridColumn: {
            base: "1",
            md: "1 / span 2"
        },
        height: "100%"
    })
}), $0422a6ce4ea03acc$var$Ij = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        gridColumn: {
            base: "1",
            md: "1 / span 2"
        }
    }),
    variants: {
        left: {
            gridColumn: {
                base: "1",
                md: "2"
            },
            marginEnd: {
                md: 0
            },
            minWidth: {
                md: 0
            }
        },
        right: {
            gridColumn: {
                base: "1",
                md: "1"
            }
        }
    }
}), $0422a6ce4ea03acc$var$$j = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    variants: {
        left: {
            gridColumn: "1"
        },
        right: {
            gridColumn: {
                base: "1",
                md: "2"
            }
        }
    }
}), $0422a6ce4ea03acc$var$Yj = {
    Template: $0422a6ce4ea03acc$var$Aj,
    TemplateBreakout: $0422a6ce4ea03acc$var$jj,
    TemplateContent: $0422a6ce4ea03acc$var$zj,
    TemplateContentTopBottom: $0422a6ce4ea03acc$var$Uj,
    TemplateContentPrimary: $0422a6ce4ea03acc$var$Ij,
    TemplateContentSidebar: $0422a6ce4ea03acc$var$$j
}, $0422a6ce4ea03acc$var$Wj = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)(({ isBold: r, isItalic: a, isCapitalized: o, isUppercase: s, isLowercase: i, noSpace: p, variant: C })=>({
        fontStyle: a ? "italic" : null,
        fontWeight: r ? C === "tag" || C === "mini" || C === "caption" ? "medium" : "bold" : null,
        textTransform: o ? "capitalize" : s ? "uppercase" : i ? "lowercase" : null,
        marginBottom: p ? "0 !important" : null
    })), $0422a6ce4ea03acc$var$Qj = {
    default: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({}),
    body1: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({}),
    body2: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "desktop.body.body2"
    }),
    caption: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "desktop.caption",
        fontWeight: "caption"
    }),
    overline1: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "desktop.overline.overline1",
        fontWeight: "overline.overline1",
        lineHeight: 1,
        textTransform: "uppercase"
    }),
    overline2: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "desktop.overline.overline2",
        fontWeight: "overline.overline2",
        lineHeight: 1,
        textTransform: "uppercase"
    }),
    subtitle1: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: {
            base: "mobile.subtitle.subtitle1",
            md: "desktop.subtitle.subtitle1"
        },
        fontWeight: "subtitle.subtitle1",
        lineHeight: 1.35
    }),
    subtitle2: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: {
            base: "mobile.subtitle.subtitle2",
            md: "desktop.subtitle.subtitle2"
        },
        fontWeight: "subtitle.subtitle2",
        lineHeight: 1.4
    }),
    // Deprecated options
    tag: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "text.tag",
        fontWeight: "text.tag"
    }),
    mini: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "text.mini",
        fontWeight: "text.mini"
    })
}, $0422a6ce4ea03acc$var$qj = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $0422a6ce4ea03acc$var$Wj,
    variants: $0422a6ce4ea03acc$var$Qj
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$Gj, definePartsStyle: $0422a6ce4ea03acc$var$Ap } = $0422a6ce4ea03acc$var$Y2([
    "clearButton",
    "input",
    "textarea"
]), $0422a6ce4ea03acc$var$ib = {
    bgColor: "ui.white",
    border: "1px solid",
    borderColor: "ui.border.default",
    borderRadius: "sm",
    fontSize: "desktop.body.body2",
    minHeight: {
        base: $0422a6ce4ea03acc$var$n6.mobileFieldHeight,
        md: "auto"
    },
    py: "inset.narrow",
    px: "inset.default",
    _hover: {
        borderColor: "ui.border.hover"
    },
    _disabled: {
        ...$0422a6ce4ea03acc$var$ah,
        _placeholder: {
            color: "ui.gray.medium"
        }
    },
    _active: $0422a6ce4ea03acc$var$Ir,
    _focus: $0422a6ce4ea03acc$var$Ir,
    _placeholder: {
        color: "ui.gray.dark",
        fontStyle: "italic",
        lineHeight: "21px"
    },
    _invalid: {
        border: "1px solid",
        borderColor: "ui.error.primary",
        boxShadow: "none",
        color: "ui.error.primary",
        _focus: {
            borderColor: "ui.focus"
        }
    },
    _dark: {
        bgColor: "dark.ui.bg.default",
        borderColor: "dark.ui.border.default",
        _hover: {
            borderColor: "dark.ui.border.hover"
        },
        _disabled: {
            ...$0422a6ce4ea03acc$var$ah,
            _placeholder: {
                color: "ui.gray.x-dark"
            }
        },
        _active: $0422a6ce4ea03acc$var$Ir,
        _focus: $0422a6ce4ea03acc$var$Ir,
        _placeholder: {
            color: "ui.gray.dark"
        },
        _invalid: {
            borderColor: "dark.ui.error.primary",
            color: "dark.ui.error.primary"
        }
    }
}, $0422a6ce4ea03acc$var$Xj = $0422a6ce4ea03acc$var$Gj({
    baseStyle: $0422a6ce4ea03acc$var$Ap(({ showLabel: r })=>({
            position: "relative",
            clearButton: {
                borderRadius: "1px",
                minHeight: {
                    base: "42px",
                    md: "auto"
                },
                height: "38px",
                position: "absolute",
                // When `showLabel` is false, the input field is at the top
                // which means the clear button should float higher.
                top: r ? ".75px" : "1px",
                px: "xs",
                right: "0.5px",
                // Don't visually show the text. This also helps
                // use the "text" `Button` type.
                span: $0422a6ce4ea03acc$var$u9(),
                zIndex: "9999",
                _dark: {
                    svg: {
                        fill: "dark.ui.typography.heading"
                    }
                }
            },
            input: $0422a6ce4ea03acc$var$ib,
            label: $0422a6ce4ea03acc$var$kc,
            textarea: {
                ...$0422a6ce4ea03acc$var$ib,
                lineheight: "1.5",
                minHeight: "xxl"
            }
        })),
    variants: {
        searchBar: $0422a6ce4ea03acc$var$Ap({
            flex: "1 1 80%",
            input: {
                borderRightRadius: "none"
            }
        }),
        searchBarSelect: $0422a6ce4ea03acc$var$Ap({
            flex: "1 1 80%",
            input: {
                borderRadius: "none",
                borderTopLeftRadius: {
                    base: "sm",
                    md: "none"
                },
                borderTopRightRadius: {
                    base: "sm",
                    md: "none"
                }
            }
        })
    }
});
function $0422a6ce4ea03acc$var$Kj(r) {
    return !Number.isInteger(parseFloat(r.toString()));
}
function $0422a6ce4ea03acc$var$Jj(r, a = "-") {
    return r.replace(/\s+/g, a);
}
function $0422a6ce4ea03acc$var$Uw(r) {
    const a = $0422a6ce4ea03acc$var$Jj(r.toString());
    return a.includes("\\.") ? r : $0422a6ce4ea03acc$var$Kj(r) ? a.replace(".", "\\.") : r;
}
function $0422a6ce4ea03acc$var$ez(r, a = "") {
    return [
        a,
        $0422a6ce4ea03acc$var$Uw(r)
    ].filter(Boolean).join("-");
}
function $0422a6ce4ea03acc$var$tz(r, a) {
    return `var(${$0422a6ce4ea03acc$var$Uw(r)}${a ? `, ${a}` : ""})`;
}
function $0422a6ce4ea03acc$var$nz(r, a = "") {
    return `--${$0422a6ce4ea03acc$var$ez(r, a)}`;
}
function $0422a6ce4ea03acc$var$zh(r, a) {
    const o = $0422a6ce4ea03acc$var$nz(r, void 0);
    return {
        variable: o,
        reference: $0422a6ce4ea03acc$var$tz(o, $0422a6ce4ea03acc$var$rz(void 0))
    };
}
function $0422a6ce4ea03acc$var$rz(r) {
    return typeof r == "string" ? r : r == null ? void 0 : r.reference;
}
const { defineMultiStyleConfig: $0422a6ce4ea03acc$var$az, definePartsStyle: $0422a6ce4ea03acc$var$hh } = $0422a6ce4ea03acc$var$Y2([
    "container",
    "track",
    "thumb",
    "label"
]), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$iz, definePartsStyle: $0422a6ce4ea03acc$var$oz } = $0422a6ce4ea03acc$var$Y2([
    "label",
    "helperErrorText"
]), $0422a6ce4ea03acc$var$ob = $0422a6ce4ea03acc$var$zh("switch-track-width"), $0422a6ce4ea03acc$var$lb = $0422a6ce4ea03acc$var$zh("switch-track-height"), $0422a6ce4ea03acc$var$lz = $0422a6ce4ea03acc$var$oz(({ isDisabled: r, size: a })=>({
        label: {
            alignItems: "start",
            display: "flex",
            width: "fit-content"
        },
        helperErrorText: {
            marginStart: a === "default" ? "xxl" : "xl",
            fontStyle: r ? "italic" : null
        }
    })), $0422a6ce4ea03acc$var$sz = $0422a6ce4ea03acc$var$hh(({ size: r })=>({
        alignItems: "start",
        track: {
            backgroundColor: "ui.gray.semi-dark",
            border: "1px solid",
            borderColor: "ui.gray.semi-dark",
            p: "1px",
            _checked: {
                bg: "ui.link.primary",
                borderColor: "ui.link.primary",
                opacity: 1
            },
            _invalid: {
                bg: "inherit",
                borderColor: "ui.error.primary",
                "> span": {
                    bg: "ui.error.primary"
                }
            },
            _disabled: {
                bg: "ui.gray.medium",
                borderColor: "ui.gray.medium",
                _checked: {
                    opacity: 0.4
                }
            },
            _focus: {
                outline: "2px solid",
                outlineColor: "ui.focus",
                outlineOffset: "2px",
                zIndex: "9999"
            },
            _dark: {
                bgColor: "ui.gray.semi-dark",
                borderColor: "ui.gray.semi-dark",
                _checked: {
                    bg: "dark.ui.link.primary",
                    borderColor: "dark.ui.link.primary"
                },
                _invalid: {
                    bg: "inherit",
                    borderColor: "dark.ui.error.primary",
                    "> span": {
                        bg: "dark.ui.error.primary"
                    }
                },
                _disabled: {
                    bg: "dark.ui.disabled.secondary",
                    borderColor: "dark.ui.disabled.secondary",
                    opacity: 1,
                    // These are styles for the thumb. _isDisabled was not working within the `thumb` part.
                    ".chakra-switch__thumb": {
                        bgColor: "dark.ui.disabled.primary"
                    }
                },
                _focus: {
                    outlineColor: "dark.ui.focus"
                }
            }
        },
        label: {
            fontSize: "desktop.label.label1",
            marginStart: "xs",
            marginTop: r === "lg" ? "xxxs" : null,
            _disabled: {
                color: "ui.gray.dark",
                fontStyle: "italic"
            },
            _invalid: {
                color: "ui.error.primary"
            },
            _dark: {
                _disabled: {
                    color: "dark.ui.disabled.primary"
                },
                _invalid: {
                    color: "dark.ui.error.primary"
                }
            }
        },
        thumb: {
            _dark: {
                bgColor: "dark.ui.bg.default"
            }
        }
    })), $0422a6ce4ea03acc$var$uz = $0422a6ce4ea03acc$var$az({
    baseStyle: $0422a6ce4ea03acc$var$sz,
    sizes: {
        sm: $0422a6ce4ea03acc$var$hh({
            container: {
                // Chakra defaults for `sm`:
                // width: 1.375rem
                // height: 0.75rem
                [$0422a6ce4ea03acc$var$ob.variable]: "2.25rem",
                [$0422a6ce4ea03acc$var$lb.variable]: "1rem"
            }
        }),
        lg: $0422a6ce4ea03acc$var$hh({
            container: {
                // Chakra defaults for `lg`:
                // width: 2.875rem
                // height: 1.5rem
                [$0422a6ce4ea03acc$var$ob.variable]: "3.25rem",
                [$0422a6ce4ea03acc$var$lb.variable]: "1.5rem"
            }
        })
    },
    defaultProps: {
        colorScheme: "white"
    }
}), $0422a6ce4ea03acc$var$cz = $0422a6ce4ea03acc$var$iz({
    baseStyle: $0422a6ce4ea03acc$var$lz,
    // Default values
    defaultProps: {
        size: "lg"
    }
}), $0422a6ce4ea03acc$var$dz = {
    Toggle: $0422a6ce4ea03acc$var$cz,
    Switch: $0422a6ce4ea03acc$var$uz
}, $0422a6ce4ea03acc$var$sb = $0422a6ce4ea03acc$var$zh("tooltip-bg"), $0422a6ce4ea03acc$var$Cz = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$0422a6ce4ea03acc$var$sb.variable]: "colors.ui.gray.xx-dark",
        borderRadius: "4px",
        boxShadow: "none",
        color: "ui.typography.inverse.body",
        fontSize: "desktop.caption",
        marginBottom: "xxs",
        maxWidth: "240px",
        marginTop: "0px",
        px: "s",
        py: "xs",
        _dark: {
            [$0422a6ce4ea03acc$var$sb.variable]: "colors.ui.gray.x-dark",
            color: "dark.ui.typography.heading"
        }
    })
}), { defineMultiStyleConfig: $0422a6ce4ea03acc$var$fz, definePartsStyle: $0422a6ce4ea03acc$var$Dc } = $0422a6ce4ea03acc$var$Y2([
    "base",
    "inside"
]), $0422a6ce4ea03acc$var$pz = $0422a6ce4ea03acc$var$Dc({
    inside: {
        paddingBottom: "75%"
    }
}), $0422a6ce4ea03acc$var$hz = $0422a6ce4ea03acc$var$Dc({
    inside: {
        paddingBottom: "100%"
    }
}), $0422a6ce4ea03acc$var$mz = $0422a6ce4ea03acc$var$Dc({
    base: {
        backgroundColor: "ui.gray.light-cool",
        border: "1px solid",
        borderColor: "ui.border.default",
        height: "auto",
        padding: "s",
        _dark: {
            bg: "dark.ui.bg.default",
            border: "1px solid",
            borderColor: "dark.ui.border.default"
        }
    }
}), $0422a6ce4ea03acc$var$vz = $0422a6ce4ea03acc$var$fz({
    baseStyle: $0422a6ce4ea03acc$var$Dc({
        base: {
            iframe: {
                height: "100%",
                left: "0",
                margin: "auto",
                position: "absolute",
                top: "0",
                width: "100%"
            }
        },
        inside: {
            height: "0",
            overflow: "hidden",
            paddingBottom: "56.25%",
            position: "relative"
        }
    }),
    variants: {
        fourByThree: $0422a6ce4ea03acc$var$pz,
        invalid: $0422a6ce4ea03acc$var$mz,
        square: $0422a6ce4ea03acc$var$hz
    }
}), $0422a6ce4ea03acc$var$gz = {
    styles: {
        global: $0422a6ce4ea03acc$var$GN
    },
    breakpoints: $0422a6ce4ea03acc$var$XN,
    colors: $0422a6ce4ea03acc$var$dP,
    radii: $0422a6ce4ea03acc$var$CP,
    shadows: $0422a6ce4ea03acc$var$fP,
    space: $0422a6ce4ea03acc$var$No,
    ...$0422a6ce4ea03acc$var$pP,
    /**
   * Chakra documentation on component styles:
   * https://chakra-ui.com/docs/theming/component-style
   */ components: {
        Accordion: $0422a6ce4ea03acc$var$JP,
        AlphabetFilter: $0422a6ce4ea03acc$var$nB,
        AudioPlayer: $0422a6ce4ea03acc$var$iB,
        Banner: $0422a6ce4ea03acc$var$gB,
        CustomBreadcrumb: $0422a6ce4ea03acc$var$SB,
        CustomButton: $0422a6ce4ea03acc$var$ZB,
        ButtonGroup: $0422a6ce4ea03acc$var$OB,
        Checkbox: $0422a6ce4ea03acc$var$UB,
        CheckboxGroup: $0422a6ce4ea03acc$var$WB,
        ComponentWrapper: $0422a6ce4ea03acc$var$IB,
        CustomSelect: $0422a6ce4ea03acc$var$GB,
        DatePicker: $0422a6ce4ea03acc$var$iF,
        FeedbackBox: $0422a6ce4ea03acc$var$sF,
        FeaturedContent: $0422a6ce4ea03acc$var$dF,
        Fieldset: $0422a6ce4ea03acc$var$CF,
        FilterBar: $0422a6ce4ea03acc$var$pF,
        Heading: $0422a6ce4ea03acc$var$EF,
        HelperErrorText: $0422a6ce4ea03acc$var$DF,
        Hero: $0422a6ce4ea03acc$var$IF,
        HorizontalRule: $0422a6ce4ea03acc$var$$F,
        Label: $0422a6ce4ea03acc$var$XF,
        Link: $0422a6ce4ea03acc$var$xF,
        ReservoirList: $0422a6ce4ea03acc$var$JF,
        Logo: $0422a6ce4ea03acc$var$rA,
        Menu: $0422a6ce4ea03acc$var$lA,
        Modal: $0422a6ce4ea03acc$var$cA,
        MultiSelect: $0422a6ce4ea03acc$var$pA,
        MultiSelectItemsCountButton: $0422a6ce4ea03acc$var$hA,
        Notification: $0422a6ce4ea03acc$var$wA,
        NotificationContent: $0422a6ce4ea03acc$var$MA,
        NotificationHeading: $0422a6ce4ea03acc$var$TA,
        NewsletterSignup: $0422a6ce4ea03acc$var$gA,
        Pagination: $0422a6ce4ea03acc$var$RA,
        ProgressIndicator: $0422a6ce4ea03acc$var$NA,
        Radio: $0422a6ce4ea03acc$var$zA,
        RadioGroup: $0422a6ce4ea03acc$var$YA,
        RadioWrapper: $0422a6ce4ea03acc$var$UA,
        ...$0422a6ce4ea03acc$var$tj,
        ReservoirIcon: $0422a6ce4ea03acc$var$GF,
        ReservoirImage: $0422a6ce4ea03acc$var$lj,
        ReservoirImageWrapper: $0422a6ce4ea03acc$var$sj,
        SearchBar: $0422a6ce4ea03acc$var$dj,
        SkeletonLoader: $0422a6ce4ea03acc$var$vj,
        SkipNavigation: $0422a6ce4ea03acc$var$gj,
        CustomSlider: $0422a6ce4ea03acc$var$JB,
        StatusBadge: $0422a6ce4ea03acc$var$cB,
        StructuredContent: $0422a6ce4ea03acc$var$bj,
        StyledList: $0422a6ce4ea03acc$var$wj,
        SocialMediaLinks: $0422a6ce4ea03acc$var$xj,
        Tabs: $0422a6ce4ea03acc$var$Rj,
        CustomTable: $0422a6ce4ea03acc$var$nF,
        ...$0422a6ce4ea03acc$var$Fj,
        ...$0422a6ce4ea03acc$var$Yj,
        Text: $0422a6ce4ea03acc$var$qj,
        TextInput: $0422a6ce4ea03acc$var$Xj,
        ...$0422a6ce4ea03acc$var$dz,
        Tooltip: $0422a6ce4ea03acc$var$Cz,
        VideoPlayer: $0422a6ce4ea03acc$var$vz
    },
    config: {
        // Use `cssVarPrefix` to set the prefix used on the CSS vars produced by
        // Chakra. By default, Chakra prefixes its own CSS variables with `--chakra`.
        cssVarPrefix: "nypl",
        // Start off in the "light" mode.
        initialColorMode: "light",
        // Don't use the user's system preference. Once the Reservoir
        // has better dark mode variants for its components, this
        // value can be set to true.
        useSystemColorMode: !1
    }
}, $0422a6ce4ea03acc$export$a1997ffb807ec042 = ({ children: r, colorModeManager: a, disableGlobalStyle: o = !1, resetCSS: s = !0, theme: i = {} })=>{
    const p = (0, $a0ae5775f52b77ad$export$33a2b855d5b8731e)($0422a6ce4ea03acc$var$uw($0422a6ce4ea03acc$var$gz, i));
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $87af691840ea6fe4$export$80dbe0482bcbd25a), {
        colorModeManager: a,
        theme: p,
        resetCSS: s,
        disableGlobalStyle: o,
        children: r
    });
};
function $0422a6ce4ea03acc$var$yz(r) {
    const { alt: a, src: o } = r;
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$3e431a229df88919, {
        alt: a,
        src: o
    });
}
const $0422a6ce4ea03acc$export$5b0db12c0e58362a = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { textContent: o, isFullWidth: s, imageProps: i = {
        alt: "",
        position: "end",
        width: "oneHalf",
        src: ""
    }, ...p } = r, C = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("FeaturedContent", {
        imagePosition: i.position,
        imageWidth: i.width,
        isFullWidth: s
    });
    return i.src || console.warn("NYPL Reservoir FeaturedContent: A value for 'imageProps.src' is required."), i.alt || console.warn("NYPL Reservoir FeaturedContent: A value for 'imageProps.alt' is required."), o || console.warn("NYPL Reservoir FeaturedContent: The 'textContent' prop is required."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        "data-testid": "featuredcontent",
        __css: C.base,
        ref: a,
        ...p,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            __css: C.wrapper,
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                    "data-testid": "featuredcontent-bg-image",
                    __css: {
                        ...C.imgWrapper,
                        backgroundImage: `/**/url(${i.src})`
                    },
                    children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$yz, {
                        alt: i.alt,
                        src: i.src ? i.src : void 0
                    })
                }),
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                    __css: C.text,
                    children: o
                })
            ]
        })
    });
})), $0422a6ce4ea03acc$var$Lz = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((r)=>{
    const { children: a, icon: o, id: s, isCentered: i, notificationType: p, ...C } = r, v = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("NotificationHeading", {
        icon: o,
        isCentered: i,
        notificationType: p
    }), y = a ? typeof a == "string" ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$a8a3e93435678ff9, {
        id: `${s}-heading`,
        level: "h4",
        noSpace: !0,
        size: "heading6",
        __css: v.heading,
        children: a
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(a, {
        __css: v.heading,
        noSpace: !0,
        size: "heading6"
    }) : void 0, L = $0422a6ce4ea03acc$var$Yr({
        title: y,
        id: s
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "header",
        __css: v,
        ...C,
        children: [
            o,
            a && L
        ]
    });
}), $0422a6ce4ea03acc$var$bz = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((r)=>{
    const { alignText: a, children: o, isCentered: s, notificationHeading: i, notificationType: p, showIcon: C, ...v } = r, y = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("NotificationContent", {
        alignText: a,
        isCentered: s,
        notificationHeading: i,
        notificationType: p,
        showIcon: C
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: y,
        ...v,
        children: o && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            __css: y.content,
            children: o
        })
    });
}), $0422a6ce4ea03acc$export$14834abbfce3b8cd = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { ariaLabel: o, className: s, dismissible: i = !1, icon: p, id: C, isCentered: v = !1, noMargin: y = !1, notificationContent: L, notificationHeading: M, notificationType: E = "standard", showIcon: k = !0, ..._ } = r, [Z, O] = (0, $acw62.useState)(!0), { colorMode: B } = (0, $b80b1cf263c5808a$export$20f3076712c8dfa)(), z = ()=>O(!1), I = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Notification", {
        isCentered: v,
        noMargin: y,
        notificationHeading: M,
        notificationType: E,
        showIcon: k
    }), P = ()=>{
        const E1 = {
            size: "large",
            __css: I.icon
        };
        if (!k) return;
        if (p) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(p, {
            id: `${C}-custom-notification-icon`,
            ...E1
        });
        const H1 = {
            announcement: {
                color: B === "dark" ? "dark.ui.success.primary" : "section.research.secondary",
                name: "speakerNotes",
                title: "Notification announcement icon"
            },
            standard: {
                color: B === "dark" ? "ui.status.primary" : "ui.black",
                name: "alertNotificationImportant",
                title: "Notification standard icon"
            },
            warning: {
                color: B === "dark" ? "dark.ui.error.primary" : "brand.primary",
                name: "errorFilled",
                title: "Notification warning icon"
            }
        };
        return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
            className: "notification-icon",
            id: `${C}-notification-icon`,
            ...H1[E],
            ...E1
        });
    }, $ = (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("ui.black", "dark.ui.typography.heading"), W = i && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
        "aria-label": "Close the notification",
        buttonType: "text",
        id: `${C}-notification-dismissible-button`,
        onClick: z,
        __css: I.dismissibleButton,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
            fill: $,
            id: `${C}-dismissible-notification-icon`,
            name: "close",
            size: "large",
            title: "Notification close icon"
        })
    }), l1 = P(), u1 = (M || k) && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$Lz, {
        icon: l1,
        id: C,
        isCentered: v,
        notificationType: E,
        children: M
    }), m1 = !!(u1 && k && (p || !v)), L1 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$bz, {
        alignText: m1,
        isCentered: v,
        notificationHeading: M,
        notificationType: E,
        showIcon: k,
        children: L
    });
    return Z ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        "aria-label": o,
        as: "aside",
        className: s,
        "data-type": E,
        id: C,
        ref: a,
        __css: I,
        ..._,
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                __css: I.container,
                children: [
                    u1,
                    L1
                ]
            }),
            W
        ]
    }) : null;
})), $0422a6ce4ea03acc$export$d7b12c4107be0d61 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { className: o, helperText: s, id: i, invalidText: p, isChecked: C, isDisabled: v = !1, isInvalid: y = !1, isRequired: L = !1, labelText: M, name: E, onChange: k, showHelperInvalidText: _ = !0, showLabel: Z = !0, value: O, ...B } = r, z = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Radio", {
        showLabel: Z
    }), I = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("RadioWrapper"), $ = $0422a6ce4ea03acc$var$Uo({
        footnote: y ? p : s,
        id: i,
        labelText: M,
        name: "Radio",
        showLabel: Z
    });
    return delete $["aria-label"], i || console.warn("NYPL Reservoir Radio: This component's required `id` prop was not passed."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$g7, {
        helperText: s,
        helperTextStyles: z.helperErrorText,
        id: i,
        invalidText: p,
        isInvalid: y,
        showHelperInvalidText: _,
        sx: I,
        ...B,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $f521c6bceffd8e4c$export$d7b12c4107be0d61), {
            className: o,
            id: i,
            isChecked: C,
            isDisabled: v,
            isInvalid: y,
            isRequired: L,
            name: E,
            onChange: k,
            ref: a,
            value: O,
            alignItems: "flex-start",
            sx: z,
            ...$,
            children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                as: "span",
                __css: Z ? {} : z.hiddenLabel,
                children: M
            })
        })
    });
})), $0422a6ce4ea03acc$export$a98f0dcb43a68a25 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { children: o, className: s = "", defaultValue: i, helperText: p, id: C, invalidText: v, isDisabled: y = !1, isFullWidth: L = !1, isInvalid: M = !1, isRequired: E = !1, labelText: k, layout: _ = "column", name: Z, onChange: O, showHelperInvalidText: B = !0, showLabel: z = !0, showRequiredLabel: I = !0, ...P } = r, [$, W] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(i), l1 = M ? v : p, u1 = _ === "column" ? $0422a6ce4ea03acc$var$No.s : $0422a6ce4ea03acc$var$No.l, m1 = [], L1 = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("RadioGroup", {
        isFullWidth: L
    }), E1 = {
        name: Z,
        onChange: (H1)=>{
            W(H1), O && O(H1);
        },
        ref: a,
        value: $
    };
    return C || console.warn("NYPL Reservoir RadioGroup: This component's required `id` prop was not passed."), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(o, (H1, B1)=>{
        var h1, k1;
        if ((H1 == null ? void 0 : H1.type) !== $0422a6ce4ea03acc$export$d7b12c4107be0d61 && ((h1 = H1.props) != null && h1.mdxType && ((k1 = H1.props) == null ? void 0 : k1.mdxType) === "Radio" || console.warn("NYPL Reservoir RadioGroup: Only `Radio` components are allowed inside the `RadioGroup` component.")), H1 != null) {
            const I1 = {
                key: B1,
                isDisabled: y,
                isInvalid: M,
                isRequired: E
            };
            m1.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(H1, I1));
        }
    }), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$e154be390aa0e14, {
        className: s,
        id: `radio-group-${C}`,
        isLegendHidden: !z,
        isRequired: E,
        legendText: k,
        showRequiredLabel: I,
        ...P,
        __css: L1,
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $e94b26ac5efe9b2e$export$a98f0dcb43a68a25), {
                ...E1,
                children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
                    direction: [
                        _
                    ],
                    spacing: u1,
                    children: m1
                })
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$75f76bb17920f318, {
                id: `${C}-helperErrorText`,
                isInvalid: M,
                isRenderedText: B,
                text: l1,
                __css: L1.helperErrorText
            })
        ]
    });
})), $0422a6ce4ea03acc$export$f67a0166accba89c = ()=>{
    const [r, a] = (0, $acw62.useState)({
        isLargerThanSmall: !1,
        isLargerThanMedium: !1,
        isLargerThanLarge: !1,
        isLargerThanXLarge: !1
    }), [o, s, i, p] = (0, $63be06194fb9f91c$export$32d5543ab307c01)([
        "(min-width: 320px)",
        "(min-width: 600px)",
        "(min-width: 960px)",
        "(min-width: 1280px)"
    ]);
    return (0, $acw62.useEffect)(()=>{
        a({
            isLargerThanSmall: o,
            isLargerThanMedium: s,
            isLargerThanLarge: i,
            isLargerThanXLarge: p
        });
    }, [
        o,
        s,
        i,
        p
    ]), {
        isLargerThanSmall: r.isLargerThanSmall,
        isLargerThanMedium: r.isLargerThanMedium,
        // NYPL uses the medium 600px breakpoint to determine if the screen is
        // in the mobile view. This is the recommended boolean value to use.
        isLargerThanMobile: r.isLargerThanMedium,
        isLargerThanLarge: r.isLargerThanLarge,
        isLargerThanXLarge: r.isLargerThanXLarge
    };
}, $0422a6ce4ea03acc$var$Iw = {
    category: "comment",
    comment: "",
    email: ""
};
function $0422a6ce4ea03acc$var$xz(r, a) {
    switch(a.type){
        case "category":
            return {
                ...r,
                category: a.payload
            };
        case "comment":
            return {
                ...r,
                comment: a.payload
            };
        case "email":
            return {
                ...r,
                email: a.payload
            };
        case "clear":
        default:
            return $0422a6ce4ea03acc$var$Iw;
    }
}
function $0422a6ce4ea03acc$var$Vz() {
    const [r, a] = (0, $acw62.useReducer)($0422a6ce4ea03acc$var$xz, $0422a6ce4ea03acc$var$Iw);
    return {
        state: r,
        setCategory: (C)=>a({
                type: "category",
                payload: C
            }),
        setComment: (C)=>a({
                type: "comment",
                payload: C
            }),
        setEmail: (C)=>a({
                type: "email",
                payload: C
            }),
        clearValues: ()=>a({
                type: "clear"
            })
    };
}
const $0422a6ce4ea03acc$export$9c3fd7fe9a73f538 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)(({ className: r, confirmationText: a, descriptionText: o, hiddenFields: s, id: i = "feedbackbox", isInvalidComment: p = !1, isInvalidEmail: C = !1, notificationText: v, onSubmit: y, showCategoryField: L = !1, showEmailField: M = !1, title: E, view: k = "form", isOpen: _, onOpen: Z, onClose: O, ...B }, z)=>{
    const [I, P] = $0422a6ce4ea03acc$var$fc(k), [$, W] = $0422a6ce4ea03acc$var$fc(p), [l1, u1] = (0, $acw62.useState)(!1), { state: m1, setCategory: L1, setComment: E1, setEmail: H1, clearValues: B1 } = $0422a6ce4ea03acc$var$Vz(), { isLargerThanMobile: h1 } = $0422a6ce4ea03acc$export$f67a0166accba89c(), k1 = (0, $8b7bde38f2a271a2$export$6e3e27031a30522f)(), I1 = _ || k1.isOpen, D1 = Z || k1.onOpen, s2 = O || k1.onClose, f1 = (0, $acw62.useRef)(), M1 = (0, $acw62.useRef)(), g1 = (0, $acw62.useRef)(), K1 = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("FeedbackBox", {}), G1 = I === "form", R1 = I === "confirmation", E2 = I === "error", a3 = 3e3, H2 = 500, A2 = 165, u2 = "auto 1fr", o2 = (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)(null, "dark.ui.typography.body"), P2 = 235, G2 = 275, V3 = 345, I2 = 37, T1 = 24;
    let j1 = A2;
    const N2 = ()=>{
        s2(), P("form"), B1(), W(!1), setTimeout(()=>{
            var D2;
            (D2 = M1 == null ? void 0 : M1.current) == null || D2.focus();
        }, 250);
    }, _2 = (D2)=>{
        var se;
        D2.preventDefault();
        let z3 = {
            ...m1
        };
        if (s && (z3 = {
            ...z3,
            ...s
        }), z3.comment.length === 0) {
            (se = g1 == null ? void 0 : g1.current) == null || se.focus(), W(!0);
            return;
        }
        y && y(z3), W(!1), u1(!0);
    }, R3 = G1 && v ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$14834abbfce3b8cd, {
        isCentered: !0,
        noMargin: !0,
        notificationContent: v,
        showIcon: !1,
        p: "0",
        sx: {
            // The padding of the Notification is smaller than
            // the initial one.
            "> div": {
                py: "xs"
            }
        },
        width: "100%"
    }) : void 0, he = (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("ui.typography.heading", "dark.ui.typography.heading"), j3 = G1 && o ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
        color: he,
        fontWeight: "medium",
        noSpace: !0,
        children: o
    }) : void 0, ee = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$56e87bf42978147a, {
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$a6c7ac8248d6e38a, {
            href: "https://www.nypl.org/help/about-nypl/legal-notices/privacy-policy",
            type: "external",
            fontSize: "text.tag",
            isUnderlined: !1,
            width: "fit-content",
            children: "Privacy Policy"
        })
    });
    (0, $acw62.useEffect)(()=>{
        let D2;
        return l1 && (D2 = setTimeout(()=>{
            u1(!1), P(E2 ? "error" : "confirmation"), B1();
        }, a3), k !== I && (u1(!1), P(k), clearTimeout(D2))), ()=>clearTimeout(D2);
    }, [
        B1,
        E2,
        l1,
        P,
        k,
        I
    ]), (0, $acw62.useEffect)(()=>{
        let D2;
        return (I === "error" || I === "confirmation") && (D2 = setTimeout(()=>{
            var z3;
            (z3 = f1 == null ? void 0 : f1.current) == null || z3.focus();
        }, 250)), ()=>clearTimeout(D2);
    }, [
        f1,
        I
    ]), L && (j1 = P2), M && (j1 = G2), L && M && (j1 = V3), v && (j1 += I2), o && (j1 += T1), v && o && (j1 += 16);
    let me = j1 + "px";
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        className: r,
        id: i,
        ref: z,
        sx: K1,
        ...B,
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                id: "open",
                onClick: D1,
                sx: K1.openButton,
                ref: M1,
                children: E
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2c5be1008fbfcbeb$export$4071300121a182f5), {
                blockScrollOnMount: !1,
                isOpen: I1,
                onClose: N2,
                placement: "bottom",
                children: [
                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $006bfa297e893b21$export$8948f78d83984c69), {}),
                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $de1928e3734003a6$export$57ca055474bc0056), {
                        sx: K1.drawerContent,
                        children: [
                            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                                buttonType: "text",
                                id: "close-btn",
                                onClick: N2,
                                sx: K1.closeButton,
                                children: [
                                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                                        color: "ui.black",
                                        name: "minus",
                                        size: "medium"
                                    }),
                                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs("span", {
                                        children: [
                                            "Close ",
                                            E
                                        ]
                                    })
                                ]
                            }),
                            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $fae03f3c1cb3a345$export$f50a68e3694789ee), {
                                sx: K1.drawerHeader,
                                children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
                                    "data-testid": "title",
                                    children: E
                                })
                            }),
                            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $0caf763c70514c51$export$cb540d8b0ef7906c), {
                                sx: K1.drawerBody,
                                children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$a7fed597f4b8afd8, {
                                    gap: "grid.s",
                                    id: "feedback-form",
                                    onSubmit: _2,
                                    sx: {
                                        ".feedback-body": {
                                            alignItems: "flex-start",
                                            minHeight: me,
                                            gridTemplateRows: u2
                                        },
                                        ".feedback-body.response": {
                                            alignItems: "center",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center"
                                        }
                                    },
                                    children: [
                                        G1 && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                                            children: [
                                                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $f85d52b2d7cbb881$export$e6c02a6dccfa2120), {
                                                    className: "feedback-body",
                                                    spacing: "s",
                                                    children: [
                                                        (R3 || j3) && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                                                            children: [
                                                                R3,
                                                                j3
                                                            ]
                                                        }),
                                                        L && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$56e87bf42978147a, {
                                                            children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$a98f0dcb43a68a25, {
                                                                defaultValue: m1.category,
                                                                id: `${i}-category`,
                                                                isDisabled: l1,
                                                                labelText: "What is your feedback about?",
                                                                layout: h1 ? "row" : "column",
                                                                name: `${i}-category`,
                                                                onChange: (D2)=>L1(D2),
                                                                children: [
                                                                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$d7b12c4107be0d61, {
                                                                        id: "comment",
                                                                        labelText: "Comment",
                                                                        value: "comment"
                                                                    }),
                                                                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$d7b12c4107be0d61, {
                                                                        id: "correction",
                                                                        labelText: "Correction",
                                                                        value: "correction"
                                                                    }),
                                                                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$d7b12c4107be0d61, {
                                                                        id: "bug",
                                                                        labelText: "Bug",
                                                                        value: "bug"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$56e87bf42978147a, {
                                                            width: "100%",
                                                            children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$c86715117507e8e5, {
                                                                defaultValue: m1.comment,
                                                                helperText: `${H2 - m1.comment.length} characters remaining`,
                                                                id: `${i}-comment`,
                                                                invalidText: "There was a problem. Please fill out this field.",
                                                                isDisabled: l1,
                                                                isInvalid: $,
                                                                labelText: "Comment (Required)",
                                                                maxLength: H2,
                                                                name: `${i}-comment`,
                                                                onChange: (D2)=>E1(D2.target.value),
                                                                placeholder: "Enter your question or feedback here",
                                                                ref: g1,
                                                                type: "textarea"
                                                            })
                                                        }),
                                                        M && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$56e87bf42978147a, {
                                                            width: "100%",
                                                            children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$c86715117507e8e5, {
                                                                id: `${i}-email`,
                                                                invalidText: "There was a problem. Please enter a valid email address.",
                                                                isDisabled: l1,
                                                                isInvalid: C,
                                                                labelText: "Email",
                                                                name: `${i}-email`,
                                                                onChange: (D2)=>H1(D2.target.value),
                                                                placeholder: "Enter your email address here",
                                                                type: "email",
                                                                value: m1.email
                                                            })
                                                        })
                                                    ]
                                                }),
                                                ee,
                                                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$56e87bf42978147a, {
                                                    children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$69b1032f2ecdf404, {
                                                        buttonWidth: "full",
                                                        id: "submit-cancel",
                                                        children: [
                                                            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                                                                buttonType: "secondary",
                                                                id: "cancel",
                                                                isDisabled: l1,
                                                                onClick: N2,
                                                                children: "Cancel"
                                                            }, "cancel"),
                                                            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                                                                id: "submit",
                                                                isDisabled: l1,
                                                                type: "submit",
                                                                children: "Submit"
                                                            }, "submit")
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        R1 && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                                            children: [
                                                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                                                    className: "feedback-body response",
                                                    margin: "auto",
                                                    tabIndex: -1,
                                                    textAlign: "center",
                                                    ref: f1,
                                                    children: [
                                                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                                                            color: o2,
                                                            name: "actionCheckCircleFilled",
                                                            size: "large"
                                                        }),
                                                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
                                                            fontWeight: "medium",
                                                            children: "Thank you for submitting your feedback."
                                                        }),
                                                        M && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
                                                            children: "If you provided an email address and require a response, our service staff will reach out to you via email."
                                                        }),
                                                        a ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
                                                            children: a
                                                        }) : void 0
                                                    ]
                                                }, "confirmationWrapper"),
                                                ee,
                                                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$56e87bf42978147a, {
                                                    children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$69b1032f2ecdf404, {
                                                        buttonWidth: "full",
                                                        id: "submit-cancel",
                                                        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                                                            id: "return-browsing",
                                                            buttonType: "secondary",
                                                            onClick: N2,
                                                            children: "Return to Browsing"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        E2 && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                                            children: [
                                                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                                                    className: "feedback-body response",
                                                    color: "ui.error.primary",
                                                    margin: "auto",
                                                    tabIndex: -1,
                                                    textAlign: "center",
                                                    ref: f1,
                                                    children: [
                                                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                                                            color: "ui.error.primary",
                                                            name: "errorFilled",
                                                            size: "large"
                                                        }),
                                                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$5f1af8db9871e1d6, {
                                                            fontWeight: "medium",
                                                            children: "Oops! Something went wrong. An error occured while processing your feedback."
                                                        })
                                                    ]
                                                }, "errorWrapper"),
                                                ee,
                                                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$56e87bf42978147a, {
                                                    children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$69b1032f2ecdf404, {
                                                        buttonWidth: "full",
                                                        id: "submit-cancel",
                                                        children: [
                                                            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                                                                id: "return-browsing2",
                                                                buttonType: "secondary",
                                                                onClick: N2,
                                                                children: "Return to Browsing"
                                                            }, "return-browsing2"),
                                                            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                                                                id: "try-again",
                                                                onClick: ()=>P("form"),
                                                                children: "Try Again"
                                                            }, "try-again")
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}));
function $0422a6ce4ea03acc$export$c61fc57ab0b7c5d2() {
    const { isOpen: r, onClose: a, onOpen: o } = (0, $8b7bde38f2a271a2$export$6e3e27031a30522f)(), s = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((i)=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$9c3fd7fe9a73f538, {
            isOpen: r,
            onClose: a,
            onOpen: o,
            ...i
        }));
    return {
        isOpen: r,
        onClose: a,
        onOpen: o,
        FeedbackBox: s
    };
}
const $0422a6ce4ea03acc$var$ub = [
    "secondary",
    "secondaryBooksAndMore",
    "secondaryLocations",
    "secondaryResearch",
    "secondaryWhatsOn"
], $0422a6ce4ea03acc$export$887967f05dc521ae = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { backdropBackgroundColor: o, backgroundColor: s, backgroundImageSrc: i, foregroundColor: p, heading: C, heroType: v, id: y, imageProps: L = {
        alt: "",
        id: void 0,
        src: ""
    }, isDarkText: M, isDarkBackgroundImage: E = !1, locationDetails: k, subHeaderText: _ } = r, Z = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Hero", {
        foregroundColor: p,
        isDarkText: M,
        variant: v
    }), O = Z.heading, B = C && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(C, {
        __css: O
    });
    let z = {}, I = {};
    L.src && !L.alt && console.warn('NYPL Reservoir Hero: The "imageProps.src" prop was passed but the "imageProps.alt" props was not. This will make the rendered image inaccessible.'), v === "primary" ? (i || console.warn("NYPL Reservoir Hero: It is recommended to use the `backgroundImageSrc` prop for the `'primary'` `heroType` variant."), L.alt && L.src && console.warn("NYPL Reservoir Hero: The `imageProps.src` and `imageProps.alt` props have been passed, but the `'primary'` `heroType` variant will not use it.")) : k && console.warn("NYPL Reservoir Hero: The `locationDetails` prop should only be used with the `'primary'` `heroType` variant."), $0422a6ce4ea03acc$var$ub.includes(v) && i && console.warn("NYPL Reservoir Hero: The `backgroundImageSrc` prop has been passed, but the `'secondary'` `heroType` variant will not use it."), v === "tertiary" && (i || L.src) && console.warn("NYPL Reservoir Hero: The `'tertiary'` `heroType` variant hero will not use any of the image props."), v === "campaign" && (!o || !i || !L.src) && console.warn("NYPL Reservoir Hero: It is recommended to use either the `backdropBackgroundColor`, `backgroundImageSrc`, or `imageProps.src` prop for the `'campaign'` `heroType` variant."), v === "fiftyFifty" && i && console.warn("NYPL Reservoir Hero: The `backgroundImageSrc` prop has been passed, but the `'fiftyFifty'` `heroType` variant hero will not use it."), v !== "campaign" && o && console.warn("NYPL Reservoir Hero: The `backdropBackgroundColor` prop has been passed, but the `'campaign'` `heroType` variant was not set. It will be ignored."), v !== "campaign" && E && console.warn("NYPL Reservoir Hero: The `isDarkBackgroundImage` prop has been passed, but the `'campaign'` `heroType` variant was not set. It will be ignored.");
    const P = {
        primary: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("ui.black", "dark.ui.bg.default"),
        secondary: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("ui.bg.default", "dark.ui.bg.default"),
        tertiary: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("ui.gray.x-dark", "dark.ui.bg.default"),
        campaign: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("ui.black", "dark.ui.bg.default"),
        campaignBackdrop: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("dark.ui.bg.active", "dark.ui.bg.active"),
        fiftyFifty: (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("ui.bg.default", "dark.ui.bg.default")
    }, $ = P[v];
    if (v === "primary") z = i ? {
        bgColor: $,
        backgroundImage: `/**/url("${i}")`
    } : {};
    else if (v === "secondary") z = {
        bgColor: $
    };
    else if (v === "campaign") {
        const u1 = {
            content: '""',
            height: {
                base: "100%",
                md: "calc(100% - var(--nypl-space-xl))"
            },
            minHeight: "300px",
            paddingBottom: {
                base: "0",
                md: "xl"
            },
            position: "absolute",
            top: 0,
            width: "100%"
        };
        z = i ? {
            _before: {
                ...u1,
                bgColor: "ui.black"
            },
            _after: {
                ...u1,
                backgroundBlendMode: E ? "saturation" : null,
                backgroundImage: E ? `/**/linear-gradient(black, black), url("${i}")` : `/**/url("${i}")`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                opacity: E ? "0.4" : "1.0"
            }
        } : o ? {
            _before: {
                ...u1,
                bgColor: o
            }
        } : {
            _before: {
                ...u1,
                bgColor: P.campaignBackdrop
            }
        };
    } else (v === "tertiary" || v === "fiftyFifty") && (z = s ? {
        bgColor: s
    } : {
        bgColor: s || $
    });
    $0422a6ce4ea03acc$var$ub.includes(v) ? (p || s || o) && console.warn("NYPL Reservoir Hero: The `foregroundColor`, `backgroundColor`, or `backdropBackgroundColor` props have been passed, but the `'secondary'` `heroType` variant will not use them.") : I = {
        ...p && {
            color: p
        },
        ...s ? {
            backgroundColor: s
        } : {
            bgColor: $
        }
    }, p && M && console.warn("NYPL Reservoir Hero: The `foregroundColor` and `isDarkText` props have both been passed. Thse props can not be used at the same time, so the `foregroundColor` prop will override the `isDarkText` prop.");
    const W = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$3e431a229df88919, {
        alt: L.alt,
        fallbackSrc: L.fallbackSrc,
        id: L.id,
        onError: L.onError,
        src: L.src
    }), l1 = v === "campaign" ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                __css: {
                    ...Z.imgWrapper
                },
                style: {
                    backgroundImage: `/**/url("${L.src}")`
                },
                children: W
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                __css: Z.interior,
                children: [
                    B,
                    _
                ]
            })
        ]
    }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
        children: [
            v !== "primary" && v !== "tertiary" && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                __css: {
                    ...Z.imgWrapper
                },
                style: {
                    backgroundImage: v === "fiftyFifty" ? `/**/url("${L.src}")` : void 0
                },
                children: W
            }),
            B,
            v === "tertiary" && _ ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("p", {
                children: _
            }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                __css: Z.bodyText,
                children: _
            })
        ]
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        "data-testid": "hero",
        "data-responsive-background-image": !0,
        id: y,
        ref: a,
        __css: {
            ...Z.base,
            ...z
        },
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            "data-testid": "hero-content",
            style: I,
            __css: {
                ...Z.content,
                ...I
            },
            children: l1
        })
    });
}), {
    shouldForwardProp: ()=>!0
}), $0422a6ce4ea03acc$export$841e9c95e6429474 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { align: o, className: s, id: i, ...p } = r, v = {
        ...(0, $6225152922b2fd2b$export$b863f77547fbcb03)("HorizontalRule", {
            align: o
        }),
        height: "2px",
        width: "100%"
    };
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "hr",
        className: s,
        id: i,
        ref: a,
        __css: v,
        ...p
    });
})), $0422a6ce4ea03acc$export$54c2e3dc7acea9f5 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { children: o, className: s, id: i, inline: p = !1, listItems: C, noStyling: v = !1, showRowDividers: y = !0, title: L, type: M = "ul", ...E } = r, k = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("ReservoirList", {
        inline: p,
        noStyling: v,
        showRowDividers: y,
        variant: M
    }), _ = $0422a6ce4ea03acc$var$Yr({
        title: L,
        id: i,
        additionalStyles: k.heading
    });
    let Z = null;
    if (o && C && (C == null ? void 0 : C.length) > 0) return console.warn("NYPL Reservoir List: Pass in either `<li>`, `<dt>`, or `<dd>` children or use the `listItems` data prop. Do not use both."), null;
    if (!o && !C) return console.warn("NYPL Reservoir List: Pass in either `<li>` children or pass data in the `listItems` prop, not both."), null;
    const O = (z)=>o || (C ? z === "ol" || z === "ul" ? C.map((I, P)=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("li", {
                children: I
            }, P)) : z === "dl" ? C.map((I, P)=>[
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("dt", {
                    children: I.term
                }, `${P}-term`),
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("dd", {
                    children: I.description
                }, `${P}-des`)
            ]) : null : null);
    return M === "ol" || M === "ul" ? ($0422a6ce4ea03acc$var$Yw(o, M), Z = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: M,
        id: i,
        className: s,
        ref: a,
        __css: k.base,
        ...E,
        children: O(M)
    })) : M === "dl" && ((()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(o, (z)=>{
            z.type !== "dt" && z.type !== "dd" && z.type !== (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment && z.props.mdxType !== "dt" && z.props.mdxType !== "dd" && z.props.mdxType !== (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment && console.warn("NYPL Reservoir List: Direct children of `List` (description) must be `<dt>`s and `<dd>`s.");
        });
    })(), Z = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "section",
        id: i,
        className: s,
        ref: a,
        __css: k.base,
        ...E,
        children: [
            _,
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("dl", {
                children: O(M)
            })
        ]
    })), Z;
})), $0422a6ce4ea03acc$var$Yw = (r, a = "ul", o = "List")=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(r, (s)=>{
        var i;
        s && (s == null ? void 0 : s.type) !== "li" && ((i = s == null ? void 0 : s.props) == null ? void 0 : i.mdxType) !== "li" && console.warn(`NYPL Reservoir ${o}: Direct children of \`${o}\` (${a}) must be \`<li>\`s.`);
    });
}, $0422a6ce4ea03acc$var$Ez = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 200 67",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M184.072 0H12.569C11.4488 0.017257 10.3314 0.118035 9.22616 0.3015C8.12109 0.492882 7.05074 0.848553 6.0505 1.35675C5.04367 1.86574 4.12857 2.5394 3.34282 3.35C2.53991 4.13873 1.87341 5.05573 1.37057 6.0635C0.863464 7.0659 0.508556 8.13856 0.317586 9.246C0.131064 10.3529 0.0360291 11.4734 0.0334473 12.596C0.0334473 13.1153 0.0334473 13.6345 0.0334473 14.137V52.863C0.0334473 53.3823 0.0334473 53.8848 0.0334473 54.404C0.0360291 55.5266 0.131064 56.6471 0.317586 57.754C0.508403 58.8668 0.863278 59.945 1.37057 60.9533C1.87808 61.9532 2.54415 62.8639 3.34282 63.65C4.12986 64.4546 5.04489 65.1226 6.0505 65.6265C7.05074 66.1347 8.12109 66.4904 9.22616 66.6818C10.3314 66.8652 11.4488 66.966 12.569 66.9833H187.431C188.551 66.9667 189.669 66.866 190.774 66.6818C191.884 66.4879 192.959 66.1324 193.966 65.6265C194.969 65.1182 195.884 64.4507 196.674 63.65C197.462 62.8552 198.127 61.9461 198.646 60.9533C199.141 59.9413 199.49 58.8641 199.682 57.754C199.866 56.6465 199.967 55.5266 199.983 54.404C199.983 53.8848 199.983 53.3823 199.983 52.863V14.137C199.983 13.6345 199.983 13.1153 199.983 12.596C199.967 11.4734 199.866 10.3535 199.682 9.246C199.49 8.14123 199.141 7.06963 198.646 6.0635C198.132 5.06282 197.467 4.14758 196.674 3.35C195.884 2.54927 194.969 1.88183 193.966 1.3735C192.959 0.867607 191.884 0.512092 190.774 0.31825C189.669 0.134041 188.551 0.0332577 187.431 0.01675H184.088L184.072 0Z",
        fill: "#B7B7B7"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M14.1065 65.526H12.6023C11.5567 65.5441 10.5114 65.4769 9.47674 65.325C8.50102 65.1332 7.55993 64.7943 6.6855 64.32C5.8234 63.8952 5.03817 63.3291 4.36225 62.645C3.67881 61.9619 3.11392 61.1694 2.69085 60.3C2.24572 59.4251 1.93576 58.4876 1.77157 57.5195C1.60165 56.4839 1.51224 55.4367 1.50415 54.3872C1.50415 54.0355 1.50415 52.8462 1.50415 52.8462V14.137C1.50415 14.137 1.50415 12.9812 1.50415 12.6462C1.51156 11.5967 1.60097 10.5495 1.77157 9.51397C1.92457 8.53464 2.22909 7.58523 2.67413 6.69997C3.09361 5.82842 3.65891 5.03529 4.34553 4.35497C5.03337 3.67751 5.82295 3.11231 6.6855 2.67997C7.55847 2.23389 8.49398 1.92326 9.46003 1.75872C10.4989 1.58756 11.5495 1.49796 12.6023 1.49072H187.414C188.456 1.49956 189.495 1.58916 190.523 1.75872C191.494 1.92678 192.434 2.2372 193.314 2.67997C195.048 3.55887 196.458 4.96644 197.342 6.69997C197.777 7.57177 198.081 8.50303 198.245 9.46372C198.412 10.5056 198.507 11.5578 198.529 12.6127V14.1035C198.529 14.74 198.529 15.343 198.529 15.946V51.0205C198.529 51.6402 198.529 52.2265 198.529 52.8295V54.3872C198.508 55.4256 198.413 56.4611 198.245 57.486C198.086 58.4586 197.782 59.4016 197.342 60.2832C196.912 61.1432 196.348 61.929 195.671 62.6115C194.989 63.2964 194.199 63.8625 193.331 64.2865C192.462 64.7799 191.52 65.1306 190.54 65.325C189.507 65.4993 188.462 65.589 187.414 65.593H14.1065V65.526Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M41.4006 34.0024C41.4153 32.6035 41.7851 31.2313 42.4752 30.0152C43.1653 28.7991 44.153 27.779 45.3451 27.0511C44.5877 25.9692 43.5892 25.0789 42.4287 24.4509C41.2682 23.8229 39.9777 23.4744 38.6595 23.4331C35.8683 23.1316 33.1439 25.1081 31.7065 25.1081C30.2691 25.1081 28.0461 23.4331 25.6727 23.4331C24.1392 23.4831 22.6448 23.9307 21.3354 24.7321C20.026 25.5336 18.9463 26.6615 18.2016 28.0059C15.0426 33.6841 17.3826 41.8749 20.4747 46.4644C22.0291 48.6921 23.8175 51.1711 26.2076 51.0706C28.5977 50.9701 29.3833 49.5966 32.1912 49.5966C34.9992 49.5966 35.768 51.0706 38.1915 51.0204C40.6151 50.9701 42.2531 48.7927 43.7406 46.5481C44.8512 44.966 45.7084 43.2197 46.2811 41.3724C44.8338 40.7621 43.5986 39.7371 42.7304 38.426C41.8621 37.1148 41.3995 35.576 41.4006 34.0024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M36.7708 20.4517C38.1215 18.8175 38.7866 16.7218 38.6261 14.606C36.5543 14.83 34.6408 15.8217 33.2608 17.3865C31.9084 18.9363 31.2234 20.9598 31.3555 23.0145C32.3926 23.0247 33.4186 22.7995 34.3565 22.3556C35.2943 21.9118 36.1198 21.2609 36.7708 20.4517V20.4517Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M70.7003 45.4594H62.7946L60.8892 51.0874H57.5464L65.0343 30.2839H68.5275L76.0154 51.0874H72.6726L70.7003 45.4594ZM63.6136 42.8632H69.8813L66.8561 33.7344H66.7725L63.6136 42.8632Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M92.1945 43.55C92.1945 48.2567 89.6707 51.2885 85.8767 51.2885C84.9086 51.3295 83.9486 51.0968 83.1062 50.617C82.2639 50.1371 81.5732 49.4295 81.1132 48.575V48.575V56.079H77.9375V35.979H80.946V38.525C81.4346 37.6827 82.1417 36.9888 82.9921 36.5169C83.8426 36.0451 84.8048 35.8129 85.7764 35.845C89.6707 35.7612 92.1945 38.793 92.1945 43.55ZM89.0022 43.55C89.0022 40.4847 87.3308 38.525 85.0075 38.525C82.6843 38.525 81.0296 40.5852 81.0296 43.55C81.0296 46.5147 82.701 48.6587 85.0075 48.6587C87.3141 48.6587 89.0022 46.5985 89.0022 43.55Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M108.842 43.5499C108.842 48.2567 106.335 51.2885 102.54 51.2885C101.572 51.3315 100.611 51.0996 99.7686 50.6196C98.9259 50.1395 98.2355 49.4308 97.777 48.5749V56.0789H94.6013V35.9789H97.6098V38.5249C98.097 37.6852 98.8015 36.993 99.6487 36.5213C100.496 36.0495 101.455 35.8159 102.423 35.8449C106.318 35.7612 108.842 38.7929 108.842 43.5499ZM105.649 43.5499C105.649 40.4847 104.078 38.5249 101.655 38.5249C99.2311 38.5249 97.6934 40.5852 97.6934 43.5499C97.6934 46.5147 99.2812 48.5749 101.655 48.5749C104.028 48.5749 105.649 46.5984 105.649 43.5499V43.5499Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M119.856 45.2251C120.09 47.2853 122.079 48.5751 124.871 48.5751C127.662 48.5751 129.367 47.2183 129.367 45.3591C129.367 43.4998 128.23 42.7796 125.539 42.1096L122.848 41.4563C119.037 40.5351 117.282 38.7596 117.282 35.8618C117.282 32.2606 120.391 29.7983 124.82 29.7983C129.25 29.7983 132.225 32.2606 132.325 35.8618H129.133C128.949 33.7848 127.227 32.5118 124.737 32.5118C122.246 32.5118 120.525 33.7681 120.525 35.6273C120.525 37.0846 121.611 37.9556 124.286 38.6256L126.575 39.1783C130.837 40.1833 132.609 41.9086 132.609 44.9403C132.609 48.8431 129.5 51.2718 124.586 51.2718C119.99 51.2718 116.881 48.8933 116.681 45.1413L119.856 45.2251Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M139.311 32.3274V35.9119H142.186V38.3741H139.311V46.7491C139.311 48.0389 139.88 48.6419 141.15 48.6419C141.489 48.6627 141.83 48.6627 142.169 48.6419V51.0874C141.618 51.1915 141.059 51.2419 140.498 51.2381C137.423 51.2381 136.236 50.0824 136.236 47.1344V38.3741H133.979V35.9119H136.186V32.3274H139.311Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M143.841 43.5501C143.841 38.7763 146.649 35.7781 151.028 35.7781C155.407 35.7781 158.198 38.7763 158.198 43.5501C158.198 48.3238 155.44 51.2718 151.028 51.2718C146.615 51.2718 143.841 48.2903 143.841 43.5501ZM155.039 43.5501C155.039 40.2838 153.535 38.3408 151.028 38.3408C148.521 38.3408 147.083 40.2001 147.083 43.5501C147.083 46.9001 148.571 48.7593 151.095 48.7593C153.619 48.7593 155.039 46.7828 155.039 43.5501Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M160.772 35.9121H163.797V38.5251C164 37.7201 164.473 37.0095 165.136 36.5124C165.8 36.0153 166.613 35.7619 167.441 35.7948C167.801 35.789 168.161 35.8284 168.511 35.9121V38.8266C168.075 38.6452 167.611 38.543 167.14 38.5251C166.673 38.4908 166.205 38.5615 165.769 38.7319C165.333 38.9023 164.94 39.1682 164.62 39.5101C164.3 39.8521 164.059 40.2614 163.917 40.7082C163.775 41.1551 163.734 41.6281 163.797 42.0928V51.0876H160.772V35.9121Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M182.818 46.632C182.4 49.379 179.726 51.2718 176.316 51.2718C171.904 51.2718 169.179 48.307 169.179 43.5668C169.179 38.8265 171.921 35.7278 176.183 35.7278C180.445 35.7278 183.002 38.6088 183.002 43.215V44.2703H172.305V44.4713C172.257 45.0293 172.328 45.5912 172.514 46.1196C172.699 46.648 172.994 47.131 173.38 47.5364C173.765 47.9418 174.233 48.2605 174.75 48.4713C175.268 48.6822 175.825 48.7803 176.383 48.7593C177.116 48.8279 177.852 48.658 178.481 48.2749C179.11 47.8917 179.599 47.3157 179.876 46.632H182.818ZM172.322 42.0928H179.893C179.921 41.5917 179.845 41.0902 179.67 40.62C179.495 40.1498 179.224 39.7211 178.876 39.3607C178.527 39.0004 178.108 38.7163 177.645 38.5263C177.181 38.3364 176.683 38.2447 176.183 38.257C175.678 38.2548 175.177 38.3523 174.71 38.5439C174.243 38.7354 173.818 39.0174 173.459 39.3735C173.101 39.7297 172.816 40.1532 172.621 40.6198C172.425 41.0863 172.324 41.5869 172.322 42.0928Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M63.2291 14.6228C63.8849 14.5764 64.5427 14.6776 65.1545 14.9187C65.7663 15.1599 66.3165 15.535 66.7651 16.0166C67.2136 16.4982 67.5491 17.0742 67.7471 17.7025C67.945 18.3307 68.0003 18.9953 67.9091 19.6478C67.9091 22.8303 66.2377 24.6728 63.2291 24.6728H59.6189V14.6228H63.2291ZM61.1733 23.1988H63.0453C63.5144 23.2367 63.9861 23.168 64.4251 22.9977C64.864 22.8274 65.2589 22.56 65.5803 22.2154C65.9017 21.8708 66.1413 21.4578 66.2811 21.0074C66.421 20.557 66.4576 20.0808 66.3881 19.6143C66.4543 19.1483 66.4155 18.6733 66.2744 18.2244C66.1334 17.7754 65.8937 17.3639 65.573 17.02C65.2523 16.6761 64.8587 16.4087 64.4213 16.2373C63.9839 16.0659 63.5137 15.995 63.0453 16.0298H61.1733V23.1988Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M69.6641 20.837C69.6307 20.349 69.6978 19.8594 69.8611 19.3985C70.0245 18.9376 70.2806 18.5153 70.6137 18.1578C70.9468 17.8003 71.3497 17.5152 71.7973 17.3204C72.245 17.1255 72.7278 17.0249 73.2159 17.0249C73.7039 17.0249 74.1867 17.1255 74.6344 17.3204C75.082 17.5152 75.4849 17.8003 75.818 18.1578C76.1511 18.5153 76.4072 18.9376 76.5706 19.3985C76.734 19.8594 76.801 20.349 76.7676 20.837C76.801 21.3249 76.734 21.8146 76.5706 22.2755C76.4072 22.7363 76.1511 23.1587 75.818 23.5162C75.4849 23.8736 75.082 24.1587 74.6344 24.3536C74.1867 24.5485 73.7039 24.649 73.2159 24.649C72.7278 24.649 72.245 24.5485 71.7973 24.3536C71.3497 24.1587 70.9468 23.8736 70.6137 23.5162C70.2806 23.1587 70.0245 22.7363 69.8611 22.2755C69.6978 21.8146 69.6307 21.3249 69.6641 20.837ZM75.2299 20.837C75.2299 19.162 74.5112 18.2575 73.2242 18.2575C71.9372 18.2575 71.2018 19.2122 71.2018 20.837C71.2018 22.4617 71.8704 23.45 73.2242 23.45C74.578 23.45 75.2132 22.4785 75.2132 20.837H75.2299Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M86.1942 24.6226H84.6565L83.1021 19.0616H82.9851L81.4307 24.6226H79.9097L77.8372 17.0684H79.3414L80.6953 22.8304H80.7955L82.3499 17.0684H83.7706L85.325 22.8304H85.442L86.7792 17.0684H88.2667L86.1942 24.6226Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M90.005 17.0683H91.4424V18.2743H91.5594C91.7442 17.843 92.0603 17.4811 92.4625 17.2405C92.8647 16.9999 93.3325 16.8927 93.7991 16.9343C94.165 16.9051 94.5329 16.959 94.8751 17.0921C95.2174 17.2251 95.5253 17.4339 95.7759 17.7027C96.0266 17.9716 96.2134 18.2937 96.3226 18.6449C96.4317 18.9962 96.4604 19.3676 96.4064 19.7316V24.6226H94.9189V20.1001C94.9189 18.8773 94.3841 18.2743 93.2475 18.2743C92.9959 18.2514 92.7424 18.286 92.5061 18.3754C92.2698 18.4648 92.0567 18.6067 91.883 18.7905C91.7092 18.9743 91.5793 19.1951 91.503 19.4364C91.4267 19.6778 91.406 19.9333 91.4424 20.1838V24.6226H89.9548L90.005 17.0683Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M98.7632 14.137H100.284V24.6225H98.7966L98.7632 14.137Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M102.323 20.837C102.29 20.349 102.357 19.8594 102.52 19.3985C102.684 18.9376 102.94 18.5153 103.273 18.1578C103.606 17.8003 104.009 17.5152 104.456 17.3204C104.904 17.1255 105.387 17.0249 105.875 17.0249C106.363 17.0249 106.846 17.1255 107.294 17.3204C107.741 17.5152 108.144 17.8003 108.477 18.1578C108.81 18.5153 109.066 18.9376 109.23 19.3985C109.393 19.8594 109.46 20.349 109.427 20.837C109.46 21.3249 109.393 21.8146 109.23 22.2755C109.066 22.7363 108.81 23.1587 108.477 23.5162C108.144 23.8736 107.741 24.1587 107.294 24.3536C106.846 24.5485 106.363 24.649 105.875 24.649C105.387 24.649 104.904 24.5485 104.456 24.3536C104.009 24.1587 103.606 23.8736 103.273 23.5162C102.94 23.1587 102.684 22.7363 102.52 22.2755C102.357 21.8146 102.29 21.3249 102.323 20.837V20.837ZM107.889 20.837C107.889 19.162 107.154 18.2575 105.867 18.2575C104.58 18.2575 103.861 19.2122 103.861 20.837C103.861 22.4617 104.58 23.45 105.867 23.45C107.154 23.45 107.889 22.4785 107.889 20.837Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M110.981 22.4785C110.981 21.1217 111.984 20.3512 113.789 20.234L115.828 20.1V19.4467C115.828 18.6595 115.293 18.2072 114.274 18.2072C113.254 18.2072 112.87 18.5087 112.719 19.0447H111.265C111.432 17.7382 112.636 16.9175 114.341 16.9175C116.046 16.9175 117.299 17.8555 117.299 19.4467V24.6225H115.862V23.5505H115.745C115.51 23.9341 115.177 24.2471 114.78 24.4564C114.383 24.6657 113.936 24.7636 113.488 24.7397C113.172 24.7725 112.853 24.7385 112.55 24.6399C112.248 24.5412 111.97 24.3801 111.734 24.1671C111.497 23.954 111.308 23.6936 111.179 23.4027C111.049 23.1119 110.982 22.797 110.981 22.4785ZM115.828 21.775V21.1385L113.99 21.2557C112.953 21.2557 112.469 21.6912 112.469 22.3445C112.469 22.9977 113.07 23.4165 113.873 23.4165C114.109 23.4418 114.349 23.4191 114.577 23.3496C114.805 23.2801 115.016 23.1654 115.199 23.0121C115.381 22.8589 115.531 22.6704 115.639 22.4578C115.747 22.2453 115.812 22.013 115.828 21.775V21.775Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M119.255 20.837C119.255 18.4585 120.475 16.951 122.38 16.951C122.85 16.9307 123.316 17.0443 123.724 17.2785C124.132 17.5126 124.466 17.8579 124.687 18.2742H124.787V14.137H126.275V24.6225H124.854V23.45H124.737C124.5 23.8621 124.155 24.2015 123.74 24.4318C123.325 24.662 122.854 24.7743 122.38 24.7565C120.458 24.7397 119.255 23.2322 119.255 20.837ZM120.792 20.837C120.792 22.512 121.544 23.3997 122.798 23.3997C124.052 23.3997 124.82 22.4282 124.82 20.8537C124.82 19.2792 124.035 18.291 122.798 18.291C121.561 18.291 120.792 19.2625 120.792 20.837Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M132.425 20.837C132.392 20.349 132.459 19.8594 132.622 19.3985C132.785 18.9376 133.042 18.5153 133.375 18.1578C133.708 17.8003 134.111 17.5152 134.558 17.3204C135.006 17.1255 135.489 17.0249 135.977 17.0249C136.465 17.0249 136.948 17.1255 137.395 17.3204C137.843 17.5152 138.246 17.8003 138.579 18.1578C138.912 18.5153 139.168 18.9376 139.332 19.3985C139.495 19.8594 139.562 20.349 139.529 20.837C139.562 21.3249 139.495 21.8146 139.332 22.2755C139.168 22.7363 138.912 23.1587 138.579 23.5162C138.246 23.8736 137.843 24.1587 137.395 24.3536C136.948 24.5485 136.465 24.649 135.977 24.649C135.489 24.649 135.006 24.5485 134.558 24.3536C134.111 24.1587 133.708 23.8736 133.375 23.5162C133.042 23.1587 132.785 22.7363 132.622 22.2755C132.459 21.8146 132.392 21.3249 132.425 20.837ZM137.991 20.837C137.991 19.162 137.255 18.2575 135.985 18.2575C134.715 18.2575 133.963 19.2122 133.963 20.837C133.963 22.4617 134.681 23.45 135.985 23.45C137.289 23.45 137.991 22.4785 137.991 20.837Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M141.518 17.0683H142.938V18.2743H143.055C143.247 17.8447 143.567 17.4852 143.971 17.2453C144.375 17.0053 144.843 16.8967 145.312 16.9343C145.676 16.9078 146.042 16.9637 146.382 17.0979C146.723 17.2321 147.028 17.4412 147.277 17.7097C147.526 17.9783 147.711 18.2994 147.819 18.6493C147.927 18.9993 147.956 19.3691 147.902 19.7315V24.6225H146.431V20.1C146.431 18.8773 145.897 18.2743 144.76 18.2743C144.51 18.2541 144.258 18.2906 144.024 18.3812C143.79 18.4718 143.579 18.6141 143.407 18.7976C143.235 18.981 143.107 19.2009 143.032 19.4409C142.956 19.6809 142.936 19.9348 142.972 20.1838V24.6225H141.484L141.518 17.0683Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M156.31 15.1921V17.1184H157.981V18.4249H156.31V22.3109C156.31 23.0981 156.627 23.4499 157.363 23.4499H157.931V24.6894C157.664 24.7081 157.396 24.7081 157.129 24.6894C155.457 24.6894 154.822 24.1199 154.822 22.6626V18.4249H153.619V17.1854H154.822V15.1921H156.31Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M159.953 14.137H161.441V18.291H161.558C161.748 17.8626 162.065 17.5029 162.465 17.2603C162.865 17.0178 163.33 16.904 163.797 16.9342C164.162 16.9135 164.527 16.9739 164.865 17.1112C165.204 17.2485 165.508 17.4592 165.756 17.7282C166.003 17.9973 166.189 18.3179 166.298 18.6672C166.407 19.0164 166.438 19.3856 166.388 19.7482V24.6225H164.9V20.1C164.9 18.894 164.349 18.291 163.229 18.291C162.974 18.2708 162.717 18.3064 162.477 18.3952C162.236 18.484 162.018 18.624 161.837 18.8055C161.656 18.987 161.516 19.2057 161.428 19.4465C161.339 19.6874 161.304 19.9446 161.324 20.2005V24.6225H159.953V14.137Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M175.096 22.579C174.894 23.2844 174.444 23.893 173.83 24.293C173.216 24.693 172.479 24.8576 171.753 24.7565C171.254 24.7831 170.756 24.6972 170.294 24.5053C169.833 24.3134 169.42 24.0203 169.087 23.6475C168.753 23.2747 168.507 22.8317 168.367 22.3511C168.227 21.8705 168.196 21.3646 168.277 20.8705C168.212 20.3765 168.254 19.8743 168.4 19.398C168.545 18.9216 168.791 18.482 169.121 18.109C169.45 17.7359 169.856 17.438 170.31 17.2353C170.764 17.0327 171.256 16.93 171.753 16.9342C173.843 16.9342 175.096 18.358 175.096 20.7365V21.2557H169.798V21.3395C169.778 21.6187 169.818 21.899 169.915 22.1615C170.012 22.4241 170.164 22.6631 170.36 22.8626C170.555 23.0622 170.791 23.2177 171.052 23.319C171.312 23.4202 171.591 23.4649 171.87 23.45C172.228 23.4904 172.59 23.4247 172.911 23.2609C173.232 23.0972 173.498 22.8426 173.675 22.5287L175.096 22.579ZM169.881 20.1H173.675C173.694 19.8463 173.66 19.5916 173.574 19.352C173.489 19.1125 173.355 18.8935 173.18 18.709C173.005 18.5245 172.794 18.3786 172.56 18.2806C172.326 18.1827 172.074 18.1349 171.82 18.1402C171.563 18.1379 171.309 18.1872 171.072 18.2851C170.834 18.383 170.619 18.5275 170.438 18.7102C170.257 18.8928 170.115 19.1099 170.019 19.3486C169.924 19.5873 169.877 19.8428 169.881 20.1V20.1Z",
        fill: "white"
    })), $0422a6ce4ea03acc$var$Sz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 200 67",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M184.072 0H12.569C11.4488 0.01722 10.3314 0.117782 9.22616 0.300852C8.12109 0.491823 7.05074 0.846731 6.0505 1.35384C5.04367 1.86174 4.12857 2.53394 3.34282 3.3428C2.53991 4.12984 1.87341 5.04487 1.37057 6.05048C0.863464 7.05072 0.508556 8.12107 0.317586 9.22614C0.131064 10.3307 0.0360291 11.4488 0.0334473 12.5689C0.0334473 13.0871 0.0334473 13.6052 0.0334473 14.1066V52.7495C0.0334473 53.2676 0.0334473 53.769 0.0334473 54.2871C0.0360291 55.4073 0.131064 56.5254 0.317586 57.6299C0.508403 58.7404 0.863278 59.8163 1.37057 60.8223C1.87808 61.8201 2.54415 62.7289 3.34282 63.5133C4.12986 64.3162 5.04489 64.9827 6.0505 65.4855C7.05074 65.9926 8.12109 66.3475 9.22616 66.5385C10.3314 66.7216 11.4488 66.8222 12.569 66.8394H187.431C188.551 66.8229 189.669 66.7223 190.774 66.5385C191.884 66.3451 192.959 65.9903 193.966 65.4855C194.969 64.9783 195.884 64.3123 196.674 63.5133C197.462 62.7201 198.127 61.813 198.646 60.8223C199.141 59.8125 199.49 58.7377 199.682 57.6299C199.866 56.5248 199.967 55.4074 199.983 54.2871C199.983 53.769 199.983 53.2676 199.983 52.7495V14.1066C199.983 13.6052 199.983 13.0871 199.983 12.5689C199.967 11.4487 199.866 10.3313 199.682 9.22614C199.49 8.12375 199.141 7.05445 198.646 6.05048C198.132 5.05195 197.467 4.13867 196.674 3.3428C195.884 2.54379 194.969 1.87778 193.966 1.37055C192.959 0.865743 191.884 0.510992 190.774 0.317566C189.669 0.133753 188.551 0.0331862 187.431 0.016714H184.088L184.072 0Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M14.1065 65.3853H12.6023C11.5567 65.4034 10.5114 65.3363 9.47674 65.1847C8.50102 64.9933 7.55993 64.6552 6.6855 64.1819C5.8234 63.758 5.03817 63.1931 4.36225 62.5104C3.67881 61.8289 3.11392 61.038 2.69085 60.1705C2.24572 59.2975 1.93576 58.362 1.77157 57.396C1.60165 56.3626 1.51224 55.3176 1.50415 54.2704C1.50415 53.9194 1.50415 52.7327 1.50415 52.7327V14.1066C1.50415 14.1066 1.50415 12.9534 1.50415 12.6191C1.51156 11.5719 1.60097 10.5268 1.77157 9.49357C1.92457 8.51634 2.22909 7.56896 2.67413 6.68561C3.09361 5.81593 3.65891 5.0245 4.34553 4.34565C5.03337 3.66964 5.82295 3.10565 6.6855 2.67424C7.55847 2.22912 8.49398 1.91916 9.46003 1.75497C10.4989 1.58418 11.5495 1.49477 12.6023 1.48755H187.414C188.456 1.49636 189.495 1.58577 190.523 1.75497C191.494 1.92267 192.434 2.23242 193.314 2.67424C195.048 3.55125 196.458 4.9558 197.342 6.68561C197.777 7.55553 198.081 8.48479 198.245 9.44342C198.412 10.483 198.507 11.533 198.529 12.5857V14.0732C198.529 14.7083 198.529 15.31 198.529 15.9117V50.9109C198.529 51.5293 198.529 52.1143 198.529 52.716V54.2704C198.508 55.3066 198.413 56.3398 198.245 57.3625C198.086 58.333 197.782 59.274 197.342 60.1538C196.912 61.0119 196.348 61.7961 195.671 62.477C194.989 63.1605 194.199 63.7253 193.331 64.1484C192.462 64.6408 191.52 64.9907 190.54 65.1847C189.507 65.3587 188.462 65.4481 187.414 65.4521H14.1065V65.3853Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M41.7851 33.2441C41.8036 31.793 42.1887 30.37 42.9047 29.1077C43.6206 27.8453 44.6441 26.7844 45.88 26.0237C45.094 24.9038 44.058 23.9824 42.854 23.3325C41.65 22.6826 40.3112 22.3222 38.9437 22.2797C36.0187 21.9621 33.1941 23.9511 31.7065 23.9511C30.219 23.9511 27.8957 22.2797 25.4388 22.2797C23.8436 22.3329 22.289 22.7961 20.9248 23.6245C19.5606 24.453 18.4328 25.6189 17.65 27.0098C14.3072 32.843 16.7976 41.3838 20.0234 46.0972C21.6948 48.4037 23.5167 50.961 25.9736 50.8774C28.4306 50.7938 29.3164 49.3397 32.2079 49.3397C35.0995 49.3397 35.9352 50.8774 38.4423 50.8273C40.9494 50.7771 42.6542 48.504 44.2086 46.1808C45.3448 44.5615 46.219 42.7735 46.7993 40.8824C45.3122 40.2334 44.0463 39.1656 43.1559 37.8092C42.2655 36.4528 41.7892 34.8666 41.7851 33.2441Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M37.0382 19.1878C38.4395 17.4894 39.1338 15.3169 38.977 13.1206C36.832 13.3483 34.8512 14.3745 33.428 15.9954C32.0171 17.6054 31.3018 19.709 31.439 21.8453C32.5114 21.8482 33.5709 21.611 34.5398 21.1511C35.5086 20.6913 36.3623 20.0205 37.0382 19.1878Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M70.7003 45.3619H62.7946L60.8892 50.9778H57.5464L65.0343 30.219H68.5275L76.0154 50.9778H72.6726L70.7003 45.3619ZM63.6136 42.7712H69.8813L66.8561 33.6621H66.7725L63.6136 42.7712Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M92.1945 43.4565C92.1945 48.1532 89.6707 51.1784 85.8767 51.1784C84.9086 51.2193 83.9486 50.9871 83.1062 50.5083C82.2639 50.0295 81.5732 49.3234 81.1132 48.4707V55.9586H77.9375V35.9018H80.946V38.4423C81.4346 37.6019 82.1417 36.9094 82.9921 36.4386C83.8426 35.9677 84.8048 35.736 85.7764 35.7681C89.654 35.6845 92.1945 38.7097 92.1945 43.4565ZM89.0022 43.4565C89.0022 40.3978 87.3308 38.4423 85.0075 38.4423C82.6843 38.4423 81.0296 40.4981 81.0296 43.4565C81.0296 46.4149 82.701 48.5543 85.0075 48.5543C87.3141 48.5543 89.0022 46.4985 89.0022 43.4565Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M108.842 43.4565C108.842 48.1531 106.335 51.1784 102.54 51.1784C101.572 51.2213 100.611 50.9899 99.7686 50.5109C98.9259 50.0319 98.2355 49.3247 97.777 48.4707V55.9586H94.6013V35.9017H97.5931V38.4423C98.0803 37.6044 98.7848 36.9136 99.632 36.4429C100.479 35.9722 101.438 35.739 102.407 35.768C106.318 35.6845 108.842 38.7097 108.842 43.4565ZM105.649 43.4565C105.649 40.3978 104.078 38.4423 101.655 38.4423C99.2311 38.4423 97.6934 40.4981 97.6934 43.4565C97.6934 46.4149 99.2812 48.4707 101.655 48.4707C104.028 48.4707 105.649 46.4984 105.649 43.4565Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M119.856 45.1277C120.09 47.1836 122.079 48.4705 124.871 48.4705C127.662 48.4705 129.367 47.1167 129.367 45.2615C129.367 43.4062 128.23 42.6875 125.539 42.0189L122.848 41.3671C119.037 40.4478 117.266 38.6761 117.266 35.7846C117.266 32.1911 120.391 29.7341 124.82 29.7341C129.25 29.7341 132.225 32.1911 132.325 35.7846H129.133C128.949 33.7121 127.227 32.4418 124.737 32.4418C122.246 32.4418 120.525 33.6954 120.525 35.5506C120.525 37.0047 121.611 37.8739 124.286 38.5424L126.575 39.094C130.837 40.0968 132.592 41.8184 132.592 44.8436C132.592 48.738 129.5 51.1615 124.586 51.1615C119.99 51.1615 116.881 48.7881 116.681 45.0442L119.856 45.1277Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M139.311 32.2581V35.8349H142.186V38.2918H139.311V46.6488C139.311 47.9358 139.88 48.5375 141.15 48.5375C141.489 48.5583 141.83 48.5583 142.169 48.5375V50.9778C141.618 51.0816 141.059 51.132 140.498 51.1282C137.423 51.1282 136.236 49.9749 136.236 47.0333V38.2918H133.979V35.8349H136.186V32.2581H139.311Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M143.841 43.4565C143.841 38.693 146.649 35.7012 151.028 35.7012C155.407 35.7012 158.198 38.693 158.198 43.4565C158.198 48.22 155.44 51.1616 151.028 51.1616C146.615 51.1616 143.841 48.1865 143.841 43.4565ZM155.039 43.4565C155.039 40.1972 153.535 38.2584 151.028 38.2584C148.521 38.2584 147.083 40.1137 147.083 43.4565C147.083 46.7993 148.571 48.6545 151.095 48.6545C153.619 48.6545 155.039 46.6823 155.039 43.4565Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M160.772 35.8349H163.797V38.4423C164 37.6391 164.473 36.93 165.136 36.434C165.8 35.9379 166.613 35.6851 167.441 35.7179C167.796 35.7119 168.15 35.7512 168.494 35.8349V38.7432C168.065 38.5606 167.606 38.4586 167.14 38.4423C166.673 38.4081 166.205 38.4786 165.769 38.6487C165.333 38.8187 164.94 39.0841 164.62 39.4253C164.3 39.7664 164.059 40.1749 163.917 40.6208C163.775 41.0667 163.734 41.5387 163.797 42.0024V50.9778H160.772V35.8349Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M182.818 46.532C182.4 49.2731 179.726 51.1617 176.3 51.1617C171.904 51.1617 169.179 48.2034 169.179 43.4733C169.179 38.7432 171.921 35.6511 176.183 35.6511C180.445 35.6511 183.002 38.5259 183.002 43.1223V44.1753H172.305V44.3758C172.257 44.9327 172.328 45.4933 172.514 46.0206C172.699 46.5479 172.994 47.0298 173.38 47.4344C173.765 47.8389 174.233 48.1569 174.75 48.3673C175.268 48.5777 175.825 48.6756 176.383 48.6546C177.116 48.7231 177.852 48.5536 178.481 48.1712C179.11 47.7889 179.599 47.2141 179.876 46.532H182.818ZM172.322 42.0024H179.893C179.918 41.503 179.841 41.0038 179.665 40.5357C179.489 40.0676 179.218 39.6408 178.87 39.2817C178.522 38.9227 178.104 38.6391 177.642 38.4487C177.179 38.2583 176.683 38.1651 176.183 38.1749C175.677 38.1705 175.176 38.2663 174.708 38.4566C174.239 38.647 173.813 38.9282 173.455 39.2841C173.096 39.64 172.811 40.0634 172.616 40.53C172.422 40.9965 172.322 41.497 172.322 42.0024Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M63.2291 14.5912C63.8849 14.545 64.5427 14.6459 65.1545 14.8866C65.7663 15.1272 66.3165 15.5015 66.7651 15.9821C67.2136 16.4627 67.5491 17.0374 67.7471 17.6643C67.945 18.2912 68.0003 18.9544 67.9091 19.6054C67.9091 22.7811 66.2377 24.6197 63.2291 24.6197H59.6189V14.5912H63.2291ZM61.1733 23.1488H63.0453C63.5144 23.1867 63.9861 23.1181 64.4251 22.9482C64.864 22.7783 65.2589 22.5114 65.5803 22.1676C65.9017 21.8237 66.1413 21.4116 66.2811 20.9622C66.421 20.5128 66.4576 20.0376 66.3881 19.572C66.4543 19.107 66.4155 18.6331 66.2744 18.1851C66.1334 17.7372 65.8937 17.3265 65.573 16.9833C65.2523 16.6402 64.8587 16.3733 64.4213 16.2023C63.9839 16.0313 63.5137 15.9605 63.0453 15.9952H61.1733V23.1488Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M69.6641 20.7922C69.6307 20.3052 69.6978 19.8167 69.8611 19.3568C70.0245 18.8969 70.2806 18.4755 70.6137 18.1187C70.9468 17.762 71.3497 17.4776 71.7973 17.2831C72.245 17.0886 72.7278 16.9883 73.2159 16.9883C73.7039 16.9883 74.1867 17.0886 74.6344 17.2831C75.082 17.4776 75.4849 17.762 75.818 18.1187C76.1511 18.4755 76.4072 18.8969 76.5706 19.3568C76.734 19.8167 76.801 20.3052 76.7676 20.7922C76.801 21.2791 76.734 21.7676 76.5706 22.2276C76.4072 22.6875 76.1511 23.1089 75.818 23.4656C75.4849 23.8223 75.082 24.1067 74.6344 24.3012C74.1867 24.4957 73.7039 24.596 73.2159 24.596C72.7278 24.596 72.245 24.4957 71.7973 24.3012C71.3497 24.1067 70.9468 23.8223 70.6137 23.4656C70.2806 23.1089 70.0245 22.6875 69.8611 22.2276C69.6978 21.7676 69.6307 21.2791 69.6641 20.7922ZM75.2299 20.7922C75.2299 19.1208 74.5112 18.2182 73.2242 18.2182C71.9372 18.2182 71.2018 19.1709 71.2018 20.7922C71.2018 22.4134 71.8704 23.3995 73.2242 23.3995C74.578 23.3995 75.2132 22.4301 75.2132 20.7922H75.2299Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M86.1942 24.5695H84.6565L83.1021 19.0205H82.9851L81.4307 24.5695H79.9097L77.8372 17.0315H79.3414L80.6953 22.7811H80.7955L82.3499 17.0315H83.7706L85.325 22.7811H85.442L86.7792 17.0315H88.2667L86.1942 24.5695Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M90.005 17.0316H91.4424V18.235H91.5594C91.7442 17.8046 92.0603 17.4436 92.4625 17.2034C92.8647 16.9633 93.3325 16.8564 93.7991 16.8979C94.165 16.8688 94.5329 16.9226 94.8751 17.0554C95.2174 17.1881 95.5253 17.3964 95.7759 17.6647C96.0266 17.933 96.2134 18.2543 96.3226 18.6049C96.4317 18.9554 96.4604 19.326 96.4064 19.6892V24.5696H94.9189V20.0569C94.9189 18.8367 94.3841 18.235 93.2475 18.235C92.9959 18.2122 92.7424 18.2467 92.5061 18.3359C92.2698 18.4251 92.0567 18.5667 91.883 18.7501C91.7092 18.9335 91.5793 19.1539 91.503 19.3947C91.4267 19.6355 91.406 19.8905 91.4424 20.1404V24.5696H89.9548L90.005 17.0316Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M98.7632 14.1067H100.284V24.5697H98.7966L98.7632 14.1067Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M102.323 20.7922C102.29 20.3052 102.357 19.8167 102.52 19.3568C102.684 18.8969 102.94 18.4755 103.273 18.1187C103.606 17.762 104.009 17.4776 104.456 17.2831C104.904 17.0886 105.387 16.9883 105.875 16.9883C106.363 16.9883 106.846 17.0886 107.294 17.2831C107.741 17.4776 108.144 17.762 108.477 18.1187C108.81 18.4755 109.066 18.8969 109.23 19.3568C109.393 19.8167 109.46 20.3052 109.427 20.7922C109.46 21.2791 109.393 21.7676 109.23 22.2276C109.066 22.6875 108.81 23.1089 108.477 23.4656C108.144 23.8223 107.741 24.1067 107.294 24.3012C106.846 24.4957 106.363 24.596 105.875 24.596C105.387 24.596 104.904 24.4957 104.456 24.3012C104.009 24.1067 103.606 23.8223 103.273 23.4656C102.94 23.1089 102.684 22.6875 102.52 22.2276C102.357 21.7676 102.29 21.2791 102.323 20.7922ZM107.889 20.7922C107.889 19.1208 107.154 18.2182 105.867 18.2182C104.58 18.2182 103.861 19.1709 103.861 20.7922C103.861 22.4134 104.58 23.3995 105.867 23.3995C107.154 23.3995 107.889 22.4301 107.889 20.7922Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M110.981 22.4302C110.981 21.0763 111.984 20.3075 113.789 20.1905L115.828 20.0568V19.4049C115.828 18.6194 115.293 18.1681 114.274 18.1681C113.254 18.1681 112.87 18.4689 112.719 19.0038H111.265C111.432 17.7001 112.636 16.8811 114.341 16.8811C116.046 16.8811 117.299 17.8171 117.299 19.4049V24.5696H115.862V23.4999H115.745C115.51 23.8826 115.177 24.1949 114.78 24.4038C114.383 24.6127 113.936 24.7104 113.488 24.6866C113.172 24.7193 112.853 24.6853 112.55 24.5869C112.248 24.4885 111.97 24.3277 111.734 24.1151C111.497 23.9025 111.308 23.6427 111.179 23.3524C111.049 23.0622 110.982 22.748 110.981 22.4302ZM115.828 21.7282V21.093L113.99 21.21C112.953 21.21 112.469 21.6446 112.469 22.2964C112.469 22.9483 113.07 23.3661 113.873 23.3661C114.109 23.3914 114.349 23.3687 114.577 23.2994C114.805 23.2301 115.016 23.1156 115.199 22.9627C115.381 22.8098 115.531 22.6217 115.639 22.4095C115.747 22.1974 115.812 21.9657 115.828 21.7282Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M119.255 20.7923C119.255 18.4189 120.475 16.9146 122.38 16.9146C122.85 16.8945 123.316 17.0078 123.724 17.2414C124.132 17.4751 124.466 17.8196 124.687 18.2351H124.787V14.1067H126.275V24.5697H124.854V23.3997H124.737C124.5 23.8109 124.155 24.1496 123.74 24.3794C123.325 24.6091 122.854 24.7211 122.38 24.7034C120.458 24.6867 119.255 23.1824 119.255 20.7923ZM120.792 20.7923C120.792 22.4637 121.544 23.3495 122.798 23.3495C124.052 23.3495 124.82 22.3801 124.82 20.809C124.82 19.2379 124.035 18.2518 122.798 18.2518C121.561 18.2518 120.792 19.2212 120.792 20.7923Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M132.425 20.7922C132.392 20.3052 132.459 19.8167 132.622 19.3568C132.785 18.8969 133.042 18.4755 133.375 18.1187C133.708 17.762 134.111 17.4776 134.558 17.2831C135.006 17.0886 135.489 16.9883 135.977 16.9883C136.465 16.9883 136.948 17.0886 137.395 17.2831C137.843 17.4776 138.246 17.762 138.579 18.1187C138.912 18.4755 139.168 18.8969 139.332 19.3568C139.495 19.8167 139.562 20.3052 139.529 20.7922C139.562 21.2791 139.495 21.7676 139.332 22.2276C139.168 22.6875 138.912 23.1089 138.579 23.4656C138.246 23.8223 137.843 24.1067 137.395 24.3012C136.948 24.4957 136.465 24.596 135.977 24.596C135.489 24.596 135.006 24.4957 134.558 24.3012C134.111 24.1067 133.708 23.8223 133.375 23.4656C133.042 23.1089 132.785 22.6875 132.622 22.2276C132.459 21.7676 132.392 21.2791 132.425 20.7922ZM137.991 20.7922C137.991 19.1208 137.255 18.2182 135.985 18.2182C134.715 18.2182 133.963 19.1709 133.963 20.7922C133.963 22.4134 134.681 23.3995 135.985 23.3995C137.289 23.3995 137.991 22.4301 137.991 20.7922Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M141.518 17.0316H142.938V18.235H143.055C143.247 17.8063 143.567 17.4476 143.971 17.2082C144.375 16.9688 144.843 16.8604 145.312 16.8979C145.676 16.8714 146.042 16.9272 146.382 17.0611C146.723 17.1951 147.028 17.4037 147.277 17.6717C147.526 17.9396 147.711 18.26 147.819 18.6092C147.927 18.9584 147.956 19.3275 147.902 19.6891V24.5696H146.431V20.0568C146.431 18.8367 145.897 18.235 144.76 18.235C144.51 18.2149 144.258 18.2513 144.024 18.3417C143.79 18.4321 143.579 18.5741 143.407 18.7572C143.235 18.9402 143.107 19.1596 143.032 19.3991C142.956 19.6386 142.936 19.892 142.972 20.1404V24.5696H141.484L141.518 17.0316Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M156.31 15.1597V17.0818H157.981V18.3855H156.31V22.2631C156.31 23.0487 156.627 23.3997 157.363 23.3997H157.931V24.6365C157.664 24.6551 157.396 24.6551 157.129 24.6365C155.457 24.6365 154.822 24.0682 154.822 22.6141V18.3855H153.619V17.1486H154.822V15.1597H156.31Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M159.953 14.1067H161.441V18.2518H161.558C161.748 17.8243 162.065 17.4654 162.465 17.2234C162.865 16.9813 163.33 16.8677 163.797 16.8979C164.162 16.8772 164.527 16.9375 164.865 17.0745C165.204 17.2115 165.508 17.4218 165.756 17.6902C166.003 17.9587 166.189 18.2787 166.298 18.6272C166.407 18.9757 166.438 19.3441 166.388 19.7059V24.5697H164.9V20.0569C164.9 18.8535 164.349 18.2518 163.229 18.2518C162.974 18.2316 162.717 18.2671 162.477 18.3558C162.236 18.4444 162.018 18.5841 161.837 18.7652C161.656 18.9463 161.516 19.1645 161.428 19.4049C161.339 19.6452 161.304 19.9018 161.324 20.1572V24.5697H159.953V14.1067Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M175.096 22.5305C174.894 23.2344 174.444 23.8417 173.83 24.2408C173.216 24.64 172.479 24.8042 171.753 24.7033C171.254 24.7298 170.756 24.6442 170.294 24.4527C169.833 24.2612 169.42 23.9687 169.087 23.5967C168.753 23.2247 168.507 22.7826 168.367 22.3031C168.227 21.8236 168.196 21.3187 168.277 20.8256C168.212 20.3327 168.254 19.8316 168.4 19.3563C168.545 18.8809 168.791 18.4423 169.121 18.0701C169.45 17.6978 169.856 17.4005 170.31 17.1983C170.764 16.9961 171.256 16.8936 171.753 16.8978C173.843 16.8978 175.096 18.3185 175.096 20.6919V21.21H169.798V21.2936C169.778 21.5723 169.818 21.8519 169.915 22.1139C170.012 22.376 170.164 22.6144 170.36 22.8135C170.555 23.0126 170.791 23.1678 171.052 23.2689C171.312 23.3699 171.591 23.4145 171.87 23.3996C172.228 23.44 172.59 23.3744 172.911 23.211C173.232 23.0476 173.498 22.7935 173.675 22.4803L175.096 22.5305ZM169.881 20.0568H173.675C173.694 19.8037 173.66 19.5495 173.574 19.3105C173.489 19.0714 173.355 18.8529 173.18 18.6688C173.005 18.4847 172.794 18.3391 172.56 18.2413C172.326 18.1436 172.074 18.0959 171.82 18.1012C171.563 18.099 171.309 18.1481 171.072 18.2458C170.834 18.3435 170.619 18.4877 170.438 18.67C170.257 18.8523 170.115 19.0689 170.019 19.307C169.924 19.5452 169.877 19.8002 169.881 20.0568Z",
        fill: "black"
    })), $0422a6ce4ea03acc$var$kz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 328 120",
        fill: "#000000",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M277.596 75.8511C277.596 66.8825 277.55 57.9501 277.55 48.9953C277.533 42.4967 278.746 29.3438 265.868 24.3751C264.726 23.9933 263.554 23.7068 262.364 23.5185C259.041 23.1662 255.681 23.4571 252.468 24.3751C250.306 25.1545 248.275 26.2577 246.445 27.647C246.012 27.9563 245.164 28.6788 244.606 29.1748C243.415 30.2554 242.295 31.4115 241.253 32.6359C241.227 32.6359 241.524 25.6055 241.557 24.2194H193.825C193.721 24.446 187.159 48.7925 186.551 50.9016C186.037 48.9006 178.979 24.9295 178.803 24.2194H153.649V0H128.184V24.4554C128.157 24.4754 101.022 24.4554 100.86 24.4554C100.813 24.5028 88.1848 34.5752 87.7386 34.92C87.7386 22.2652 87.7422 0.21551 87.7422 0.0346C79.3844 0.03461 70.9701 0 62.6122 0C62.6122 4.62018 62.6151 9.45264 62.6151 14.0728C61.5597 10.9655 59.6518 8.21772 57.1091 6.14324C56.8438 5.92388 56.1953 5.37424 55.6793 5.02782C51.8869 2.48265 50.3963 2.01622 45.9651 0.92107C44.6721 0.670397 43.366 0.492871 42.053 0.38934C41.3394 0.32214 38.5222 0.17071 38.0034 0.15576C35.3078 0.09973 31.228 0.07788 29.2813 0.07788H0C0 25.4109 0.0156867 50.7341 0.04706 76.0475C0.76331 76.0475 34.2054 75.9063 34.8073 75.9063C36.1531 75.9063 37.1127 75.8463 38.4005 75.8463C41.2784 75.7682 44.1456 75.4628 46.9754 74.9329C50.2891 74.2289 53.4014 72.787 56.0812 70.7146C61.7191 65.9285 62.3884 62.5011 62.61 62.1361C62.61 62.6938 62.5982 75.2979 62.5982 75.744H87.5763V61.4059C87.9211 61.1221 90.3636 59.0941 90.4156 59.0941C91.4142 60.3814 103.314 74.8923 104.024 75.744H153.649V29.7486C153.675 29.7486 173.005 71.9728 173.269 72.6217C172.639 73.897 154.895 110.869 154.895 110.895H181.969C182.334 110.018 217.581 30.43 217.581 30.3781C217.607 30.3781 217.561 48.4274 217.561 75.8511H243.135V53.0716C243.135 47.9053 242.192 43.2605 248.367 43.4385C250.683 43.5053 251.981 46.0471 252.078 47.4134V75.8511H277.596ZM37.0651 55.6329C34.4276 58.4305 29.3453 57.8571 25.1132 57.8571V46.1282C32.8062 46.1282 33.8425 46.1421 35.0303 46.6487C36.0086 47.032 36.8466 47.7046 37.4325 48.5767C38.0183 49.4489 38.3241 50.479 38.309 51.5295C38.309 53.882 37.7841 54.8703 37.0651 55.6329ZM37.0651 27.5651C34.4276 30.3627 29.3453 29.7893 25.1132 29.7893V18.0604C32.8062 18.0604 33.8425 18.0743 35.0303 18.581C36.0086 18.9642 36.8466 19.6368 37.4324 20.509C38.0183 21.3811 38.3241 22.4112 38.309 23.4617C38.309 25.8142 37.7841 26.8025 37.0651 27.5651ZM62.5506 48.67C62.03 45.9052 57.663 41.5922 55.1281 39.9698C54.2698 39.4288 53.3829 38.9346 52.4713 38.4894C52.1016 38.3057 51.2602 37.9678 51.2342 37.9418C54.6687 36.6321 57.717 34.4766 60.0967 31.6752C61.2067 30.4174 62.0508 28.9481 62.5782 27.3555C62.5782 34.2858 62.5765 48.67 62.5506 48.67ZM128.15 69.8831C128.124 69.8831 107.666 43.0186 107.64 43.0186C108.357 42.4508 128.124 27.0562 128.15 27.0562V69.8831Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M143.024 91.4629C144.57 91.3545 146.12 91.6217 147.541 92.2416C147.779 92.3622 148.322 92.6104 148.553 92.7089V99.3164C148.501 99.3164 146.051 96.9099 143.225 97.8968C142.296 98.4034 141.566 99.2101 141.155 100.185C140.974 100.817 140.895 101.475 140.921 102.132C141.089 103.954 142.955 106.049 146.217 105.169C147.104 104.834 147.903 104.302 148.553 103.612V110.231C147.702 110.647 146.816 110.986 145.905 111.243C143.09 111.771 140.18 111.244 137.728 109.764C134.87 108.078 132.281 103.259 133.912 98.2381C134.38 96.9045 135.12 95.6828 136.086 94.6505C137.051 93.6182 138.22 92.7979 139.519 92.2417C140.655 91.8513 141.83 91.5901 143.024 91.4629Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M73.247 92.0859H80.5674V100.652C80.5674 102.198 80.463 103.808 81.1125 104.702C81.438 105.017 81.833 105.252 82.2658 105.388C82.6986 105.523 83.1572 105.555 83.6045 105.481C84.1946 105.419 84.7584 105.204 85.2399 104.858C86.0019 104.08 85.9408 102.418 85.9408 100.886V92.0859H93.1833C93.1833 92.7321 93.3358 104.048 92.9496 105.87C92.5922 107.861 90.7129 109.97 87.7319 110.932C86.926 111.161 86.0995 111.31 85.2643 111.376C83.959 111.481 82.6471 111.472 81.3434 111.349C79.6897 111.25 78.0764 110.798 76.6114 110.024C75.3355 109.213 74.3469 108.021 73.7857 106.617C73.343 104.767 73.1617 102.864 73.2471 100.964L73.247 92.0859ZM85.9408 100.886V92.0859H93.1833C93.1833 92.7321 93.3358 104.048 92.9496 105.87"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M72.2985 90.5616C72.0258 88.8598 71.2046 87.2938 69.9599 86.1016C68.7152 84.9095 67.1152 84.1566 65.4033 83.9575C63.1995 83.6331 51.7095 83.8066 51.5254 83.8066V110.965H59.2927V102.243C65.0758 102.263 68.921 102.076 71.1298 98.505C71.6429 97.561 72.0096 96.5445 72.2174 95.4903C72.2783 95.1658 72.4141 94.4019 72.4243 94.1585C72.4752 92.9581 72.4331 91.7555 72.2985 90.5616ZM63.8992 94.9291C62.8142 95.9026 60.9591 95.6998 59.3066 95.6998V90.1324C62.368 90.1734 62.9338 90.4189 63.382 90.65C63.7084 90.8889 63.9734 91.202 64.155 91.5634C64.3366 91.9248 64.4296 92.3242 64.4265 92.7287C64.4074 94.0269 64.2236 94.5641 63.8992 94.9291V94.9291Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M115.861 98.8162C115.486 97.2115 114.702 95.7309 113.586 94.5181C112.471 93.3052 111.061 92.4013 109.493 91.8939C108.181 91.4713 106.787 91.3671 105.428 91.5901C104.068 91.8131 102.78 92.3567 101.672 93.1761V81.0275H94.4297V110.854H101.672V109.608C102.47 110.441 103.502 111.011 104.631 111.243C106.468 111.605 108.368 111.459 110.128 110.822C111.814 110.103 113.268 108.933 114.332 107.441C115.395 105.95 116.027 104.193 116.157 102.366C116.2 101.175 116.1 99.9833 115.861 98.8162ZM105.058 105.068C104.343 105.068 103.644 104.856 103.05 104.458C102.455 104.061 101.992 103.497 101.718 102.836C101.445 102.175 101.373 101.449 101.512 100.747C101.652 100.046 101.996 99.4019 102.502 98.8963C103.007 98.3907 103.652 98.0464 104.353 97.9069C105.054 97.7674 105.781 97.839 106.442 98.1127C107.102 98.3863 107.667 98.8496 108.064 99.4441C108.461 100.039 108.673 100.738 108.673 101.453C108.673 101.927 108.58 102.397 108.398 102.836C108.216 103.275 107.95 103.673 107.614 104.009C107.279 104.345 106.88 104.611 106.442 104.793C106.003 104.974 105.533 105.068 105.058 105.068Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M129.029 89.7629C131.257 89.7629 133.064 87.9567 133.064 85.7287C133.064 83.5006 131.257 81.6945 129.029 81.6945C126.801 81.6945 124.995 83.5006 124.995 85.7287C124.995 87.9567 126.801 89.7629 129.029 89.7629Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M116.931 81.0575H124.161V110.857H116.931C116.931 110.857 116.901 81.0271 116.931 81.0575Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M125.368 92.1102H132.598V110.857H125.368C125.368 110.857 125.338 92.0798 125.368 92.1102Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M223.562 89.7629C225.79 89.7629 227.596 87.9567 227.596 85.7287C227.596 83.5006 225.79 81.6945 223.562 81.6945C221.334 81.6945 219.527 83.5006 219.527 85.7287C219.527 87.9567 221.334 89.7629 223.562 89.7629Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M219.901 92.1102H227.131V110.857H219.901C219.901 110.857 219.871 92.0798 219.901 92.1102Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M249.872 98.8702C249.497 97.2655 248.714 95.785 247.598 94.5721C246.483 93.3593 245.072 92.4554 243.504 91.9479C242.193 91.5253 240.799 91.4212 239.439 91.6442C238.079 91.8672 236.792 92.4108 235.684 93.2302V81.0815H228.441V110.908H235.684V109.662C236.482 110.495 237.514 111.065 238.643 111.297C240.48 111.659 242.38 111.513 244.14 110.876C245.825 110.157 247.28 108.987 248.343 107.496C249.407 106.004 250.039 104.247 250.169 102.42C250.211 101.229 250.112 100.037 249.872 98.8702ZM239.07 105.122C238.355 105.122 237.656 104.91 237.061 104.513C236.467 104.115 236.004 103.551 235.73 102.89C235.456 102.23 235.385 101.503 235.524 100.801C235.664 100.1 236.008 99.456 236.514 98.9504C237.019 98.4448 237.663 98.1005 238.365 97.961C239.066 97.8215 239.793 97.8931 240.453 98.1667C241.114 98.4404 241.678 98.9037 242.076 99.4982C242.473 100.093 242.685 100.792 242.685 101.507C242.685 101.981 242.591 102.451 242.41 102.89C242.228 103.329 241.962 103.727 241.626 104.063C241.29 104.399 240.892 104.665 240.453 104.847C240.015 105.028 239.545 105.122 239.07 105.122Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M279.092 92.093C279.092 92.4304 279.093 92.8184 279.093 93.1558C278.862 93.0195 278.518 92.7287 278.18 92.5361C277.48 92.1008 276.701 91.8079 275.888 91.6741C270.26 91.086 267.806 93.7123 266.356 95.6085C265.941 96.2733 265.614 96.989 265.383 97.7379H265.289V92.093C259.928 91.7726 258.316 94.2903 258.265 94.2903V92.093H250.96V110.854C251.427 110.854 257.617 110.849 258.227 110.849C258.386 105.14 257.839 101.327 259.015 99.6341C259.641 98.9044 260.518 98.4344 261.472 98.3159C262.103 98.2505 262.74 98.271 263.365 98.3768C263.89 98.5246 264.403 98.7125 264.9 98.9389C264.738 100.1 264.66 101.271 264.666 102.443C265.204 106.969 267.36 109.369 270.74 110.854C273.292 111.914 277.759 111.544 278.981 109.703H279.143C279.143 110.093 279.151 110.707 279.151 110.854H286.393V92.093H279.092ZM275.736 105.122C275.021 105.122 274.322 104.91 273.727 104.513C273.133 104.115 272.67 103.551 272.396 102.89C272.122 102.23 272.051 101.503 272.19 100.801C272.33 100.1 272.674 99.456 273.18 98.9504C273.685 98.4448 274.329 98.1005 275.031 97.961C275.732 97.8215 276.459 97.8931 277.119 98.1667C277.78 98.4403 278.345 98.9037 278.742 99.4982C279.139 100.093 279.351 100.792 279.351 101.507C279.351 101.981 279.258 102.451 279.076 102.89C278.894 103.329 278.628 103.727 278.292 104.063C277.957 104.399 277.558 104.665 277.119 104.847C276.681 105.028 276.211 105.122 275.736 105.122Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M202.876 83.7277V110.849H218.857V104.13L210.691 104.157V83.7277C210.691 83.7277 202.849 83.7007 202.876 83.7277Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M302.06 99.1271C301.552 98.9618 300.67 98.5034 300.113 98.3903C299.54 98.2924 298.956 98.272 298.377 98.3295C297.875 98.3619 297.385 98.4954 296.936 98.722C296.486 98.9485 296.088 99.2633 295.763 99.6477C294.587 101.341 295.175 105.143 295.016 110.852H287.708V92.093H295.013V94.3038C295.064 94.3038 296.706 92.093 302.037 92.093C302.037 92.452 302.073 97.3086 302.073 97.7345L302.06 99.1271ZM287.708 110.852V92.093H294.95"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M301.248 92.093L310.442 107.956L304.168 119.691H312.335L327.044 92.093H318.838L314.457 100.736L309.941 92.093C309.941 92.093 301.262 92.0795 301.248 92.093Z"
    })), $0422a6ce4ea03acc$var$Tz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 328 120",
        fill: "#ffffff",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M277.596 75.8511C277.596 66.8825 277.55 57.9501 277.55 48.9953C277.533 42.4967 278.746 29.3438 265.868 24.3751C264.726 23.9933 263.554 23.7068 262.364 23.5185C259.041 23.1662 255.681 23.4571 252.468 24.3751C250.306 25.1545 248.275 26.2577 246.445 27.647C246.012 27.9563 245.164 28.6788 244.606 29.1748C243.415 30.2554 242.295 31.4115 241.253 32.6359C241.227 32.6359 241.524 25.6055 241.557 24.2194H193.825C193.721 24.446 187.159 48.7925 186.551 50.9016C186.037 48.9006 178.979 24.9295 178.803 24.2194H153.649V0H128.184V24.4554C128.157 24.4754 101.022 24.4554 100.86 24.4554C100.813 24.5028 88.1848 34.5752 87.7386 34.92C87.7386 22.2652 87.7422 0.21551 87.7422 0.0346C79.3844 0.03461 70.9701 0 62.6122 0C62.6122 4.62018 62.6151 9.45264 62.6151 14.0728C61.5597 10.9655 59.6518 8.21772 57.1091 6.14324C56.8438 5.92388 56.1953 5.37424 55.6793 5.02782C51.8869 2.48265 50.3963 2.01622 45.9651 0.92107C44.6721 0.670397 43.366 0.492871 42.053 0.38934C41.3394 0.32214 38.5222 0.17071 38.0034 0.15576C35.3078 0.09973 31.228 0.07788 29.2813 0.07788H0C0 25.4109 0.0156867 50.7341 0.04706 76.0475C0.76331 76.0475 34.2054 75.9063 34.8073 75.9063C36.1531 75.9063 37.1127 75.8463 38.4005 75.8463C41.2784 75.7682 44.1456 75.4628 46.9754 74.9329C50.2891 74.2289 53.4014 72.787 56.0812 70.7146C61.7191 65.9285 62.3884 62.5011 62.61 62.1361C62.61 62.6938 62.5982 75.2979 62.5982 75.744H87.5763V61.4059C87.9211 61.1221 90.3636 59.0941 90.4156 59.0941C91.4142 60.3814 103.314 74.8923 104.024 75.744H153.649V29.7486C153.675 29.7486 173.005 71.9728 173.269 72.6217C172.639 73.897 154.895 110.869 154.895 110.895H181.969C182.334 110.018 217.581 30.43 217.581 30.3781C217.607 30.3781 217.561 48.4274 217.561 75.8511H243.135V53.0716C243.135 47.9053 242.192 43.2605 248.367 43.4385C250.683 43.5053 251.981 46.0471 252.078 47.4134V75.8511H277.596ZM37.0651 55.6329C34.4276 58.4305 29.3453 57.8571 25.1132 57.8571V46.1282C32.8062 46.1282 33.8425 46.1421 35.0303 46.6487C36.0086 47.032 36.8466 47.7046 37.4325 48.5767C38.0183 49.4489 38.3241 50.479 38.309 51.5295C38.309 53.882 37.7841 54.8703 37.0651 55.6329ZM37.0651 27.5651C34.4276 30.3627 29.3453 29.7893 25.1132 29.7893V18.0604C32.8062 18.0604 33.8425 18.0743 35.0303 18.581C36.0086 18.9642 36.8466 19.6368 37.4324 20.509C38.0183 21.3811 38.3241 22.4112 38.309 23.4617C38.309 25.8142 37.7841 26.8025 37.0651 27.5651ZM62.5506 48.67C62.03 45.9052 57.663 41.5922 55.1281 39.9698C54.2698 39.4288 53.3829 38.9346 52.4713 38.4894C52.1016 38.3057 51.2602 37.9678 51.2342 37.9418C54.6687 36.6321 57.717 34.4766 60.0967 31.6752C61.2067 30.4174 62.0508 28.9481 62.5782 27.3555C62.5782 34.2858 62.5765 48.67 62.5506 48.67ZM128.15 69.8831C128.124 69.8831 107.666 43.0186 107.64 43.0186C108.357 42.4508 128.124 27.0562 128.15 27.0562V69.8831Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M143.024 91.4629C144.57 91.3545 146.12 91.6217 147.541 92.2416C147.779 92.3622 148.322 92.6104 148.553 92.7089V99.3164C148.501 99.3164 146.051 96.9099 143.225 97.8968C142.296 98.4034 141.566 99.2101 141.155 100.185C140.974 100.817 140.895 101.475 140.921 102.132C141.089 103.954 142.955 106.049 146.217 105.169C147.104 104.834 147.903 104.302 148.553 103.612V110.231C147.702 110.647 146.816 110.986 145.905 111.243C143.09 111.771 140.18 111.244 137.728 109.764C134.87 108.078 132.281 103.259 133.912 98.2381C134.38 96.9045 135.12 95.6828 136.086 94.6505C137.051 93.6182 138.22 92.7979 139.519 92.2417C140.655 91.8513 141.83 91.5901 143.024 91.4629Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M73.247 92.0859H80.5674V100.652C80.5674 102.198 80.463 103.808 81.1125 104.702C81.438 105.017 81.833 105.252 82.2658 105.388C82.6986 105.523 83.1572 105.555 83.6045 105.481C84.1946 105.419 84.7584 105.204 85.2399 104.858C86.0019 104.08 85.9408 102.418 85.9408 100.886V92.0859H93.1833C93.1833 92.7321 93.3358 104.048 92.9496 105.87C92.5922 107.861 90.7129 109.97 87.7319 110.932C86.926 111.161 86.0995 111.31 85.2643 111.376C83.959 111.481 82.6471 111.472 81.3434 111.349C79.6897 111.25 78.0764 110.798 76.6114 110.024C75.3355 109.213 74.3469 108.021 73.7857 106.617C73.343 104.767 73.1617 102.864 73.2471 100.964L73.247 92.0859ZM85.9408 100.886V92.0859H93.1833C93.1833 92.7321 93.3358 104.048 92.9496 105.87"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M72.2985 90.5616C72.0258 88.8598 71.2046 87.2938 69.9599 86.1016C68.7152 84.9095 67.1152 84.1566 65.4033 83.9575C63.1995 83.6331 51.7095 83.8066 51.5254 83.8066V110.965H59.2927V102.243C65.0758 102.263 68.921 102.076 71.1298 98.505C71.6429 97.561 72.0096 96.5445 72.2174 95.4903C72.2783 95.1658 72.4141 94.4019 72.4243 94.1585C72.4752 92.9581 72.4331 91.7555 72.2985 90.5616ZM63.8992 94.9291C62.8142 95.9026 60.9591 95.6998 59.3066 95.6998V90.1324C62.368 90.1734 62.9338 90.4189 63.382 90.65C63.7084 90.8889 63.9734 91.202 64.155 91.5634C64.3366 91.9248 64.4296 92.3242 64.4265 92.7287C64.4074 94.0269 64.2236 94.5641 63.8992 94.9291V94.9291Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M115.861 98.8162C115.486 97.2115 114.702 95.7309 113.586 94.5181C112.471 93.3052 111.061 92.4013 109.493 91.8939C108.181 91.4713 106.787 91.3671 105.428 91.5901C104.068 91.8131 102.78 92.3567 101.672 93.1761V81.0275H94.4297V110.854H101.672V109.608C102.47 110.441 103.502 111.011 104.631 111.243C106.468 111.605 108.368 111.459 110.128 110.822C111.814 110.103 113.268 108.933 114.332 107.441C115.395 105.95 116.027 104.193 116.157 102.366C116.2 101.175 116.1 99.9833 115.861 98.8162ZM105.058 105.068C104.343 105.068 103.644 104.856 103.05 104.458C102.455 104.061 101.992 103.497 101.718 102.836C101.445 102.175 101.373 101.449 101.512 100.747C101.652 100.046 101.996 99.4019 102.502 98.8963C103.007 98.3907 103.652 98.0464 104.353 97.9069C105.054 97.7674 105.781 97.839 106.442 98.1127C107.102 98.3863 107.667 98.8496 108.064 99.4441C108.461 100.039 108.673 100.738 108.673 101.453C108.673 101.927 108.58 102.397 108.398 102.836C108.216 103.275 107.95 103.673 107.614 104.009C107.279 104.345 106.88 104.611 106.442 104.793C106.003 104.974 105.533 105.068 105.058 105.068Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M129.029 89.7629C131.257 89.7629 133.064 87.9567 133.064 85.7287C133.064 83.5006 131.257 81.6945 129.029 81.6945C126.801 81.6945 124.995 83.5006 124.995 85.7287C124.995 87.9567 126.801 89.7629 129.029 89.7629Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M116.931 81.0575H124.161V110.857H116.931C116.931 110.857 116.901 81.0271 116.931 81.0575Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M125.368 92.1102H132.598V110.857H125.368C125.368 110.857 125.338 92.0798 125.368 92.1102Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M223.562 89.7629C225.79 89.7629 227.596 87.9567 227.596 85.7287C227.596 83.5006 225.79 81.6945 223.562 81.6945C221.334 81.6945 219.527 83.5006 219.527 85.7287C219.527 87.9567 221.334 89.7629 223.562 89.7629Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M219.901 92.1102H227.131V110.857H219.901C219.901 110.857 219.871 92.0798 219.901 92.1102Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M249.872 98.8702C249.497 97.2655 248.714 95.785 247.598 94.5721C246.483 93.3593 245.072 92.4554 243.504 91.9479C242.193 91.5253 240.799 91.4212 239.439 91.6442C238.079 91.8672 236.792 92.4108 235.684 93.2302V81.0815H228.441V110.908H235.684V109.662C236.482 110.495 237.514 111.065 238.643 111.297C240.48 111.659 242.38 111.513 244.14 110.876C245.825 110.157 247.28 108.987 248.343 107.496C249.407 106.004 250.039 104.247 250.169 102.42C250.211 101.229 250.112 100.037 249.872 98.8702ZM239.07 105.122C238.355 105.122 237.656 104.91 237.061 104.513C236.467 104.115 236.004 103.551 235.73 102.89C235.456 102.23 235.385 101.503 235.524 100.801C235.664 100.1 236.008 99.456 236.514 98.9504C237.019 98.4448 237.663 98.1005 238.365 97.961C239.066 97.8215 239.793 97.8931 240.453 98.1667C241.114 98.4404 241.678 98.9037 242.076 99.4982C242.473 100.093 242.685 100.792 242.685 101.507C242.685 101.981 242.591 102.451 242.41 102.89C242.228 103.329 241.962 103.727 241.626 104.063C241.29 104.399 240.892 104.665 240.453 104.847C240.015 105.028 239.545 105.122 239.07 105.122Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M279.092 92.093C279.092 92.4304 279.093 92.8184 279.093 93.1558C278.862 93.0195 278.518 92.7287 278.18 92.5361C277.48 92.1008 276.701 91.8079 275.888 91.6741C270.26 91.086 267.806 93.7123 266.356 95.6085C265.941 96.2733 265.614 96.989 265.383 97.7379H265.289V92.093C259.928 91.7726 258.316 94.2903 258.265 94.2903V92.093H250.96V110.854C251.427 110.854 257.617 110.849 258.227 110.849C258.386 105.14 257.839 101.327 259.015 99.6341C259.641 98.9044 260.518 98.4344 261.472 98.3159C262.103 98.2505 262.74 98.271 263.365 98.3768C263.89 98.5246 264.403 98.7125 264.9 98.9389C264.738 100.1 264.66 101.271 264.666 102.443C265.204 106.969 267.36 109.369 270.74 110.854C273.292 111.914 277.759 111.544 278.981 109.703H279.143C279.143 110.093 279.151 110.707 279.151 110.854H286.393V92.093H279.092ZM275.736 105.122C275.021 105.122 274.322 104.91 273.727 104.513C273.133 104.115 272.67 103.551 272.396 102.89C272.122 102.23 272.051 101.503 272.19 100.801C272.33 100.1 272.674 99.456 273.18 98.9504C273.685 98.4448 274.329 98.1005 275.031 97.961C275.732 97.8215 276.459 97.8931 277.119 98.1667C277.78 98.4403 278.345 98.9037 278.742 99.4982C279.139 100.093 279.351 100.792 279.351 101.507C279.351 101.981 279.258 102.451 279.076 102.89C278.894 103.329 278.628 103.727 278.292 104.063C277.957 104.399 277.558 104.665 277.119 104.847C276.681 105.028 276.211 105.122 275.736 105.122Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M202.876 83.7277V110.849H218.857V104.13L210.691 104.157V83.7277C210.691 83.7277 202.849 83.7007 202.876 83.7277Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M302.06 99.1271C301.552 98.9618 300.67 98.5034 300.113 98.3903C299.54 98.2924 298.956 98.272 298.377 98.3295C297.875 98.3619 297.385 98.4954 296.936 98.722C296.486 98.9485 296.088 99.2633 295.763 99.6477C294.587 101.341 295.175 105.143 295.016 110.852H287.708V92.093H295.013V94.3038C295.064 94.3038 296.706 92.093 302.037 92.093C302.037 92.452 302.073 97.3086 302.073 97.7345L302.06 99.1271ZM287.708 110.852V92.093H294.95"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M301.248 92.093L310.442 107.956L304.168 119.691H312.335L327.044 92.093H318.838L314.457 100.736L309.941 92.093C309.941 92.093 301.262 92.0795 301.248 92.093Z"
    })), $0422a6ce4ea03acc$var$_z = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 118 119",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("rect", {
        y: 0.9505,
        width: 118,
        height: 118,
        rx: 20,
        fill: "#436CF2"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.1768 60.2227C17.1768 33.6874 36.6035 12.153 64.4518 12.153C81.5298 12.153 91.7632 17.9704 100.185 26.4072L87.5021 41.3418C80.5233 34.8781 73.3766 30.8978 64.3176 30.8978C49.0513 30.8978 38.0127 43.8253 38.0127 59.6784C38.0127 75.8036 48.7494 89.0032 64.3176 89.0032C74.6852 89.0032 81.0265 84.7848 88.1396 78.185L100.822 91.2485C91.4948 101.42 81.1272 107.748 63.6465 107.748C36.9725 107.748 17.1768 86.7579 17.1768 60.2227Z",
        fill: "white"
    })), $0422a6ce4ea03acc$var$Dz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 312 88",
        fill: "#436CF2",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 44.2746C0 20.3424 17.6673 0.92041 42.9935 0.92041C58.5248 0.92041 67.8314 6.1671 75.4903 13.7763L63.9562 27.2459C57.6094 21.4162 51.1101 17.8264 42.8714 17.8264C28.9878 17.8264 18.9489 29.4857 18.9489 43.7837C18.9489 58.3272 28.7132 70.2319 42.8714 70.2319C52.3001 70.2319 58.0671 66.4273 64.536 60.4749L76.0701 72.257C67.5873 81.431 58.1587 87.1379 42.2612 87.1379C18.0029 87.1379 0 68.2069 0 44.2746Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M77.7183 0H95.6297V86.9539H77.7183V0Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M128.828 35.2234C121.413 35.2234 116.592 40.5928 115.158 48.8157H142.132C141.094 40.6849 136.365 35.2234 128.828 35.2234ZM159.342 60.1068H115.402C117.172 68.3297 122.817 72.6252 130.842 72.6252C136.853 72.6252 141.217 70.7229 146.16 66.0592L156.412 75.2332C150.523 82.6277 142.04 87.138 130.628 87.138C111.68 87.138 97.6433 73.6684 97.6433 54.1544V53.909C97.6433 35.6836 110.489 20.6799 128.859 20.6799C149.943 20.6799 159.586 37.2484 159.586 55.351V55.5965C159.586 57.3761 159.464 58.45 159.342 60.1068Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M193.638 86.8005H177.374L152.536 22.4902H171.485L185.612 65.2615L199.862 22.4902H218.476L193.638 86.8005Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M241.665 35.2234C234.25 35.2234 229.429 40.5928 227.995 48.8157H254.969C253.931 40.6849 249.202 35.2234 241.665 35.2234ZM272.178 60.1068H228.239C230.009 68.3297 235.654 72.6252 243.679 72.6252C249.69 72.6252 254.053 70.7229 258.997 66.0592L269.249 75.2332C263.36 82.6277 254.877 87.138 243.465 87.138C224.516 87.138 210.48 73.6684 210.48 54.1544V53.909C210.48 35.6836 223.326 20.6799 241.696 20.6799C262.78 20.6799 272.423 37.2484 272.423 55.351V55.5965C272.423 57.3761 272.301 58.45 272.178 60.1068Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M311.054 40.8691C299.154 40.8691 291.861 48.1408 291.861 63.39V86.9848H273.95V23.104H291.861V35.9599C295.523 27.1541 301.412 21.4165 312 21.9074V40.8384H311.054"
    })), $0422a6ce4ea03acc$var$Rz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 312 88",
        fill: "#ffffff",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 44.2746C0 20.3424 17.6673 0.92041 42.9935 0.92041C58.5248 0.92041 67.8314 6.1671 75.4903 13.7763L63.9562 27.2459C57.6094 21.4162 51.1101 17.8264 42.8714 17.8264C28.9878 17.8264 18.9489 29.4857 18.9489 43.7837C18.9489 58.3272 28.7132 70.2319 42.8714 70.2319C52.3001 70.2319 58.0671 66.4273 64.536 60.4749L76.0701 72.257C67.5873 81.431 58.1587 87.1379 42.2612 87.1379C18.0029 87.1379 0 68.2069 0 44.2746Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M77.7183 0H95.6297V86.9539H77.7183V0Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M128.828 35.2234C121.413 35.2234 116.592 40.5928 115.158 48.8157H142.132C141.094 40.6849 136.365 35.2234 128.828 35.2234ZM159.342 60.1068H115.402C117.172 68.3297 122.817 72.6252 130.842 72.6252C136.853 72.6252 141.217 70.7229 146.16 66.0592L156.412 75.2332C150.523 82.6277 142.04 87.138 130.628 87.138C111.68 87.138 97.6433 73.6684 97.6433 54.1544V53.909C97.6433 35.6836 110.489 20.6799 128.859 20.6799C149.943 20.6799 159.586 37.2484 159.586 55.351V55.5965C159.586 57.3761 159.464 58.45 159.342 60.1068Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M193.638 86.8005H177.374L152.536 22.4902H171.485L185.612 65.2615L199.862 22.4902H218.476L193.638 86.8005Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M241.665 35.2234C234.25 35.2234 229.429 40.5928 227.995 48.8157H254.969C253.931 40.6849 249.202 35.2234 241.665 35.2234ZM272.178 60.1068H228.239C230.009 68.3297 235.654 72.6252 243.679 72.6252C249.69 72.6252 254.053 70.7229 258.997 66.0592L269.249 75.2332C263.36 82.6277 254.877 87.138 243.465 87.138C224.516 87.138 210.48 73.6684 210.48 54.1544V53.909C210.48 35.6836 223.326 20.6799 241.696 20.6799C262.78 20.6799 272.423 37.2484 272.423 55.351V55.5965C272.423 57.3761 272.301 58.45 272.178 60.1068Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M311.054 40.8691C299.154 40.8691 291.861 48.1408 291.861 63.39V86.9848H273.95V23.104H291.861V35.9599C295.523 27.1541 301.412 21.4165 312 21.9074V40.8384H311.054"
    })), $0422a6ce4ea03acc$var$Zz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 360 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.42997 19.7754C2.4791 19.4977 2.50057 19.4205 2.66774 19.2021C2.93271 18.8059 6.1469 15.1988 11.1287 14.3247C11.7842 14.2307 12.2567 14.2761 12.3641 14.539C12.5524 14.9998 12.171 15.2652 11.7118 15.531C3.72189 20.307 4.28828 27.4069 4.2118 30.3113C4.23575 31.4994 3.37797 31.7156 3.16368 31.1559C2.22618 28.5977 1.43762 24.5878 2.42997 19.7754",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.83744 9.31569C8.00106 9.14201 8.10782 9.06228 8.35069 8.99382C11.4193 8.23141 14.4976 8.71677 16.7143 9.7054C17.212 9.92574 17.4361 10.238 17.1094 10.4477C16.6938 10.6892 15.4343 11.5085 14.7381 12.1573C14.5357 12.3318 14.175 12.3409 13.9621 12.3126C11.3634 11.9701 10.0137 11.7676 6.10706 13.2487C5.5076 13.5008 4.96856 13.1579 5.24434 12.6866C5.76454 11.7548 6.97411 10.196 7.83744 9.31569",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8868 6.24958C12.2149 6.17309 12.2055 5.68156 12.4895 5.49011C13.2195 4.97864 14.404 4.36102 15.5955 3.88849C15.9522 3.7471 16.1364 3.71033 16.4632 3.74309C17.3412 3.83101 18.7952 4.42221 20.4635 5.6128C22.4642 7.04057 24.244 9.75305 23.0538 9.53347C22.3009 9.40305 22.6288 9.4389 21.7463 9.34202C20.8446 9.26213 20.2529 9.35469 19.8373 9.31235C19.6562 9.29752 19.5136 9.17699 19.3861 9.07253C17.6975 7.55807 15.7468 6.59694 12.8868 6.24958",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.3579 16.9679C28.2845 17.3501 28.0513 18.0883 27.6785 18.1363C27.3028 18.1843 27.0322 17.7818 26.7628 17.631C26.3083 17.3775 25.6656 17.2117 25.0716 17.0153C24.5592 16.8456 23.8567 16.6355 23.6506 16.1469C23.3419 15.4195 24.0632 15.0753 24.5824 14.9156C25.0716 14.7654 25.4296 14.7089 26.0674 14.6792C27.0055 14.6341 27.9012 14.7683 28.2162 15.3577C28.4061 15.7127 28.464 16.4169 28.3579 16.9679ZM36.9696 17.4368C35.3356 16.6377 33.2135 16.2373 31.6694 15.3802C30.4468 14.7027 29.5094 13.5837 28.1938 12.9807C26.8516 12.324 24.8315 11.6639 24.0592 11.4736C21.3294 10.8025 19.0364 11.6764 18.2411 12.3054C16.7561 13.4781 15.596 15.3843 16.0486 18.1267C16.2404 19.2859 16.5975 20.2611 17.1649 21.063C19.4675 24.3131 23.7771 25.3689 27.1912 27.4193C27.3116 27.5012 27.4372 27.4794 27.514 27.3749C28.0875 26.5321 28.5536 25.8537 29.5195 25.4522C30.5001 25.0431 32.0433 25.1821 33.3738 25.2468C34.7484 25.3132 36.2321 25.1843 36.7306 24.474C37.3262 23.6262 37.2915 21.918 36.3824 21.3962C35.8946 21.1152 35.1672 21.1023 34.6367 20.8579C34.2496 20.6791 33.951 20.3445 33.7376 19.8793C33.5585 19.4901 33.3921 18.851 33.6242 18.4341C33.8378 18.05 34.3764 18.1587 34.8091 18.2592C35.6665 18.456 37.0993 18.6645 37.9242 18.3029C38.1672 18.1788 37.2984 17.5974 36.9696 17.4368V17.4368Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M45.1527 29.9327C44.972 30.496 44.7575 31.2027 44.2977 30.8748C43.4435 30.2396 41.5449 29.0185 39.7063 28.3407C39.6076 28.3187 39.6188 28.1817 39.6536 28.1045C39.7839 27.8159 39.8423 27.549 39.8987 27.2075C39.9511 26.888 40.1817 26.6745 40.3404 26.4183C40.8116 25.666 41.0669 24.3548 41.1697 23.5367C41.2478 22.7851 41.2013 21.9476 41.0384 21.2495C40.9688 20.9514 40.7537 20.567 40.7594 20.2372C40.765 19.9146 40.9168 19.5766 40.9479 19.1958C41.0388 18.0939 39.6473 17.175 38.8878 16.821C37.1648 16.017 35.3336 15.2979 33.4727 14.3167C32.4222 13.763 31.5792 12.5483 30.7364 11.8964C29.885 11.2398 27.1486 10.1552 26.055 9.86651C25.808 9.78879 25.7205 9.68631 25.6787 9.48985C25.2279 7.33966 23.9581 4.97119 21.5863 3.13961C20.8182 2.54311 21.6795 2.20377 22.7372 2.15221C39.4112 1.58096 49.0064 16.9159 45.1527 29.9327",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.3808 22.5618C38.3689 22.477 38.3323 22.1898 38.3326 22.1305C38.3335 21.979 38.6452 21.7728 38.7905 21.6574C39.011 21.482 39.2661 21.2894 39.4332 21.2052C39.4937 21.1673 39.5338 21.2551 39.542 21.2724C40.1567 22.2048 39.9262 24.5095 39.482 25.6054C39.4306 25.7169 39.3366 25.7603 39.2983 25.6787C39.0717 25.1842 38.7354 24.7391 38.3492 24.4948C38.2779 24.4396 38.2725 24.3244 38.2779 24.303C38.4022 23.7822 38.4668 23.2046 38.3808 22.5618",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.7796 28.2347C30.9121 27.8527 31.0662 27.6276 31.3633 27.4418C31.9227 27.0911 32.8523 27.076 33.7496 27.0147C34.6189 26.956 35.5478 26.9052 36.1663 26.6196C36.5406 26.4476 36.915 25.9576 37.4935 26.2072C37.7673 26.3251 37.9164 26.5759 37.9982 26.8253C38.0899 27.1032 38.1566 27.3839 38.1281 27.7564C38.0449 28.8314 37.1712 29.3564 37.014 30.3612C36.9994 30.5165 36.973 30.7413 36.8837 30.8306C36.2167 31.5092 34.8975 31.3664 33.7048 31.2465C33.2779 31.204 32.8559 31.1924 32.5671 31.055C32.3588 30.9576 32.1718 30.759 31.9986 30.5984C31.6171 30.245 31.4013 29.9849 31.0188 29.5562C30.889 29.411 30.595 29.1481 30.5756 28.9885C30.5592 28.8354 30.7231 28.3959 30.7796 28.2347",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.89366 40.9045C9.45588 40.5461 9.26751 40.2438 9.01578 39.8193C6.97375 36.5572 5.82911 25.005 8.46073 21.0867C9.29803 19.7138 10.1852 20.3467 9.8904 21.4079C9.38648 23.7901 9.69537 25.1251 10.8544 27.71C12.6762 31.5514 18.2988 36.8848 19.7873 38.8192C22.339 42.1365 23.1882 44.5534 23.1766 45.2046C23.1628 45.704 23.0669 46.0224 22.1911 45.9486C17.571 45.5826 13.1046 43.6684 9.89366 40.9045",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5342 25.3258C11.125 21.895 12.0452 18.8057 12.6676 17.6339C12.9816 17.0427 13.2884 16.6564 13.6888 16.7676C14.1247 16.8891 14.2253 17.3348 14.2855 18.1612C14.7289 25.0191 18.8797 27.3281 24.0932 29.7494C28.2062 31.8506 32.8859 34.253 36.808 40.0724C37.4016 40.9124 37.4873 41.4222 36.8171 41.9035C34.4259 43.5349 32.2596 44.672 29.0903 45.4106C28.6132 45.5223 28.1212 45.4385 27.6986 44.3491C23.2957 33.012 15.9036 33.5231 12.5342 25.3258",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("mask", {
        id: "mask0_75161_120622",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: 0,
        y: 0,
        width: 49,
        height: 49
    }, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0H48.0491V48.0562H0V0Z",
        fill: "white"
    })), /* @__PURE__ */ $acw62.createElement("g", {
        mask: "url(#mask0_75161_120622)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39.8049 39.2638C39.1346 39.9334 38.7545 39.4084 38.5354 38.9785C37.5967 36.9836 36.6798 35.3139 35.2011 33.6968C34.9449 33.4373 35.1423 33.073 35.5189 33.11C36.0002 33.1486 36.3156 33.1223 36.8451 32.8948C37.2929 32.7026 37.8061 32.075 38.062 31.1735C38.2485 30.5158 38.2572 30.3223 38.6605 30.2813C38.7607 30.2719 38.9441 30.2971 39.0553 30.3291C39.5461 30.4688 40.0731 30.8694 40.4582 31.1647C41.4459 31.9188 42.9194 33.583 43.1773 34.1214C43.3411 34.4642 43.1843 34.6969 43.092 34.8925C42.5752 35.9487 40.9452 38.1371 39.8049 39.2638",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39.8051 39.2648C39.1348 39.9343 38.7546 39.4094 38.5356 38.9794C37.5968 36.9845 36.6799 35.3149 35.2013 33.6977C34.945 33.4383 35.1424 33.0738 35.519 33.111C36.0003 33.1495 36.3157 33.1232 36.8452 32.8958C37.293 32.7035 37.8062 32.0759 38.0622 31.1744C38.2487 30.5168 38.2573 30.3233 38.6606 30.2822C38.7608 30.2728 38.9442 30.298 39.0554 30.3301C39.5462 30.4697 40.0732 30.8704 40.4583 31.1656C41.446 31.9195 42.9195 33.5838 43.1775 34.1224C43.3412 34.4651 43.1844 34.6978 43.0921 34.8935C42.5753 35.9496 40.9454 38.1379 39.8051 39.2648ZM12.5386 25.3222C11.1294 21.8915 12.0496 18.8023 12.672 17.6305C12.9858 17.0393 13.2926 16.653 13.6932 16.7642C14.1289 16.8857 14.2296 17.3314 14.2897 18.1578C14.7332 25.0157 18.8839 27.3247 24.0974 29.7458C28.2106 31.8472 32.8903 34.2494 36.8123 40.0688C37.406 40.909 37.4916 41.4188 36.8213 41.9C34.4301 43.5314 32.264 44.6686 29.0947 45.4071C28.6176 45.5187 28.1254 45.4349 27.7028 44.3455C23.3 33.0086 15.9078 33.5195 12.5386 25.3222ZM2.44191 19.7299C2.49133 19.4517 2.51286 19.3743 2.68047 19.1555C2.94615 18.7587 6.16875 15.1447 11.164 14.269C11.8211 14.1751 12.2948 14.2204 12.4025 14.4838C12.5913 14.9454 12.2089 15.2115 11.7486 15.4777C3.73728 20.2626 4.30518 27.3759 4.2285 30.2858C4.25266 31.476 3.39244 31.6927 3.17774 31.132C2.23759 28.5689 1.44692 24.5514 2.44191 19.7299ZM7.85724 9.2465C8.02129 9.07249 8.12834 8.99261 8.37186 8.92403C11.4487 8.16034 14.5351 8.6466 16.7578 9.63709C17.2568 9.85786 17.4815 10.1707 17.1539 10.3807C16.7372 10.6226 15.4744 11.4434 14.7763 12.0935C14.5734 12.2683 14.2117 12.2774 13.9982 12.2491C11.3926 11.9059 10.0393 11.7031 6.12224 13.1869C5.52119 13.4396 4.98071 13.0959 5.25722 12.6239C5.77881 11.6902 6.9916 10.1286 7.85724 9.2465ZM30.7797 28.2289C30.9122 27.8469 31.0663 27.6218 31.3634 27.4358C31.9228 27.0853 32.8524 27.0702 33.7497 27.0089C34.619 26.9502 35.5479 26.8994 36.1664 26.6138C36.5407 26.4418 36.9151 25.9518 37.4936 26.2014C37.7674 26.3193 37.9165 26.5701 37.9983 26.8195C38.09 27.0974 38.1567 27.3779 38.1282 27.7506C38.045 28.8256 37.1714 29.3505 37.0141 30.3554C36.9996 30.5107 36.9731 30.7355 36.8838 30.8248C36.2168 31.5034 34.8976 31.3606 33.7049 31.2407C33.278 31.1982 32.856 31.1866 32.5672 31.0492C32.3589 30.9516 32.1719 30.7531 31.9987 30.5926C31.6172 30.2392 31.4014 29.9791 31.0189 29.5504C30.8891 29.4052 30.5951 29.1423 30.5757 28.9827C30.5593 28.8296 30.7232 28.3901 30.7797 28.2289ZM12.9204 6.17451C12.2467 6.09773 12.2372 5.60542 12.5219 5.41361C13.2539 4.90103 14.4416 4.28224 15.6363 3.80883C15.994 3.66733 16.1786 3.63033 16.5063 3.6633C17.3866 3.75139 18.8445 4.3437 20.5172 5.53638C22.5233 6.96684 24.3079 9.68442 23.1144 9.46443C22.3596 9.33377 22.6883 9.36984 21.8034 9.27277C20.8994 9.19258 20.3061 9.28531 19.8893 9.24289C19.7078 9.22818 19.5648 9.10728 19.437 9.00278C17.7438 7.48546 15.7879 6.52253 12.9204 6.17451ZM18.2412 12.2995C19.0365 11.6705 21.3295 10.7966 24.0593 11.4677C24.8315 11.658 26.8517 12.3181 28.1939 12.975C29.5095 13.5778 30.4469 14.697 31.6694 15.3744C33.2136 16.2315 35.3357 16.6318 36.9697 17.4309C37.2984 17.5915 38.1673 18.1728 37.9243 18.297C37.0994 18.6586 35.6666 18.4501 34.8092 18.2533C34.3765 18.1528 33.8379 18.044 33.6243 18.4282C33.3922 18.8452 33.5586 19.4842 33.7377 19.8734C33.9511 20.3386 34.2496 20.6732 34.6368 20.852C35.1673 21.0964 35.8946 21.1093 36.3824 21.3903C37.2916 21.9121 37.3263 23.6203 36.7307 24.4681C36.2322 25.1782 34.7484 25.3072 33.3739 25.2409C32.0434 25.1762 30.5002 25.0372 29.5196 25.4463C28.5537 25.8478 28.0876 26.5262 27.5141 27.369C27.4373 27.4735 27.3117 27.4953 27.1913 27.4134C23.7772 25.3631 19.4676 24.3071 17.165 21.0571C16.5976 20.2552 16.2405 19.28 16.0487 18.1208C15.5961 15.3784 16.7562 13.4722 18.2412 12.2995ZM38.3807 22.5563C38.3688 22.4714 38.3323 22.1843 38.3326 22.125C38.3335 21.9734 38.6452 21.7672 38.7905 21.6519C39.0109 21.4765 39.2661 21.2839 39.4332 21.1997C39.4936 21.1617 39.5337 21.2495 39.542 21.2668C40.1566 22.1993 39.9261 24.504 39.482 25.5999C39.4306 25.7114 39.3365 25.7547 39.2983 25.6731C39.0716 25.1786 38.7353 24.7336 38.3491 24.4893C38.2779 24.434 38.2725 24.3188 38.2779 24.2975C38.4021 23.7767 38.4667 23.1991 38.3807 22.5563ZM45.1528 29.9269C44.9721 30.4903 44.7576 31.1968 44.2978 30.8691C43.4436 30.2339 41.5451 29.0127 39.7064 28.335C39.6077 28.3128 39.6189 28.176 39.6538 28.0987C39.784 27.81 39.8424 27.5433 39.8988 27.2017C39.9512 26.8822 40.1818 26.6687 40.3405 26.4125C40.8117 25.6603 41.067 24.349 41.1699 23.531C41.2479 22.7794 41.2015 21.9418 41.0385 21.2438C40.9689 20.9456 40.7538 20.5612 40.7595 20.2315C40.7651 19.9088 40.9169 19.5709 40.948 19.1901C41.039 18.0881 39.6474 17.1694 38.8879 16.8152C37.165 16.0113 35.3338 15.2923 33.4728 14.3111C32.4224 13.7574 31.5793 12.5426 30.7365 11.8907C29.8851 11.2343 27.1487 10.1495 26.0551 9.86091C25.8081 9.7832 25.7206 9.68056 25.6788 9.4841C25.228 7.33407 23.9582 4.96544 21.5864 3.13386C20.8183 2.53736 21.6796 2.19802 22.7374 2.14646C39.4113 1.57536 49.0065 16.9103 45.1528 29.9269ZM9.89364 40.8987C9.45586 40.5404 9.26749 40.238 9.01576 39.8135C6.97373 36.5515 5.82909 24.9992 8.46071 21.0809C9.29801 19.7079 10.1852 20.3409 9.89038 21.4022C9.38646 23.7844 9.69535 25.1194 10.8544 27.7043C12.6761 31.5456 18.2988 36.879 19.7873 38.8134C22.339 42.1307 23.1882 44.5477 23.1766 45.1988C23.1628 45.6982 23.0669 46.0167 22.1911 45.9427C17.571 45.5769 13.1046 43.6626 9.89364 40.8987ZM23.9207 0C10.74 0 0 10.7105 0 24.0298C0 37.3486 10.8053 48.0655 23.9356 48.0655C37.2633 48.0655 48.0491 37.3542 48.0491 24.0352C48.0491 10.7155 37.2478 0 23.9207 0Z",
        fill: "black"
    })), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.0742 17.015C25.6681 17.2115 26.3107 17.3773 26.7652 17.6307C27.0346 17.7815 27.3052 18.184 27.681 18.136C28.0537 18.088 28.2867 17.3499 28.3603 16.9677C28.4664 16.4167 28.4085 15.7124 28.2186 15.3575C27.9038 14.7681 27.0079 14.6339 26.0698 14.6789C25.432 14.7086 25.0742 14.7651 24.5848 14.9153C24.0656 15.0751 23.3445 15.4192 23.653 16.1467C23.8591 16.6353 24.5616 16.8454 25.0742 17.015",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M60.9845 15.8367H63.3999V6.28539H66.8632V4.29354H57.5212V6.28539H60.9845V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M69.3263 15.8367H71.7418V10.973H76.9406V15.8367H79.3561V4.29354H76.9406V8.98119H71.7418V4.29354H69.3263V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.4831 15.8367H90.1294V13.8448H84.8985V10.925H89.8334V9.06919H84.8985V6.28539H90.1294V4.29354H82.4831V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M97.5511 15.8367H99.8626V8.45323H101.07L99.3747 7.59729L105.333 15.8367H107.333V4.29354H105.021V11.645H103.822L105.509 12.5009L99.5667 4.29354H97.5511V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M110.468 15.8367H118.114V13.8448H112.883V10.925H117.818V9.06919H112.883V6.28539H118.114V4.29354H110.468V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M123.345 15.8367H125.624L127.784 8.06126H127.912L130.095 15.8367H132.359L135.422 4.29354H132.927L131.143 12.5409H131.015L128.872 4.29354H126.832L124.728 12.5409H124.6L122.801 4.29354H120.289L123.345 15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M145.595 15.8367H148.011V11.525L152.034 4.29354H149.418L146.883 9.14918H146.739L144.195 4.29354H141.58L145.595 11.525V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M158.704 16.1327C159.84 16.1327 160.823 15.8874 161.655 15.3967C162.487 14.9008 163.127 14.1995 163.575 13.2929C164.028 12.3863 164.255 11.3117 164.255 10.0691V10.0531C164.255 8.81054 164.028 7.73595 163.575 6.82935C163.122 5.92275 162.479 5.22414 161.647 4.7335C160.821 4.24287 159.84 3.99756 158.704 3.99756C157.574 3.99756 156.592 4.24287 155.761 4.7335C154.929 5.22414 154.284 5.92275 153.825 6.82935C153.372 7.73062 153.145 8.80521 153.145 10.0531V10.0691C153.145 11.3117 153.369 12.3863 153.817 13.2929C154.27 14.1995 154.913 14.9008 155.745 15.3967C156.576 15.8874 157.563 16.1327 158.704 16.1327ZM158.704 14.0848C158.069 14.0848 157.52 13.9195 157.056 13.5889C156.598 13.2582 156.241 12.7916 155.985 12.189C155.734 11.5863 155.609 10.8797 155.609 10.0691V10.0531C155.609 9.23717 155.737 8.53056 155.993 7.93327C156.249 7.33065 156.608 6.86668 157.072 6.54137C157.536 6.21073 158.08 6.04541 158.704 6.04541C159.328 6.04541 159.872 6.21073 160.336 6.54137C160.799 6.86668 161.157 7.33065 161.407 7.93327C161.663 8.53056 161.791 9.23717 161.791 10.0531V10.0691C161.791 10.8797 161.663 11.5863 161.407 12.189C161.157 12.7916 160.799 13.2582 160.336 13.5889C159.872 13.9195 159.328 14.0848 158.704 14.0848Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M166.878 15.8367H169.293V11.613H171.157C171.173 11.613 171.192 11.613 171.213 11.613C171.234 11.613 171.253 11.613 171.269 11.613L173.42 15.8367H176.156L173.724 11.253C174.386 10.9917 174.897 10.5677 175.26 9.98112C175.628 9.38916 175.812 8.72254 175.812 7.98127V7.96527C175.812 7.20799 175.649 6.5547 175.324 6.00541C175.004 5.45612 174.535 5.03482 173.916 4.7415C173.303 4.44286 172.559 4.29354 171.685 4.29354H166.878V15.8367ZM169.293 9.85313V6.1814H171.389C171.997 6.1814 172.474 6.34672 172.821 6.67736C173.167 7.008 173.34 7.4533 173.34 8.01326V8.02926C173.34 8.59989 173.17 9.04785 172.829 9.37316C172.493 9.69314 172.023 9.85313 171.421 9.85313H169.293Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M180.842 12.4929L182.29 10.7491L183.73 9.53315L188.089 4.29354H185.401L181.138 9.47716H180.754L180.842 12.4929ZM178.579 15.8367H180.994V4.29354H178.579V15.8367ZM185.489 15.8367H188.385L183.746 9.14918L182.01 10.7331L185.489 15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M196.294 12.197H199.846C200.656 12.197 201.365 12.0343 201.973 11.709C202.581 11.3837 203.053 10.925 203.389 10.3331C203.73 9.74114 203.901 9.04785 203.901 8.25325V8.23725C203.901 7.44797 203.73 6.75736 203.389 6.1654C203.053 5.57344 202.581 5.11481 201.973 4.7895C201.365 4.45886 200.656 4.29354 199.846 4.29354H196.294V6.2054H199.254C199.947 6.2054 200.485 6.38138 200.869 6.73336C201.259 7.08533 201.453 7.58929 201.453 8.24525V8.26125C201.453 8.9172 201.259 9.42383 200.869 9.78113C200.485 10.1331 199.947 10.3091 199.254 10.3091H196.294V12.197ZM195.087 15.8367H197.502V4.29354H195.087V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M211.283 16.1327C212.274 16.1327 213.13 15.954 213.85 15.5967C214.575 15.2394 215.133 14.7408 215.522 14.1008C215.916 13.4555 216.114 12.7063 216.114 11.853V4.29354H213.698V11.637C213.698 12.133 213.605 12.5649 213.418 12.9329C213.232 13.2955 212.957 13.5782 212.594 13.7808C212.237 13.9835 211.8 14.0848 211.283 14.0848C210.765 14.0848 210.326 13.9835 209.963 13.7808C209.606 13.5782 209.331 13.2955 209.139 12.9329C208.953 12.5649 208.859 12.133 208.859 11.637V4.29354H206.444V11.853C206.444 12.7116 206.641 13.4609 207.036 14.1008C207.436 14.7408 207.995 15.2394 208.715 15.5967C209.44 15.954 210.296 16.1327 211.283 16.1327Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M220.448 15.8367H224.423C225.25 15.8367 225.959 15.7034 226.551 15.4367C227.148 15.1647 227.607 14.7834 227.927 14.2928C228.252 13.7968 228.415 13.2129 228.415 12.5409V12.5249C228.415 12.0343 228.3 11.589 228.071 11.189C227.847 10.7891 227.535 10.4638 227.135 10.2131C226.74 9.96245 226.287 9.81846 225.775 9.78113V9.63714C226.17 9.57848 226.524 9.43183 226.839 9.19718C227.154 8.96253 227.402 8.66922 227.583 8.31724C227.769 7.96527 227.863 7.58663 227.863 7.18132V7.16533C227.863 6.57337 227.719 6.06407 227.431 5.63744C227.148 5.20547 226.74 4.87483 226.207 4.64551C225.679 4.41086 225.039 4.29354 224.288 4.29354H220.448V6.08541H223.672C224.248 6.08541 224.693 6.21873 225.007 6.48538C225.327 6.74669 225.487 7.112 225.487 7.5813V7.59729C225.487 8.07193 225.314 8.4399 224.967 8.70121C224.621 8.96253 224.122 9.09318 223.472 9.09318H220.448V10.6851H223.752C224.226 10.6851 224.626 10.7491 224.951 10.8771C225.282 10.9997 225.53 11.1837 225.695 11.429C225.866 11.6743 225.951 11.9756 225.951 12.3329V12.3489C225.951 12.8982 225.767 13.3169 225.399 13.6049C225.037 13.8928 224.506 14.0368 223.808 14.0368H220.448V15.8367ZM219.241 15.8367H221.656V4.29354H219.241V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M230.926 15.8367H238.476V13.8448H233.341V4.29354H230.926V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M240.995 15.8367H243.411V4.29354H240.995V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M251.441 16.1327C252.374 16.1327 253.2 15.962 253.92 15.6207C254.64 15.2741 255.221 14.7968 255.664 14.1888C256.106 13.5809 256.37 12.8742 256.455 12.069V11.973H254.104L254.088 12.045C254.008 12.4556 253.845 12.8156 253.6 13.1249C253.36 13.4289 253.056 13.6662 252.688 13.8368C252.326 14.0022 251.912 14.0848 251.449 14.0848C250.841 14.0848 250.315 13.9222 249.873 13.5969C249.43 13.2715 249.089 12.8076 248.849 12.205C248.615 11.6023 248.497 10.8904 248.497 10.0691V10.0531C248.497 9.22651 248.615 8.51456 248.849 7.91727C249.089 7.31465 249.43 6.85335 249.873 6.53337C250.315 6.20806 250.838 6.04541 251.441 6.04541C251.899 6.04541 252.312 6.13607 252.68 6.31739C253.054 6.49871 253.363 6.75469 253.608 7.08533C253.853 7.41064 254.016 7.78928 254.096 8.22125L254.104 8.27724H256.447V8.17325C256.373 7.36264 256.112 6.6427 255.664 6.01341C255.216 5.38412 254.627 4.89083 253.896 4.53352C253.171 4.17621 252.352 3.99756 251.441 3.99756C250.321 3.99756 249.356 4.24287 248.545 4.7335C247.74 5.2188 247.119 5.91475 246.682 6.82135C246.244 7.72795 246.026 8.80521 246.026 10.0531V10.0691C246.026 11.317 246.244 12.3943 246.682 13.3009C247.119 14.2075 247.743 14.9061 248.553 15.3967C249.364 15.8874 250.326 16.1327 251.441 16.1327Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M263.557 15.8367H271.108V13.8448H265.973V4.29354H263.557V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M273.627 15.8367H276.042V4.29354H273.627V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M280.377 15.8367H284.352C285.178 15.8367 285.888 15.7034 286.48 15.4367C287.077 15.1647 287.535 14.7834 287.855 14.2928C288.18 13.7968 288.343 13.2129 288.343 12.5409V12.5249C288.343 12.0343 288.228 11.589 287.999 11.189C287.775 10.7891 287.463 10.4638 287.063 10.2131C286.669 9.96245 286.216 9.81846 285.704 9.78113V9.63714C286.098 9.57848 286.453 9.43183 286.767 9.19718C287.082 8.96253 287.33 8.66922 287.511 8.31724C287.698 7.96527 287.791 7.58663 287.791 7.18132V7.16533C287.791 6.57337 287.647 6.06407 287.359 5.63744C287.077 5.20547 286.669 4.87483 286.136 4.64551C285.608 4.41086 284.968 4.29354 284.216 4.29354H280.377V6.08541H283.6C284.176 6.08541 284.621 6.21873 284.936 6.48538C285.256 6.74669 285.416 7.112 285.416 7.5813V7.59729C285.416 8.07193 285.242 8.4399 284.896 8.70121C284.549 8.96253 284.051 9.09318 283.4 9.09318H280.377V10.6851H283.68C284.155 10.6851 284.555 10.7491 284.88 10.8771C285.21 10.9997 285.458 11.1837 285.624 11.429C285.794 11.6743 285.88 11.9756 285.88 12.3329V12.3489C285.88 12.8982 285.696 13.3169 285.328 13.6049C284.965 13.8928 284.435 14.0368 283.736 14.0368H280.377V15.8367ZM279.169 15.8367H281.585V4.29354H279.169V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M290.854 15.8367H293.27V11.613H295.133C295.149 11.613 295.168 11.613 295.189 11.613C295.211 11.613 295.229 11.613 295.245 11.613L297.397 15.8367H300.132L297.701 11.253C298.362 10.9917 298.874 10.5677 299.236 9.98112C299.604 9.38916 299.788 8.72254 299.788 7.98127V7.96527C299.788 7.20799 299.626 6.5547 299.3 6.00541C298.98 5.45612 298.511 5.03482 297.893 4.7415C297.279 4.44286 296.536 4.29354 295.661 4.29354H290.854V15.8367ZM293.27 9.85313V6.1814H295.365C295.973 6.1814 296.45 6.34672 296.797 6.67736C297.143 7.008 297.317 7.4533 297.317 8.01326V8.02926C297.317 8.59989 297.146 9.04785 296.805 9.37316C296.469 9.69314 296 9.85313 295.397 9.85313H293.27Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M301.731 15.8367H304.267L307.09 6.59737H307.794V4.29354H305.739L301.731 15.8367ZM303.875 13.0369H310.394L309.802 11.229H304.467L303.875 13.0369ZM310.05 15.8367H312.593L308.578 4.29354H307.234V6.59737L310.05 15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M314.88 15.8367H317.296V11.613H319.159C319.175 11.613 319.194 11.613 319.215 11.613C319.237 11.613 319.255 11.613 319.271 11.613L321.423 15.8367H324.158L321.727 11.253C322.388 10.9917 322.9 10.5677 323.262 9.98112C323.63 9.38916 323.814 8.72254 323.814 7.98127V7.96527C323.814 7.20799 323.652 6.5547 323.326 6.00541C323.006 5.45612 322.537 5.03482 321.919 4.7415C321.306 4.44286 320.562 4.29354 319.687 4.29354H314.88V15.8367ZM317.296 9.85313V6.1814H319.391C319.999 6.1814 320.476 6.34672 320.823 6.67736C321.17 7.008 321.343 7.4533 321.343 8.01326V8.02926C321.343 8.59989 321.172 9.04785 320.831 9.37316C320.495 9.69314 320.026 9.85313 319.423 9.85313H317.296Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M329.405 15.8367H331.82V11.525L335.843 4.29354H333.228L330.692 9.14918H330.548L328.005 4.29354H325.39L329.405 11.525V15.8367Z",
        fill: "#424242"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M59.541 40.9572H66.6306C68.482 40.9572 70.0603 40.5903 71.3656 39.8565C72.6709 39.1227 73.6691 38.0603 74.3601 36.6695C75.0597 35.2787 75.4095 33.602 75.4095 31.6395V31.6139C75.4095 29.6684 75.0597 28.0173 74.3601 26.6606C73.6691 25.3039 72.6666 24.2715 71.3528 23.5633C70.0475 22.8465 68.4734 22.4882 66.6306 22.4882H59.541V40.9572ZM63.4058 37.7702V25.6751H66.1444C67.2705 25.6751 68.2303 25.9055 69.0237 26.3663C69.8171 26.827 70.4229 27.5011 70.8409 28.3885C71.259 29.2759 71.468 30.3596 71.468 31.6395V31.6651C71.468 32.9962 71.2632 34.114 70.8537 35.0184C70.4442 35.9229 69.8427 36.6098 69.0493 37.0791C68.2644 37.5398 67.2961 37.7702 66.1444 37.7702H63.4058Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M79.1708 40.9572H83.0356V22.4882H79.1708V40.9572Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M95.6654 41.3028C96.9451 41.3028 98.0926 41.1193 99.1078 40.7524C100.123 40.3855 100.985 39.8522 101.693 39.1525C102.401 38.4528 102.938 37.6081 103.305 36.6183C103.681 35.62 103.868 34.4979 103.868 33.2522V31.0891H95.9213V33.9561H100.106L100.093 34.2377C100.059 34.9971 99.8543 35.6627 99.4789 36.2343C99.1121 36.806 98.6045 37.2497 97.9561 37.5654C97.3162 37.8726 96.5782 38.0262 95.7422 38.0262C94.9743 38.0262 94.279 37.8812 93.6562 37.591C93.0419 37.3009 92.5173 36.8828 92.0822 36.3367C91.6471 35.7821 91.3101 35.1123 91.0712 34.3273C90.8408 33.5337 90.7257 32.6378 90.7257 31.6395V31.6267C90.7257 30.3212 90.9219 29.2077 91.3143 28.2861C91.7068 27.3561 92.2656 26.6478 92.9908 26.1615C93.7159 25.6666 94.5861 25.4191 95.6014 25.4191C96.6508 25.4191 97.5338 25.6709 98.2504 26.1743C98.9756 26.6692 99.4875 27.3646 99.7861 28.2605L99.8244 28.4013H103.702L103.664 28.2221C103.467 27.0446 103.011 25.9994 102.294 25.0864C101.578 24.1734 100.648 23.4566 99.5045 22.9361C98.3698 22.4071 97.0645 22.1426 95.5886 22.1426C93.7885 22.1426 92.2272 22.5265 90.9048 23.2945C89.591 24.0539 88.5757 25.1461 87.8591 26.5711C87.1425 27.9875 86.7841 29.6855 86.7841 31.6651V31.6779C86.7841 33.1796 86.9889 34.5278 87.3984 35.7224C87.8079 36.9084 88.3966 37.9196 89.1644 38.7558C89.9322 39.5834 90.8622 40.2149 91.9542 40.65C93.0547 41.0852 94.2918 41.3028 95.6654 41.3028Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M107.681 40.9572H111.546V22.4882H107.681V40.9572Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M120.349 40.9572H124.214V25.6751H129.589V22.4882H114.974V25.6751H120.349V40.9572Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M129.396 40.9572H133.465L138.059 26.0975H139.237V22.4882H135.845L129.396 40.9572ZM132.864 36.4775H143.357L142.41 33.5849H133.811L132.864 36.4775ZM142.769 40.9572H146.825L140.388 22.4882H138.174V26.0975L142.769 40.9572Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M149.985 40.9572H161.951V37.7702H153.85V22.4882H149.985V40.9572Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M180.185 41.3028C181.678 41.3028 183.004 41.0169 184.164 40.4452C185.333 39.8735 186.276 39.0843 186.993 38.0774C187.709 37.0705 188.127 35.9144 188.247 34.6089L188.26 34.4809H184.497L184.472 34.5961C184.309 35.3128 184.032 35.9272 183.64 36.4391C183.247 36.9511 182.761 37.3436 182.181 37.6166C181.601 37.8897 180.94 38.0262 180.197 38.0262C179.216 38.0262 178.363 37.7745 177.638 37.2711C176.913 36.7591 176.354 36.0296 175.961 35.0824C175.569 34.1353 175.373 33.0132 175.373 31.7163V31.7035C175.373 30.398 175.569 29.2802 175.961 28.3501C176.354 27.4115 176.908 26.6905 177.625 26.1871C178.35 25.6751 179.203 25.4191 180.185 25.4191C180.952 25.4191 181.626 25.5599 182.206 25.8415C182.795 26.1231 183.277 26.5199 183.653 27.0318C184.036 27.5352 184.297 28.1283 184.433 28.8109L184.484 29.0029H188.247L188.234 28.8749C188.114 27.5694 187.696 26.4132 186.98 25.4063C186.272 24.3909 185.333 23.5931 184.164 23.0129C183.004 22.4327 181.678 22.1426 180.185 22.1426C178.393 22.1426 176.84 22.5265 175.526 23.2945C174.213 24.0624 173.197 25.1589 172.481 26.5839C171.773 28.0088 171.418 29.7154 171.418 31.7035V31.7163C171.418 33.7044 171.773 35.4152 172.481 36.8487C173.197 38.2737 174.213 39.3744 175.526 40.1509C176.84 40.9188 178.393 41.3028 180.185 41.3028Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M200.185 41.3028C202.02 41.3028 203.598 40.9145 204.92 40.1381C206.251 39.3616 207.275 38.2566 207.992 36.8231C208.717 35.3896 209.079 33.6916 209.079 31.7291V31.7035C209.079 29.741 208.717 28.0472 207.992 26.6222C207.275 25.1888 206.251 24.0838 204.92 23.3073C203.59 22.5308 202.011 22.1426 200.185 22.1426C198.368 22.1426 196.794 22.5308 195.463 23.3073C194.132 24.0838 193.1 25.1888 192.366 26.6222C191.641 28.0472 191.279 29.741 191.279 31.7035V31.7291C191.279 33.6916 191.641 35.3896 192.366 36.8231C193.092 38.2566 194.12 39.3616 195.451 40.1381C196.781 40.9145 198.36 41.3028 200.185 41.3028ZM200.185 38.0262C199.17 38.0262 198.291 37.7702 197.549 37.2583C196.807 36.7463 196.231 36.021 195.822 35.0824C195.421 34.1353 195.22 33.0175 195.22 31.7291V31.7035C195.22 30.4065 195.425 29.2887 195.834 28.3501C196.244 27.4115 196.82 26.6905 197.562 26.1871C198.304 25.6751 199.179 25.4191 200.185 25.4191C201.192 25.4191 202.067 25.6751 202.809 26.1871C203.551 26.699 204.123 27.4243 204.524 28.3629C204.933 29.3015 205.138 30.415 205.138 31.7035V31.7291C205.138 33.009 204.937 34.1225 204.537 35.0696C204.136 36.0082 203.564 36.7378 202.822 37.2583C202.088 37.7702 201.209 38.0262 200.185 38.0262Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M212.841 40.9572H224.806V37.7702H216.706V22.4882H212.841V40.9572Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M228.376 40.9572H240.341V37.7702H232.24V22.4882H228.376V40.9572Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M243.91 40.9572H256.144V37.7702H247.775V33.1242H255.671V30.1164H247.775V25.6751H256.144V22.4882H243.91V40.9572Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M268.352 41.3028C269.845 41.3028 271.172 41.0169 272.332 40.4452C273.501 39.8735 274.443 39.0843 275.16 38.0774C275.877 37.0705 276.295 35.9144 276.414 34.6089L276.427 34.4809H272.665L272.639 34.5961C272.477 35.3128 272.2 35.9272 271.807 36.4391C271.415 36.9511 270.928 37.3436 270.348 37.6166C269.768 37.8897 269.107 38.0262 268.365 38.0262C267.384 38.0262 266.53 37.7745 265.805 37.2711C265.08 36.7591 264.521 36.0296 264.129 35.0824C263.736 34.1353 263.54 33.0132 263.54 31.7163V31.7035C263.54 30.398 263.736 29.2802 264.129 28.3501C264.521 27.4115 265.076 26.6905 265.792 26.1871C266.518 25.6751 267.371 25.4191 268.352 25.4191C269.12 25.4191 269.794 25.5599 270.374 25.8415C270.962 26.1231 271.445 26.5199 271.82 27.0318C272.204 27.5352 272.464 28.1283 272.601 28.8109L272.652 29.0029H276.414L276.401 28.8749C276.282 27.5694 275.864 26.4132 275.147 25.4063C274.439 24.3909 273.501 23.5931 272.332 23.0129C271.172 22.4327 269.845 22.1426 268.352 22.1426C266.56 22.1426 265.008 22.5265 263.694 23.2945C262.38 24.0624 261.365 25.1589 260.648 26.5839C259.94 28.0088 259.586 29.7154 259.586 31.7035V31.7163C259.586 33.7044 259.94 35.4152 260.648 36.8487C261.365 38.2737 262.38 39.3744 263.694 40.1509C265.008 40.9188 266.56 41.3028 268.352 41.3028Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M283.963 40.9572H287.828V25.6751H293.203V22.4882H278.589V25.6751H283.963V40.9572Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M296.632 40.9572H300.496V22.4882H296.632V40.9572Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M313.152 41.3028C314.986 41.3028 316.564 40.9145 317.887 40.1381C319.218 39.3616 320.241 38.2566 320.958 36.8231C321.683 35.3896 322.046 33.6916 322.046 31.7291V31.7035C322.046 29.741 321.683 28.0472 320.958 26.6222C320.241 25.1888 319.218 24.0838 317.887 23.3073C316.556 22.5308 314.977 22.1426 313.152 22.1426C311.334 22.1426 309.76 22.5308 308.43 23.3073C307.099 24.0838 306.066 25.1888 305.333 26.6222C304.607 28.0472 304.245 29.741 304.245 31.7035V31.7291C304.245 33.6916 304.607 35.3896 305.333 36.8231C306.058 38.2566 307.086 39.3616 308.417 40.1381C309.748 40.9145 311.326 41.3028 313.152 41.3028ZM313.152 38.0262C312.136 38.0262 311.258 37.7702 310.515 37.2583C309.773 36.7463 309.197 36.021 308.788 35.0824C308.387 34.1353 308.186 33.0175 308.186 31.7291V31.7035C308.186 30.4065 308.391 29.2887 308.801 28.3501C309.21 27.4115 309.786 26.6905 310.528 26.1871C311.271 25.6751 312.145 25.4191 313.152 25.4191C314.158 25.4191 315.033 25.6751 315.775 26.1871C316.517 26.699 317.089 27.4243 317.49 28.3629C317.899 29.3015 318.104 30.415 318.104 31.7035V31.7291C318.104 33.009 317.904 34.1225 317.503 35.0696C317.102 36.0082 316.53 36.7378 315.788 37.2583C315.054 37.7702 314.175 38.0262 313.152 38.0262Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M325.807 40.9572H329.633V28.9133H331.31L328.175 26.6734L338.131 40.9572H341.458V22.4882H337.632V34.4553H335.955L339.103 36.7079L329.16 22.4882H325.807V40.9572Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M352.565 41.3028C354.118 41.3028 355.449 41.0681 356.558 40.5988C357.667 40.121 358.516 39.4469 359.104 38.5766C359.701 37.6977 360 36.6652 360 35.4792V35.4664C360 34.5022 359.804 33.6788 359.411 32.9962C359.019 32.305 358.409 31.7333 357.581 31.2811C356.754 30.8289 355.692 30.4748 354.395 30.2188L352.45 29.822C351.383 29.6002 350.603 29.3101 350.108 28.9517C349.613 28.5933 349.366 28.1197 349.366 27.531V27.5182C349.366 27.0745 349.494 26.6862 349.75 26.3535C350.014 26.0207 350.381 25.7604 350.85 25.5727C351.328 25.3765 351.891 25.2783 352.539 25.2783C353.188 25.2783 353.755 25.3722 354.241 25.5599C354.736 25.7476 355.133 26.0122 355.431 26.3535C355.73 26.6948 355.914 27.1086 355.982 27.595L355.995 27.7486H359.642L359.629 27.5182C359.569 26.4516 359.245 25.513 358.656 24.7024C358.076 23.8918 357.27 23.2646 356.238 22.8209C355.205 22.3687 353.973 22.1426 352.539 22.1426C351.183 22.1426 349.971 22.3772 348.905 22.8465C347.847 23.3158 347.015 23.9728 346.409 24.8176C345.812 25.6538 345.509 26.635 345.501 27.7614V27.7742C345.501 29.165 345.957 30.2998 346.87 31.1787C347.783 32.0576 349.157 32.6805 350.991 33.0474L352.949 33.4441C354.092 33.6745 354.907 33.9689 355.393 34.3273C355.888 34.6857 356.135 35.172 356.135 35.7864V35.7992C356.135 36.2685 355.995 36.6823 355.713 37.0407C355.431 37.3991 355.031 37.6764 354.51 37.8726C353.99 38.0689 353.371 38.167 352.654 38.167C351.955 38.167 351.328 38.0689 350.773 37.8726C350.227 37.6764 349.779 37.4076 349.43 37.0663C349.088 36.7164 348.879 36.3069 348.803 35.8376L348.777 35.6968H345.117L345.13 35.9016C345.207 37.0279 345.552 37.9963 346.166 38.807C346.789 39.609 347.642 40.2276 348.726 40.6628C349.818 41.0895 351.098 41.3028 352.565 41.3028Z",
        fill: "black"
    })), $0422a6ce4ea03acc$var$Oz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 360 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M45.2839 29.1926L45.2816 29.1998C45.0975 29.7838 44.8633 30.5269 44.3949 30.1861C42.9149 29.1018 41.3038 28.208 39.5996 27.5258C39.4982 27.5 39.5111 27.3602 39.548 27.2848C39.6803 26.9855 39.7661 26.6678 39.8025 26.3428C39.8959 26.0382 40.0517 25.7563 40.2599 25.5149C40.7373 24.5691 41.0302 23.5414 41.1231 22.4866C41.2047 21.6827 41.1574 20.871 40.9829 20.082C40.8474 19.7416 40.7497 19.3875 40.6915 19.0259C40.6915 18.8424 40.7387 18.6589 40.7884 18.4659C40.8318 18.297 40.8771 18.1209 40.8944 17.9312C40.6774 16.7723 39.8524 15.8194 38.7346 15.4365C38.1319 15.1555 37.5161 14.8832 36.8909 14.6066L36.8902 14.6063L36.8901 14.6063C35.6445 14.0554 34.3611 13.4877 33.067 12.8019C32.0386 12.0373 31.0779 11.186 30.1954 10.2575C28.6601 9.33992 27.0115 8.6256 25.2913 8.1325C25.0875 8.10174 24.9275 7.94214 24.8967 7.73879C24.3049 5.07852 22.7852 2.71437 20.6086 1.06779C19.8082 0.444103 20.7174 0.0871843 21.824 0.0375054C29.2499 -0.380325 36.4207 2.80585 41.0764 8.59183C45.7321 14.3778 47.2992 22.0509 45.2839 29.1926ZM10.8907 3.2644C10.5965 3.46006 10.5965 3.96521 11.3136 4.03815C13.8823 4.24978 16.3086 5.25585 18.2242 6.90368C18.3492 7.03406 18.5165 7.12052 18.6992 7.14915C18.8797 7.16413 19.0865 7.15741 19.3315 7.14946C19.6982 7.13755 20.1503 7.12286 20.7277 7.17405C21.1936 7.21179 21.6564 7.27774 22.1136 7.37149C23.3727 7.59384 21.4858 4.83682 19.3679 3.38535C18.1282 2.44333 16.6731 1.79425 15.1209 1.491C14.802 1.45063 14.4778 1.50203 14.1896 1.63863C13.0322 2.06615 11.9262 2.6112 10.8907 3.2644ZM6.09108 7.36165C6.22874 7.20128 6.41233 7.08497 6.61816 7.02774C9.51601 6.33416 12.5662 6.59008 15.3013 7.75627C15.8156 7.97947 16.0545 8.29196 15.7153 8.5098C14.8481 9.02442 14.0248 9.60664 13.2532 10.2508C13.0137 10.3976 12.728 10.4547 12.4489 10.4115C9.69673 9.86617 6.83853 10.1978 4.2928 11.3579C3.66542 11.6168 3.11098 11.2597 3.40097 10.7901C4.16925 9.55595 5.07117 8.40651 6.09108 7.36165ZM36.2813 16.1045C35.4939 15.7177 34.5983 15.4206 33.7046 15.1241C32.6653 14.7792 31.6284 14.4352 30.7667 13.952C30.1829 13.6294 29.6652 13.212 29.1458 12.7932C28.5246 12.2922 27.9009 11.7893 27.1588 11.4444C25.7728 10.7978 24.3334 10.2724 22.8567 9.874C20.8043 9.30797 18.6087 9.62448 16.8 10.7471C14.9433 12.173 14.0578 14.5289 14.5162 16.8238C14.6625 17.9216 15.0591 18.9711 15.6755 19.8915C17.3271 22.2292 19.9669 23.4795 22.6089 24.7306C23.8019 25.2956 24.9953 25.8608 26.0983 26.5265C26.1959 26.6084 26.3415 26.5957 26.4235 26.4982L26.4243 26.4972L26.4463 26.4807C26.9116 25.6076 27.6402 24.9031 28.5287 24.4673C29.8401 24.139 31.2024 24.0657 32.5414 24.2514C33.7686 24.4877 35.0385 24.193 36.0359 23.4405C36.723 22.4247 36.5675 21.0601 35.6696 20.2246C35.3934 20.0656 35.0423 19.9896 34.6901 19.9134L34.69 19.9134C34.3976 19.8502 34.1045 19.7867 33.8528 19.6755C33.4245 19.462 33.0915 19.0965 32.9187 18.6505C32.6684 18.1873 32.6271 17.6395 32.8052 17.144C33.1317 16.8172 33.634 16.7428 34.0414 16.961C35.0993 17.2625 36.218 17.2801 37.2849 17.0123C37.1016 16.5759 36.734 16.2434 36.2813 16.1045ZM27.3351 15.6103C27.3094 16.1056 27.0461 16.5582 26.6281 16.8256C26.2616 16.7593 25.9281 16.5717 25.6812 16.293C25.117 16.0255 24.5297 15.8092 23.9267 15.6469C23.3331 15.5484 22.8025 15.2195 22.4505 14.7317C22.1355 13.9721 22.8791 13.617 23.4212 13.4395C23.9221 13.2894 24.4406 13.2064 24.9633 13.1924C25.7809 13.0075 26.6347 13.2784 27.1959 13.9007C27.3879 14.4493 27.4358 15.0379 27.3351 15.6103ZM0.751709 17.7706C0.602344 17.9368 0.512103 18.1467 0.494743 18.3682C-0.365966 22.3517 -0.0999115 26.4923 1.26377 30.3364C1.49651 30.9174 2.40705 30.6931 2.38098 29.4464C2.3877 29.2163 2.39052 28.9613 2.39357 28.6844C2.43114 25.2801 2.50529 18.5621 10.3281 13.9167C10.816 13.6372 11.2256 13.3577 11.0208 12.8741C10.6686 12.5536 10.1601 12.4639 9.71738 12.6443C6.23331 13.3174 3.07733 15.1219 0.751709 17.7706ZM37.7003 20.9227C37.7003 20.9877 37.7423 21.2962 37.7563 21.3854C37.837 21.9989 37.8025 22.6208 37.6543 23.2233C37.6493 23.2997 37.6791 23.3746 37.7363 23.4296C38.2105 23.7517 38.5818 24.1871 38.8107 24.6896C38.8447 24.7788 38.9547 24.7267 39.0108 24.6115C39.6382 23.1415 39.6624 21.5087 39.0788 20.0232L39.0759 20.0178C39.0596 19.9866 39.0186 19.9085 38.9547 19.9452C38.6979 20.0853 38.4537 20.2443 38.2245 20.4209C38.0031 20.5398 37.8216 20.7136 37.7003 20.9227ZM30.128 27.2785C30.2162 26.9315 30.4295 26.6323 30.7243 26.4421C31.4983 26.1121 32.3322 25.9587 33.169 25.9923C34.0094 25.9932 34.8441 25.85 35.639 25.5685C35.9903 25.1979 36.4985 25.0338 36.9919 25.1317C37.2501 25.2613 37.4404 25.5011 37.5126 25.7878C37.6258 26.1043 37.6725 26.442 37.6495 26.7785C37.314 27.719 36.9328 28.6415 36.5073 29.5424C36.5113 29.7201 36.4636 29.8949 36.3704 30.0443C35.3892 30.6404 34.215 30.7982 33.1186 30.4811C32.7209 30.4812 32.3262 30.4114 31.9512 30.2748C31.7322 30.1456 31.535 29.9805 31.3675 29.7859C31.0811 29.5098 30.8842 29.2818 30.6394 28.9985L30.6391 28.9982C30.5544 28.9002 30.464 28.7955 30.3622 28.68C30.1728 28.5111 30.0168 28.3059 29.9028 28.0759C29.9565 27.8042 30.0318 27.5375 30.128 27.2785ZM7.35405 39.6856C7.57995 40.1259 7.89329 40.5156 8.27492 40.8308C11.8992 43.8942 16.3905 45.7488 21.1209 46.1352C22.0344 46.2107 22.1357 45.8812 22.1486 45.3583C21.5277 42.8685 20.3132 40.5659 18.6088 38.6472C18.155 38.0539 17.3288 37.1535 16.3394 36.0753C13.9519 33.4734 10.6145 29.8364 9.26941 26.9817C8.11003 24.9781 7.75208 22.6101 8.2675 20.3535C8.57138 19.2451 7.64498 18.5823 6.77016 20.0221C4.01681 24.1352 5.21027 36.2592 7.35405 39.6856ZM11.1144 24.0643C10.0309 21.4933 10.0815 18.5882 11.254 16.0561C11.5826 15.4371 11.8984 15.0336 12.317 15.1596C12.7724 15.2856 12.8679 15.753 12.9376 16.6203C13.4058 23.7685 17.7316 26.1677 23.159 28.6947C28.4971 30.9817 33.088 34.7042 36.4154 39.4435C37.036 40.3144 37.1241 40.8458 36.4283 41.3497C34.0167 43.094 31.2758 44.3361 28.3698 45.0015C27.8759 45.1147 27.3581 45.027 26.9156 43.8895C24.422 37.4561 21.003 34.6799 17.8379 32.1098C15.1883 29.9584 12.7166 27.9513 11.1144 24.0643ZM37.9272 38.5047C38.1529 38.9544 38.5584 39.4907 39.2538 38.8045C40.5813 37.4497 41.7286 35.9345 42.6684 34.2953C42.8361 34.0615 42.8694 33.7591 42.7565 33.4953C41.9732 32.3455 41.0188 31.3179 39.9254 30.4471C39.486 30.0845 38.9904 29.7937 38.4575 29.5857C38.3225 29.5458 38.1817 29.5287 38.041 29.5351C37.6557 29.5817 37.6097 29.7538 37.4615 30.3084C37.4488 30.356 37.4353 30.4063 37.4208 30.4597C37.2645 31.1965 36.8074 31.8376 36.1566 32.233C35.7291 32.4377 35.2505 32.5161 34.7787 32.4588C34.6196 32.4175 34.4526 32.4888 34.3746 32.6313C34.2965 32.7737 34.3278 32.9502 34.4502 33.0583C35.8945 34.6814 37.0681 36.5197 37.9272 38.5047Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("mask", {
        id: "mask0_75161_120621",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: 0,
        y: 0,
        width: 47,
        height: 47
    }, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M45.2839 29.1926L45.2816 29.1998C45.0975 29.7838 44.8633 30.5269 44.3949 30.1861C42.9149 29.1018 41.3038 28.208 39.5996 27.5258C39.4982 27.5 39.5111 27.3602 39.548 27.2848C39.6803 26.9855 39.7661 26.6678 39.8025 26.3428C39.8959 26.0382 40.0517 25.7563 40.2599 25.5149C40.7373 24.5691 41.0302 23.5414 41.1231 22.4866C41.2047 21.6827 41.1574 20.871 40.9829 20.082C40.8474 19.7416 40.7497 19.3875 40.6915 19.0259C40.6915 18.8424 40.7387 18.6589 40.7884 18.4659C40.8318 18.297 40.8771 18.1209 40.8944 17.9312C40.6774 16.7723 39.8524 15.8194 38.7346 15.4365C38.1319 15.1555 37.5161 14.8832 36.8909 14.6066L36.8902 14.6063L36.8901 14.6063C35.6445 14.0554 34.3611 13.4877 33.067 12.8019C32.0386 12.0373 31.0779 11.186 30.1954 10.2575C28.6601 9.33992 27.0115 8.6256 25.2913 8.1325C25.0875 8.10174 24.9275 7.94214 24.8967 7.73879C24.3049 5.07852 22.7852 2.71437 20.6086 1.06779C19.8082 0.444103 20.7174 0.0871843 21.824 0.0375054C29.2499 -0.380325 36.4207 2.80585 41.0764 8.59183C45.7321 14.3778 47.2992 22.0509 45.2839 29.1926ZM10.8907 3.2644C10.5965 3.46006 10.5965 3.96521 11.3136 4.03815C13.8823 4.24978 16.3086 5.25585 18.2242 6.90368C18.3492 7.03406 18.5165 7.12052 18.6992 7.14915C18.8797 7.16413 19.0865 7.15741 19.3315 7.14946C19.6982 7.13755 20.1503 7.12286 20.7277 7.17405C21.1936 7.21179 21.6564 7.27774 22.1136 7.37149C23.3727 7.59384 21.4858 4.83682 19.3679 3.38535C18.1282 2.44333 16.6731 1.79425 15.1209 1.491C14.802 1.45063 14.4778 1.50203 14.1896 1.63863C13.0322 2.06615 11.9262 2.6112 10.8907 3.2644ZM6.09108 7.36165C6.22874 7.20128 6.41233 7.08497 6.61816 7.02774C9.51601 6.33416 12.5662 6.59008 15.3013 7.75627C15.8156 7.97947 16.0545 8.29196 15.7153 8.5098C14.8481 9.02442 14.0248 9.60664 13.2532 10.2508C13.0137 10.3976 12.728 10.4547 12.4489 10.4115C9.69673 9.86617 6.83853 10.1978 4.2928 11.3579C3.66542 11.6168 3.11098 11.2597 3.40097 10.7901C4.16925 9.55595 5.07117 8.40651 6.09108 7.36165ZM36.2813 16.1045C35.4939 15.7177 34.5983 15.4206 33.7046 15.1241C32.6653 14.7792 31.6284 14.4352 30.7667 13.952C30.1829 13.6294 29.6652 13.212 29.1458 12.7932C28.5246 12.2922 27.9009 11.7893 27.1588 11.4444C25.7728 10.7978 24.3334 10.2724 22.8567 9.874C20.8043 9.30797 18.6087 9.62448 16.8 10.7471C14.9433 12.173 14.0578 14.5289 14.5162 16.8238C14.6625 17.9216 15.0591 18.9711 15.6755 19.8915C17.3271 22.2292 19.9669 23.4795 22.6089 24.7306C23.8019 25.2956 24.9953 25.8608 26.0983 26.5265C26.1959 26.6084 26.3415 26.5957 26.4235 26.4982L26.4243 26.4972L26.4463 26.4807C26.9116 25.6076 27.6402 24.9031 28.5287 24.4673C29.8401 24.139 31.2024 24.0657 32.5414 24.2514C33.7686 24.4877 35.0385 24.193 36.0359 23.4405C36.723 22.4247 36.5675 21.0601 35.6696 20.2246C35.3934 20.0656 35.0423 19.9896 34.6901 19.9134L34.69 19.9134C34.3976 19.8502 34.1045 19.7867 33.8528 19.6755C33.4245 19.462 33.0915 19.0965 32.9187 18.6505C32.6684 18.1873 32.6271 17.6395 32.8052 17.144C33.1317 16.8172 33.634 16.7428 34.0414 16.961C35.0993 17.2625 36.218 17.2801 37.2849 17.0123C37.1016 16.5759 36.734 16.2434 36.2813 16.1045ZM27.3351 15.6103C27.3094 16.1056 27.0461 16.5582 26.6281 16.8256C26.2616 16.7593 25.9281 16.5717 25.6812 16.293C25.117 16.0255 24.5297 15.8092 23.9267 15.6469C23.3331 15.5484 22.8025 15.2195 22.4505 14.7317C22.1355 13.9721 22.8791 13.617 23.4212 13.4395C23.9221 13.2894 24.4406 13.2064 24.9633 13.1924C25.7809 13.0075 26.6347 13.2784 27.1959 13.9007C27.3879 14.4493 27.4358 15.0379 27.3351 15.6103ZM0.751709 17.7706C0.602344 17.9368 0.512103 18.1467 0.494743 18.3682C-0.365966 22.3517 -0.0999115 26.4923 1.26377 30.3364C1.49651 30.9174 2.40705 30.6931 2.38098 29.4464C2.3877 29.2163 2.39052 28.9613 2.39357 28.6844C2.43114 25.2801 2.50529 18.5621 10.3281 13.9167C10.816 13.6372 11.2256 13.3577 11.0208 12.8741C10.6686 12.5536 10.1601 12.4639 9.71738 12.6443C6.23331 13.3174 3.07733 15.1219 0.751709 17.7706ZM37.7003 20.9227C37.7003 20.9877 37.7423 21.2962 37.7563 21.3854C37.837 21.9989 37.8025 22.6208 37.6543 23.2233C37.6493 23.2997 37.6791 23.3746 37.7363 23.4296C38.2105 23.7517 38.5818 24.1871 38.8107 24.6896C38.8447 24.7788 38.9547 24.7267 39.0108 24.6115C39.6382 23.1415 39.6624 21.5087 39.0788 20.0232L39.0759 20.0178C39.0596 19.9866 39.0186 19.9085 38.9547 19.9452C38.6979 20.0853 38.4537 20.2443 38.2245 20.4209C38.0031 20.5398 37.8216 20.7136 37.7003 20.9227ZM30.128 27.2785C30.2162 26.9315 30.4295 26.6323 30.7243 26.4421C31.4983 26.1121 32.3322 25.9587 33.169 25.9923C34.0094 25.9932 34.8441 25.85 35.639 25.5685C35.9903 25.1979 36.4985 25.0338 36.9919 25.1317C37.2501 25.2613 37.4404 25.5011 37.5126 25.7878C37.6258 26.1043 37.6725 26.442 37.6495 26.7785C37.314 27.719 36.9328 28.6415 36.5073 29.5424C36.5113 29.7201 36.4636 29.8949 36.3704 30.0443C35.3892 30.6404 34.215 30.7982 33.1186 30.4811C32.7209 30.4812 32.3262 30.4114 31.9512 30.2748C31.7322 30.1456 31.535 29.9805 31.3675 29.7859C31.0811 29.5098 30.8842 29.2818 30.6394 28.9985L30.6391 28.9982C30.5544 28.9002 30.464 28.7955 30.3622 28.68C30.1728 28.5111 30.0168 28.3059 29.9028 28.0759C29.9565 27.8042 30.0318 27.5375 30.128 27.2785ZM7.35405 39.6856C7.57995 40.1259 7.89329 40.5156 8.27492 40.8308C11.8992 43.8942 16.3905 45.7488 21.1209 46.1352C22.0344 46.2107 22.1357 45.8812 22.1486 45.3583C21.5277 42.8685 20.3132 40.5659 18.6088 38.6472C18.155 38.0539 17.3288 37.1535 16.3394 36.0753C13.9519 33.4734 10.6145 29.8364 9.26941 26.9817C8.11003 24.9781 7.75208 22.6101 8.2675 20.3535C8.57138 19.2451 7.64498 18.5823 6.77016 20.0221C4.01681 24.1352 5.21027 36.2592 7.35405 39.6856ZM11.1144 24.0643C10.0309 21.4933 10.0815 18.5882 11.254 16.0561C11.5826 15.4371 11.8984 15.0336 12.317 15.1596C12.7724 15.2856 12.8679 15.753 12.9376 16.6203C13.4058 23.7685 17.7316 26.1677 23.159 28.6947C28.4971 30.9817 33.088 34.7042 36.4154 39.4435C37.036 40.3144 37.1241 40.8458 36.4283 41.3497C34.0167 43.094 31.2758 44.3361 28.3698 45.0015C27.8759 45.1147 27.3581 45.027 26.9156 43.8895C24.422 37.4561 21.003 34.6799 17.8379 32.1098C15.1883 29.9584 12.7166 27.9513 11.1144 24.0643ZM37.9272 38.5047C38.1529 38.9544 38.5584 39.4907 39.2538 38.8045C40.5813 37.4497 41.7286 35.9345 42.6684 34.2953C42.8361 34.0615 42.8694 33.7591 42.7565 33.4953C41.9732 32.3455 41.0188 31.3179 39.9254 30.4471C39.486 30.0845 38.9904 29.7937 38.4575 29.5857C38.3225 29.5458 38.1817 29.5287 38.041 29.5351C37.6557 29.5817 37.6097 29.7538 37.4615 30.3084C37.4488 30.356 37.4353 30.4063 37.4208 30.4597C37.2645 31.1965 36.8074 31.8376 36.1566 32.233C35.7291 32.4377 35.2505 32.5161 34.7787 32.4588C34.6196 32.4175 34.4526 32.4888 34.3746 32.6313C34.2965 32.7737 34.3278 32.9502 34.4502 33.0583C35.8945 34.6814 37.0681 36.5197 37.9272 38.5047Z",
        fill: "white"
    })), /* @__PURE__ */ $acw62.createElement("g", {
        mask: "url(#mask0_75161_120621)"
    }, /* @__PURE__ */ $acw62.createElement("rect", {
        y: -0.368164,
        width: 46.145,
        height: 46.5142,
        fill: "white"
    })), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M59.1592 14.8325H61.5894V5.22431H65.0738V3.22059H55.6748V5.22431H59.1592V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M67.5519 14.8325H69.9821V9.93988H75.2127V14.8325H77.6429V3.22059H75.2127V7.93616H69.9821V3.22059H67.5519V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M80.789 14.8325H88.482V12.8288H83.2192V9.8916H88.1842V8.02468H83.2192V5.22431H88.482V3.22059H80.789V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M95.949 14.8325H98.2746V7.40506H99.4897L97.7837 6.54402L103.779 14.8325H105.791V3.22059H103.465V10.6158H102.258L103.956 11.4769L97.9769 3.22059H95.949V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M108.945 14.8325H116.638V12.8288H111.375V9.8916H116.34V8.02468H111.375V5.22431H116.638V3.22059H108.945V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M121.9 14.8325H124.194L126.366 7.01075H126.495L128.692 14.8325H130.969L134.051 3.22059H131.54L129.746 11.5171H129.617L127.461 3.22059H125.409L123.292 11.5171H123.163L121.353 3.22059H118.826L121.9 14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M144.286 14.8325H146.717V10.4951L150.764 3.22059H148.133L145.582 8.10515H145.437L142.878 3.22059H140.247L144.286 10.4951V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M157.475 15.1302C158.618 15.1302 159.608 14.8834 160.445 14.3899C161.281 13.891 161.925 13.1855 162.376 12.2735C162.832 11.3615 163.06 10.2805 163.06 9.03056V9.01447C163.06 7.76449 162.832 6.68351 162.376 5.77151C161.92 4.85951 161.273 4.15673 160.436 3.66318C159.605 3.16963 158.618 2.92285 157.475 2.92285C156.338 2.92285 155.351 3.16963 154.514 3.66318C153.677 4.15673 153.028 4.85951 152.566 5.77151C152.11 6.67814 151.882 7.75913 151.882 9.01447V9.03056C151.882 10.2805 152.108 11.3615 152.558 12.2735C153.014 13.1855 153.661 13.891 154.498 14.3899C155.335 14.8834 156.327 15.1302 157.475 15.1302ZM157.475 13.0702C156.837 13.0702 156.284 12.9039 155.817 12.5713C155.356 12.2387 154.997 11.7692 154.739 11.163C154.487 10.5568 154.361 9.846 154.361 9.03056V9.01447C154.361 8.19367 154.49 7.48285 154.747 6.882C155.005 6.27579 155.367 5.80906 155.834 5.48181C156.3 5.1492 156.847 4.9829 157.475 4.9829C158.103 4.9829 158.65 5.1492 159.117 5.48181C159.583 5.80906 159.943 6.27579 160.195 6.882C160.453 7.48285 160.581 8.19367 160.581 9.01447V9.03056C160.581 9.846 160.453 10.5568 160.195 11.163C159.943 11.7692 159.583 12.2387 159.117 12.5713C158.65 12.9039 158.103 13.0702 157.475 13.0702Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M165.699 14.8325H168.129V10.5836H170.004C170.02 10.5836 170.039 10.5836 170.06 10.5836C170.082 10.5836 170.101 10.5836 170.117 10.5836L172.281 14.8325H175.033L172.587 10.2215C173.252 9.95866 173.767 9.53216 174.132 8.94204C174.502 8.34656 174.687 7.67598 174.687 6.93028V6.91419C174.687 6.1524 174.524 5.49523 174.197 4.94266C173.875 4.3901 173.403 3.96629 172.78 3.67123C172.163 3.3708 171.415 3.22059 170.535 3.22059H165.699V14.8325ZM168.129 8.81329V5.1197H170.237C170.849 5.1197 171.329 5.286 171.678 5.61861C172.027 5.95122 172.201 6.39918 172.201 6.96247V6.97856C172.201 7.55259 172.029 8.00322 171.686 8.33047C171.348 8.65235 170.876 8.81329 170.27 8.81329H168.129Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M179.749 11.4688L181.205 9.71456L182.654 8.49141L187.039 3.22059H184.336L180.046 8.43508H179.66L179.749 11.4688ZM177.471 14.8325H179.902V3.22059H177.471V14.8325ZM184.424 14.8325H187.337L182.67 8.10515L180.924 9.69847L184.424 14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M195.295 11.1711H198.868C199.683 11.1711 200.397 11.0075 201.008 10.6802C201.62 10.353 202.095 9.8916 202.433 9.29611C202.776 8.70063 202.948 8.00322 202.948 7.20388V7.18779C202.948 6.39381 202.776 5.69908 202.433 5.1036C202.095 4.50812 201.62 4.04676 201.008 3.71951C200.397 3.3869 199.683 3.22059 198.868 3.22059H195.295V5.14384H198.272C198.97 5.14384 199.512 5.32087 199.898 5.67494C200.29 6.02901 200.485 6.53598 200.485 7.19584V7.21193C200.485 7.87179 200.29 8.38143 199.898 8.74087C199.512 9.09494 198.97 9.27197 198.272 9.27197H195.295V11.1711ZM194.08 14.8325H196.51V3.22059H194.08V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M210.375 15.1302C211.373 15.1302 212.234 14.9505 212.958 14.5911C213.688 14.2316 214.248 13.73 214.64 13.0863C215.037 12.4371 215.235 11.6834 215.235 10.8251V3.22059H212.805V10.6078C212.805 11.1067 212.711 11.5412 212.523 11.9114C212.336 12.2762 212.059 12.5605 211.695 12.7644C211.335 12.9683 210.895 13.0702 210.375 13.0702C209.854 13.0702 209.412 12.9683 209.047 12.7644C208.688 12.5605 208.411 12.2762 208.218 11.9114C208.03 11.5412 207.937 11.1067 207.937 10.6078V3.22059H205.506V10.8251C205.506 11.6888 205.705 12.4425 206.102 13.0863C206.504 13.73 207.068 14.2316 207.792 14.5911C208.521 14.9505 209.382 15.1302 210.375 15.1302Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M219.596 14.8325H223.596C224.427 14.8325 225.141 14.6984 225.736 14.4301C226.337 14.1565 226.799 13.773 227.12 13.2794C227.448 12.7805 227.611 12.1931 227.611 11.5171V11.501C227.611 11.0075 227.496 10.5595 227.265 10.1571C227.04 9.7548 226.726 9.42755 226.324 9.17541C225.927 8.92327 225.471 8.77842 224.956 8.74087V8.59602C225.353 8.53701 225.71 8.38948 226.026 8.15343C226.343 7.91739 226.592 7.62233 226.774 7.26826C226.962 6.91419 227.056 6.53329 227.056 6.12558V6.10948C227.056 5.514 226.911 5.00167 226.622 4.5725C226.337 4.13796 225.927 3.80534 225.39 3.57466C224.859 3.33862 224.215 3.22059 223.459 3.22059H219.596V5.02313H222.839C223.419 5.02313 223.867 5.15725 224.183 5.42548C224.505 5.68835 224.666 6.05584 224.666 6.52793V6.54402C224.666 7.02148 224.492 7.39165 224.143 7.65452C223.794 7.91739 223.293 8.04882 222.638 8.04882H219.596V9.65019H222.92C223.397 9.65019 223.8 9.71456 224.127 9.84331C224.46 9.9667 224.709 10.1518 224.875 10.3986C225.047 10.6453 225.133 10.9484 225.133 11.3079V11.324C225.133 11.8765 224.948 12.2977 224.578 12.5874C224.213 12.8771 223.679 13.0219 222.976 13.0219H219.596V14.8325ZM218.381 14.8325H220.812V3.22059H218.381V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M230.138 14.8325H237.734V12.8288H232.568V3.22059H230.138V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M240.269 14.8325H242.699V3.22059H240.269V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M250.778 15.1302C251.717 15.1302 252.548 14.9586 253.272 14.6152C253.997 14.2665 254.581 13.7864 255.027 13.1748C255.472 12.5632 255.737 11.8524 255.823 11.0423V10.9458H253.457L253.441 11.0182C253.361 11.4313 253.197 11.7934 252.951 12.1045C252.709 12.4103 252.403 12.6491 252.033 12.8207C251.668 12.987 251.253 13.0702 250.786 13.0702C250.174 13.0702 249.646 12.9066 249.201 12.5793C248.755 12.2521 248.412 11.7853 248.171 11.1791C247.934 10.5729 247.816 9.85673 247.816 9.03056V9.01447C247.816 8.18294 247.934 7.46675 248.171 6.86591C248.412 6.25969 248.755 5.79565 249.201 5.47377C249.646 5.14652 250.172 4.9829 250.778 4.9829C251.239 4.9829 251.655 5.0741 252.025 5.2565C252.401 5.4389 252.712 5.6964 252.959 6.02901C253.205 6.35626 253.369 6.73715 253.449 7.17169L253.457 7.22802H255.815V7.12341C255.74 6.30798 255.477 5.58374 255.027 4.95071C254.576 4.31767 253.983 3.82144 253.248 3.462C252.519 3.10257 251.695 2.92285 250.778 2.92285C249.651 2.92285 248.68 3.16963 247.865 3.66318C247.055 4.15137 246.43 4.85146 245.99 5.76346C245.55 6.67546 245.33 7.75913 245.33 9.01447V9.03056C245.33 10.2859 245.55 11.3696 245.99 12.2816C246.43 13.1936 247.057 13.8963 247.873 14.3899C248.688 14.8834 249.657 15.1302 250.778 15.1302Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M262.968 14.8325H270.565V12.8288H265.399V3.22059H262.968V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M273.099 14.8325H275.53V3.22059H273.099V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M279.891 14.8325H283.89C284.722 14.8325 285.435 14.6984 286.031 14.4301C286.631 14.1565 287.093 13.773 287.415 13.2794C287.742 12.7805 287.906 12.1931 287.906 11.5171V11.501C287.906 11.0075 287.79 10.5595 287.56 10.1571C287.334 9.7548 287.02 9.42755 286.618 9.17541C286.221 8.92327 285.765 8.77842 285.25 8.74087V8.59602C285.647 8.53701 286.004 8.38948 286.32 8.15343C286.637 7.91739 286.886 7.62233 287.069 7.26826C287.256 6.91419 287.35 6.53329 287.35 6.12558V6.10948C287.35 5.514 287.206 5.00167 286.916 4.5725C286.631 4.13796 286.221 3.80534 285.685 3.57466C285.154 3.33862 284.51 3.22059 283.753 3.22059H279.891V5.02313H283.134C283.713 5.02313 284.161 5.15725 284.478 5.42548C284.799 5.68835 284.96 6.05584 284.96 6.52793V6.54402C284.96 7.02148 284.786 7.39165 284.437 7.65452C284.089 7.91739 283.587 8.04882 282.933 8.04882H279.891V9.65019H283.214C283.692 9.65019 284.094 9.71456 284.421 9.84331C284.754 9.9667 285.003 10.1518 285.17 10.3986C285.341 10.6453 285.427 10.9484 285.427 11.3079V11.324C285.427 11.8765 285.242 12.2977 284.872 12.5874C284.507 12.8771 283.973 13.0219 283.271 13.0219H279.891V14.8325ZM278.676 14.8325H281.106V3.22059H278.676V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M290.432 14.8325H292.862V10.5836H294.737C294.753 10.5836 294.772 10.5836 294.794 10.5836C294.815 10.5836 294.834 10.5836 294.85 10.5836L297.015 14.8325H299.767L297.32 10.2215C297.986 9.95866 298.501 9.53216 298.865 8.94204C299.236 8.34656 299.421 7.67598 299.421 6.93028V6.91419C299.421 6.1524 299.257 5.49523 298.93 4.94266C298.608 4.3901 298.136 3.96629 297.513 3.67123C296.897 3.3708 296.148 3.22059 295.268 3.22059H290.432V14.8325ZM292.862 8.81329V5.1197H294.971C295.582 5.1197 296.062 5.286 296.411 5.61861C296.76 5.95122 296.934 6.39918 296.934 6.96247V6.97856C296.934 7.55259 296.762 8.00322 296.419 8.33047C296.081 8.65235 295.609 8.81329 295.003 8.81329H292.862Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M301.376 14.8325H303.927L306.767 5.53814H307.475V3.22059H305.407L301.376 14.8325ZM303.532 12.016H310.091L309.495 10.1974H304.128L303.532 12.016ZM309.745 14.8325H312.304L308.264 3.22059H306.912V5.53814L309.745 14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M314.605 14.8325H317.035V10.5836H318.91C318.926 10.5836 318.945 10.5836 318.966 10.5836C318.988 10.5836 319.007 10.5836 319.023 10.5836L321.187 14.8325H323.939L321.493 10.2215C322.158 9.95866 322.673 9.53216 323.038 8.94204C323.408 8.34656 323.593 7.67598 323.593 6.93028V6.91419C323.593 6.1524 323.43 5.49523 323.102 4.94266C322.781 4.3901 322.308 3.96629 321.686 3.67123C321.069 3.3708 320.321 3.22059 319.441 3.22059H314.605V14.8325ZM317.035 8.81329V5.1197H319.143C319.755 5.1197 320.235 5.286 320.584 5.61861C320.932 5.95122 321.107 6.39918 321.107 6.96247V6.97856C321.107 7.55259 320.935 8.00322 320.592 8.33047C320.254 8.65235 319.782 8.81329 319.175 8.81329H317.035Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M329.218 14.8325H331.648V10.4951L335.696 3.22059H333.064L330.513 8.10515H330.369L327.81 3.22059H325.178L329.218 10.4951V14.8325Z",
        fill: "#BDBDBD"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M57.707 40.1024H64.8399C66.7026 40.1024 68.2905 39.7333 69.6038 38.9952C70.9171 38.257 71.9213 37.1883 72.6166 35.7892C73.3205 34.3901 73.6724 32.7034 73.6724 30.7292V30.7035C73.6724 28.7464 73.3205 27.0855 72.6166 25.7208C71.9213 24.356 70.9128 23.3174 69.5909 22.6049C68.2776 21.8839 66.694 21.5234 64.8399 21.5234H57.707V40.1024ZM61.5954 36.8965V24.7294H64.3507C65.4837 24.7294 66.4493 24.9611 67.2476 25.4246C68.0459 25.8881 68.6553 26.5662 69.0759 27.4589C69.4965 28.3516 69.7068 29.4417 69.7068 30.7292V30.755C69.7068 32.094 69.5008 33.2185 69.0888 34.1283C68.6768 35.0382 68.0716 35.7291 67.2734 36.2012C66.4837 36.6647 65.5094 36.8965 64.3507 36.8965H61.5954Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M77.4567 40.1024H81.345V21.5234H77.4567V40.1024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M94.0519 40.4501C95.3394 40.4501 96.4939 40.2655 97.5153 39.8964C98.5368 39.5273 99.4037 38.9909 100.116 38.287C100.829 37.5832 101.369 36.7334 101.738 35.7377C102.116 34.7334 102.305 33.6047 102.305 32.3515V30.1756H94.3094V33.0597H98.5196L98.5067 33.3429C98.4724 34.1069 98.2664 34.7764 97.8887 35.3515C97.5196 35.9266 97.0089 36.3729 96.3566 36.6905C95.7128 36.9995 94.9703 37.154 94.1291 37.154C93.3566 37.154 92.6571 37.0081 92.0305 36.7162C91.4124 36.4244 90.8846 36.0038 90.4468 35.4545C90.009 34.8965 89.67 34.2227 89.4297 33.433C89.1979 32.6348 89.082 31.7335 89.082 30.7292V30.7164C89.082 29.4031 89.2794 28.2829 89.6743 27.3559C90.0691 26.4203 90.6313 25.7079 91.3609 25.2186C92.0905 24.7208 92.9661 24.4719 93.9875 24.4719C95.0433 24.4719 95.9317 24.7251 96.6527 25.2315C97.3823 25.7293 97.8973 26.4289 98.1977 27.3302L98.2363 27.4718H102.138L102.099 27.2915C101.902 26.107 101.442 25.0555 100.721 24.1371C100 23.2187 99.0647 22.4976 97.9145 21.974C96.7729 21.4419 95.4596 21.1758 93.9746 21.1758C92.1635 21.1758 90.5927 21.562 89.2623 22.3346C87.9404 23.0985 86.919 24.1972 86.198 25.6306C85.4769 27.0555 85.1164 28.7636 85.1164 30.755V30.7679C85.1164 32.2786 85.3224 33.6348 85.7345 34.8365C86.1465 36.0296 86.7387 37.0467 87.5112 37.8879C88.2838 38.7205 89.2194 39.3557 90.3181 39.7934C91.4253 40.2312 92.6699 40.4501 94.0519 40.4501Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M106.141 40.1024H110.029V21.5234H106.141V40.1024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M118.886 40.1024H122.775V24.7294H128.182V21.5234H113.479V24.7294H118.886V40.1024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M127.988 40.1024H132.082L136.705 25.1542H137.889V21.5234H134.477L127.988 40.1024ZM131.477 35.5961H142.035L141.082 32.6863H132.43L131.477 35.5961ZM141.443 40.1024H145.524L139.048 21.5234H136.82V25.1542L141.443 40.1024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M148.703 40.1024H160.742V36.8965H152.592V21.5234H148.703V40.1024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M179.087 40.4501C180.589 40.4501 181.924 40.1625 183.091 39.5874C184.267 39.0123 185.216 38.2184 185.937 37.2055C186.658 36.1926 187.078 35.0296 187.198 33.7163L187.211 33.5875H183.426L183.4 33.7034C183.237 34.4244 182.958 35.0425 182.563 35.5575C182.168 36.0725 181.679 36.4673 181.095 36.742C180.512 37.0167 179.847 37.154 179.1 37.154C178.113 37.154 177.254 36.9008 176.525 36.3944C175.795 35.8793 175.233 35.1455 174.838 34.1927C174.443 33.2399 174.246 32.1112 174.246 30.8065V30.7936C174.246 29.4803 174.443 28.3559 174.838 27.4203C175.233 26.4761 175.791 25.7508 176.512 25.2444C177.241 24.7294 178.1 24.4719 179.087 24.4719C179.859 24.4719 180.538 24.6135 181.121 24.8967C181.713 25.18 182.198 25.5791 182.576 26.0941C182.962 26.6006 183.224 27.1971 183.362 27.8838L183.413 28.0769H187.198L187.185 27.9482C187.065 26.6349 186.645 25.4718 185.924 24.459C185.211 23.4375 184.267 22.635 183.091 22.0513C181.924 21.4676 180.589 21.1758 179.087 21.1758C177.284 21.1758 175.722 21.562 174.4 22.3346C173.078 23.1071 172.057 24.2101 171.336 25.6435C170.624 27.077 170.267 28.7937 170.267 30.7936V30.8065C170.267 32.8064 170.624 34.5274 171.336 35.9695C172.057 37.4029 173.078 38.5102 174.4 39.2913C175.722 40.0638 177.284 40.4501 179.087 40.4501Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M199.21 40.4501C201.055 40.4501 202.643 40.0595 203.974 39.2784C205.313 38.4973 206.343 37.3858 207.064 35.9437C207.793 34.5017 208.158 32.7936 208.158 30.8194V30.7936C208.158 28.8194 207.793 27.1156 207.064 25.6821C206.343 24.2401 205.313 23.1285 203.974 22.3474C202.635 21.5663 201.047 21.1758 199.21 21.1758C197.382 21.1758 195.798 21.5663 194.459 22.3474C193.12 23.1285 192.081 24.2401 191.343 25.6821C190.614 27.1156 190.249 28.8194 190.249 30.7936V30.8194C190.249 32.7936 190.614 34.5017 191.343 35.9437C192.073 37.3858 193.107 38.4973 194.446 39.2784C195.785 40.0595 197.373 40.4501 199.21 40.4501ZM199.21 37.154C198.189 37.154 197.304 36.8965 196.558 36.3815C195.811 35.8665 195.231 35.1369 194.819 34.1927C194.416 33.2399 194.214 32.1155 194.214 30.8194V30.7936C194.214 29.4889 194.42 28.3645 194.832 27.4203C195.244 26.4761 195.824 25.7508 196.571 25.2444C197.317 24.7294 198.197 24.4719 199.21 24.4719C200.223 24.4719 201.103 24.7294 201.849 25.2444C202.596 25.7594 203.171 26.489 203.575 27.4332C203.987 28.3774 204.193 29.4975 204.193 30.7936V30.8194C204.193 32.1069 203.991 33.227 203.588 34.1798C203.184 35.124 202.609 35.8579 201.862 36.3815C201.124 36.8965 200.24 37.154 199.21 37.154Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M211.943 40.1024H223.981V36.8965H215.831V21.5234H211.943V40.1024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M227.572 40.1024H239.611V36.8965H231.46V21.5234H227.572V40.1024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M243.202 40.1024H255.51V36.8965H247.09V32.2228H255.034V29.1971H247.09V24.7294H255.51V21.5234H243.202V40.1024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M267.792 40.4501C269.295 40.4501 270.629 40.1625 271.797 39.5874C272.973 39.0123 273.921 38.2184 274.642 37.2055C275.363 36.1926 275.784 35.0296 275.904 33.7163L275.917 33.5875H272.131L272.106 33.7034C271.943 34.4244 271.664 35.0425 271.269 35.5575C270.874 36.0725 270.385 36.4673 269.801 36.742C269.217 37.0167 268.552 37.154 267.805 37.154C266.818 37.154 265.96 36.9008 265.23 36.3944C264.501 35.8793 263.938 35.1455 263.544 34.1927C263.149 33.2399 262.951 32.1112 262.951 30.8065V30.7936C262.951 29.4803 263.149 28.3559 263.544 27.4203C263.938 26.4761 264.496 25.7508 265.217 25.2444C265.947 24.7294 266.805 24.4719 267.792 24.4719C268.565 24.4719 269.243 24.6135 269.827 24.8967C270.419 25.18 270.904 25.5791 271.282 26.0941C271.668 26.6006 271.93 27.1971 272.067 27.8838L272.119 28.0769H275.904L275.891 27.9482C275.771 26.6349 275.35 25.4718 274.629 24.459C273.917 23.4375 272.973 22.635 271.797 22.0513C270.629 21.4676 269.295 21.1758 267.792 21.1758C265.99 21.1758 264.428 21.562 263.106 22.3346C261.784 23.1071 260.763 24.2101 260.042 25.6435C259.329 27.077 258.973 28.7937 258.973 30.7936V30.8065C258.973 32.8064 259.329 34.5274 260.042 35.9695C260.763 37.4029 261.784 38.5102 263.106 39.2913C264.428 40.0638 265.99 40.4501 267.792 40.4501Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M283.499 40.1024H287.388V24.7294H292.795V21.5234H278.092V24.7294H283.499V40.1024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M296.245 40.1024H300.133V21.5234H296.245V40.1024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M312.866 40.4501C314.711 40.4501 316.299 40.0595 317.63 39.2784C318.969 38.4973 319.999 37.3858 320.72 35.9437C321.449 34.5017 321.814 32.7936 321.814 30.8194V30.7936C321.814 28.8194 321.449 27.1156 320.72 25.6821C319.999 24.2401 318.969 23.1285 317.63 22.3474C316.29 21.5663 314.703 21.1758 312.866 21.1758C311.037 21.1758 309.454 21.5663 308.115 22.3474C306.776 23.1285 305.737 24.2401 304.999 25.6821C304.269 27.1156 303.904 28.8194 303.904 30.7936V30.8194C303.904 32.7936 304.269 34.5017 304.999 35.9437C305.728 37.3858 306.763 38.4973 308.102 39.2784C309.441 40.0595 311.029 40.4501 312.866 40.4501ZM312.866 37.154C311.844 37.154 310.96 36.8965 310.213 36.3815C309.467 35.8665 308.887 35.1369 308.475 34.1927C308.072 33.2399 307.87 32.1155 307.87 30.8194V30.7936C307.87 29.4889 308.076 28.3645 308.488 27.4203C308.9 26.4761 309.479 25.7508 310.226 25.2444C310.973 24.7294 311.853 24.4719 312.866 24.4719C313.879 24.4719 314.758 24.7294 315.505 25.2444C316.252 25.7594 316.827 26.489 317.23 27.4332C317.642 28.3774 317.848 29.4975 317.848 30.7936V30.8194C317.848 32.1069 317.647 33.227 317.243 34.1798C316.84 35.124 316.265 35.8579 315.518 36.3815C314.78 36.8965 313.896 37.154 312.866 37.154Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M325.598 40.1024H329.448V27.9868H331.135L327.98 25.7336L337.997 40.1024H341.345V21.5234H337.495V33.5618H335.808L338.976 35.8278L328.972 21.5234H325.598V40.1024Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M352.519 40.4501C354.082 40.4501 355.421 40.214 356.537 39.7419C357.652 39.2613 358.507 38.5832 359.099 37.7076C359.7 36.8235 360 35.7849 360 34.5918V34.5789C360 33.609 359.803 32.7807 359.408 32.094C359.013 31.3988 358.399 30.8237 357.567 30.3687C356.734 29.9138 355.665 29.5576 354.361 29.3001L352.404 28.9009C351.331 28.6778 350.545 28.3859 350.047 28.0254C349.55 27.6649 349.301 27.1885 349.301 26.5963V26.5834C349.301 26.1371 349.429 25.7465 349.687 25.4117C349.953 25.077 350.322 24.8152 350.794 24.6264C351.275 24.4289 351.841 24.3302 352.494 24.3302C353.146 24.3302 353.717 24.4246 354.206 24.6135C354.704 24.8023 355.103 25.0684 355.404 25.4117C355.704 25.7551 355.889 26.1714 355.957 26.6606L355.97 26.8152H359.639L359.627 26.5834C359.567 25.5105 359.24 24.5663 358.648 23.7508C358.064 22.9354 357.253 22.3045 356.215 21.8582C355.176 21.4032 353.936 21.1758 352.494 21.1758C351.129 21.1758 349.91 21.4118 348.837 21.8839C347.773 22.356 346.936 23.0169 346.326 23.8667C345.726 24.7079 345.421 25.695 345.412 26.828V26.8409C345.412 28.24 345.872 29.3816 346.79 30.2657C347.708 31.1498 349.09 31.7764 350.936 32.1455L352.906 32.5447C354.056 32.7764 354.876 33.0725 355.365 33.433C355.863 33.7936 356.112 34.2828 356.112 34.9008V34.9137C356.112 35.3858 355.97 35.8021 355.687 36.1626C355.404 36.5231 355 36.8021 354.477 36.9995C353.953 37.1969 353.331 37.2956 352.61 37.2956C351.906 37.2956 351.275 37.1969 350.717 36.9995C350.168 36.8021 349.717 36.5317 349.365 36.1884C349.022 35.8364 348.811 35.4244 348.734 34.9523L348.708 34.8107H345.026L345.039 35.0167C345.116 36.1497 345.464 37.124 346.082 37.9394C346.708 38.7462 347.567 39.3685 348.657 39.8063C349.756 40.2355 351.043 40.4501 352.519 40.4501Z",
        fill: "white"
    })), $0422a6ce4ea03acc$var$Nz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 172 152",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M154.516 34.2437L108.393 41.2322L152.478 31.5007C152.565 31.4746 152.646 31.4308 152.717 31.3718C152.787 31.3128 152.846 31.2398 152.889 31.157C152.933 31.0742 152.96 30.9832 152.97 30.8892C152.98 30.7953 152.971 30.7003 152.946 30.6097C152.897 30.4469 152.795 30.3073 152.657 30.2148C152.52 30.1223 152.356 30.0828 152.194 30.103L106.038 39.8869L149.456 27.3775C149.542 27.3533 149.623 27.3114 149.693 27.2541C149.763 27.1968 149.822 27.1253 149.866 27.0439C149.909 26.9625 149.937 26.8727 149.947 26.78C149.957 26.6873 149.949 26.5934 149.923 26.5039C149.876 26.3212 149.762 26.1654 149.606 26.0705C149.449 25.9755 149.263 25.9492 149.088 25.9972L105.487 38.2271L146.033 23.726C146.205 23.6657 146.348 23.5362 146.429 23.3658C146.511 23.1954 146.524 22.9982 146.467 22.8175C146.409 22.6368 146.285 22.4874 146.122 22.4022C145.96 22.317 145.771 22.303 145.598 22.3632V22.3632L102.932 37.0216L141.958 20.057C142.126 19.9852 142.26 19.8464 142.331 19.6711C142.401 19.4958 142.402 19.2984 142.334 19.1223C142.265 18.9462 142.132 18.8059 141.965 18.7322C141.797 18.6584 141.609 18.6574 141.44 18.7292L99.8931 36.3926L137.065 16.5802C137.222 16.4852 137.337 16.3288 137.384 16.1453C137.431 15.9618 137.406 15.7663 137.316 15.6018C137.229 15.452 137.093 15.3396 136.934 15.2851C136.775 15.2306 136.602 15.2376 136.447 15.3048L97.8725 35.2745L131.822 13.4529C131.952 13.3549 132.047 13.2129 132.089 13.0507C132.132 12.8885 132.12 12.7159 132.055 12.5618C132.009 12.4795 131.947 12.4077 131.874 12.3506C131.801 12.2936 131.717 12.2525 131.629 12.2297C131.54 12.2069 131.448 12.2029 131.358 12.2179C131.268 12.233 131.181 12.2667 131.104 12.3172V12.3172L94.7665 35.0299L125.91 10.5701C125.983 10.515 126.044 10.4451 126.09 10.3646C126.136 10.2842 126.167 10.1948 126.179 10.1019C126.192 10.0089 126.186 9.9143 126.163 9.82365C126.139 9.73301 126.099 9.64819 126.044 9.57425C125.992 9.49699 125.926 9.4314 125.85 9.38142C125.774 9.33145 125.689 9.29812 125.6 9.28343C125.511 9.26875 125.42 9.27301 125.333 9.29596C125.246 9.31892 125.164 9.36009 125.092 9.41701V9.41701L92.128 34.5931L119.548 7.98437C119.657 7.84522 119.714 7.66888 119.707 7.48892C119.7 7.30896 119.63 7.13796 119.51 7.00846C119.391 6.87897 119.23 6.80003 119.058 6.78669C118.886 6.77334 118.716 6.82652 118.579 6.93609V6.93609L89.523 34.331L112.785 5.74805C112.904 5.6044 112.964 5.41694 112.952 5.22691C112.939 5.03687 112.855 4.85982 112.718 4.73471C112.581 4.6096 112.401 4.54668 112.22 4.55979C112.038 4.57289 111.869 4.66095 111.749 4.8046V4.8046L87.6694 33.4225L106.155 4.01839C106.206 3.94038 106.241 3.85274 106.259 3.76048C106.277 3.66822 106.278 3.57313 106.261 3.48066C106.243 3.38818 106.209 3.30013 106.16 3.22152C106.11 3.14292 106.046 3.0753 105.972 3.02253C105.897 2.96976 105.813 2.93287 105.725 2.91397C105.637 2.89507 105.546 2.89453 105.458 2.91237C105.369 2.93022 105.285 2.9661 105.21 3.01798C105.135 3.06985 105.07 3.1367 105.02 3.21471L84.9809 33.7021L99.0915 2.60322C99.1504 2.42479 99.1396 2.22926 99.0614 2.05913C98.9832 1.88901 98.844 1.75805 98.6741 1.69471C98.5298 1.64078 98.3725 1.63902 98.2272 1.68969C98.0818 1.74037 97.957 1.84057 97.8725 1.97425L83.1941 32.7586L92.3618 1.62483C92.3816 1.53534 92.3844 1.44266 92.3699 1.35207C92.3554 1.26147 92.324 1.17476 92.2775 1.09687C92.231 1.01898 92.1702 0.951455 92.0987 0.898149C92.0272 0.844843 91.9464 0.806804 91.8609 0.786207C91.7062 0.752708 91.5453 0.776152 91.4053 0.852567C91.2653 0.928982 91.1549 1.05367 91.0927 1.20552L81.0733 32.514L85.6822 1.06575C85.711 0.878084 85.6674 0.686142 85.5609 0.532146C85.4544 0.378151 85.2938 0.274717 85.1144 0.244598C84.9351 0.214479 84.7516 0.260143 84.6044 0.371544C84.4572 0.482945 84.3584 0.650957 84.3296 0.838621V0.838621L78.8857 33.0382L78.7187 0.716322C78.7187 0.526342 78.6466 0.344142 78.5182 0.209806C78.3898 0.0754696 78.2156 0 78.0341 0C77.8525 0 77.6783 0.0754696 77.5499 0.209806C77.4215 0.344142 77.3494 0.526342 77.3494 0.716322L76.8317 33.2478L71.6049 0.786207C71.5701 0.606484 71.4706 0.447596 71.3272 0.34228C71.1837 0.236963 71.007 0.193238 70.8336 0.220113C70.6602 0.246989 70.5033 0.342417 70.3951 0.486739C70.287 0.63106 70.2359 0.813282 70.2523 0.995862L74.711 33.5274L64.2741 1.24046C64.2084 1.07636 64.0868 0.943671 63.9329 0.86822C63.7789 0.792768 63.6036 0.779952 63.4411 0.832264C63.2786 0.884577 63.1405 0.998276 63.0537 1.15123C62.9669 1.30419 62.9376 1.48546 62.9715 1.65977L72.4733 33.5274L57.1102 2.07908C57.0194 1.91461 56.8698 1.7946 56.6945 1.74546C56.5191 1.69631 56.3323 1.72205 56.175 1.81701C56.0318 1.90799 55.9244 2.04962 55.8723 2.21627C55.8202 2.38292 55.8269 2.56357 55.8911 2.72552L70.3358 33.8244L49.9296 3.38943C49.8781 3.31142 49.8123 3.24479 49.7362 3.19336C49.6601 3.14192 49.575 3.10668 49.4858 3.08964C49.3967 3.07261 49.3052 3.07411 49.2165 3.09407C49.1279 3.11403 49.044 3.15206 48.9694 3.20598C48.8948 3.25989 48.8312 3.32865 48.782 3.40831C48.7328 3.48798 48.6992 3.577 48.6829 3.67028C48.6666 3.76357 48.668 3.8593 48.6871 3.952C48.7062 4.0447 48.7425 4.13257 48.7941 4.21057V4.21057L67.8477 33.7894L43.0329 5.0492C42.9726 4.97922 42.8997 4.92235 42.8184 4.88185C42.7371 4.84134 42.6489 4.81799 42.559 4.81312C42.4691 4.80825 42.3791 4.82197 42.2942 4.85348C42.2093 4.88499 42.1312 4.93369 42.0644 4.99678C41.9975 5.05988 41.9431 5.13614 41.9044 5.22121C41.8657 5.30628 41.8434 5.3985 41.8387 5.49259C41.8341 5.58669 41.8472 5.68082 41.8773 5.76962C41.9074 5.85842 41.9539 5.94014 42.0143 6.01012V6.01012L65.6601 34.2961L36.2531 7.18069C36.118 7.05326 35.9401 6.9872 35.7584 6.99703C35.5768 7.00686 35.4063 7.09178 35.2845 7.2331C35.1628 7.37443 35.0996 7.56059 35.109 7.75063C35.1184 7.94066 35.1996 8.11901 35.3346 8.24644V8.24644L62.4205 33.9991L30.1746 9.53931C30.1029 9.48239 30.021 9.44122 29.9337 9.41826C29.8464 9.39531 29.7556 9.39104 29.6667 9.40573C29.5778 9.42042 29.4927 9.45375 29.4164 9.50372C29.3401 9.5537 29.2742 9.61929 29.2228 9.69655C29.1675 9.77049 29.1271 9.85531 29.1038 9.94595C29.0806 10.0366 29.0751 10.1312 29.0875 10.2242C29.1 10.3171 29.1302 10.4065 29.1764 10.4869C29.2226 10.5674 29.2838 10.6373 29.3564 10.6924L60.1327 34.663L24.4135 12.2823C24.3372 12.2322 24.2521 12.1987 24.1632 12.1839C24.0743 12.169 23.9834 12.1732 23.8961 12.196C23.8087 12.2189 23.7267 12.26 23.6549 12.3168C23.5831 12.3737 23.5231 12.4451 23.4783 12.5269C23.3847 12.6872 23.3549 12.8796 23.3955 13.0626C23.4361 13.2456 23.5438 13.4046 23.6954 13.5053L58.0787 35.6239L18.9529 15.4446C18.7929 15.3725 18.6127 15.3669 18.4488 15.4289C18.285 15.491 18.15 15.616 18.0712 15.7786C17.9925 15.9412 17.9759 16.129 18.0249 16.304C18.0739 16.4789 18.1848 16.6276 18.335 16.72L55.123 36.2179L14.1603 18.7467C14.0769 18.7111 13.9877 18.6931 13.8977 18.6936C13.8077 18.6941 13.7187 18.7131 13.6358 18.7496C13.5528 18.7861 13.4775 18.8394 13.4142 18.9063C13.3509 18.9733 13.3009 19.0526 13.2669 19.1398C13.2329 19.227 13.2156 19.3203 13.2161 19.4145C13.2166 19.5086 13.2348 19.6017 13.2697 19.6885C13.3046 19.7753 13.3555 19.8541 13.4195 19.9203C13.4835 19.9865 13.5593 20.0389 13.6426 20.0745V20.0745L53.4531 37.5283L9.83523 22.503C9.7497 22.4732 9.6594 22.4613 9.56948 22.4679C9.47955 22.4746 9.39177 22.4998 9.31113 22.542C9.2305 22.5841 9.1586 22.6425 9.09953 22.7138C9.04046 22.785 8.99539 22.8678 8.96688 22.9572C8.93837 23.0467 8.92699 23.1412 8.93338 23.2353C8.93977 23.3294 8.96381 23.4212 9.00413 23.5056C9.08555 23.676 9.22833 23.8055 9.40105 23.8657V23.8657L51.3991 38.7687L6.12804 26.5389C5.95863 26.5065 5.78378 26.5421 5.63834 26.6386C5.4929 26.7351 5.38756 26.8854 5.34332 27.0595C5.29908 27.2336 5.31918 27.4188 5.39963 27.5781C5.48007 27.7374 5.61495 27.8592 5.77736 27.9191L49.5956 40.149L3.10552 30.6621C3.0189 30.6357 2.92816 30.6274 2.83848 30.6377C2.7488 30.648 2.66194 30.6767 2.58286 30.7221C2.50377 30.7676 2.43402 30.8288 2.37757 30.9025C2.32112 30.9761 2.27909 31.0606 2.25387 31.1513C2.22865 31.2419 2.22074 31.3368 2.23059 31.4307C2.24044 31.5245 2.26786 31.6154 2.31127 31.6981C2.35469 31.7808 2.41326 31.8538 2.48364 31.9129C2.55401 31.9719 2.63482 32.0159 2.72144 32.0423H2.82164L46.356 41.337L0.934646 34.6979C0.760135 34.6807 0.585968 34.7342 0.448026 34.8474C0.310083 34.9605 0.218873 35.1247 0.193185 35.3061C0.167498 35.4875 0.20929 35.6723 0.309952 35.8225C0.410614 35.9726 0.562478 36.0766 0.734258 36.1131L33.4143 41.1972L77.7168 46.6308L115.557 41.931L154.716 35.6589C154.806 35.6501 154.894 35.6228 154.974 35.5784C155.053 35.5341 155.124 35.4736 155.182 35.4005C155.239 35.3274 155.282 35.2431 155.308 35.1525C155.334 35.0619 155.343 34.9668 155.334 34.8726C155.326 34.7784 155.299 34.6868 155.257 34.6032C155.215 34.5196 155.157 34.4456 155.087 34.3855C155.017 34.3254 154.937 34.2804 154.85 34.253C154.763 34.2257 154.672 34.2166 154.582 34.2262L154.516 34.2437Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M167.41 138.023C167.272 137.861 167.108 137.725 166.926 137.621C167.264 137.587 167.578 137.426 167.811 137.167C168.016 136.921 168.124 136.602 168.111 136.276C168.112 136.017 168.042 135.762 167.911 135.542C167.793 135.334 167.61 135.173 167.393 135.088C167.052 134.986 166.696 134.945 166.341 134.966H164.671V139.665H165.49V137.918H165.657C165.79 137.902 165.924 137.902 166.057 137.918C166.145 137.96 166.225 138.02 166.291 138.093C166.441 138.285 166.575 138.495 166.709 138.705L167.276 139.596H168.395L167.844 138.705C167.719 138.464 167.574 138.236 167.41 138.023V138.023ZM166.074 137.115H165.556V135.839H166.108C166.303 135.945 166.522 135.993 166.742 135.979C166.871 135.99 166.99 136.053 167.076 136.154C167.157 136.257 167.198 136.387 167.193 136.521C167.225 136.629 167.225 136.744 167.193 136.853C167.139 136.943 167.056 137.011 166.959 137.045C166.668 137.109 166.371 137.133 166.074 137.115Z",
        fill: "#00ACE4"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M166.258 133.114C165.425 133.11 164.611 133.365 163.917 133.846C163.223 134.327 162.681 135.012 162.359 135.815C162.038 136.618 161.951 137.503 162.11 138.358C162.269 139.213 162.667 139.999 163.253 140.617C163.84 141.235 164.588 141.658 165.404 141.831C166.219 142.004 167.066 141.921 167.836 141.591C168.606 141.261 169.265 140.699 169.731 139.977C170.196 139.255 170.446 138.405 170.449 137.534V137.534C170.451 136.956 170.345 136.383 170.135 135.848C169.926 135.313 169.617 134.826 169.228 134.415C168.839 134.005 168.376 133.679 167.867 133.455C167.357 133.232 166.81 133.116 166.258 133.114ZM166.258 141.308C165.538 141.308 164.834 141.084 164.235 140.666C163.636 140.247 163.17 139.652 162.894 138.956C162.619 138.26 162.547 137.495 162.687 136.756C162.828 136.017 163.174 135.338 163.683 134.806C164.193 134.273 164.841 133.91 165.547 133.763C166.253 133.616 166.985 133.692 167.651 133.98C168.316 134.268 168.884 134.756 169.284 135.383C169.684 136.009 169.898 136.746 169.898 137.499C169.894 138.508 169.509 139.474 168.827 140.187C168.145 140.9 167.222 141.303 166.258 141.308V141.308Z",
        fill: "#00ACE4"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M77.8676 51.1558H78.0346L56.4093 48.6399V48.6574L0 41.8611V141.552L76.4815 151.79L156.153 142.234V41.8611L77.8676 51.1558Z",
        fill: "#00ACE4"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M8.18311 99.6736V67.6663L25.3497 69.8502V76.5067L15.5307 75.2488V81.3637L22.4942 82.2548V88.7191L15.5307 87.8281V100.6L8.18311 99.6736Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M8.48334 68.4701L24.5311 70.4968V75.7381L15.1296 74.5326V81.923L22.0763 82.814V88.0554L15.1296 87.1643V99.9184L8.58353 99.0797V68.2604L8.48334 68.4701ZM7.3645 66.9326V100.128L8.46664 100.268L14.9459 101.089L16.3486 101.264V88.5446L21.9595 89.2609L23.3956 89.4356V81.6958L22.3435 81.5561L16.4488 80.8048V75.9827L24.5311 77.031L25.8503 77.2057V69.2738L24.7816 69.134L8.73382 67.1248L7.3645 66.9501V66.9326Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M25.3486 101.787V78.5679L31.8947 79.4065V102.608L25.3486 101.787Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M26.1864 79.3193L31.48 80.0007V101.857L26.1697 101.176V79.3717L26.1864 79.3193ZM24.9507 77.8342V102.294L26.0194 102.434L31.3464 103.115L32.7157 103.29V78.8301L31.647 78.6903L26.32 78.0089L24.9507 77.8342Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M33.9329 102.94V79.5112L39.5604 80.245L39.7441 82.6211C40.1242 81.9536 40.665 81.4022 41.3127 81.022C41.9603 80.6418 42.692 80.4462 43.4346 80.4547C44.2266 80.4754 45.0102 80.6287 45.7558 80.9089L46.1565 81.0662V87.8625L45.4051 87.6878C44.5436 87.4095 43.6509 87.2509 42.7499 87.2161C41.1969 87.2161 40.4789 87.8625 40.4789 89.2602V103.761L33.9329 102.94Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M34.3166 80.2452L38.7752 80.8043L39.1259 85.2245C39.8607 82.3767 41.2968 81.0838 43.2506 81.0838C43.9745 81.1024 44.6908 81.244 45.3713 81.5031V86.9891C44.4519 86.6865 43.4961 86.5218 42.5325 86.4999C40.4284 86.4999 39.6436 87.653 39.6436 89.1905V103.045L34.3333 102.364V80.2277L34.3166 80.2452ZM33.1143 78.7776V103.517L34.183 103.657L39.51 104.338L40.8793 104.513V89.173C40.8793 88.4567 41.0129 87.7578 42.5492 87.7578C43.3934 87.7881 44.23 87.9349 45.0374 88.1946L46.6238 88.6663V80.5946L45.8055 80.2976C44.9923 79.9819 44.1344 79.8106 43.2673 79.7909C42.0965 79.7742 40.9609 80.2096 40.0778 81.0139V79.6512L39.0758 79.5289L34.5003 78.9523L33.1143 78.7776Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M56.0922 106.086C55.6346 106.083 55.1775 106.054 54.7229 105.998C49.7132 105.369 46.6072 101.98 46.6072 97.3501V95.8301L52.3349 96.5639V97.8219C52.2691 98.4195 52.4326 99.02 52.7895 99.4917C53.1464 99.9634 53.6676 100.268 54.2386 100.338H55.1237C56.0421 100.338 56.4095 99.9883 56.4095 99.0798C56.4095 97.5947 55.0068 96.7386 52.0845 95.0964C49.6297 93.7511 47.0748 91.8467 47.0748 87.9157C47.0748 83.9846 49.5796 81.6959 53.4705 81.6959C53.8929 81.6609 54.3172 81.6609 54.7396 81.6959C59.265 82.2724 62.1707 85.4522 62.1707 89.7851V90.8508L56.7936 90.2568V88.9814C56.7936 87.7934 56.1423 87.1295 54.7897 86.9547H54.3388C53.387 86.9547 53.2033 87.3915 53.2033 88.0205C53.2033 88.929 53.9714 89.6278 56.5431 90.9906C59.6324 92.6329 62.7718 94.9391 62.7718 99.5865C62.7918 100.427 62.6527 101.263 62.3627 102.047C62.0726 102.831 61.6372 103.547 61.0816 104.154C60.526 104.762 59.8612 105.248 59.1253 105.586C58.3893 105.923 57.5969 106.105 56.7936 106.121L56.0922 106.086Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M53.4536 82.2023H54.6727C59.1647 82.7788 61.6863 85.8537 61.6863 89.7848V90.1517L57.1942 89.5751V88.9112C57.1942 87.4611 56.3927 86.4652 54.6393 86.2381H54.1049C52.9694 86.2381 52.435 86.8147 52.435 87.9852C52.435 89.1558 53.4703 90.1342 56.0587 91.4795C59.3985 93.2266 61.9701 95.428 61.9701 99.4988C61.9879 100.254 61.8633 101.005 61.6035 101.709C61.3437 102.414 60.9537 103.058 60.4559 103.605C59.9581 104.151 59.3622 104.59 58.7023 104.896C58.0424 105.202 57.3313 105.368 56.6097 105.387H55.9084C55.4804 105.421 55.0505 105.421 54.6226 105.387C49.6129 104.758 47.0412 101.421 47.0412 97.3848V96.5811L51.5332 97.1577V97.9439C51.4964 98.3296 51.533 98.7192 51.6409 99.0901C51.7489 99.461 51.9259 99.8059 52.1619 100.105C52.3979 100.404 52.6882 100.651 53.0159 100.832C53.3437 101.012 53.7025 101.124 54.0715 101.159H54.9732C56.2257 101.159 56.8936 100.547 56.8936 99.2193C56.8936 97.28 55.2237 96.2666 52.1845 94.6069C49.1453 92.9471 47.4754 91.1126 47.4754 87.8804C47.4754 84.2813 49.8633 82.2023 53.3534 82.2023H53.4536ZM53.7041 81.1016C49.4292 81.1016 46.6571 83.8271 46.6571 88.0901C46.6571 92.3531 49.496 94.5894 51.9841 95.9521L52.1678 96.057L47.7092 95.4804L46.3398 95.3057V97.5246C46.3398 102.417 49.6796 105.998 54.7896 106.662C55.2568 106.688 55.725 106.688 56.1923 106.662C57.0508 106.741 57.9159 106.643 58.738 106.372C59.5602 106.102 60.3233 105.664 60.9839 105.085C61.6445 104.506 62.1896 103.796 62.588 102.997C62.9864 102.197 63.2304 101.323 63.3061 100.425C63.3061 100.163 63.3061 99.9181 63.3061 99.6735C63.3061 95.2183 60.6342 92.8248 57.7787 91.1475L61.7363 91.6542L63.1057 91.8289V90.0818C63.1057 85.3296 59.9663 81.8528 55.0901 81.2239C54.6411 81.1687 54.1896 81.1395 53.7375 81.1365L53.7041 81.1016ZM56.1255 90.1517C54.2051 89.0685 53.821 88.5793 53.821 88.125C53.7878 88.0171 53.7878 87.901 53.821 87.7931C53.9694 87.7578 54.1235 87.7578 54.2719 87.7931H54.6393C55.9585 87.9678 56.0754 88.5793 56.0754 89.1383V90.1866L56.1255 90.1517ZM54.9565 99.9356H54.5057C53.3033 99.7783 52.8358 99.2193 52.8358 97.9963V96.4239C54.7395 97.542 55.6746 98.171 55.6746 99.2018C55.6746 99.7259 55.6746 99.8482 54.9899 99.8482L54.9565 99.9356Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M66.8151 107.116L66.6648 106.784C65.6605 104.285 65.226 101.575 65.3957 98.8695V88.9982L62.9409 88.6488V82.9881L65.7965 83.355V79.4763L72.3425 78.6028V84.1936L75.6823 84.6129V90.1513L72.3425 89.732V99.5683C72.1923 102.1 72.6758 104.629 73.7452 106.906L74.3297 108.042L66.8151 107.116Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M71.5395 79.3717V84.7878L74.8793 85.2071V89.4351L71.5395 89.0158V99.7606C71.4071 102.228 71.8844 104.689 72.9256 106.906L67.3481 106.19C66.4406 103.928 66.0517 101.475 66.2125 99.0268V88.4393L63.357 88.0724V83.7045L66.2125 84.0714V80.0181L71.3725 79.3367L71.5395 79.3717ZM72.7753 77.8691L71.3559 78.0613L66.079 78.7602L64.9768 78.9524V82.6213L63.4739 82.4466L62.1714 82.2719V89.2604L63.2902 89.4002L64.9601 89.6273V99.1666C64.8151 101.816 65.255 104.464 66.2459 106.906L66.5298 107.535H67.1978L72.792 108.252L75.1632 108.654L74.0611 106.505C73.1132 104.457 72.682 102.189 72.8087 99.9179V90.5707L74.7291 90.8153L76.065 90.9901V84.0016L75.0129 83.8618L72.792 83.5822V77.8691H72.7753Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M91.228 106.645L80.5239 107.92V77.6599L90.9608 76.4369C95.5697 75.8953 98.108 78.184 98.108 82.4296V84.6659C98.108 84.6659 97.3398 89.9073 94.3841 90.7808C97.4567 91.1827 98.5422 95.9174 98.5422 95.9174V98.8351C98.5422 103.203 95.9037 106.086 91.228 106.645ZM92.3802 83.7748C92.3802 82.2723 91.7624 81.3813 90.1426 81.5735L86.6525 82.0102V89.785L89.8921 89.4355C90.2254 89.431 90.5546 89.3578 90.8609 89.2201C91.1672 89.0824 91.4446 88.8829 91.6772 88.6331C91.9098 88.3832 92.0931 88.0879 92.2166 87.7639C92.3401 87.44 92.4013 87.0937 92.3969 86.745C92.4052 86.6578 92.4052 86.57 92.3969 86.4829L92.3802 83.7748ZM92.3802 96.2493C92.3802 94.5022 91.5286 93.7335 89.9422 93.9082L86.6024 94.2925V102.015L90.1927 101.665C90.4843 101.661 90.7723 101.596 91.0401 101.475C91.3079 101.354 91.5503 101.179 91.7534 100.96C91.9566 100.741 92.1165 100.482 92.224 100.199C92.3316 99.915 92.3847 99.612 92.3802 99.3068C92.3885 99.2197 92.3885 99.1319 92.3802 99.0447V96.2493Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M108.361 104.897C103.902 105.421 100.963 102.94 100.963 98.1184V91.1823C100.848 89.0005 101.561 86.8595 102.946 85.224C104.331 83.5886 106.277 82.5906 108.361 82.4466C109.145 82.2725 109.954 82.2618 110.742 82.4153C111.53 82.5688 112.281 82.8833 112.953 83.341C113.624 83.7986 114.203 84.3904 114.656 85.0823C115.109 85.7743 115.426 86.5529 115.591 87.3735C115.728 88.0512 115.756 88.7478 115.675 89.4351V96.4236C115.757 98.5563 115.038 100.638 113.67 102.222C112.303 103.806 110.397 104.766 108.361 104.897V104.897ZM110.364 89.0682C110.426 88.5382 110.285 88.0041 109.972 87.5821C109.66 87.1601 109.201 86.8842 108.695 86.8145C108.512 86.7883 108.326 86.7883 108.143 86.8145C107.492 86.8724 106.888 87.1964 106.463 87.7162C106.038 88.2361 105.826 88.91 105.872 89.5924V98.328C105.832 98.6441 105.865 98.9655 105.967 99.2659C106.069 99.5662 106.238 99.8368 106.46 100.055C106.682 100.274 106.95 100.434 107.243 100.522C107.536 100.611 107.844 100.625 108.143 100.564C108.784 100.489 109.373 100.159 109.786 99.6413C110.2 99.1239 110.407 98.4595 110.364 97.7864V89.0682Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M125.528 102.87C121.069 103.395 118.13 100.914 118.13 96.0916V89.1031C118.043 86.9408 118.768 84.8286 120.151 83.2188C121.533 81.609 123.463 80.6294 125.528 80.4898C127.109 80.1432 128.756 80.4675 130.109 81.3913C131.462 82.3151 132.408 83.7629 132.742 85.4167C132.875 86.0591 132.908 86.7198 132.842 87.3734V94.3619C132.938 96.5017 132.223 98.5947 130.854 100.187C129.485 101.78 127.571 102.744 125.528 102.87V102.87ZM127.531 87.0415C127.571 86.7255 127.539 86.404 127.437 86.1036C127.335 85.8033 127.166 85.5327 126.944 85.3142C126.722 85.0957 126.454 84.9355 126.161 84.847C125.868 84.7585 125.559 84.7442 125.26 84.8052C124.609 84.8631 124.005 85.1871 123.58 85.7069C123.155 86.2268 122.943 86.9007 122.989 87.5831V96.3187C122.949 96.5855 122.961 96.8581 123.024 97.12C123.087 97.3819 123.2 97.6279 123.356 97.8431C123.512 98.0584 123.707 98.2386 123.931 98.3729C124.155 98.5073 124.403 98.593 124.659 98.6249C124.885 98.6686 125.118 98.6686 125.344 98.6249C125.985 98.55 126.573 98.2194 126.987 97.7019C127.4 97.1845 127.607 96.5201 127.565 95.847L127.531 87.0415Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M145.999 100.18L142.659 91.8467L140.655 95.7253V100.827L135.278 101.438V71.1607L140.589 70.5317V88.8591L145.465 78.3763L150.641 77.7648L145.966 87.4614L151.176 99.569L145.999 100.18Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M29.0576 67.946L30.1263 71.0559L32.5477 71.4054L30.7943 72.9603L31.529 75.9129L29.0576 74.0435L26.5694 75.2141L27.3042 72.4711L25.5508 70.4444L27.9721 70.7414L29.0576 67.946Z",
        fill: "white"
    })), $0422a6ce4ea03acc$var$Pz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 170 150",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_50221_35656)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M78.2826 0H77.8576C74.6865 0.183333 0.0172589 4.8 0.0172589 44.05V136.367C0.0172589 138.333 -0.309664 140 1.65187 140.283L76.1413 149.667H77.073L154.505 140.833C156.466 140.6 156.139 138.917 156.139 134.583V46.3667C156.074 4.8 81.4538 0.183333 78.2826 0Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M152.885 35.6835L107.737 42.3502L150.891 33.0668C150.976 33.0419 151.055 33.0002 151.124 32.9439C151.193 32.8876 151.251 32.818 151.293 32.739C151.336 32.66 151.363 32.5732 151.372 32.4835C151.382 32.3939 151.374 32.3033 151.349 32.2168C151.3 32.0616 151.201 31.9284 151.066 31.8402C150.932 31.752 150.772 31.7143 150.613 31.7335L105.432 41.0668L147.932 29.1335C148.017 29.1105 148.096 29.0704 148.165 29.0158C148.234 28.9611 148.291 28.893 148.334 28.8153C148.376 28.7376 148.403 28.652 148.413 28.5636C148.423 28.4751 148.415 28.3855 148.39 28.3002C148.344 28.1259 148.232 27.9772 148.079 27.8867C147.926 27.7961 147.744 27.771 147.573 27.8168L104.893 39.4835L144.581 25.6502C144.751 25.5927 144.89 25.4691 144.97 25.3066C145.05 25.1441 145.063 24.9559 145.006 24.7835C144.95 24.6111 144.829 24.4686 144.669 24.3874C144.51 24.3061 144.326 24.2927 144.156 24.3502V24.3502L102.392 38.3335L140.593 22.1502C140.758 22.0817 140.889 21.9492 140.958 21.782C141.027 21.6148 141.028 21.4265 140.961 21.2585C140.894 21.0905 140.764 20.9567 140.6 20.8863C140.436 20.816 140.251 20.815 140.086 20.8835L99.417 37.7335L135.804 18.8335C135.957 18.7429 136.07 18.5936 136.116 18.4186C136.162 18.2436 136.138 18.0571 136.049 17.9002C135.964 17.7572 135.831 17.65 135.675 17.598C135.519 17.5461 135.35 17.5527 135.199 17.6168L97.4391 36.6668L130.671 15.8502C130.799 15.7567 130.891 15.6213 130.933 15.4665C130.975 15.3118 130.963 15.1471 130.9 15.0002C130.854 14.9216 130.794 14.8531 130.722 14.7987C130.651 14.7443 130.569 14.7051 130.482 14.6833C130.395 14.6616 130.305 14.6578 130.217 14.6721C130.128 14.6865 130.044 14.7187 129.968 14.7668V14.7668L94.3987 36.4335L124.884 13.1002C124.955 13.0476 125.015 12.9809 125.061 12.9041C125.106 12.8274 125.135 12.7421 125.148 12.6535C125.16 12.5648 125.154 12.4746 125.132 12.3881C125.109 12.3016 125.069 12.2207 125.015 12.1502C124.965 12.0765 124.9 12.0139 124.826 11.9662C124.751 11.9186 124.668 11.8868 124.581 11.8728C124.494 11.8587 124.405 11.8628 124.319 11.8847C124.234 11.9066 124.154 11.9459 124.083 12.0002V12.0002L91.816 36.0168L118.656 10.6335C118.763 10.5008 118.819 10.3326 118.812 10.1609C118.805 9.98921 118.737 9.82608 118.62 9.70255C118.503 9.57902 118.345 9.50372 118.177 9.49099C118.009 9.47826 117.842 9.52899 117.708 9.63351V9.63351L89.266 35.7668L112.036 8.50018C112.153 8.36315 112.212 8.18432 112.2 8.00304C112.188 7.82175 112.105 7.65286 111.971 7.53351C111.836 7.41416 111.661 7.35414 111.483 7.36664C111.305 7.37914 111.14 7.46315 111.023 7.60018V7.60018L87.4516 34.9002L105.547 6.85018C105.596 6.77576 105.631 6.69216 105.648 6.60415C105.666 6.51613 105.667 6.42543 105.65 6.33721C105.633 6.24899 105.6 6.165 105.551 6.09001C105.503 6.01502 105.44 5.95052 105.367 5.90018C105.294 5.84984 105.212 5.81465 105.126 5.79662C105.039 5.77859 104.95 5.77807 104.864 5.79509C104.777 5.81212 104.695 5.84635 104.621 5.89584C104.548 5.94532 104.485 6.0091 104.435 6.08351L84.8199 35.1668L98.6324 5.50018C98.69 5.32996 98.6794 5.14344 98.6029 4.98115C98.5264 4.81886 98.3901 4.69393 98.2237 4.63351C98.0825 4.58207 97.9285 4.58038 97.7863 4.62873C97.644 4.67707 97.5218 4.77265 97.4391 4.90018L83.0708 34.2668L92.0449 4.56685C92.0643 4.48148 92.0669 4.39306 92.0528 4.30665C92.0386 4.22023 92.0079 4.1375 91.9623 4.0632C91.9168 3.9889 91.8573 3.92448 91.7874 3.87363C91.7174 3.82278 91.6382 3.78649 91.5545 3.76685C91.4032 3.73489 91.2456 3.75725 91.1086 3.83015C90.9716 3.90305 90.8635 4.02199 90.8026 4.16685L80.9949 34.0335L85.5064 4.03351C85.5346 3.85449 85.4919 3.67139 85.3877 3.52449C85.2834 3.37758 85.1262 3.27891 84.9507 3.25018C84.7751 3.22145 84.5955 3.26501 84.4514 3.37128C84.3073 3.47755 84.2106 3.63782 84.1824 3.81685V3.81685L78.8535 34.5335L78.6901 3.70018C78.6901 3.51895 78.6195 3.34514 78.4938 3.21699C78.3681 3.08884 78.1976 3.01685 78.0199 3.01685C77.8421 3.01685 77.6717 3.08884 77.546 3.21699C77.4203 3.34514 77.3497 3.51895 77.3497 3.70018L76.843 34.7335L71.7266 3.76685C71.6925 3.5954 71.5952 3.44383 71.4547 3.34336C71.3142 3.2429 71.1413 3.20118 70.9716 3.22682C70.8019 3.25246 70.6483 3.34349 70.5424 3.48117C70.4365 3.61884 70.3865 3.79267 70.4026 3.96685L74.767 35.0002L64.5507 4.20018C64.4864 4.04364 64.3674 3.91706 64.2167 3.84508C64.0659 3.77311 63.8944 3.76088 63.7353 3.81078C63.5762 3.86069 63.4411 3.96915 63.3561 4.11506C63.2711 4.26097 63.2425 4.4339 63.2757 4.60018L72.5766 35.0002L57.5381 5.00018C57.4493 4.84328 57.3029 4.7288 57.1312 4.68192C56.9596 4.63504 56.7767 4.65959 56.6228 4.75018C56.4825 4.83697 56.3774 4.97208 56.3264 5.13105C56.2755 5.29003 56.282 5.46236 56.3449 5.61685L70.4843 35.2835L50.5093 6.25018C50.4589 6.17576 50.3945 6.11221 50.32 6.06314C50.2455 6.01407 50.1622 5.98045 50.0749 5.9642C49.9876 5.94795 49.8981 5.94939 49.8113 5.96843C49.7246 5.98747 49.6424 6.02374 49.5694 6.07518C49.4964 6.12661 49.4341 6.1922 49.386 6.2682C49.3378 6.3442 49.3049 6.42911 49.2889 6.5181C49.273 6.60709 49.2744 6.69841 49.2931 6.78684C49.3117 6.87528 49.3473 6.9591 49.3978 7.03351V7.03351L68.0487 35.2502L43.7583 7.83351C43.6993 7.76676 43.628 7.71251 43.5484 7.67387C43.4688 7.63523 43.3825 7.61295 43.2945 7.60831C43.2064 7.60367 43.1183 7.61675 43.0353 7.64681C42.9522 7.67687 42.8757 7.72332 42.8103 7.78351C42.7448 7.8437 42.6916 7.91645 42.6537 7.9976C42.6158 8.07876 42.5939 8.16673 42.5894 8.25649C42.5848 8.34625 42.5977 8.43605 42.6272 8.52076C42.6566 8.60547 42.7022 8.68342 42.7612 8.75018V8.75018L65.9074 35.7335L37.1218 9.86685C36.9896 9.74529 36.8154 9.68227 36.6376 9.69164C36.4598 9.70102 36.2929 9.78203 36.1737 9.91685C36.0545 10.0517 35.9927 10.2292 36.0019 10.4105C36.0111 10.5918 36.0905 10.762 36.2228 10.8835V10.8835L62.7362 35.4502L31.1718 12.1168C31.1016 12.0625 31.0214 12.0233 30.936 12.0014C30.8505 11.9795 30.7616 11.9754 30.6746 11.9894C30.5876 12.0034 30.5042 12.0352 30.4295 12.0829C30.3549 12.1306 30.2904 12.1931 30.2401 12.2668C30.186 12.3374 30.1464 12.4183 30.1236 12.5048C30.1009 12.5912 30.0954 12.6815 30.1077 12.7702C30.1199 12.8588 30.1494 12.9441 30.1947 13.0208C30.2399 13.0975 30.2998 13.1642 30.3708 13.2168L60.4968 36.0835L25.5324 14.7335C25.4578 14.6857 25.3744 14.6538 25.2874 14.6396C25.2003 14.6255 25.1114 14.6294 25.0259 14.6512C24.9404 14.673 24.8601 14.7122 24.7898 14.7664C24.7196 14.8207 24.6608 14.8889 24.617 14.9668C24.5253 15.1197 24.4962 15.3033 24.5359 15.4778C24.5757 15.6524 24.6811 15.8041 24.8295 15.9002L58.4862 37.0002L20.1872 17.7502C20.0306 17.6814 19.8541 17.676 19.6938 17.7352C19.5334 17.7944 19.4013 17.9137 19.3242 18.0688C19.2471 18.2239 19.2309 18.4031 19.2788 18.57C19.3268 18.7368 19.4354 18.8787 19.5824 18.9668L55.593 37.5668L15.4958 20.9002C15.4143 20.8663 15.3269 20.849 15.2388 20.8495C15.1508 20.85 15.0636 20.8682 14.9824 20.903C14.9012 20.9378 14.8275 20.9886 14.7656 21.0525C14.7036 21.1163 14.6546 21.192 14.6213 21.2752C14.588 21.3583 14.5712 21.4474 14.5716 21.5372C14.5721 21.627 14.5899 21.7159 14.6241 21.7987C14.6582 21.8815 14.7081 21.9566 14.7707 22.0198C14.8333 22.0829 14.9075 22.1329 14.9891 22.1668V22.1668L53.9583 38.8168L11.2622 24.4835C11.1785 24.4551 11.0901 24.4437 11.002 24.4501C10.914 24.4565 10.8281 24.4804 10.7492 24.5207C10.6702 24.5609 10.5998 24.6166 10.542 24.6846C10.4842 24.7526 10.4401 24.8315 10.4122 24.9168C10.3843 25.0022 10.3731 25.0923 10.3794 25.1821C10.3856 25.2718 10.4092 25.3594 10.4486 25.4399C10.5283 25.6025 10.6681 25.726 10.8372 25.7835V25.7835L51.9478 40.0002L7.63334 28.3335C7.4675 28.3026 7.29634 28.3366 7.15398 28.4286C7.01161 28.5207 6.9085 28.6641 6.86519 28.8302C6.82188 28.9963 6.84156 29.1729 6.92031 29.3249C6.99905 29.4769 7.13108 29.593 7.29007 29.6502L50.1824 41.3168L4.67468 32.2668C4.58989 32.2417 4.50107 32.2338 4.41328 32.2436C4.3255 32.2534 4.24048 32.2808 4.16306 32.3241C4.08565 32.3675 4.01737 32.4259 3.96211 32.4962C3.90686 32.5664 3.86571 32.6471 3.84103 32.7335C3.81634 32.82 3.8086 32.9105 3.81824 33C3.82788 33.0895 3.85472 33.1762 3.89722 33.2552C3.93972 33.3341 3.99705 33.4037 4.06594 33.4601C4.13483 33.5164 4.21393 33.5583 4.29872 33.5835H4.3968L47.0112 42.4502L2.54968 36.1168C2.37886 36.1004 2.20837 36.1515 2.07334 36.2594C1.93832 36.3673 1.84903 36.524 1.82389 36.697C1.79874 36.8701 1.83965 37.0464 1.93819 37.1896C2.03672 37.3328 2.18538 37.432 2.35353 37.4668L34.343 42.3168L77.7093 47.5002L114.75 43.0168L153.081 37.0335C153.17 37.0252 153.255 36.9991 153.334 36.9568C153.412 36.9145 153.481 36.8568 153.537 36.7871C153.593 36.7174 153.636 36.6369 153.661 36.5505C153.687 36.4641 153.695 36.3733 153.686 36.2835C153.678 36.1936 153.652 36.1063 153.611 36.0265C153.57 35.9467 153.513 35.8761 153.445 35.8188C153.376 35.7615 153.297 35.7185 153.213 35.6924C153.128 35.6663 153.039 35.6577 152.951 35.6668L152.885 35.6835Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M165.507 134.684C165.372 134.529 165.211 134.4 165.033 134.3C165.364 134.267 165.671 134.114 165.899 133.867C166.1 133.632 166.206 133.328 166.193 133.017C166.194 132.769 166.126 132.527 165.997 132.317C165.882 132.118 165.703 131.965 165.491 131.884C165.156 131.787 164.808 131.747 164.461 131.767H162.826V136.25H163.627V134.584H163.791C163.921 134.568 164.053 134.568 164.183 134.584C164.269 134.624 164.347 134.68 164.412 134.75C164.559 134.934 164.69 135.134 164.82 135.334L165.376 136.184H166.471L165.932 135.334C165.809 135.105 165.667 134.887 165.507 134.684V134.684ZM164.199 133.817H163.693V132.6H164.232C164.423 132.701 164.638 132.747 164.853 132.734C164.979 132.744 165.096 132.804 165.18 132.9C165.259 132.999 165.3 133.123 165.294 133.25C165.326 133.353 165.326 133.464 165.294 133.567C165.242 133.654 165.161 133.719 165.066 133.75C164.781 133.812 164.49 133.834 164.199 133.817Z",
        fill: "#00ACE4"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M164.379 130C163.564 129.997 162.767 130.24 162.088 130.699C161.409 131.157 160.878 131.811 160.563 132.577C160.248 133.344 160.164 134.188 160.319 135.003C160.475 135.818 160.865 136.568 161.438 137.158C162.012 137.748 162.745 138.151 163.543 138.316C164.341 138.481 165.17 138.401 165.924 138.087C166.678 137.772 167.323 137.236 167.779 136.547C168.234 135.858 168.479 135.047 168.482 134.217V134.217C168.484 133.665 168.38 133.119 168.175 132.608C167.97 132.098 167.668 131.634 167.287 131.242C166.906 130.85 166.453 130.539 165.954 130.326C165.455 130.113 164.92 130.002 164.379 130ZM164.379 137.817C163.674 137.817 162.985 137.604 162.399 137.204C161.813 136.805 161.356 136.238 161.087 135.574C160.817 134.91 160.746 134.179 160.884 133.475C161.021 132.77 161.361 132.122 161.859 131.614C162.358 131.106 162.993 130.76 163.684 130.62C164.375 130.48 165.091 130.552 165.743 130.827C166.394 131.102 166.95 131.567 167.342 132.165C167.733 132.762 167.942 133.465 167.942 134.183C167.938 135.146 167.561 136.067 166.894 136.748C166.227 137.428 165.323 137.812 164.379 137.817V137.817Z",
        fill: "#00ACE4"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M77.8566 51.8166H78.0201L56.8518 49.4166V49.4333L1.63452 42.95V138.05L76.4999 147.817L154.487 138.7V42.95L77.8566 51.8166Z",
        fill: "#00ACE4"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M9.64478 98.1V67.5667L26.4486 69.65V76L16.8371 74.8V80.6333L23.6534 81.4833V87.65L16.8371 86.8V98.9833L9.64478 98.1Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M9.9387 68.3336L25.6474 70.2669V75.2669L16.4445 74.1169V81.1669L23.2445 82.0169V87.0169L16.4445 86.167V98.3336L10.0368 97.5336V68.1336L9.9387 68.3336ZM8.84351 66.8669V98.5336L9.92235 98.667L16.2647 99.4503L17.6377 99.617V87.4836L23.13 88.167L24.5358 88.3336V80.9503L23.506 80.817L17.7358 80.1003V75.5003L25.6474 76.5003L26.9387 76.6669V69.1003L25.8925 68.9669L10.1839 67.0503L8.84351 66.8836V66.8669Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M26.4475 100.116V77.9663L32.8552 78.7663V100.9L26.4475 100.116Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M27.2677 78.683L32.4495 79.333V100.183L27.2514 99.533V78.733L27.2677 78.683ZM26.0581 77.2664V100.6L27.1043 100.733L32.3187 101.383L33.6591 101.55V78.2164L32.6129 78.083L27.3985 77.433L26.0581 77.2664Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M34.8506 101.216V78.8665L40.3592 79.5665L40.5391 81.8331C40.9111 81.1963 41.4405 80.6703 42.0745 80.3076C42.7084 79.945 43.4247 79.7583 44.1515 79.7665C44.9268 79.7862 45.6939 79.9325 46.4237 80.1998L46.816 80.3498V86.8331L46.0804 86.6665C45.2371 86.401 44.3633 86.2497 43.4814 86.2165C41.9612 86.2165 41.2583 86.8331 41.2583 88.1665V102L34.8506 101.216Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M35.226 79.5665L39.5904 80.0998L39.9337 84.3165C40.6529 81.5998 42.0587 80.3665 43.9712 80.3665C44.6799 80.3842 45.381 80.5193 46.0472 80.7665V85.9998C45.1471 85.7112 44.2116 85.5541 43.2683 85.5332C41.2087 85.5332 40.4404 86.6332 40.4404 88.0998V101.316L35.2423 100.667V79.5498L35.226 79.5665ZM34.0491 78.1665V101.766L35.0952 101.9L40.3097 102.55L41.65 102.716V88.0832C41.65 87.3998 41.7808 86.7332 43.2847 86.7332C44.111 86.762 44.9299 86.9021 45.7202 87.1498L47.2731 87.5998V79.8998L46.4722 79.6165C45.6762 79.3153 44.8364 79.152 43.9875 79.1332C42.8415 79.1172 41.7299 79.5326 40.8654 80.2998V78.9998L39.8846 78.8832L35.4058 78.3332L34.0491 78.1665Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M56.5417 104.217C56.0938 104.214 55.6463 104.186 55.2013 104.134C50.2975 103.534 47.2571 100.3 47.2571 95.8836V94.4336L52.8638 95.1336V96.3336C52.7994 96.9037 52.9594 97.4766 53.3087 97.9266C53.6581 98.3765 54.1683 98.6668 54.7273 98.7336H55.5936C56.4927 98.7336 56.8523 98.4003 56.8523 97.5336C56.8523 96.117 55.4792 95.3003 52.6186 93.7336C50.2157 92.4503 47.7148 90.6336 47.7148 86.8836C47.7148 83.1336 50.1667 80.9503 53.9753 80.9503C54.3888 80.917 54.8042 80.917 55.2177 80.9503C59.6475 81.5003 62.4917 84.5336 62.4917 88.667V89.6836L57.2282 89.117V87.9003C57.2282 86.767 56.5907 86.1336 55.2667 85.967H54.8253C53.8936 85.967 53.7138 86.3836 53.7138 86.9836C53.7138 87.8503 54.4657 88.517 56.983 89.817C60.0071 91.3836 63.0802 93.5836 63.0802 98.017C63.0997 98.8186 62.9636 99.6164 62.6796 100.364C62.3957 101.112 61.9695 101.795 61.4257 102.375C60.8818 102.954 60.231 103.418 59.5106 103.74C58.7903 104.062 58.0146 104.235 57.2282 104.25L56.5417 104.217Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M53.9586 81.4333H55.1518C59.549 81.9833 62.0172 84.9166 62.0172 88.6666V89.0166L57.6201 88.4666V87.8333C57.6201 86.45 56.8355 85.5 55.1192 85.2833H54.5961C53.4845 85.2833 52.9615 85.8333 52.9615 86.95C52.9615 88.0666 53.9749 89 56.5086 90.2833C59.7778 91.95 62.2951 94.05 62.2951 97.9333C62.3125 98.6534 62.1906 99.37 61.9362 100.042C61.6819 100.714 61.3002 101.329 60.8129 101.85C60.3256 102.372 59.7423 102.79 59.0963 103.082C58.4503 103.374 57.7543 103.533 57.048 103.55H56.3615C55.9425 103.583 55.5217 103.583 55.1028 103.55C50.199 102.95 47.6817 99.7666 47.6817 95.9166V95.15L52.0788 95.7V96.45C52.0427 96.818 52.0786 97.1896 52.1842 97.5434C52.2898 97.8972 52.4632 98.2262 52.6942 98.5113C52.9252 98.7965 53.2093 99.0321 53.5301 99.2047C53.851 99.3772 54.2021 99.4832 54.5634 99.5166H55.4461C56.672 99.5166 57.3259 98.9333 57.3259 97.6666C57.3259 95.8166 55.6913 94.85 52.7163 93.2666C49.7413 91.6833 48.1067 89.9333 48.1067 86.85C48.1067 83.4166 50.4442 81.4333 53.8605 81.4333H53.9586ZM54.2038 80.3833C50.0192 80.3833 47.3057 82.9833 47.3057 87.05C47.3057 91.1166 50.0845 93.25 52.5201 94.55L52.6999 94.65L48.3355 94.1L46.9951 93.9333V96.05C46.9951 100.717 50.2643 104.133 55.2663 104.767C55.7236 104.791 56.182 104.791 56.6393 104.767C57.4798 104.842 58.3265 104.748 59.1313 104.49C59.9361 104.232 60.6831 103.815 61.3297 103.262C61.9764 102.71 62.5099 102.033 62.8999 101.27C63.29 100.507 63.5288 99.6735 63.6028 98.8166C63.6028 98.5666 63.6028 98.3333 63.6028 98.1C63.6028 93.85 60.9874 91.5666 58.1922 89.9666L62.0663 90.45L63.4067 90.6166V88.95C63.4067 84.4166 60.3336 81.1 55.5605 80.5C55.121 80.4473 54.679 80.4195 54.2365 80.4166L54.2038 80.3833ZM56.574 89.0166C54.6942 87.9833 54.3182 87.5166 54.3182 87.0833C54.2857 86.9803 54.2857 86.8696 54.3182 86.7666C54.4635 86.733 54.6143 86.733 54.7595 86.7666H55.1192C56.4105 86.9333 56.5249 87.5166 56.5249 88.05V89.05L56.574 89.0166ZM55.4297 98.35H54.9884C53.8115 98.2 53.3538 97.6666 53.3538 96.5V95C55.2172 96.0666 56.1326 96.6666 56.1326 97.65C56.1326 98.15 56.1326 98.2666 55.4624 98.2666L55.4297 98.35Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M67.0379 105.2L66.8908 104.883C65.9077 102.499 65.4824 99.9139 65.6485 97.3331V87.9164L63.2456 87.5831V82.1831L66.0408 82.5331V78.8331L72.4485 77.9998V83.3331L75.7177 83.7331V89.0164L72.4485 88.6164V97.9997C72.3015 100.415 72.7747 102.828 73.8216 105L74.3937 106.083L67.0379 105.2Z",
        fill: "#ED1C24"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M71.6624 78.7331V83.8998L74.9316 84.2998V88.3331L71.6624 87.9331V98.1831C71.5327 100.536 72 102.884 73.0191 105L67.5595 104.316C66.6712 102.158 66.2905 99.8181 66.448 97.4831V87.3831L63.6528 87.0331V82.8665L66.448 83.2165V79.3498L71.4989 78.6998L71.6624 78.7331ZM72.872 77.2998L71.4826 77.4831L66.3172 78.1498L65.2383 78.3331V81.8331L63.7672 81.6665L62.4922 81.4998V88.1665L63.5874 88.2998L65.222 88.5165V97.6165C65.08 100.143 65.5107 102.67 66.4806 105L66.7585 105.6H67.4124L72.8883 106.283L75.2095 106.666L74.1307 104.616C73.2028 102.663 72.7807 100.5 72.9047 98.3331V89.4165L74.7845 89.6498L76.0922 89.8165V83.1498L75.0624 83.0165L72.8883 82.7498V77.2998H72.872Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M90.9349 104.75L80.457 105.967V77.1002L90.6734 75.9335C95.1849 75.4169 97.6695 77.6002 97.6695 81.6502V83.7835C97.6695 83.7835 96.9176 88.7835 94.0243 89.6169C97.032 90.0002 98.0945 94.5169 98.0945 94.5169V97.3002C98.0945 101.467 95.5118 104.217 90.9349 104.75ZM92.0628 82.9335C92.0628 81.5002 91.458 80.6502 89.8724 80.8335L86.4561 81.2502V88.6669L89.6272 88.3335C89.9535 88.3292 90.2758 88.2594 90.5756 88.128C90.8754 87.9967 91.1469 87.8064 91.3746 87.568C91.6023 87.3297 91.7817 87.048 91.9026 86.7389C92.0235 86.4299 92.0835 86.0996 92.0791 85.7669C92.0872 85.6837 92.0872 85.6 92.0791 85.5169L92.0628 82.9335ZM92.0628 94.8335C92.0628 93.1669 91.2291 92.4335 89.6763 92.6002L86.407 92.9669V100.334L89.9215 100C90.207 99.9959 90.4888 99.9342 90.751 99.8188C91.0131 99.7034 91.2504 99.5364 91.4492 99.3275C91.6481 99.1185 91.8046 98.8717 91.9099 98.6011C92.0152 98.3304 92.0671 98.0413 92.0628 97.7502C92.0709 97.6671 92.0709 97.5833 92.0628 97.5002V94.8335Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M107.705 103.083C103.341 103.583 100.464 101.217 100.464 96.6166V89.9999C100.352 87.9186 101.049 85.8762 102.405 84.316C103.761 82.7559 105.665 81.8038 107.705 81.6666C108.473 81.5004 109.265 81.4903 110.036 81.6367C110.807 81.7831 111.543 82.0831 112.2 82.5197C112.858 82.9563 113.424 83.5208 113.867 84.1808C114.311 84.8409 114.622 85.5837 114.783 86.3666C114.917 87.013 114.945 87.6776 114.865 88.3332V94.9999C114.946 97.0343 114.241 99.02 112.903 100.531C111.564 102.042 109.698 102.958 107.705 103.083V103.083ZM109.667 87.9832C109.727 87.4776 109.589 86.9681 109.283 86.5655C108.977 86.1629 108.527 85.8998 108.032 85.8332C107.853 85.8083 107.672 85.8083 107.493 85.8332C106.855 85.8885 106.264 86.1975 105.848 86.6934C105.432 87.1894 105.224 87.8323 105.27 88.4832V96.8166C105.23 97.118 105.262 97.4247 105.362 97.7112C105.462 97.9977 105.628 98.2559 105.845 98.4643C106.062 98.6728 106.325 98.8255 106.611 98.9099C106.898 98.9944 107.2 99.0081 107.493 98.9499C108.12 98.8784 108.696 98.563 109.101 98.0694C109.506 97.5758 109.708 96.942 109.667 96.2999V87.9832Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M124.509 101.15C120.145 101.65 117.268 99.283 117.268 94.683V88.0163C117.183 85.9536 117.893 83.9387 119.246 82.403C120.6 80.8673 122.489 79.9329 124.509 79.7997C126.057 79.4691 127.67 79.7784 128.994 80.6597C130.318 81.541 131.245 82.9221 131.571 84.4997C131.701 85.1126 131.734 85.7428 131.669 86.3663V93.033C131.763 95.0742 131.064 97.0709 129.724 98.5902C128.384 100.11 126.51 101.029 124.509 101.15V101.15ZM126.471 86.0497C126.51 85.7482 126.479 85.4415 126.379 85.155C126.279 84.8685 126.113 84.6103 125.896 84.4019C125.679 84.1935 125.416 84.0407 125.129 83.9563C124.843 83.8719 124.541 83.8582 124.248 83.9163C123.61 83.9716 123.019 84.2807 122.603 84.7766C122.187 85.2725 121.98 85.9154 122.025 86.5663V94.8997C121.986 95.1542 121.997 95.4142 122.059 95.664C122.121 95.9139 122.231 96.1485 122.384 96.3539C122.536 96.5592 122.728 96.7311 122.947 96.8593C123.166 96.9874 123.409 97.0692 123.659 97.0997C123.881 97.1413 124.108 97.1413 124.33 97.0997C124.957 97.0282 125.533 96.7128 125.938 96.2192C126.343 95.7256 126.545 95.0918 126.504 94.4497L126.471 86.0497Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M144.549 98.5836L141.279 90.6336L139.318 94.3336V99.2003L134.054 99.7836V70.9003L139.253 70.3003V87.7836L144.026 77.7836L149.093 77.2003L144.516 86.4503L149.616 98.0003L144.549 98.5836Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M30.0782 67.8337L31.1244 70.8004L33.4945 71.1337L31.7782 72.6171L32.4974 75.4337L30.0782 73.6504L27.6426 74.7671L28.3619 72.1504L26.6455 70.2171L29.0157 70.5004L30.0782 67.8337Z",
        fill: "white"
    }))), $0422a6ce4ea03acc$var$Bz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 200 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_55995_43169)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M192.593 0H7.40741C3.31641 0 0 3.31641 0 7.40741V51.8518C0 55.9428 3.31641 59.2593 7.40741 59.2593H192.593C196.684 59.2593 200 55.9428 200 51.8518V7.40741C200 3.31641 196.684 0 192.593 0Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M192.593 1.18519C194.242 1.1891 195.822 1.84591 196.988 3.01195C198.154 4.178 198.811 5.75837 198.815 7.40741V51.8518C198.811 53.5009 198.154 55.0813 196.988 56.2473C195.822 57.4133 194.242 58.0702 192.593 58.0741H7.40741C6.59029 58.0741 5.78118 57.9131 5.02627 57.6004C4.27135 57.2877 3.58542 56.8294 3.00763 56.2516C2.42984 55.6738 1.97152 54.9879 1.65882 54.233C1.34613 53.4781 1.18519 52.669 1.18519 51.8518V7.40741C1.18519 5.75717 1.84074 4.17452 3.00763 3.00763C4.17452 1.84074 5.75717 1.18519 7.40741 1.18519H192.593ZM192.593 0H7.40741C5.44284 0 3.55874 0.780421 2.16958 2.16958C0.780421 3.55874 0 5.44284 0 7.40741V51.8518C0 53.8164 0.780421 55.7005 2.16958 57.0897C3.55874 58.4788 5.44284 59.2593 7.40741 59.2593H192.593C194.557 59.2593 196.441 58.4788 197.83 57.0897C199.22 55.7005 200 53.8164 200 51.8518V7.40741C200 5.44284 199.22 3.55874 197.83 2.16958C196.441 0.780421 194.557 0 192.593 0Z",
        fill: "#A6A6A6"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M70.237 15.1704C70.2641 15.7127 70.1809 16.2549 69.9925 16.7642C69.8041 17.2735 69.5143 17.7393 69.1407 18.1333C68.717 18.5682 68.2065 18.9091 67.6424 19.1337C67.0783 19.3583 66.4732 19.4617 65.8666 19.437C65.2579 19.441 64.6546 19.3236 64.0918 19.0916C63.5291 18.8596 63.0183 18.5177 62.5892 18.0859C62.1602 17.6542 61.8216 17.1412 61.5932 16.5769C61.3648 16.0127 61.2513 15.4086 61.2592 14.8C61.2513 14.1914 61.3648 13.5873 61.5932 13.0231C61.8216 12.4588 62.1602 11.9458 62.5892 11.5141C63.0183 11.0823 63.5291 10.7404 64.0918 10.5084C64.6546 10.2764 65.2579 10.159 65.8666 10.163C66.4979 10.1584 67.1234 10.2845 67.7036 10.5333C68.2355 10.7496 68.7079 11.0899 69.0814 11.5259L68.311 12.3111C68.0153 11.9546 67.6401 11.6724 67.2156 11.4872C66.7911 11.3019 66.329 11.2188 65.8666 11.2444C65.4025 11.2442 64.943 11.3372 64.5155 11.5179C64.088 11.6986 63.7012 11.9632 63.3779 12.2962C63.0546 12.6292 62.8014 13.0237 62.6334 13.4563C62.4654 13.8889 62.386 14.3509 62.3999 14.8148C62.3881 15.2762 62.4685 15.7354 62.6365 16.1653C62.8045 16.5953 63.0566 16.9873 63.3781 17.3185C63.6997 17.6497 64.0841 17.9133 64.5088 18.0939C64.9336 18.2746 65.3902 18.3685 65.8518 18.3704C66.3074 18.3819 66.7608 18.3027 67.1855 18.1374C67.6103 17.9721 67.9979 17.7239 68.3258 17.4074C68.784 16.9148 69.0473 16.2724 69.0666 15.6H65.8666V14.4444H70.1777C70.222 14.6838 70.2419 14.927 70.237 15.1704Z",
        fill: "white",
        stroke: "white",
        strokeWidth: 0.2,
        strokeMiterlimit: 10
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M77.0668 11.4815H73.0223V14.2964H76.6668V15.363H73.0223V18.1778H77.0668V19.2741H71.8816V10.3853H77.0668V11.4815Z",
        fill: "white",
        stroke: "white",
        strokeWidth: 0.2,
        strokeMiterlimit: 10
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M81.8814 19.2593H80.7407V11.4815H78.2666V10.3853H84.3703V11.4815H81.8814V19.2593Z",
        fill: "white",
        stroke: "white",
        strokeWidth: 0.2,
        strokeMiterlimit: 10
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M88.7852 19.2592V10.3704H89.9259V19.2592H88.7852Z",
        fill: "white",
        stroke: "white",
        strokeWidth: 0.2,
        strokeMiterlimit: 10
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M94.9925 19.2593H93.8518V11.4815H91.3777V10.3853H97.4814V11.4815H94.9925V19.2593Z",
        fill: "white",
        stroke: "white",
        strokeWidth: 0.2,
        strokeMiterlimit: 10
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M109.037 18.1036C108.609 18.5319 108.101 18.8716 107.542 19.1034C106.982 19.3351 106.383 19.4544 105.778 19.4544C105.172 19.4544 104.573 19.3351 104.014 19.1034C103.454 18.8716 102.946 18.5319 102.518 18.1036C101.681 17.2133 101.215 16.0371 101.215 14.8147C101.215 13.5924 101.681 12.4162 102.518 11.5259C102.946 11.0976 103.454 10.7579 104.014 10.5261C104.573 10.2943 105.172 10.175 105.778 10.175C106.383 10.175 106.982 10.2943 107.542 10.5261C108.101 10.7579 108.609 11.0976 109.037 11.5259C109.465 11.9584 109.802 12.4723 110.028 13.0371C110.255 13.6019 110.366 14.2063 110.355 14.8147C110.373 15.4241 110.265 16.0305 110.038 16.5963C109.811 17.1621 109.471 17.6752 109.037 18.1036ZM103.363 17.4073C103.675 17.7315 104.05 17.9882 104.466 18.1615C104.881 18.3348 105.328 18.421 105.778 18.4147C106.228 18.4237 106.675 18.3387 107.091 18.1653C107.507 17.9918 107.882 17.7337 108.193 17.4073C108.524 17.0731 108.782 16.6745 108.953 16.2362C109.124 15.7979 109.203 15.3292 109.185 14.8592C109.203 14.3891 109.124 13.9205 108.953 13.4821C108.782 13.0438 108.524 12.6453 108.193 12.311C107.882 11.9847 107.507 11.7266 107.091 11.5531C106.675 11.3797 106.228 11.2947 105.778 11.3036C105.328 11.2974 104.881 11.3836 104.466 11.5569C104.05 11.7301 103.675 11.9868 103.363 12.311C102.733 13.0103 102.384 13.9181 102.384 14.8592C102.384 15.8003 102.733 16.7081 103.363 17.4073Z",
        fill: "white",
        stroke: "white",
        strokeWidth: 0.2,
        strokeMiterlimit: 10
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M111.956 19.2592V10.3704H113.348L117.659 17.2889V15.5704V10.3704H118.815V19.2592H117.615L113.17 12.0148V13.7185V19.2592H111.956Z",
        fill: "white",
        stroke: "white",
        strokeWidth: 0.2,
        strokeMiterlimit: 10
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M100.918 32.2223C99.6702 32.2253 98.4509 32.5983 97.4147 33.2942C96.3784 33.9901 95.5718 34.9776 95.0969 36.132C94.6219 37.2863 94.4999 38.5555 94.7463 39.7792C94.9927 41.0028 95.5964 42.126 96.4811 43.0065C97.3658 43.8871 98.4917 44.4855 99.7165 44.7261C100.941 44.9668 102.21 44.8388 103.362 44.3584C104.514 43.8781 105.498 43.0668 106.189 42.0274C106.88 40.9879 107.247 39.7668 107.244 38.5186C107.256 37.6859 107.101 36.8593 106.787 36.088C106.473 35.3167 106.007 34.6165 105.417 34.029C104.826 33.4415 104.124 32.9788 103.351 32.6684C102.578 32.3581 101.751 32.2063 100.918 32.2223ZM100.918 42.3408C100.153 42.3944 99.3899 42.2165 98.7273 41.8303C98.0646 41.4441 97.5335 40.8676 97.2029 40.1756C96.8723 39.4835 96.7575 38.7081 96.8735 37.95C96.9895 37.1918 97.3308 36.4861 97.8532 35.9246C98.3755 35.3631 99.0548 34.9717 99.8025 34.8012C100.55 34.6308 101.332 34.6893 102.046 34.9691C102.76 35.2489 103.374 35.737 103.807 36.37C104.24 37.0031 104.472 37.7517 104.474 38.5186C104.498 39.0046 104.424 39.4904 104.257 39.9474C104.09 40.4044 103.834 40.8234 103.502 41.1796C103.171 41.5359 102.772 41.8221 102.328 42.0216C101.884 42.221 101.405 42.3296 100.918 42.3408ZM87.1406 32.2223C85.8944 32.234 84.6795 32.6145 83.6491 33.3157C82.6188 34.0169 81.8191 35.0075 81.351 36.1625C80.8828 37.3175 80.7671 38.5853 81.0185 39.8061C81.2699 41.0268 81.877 42.1457 82.7634 43.0218C83.6499 43.8979 84.7758 44.492 85.9994 44.729C87.223 44.9661 88.4893 44.8356 89.6388 44.354C90.7883 43.8723 91.7695 43.0611 92.4586 42.0227C93.1477 40.9842 93.5139 39.7649 93.511 38.5186C93.5233 37.6821 93.3663 36.8517 93.0496 36.0774C92.7328 35.3031 92.2628 34.6008 91.6678 34.0127C91.0728 33.4246 90.365 32.9628 89.5871 32.6552C88.8091 32.3475 87.9769 32.2003 87.1406 32.2223ZM87.1406 42.3408C86.3756 42.3944 85.6121 42.2165 84.9495 41.8303C84.2868 41.4441 83.7557 40.8676 83.4251 40.1756C83.0945 39.4835 82.9797 38.7081 83.0957 37.95C83.2117 37.1918 83.553 36.4861 84.0754 35.9246C84.5978 35.3631 85.277 34.9717 86.0247 34.8012C86.7725 34.6308 87.5542 34.6893 88.2683 34.9691C88.9824 35.2489 89.5958 35.737 90.0288 36.37C90.4618 37.0031 90.6943 37.7517 90.6962 38.5186C90.7201 39.0046 90.6464 39.4904 90.4795 39.9474C90.3126 40.4044 90.0559 40.8234 89.7245 41.1796C89.3932 41.5359 88.9938 41.8221 88.55 42.0216C88.1063 42.221 87.627 42.3296 87.1406 42.3408ZM70.7258 34.1631V36.8297H77.1258C77.0313 38.0872 76.5084 39.2742 75.6443 40.1927C75.0057 40.8471 74.2363 41.3596 73.3862 41.6965C72.5361 42.0335 71.6246 42.1874 70.711 42.1483C68.825 42.1483 67.0163 41.399 65.6827 40.0655C64.3491 38.7319 63.5999 36.9231 63.5999 35.0371C63.5999 33.1512 64.3491 31.3424 65.6827 30.0088C67.0163 28.6752 68.825 27.926 70.711 27.926C72.5046 27.9061 74.2341 28.5925 75.5258 29.8371L77.4221 27.9557C76.5386 27.083 75.4902 26.3951 74.3379 25.9322C73.1856 25.4692 71.9527 25.2405 70.711 25.2594C69.394 25.2081 68.0801 25.4233 66.8482 25.8919C65.6163 26.3606 64.4917 27.0731 63.5418 27.9868C62.5918 28.9005 61.8361 29.9965 61.3199 31.2093C60.8037 32.422 60.5376 33.7265 60.5376 35.0445C60.5376 36.3626 60.8037 37.6671 61.3199 38.8798C61.8361 40.0926 62.5918 41.1886 63.5418 42.1023C64.4917 43.016 65.6163 43.7285 66.8482 44.1972C68.0801 44.6658 69.394 44.881 70.711 44.8297C71.9782 44.8794 73.2416 44.661 74.4185 44.1887C75.5954 43.7164 76.6593 43.0009 77.5406 42.089C79.0964 40.38 79.9253 38.1322 79.8517 35.8223C79.86 35.2656 79.8104 34.7095 79.7036 34.1631H70.7258ZM137.852 36.2371C137.465 35.1005 136.743 34.1079 135.78 33.391C134.817 32.674 133.659 32.2665 132.459 32.2223C131.649 32.2207 130.847 32.3854 130.102 32.7061C129.358 33.0268 128.688 33.4967 128.132 34.0868C127.577 34.6769 127.148 35.3747 126.873 36.137C126.598 36.8992 126.483 37.7098 126.533 38.5186C126.515 39.3486 126.665 40.1737 126.973 40.9446C127.281 41.7155 127.741 42.4164 128.326 43.0055C128.911 43.5946 129.608 44.0597 130.377 44.3732C131.146 44.6866 131.97 44.8419 132.8 44.8297C133.822 44.8191 134.827 44.5584 135.726 44.0703C136.624 43.5823 137.39 42.8817 137.955 42.0297L135.807 40.5483C135.487 41.082 135.033 41.5228 134.49 41.8268C133.947 42.1309 133.333 42.2876 132.711 42.2816C132.067 42.3091 131.429 42.1413 130.882 41.8003C130.335 41.4593 129.903 40.9609 129.644 40.3705L138.074 36.889L137.852 36.2371ZM129.259 38.3408C129.227 37.8814 129.287 37.4202 129.436 36.9844C129.585 36.5486 129.82 36.147 130.126 35.8032C130.433 35.4594 130.805 35.1805 131.221 34.9828C131.637 34.7851 132.088 34.6726 132.548 34.652C133.027 34.6237 133.504 34.7363 133.92 34.9759C134.336 35.2154 134.673 35.5715 134.889 36.0001L129.259 38.3408ZM122.4 44.4445H125.17V25.926H122.4V44.4445ZM117.867 33.7038H117.778C117.36 33.237 116.849 32.8637 116.277 32.6084C115.705 32.3531 115.085 32.2215 114.459 32.2223C112.84 32.3008 111.313 32.9992 110.195 34.1728C109.077 35.3464 108.454 36.9051 108.454 38.526C108.454 40.1469 109.077 41.7057 110.195 42.8792C111.313 44.0528 112.84 44.7512 114.459 44.8297C115.087 44.8403 115.709 44.7131 116.283 44.4572C116.856 44.2012 117.366 43.8227 117.778 43.3482H117.867V44.252C117.867 46.6668 116.578 47.9557 114.504 47.9557C113.81 47.9518 113.134 47.7411 112.561 47.3504C111.989 46.9598 111.545 46.4071 111.289 45.7631L108.874 46.7557C109.328 47.863 110.102 48.8097 111.097 49.4748C112.092 50.1398 113.262 50.4929 114.459 50.489C117.704 50.489 120.385 48.5779 120.385 43.926V32.6075H117.867V33.7038ZM114.696 42.3408C113.726 42.2803 112.814 41.8521 112.148 41.1433C111.483 40.4345 111.112 39.4986 111.112 38.526C111.112 37.5535 111.483 36.6175 112.148 35.9088C112.814 35.2 113.726 34.7717 114.696 34.7112C115.172 34.7334 115.639 34.8514 116.068 35.0581C116.497 35.2649 116.88 35.5561 117.194 35.9143C117.508 36.2726 117.746 36.6905 117.895 37.1431C118.044 37.5957 118.1 38.0736 118.059 38.5483C118.095 39.0198 118.036 39.4938 117.886 39.9421C117.735 40.3903 117.495 40.8037 117.182 41.1575C116.868 41.5114 116.486 41.7985 116.059 42.0018C115.632 42.2051 115.169 42.3204 114.696 42.3408ZM150.815 25.926H144.192V44.4445H146.963V37.4223H150.815C151.604 37.479 152.397 37.3725 153.144 37.1093C153.89 36.8462 154.575 36.432 155.154 35.8927C155.733 35.3534 156.196 34.7005 156.512 33.9747C156.828 33.2489 156.991 32.4658 156.991 31.6742C156.991 30.8826 156.828 30.0995 156.512 29.3737C156.196 28.6479 155.733 27.995 155.154 27.4557C154.575 26.9164 153.89 26.5022 153.144 26.239C152.397 25.9759 151.604 25.8693 150.815 25.926ZM150.815 34.8149H146.889V28.5038H150.815C151.656 28.5038 152.462 28.8378 153.057 29.4324C153.651 30.0269 153.985 30.8333 153.985 31.6742C153.985 32.515 153.651 33.3214 153.057 33.916C152.462 34.5105 151.656 34.8445 150.815 34.8445V34.8149ZM167.97 32.2223C166.962 32.162 165.957 32.3977 165.081 32.9004C164.205 33.4031 163.494 34.1509 163.037 35.052L165.496 36.0742C165.739 35.6288 166.107 35.264 166.554 35.0245C167.002 34.785 167.509 34.6813 168.015 34.726C168.366 34.685 168.723 34.7143 169.063 34.8124C169.403 34.9105 169.72 35.0754 169.996 35.2975C170.272 35.5195 170.501 35.7942 170.669 36.1056C170.838 36.417 170.943 36.7589 170.978 37.1112V37.289C170.064 36.8106 169.046 36.5663 168.015 36.5779C165.363 36.5779 162.681 38.0594 162.681 40.7557C162.708 41.3274 162.848 41.8881 163.095 42.4046C163.341 42.9211 163.689 43.3829 164.117 43.7628C164.545 44.1426 165.045 44.4327 165.587 44.616C166.13 44.7992 166.703 44.8719 167.274 44.8297C167.971 44.8698 168.666 44.7218 169.286 44.4012C169.907 44.0807 170.429 43.5993 170.8 43.0075H170.904V44.489H173.57V37.3186C173.6 34.0297 171.141 32.2223 167.97 32.2223ZM167.585 42.3408C166.667 42.3408 165.407 41.8816 165.407 40.7705C165.407 39.289 166.978 38.7853 168.37 38.7853C169.255 38.7638 170.129 38.9786 170.904 39.4075C170.8 40.2154 170.406 40.9581 169.795 41.4976C169.185 42.0371 168.4 42.3368 167.585 42.3408ZM183.259 32.5927L180.089 40.6223H179.985L176.711 32.5927H173.748L178.667 43.8223L175.911 50.0001H178.785L186.385 32.5334L183.259 32.5927ZM158.355 44.4445H161.126V25.926H158.355V44.4445Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M15.4519 11.1704C14.9691 11.7498 14.7253 12.4915 14.7704 13.2444V46.0148C14.7253 46.7677 14.9691 47.5094 15.4519 48.0889L15.5556 48.2074L33.9112 29.8518V29.4074L15.5556 11.0667L15.4519 11.1704Z",
        fill: "url(#paint0_linear_55995_43169)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M40.0297 35.9703L33.9111 29.8518V29.4073L40.0297 23.3333H40.1778L47.4222 27.4518C49.4963 28.6221 49.4963 30.5481 47.4222 31.7333L40.1778 35.8962L40.0297 35.9703Z",
        fill: "url(#paint1_linear_55995_43169)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M40.1778 35.8815L33.9112 29.6296L15.4519 48.0889C15.8729 48.4627 16.4113 48.6776 16.9739 48.6966C17.5366 48.7155 18.0882 48.5372 18.5334 48.1926L40.1778 35.8815Z",
        fill: "url(#paint2_linear_55995_43169)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M40.1778 23.3333L18.5334 11.037C18.0911 10.6876 17.5399 10.505 16.9765 10.5213C16.4131 10.5375 15.8733 10.7516 15.4519 11.1259L33.9112 29.6296L40.1778 23.3333Z",
        fill: "url(#paint3_linear_55995_43169)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        opacity: 0.2,
        d: "M40.0295 35.748L18.5332 47.9703C18.1046 48.2878 17.5852 48.4592 17.0517 48.4592C16.5183 48.4592 15.9989 48.2878 15.5703 47.9703L15.4666 48.074L15.5703 48.1925C15.9989 48.51 16.5183 48.6814 17.0517 48.6814C17.5852 48.6814 18.1046 48.51 18.5332 48.1925L40.1777 35.8814L40.0295 35.748Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        opacity: 0.12,
        d: "M15.4518 47.8814C14.9653 47.2981 14.7214 46.5504 14.7703 45.7925V46.0147C14.7252 46.7676 14.9689 47.5094 15.4518 48.0888L15.5555 47.9851L15.4518 47.8814Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        opacity: 0.12,
        d: "M47.4223 31.5556L40.0149 35.7482L40.163 35.8815L47.4075 31.763C47.8202 31.5691 48.1745 31.2698 48.4346 30.8952C48.6947 30.5206 48.8515 30.0841 48.889 29.6296C48.8042 30.0399 48.6284 30.426 48.3745 30.7593C48.1207 31.0926 47.7953 31.3647 47.4223 31.5556Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        opacity: 0.25,
        d: "M18.5332 11.289L47.4221 27.7779C47.7979 27.967 48.1262 28.2383 48.3826 28.5718C48.6391 28.9052 48.8172 29.2921 48.9036 29.7038C48.8661 29.2493 48.7094 28.8128 48.4493 28.4382C48.1892 28.0637 47.8349 27.7644 47.4221 27.5705L18.5332 11.0816C16.4592 9.8964 14.7703 10.8742 14.7703 13.2445V13.4668C14.7703 11.0964 16.474 10.1186 18.5332 11.289Z",
        fill: "white"
    })), /* @__PURE__ */ $acw62.createElement("defs", null, /* @__PURE__ */ $acw62.createElement("linearGradient", {
        id: "paint0_linear_55995_43169",
        x1: 32.2816,
        y1: 12.9037,
        x2: 7.4223,
        y2: 37.7629,
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ $acw62.createElement("stop", {
        stopColor: "#00A0FF"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.01,
        stopColor: "#00A1FF"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.26,
        stopColor: "#00BEFF"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.51,
        stopColor: "#00D2FF"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.76,
        stopColor: "#00DFFF"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 1,
        stopColor: "#00E3FF"
    })), /* @__PURE__ */ $acw62.createElement("linearGradient", {
        id: "paint1_linear_55995_43169",
        x1: 50.1185,
        y1: 29.6296,
        x2: 14.2667,
        y2: 29.6296,
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ $acw62.createElement("stop", {
        stopColor: "#FFE000"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.41,
        stopColor: "#FFBD00"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.78,
        stopColor: "#FFA500"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 1,
        stopColor: "#FF9C00"
    })), /* @__PURE__ */ $acw62.createElement("linearGradient", {
        id: "paint2_linear_55995_43169",
        x1: 36.7704,
        y1: 33.037,
        x2: 3.0519,
        y2: 66.7407,
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ $acw62.createElement("stop", {
        stopColor: "#FF3A44"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 1,
        stopColor: "#C31162"
    })), /* @__PURE__ */ $acw62.createElement("linearGradient", {
        id: "paint3_linear_55995_43169",
        x1: 10.8001,
        y1: 0.26661,
        x2: 25.8519,
        y2: 15.3185,
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ $acw62.createElement("stop", {
        stopColor: "#32A071"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.07,
        stopColor: "#2DA771"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.48,
        stopColor: "#15CF74"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.8,
        stopColor: "#06E775"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 1,
        stopColor: "#00F076"
    })), /* @__PURE__ */ $acw62.createElement("clipPath", {
        id: "clip0_55995_43169"
    }, /* @__PURE__ */ $acw62.createElement("rect", {
        width: 200,
        height: 59.2593,
        fill: "white"
    })))), $0422a6ce4ea03acc$var$Fz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 186 74",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M44.4297 13.7454C41.1276 10.8316 37.428 8.9097 32.9029 8.16575C27.3383 7.23582 23.2107 8.56872 20.8564 9.34367C20.3672 9.49866 20.306 9.80865 20.306 10.2116C20.2755 11.2345 20.7035 12.0405 21.0398 12.3505C21.4067 12.6915 21.7736 12.5055 22.324 12.3195C24.4948 11.5755 27.4911 11.0486 30.6404 11.4205C33.6367 11.7615 36.419 12.6914 38.4981 13.8694C35.5629 14.3033 31.1601 15.4503 26.5433 18.829C22.752 18.6121 17.9823 19.139 12.6929 21.8358C2.66427 26.9195 -3.63418 39.8456 2.29737 53.9187C4.71279 59.6223 10.1857 64.8919 16.5759 66.7828C20.306 67.8987 23.6387 67.8057 24.5254 67.7438C24.8006 67.9607 25.2592 68.3017 25.8095 68.6737C34.768 74.6873 43.0232 73.4784 47.8847 70.7815C52.3486 68.3017 58.2802 62.0711 58.4636 51.2219C66.7494 43.1314 65.1901 33.801 64.0894 29.8333C61.4905 20.3789 52.8072 14.3963 44.4297 13.7454ZM53.9691 47.2231C53.9997 47.9361 53.6939 48.2461 52.8684 48.835C51.7677 49.61 50.0861 50.5399 48.435 51.0669C48.221 51.1289 48.1293 50.8809 48.1904 50.7259C48.4044 50.3229 48.7102 49.703 48.8936 49.3C49.2605 48.494 49.6274 47.6571 49.9332 46.8512C50.5753 45.1773 51.2173 43.0074 51.6148 41.2405C51.676 40.9616 51.8594 40.9306 51.9511 41.0855C52.1346 41.3645 52.7461 42.7594 53.1741 44.1543C53.6328 45.6422 53.9385 46.8202 53.9691 47.2231ZM45.4081 48.1841C44.766 49.517 44.1851 50.6329 43.5736 51.4078C43.2067 51.8728 40.7913 52.7098 36.3273 50.7879C33.2087 49.455 31.4353 48.0601 28.7753 44.5263C28.1638 43.6894 27.6746 42.9764 27.3383 42.4495C26.9714 41.8605 26.7879 41.3955 25.7484 41.6125C24.984 41.7675 23.3635 42.4184 22.4769 43.7514C22.1405 44.2783 22.3851 44.7123 22.6909 45.2083C23.2718 46.2002 24.1585 47.3781 24.984 48.3701C27.8886 51.9038 31.5576 54.8796 35.8687 56.3675C36.4496 56.5535 37.5503 56.8635 38.0395 56.9875C38.3758 57.0805 38.5287 57.4834 38.3453 57.6694C37.214 58.9093 34.2788 60.9242 33.3921 61.3892C31.2519 62.5051 29.081 63.2801 27.4606 63.528C26.9102 63.621 26.3904 63.714 25.6261 63.0631C24.6782 62.2261 23.8222 61.2342 23.0578 60.2423C21.5596 58.2584 20.3978 55.9955 19.6028 53.6397C17.9518 48.773 17.7683 43.4724 18.8996 38.4817C19.9391 33.863 22.0794 29.5233 25.198 25.9896C25.6261 25.4936 27.2465 23.8817 27.7357 23.5407C28.1332 23.2927 28.653 23.0448 29.9371 23.2927C32.0162 23.7267 35.5018 24.7496 39.2319 27.0745C44.2157 30.1743 47.0591 33.615 47.9458 34.731C48.649 35.6299 48.6796 36.2499 48.5573 37.2418C48.1293 41.4265 46.5394 45.8282 45.4081 48.1841ZM43.3901 18.1781C43.6347 18.2091 43.9099 18.2711 44.2768 18.767C44.98 19.759 46.1419 21.7738 46.6005 22.8278C47.426 24.8116 48.0681 27.3535 48.3433 28.6244C48.4044 28.9344 48.1598 28.8724 48.0681 28.8104C47.7929 28.5004 47.212 28.0044 47.0286 27.8494C46.1725 26.9815 43.6959 24.9666 40.7913 23.2617C38.1924 21.7428 35.1349 20.5029 33.8813 20.162C33.7284 20.131 33.6673 19.883 33.8507 19.79C34.4011 19.542 36.1744 18.86 38.3147 18.4571C39.9657 18.1471 41.8308 18.0231 43.3901 18.1781ZM4.13187 46.6962C3.06174 40.0316 5.04911 33.4911 9.36019 29.2443C11.6839 26.9505 14.4968 25.1216 17.5849 24.0987C18.5021 23.7887 20.1532 23.3547 21.2539 23.1687C21.5596 23.1377 21.6513 23.5097 21.4679 23.6957C20.4283 24.8116 18.9607 27.1365 18.5021 27.9114C14.9248 33.956 13.3655 41.2405 14.0993 48.2461C14.986 56.8945 19.2053 62.1021 19.878 63.0011C20.0309 63.2181 20.1837 63.59 19.8474 63.652C19.7863 63.652 19.4499 63.59 18.9607 63.497C9.39076 61.3582 5.14084 52.9267 4.13187 46.6962ZM31.3436 66.9378C30.9767 66.7828 31.0073 66.5038 31.3436 66.3798C32.2914 66.0389 34.0342 65.3259 34.8597 64.8609C36.5108 63.962 38.0701 62.8771 39.5071 61.6372C40.2409 61.0172 41.8002 59.5913 42.7175 58.5064C43.0232 58.1344 43.543 57.4834 44.552 57.3595C46.5088 57.1425 47.0897 57.0495 48.4656 56.7085C49.7803 56.3675 52.0429 55.5616 53.541 54.7246C53.7245 54.6316 54.0302 54.7246 53.9385 55.1896C53.2659 58.5684 50.9422 63.776 46.784 66.4418C41.9837 69.6036 36.3885 69.2626 31.3436 66.9378ZM57.9744 43.4104C57.7298 43.8134 57.3629 43.7204 57.21 43.3794C57.0877 43.0074 56.9348 42.4804 56.8125 42.1085C56.1705 40.3106 55.3755 38.5437 54.3971 36.9008C53.9079 36.0949 53.3882 35.2579 52.7767 34.359C52.4098 33.801 52.4098 33.5221 52.4098 32.8401C52.3792 28.9654 51.1868 23.6337 49.2911 20.1929C49.1077 19.852 49.3828 19.635 49.5969 19.728C54.7029 22.1148 57.4546 25.6176 58.7694 28.9344C61.7045 36.3119 59.2891 41.2095 57.9744 43.4104Z",
        fill: "#008375"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84.3488 38.2041C84.3488 35.8482 82.5448 34.7323 80.1906 34.7323H76.6133V45.7366H78.937V41.7998H79.9154C82.6366 41.7998 84.3488 40.5909 84.3488 38.2041ZM82.0251 38.2351C82.0251 39.444 81.4136 40.064 79.946 40.064H78.937V36.5302H80.0071C81.4441 36.4992 82.0251 37.1192 82.0251 38.2351ZM86.9171 42.2028H91.9313C92.2065 39.227 90.9835 37.4911 88.5069 37.4911C86.3055 37.4911 84.5934 39.134 84.5934 41.6759C84.5934 44.2487 86.0915 45.9226 88.7515 45.9226C90.372 45.9226 91.1975 45.4576 91.7173 45.1476L91.0141 43.7217C90.6166 43.9077 90.0357 44.2797 88.935 44.2797C87.6509 44.2797 87.0394 43.4427 86.9171 42.2028ZM86.9171 40.7149C87.0699 39.661 87.5897 39.072 88.5069 39.072C89.4853 39.072 89.8522 39.816 89.8828 40.7149H86.9171ZM98.4744 37.7081C98.2909 37.6151 97.9852 37.4911 97.4043 37.4911C96.3953 37.4911 95.7532 38.1731 95.4169 38.793V37.7081H93.2461V45.7366H95.4169V40.6839C95.6003 40.3119 96.1813 39.475 97.1291 39.475C97.5877 39.475 97.8323 39.568 97.9546 39.661L98.4744 37.7081ZM102.052 39.32H103.947V37.6771H102.052V37.0262C102.052 35.9722 102.449 35.4453 103.336 35.4453C103.917 35.4453 104.284 35.6003 104.437 35.6623L104.926 34.0194C104.742 33.8954 104.161 33.6474 102.999 33.6474C100.982 33.6474 99.8808 34.9493 99.8808 36.8712V37.7081H98.6884V39.351H99.8808V45.7676H102.052V39.32ZM112.294 41.6449C112.294 39.568 111.041 37.4601 108.289 37.4601C105.537 37.4601 104.345 39.63 104.345 41.7069C104.345 43.7837 105.537 45.8916 108.32 45.8916C111.071 45.9226 112.294 43.6907 112.294 41.6449ZM110.001 41.7378C110.001 43.2257 109.573 44.2487 108.32 44.2487C107.097 44.2487 106.607 43.1638 106.607 41.6449C106.607 40.157 107.005 39.103 108.228 39.103C109.481 39.103 110.001 40.219 110.001 41.7378ZM118.654 37.7081C118.47 37.6151 118.165 37.4911 117.584 37.4911C116.575 37.4911 115.933 38.1731 115.596 38.793V37.7081H113.426V45.7366H115.596V40.6839C115.78 40.3119 116.361 39.475 117.309 39.475C117.767 39.475 118.012 39.568 118.134 39.661L118.654 37.7081ZM125.961 38.7621C125.656 38.0181 125.044 37.4911 123.913 37.4911C122.629 37.4911 121.956 38.2041 121.528 38.6691V37.6771H119.418V45.7056H121.589V40.281C121.742 40.064 122.262 39.289 123.057 39.289C123.699 39.289 123.974 39.692 123.974 40.4979V45.6746H126.145V40.188C126.45 39.816 126.94 39.289 127.612 39.289C128.316 39.289 128.56 39.723 128.56 40.4979V45.6746H130.731V40.033C130.731 38.5451 130.15 37.4291 128.468 37.4291C127.337 37.4911 126.603 37.9871 125.961 38.7621ZM134.583 37.6771H132.413V45.7056H134.583V37.6771ZM134.828 35.3213C134.828 34.6393 134.247 34.0194 133.483 34.0194C132.718 34.0194 132.168 34.6083 132.168 35.3213C132.168 36.0342 132.718 36.6542 133.483 36.6542C134.247 36.6542 134.828 36.0342 134.828 35.3213ZM143.542 45.7056V40.064C143.542 38.5761 142.9 37.4601 141.157 37.4601C139.842 37.4601 139.047 38.1731 138.619 38.6691V37.6771H136.51V45.7056H138.68V40.312C138.833 40.095 139.475 39.32 140.301 39.32C141.096 39.32 141.371 39.723 141.371 40.5289V45.7056H143.542ZM149.626 37.6771C149.229 37.5531 148.74 37.4911 148.22 37.4911C146.018 37.4911 144.704 38.6691 144.704 40.4049C144.704 41.4589 145.224 42.2958 146.11 42.8228C145.652 43.1018 145.224 43.5667 145.224 44.3417C145.224 44.9306 145.499 45.3026 145.927 45.5506C145.132 45.9846 144.581 46.6355 144.581 47.5035C144.581 48.9604 145.896 49.6423 148.067 49.6423C150.666 49.6423 152.409 48.4334 152.409 46.7285C152.409 44.3417 150.33 44.3417 148.678 44.2487C147.547 44.1867 147.089 44.0937 147.089 43.6597C147.089 43.4427 147.241 43.2877 147.394 43.1948C147.7 43.2568 148.006 43.2877 148.342 43.2877C150.544 43.2877 151.767 42.1098 151.767 40.3739C151.767 39.909 151.675 39.475 151.461 39.072H152.531V37.6461H149.626V37.6771ZM148.22 41.8928C147.333 41.8928 146.783 41.3349 146.783 40.4049C146.783 39.475 147.333 38.917 148.22 38.917C149.107 38.917 149.657 39.475 149.657 40.4049C149.657 41.3349 149.137 41.8928 148.22 41.8928ZM147.303 45.9846C147.639 46.0466 148.006 46.0776 148.373 46.1086C149.535 46.2016 150.268 46.1706 150.268 47.0075C150.268 47.6894 149.535 48.1854 148.189 48.1854C147.089 48.1854 146.63 47.7515 146.63 47.1005C146.661 46.6355 146.875 46.2635 147.303 45.9846ZM159.166 43.6597H163.507L164.241 45.7366H166.748L162.498 34.7323H160.266L156.139 45.7366H158.462L159.166 43.6597ZM162.835 41.7998H159.808L160.725 39.165C161.061 38.2351 161.275 37.3981 161.306 37.2742H161.337C161.367 37.3981 161.581 38.2351 161.917 39.165L162.835 41.7998ZM172.772 37.7081C172.588 37.6151 172.282 37.4911 171.701 37.4911C170.692 37.4911 170.05 38.1731 169.714 38.793V37.7081H167.543V45.7366H169.714V40.6839C169.898 40.3119 170.478 39.475 171.426 39.475C171.885 39.475 172.13 39.568 172.252 39.661L172.772 37.7081ZM174.27 39.32V43.4117C174.27 44.9616 174.912 45.9226 176.777 45.9226C177.755 45.9226 178.428 45.6436 178.764 45.4576L178.275 43.8147C178.122 43.9077 177.694 44.1247 177.236 44.1247C176.624 44.1247 176.441 43.7837 176.441 42.9778V39.32H178.306V37.6771H176.441V35.3523H174.3V37.6771H173.016V39.32H174.27ZM185.002 43.3497C185.002 41.9858 184.084 41.4279 182.831 40.9009C181.913 40.5289 181.21 40.3739 181.21 39.847C181.21 39.413 181.547 39.134 182.311 39.134C183.075 39.134 183.687 39.444 183.993 39.661L184.757 38.1731C184.39 37.9561 183.565 37.5221 182.219 37.5221C180.415 37.5221 179.253 38.4831 179.253 39.971C179.253 41.1799 179.926 41.8308 181.027 42.3578C182.158 42.9158 183.014 43.0398 183.014 43.5977C183.014 44.0627 182.556 44.3107 181.699 44.3107C180.813 44.3107 180.048 43.8767 179.743 43.6597L179.009 45.1786C179.498 45.5196 180.415 45.9226 181.822 45.9226C183.84 45.9226 185.002 45.0236 185.002 43.3497Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M76.7197 29.7333H81.948V28.9584H77.6064V18.7291H76.7197V29.7333ZM83.966 20.217C84.3329 20.217 84.6081 19.907 84.6081 19.535C84.6081 19.1631 84.3023 18.8841 83.966 18.8841C83.6297 18.8841 83.3239 19.1631 83.3239 19.535C83.3239 19.907 83.5991 20.217 83.966 20.217ZM83.5379 29.7333H84.394V21.8599H83.5379V29.7333ZM89.1026 29.9193C91.4874 29.9193 92.955 27.9975 92.955 25.7656C92.955 23.4718 91.8849 21.6739 89.6529 21.6739C88.858 21.6739 88.0936 22.0459 87.6044 22.5728V17.8301H86.7483V29.2994C87.3292 29.6714 88.1853 29.9193 89.1026 29.9193ZM89.1332 29.1754C88.5217 29.1754 87.9713 29.0514 87.6044 28.8654V23.3478C88.0325 22.8518 88.8274 22.4488 89.5001 22.4488C91.3957 22.4488 92.0378 24.0917 92.0378 25.7966C92.0684 27.4395 91.1205 29.1754 89.1332 29.1754ZM94.9118 29.7333H95.7679V24.2467C95.982 23.7817 96.6852 22.5108 97.7553 22.5108C98.0916 22.5108 98.2751 22.5728 98.3974 22.6348L98.6114 21.8289C98.4891 21.7669 98.2139 21.7049 97.8776 21.7049C96.7769 21.7049 96.0737 22.6658 95.7985 23.2548V21.8909H94.9118V29.7333ZM101.516 29.9193C102.433 29.9193 103.32 29.4544 103.87 28.7414C103.901 29.0204 103.931 29.4854 103.993 29.7333H104.849C104.757 29.3924 104.696 28.8344 104.696 28.1524V24.1847C104.696 22.4798 103.809 21.6739 102.219 21.6739C101.21 21.6739 100.354 22.0149 99.6815 22.6658L100.14 23.2548C100.782 22.6348 101.424 22.4178 102.158 22.4178C103.32 22.4178 103.87 23.0068 103.87 24.2777V25.1766H103.503C101.699 25.1766 99.4064 25.7656 99.4064 27.8735C99.3452 29.1134 100.232 29.9193 101.516 29.9193ZM101.638 29.1754C100.966 29.1754 100.232 28.7104 100.232 27.8425C100.232 26.3856 101.699 25.8586 103.442 25.8586H103.809V27.9665C103.228 28.7414 102.494 29.1754 101.638 29.1754ZM106.958 29.7333H107.814V24.2467C108.029 23.7817 108.732 22.5108 109.802 22.5108C110.138 22.5108 110.322 22.5728 110.444 22.6348L110.658 21.8289C110.536 21.7669 110.26 21.7049 109.924 21.7049C108.823 21.7049 108.12 22.6658 107.845 23.2548V21.8909H106.989V29.7333H106.958ZM111.728 33.5151C113.41 33.5151 114.021 32.3372 114.572 30.8493L117.904 21.8289H117.018L114.633 28.5864L112.187 21.8289H111.269L114.174 29.6403L113.777 30.7563C113.318 31.9962 112.859 32.7401 111.728 32.7401C111.422 32.7401 111.3 32.7091 111.178 32.6781L111.055 33.3911C111.208 33.4841 111.392 33.5151 111.728 33.5151ZM123.316 29.7333H124.142V22.5418H126.159V21.8599H124.142V20.62C124.142 19.1941 124.722 18.4501 125.915 18.4501C126.373 18.4501 126.74 18.5741 126.893 18.6671L127.107 17.9231C126.893 17.8301 126.496 17.7061 125.915 17.7061C124.203 17.7061 123.285 18.7911 123.285 20.589V21.9219H121.94V22.6038H123.285V29.7333H123.316ZM130.195 29.9193C132.641 29.9193 133.742 27.7495 133.742 25.7656C133.742 23.8127 132.611 21.6739 130.165 21.6739C127.719 21.6739 126.679 23.8127 126.679 25.7966C126.71 27.7805 127.78 29.9193 130.195 29.9193ZM130.226 29.1754C128.483 29.1754 127.596 27.5635 127.596 25.7656C127.596 23.9987 128.391 22.4178 130.165 22.4178C131.938 22.4178 132.855 24.0297 132.855 25.7966C132.855 27.5945 131.999 29.1754 130.226 29.1754ZM135.699 29.7333H136.555V24.2467C136.769 23.7817 137.472 22.5108 138.542 22.5108C138.879 22.5108 139.062 22.5728 139.184 22.6348L139.398 21.8289C139.276 21.7669 139.001 21.7049 138.665 21.7049C137.564 21.7049 136.861 22.6658 136.586 23.2548V21.8909H135.729V29.7333H135.699ZM146.492 29.9193C147.226 29.9193 147.776 29.6094 147.99 29.4544L147.654 28.8034C147.501 28.9274 147.042 29.1754 146.584 29.1754C145.88 29.1754 145.636 28.7414 145.636 27.9355V22.5728H147.623V21.8909H145.636V19.628H144.78V21.8599H143.465V22.5418H144.78V27.9665C144.78 29.2064 145.33 29.9193 146.492 29.9193ZM149.641 29.7333H150.497V23.9987C150.772 23.5648 151.72 22.4488 152.882 22.4488C154.044 22.4488 154.472 23.1618 154.472 24.3397V29.7333H155.328V24.1537C155.328 22.7278 154.686 21.6739 153.065 21.6739C151.751 21.6739 150.864 22.5728 150.497 23.0998V17.8301H149.641V29.7333ZM160.709 29.9193C161.963 29.9193 162.849 29.4854 163.339 29.1134L162.972 28.4314C162.544 28.7724 161.718 29.1754 160.74 29.1754C158.875 29.1754 158.141 27.5325 158.11 25.7346V25.5486H163.461C163.492 25.3936 163.492 25.2696 163.492 25.1147C163.492 23.0998 162.421 21.6739 160.556 21.6739C158.477 21.6739 157.224 23.5028 157.224 25.7036C157.224 27.9975 158.324 29.9193 160.709 29.9193ZM158.171 24.8357C158.385 23.4718 159.18 22.4178 160.526 22.4178C161.993 22.4178 162.605 23.6267 162.635 24.8357H158.171Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M76.6868 12.6878H77.5124V3.14047L84.0248 12.6878H84.8503V1.68357H83.9942V11.1689L77.5429 1.68357H76.6562V12.6878H76.6868ZM89.8646 12.8428C91.1182 12.8428 92.0049 12.4088 92.4941 12.0369L92.1272 11.3549C91.6991 11.6959 90.8736 12.0989 89.8952 12.0989C88.0301 12.0989 87.2963 10.456 87.2658 8.6581V8.47211H92.6164C92.647 8.31712 92.647 8.19313 92.647 8.03814C92.647 6.02328 91.5768 4.59737 89.7118 4.59737C87.6327 4.59737 86.3791 6.42625 86.3791 8.6271C86.3791 10.9209 87.4798 12.8428 89.8646 12.8428ZM87.3269 7.79015C87.5409 6.42624 88.3359 5.37232 89.6812 5.37232C91.1488 5.37232 91.7603 6.58123 91.7909 7.79015H87.3269ZM95.8268 12.6878H96.6217L98.7314 6.05428L100.841 12.6878H101.636L103.99 4.81436H103.134L101.239 11.3859L99.19 4.81436H98.3645L96.316 11.3549L94.4203 4.81436H93.5031L95.8268 12.6878ZM111.084 12.6878H111.97V8.53411L115.578 1.68357H114.661L111.573 7.63516H111.542L108.454 1.68357H107.445L111.084 8.53411V12.6878ZM118.177 12.8428C120.623 12.8428 121.724 10.673 121.724 8.6891C121.724 6.73623 120.592 4.59737 118.146 4.59737C115.701 4.59737 114.661 6.73622 114.661 8.72009C114.661 10.735 115.731 12.8428 118.177 12.8428ZM118.177 12.0989C116.404 12.0989 115.548 10.487 115.548 8.6891C115.548 6.92222 116.343 5.34132 118.116 5.34132C119.889 5.34132 120.807 6.95321 120.807 8.72009C120.807 10.518 119.95 12.0989 118.177 12.0989ZM123.344 12.6878H124.2V7.20119C124.414 6.73623 125.118 5.46531 126.188 5.46531C126.524 5.46531 126.707 5.52731 126.83 5.58931L127.044 4.78336C126.922 4.72136 126.646 4.65937 126.31 4.65937C125.209 4.65937 124.506 5.62031 124.231 6.20927V4.84536H123.344V12.6878ZM133.067 12.6878H134.137L130.529 8.25512L133.954 4.81436H132.884L129.49 8.25512L133.067 12.6878ZM128.542 12.6878H129.398V0.815626H128.542V12.6878ZM139.549 12.6878H140.436V8.00714H141.812C144.258 8.00714 145.633 6.76723 145.633 4.78336C145.633 2.83049 144.196 1.68357 141.934 1.68357H139.549V12.6878ZM140.436 7.23219V2.45852H141.812C143.891 2.45852 144.686 3.45045 144.686 4.81436C144.686 6.27126 143.829 7.23219 141.781 7.23219H140.436ZM149.302 12.8428C150.617 12.8428 151.504 11.9749 151.871 11.3859C151.871 11.8199 151.932 12.4088 151.993 12.6878H152.849C152.757 12.3779 152.696 11.7889 152.696 11.1689V4.81436H151.84V10.518C151.565 10.9829 150.617 12.0989 149.455 12.0989C148.263 12.0989 147.865 11.3549 147.865 10.208V4.81436H147.009V10.363C147.009 11.7889 147.651 12.8428 149.302 12.8428ZM157.374 12.8428C159.759 12.8428 161.227 10.9209 161.227 8.6891C161.227 6.39525 160.157 4.59737 157.925 4.59737C157.13 4.59737 156.365 4.96934 155.876 5.49631V0.753632H155.02V12.2229C155.57 12.6258 156.426 12.8428 157.374 12.8428ZM157.405 12.0989C156.793 12.0989 156.243 11.9749 155.907 11.7889V6.30226C156.335 5.80629 157.13 5.40332 157.802 5.40332C159.698 5.40332 160.34 7.04621 160.34 8.75109C160.309 10.394 159.362 12.0989 157.405 12.0989ZM162.847 12.6878H163.703V0.815626H162.847V12.6878ZM166.577 3.14047C166.944 3.14047 167.219 2.83049 167.219 2.45852C167.219 2.08654 166.914 1.80756 166.577 1.80756C166.241 1.80756 165.935 2.08654 165.935 2.45852C165.935 2.86149 166.241 3.14047 166.577 3.14047ZM166.149 12.6878H167.005V4.81436H166.149V12.6878ZM172.05 12.8428C173.212 12.8428 174.038 12.4088 174.466 12.0369L174.099 11.3859C173.762 11.6959 172.998 12.0989 172.111 12.0989C170.399 12.0989 169.635 10.425 169.635 8.6891C169.635 6.86022 170.43 5.34132 172.142 5.34132C172.998 5.34132 173.579 5.6823 174.038 6.05428L174.466 5.43432C174.038 5.06234 173.304 4.59737 172.142 4.59737C170.155 4.59737 168.718 6.20926 168.718 8.72009C168.718 10.8589 169.818 12.8428 172.05 12.8428Z",
        fill: "black"
    })), $0422a6ce4ea03acc$var$Az = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 186 74",
        fill: "#000000",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M44.4297 13.7454C41.1276 10.8316 37.428 8.9097 32.9029 8.16575C27.3383 7.23582 23.2107 8.56872 20.8564 9.34367C20.3672 9.49866 20.306 9.80865 20.306 10.2116C20.2755 11.2345 20.7035 12.0405 21.0398 12.3505C21.4067 12.6915 21.7736 12.5055 22.324 12.3195C24.4948 11.5755 27.4911 11.0486 30.6404 11.4205C33.6367 11.7615 36.419 12.6914 38.4981 13.8694C35.5629 14.3033 31.1601 15.4503 26.5433 18.829C22.752 18.6121 17.9823 19.139 12.6929 21.8358C2.66427 26.9195 -3.63418 39.8456 2.29737 53.9187C4.71279 59.6223 10.1857 64.8919 16.5759 66.7828C20.306 67.8987 23.6387 67.8057 24.5254 67.7438C24.8006 67.9607 25.2592 68.3017 25.8095 68.6737C34.768 74.6873 43.0232 73.4784 47.8847 70.7815C52.3486 68.3017 58.2802 62.0711 58.4636 51.2219C66.7494 43.1314 65.1901 33.801 64.0894 29.8333C61.4905 20.3789 52.8072 14.3963 44.4297 13.7454ZM53.9691 47.2231C53.9997 47.9361 53.6939 48.2461 52.8684 48.835C51.7677 49.61 50.0861 50.5399 48.435 51.0669C48.221 51.1289 48.1293 50.8809 48.1904 50.7259C48.4044 50.3229 48.7102 49.703 48.8936 49.3C49.2605 48.494 49.6274 47.6571 49.9332 46.8512C50.5753 45.1773 51.2173 43.0074 51.6148 41.2405C51.676 40.9616 51.8594 40.9306 51.9511 41.0855C52.1346 41.3645 52.7461 42.7594 53.1741 44.1543C53.6328 45.6422 53.9385 46.8202 53.9691 47.2231ZM45.4081 48.1841C44.766 49.517 44.1851 50.6329 43.5736 51.4078C43.2067 51.8728 40.7913 52.7098 36.3273 50.7879C33.2087 49.455 31.4353 48.0601 28.7753 44.5263C28.1638 43.6894 27.6746 42.9764 27.3383 42.4495C26.9714 41.8605 26.7879 41.3955 25.7484 41.6125C24.984 41.7675 23.3635 42.4184 22.4769 43.7514C22.1405 44.2783 22.3851 44.7123 22.6909 45.2083C23.2718 46.2002 24.1585 47.3781 24.984 48.3701C27.8886 51.9038 31.5576 54.8796 35.8687 56.3675C36.4496 56.5535 37.5503 56.8635 38.0395 56.9875C38.3758 57.0805 38.5287 57.4834 38.3453 57.6694C37.214 58.9093 34.2788 60.9242 33.3921 61.3892C31.2519 62.5051 29.081 63.2801 27.4606 63.528C26.9102 63.621 26.3904 63.714 25.6261 63.0631C24.6782 62.2261 23.8222 61.2342 23.0578 60.2423C21.5596 58.2584 20.3978 55.9955 19.6028 53.6397C17.9518 48.773 17.7683 43.4724 18.8996 38.4817C19.9391 33.863 22.0794 29.5233 25.198 25.9896C25.6261 25.4936 27.2465 23.8817 27.7357 23.5407C28.1332 23.2927 28.653 23.0448 29.9371 23.2927C32.0162 23.7267 35.5018 24.7496 39.2319 27.0745C44.2157 30.1743 47.0591 33.615 47.9458 34.731C48.649 35.6299 48.6796 36.2499 48.5573 37.2418C48.1293 41.4265 46.5394 45.8282 45.4081 48.1841ZM43.3901 18.1781C43.6347 18.2091 43.9099 18.2711 44.2768 18.767C44.98 19.759 46.1419 21.7738 46.6005 22.8278C47.426 24.8116 48.0681 27.3535 48.3433 28.6244C48.4044 28.9344 48.1598 28.8724 48.0681 28.8104C47.7929 28.5004 47.212 28.0044 47.0286 27.8494C46.1725 26.9815 43.6959 24.9666 40.7913 23.2617C38.1924 21.7428 35.1349 20.5029 33.8813 20.162C33.7284 20.131 33.6673 19.883 33.8507 19.79C34.4011 19.542 36.1744 18.86 38.3147 18.4571C39.9657 18.1471 41.8308 18.0231 43.3901 18.1781ZM4.13187 46.6962C3.06174 40.0316 5.04911 33.4911 9.36019 29.2443C11.6839 26.9505 14.4968 25.1216 17.5849 24.0987C18.5021 23.7887 20.1532 23.3547 21.2539 23.1687C21.5596 23.1377 21.6513 23.5097 21.4679 23.6957C20.4283 24.8116 18.9607 27.1365 18.5021 27.9114C14.9248 33.956 13.3655 41.2405 14.0993 48.2461C14.986 56.8945 19.2053 62.1021 19.878 63.0011C20.0309 63.2181 20.1837 63.59 19.8474 63.652C19.7863 63.652 19.4499 63.59 18.9607 63.497C9.39076 61.3582 5.14084 52.9267 4.13187 46.6962ZM31.3436 66.9378C30.9767 66.7828 31.0073 66.5038 31.3436 66.3798C32.2914 66.0389 34.0342 65.3259 34.8597 64.8609C36.5108 63.962 38.0701 62.8771 39.5071 61.6372C40.2409 61.0172 41.8002 59.5913 42.7175 58.5064C43.0232 58.1344 43.543 57.4834 44.552 57.3595C46.5088 57.1425 47.0897 57.0495 48.4656 56.7085C49.7803 56.3675 52.0429 55.5616 53.541 54.7246C53.7245 54.6316 54.0302 54.7246 53.9385 55.1896C53.2659 58.5684 50.9422 63.776 46.784 66.4418C41.9837 69.6036 36.3885 69.2626 31.3436 66.9378ZM57.9744 43.4104C57.7298 43.8134 57.3629 43.7204 57.21 43.3794C57.0877 43.0074 56.9348 42.4804 56.8125 42.1085C56.1705 40.3106 55.3755 38.5437 54.3971 36.9008C53.9079 36.0949 53.3882 35.2579 52.7767 34.359C52.4098 33.801 52.4098 33.5221 52.4098 32.8401C52.3792 28.9654 51.1868 23.6337 49.2911 20.1929C49.1077 19.852 49.3828 19.635 49.5969 19.728C54.7029 22.1148 57.4546 25.6176 58.7694 28.9344C61.7045 36.3119 59.2891 41.2095 57.9744 43.4104Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84.3488 38.2041C84.3488 35.8482 82.5448 34.7323 80.1906 34.7323H76.6133V45.7366H78.937V41.7998H79.9154C82.6366 41.7998 84.3488 40.5909 84.3488 38.2041ZM82.0251 38.2351C82.0251 39.444 81.4136 40.064 79.946 40.064H78.937V36.5302H80.0071C81.4441 36.4992 82.0251 37.1192 82.0251 38.2351ZM86.9171 42.2028H91.9313C92.2065 39.227 90.9835 37.4911 88.5069 37.4911C86.3055 37.4911 84.5934 39.134 84.5934 41.6759C84.5934 44.2487 86.0915 45.9226 88.7515 45.9226C90.372 45.9226 91.1975 45.4576 91.7173 45.1476L91.0141 43.7217C90.6166 43.9077 90.0357 44.2797 88.935 44.2797C87.6509 44.2797 87.0394 43.4427 86.9171 42.2028ZM86.9171 40.7149C87.0699 39.661 87.5897 39.072 88.5069 39.072C89.4853 39.072 89.8522 39.816 89.8828 40.7149H86.9171ZM98.4744 37.7081C98.2909 37.6151 97.9852 37.4911 97.4043 37.4911C96.3953 37.4911 95.7532 38.1731 95.4169 38.793V37.7081H93.2461V45.7366H95.4169V40.6839C95.6003 40.3119 96.1813 39.475 97.1291 39.475C97.5877 39.475 97.8323 39.568 97.9546 39.661L98.4744 37.7081ZM102.052 39.32H103.947V37.6771H102.052V37.0262C102.052 35.9722 102.449 35.4453 103.336 35.4453C103.917 35.4453 104.284 35.6003 104.437 35.6623L104.926 34.0194C104.742 33.8954 104.161 33.6474 102.999 33.6474C100.982 33.6474 99.8808 34.9493 99.8808 36.8712V37.7081H98.6884V39.351H99.8808V45.7676H102.052V39.32ZM112.294 41.6449C112.294 39.568 111.041 37.4601 108.289 37.4601C105.537 37.4601 104.345 39.63 104.345 41.7069C104.345 43.7837 105.537 45.8916 108.32 45.8916C111.071 45.9226 112.294 43.6907 112.294 41.6449ZM110.001 41.7378C110.001 43.2257 109.573 44.2487 108.32 44.2487C107.097 44.2487 106.607 43.1638 106.607 41.6449C106.607 40.157 107.005 39.103 108.228 39.103C109.481 39.103 110.001 40.219 110.001 41.7378ZM118.654 37.7081C118.47 37.6151 118.165 37.4911 117.584 37.4911C116.575 37.4911 115.933 38.1731 115.596 38.793V37.7081H113.426V45.7366H115.596V40.6839C115.78 40.3119 116.361 39.475 117.309 39.475C117.767 39.475 118.012 39.568 118.134 39.661L118.654 37.7081ZM125.961 38.7621C125.656 38.0181 125.044 37.4911 123.913 37.4911C122.629 37.4911 121.956 38.2041 121.528 38.6691V37.6771H119.418V45.7056H121.589V40.281C121.742 40.064 122.262 39.289 123.057 39.289C123.699 39.289 123.974 39.692 123.974 40.4979V45.6746H126.145V40.188C126.45 39.816 126.94 39.289 127.612 39.289C128.316 39.289 128.56 39.723 128.56 40.4979V45.6746H130.731V40.033C130.731 38.5451 130.15 37.4291 128.468 37.4291C127.337 37.4911 126.603 37.9871 125.961 38.7621ZM134.583 37.6771H132.413V45.7056H134.583V37.6771ZM134.828 35.3213C134.828 34.6393 134.247 34.0194 133.483 34.0194C132.718 34.0194 132.168 34.6083 132.168 35.3213C132.168 36.0342 132.718 36.6542 133.483 36.6542C134.247 36.6542 134.828 36.0342 134.828 35.3213ZM143.542 45.7056V40.064C143.542 38.5761 142.9 37.4601 141.157 37.4601C139.842 37.4601 139.047 38.1731 138.619 38.6691V37.6771H136.51V45.7056H138.68V40.312C138.833 40.095 139.475 39.32 140.301 39.32C141.096 39.32 141.371 39.723 141.371 40.5289V45.7056H143.542ZM149.626 37.6771C149.229 37.5531 148.74 37.4911 148.22 37.4911C146.018 37.4911 144.704 38.6691 144.704 40.4049C144.704 41.4589 145.224 42.2958 146.11 42.8228C145.652 43.1018 145.224 43.5667 145.224 44.3417C145.224 44.9306 145.499 45.3026 145.927 45.5506C145.132 45.9846 144.581 46.6355 144.581 47.5035C144.581 48.9604 145.896 49.6423 148.067 49.6423C150.666 49.6423 152.409 48.4334 152.409 46.7285C152.409 44.3417 150.33 44.3417 148.678 44.2487C147.547 44.1867 147.089 44.0937 147.089 43.6597C147.089 43.4427 147.241 43.2877 147.394 43.1948C147.7 43.2568 148.006 43.2877 148.342 43.2877C150.544 43.2877 151.767 42.1098 151.767 40.3739C151.767 39.909 151.675 39.475 151.461 39.072H152.531V37.6461H149.626V37.6771ZM148.22 41.8928C147.333 41.8928 146.783 41.3349 146.783 40.4049C146.783 39.475 147.333 38.917 148.22 38.917C149.107 38.917 149.657 39.475 149.657 40.4049C149.657 41.3349 149.137 41.8928 148.22 41.8928ZM147.303 45.9846C147.639 46.0466 148.006 46.0776 148.373 46.1086C149.535 46.2016 150.268 46.1706 150.268 47.0075C150.268 47.6894 149.535 48.1854 148.189 48.1854C147.089 48.1854 146.63 47.7515 146.63 47.1005C146.661 46.6355 146.875 46.2635 147.303 45.9846ZM159.166 43.6597H163.507L164.241 45.7366H166.748L162.498 34.7323H160.266L156.139 45.7366H158.462L159.166 43.6597ZM162.835 41.7998H159.808L160.725 39.165C161.061 38.2351 161.275 37.3981 161.306 37.2742H161.337C161.367 37.3981 161.581 38.2351 161.917 39.165L162.835 41.7998ZM172.772 37.7081C172.588 37.6151 172.282 37.4911 171.701 37.4911C170.692 37.4911 170.05 38.1731 169.714 38.793V37.7081H167.543V45.7366H169.714V40.6839C169.898 40.3119 170.478 39.475 171.426 39.475C171.885 39.475 172.13 39.568 172.252 39.661L172.772 37.7081ZM174.27 39.32V43.4117C174.27 44.9616 174.912 45.9226 176.777 45.9226C177.755 45.9226 178.428 45.6436 178.764 45.4576L178.275 43.8147C178.122 43.9077 177.694 44.1247 177.236 44.1247C176.624 44.1247 176.441 43.7837 176.441 42.9778V39.32H178.306V37.6771H176.441V35.3523H174.3V37.6771H173.016V39.32H174.27ZM185.002 43.3497C185.002 41.9858 184.084 41.4279 182.831 40.9009C181.913 40.5289 181.21 40.3739 181.21 39.847C181.21 39.413 181.547 39.134 182.311 39.134C183.075 39.134 183.687 39.444 183.993 39.661L184.757 38.1731C184.39 37.9561 183.565 37.5221 182.219 37.5221C180.415 37.5221 179.253 38.4831 179.253 39.971C179.253 41.1799 179.926 41.8308 181.027 42.3578C182.158 42.9158 183.014 43.0398 183.014 43.5977C183.014 44.0627 182.556 44.3107 181.699 44.3107C180.813 44.3107 180.048 43.8767 179.743 43.6597L179.009 45.1786C179.498 45.5196 180.415 45.9226 181.822 45.9226C183.84 45.9226 185.002 45.0236 185.002 43.3497Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M76.7197 29.7333H81.948V28.9584H77.6064V18.7291H76.7197V29.7333ZM83.966 20.217C84.3329 20.217 84.6081 19.907 84.6081 19.535C84.6081 19.1631 84.3023 18.8841 83.966 18.8841C83.6297 18.8841 83.3239 19.1631 83.3239 19.535C83.3239 19.907 83.5991 20.217 83.966 20.217ZM83.5379 29.7333H84.394V21.8599H83.5379V29.7333ZM89.1026 29.9193C91.4874 29.9193 92.955 27.9975 92.955 25.7656C92.955 23.4718 91.8849 21.6739 89.6529 21.6739C88.858 21.6739 88.0936 22.0459 87.6044 22.5728V17.8301H86.7483V29.2994C87.3292 29.6714 88.1853 29.9193 89.1026 29.9193ZM89.1332 29.1754C88.5217 29.1754 87.9713 29.0514 87.6044 28.8654V23.3478C88.0325 22.8518 88.8274 22.4488 89.5001 22.4488C91.3957 22.4488 92.0378 24.0917 92.0378 25.7966C92.0684 27.4395 91.1205 29.1754 89.1332 29.1754ZM94.9118 29.7333H95.7679V24.2467C95.982 23.7817 96.6852 22.5108 97.7553 22.5108C98.0916 22.5108 98.2751 22.5728 98.3974 22.6348L98.6114 21.8289C98.4891 21.7669 98.2139 21.7049 97.8776 21.7049C96.7769 21.7049 96.0737 22.6658 95.7985 23.2548V21.8909H94.9118V29.7333ZM101.516 29.9193C102.433 29.9193 103.32 29.4544 103.87 28.7414C103.901 29.0204 103.931 29.4854 103.993 29.7333H104.849C104.757 29.3924 104.696 28.8344 104.696 28.1524V24.1847C104.696 22.4798 103.809 21.6739 102.219 21.6739C101.21 21.6739 100.354 22.0149 99.6815 22.6658L100.14 23.2548C100.782 22.6348 101.424 22.4178 102.158 22.4178C103.32 22.4178 103.87 23.0068 103.87 24.2777V25.1766H103.503C101.699 25.1766 99.4064 25.7656 99.4064 27.8735C99.3452 29.1134 100.232 29.9193 101.516 29.9193ZM101.638 29.1754C100.966 29.1754 100.232 28.7104 100.232 27.8425C100.232 26.3856 101.699 25.8586 103.442 25.8586H103.809V27.9665C103.228 28.7414 102.494 29.1754 101.638 29.1754ZM106.958 29.7333H107.814V24.2467C108.029 23.7817 108.732 22.5108 109.802 22.5108C110.138 22.5108 110.322 22.5728 110.444 22.6348L110.658 21.8289C110.536 21.7669 110.26 21.7049 109.924 21.7049C108.823 21.7049 108.12 22.6658 107.845 23.2548V21.8909H106.989V29.7333H106.958ZM111.728 33.5151C113.41 33.5151 114.021 32.3372 114.572 30.8493L117.904 21.8289H117.018L114.633 28.5864L112.187 21.8289H111.269L114.174 29.6403L113.777 30.7563C113.318 31.9962 112.859 32.7401 111.728 32.7401C111.422 32.7401 111.3 32.7091 111.178 32.6781L111.055 33.3911C111.208 33.4841 111.392 33.5151 111.728 33.5151ZM123.316 29.7333H124.142V22.5418H126.159V21.8599H124.142V20.62C124.142 19.1941 124.722 18.4501 125.915 18.4501C126.373 18.4501 126.74 18.5741 126.893 18.6671L127.107 17.9231C126.893 17.8301 126.496 17.7061 125.915 17.7061C124.203 17.7061 123.285 18.7911 123.285 20.589V21.9219H121.94V22.6038H123.285V29.7333H123.316ZM130.195 29.9193C132.641 29.9193 133.742 27.7495 133.742 25.7656C133.742 23.8127 132.611 21.6739 130.165 21.6739C127.719 21.6739 126.679 23.8127 126.679 25.7966C126.71 27.7805 127.78 29.9193 130.195 29.9193ZM130.226 29.1754C128.483 29.1754 127.596 27.5635 127.596 25.7656C127.596 23.9987 128.391 22.4178 130.165 22.4178C131.938 22.4178 132.855 24.0297 132.855 25.7966C132.855 27.5945 131.999 29.1754 130.226 29.1754ZM135.699 29.7333H136.555V24.2467C136.769 23.7817 137.472 22.5108 138.542 22.5108C138.879 22.5108 139.062 22.5728 139.184 22.6348L139.398 21.8289C139.276 21.7669 139.001 21.7049 138.665 21.7049C137.564 21.7049 136.861 22.6658 136.586 23.2548V21.8909H135.729V29.7333H135.699ZM146.492 29.9193C147.226 29.9193 147.776 29.6094 147.99 29.4544L147.654 28.8034C147.501 28.9274 147.042 29.1754 146.584 29.1754C145.88 29.1754 145.636 28.7414 145.636 27.9355V22.5728H147.623V21.8909H145.636V19.628H144.78V21.8599H143.465V22.5418H144.78V27.9665C144.78 29.2064 145.33 29.9193 146.492 29.9193ZM149.641 29.7333H150.497V23.9987C150.772 23.5648 151.72 22.4488 152.882 22.4488C154.044 22.4488 154.472 23.1618 154.472 24.3397V29.7333H155.328V24.1537C155.328 22.7278 154.686 21.6739 153.065 21.6739C151.751 21.6739 150.864 22.5728 150.497 23.0998V17.8301H149.641V29.7333ZM160.709 29.9193C161.963 29.9193 162.849 29.4854 163.339 29.1134L162.972 28.4314C162.544 28.7724 161.718 29.1754 160.74 29.1754C158.875 29.1754 158.141 27.5325 158.11 25.7346V25.5486H163.461C163.492 25.3936 163.492 25.2696 163.492 25.1147C163.492 23.0998 162.421 21.6739 160.556 21.6739C158.477 21.6739 157.224 23.5028 157.224 25.7036C157.224 27.9975 158.324 29.9193 160.709 29.9193ZM158.171 24.8357C158.385 23.4718 159.18 22.4178 160.526 22.4178C161.993 22.4178 162.605 23.6267 162.635 24.8357H158.171Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M76.6868 12.6878H77.5124V3.14047L84.0248 12.6878H84.8503V1.68357H83.9942V11.1689L77.5429 1.68357H76.6562V12.6878H76.6868ZM89.8646 12.8428C91.1182 12.8428 92.0049 12.4088 92.4941 12.0369L92.1272 11.3549C91.6991 11.6959 90.8736 12.0989 89.8952 12.0989C88.0301 12.0989 87.2963 10.456 87.2658 8.6581V8.47211H92.6164C92.647 8.31712 92.647 8.19313 92.647 8.03814C92.647 6.02328 91.5768 4.59737 89.7118 4.59737C87.6327 4.59737 86.3791 6.42625 86.3791 8.6271C86.3791 10.9209 87.4798 12.8428 89.8646 12.8428ZM87.3269 7.79015C87.5409 6.42624 88.3359 5.37232 89.6812 5.37232C91.1488 5.37232 91.7603 6.58123 91.7909 7.79015H87.3269ZM95.8268 12.6878H96.6217L98.7314 6.05428L100.841 12.6878H101.636L103.99 4.81436H103.134L101.239 11.3859L99.19 4.81436H98.3645L96.316 11.3549L94.4203 4.81436H93.5031L95.8268 12.6878ZM111.084 12.6878H111.97V8.53411L115.578 1.68357H114.661L111.573 7.63516H111.542L108.454 1.68357H107.445L111.084 8.53411V12.6878ZM118.177 12.8428C120.623 12.8428 121.724 10.673 121.724 8.6891C121.724 6.73623 120.592 4.59737 118.146 4.59737C115.701 4.59737 114.661 6.73622 114.661 8.72009C114.661 10.735 115.731 12.8428 118.177 12.8428ZM118.177 12.0989C116.404 12.0989 115.548 10.487 115.548 8.6891C115.548 6.92222 116.343 5.34132 118.116 5.34132C119.889 5.34132 120.807 6.95321 120.807 8.72009C120.807 10.518 119.95 12.0989 118.177 12.0989ZM123.344 12.6878H124.2V7.20119C124.414 6.73623 125.118 5.46531 126.188 5.46531C126.524 5.46531 126.707 5.52731 126.83 5.58931L127.044 4.78336C126.922 4.72136 126.646 4.65937 126.31 4.65937C125.209 4.65937 124.506 5.62031 124.231 6.20927V4.84536H123.344V12.6878ZM133.067 12.6878H134.137L130.529 8.25512L133.954 4.81436H132.884L129.49 8.25512L133.067 12.6878ZM128.542 12.6878H129.398V0.815626H128.542V12.6878ZM139.549 12.6878H140.436V8.00714H141.812C144.258 8.00714 145.633 6.76723 145.633 4.78336C145.633 2.83049 144.196 1.68357 141.934 1.68357H139.549V12.6878ZM140.436 7.23219V2.45852H141.812C143.891 2.45852 144.686 3.45045 144.686 4.81436C144.686 6.27126 143.829 7.23219 141.781 7.23219H140.436ZM149.302 12.8428C150.617 12.8428 151.504 11.9749 151.871 11.3859C151.871 11.8199 151.932 12.4088 151.993 12.6878H152.849C152.757 12.3779 152.696 11.7889 152.696 11.1689V4.81436H151.84V10.518C151.565 10.9829 150.617 12.0989 149.455 12.0989C148.263 12.0989 147.865 11.3549 147.865 10.208V4.81436H147.009V10.363C147.009 11.7889 147.651 12.8428 149.302 12.8428ZM157.374 12.8428C159.759 12.8428 161.227 10.9209 161.227 8.6891C161.227 6.39525 160.157 4.59737 157.925 4.59737C157.13 4.59737 156.365 4.96934 155.876 5.49631V0.753632H155.02V12.2229C155.57 12.6258 156.426 12.8428 157.374 12.8428ZM157.405 12.0989C156.793 12.0989 156.243 11.9749 155.907 11.7889V6.30226C156.335 5.80629 157.13 5.40332 157.802 5.40332C159.698 5.40332 160.34 7.04621 160.34 8.75109C160.309 10.394 159.362 12.0989 157.405 12.0989ZM162.847 12.6878H163.703V0.815626H162.847V12.6878ZM166.577 3.14047C166.944 3.14047 167.219 2.83049 167.219 2.45852C167.219 2.08654 166.914 1.80756 166.577 1.80756C166.241 1.80756 165.935 2.08654 165.935 2.45852C165.935 2.86149 166.241 3.14047 166.577 3.14047ZM166.149 12.6878H167.005V4.81436H166.149V12.6878ZM172.05 12.8428C173.212 12.8428 174.038 12.4088 174.466 12.0369L174.099 11.3859C173.762 11.6959 172.998 12.0989 172.111 12.0989C170.399 12.0989 169.635 10.425 169.635 8.6891C169.635 6.86022 170.43 5.34132 172.142 5.34132C172.998 5.34132 173.579 5.6823 174.038 6.05428L174.466 5.43432C174.038 5.06234 173.304 4.59737 172.142 4.59737C170.155 4.59737 168.718 6.20926 168.718 8.72009C168.718 10.8589 169.818 12.8428 172.05 12.8428Z"
    })), $0422a6ce4ea03acc$var$jz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 186 74",
        fill: "#ffffff",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M44.4297 13.7454C41.1276 10.8316 37.428 8.9097 32.9029 8.16575C27.3383 7.23582 23.2107 8.56872 20.8564 9.34367C20.3672 9.49866 20.306 9.80865 20.306 10.2116C20.2755 11.2345 20.7035 12.0405 21.0398 12.3505C21.4067 12.6915 21.7736 12.5055 22.324 12.3195C24.4948 11.5755 27.4911 11.0486 30.6404 11.4205C33.6367 11.7615 36.419 12.6914 38.4981 13.8694C35.5629 14.3033 31.1601 15.4503 26.5433 18.829C22.752 18.6121 17.9823 19.139 12.6929 21.8358C2.66427 26.9195 -3.63418 39.8456 2.29737 53.9187C4.71279 59.6223 10.1857 64.8919 16.5759 66.7828C20.306 67.8987 23.6387 67.8057 24.5254 67.7438C24.8006 67.9607 25.2592 68.3017 25.8095 68.6737C34.768 74.6873 43.0232 73.4784 47.8847 70.7815C52.3486 68.3017 58.2802 62.0711 58.4636 51.2219C66.7494 43.1314 65.1901 33.801 64.0894 29.8333C61.4905 20.3789 52.8072 14.3963 44.4297 13.7454ZM53.9691 47.2231C53.9997 47.9361 53.6939 48.2461 52.8684 48.835C51.7677 49.61 50.0861 50.5399 48.435 51.0669C48.221 51.1289 48.1293 50.8809 48.1904 50.7259C48.4044 50.3229 48.7102 49.703 48.8936 49.3C49.2605 48.494 49.6274 47.6571 49.9332 46.8512C50.5753 45.1773 51.2173 43.0074 51.6148 41.2405C51.676 40.9616 51.8594 40.9306 51.9511 41.0855C52.1346 41.3645 52.7461 42.7594 53.1741 44.1543C53.6328 45.6422 53.9385 46.8202 53.9691 47.2231ZM45.4081 48.1841C44.766 49.517 44.1851 50.6329 43.5736 51.4078C43.2067 51.8728 40.7913 52.7098 36.3273 50.7879C33.2087 49.455 31.4353 48.0601 28.7753 44.5263C28.1638 43.6894 27.6746 42.9764 27.3383 42.4495C26.9714 41.8605 26.7879 41.3955 25.7484 41.6125C24.984 41.7675 23.3635 42.4184 22.4769 43.7514C22.1405 44.2783 22.3851 44.7123 22.6909 45.2083C23.2718 46.2002 24.1585 47.3781 24.984 48.3701C27.8886 51.9038 31.5576 54.8796 35.8687 56.3675C36.4496 56.5535 37.5503 56.8635 38.0395 56.9875C38.3758 57.0805 38.5287 57.4834 38.3453 57.6694C37.214 58.9093 34.2788 60.9242 33.3921 61.3892C31.2519 62.5051 29.081 63.2801 27.4606 63.528C26.9102 63.621 26.3904 63.714 25.6261 63.0631C24.6782 62.2261 23.8222 61.2342 23.0578 60.2423C21.5596 58.2584 20.3978 55.9955 19.6028 53.6397C17.9518 48.773 17.7683 43.4724 18.8996 38.4817C19.9391 33.863 22.0794 29.5233 25.198 25.9896C25.6261 25.4936 27.2465 23.8817 27.7357 23.5407C28.1332 23.2927 28.653 23.0448 29.9371 23.2927C32.0162 23.7267 35.5018 24.7496 39.2319 27.0745C44.2157 30.1743 47.0591 33.615 47.9458 34.731C48.649 35.6299 48.6796 36.2499 48.5573 37.2418C48.1293 41.4265 46.5394 45.8282 45.4081 48.1841ZM43.3901 18.1781C43.6347 18.2091 43.9099 18.2711 44.2768 18.767C44.98 19.759 46.1419 21.7738 46.6005 22.8278C47.426 24.8116 48.0681 27.3535 48.3433 28.6244C48.4044 28.9344 48.1598 28.8724 48.0681 28.8104C47.7929 28.5004 47.212 28.0044 47.0286 27.8494C46.1725 26.9815 43.6959 24.9666 40.7913 23.2617C38.1924 21.7428 35.1349 20.5029 33.8813 20.162C33.7284 20.131 33.6673 19.883 33.8507 19.79C34.4011 19.542 36.1744 18.86 38.3147 18.4571C39.9657 18.1471 41.8308 18.0231 43.3901 18.1781ZM4.13187 46.6962C3.06174 40.0316 5.04911 33.4911 9.36019 29.2443C11.6839 26.9505 14.4968 25.1216 17.5849 24.0987C18.5021 23.7887 20.1532 23.3547 21.2539 23.1687C21.5596 23.1377 21.6513 23.5097 21.4679 23.6957C20.4283 24.8116 18.9607 27.1365 18.5021 27.9114C14.9248 33.956 13.3655 41.2405 14.0993 48.2461C14.986 56.8945 19.2053 62.1021 19.878 63.0011C20.0309 63.2181 20.1837 63.59 19.8474 63.652C19.7863 63.652 19.4499 63.59 18.9607 63.497C9.39076 61.3582 5.14084 52.9267 4.13187 46.6962ZM31.3436 66.9378C30.9767 66.7828 31.0073 66.5038 31.3436 66.3798C32.2914 66.0389 34.0342 65.3259 34.8597 64.8609C36.5108 63.962 38.0701 62.8771 39.5071 61.6372C40.2409 61.0172 41.8002 59.5913 42.7175 58.5064C43.0232 58.1344 43.543 57.4834 44.552 57.3595C46.5088 57.1425 47.0897 57.0495 48.4656 56.7085C49.7803 56.3675 52.0429 55.5616 53.541 54.7246C53.7245 54.6316 54.0302 54.7246 53.9385 55.1896C53.2659 58.5684 50.9422 63.776 46.784 66.4418C41.9837 69.6036 36.3885 69.2626 31.3436 66.9378ZM57.9744 43.4104C57.7298 43.8134 57.3629 43.7204 57.21 43.3794C57.0877 43.0074 56.9348 42.4804 56.8125 42.1085C56.1705 40.3106 55.3755 38.5437 54.3971 36.9008C53.9079 36.0949 53.3882 35.2579 52.7767 34.359C52.4098 33.801 52.4098 33.5221 52.4098 32.8401C52.3792 28.9654 51.1868 23.6337 49.2911 20.1929C49.1077 19.852 49.3828 19.635 49.5969 19.728C54.7029 22.1148 57.4546 25.6176 58.7694 28.9344C61.7045 36.3119 59.2891 41.2095 57.9744 43.4104Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84.3488 38.2041C84.3488 35.8482 82.5448 34.7323 80.1906 34.7323H76.6133V45.7366H78.937V41.7998H79.9154C82.6366 41.7998 84.3488 40.5909 84.3488 38.2041ZM82.0251 38.2351C82.0251 39.444 81.4136 40.064 79.946 40.064H78.937V36.5302H80.0071C81.4441 36.4992 82.0251 37.1192 82.0251 38.2351ZM86.9171 42.2028H91.9313C92.2065 39.227 90.9835 37.4911 88.5069 37.4911C86.3055 37.4911 84.5934 39.134 84.5934 41.6759C84.5934 44.2487 86.0915 45.9226 88.7515 45.9226C90.372 45.9226 91.1975 45.4576 91.7173 45.1476L91.0141 43.7217C90.6166 43.9077 90.0357 44.2797 88.935 44.2797C87.6509 44.2797 87.0394 43.4427 86.9171 42.2028ZM86.9171 40.7149C87.0699 39.661 87.5897 39.072 88.5069 39.072C89.4853 39.072 89.8522 39.816 89.8828 40.7149H86.9171ZM98.4744 37.7081C98.2909 37.6151 97.9852 37.4911 97.4043 37.4911C96.3953 37.4911 95.7532 38.1731 95.4169 38.793V37.7081H93.2461V45.7366H95.4169V40.6839C95.6003 40.3119 96.1813 39.475 97.1291 39.475C97.5877 39.475 97.8323 39.568 97.9546 39.661L98.4744 37.7081ZM102.052 39.32H103.947V37.6771H102.052V37.0262C102.052 35.9722 102.449 35.4453 103.336 35.4453C103.917 35.4453 104.284 35.6003 104.437 35.6623L104.926 34.0194C104.742 33.8954 104.161 33.6474 102.999 33.6474C100.982 33.6474 99.8808 34.9493 99.8808 36.8712V37.7081H98.6884V39.351H99.8808V45.7676H102.052V39.32ZM112.294 41.6449C112.294 39.568 111.041 37.4601 108.289 37.4601C105.537 37.4601 104.345 39.63 104.345 41.7069C104.345 43.7837 105.537 45.8916 108.32 45.8916C111.071 45.9226 112.294 43.6907 112.294 41.6449ZM110.001 41.7378C110.001 43.2257 109.573 44.2487 108.32 44.2487C107.097 44.2487 106.607 43.1638 106.607 41.6449C106.607 40.157 107.005 39.103 108.228 39.103C109.481 39.103 110.001 40.219 110.001 41.7378ZM118.654 37.7081C118.47 37.6151 118.165 37.4911 117.584 37.4911C116.575 37.4911 115.933 38.1731 115.596 38.793V37.7081H113.426V45.7366H115.596V40.6839C115.78 40.3119 116.361 39.475 117.309 39.475C117.767 39.475 118.012 39.568 118.134 39.661L118.654 37.7081ZM125.961 38.7621C125.656 38.0181 125.044 37.4911 123.913 37.4911C122.629 37.4911 121.956 38.2041 121.528 38.6691V37.6771H119.418V45.7056H121.589V40.281C121.742 40.064 122.262 39.289 123.057 39.289C123.699 39.289 123.974 39.692 123.974 40.4979V45.6746H126.145V40.188C126.45 39.816 126.94 39.289 127.612 39.289C128.316 39.289 128.56 39.723 128.56 40.4979V45.6746H130.731V40.033C130.731 38.5451 130.15 37.4291 128.468 37.4291C127.337 37.4911 126.603 37.9871 125.961 38.7621ZM134.583 37.6771H132.413V45.7056H134.583V37.6771ZM134.828 35.3213C134.828 34.6393 134.247 34.0194 133.483 34.0194C132.718 34.0194 132.168 34.6083 132.168 35.3213C132.168 36.0342 132.718 36.6542 133.483 36.6542C134.247 36.6542 134.828 36.0342 134.828 35.3213ZM143.542 45.7056V40.064C143.542 38.5761 142.9 37.4601 141.157 37.4601C139.842 37.4601 139.047 38.1731 138.619 38.6691V37.6771H136.51V45.7056H138.68V40.312C138.833 40.095 139.475 39.32 140.301 39.32C141.096 39.32 141.371 39.723 141.371 40.5289V45.7056H143.542ZM149.626 37.6771C149.229 37.5531 148.74 37.4911 148.22 37.4911C146.018 37.4911 144.704 38.6691 144.704 40.4049C144.704 41.4589 145.224 42.2958 146.11 42.8228C145.652 43.1018 145.224 43.5667 145.224 44.3417C145.224 44.9306 145.499 45.3026 145.927 45.5506C145.132 45.9846 144.581 46.6355 144.581 47.5035C144.581 48.9604 145.896 49.6423 148.067 49.6423C150.666 49.6423 152.409 48.4334 152.409 46.7285C152.409 44.3417 150.33 44.3417 148.678 44.2487C147.547 44.1867 147.089 44.0937 147.089 43.6597C147.089 43.4427 147.241 43.2877 147.394 43.1948C147.7 43.2568 148.006 43.2877 148.342 43.2877C150.544 43.2877 151.767 42.1098 151.767 40.3739C151.767 39.909 151.675 39.475 151.461 39.072H152.531V37.6461H149.626V37.6771ZM148.22 41.8928C147.333 41.8928 146.783 41.3349 146.783 40.4049C146.783 39.475 147.333 38.917 148.22 38.917C149.107 38.917 149.657 39.475 149.657 40.4049C149.657 41.3349 149.137 41.8928 148.22 41.8928ZM147.303 45.9846C147.639 46.0466 148.006 46.0776 148.373 46.1086C149.535 46.2016 150.268 46.1706 150.268 47.0075C150.268 47.6894 149.535 48.1854 148.189 48.1854C147.089 48.1854 146.63 47.7515 146.63 47.1005C146.661 46.6355 146.875 46.2635 147.303 45.9846ZM159.166 43.6597H163.507L164.241 45.7366H166.748L162.498 34.7323H160.266L156.139 45.7366H158.462L159.166 43.6597ZM162.835 41.7998H159.808L160.725 39.165C161.061 38.2351 161.275 37.3981 161.306 37.2742H161.337C161.367 37.3981 161.581 38.2351 161.917 39.165L162.835 41.7998ZM172.772 37.7081C172.588 37.6151 172.282 37.4911 171.701 37.4911C170.692 37.4911 170.05 38.1731 169.714 38.793V37.7081H167.543V45.7366H169.714V40.6839C169.898 40.3119 170.478 39.475 171.426 39.475C171.885 39.475 172.13 39.568 172.252 39.661L172.772 37.7081ZM174.27 39.32V43.4117C174.27 44.9616 174.912 45.9226 176.777 45.9226C177.755 45.9226 178.428 45.6436 178.764 45.4576L178.275 43.8147C178.122 43.9077 177.694 44.1247 177.236 44.1247C176.624 44.1247 176.441 43.7837 176.441 42.9778V39.32H178.306V37.6771H176.441V35.3523H174.3V37.6771H173.016V39.32H174.27ZM185.002 43.3497C185.002 41.9858 184.084 41.4279 182.831 40.9009C181.913 40.5289 181.21 40.3739 181.21 39.847C181.21 39.413 181.547 39.134 182.311 39.134C183.075 39.134 183.687 39.444 183.993 39.661L184.757 38.1731C184.39 37.9561 183.565 37.5221 182.219 37.5221C180.415 37.5221 179.253 38.4831 179.253 39.971C179.253 41.1799 179.926 41.8308 181.027 42.3578C182.158 42.9158 183.014 43.0398 183.014 43.5977C183.014 44.0627 182.556 44.3107 181.699 44.3107C180.813 44.3107 180.048 43.8767 179.743 43.6597L179.009 45.1786C179.498 45.5196 180.415 45.9226 181.822 45.9226C183.84 45.9226 185.002 45.0236 185.002 43.3497Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M76.7197 29.7333H81.948V28.9584H77.6064V18.7291H76.7197V29.7333ZM83.966 20.217C84.3329 20.217 84.6081 19.907 84.6081 19.535C84.6081 19.1631 84.3023 18.8841 83.966 18.8841C83.6297 18.8841 83.3239 19.1631 83.3239 19.535C83.3239 19.907 83.5991 20.217 83.966 20.217ZM83.5379 29.7333H84.394V21.8599H83.5379V29.7333ZM89.1026 29.9193C91.4874 29.9193 92.955 27.9975 92.955 25.7656C92.955 23.4718 91.8849 21.6739 89.6529 21.6739C88.858 21.6739 88.0936 22.0459 87.6044 22.5728V17.8301H86.7483V29.2994C87.3292 29.6714 88.1853 29.9193 89.1026 29.9193ZM89.1332 29.1754C88.5217 29.1754 87.9713 29.0514 87.6044 28.8654V23.3478C88.0325 22.8518 88.8274 22.4488 89.5001 22.4488C91.3957 22.4488 92.0378 24.0917 92.0378 25.7966C92.0684 27.4395 91.1205 29.1754 89.1332 29.1754ZM94.9118 29.7333H95.7679V24.2467C95.982 23.7817 96.6852 22.5108 97.7553 22.5108C98.0916 22.5108 98.2751 22.5728 98.3974 22.6348L98.6114 21.8289C98.4891 21.7669 98.2139 21.7049 97.8776 21.7049C96.7769 21.7049 96.0737 22.6658 95.7985 23.2548V21.8909H94.9118V29.7333ZM101.516 29.9193C102.433 29.9193 103.32 29.4544 103.87 28.7414C103.901 29.0204 103.931 29.4854 103.993 29.7333H104.849C104.757 29.3924 104.696 28.8344 104.696 28.1524V24.1847C104.696 22.4798 103.809 21.6739 102.219 21.6739C101.21 21.6739 100.354 22.0149 99.6815 22.6658L100.14 23.2548C100.782 22.6348 101.424 22.4178 102.158 22.4178C103.32 22.4178 103.87 23.0068 103.87 24.2777V25.1766H103.503C101.699 25.1766 99.4064 25.7656 99.4064 27.8735C99.3452 29.1134 100.232 29.9193 101.516 29.9193ZM101.638 29.1754C100.966 29.1754 100.232 28.7104 100.232 27.8425C100.232 26.3856 101.699 25.8586 103.442 25.8586H103.809V27.9665C103.228 28.7414 102.494 29.1754 101.638 29.1754ZM106.958 29.7333H107.814V24.2467C108.029 23.7817 108.732 22.5108 109.802 22.5108C110.138 22.5108 110.322 22.5728 110.444 22.6348L110.658 21.8289C110.536 21.7669 110.26 21.7049 109.924 21.7049C108.823 21.7049 108.12 22.6658 107.845 23.2548V21.8909H106.989V29.7333H106.958ZM111.728 33.5151C113.41 33.5151 114.021 32.3372 114.572 30.8493L117.904 21.8289H117.018L114.633 28.5864L112.187 21.8289H111.269L114.174 29.6403L113.777 30.7563C113.318 31.9962 112.859 32.7401 111.728 32.7401C111.422 32.7401 111.3 32.7091 111.178 32.6781L111.055 33.3911C111.208 33.4841 111.392 33.5151 111.728 33.5151ZM123.316 29.7333H124.142V22.5418H126.159V21.8599H124.142V20.62C124.142 19.1941 124.722 18.4501 125.915 18.4501C126.373 18.4501 126.74 18.5741 126.893 18.6671L127.107 17.9231C126.893 17.8301 126.496 17.7061 125.915 17.7061C124.203 17.7061 123.285 18.7911 123.285 20.589V21.9219H121.94V22.6038H123.285V29.7333H123.316ZM130.195 29.9193C132.641 29.9193 133.742 27.7495 133.742 25.7656C133.742 23.8127 132.611 21.6739 130.165 21.6739C127.719 21.6739 126.679 23.8127 126.679 25.7966C126.71 27.7805 127.78 29.9193 130.195 29.9193ZM130.226 29.1754C128.483 29.1754 127.596 27.5635 127.596 25.7656C127.596 23.9987 128.391 22.4178 130.165 22.4178C131.938 22.4178 132.855 24.0297 132.855 25.7966C132.855 27.5945 131.999 29.1754 130.226 29.1754ZM135.699 29.7333H136.555V24.2467C136.769 23.7817 137.472 22.5108 138.542 22.5108C138.879 22.5108 139.062 22.5728 139.184 22.6348L139.398 21.8289C139.276 21.7669 139.001 21.7049 138.665 21.7049C137.564 21.7049 136.861 22.6658 136.586 23.2548V21.8909H135.729V29.7333H135.699ZM146.492 29.9193C147.226 29.9193 147.776 29.6094 147.99 29.4544L147.654 28.8034C147.501 28.9274 147.042 29.1754 146.584 29.1754C145.88 29.1754 145.636 28.7414 145.636 27.9355V22.5728H147.623V21.8909H145.636V19.628H144.78V21.8599H143.465V22.5418H144.78V27.9665C144.78 29.2064 145.33 29.9193 146.492 29.9193ZM149.641 29.7333H150.497V23.9987C150.772 23.5648 151.72 22.4488 152.882 22.4488C154.044 22.4488 154.472 23.1618 154.472 24.3397V29.7333H155.328V24.1537C155.328 22.7278 154.686 21.6739 153.065 21.6739C151.751 21.6739 150.864 22.5728 150.497 23.0998V17.8301H149.641V29.7333ZM160.709 29.9193C161.963 29.9193 162.849 29.4854 163.339 29.1134L162.972 28.4314C162.544 28.7724 161.718 29.1754 160.74 29.1754C158.875 29.1754 158.141 27.5325 158.11 25.7346V25.5486H163.461C163.492 25.3936 163.492 25.2696 163.492 25.1147C163.492 23.0998 162.421 21.6739 160.556 21.6739C158.477 21.6739 157.224 23.5028 157.224 25.7036C157.224 27.9975 158.324 29.9193 160.709 29.9193ZM158.171 24.8357C158.385 23.4718 159.18 22.4178 160.526 22.4178C161.993 22.4178 162.605 23.6267 162.635 24.8357H158.171Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M76.6868 12.6878H77.5124V3.14047L84.0248 12.6878H84.8503V1.68357H83.9942V11.1689L77.5429 1.68357H76.6562V12.6878H76.6868ZM89.8646 12.8428C91.1182 12.8428 92.0049 12.4088 92.4941 12.0369L92.1272 11.3549C91.6991 11.6959 90.8736 12.0989 89.8952 12.0989C88.0301 12.0989 87.2963 10.456 87.2658 8.6581V8.47211H92.6164C92.647 8.31712 92.647 8.19313 92.647 8.03814C92.647 6.02328 91.5768 4.59737 89.7118 4.59737C87.6327 4.59737 86.3791 6.42625 86.3791 8.6271C86.3791 10.9209 87.4798 12.8428 89.8646 12.8428ZM87.3269 7.79015C87.5409 6.42624 88.3359 5.37232 89.6812 5.37232C91.1488 5.37232 91.7603 6.58123 91.7909 7.79015H87.3269ZM95.8268 12.6878H96.6217L98.7314 6.05428L100.841 12.6878H101.636L103.99 4.81436H103.134L101.239 11.3859L99.19 4.81436H98.3645L96.316 11.3549L94.4203 4.81436H93.5031L95.8268 12.6878ZM111.084 12.6878H111.97V8.53411L115.578 1.68357H114.661L111.573 7.63516H111.542L108.454 1.68357H107.445L111.084 8.53411V12.6878ZM118.177 12.8428C120.623 12.8428 121.724 10.673 121.724 8.6891C121.724 6.73623 120.592 4.59737 118.146 4.59737C115.701 4.59737 114.661 6.73622 114.661 8.72009C114.661 10.735 115.731 12.8428 118.177 12.8428ZM118.177 12.0989C116.404 12.0989 115.548 10.487 115.548 8.6891C115.548 6.92222 116.343 5.34132 118.116 5.34132C119.889 5.34132 120.807 6.95321 120.807 8.72009C120.807 10.518 119.95 12.0989 118.177 12.0989ZM123.344 12.6878H124.2V7.20119C124.414 6.73623 125.118 5.46531 126.188 5.46531C126.524 5.46531 126.707 5.52731 126.83 5.58931L127.044 4.78336C126.922 4.72136 126.646 4.65937 126.31 4.65937C125.209 4.65937 124.506 5.62031 124.231 6.20927V4.84536H123.344V12.6878ZM133.067 12.6878H134.137L130.529 8.25512L133.954 4.81436H132.884L129.49 8.25512L133.067 12.6878ZM128.542 12.6878H129.398V0.815626H128.542V12.6878ZM139.549 12.6878H140.436V8.00714H141.812C144.258 8.00714 145.633 6.76723 145.633 4.78336C145.633 2.83049 144.196 1.68357 141.934 1.68357H139.549V12.6878ZM140.436 7.23219V2.45852H141.812C143.891 2.45852 144.686 3.45045 144.686 4.81436C144.686 6.27126 143.829 7.23219 141.781 7.23219H140.436ZM149.302 12.8428C150.617 12.8428 151.504 11.9749 151.871 11.3859C151.871 11.8199 151.932 12.4088 151.993 12.6878H152.849C152.757 12.3779 152.696 11.7889 152.696 11.1689V4.81436H151.84V10.518C151.565 10.9829 150.617 12.0989 149.455 12.0989C148.263 12.0989 147.865 11.3549 147.865 10.208V4.81436H147.009V10.363C147.009 11.7889 147.651 12.8428 149.302 12.8428ZM157.374 12.8428C159.759 12.8428 161.227 10.9209 161.227 8.6891C161.227 6.39525 160.157 4.59737 157.925 4.59737C157.13 4.59737 156.365 4.96934 155.876 5.49631V0.753632H155.02V12.2229C155.57 12.6258 156.426 12.8428 157.374 12.8428ZM157.405 12.0989C156.793 12.0989 156.243 11.9749 155.907 11.7889V6.30226C156.335 5.80629 157.13 5.40332 157.802 5.40332C159.698 5.40332 160.34 7.04621 160.34 8.75109C160.309 10.394 159.362 12.0989 157.405 12.0989ZM162.847 12.6878H163.703V0.815626H162.847V12.6878ZM166.577 3.14047C166.944 3.14047 167.219 2.83049 167.219 2.45852C167.219 2.08654 166.914 1.80756 166.577 1.80756C166.241 1.80756 165.935 2.08654 165.935 2.45852C165.935 2.86149 166.241 3.14047 166.577 3.14047ZM166.149 12.6878H167.005V4.81436H166.149V12.6878ZM172.05 12.8428C173.212 12.8428 174.038 12.4088 174.466 12.0369L174.099 11.3859C173.762 11.6959 172.998 12.0989 172.111 12.0989C170.399 12.0989 169.635 10.425 169.635 8.6891C169.635 6.86022 170.43 5.34132 172.142 5.34132C172.998 5.34132 173.579 5.6823 174.038 6.05428L174.466 5.43432C174.038 5.06234 173.304 4.59737 172.142 4.59737C170.155 4.59737 168.718 6.20926 168.718 8.72009C168.718 10.8589 169.818 12.8428 172.05 12.8428Z"
    })), $0422a6ce4ea03acc$var$zz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 300 71",
        fill: "#000000",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_51609_40290)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0 66.1146C3.74096 61.8492 7.60662 57.6829 11.173 53.2438C11.4265 52.7404 12.0953 52.0478 12.2259 51.9429C12.6662 51.5889 13 51.0002 13.5 50.5002C14 50.5002 14.8462 51.0283 15.4039 51.1256C16.7953 51.7559 16.1287 51.395 16.959 51.7559C26.6109 55.9507 37.3134 57.1438 47.6598 55.1782C63.1225 52.6983 78.3606 49.0032 93.7235 45.8785C103.45 43.8946 113.201 42.0594 123.252 43.0762C128.472 43.3951 133.533 44.9845 137.991 47.7044C142.448 50.4243 146.165 54.1916 148.815 58.6749C149.065 59.0716 149.364 59.4684 149.738 60.0388C150.087 59.6695 150.405 59.2713 150.686 58.8485C157.445 47.6392 167.819 42.9026 180.614 42.7042C192.859 42.5058 204.606 45.5809 216.427 48.1352C227.75 50.6151 239.097 53.095 250.545 54.9302C262.546 57.2351 274.976 55.6261 285.984 50.3423L300.075 67.181C294.912 68.2721 290.373 69.6609 285.784 70.1569C267.878 72.6368 250.569 69.3137 233.411 64.6266C220.692 61.1796 208.022 57.5093 195.153 54.707C184.853 52.4007 174.428 52.2271 164.627 57.3853C159.539 60.0929 155.138 63.9179 151.758 68.5697L150.112 70.752C146.945 67.4786 144.152 64.0067 140.81 61.1796C133.029 54.6326 123.701 52.8222 113.725 53.4918C100.133 54.4094 87.314 58.7245 74.3703 62.4443C61.981 66.3923 49.235 69.1331 36.3122 70.6281C25.009 71.8704 13.571 70.9443 2.61867 67.9001C1.79566 67.6521 0.897828 67.5529 0.124697 67.3794L-1 67.0002L0 66.1146Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M15.5703 30H20.5615V11.7793H20.9326L27.7979 30H31.3047L38.1699 11.7793H38.541V30H43.5322V3.22559H37.1123L29.7275 22.8193H29.3936L21.9902 3.22559H15.5703V30ZM51.9375 37.1992C56.9844 37.1992 59.6748 35.3809 61.4932 29.9814L68.4512 9.57129H62.7363L58.4502 25.0459H58.0791L53.793 9.57129H47.8369L55.0176 30L54.832 30.7793C54.4424 32.375 53.3291 33.1172 51.3994 33.1172C50.8984 33.1172 50.3604 33.0986 49.9893 33.0615V37.1436C50.6201 37.1807 51.3066 37.1992 51.9375 37.1992ZM72.7559 30H90.2715V25.3799H78.3594V3.22559H72.7559V30ZM97.582 6.43555C99.252 6.43555 100.625 5.09961 100.625 3.42969C100.625 1.74121 99.252 0.405273 97.582 0.405273C95.9121 0.405273 94.5205 1.74121 94.5205 3.42969C94.5205 5.09961 95.9121 6.43555 97.582 6.43555ZM94.8545 30H100.272V9.57129H94.8545V30ZM117.788 30.3154C122.891 30.3154 126.082 26.3262 126.082 19.7949V19.7578C126.082 13.1895 122.965 9.2373 117.788 9.2373C114.986 9.2373 112.704 10.6104 111.665 12.8369H111.331V1.75977H105.913V30H111.331V26.8271H111.665C112.723 29.0352 114.894 30.3154 117.788 30.3154ZM115.933 25.8252C113.075 25.8252 111.275 23.5615 111.275 19.8135V19.7764C111.275 16.0283 113.094 13.7275 115.933 13.7275C118.79 13.7275 120.571 16.0283 120.571 19.7578V19.7949C120.571 23.5615 118.809 25.8252 115.933 25.8252ZM130.479 30H135.897V18.5703C135.897 15.6758 137.846 13.9131 140.926 13.9131C141.761 13.9131 142.596 14.043 143.412 14.2285V9.49707C142.874 9.34863 142.113 9.2373 141.39 9.2373C138.736 9.2373 136.881 10.5361 136.231 12.7441H135.897V9.57129H130.479V30ZM152.226 30.3154C154.897 30.3154 157.05 29.1836 158.089 27.291H158.423V30H163.767V16.0469C163.767 11.6865 160.705 9.12598 155.287 9.12598C150.147 9.12598 146.771 11.501 146.344 15.082L146.325 15.249H151.335L151.372 15.1748C151.799 13.9688 153.042 13.2822 154.99 13.2822C157.217 13.2822 158.423 14.2842 158.423 16.0469V17.7354L153.487 18.0322C148.403 18.3291 145.564 20.4814 145.564 24.1553V24.1924C145.564 27.9033 148.329 30.3154 152.226 30.3154ZM150.853 23.8584V23.8213C150.853 22.3369 151.984 21.4648 154.304 21.3164L158.423 21.0566V22.5596C158.423 24.7119 156.549 26.3633 154.044 26.3633C152.17 26.3633 150.853 25.417 150.853 23.8584ZM169.073 30H174.491V18.5703C174.491 15.6758 176.439 13.9131 179.52 13.9131C180.354 13.9131 181.189 14.043 182.006 14.2285V9.49707C181.468 9.34863 180.707 9.2373 179.983 9.2373C177.33 9.2373 175.475 10.5361 174.825 12.7441H174.491V9.57129H169.073V30ZM188.426 37.1992C193.473 37.1992 196.163 35.3809 197.981 29.9814L204.939 9.57129H199.225L194.938 25.0459H194.567L190.281 9.57129H184.325L191.506 30L191.32 30.7793C190.931 32.375 189.817 33.1172 187.888 33.1172C187.387 33.1172 186.849 33.0986 186.478 33.0615V37.1436C187.108 37.1807 187.795 37.1992 188.426 37.1992ZM209.244 30H214.606V12.874H214.903L227.298 30H231.937V3.22559H226.574V20.2773H226.277L213.92 3.22559H209.244V30ZM245.853 30H251.456V19.999L260.789 3.22559H254.722L248.84 14.4883H248.506L242.605 3.22559H236.538L245.853 19.999V30ZM275.132 30.6865C281.589 30.6865 286.172 26.8643 286.747 21.2607L286.766 21.0566H281.311L281.273 21.2051C280.68 24.0625 278.36 25.9365 275.15 25.9365C270.92 25.9365 268.304 22.374 268.304 16.6221V16.585C268.304 10.833 270.92 7.28906 275.132 7.28906C278.323 7.28906 280.717 9.33008 281.292 12.3359V12.4658H286.747V12.2432C286.228 6.58398 281.478 2.53906 275.132 2.53906C267.357 2.53906 262.57 7.90137 262.57 16.585V16.6221C262.57 25.3057 267.376 30.6865 275.132 30.6865Z"
    }))), $0422a6ce4ea03acc$var$Uz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 300 71",
        fill: "#C60917",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_51609_40290)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0 66.1146C3.74096 61.8492 7.60662 57.6829 11.173 53.2438C11.4265 52.7404 12.0953 52.0478 12.2259 51.9429C12.6662 51.5889 13 51.0002 13.5 50.5002C14 50.5002 14.8462 51.0283 15.4039 51.1256C16.7953 51.7559 16.1287 51.395 16.959 51.7559C26.6109 55.9507 37.3134 57.1438 47.6598 55.1782C63.1225 52.6983 78.3606 49.0032 93.7235 45.8785C103.45 43.8946 113.201 42.0594 123.252 43.0762C128.472 43.3951 133.533 44.9845 137.991 47.7044C142.448 50.4243 146.165 54.1916 148.815 58.6749C149.065 59.0716 149.364 59.4684 149.738 60.0388C150.087 59.6695 150.405 59.2713 150.686 58.8485C157.445 47.6392 167.819 42.9026 180.614 42.7042C192.859 42.5058 204.606 45.5809 216.427 48.1352C227.75 50.6151 239.097 53.095 250.545 54.9302C262.546 57.2351 274.976 55.6261 285.984 50.3423L300.075 67.181C294.912 68.2721 290.373 69.6609 285.784 70.1569C267.878 72.6368 250.569 69.3137 233.411 64.6266C220.692 61.1796 208.022 57.5093 195.153 54.707C184.853 52.4007 174.428 52.2271 164.627 57.3853C159.539 60.0929 155.138 63.9179 151.758 68.5697L150.112 70.752C146.945 67.4786 144.152 64.0067 140.81 61.1796C133.029 54.6326 123.701 52.8222 113.725 53.4918C100.133 54.4094 87.314 58.7245 74.3703 62.4443C61.981 66.3923 49.235 69.1331 36.3122 70.6281C25.009 71.8704 13.571 70.9443 2.61867 67.9001C1.79566 67.6521 0.897828 67.5529 0.124697 67.3794L-1 67.0002L0 66.1146Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M15.5703 30H20.5615V11.7793H20.9326L27.7979 30H31.3047L38.1699 11.7793H38.541V30H43.5322V3.22559H37.1123L29.7275 22.8193H29.3936L21.9902 3.22559H15.5703V30ZM51.9375 37.1992C56.9844 37.1992 59.6748 35.3809 61.4932 29.9814L68.4512 9.57129H62.7363L58.4502 25.0459H58.0791L53.793 9.57129H47.8369L55.0176 30L54.832 30.7793C54.4424 32.375 53.3291 33.1172 51.3994 33.1172C50.8984 33.1172 50.3604 33.0986 49.9893 33.0615V37.1436C50.6201 37.1807 51.3066 37.1992 51.9375 37.1992ZM72.7559 30H90.2715V25.3799H78.3594V3.22559H72.7559V30ZM97.582 6.43555C99.252 6.43555 100.625 5.09961 100.625 3.42969C100.625 1.74121 99.252 0.405273 97.582 0.405273C95.9121 0.405273 94.5205 1.74121 94.5205 3.42969C94.5205 5.09961 95.9121 6.43555 97.582 6.43555ZM94.8545 30H100.272V9.57129H94.8545V30ZM117.788 30.3154C122.891 30.3154 126.082 26.3262 126.082 19.7949V19.7578C126.082 13.1895 122.965 9.2373 117.788 9.2373C114.986 9.2373 112.704 10.6104 111.665 12.8369H111.331V1.75977H105.913V30H111.331V26.8271H111.665C112.723 29.0352 114.894 30.3154 117.788 30.3154ZM115.933 25.8252C113.075 25.8252 111.275 23.5615 111.275 19.8135V19.7764C111.275 16.0283 113.094 13.7275 115.933 13.7275C118.79 13.7275 120.571 16.0283 120.571 19.7578V19.7949C120.571 23.5615 118.809 25.8252 115.933 25.8252ZM130.479 30H135.897V18.5703C135.897 15.6758 137.846 13.9131 140.926 13.9131C141.761 13.9131 142.596 14.043 143.412 14.2285V9.49707C142.874 9.34863 142.113 9.2373 141.39 9.2373C138.736 9.2373 136.881 10.5361 136.231 12.7441H135.897V9.57129H130.479V30ZM152.226 30.3154C154.897 30.3154 157.05 29.1836 158.089 27.291H158.423V30H163.767V16.0469C163.767 11.6865 160.705 9.12598 155.287 9.12598C150.147 9.12598 146.771 11.501 146.344 15.082L146.325 15.249H151.335L151.372 15.1748C151.799 13.9688 153.042 13.2822 154.99 13.2822C157.217 13.2822 158.423 14.2842 158.423 16.0469V17.7354L153.487 18.0322C148.403 18.3291 145.564 20.4814 145.564 24.1553V24.1924C145.564 27.9033 148.329 30.3154 152.226 30.3154ZM150.853 23.8584V23.8213C150.853 22.3369 151.984 21.4648 154.304 21.3164L158.423 21.0566V22.5596C158.423 24.7119 156.549 26.3633 154.044 26.3633C152.17 26.3633 150.853 25.417 150.853 23.8584ZM169.073 30H174.491V18.5703C174.491 15.6758 176.439 13.9131 179.52 13.9131C180.354 13.9131 181.189 14.043 182.006 14.2285V9.49707C181.468 9.34863 180.707 9.2373 179.983 9.2373C177.33 9.2373 175.475 10.5361 174.825 12.7441H174.491V9.57129H169.073V30ZM188.426 37.1992C193.473 37.1992 196.163 35.3809 197.981 29.9814L204.939 9.57129H199.225L194.938 25.0459H194.567L190.281 9.57129H184.325L191.506 30L191.32 30.7793C190.931 32.375 189.817 33.1172 187.888 33.1172C187.387 33.1172 186.849 33.0986 186.478 33.0615V37.1436C187.108 37.1807 187.795 37.1992 188.426 37.1992ZM209.244 30H214.606V12.874H214.903L227.298 30H231.937V3.22559H226.574V20.2773H226.277L213.92 3.22559H209.244V30ZM245.853 30H251.456V19.999L260.789 3.22559H254.722L248.84 14.4883H248.506L242.605 3.22559H236.538L245.853 19.999V30ZM275.132 30.6865C281.589 30.6865 286.172 26.8643 286.747 21.2607L286.766 21.0566H281.311L281.273 21.2051C280.68 24.0625 278.36 25.9365 275.15 25.9365C270.92 25.9365 268.304 22.374 268.304 16.6221V16.585C268.304 10.833 270.92 7.28906 275.132 7.28906C278.323 7.28906 280.717 9.33008 281.292 12.3359V12.4658H286.747V12.2432C286.228 6.58398 281.478 2.53906 275.132 2.53906C267.357 2.53906 262.57 7.90137 262.57 16.585V16.6221C262.57 25.3057 267.376 30.6865 275.132 30.6865Z"
    }))), $0422a6ce4ea03acc$var$Iz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 300 71",
        fill: "#ffffff",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_51609_40290)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0 66.1146C3.74096 61.8492 7.60662 57.6829 11.173 53.2438C11.4265 52.7404 12.0953 52.0478 12.2259 51.9429C12.6662 51.5889 13 51.0002 13.5 50.5002C14 50.5002 14.8462 51.0283 15.4039 51.1256C16.7953 51.7559 16.1287 51.395 16.959 51.7559C26.6109 55.9507 37.3134 57.1438 47.6598 55.1782C63.1225 52.6983 78.3606 49.0032 93.7235 45.8785C103.45 43.8946 113.201 42.0594 123.252 43.0762C128.472 43.3951 133.533 44.9845 137.991 47.7044C142.448 50.4243 146.165 54.1916 148.815 58.6749C149.065 59.0716 149.364 59.4684 149.738 60.0388C150.087 59.6695 150.405 59.2713 150.686 58.8485C157.445 47.6392 167.819 42.9026 180.614 42.7042C192.859 42.5058 204.606 45.5809 216.427 48.1352C227.75 50.6151 239.097 53.095 250.545 54.9302C262.546 57.2351 274.976 55.6261 285.984 50.3423L300.075 67.181C294.912 68.2721 290.373 69.6609 285.784 70.1569C267.878 72.6368 250.569 69.3137 233.411 64.6266C220.692 61.1796 208.022 57.5093 195.153 54.707C184.853 52.4007 174.428 52.2271 164.627 57.3853C159.539 60.0929 155.138 63.9179 151.758 68.5697L150.112 70.752C146.945 67.4786 144.152 64.0067 140.81 61.1796C133.029 54.6326 123.701 52.8222 113.725 53.4918C100.133 54.4094 87.314 58.7245 74.3703 62.4443C61.981 66.3923 49.235 69.1331 36.3122 70.6281C25.009 71.8704 13.571 70.9443 2.61867 67.9001C1.79566 67.6521 0.897828 67.5529 0.124697 67.3794L-1 67.0002L0 66.1146Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M15.5703 30H20.5615V11.7793H20.9326L27.7979 30H31.3047L38.1699 11.7793H38.541V30H43.5322V3.22559H37.1123L29.7275 22.8193H29.3936L21.9902 3.22559H15.5703V30ZM51.9375 37.1992C56.9844 37.1992 59.6748 35.3809 61.4932 29.9814L68.4512 9.57129H62.7363L58.4502 25.0459H58.0791L53.793 9.57129H47.8369L55.0176 30L54.832 30.7793C54.4424 32.375 53.3291 33.1172 51.3994 33.1172C50.8984 33.1172 50.3604 33.0986 49.9893 33.0615V37.1436C50.6201 37.1807 51.3066 37.1992 51.9375 37.1992ZM72.7559 30H90.2715V25.3799H78.3594V3.22559H72.7559V30ZM97.582 6.43555C99.252 6.43555 100.625 5.09961 100.625 3.42969C100.625 1.74121 99.252 0.405273 97.582 0.405273C95.9121 0.405273 94.5205 1.74121 94.5205 3.42969C94.5205 5.09961 95.9121 6.43555 97.582 6.43555ZM94.8545 30H100.272V9.57129H94.8545V30ZM117.788 30.3154C122.891 30.3154 126.082 26.3262 126.082 19.7949V19.7578C126.082 13.1895 122.965 9.2373 117.788 9.2373C114.986 9.2373 112.704 10.6104 111.665 12.8369H111.331V1.75977H105.913V30H111.331V26.8271H111.665C112.723 29.0352 114.894 30.3154 117.788 30.3154ZM115.933 25.8252C113.075 25.8252 111.275 23.5615 111.275 19.8135V19.7764C111.275 16.0283 113.094 13.7275 115.933 13.7275C118.79 13.7275 120.571 16.0283 120.571 19.7578V19.7949C120.571 23.5615 118.809 25.8252 115.933 25.8252ZM130.479 30H135.897V18.5703C135.897 15.6758 137.846 13.9131 140.926 13.9131C141.761 13.9131 142.596 14.043 143.412 14.2285V9.49707C142.874 9.34863 142.113 9.2373 141.39 9.2373C138.736 9.2373 136.881 10.5361 136.231 12.7441H135.897V9.57129H130.479V30ZM152.226 30.3154C154.897 30.3154 157.05 29.1836 158.089 27.291H158.423V30H163.767V16.0469C163.767 11.6865 160.705 9.12598 155.287 9.12598C150.147 9.12598 146.771 11.501 146.344 15.082L146.325 15.249H151.335L151.372 15.1748C151.799 13.9688 153.042 13.2822 154.99 13.2822C157.217 13.2822 158.423 14.2842 158.423 16.0469V17.7354L153.487 18.0322C148.403 18.3291 145.564 20.4814 145.564 24.1553V24.1924C145.564 27.9033 148.329 30.3154 152.226 30.3154ZM150.853 23.8584V23.8213C150.853 22.3369 151.984 21.4648 154.304 21.3164L158.423 21.0566V22.5596C158.423 24.7119 156.549 26.3633 154.044 26.3633C152.17 26.3633 150.853 25.417 150.853 23.8584ZM169.073 30H174.491V18.5703C174.491 15.6758 176.439 13.9131 179.52 13.9131C180.354 13.9131 181.189 14.043 182.006 14.2285V9.49707C181.468 9.34863 180.707 9.2373 179.983 9.2373C177.33 9.2373 175.475 10.5361 174.825 12.7441H174.491V9.57129H169.073V30ZM188.426 37.1992C193.473 37.1992 196.163 35.3809 197.981 29.9814L204.939 9.57129H199.225L194.938 25.0459H194.567L190.281 9.57129H184.325L191.506 30L191.32 30.7793C190.931 32.375 189.817 33.1172 187.888 33.1172C187.387 33.1172 186.849 33.0986 186.478 33.0615V37.1436C187.108 37.1807 187.795 37.1992 188.426 37.1992ZM209.244 30H214.606V12.874H214.903L227.298 30H231.937V3.22559H226.574V20.2773H226.277L213.92 3.22559H209.244V30ZM245.853 30H251.456V19.999L260.789 3.22559H254.722L248.84 14.4883H248.506L242.605 3.22559H236.538L245.853 19.999V30ZM275.132 30.6865C281.589 30.6865 286.172 26.8643 286.747 21.2607L286.766 21.0566H281.311L281.273 21.2051C280.68 24.0625 278.36 25.9365 275.15 25.9365C270.92 25.9365 268.304 22.374 268.304 16.6221V16.585C268.304 10.833 270.92 7.28906 275.132 7.28906C278.323 7.28906 280.717 9.33008 281.292 12.3359V12.4658H286.747V12.2432C286.228 6.58398 281.478 2.53906 275.132 2.53906C267.357 2.53906 262.57 7.90137 262.57 16.585V16.6221C262.57 25.3057 267.376 30.6865 275.132 30.6865Z"
    }))), $0422a6ce4ea03acc$var$$z = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 341 61",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_77131_127720)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M188.913 1.96319H195.581C200.337 1.96319 203.182 4.85386 203.182 9.65253C203.182 14.7339 200.294 17.4712 195.581 17.4712H188.913V1.96319ZM192.953 13.9952H194.863C197.926 13.9325 199.143 12.7379 199.143 9.62986C199.143 6.80719 197.622 5.43919 194.863 5.43919H192.953V13.9952Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M207.932 12.7382C207.997 14.2782 208.888 15.2995 210.45 15.2995C211.341 15.2995 212.21 14.8875 212.558 14.0609H216.012C215.338 16.6675 212.926 17.7969 210.408 17.7969C206.737 17.7969 204.24 15.5809 204.24 11.8035C204.24 8.35021 206.998 5.87421 210.321 5.87421C214.36 5.87421 216.381 8.91554 216.206 12.7382H207.932ZM212.514 10.6742C212.449 9.41421 211.558 8.37288 210.321 8.37288C209.017 8.37288 208.149 9.30488 207.932 10.6742H212.514Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M217.615 6.19995H221.134V7.50262H221.176C221.894 6.43862 222.98 5.87462 224.283 5.87462C227.823 5.87462 229.322 8.91462 229.322 12.0853C229.322 15.0173 227.758 17.796 224.564 17.796C223.175 17.796 222.111 17.2773 221.35 16.256H221.307V21.252H217.615V6.19995ZM221.176 11.7173C221.176 13.6933 221.742 14.9733 223.414 14.9733C225.064 14.9733 225.63 13.2573 225.63 11.7173C225.63 10.2826 225.064 8.69729 223.435 8.69729C222.436 8.69729 221.176 9.39329 221.176 11.7173Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M230.668 9.67554C230.735 8.19821 231.428 7.24088 232.427 6.65554C233.428 6.09154 234.729 5.87421 236.012 5.87421C238.683 5.87421 241.267 6.45954 241.267 9.65287V14.5835C241.267 15.5382 241.267 16.5822 241.703 17.4715H237.987C237.859 17.1235 237.813 16.7755 237.771 16.4075C236.815 17.4062 235.404 17.7969 234.057 17.7969C231.907 17.7969 230.212 16.7129 230.212 14.3862C230.212 10.7169 234.209 10.9995 236.772 10.4769C237.401 10.3489 237.749 10.1315 237.749 9.43554C237.749 8.58888 236.728 8.26221 235.968 8.26221C234.948 8.26221 234.296 8.71821 234.121 9.67554H230.668ZM235.447 15.5182C237.205 15.5182 237.792 14.5182 237.705 12.1942C237.184 12.5195 236.228 12.5849 235.425 12.8009C234.6 12.9969 233.904 13.3449 233.904 14.2355C233.904 15.1475 234.621 15.5182 235.447 15.5182Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M243.378 6.19968H246.961V8.17568H247.003C247.547 6.74101 248.807 5.98235 250.393 5.98235C250.674 5.98235 250.979 6.00368 251.262 6.06901V9.43568C250.783 9.30501 250.35 9.21835 249.849 9.21835C248.026 9.21835 247.07 10.477 247.07 11.8903V17.4717H243.378V6.19968Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M259.404 8.58941H257.123V13.7134C257.123 14.6054 257.646 14.8001 258.448 14.8001C258.751 14.8001 259.078 14.7574 259.404 14.7574V17.4721C258.73 17.4947 258.058 17.5801 257.383 17.5801C254.235 17.5801 253.431 16.6681 253.431 13.6054V8.58941H251.563V6.20008H253.431V2.78941H257.123V6.20008H259.404V8.58941Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M260.831 6.19968H264.414V7.74235H264.459C265.131 6.61301 266.324 5.87435 267.692 5.87435C269.106 5.87435 270.364 6.33035 270.972 7.69701C271.864 6.50235 272.972 5.87435 274.492 5.87435C278.075 5.87435 278.466 8.58901 278.466 10.7383V17.4717H274.774V10.8477C274.774 9.63035 274.187 8.91435 273.232 8.91435C271.647 8.91435 271.494 10.1317 271.494 11.9543V17.4717H267.803V11.0637C267.803 9.73835 267.411 8.91435 266.412 8.91435C265.088 8.91435 264.523 9.67568 264.523 11.977V17.4717H260.831V6.19968Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M283.631 12.7382C283.695 14.2782 284.587 15.2995 286.15 15.2995C287.042 15.2995 287.91 14.8875 288.258 14.0609H291.711C291.038 16.6675 288.627 17.7969 286.107 17.7969C282.437 17.7969 279.939 15.5809 279.939 11.8035C279.939 8.35021 282.697 5.87421 286.019 5.87421C290.059 5.87421 292.081 8.91554 291.906 12.7382H283.631ZM288.214 10.6742C288.149 9.41421 287.259 8.37288 286.019 8.37288C284.718 8.37288 283.849 9.30488 283.631 10.6742H288.214Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M293.316 6.19968H296.898V7.74235H296.941C297.616 6.59035 299.136 5.87435 300.482 5.87435C304.238 5.87435 304.544 8.60901 304.544 10.2397V17.4717H300.852V12.0197C300.852 10.477 301.026 8.91435 299.005 8.91435C297.616 8.91435 297.008 10.0863 297.008 11.3237V17.4717H293.316V6.19968Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M313.231 8.58941H310.953V13.7134C310.953 14.6054 311.473 14.8001 312.278 14.8001C312.581 14.8001 312.907 14.7574 313.231 14.7574V17.4721C312.559 17.4947 311.885 17.5801 311.213 17.5801C308.063 17.5801 307.261 16.6681 307.261 13.6054V8.58941H305.393V6.20008H307.261V2.78941H310.953V6.20008H313.231V8.58941Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M326.246 5.87457C329.742 5.87457 332.196 8.45856 332.196 11.8452C332.196 15.2359 329.742 17.7959 326.246 17.7959C322.747 17.7959 320.316 15.2359 320.316 11.8452C320.316 8.45856 322.747 5.87457 326.246 5.87457ZM326.246 14.9732C327.962 14.9732 328.504 13.2799 328.504 11.8452C328.504 10.4132 327.962 8.69723 326.246 8.69723C324.53 8.69723 324.008 10.4132 324.008 11.8452C324.008 13.2799 324.53 14.9732 326.246 14.9732Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M334.281 8.58901H332.498V6.19968H334.281C334.281 2.96368 335.409 1.96235 338.559 1.96235C339.145 1.96235 339.753 2.00768 340.339 2.02901V4.63435C339.991 4.59168 339.667 4.57168 339.341 4.57168C338.493 4.57168 337.973 4.67968 337.973 5.69968V6.19968H340.187V8.58901H337.973V17.4717H334.281V8.58901Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M188.913 25.8255H201.271V29.0615H192.953V31.7788H200.554V34.9042H192.953V37.8588H201.487V41.3335H188.913V25.8255Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M214.339 41.3338H210.82V40.0312H210.777C210.06 41.0938 208.973 41.6592 207.671 41.6592C204.131 41.6592 202.632 38.6192 202.632 35.4485C202.632 32.5165 204.196 29.7365 207.389 29.7365C208.779 29.7365 209.843 30.2565 210.603 31.2778H210.647V25.8258H214.339V41.3338ZM206.324 35.5792C206.324 37.1205 206.889 38.8365 208.583 38.8365C210.385 38.8365 210.777 37.1205 210.777 35.6885C210.777 34.0578 210.189 32.5592 208.583 32.5592C206.889 32.5592 206.324 34.1458 206.324 35.5792Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M227.625 41.3338H224.041V39.7912H223.998C223.302 40.9432 221.87 41.6592 220.566 41.6592C217.329 41.6592 216.396 39.7912 216.396 36.8378V30.0618H220.088V36.6005C220.088 38.0978 220.74 38.6192 221.913 38.6192C222.716 38.6192 223.933 38.0978 223.933 36.0992V30.0618H227.625V41.3338Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M237.03 34.1885C237.008 33.2338 236.16 32.5605 235.227 32.5605C233.164 32.5605 232.838 34.3192 232.838 35.8832C232.838 37.3392 233.468 38.8365 235.032 38.8365C236.312 38.8365 236.966 38.0978 237.139 36.9032H240.722C240.398 39.9218 238.05 41.6592 235.054 41.6592C231.664 41.6592 229.146 39.3352 229.146 35.8832C229.146 32.2978 231.426 29.7365 235.054 29.7365C237.855 29.7365 240.352 31.2138 240.614 34.1885H237.03Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M241.963 33.5378C242.029 32.0618 242.723 31.1032 243.721 30.5192C244.723 29.9538 246.024 29.7378 247.307 29.7378C249.977 29.7378 252.561 30.3218 252.561 33.5152V38.4458C252.561 39.4005 252.561 40.4445 252.997 41.3338H249.281C249.153 40.9858 249.108 40.6392 249.065 40.2698C248.109 41.2685 246.699 41.6592 245.352 41.6592C243.201 41.6592 241.507 40.5752 241.507 38.2498C241.507 34.5792 245.504 34.8618 248.067 34.3405C248.696 34.2112 249.044 33.9938 249.044 33.2992C249.044 32.4512 248.024 32.1245 247.263 32.1245C246.243 32.1245 245.591 32.5805 245.416 33.5378H241.963ZM246.741 39.3805C248.5 39.3805 249.087 38.3805 249 36.0565C248.479 36.3818 247.523 36.4472 246.72 36.6645C245.895 36.8605 245.199 37.2085 245.199 38.0978C245.199 39.0098 245.916 39.3805 246.741 39.3805Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M261.261 32.4512H258.979V37.5752C258.979 38.4686 259.502 38.6619 260.305 38.6619C260.61 38.6619 260.934 38.6192 261.261 38.6192V41.3339C260.589 41.3566 259.914 41.4419 259.242 41.4419C256.091 41.4419 255.287 40.5299 255.287 37.4672V32.4512H253.419V30.0619H255.287V26.6526H258.979V30.0619H261.261V32.4512Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M266.463 28.6509H262.771V25.8255H266.463V28.6509Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M262.771 30.0629H266.463V41.335H262.771V30.0629Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M273.933 29.7375C277.429 29.7375 279.884 32.3202 279.884 35.7082C279.884 39.0988 277.429 41.6602 273.933 41.6602C270.435 41.6602 268.004 39.0988 268.004 35.7082C268.004 32.3202 270.435 29.7375 273.933 29.7375ZM273.933 38.8362C275.649 38.8362 276.192 37.1428 276.192 35.7082C276.192 34.2762 275.649 32.5602 273.933 32.5602C272.217 32.5602 271.696 34.2762 271.696 35.7082C271.696 37.1428 272.217 38.8362 273.933 38.8362Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M281.37 30.0625H284.954V31.6051H284.998C285.671 30.4531 287.19 29.7371 288.537 29.7371C292.295 29.7371 292.601 32.4718 292.601 34.1025V41.3345H288.906V35.8825C288.906 34.3398 289.081 32.7771 287.061 32.7771C285.671 32.7771 285.062 33.9491 285.062 35.1865V41.3345H281.37V30.0625Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M169.13 0.000457764H131.548L120.272 11.2751V48.8591L131.548 60.1338H169.13L180.408 48.8591V37.5831L176.649 33.8205H157.856V37.5831H142.822V22.5485H157.856V26.2605H176.649L180.408 22.5485V11.2751L169.13 0.000457764Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M56.3773 0.000457764H41.344L37.5853 3.75646V18.7898L18.792 0.000457764H3.76L0 3.75646V56.3765L3.76 60.1338H18.792L22.552 56.3765V41.3405L41.344 60.1338H56.3773L60.1347 56.3765V3.75646L56.3773 0.000457764Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.6864 60.1333H97.7197L101.478 56.376V45.1013L120.272 26.308V3.7573L116.513 -3.05176e-05H101.478L97.7197 3.7573V11.2746L90.2037 18.7906L82.6864 11.2746V3.7573L78.9277 -3.05176e-05H63.8944L60.1357 3.7573V26.308L78.9277 45.1013V56.376L82.6864 60.1333Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M173.67 0.537792V0.00179172H176.397V0.537792H175.356V3.20312H174.718V0.537792H173.67Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M177.853 0.00179172L178.672 2.29513L179.485 0.00179172H180.404V3.20312H179.815V0.623125L178.933 3.20312H178.421L177.529 0.623125V3.20312H176.941V0.00179172H177.853Z",
        fill: "black"
    }))), $0422a6ce4ea03acc$var$Yz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 341 61",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_68248_67681)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M188.913 1.96319H195.581C200.337 1.96319 203.182 4.85386 203.182 9.65253C203.182 14.7339 200.294 17.4712 195.581 17.4712H188.913V1.96319ZM192.953 13.9952H194.863C197.926 13.9325 199.143 12.7379 199.143 9.62986C199.143 6.80719 197.622 5.43919 194.863 5.43919H192.953V13.9952Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M207.932 12.7382C207.997 14.2782 208.888 15.2995 210.45 15.2995C211.341 15.2995 212.21 14.8875 212.558 14.0609H216.012C215.338 16.6675 212.926 17.7969 210.408 17.7969C206.737 17.7969 204.24 15.5809 204.24 11.8035C204.24 8.35021 206.998 5.87421 210.321 5.87421C214.36 5.87421 216.381 8.91554 216.206 12.7382H207.932ZM212.514 10.6742C212.449 9.41421 211.558 8.37288 210.321 8.37288C209.017 8.37288 208.149 9.30488 207.932 10.6742H212.514Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M217.615 6.19995H221.134V7.50262H221.176C221.894 6.43862 222.98 5.87462 224.283 5.87462C227.823 5.87462 229.322 8.91462 229.322 12.0853C229.322 15.0173 227.758 17.796 224.564 17.796C223.175 17.796 222.111 17.2773 221.35 16.256H221.307V21.252H217.615V6.19995ZM221.176 11.7173C221.176 13.6933 221.742 14.9733 223.414 14.9733C225.064 14.9733 225.63 13.2573 225.63 11.7173C225.63 10.2826 225.064 8.69729 223.435 8.69729C222.436 8.69729 221.176 9.39329 221.176 11.7173Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M230.668 9.67554C230.735 8.19821 231.428 7.24088 232.427 6.65554C233.428 6.09154 234.729 5.87421 236.012 5.87421C238.683 5.87421 241.267 6.45954 241.267 9.65287V14.5835C241.267 15.5382 241.267 16.5822 241.703 17.4715H237.987C237.859 17.1235 237.813 16.7755 237.771 16.4075C236.815 17.4062 235.404 17.7969 234.057 17.7969C231.907 17.7969 230.212 16.7129 230.212 14.3862C230.212 10.7169 234.209 10.9995 236.772 10.4769C237.401 10.3489 237.749 10.1315 237.749 9.43554C237.749 8.58888 236.728 8.26221 235.968 8.26221C234.948 8.26221 234.296 8.71821 234.121 9.67554H230.668ZM235.447 15.5182C237.205 15.5182 237.792 14.5182 237.705 12.1942C237.184 12.5195 236.228 12.5849 235.425 12.8009C234.6 12.9969 233.904 13.3449 233.904 14.2355C233.904 15.1475 234.621 15.5182 235.447 15.5182Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M243.378 6.19968H246.961V8.17568H247.003C247.547 6.74101 248.807 5.98235 250.393 5.98235C250.674 5.98235 250.979 6.00368 251.262 6.06901V9.43568C250.783 9.30501 250.35 9.21835 249.849 9.21835C248.026 9.21835 247.07 10.477 247.07 11.8903V17.4717H243.378V6.19968Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M259.404 8.58941H257.123V13.7134C257.123 14.6054 257.646 14.8001 258.448 14.8001C258.751 14.8001 259.078 14.7574 259.404 14.7574V17.4721C258.73 17.4947 258.058 17.5801 257.383 17.5801C254.235 17.5801 253.431 16.6681 253.431 13.6054V8.58941H251.563V6.20008H253.431V2.78941H257.123V6.20008H259.404V8.58941Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M260.831 6.19968H264.414V7.74235H264.459C265.131 6.61301 266.324 5.87435 267.692 5.87435C269.106 5.87435 270.364 6.33035 270.972 7.69701C271.864 6.50235 272.972 5.87435 274.492 5.87435C278.075 5.87435 278.466 8.58901 278.466 10.7383V17.4717H274.774V10.8477C274.774 9.63035 274.187 8.91435 273.232 8.91435C271.647 8.91435 271.494 10.1317 271.494 11.9543V17.4717H267.803V11.0637C267.803 9.73835 267.411 8.91435 266.412 8.91435C265.088 8.91435 264.523 9.67568 264.523 11.977V17.4717H260.831V6.19968Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M283.631 12.7382C283.695 14.2782 284.587 15.2995 286.15 15.2995C287.042 15.2995 287.91 14.8875 288.258 14.0609H291.711C291.038 16.6675 288.627 17.7969 286.107 17.7969C282.437 17.7969 279.939 15.5809 279.939 11.8035C279.939 8.35021 282.697 5.87421 286.019 5.87421C290.059 5.87421 292.081 8.91554 291.906 12.7382H283.631ZM288.214 10.6742C288.149 9.41421 287.259 8.37288 286.019 8.37288C284.718 8.37288 283.849 9.30488 283.631 10.6742H288.214Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M293.316 6.19968H296.898V7.74235H296.941C297.616 6.59035 299.136 5.87435 300.482 5.87435C304.238 5.87435 304.544 8.60901 304.544 10.2397V17.4717H300.852V12.0197C300.852 10.477 301.026 8.91435 299.005 8.91435C297.616 8.91435 297.008 10.0863 297.008 11.3237V17.4717H293.316V6.19968Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M313.231 8.58941H310.953V13.7134C310.953 14.6054 311.473 14.8001 312.278 14.8001C312.581 14.8001 312.907 14.7574 313.231 14.7574V17.4721C312.559 17.4947 311.885 17.5801 311.213 17.5801C308.063 17.5801 307.261 16.6681 307.261 13.6054V8.58941H305.393V6.20008H307.261V2.78941H310.953V6.20008H313.231V8.58941Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M326.246 5.87457C329.742 5.87457 332.196 8.45856 332.196 11.8452C332.196 15.2359 329.742 17.7959 326.246 17.7959C322.747 17.7959 320.316 15.2359 320.316 11.8452C320.316 8.45856 322.747 5.87457 326.246 5.87457ZM326.246 14.9732C327.962 14.9732 328.504 13.2799 328.504 11.8452C328.504 10.4132 327.962 8.69723 326.246 8.69723C324.53 8.69723 324.008 10.4132 324.008 11.8452C324.008 13.2799 324.53 14.9732 326.246 14.9732Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M334.281 8.58901H332.498V6.19968H334.281C334.281 2.96368 335.409 1.96235 338.559 1.96235C339.145 1.96235 339.753 2.00768 340.339 2.02901V4.63435C339.991 4.59168 339.667 4.57168 339.341 4.57168C338.493 4.57168 337.973 4.67968 337.973 5.69968V6.19968H340.187V8.58901H337.973V17.4717H334.281V8.58901Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M188.913 25.8255H201.271V29.0615H192.953V31.7788H200.554V34.9042H192.953V37.8588H201.487V41.3335H188.913V25.8255Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M214.339 41.3338H210.82V40.0312H210.777C210.06 41.0938 208.973 41.6592 207.671 41.6592C204.131 41.6592 202.632 38.6192 202.632 35.4485C202.632 32.5165 204.196 29.7365 207.389 29.7365C208.779 29.7365 209.843 30.2565 210.603 31.2778H210.647V25.8258H214.339V41.3338ZM206.324 35.5792C206.324 37.1205 206.889 38.8365 208.583 38.8365C210.385 38.8365 210.777 37.1205 210.777 35.6885C210.777 34.0578 210.189 32.5592 208.583 32.5592C206.889 32.5592 206.324 34.1458 206.324 35.5792Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M227.625 41.3338H224.041V39.7912H223.998C223.302 40.9432 221.87 41.6592 220.566 41.6592C217.329 41.6592 216.396 39.7912 216.396 36.8378V30.0618H220.088V36.6005C220.088 38.0978 220.74 38.6192 221.913 38.6192C222.716 38.6192 223.933 38.0978 223.933 36.0992V30.0618H227.625V41.3338Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M237.03 34.1885C237.008 33.2338 236.16 32.5605 235.227 32.5605C233.164 32.5605 232.838 34.3192 232.838 35.8832C232.838 37.3392 233.468 38.8365 235.032 38.8365C236.312 38.8365 236.966 38.0978 237.139 36.9032H240.722C240.398 39.9218 238.05 41.6592 235.054 41.6592C231.664 41.6592 229.146 39.3352 229.146 35.8832C229.146 32.2978 231.426 29.7365 235.054 29.7365C237.855 29.7365 240.352 31.2138 240.614 34.1885H237.03Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M241.963 33.5378C242.029 32.0618 242.723 31.1032 243.721 30.5192C244.723 29.9538 246.024 29.7378 247.307 29.7378C249.977 29.7378 252.561 30.3218 252.561 33.5152V38.4458C252.561 39.4005 252.561 40.4445 252.997 41.3338H249.281C249.153 40.9858 249.108 40.6392 249.065 40.2698C248.109 41.2685 246.699 41.6592 245.352 41.6592C243.201 41.6592 241.507 40.5752 241.507 38.2498C241.507 34.5792 245.504 34.8618 248.067 34.3405C248.696 34.2112 249.044 33.9938 249.044 33.2992C249.044 32.4512 248.024 32.1245 247.263 32.1245C246.243 32.1245 245.591 32.5805 245.416 33.5378H241.963ZM246.741 39.3805C248.5 39.3805 249.087 38.3805 249 36.0565C248.479 36.3818 247.523 36.4472 246.72 36.6645C245.895 36.8605 245.199 37.2085 245.199 38.0978C245.199 39.0098 245.916 39.3805 246.741 39.3805Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M261.261 32.4512H258.979V37.5752C258.979 38.4686 259.502 38.6619 260.305 38.6619C260.61 38.6619 260.934 38.6192 261.261 38.6192V41.3339C260.589 41.3566 259.914 41.4419 259.242 41.4419C256.091 41.4419 255.287 40.5299 255.287 37.4672V32.4512H253.419V30.0619H255.287V26.6526H258.979V30.0619H261.261V32.4512Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M266.463 28.6509H262.771V25.8255H266.463V28.6509Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M262.771 30.0629H266.463V41.335H262.771V30.0629Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M273.933 29.7375C277.429 29.7375 279.884 32.3202 279.884 35.7082C279.884 39.0988 277.429 41.6602 273.933 41.6602C270.435 41.6602 268.004 39.0988 268.004 35.7082C268.004 32.3202 270.435 29.7375 273.933 29.7375ZM273.933 38.8362C275.649 38.8362 276.192 37.1428 276.192 35.7082C276.192 34.2762 275.649 32.5602 273.933 32.5602C272.217 32.5602 271.696 34.2762 271.696 35.7082C271.696 37.1428 272.217 38.8362 273.933 38.8362Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M281.37 30.0625H284.954V31.6051H284.998C285.671 30.4531 287.19 29.7371 288.537 29.7371C292.295 29.7371 292.601 32.4718 292.601 34.1025V41.3345H288.906V35.8825C288.906 34.3398 289.081 32.7771 287.061 32.7771C285.671 32.7771 285.062 33.9491 285.062 35.1865V41.3345H281.37V30.0625Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M169.13 0.000457764H131.548L120.272 11.2751V48.8591L131.548 60.1338H169.13L180.408 48.8591V37.5831L176.649 33.8205H157.856V37.5831H142.822V22.5485H157.856V26.2605H176.649L180.408 22.5485V11.2751L169.13 0.000457764Z",
        fill: "#6699CC"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M56.3773 0.000457764H41.344L37.5853 3.75646V18.7898L18.792 0.000457764H3.76L0 3.75646V56.3765L3.76 60.1338H18.792L22.552 56.3765V41.3405L41.344 60.1338H56.3773L60.1347 56.3765V3.75646L56.3773 0.000457764Z",
        fill: "#80B24C"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.6864 60.1333H97.7197L101.478 56.376V45.1013L120.272 26.308V3.7573L116.513 -3.05176e-05H101.478L97.7197 3.7573V11.2746L90.2037 18.7906L82.6864 11.2746V3.7573L78.9277 -3.05176e-05H63.8944L60.1357 3.7573V26.308L78.9277 45.1013V56.376L82.6864 60.1333Z",
        fill: "#FF9933"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M173.67 0.537792V0.00179172H176.397V0.537792H175.356V3.20312H174.718V0.537792H173.67Z",
        fill: "#6699CC"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M177.853 0.00179172L178.672 2.29513L179.485 0.00179172H180.404V3.20312H179.815V0.623125L178.933 3.20312H178.421L177.529 0.623125V3.20312H176.941V0.00179172H177.853Z",
        fill: "#6699CC"
    })), /* @__PURE__ */ $acw62.createElement("defs", null, /* @__PURE__ */ $acw62.createElement("clipPath", {
        id: "clip0_68248_67681"
    }, /* @__PURE__ */ $acw62.createElement("rect", {
        width: 340.339,
        height: 60.1337,
        fill: "white"
    })))), $0422a6ce4ea03acc$var$Wz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 341 61",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_77131_127719)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M188.913 1.96319H195.581C200.337 1.96319 203.182 4.85386 203.182 9.65253C203.182 14.7339 200.294 17.4712 195.581 17.4712H188.913V1.96319ZM192.953 13.9952H194.863C197.926 13.9325 199.143 12.7379 199.143 9.62986C199.143 6.80719 197.622 5.43919 194.863 5.43919H192.953V13.9952Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M207.932 12.7382C207.997 14.2782 208.888 15.2995 210.45 15.2995C211.341 15.2995 212.21 14.8875 212.558 14.0609H216.012C215.338 16.6675 212.926 17.7969 210.408 17.7969C206.737 17.7969 204.24 15.5809 204.24 11.8035C204.24 8.35021 206.998 5.87421 210.321 5.87421C214.36 5.87421 216.381 8.91554 216.206 12.7382H207.932ZM212.514 10.6742C212.449 9.41421 211.558 8.37288 210.321 8.37288C209.017 8.37288 208.149 9.30488 207.932 10.6742H212.514Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M217.615 6.19995H221.134V7.50262H221.176C221.894 6.43862 222.98 5.87462 224.283 5.87462C227.823 5.87462 229.322 8.91462 229.322 12.0853C229.322 15.0173 227.758 17.796 224.564 17.796C223.175 17.796 222.111 17.2773 221.35 16.256H221.307V21.252H217.615V6.19995ZM221.176 11.7173C221.176 13.6933 221.742 14.9733 223.414 14.9733C225.064 14.9733 225.63 13.2573 225.63 11.7173C225.63 10.2826 225.064 8.69729 223.435 8.69729C222.436 8.69729 221.176 9.39329 221.176 11.7173Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M230.668 9.67554C230.735 8.19821 231.428 7.24088 232.427 6.65554C233.428 6.09154 234.729 5.87421 236.012 5.87421C238.683 5.87421 241.267 6.45954 241.267 9.65287V14.5835C241.267 15.5382 241.267 16.5822 241.703 17.4715H237.987C237.859 17.1235 237.813 16.7755 237.771 16.4075C236.815 17.4062 235.404 17.7969 234.057 17.7969C231.907 17.7969 230.212 16.7129 230.212 14.3862C230.212 10.7169 234.209 10.9995 236.772 10.4769C237.401 10.3489 237.749 10.1315 237.749 9.43554C237.749 8.58888 236.728 8.26221 235.968 8.26221C234.948 8.26221 234.296 8.71821 234.121 9.67554H230.668ZM235.447 15.5182C237.205 15.5182 237.792 14.5182 237.705 12.1942C237.184 12.5195 236.228 12.5849 235.425 12.8009C234.6 12.9969 233.904 13.3449 233.904 14.2355C233.904 15.1475 234.621 15.5182 235.447 15.5182Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M243.378 6.19968H246.961V8.17568H247.003C247.547 6.74101 248.807 5.98235 250.393 5.98235C250.674 5.98235 250.979 6.00368 251.262 6.06901V9.43568C250.783 9.30501 250.35 9.21835 249.849 9.21835C248.026 9.21835 247.07 10.477 247.07 11.8903V17.4717H243.378V6.19968Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M259.404 8.58941H257.123V13.7134C257.123 14.6054 257.646 14.8001 258.448 14.8001C258.751 14.8001 259.078 14.7574 259.404 14.7574V17.4721C258.73 17.4947 258.058 17.5801 257.383 17.5801C254.235 17.5801 253.431 16.6681 253.431 13.6054V8.58941H251.563V6.20008H253.431V2.78941H257.123V6.20008H259.404V8.58941Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M260.831 6.19968H264.414V7.74235H264.459C265.131 6.61301 266.324 5.87435 267.692 5.87435C269.106 5.87435 270.364 6.33035 270.972 7.69701C271.864 6.50235 272.972 5.87435 274.492 5.87435C278.075 5.87435 278.466 8.58901 278.466 10.7383V17.4717H274.774V10.8477C274.774 9.63035 274.187 8.91435 273.232 8.91435C271.647 8.91435 271.494 10.1317 271.494 11.9543V17.4717H267.803V11.0637C267.803 9.73835 267.411 8.91435 266.412 8.91435C265.088 8.91435 264.523 9.67568 264.523 11.977V17.4717H260.831V6.19968Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M283.631 12.7382C283.695 14.2782 284.587 15.2995 286.15 15.2995C287.042 15.2995 287.91 14.8875 288.258 14.0609H291.711C291.038 16.6675 288.627 17.7969 286.107 17.7969C282.437 17.7969 279.939 15.5809 279.939 11.8035C279.939 8.35021 282.697 5.87421 286.019 5.87421C290.059 5.87421 292.081 8.91554 291.906 12.7382H283.631ZM288.214 10.6742C288.149 9.41421 287.259 8.37288 286.019 8.37288C284.718 8.37288 283.849 9.30488 283.631 10.6742H288.214Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M293.316 6.19968H296.898V7.74235H296.941C297.616 6.59035 299.136 5.87435 300.482 5.87435C304.238 5.87435 304.544 8.60901 304.544 10.2397V17.4717H300.852V12.0197C300.852 10.477 301.026 8.91435 299.005 8.91435C297.616 8.91435 297.008 10.0863 297.008 11.3237V17.4717H293.316V6.19968Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M313.231 8.58941H310.953V13.7134C310.953 14.6054 311.473 14.8001 312.278 14.8001C312.581 14.8001 312.907 14.7574 313.231 14.7574V17.4721C312.559 17.4947 311.885 17.5801 311.213 17.5801C308.063 17.5801 307.261 16.6681 307.261 13.6054V8.58941H305.393V6.20008H307.261V2.78941H310.953V6.20008H313.231V8.58941Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M326.246 5.87457C329.742 5.87457 332.196 8.45856 332.196 11.8452C332.196 15.2359 329.742 17.7959 326.246 17.7959C322.747 17.7959 320.316 15.2359 320.316 11.8452C320.316 8.45856 322.747 5.87457 326.246 5.87457ZM326.246 14.9732C327.962 14.9732 328.504 13.2799 328.504 11.8452C328.504 10.4132 327.962 8.69723 326.246 8.69723C324.53 8.69723 324.008 10.4132 324.008 11.8452C324.008 13.2799 324.53 14.9732 326.246 14.9732Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M334.281 8.58901H332.498V6.19968H334.281C334.281 2.96368 335.409 1.96235 338.559 1.96235C339.145 1.96235 339.753 2.00768 340.339 2.02901V4.63435C339.991 4.59168 339.667 4.57168 339.341 4.57168C338.493 4.57168 337.973 4.67968 337.973 5.69968V6.19968H340.187V8.58901H337.973V17.4717H334.281V8.58901Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M188.913 25.8255H201.271V29.0615H192.953V31.7788H200.554V34.9042H192.953V37.8588H201.487V41.3335H188.913V25.8255Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M214.339 41.3338H210.82V40.0312H210.777C210.06 41.0938 208.973 41.6592 207.671 41.6592C204.131 41.6592 202.632 38.6192 202.632 35.4485C202.632 32.5165 204.196 29.7365 207.389 29.7365C208.779 29.7365 209.843 30.2565 210.603 31.2778H210.647V25.8258H214.339V41.3338ZM206.324 35.5792C206.324 37.1205 206.889 38.8365 208.583 38.8365C210.385 38.8365 210.777 37.1205 210.777 35.6885C210.777 34.0578 210.189 32.5592 208.583 32.5592C206.889 32.5592 206.324 34.1458 206.324 35.5792Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M227.625 41.3338H224.041V39.7912H223.998C223.302 40.9432 221.87 41.6592 220.566 41.6592C217.329 41.6592 216.396 39.7912 216.396 36.8378V30.0618H220.088V36.6005C220.088 38.0978 220.74 38.6192 221.913 38.6192C222.716 38.6192 223.933 38.0978 223.933 36.0992V30.0618H227.625V41.3338Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M237.03 34.1885C237.008 33.2338 236.16 32.5605 235.227 32.5605C233.164 32.5605 232.838 34.3192 232.838 35.8832C232.838 37.3392 233.468 38.8365 235.032 38.8365C236.312 38.8365 236.966 38.0978 237.139 36.9032H240.722C240.398 39.9218 238.05 41.6592 235.054 41.6592C231.664 41.6592 229.146 39.3352 229.146 35.8832C229.146 32.2978 231.426 29.7365 235.054 29.7365C237.855 29.7365 240.352 31.2138 240.614 34.1885H237.03Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M241.963 33.5378C242.029 32.0618 242.723 31.1032 243.721 30.5192C244.723 29.9538 246.024 29.7378 247.307 29.7378C249.977 29.7378 252.561 30.3218 252.561 33.5152V38.4458C252.561 39.4005 252.561 40.4445 252.997 41.3338H249.281C249.153 40.9858 249.108 40.6392 249.065 40.2698C248.109 41.2685 246.699 41.6592 245.352 41.6592C243.201 41.6592 241.507 40.5752 241.507 38.2498C241.507 34.5792 245.504 34.8618 248.067 34.3405C248.696 34.2112 249.044 33.9938 249.044 33.2992C249.044 32.4512 248.024 32.1245 247.263 32.1245C246.243 32.1245 245.591 32.5805 245.416 33.5378H241.963ZM246.741 39.3805C248.5 39.3805 249.087 38.3805 249 36.0565C248.479 36.3818 247.523 36.4472 246.72 36.6645C245.895 36.8605 245.199 37.2085 245.199 38.0978C245.199 39.0098 245.916 39.3805 246.741 39.3805Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M261.261 32.4512H258.979V37.5752C258.979 38.4686 259.502 38.6619 260.305 38.6619C260.61 38.6619 260.934 38.6192 261.261 38.6192V41.3339C260.589 41.3566 259.914 41.4419 259.242 41.4419C256.091 41.4419 255.287 40.5299 255.287 37.4672V32.4512H253.419V30.0619H255.287V26.6526H258.979V30.0619H261.261V32.4512Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M266.463 28.6509H262.771V25.8255H266.463V28.6509Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M262.771 30.0629H266.463V41.335H262.771V30.0629Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M273.933 29.7375C277.429 29.7375 279.884 32.3202 279.884 35.7082C279.884 39.0988 277.429 41.6602 273.933 41.6602C270.435 41.6602 268.004 39.0988 268.004 35.7082C268.004 32.3202 270.435 29.7375 273.933 29.7375ZM273.933 38.8362C275.649 38.8362 276.192 37.1428 276.192 35.7082C276.192 34.2762 275.649 32.5602 273.933 32.5602C272.217 32.5602 271.696 34.2762 271.696 35.7082C271.696 37.1428 272.217 38.8362 273.933 38.8362Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M281.37 30.0625H284.954V31.6051H284.998C285.671 30.4531 287.19 29.7371 288.537 29.7371C292.295 29.7371 292.601 32.4718 292.601 34.1025V41.3345H288.906V35.8825C288.906 34.3398 289.081 32.7771 287.061 32.7771C285.671 32.7771 285.062 33.9491 285.062 35.1865V41.3345H281.37V30.0625Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M169.13 0.000457764H131.548L120.272 11.2751V48.8591L131.548 60.1338H169.13L180.408 48.8591V37.5831L176.649 33.8205H157.856V37.5831H142.822V22.5485H157.856V26.2605H176.649L180.408 22.5485V11.2751L169.13 0.000457764Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M56.3773 0.000457764H41.344L37.5853 3.75646V18.7898L18.792 0.000457764H3.76L0 3.75646V56.3765L3.76 60.1338H18.792L22.552 56.3765V41.3405L41.344 60.1338H56.3773L60.1347 56.3765V3.75646L56.3773 0.000457764Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.6864 60.1333H97.7197L101.478 56.376V45.1013L120.272 26.308V3.7573L116.513 -3.05176e-05H101.478L97.7197 3.7573V11.2746L90.2037 18.7906L82.6864 11.2746V3.7573L78.9277 -3.05176e-05H63.8944L60.1357 3.7573V26.308L78.9277 45.1013V56.376L82.6864 60.1333Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M173.67 0.537792V0.00179172H176.397V0.537792H175.356V3.20312H174.718V0.537792H173.67Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M177.853 0.00179172L178.672 2.29513L179.485 0.00179172H180.404V3.20312H179.815V0.623125L178.933 3.20312H178.421L177.529 0.623125V3.20312H176.941V0.00179172H177.853Z",
        fill: "white"
    }))), $0422a6ce4ea03acc$var$Qz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 332 63",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M266.463 28.6509H262.771V25.8255H266.463V28.6509Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M169.13 2.00046H131.547L120.271 13.2751V50.8591L131.547 62.1338H169.13L180.407 50.8591V39.5831L176.649 35.8205H157.855V39.5831H142.822V24.5485H157.855V28.2605H176.649L180.407 24.5485V13.2751L169.13 2.00046Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M56.3773 2.00046H41.344L37.5853 5.75646V20.7898L18.792 2.00046H3.76L0 5.75646V58.3765L3.76 62.1338H18.792L22.552 58.3765V43.3405L41.344 62.1338H56.3773L60.1347 58.3765V5.75646L56.3773 2.00046Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.6874 62.1333H97.7207L101.479 58.376V47.1013L120.273 28.308V5.7573L116.514 1.99997H101.479L97.7207 5.7573V13.2746L90.2047 20.7906L82.6874 13.2746V5.7573L78.9287 1.99997H63.8954L60.1367 5.7573V28.308L78.9287 47.1013V58.376L82.6874 62.1333Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M173.67 2.53779V2.00179H176.397V2.53779H175.355V5.20312H174.718V2.53779H173.67Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M177.853 2.00179L178.672 4.29513L179.485 2.00179H180.404V5.20312H179.815V2.62313L178.933 5.20312H178.421L177.529 2.62313V5.20312H176.941V2.00179H177.853Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M196.303 20.5066V15.4794H202.487C203.886 15.4794 204.977 15.1238 205.76 14.4125C206.556 13.7012 206.954 12.6704 206.954 11.3202V11.284C206.954 9.92176 206.556 8.89101 205.76 8.19178C204.977 7.49256 203.886 7.14295 202.487 7.14295H196.303V2.04342H204.079C206.02 2.04342 207.707 2.4292 209.142 3.20076C210.577 3.96027 211.686 5.03322 212.469 6.41961C213.265 7.79395 213.663 9.41543 213.663 11.284V11.3202C213.663 13.1768 213.265 14.7983 212.469 16.1847C211.686 17.559 210.577 18.6259 209.142 19.3854C207.707 20.1329 206.02 20.5066 204.079 20.5066H196.303ZM192.957 28.1378V2.04342H199.594V28.1378H192.957Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M222.867 28.5537C221.433 28.5537 220.209 28.2583 219.196 27.6676C218.184 27.0769 217.412 26.227 216.882 25.1179C216.351 24.0087 216.086 22.6766 216.086 21.1214V8.44495H222.506V19.7471C222.506 20.8683 222.771 21.7483 223.301 22.3873C223.832 23.0141 224.621 23.3276 225.67 23.3276C226.177 23.3276 226.635 23.2372 227.045 23.0563C227.454 22.8755 227.804 22.6223 228.093 22.2968C228.383 21.9713 228.6 21.5795 228.744 21.1214C228.901 20.6633 228.979 20.163 228.979 19.6205V8.44495H235.399V28.1378H228.979V24.6658H228.853C228.515 25.4855 228.069 26.1908 227.515 26.7815C226.96 27.3602 226.297 27.8002 225.526 28.1016C224.754 28.403 223.868 28.5537 222.867 28.5537Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M251.114 28.5537C250.173 28.5537 249.311 28.403 248.528 28.1016C247.744 27.8002 247.063 27.3722 246.484 26.8177C245.918 26.2511 245.472 25.5699 245.146 24.7743H245.019V28.1378H238.6V2.04342H245.019V11.935H245.146C245.484 11.1153 245.936 10.416 246.502 9.83737C247.081 9.24665 247.756 8.80059 248.528 8.4992C249.311 8.18576 250.167 8.02903 251.095 8.02903C252.759 8.02903 254.176 8.4329 255.345 9.24062C256.514 10.0363 257.407 11.1997 258.021 12.7307C258.648 14.2497 258.962 16.0942 258.962 18.2642V18.2823C258.962 20.4523 258.648 22.3029 258.021 23.8339C257.407 25.365 256.508 26.5344 255.327 27.3421C254.158 28.1498 252.753 28.5537 251.114 28.5537ZM248.745 23.3276C249.504 23.3276 250.161 23.1226 250.716 22.7128C251.27 22.3029 251.692 21.7242 251.982 20.9768C252.283 20.2293 252.434 19.3312 252.434 18.2823V18.2642C252.434 17.2275 252.283 16.3353 251.982 15.5879C251.68 14.8284 251.252 14.2497 250.698 13.8519C250.143 13.4541 249.492 13.2551 248.745 13.2551C248.009 13.2551 247.358 13.4601 246.792 13.87C246.237 14.2678 245.803 14.8404 245.49 15.5879C245.176 16.3353 245.019 17.2335 245.019 18.2823V18.3004C245.019 19.3372 245.176 20.2353 245.49 20.9948C245.803 21.7423 246.237 22.321 246.792 22.7308C247.346 23.1287 247.997 23.3276 248.745 23.3276Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M261.566 28.1378V2.04342H267.985V28.1378H261.566Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M271.24 28.1378V8.44495H277.66V28.1378H271.24ZM274.441 6.32919C273.525 6.32919 272.747 6.01575 272.108 5.38886C271.482 4.76196 271.168 4.02054 271.168 3.1646C271.168 2.29659 271.482 1.55517 272.108 0.940337C272.747 0.313446 273.525 0 274.441 0C275.369 0 276.147 0.313446 276.774 0.940337C277.401 1.55517 277.714 2.29659 277.714 3.1646C277.714 4.02054 277.401 4.76196 276.774 5.38886C276.147 6.01575 275.369 6.32919 274.441 6.32919Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M290.228 28.5537C288.166 28.5537 286.382 28.1438 284.875 27.324C283.38 26.4922 282.229 25.3107 281.421 23.7797C280.614 22.2366 280.21 20.3981 280.21 18.2642V18.2462C280.21 16.1364 280.614 14.316 281.421 12.785C282.241 11.2539 283.392 10.0785 284.875 9.2587C286.37 8.43892 288.136 8.02903 290.174 8.02903C292.03 8.02903 293.652 8.37262 295.038 9.05979C296.425 9.7349 297.504 10.6752 298.275 11.8808C299.047 13.0864 299.451 14.4728 299.487 16.04V16.1666H293.591L293.573 15.9857C293.453 15.0816 293.109 14.3401 292.543 13.7615C291.976 13.1828 291.223 12.8935 290.282 12.8935C289.547 12.8935 288.908 13.1044 288.365 13.5264C287.835 13.9483 287.425 14.5632 287.136 15.3709C286.858 16.1666 286.72 17.137 286.72 18.2823V18.3004C286.72 19.4457 286.858 20.4222 287.136 21.2299C287.425 22.0376 287.835 22.6525 288.365 23.0744C288.908 23.4843 289.553 23.6893 290.3 23.6893C291.241 23.6893 291.988 23.412 292.543 22.8574C293.109 22.2908 293.453 21.5373 293.573 20.597L293.61 20.4162H299.505L299.487 20.5247C299.451 22.0557 299.053 23.424 298.293 24.6296C297.546 25.8352 296.485 26.7936 295.11 27.5049C293.748 28.2041 292.121 28.5537 290.228 28.5537Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M203.03 62C200.86 62 198.973 61.6926 197.37 61.0777C195.778 60.4509 194.531 59.5527 193.626 58.3833C192.734 57.2139 192.234 55.7974 192.126 54.1337L192.107 53.8082H198.274L198.31 53.989C198.431 54.5557 198.708 55.0499 199.142 55.4719C199.588 55.8818 200.155 56.2073 200.842 56.4484C201.529 56.6774 202.294 56.792 203.138 56.792C204.018 56.792 204.772 56.6774 205.399 56.4484C206.038 56.2073 206.532 55.8818 206.882 55.4719C207.231 55.062 207.406 54.5858 207.406 54.0433V54.0252C207.406 53.2898 207.087 52.7232 206.448 52.3254C205.809 51.9155 204.724 51.5659 203.193 51.2765L200.516 50.7521C197.936 50.2699 195.971 49.4019 194.621 48.1481C193.283 46.8823 192.614 45.2487 192.614 43.2475V43.2294C192.614 41.5537 193.06 40.101 193.952 38.8713C194.844 37.6296 196.068 36.6712 197.623 35.9961C199.19 35.3089 200.968 34.9653 202.957 34.9653C205.14 34.9653 206.996 35.2908 208.527 35.9418C210.058 36.5808 211.24 37.4849 212.072 38.6543C212.915 39.8237 213.374 41.1981 213.446 42.7773L213.464 43.1571H207.297L207.279 42.9582C207.207 42.3795 206.984 41.8852 206.61 41.4753C206.237 41.0654 205.742 40.746 205.127 40.5169C204.513 40.2879 203.807 40.1733 203.012 40.1733C202.204 40.1733 201.517 40.2879 200.95 40.5169C200.384 40.746 199.95 41.0594 199.648 41.4572C199.359 41.843 199.214 42.2831 199.214 42.7773V42.7954C199.214 43.4946 199.534 44.0492 200.173 44.4591C200.812 44.869 201.83 45.2065 203.229 45.4718L205.905 45.9781C207.762 46.3277 209.287 46.822 210.48 47.4609C211.674 48.0999 212.56 48.9136 213.138 49.9022C213.717 50.8787 214.006 52.0662 214.006 53.4646V53.4827C214.006 55.2187 213.572 56.7257 212.704 58.0036C211.836 59.2815 210.583 60.27 208.943 60.9692C207.304 61.6564 205.332 62 203.03 62Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M226.068 61.9457C224.007 61.9457 222.222 61.5359 220.715 60.7161C219.22 59.8842 218.069 58.7028 217.261 57.1717C216.454 55.6286 216.05 53.7901 216.05 51.6563V51.6382C216.05 49.5285 216.454 47.7081 217.261 46.177C218.081 44.646 219.233 43.4705 220.715 42.6508C222.21 41.831 223.976 41.4211 226.014 41.4211C227.87 41.4211 229.492 41.7647 230.878 42.4518C232.265 43.1269 233.344 44.0673 234.115 45.2729C234.887 46.4784 235.291 47.8648 235.327 49.432V49.5586H229.432L229.413 49.3778C229.293 48.4736 228.949 47.7322 228.383 47.1535C227.816 46.5748 227.063 46.2855 226.122 46.2855C225.387 46.2855 224.748 46.4965 224.205 46.9184C223.675 47.3404 223.265 47.9552 222.976 48.7629C222.699 49.5586 222.56 50.5291 222.56 51.6744V51.6925C222.56 52.8377 222.699 53.8142 222.976 54.622C223.265 55.4297 223.675 56.0445 224.205 56.4665C224.748 56.8764 225.393 57.0813 226.14 57.0813C227.081 57.0813 227.828 56.804 228.383 56.2495C228.949 55.6829 229.293 54.9294 229.413 53.989L229.45 53.8082H235.345L235.327 53.9167C235.291 55.4478 234.893 56.8161 234.133 58.0217C233.386 59.2272 232.325 60.1856 230.951 60.8969C229.588 61.5961 227.961 61.9457 226.068 61.9457Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M237.804 61.5298V35.4355H244.224V45.3813H244.35C244.857 44.0914 245.61 43.1089 246.611 42.4338C247.623 41.7586 248.871 41.4211 250.354 41.4211C251.789 41.4211 253.012 41.7285 254.025 42.3433C255.05 42.9461 255.827 43.8141 256.358 44.9473C256.9 46.0685 257.172 47.4248 257.172 49.0161V61.5298H250.752V50.3905C250.752 49.2211 250.475 48.3048 249.92 47.6418C249.378 46.9787 248.576 46.6472 247.515 46.6472C246.852 46.6472 246.273 46.8099 245.779 47.1354C245.285 47.4489 244.899 47.8829 244.622 48.4374C244.356 48.992 244.224 49.637 244.224 50.3724V61.5298H237.804Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M269.703 61.9457C267.63 61.9457 265.839 61.5419 264.333 60.7342C262.826 59.9264 261.662 58.757 260.842 57.226C260.035 55.6949 259.631 53.8504 259.631 51.6925V51.6563C259.631 49.5345 260.047 47.7081 260.879 46.177C261.71 44.6339 262.88 43.4585 264.387 42.6508C265.894 41.831 267.666 41.4211 269.703 41.4211C271.753 41.4211 273.531 41.831 275.038 42.6508C276.545 43.4585 277.714 44.6279 278.546 46.1589C279.378 47.6779 279.794 49.5104 279.794 51.6563V51.6925C279.794 53.8625 279.384 55.713 278.564 57.2441C277.744 58.7751 276.581 59.9445 275.074 60.7522C273.579 61.5479 271.789 61.9457 269.703 61.9457ZM269.721 57.0813C270.457 57.0813 271.09 56.8764 271.62 56.4665C272.151 56.0445 272.554 55.4297 272.832 54.622C273.121 53.8142 273.266 52.8377 273.266 51.6925V51.6563C273.266 50.5231 273.115 49.5586 272.814 48.7629C272.524 47.9552 272.114 47.3404 271.584 46.9184C271.054 46.4965 270.427 46.2855 269.703 46.2855C268.992 46.2855 268.365 46.4965 267.823 46.9184C267.292 47.3404 266.876 47.9552 266.575 48.7629C266.286 49.5586 266.141 50.5231 266.141 51.6563V51.6925C266.141 52.8377 266.286 53.8142 266.575 54.622C266.864 55.4297 267.274 56.0445 267.805 56.4665C268.347 56.8764 268.986 57.0813 269.721 57.0813Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M291.765 61.9457C289.692 61.9457 287.901 61.5419 286.394 60.7342C284.887 59.9264 283.724 58.757 282.904 57.226C282.096 55.6949 281.693 53.8504 281.693 51.6925V51.6563C281.693 49.5345 282.109 47.7081 282.94 46.177C283.772 44.6339 284.942 43.4585 286.449 42.6508C287.956 41.831 289.728 41.4211 291.765 41.4211C293.815 41.4211 295.593 41.831 297.1 42.6508C298.607 43.4585 299.776 44.6279 300.608 46.1589C301.44 47.6779 301.856 49.5104 301.856 51.6563V51.6925C301.856 53.8625 301.446 55.713 300.626 57.2441C299.806 58.7751 298.643 59.9445 297.136 60.7522C295.641 61.5479 293.851 61.9457 291.765 61.9457ZM291.783 57.0813C292.519 57.0813 293.151 56.8764 293.682 56.4665C294.212 56.0445 294.616 55.4297 294.894 54.622C295.183 53.8142 295.327 52.8377 295.327 51.6925V51.6563C295.327 50.5231 295.177 49.5586 294.875 48.7629C294.586 47.9552 294.176 47.3404 293.646 46.9184C293.115 46.4965 292.488 46.2855 291.765 46.2855C291.054 46.2855 290.427 46.4965 289.884 46.9184C289.354 47.3404 288.938 47.9552 288.637 48.7629C288.347 49.5586 288.203 50.5231 288.203 51.6563V51.6925C288.203 52.8377 288.347 53.8142 288.637 54.622C288.926 55.4297 289.336 56.0445 289.866 56.4665C290.409 56.8764 291.048 57.0813 291.783 57.0813Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M304.46 61.5298V35.4355H310.879V61.5298H304.46Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M322.742 61.9457C320.789 61.9457 319.137 61.6805 317.787 61.1501C316.437 60.6076 315.388 59.8541 314.641 58.8897C313.893 57.9252 313.447 56.804 313.302 55.5261L313.284 55.3634H319.505L319.541 55.5081C319.698 56.1711 320.035 56.6895 320.554 57.0632C321.084 57.4369 321.814 57.6238 322.742 57.6238C323.309 57.6238 323.797 57.5575 324.207 57.4249C324.617 57.2923 324.93 57.1054 325.147 56.8643C325.364 56.6111 325.473 56.3218 325.473 55.9963V55.9782C325.473 55.5442 325.292 55.1946 324.93 54.9294C324.58 54.6521 323.966 54.423 323.086 54.2422L319.614 53.5731C318.336 53.32 317.257 52.9342 316.377 52.4158C315.509 51.8853 314.852 51.2343 314.405 50.4628C313.971 49.6912 313.754 48.8051 313.754 47.8045V47.7864C313.754 46.4724 314.104 45.3452 314.803 44.4048C315.515 43.4525 316.527 42.7171 317.841 42.1987C319.167 41.6803 320.723 41.4211 322.507 41.4211C324.412 41.4211 326.009 41.7164 327.299 42.3072C328.601 42.8858 329.59 43.6634 330.265 44.6399C330.94 45.6044 331.283 46.6773 331.295 47.8588V48.0034H325.436L325.418 47.8588C325.358 47.2801 325.081 46.7858 324.586 46.3759C324.092 45.954 323.399 45.743 322.507 45.743C321.988 45.743 321.536 45.8153 321.151 45.96C320.765 46.0926 320.463 46.2855 320.246 46.5387C320.041 46.7798 319.939 47.0752 319.939 47.4248V47.4429C319.939 47.7201 320.011 47.9673 320.156 48.1843C320.301 48.4013 320.554 48.5881 320.916 48.7449C321.277 48.9016 321.771 49.0462 322.398 49.1789L325.852 49.866C327.962 50.2759 329.487 50.9149 330.427 51.7829C331.38 52.6388 331.856 53.8022 331.856 55.273V55.2911C331.856 56.6413 331.47 57.8167 330.699 58.8173C329.927 59.8179 328.86 60.5895 327.498 61.132C326.136 61.6745 324.55 61.9457 322.742 61.9457Z",
        fill: "black"
    })), $0422a6ce4ea03acc$var$qz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 332 63",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M266.463 28.6509H262.771V25.8255H266.463V28.6509Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M169.13 2.00046H131.547L120.271 13.2751V50.8591L131.547 62.1338H169.13L180.407 50.8591V39.5831L176.649 35.8205H157.855V39.5831H142.822V24.5485H157.855V28.2605H176.649L180.407 24.5485V13.2751L169.13 2.00046Z",
        fill: "#6699CC"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M56.3773 2.00046H41.344L37.5853 5.75646V20.7898L18.792 2.00046H3.76L0 5.75646V58.3765L3.76 62.1338H18.792L22.552 58.3765V43.3405L41.344 62.1338H56.3773L60.1347 58.3765V5.75646L56.3773 2.00046Z",
        fill: "#80B24C"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.6874 62.1333H97.7207L101.479 58.376V47.1013L120.273 28.308V5.7573L116.514 1.99997H101.479L97.7207 5.7573V13.2746L90.2047 20.7906L82.6874 13.2746V5.7573L78.9287 1.99997H63.8954L60.1367 5.7573V28.308L78.9287 47.1013V58.376L82.6874 62.1333Z",
        fill: "#FF9933"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M173.67 2.53779V2.00179H176.397V2.53779H175.355V5.20312H174.718V2.53779H173.67Z",
        fill: "#6699CC"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M177.853 2.00179L178.672 4.29513L179.485 2.00179H180.404V5.20312H179.815V2.62313L178.933 5.20312H178.421L177.529 2.62313V5.20312H176.941V2.00179H177.853Z",
        fill: "#6699CC"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M196.303 20.5066V15.4794H202.487C203.886 15.4794 204.977 15.1238 205.76 14.4125C206.556 13.7012 206.954 12.6704 206.954 11.3202V11.284C206.954 9.92176 206.556 8.89101 205.76 8.19178C204.977 7.49256 203.886 7.14295 202.487 7.14295H196.303V2.04342H204.079C206.02 2.04342 207.707 2.4292 209.142 3.20076C210.577 3.96027 211.686 5.03322 212.469 6.41961C213.265 7.79395 213.663 9.41543 213.663 11.284V11.3202C213.663 13.1768 213.265 14.7983 212.469 16.1847C211.686 17.559 210.577 18.6259 209.142 19.3854C207.707 20.1329 206.02 20.5066 204.079 20.5066H196.303ZM192.957 28.1378V2.04342H199.594V28.1378H192.957Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M222.867 28.5537C221.433 28.5537 220.209 28.2583 219.196 27.6676C218.184 27.0769 217.412 26.227 216.882 25.1179C216.351 24.0087 216.086 22.6766 216.086 21.1214V8.44495H222.506V19.7471C222.506 20.8683 222.771 21.7483 223.301 22.3873C223.832 23.0141 224.621 23.3276 225.67 23.3276C226.177 23.3276 226.635 23.2372 227.045 23.0563C227.454 22.8755 227.804 22.6223 228.093 22.2968C228.383 21.9713 228.6 21.5795 228.744 21.1214C228.901 20.6633 228.979 20.163 228.979 19.6205V8.44495H235.399V28.1378H228.979V24.6658H228.853C228.515 25.4855 228.069 26.1908 227.515 26.7815C226.96 27.3602 226.297 27.8002 225.526 28.1016C224.754 28.403 223.868 28.5537 222.867 28.5537Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M251.114 28.5537C250.173 28.5537 249.311 28.403 248.528 28.1016C247.744 27.8002 247.063 27.3722 246.484 26.8177C245.918 26.2511 245.472 25.5699 245.146 24.7743H245.019V28.1378H238.6V2.04342H245.019V11.935H245.146C245.484 11.1153 245.936 10.416 246.502 9.83737C247.081 9.24665 247.756 8.80059 248.528 8.4992C249.311 8.18576 250.167 8.02903 251.095 8.02903C252.759 8.02903 254.176 8.4329 255.345 9.24062C256.514 10.0363 257.407 11.1997 258.021 12.7307C258.648 14.2497 258.962 16.0942 258.962 18.2642V18.2823C258.962 20.4523 258.648 22.3029 258.021 23.8339C257.407 25.365 256.508 26.5344 255.327 27.3421C254.158 28.1498 252.753 28.5537 251.114 28.5537ZM248.745 23.3276C249.504 23.3276 250.161 23.1226 250.716 22.7128C251.27 22.3029 251.692 21.7242 251.982 20.9768C252.283 20.2293 252.434 19.3312 252.434 18.2823V18.2642C252.434 17.2275 252.283 16.3353 251.982 15.5879C251.68 14.8284 251.252 14.2497 250.698 13.8519C250.143 13.4541 249.492 13.2551 248.745 13.2551C248.009 13.2551 247.358 13.4601 246.792 13.87C246.237 14.2678 245.803 14.8404 245.49 15.5879C245.176 16.3353 245.019 17.2335 245.019 18.2823V18.3004C245.019 19.3372 245.176 20.2353 245.49 20.9948C245.803 21.7423 246.237 22.321 246.792 22.7308C247.346 23.1287 247.997 23.3276 248.745 23.3276Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M261.566 28.1378V2.04342H267.985V28.1378H261.566Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M271.24 28.1378V8.44495H277.66V28.1378H271.24ZM274.441 6.32919C273.525 6.32919 272.747 6.01575 272.108 5.38886C271.482 4.76196 271.168 4.02054 271.168 3.1646C271.168 2.29659 271.482 1.55517 272.108 0.940337C272.747 0.313446 273.525 0 274.441 0C275.369 0 276.147 0.313446 276.774 0.940337C277.401 1.55517 277.714 2.29659 277.714 3.1646C277.714 4.02054 277.401 4.76196 276.774 5.38886C276.147 6.01575 275.369 6.32919 274.441 6.32919Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M290.228 28.5537C288.166 28.5537 286.382 28.1438 284.875 27.324C283.38 26.4922 282.229 25.3107 281.421 23.7797C280.614 22.2366 280.21 20.3981 280.21 18.2642V18.2462C280.21 16.1364 280.614 14.316 281.421 12.785C282.241 11.2539 283.392 10.0785 284.875 9.2587C286.37 8.43892 288.136 8.02903 290.174 8.02903C292.03 8.02903 293.652 8.37262 295.038 9.05979C296.425 9.7349 297.504 10.6752 298.275 11.8808C299.047 13.0864 299.451 14.4728 299.487 16.04V16.1666H293.591L293.573 15.9857C293.453 15.0816 293.109 14.3401 292.543 13.7615C291.976 13.1828 291.223 12.8935 290.282 12.8935C289.547 12.8935 288.908 13.1044 288.365 13.5264C287.835 13.9483 287.425 14.5632 287.136 15.3709C286.858 16.1666 286.72 17.137 286.72 18.2823V18.3004C286.72 19.4457 286.858 20.4222 287.136 21.2299C287.425 22.0376 287.835 22.6525 288.365 23.0744C288.908 23.4843 289.553 23.6893 290.3 23.6893C291.241 23.6893 291.988 23.412 292.543 22.8574C293.109 22.2908 293.453 21.5373 293.573 20.597L293.61 20.4162H299.505L299.487 20.5247C299.451 22.0557 299.053 23.424 298.293 24.6296C297.546 25.8352 296.485 26.7936 295.11 27.5049C293.748 28.2041 292.121 28.5537 290.228 28.5537Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M203.03 62C200.86 62 198.973 61.6926 197.37 61.0777C195.778 60.4509 194.531 59.5527 193.626 58.3833C192.734 57.2139 192.234 55.7974 192.126 54.1337L192.107 53.8082H198.274L198.31 53.989C198.431 54.5557 198.708 55.0499 199.142 55.4719C199.588 55.8818 200.155 56.2073 200.842 56.4484C201.529 56.6774 202.294 56.792 203.138 56.792C204.018 56.792 204.772 56.6774 205.399 56.4484C206.038 56.2073 206.532 55.8818 206.882 55.4719C207.231 55.062 207.406 54.5858 207.406 54.0433V54.0252C207.406 53.2898 207.087 52.7232 206.448 52.3254C205.809 51.9155 204.724 51.5659 203.193 51.2765L200.516 50.7521C197.936 50.2699 195.971 49.4019 194.621 48.1481C193.283 46.8823 192.614 45.2487 192.614 43.2475V43.2294C192.614 41.5537 193.06 40.101 193.952 38.8713C194.844 37.6296 196.068 36.6712 197.623 35.9961C199.19 35.3089 200.968 34.9653 202.957 34.9653C205.14 34.9653 206.996 35.2908 208.527 35.9418C210.058 36.5808 211.24 37.4849 212.072 38.6543C212.915 39.8237 213.374 41.1981 213.446 42.7773L213.464 43.1571H207.297L207.279 42.9582C207.207 42.3795 206.984 41.8852 206.61 41.4753C206.237 41.0654 205.742 40.746 205.127 40.5169C204.513 40.2879 203.807 40.1733 203.012 40.1733C202.204 40.1733 201.517 40.2879 200.95 40.5169C200.384 40.746 199.95 41.0594 199.648 41.4572C199.359 41.843 199.214 42.2831 199.214 42.7773V42.7954C199.214 43.4946 199.534 44.0492 200.173 44.4591C200.812 44.869 201.83 45.2065 203.229 45.4718L205.905 45.9781C207.762 46.3277 209.287 46.822 210.48 47.4609C211.674 48.0999 212.56 48.9136 213.138 49.9022C213.717 50.8787 214.006 52.0662 214.006 53.4646V53.4827C214.006 55.2187 213.572 56.7257 212.704 58.0036C211.836 59.2815 210.583 60.27 208.943 60.9692C207.304 61.6564 205.332 62 203.03 62Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M226.068 61.9457C224.007 61.9457 222.222 61.5359 220.715 60.7161C219.22 59.8842 218.069 58.7028 217.261 57.1717C216.454 55.6286 216.05 53.7901 216.05 51.6563V51.6382C216.05 49.5285 216.454 47.7081 217.261 46.177C218.081 44.646 219.233 43.4705 220.715 42.6508C222.21 41.831 223.976 41.4211 226.014 41.4211C227.87 41.4211 229.492 41.7647 230.878 42.4518C232.265 43.1269 233.344 44.0673 234.115 45.2729C234.887 46.4784 235.291 47.8648 235.327 49.432V49.5586H229.432L229.413 49.3778C229.293 48.4736 228.949 47.7322 228.383 47.1535C227.816 46.5748 227.063 46.2855 226.122 46.2855C225.387 46.2855 224.748 46.4965 224.205 46.9184C223.675 47.3404 223.265 47.9552 222.976 48.7629C222.699 49.5586 222.56 50.5291 222.56 51.6744V51.6925C222.56 52.8377 222.699 53.8142 222.976 54.622C223.265 55.4297 223.675 56.0445 224.205 56.4665C224.748 56.8764 225.393 57.0813 226.14 57.0813C227.081 57.0813 227.828 56.804 228.383 56.2495C228.949 55.6829 229.293 54.9294 229.413 53.989L229.45 53.8082H235.345L235.327 53.9167C235.291 55.4478 234.893 56.8161 234.133 58.0217C233.386 59.2272 232.325 60.1856 230.951 60.8969C229.588 61.5961 227.961 61.9457 226.068 61.9457Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M237.804 61.5298V35.4355H244.224V45.3813H244.35C244.857 44.0914 245.61 43.1089 246.611 42.4338C247.623 41.7586 248.871 41.4211 250.354 41.4211C251.789 41.4211 253.012 41.7285 254.025 42.3433C255.05 42.9461 255.827 43.8141 256.358 44.9473C256.9 46.0685 257.172 47.4248 257.172 49.0161V61.5298H250.752V50.3905C250.752 49.2211 250.475 48.3048 249.92 47.6418C249.378 46.9787 248.576 46.6472 247.515 46.6472C246.852 46.6472 246.273 46.8099 245.779 47.1354C245.285 47.4489 244.899 47.8829 244.622 48.4374C244.356 48.992 244.224 49.637 244.224 50.3724V61.5298H237.804Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M269.703 61.9457C267.63 61.9457 265.839 61.5419 264.333 60.7342C262.826 59.9264 261.662 58.757 260.842 57.226C260.035 55.6949 259.631 53.8504 259.631 51.6925V51.6563C259.631 49.5345 260.047 47.7081 260.879 46.177C261.71 44.6339 262.88 43.4585 264.387 42.6508C265.894 41.831 267.666 41.4211 269.703 41.4211C271.753 41.4211 273.531 41.831 275.038 42.6508C276.545 43.4585 277.714 44.6279 278.546 46.1589C279.378 47.6779 279.794 49.5104 279.794 51.6563V51.6925C279.794 53.8625 279.384 55.713 278.564 57.2441C277.744 58.7751 276.581 59.9445 275.074 60.7522C273.579 61.5479 271.789 61.9457 269.703 61.9457ZM269.721 57.0813C270.457 57.0813 271.09 56.8764 271.62 56.4665C272.151 56.0445 272.554 55.4297 272.832 54.622C273.121 53.8142 273.266 52.8377 273.266 51.6925V51.6563C273.266 50.5231 273.115 49.5586 272.814 48.7629C272.524 47.9552 272.114 47.3404 271.584 46.9184C271.054 46.4965 270.427 46.2855 269.703 46.2855C268.992 46.2855 268.365 46.4965 267.823 46.9184C267.292 47.3404 266.876 47.9552 266.575 48.7629C266.286 49.5586 266.141 50.5231 266.141 51.6563V51.6925C266.141 52.8377 266.286 53.8142 266.575 54.622C266.864 55.4297 267.274 56.0445 267.805 56.4665C268.347 56.8764 268.986 57.0813 269.721 57.0813Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M291.765 61.9457C289.692 61.9457 287.901 61.5419 286.394 60.7342C284.887 59.9264 283.724 58.757 282.904 57.226C282.096 55.6949 281.693 53.8504 281.693 51.6925V51.6563C281.693 49.5345 282.109 47.7081 282.94 46.177C283.772 44.6339 284.942 43.4585 286.449 42.6508C287.956 41.831 289.728 41.4211 291.765 41.4211C293.815 41.4211 295.593 41.831 297.1 42.6508C298.607 43.4585 299.776 44.6279 300.608 46.1589C301.44 47.6779 301.856 49.5104 301.856 51.6563V51.6925C301.856 53.8625 301.446 55.713 300.626 57.2441C299.806 58.7751 298.643 59.9445 297.136 60.7522C295.641 61.5479 293.851 61.9457 291.765 61.9457ZM291.783 57.0813C292.519 57.0813 293.151 56.8764 293.682 56.4665C294.212 56.0445 294.616 55.4297 294.894 54.622C295.183 53.8142 295.327 52.8377 295.327 51.6925V51.6563C295.327 50.5231 295.177 49.5586 294.875 48.7629C294.586 47.9552 294.176 47.3404 293.646 46.9184C293.115 46.4965 292.488 46.2855 291.765 46.2855C291.054 46.2855 290.427 46.4965 289.884 46.9184C289.354 47.3404 288.938 47.9552 288.637 48.7629C288.347 49.5586 288.203 50.5231 288.203 51.6563V51.6925C288.203 52.8377 288.347 53.8142 288.637 54.622C288.926 55.4297 289.336 56.0445 289.866 56.4665C290.409 56.8764 291.048 57.0813 291.783 57.0813Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M304.46 61.5298V35.4355H310.879V61.5298H304.46Z",
        fill: "#003366"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M322.742 61.9457C320.789 61.9457 319.137 61.6805 317.787 61.1501C316.437 60.6076 315.388 59.8541 314.641 58.8897C313.893 57.9252 313.447 56.804 313.302 55.5261L313.284 55.3634H319.505L319.541 55.5081C319.698 56.1711 320.035 56.6895 320.554 57.0632C321.084 57.4369 321.814 57.6238 322.742 57.6238C323.309 57.6238 323.797 57.5575 324.207 57.4249C324.617 57.2923 324.93 57.1054 325.147 56.8643C325.364 56.6111 325.473 56.3218 325.473 55.9963V55.9782C325.473 55.5442 325.292 55.1946 324.93 54.9294C324.58 54.6521 323.966 54.423 323.086 54.2422L319.614 53.5731C318.336 53.32 317.257 52.9342 316.377 52.4158C315.509 51.8853 314.852 51.2343 314.405 50.4628C313.971 49.6912 313.754 48.8051 313.754 47.8045V47.7864C313.754 46.4724 314.104 45.3452 314.803 44.4048C315.515 43.4525 316.527 42.7171 317.841 42.1987C319.167 41.6803 320.723 41.4211 322.507 41.4211C324.412 41.4211 326.009 41.7164 327.299 42.3072C328.601 42.8858 329.59 43.6634 330.265 44.6399C330.94 45.6044 331.283 46.6773 331.295 47.8588V48.0034H325.436L325.418 47.8588C325.358 47.2801 325.081 46.7858 324.586 46.3759C324.092 45.954 323.399 45.743 322.507 45.743C321.988 45.743 321.536 45.8153 321.151 45.96C320.765 46.0926 320.463 46.2855 320.246 46.5387C320.041 46.7798 319.939 47.0752 319.939 47.4248V47.4429C319.939 47.7201 320.011 47.9673 320.156 48.1843C320.301 48.4013 320.554 48.5881 320.916 48.7449C321.277 48.9016 321.771 49.0462 322.398 49.1789L325.852 49.866C327.962 50.2759 329.487 50.9149 330.427 51.7829C331.38 52.6388 331.856 53.8022 331.856 55.273V55.2911C331.856 56.6413 331.47 57.8167 330.699 58.8173C329.927 59.8179 328.86 60.5895 327.498 61.132C326.136 61.6745 324.55 61.9457 322.742 61.9457Z",
        fill: "#003366"
    })), $0422a6ce4ea03acc$var$Gz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 332 63",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M266.463 28.6509H262.771V25.8255H266.463V28.6509Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M169.13 2.00046H131.547L120.271 13.2751V50.8591L131.547 62.1338H169.13L180.407 50.8591V39.5831L176.649 35.8205H157.855V39.5831H142.822V24.5485H157.855V28.2605H176.649L180.407 24.5485V13.2751L169.13 2.00046Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M56.3773 2.00046H41.344L37.5853 5.75646V20.7898L18.792 2.00046H3.76L0 5.75646V58.3765L3.76 62.1338H18.792L22.552 58.3765V43.3405L41.344 62.1338H56.3773L60.1347 58.3765V5.75646L56.3773 2.00046Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.6874 62.1333H97.7207L101.479 58.376V47.1013L120.273 28.308V5.7573L116.514 1.99997H101.479L97.7207 5.7573V13.2746L90.2047 20.7906L82.6874 13.2746V5.7573L78.9287 1.99997H63.8954L60.1367 5.7573V28.308L78.9287 47.1013V58.376L82.6874 62.1333Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M173.67 2.53779V2.00179H176.397V2.53779H175.355V5.20312H174.718V2.53779H173.67Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M177.853 2.00179L178.672 4.29513L179.485 2.00179H180.404V5.20312H179.815V2.62313L178.933 5.20312H178.421L177.529 2.62313V5.20312H176.941V2.00179H177.853Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M196.303 20.5066V15.4794H202.487C203.886 15.4794 204.977 15.1238 205.76 14.4125C206.556 13.7012 206.954 12.6704 206.954 11.3202V11.284C206.954 9.92176 206.556 8.89101 205.76 8.19178C204.977 7.49256 203.886 7.14295 202.487 7.14295H196.303V2.04342H204.079C206.02 2.04342 207.707 2.4292 209.142 3.20076C210.577 3.96027 211.686 5.03322 212.469 6.41961C213.265 7.79395 213.663 9.41543 213.663 11.284V11.3202C213.663 13.1768 213.265 14.7983 212.469 16.1847C211.686 17.559 210.577 18.6259 209.142 19.3854C207.707 20.1329 206.02 20.5066 204.079 20.5066H196.303ZM192.957 28.1378V2.04342H199.594V28.1378H192.957Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M222.867 28.5537C221.433 28.5537 220.209 28.2583 219.196 27.6676C218.184 27.0769 217.412 26.227 216.882 25.1179C216.351 24.0087 216.086 22.6766 216.086 21.1214V8.44495H222.506V19.7471C222.506 20.8683 222.771 21.7483 223.301 22.3873C223.832 23.0141 224.621 23.3276 225.67 23.3276C226.177 23.3276 226.635 23.2372 227.045 23.0563C227.454 22.8755 227.804 22.6223 228.093 22.2968C228.383 21.9713 228.6 21.5795 228.744 21.1214C228.901 20.6633 228.979 20.163 228.979 19.6205V8.44495H235.399V28.1378H228.979V24.6658H228.853C228.515 25.4855 228.069 26.1908 227.515 26.7815C226.96 27.3602 226.297 27.8002 225.526 28.1016C224.754 28.403 223.868 28.5537 222.867 28.5537Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M251.114 28.5537C250.173 28.5537 249.311 28.403 248.528 28.1016C247.744 27.8002 247.063 27.3722 246.484 26.8177C245.918 26.2511 245.472 25.5699 245.146 24.7743H245.019V28.1378H238.6V2.04342H245.019V11.935H245.146C245.484 11.1153 245.936 10.416 246.502 9.83737C247.081 9.24665 247.756 8.80059 248.528 8.4992C249.311 8.18576 250.167 8.02903 251.095 8.02903C252.759 8.02903 254.176 8.4329 255.345 9.24062C256.514 10.0363 257.407 11.1997 258.021 12.7307C258.648 14.2497 258.962 16.0942 258.962 18.2642V18.2823C258.962 20.4523 258.648 22.3029 258.021 23.8339C257.407 25.365 256.508 26.5344 255.327 27.3421C254.158 28.1498 252.753 28.5537 251.114 28.5537ZM248.745 23.3276C249.504 23.3276 250.161 23.1226 250.716 22.7128C251.27 22.3029 251.692 21.7242 251.982 20.9768C252.283 20.2293 252.434 19.3312 252.434 18.2823V18.2642C252.434 17.2275 252.283 16.3353 251.982 15.5879C251.68 14.8284 251.252 14.2497 250.698 13.8519C250.143 13.4541 249.492 13.2551 248.745 13.2551C248.009 13.2551 247.358 13.4601 246.792 13.87C246.237 14.2678 245.803 14.8404 245.49 15.5879C245.176 16.3353 245.019 17.2335 245.019 18.2823V18.3004C245.019 19.3372 245.176 20.2353 245.49 20.9948C245.803 21.7423 246.237 22.321 246.792 22.7308C247.346 23.1287 247.997 23.3276 248.745 23.3276Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M261.566 28.1378V2.04342H267.985V28.1378H261.566Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M271.24 28.1378V8.44495H277.66V28.1378H271.24ZM274.441 6.32919C273.525 6.32919 272.747 6.01575 272.108 5.38886C271.482 4.76196 271.168 4.02054 271.168 3.1646C271.168 2.29659 271.482 1.55517 272.108 0.940337C272.747 0.313446 273.525 0 274.441 0C275.369 0 276.147 0.313446 276.774 0.940337C277.401 1.55517 277.714 2.29659 277.714 3.1646C277.714 4.02054 277.401 4.76196 276.774 5.38886C276.147 6.01575 275.369 6.32919 274.441 6.32919Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M290.228 28.5537C288.166 28.5537 286.382 28.1438 284.875 27.324C283.38 26.4922 282.229 25.3107 281.421 23.7797C280.614 22.2366 280.21 20.3981 280.21 18.2642V18.2462C280.21 16.1364 280.614 14.316 281.421 12.785C282.241 11.2539 283.392 10.0785 284.875 9.2587C286.37 8.43892 288.136 8.02903 290.174 8.02903C292.03 8.02903 293.652 8.37262 295.038 9.05979C296.425 9.7349 297.504 10.6752 298.275 11.8808C299.047 13.0864 299.451 14.4728 299.487 16.04V16.1666H293.591L293.573 15.9857C293.453 15.0816 293.109 14.3401 292.543 13.7615C291.976 13.1828 291.223 12.8935 290.282 12.8935C289.547 12.8935 288.908 13.1044 288.365 13.5264C287.835 13.9483 287.425 14.5632 287.136 15.3709C286.858 16.1666 286.72 17.137 286.72 18.2823V18.3004C286.72 19.4457 286.858 20.4222 287.136 21.2299C287.425 22.0376 287.835 22.6525 288.365 23.0744C288.908 23.4843 289.553 23.6893 290.3 23.6893C291.241 23.6893 291.988 23.412 292.543 22.8574C293.109 22.2908 293.453 21.5373 293.573 20.597L293.61 20.4162H299.505L299.487 20.5247C299.451 22.0557 299.053 23.424 298.293 24.6296C297.546 25.8352 296.485 26.7936 295.11 27.5049C293.748 28.2041 292.121 28.5537 290.228 28.5537Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M203.03 62C200.86 62 198.973 61.6926 197.37 61.0777C195.778 60.4509 194.531 59.5527 193.626 58.3833C192.734 57.2139 192.234 55.7974 192.126 54.1337L192.107 53.8082H198.274L198.31 53.989C198.431 54.5557 198.708 55.0499 199.142 55.4719C199.588 55.8818 200.155 56.2073 200.842 56.4484C201.529 56.6774 202.294 56.792 203.138 56.792C204.018 56.792 204.772 56.6774 205.399 56.4484C206.038 56.2073 206.532 55.8818 206.882 55.4719C207.231 55.062 207.406 54.5858 207.406 54.0433V54.0252C207.406 53.2898 207.087 52.7232 206.448 52.3254C205.809 51.9155 204.724 51.5659 203.193 51.2765L200.516 50.7521C197.936 50.2699 195.971 49.4019 194.621 48.1481C193.283 46.8823 192.614 45.2487 192.614 43.2475V43.2294C192.614 41.5537 193.06 40.101 193.952 38.8713C194.844 37.6296 196.068 36.6712 197.623 35.9961C199.19 35.3089 200.968 34.9653 202.957 34.9653C205.14 34.9653 206.996 35.2908 208.527 35.9418C210.058 36.5808 211.24 37.4849 212.072 38.6543C212.915 39.8237 213.374 41.1981 213.446 42.7773L213.464 43.1571H207.297L207.279 42.9582C207.207 42.3795 206.984 41.8852 206.61 41.4753C206.237 41.0654 205.742 40.746 205.127 40.5169C204.513 40.2879 203.807 40.1733 203.012 40.1733C202.204 40.1733 201.517 40.2879 200.95 40.5169C200.384 40.746 199.95 41.0594 199.648 41.4572C199.359 41.843 199.214 42.2831 199.214 42.7773V42.7954C199.214 43.4946 199.534 44.0492 200.173 44.4591C200.812 44.869 201.83 45.2065 203.229 45.4718L205.905 45.9781C207.762 46.3277 209.287 46.822 210.48 47.4609C211.674 48.0999 212.56 48.9136 213.138 49.9022C213.717 50.8787 214.006 52.0662 214.006 53.4646V53.4827C214.006 55.2187 213.572 56.7257 212.704 58.0036C211.836 59.2815 210.583 60.27 208.943 60.9692C207.304 61.6564 205.332 62 203.03 62Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M226.068 61.9457C224.007 61.9457 222.222 61.5359 220.715 60.7161C219.22 59.8842 218.069 58.7028 217.261 57.1717C216.454 55.6286 216.05 53.7901 216.05 51.6563V51.6382C216.05 49.5285 216.454 47.7081 217.261 46.177C218.081 44.646 219.233 43.4705 220.715 42.6508C222.21 41.831 223.976 41.4211 226.014 41.4211C227.87 41.4211 229.492 41.7647 230.878 42.4518C232.265 43.1269 233.344 44.0673 234.115 45.2729C234.887 46.4784 235.291 47.8648 235.327 49.432V49.5586H229.432L229.413 49.3778C229.293 48.4736 228.949 47.7322 228.383 47.1535C227.816 46.5748 227.063 46.2855 226.122 46.2855C225.387 46.2855 224.748 46.4965 224.205 46.9184C223.675 47.3404 223.265 47.9552 222.976 48.7629C222.699 49.5586 222.56 50.5291 222.56 51.6744V51.6925C222.56 52.8377 222.699 53.8142 222.976 54.622C223.265 55.4297 223.675 56.0445 224.205 56.4665C224.748 56.8764 225.393 57.0813 226.14 57.0813C227.081 57.0813 227.828 56.804 228.383 56.2495C228.949 55.6829 229.293 54.9294 229.413 53.989L229.45 53.8082H235.345L235.327 53.9167C235.291 55.4478 234.893 56.8161 234.133 58.0217C233.386 59.2272 232.325 60.1856 230.951 60.8969C229.588 61.5961 227.961 61.9457 226.068 61.9457Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M237.804 61.5298V35.4355H244.224V45.3813H244.35C244.857 44.0914 245.61 43.1089 246.611 42.4338C247.623 41.7586 248.871 41.4211 250.354 41.4211C251.789 41.4211 253.012 41.7285 254.025 42.3433C255.05 42.9461 255.827 43.8141 256.358 44.9473C256.9 46.0685 257.172 47.4248 257.172 49.0161V61.5298H250.752V50.3905C250.752 49.2211 250.475 48.3048 249.92 47.6418C249.378 46.9787 248.576 46.6472 247.515 46.6472C246.852 46.6472 246.273 46.8099 245.779 47.1354C245.285 47.4489 244.899 47.8829 244.622 48.4374C244.356 48.992 244.224 49.637 244.224 50.3724V61.5298H237.804Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M269.703 61.9457C267.63 61.9457 265.839 61.5419 264.333 60.7342C262.826 59.9264 261.662 58.757 260.842 57.226C260.035 55.6949 259.631 53.8504 259.631 51.6925V51.6563C259.631 49.5345 260.047 47.7081 260.879 46.177C261.71 44.6339 262.88 43.4585 264.387 42.6508C265.894 41.831 267.666 41.4211 269.703 41.4211C271.753 41.4211 273.531 41.831 275.038 42.6508C276.545 43.4585 277.714 44.6279 278.546 46.1589C279.378 47.6779 279.794 49.5104 279.794 51.6563V51.6925C279.794 53.8625 279.384 55.713 278.564 57.2441C277.744 58.7751 276.581 59.9445 275.074 60.7522C273.579 61.5479 271.789 61.9457 269.703 61.9457ZM269.721 57.0813C270.457 57.0813 271.09 56.8764 271.62 56.4665C272.151 56.0445 272.554 55.4297 272.832 54.622C273.121 53.8142 273.266 52.8377 273.266 51.6925V51.6563C273.266 50.5231 273.115 49.5586 272.814 48.7629C272.524 47.9552 272.114 47.3404 271.584 46.9184C271.054 46.4965 270.427 46.2855 269.703 46.2855C268.992 46.2855 268.365 46.4965 267.823 46.9184C267.292 47.3404 266.876 47.9552 266.575 48.7629C266.286 49.5586 266.141 50.5231 266.141 51.6563V51.6925C266.141 52.8377 266.286 53.8142 266.575 54.622C266.864 55.4297 267.274 56.0445 267.805 56.4665C268.347 56.8764 268.986 57.0813 269.721 57.0813Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M291.765 61.9457C289.692 61.9457 287.901 61.5419 286.394 60.7342C284.887 59.9264 283.724 58.757 282.904 57.226C282.096 55.6949 281.693 53.8504 281.693 51.6925V51.6563C281.693 49.5345 282.109 47.7081 282.94 46.177C283.772 44.6339 284.942 43.4585 286.449 42.6508C287.956 41.831 289.728 41.4211 291.765 41.4211C293.815 41.4211 295.593 41.831 297.1 42.6508C298.607 43.4585 299.776 44.6279 300.608 46.1589C301.44 47.6779 301.856 49.5104 301.856 51.6563V51.6925C301.856 53.8625 301.446 55.713 300.626 57.2441C299.806 58.7751 298.643 59.9445 297.136 60.7522C295.641 61.5479 293.851 61.9457 291.765 61.9457ZM291.783 57.0813C292.519 57.0813 293.151 56.8764 293.682 56.4665C294.212 56.0445 294.616 55.4297 294.894 54.622C295.183 53.8142 295.327 52.8377 295.327 51.6925V51.6563C295.327 50.5231 295.177 49.5586 294.875 48.7629C294.586 47.9552 294.176 47.3404 293.646 46.9184C293.115 46.4965 292.488 46.2855 291.765 46.2855C291.054 46.2855 290.427 46.4965 289.884 46.9184C289.354 47.3404 288.938 47.9552 288.637 48.7629C288.347 49.5586 288.203 50.5231 288.203 51.6563V51.6925C288.203 52.8377 288.347 53.8142 288.637 54.622C288.926 55.4297 289.336 56.0445 289.866 56.4665C290.409 56.8764 291.048 57.0813 291.783 57.0813Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M304.46 61.5298V35.4355H310.879V61.5298H304.46Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M322.742 61.9457C320.789 61.9457 319.137 61.6805 317.787 61.1501C316.437 60.6076 315.388 59.8541 314.641 58.8897C313.893 57.9252 313.447 56.804 313.302 55.5261L313.284 55.3634H319.505L319.541 55.5081C319.698 56.1711 320.035 56.6895 320.554 57.0632C321.084 57.4369 321.814 57.6238 322.742 57.6238C323.309 57.6238 323.797 57.5575 324.207 57.4249C324.617 57.2923 324.93 57.1054 325.147 56.8643C325.364 56.6111 325.473 56.3218 325.473 55.9963V55.9782C325.473 55.5442 325.292 55.1946 324.93 54.9294C324.58 54.6521 323.966 54.423 323.086 54.2422L319.614 53.5731C318.336 53.32 317.257 52.9342 316.377 52.4158C315.509 51.8853 314.852 51.2343 314.405 50.4628C313.971 49.6912 313.754 48.8051 313.754 47.8045V47.7864C313.754 46.4724 314.104 45.3452 314.803 44.4048C315.515 43.4525 316.527 42.7171 317.841 42.1987C319.167 41.6803 320.723 41.4211 322.507 41.4211C324.412 41.4211 326.009 41.7164 327.299 42.3072C328.601 42.8858 329.59 43.6634 330.265 44.6399C330.94 45.6044 331.283 46.6773 331.295 47.8588V48.0034H325.436L325.418 47.8588C325.358 47.2801 325.081 46.7858 324.586 46.3759C324.092 45.954 323.399 45.743 322.507 45.743C321.988 45.743 321.536 45.8153 321.151 45.96C320.765 46.0926 320.463 46.2855 320.246 46.5387C320.041 46.7798 319.939 47.0752 319.939 47.4248V47.4429C319.939 47.7201 320.011 47.9673 320.156 48.1843C320.301 48.4013 320.554 48.5881 320.916 48.7449C321.277 48.9016 321.771 49.0462 322.398 49.1789L325.852 49.866C327.962 50.2759 329.487 50.9149 330.427 51.7829C331.38 52.6388 331.856 53.8022 331.856 55.273V55.2911C331.856 56.6413 331.47 57.8167 330.699 58.8173C329.927 59.8179 328.86 60.5895 327.498 61.132C326.136 61.6745 324.55 61.9457 322.742 61.9457Z",
        fill: "white"
    })), $0422a6ce4ea03acc$var$Xz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 966.787 543.733",
        xmlSpace: "preserve",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        style: {
            fill: "#000000",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none"
        },
        d: "M3639.75 4023.47h54.52l400.81-580.52v580.52h52.5v-672.39h-51.5l-404.85 584.56v-584.56h-51.48v672.39M4588.79 3650.93c-1.01 72.69-38.36 147.4-130.24 147.4-83.79 0-132.26-64.61-146.39-147.4zm-335.2-54.52c0 136.29 78.75 247.35 206.98 247.35 123.17 0 190.82-98.94 180.71-236.24h-332.16v-11.11c1.02-110.05 47.46-211.01 162.56-211.01 61.58 0 113.07 25.24 139.32 45.44l22.21-41.4c-30.29-22.21-85.82-49.47-163.56-49.47-147.4 0-216.06 118.12-216.06 256.44M4697.79 3832.66h56.54l117.13-400.82 126.19 400.82h51.49l126.2-401.82 118.12 401.82h52.51l-145.39-481.58h-48.46l-130.24 405.85-130.24-405.85h-48.46l-145.39 481.58M5810.34 3604.49l-225.13 418.98h62.59l190.81-363.45h2.02l190.82 363.45h56.54l-223.13-418.98v-253.41h-54.52v253.41M6424.16 3591.36c0 108.03-57.55 206.97-167.59 206.97-109.04 0-158.51-96.92-158.51-204.95 0-109.04 53.51-207.98 162.54-207.98 110.04 0 163.56 96.93 163.56 205.96zm-381.63 0c0 121.16 64.61 252.4 216.05 252.4 151.45 0 221.11-130.24 221.11-250.38 0-121.15-68.65-253.41-220.1-253.41-151.44 0-217.06 130.24-217.06 251.39M6580.52 3832.66h52.51v-83.8c18.17 35.34 61.58 94.9 129.23 94.9 22.2 0 38.36-5.05 46.44-8.08l-13.13-49.46c-8.08 3.03-19.18 7.07-39.38 7.07-66.63 0-110.05-78.76-123.16-107.03v-335.18h-52.51v481.58M6963.13 3621.65l211.02 211.01h65.63l-213.03-211.01 224.13-270.57h-65.63zm-57.53 456.34h52.5v-726.91h-52.5v726.91M3780.09 2672.61c128.21 0 180.71 58.56 180.71 147.41 0 83.8-50.48 144.37-178.7 144.37h-85.81v-291.78zm-139.33 339.23h146.39c141.35 0 230.19-69.67 230.19-189.81 0-121.14-83.8-196.87-236.25-196.87h-84.8v-285.71h-55.53v672.39M4102.12 2480.79v340.24h52.51V2491.9c0-70.68 25.23-116.11 98.93-116.11 71.69 0 131.24 67.64 147.41 95.91v349.33h52.49v-388.7c0-38.36 4.04-74.71 9.09-92.88h-53.51c-3.02 16.15-7.07 52.5-7.07 78.75-23.22-36.35-77.74-89.86-159.51-89.86-100.96 0-140.34 65.63-140.34 152.45M4911.82 2579.73c0 105-40.39 204.95-157.5 204.95-41.39 0-89.86-24.23-117.12-54.52v-337.21c22.21-11.1 55.52-19.18 93.9-19.18 122.15 0 180.72 106.01 180.72 205.96zm-327.11-215.05v701.68h52.49V2776.6c29.28 33.32 76.74 55.53 126.21 55.53 137.29 0 203.93-110.04 203.93-250.38 0-135.29-90.87-253.41-238.27-253.41-57.54 0-111.05 14.13-144.36 36.34M5075.34 3066.36h52.51v-726.91h-52.51v726.91M5284.32 2821.03h53.5v-481.58h-53.5zm-13.13 142.35c0 23.22 18.18 40.39 39.39 40.39 22.19 0 40.37-17.17 40.37-40.39s-18.18-41.4-40.37-41.4c-21.21 0-39.39 18.18-39.39 41.4M5438.77 2580.74c0 152.45 87.84 251.39 212.02 251.39 71.69 0 117.12-27.26 143.36-50.48l-27.26-38.36c-27.25 23.22-63.6 43.41-117.1 43.41-107.03 0-155.49-92.88-155.49-203.94 0-107.02 47.46-208.99 154.48-208.99 55.53 0 101.96 24.23 123.17 43.41l23.22-39.37c-26.25-23.22-76.73-49.47-149.43-49.47-138.31 0-206.97 123.17-206.97 252.4M3625.61 1327.8v672.4h143.36v-557.29h250.39V1327.8h-393.75M4125.79 1327.8v491.7h135.28v-491.7zm67.65 555.28c-47.46 0-81.79 37.36-81.79 80.78 0 42.4 34.33 78.75 81.79 78.75 47.45 0 82.78-36.35 82.78-78.75 0-43.42-35.33-80.78-82.78-80.78M4513.47 1431.8c9.08-3.03 30.28-11.12 67.64-11.12 74.71 0 119.12 55.53 119.12 156.49 0 91.88-31.28 148.41-103.98 148.41-42.39 0-74.71-27.25-82.78-37.35zm0 622.92v-273.61c22.21 22.23 65.62 50.49 120.13 50.49 123.19 0 209-84.8 209-254.43 0-167.58-113.08-261.48-261.49-261.48-111.06 0-178.7 28.27-201.92 39.38v699.65h134.28M5220.17 1701.36c-8.08 5.04-23.23 11.11-51.51 11.11-59.55 0-94.89-52.51-107.01-74.71V1327.8h-134.28v491.7h134.28v-66.65c21.2 36.35 61.59 78.75 124.18 78.75 36.35 0 55.53-7.07 66.64-13.14l-32.3-117.1M5560.39 1545.89h-17.17c-78.74 0-133.26-23.24-133.26-80.78 0-36.34 29.29-51.48 59.56-51.48 48.47 0 76.74 28.27 90.87 43.4zm15.15-218.09c-4.05 12.13-7.06 37.35-8.09 52.51-22.2-26.25-68.65-64.62-138.31-64.62-83.8 0-148.41 50.47-148.41 138.32 0 128.22 132.26 174.66 262.49 174.66h17.17v28.27c0 42.41-17.17 68.64-79.76 68.64-63.6 0-107.02-33.3-125.19-46.43l-58.56 81.77c29.28 26.25 93.9 70.68 198.9 70.68 134.28 0 197.88-51.5 197.88-181.73v-176.68c0-66.63 7.06-114.07 14.13-145.39h-132.25M6094.45 1701.36c-8.07 5.04-23.22 11.11-51.48 11.11-59.57 0-94.91-52.51-107.03-74.71V1327.8h-134.28v491.7h134.28v-66.65c21.21 36.35 61.59 78.75 124.19 78.75 36.33 0 55.52-7.07 66.63-13.14l-32.31-117.1M6175.21 1819.5h143.35l109.05-324.1h5.05l99.95 324.1h138.32L6468 1275.32c-43.42-116.11-94.91-183.75-229.18-183.75-41.4 0-65.63 6.04-75.72 9.08l19.18 106.01c7.06-2.02 18.17-5.04 47.45-5.04 68.65 0 92.88 33.3 112.06 85.81l18.17 50.47-184.75 481.6",
        transform: "matrix(.13333 0 0 -.13333 0 543.733)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        style: {
            fill: "#fff",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none"
        },
        d: "M1830.57 2008.74c-4.74-24.69-19.79-72.37-43.86-75.47-24.25-3.1-41.72 22.9-59.11 32.64-29.34 16.37-70.83 27.08-109.17 39.77-33.08 10.96-78.43 24.53-91.73 56.09-19.93 46.99 26.63 69.22 60.15 79.54 31.58 9.7 54.69 13.35 95.86 15.27 60.56 2.91 118.38-5.76 138.71-43.83 12.26-22.93 16-68.42 9.15-104.01zm555.91-30.29c-105.48 51.62-242.47 77.48-342.15 132.85-78.92 43.76-139.43 116.04-224.36 154.99-86.64 42.42-217.05 85.06-266.9 97.35-176.22 43.35-324.24-13.1-375.58-53.73-95.86-75.75-170.75-198.88-141.53-376.02 12.38-74.88 35.43-137.87 72.06-189.67 148.64-209.94 426.84-278.14 647.23-410.58 7.77-5.29 15.88-3.88 20.84 2.87 37.02 54.44 67.11 98.26 129.46 124.19 63.3 26.43 162.92 17.45 248.81 13.27 88.73-4.29 184.51 4.04 216.69 49.92 38.45 54.76 36.21 165.1-22.48 198.81-31.49 18.15-78.44 18.98-112.69 34.77-24.99 11.55-44.26 33.16-58.04 63.21-11.56 25.14-22.3 66.42-7.32 93.35 13.79 24.81 48.56 17.79 76.49 11.3 55.35-12.71 147.84-26.18 201.09-2.82 15.69 8.01-40.4 45.57-61.62 55.94M157.34 1830.22c3.183 17.97 4.574 22.97 15.394 37.1 17.149 25.64 225.188 259.08 547.637 315.65 42.434 6.08 73.008 3.14 79.961-13.87 12.188-29.82-12.504-47-42.219-64.2-517.156-309.08-480.496-768.56-485.449-956.52 1.559-76.89-53.965-90.88-67.828-54.66-60.691 165.56-111.723 425.06-47.496 736.5M507.273 2507.12c10.598 11.24 17.508 16.4 33.223 20.83 198.621 49.34 397.863 17.93 541.344-46.05 32.21-14.26 46.72-34.47 25.57-48.04-26.9-15.63-108.422-68.65-153.48-110.64-13.102-11.29-36.453-11.88-50.235-10.05-168.199 22.17-255.558 35.27-508.414-60.58-38.797-16.31-73.695 5.88-55.84 36.38 33.668 60.3 111.961 161.18 167.832 218.15M834.086 2705.56c-43.481 4.95-44.098 36.76-25.711 49.15 47.25 33.1 123.914 73.07 201.035 103.65 23.09 9.15 35.01 11.53 56.16 9.41 56.83-5.69 150.94-43.95 258.92-121 129.5-92.4 244.7-267.94 167.66-253.73-48.73 8.44-27.51 6.12-84.63 12.39-58.36 5.17-96.66-.82-123.56 1.92-11.72.96-20.95 8.76-29.2 15.52-109.3 98.01-235.56 160.21-420.674 182.69",
        transform: "matrix(.13333 0 0 -.13333 0 543.733)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        style: {
            fill: "#fff",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none"
        },
        d: "M2914.7 1171.28c-11.66-36.39-25.51-82.04-55.19-60.86-55.14 41.03-177.7 119.91-296.39 163.69-6.37 1.42-5.65 10.27-3.4 15.26 8.41 18.64 12.18 35.88 15.82 57.94 3.38 20.64 18.27 34.43 28.51 50.98 30.42 48.59 46.9 133.29 53.54 186.13 5.04 48.55 2.04 102.65-8.48 147.74-4.49 19.26-18.38 44.09-18.01 65.39.36 20.84 10.16 42.67 12.17 67.27 5.87 71.18-83.96 130.53-132.99 153.4-111.22 51.93-229.43 98.38-349.56 161.76-67.81 35.77-122.23 114.23-176.64 156.34-54.96 42.41-231.6 112.47-302.2 131.12-15.94 5.02-21.59 11.64-24.29 24.33-29.1 138.89-111.07 291.88-264.18 410.19-49.58 38.53 6.02 60.45 74.3 63.78 1076.36 36.9 1695.76-953.65 1446.99-1794.46",
        transform: "matrix(.13333 0 0 -.13333 0 543.733)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        style: {
            fill: "#fff",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none"
        },
        d: "M2477.65 1647.38c-.77 5.48-3.13 24.03-3.11 27.86.06 9.79 20.18 23.11 29.56 30.56 14.23 11.33 30.7 23.77 41.49 29.21 3.9 2.45 6.49-3.22 7.02-4.34 39.68-60.23 24.8-209.1-3.87-279.89-3.32-7.2-9.39-10-11.86-4.73-14.63 31.94-36.34 60.69-61.27 76.47-4.6 3.57-4.95 11.01-4.6 12.39 8.02 33.64 12.19 70.95 6.64 112.47M1986.94 1280.96c8.55 24.68 18.5 39.22 37.68 51.22 36.11 22.65 96.12 23.63 154.04 27.59 56.12 3.79 116.08 7.07 156.01 25.52 24.16 11.11 48.33 42.76 85.67 26.64 17.68-7.62 27.3-23.82 32.58-39.93 5.92-17.95 10.23-36.08 8.39-60.14-5.37-69.44-61.77-103.35-71.92-168.26-.94-10.03-2.65-24.55-8.41-30.32-43.06-43.83-128.22-34.61-205.21-26.86-27.56 2.74-54.8 3.49-73.44 12.37-13.45 6.29-25.52 19.12-36.7 29.49-24.63 22.83-38.56 39.63-63.25 67.32-8.38 9.38-27.36 26.36-28.61 36.67-1.06 9.89 9.52 38.28 13.17 48.69M638.656 462.559c-28.258 23.152-40.414 42.683-56.664 70.101-131.824 210.711-205.707 956.92-35.836 1210.02 54.059 88.68 111.328 47.8 92.297-20.75-32.535-153.88-12.594-240.11 62.231-407.08 117.593-248.13 480.556-592.639 576.646-717.588 164.72-214.282 219.54-370.403 218.79-412.461-.89-32.262-7.08-52.832-63.62-48.059-298.24 23.637-586.559 147.289-793.844 325.817",
        transform: "matrix(.13333 0 0 -.13333 0 543.733)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        style: {
            fill: "#fff",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none"
        },
        d: "M809.16 1468.87c-90.969 221.61-31.566 421.16 8.613 496.85 20.262 38.19 40.063 63.14 65.918 55.96 28.133-7.85 34.633-36.64 38.516-90.02 28.629-442.98 296.573-592.13 633.123-748.53 265.51-135.73 567.6-290.911 820.78-666.81 38.32-54.261 43.85-87.191.59-118.281-154.36-105.379-294.2-178.828-498.79-226.539-30.8-7.211-62.56-1.801-89.84 68.57-284.22 732.309-761.41 699.301-978.91 1228.8M2569.57 568.539c-43.27-43.25-67.81-9.34-81.95 18.43-60.6 128.863-119.79 236.711-215.24 341.172-16.54 16.761-3.8 40.289 20.51 37.898 31.07-2.488 51.43-.789 85.61 13.902 28.91 12.418 62.04 52.959 78.56 111.189 12.04 42.48 12.6 54.98 38.63 57.63 6.47.61 18.31-1.02 25.49-3.09 31.68-9.02 65.7-34.9 90.56-53.97 63.76-48.71 158.88-156.208 175.53-190.989 10.57-22.141.45-37.172-5.51-49.813-33.36-68.218-138.58-209.578-212.19-282.359",
        transform: "matrix(.13333 0 0 -.13333 0 543.733)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        style: {
            fill: "#000000",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none"
        },
        d: "M2569.57 568.48c-43.27-43.25-67.81-9.339-81.95 18.43-60.6 128.86-119.79 236.711-215.24 341.172-16.54 16.758-3.8 40.297 20.51 37.898 31.07-2.488 51.43-.789 85.61 13.899 28.91 12.422 62.04 52.961 78.56 111.191 12.04 42.48 12.6 54.98 38.63 57.63 6.47.61 18.31-1.02 25.49-3.09 31.68-9.02 65.7-34.9 90.56-53.97 63.76-48.7 158.88-156.199 175.53-190.992 10.57-22.136.45-37.168-5.51-49.808-33.36-68.219-138.58-209.57-212.19-282.36zM809.348 1469.09c-90.969 221.6-31.571 421.15 8.613 496.84 20.262 38.19 40.062 63.14 65.918 55.96 28.133-7.85 34.633-36.64 38.516-90.02 28.625-442.98 296.565-592.13 633.115-748.52 265.52-135.74 567.61-290.909 820.79-666.811 38.32-54.269 43.85-87.199.58-118.277-154.36-105.383-294.19-178.84-498.78-226.543-30.8-7.207-62.57-1.797-89.85 68.57C1504.03 972.59 1026.84 939.59 809.348 1469.09zm-651.743 361.23c3.192 17.97 4.583 22.97 15.403 37.1 17.148 25.63 225.18 259.08 547.637 315.64 42.425 6.07 73.003 3.14 79.957-13.87 12.187-29.82-12.504-47.01-42.211-64.2-517.164-309.08-480.5-768.56-485.453-956.52 1.558-76.88-53.961-90.88-67.833-54.66-60.687 165.56-111.722 425.07-47.5 736.51zm349.668 677.17c10.598 11.24 17.508 16.4 33.223 20.83 198.621 49.33 397.863 17.92 541.344-46.06 32.21-14.26 46.72-34.47 25.57-48.03-26.9-15.63-108.422-68.65-153.48-110.64-13.102-11.29-36.453-11.88-50.235-10.05-168.199 22.17-255.558 35.27-508.414-60.58-38.797-16.32-73.695 5.88-55.84 36.37 33.668 60.31 111.961 161.18 167.832 218.16zM1986.94 1281.33c8.55 24.68 18.5 39.22 37.68 51.23 36.11 22.64 96.12 23.62 154.04 27.58 56.12 3.79 116.08 7.07 156.01 25.52 24.16 11.11 48.33 42.76 85.67 26.64 17.68-7.62 27.3-23.82 32.58-39.93 5.92-17.95 10.23-36.07 8.39-60.14-5.37-69.44-61.77-103.35-71.92-168.26-.94-10.03-2.65-24.55-8.41-30.32-43.06-43.83-128.22-34.61-205.21-26.86-27.56 2.74-54.8 3.49-73.44 12.37-13.45 6.3-25.52 19.12-36.7 29.49-24.63 22.83-38.56 39.63-63.25 67.32-8.38 9.38-27.36 26.36-28.61 36.67-1.06 9.89 9.52 38.28 13.17 48.69zM834.086 2705.92c-43.481 4.96-44.098 36.76-25.711 49.15 47.25 33.11 123.914 73.08 201.035 103.66 23.09 9.14 35.01 11.53 56.16 9.4 56.83-5.69 150.94-43.95 258.92-120.99 129.5-92.4 244.7-267.94 167.66-253.73-48.73 8.44-27.51 6.11-84.63 12.38-58.36 5.18-96.66-.81-123.56 1.93-11.72.95-20.95 8.76-29.2 15.51-109.3 98.01-235.56 160.21-420.674 182.69zm343.404-395.64c51.34 40.63 199.36 97.08 375.58 53.73 49.85-12.29 180.26-54.93 266.9-97.36 84.93-38.94 145.44-111.23 224.36-154.99 99.68-55.36 236.67-81.22 342.15-132.84 21.22-10.37 77.31-47.92 61.62-55.94-53.25-23.36-145.74-9.89-201.09 2.82-27.93 6.49-62.7 13.52-76.49-11.3-14.98-26.93-4.24-68.21 7.32-93.35 13.78-30.05 33.05-51.66 58.04-63.21 34.25-15.79 81.2-16.62 112.69-34.77 58.69-33.71 60.93-144.05 22.48-198.81-32.18-45.87-127.96-54.2-216.69-49.92-85.89 4.18-185.51 13.16-248.81-13.27-62.35-25.93-92.44-69.75-129.46-124.19-4.96-6.75-13.07-8.16-20.84-2.87-220.39 132.44-498.59 200.65-647.23 410.58-36.63 51.8-59.68 114.79-72.06 189.67-29.22 177.14 45.67 300.27 141.53 376.02zm1300.16-662.53c-.77 5.48-3.13 24.03-3.11 27.86.06 9.79 20.18 23.11 29.56 30.56 14.23 11.33 30.7 23.77 41.49 29.21 3.9 2.45 6.49-3.22 7.02-4.34 39.68-60.23 24.8-209.1-3.87-279.89-3.32-7.2-9.39-10-11.86-4.73-14.63 31.94-36.34 60.69-61.27 76.47-4.6 3.57-4.95 11.01-4.6 12.39 8.02 33.64 12.19 70.95 6.64 112.47zm437.05-476.1c-11.66-36.39-25.51-82.03-55.19-60.86-55.14 41.03-177.7 119.91-296.39 163.69-6.37 1.43-5.65 10.27-3.4 15.26 8.41 18.65 12.18 35.88 15.82 57.94 3.38 20.64 18.27 34.43 28.51 50.98 30.42 48.59 46.9 133.29 53.54 186.13 5.04 48.55 2.04 102.65-8.48 147.74-4.49 19.26-18.38 44.09-18.01 65.39.36 20.84 10.16 42.67 12.17 67.27 5.87 71.18-83.96 130.52-132.99 153.4-111.22 51.93-229.43 98.37-349.56 161.75-67.81 35.77-122.23 114.24-176.64 156.35-54.96 42.4-231.6 112.47-302.2 131.11-15.94 5.02-21.59 11.65-24.29 24.34-29.1 138.88-111.07 291.88-264.18 410.19-49.58 38.53 6.02 60.45 74.3 63.78C2544.07 3003 3163.47 2012.45 2914.7 1171.65zM638.656 462.93c-28.258 23.152-40.414 42.679-56.664 70.101-131.824 210.711-205.707 956.919-35.836 1210.019 54.059 88.69 111.328 47.8 92.297-20.75-32.535-153.88-12.594-240.11 62.231-407.08 117.593-248.13 480.556-592.638 576.646-717.591 164.72-214.277 219.54-370.399 218.79-412.457-.89-32.262-7.08-52.832-63.62-48.051-298.24 23.629-586.559 147.277-793.844 325.809zm905.504 2641.83C693.301 3104.76 0 2412.92 0 1552.57 0 692.25 697.52 0 1545.12 0c860.35 0 1556.61 691.891 1556.61 1552.22 0 860.38-697.26 1552.54-1557.57 1552.54",
        transform: "matrix(.13333 0 0 -.13333 0 543.733)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        style: {
            fill: "#000000",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none"
        },
        d: "M1618.66 2005.68c38.34-12.69 79.82-23.4 109.16-39.77 17.39-9.74 34.86-35.74 59.12-32.64 24.06 3.1 39.1 50.78 43.85 75.47 6.85 35.59 3.11 81.08-9.15 104.01-20.32 38.07-78.15 46.74-138.71 43.83-41.17-1.92-64.27-5.57-95.86-15.27-33.52-10.32-80.07-32.55-60.15-79.54 13.3-31.56 58.65-45.13 91.74-56.09",
        transform: "matrix(.13333 0 0 -.13333 0 543.733)"
    })), $0422a6ce4ea03acc$var$Kz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 967 568",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_1147_1139)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M251.237 291.137C250.539 294.778 248.318 301.814 244.765 302.272C241.189 302.728 238.61 298.893 236.046 297.454C231.716 295.041 225.595 293.46 219.939 291.589C215.059 289.973 208.368 287.969 206.408 283.313C203.466 276.383 210.336 273.102 215.28 271.58C219.939 270.147 223.348 269.61 229.422 269.326C238.356 268.898 246.887 270.176 249.886 275.792C251.695 279.174 252.247 285.885 251.237 291.137ZM333.249 295.606C317.688 287.989 297.479 284.173 282.77 276.007C271.129 269.552 262.204 258.887 249.673 253.141C236.892 246.882 217.652 240.592 210.296 238.78C184.298 232.384 162.463 240.712 154.887 246.705C140.747 257.881 129.697 276.047 134.009 302.178C135.835 313.226 139.237 322.519 144.638 330.163C166.568 361.133 207.61 371.197 240.126 390.735C241.271 391.513 242.467 391.307 243.198 390.312C248.659 382.278 253.099 375.814 262.298 371.99C271.637 368.091 286.333 369.414 299.003 370.033C312.096 370.662 326.227 369.435 330.971 362.667C336.646 354.588 336.314 338.309 327.657 333.336C323.012 330.66 316.084 330.538 311.032 328.208C307.345 326.503 304.501 323.315 302.469 318.882C300.765 315.173 299.179 309.083 301.389 305.112C303.423 301.449 308.554 302.485 312.672 303.444C320.84 305.317 334.485 307.306 342.341 303.858C344.656 302.676 336.38 297.134 333.249 295.606V295.606ZM4.38608 317.474C4.8554 314.825 5.06046 314.085 6.65829 312.001C9.18689 308.218 39.8784 273.779 87.4491 265.434C93.7093 264.535 98.2212 264.97 99.2472 267.479C101.044 271.878 97.4008 274.414 93.0181 276.951C16.7216 322.55 22.1303 390.336 21.4002 418.066C21.6299 429.407 13.4384 431.475 11.3926 426.13C2.43866 401.705 -5.08928 363.422 4.38608 317.474V317.474ZM56.0113 217.612C57.5753 215.954 58.593 215.191 60.9132 214.538C90.2141 207.259 119.609 211.894 140.775 221.334C145.53 223.436 147.67 226.419 144.55 228.42C140.581 230.725 128.554 238.547 121.907 244.741C119.974 246.408 116.528 246.494 114.495 246.225C89.6818 242.953 76.792 241.022 39.4888 255.162C33.7655 257.569 28.6183 254.294 31.2515 249.796C36.219 240.898 47.7678 226.016 56.0113 217.612V217.612ZM104.227 188.336C97.8117 187.605 97.7207 182.913 100.433 181.085C107.404 176.2 118.715 170.304 130.089 165.794C133.5 164.444 135.257 164.092 138.378 164.406C146.762 165.244 160.644 170.89 176.576 182.256C195.682 195.888 212.676 221.784 201.31 219.69C194.121 218.444 197.251 218.786 188.825 217.862C180.214 217.098 174.564 217.982 170.596 217.578C168.867 217.436 167.505 216.283 166.287 215.288C150.163 200.83 131.536 191.653 104.227 188.336Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M411.177 414.687C409.458 420.055 407.413 426.787 403.035 423.666C394.9 417.611 376.819 405.977 359.309 399.517C358.37 399.308 358.477 398 358.807 397.265C360.049 394.515 360.604 391.971 361.142 388.717C361.639 385.671 363.836 383.638 365.347 381.195C369.835 374.026 372.267 361.534 373.246 353.737C373.989 346.576 373.547 338.595 371.995 331.942C371.332 329.099 369.284 325.436 369.339 322.294C369.391 319.221 370.838 315.999 371.132 312.37C372 301.869 358.746 293.112 351.515 289.739C335.104 282.077 317.667 275.224 299.943 265.875C289.938 260.598 281.91 249.022 273.883 242.809C265.775 236.553 239.714 226.216 229.301 223.467C226.948 222.726 226.115 221.748 225.717 219.875C221.424 199.386 209.328 176.815 186.742 159.361C179.428 153.675 187.629 150.443 197.703 149.951C356.498 144.508 447.878 290.643 411.177 414.687",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M346.699 344.448C346.585 343.64 346.238 340.903 346.241 340.337C346.25 338.895 349.217 336.931 350.602 335.831C352.7 334.16 355.131 332.324 356.724 331.522C357.298 331.16 357.682 331.994 357.758 332.16C363.612 341.048 361.418 363.007 357.187 373.452C356.698 374.514 355.802 374.93 355.436 374.15C353.279 369.439 350.077 365.198 346.401 362.87C345.719 362.343 345.667 361.245 345.719 361.039C346.903 356.077 347.518 350.574 346.699 344.448V344.448ZM274.305 398.504C275.569 394.865 277.036 392.72 279.864 390.951C285.191 387.608 294.046 387.465 302.59 386.879C310.868 386.323 319.715 385.835 325.604 383.115C329.172 381.475 332.737 376.807 338.243 379.184C340.851 380.307 342.274 382.698 343.05 385.075C343.925 387.721 344.561 390.397 344.29 393.947C343.497 404.192 335.176 409.194 333.68 418.771C333.538 420.251 333.288 422.393 332.437 423.243C326.085 429.71 313.523 428.351 302.164 427.206C298.098 426.803 294.078 426.692 291.327 425.383C289.343 424.453 287.563 422.562 285.915 421.03C282.28 417.662 280.226 415.185 276.581 411.1C275.348 409.716 272.548 407.21 272.364 405.689C272.204 404.229 273.766 400.041 274.305 398.504V398.504ZM75.3954 519.246C71.2263 515.829 69.4321 512.948 67.0347 508.902C47.5857 477.819 36.686 367.727 61.7484 330.39C69.7227 317.306 78.172 323.336 75.3631 333.449C70.5643 356.152 73.506 368.873 84.5452 393.505C101.893 430.114 155.441 480.938 169.617 499.37C193.918 530.986 202.006 554.017 201.896 560.221C201.766 564.981 200.851 568.016 192.511 567.311C148.51 563.823 105.976 545.583 75.3954 519.246",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M100.548 370.783C87.1276 338.089 95.8903 308.651 101.82 297.484C104.808 291.849 107.73 288.168 111.544 289.228C115.695 290.385 116.654 294.634 117.227 302.509C121.449 367.862 160.98 389.865 210.628 412.939C249.802 432.963 294.369 455.857 331.72 511.312C337.373 519.319 338.189 524.176 331.808 528.762C309.032 544.308 288.404 555.145 258.219 562.184C253.678 563.247 248.99 562.449 244.966 552.068C203.035 444.031 132.634 448.9 100.548 370.783ZM360.26 503.607C353.878 509.99 350.254 504.989 348.171 500.888C339.23 481.878 330.497 465.969 316.415 450.556C313.978 448.085 315.857 444.612 319.443 444.967C324.025 445.333 327.029 445.081 332.07 442.916C336.338 441.084 341.224 435.102 343.661 426.511C345.437 420.243 345.521 418.399 349.361 418.01C350.315 417.921 352.063 418.159 353.122 418.463C357.796 419.795 362.815 423.615 366.482 426.427C375.888 433.612 389.921 449.473 392.377 454.604C393.937 457.871 392.445 460.086 391.565 461.953C386.642 472.015 371.12 492.871 360.26 503.607V503.607ZM476.671 7.3883H484.04L538.309 85.9543V7.3883H545.397V98.3847H538.421L483.644 19.2547V98.3847H476.671V7.3883V7.3883ZM605.125 57.779C604.966 47.9393 599.942 37.8622 587.485 37.8622C576.163 37.8622 569.581 46.5873 567.671 57.779H605.125ZM559.738 65.1749C559.738 46.7167 570.424 31.685 587.747 31.685C604.45 31.685 613.59 45.07 612.21 63.6842H567.275V65.1749C567.389 80.0505 573.687 93.7168 589.267 93.7168C597.589 93.7168 604.562 90.3196 608.106 87.5863L611.143 93.1942C607.037 96.1914 599.501 99.8993 588.983 99.8993C569.03 99.8993 559.738 83.8744 559.738 65.1749V65.1749ZM620.521 33.2023H628.17L644.031 87.4436L661.094 33.2023H668.102L685.143 87.5863L701.169 33.2023H708.257L688.569 98.3847H682.05L664.441 43.4381L646.779 98.3847H640.207L620.521 33.2023V33.2023ZM771.793 64.0775L741.301 7.3883H749.804L775.619 56.5511H775.842L801.665 7.3883H809.329L779.166 64.0775V98.3847H771.793V64.0775V64.0775ZM854.883 65.8775C854.883 51.2552 847.094 37.8622 832.19 37.8622C817.456 37.8622 810.764 50.9739 810.764 65.5975C810.764 80.3318 817.953 93.7168 832.753 93.7168C847.653 93.7168 854.883 80.6131 854.883 65.8775ZM803.171 65.8775C803.171 49.4552 811.944 31.685 832.417 31.685C852.968 31.685 862.393 49.3433 862.393 65.5975C862.393 81.9624 853.057 99.8993 832.583 99.8993C812.113 99.8993 803.171 82.2438 803.171 65.8775ZM875.978 33.2023H883.118V44.562C885.551 39.7768 891.447 31.685 900.614 31.685C903.652 31.685 905.787 32.3597 906.912 32.809L905.16 39.5008C904.043 39.0529 902.524 38.5448 899.827 38.5448C890.784 38.5448 884.921 49.1753 883.118 52.9992V98.3847H875.978V33.2023V33.2023ZM927.774 61.7736L956.4 33.2023H965.228L936.381 61.7736L966.747 98.3847H957.867L927.774 61.7736ZM920.048 0.00847064H927.154V98.3847H920.048V0.00847064V0.00847064ZM495.649 190.396C512.97 190.396 520.112 182.467 520.112 170.432C520.112 159.071 513.251 150.866 495.929 150.866H484.289V190.396H495.649ZM476.768 144.45H496.605C515.727 144.45 527.763 153.898 527.763 170.151C527.763 186.569 516.402 196.809 495.761 196.809H484.289V235.501H476.768V144.45V144.45ZM539.231 216.379V170.283H546.318V214.86C546.318 224.423 549.746 230.551 559.702 230.551C569.433 230.551 577.472 221.386 579.667 217.56V170.283H586.752V222.906C586.752 228.077 587.315 233.027 587.989 235.501H580.746C580.343 233.252 579.79 228.379 579.79 224.815C576.664 229.764 569.262 237.003 558.223 237.003C544.56 237.003 539.231 228.077 539.231 216.379V216.379ZM648.8 202.942C648.8 188.72 643.327 175.212 627.468 175.212C621.902 175.212 615.322 178.475 611.642 182.581V228.248C614.646 229.764 619.145 230.779 624.347 230.779C640.871 230.779 648.8 216.436 648.8 202.942V202.942ZM604.524 232.069V137.082H611.642V176.281C615.603 171.782 622.014 168.802 628.707 168.802C647.32 168.802 656.32 183.697 656.32 202.655C656.32 220.992 644.004 237.003 624.092 237.003C616.278 237.003 609.022 235.087 604.524 232.069ZM672.271 137.082H679.414V235.501H672.271V137.082ZM700.549 170.283H707.756V235.501H700.549V170.283ZM698.759 151.03C698.759 147.881 701.233 145.574 704.104 145.574C707.137 145.574 709.612 147.881 709.612 151.03C709.612 154.178 707.137 156.615 704.104 156.615C701.233 156.615 698.759 154.178 698.759 151.03ZM721.477 202.826C721.477 182.185 733.343 168.802 750.16 168.802C759.89 168.802 766.018 172.456 769.55 175.605L765.85 180.823C762.196 177.687 757.245 174.931 749.992 174.931C735.52 174.931 728.955 187.526 728.955 202.543C728.955 216.999 735.426 230.779 749.896 230.779C757.416 230.779 763.713 227.515 766.584 224.983L769.675 230.295C766.184 233.421 759.328 237.003 749.431 237.003C730.73 237.003 721.477 220.262 721.477 202.826V202.826ZM476.671 372.798V281.801H496.073V357.193H529.98V372.798H476.671V372.798ZM544.358 372.798V306.263H562.677V372.798H544.358ZM553.512 297.664C547.097 297.664 542.442 292.547 542.442 286.748C542.442 281.003 547.097 276.063 553.512 276.063C559.923 276.063 564.713 281.003 564.713 286.748C564.713 292.547 559.923 297.664 553.512 297.664ZM596.817 358.681C598.049 359.11 600.917 360.202 605.98 360.202C616.102 360.202 622.119 352.722 622.119 338.999C622.119 326.57 617.897 318.922 608.06 318.922C602.324 318.922 597.937 322.687 596.817 324.039V358.681ZM596.817 274.378V311.442C599.849 308.401 605.698 304.578 613.106 304.578C629.77 304.578 641.376 316.05 641.376 338.999C641.376 361.718 626.058 374.443 605.98 374.443C590.961 374.443 581.796 370.61 578.647 369.142V274.378H596.817V274.378ZM692.525 322.214C691.403 321.564 689.323 320.774 685.496 320.774C677.455 320.774 672.675 327.864 670.99 330.838V372.798H652.852V306.263H670.99V315.266C673.856 310.315 679.367 304.578 687.804 304.578C692.752 304.578 695.393 305.536 696.839 306.402L692.525 322.214V322.214ZM738.535 343.296H736.167C725.589 343.296 718.171 346.422 718.171 354.238C718.171 359.11 722.167 361.155 726.214 361.155C732.786 361.155 736.619 357.33 738.535 355.277V343.296ZM740.555 372.798C739.992 371.11 739.6 367.734 739.494 365.711C736.507 369.198 730.206 374.443 720.797 374.443C709.398 374.443 700.673 367.625 700.673 355.752C700.673 338.377 718.565 332.079 736.167 332.079H738.535V328.255C738.535 322.518 736.167 318.922 727.732 318.922C719.127 318.922 713.222 323.475 710.749 325.22L702.874 314.139C706.866 310.653 715.535 304.578 729.812 304.578C747.979 304.578 756.582 311.61 756.582 329.212V353.112C756.582 362.111 757.538 368.577 758.494 372.798H740.555V372.798ZM811.517 322.214C810.394 321.564 808.312 320.774 804.488 320.774C796.447 320.774 791.664 327.864 789.992 330.838V372.798H771.811V306.263H789.992V315.266C792.87 310.315 798.357 304.578 806.793 304.578C811.741 304.578 814.386 305.536 815.876 306.402L811.517 322.214ZM822.121 306.263H841.47L856.269 350.077H856.936L870.49 306.263H889.216L861.717 379.882C855.827 395.575 848.892 404.74 830.729 404.74C825.153 404.74 821.788 403.954 820.437 403.558L823.079 389.22C824.033 389.444 825.554 389.836 829.442 389.836C838.77 389.836 842.032 385.395 844.675 378.276L847.149 371.447L822.121 306.263Z",
        fill: "white"
    })), /* @__PURE__ */ $acw62.createElement("defs", null, /* @__PURE__ */ $acw62.createElement("clipPath", {
        id: "clip0_1147_1139"
    }, /* @__PURE__ */ $acw62.createElement("rect", {
        width: 966.773,
        height: 567.413,
        fill: "white"
    })))), $0422a6ce4ea03acc$var$Jz = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 136 135",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M80.2515 43.3532C79.3806 41.7034 76.8551 41.3127 74.1989 41.4429C72.7832 41.4803 71.3783 41.6992 70.0187 42.0942C68.5382 42.5283 66.5351 43.5268 67.406 45.5673C67.9721 46.9566 69.9751 47.521 71.4121 47.9986C73.0667 48.5629 74.8956 48.9971 76.1584 49.7351C76.8986 50.1693 77.6824 51.2981 78.7275 51.1678C79.7725 51.0376 80.4257 48.9537 80.6434 47.9117C80.9482 46.3054 80.8176 44.3517 80.2515 43.3532Z",
        fill: "#000000"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M68.1027 0.112183C31.0468 0.112183 0.87085 30.1551 0.87085 67.4917C0.87085 104.828 31.2645 134.915 68.1463 134.915C105.594 134.915 135.944 104.872 135.944 67.5351C135.901 30.1551 105.551 0.112183 68.1027 0.112183ZM28.6519 114.77C27.6447 113.917 26.8034 112.887 26.1699 111.731C20.4221 102.571 17.1998 70.1834 24.6023 59.1995C26.9537 55.3356 29.4357 57.1156 28.6083 60.1112C27.1714 66.7971 28.0423 70.5307 31.3081 77.781C34.9391 85.3897 43.898 95.1016 50.3164 102.06C52.9804 104.947 55.2068 107.361 56.4329 108.953C63.6177 118.243 66.0126 125.016 65.969 126.84C65.9255 128.229 65.6642 129.14 63.1822 128.923C50.2497 127.925 37.6655 122.541 28.6519 114.77ZM127.704 84.1946L127.758 84.0326C138.6 47.521 111.647 4.49706 64.8369 6.19023C61.8759 6.36389 59.4375 7.2756 61.6147 8.96877C68.2769 14.0917 71.8475 20.7341 73.1103 26.7688C73.1974 27.2897 73.4586 27.5936 74.1553 27.8107C77.2034 28.6356 84.9107 31.6746 87.3056 33.498C88.2545 34.2205 89.1967 35.1884 90.1726 36.191C91.6596 37.7187 93.2251 39.3271 95.0129 40.2707C98.4249 42.0701 101.782 43.5417 105.037 44.9686L105.038 44.9687L105.038 44.9688L105.038 44.9689L105.038 44.969L105.039 44.9691L105.04 44.9697C106.81 45.7458 108.551 46.5087 110.253 47.3039C112.387 48.259 116.306 50.8639 116.045 53.9463C116.004 54.4314 115.888 54.8978 115.776 55.3496C115.646 55.8683 115.522 56.3679 115.522 56.8551C115.522 57.4172 115.754 58.0453 115.972 58.6376C116.108 59.0061 116.239 59.3607 116.306 59.677C116.752 61.7884 116.869 63.9555 116.654 66.1024C116.349 68.4034 115.609 72.0502 114.303 74.1775C114.169 74.3844 114.021 74.5777 113.874 74.7688C113.499 75.2593 113.134 75.7356 113.04 76.3917C112.906 77.2551 112.673 78.1001 112.343 78.9097C112.213 79.1268 112.213 79.5175 112.474 79.5609C117.612 81.4712 122.968 84.9009 125.363 86.6809C126.583 87.5614 127.193 85.729 127.704 84.1946ZM108.729 63.3673C108.686 63.1502 108.599 62.3254 108.599 62.1517C108.599 61.7932 109.192 61.3459 109.645 61.0053C109.74 60.9335 109.829 60.8664 109.905 60.8059C110.466 60.3405 111.063 59.9195 111.69 59.5468C111.83 59.4774 111.913 59.6024 111.963 59.6774C111.976 59.6962 111.986 59.7118 111.995 59.7205C113.737 62.3254 113.084 68.7941 111.821 71.8766C111.69 72.1805 111.429 72.3107 111.298 72.0937C110.645 70.7044 109.731 69.4454 108.642 68.7941C108.498 68.6596 108.419 68.4699 108.424 68.2732C108.859 66.6754 108.962 65.0063 108.729 63.3673ZM68.4946 32.239C60.7873 30.3722 54.3428 32.8034 52.1221 34.5834C47.9419 37.8829 44.6761 43.2229 45.9824 50.8205C46.5049 54.0766 47.5064 56.8117 49.1176 59.0693C53.5685 65.366 60.7404 68.7428 67.9076 72.1174L67.9078 72.1175C71.1179 73.6289 74.3271 75.14 77.2905 76.9127C77.4268 77.0225 77.6027 77.0709 77.7762 77.0462C77.9496 77.0215 78.105 76.9259 78.2049 76.7825L78.2211 76.759C79.8248 74.4253 81.1314 72.524 83.8221 71.399C86.2517 70.3993 89.9451 70.5915 93.3594 70.7692L93.3625 70.7693C93.8022 70.7922 94.2374 70.8148 94.6645 70.8346C98.54 71.0083 102.72 70.661 104.114 68.6639C105.812 66.2761 105.725 61.5005 103.156 60.0244C102.414 59.6087 101.488 59.4018 100.561 59.1947C99.7449 59.0125 98.928 58.83 98.2351 58.5049C97.1465 58.0273 96.3192 57.0722 95.7096 55.7698C95.2306 54.6844 94.7516 52.9044 95.4048 51.7322C95.9611 50.6656 97.4425 50.9826 98.6506 51.2411L98.7141 51.2546C101.109 51.819 105.159 52.3834 107.466 51.3849C108.12 51.0376 105.681 49.3878 104.767 48.9537C102.617 47.8924 100.16 47.0806 97.7071 46.2701C94.9419 45.3566 92.1821 44.4448 89.8747 43.1795C88.33 42.3217 86.9521 41.2188 85.5676 40.1106C83.8689 38.7509 82.1601 37.3831 80.1209 36.4503C76.3695 34.7269 72.4807 33.3183 68.4946 32.239ZM37.1865 17.3912C35.3141 17.1741 35.2706 15.7849 36.0544 15.2639C38.8071 13.4607 41.7403 11.9475 44.8067 10.7488C45.5606 10.3738 46.4114 10.2375 47.2452 10.358C49.7272 10.6185 53.8203 12.2683 58.5231 15.6112C64.1402 19.6054 69.1913 27.2463 65.8384 26.6385C64.6151 26.3981 63.3795 26.2242 62.1372 26.1176C60.697 25.9938 59.5259 26.0253 58.5672 26.0511C57.8448 26.0705 57.243 26.0867 56.7378 26.0307C56.2524 25.9419 55.8092 25.6981 55.475 25.3361C50.7287 21.0815 45.2421 18.3897 37.1865 17.3912ZM89.0038 77.0429C88.1951 77.55 87.6051 78.3394 87.3491 79.2571C87.3221 79.347 87.2801 79.4724 87.2312 79.6181C87.0443 80.1756 86.7576 81.0312 86.8266 81.341C86.8941 81.7112 87.4065 82.238 87.7958 82.6381C87.9086 82.7541 88.0111 82.8595 88.0894 82.9473C88.948 83.9677 89.8639 84.9389 90.8326 85.8561C91.3082 86.3486 91.8505 86.7724 92.4438 87.1151C93.0471 87.4159 93.8825 87.4851 94.7913 87.5605L94.7917 87.5605C95.0635 87.583 95.3418 87.6061 95.6225 87.6361L95.6573 87.6397C99.0009 87.9861 102.683 88.3675 104.549 86.4639C104.767 86.2468 104.854 85.5956 104.897 85.1615C105.103 83.826 105.768 82.792 106.434 81.7557C107.175 80.6021 107.918 79.4458 108.033 77.8678C108.107 76.9846 107.988 76.0959 107.684 75.2629C107.467 74.5107 106.947 73.882 106.247 73.5263C105.034 73.0171 104.149 73.6279 103.351 74.1783C103.06 74.3787 102.781 74.5711 102.502 74.6985C100.88 75.4669 98.502 75.6325 96.213 75.792H96.2129C96.0445 75.8037 95.8766 75.8154 95.7096 75.8273C95.4136 75.8477 95.1164 75.8662 94.8199 75.8847L94.8192 75.8848L94.8185 75.8848C92.5851 76.0243 90.3874 76.1616 89.0038 77.0429ZM22.9476 26.0307C23.3332 25.6006 23.8305 25.2851 24.3846 25.119C32.2464 23.219 40.5147 23.92 47.9419 27.1161C49.3353 27.7239 49.9884 28.5922 49.074 29.2C47.8983 29.8946 44.3713 32.1956 42.4118 34.019C41.8457 34.4966 40.8442 34.54 40.2346 34.4532L39.9891 34.4211C32.8321 33.486 28.9639 32.9805 18.1143 37.1015C16.416 37.7961 14.892 36.841 15.6758 35.5385C17.1128 32.8903 20.5092 28.5054 22.9476 26.0307ZM8.36042 53.8161C7.98633 54.2743 7.7588 54.8338 7.70726 55.4224C4.92045 68.9243 7.14119 80.2122 9.79737 87.419C10.407 88.9819 12.8454 88.3741 12.7584 85.0312C12.7745 84.4262 12.7806 83.7563 12.7872 83.029V83.0289C12.8698 73.9444 13.0338 55.9041 33.8772 43.4834C35.14 42.7453 36.2286 42.0073 35.706 40.7048C35.4012 39.9668 34.0514 39.8366 32.2225 40.097C18.1578 42.5717 9.10067 52.6873 8.36042 53.8161ZM36.0979 71.0951C32.1354 61.4571 34.7045 52.8175 36.4898 49.518C37.3607 47.8683 38.2315 46.7829 39.3637 47.0868C40.5829 47.4341 40.8877 48.6932 41.0619 50.9941C42.3247 70.2268 53.9944 76.6956 68.6252 83.5117C80.2079 89.4161 93.3582 96.1453 104.375 112.469C106.029 114.814 106.291 116.246 104.418 117.592C97.7126 122.151 91.6164 125.363 82.6899 127.447C81.34 127.751 79.9466 127.534 78.771 124.452C72.029 107.187 62.8066 99.7243 54.2737 92.8196C47.1 87.0148 40.4135 81.6043 36.0979 71.0951ZM109.165 109.43C109.774 110.602 110.863 112.079 112.735 110.212C115.958 107.042 120.53 100.921 122.054 97.9688C122.089 97.8924 122.128 97.8145 122.169 97.7344C122.427 97.2226 122.729 96.6239 122.315 95.798C121.575 94.2785 117.438 89.6332 114.651 87.5059L114.618 87.4805C113.532 86.658 112.068 85.5482 110.689 85.1615C110.336 85.0566 109.968 85.0126 109.6 85.0312C108.575 85.1491 108.442 85.623 108.039 87.0649C107.996 87.2155 107.951 87.3768 107.902 87.5493C107.162 90.0673 105.725 91.8473 104.462 92.3683C103.295 92.9138 101.998 93.1243 100.717 92.9761C99.6286 92.8893 99.0625 93.8878 99.8027 94.6259C103.939 99.141 106.508 103.83 109.165 109.43Z",
        fill: "#000000"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M71.4555 47.9985C73.1102 48.5629 74.939 48.997 76.2018 49.7351C76.9421 50.1692 77.7259 51.298 78.7709 51.1678C79.816 51.0375 80.4691 48.9536 80.6868 47.9117C80.9916 46.3487 80.8175 44.3951 80.2949 43.3965C79.4241 41.7468 76.8985 41.356 74.2423 41.4863C72.8267 41.5237 71.4217 41.7426 70.0621 42.1375C68.5816 42.5716 66.5786 43.5702 67.4495 45.6107C68.0156 46.9131 70.0186 47.5209 71.4555 47.9985Z",
        fill: "#000000"
    })), $0422a6ce4ea03acc$var$eU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 125 126",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M122.666 79.0815L122.66 79.101C122.161 80.6829 121.527 82.6958 120.258 81.7727C116.249 78.8355 111.884 76.4143 107.268 74.5662C106.993 74.4964 107.028 74.1177 107.128 73.9133C107.487 73.1026 107.719 72.2422 107.818 71.3617C108.071 70.5367 108.493 69.773 109.057 69.119C110.35 66.5569 111.143 63.7732 111.395 60.9158C111.616 58.7382 111.488 56.5394 111.015 54.4021C110.648 53.4802 110.383 52.5209 110.226 51.5414C110.226 51.0443 110.354 50.5471 110.488 50.0243L110.488 50.0242C110.606 49.5669 110.729 49.0898 110.775 48.576C110.188 45.4367 107.953 42.8553 104.925 41.8181C103.292 41.0567 101.623 40.3186 99.9283 39.5692C96.5542 38.0769 93.0777 36.5392 89.5723 34.6814C86.7865 32.6101 84.184 30.3042 81.7935 27.7889C77.6345 25.3034 73.1688 23.3685 68.5091 22.0327C67.957 21.9494 67.5235 21.517 67.44 20.9662C65.8369 13.7599 61.7204 7.35579 55.8243 2.89546C53.656 1.20598 56.1191 0.239139 59.1167 0.104566C79.2322 -1.02727 98.6569 7.60362 111.269 23.277C123.88 38.9503 128.125 59.7355 122.666 79.0815ZM29.5009 8.84576C28.7039 9.37578 28.7039 10.7442 30.6463 10.9417C37.6046 11.515 44.1771 14.2403 49.3663 18.704C49.7049 19.0572 50.1581 19.2914 50.653 19.369C51.142 19.4095 51.7022 19.3914 52.3657 19.3698C53.359 19.3376 54.5839 19.2978 56.1479 19.4364C57.4098 19.5387 58.6637 19.7173 59.9019 19.9713C63.3129 20.5736 58.2015 13.1052 52.4644 9.1734C49.1063 6.6216 45.1645 4.86335 40.96 4.04188C40.0961 3.93254 39.2177 4.07178 38.4371 4.44179C35.3018 5.59989 32.3059 7.07635 29.5009 8.84576ZM16.5015 19.9447C16.8744 19.5103 17.3717 19.1952 17.9293 19.0401C25.7792 17.1614 34.0417 17.8546 41.4506 21.0136C42.8438 21.6183 43.491 22.4647 42.5721 23.0548C40.2231 24.4489 37.9927 26.026 35.9026 27.7709C35.2538 28.1687 34.48 28.3233 33.7239 28.2063C26.2687 26.729 18.5262 27.6274 11.6302 30.7699C9.93075 31.4713 8.42885 30.5039 9.21439 29.2317C11.2956 25.8887 13.7387 22.775 16.5015 19.9447ZM98.2814 43.6276C96.1482 42.58 93.7224 41.7751 91.3015 40.9718L91.3014 40.9718C88.486 40.0377 85.6773 39.1057 83.3431 37.7968C81.7617 36.9231 80.3593 35.7923 78.9523 34.6577C77.2695 33.3008 75.58 31.9385 73.5697 31.0042C69.8152 29.2527 65.9161 27.8293 61.9159 26.7501C56.3564 25.2169 50.4087 26.0742 45.5094 29.1152C40.4797 32.9777 38.0812 39.3596 39.3228 45.5762C39.7191 48.5499 40.7936 51.3929 42.4632 53.886C46.9371 60.2187 54.0881 63.6053 61.2447 66.9946L61.2447 66.9946C64.4764 68.5251 67.7092 70.0561 70.6972 71.8592C70.9615 72.0811 71.3558 72.0469 71.5779 71.7827L71.5802 71.7799L71.6398 71.7352C72.9 69.3701 74.8737 67.4619 77.2806 66.2813C80.8329 65.3919 84.5232 65.1933 88.1505 65.6963C91.4747 66.3364 94.9146 65.5382 97.6165 63.4998C99.4777 60.7481 99.0566 57.0516 96.6242 54.7884C95.8761 54.3576 94.925 54.1519 93.9709 53.9455C93.1788 53.7741 92.3846 53.6023 91.7027 53.3009C90.5427 52.7226 89.6405 51.7325 89.1725 50.5243C88.4944 49.2696 88.3825 47.7857 88.8649 46.4436C89.7495 45.5582 91.1102 45.3567 92.2137 45.9478C95.0795 46.7644 98.1099 46.8123 101 46.0866C100.503 44.9047 99.5076 44.0039 98.2814 43.6276ZM74.0461 42.2889C73.9765 43.6307 73.2634 44.8566 72.1311 45.581C71.1383 45.4014 70.2349 44.8932 69.5662 44.1382C68.0376 43.4136 66.4469 42.8278 64.8134 42.388C63.2054 42.1213 61.768 41.2302 60.8147 39.9089C59.9613 37.8513 61.9756 36.8894 63.4441 36.4085C64.8008 36.002 66.2055 35.777 67.6214 35.7392C69.8362 35.2382 72.1489 35.972 73.669 37.658C74.1892 39.1439 74.3191 40.7384 74.0461 42.2889ZM2.03627 48.1409C1.63166 48.5911 1.38721 49.1596 1.34019 49.7597C-0.991349 60.5504 -0.270646 71.7666 3.42336 82.1797C4.05382 83.7537 6.52034 83.146 6.44972 79.769C6.46794 79.1455 6.47556 78.4548 6.48384 77.7046C6.58561 68.4831 6.78645 50.285 27.9774 37.7011C29.2989 36.9441 30.4085 36.187 29.8537 34.877C28.8997 34.0088 27.5223 33.7659 26.3229 34.2544C16.8851 36.0778 8.33604 40.9659 2.03627 48.1409ZM102.126 56.6795C102.126 56.8557 102.24 57.6913 102.278 57.9329C102.496 59.5948 102.403 61.2794 102.001 62.9116C101.988 63.1185 102.069 63.3213 102.224 63.4704C103.508 64.3428 104.514 65.5223 105.134 66.8834C105.226 67.1251 105.524 66.9841 105.676 66.672C107.375 62.69 107.441 58.2669 105.86 54.243L105.852 54.2283C105.808 54.1438 105.697 53.9323 105.524 54.0316C104.829 54.411 104.167 54.842 103.546 55.3203C102.946 55.6424 102.455 56.113 102.126 56.6795ZM81.61 73.8964C81.8488 72.9563 82.4266 72.1458 83.2253 71.6307C85.3218 70.7367 87.5809 70.3211 89.8476 70.4122C92.1241 70.4147 94.3851 70.0267 96.5383 69.2642C97.4901 68.2602 98.8666 67.8158 100.203 68.0809C100.903 68.4321 101.418 69.0816 101.614 69.8583C101.92 70.7155 102.047 71.6304 101.985 72.5419C101.076 75.0897 100.043 77.5885 98.8905 80.029C98.9015 80.5103 98.7723 80.9838 98.5196 81.3885C95.8619 83.0033 92.6809 83.4306 89.711 82.5717C88.6338 82.5719 87.5644 82.3829 86.5487 82.0128C85.9555 81.663 85.4214 81.2157 84.9676 80.6887C84.1918 79.9406 83.6583 79.3231 82.9951 78.5555C82.7656 78.2898 82.5205 78.0061 82.2444 77.6927C81.7313 77.2352 81.3087 76.6795 81 76.0564C81.1453 75.3203 81.3494 74.5978 81.61 73.8964ZM19.9236 107.506C20.5356 108.698 21.3844 109.754 22.4181 110.608C32.2358 118.906 44.4022 123.93 57.2161 124.977C59.6907 125.181 59.9649 124.288 60 122.872C58.3181 116.127 55.0281 109.89 50.4112 104.693C49.1819 103.085 46.9438 100.646 44.2638 97.7257C37.7963 90.6776 28.7558 80.8254 25.1121 73.0924C21.9715 67.665 21.0019 61.2504 22.398 55.1377C23.2212 52.1352 20.7117 50.3397 18.342 54.2399C10.8836 65.3817 14.1165 98.2239 19.9236 107.506ZM30.1067 65.1896C27.1716 58.2251 27.3088 50.3557 30.4847 43.4965C31.375 41.8198 32.2305 40.7268 33.3645 41.068C34.5979 41.4093 34.8566 42.6755 35.0455 45.0248C36.3138 64.3884 48.0317 70.8874 62.7337 77.7327C77.1939 83.9279 89.6298 94.0114 98.6433 106.85C100.324 109.209 100.563 110.648 98.6783 112.013C92.1456 116.738 84.7208 120.103 76.849 121.905C75.5111 122.212 74.1086 121.975 72.9099 118.893C66.1551 101.466 56.8936 93.9458 48.3196 86.9837C41.1422 81.1557 34.4467 75.719 30.1067 65.1896ZM102.739 104.307C103.35 105.525 104.449 106.977 106.333 105.119C109.928 101.449 113.037 97.3442 115.582 92.9039C116.037 92.2705 116.127 91.4513 115.821 90.7368C113.699 87.622 111.114 84.8385 108.152 82.4795C106.962 81.4974 105.619 80.7096 104.176 80.1461C103.81 80.0381 103.429 79.9918 103.047 80.0092C102.004 80.1353 101.879 80.6016 101.477 82.104C101.443 82.2328 101.407 82.3693 101.367 82.5138C100.944 84.5096 99.7056 86.2465 97.9428 87.3175C96.7847 87.8719 95.4882 88.0843 94.2101 87.9289C93.7794 87.8172 93.3269 88.0103 93.1155 88.3962C92.9041 88.7821 92.9888 89.2603 93.3204 89.553C97.2327 93.9499 100.412 98.9296 102.739 104.307Z",
        fill: "white"
    })), $0422a6ce4ea03acc$var$tU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 201 165",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M1.66113 3.03403H4.69144L26.7851 35.0843V3.03403H29.6501V40.1042H26.8402L4.52615 7.83329V40.1042H1.71623V3.03403H1.66113Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M46.8952 12.9635C39.8429 12.9635 35.4902 19.0867 35.4902 26.589C35.4902 34.2017 39.2368 40.711 47.3911 40.711C50.6115 40.7805 53.7723 39.8349 56.4269 38.008L55.2147 35.7463C52.9863 37.3598 50.3064 38.2284 47.5563 38.2286C41.1652 38.2286 38.6307 32.6571 38.5756 26.589V25.9822H56.8676C57.4186 18.4248 53.672 12.9635 46.8952 12.9635ZM46.785 15.5011C51.8539 15.5011 53.8924 19.5832 53.9475 23.6102H38.7409C39.5123 19.0867 42.1569 15.5011 46.785 15.5011Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M59.9531 13.5703H63.0936L69.5399 35.6911L76.4821 13.5703H79.292L86.2341 35.7463L92.7355 13.5703H95.6556L87.6666 40.1594H85.022L77.8595 17.7628L70.6969 40.1594H68.0523L59.9531 13.5703Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M121.22 26.1477L108.824 3.03403H112.295L122.818 23.0585H122.928L133.452 3.03403H136.592L124.251 26.1477V40.1042H121.22V26.1477Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M145.959 12.9635C137.639 12.9635 134.058 20.19 134.058 26.8649C134.058 33.5397 137.639 40.711 146.014 40.711C154.333 40.711 158.135 33.4294 158.135 26.7545C158.135 20.1348 154.278 12.9635 145.959 12.9635ZM145.793 15.4459C151.854 15.4459 155.05 20.9071 155.05 26.8649C155.05 32.8777 152.13 38.2286 146.014 38.2286C140.008 38.2286 137.033 32.7674 137.033 26.7545C137.033 20.7968 139.788 15.4459 145.793 15.4459Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M163.7 13.5703H166.62V18.2041C167.612 16.2734 170.036 12.9635 173.727 12.9635C174.592 12.957 175.45 13.1065 176.262 13.4048L175.545 16.1079C174.862 15.8362 174.132 15.7049 173.397 15.7217C169.705 15.7217 167.336 20.0797 166.62 21.6243V40.1042H163.7L163.7 13.5703Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M184.471 0H181.606V40.1042H184.471V0ZM196.372 13.5703L184.746 25.2099L196.978 40.1594H200.614L188.273 25.2099L200.008 13.5703H196.372Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.76031 58.86H1.71623H1.66113V95.9853H4.74653V80.2084H9.42973C17.8044 80.2084 22.4325 76.016 22.4325 69.3411C22.4325 62.7214 17.5289 58.86 9.76031 58.86ZM19.3471 69.4514C19.3471 74.3059 16.427 77.5605 9.37463 77.5605V77.6157H4.74653V61.5078H9.48483C16.5923 61.5078 19.3471 64.8177 19.3471 69.4514Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M27.1157 88.152V69.3963H30.0358V87.5452C30.0358 91.4618 31.4132 93.9442 35.4904 93.9442C39.4573 93.9442 42.708 90.1931 43.5895 88.6485V69.3963H46.4546V90.855C46.4253 92.5784 46.5917 94.2995 46.9504 95.9853H43.9752C43.7371 94.5445 43.6082 93.0876 43.5895 91.6273C42.3223 93.6132 39.292 96.5921 34.7741 96.5921C29.3196 96.5369 27.1157 92.8961 27.1157 88.152Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M53.7273 55.8259V94.551C55.5455 95.7646 58.5207 96.5369 61.6612 96.4818C69.7604 96.4818 74.7741 89.9724 74.7741 82.5253C74.7741 74.8023 71.0827 68.7343 63.5345 68.7343C60.8923 68.7539 58.3773 69.873 56.5923 71.8235V55.8259H53.7273ZM63.0386 71.3822C69.54 71.3822 71.7438 76.8986 71.7438 82.6908C71.7438 88.2072 68.4931 94.0545 61.7714 94.0545C59.989 94.0908 58.2207 93.7329 56.5923 93.0064V74.4162C58.2588 72.5953 60.5749 71.5052 63.0386 71.3822Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M80.7246 55.8259H83.6447V95.9301H80.7246V55.8259Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M92.6035 59.5972C91.9259 59.9927 91.5134 60.7226 91.5235 61.5078C91.4937 62.3058 91.9018 63.0562 92.5874 63.4641C93.2731 63.8719 94.1265 63.8719 94.8122 63.4641C95.4978 63.0562 95.906 62.3058 95.8761 61.5078C95.8863 60.7226 95.4737 59.9927 94.7962 59.5972C94.1186 59.2016 93.281 59.2016 92.6035 59.5972ZM95.215 69.3411H92.2398V95.9301H95.215V69.3411Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M100.78 82.6356C100.78 74.2507 105.628 68.7895 112.46 68.7895C116.427 68.7895 118.906 70.2789 120.339 71.5477L118.851 73.6439C117.07 72.0818 114.773 71.2366 112.405 71.2718C106.51 71.2718 103.865 76.4021 103.865 82.5253C103.865 88.4278 106.454 94.0545 112.35 94.0545C114.815 94.0736 117.21 93.2352 119.127 91.6825L120.394 93.8339C118.961 95.1027 116.151 96.5369 112.185 96.5369C104.526 96.5369 100.78 89.7518 100.78 82.6356Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.889648 151.756V114.686H8.76844V145.412H22.5425V151.756H0.889648Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.936 119.798C29.7853 120.638 30.9356 121.101 32.1292 121.085C33.7427 121.144 35.2598 120.317 36.0842 118.927C36.9086 117.537 36.9086 115.807 36.0842 114.417C35.2598 113.027 33.7427 112.199 32.1292 112.259C30.9502 112.227 29.8077 112.671 28.9583 113.49C28.1089 114.309 27.6236 115.436 27.6113 116.617C27.6095 117.812 28.0867 118.958 28.936 119.798ZM28.4378 124.615V151.756H35.8758V124.615H28.4378Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M49.8153 126.767V111.652H42.4324V150.267C43.6996 150.873 47.4461 152.418 53.5619 152.418C61.7161 152.418 67.942 147.288 67.942 138.02C67.942 128.698 63.2037 124.009 56.4269 124.009C53.9527 124.052 51.5883 125.038 49.8153 126.767ZM53.5618 146.626C52.2865 146.653 51.0169 146.448 49.8153 146.019V131.897C51.0085 130.636 52.6538 129.901 54.3883 129.856C58.4103 129.856 60.1183 132.945 60.1183 138.02C60.1183 143.537 57.6941 146.626 53.5618 146.626Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M88.7133 131.125C87.8342 130.657 86.8413 130.447 85.8483 130.518C82.5425 130.518 80.6141 133.442 79.953 134.655V151.756H72.5701V124.615H79.953V128.311C81.11 126.325 83.369 123.953 86.7849 123.953C88.7684 123.953 89.8703 124.34 90.4764 124.671L88.7133 131.125Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M107.887 148.832C107.936 149.819 108.084 150.799 108.328 151.756V151.701H115.6C115.049 149.071 114.79 146.389 114.829 143.702V133.938C114.829 126.712 111.303 123.898 103.92 123.898C98.1349 123.898 94.5536 126.381 92.9558 127.815L96.2065 132.338C98.1589 130.753 100.581 129.861 103.094 129.801C106.565 129.801 107.501 131.29 107.501 133.607V135.152H106.565C99.4021 135.152 92.1294 137.744 92.1294 144.805C92.1294 149.66 95.6556 152.418 100.284 152.418C103.22 152.392 105.997 151.082 107.887 148.832ZM106.51 139.73H107.446H107.501V144.64C106.249 146.117 104.422 146.981 102.488 147.012C100.78 147.012 99.1817 146.184 99.1817 144.199C99.1817 140.999 102.157 139.73 106.51 139.73Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M136.868 131.125C136.006 130.663 135.033 130.452 134.058 130.518C130.752 130.518 128.824 133.442 128.162 134.655V151.756H120.78V124.615H128.162V128.311C129.319 126.325 131.578 123.953 134.994 123.953C136.978 123.953 138.08 124.34 138.686 124.671L136.868 131.125Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M141.331 124.615H149.209L155.215 142.489H155.49L161 124.615H168.603L157.419 154.625C155.05 161.024 152.185 164.775 144.802 164.775C143.389 164.809 141.979 164.642 140.614 164.278L141.661 158.431C142.505 158.656 143.378 158.749 144.251 158.707C148.052 158.707 149.375 156.886 150.421 153.963L151.413 151.204L141.331 124.615Z",
        fill: "black"
    })), $0422a6ce4ea03acc$var$nU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 201 165",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M1.66113 3.03403H4.69144L26.7851 35.0843V3.03403H29.6501V40.1042H26.8402L4.52615 7.83329V40.1042H1.71623V3.03403H1.66113Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M46.8952 12.9635C39.8429 12.9635 35.4902 19.0867 35.4902 26.589C35.4902 34.2017 39.2368 40.711 47.3911 40.711C50.6115 40.7805 53.7723 39.8349 56.4269 38.008L55.2147 35.7463C52.9863 37.3598 50.3064 38.2284 47.5563 38.2286C41.1652 38.2286 38.6307 32.6571 38.5756 26.589V25.9822H56.8676C57.4186 18.4248 53.672 12.9635 46.8952 12.9635ZM46.785 15.5011C51.8539 15.5011 53.8924 19.5832 53.9475 23.6102H38.7409C39.5123 19.0867 42.1569 15.5011 46.785 15.5011Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M59.9531 13.5703H63.0936L69.5399 35.6911L76.482 13.5703H79.292L86.2341 35.7463L92.7355 13.5703H95.6556L87.6666 40.1594H85.022L77.8595 17.7628L70.6969 40.1594H68.0523L59.9531 13.5703Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M121.22 26.1477L108.824 3.03403H112.295L122.818 23.0585H122.928L133.452 3.03403H136.592L124.251 26.1477V40.1042H121.22V26.1477Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M145.959 12.9635C137.639 12.9635 134.058 20.19 134.058 26.8649C134.058 33.5397 137.639 40.711 146.014 40.711C154.333 40.711 158.135 33.4294 158.135 26.7545C158.135 20.1348 154.278 12.9635 145.959 12.9635ZM145.793 15.4459C151.854 15.4459 155.05 20.9071 155.05 26.8649C155.05 32.8777 152.13 38.2286 146.014 38.2286C140.008 38.2286 137.033 32.7674 137.033 26.7545C137.033 20.7968 139.788 15.4459 145.793 15.4459Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M163.7 13.5703H166.62V18.2041C167.612 16.2734 170.036 12.9635 173.727 12.9635C174.592 12.957 175.45 13.1065 176.262 13.4048L175.545 16.1079C174.862 15.8362 174.132 15.7049 173.397 15.7217C169.705 15.7217 167.336 20.0797 166.62 21.6243V40.1042H163.7L163.7 13.5703Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M184.471 0H181.606V40.1042H184.471V0ZM196.372 13.5703L184.746 25.2099L196.978 40.1594H200.614L188.273 25.2099L200.008 13.5703H196.372Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.76031 58.86H1.71623H1.66113V95.9853H4.74653V80.2084H9.42973C17.8044 80.2084 22.4325 76.016 22.4325 69.3411C22.4325 62.7214 17.5289 58.86 9.76031 58.86ZM19.3471 69.4514C19.3471 74.3059 16.427 77.5605 9.37463 77.5605V77.6157H4.74653V61.5078H9.48483C16.5923 61.5078 19.3471 64.8177 19.3471 69.4514Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M27.1157 88.152V69.3963H30.0358V87.5452C30.0358 91.4618 31.4132 93.9442 35.4904 93.9442C39.4573 93.9442 42.708 90.1931 43.5896 88.6485V69.3963H46.4546V90.855C46.4253 92.5784 46.5917 94.2995 46.9504 95.9853H43.9752C43.7371 94.5445 43.6082 93.0876 43.5896 91.6273C42.3223 93.6132 39.292 96.5921 34.7741 96.5921C29.3196 96.5369 27.1157 92.8961 27.1157 88.152Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M53.7273 55.8259V94.551C55.5455 95.7646 58.5207 96.5369 61.6612 96.4818C69.7604 96.4818 74.7741 89.9724 74.7741 82.5253C74.7741 74.8023 71.0827 68.7343 63.5345 68.7343C60.8923 68.7539 58.3773 69.873 56.5923 71.8235V55.8259H53.7273ZM63.0386 71.3822C69.54 71.3822 71.7438 76.8986 71.7438 82.6908C71.7438 88.2072 68.4931 94.0545 61.7714 94.0545C59.989 94.0908 58.2207 93.7329 56.5923 93.0064V74.4162C58.2588 72.5953 60.5749 71.5052 63.0386 71.3822Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M80.7246 55.8259H83.6447V95.9301H80.7246V55.8259Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M92.6035 59.5972C91.9259 59.9927 91.5134 60.7226 91.5235 61.5078C91.4937 62.3058 91.9018 63.0562 92.5874 63.4641C93.2731 63.8719 94.1265 63.8719 94.8122 63.4641C95.4978 63.0562 95.906 62.3058 95.8761 61.5078C95.8863 60.7226 95.4737 59.9927 94.7962 59.5972C94.1186 59.2016 93.281 59.2016 92.6035 59.5972ZM95.215 69.3411H92.2398V95.9301H95.215V69.3411Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M100.78 82.6356C100.78 74.2507 105.628 68.7895 112.46 68.7895C116.427 68.7895 118.906 70.2789 120.339 71.5477L118.851 73.6439C117.07 72.0818 114.773 71.2366 112.405 71.2718C106.51 71.2718 103.865 76.4021 103.865 82.5253C103.865 88.4278 106.454 94.0545 112.35 94.0545C114.815 94.0736 117.21 93.2352 119.127 91.6825L120.394 93.8339C118.961 95.1027 116.151 96.5369 112.185 96.5369C104.526 96.5369 100.78 89.7518 100.78 82.6356Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.889648 151.756V114.686H8.76844V145.412H22.5425V151.756H0.889648Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.936 119.798C29.7853 120.638 30.9356 121.101 32.1292 121.085C33.7427 121.144 35.2598 120.317 36.0842 118.927C36.9086 117.537 36.9086 115.807 36.0842 114.417C35.2598 113.027 33.7427 112.199 32.1292 112.259C30.9502 112.227 29.8077 112.671 28.9583 113.49C28.1089 114.309 27.6236 115.436 27.6113 116.617C27.6095 117.812 28.0867 118.958 28.936 119.798ZM28.4378 124.615V151.756H35.8758V124.615H28.4378Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M49.8153 126.767V111.652H42.4324V150.267C43.6996 150.873 47.4461 152.418 53.5619 152.418C61.7161 152.418 67.942 147.288 67.942 138.02C67.942 128.698 63.2037 124.009 56.4269 124.009C53.9527 124.052 51.5883 125.038 49.8153 126.767ZM53.5618 146.626C52.2865 146.653 51.0169 146.448 49.8153 146.019V131.897C51.0085 130.636 52.6538 129.901 54.3883 129.856C58.4103 129.856 60.1183 132.945 60.1183 138.02C60.1183 143.537 57.6941 146.626 53.5618 146.626Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M88.7133 131.125C87.8342 130.657 86.8413 130.447 85.8483 130.518C82.5425 130.518 80.6141 133.442 79.953 134.655V151.756H72.5701V124.615H79.953V128.311C81.11 126.325 83.369 123.953 86.7849 123.953C88.7684 123.953 89.8703 124.34 90.4764 124.671L88.7133 131.125Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M107.887 148.832C107.936 149.819 108.084 150.799 108.328 151.756V151.701H115.6C115.049 149.071 114.79 146.389 114.829 143.702V133.938C114.829 126.712 111.303 123.898 103.92 123.898C98.1349 123.898 94.5536 126.381 92.9558 127.815L96.2065 132.338C98.1589 130.753 100.581 129.861 103.094 129.801C106.565 129.801 107.501 131.29 107.501 133.607V135.152H106.565C99.4021 135.152 92.1294 137.744 92.1294 144.805C92.1294 149.66 95.6556 152.418 100.284 152.418C103.22 152.392 105.997 151.082 107.887 148.832ZM106.51 139.73H107.446H107.501V144.64C106.249 146.117 104.422 146.981 102.488 147.012C100.78 147.012 99.1817 146.184 99.1817 144.199C99.1817 140.999 102.157 139.73 106.51 139.73Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M136.868 131.125C136.006 130.663 135.033 130.452 134.058 130.518C130.752 130.518 128.824 133.442 128.162 134.655V151.756H120.78V124.615H128.162V128.311C129.319 126.325 131.578 123.953 134.994 123.953C136.978 123.953 138.08 124.34 138.686 124.671L136.868 131.125Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M141.331 124.615H149.209L155.215 142.489H155.49L161 124.615H168.603L157.419 154.625C155.05 161.024 152.185 164.775 144.802 164.775C143.389 164.809 141.979 164.642 140.614 164.278L141.661 158.431C142.505 158.656 143.378 158.749 144.251 158.707C148.052 158.707 149.375 156.886 150.421 153.963L151.413 151.204L141.331 124.615Z",
        fill: "white"
    })), $0422a6ce4ea03acc$var$rU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 152 139",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_53471_41906)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M130.79 29.5411H20.9897C17.8568 29.5411 15.3171 32.0758 15.3171 35.2025V133.341C15.3171 136.467 17.8568 139.002 20.9897 139.002H130.79C133.923 139.002 136.462 136.467 136.462 133.341V35.2025C136.462 32.0758 133.923 29.5411 130.79 29.5411Z",
        fill: "#012F53"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M76.0001 7.79019C76.0001 7.79019 43.5204 -12.1819 -0.00830078 11.8424V123.174C-0.00830078 123.174 22.2179 100.053 58.7746 109.532V30.593H93.2256V109.532C129.784 100.059 152.008 123.168 152.008 123.168V11.8424C108.482 -12.1819 76.0001 7.79019 76.0001 7.79019Z",
        fill: "url(#paint0_linear_53471_41906)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M13.3123 98.9825C32.528 91.2552 51.7437 90.8696 70.9615 98.9825V20.0685C52.067 11.2537 32.845 11.1091 13.3123 20.0685V98.9825Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M80.1023 98.9825C99.318 91.2552 118.534 90.8696 137.752 98.9825V20.0685C118.847 11.2537 99.635 11.1091 80.1023 20.0685V98.9825Z",
        fill: "white"
    })), /* @__PURE__ */ $acw62.createElement("defs", null, /* @__PURE__ */ $acw62.createElement("linearGradient", {
        id: "paint0_linear_53471_41906",
        x1: 76.5186,
        y1: 132.496,
        x2: 75.5128,
        y2: 5.94004,
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.15,
        stopColor: "#8AC33E"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.3,
        stopColor: "#5F9445"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.47,
        stopColor: "#37694B"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.62,
        stopColor: "#19494F"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.74,
        stopColor: "#073652"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.83,
        stopColor: "#012F53"
    })))), $0422a6ce4ea03acc$var$aU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 155 139",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_54498_42323)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M78.0867 9.49969C36.2607 -12.0237 1.80178 9.58976 0 10.7471V121.185C1.07431 119.913 5.51794 115.027 15.3939 111.613V133.209C15.3981 134.743 16.0094 136.213 17.0944 137.298C18.1793 138.384 19.6497 138.995 21.1844 139H133.298C134.832 138.995 136.303 138.384 137.388 137.298C138.473 136.213 139.084 134.743 139.088 133.209V111.003C150.908 114.714 155 120.888 155 120.888V10.7966C155 10.7966 121.052 -12.6091 78.0867 9.49969Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M100.627 10.8012C143.223 6.9329 154.973 23.6355 154.973 23.6355V121.19C154.973 121.19 143.223 104.485 100.627 108.355V10.8012Z",
        fill: "url(#paint0_linear_54498_42323)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M147.325 106.011C110.989 88.8854 82.3547 106.011 82.3547 106.011V16.268C82.3547 16.268 110.958 -0.860131 147.325 16.268V106.011Z",
        fill: "#0B1F31"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M54.3459 10.7925C11.7497 6.92423 -0.000115907 23.6268 -0.000115907 23.6268V121.181C-0.000115907 121.181 11.7497 104.476 54.3459 108.347V10.7925Z",
        fill: "url(#paint1_linear_54498_42323)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M8.52051 106.014C44.8578 88.8855 73.4925 106.014 73.4925 106.014V16.2659C73.4925 16.2659 44.8893 -0.857749 8.52051 16.2659V106.014Z",
        fill: "#0B1F31"
    })), /* @__PURE__ */ $acw62.createElement("defs", null, /* @__PURE__ */ $acw62.createElement("linearGradient", {
        id: "paint0_linear_54498_42323",
        x1: 127.8,
        y1: 121.19,
        x2: 127.8,
        y2: 10.218,
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ $acw62.createElement("stop", {
        stopColor: "#8ABF3F"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.36,
        stopColor: "#9EC856"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.9,
        stopColor: "#FFFFF9"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.97,
        stopColor: "white"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 1,
        stopColor: "white"
    })), /* @__PURE__ */ $acw62.createElement("linearGradient", {
        id: "paint1_linear_54498_42323",
        x1: 27.1729,
        y1: 121.181,
        x2: 27.1729,
        y2: 10.2094,
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ $acw62.createElement("stop", {
        stopColor: "#8ABF3F"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.36,
        stopColor: "#9EC856"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.9,
        stopColor: "#FFFFF9"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.97,
        stopColor: "white"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 1,
        stopColor: "white"
    })))), $0422a6ce4ea03acc$var$iU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 152 139",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_53471_41905)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M130.79 29.5411H20.9897C17.8568 29.5411 15.3171 32.0758 15.3171 35.2025V133.341C15.3171 136.467 17.8568 139.002 20.9897 139.002H130.79C133.923 139.002 136.462 136.467 136.462 133.341V35.2025C136.462 32.0758 133.923 29.5411 130.79 29.5411Z",
        fill: "#012F53"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M76.0001 7.79019C76.0001 7.79019 43.5204 -12.1819 -0.00830078 11.8424V123.174C-0.00830078 123.174 22.2179 100.053 58.7746 109.532V30.593H93.2256V109.532C129.784 100.059 152.008 123.168 152.008 123.168V11.8424C108.482 -12.1819 76.0001 7.79019 76.0001 7.79019Z",
        fill: "url(#paint0_linear_53471_41905)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M13.3123 98.9825C32.528 91.2552 51.7437 90.8696 70.9615 98.9825V20.0685C52.067 11.2537 32.845 11.1091 13.3123 20.0685V98.9825Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M80.1023 98.9825C99.318 91.2552 118.534 90.8696 137.752 98.9825V20.0685C118.847 11.2537 99.635 11.1091 80.1023 20.0685V98.9825Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M130.032 126.627C130.042 127.253 129.861 127.867 129.513 128.387C129.141 128.918 128.623 129.331 128.023 129.578C127.297 129.872 126.519 130.014 125.737 129.997C125.122 130.006 124.507 129.958 123.902 129.852C123.368 129.737 122.85 129.561 122.357 129.328V126.772C122.92 127.052 123.511 127.274 124.12 127.432C124.668 127.58 125.232 127.658 125.8 127.667C126.136 127.695 126.473 127.622 126.767 127.457C126.863 127.395 126.941 127.309 126.995 127.209C127.049 127.109 127.077 126.997 127.076 126.883C127.079 126.746 127.034 126.613 126.948 126.506C126.839 126.37 126.704 126.256 126.551 126.171C126.373 126.062 125.888 125.833 125.096 125.49C124.522 125.256 123.98 124.948 123.486 124.574C123.147 124.3 122.875 123.952 122.69 123.558C122.511 123.127 122.425 122.664 122.436 122.198C122.418 121.756 122.509 121.316 122.701 120.917C122.893 120.517 123.181 120.172 123.539 119.91C124.273 119.362 125.282 119.089 126.566 119.091C127.763 119.104 128.944 119.364 130.036 119.853L129.125 122.054C128.1 121.598 127.216 121.371 126.471 121.373C126.178 121.348 125.884 121.416 125.632 121.567C125.551 121.621 125.486 121.693 125.44 121.778C125.394 121.863 125.37 121.957 125.369 122.054C125.375 122.166 125.408 122.276 125.466 122.373C125.523 122.471 125.603 122.553 125.699 122.613C126.28 122.959 126.887 123.26 127.515 123.514C128.458 123.925 129.112 124.367 129.478 124.842C129.861 125.357 130.057 125.987 130.032 126.627ZM121.674 129.854H118.332L116.168 125.794L115.29 126.301V129.863H112.309V119.244H115.29V123.853C115.563 123.382 115.866 122.928 116.197 122.496L118.506 119.242H121.735L118.28 123.998L121.674 129.854ZM102.799 124.53C102.799 126.583 103.536 127.609 105.009 127.608C105.757 127.608 106.311 127.361 106.672 126.86C107.033 126.359 107.218 125.584 107.218 124.53C107.218 123.476 107.035 122.686 106.664 122.183C106.292 121.681 105.752 121.421 105.022 121.421C103.54 121.424 102.799 122.46 102.799 124.53V124.53ZM110.335 124.53C110.335 126.317 109.883 127.675 108.979 128.605C108.075 129.536 106.752 130 105.009 129.999C103.289 129.999 101.97 129.532 101.052 128.597C100.134 127.663 99.6769 126.302 99.6811 124.515C99.6811 122.747 100.135 121.398 101.044 120.469C101.952 119.541 103.278 119.073 105.022 119.068C106.767 119.068 108.089 119.53 108.988 120.455C109.886 121.38 110.335 122.738 110.335 124.53V124.53ZM90.5676 124.53C90.5676 126.583 91.3045 127.609 92.7783 127.608C93.5278 127.608 94.082 127.361 94.441 126.86C94.8 126.359 94.9889 125.584 94.9889 124.53C94.9889 123.476 94.8042 122.686 94.4326 122.183C94.061 121.681 93.5215 121.425 92.7846 121.425C91.3066 121.425 90.5676 122.46 90.5676 124.53V124.53ZM98.1044 124.53C98.1044 126.317 97.6531 127.675 96.7503 128.605C95.8476 129.536 94.5257 130 92.7846 129.999C91.0645 129.999 89.7454 129.532 88.8272 128.597C87.9091 127.663 87.4521 126.302 87.4563 124.515C87.4563 122.747 87.9112 121.398 88.8209 120.469C89.7307 119.541 91.0568 119.073 92.7993 119.068C94.5446 119.068 95.8658 119.53 96.7629 120.455C97.6601 121.38 98.1072 122.738 98.1044 124.53V124.53ZM80.4696 125.408V127.639H81.5088C82.4325 127.639 82.8951 127.261 82.8965 126.504C82.905 126.348 82.8754 126.193 82.8103 126.051C82.7452 125.91 82.6465 125.786 82.5228 125.691C82.2055 125.481 81.8278 125.381 81.4479 125.406L80.4696 125.408ZM80.4696 123.313H81.3597C81.7061 123.334 82.0504 123.245 82.3422 123.057C82.4594 122.97 82.553 122.856 82.6142 122.724C82.6755 122.591 82.7025 122.446 82.6928 122.301C82.6928 121.706 82.2288 121.408 81.3009 121.408H80.4612L80.4696 123.313ZM77.5073 119.237H81.3303C82.8181 119.237 83.9224 119.453 84.6431 119.883C85.3674 120.302 85.7306 120.974 85.7306 121.882C85.7453 122.428 85.5785 122.963 85.2562 123.405C84.9554 123.819 84.5134 124.109 84.0133 124.22V124.291C84.5885 124.378 85.1089 124.68 85.4683 125.136C85.8276 125.593 85.9988 126.169 85.9469 126.747C85.9623 127.19 85.8678 127.63 85.6719 128.027C85.4759 128.425 85.1846 128.768 84.8237 129.027C84.0777 129.585 83.0602 129.865 81.7712 129.865H77.5115L77.5073 119.237ZM71.7739 123.413C71.4542 123.406 71.1435 123.519 70.9048 123.732C70.6504 123.998 70.5058 124.351 70.4996 124.719H73.0188C73.0252 124.37 72.9001 124.031 72.6682 123.77C72.5541 123.65 72.4156 123.556 72.2621 123.494C72.1085 123.432 71.9435 123.404 71.7781 123.411L71.7739 123.413ZM71.9481 130.001C70.5332 130.001 69.4338 129.638 68.65 128.911C67.8662 128.185 67.4771 127.146 67.4827 125.796C67.4827 124.407 67.8438 123.342 68.566 122.6C69.2882 121.859 70.3232 121.486 71.671 121.481C72.9489 121.481 73.9356 121.806 74.6312 122.456C75.3282 123.097 75.6809 124.029 75.6809 125.245V126.502H70.445C70.4457 126.709 70.4923 126.914 70.5816 127.101C70.6709 127.288 70.8006 127.454 70.9614 127.585C71.3512 127.865 71.8255 128.003 72.305 127.977C72.7803 127.982 73.2547 127.935 73.72 127.839C74.2054 127.726 74.6776 127.563 75.1287 127.352V129.387C74.6798 129.612 74.2003 129.771 73.7053 129.858C73.1262 129.956 72.5397 130.003 71.9523 129.999L71.9481 130.001ZM64.256 129.856H62.8053L56.8178 120.943H56.7591C56.8388 121.991 56.8787 122.95 56.8787 123.82V129.856H55.701V119.237H57.1391L63.1139 128.113H63.1832C63.1727 127.981 63.1517 127.564 63.116 126.856C63.0803 126.148 63.0698 125.636 63.0803 125.331V119.237H64.2707L64.256 129.856ZM52.1887 129.856H46.0795V119.237H52.1887V120.333H47.3601V123.753H51.9032V124.842H47.3559V128.758H52.1845L52.1887 129.856ZM37.0332 124.618H38.1795C39.3089 124.618 40.1235 124.44 40.6295 124.086C41.1354 123.732 41.3852 123.166 41.3852 122.387C41.3852 121.685 41.148 121.163 40.6735 120.817C40.1991 120.472 39.4601 120.302 38.4566 120.302H37.0332V124.618ZM42.7016 122.33C42.7016 123.403 42.3223 124.23 41.5637 124.813C40.8051 125.395 39.7232 125.683 38.318 125.676H37.0311V129.854H35.7568V119.235H38.5973C41.3377 119.235 42.7079 120.267 42.7079 122.33H42.7016ZM23.5047 124.53C23.5047 125.967 23.8197 127.059 24.4495 127.805C25.0793 128.551 25.9981 128.921 27.206 128.915C28.4194 128.915 29.3361 128.545 29.9562 127.805C30.5762 127.065 30.8862 125.973 30.8862 124.53C30.8862 123.101 30.5762 122.019 29.9562 121.282C29.3361 120.546 28.4264 120.176 27.227 120.172C26.0135 120.172 25.0898 120.545 24.4558 121.291C23.8218 122.037 23.5047 123.116 23.5047 124.53ZM32.234 124.53C32.234 126.23 31.7896 127.566 30.9009 128.538C30.0122 129.511 28.7805 129.999 27.206 130.005C25.5936 130.005 24.3473 129.528 23.467 128.574C22.5866 127.62 22.1492 126.269 22.1548 124.522C22.1548 122.791 22.5943 121.452 23.4733 120.505C24.3522 119.558 25.6013 119.081 27.2207 119.074C28.7952 119.074 30.024 119.559 30.9072 120.528C31.7903 121.498 32.2333 122.832 32.2361 124.53H32.234Z",
        fill: "white"
    })), /* @__PURE__ */ $acw62.createElement("defs", null, /* @__PURE__ */ $acw62.createElement("linearGradient", {
        id: "paint0_linear_53471_41905",
        x1: 76.5186,
        y1: 132.496,
        x2: 75.5128,
        y2: 5.94004,
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.15,
        stopColor: "#8AC33E"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.3,
        stopColor: "#5F9445"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.47,
        stopColor: "#37694B"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.62,
        stopColor: "#19494F"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.74,
        stopColor: "#073652"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.83,
        stopColor: "#012F53"
    })))), $0422a6ce4ea03acc$var$oU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 155 139",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_54498_42322)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M78.0867 9.49969C36.2607 -12.0237 1.80178 9.58976 0 10.7471V121.185C1.07431 119.913 5.51794 115.027 15.3939 111.613V133.209C15.3981 134.743 16.0094 136.213 17.0944 137.298C18.1793 138.384 19.6497 138.995 21.1844 139H133.298C134.832 138.995 136.303 138.384 137.388 137.298C138.473 136.213 139.084 134.743 139.088 133.209V111.003C150.908 114.714 155 120.888 155 120.888V10.7966C155 10.7966 121.052 -12.6091 78.0867 9.49969Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M100.627 10.8012C143.223 6.9329 154.973 23.6355 154.973 23.6355V121.19C154.973 121.19 143.223 104.485 100.627 108.355V10.8012Z",
        fill: "url(#paint0_linear_54498_42322)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M147.325 106.011C110.989 88.8854 82.3547 106.011 82.3547 106.011V16.268C82.3547 16.268 110.958 -0.860131 147.325 16.268V106.011Z",
        fill: "#0B1F31"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M130.113 124.927C130.124 125.565 129.945 126.192 129.599 126.729C129.233 127.268 128.72 127.691 128.12 127.947C127.403 128.249 126.631 128.397 125.854 128.379C125.243 128.388 124.633 128.338 124.032 128.23C123.502 128.112 122.988 127.932 122.5 127.695V125.085C123.057 125.372 123.643 125.598 124.248 125.76C124.79 125.912 125.35 125.993 125.912 126.001C126.248 126.027 126.583 125.948 126.872 125.776C126.967 125.71 127.044 125.623 127.097 125.52C127.15 125.418 127.177 125.304 127.176 125.189C127.18 125.049 127.135 124.913 127.05 124.803C126.943 124.664 126.809 124.548 126.656 124.461C126.187 124.204 125.706 123.971 125.214 123.763C124.642 123.523 124.105 123.208 123.615 122.827C123.279 122.542 123.009 122.187 122.827 121.786C122.649 121.344 122.563 120.871 122.575 120.395C122.554 119.946 122.643 119.498 122.833 119.091C123.024 118.683 123.31 118.328 123.667 118.055C124.404 117.488 125.406 117.204 126.671 117.204C127.861 117.218 129.034 117.484 130.113 117.986L129.212 120.251C128.197 119.787 127.319 119.554 126.579 119.553C126.288 119.528 125.996 119.598 125.748 119.753C125.668 119.809 125.602 119.883 125.557 119.97C125.511 120.057 125.487 120.153 125.487 120.251C125.492 120.365 125.524 120.477 125.581 120.576C125.637 120.676 125.717 120.76 125.813 120.823C126.39 121.176 126.992 121.484 127.615 121.746C128.552 122.165 129.201 122.615 129.563 123.097C129.946 123.628 130.14 124.273 130.113 124.927V124.927ZM121.825 128.237H118.509L116.361 124.083L115.491 124.603V128.237H112.541V117.362H115.491V122.09C115.762 121.609 116.063 121.145 116.392 120.701L118.676 117.371H121.885L118.467 122.23L121.825 128.237ZM103.1 122.788C103.1 124.89 103.831 125.941 105.293 125.941C106.034 125.941 106.584 125.684 106.942 125.175C107.3 124.666 107.485 123.869 107.485 122.788C107.485 121.707 107.302 120.904 106.935 120.39C106.753 120.132 106.508 119.924 106.223 119.787C105.938 119.651 105.623 119.589 105.307 119.609C103.835 119.603 103.1 120.66 103.1 122.779V122.788ZM110.577 122.788C110.577 124.617 110.127 126.007 109.226 126.958C108.325 127.91 107.012 128.386 105.287 128.386C103.579 128.386 102.271 127.907 101.361 126.949C100.451 125.992 100.001 124.6 100.01 122.775C100.01 120.973 100.46 119.593 101.361 118.634C102.262 117.675 103.577 117.197 105.307 117.2C107.037 117.2 108.347 117.673 109.239 118.621C110.131 119.568 110.579 120.954 110.584 122.779L110.577 122.788ZM90.9693 122.788C90.9693 124.89 91.6997 125.941 93.1607 125.941C93.9039 125.941 94.4535 125.684 94.8116 125.175C95.1697 124.666 95.3521 123.869 95.3521 122.788C95.3521 121.707 95.1719 120.904 94.8026 120.39C94.6209 120.131 94.3757 119.924 94.0906 119.787C93.8054 119.65 93.4899 119.589 93.1742 119.609C91.7043 119.603 90.9693 120.66 90.9693 122.779V122.788ZM98.4444 122.788C98.4444 124.617 97.9939 126.007 97.0931 126.958C96.1922 127.91 94.8791 128.386 93.1539 128.386C91.4497 128.386 90.1412 127.907 89.2283 126.949C88.3154 125.992 87.865 124.6 87.877 122.775C87.877 120.973 88.3274 119.593 89.2283 118.634C90.1292 117.675 91.4445 117.197 93.1742 117.2C94.9054 117.2 96.2162 117.673 97.1066 118.621C97.9969 119.568 98.4429 120.954 98.4444 122.779V122.788ZM80.9559 123.689V125.97H81.9807C82.8973 125.97 83.3568 125.585 83.3568 124.81C83.3659 124.652 83.337 124.493 83.2723 124.349C83.2077 124.204 83.1092 124.076 82.9852 123.977C82.6734 123.764 82.2988 123.662 81.9221 123.689H80.9559ZM80.9559 121.541H81.841C82.1852 121.563 82.527 121.471 82.814 121.28C82.9311 121.189 83.0242 121.072 83.0851 120.937C83.146 120.802 83.1728 120.655 83.1631 120.507C83.1631 119.899 82.7126 119.593 81.7802 119.593H80.9559V121.541ZM78.028 117.371H81.8185C83.296 117.371 84.3905 117.596 85.1045 118.033C85.8184 118.47 86.1833 119.159 86.1833 120.077C86.1982 120.634 86.034 121.181 85.7149 121.638C85.419 122.057 84.98 122.353 84.4806 122.471V122.543C85.0584 122.664 85.576 122.982 85.9446 123.444C86.2635 123.922 86.4213 124.49 86.395 125.065C86.4103 125.516 86.3159 125.964 86.1197 126.37C85.9235 126.776 85.6316 127.129 85.2689 127.397C84.5279 127.963 83.5212 128.246 82.2419 128.246H78.019L78.028 117.371ZM72.3412 121.649C72.022 121.641 71.7125 121.758 71.4786 121.975C71.2248 122.251 71.082 122.612 71.0777 122.986H73.5754C73.5844 122.63 73.4599 122.283 73.2263 122.014C73.1149 121.888 72.9768 121.789 72.8221 121.723C72.6674 121.658 72.5 121.628 72.3322 121.635L72.3412 121.649ZM72.5123 128.39C71.11 128.39 70.0199 128.015 69.2421 127.265C68.4644 126.514 68.0777 125.451 68.0822 124.076C68.0822 122.653 68.4411 121.563 69.1588 120.807C69.8765 120.05 70.9028 119.668 72.2376 119.661C73.5048 119.661 74.4808 119.993 75.1655 120.658C75.8569 121.316 76.206 122.268 76.206 123.511V124.803H71.0079C71.0077 125.014 71.0536 125.223 71.1423 125.414C71.231 125.605 71.3603 125.775 71.5214 125.911C71.9046 126.196 72.3755 126.338 72.8524 126.312C73.3239 126.316 73.7944 126.269 74.2556 126.17C74.7384 126.055 75.2073 125.888 75.6542 125.673V127.762C75.2103 127.991 74.7353 128.153 74.2443 128.244C73.6691 128.34 73.0865 128.385 72.5033 128.377L72.5123 128.39ZM64.8638 128.237H63.4224L57.4833 119.118H57.4315C57.5111 120.188 57.5501 121.169 57.5486 122.061V128.237H56.3819V117.362H57.8099L63.7377 126.436H63.7985C63.7865 126.304 63.764 125.876 63.7309 125.152C63.6972 124.423 63.6836 123.903 63.6949 123.592V117.362H64.8638V128.237ZM52.8955 128.237H46.8461V117.362H52.9045V118.488H48.1073V121.987H52.6117V123.101H48.1073V127.1H52.9045L52.8955 128.237ZM37.8619 122.878H38.9993C40.1194 122.878 40.9295 122.697 41.4295 122.336C41.9295 121.975 42.1795 121.395 42.1795 120.597C42.1795 119.88 41.9445 119.344 41.4745 118.99C41.0038 118.641 40.2696 118.463 39.2741 118.463H37.8619V122.878ZM43.4925 120.537C43.4925 121.638 43.1171 122.486 42.3664 123.079C41.6156 123.672 40.5428 123.965 39.148 123.959H37.871V128.237H36.6075V117.362H39.425C42.1397 117.362 43.497 118.417 43.497 120.528L43.4925 120.537ZM24.4455 122.788C24.4455 124.258 24.7578 125.375 25.3824 126.141C26.007 126.907 26.9184 127.286 28.1166 127.278C29.3178 127.278 30.2269 126.899 30.844 126.141C31.4611 125.383 31.7689 124.265 31.7674 122.788C31.7674 121.326 31.4596 120.219 30.844 119.467C30.2284 118.715 29.3275 118.34 28.1414 118.341C26.9402 118.341 26.0235 118.723 25.3914 119.485C24.7593 120.248 24.4455 121.346 24.45 122.779L24.4455 122.788ZM33.1053 122.788C33.1053 124.53 32.6646 125.897 31.7832 126.891C30.9018 127.884 29.6796 128.383 28.1166 128.386C26.5175 128.386 25.2811 127.895 24.4094 126.922C23.5378 125.95 23.1077 124.558 23.1077 122.775C23.1077 120.991 23.5423 119.636 24.4162 118.666C25.2901 117.695 26.5265 117.2 28.1324 117.2C29.6939 117.2 30.9131 117.696 31.79 118.688C32.6668 119.68 33.106 121.044 33.1075 122.779L33.1053 122.788Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M54.3459 10.7925C11.7497 6.92423 -0.000115907 23.6268 -0.000115907 23.6268V121.181C-0.000115907 121.181 11.7497 104.476 54.3459 108.347V10.7925Z",
        fill: "url(#paint1_linear_54498_42322)"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M8.52051 106.014C44.8578 88.8855 73.4925 106.014 73.4925 106.014V16.2659C73.4925 16.2659 44.8893 -0.857749 8.52051 16.2659V106.014Z",
        fill: "#0B1F31"
    })), /* @__PURE__ */ $acw62.createElement("defs", null, /* @__PURE__ */ $acw62.createElement("linearGradient", {
        id: "paint0_linear_54498_42322",
        x1: 127.8,
        y1: 121.19,
        x2: 127.8,
        y2: 10.218,
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ $acw62.createElement("stop", {
        stopColor: "#8ABF3F"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.36,
        stopColor: "#9EC856"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.9,
        stopColor: "#FFFFF9"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.97,
        stopColor: "white"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 1,
        stopColor: "white"
    })), /* @__PURE__ */ $acw62.createElement("linearGradient", {
        id: "paint1_linear_54498_42322",
        x1: 27.1729,
        y1: 121.181,
        x2: 27.1729,
        y2: 10.2094,
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ $acw62.createElement("stop", {
        stopColor: "#8ABF3F"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.36,
        stopColor: "#9EC856"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.9,
        stopColor: "#FFFFF9"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 0.97,
        stopColor: "white"
    }), /* @__PURE__ */ $acw62.createElement("stop", {
        offset: 1,
        stopColor: "white"
    })))), $0422a6ce4ea03acc$var$lU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 250 134",
        fill: "#000000",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M25.8528 14.8491L0 29.6984L0.0448833 59.5976L0.112208 89.4967L38.7119 111.659C59.9417 123.833 77.4237 133.866 77.5808 133.911C77.8052 134.022 102.917 119.82 103.613 119.195C103.838 118.995 100.853 117.189 91.1131 111.615C84.0664 107.579 78.3214 104.212 78.3214 104.145C78.3214 104.078 84.0889 100.712 91.1131 96.6761L103.905 89.363V59.553V29.7653L78.0745 14.9383C63.8465 6.77792 52.1095 0.0890681 51.9749 0.0667719C51.8402 0.0221795 40.0808 6.68874 25.8528 14.8491ZM64.5646 37.2568C71.4542 41.2032 77.2217 44.5476 77.3788 44.6814C77.5808 44.8821 77.6481 51.0135 77.6032 74.3799L77.5359 103.833L64.9686 96.6092C58.0566 92.6182 52.2666 89.3184 52.132 89.2515C51.9749 89.1846 46.1176 92.4175 39.1158 96.4308C32.0916 100.444 26.3016 103.789 26.1894 103.833C26.0996 103.878 26.0548 90.6115 26.0772 74.3576L26.1445 44.7706L38.9363 37.4352C45.983 33.3996 51.7953 30.0997 51.8851 30.0997C51.9749 30.0997 57.6975 33.3327 64.5646 37.2568Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M136.917 15.0498C135.099 15.5626 133.663 16.4321 132.294 17.8591C127.087 23.2771 129.601 32.3739 136.782 34.2245C138.465 34.6481 140.687 34.6481 142.325 34.2245L143.604 33.89L145.759 35.1163C148.497 36.6548 148.586 36.6771 149.641 36.142C151.391 35.2501 151.167 34.6927 148.452 33.1766L146.365 32.0172L147.128 31.1253C150.045 27.7363 150.18 22.3406 147.442 18.7063C146.365 17.2794 144.659 16.0085 142.998 15.3842C141.315 14.7376 138.555 14.6038 136.917 15.0498ZM142.594 18.1489C143.29 18.4834 144.277 19.2415 144.839 19.8657C148.115 23.4777 147.083 28.8511 142.662 31.1476C141.652 31.6827 141.248 31.7719 139.475 31.7719C137.725 31.7719 137.298 31.6827 136.333 31.1699C133.102 29.4754 131.508 25.8857 132.54 22.6082C133.887 18.3273 138.622 16.2315 142.594 18.1489Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M214.34 15.0275C214.161 15.2282 214.116 17.9929 214.138 24.7709L214.205 34.2245L215.238 34.2914C215.911 34.336 216.36 34.2468 216.517 34.0461C216.696 33.8455 216.809 31.6828 216.831 27.0897L216.898 20.4232L222.576 27.4911C227.985 34.2022 228.321 34.559 229.017 34.559C229.488 34.559 229.802 34.4252 229.892 34.2022C230.094 33.6671 230.049 15.7633 229.825 15.4288C229.713 15.2282 229.264 15.1613 228.546 15.2059L227.446 15.2728L227.334 22.0954L227.222 28.9403L221.499 21.8278C216.629 15.7633 215.687 14.7154 215.193 14.7154C214.856 14.7154 214.475 14.8491 214.34 15.0275Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M240.642 14.9382C237.971 15.4734 236.086 17.5469 236.086 19.9995C236.086 22.3183 237.455 24.102 240.238 25.3951C243.312 26.8221 243.806 27.0897 244.524 27.7808C245.96 29.1186 245.691 30.8577 243.873 31.6604C242.258 32.3961 240.956 32.1509 238.667 30.6347C237.275 29.7206 237.051 29.7429 236.243 30.8131C235.66 31.5935 235.884 32.1732 237.118 33.0204C239.497 34.6258 242.953 35.0717 245.175 34.0238C248.564 32.463 249.461 28.7842 247.127 26.0863C246.544 25.3951 245.601 24.8154 243.133 23.6115C239.587 21.8946 239.003 21.3818 239.003 19.888C239.003 19.1745 239.161 18.8401 239.677 18.305C240.844 17.1679 242.482 17.101 244.726 18.1489C245.377 18.461 246.073 18.7286 246.275 18.7286C246.746 18.7286 247.599 17.2793 247.419 16.7442C247.24 16.1422 245.22 15.2058 243.582 14.9382C242.1 14.693 241.943 14.693 240.642 14.9382Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M155.453 15.2951C155.363 15.3843 155.296 18.5057 155.296 22.2069C155.296 28.5167 155.319 29.0518 155.767 30.2112C156.396 31.8834 157.989 33.4665 159.717 34.113C161.557 34.8042 164.542 34.6704 166.203 33.8455C167.549 33.1543 168.851 31.7719 169.524 30.345C169.973 29.364 169.995 29.0072 169.995 22.2961V15.2728L168.918 15.2059C168.312 15.1613 167.684 15.2505 167.504 15.4066C167.258 15.6072 167.19 16.7889 167.19 22.0508C167.19 28.2492 167.168 28.4721 166.696 29.4308C166.405 29.966 165.799 30.7017 165.328 31.0808C164.609 31.6605 164.228 31.7719 162.971 31.8388C160.996 31.9503 159.74 31.326 158.775 29.7653L158.101 28.6951L157.989 21.9839L157.877 15.2728L156.755 15.2059C156.126 15.1613 155.543 15.2059 155.453 15.2951Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M177.334 15.4288C176.93 15.8301 176.952 33.4218 177.356 33.9569C177.603 34.3136 178.164 34.3359 183.461 34.2913L189.295 34.2244V33.1096V31.9948L184.65 31.9279L179.982 31.8833V28.8734V25.8634L183.977 25.8188L187.949 25.7519V24.6371V23.5223L183.977 23.4554L179.982 23.4108V20.5123V17.6138L184.65 17.5692L189.295 17.5023V16.3875V15.2727L183.461 15.2058C179.107 15.1612 177.536 15.2281 177.334 15.4288Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M195.803 15.4289C195.736 15.585 195.714 19.8882 195.736 24.9717L195.803 34.2246H201.75H207.697V33.1098V31.995L203.052 31.9281L198.384 31.8835V28.8735V25.8635L202.379 25.819L206.351 25.7521V24.6373V23.5224L202.379 23.4556L198.384 23.411V20.5125V17.614L203.052 17.5694L207.697 17.5025V16.3877V15.2729L201.795 15.206C197.195 15.1614 195.871 15.206 195.803 15.4289Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M223.407 57.3011C220.04 57.8362 217.325 59.8875 215.821 63.0536C215.148 64.4582 215.103 64.6812 215.103 67.1338C215.103 69.6532 215.126 69.7424 215.934 71.37C216.966 73.4436 218.672 75.1158 220.759 76.0968C222.217 76.7657 222.419 76.8103 224.978 76.8103C227.558 76.8103 227.738 76.788 229.129 76.0968C230.768 75.2942 232.047 74.2239 232.047 73.6888C232.047 73.176 230.947 72.2396 230.364 72.2396C230.094 72.2396 229.601 72.4403 229.286 72.6855C228.972 72.9308 228.142 73.399 227.424 73.7334C224.955 74.8482 221.656 74.0902 219.794 71.9274C218.425 70.3444 218.021 69.2296 218.021 67.1115C218.021 64.8818 218.47 63.6778 219.883 62.1617C222.262 59.5976 226.212 59.2409 229.107 61.3367C229.623 61.6935 230.207 61.9833 230.453 61.9833C230.857 61.9833 232.047 60.8239 232.047 60.4449C232.047 59.7314 229.668 58.1261 227.783 57.5687C226.616 57.212 224.663 57.1005 223.407 57.3011Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M130.947 57.8139C130.88 57.9477 130.857 62.2509 130.88 67.3344L130.947 76.5873H132.181H133.415L133.483 73.3097L133.55 70.0545L136.512 69.9653C139.699 69.8761 140.44 69.6532 142.011 68.3377C144.546 66.2196 144.546 61.4482 142.011 59.174C140.327 57.6801 139.744 57.5241 135.143 57.5241C132.069 57.5241 131.014 57.591 130.947 57.8139ZM139.16 60.7124C140.485 61.3813 141.27 62.8751 141.046 64.2352C140.844 65.4169 139.609 66.7993 138.51 67.1114C138.038 67.2229 136.737 67.3344 135.615 67.3344H133.528V63.767V60.1996H135.839C137.836 60.1996 138.308 60.2665 139.16 60.7124Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M149.26 57.9477C148.945 58.5274 148.945 68.9621 149.26 70.9018C149.664 73.3767 150.92 75.1381 153.12 76.2975C153.927 76.7434 154.399 76.8103 156.531 76.8103C158.775 76.8103 159.111 76.7657 160.144 76.2083C161.782 75.3611 163.061 73.8226 163.6 72.0612C164.004 70.7903 164.049 69.9877 164.049 64.4359C164.049 61.0246 163.981 58.0815 163.914 57.8809C163.757 57.4572 161.804 57.3903 161.4 57.7917C161.199 57.9923 161.131 59.776 161.131 64.4359C161.131 70.612 161.109 70.8349 160.637 71.7937C160.346 72.3288 159.74 73.0645 159.269 73.4436C157.675 74.6922 154.556 74.4692 153.254 72.9977C152.087 71.6822 152.042 71.4146 151.93 64.3245L151.818 57.6356L150.651 57.5687C149.686 57.5018 149.439 57.5687 149.26 57.9477Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M171.275 57.7916C171.073 57.9922 171.005 60.3779 171.005 67.1337C171.005 74.7589 171.05 76.2305 171.32 76.4758C171.566 76.6541 172.846 76.721 175.987 76.6541C179.937 76.5872 180.408 76.5426 181.239 76.0967C184.605 74.313 185.301 69.8538 182.563 67.6242L181.71 66.9107L182.406 66.0411C183.348 64.8817 183.573 64.2129 183.573 62.6298C183.573 60.9799 183.191 60.0658 182.114 59.0178C180.79 57.747 179.803 57.524 175.382 57.524C172.688 57.524 171.454 57.6132 171.275 57.7916ZM179.466 60.5563C179.803 60.8015 180.251 61.4481 180.431 61.9386C180.723 62.7636 180.723 62.9866 180.431 63.8115C179.87 65.35 179.219 65.6398 176.369 65.729L173.923 65.8182V62.8751V59.932L176.369 60.0212C178.434 60.0881 178.95 60.1773 179.466 60.5563ZM179.69 68.8951C180.7 69.4971 181.149 70.2997 181.149 71.3922C181.127 72.4847 180.588 73.3097 179.511 73.8448C178.927 74.157 178.187 74.2461 176.346 74.2461H173.923V71.3476V68.4491H176.459C178.546 68.4491 179.084 68.516 179.69 68.8951Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M190.575 57.7915C190.148 58.2152 190.193 76.0967 190.619 76.4534C190.821 76.6318 192.46 76.6987 196.05 76.6541L201.19 76.5872V75.4724V74.3576L197.217 74.2907L193.223 74.2461L193.178 65.9296L193.111 57.6355L191.988 57.5686C191.315 57.524 190.754 57.6132 190.575 57.7915Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M206.261 57.9477C205.88 58.6389 205.925 75.8293 206.306 76.3421C206.531 76.6319 206.845 76.7211 207.698 76.6542L208.82 76.5873V67.1115V57.6356L207.653 57.5687C206.688 57.5018 206.441 57.5687 206.261 57.9477Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M201.773 100.266C198.407 107.445 193.671 118.17 193.716 118.504C193.784 118.883 193.986 118.95 195.04 119.017L196.297 119.084L197.307 116.787L198.317 114.491L202.738 114.424L207.136 114.379L208.034 116.319C209.313 119.106 209.156 118.95 210.525 118.95C211.647 118.95 211.737 118.905 211.782 118.393C211.827 118.058 210.233 114.245 207.742 108.805L203.658 99.7752L202.85 99.7084C202.177 99.6415 202.02 99.7306 201.773 100.266ZM204.533 108.426L206.194 112.15H202.828C199.708 112.15 199.461 112.127 199.596 111.748C199.843 111.057 202.76 104.614 202.805 104.658C202.828 104.68 203.591 106.375 204.533 108.426Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M130.947 100.177C130.88 100.31 130.857 104.614 130.88 109.697L130.947 118.95H136.333H141.719V117.835V116.72L137.747 116.654L133.752 116.609V108.515C133.752 102.518 133.685 100.355 133.483 100.154C133.124 99.7976 131.081 99.7976 130.947 100.177Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M146.679 100.243C146.499 100.689 146.499 118.259 146.679 118.705C146.836 119.128 148.788 119.195 149.192 118.794C149.394 118.593 149.461 116.23 149.461 109.563C149.461 104.636 149.394 100.444 149.327 100.243C149.125 99.7307 146.881 99.7307 146.679 100.243Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M156.912 100.154C156.71 100.355 156.643 102.741 156.643 109.496C156.643 117.122 156.688 118.593 156.957 118.838C157.204 119.017 158.483 119.084 161.625 119.017L165.956 118.95L167.19 118.259C170.287 116.52 170.848 112.239 168.268 110.054L167.347 109.273L167.976 108.538C168.896 107.467 169.21 106.553 169.21 105.015C169.21 103.365 168.851 102.428 167.751 101.381C166.427 100.11 165.44 99.8867 161.019 99.8867C158.326 99.8867 157.092 99.9759 156.912 100.154ZM165.103 102.919C165.44 103.164 165.889 103.811 166.068 104.301C166.36 105.126 166.36 105.349 166.068 106.174C165.844 106.776 165.462 107.289 164.969 107.623C164.295 108.069 163.936 108.136 161.894 108.136H159.56V105.215V102.295L162.006 102.384C164.071 102.451 164.587 102.54 165.103 102.919ZM165.148 111.213C167.392 112.35 167.392 115.07 165.148 116.207C164.565 116.52 163.824 116.609 161.984 116.609H159.56V113.71V110.812H161.984C163.824 110.812 164.565 110.901 165.148 111.213Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M176.212 100.154C176.01 100.355 175.943 102.741 175.943 109.496C175.943 117.055 175.988 118.616 176.257 118.816C176.436 118.972 177.065 119.062 177.671 119.017L178.748 118.95L178.815 115.427L178.882 111.927H181.104H183.348L185.144 115.494L186.939 119.062H188.286C190.305 119.062 190.283 118.749 188.106 114.781L186.333 111.525L187.298 110.834C189.251 109.474 190.328 107.133 189.991 104.993C189.812 103.722 188.712 101.849 187.769 101.135C186.333 100.043 185.435 99.8868 180.79 99.8868C177.738 99.8868 176.391 99.976 176.212 100.154ZM184.987 102.874C185.391 103.031 185.996 103.499 186.333 103.878C187.5 105.26 187.343 106.999 185.907 108.382L185.121 109.14L181.979 109.207L178.86 109.296V105.929V102.562H181.553C183.326 102.562 184.515 102.674 184.987 102.874Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M216.697 100.221C216.517 100.689 216.517 118.237 216.697 118.705C216.899 119.218 219.143 119.218 219.345 118.705C219.412 118.504 219.479 116.899 219.479 115.137V111.927H221.679H223.856L225.651 115.45L227.446 118.95H228.77C230.857 118.95 230.857 118.794 228.725 114.914C226.93 111.615 226.93 111.592 227.401 111.258C229.556 109.764 230.543 108.114 230.543 105.907C230.566 104.168 230.005 102.785 228.86 101.626C227.312 100.11 226.863 99.9982 221.589 99.9314C217.37 99.8645 216.831 99.9091 216.697 100.221ZM225.673 102.919C226.616 103.365 227.244 104.145 227.581 105.26C227.805 105.996 227.783 106.219 227.312 107.178C227.02 107.757 226.436 108.471 226.01 108.738C225.314 109.207 224.978 109.251 222.374 109.251H219.479V105.907V102.562H222.195C224.237 102.562 225.09 102.651 225.673 102.919Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M234.179 100.355C233.999 100.89 234.223 101.247 237.926 106.308L240.574 109.942V114.223C240.574 117.278 240.642 118.593 240.844 118.794C241.248 119.195 243.2 119.128 243.357 118.705C243.424 118.504 243.492 116.453 243.492 114.156V109.942L246.746 105.528C250.583 100.355 250.673 100.043 248.631 99.9313L247.352 99.8645L244.726 103.454C243.267 105.438 242.011 106.977 241.943 106.865C241.854 106.776 240.821 105.372 239.677 103.789C236.759 99.753 236.894 99.8868 235.503 99.8868C234.515 99.8868 234.291 99.9536 234.179 100.355Z"
    })), $0422a6ce4ea03acc$var$sU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 250 134",
        fill: "#ffffff",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M25.8528 14.8491L0 29.6984L0.0448833 59.5976L0.112208 89.4967L38.7119 111.659C59.9417 123.833 77.4237 133.866 77.5808 133.911C77.8052 134.022 102.917 119.82 103.613 119.195C103.838 118.995 100.853 117.189 91.1131 111.615C84.0664 107.579 78.3214 104.212 78.3214 104.145C78.3214 104.078 84.0889 100.712 91.1131 96.6761L103.905 89.363V59.553V29.7653L78.0745 14.9383C63.8465 6.77792 52.1095 0.0890681 51.9749 0.0667719C51.8402 0.0221795 40.0808 6.68874 25.8528 14.8491ZM64.5646 37.2568C71.4542 41.2032 77.2217 44.5476 77.3788 44.6814C77.5808 44.8821 77.6481 51.0135 77.6032 74.3799L77.5359 103.833L64.9686 96.6092C58.0566 92.6182 52.2666 89.3184 52.132 89.2515C51.9749 89.1846 46.1176 92.4175 39.1158 96.4308C32.0916 100.444 26.3016 103.789 26.1894 103.833C26.0996 103.878 26.0548 90.6115 26.0772 74.3576L26.1445 44.7706L38.9363 37.4352C45.983 33.3996 51.7953 30.0997 51.8851 30.0997C51.9749 30.0997 57.6975 33.3327 64.5646 37.2568Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M136.917 15.0498C135.099 15.5626 133.663 16.4321 132.294 17.8591C127.087 23.2771 129.601 32.3739 136.782 34.2245C138.465 34.6481 140.687 34.6481 142.325 34.2245L143.604 33.89L145.759 35.1163C148.497 36.6548 148.586 36.6771 149.641 36.142C151.391 35.2501 151.167 34.6927 148.452 33.1766L146.365 32.0172L147.128 31.1253C150.045 27.7363 150.18 22.3406 147.442 18.7063C146.365 17.2794 144.659 16.0085 142.998 15.3842C141.315 14.7376 138.555 14.6038 136.917 15.0498ZM142.594 18.1489C143.29 18.4834 144.277 19.2415 144.839 19.8657C148.115 23.4777 147.083 28.8511 142.662 31.1476C141.652 31.6827 141.248 31.7719 139.475 31.7719C137.725 31.7719 137.298 31.6827 136.333 31.1699C133.102 29.4754 131.508 25.8857 132.54 22.6082C133.887 18.3273 138.622 16.2315 142.594 18.1489Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M214.34 15.0275C214.161 15.2282 214.116 17.9929 214.138 24.7709L214.205 34.2245L215.238 34.2914C215.911 34.336 216.36 34.2468 216.517 34.0461C216.696 33.8455 216.809 31.6828 216.831 27.0897L216.898 20.4232L222.576 27.4911C227.985 34.2022 228.321 34.559 229.017 34.559C229.488 34.559 229.802 34.4252 229.892 34.2022C230.094 33.6671 230.049 15.7633 229.825 15.4288C229.713 15.2282 229.264 15.1613 228.546 15.2059L227.446 15.2728L227.334 22.0954L227.222 28.9403L221.499 21.8278C216.629 15.7633 215.687 14.7154 215.193 14.7154C214.856 14.7154 214.475 14.8491 214.34 15.0275Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M240.642 14.9382C237.971 15.4734 236.086 17.5469 236.086 19.9995C236.086 22.3183 237.455 24.102 240.238 25.3951C243.312 26.8221 243.806 27.0897 244.524 27.7808C245.96 29.1186 245.691 30.8577 243.873 31.6604C242.258 32.3961 240.956 32.1509 238.667 30.6347C237.275 29.7206 237.051 29.7429 236.243 30.8131C235.66 31.5935 235.884 32.1732 237.118 33.0204C239.497 34.6258 242.953 35.0717 245.175 34.0238C248.564 32.463 249.461 28.7842 247.127 26.0863C246.544 25.3951 245.601 24.8154 243.133 23.6115C239.587 21.8946 239.003 21.3818 239.003 19.888C239.003 19.1745 239.161 18.8401 239.677 18.305C240.844 17.1679 242.482 17.101 244.726 18.1489C245.377 18.461 246.073 18.7286 246.275 18.7286C246.746 18.7286 247.599 17.2793 247.419 16.7442C247.24 16.1422 245.22 15.2058 243.582 14.9382C242.1 14.693 241.943 14.693 240.642 14.9382Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M155.453 15.2951C155.363 15.3843 155.296 18.5057 155.296 22.2069C155.296 28.5167 155.319 29.0518 155.767 30.2112C156.396 31.8834 157.989 33.4665 159.717 34.113C161.557 34.8042 164.542 34.6704 166.203 33.8455C167.549 33.1543 168.851 31.7719 169.524 30.345C169.973 29.364 169.995 29.0072 169.995 22.2961V15.2728L168.918 15.2059C168.312 15.1613 167.684 15.2505 167.504 15.4066C167.258 15.6072 167.19 16.7889 167.19 22.0508C167.19 28.2492 167.168 28.4721 166.696 29.4308C166.405 29.966 165.799 30.7017 165.328 31.0808C164.609 31.6605 164.228 31.7719 162.971 31.8388C160.996 31.9503 159.74 31.326 158.775 29.7653L158.101 28.6951L157.989 21.9839L157.877 15.2728L156.755 15.2059C156.126 15.1613 155.543 15.2059 155.453 15.2951Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M177.334 15.4288C176.93 15.8301 176.952 33.4218 177.356 33.9569C177.603 34.3136 178.164 34.3359 183.461 34.2913L189.295 34.2244V33.1096V31.9948L184.65 31.9279L179.982 31.8833V28.8734V25.8634L183.977 25.8188L187.949 25.7519V24.6371V23.5223L183.977 23.4554L179.982 23.4108V20.5123V17.6138L184.65 17.5692L189.295 17.5023V16.3875V15.2727L183.461 15.2058C179.107 15.1612 177.536 15.2281 177.334 15.4288Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M195.803 15.4289C195.736 15.585 195.714 19.8882 195.736 24.9717L195.803 34.2246H201.75H207.697V33.1098V31.995L203.052 31.9281L198.384 31.8835V28.8735V25.8635L202.379 25.819L206.351 25.7521V24.6373V23.5224L202.379 23.4556L198.384 23.411V20.5125V17.614L203.052 17.5694L207.697 17.5025V16.3877V15.2729L201.795 15.206C197.195 15.1614 195.871 15.206 195.803 15.4289Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M223.407 57.3011C220.04 57.8362 217.325 59.8875 215.821 63.0536C215.148 64.4582 215.103 64.6812 215.103 67.1338C215.103 69.6532 215.126 69.7424 215.934 71.37C216.966 73.4436 218.672 75.1158 220.759 76.0968C222.217 76.7657 222.419 76.8103 224.978 76.8103C227.558 76.8103 227.738 76.788 229.129 76.0968C230.768 75.2942 232.047 74.2239 232.047 73.6888C232.047 73.176 230.947 72.2396 230.364 72.2396C230.094 72.2396 229.601 72.4403 229.286 72.6855C228.972 72.9308 228.142 73.399 227.424 73.7334C224.955 74.8482 221.656 74.0902 219.794 71.9274C218.425 70.3444 218.021 69.2296 218.021 67.1115C218.021 64.8818 218.47 63.6778 219.883 62.1617C222.262 59.5976 226.212 59.2409 229.107 61.3367C229.623 61.6935 230.207 61.9833 230.453 61.9833C230.857 61.9833 232.047 60.8239 232.047 60.4449C232.047 59.7314 229.668 58.1261 227.783 57.5687C226.616 57.212 224.663 57.1005 223.407 57.3011Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M130.947 57.8139C130.88 57.9477 130.857 62.2509 130.88 67.3344L130.947 76.5873H132.181H133.415L133.483 73.3097L133.55 70.0545L136.512 69.9653C139.699 69.8761 140.44 69.6532 142.011 68.3377C144.546 66.2196 144.546 61.4482 142.011 59.174C140.327 57.6801 139.744 57.5241 135.143 57.5241C132.069 57.5241 131.014 57.591 130.947 57.8139ZM139.16 60.7124C140.485 61.3813 141.27 62.8751 141.046 64.2352C140.844 65.4169 139.609 66.7993 138.51 67.1114C138.038 67.2229 136.737 67.3344 135.615 67.3344H133.528V63.767V60.1996H135.839C137.836 60.1996 138.308 60.2665 139.16 60.7124Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M149.26 57.9477C148.945 58.5274 148.945 68.9621 149.26 70.9018C149.664 73.3767 150.92 75.1381 153.12 76.2975C153.927 76.7434 154.399 76.8103 156.531 76.8103C158.775 76.8103 159.111 76.7657 160.144 76.2083C161.782 75.3611 163.061 73.8226 163.6 72.0612C164.004 70.7903 164.049 69.9877 164.049 64.4359C164.049 61.0246 163.981 58.0815 163.914 57.8809C163.757 57.4572 161.804 57.3903 161.4 57.7917C161.199 57.9923 161.131 59.776 161.131 64.4359C161.131 70.612 161.109 70.8349 160.637 71.7937C160.346 72.3288 159.74 73.0645 159.269 73.4436C157.675 74.6922 154.556 74.4692 153.254 72.9977C152.087 71.6822 152.042 71.4146 151.93 64.3245L151.818 57.6356L150.651 57.5687C149.686 57.5018 149.439 57.5687 149.26 57.9477Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M171.275 57.7916C171.073 57.9922 171.005 60.3779 171.005 67.1337C171.005 74.7589 171.05 76.2305 171.32 76.4758C171.566 76.6541 172.846 76.721 175.987 76.6541C179.937 76.5872 180.408 76.5426 181.239 76.0967C184.605 74.313 185.301 69.8538 182.563 67.6242L181.71 66.9107L182.406 66.0411C183.348 64.8817 183.573 64.2129 183.573 62.6298C183.573 60.9799 183.191 60.0658 182.114 59.0178C180.79 57.747 179.803 57.524 175.382 57.524C172.688 57.524 171.454 57.6132 171.275 57.7916ZM179.466 60.5563C179.803 60.8015 180.251 61.4481 180.431 61.9386C180.723 62.7636 180.723 62.9866 180.431 63.8115C179.87 65.35 179.219 65.6398 176.369 65.729L173.923 65.8182V62.8751V59.932L176.369 60.0212C178.434 60.0881 178.95 60.1773 179.466 60.5563ZM179.69 68.8951C180.7 69.4971 181.149 70.2997 181.149 71.3922C181.127 72.4847 180.588 73.3097 179.511 73.8448C178.927 74.157 178.187 74.2461 176.346 74.2461H173.923V71.3476V68.4491H176.459C178.546 68.4491 179.084 68.516 179.69 68.8951Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M190.575 57.7915C190.148 58.2152 190.193 76.0967 190.619 76.4534C190.821 76.6318 192.46 76.6987 196.05 76.6541L201.19 76.5872V75.4724V74.3576L197.217 74.2907L193.223 74.2461L193.178 65.9296L193.111 57.6355L191.988 57.5686C191.315 57.524 190.754 57.6132 190.575 57.7915Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M206.261 57.9477C205.88 58.6389 205.925 75.8293 206.306 76.3421C206.531 76.6319 206.845 76.7211 207.698 76.6542L208.82 76.5873V67.1115V57.6356L207.653 57.5687C206.688 57.5018 206.441 57.5687 206.261 57.9477Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M201.773 100.266C198.407 107.445 193.671 118.17 193.716 118.504C193.784 118.883 193.986 118.95 195.04 119.017L196.297 119.084L197.307 116.787L198.317 114.491L202.738 114.424L207.136 114.379L208.034 116.319C209.313 119.106 209.156 118.95 210.525 118.95C211.647 118.95 211.737 118.905 211.782 118.393C211.827 118.058 210.233 114.245 207.742 108.805L203.658 99.7752L202.85 99.7084C202.177 99.6415 202.02 99.7306 201.773 100.266ZM204.533 108.426L206.194 112.15H202.828C199.708 112.15 199.461 112.127 199.596 111.748C199.843 111.057 202.76 104.614 202.805 104.658C202.828 104.68 203.591 106.375 204.533 108.426Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M130.947 100.177C130.88 100.31 130.857 104.614 130.88 109.697L130.947 118.95H136.333H141.719V117.835V116.72L137.747 116.654L133.752 116.609V108.515C133.752 102.518 133.685 100.355 133.483 100.154C133.124 99.7976 131.081 99.7976 130.947 100.177Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M146.679 100.243C146.499 100.689 146.499 118.259 146.679 118.705C146.836 119.128 148.788 119.195 149.192 118.794C149.394 118.593 149.461 116.23 149.461 109.563C149.461 104.636 149.394 100.444 149.327 100.243C149.125 99.7307 146.881 99.7307 146.679 100.243Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M156.912 100.154C156.71 100.355 156.643 102.741 156.643 109.496C156.643 117.122 156.688 118.593 156.957 118.838C157.204 119.017 158.483 119.084 161.625 119.017L165.956 118.95L167.19 118.259C170.287 116.52 170.848 112.239 168.268 110.054L167.347 109.273L167.976 108.538C168.896 107.467 169.21 106.553 169.21 105.015C169.21 103.365 168.851 102.428 167.751 101.381C166.427 100.11 165.44 99.8867 161.019 99.8867C158.326 99.8867 157.092 99.9759 156.912 100.154ZM165.103 102.919C165.44 103.164 165.889 103.811 166.068 104.301C166.36 105.126 166.36 105.349 166.068 106.174C165.844 106.776 165.462 107.289 164.969 107.623C164.295 108.069 163.936 108.136 161.894 108.136H159.56V105.215V102.295L162.006 102.384C164.071 102.451 164.587 102.54 165.103 102.919ZM165.148 111.213C167.392 112.35 167.392 115.07 165.148 116.207C164.565 116.52 163.824 116.609 161.984 116.609H159.56V113.71V110.812H161.984C163.824 110.812 164.565 110.901 165.148 111.213Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M176.212 100.154C176.01 100.355 175.943 102.741 175.943 109.496C175.943 117.055 175.988 118.616 176.257 118.816C176.436 118.972 177.065 119.062 177.671 119.017L178.748 118.95L178.815 115.427L178.882 111.927H181.104H183.348L185.144 115.494L186.939 119.062H188.286C190.305 119.062 190.283 118.749 188.106 114.781L186.333 111.525L187.298 110.834C189.251 109.474 190.328 107.133 189.991 104.993C189.812 103.722 188.712 101.849 187.769 101.135C186.333 100.043 185.435 99.8868 180.79 99.8868C177.738 99.8868 176.391 99.976 176.212 100.154ZM184.987 102.874C185.391 103.031 185.996 103.499 186.333 103.878C187.5 105.26 187.343 106.999 185.907 108.382L185.121 109.14L181.979 109.207L178.86 109.296V105.929V102.562H181.553C183.326 102.562 184.515 102.674 184.987 102.874Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M216.697 100.221C216.517 100.689 216.517 118.237 216.697 118.705C216.899 119.218 219.143 119.218 219.345 118.705C219.412 118.504 219.479 116.899 219.479 115.137V111.927H221.679H223.856L225.651 115.45L227.446 118.95H228.77C230.857 118.95 230.857 118.794 228.725 114.914C226.93 111.615 226.93 111.592 227.401 111.258C229.556 109.764 230.543 108.114 230.543 105.907C230.566 104.168 230.005 102.785 228.86 101.626C227.312 100.11 226.863 99.9982 221.589 99.9314C217.37 99.8645 216.831 99.9091 216.697 100.221ZM225.673 102.919C226.616 103.365 227.244 104.145 227.581 105.26C227.805 105.996 227.783 106.219 227.312 107.178C227.02 107.757 226.436 108.471 226.01 108.738C225.314 109.207 224.978 109.251 222.374 109.251H219.479V105.907V102.562H222.195C224.237 102.562 225.09 102.651 225.673 102.919Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M234.179 100.355C233.999 100.89 234.223 101.247 237.926 106.308L240.574 109.942V114.223C240.574 117.278 240.642 118.593 240.844 118.794C241.248 119.195 243.2 119.128 243.357 118.705C243.424 118.504 243.492 116.453 243.492 114.156V109.942L246.746 105.528C250.583 100.355 250.673 100.043 248.631 99.9313L247.352 99.8645L244.726 103.454C243.267 105.438 242.011 106.977 241.943 106.865C241.854 106.776 240.821 105.372 239.677 103.789C236.759 99.753 236.894 99.8868 235.503 99.8868C234.515 99.8868 234.291 99.9536 234.179 100.355Z"
    })), $0422a6ce4ea03acc$var$uU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 320 43",
        fill: "#000000",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M32.4615 9.32237V27.9653L24.3461 32.6256V13.9827L16.2317 9.32237L8.11628 13.9827V32.6247L0 27.9644V9.32327L8.11628 4.66028L16.2299 0H16.2317L24.347 4.66028L32.4624 9.32057L32.4615 9.32237ZM8.11448 32.6256L16.2308 27.9644L24.3461 32.6256L32.4624 37.2859L24.3461 41.9461L16.2308 37.2859L8.11448 32.6256Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.11475 32.6259L24.3379 41.9464L32.4505 37.2855L16.2252 27.9642L8.11475 32.6259Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.3379 13.9821V32.6259L32.4506 27.9649V9.32178L24.3379 13.9821Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 27.9652L8.11268 32.6248V13.9823L0 9.32202V27.9652Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M-0.000244141 9.32215L8.11581 13.9824L16.2252 9.32215L24.3379 13.9824L32.4506 9.32215L16.2252 0.000244141L-0.000244141 9.32215Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M59.4432 28.6711C59.5614 28.7267 59.6617 28.8142 59.733 28.9236C59.8042 29.033 59.8436 29.1601 59.8467 29.2907C59.8498 29.4212 59.8165 29.5501 59.7504 29.6627C59.6844 29.7754 59.5883 29.8675 59.4729 29.9286L58.7013 30.3658C58.4201 30.528 58.046 30.4848 57.7873 30.3306L54.499 28.4674C53.5994 28.837 52.5925 29.0299 51.4883 29.0299C47.3535 29.0299 44.0643 25.7587 44.0643 21.6465C44.0603 20.6704 44.2497 19.7033 44.6214 18.8008C44.9931 17.8983 45.5398 17.0783 46.2299 16.3881C46.9201 15.698 47.7401 15.1513 48.6426 14.7796C49.5451 14.4079 50.5122 14.2185 51.4883 14.2225C52.4654 14.2181 53.4338 14.4069 54.3376 14.7782C55.2415 15.1495 56.063 15.6958 56.755 16.3858C57.4469 17.0758 57.9955 17.8958 58.3693 18.7986C58.7431 19.7015 58.9347 20.6693 58.933 21.6465C58.933 23.5791 58.1073 25.6469 56.6371 27.0693L59.4432 28.6711V28.6711ZM149.303 21.7222C150.009 21.7198 150.686 21.4377 151.185 20.9377C151.683 20.4376 151.964 19.7603 151.965 19.054C151.965 17.6821 150.769 16.5842 149.303 16.5842H146.502V21.7222H149.303ZM146.502 28.1258C146.498 28.3132 146.422 28.4918 146.289 28.6239C146.156 28.7561 145.977 28.8315 145.79 28.8343H145.04C144.947 28.8347 144.854 28.8166 144.768 28.7812C144.681 28.7458 144.603 28.6936 144.537 28.6278C144.47 28.562 144.418 28.4838 144.382 28.3977C144.346 28.3115 144.327 28.2191 144.327 28.1258V15.1266C144.327 14.7408 144.64 14.4181 145.039 14.4181H149.401C152.012 14.4181 154.16 16.5292 154.16 19.0919C154.16 21.7069 152.022 23.8477 149.422 23.8477H146.502V28.1249V28.1258ZM157.882 15.1266C157.882 14.7444 158.211 14.4181 158.595 14.4181H159.344C159.745 14.4181 160.058 14.7408 160.058 15.1266V23.3141C160.058 25.463 161.396 26.9648 163.431 26.9648C165.495 26.9648 166.842 25.4901 166.842 23.3537V15.1275C166.842 14.7417 167.156 14.419 167.555 14.419H168.306C168.69 14.419 169.018 14.7453 169.018 15.1275V23.4322C169.018 26.6511 166.688 29.0317 163.43 29.0317C160.193 29.0317 157.882 26.652 157.882 23.4322V15.1275V15.1266ZM179.195 20.5819C180.453 20.5819 181.224 19.7346 181.224 18.4654C181.224 17.1989 180.49 16.4453 179.195 16.4453H176.315V20.5828H179.195V20.5819ZM179.531 26.8458C180.773 26.8458 181.68 25.9291 181.68 24.6887C181.68 23.5205 180.592 22.6101 179.195 22.6101H176.276V26.8458H179.53H179.531ZM184.012 24.7076C184.012 27.118 182.08 28.8343 179.372 28.8343H174.872C174.779 28.8344 174.686 28.8161 174.6 28.7805C174.514 28.7449 174.435 28.6926 174.369 28.6266C174.303 28.5607 174.25 28.4823 174.215 28.3961C174.179 28.3098 174.16 28.2174 174.16 28.124V15.1266C174.16 14.7417 174.473 14.419 174.872 14.419H179.195C181.748 14.419 183.579 16.0821 183.579 18.3671C183.579 19.6228 182.939 20.7288 181.986 21.4608C183.212 22.1341 184.012 23.2221 184.012 24.7085V24.7076ZM196.006 26.8458C196.406 26.8458 196.72 27.1685 196.72 27.5543V28.1249C196.719 28.2184 196.701 28.311 196.665 28.3973C196.629 28.4836 196.576 28.5619 196.51 28.6279C196.443 28.6939 196.365 28.7461 196.278 28.7817C196.192 28.8172 196.099 28.8354 196.006 28.8352H189.177C188.988 28.8352 188.807 28.7604 188.674 28.6273C188.54 28.4941 188.465 28.3134 188.465 28.1249V15.1266C188.465 14.7417 188.778 14.419 189.177 14.419H189.947C190.331 14.419 190.659 14.7453 190.659 15.1275V26.8458H196.006ZM200.125 15.1266C200.125 14.7453 200.454 14.4181 200.837 14.4181H201.628C202.012 14.4181 202.342 14.7444 202.342 15.1266V28.1249C202.338 28.3126 202.261 28.4914 202.128 28.6237C201.995 28.756 201.815 28.8315 201.628 28.8343H200.837C200.65 28.8311 200.471 28.7552 200.338 28.6228C200.205 28.4903 200.129 28.3115 200.125 28.124V15.1266ZM214.119 14.2225C216.068 14.2225 217.596 14.8399 219.136 16.1461C219.424 16.4345 219.446 16.8807 219.155 17.1719L218.647 17.674C218.355 18.0372 217.966 18.0147 217.648 17.6992C216.65 16.8384 215.32 16.3083 214.1 16.3083C211.224 16.3083 208.931 18.7097 208.931 21.6266C208.931 24.5265 211.228 26.9251 214.1 26.9251C215.472 26.9251 216.286 26.5573 217.658 25.5261C217.949 25.2963 218.268 25.2755 218.569 25.4793L219.14 25.9913C219.474 26.2418 219.435 26.7502 219.151 27.0324C217.786 28.3493 216.023 29.0317 214.119 29.0317C209.978 29.0317 206.656 25.7515 206.656 21.6465C206.656 17.5342 209.986 14.2225 214.119 14.2225V14.2225ZM238.992 26.8467C239.392 26.8467 239.706 27.1694 239.706 27.5552V28.1249C239.706 28.2184 239.687 28.311 239.651 28.3973C239.615 28.4836 239.562 28.5619 239.496 28.6279C239.43 28.6939 239.351 28.7461 239.265 28.7817C239.178 28.8172 239.086 28.8354 238.992 28.8352H232.163C232.07 28.8354 231.977 28.8172 231.891 28.7816C231.804 28.7461 231.726 28.6938 231.66 28.6278C231.593 28.5618 231.541 28.4834 231.505 28.3971C231.469 28.3108 231.451 28.2183 231.451 28.1249V15.1266C231.451 14.7417 231.763 14.419 232.163 14.419H232.934C233.317 14.419 233.646 14.7462 233.646 15.1275V26.8458H238.992V26.8467ZM243.111 15.1275C243.111 14.7453 243.44 14.419 243.824 14.419H244.612C244.997 14.419 245.326 14.7453 245.326 15.1275V28.1249C245.322 28.3126 245.246 28.4914 245.113 28.6237C244.979 28.756 244.8 28.8315 244.612 28.8343H243.824C243.636 28.8313 243.457 28.7555 243.324 28.623C243.191 28.4905 243.115 28.3116 243.111 28.124V15.1266V15.1275ZM255.683 20.5828C256.942 20.5828 257.713 19.7355 257.713 18.4663C257.713 17.1998 256.979 16.4462 255.683 16.4462H252.803V20.5837H255.683V20.5828ZM256.019 26.8467C257.261 26.8467 258.168 25.93 258.168 24.6896C258.168 23.5214 257.08 22.611 255.683 22.611H252.765V26.8467H256.019V26.8467ZM260.501 24.7085C260.501 27.1189 258.568 28.8352 255.86 28.8352H251.361C251.268 28.8354 251.175 28.8172 251.089 28.7817C251.002 28.7461 250.923 28.6939 250.857 28.6279C250.791 28.5619 250.738 28.4836 250.702 28.3973C250.666 28.311 250.647 28.2184 250.647 28.1249V15.1266C250.647 14.7417 250.961 14.419 251.361 14.419H255.683C258.237 14.419 260.068 16.0821 260.068 18.3671C260.068 19.6228 259.428 20.7288 258.474 21.4608C259.7 22.1341 260.501 23.2221 260.501 24.7085V24.7085ZM270.679 21.4869C272.039 21.4869 273.183 20.3538 273.183 18.9567C273.183 17.6559 272.019 16.5247 270.679 16.5247H267.188V21.4869H270.679ZM267.15 28.1249C267.146 28.3122 267.07 28.4906 266.937 28.6228C266.804 28.7549 266.625 28.8304 266.438 28.8334H265.667C265.574 28.8337 265.482 28.8157 265.395 28.7803C265.309 28.7448 265.23 28.6927 265.164 28.6269C265.098 28.5611 265.045 28.4829 265.009 28.3968C264.973 28.3106 264.955 28.2182 264.954 28.1249V15.1266C264.954 14.7399 265.267 14.4181 265.667 14.4181H270.778C273.345 14.4181 275.42 16.4228 275.42 18.9359C275.42 20.7189 274.329 22.2892 272.632 23.1022L275.163 27.7688C275.425 28.2556 275.115 28.8334 274.528 28.8334H273.522C273.396 28.8371 273.271 28.8053 273.162 28.7416C273.053 28.6778 272.964 28.5847 272.905 28.4728L270.374 23.4547H267.15V28.1249ZM286.037 20.7405C285.461 19.4443 285.141 18.7277 284.828 18.0327L282.387 23.488H287.265C286.947 22.7813 286.625 22.062 286.037 20.7405V20.7405ZM284.111 14.6209C284.167 14.4996 284.257 14.3973 284.37 14.3264C284.483 14.2554 284.614 14.219 284.748 14.2216H284.946C285.243 14.2216 285.46 14.3784 285.589 14.6362L291.55 27.8464C291.772 28.3268 291.446 28.8343 290.906 28.8343H290.116C289.98 28.8363 289.846 28.7979 289.732 28.724C289.617 28.65 289.527 28.5438 289.473 28.4187L288.103 25.3783H281.534L280.187 28.407C280.133 28.5348 280.043 28.6436 279.927 28.7197C279.811 28.7958 279.675 28.8357 279.536 28.8343H278.748C278.209 28.8343 277.882 28.3277 278.104 27.8482L284.111 14.6209V14.6209ZM300.75 21.486C302.11 21.486 303.253 20.3529 303.253 18.9558C303.253 17.655 302.089 16.5238 300.75 16.5238H297.259V21.486H300.75ZM297.219 28.1249C297.215 28.3123 297.138 28.4908 297.006 28.623C296.873 28.7552 296.694 28.8306 296.506 28.8334H295.736C295.642 28.8337 295.55 28.8157 295.463 28.7803C295.377 28.7448 295.299 28.6927 295.232 28.6269C295.166 28.5611 295.113 28.4829 295.078 28.3968C295.042 28.3106 295.023 28.2182 295.023 28.1249V15.1266C295.023 14.7408 295.336 14.4181 295.735 14.4181H300.848C303.414 14.4181 305.489 16.4228 305.489 18.9359C305.489 20.718 304.397 22.2892 302.701 23.1022L305.232 27.7697C305.493 28.2565 305.183 28.8334 304.597 28.8334H303.591C303.464 28.8375 303.339 28.8059 303.23 28.7421C303.121 28.6783 303.032 28.585 302.973 28.4728L300.443 23.4547H297.219V28.1249V28.1249ZM308.115 15.4998C308.045 15.393 308.005 15.2691 308.001 15.1414C307.996 15.0138 308.027 14.8873 308.089 14.7758C308.151 14.6643 308.243 14.572 308.354 14.5089C308.465 14.4458 308.591 14.4144 308.719 14.4181H309.645C309.886 14.4181 310.095 14.5506 310.235 14.7336L313.949 19.8355L317.665 14.7291C317.732 14.6357 317.82 14.559 317.922 14.5051C318.023 14.4511 318.136 14.4214 318.251 14.4181H319.18C319.758 14.4181 320.081 15.0175 319.768 15.5223L315.017 21.9719V28.1249C315.013 28.3126 314.937 28.4917 314.804 28.6242C314.671 28.7568 314.492 28.8324 314.304 28.8352H313.533C313.44 28.8354 313.347 28.8172 313.261 28.7816C313.174 28.7461 313.096 28.6938 313.03 28.6278C312.964 28.5618 312.911 28.4834 312.875 28.3971C312.839 28.3108 312.821 28.2183 312.821 28.1249V21.9908L308.115 15.5007V15.4998ZM63.0885 15.1707C63.0885 14.7894 63.4166 14.4631 63.8006 14.4631H64.5506C64.9517 14.4631 65.2645 14.7849 65.2645 15.1707V23.3591C65.2645 25.5081 66.6022 27.0098 68.6376 27.0098C70.7009 27.0098 72.0494 25.5351 72.0494 23.3988V15.1707C72.0494 14.7849 72.3622 14.4631 72.7615 14.4631H73.5124C73.8964 14.4631 74.2245 14.7894 74.2245 15.1707V23.4772C74.2245 26.6953 71.8953 29.075 68.6376 29.075C65.3988 29.075 63.0885 26.6962 63.0885 23.4772V15.1707V15.1707ZM87.8556 26.89C88.2558 26.89 88.5695 27.2127 88.5695 27.5994V28.1691C88.5688 28.3578 88.4932 28.5385 88.3593 28.6715C88.2255 28.8045 88.0443 28.8789 87.8556 28.8785H80.0791C79.9858 28.8787 79.8933 28.8605 79.807 28.825C79.7206 28.7895 79.6422 28.7373 79.576 28.6714C79.5099 28.6055 79.4574 28.5272 79.4215 28.441C79.3857 28.3548 79.3671 28.2624 79.367 28.1691V15.1707C79.367 14.7849 79.6789 14.4631 80.0791 14.4631H87.8556C88.2549 14.4631 88.5695 14.7849 88.5695 15.1707V15.7404C88.5693 15.834 88.5506 15.9265 88.5146 16.0128C88.4786 16.0991 88.426 16.1775 88.3597 16.2434C88.2934 16.3094 88.2147 16.3617 88.1282 16.3972C88.0418 16.4328 87.9491 16.451 87.8556 16.4507H81.562V20.5693H86.8893C87.2724 20.5693 87.6014 20.8965 87.6014 21.2769V21.8466C87.6014 22.245 87.2769 22.556 86.8893 22.556H81.562V26.89H87.8556ZM101.509 26.89C101.909 26.89 102.223 27.2127 102.223 27.5994V28.1691C102.222 28.3578 102.147 28.5385 102.013 28.6715C101.879 28.8045 101.698 28.8789 101.509 28.8785H93.7319C93.6385 28.8787 93.546 28.8605 93.4597 28.825C93.3734 28.7895 93.2949 28.7373 93.2288 28.6714C93.1626 28.6055 93.1101 28.5272 93.0743 28.441C93.0384 28.3548 93.0199 28.2624 93.0198 28.1691V15.1707C93.0198 14.7858 93.3326 14.4631 93.7319 14.4631H101.509C101.909 14.4631 102.223 14.7849 102.223 15.1707V15.7404C102.223 15.834 102.204 15.9265 102.168 16.0128C102.132 16.0991 102.08 16.1775 102.013 16.2434C101.947 16.3094 101.868 16.3617 101.782 16.3972C101.695 16.4328 101.603 16.451 101.509 16.4507H95.2147V20.5693H100.542C100.926 20.5693 101.255 20.8965 101.255 21.2769V21.8466C101.255 22.245 100.931 22.556 100.543 22.556H95.2156V26.89H101.509V26.89ZM108.79 28.17C108.79 28.2632 108.771 28.3556 108.735 28.4416C108.699 28.5277 108.647 28.6059 108.581 28.6717C108.514 28.7375 108.436 28.7896 108.35 28.8251C108.263 28.8606 108.171 28.8787 108.078 28.8785H107.386C107.199 28.8757 107.02 28.8001 106.887 28.6678C106.754 28.5354 106.678 28.3566 106.674 28.1691V14.9562C106.674 14.5713 107.003 14.2666 107.386 14.2666H107.718C107.924 14.2666 108.117 14.3595 108.245 14.519L116.483 24.7284V15.1716C116.483 14.7867 116.796 14.4631 117.196 14.4631H117.887C118.271 14.4631 118.601 14.7903 118.601 15.1716V28.3863C118.601 28.7703 118.27 29.0759 117.887 29.0759H117.695C117.594 29.0758 117.494 29.0531 117.403 29.0094C117.311 28.9658 117.231 28.9022 117.168 28.8235L108.79 18.4212V28.17ZM123.082 26.3004L123.109 26.2644C123.145 26.2193 123.177 26.1796 123.248 26.0886C123.325 25.9894 123.359 25.9462 123.395 25.9047C123.735 25.4612 124.147 25.3098 124.575 25.6767L124.682 25.7704C124.942 25.9987 125.221 26.2052 125.516 26.3879C126.223 26.8269 126.96 27.0865 127.69 27.0865C129.051 27.0865 129.997 26.2761 129.997 25.262C129.997 24.1902 129.128 23.4592 126.746 22.4694C124.078 21.3102 123.068 20.2664 123.068 18.0967C123.068 16.074 124.754 14.2666 127.611 14.2666C128.486 14.2725 129.35 14.4514 130.155 14.7931C130.432 14.9084 130.681 15.031 130.899 15.1554C131.032 15.2302 131.127 15.2906 131.139 15.3033C131.513 15.4907 131.699 15.9631 131.387 16.4571C131.358 16.5003 131.333 16.5391 131.277 16.6292L131.275 16.6346C131.235 16.6988 131.195 16.7622 131.153 16.8248C130.874 17.2593 130.476 17.3729 130.013 17.1133C130.005 17.1097 129.827 17.0024 129.738 16.951C129.566 16.8519 129.39 16.7601 129.21 16.6761C128.683 16.4309 128.168 16.2777 127.701 16.256C127.665 16.2543 127.628 16.2534 127.592 16.2533C126.015 16.2533 125.206 17.0962 125.206 18.0769C125.206 19.1189 125.933 19.8193 127.659 20.535C130.976 21.8781 132.253 22.9995 132.253 25.2043C132.253 27.4056 130.187 29.075 127.651 29.075C126.601 29.072 125.567 28.8169 124.637 28.3313C124.14 28.0829 123.679 27.7704 123.264 27.402L123.222 27.3659C122.893 27.0756 122.799 26.7439 123.082 26.3004V26.3004ZM51.4883 26.9837C54.4449 26.9837 56.8733 24.5787 56.8733 21.6465C56.8733 18.7061 54.4359 16.2687 51.4883 16.2687C48.5443 16.2687 46.1231 18.7025 46.1231 21.6465C46.1231 24.5823 48.5362 26.9828 51.4883 26.9828V26.9837Z"
    })), $0422a6ce4ea03acc$var$cU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 355 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M36.012 11.0161V31.6981L27.009 36.8681V16.1861L18.007 11.0161L9.004 16.1861V36.8671L0 31.6971V11.0171L9.004 5.84407L18.005 0.674072H18.007L27.01 5.84407L36.013 11.0141L36.012 11.0161ZM9.002 36.8681L18.006 31.6971L27.009 36.8681L36.013 42.0381L27.009 47.2081L18.006 42.0381L9.002 36.8681Z",
        fill: "#4B2D83"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.00293 36.8685L27.0005 47.2085L36.0005 42.0378L18.0005 31.697L9.00293 36.8685Z",
        fill: "#422980"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27 16.1854V36.8684L36 31.6976V11.0154L27 16.1854Z",
        fill: "#5C3296"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 31.6979L9 36.8671V16.1856L0 11.0156V31.6979Z",
        fill: "#282561"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 11.0158L9.00375 16.1858L18.0002 11.0158L27.0002 16.1858L36.0001 11.0158L18.0002 0.674316L0 11.0158Z",
        fill: "#422980"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M65.9449 32.4811C66.0759 32.5428 66.1872 32.6397 66.2663 32.7611C66.3454 32.8825 66.3891 33.0235 66.3925 33.1684C66.3959 33.3132 66.3589 33.4561 66.2857 33.5811C66.2125 33.7061 66.1059 33.8082 65.9779 33.8761L65.1219 34.3611C64.8099 34.5411 64.3949 34.4931 64.1079 34.3221L60.4599 32.2551C59.4619 32.6651 58.3449 32.8791 57.1199 32.8791C52.5329 32.8791 48.8839 29.2501 48.8839 24.6881C48.8795 23.6053 49.0895 22.5323 49.5019 21.5311C49.9142 20.5299 50.5207 19.6203 51.2864 18.8546C52.052 18.0889 52.9617 17.4825 53.9629 17.0701C54.9641 16.6578 56.0371 16.4477 57.1199 16.4521C58.2039 16.4472 59.2782 16.6567 60.2809 17.0686C61.2836 17.4805 62.195 18.0866 62.9626 18.8521C63.7302 19.6175 64.3388 20.5272 64.7535 21.5288C65.1682 22.5303 65.3807 23.604 65.3789 24.6881C65.3789 26.8321 64.4629 29.1261 62.8319 30.7041L65.9449 32.4811ZM165.633 24.7721C166.416 24.7694 167.167 24.4565 167.72 23.9018C168.274 23.347 168.585 22.5957 168.586 21.8121C168.586 20.2901 167.26 19.0721 165.633 19.0721H162.526V24.7721H165.633ZM162.526 31.8761C162.522 32.0839 162.437 32.2821 162.29 32.4287C162.142 32.5753 161.944 32.659 161.736 32.6621H160.904C160.8 32.6625 160.698 32.6424 160.602 32.6031C160.506 32.5638 160.419 32.506 160.345 32.433C160.272 32.36 160.214 32.2733 160.174 32.1777C160.134 32.0821 160.113 31.9796 160.113 31.8761V17.4551C160.113 17.0271 160.46 16.6691 160.903 16.6691H165.742C168.638 16.6691 171.022 19.0111 171.022 21.8541C171.022 24.7551 168.65 27.1301 165.765 27.1301H162.526V31.8751V31.8761ZM175.15 17.4551C175.15 17.0311 175.515 16.6691 175.941 16.6691H176.773C177.217 16.6691 177.564 17.0271 177.564 17.4551V26.5381C177.564 28.9221 179.049 30.5881 181.306 30.5881C183.596 30.5881 185.091 28.9521 185.091 26.5821V17.4561C185.091 17.0281 185.439 16.6701 185.881 16.6701H186.715C187.141 16.6701 187.505 17.0321 187.505 17.4561V26.6691C187.505 30.2401 184.92 32.8811 181.305 32.8811C177.714 32.8811 175.15 30.2411 175.15 26.6691V17.4561V17.4551ZM198.795 23.5071C200.19 23.5071 201.046 22.5671 201.046 21.1591C201.046 19.7541 200.231 18.9181 198.795 18.9181H195.6V23.5081H198.795V23.5071ZM199.167 30.4561C200.545 30.4561 201.551 29.4391 201.551 28.0631C201.551 26.7671 200.344 25.7571 198.795 25.7571H195.556V30.4561H199.166H199.167ZM204.139 28.0841C204.139 30.7581 201.995 32.6621 198.991 32.6621H193.999C193.895 32.6622 193.793 32.6419 193.697 32.6024C193.601 32.5629 193.514 32.5049 193.441 32.4317C193.367 32.3585 193.309 32.2716 193.269 32.1759C193.23 32.0803 193.209 31.9777 193.209 31.8741V17.4551C193.209 17.0281 193.556 16.6701 193.999 16.6701H198.795C201.627 16.6701 203.658 18.5151 203.658 21.0501C203.658 22.4431 202.948 23.6701 201.891 24.4821C203.251 25.2291 204.139 26.4361 204.139 28.0851V28.0841ZM217.444 30.4561C217.888 30.4561 218.236 30.8141 218.236 31.2421V31.8751C218.236 31.9788 218.215 32.0815 218.175 32.1772C218.135 32.273 218.077 32.3599 218.003 32.4331C217.93 32.5063 217.842 32.5642 217.746 32.6037C217.65 32.6432 217.548 32.6633 217.444 32.6631H209.868C209.659 32.6631 209.458 32.5801 209.31 32.4324C209.162 32.2847 209.078 32.0842 209.078 31.8751V17.4551C209.078 17.0281 209.426 16.6701 209.868 16.6701H210.723C211.149 16.6701 211.513 17.0321 211.513 17.4561V30.4561H217.444ZM222.014 17.4551C222.014 17.0321 222.379 16.6691 222.804 16.6691H223.681C224.107 16.6691 224.473 17.0311 224.473 17.4551V31.8751C224.468 32.0833 224.383 32.2817 224.236 32.4285C224.088 32.5753 223.889 32.659 223.681 32.6621H222.804C222.596 32.6585 222.397 32.5744 222.25 32.4274C222.103 32.2805 222.018 32.0821 222.014 31.8741V17.4551ZM237.539 16.4521C239.701 16.4521 241.396 17.1371 243.104 18.5861C243.424 18.9061 243.448 19.4011 243.125 19.7241L242.562 20.2811C242.238 20.6841 241.806 20.6591 241.453 20.3091C240.346 19.3541 238.871 18.7661 237.517 18.7661C234.327 18.7661 231.783 21.4301 231.783 24.6661C231.783 27.8831 234.331 30.5441 237.517 30.5441C239.04 30.5441 239.942 30.1361 241.465 28.9921C241.787 28.7371 242.141 28.7141 242.475 28.9401L243.109 29.5081C243.479 29.7861 243.436 30.3501 243.121 30.6631C241.607 32.1241 239.651 32.8811 237.539 32.8811C232.945 32.8811 229.259 29.2421 229.259 24.6881C229.259 20.1261 232.953 16.4521 237.539 16.4521ZM265.132 30.4571C265.576 30.4571 265.924 30.8151 265.924 31.2431V31.8751C265.924 31.9788 265.903 32.0815 265.863 32.1772C265.823 32.273 265.765 32.3599 265.691 32.4331C265.618 32.5063 265.53 32.5642 265.434 32.6037C265.338 32.6432 265.236 32.6633 265.132 32.6631H257.556C257.452 32.6633 257.35 32.6431 257.254 32.6037C257.158 32.5642 257.071 32.5062 256.997 32.433C256.924 32.3598 256.866 32.2728 256.826 32.1771C256.786 32.0813 256.766 31.9787 256.766 31.8751V17.4551C256.766 17.0281 257.112 16.6701 257.556 16.6701H258.411C258.836 16.6701 259.201 17.0331 259.201 17.4561V30.4561H265.132V30.4571ZM269.702 17.4561C269.702 17.0321 270.066 16.6701 270.492 16.6701H271.367C271.794 16.6701 272.159 17.0321 272.159 17.4561V31.8751C272.154 32.0833 272.069 32.2817 271.922 32.4285C271.774 32.5753 271.575 32.659 271.367 32.6621H270.492C270.284 32.6587 270.085 32.5747 269.938 32.4277C269.79 32.2807 269.706 32.0822 269.702 31.8741V17.4551V17.4561ZM283.649 23.5081C285.045 23.5081 285.901 22.5681 285.901 21.1601C285.901 19.7551 285.086 18.9191 283.649 18.9191H280.454V23.5091H283.649V23.5081ZM284.021 30.4571C285.399 30.4571 286.405 29.4401 286.405 28.0641C286.405 26.7681 285.198 25.7581 283.649 25.7581H280.411V30.4571H284.021ZM288.994 28.0851C288.994 30.7591 286.849 32.6631 283.845 32.6631H278.854C278.75 32.6633 278.647 32.6432 278.551 32.6037C278.455 32.5642 278.368 32.5063 278.295 32.4331C278.221 32.3599 278.163 32.273 278.123 32.1772C278.083 32.0815 278.062 31.9788 278.062 31.8751V17.4551C278.062 17.0281 278.41 16.6701 278.854 16.6701H283.649C286.482 16.6701 288.513 18.5151 288.513 21.0501C288.513 22.4431 287.803 23.6701 286.745 24.4821C288.105 25.2291 288.994 26.4361 288.994 28.0851ZM300.285 24.5111C301.794 24.5111 303.063 23.2541 303.063 21.7041C303.063 20.2611 301.771 19.0061 300.285 19.0061H296.412V24.5111H300.285ZM296.37 31.8751C296.365 32.0828 296.281 32.2808 296.133 32.4274C295.986 32.574 295.788 32.6577 295.58 32.6611H294.725C294.621 32.6615 294.519 32.6414 294.423 32.6021C294.327 32.5628 294.24 32.505 294.166 32.432C294.093 32.359 294.035 32.2723 293.995 32.1767C293.955 32.0811 293.934 31.9786 293.934 31.8751V17.4551C293.934 17.0261 294.281 16.6691 294.724 16.6691H300.395C303.242 16.6691 305.544 18.8931 305.544 21.6811C305.544 23.6591 304.334 25.4011 302.451 26.3031L305.259 31.4801C305.55 32.0201 305.206 32.6611 304.555 32.6611H303.439C303.299 32.6652 303.16 32.6299 303.039 32.5592C302.918 32.4885 302.819 32.3852 302.754 32.2611L299.946 26.6941H296.37V31.8751ZM317.323 23.6831C316.683 22.2451 316.328 21.4501 315.981 20.6791L313.273 26.7311H318.685C318.332 25.9471 317.975 25.1491 317.323 23.6831ZM315.186 16.8941C315.248 16.7596 315.347 16.646 315.473 16.5673C315.598 16.4886 315.744 16.4482 315.892 16.4511H316.112C316.442 16.4511 316.682 16.6251 316.826 16.9111L323.438 31.5661C323.685 32.0991 323.323 32.6621 322.724 32.6621H321.848C321.697 32.6643 321.548 32.6217 321.421 32.5397C321.294 32.4576 321.194 32.3398 321.134 32.2011L319.614 28.8281H312.327L310.833 32.1881C310.773 32.3298 310.673 32.4506 310.544 32.535C310.415 32.6194 310.265 32.6636 310.111 32.6621H309.236C308.638 32.6621 308.276 32.1001 308.522 31.5681L315.186 16.8941ZM333.645 24.5101C335.153 24.5101 336.422 23.2531 336.422 21.7031C336.422 20.2601 335.13 19.0051 333.645 19.0051H329.772V24.5101H333.645ZM329.727 31.8751C329.723 32.0829 329.638 32.2811 329.491 32.4277C329.343 32.5743 329.145 32.658 328.937 32.6611H328.082C327.978 32.6615 327.876 32.6414 327.78 32.6021C327.684 32.5628 327.597 32.505 327.523 32.432C327.45 32.359 327.392 32.2723 327.352 32.1767C327.312 32.0811 327.291 31.9786 327.291 31.8751V17.4551C327.291 17.0271 327.639 16.6691 328.081 16.6691H333.753C336.6 16.6691 338.902 18.8931 338.902 21.6811C338.902 23.6581 337.691 25.4011 335.809 26.3031L338.617 31.4811C338.907 32.0211 338.563 32.6611 337.913 32.6611H336.796C336.656 32.6657 336.517 32.6306 336.396 32.5598C336.275 32.489 336.176 32.3855 336.111 32.2611L333.304 26.6941H329.727V31.8751ZM341.815 17.8691C341.737 17.7506 341.693 17.6131 341.688 17.4715C341.683 17.3299 341.717 17.1897 341.786 17.0659C341.855 16.9422 341.957 16.8398 342.08 16.7699C342.203 16.6999 342.343 16.665 342.485 16.6691H343.513C343.78 16.6691 344.012 16.8161 344.167 17.0191L348.287 22.6791L352.41 17.0141C352.484 16.9105 352.582 16.8254 352.695 16.7656C352.807 16.7058 352.932 16.6727 353.06 16.6691H354.09C354.732 16.6691 355.09 17.3341 354.743 17.8941L349.472 25.0491V31.8751C349.468 32.0834 349.383 32.282 349.236 32.429C349.088 32.5761 348.889 32.66 348.681 32.6631H347.826C347.722 32.6633 347.62 32.6431 347.524 32.6037C347.428 32.5642 347.341 32.5062 347.267 32.433C347.194 32.3598 347.136 32.2728 347.096 32.1771C347.056 32.0813 347.036 31.9787 347.036 31.8751V25.0701L341.815 17.8701V17.8691ZM69.9889 17.5041C69.9889 17.0811 70.3529 16.7191 70.7789 16.7191H71.6109C72.0559 16.7191 72.4029 17.0761 72.4029 17.5041V26.5881C72.4029 28.9721 73.8869 30.6381 76.1449 30.6381C78.4339 30.6381 79.9299 29.0021 79.9299 26.6321V17.5041C79.9299 17.0761 80.2769 16.7191 80.7199 16.7191H81.5529C81.9789 16.7191 82.3429 17.0811 82.3429 17.5041V26.7191C82.3429 30.2891 79.7589 32.9291 76.1449 32.9291C72.5519 32.9291 69.9889 30.2901 69.9889 26.7191V17.5041ZM97.4649 30.5051C97.9089 30.5051 98.2569 30.8631 98.2569 31.2921V31.9241C98.2561 32.1334 98.1722 32.3339 98.0237 32.4814C97.8752 32.629 97.6742 32.7116 97.4649 32.7111H88.8379C88.7343 32.7113 88.6317 32.6912 88.5359 32.6518C88.4401 32.6123 88.3531 32.5544 88.2797 32.4813C88.2063 32.4082 88.1481 32.3214 88.1083 32.2258C88.0685 32.1302 88.048 32.0276 88.0479 31.9241V17.5041C88.0479 17.0761 88.3939 16.7191 88.8379 16.7191H97.4649C97.9079 16.7191 98.2569 17.0761 98.2569 17.5041V18.1361C98.2566 18.2398 98.2359 18.3425 98.196 18.4382C98.156 18.534 98.0976 18.6209 98.0241 18.6941C97.9505 18.7673 97.8633 18.8252 97.7673 18.8647C97.6714 18.9042 97.5686 18.9243 97.4649 18.9241H90.4829V23.4931H96.3929C96.8179 23.4931 97.1829 23.8561 97.1829 24.2781V24.9101C97.1829 25.3521 96.8229 25.6971 96.3929 25.6971H90.4829V30.5051H97.4649ZM112.612 30.5051C113.056 30.5051 113.404 30.8631 113.404 31.2921V31.9241C113.403 32.1334 113.319 32.3339 113.171 32.4814C113.022 32.629 112.821 32.7116 112.612 32.7111H103.984C103.88 32.7113 103.778 32.6912 103.682 32.6518C103.586 32.6123 103.499 32.5544 103.426 32.4813C103.352 32.4082 103.294 32.3214 103.254 32.2258C103.215 32.1302 103.194 32.0276 103.194 31.9241V17.5041C103.194 17.0771 103.541 16.7191 103.984 16.7191H112.612C113.056 16.7191 113.404 17.0761 113.404 17.5041V18.1361C113.404 18.2398 113.383 18.3425 113.343 18.4382C113.303 18.534 113.245 18.6209 113.171 18.6941C113.098 18.7673 113.01 18.8252 112.914 18.8647C112.818 18.9042 112.716 18.9243 112.612 18.9241H105.629V23.4931H111.539C111.965 23.4931 112.33 23.8561 112.33 24.2781V24.9101C112.33 25.3521 111.97 25.6971 111.54 25.6971H105.63V30.5051H112.612ZM120.689 31.9251C120.689 32.0285 120.668 32.131 120.628 32.2265C120.588 32.322 120.53 32.4087 120.457 32.4817C120.383 32.5547 120.296 32.6125 120.201 32.6518C120.105 32.6912 120.002 32.7113 119.899 32.7111H119.132C118.924 32.708 118.725 32.6242 118.578 32.4773C118.43 32.3305 118.346 32.1321 118.342 31.9241V17.2661C118.342 16.8391 118.707 16.5011 119.132 16.5011H119.5C119.728 16.5011 119.943 16.6041 120.085 16.7811L129.224 28.1071V17.5051C129.224 17.0781 129.571 16.7191 130.014 16.7191H130.781C131.207 16.7191 131.573 17.0821 131.573 17.5051V32.1651C131.573 32.5911 131.206 32.9301 130.781 32.9301H130.568C130.456 32.93 130.345 32.9048 130.244 32.8564C130.142 32.8079 130.053 32.7374 129.983 32.6501L120.689 21.1101V31.9251ZM136.544 29.8511L136.574 29.8111C136.614 29.7611 136.65 29.7171 136.729 29.6161C136.814 29.5061 136.852 29.4581 136.892 29.4121C137.269 28.9201 137.726 28.7521 138.201 29.1591L138.319 29.2631C138.608 29.5163 138.917 29.7454 139.244 29.9481C140.029 30.4351 140.846 30.7231 141.656 30.7231C143.166 30.7231 144.216 29.8241 144.216 28.6991C144.216 27.5101 143.252 26.6991 140.609 25.6011C137.649 24.3151 136.529 23.1571 136.529 20.7501C136.529 18.5061 138.399 16.5011 141.569 16.5011C142.539 16.5076 143.498 16.7061 144.391 17.0851C144.698 17.2131 144.974 17.3491 145.216 17.4871C145.364 17.5701 145.469 17.6371 145.482 17.6511C145.897 17.8591 146.104 18.3831 145.758 18.9311C145.726 18.9791 145.698 19.0221 145.636 19.1221L145.633 19.1281C145.589 19.1992 145.544 19.2696 145.498 19.3391C145.188 19.8211 144.747 19.9471 144.233 19.6591C144.224 19.6551 144.027 19.5361 143.928 19.4791C143.737 19.369 143.542 19.2673 143.343 19.1741C142.758 18.9021 142.187 18.7321 141.668 18.7081C141.628 18.7062 141.588 18.7052 141.548 18.7051C139.798 18.7051 138.901 19.6401 138.901 20.7281C138.901 21.8841 139.707 22.6611 141.622 23.4551C145.302 24.9451 146.718 26.1891 146.718 28.6351C146.718 31.0771 144.426 32.9291 141.613 32.9291C140.448 32.9257 139.301 32.6428 138.269 32.1041C137.718 31.8285 137.206 31.4819 136.746 31.0731L136.7 31.0331C136.335 30.7111 136.23 30.3431 136.544 29.8511ZM57.1199 30.6091C60.3999 30.6091 63.0939 27.9411 63.0939 24.6881C63.0939 21.4261 60.3899 18.7221 57.1199 18.7221C53.8539 18.7221 51.1679 21.4221 51.1679 24.6881C51.1679 27.9451 53.8449 30.6081 57.1199 30.6081V30.6091Z",
        fill: "#422980"
    })), /* @__PURE__ */ $acw62.createElement("defs", null, /* @__PURE__ */ $acw62.createElement("clipPath", {
        id: "clip0"
    }, /* @__PURE__ */ $acw62.createElement("rect", {
        width: 355,
        height: 47,
        fill: "white",
        transform: "translate(0 0.674072)"
    })))), $0422a6ce4ea03acc$var$dU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 320 43",
        fill: "#ffffff",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M32.4615 9.32237V27.9653L24.3461 32.6256V13.9827L16.2317 9.32237L8.11628 13.9827V32.6247L0 27.9644V9.32327L8.11628 4.66028L16.2299 0H16.2317L24.347 4.66028L32.4624 9.32057L32.4615 9.32237ZM8.11448 32.6256L16.2308 27.9644L24.3461 32.6256L32.4624 37.2859L24.3461 41.9461L16.2308 37.2859L8.11448 32.6256Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.11475 32.6259L24.3379 41.9464L32.4505 37.2855L16.2252 27.9642L8.11475 32.6259Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.3379 13.9821V32.6259L32.4506 27.9649V9.32178L24.3379 13.9821Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 27.9652L8.11268 32.6248V13.9823L0 9.32202V27.9652Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M-0.000244141 9.32215L8.11581 13.9824L16.2252 9.32215L24.3379 13.9824L32.4506 9.32215L16.2252 0.000244141L-0.000244141 9.32215Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M59.4432 28.6711C59.5614 28.7267 59.6617 28.8142 59.733 28.9236C59.8042 29.033 59.8436 29.1601 59.8467 29.2907C59.8498 29.4212 59.8165 29.5501 59.7504 29.6627C59.6844 29.7754 59.5883 29.8675 59.4729 29.9286L58.7013 30.3658C58.4201 30.528 58.046 30.4848 57.7873 30.3306L54.499 28.4674C53.5994 28.837 52.5925 29.0299 51.4883 29.0299C47.3535 29.0299 44.0643 25.7587 44.0643 21.6465C44.0603 20.6704 44.2497 19.7033 44.6214 18.8008C44.9931 17.8983 45.5398 17.0783 46.2299 16.3881C46.9201 15.698 47.7401 15.1513 48.6426 14.7796C49.5451 14.4079 50.5122 14.2185 51.4883 14.2225C52.4654 14.2181 53.4338 14.4069 54.3376 14.7782C55.2415 15.1495 56.063 15.6958 56.755 16.3858C57.4469 17.0758 57.9955 17.8958 58.3693 18.7986C58.7431 19.7015 58.9347 20.6693 58.933 21.6465C58.933 23.5791 58.1073 25.6469 56.6371 27.0693L59.4432 28.6711V28.6711ZM149.303 21.7222C150.009 21.7198 150.686 21.4377 151.185 20.9377C151.683 20.4376 151.964 19.7603 151.965 19.054C151.965 17.6821 150.769 16.5842 149.303 16.5842H146.502V21.7222H149.303ZM146.502 28.1258C146.498 28.3132 146.422 28.4918 146.289 28.6239C146.156 28.7561 145.977 28.8315 145.79 28.8343H145.04C144.947 28.8347 144.854 28.8166 144.768 28.7812C144.681 28.7458 144.603 28.6936 144.537 28.6278C144.47 28.562 144.418 28.4838 144.382 28.3977C144.346 28.3115 144.327 28.2191 144.327 28.1258V15.1266C144.327 14.7408 144.64 14.4181 145.039 14.4181H149.401C152.012 14.4181 154.16 16.5292 154.16 19.0919C154.16 21.7069 152.022 23.8477 149.422 23.8477H146.502V28.1249V28.1258ZM157.882 15.1266C157.882 14.7444 158.211 14.4181 158.595 14.4181H159.344C159.745 14.4181 160.058 14.7408 160.058 15.1266V23.3141C160.058 25.463 161.396 26.9648 163.431 26.9648C165.495 26.9648 166.842 25.4901 166.842 23.3537V15.1275C166.842 14.7417 167.156 14.419 167.555 14.419H168.306C168.69 14.419 169.018 14.7453 169.018 15.1275V23.4322C169.018 26.6511 166.688 29.0317 163.43 29.0317C160.193 29.0317 157.882 26.652 157.882 23.4322V15.1275V15.1266ZM179.195 20.5819C180.453 20.5819 181.224 19.7346 181.224 18.4654C181.224 17.1989 180.49 16.4453 179.195 16.4453H176.315V20.5828H179.195V20.5819ZM179.531 26.8458C180.773 26.8458 181.68 25.9291 181.68 24.6887C181.68 23.5205 180.592 22.6101 179.195 22.6101H176.276V26.8458H179.53H179.531ZM184.012 24.7076C184.012 27.118 182.08 28.8343 179.372 28.8343H174.872C174.779 28.8344 174.686 28.8161 174.6 28.7805C174.514 28.7449 174.435 28.6926 174.369 28.6266C174.303 28.5607 174.25 28.4823 174.215 28.3961C174.179 28.3098 174.16 28.2174 174.16 28.124V15.1266C174.16 14.7417 174.473 14.419 174.872 14.419H179.195C181.748 14.419 183.579 16.0821 183.579 18.3671C183.579 19.6228 182.939 20.7288 181.986 21.4608C183.212 22.1341 184.012 23.2221 184.012 24.7085V24.7076ZM196.006 26.8458C196.406 26.8458 196.72 27.1685 196.72 27.5543V28.1249C196.719 28.2184 196.701 28.311 196.665 28.3973C196.629 28.4836 196.576 28.5619 196.51 28.6279C196.443 28.6939 196.365 28.7461 196.278 28.7817C196.192 28.8172 196.099 28.8354 196.006 28.8352H189.177C188.988 28.8352 188.807 28.7604 188.674 28.6273C188.54 28.4941 188.465 28.3134 188.465 28.1249V15.1266C188.465 14.7417 188.778 14.419 189.177 14.419H189.947C190.331 14.419 190.659 14.7453 190.659 15.1275V26.8458H196.006ZM200.125 15.1266C200.125 14.7453 200.454 14.4181 200.837 14.4181H201.628C202.012 14.4181 202.342 14.7444 202.342 15.1266V28.1249C202.338 28.3126 202.261 28.4914 202.128 28.6237C201.995 28.756 201.815 28.8315 201.628 28.8343H200.837C200.65 28.8311 200.471 28.7552 200.338 28.6228C200.205 28.4903 200.129 28.3115 200.125 28.124V15.1266ZM214.119 14.2225C216.068 14.2225 217.596 14.8399 219.136 16.1461C219.424 16.4345 219.446 16.8807 219.155 17.1719L218.647 17.674C218.355 18.0372 217.966 18.0147 217.648 17.6992C216.65 16.8384 215.32 16.3083 214.1 16.3083C211.224 16.3083 208.931 18.7097 208.931 21.6266C208.931 24.5265 211.228 26.9251 214.1 26.9251C215.472 26.9251 216.286 26.5573 217.658 25.5261C217.949 25.2963 218.268 25.2755 218.569 25.4793L219.14 25.9913C219.474 26.2418 219.435 26.7502 219.151 27.0324C217.786 28.3493 216.023 29.0317 214.119 29.0317C209.978 29.0317 206.656 25.7515 206.656 21.6465C206.656 17.5342 209.986 14.2225 214.119 14.2225V14.2225ZM238.992 26.8467C239.392 26.8467 239.706 27.1694 239.706 27.5552V28.1249C239.706 28.2184 239.687 28.311 239.651 28.3973C239.615 28.4836 239.562 28.5619 239.496 28.6279C239.43 28.6939 239.351 28.7461 239.265 28.7817C239.178 28.8172 239.086 28.8354 238.992 28.8352H232.163C232.07 28.8354 231.977 28.8172 231.891 28.7816C231.804 28.7461 231.726 28.6938 231.66 28.6278C231.593 28.5618 231.541 28.4834 231.505 28.3971C231.469 28.3108 231.451 28.2183 231.451 28.1249V15.1266C231.451 14.7417 231.763 14.419 232.163 14.419H232.934C233.317 14.419 233.646 14.7462 233.646 15.1275V26.8458H238.992V26.8467ZM243.111 15.1275C243.111 14.7453 243.44 14.419 243.824 14.419H244.612C244.997 14.419 245.326 14.7453 245.326 15.1275V28.1249C245.322 28.3126 245.246 28.4914 245.113 28.6237C244.979 28.756 244.8 28.8315 244.612 28.8343H243.824C243.636 28.8313 243.457 28.7555 243.324 28.623C243.191 28.4905 243.115 28.3116 243.111 28.124V15.1266V15.1275ZM255.683 20.5828C256.942 20.5828 257.713 19.7355 257.713 18.4663C257.713 17.1998 256.979 16.4462 255.683 16.4462H252.803V20.5837H255.683V20.5828ZM256.019 26.8467C257.261 26.8467 258.168 25.93 258.168 24.6896C258.168 23.5214 257.08 22.611 255.683 22.611H252.765V26.8467H256.019V26.8467ZM260.501 24.7085C260.501 27.1189 258.568 28.8352 255.86 28.8352H251.361C251.268 28.8354 251.175 28.8172 251.089 28.7817C251.002 28.7461 250.923 28.6939 250.857 28.6279C250.791 28.5619 250.738 28.4836 250.702 28.3973C250.666 28.311 250.647 28.2184 250.647 28.1249V15.1266C250.647 14.7417 250.961 14.419 251.361 14.419H255.683C258.237 14.419 260.068 16.0821 260.068 18.3671C260.068 19.6228 259.428 20.7288 258.474 21.4608C259.7 22.1341 260.501 23.2221 260.501 24.7085V24.7085ZM270.679 21.4869C272.039 21.4869 273.183 20.3538 273.183 18.9567C273.183 17.6559 272.019 16.5247 270.679 16.5247H267.188V21.4869H270.679ZM267.15 28.1249C267.146 28.3122 267.07 28.4906 266.937 28.6228C266.804 28.7549 266.625 28.8304 266.438 28.8334H265.667C265.574 28.8337 265.482 28.8157 265.395 28.7803C265.309 28.7448 265.23 28.6927 265.164 28.6269C265.098 28.5611 265.045 28.4829 265.009 28.3968C264.973 28.3106 264.955 28.2182 264.954 28.1249V15.1266C264.954 14.7399 265.267 14.4181 265.667 14.4181H270.778C273.345 14.4181 275.42 16.4228 275.42 18.9359C275.42 20.7189 274.329 22.2892 272.632 23.1022L275.163 27.7688C275.425 28.2556 275.115 28.8334 274.528 28.8334H273.522C273.396 28.8371 273.271 28.8053 273.162 28.7416C273.053 28.6778 272.964 28.5847 272.905 28.4728L270.374 23.4547H267.15V28.1249ZM286.037 20.7405C285.461 19.4443 285.141 18.7277 284.828 18.0327L282.387 23.488H287.265C286.947 22.7813 286.625 22.062 286.037 20.7405V20.7405ZM284.111 14.6209C284.167 14.4996 284.257 14.3973 284.37 14.3264C284.483 14.2554 284.614 14.219 284.748 14.2216H284.946C285.243 14.2216 285.46 14.3784 285.589 14.6362L291.55 27.8464C291.772 28.3268 291.446 28.8343 290.906 28.8343H290.116C289.98 28.8363 289.846 28.7979 289.732 28.724C289.617 28.65 289.527 28.5438 289.473 28.4187L288.103 25.3783H281.534L280.187 28.407C280.133 28.5348 280.043 28.6436 279.927 28.7197C279.811 28.7958 279.675 28.8357 279.536 28.8343H278.748C278.209 28.8343 277.882 28.3277 278.104 27.8482L284.111 14.6209V14.6209ZM300.75 21.486C302.11 21.486 303.253 20.3529 303.253 18.9558C303.253 17.655 302.089 16.5238 300.75 16.5238H297.259V21.486H300.75ZM297.219 28.1249C297.215 28.3123 297.138 28.4908 297.006 28.623C296.873 28.7552 296.694 28.8306 296.506 28.8334H295.736C295.642 28.8337 295.55 28.8157 295.463 28.7803C295.377 28.7448 295.299 28.6927 295.232 28.6269C295.166 28.5611 295.113 28.4829 295.078 28.3968C295.042 28.3106 295.023 28.2182 295.023 28.1249V15.1266C295.023 14.7408 295.336 14.4181 295.735 14.4181H300.848C303.414 14.4181 305.489 16.4228 305.489 18.9359C305.489 20.718 304.397 22.2892 302.701 23.1022L305.232 27.7697C305.493 28.2565 305.183 28.8334 304.597 28.8334H303.591C303.464 28.8375 303.339 28.8059 303.23 28.7421C303.121 28.6783 303.032 28.585 302.973 28.4728L300.443 23.4547H297.219V28.1249V28.1249ZM308.115 15.4998C308.045 15.393 308.005 15.2691 308.001 15.1414C307.996 15.0138 308.027 14.8873 308.089 14.7758C308.151 14.6643 308.243 14.572 308.354 14.5089C308.465 14.4458 308.591 14.4144 308.719 14.4181H309.645C309.886 14.4181 310.095 14.5506 310.235 14.7336L313.949 19.8355L317.665 14.7291C317.732 14.6357 317.82 14.559 317.922 14.5051C318.023 14.4511 318.136 14.4214 318.251 14.4181H319.18C319.758 14.4181 320.081 15.0175 319.768 15.5223L315.017 21.9719V28.1249C315.013 28.3126 314.937 28.4917 314.804 28.6242C314.671 28.7568 314.492 28.8324 314.304 28.8352H313.533C313.44 28.8354 313.347 28.8172 313.261 28.7816C313.174 28.7461 313.096 28.6938 313.03 28.6278C312.964 28.5618 312.911 28.4834 312.875 28.3971C312.839 28.3108 312.821 28.2183 312.821 28.1249V21.9908L308.115 15.5007V15.4998ZM63.0885 15.1707C63.0885 14.7894 63.4166 14.4631 63.8006 14.4631H64.5506C64.9517 14.4631 65.2645 14.7849 65.2645 15.1707V23.3591C65.2645 25.5081 66.6022 27.0098 68.6376 27.0098C70.7009 27.0098 72.0494 25.5351 72.0494 23.3988V15.1707C72.0494 14.7849 72.3622 14.4631 72.7615 14.4631H73.5124C73.8964 14.4631 74.2245 14.7894 74.2245 15.1707V23.4772C74.2245 26.6953 71.8953 29.075 68.6376 29.075C65.3988 29.075 63.0885 26.6962 63.0885 23.4772V15.1707V15.1707ZM87.8556 26.89C88.2558 26.89 88.5695 27.2127 88.5695 27.5994V28.1691C88.5688 28.3578 88.4932 28.5385 88.3593 28.6715C88.2255 28.8045 88.0443 28.8789 87.8556 28.8785H80.0791C79.9858 28.8787 79.8933 28.8605 79.807 28.825C79.7206 28.7895 79.6422 28.7373 79.576 28.6714C79.5099 28.6055 79.4574 28.5272 79.4215 28.441C79.3857 28.3548 79.3671 28.2624 79.367 28.1691V15.1707C79.367 14.7849 79.6789 14.4631 80.0791 14.4631H87.8556C88.2549 14.4631 88.5695 14.7849 88.5695 15.1707V15.7404C88.5693 15.834 88.5506 15.9265 88.5146 16.0128C88.4786 16.0991 88.426 16.1775 88.3597 16.2434C88.2934 16.3094 88.2147 16.3617 88.1282 16.3972C88.0418 16.4328 87.9491 16.451 87.8556 16.4507H81.562V20.5693H86.8893C87.2724 20.5693 87.6014 20.8965 87.6014 21.2769V21.8466C87.6014 22.245 87.2769 22.556 86.8893 22.556H81.562V26.89H87.8556ZM101.509 26.89C101.909 26.89 102.223 27.2127 102.223 27.5994V28.1691C102.222 28.3578 102.147 28.5385 102.013 28.6715C101.879 28.8045 101.698 28.8789 101.509 28.8785H93.7319C93.6385 28.8787 93.546 28.8605 93.4597 28.825C93.3734 28.7895 93.2949 28.7373 93.2288 28.6714C93.1626 28.6055 93.1101 28.5272 93.0743 28.441C93.0384 28.3548 93.0199 28.2624 93.0198 28.1691V15.1707C93.0198 14.7858 93.3326 14.4631 93.7319 14.4631H101.509C101.909 14.4631 102.223 14.7849 102.223 15.1707V15.7404C102.223 15.834 102.204 15.9265 102.168 16.0128C102.132 16.0991 102.08 16.1775 102.013 16.2434C101.947 16.3094 101.868 16.3617 101.782 16.3972C101.695 16.4328 101.603 16.451 101.509 16.4507H95.2147V20.5693H100.542C100.926 20.5693 101.255 20.8965 101.255 21.2769V21.8466C101.255 22.245 100.931 22.556 100.543 22.556H95.2156V26.89H101.509V26.89ZM108.79 28.17C108.79 28.2632 108.771 28.3556 108.735 28.4416C108.699 28.5277 108.647 28.6059 108.581 28.6717C108.514 28.7375 108.436 28.7896 108.35 28.8251C108.263 28.8606 108.171 28.8787 108.078 28.8785H107.386C107.199 28.8757 107.02 28.8001 106.887 28.6678C106.754 28.5354 106.678 28.3566 106.674 28.1691V14.9562C106.674 14.5713 107.003 14.2666 107.386 14.2666H107.718C107.924 14.2666 108.117 14.3595 108.245 14.519L116.483 24.7284V15.1716C116.483 14.7867 116.796 14.4631 117.196 14.4631H117.887C118.271 14.4631 118.601 14.7903 118.601 15.1716V28.3863C118.601 28.7703 118.27 29.0759 117.887 29.0759H117.695C117.594 29.0758 117.494 29.0531 117.403 29.0094C117.311 28.9658 117.231 28.9022 117.168 28.8235L108.79 18.4212V28.17ZM123.082 26.3004L123.109 26.2644C123.145 26.2193 123.177 26.1796 123.248 26.0886C123.325 25.9894 123.359 25.9462 123.395 25.9047C123.735 25.4612 124.147 25.3098 124.575 25.6767L124.682 25.7704C124.942 25.9987 125.221 26.2052 125.516 26.3879C126.223 26.8269 126.96 27.0865 127.69 27.0865C129.051 27.0865 129.997 26.2761 129.997 25.262C129.997 24.1902 129.128 23.4592 126.746 22.4694C124.078 21.3102 123.068 20.2664 123.068 18.0967C123.068 16.074 124.754 14.2666 127.611 14.2666C128.486 14.2725 129.35 14.4514 130.155 14.7931C130.432 14.9084 130.681 15.031 130.899 15.1554C131.032 15.2302 131.127 15.2906 131.139 15.3033C131.513 15.4907 131.699 15.9631 131.387 16.4571C131.358 16.5003 131.333 16.5391 131.277 16.6292L131.275 16.6346C131.235 16.6988 131.195 16.7622 131.153 16.8248C130.874 17.2593 130.476 17.3729 130.013 17.1133C130.005 17.1097 129.827 17.0024 129.738 16.951C129.566 16.8519 129.39 16.7601 129.21 16.6761C128.683 16.4309 128.168 16.2777 127.701 16.256C127.665 16.2543 127.628 16.2534 127.592 16.2533C126.015 16.2533 125.206 17.0962 125.206 18.0769C125.206 19.1189 125.933 19.8193 127.659 20.535C130.976 21.8781 132.253 22.9995 132.253 25.2043C132.253 27.4056 130.187 29.075 127.651 29.075C126.601 29.072 125.567 28.8169 124.637 28.3313C124.14 28.0829 123.679 27.7704 123.264 27.402L123.222 27.3659C122.893 27.0756 122.799 26.7439 123.082 26.3004V26.3004ZM51.4883 26.9837C54.4449 26.9837 56.8733 24.5787 56.8733 21.6465C56.8733 18.7061 54.4359 16.2687 51.4883 16.2687C48.5443 16.2687 46.1231 18.7025 46.1231 21.6465C46.1231 24.5823 48.5362 26.9828 51.4883 26.9828V26.9837Z"
    })), $0422a6ce4ea03acc$var$CU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 105 129",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M57.7359 0.0660937H27.2977C27.2977 0.0660937 17.8763 -1.02099 9.17968 5.62227C0.483048 12.2655 0.603848 20.9622 0.603848 20.9622H49.4016C49.4016 20.9622 73.3173 19.6335 71.8679 42.0998C70.4185 64.5661 49.4016 61.5464 49.4016 61.5464L40 61.6672L49.1461 81.3554H50.0055C50.0055 81.3554 64.7414 86.3077 82.7387 74.1082C100.736 61.9088 99.528 42.0998 99.528 42.0998C99.528 42.0998 101.34 26.156 90.469 13.4734C79.5982 0.790833 57.7359 0.0660937 57.7359 0.0660937Z",
        fill: "#0576D3"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M49.1461 81.3554L49.1461 61.5464L57.7359 68L70.5253 81.3553L49.1461 81.3554Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M57.1321 61.667H38.4102L72.7135 128.583H104.843L77.1826 77.3037C77.1826 77.3037 67.5197 61.667 57.1321 61.667Z",
        fill: "#004B98"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M55.0787 61.3047C41.5506 61.6671 38.4102 61.6671 38.4102 61.6671L48.7735 81.4545C48.7735 81.4545 61.7391 81.225 67.2781 79.9059C72.8172 78.5867 77.0618 77.3693 77.0618 77.3693C77.0618 77.3693 68.6068 60.9424 55.0787 61.3047Z",
        fill: "#004B98"
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        y: 0.065918,
        width: 27.0562,
        height: 20.7753,
        fill: "#004B98"
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        y: 20.8413,
        width: 27.0562,
        height: 107.5,
        fill: "#0576D3"
    })), $0422a6ce4ea03acc$var$fU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 234 261",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("g", {
        clipPath: "url(#clip0_362_388)"
    }, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M3.63 181.54H17.3C19.5667 181.481 21.815 181.961 23.86 182.94C25.6436 183.806 27.1374 185.171 28.16 186.87C29.2064 188.693 29.7322 190.769 29.68 192.87V192.93C29.7509 195.447 28.9685 197.914 27.46 199.93C25.9387 201.891 23.7938 203.274 21.38 203.85L30.78 220.31H26.51L17.59 204.41C17.4603 204.421 17.3298 204.421 17.2 204.41H7.28V220.28H3.63V181.54ZM17 201.17C19.3862 201.308 21.7356 200.532 23.57 199C24.3686 198.227 24.9918 197.291 25.3972 196.255C25.8027 195.22 25.981 194.11 25.92 193C25.9815 191.884 25.7966 190.767 25.3784 189.73C24.9602 188.693 24.3189 187.761 23.5 187C21.6244 185.481 19.2491 184.718 16.84 184.86H7.28V201.21L17 201.17Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M41.15 219C39.2283 217.8 37.7017 216.061 36.76 214C35.6822 211.6 35.1559 208.99 35.22 206.36C35.1592 203.727 35.6852 201.114 36.76 198.71C37.6923 196.637 39.1983 194.875 41.1 193.63C43.0506 192.406 45.3174 191.78 47.62 191.83C49.895 191.772 52.1383 192.373 54.08 193.56C55.9276 194.746 57.3931 196.441 58.3 198.44C59.3347 200.742 59.8437 203.246 59.79 205.77V207.17H37V204.35H58.07L56.27 206.9V205.55C56.3313 203.565 55.9522 201.591 55.16 199.77C54.5077 198.311 53.4444 197.074 52.1 196.21C51.0821 195.568 49.9386 195.152 48.7463 194.988C47.554 194.825 46.3407 194.919 45.1877 195.264C44.0348 195.609 42.9691 196.197 42.0622 196.988C41.1553 197.779 40.4283 198.755 39.93 199.85C39.1263 201.64 38.7366 203.588 38.79 205.55V206.9C38.7342 208.894 39.1237 210.875 39.93 212.7C40.6154 214.207 41.7325 215.478 43.14 216.35C44.609 217.221 46.2923 217.665 48 217.63C49.2454 217.651 50.4836 217.437 51.65 217C52.6704 216.619 53.5904 216.01 54.34 215.22C55.0482 214.452 55.5716 213.531 55.87 212.53L55.95 212.29H59.44V212.56C59.1694 213.737 58.681 214.853 58 215.85C57.34 216.87 56.4996 217.761 55.52 218.48C54.4751 219.238 53.313 219.819 52.08 220.2C50.7215 220.61 49.3089 220.812 47.89 220.8C45.5192 220.843 43.184 220.219 41.15 219Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M70.65 219.74C69.1684 219.103 67.8767 218.093 66.9 216.81C65.9588 215.547 65.3844 214.049 65.24 212.48V212.23H68.76V212.48C69.0029 214.029 69.8429 215.422 71.1 216.36C72.568 217.365 74.3225 217.867 76.1 217.79C77.3558 217.822 78.6068 217.622 79.79 217.2C80.7322 216.872 81.5614 216.283 82.18 215.5C82.7405 214.761 83.0396 213.857 83.03 212.93C83.0737 212.397 83.0046 211.86 82.8271 211.355C82.6496 210.85 82.3678 210.389 82 210C80.8348 209.09 79.4592 208.488 78 208.25L73.78 207.25C71.6211 206.852 69.6022 205.901 67.92 204.49C67.2874 203.894 66.7891 203.17 66.458 202.367C66.127 201.563 65.9708 200.699 66 199.83C65.9724 198.356 66.4175 196.912 67.27 195.71C68.1711 194.476 69.3866 193.505 70.79 192.9C72.4115 192.201 74.1647 191.86 75.93 191.9C77.721 191.857 79.4987 192.219 81.13 192.96C82.5388 193.613 83.7523 194.623 84.65 195.89C85.5208 197.158 86.0354 198.636 86.14 200.17V200.47H82.8V200.28C82.7225 199.522 82.4963 198.786 82.1342 198.115C81.7722 197.444 81.2814 196.851 80.69 196.37C79.3517 195.333 77.6919 194.799 76 194.86C74.8611 194.836 73.7288 195.04 72.67 195.46C71.7928 195.811 71.031 196.4 70.47 197.16C69.9469 197.891 69.6733 198.771 69.69 199.67C69.6768 200.192 69.7783 200.711 69.9874 201.189C70.1964 201.668 70.508 202.095 70.9 202.44C72.0718 203.343 73.4439 203.95 74.9 204.21L79.09 205.21C81.89 205.877 83.8733 206.793 85.04 207.96C85.6358 208.58 86.0991 209.314 86.4017 210.119C86.7042 210.923 86.8398 211.781 86.8 212.64C86.8234 214.16 86.3415 215.644 85.43 216.86C84.4524 218.126 83.1591 219.112 81.68 219.72C79.9586 220.425 78.1097 220.766 76.25 220.72C74.3344 220.803 72.4236 220.469 70.65 219.74Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M99.15 219C97.2283 217.8 95.7017 216.061 94.76 214C93.6787 211.601 93.1491 208.991 93.21 206.36C93.1523 203.727 93.6818 201.113 94.76 198.71C95.5063 197.185 96.5609 195.831 97.857 194.734C99.1532 193.637 100.663 192.82 102.29 192.336C103.918 191.852 105.629 191.711 107.314 191.922C108.999 192.132 110.622 192.69 112.08 193.56C113.925 194.747 115.387 196.441 116.29 198.44C117.33 200.741 117.839 203.246 117.78 205.77V207.17H95V204.35H116.09L114.29 206.9V205.55C114.353 203.564 113.97 201.589 113.17 199.77C112.524 198.307 111.459 197.068 110.11 196.21C109.093 195.567 107.95 195.149 106.758 194.985C105.567 194.821 104.353 194.915 103.201 195.26C102.048 195.605 100.983 196.193 100.077 196.985C99.1712 197.777 98.4459 198.754 97.95 199.85C97.1382 201.638 96.7449 203.587 96.8 205.55V206.9C96.7422 208.895 97.1353 210.878 97.95 212.7C98.6347 214.205 99.7477 215.474 101.15 216.35C102.624 217.216 104.311 217.652 106.02 217.61C107.265 217.629 108.503 217.415 109.67 216.98C110.687 216.599 111.604 215.99 112.35 215.2C113.065 214.437 113.59 213.515 113.88 212.51L113.96 212.27H117.46L117.4 212.54C117.153 213.709 116.695 214.824 116.05 215.83C115.384 216.848 114.54 217.739 113.56 218.46C112.516 219.219 111.354 219.801 110.12 220.18C108.762 220.591 107.349 220.794 105.93 220.78C103.547 220.839 101.196 220.222 99.15 219Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M125.67 192.36H129.22V197.36H129.3C129.723 195.801 130.609 194.406 131.84 193.36C133.058 192.361 134.596 191.836 136.17 191.88C136.918 191.883 137.662 191.991 138.38 192.2V195.67C138.059 195.539 137.723 195.445 137.38 195.39C136.838 195.304 136.289 195.264 135.74 195.27C134.536 195.238 133.351 195.569 132.338 196.22C131.325 196.871 130.531 197.812 130.06 198.92C129.504 200.217 129.235 201.619 129.27 203.03V220.32H125.72L125.67 192.36Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M143.52 192.36H147.25L155.74 216.58H155.84L164.36 192.36H168L157.63 220.29H153.87L143.52 192.36Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M177.41 219C175.47 217.799 173.917 216.062 172.94 214C171.821 211.598 171.274 208.969 171.34 206.32V206.26C171.27 203.617 171.818 200.994 172.94 198.6C173.914 196.535 175.467 194.798 177.41 193.6C179.438 192.446 181.732 191.84 184.065 191.84C186.398 191.84 188.692 192.446 190.72 193.6C192.655 194.808 194.206 196.542 195.19 198.6C196.316 201 196.867 203.63 196.8 206.28V206.34C196.866 208.993 196.315 211.626 195.19 214.03C194.204 216.083 192.658 217.816 190.73 219.03C188.723 220.239 186.413 220.853 184.07 220.8C181.727 220.824 179.422 220.201 177.41 219ZM188.88 216.27C190.291 215.308 191.392 213.956 192.05 212.38C192.844 210.457 193.228 208.39 193.18 206.31V206.25C193.232 204.17 192.847 202.102 192.05 200.18C191.385 198.613 190.276 197.275 188.86 196.33C187.408 195.413 185.716 194.95 184 195C182.319 194.967 180.666 195.433 179.25 196.34C177.841 197.299 176.737 198.642 176.07 200.21C175.271 202.107 174.883 204.152 174.93 206.21V206.27C174.879 208.351 175.268 210.419 176.07 212.34C176.731 213.917 177.836 215.268 179.25 216.23C180.696 217.106 182.354 217.57 184.045 217.57C185.736 217.57 187.394 217.106 188.84 216.23L188.88 216.27Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M204 186.63C203.778 186.411 203.603 186.149 203.486 185.86C203.369 185.572 203.312 185.262 203.32 184.95C203.312 184.643 203.369 184.337 203.486 184.053C203.603 183.769 203.778 183.513 204 183.3C204.218 183.081 204.478 182.907 204.764 182.788C205.049 182.669 205.356 182.608 205.665 182.608C205.974 182.608 206.281 182.669 206.566 182.788C206.852 182.907 207.112 183.081 207.33 183.3C207.556 183.52 207.733 183.785 207.848 184.078C207.964 184.371 208.015 184.685 208 185C207.997 185.462 207.858 185.913 207.601 186.296C207.344 186.68 206.98 186.98 206.554 187.159C206.128 187.338 205.659 187.388 205.205 187.303C204.751 187.217 204.332 187.001 204 186.68V186.63ZM203.88 192.36H207.42V220.29H203.88V192.36Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M215.8 192.36H219.35V197.36H219.43C219.851 195.802 220.733 194.408 221.96 193.36C223.182 192.362 224.723 191.837 226.3 191.88C226.732 191.878 227.164 191.915 227.59 191.99C227.898 192.04 228.202 192.11 228.5 192.2V195.67C228.179 195.536 227.843 195.442 227.5 195.39C226.958 195.305 226.409 195.265 225.86 195.27C224.654 195.228 223.465 195.556 222.45 196.208C221.435 196.86 220.643 197.806 220.18 198.92C219.624 200.217 219.355 201.619 219.39 203.03V220.32H215.8V192.36Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M3.28 235.89H5.2L13.44 247.72L11.24 245.77H12.14V235.89H14.2V249.28H12.28L4.05 237.43L6.25 239.37H5.35V249.28H3.28V235.89Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M22 243.79L17.29 235.89H19.6L23.02 241.79H23.08L26.49 235.89H28.81L24.09 243.79V249.28H22V243.79Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M31.86 235.89H33.94V249.28H31.86V235.89ZM32.86 242.96H36.29C37.0516 243.011 37.8026 242.759 38.38 242.26C38.6359 242.009 38.8351 241.706 38.9645 241.371C39.0938 241.036 39.1502 240.678 39.13 240.32C39.1577 239.952 39.105 239.583 38.9754 239.237C38.8459 238.892 38.6427 238.579 38.38 238.32C37.7974 237.83 37.0502 237.58 36.29 237.62H32.9V235.87H36.9C37.7072 235.856 38.5049 236.045 39.22 236.42C39.8602 236.796 40.3831 237.343 40.73 238C41.1202 238.703 41.3169 239.496 41.3 240.3C41.3169 241.104 41.1202 241.897 40.73 242.6C40.365 243.252 39.8246 243.789 39.17 244.15C38.4566 244.529 37.6577 244.719 36.85 244.7H32.85L32.86 242.96Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M44.71 235.89H46.79V247.48H53V249.28H44.71V235.89Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M64.88 235.89H69.6C70.7844 235.857 71.9577 236.126 73.01 236.67C73.9464 237.19 74.7031 237.981 75.18 238.94C75.7128 240.064 75.9732 241.297 75.94 242.54C75.9767 243.79 75.7162 245.03 75.18 246.16C74.7121 247.144 73.9504 247.958 73 248.49C71.9456 249.04 70.7686 249.311 69.58 249.28H64.88V235.89ZM69.4 247.48C70.2396 247.506 71.0712 247.31 71.81 246.91C72.4695 246.528 72.991 245.947 73.3 245.25C73.6623 244.408 73.8363 243.497 73.81 242.58C73.8355 241.667 73.6615 240.759 73.3 239.92C72.9784 239.231 72.4554 238.656 71.8 238.27C71.0625 237.877 70.2352 237.684 69.4 237.71H67V247.5L69.4 247.48Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M79.52 235.89H88V237.69H81.6V241.59H87.67V243.33H81.6V247.48H88V249.28H79.5L79.52 235.89Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M93.69 249.05C92.9877 248.78 92.3699 248.328 91.9 247.74C91.4598 247.162 91.2021 246.465 91.16 245.74V245.6H93.16V245.72C93.2143 246.12 93.3968 246.492 93.68 246.78C93.9856 247.095 94.363 247.332 94.78 247.47C95.2896 247.638 95.8237 247.719 96.36 247.71C96.8878 247.724 97.4135 247.639 97.91 247.46C98.3013 247.318 98.6468 247.072 98.91 246.75C99.1435 246.435 99.2666 246.052 99.26 245.66C99.2702 245.416 99.2231 245.173 99.1223 244.951C99.0216 244.729 98.8701 244.533 98.68 244.38C98.1116 243.979 97.4578 243.715 96.77 243.61L95.31 243.31C94.2295 243.139 93.2163 242.675 92.38 241.97C92.0534 241.661 91.7955 241.287 91.6232 240.872C91.4509 240.456 91.3681 240.009 91.38 239.56C91.3699 238.843 91.5908 238.142 92.01 237.56C92.4441 236.96 93.0361 236.493 93.72 236.21C94.5154 235.869 95.3747 235.701 96.24 235.72C97.0836 235.706 97.9211 235.866 98.7 236.19C99.3661 236.475 99.9455 236.93 100.38 237.51C100.805 238.093 101.048 238.789 101.08 239.51V239.66H99.08V239.54C99.0362 239.146 98.8761 238.773 98.62 238.47C98.3508 238.159 98.0066 237.921 97.62 237.78C96.6993 237.467 95.7008 237.467 94.78 237.78C94.4084 237.918 94.0827 238.157 93.84 238.47C93.6161 238.755 93.4961 239.108 93.5 239.47C93.4945 239.708 93.5461 239.944 93.6505 240.158C93.7549 240.372 93.909 240.558 94.1 240.7C94.6518 241.078 95.2799 241.331 95.94 241.44L97.4 241.76C98.5012 241.926 99.5374 242.386 100.4 243.09C100.72 243.407 100.969 243.789 101.132 244.209C101.294 244.63 101.365 245.08 101.34 245.53C101.357 246.284 101.141 247.024 100.72 247.65C100.301 248.247 99.7221 248.715 99.05 249C98.1831 249.348 97.254 249.515 96.32 249.49C95.4234 249.511 94.5309 249.362 93.69 249.05Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M105.26 235.89H107.34V249.28H105.26V235.89Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M113.85 248.65C112.91 248.075 112.159 247.237 111.69 246.24C111.152 245.075 110.888 243.803 110.92 242.52C110.884 241.264 111.144 240.017 111.68 238.88C112.156 237.898 112.906 237.074 113.84 236.51C114.848 235.94 115.992 235.653 117.15 235.68C118.086 235.658 119.016 235.845 119.87 236.23C120.619 236.572 121.274 237.09 121.78 237.74C122.268 238.382 122.609 239.122 122.78 239.91V240.07H120.7V239.96C120.46 239.239 120.002 238.61 119.39 238.16C118.742 237.722 117.972 237.498 117.19 237.52C116.414 237.502 115.65 237.711 114.99 238.12C114.356 238.533 113.864 239.129 113.58 239.83C113.232 240.683 113.065 241.599 113.09 242.52C113.063 243.465 113.234 244.405 113.59 245.28C113.888 245.975 114.377 246.571 115 247C115.656 247.418 116.422 247.63 117.2 247.61C117.864 247.625 118.522 247.481 119.12 247.19C119.655 246.921 120.105 246.509 120.42 246C120.737 245.461 120.903 244.846 120.9 244.22V244H117.39V242.3H122.96V243.67C122.989 244.748 122.752 245.816 122.27 246.78C121.825 247.637 121.127 248.335 120.27 248.78C119.307 249.264 118.238 249.502 117.16 249.47C116.002 249.509 114.856 249.225 113.85 248.65Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M126.56 235.89H128.48L136.72 247.72L134.52 245.77H135.42V235.89H137.49V249.28H135.57L127.33 237.43L129.53 239.37H128.63V249.28H126.56V235.89Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M152 249.05C151.298 248.78 150.68 248.328 150.21 247.74C149.765 247.164 149.507 246.466 149.47 245.74V245.6H151.47V245.72C151.525 246.118 151.703 246.489 151.98 246.78C152.291 247.093 152.671 247.33 153.09 247.47C153.6 247.638 154.134 247.719 154.67 247.71C155.198 247.724 155.723 247.639 156.22 247.46C156.611 247.318 156.957 247.072 157.22 246.75C157.453 246.435 157.577 246.052 157.57 245.66C157.58 245.416 157.533 245.173 157.432 244.951C157.332 244.729 157.18 244.533 156.99 244.38C156.422 243.979 155.768 243.715 155.08 243.61L153.62 243.31C152.539 243.139 151.526 242.675 150.69 241.97C150.364 241.661 150.106 241.286 149.934 240.871C149.762 240.456 149.679 240.009 149.69 239.56C149.688 238.843 149.912 238.143 150.33 237.56C150.764 236.96 151.356 236.493 152.04 236.21C153.644 235.562 155.436 235.562 157.04 236.21C157.71 236.492 158.294 236.948 158.73 237.53C159.155 238.113 159.398 238.809 159.43 239.53V239.68H157.43V239.56C157.386 239.166 157.226 238.793 156.97 238.49C156.701 238.179 156.357 237.941 155.97 237.8C155.049 237.487 154.051 237.487 153.13 237.8C152.758 237.938 152.433 238.177 152.19 238.49C151.966 238.775 151.846 239.128 151.85 239.49C151.844 239.728 151.896 239.964 152 240.178C152.105 240.392 152.259 240.578 152.45 240.72C153.002 241.098 153.63 241.351 154.29 241.46L155.75 241.78C156.851 241.946 157.887 242.406 158.75 243.11C159.069 243.428 159.317 243.81 159.479 244.23C159.641 244.651 159.713 245.1 159.69 245.55C159.707 246.304 159.491 247.044 159.07 247.67C158.631 248.292 158.019 248.772 157.31 249.05C156.443 249.398 155.514 249.564 154.58 249.54C153.697 249.539 152.822 249.373 152 249.05Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M166.38 243.79L161.66 235.89H164L167.43 241.79L170.85 235.89H173.17L168.44 243.79V249.28H166.36L166.38 243.79Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M177.85 249.05C177.148 248.78 176.53 248.328 176.06 247.74C175.62 247.162 175.362 246.465 175.32 245.74V245.6H177.32V245.72C177.379 246.119 177.561 246.489 177.84 246.78C178.148 247.097 178.529 247.334 178.95 247.47C179.456 247.638 179.987 247.719 180.52 247.71C181.048 247.724 181.573 247.639 182.07 247.46C182.461 247.318 182.807 247.072 183.07 246.75C183.311 246.439 183.438 246.054 183.43 245.66C183.438 245.416 183.39 245.174 183.289 244.952C183.189 244.731 183.038 244.535 182.85 244.38C182.277 243.981 181.62 243.718 180.93 243.61L179.47 243.31C178.39 243.136 177.378 242.673 176.54 241.97C176.213 241.661 175.956 241.287 175.783 240.872C175.611 240.456 175.528 240.009 175.54 239.56C175.53 238.843 175.751 238.142 176.17 237.56C176.604 236.96 177.196 236.493 177.88 236.21C179.484 235.565 181.276 235.565 182.88 236.21C183.547 236.498 184.129 236.952 184.57 237.53C184.988 238.116 185.227 238.811 185.26 239.53V239.68H183.26V239.56C183.216 239.166 183.056 238.793 182.8 238.49C182.531 238.179 182.187 237.941 181.8 237.8C180.879 237.487 179.881 237.487 178.96 237.8C178.59 237.94 178.265 238.179 178.02 238.49C177.8 238.777 177.681 239.128 177.68 239.49C177.674 239.728 177.726 239.964 177.83 240.178C177.935 240.392 178.089 240.578 178.28 240.72C178.832 241.098 179.46 241.351 180.12 241.46L181.58 241.78C182.682 241.944 183.719 242.404 184.58 243.11C184.9 243.427 185.149 243.809 185.311 244.229C185.474 244.65 185.545 245.1 185.52 245.55C185.542 246.304 185.325 247.046 184.9 247.67C184.463 248.294 183.85 248.774 183.14 249.05C182.273 249.398 181.344 249.565 180.41 249.54C179.534 249.537 178.666 249.371 177.85 249.05Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M192.36 237.69H188.26V235.89H198.53V237.69H194.44V249.28H192.36V237.69Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M201.82 235.89H210.32V237.69H203.9V241.59H210V243.33H203.9V247.48H210.32V249.28H201.82V235.89Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M214.06 235.89H216.46L220.79 246.57H220.85L225.18 235.89H227.59V249.28H225.69V239.41H224.69L226.86 236.26L221.55 249.26H220.01L214.7 236.26L216.87 239.41H216V249.28H214.1L214.06 235.89Z",
        fill: "black"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M87.67 0.019989H57.52V23.65H87.67V0.019989Z",
        fill: "#004B98"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M87.67 23.65H57.52V144.16H87.67V23.65Z",
        fill: "#0676D3"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M87.67 23.65H115.85C115.85 23.65 138.01 24.53 137.65 46.45C137.29 67.85 118 68.79 118 68.79L101 69.11L112.39 92C112.39 92 167.09 97.57 168.5 46.35C168.5 -2.44 117.92 7.41333e-07 117.92 7.41333e-07H87.67V23.65Z",
        fill: "#0676D3"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M101 69.11L138.59 144.11L175.25 144.17L144 86.6C144 86.6 133.41 69.29 122.62 68.83L101 69.11Z",
        fill: "#004B98"
    }))), $0422a6ce4ea03acc$var$pU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 185 79",
        fill: "#000000",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M72.3064 33.4369C72.647 33.4369 72.9194 33.1673 72.9194 32.8304C72.9194 32.4934 72.647 32.2238 72.3064 32.2238C71.9999 32.2238 71.6934 32.4934 71.6934 32.8304C71.7274 33.1673 71.9999 33.4369 72.3064 33.4369ZM71.9318 42.1646H72.7491V34.9533H71.9318V42.1646ZM74.6904 42.1646H75.4737V36.9078C75.9165 36.2338 76.802 35.4925 77.7215 35.4925C78.8114 35.4925 79.2201 36.1664 79.2201 37.2111V42.1646H80.0034V37.0426C80.0034 35.7284 79.3903 34.7848 77.8918 34.7848C76.8701 34.7848 76.0187 35.3914 75.4737 36.099V34.9533H74.6904V42.1646ZM84.3968 42.1646H86.7127C89.0286 42.1646 90.4931 41.3559 90.4931 39.3677C90.4931 37.9187 89.4373 37.0763 88.1772 36.8404V36.8067C89.3011 36.5371 90.0503 35.7621 90.0503 34.5826C90.0503 32.7967 88.7561 32.089 86.7468 32.089H84.4309V42.1646H84.3968ZM85.2142 41.457V37.2111H86.7468C88.7221 37.2111 89.6416 38.0198 89.6416 39.4014C89.6416 40.8504 88.688 41.4907 86.7127 41.4907H85.2142V41.457ZM85.2142 36.5034V32.7967H86.6446C88.3475 32.7967 89.1989 33.3358 89.1989 34.6163C89.1989 35.8631 88.3815 36.5034 86.6446 36.5034H85.2142ZM92.1619 42.1646H92.9452V31.2803H92.1619V42.1646ZM96.7937 42.3331C97.6792 42.3331 98.4966 41.895 99.0074 41.2548C99.0074 41.5244 99.0755 41.9287 99.1096 42.1646H99.8929C99.7908 41.8613 99.7226 41.3222 99.7226 40.7156V37.0763C99.7226 35.5262 98.8712 34.7848 97.3727 34.7848C96.4191 34.7848 95.6357 35.0881 94.9887 35.6947L95.4314 36.2338C96.0444 35.661 96.6234 35.4588 97.3386 35.4588C98.4285 35.4588 98.9393 35.9979 98.9393 37.1774V37.9861H98.5987C96.8959 37.9861 94.7503 38.5253 94.7503 40.446C94.7503 41.5917 95.5676 42.3331 96.7937 42.3331ZM96.8959 41.6591C96.2488 41.6591 95.5676 41.2211 95.5676 40.446C95.5676 39.0981 96.964 38.6264 98.5987 38.6264H98.9393V40.5471C98.4285 41.2548 97.7132 41.6591 96.8959 41.6591ZM104.354 42.3331C105.444 42.3331 106.228 41.9287 106.602 41.5918L106.262 40.9852C105.955 41.2885 105.24 41.6254 104.389 41.6254C102.754 41.6254 102.039 40.1091 102.039 38.4916C102.039 36.8404 102.788 35.4251 104.389 35.4251C105.206 35.4251 105.751 35.7284 106.159 36.0653L106.568 35.4925C106.16 35.1555 105.478 34.7511 104.389 34.7511C102.515 34.7511 101.187 36.2338 101.187 38.5253C101.221 40.4797 102.277 42.3331 104.354 42.3331ZM112.29 42.1646H113.277L109.872 38.1209L113.107 34.9533H112.12L108.918 38.1209L112.29 42.1646ZM108.067 42.1646H108.85V31.2803H108.067V42.1646ZM121.656 42.3331C122.984 42.3331 124.04 41.895 124.653 41.3222L124.244 40.7156C123.631 41.2548 122.78 41.5918 121.69 41.5918C119.101 41.5918 117.637 39.4351 117.637 37.0426C117.637 34.6837 119.101 32.5608 121.656 32.5608C122.609 32.5608 123.358 32.8304 123.972 33.2347L124.414 32.5945C123.699 32.1227 122.848 31.8531 121.69 31.8531C118.625 31.8531 116.785 34.3131 116.785 37.0426C116.785 39.8732 118.59 42.3331 121.656 42.3331ZM128.365 42.3331C129.591 42.3331 130.442 41.5244 130.783 40.9852C130.783 41.3896 130.851 41.9287 130.885 42.1646H131.703C131.634 41.895 131.566 41.3559 131.566 40.783V34.9533H130.783V40.1764C130.545 40.6145 129.625 41.6254 128.535 41.6254C127.411 41.6254 127.037 40.9515 127.037 39.8732V34.9533H126.253V40.0417C126.253 41.3559 126.832 42.3331 128.365 42.3331ZM134.121 42.1646H134.904V31.2803H134.121V42.1646ZM139.366 42.3331C140.047 42.3331 140.558 42.0635 140.762 41.895L140.455 41.2885C140.319 41.3896 139.876 41.6254 139.434 41.6254C138.787 41.6254 138.548 41.2211 138.548 40.4797V35.5599H140.421V34.9196H138.548V32.8641H137.765V34.9196H136.539V35.5599H137.765V40.5134C137.765 41.6928 138.276 42.3331 139.366 42.3331ZM144.372 42.3331C145.598 42.3331 146.449 41.5244 146.79 40.9852C146.79 41.3896 146.858 41.9287 146.892 42.1646H147.71C147.641 41.895 147.573 41.3559 147.573 40.783V34.9533H146.79V40.1764C146.552 40.6145 145.632 41.6254 144.542 41.6254C143.418 41.6254 143.044 40.9515 143.044 39.8732V34.9533H142.26V40.0417C142.26 41.3559 142.839 42.3331 144.372 42.3331ZM150.128 42.1646H150.911V37.1437C151.115 36.7056 151.762 35.5262 152.784 35.5262C153.091 35.5262 153.261 35.5936 153.397 35.6273L153.602 34.8859C153.465 34.8522 153.227 34.7511 152.886 34.7511C151.865 34.7511 151.217 35.661 150.945 36.1664V34.9196H150.162V42.1646H150.128ZM157.484 42.3331C158.676 42.3331 159.493 41.9287 159.97 41.5918L159.63 40.9852C159.221 41.2885 158.438 41.6591 157.518 41.6591C155.781 41.6591 155.066 40.1427 155.066 38.4916V38.3231H160.106C160.106 38.1883 160.106 38.0535 160.106 37.9187C160.106 36.0653 159.085 34.7848 157.348 34.7848C155.407 34.7848 154.215 36.436 154.215 38.4916C154.215 40.5471 155.236 42.3331 157.484 42.3331ZM155.1 37.6828C155.304 36.436 156.054 35.4588 157.314 35.4588C158.71 35.4588 159.289 36.5708 159.289 37.6828H155.1Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M72.1 26.5291H72.8833V19.9581H74.7905V19.3178H72.8833V18.1721C72.8833 16.8579 73.4282 16.184 74.5521 16.184C74.9949 16.184 75.3014 16.2851 75.4717 16.3861L75.676 15.6785C75.4717 15.5774 75.097 15.4763 74.5521 15.4763C72.9514 15.4763 72.1 16.4535 72.1 18.1047V19.3178H70.8398V19.9581H72.1V26.5291ZM78.8774 26.6976C81.1593 26.6976 82.215 24.7095 82.215 22.8898C82.215 21.1038 81.1593 19.1494 78.8774 19.1494C76.5956 19.1494 75.6079 21.1038 75.6079 22.9235C75.6079 24.7432 76.5956 26.6976 78.8774 26.6976ZM78.9115 26.0237C77.2426 26.0237 76.4593 24.541 76.4593 22.8898C76.4593 21.2723 77.2086 19.8233 78.8774 19.8233C80.5462 19.8233 81.4317 21.306 81.4317 22.9235C81.3977 24.5747 80.5803 26.0237 78.9115 26.0237ZM83.7476 26.5291H84.5309V21.5082C84.7353 21.0701 85.3824 19.8907 86.4041 19.8907C86.7106 19.8907 86.8809 19.9581 87.0171 19.9918L87.2215 19.2504C87.0852 19.2167 86.8468 19.1157 86.5063 19.1157C85.4845 19.1157 84.8375 19.9918 84.565 20.531V19.2841H83.7817V26.5291H83.7476ZM92.1939 26.5291H93.0453V21.643H93.3178C93.9308 21.643 94.1011 21.7441 95.1228 23.1257L97.609 26.5291H98.6307L95.804 22.7213C95.225 21.98 95.0206 21.7104 94.8163 21.6093H94.9525C96.7235 21.5419 97.9496 20.6994 97.9496 19.0483C97.9496 17.3634 96.6895 16.4535 94.646 16.4535H92.2279V26.5291H92.1939ZM93.0112 20.969V17.1612H94.4757C96.1445 17.1612 97.03 17.8014 97.03 19.0483C97.03 20.2951 96.1786 20.969 94.5438 20.969H93.0112ZM102.615 26.6976C103.807 26.6976 104.625 26.2933 105.102 25.9563L104.761 25.3497C104.352 25.653 103.569 26.0237 102.65 26.0237C100.913 26.0237 100.197 24.5073 100.197 22.8561V22.6876H105.238C105.238 22.5528 105.238 22.418 105.238 22.2832C105.238 20.4299 104.216 19.1494 102.479 19.1494C100.538 19.1494 99.3459 20.8005 99.3459 22.8561C99.3459 24.9454 100.402 26.6976 102.615 26.6976ZM100.231 22.0474C100.436 20.8005 101.185 19.8233 102.445 19.8233C103.842 19.8233 104.386 20.9353 104.42 22.0474H100.231ZM108.678 26.7313C110.176 26.7313 111.13 25.9563 111.13 24.7095C111.13 23.5301 110.108 23.0246 108.984 22.5191C108.133 22.1484 107.418 21.8452 107.418 21.0027C107.418 20.2951 107.894 19.8233 108.78 19.8233C109.529 19.8233 110.108 20.1266 110.449 20.3962L110.857 19.8233C110.517 19.5537 109.802 19.1494 108.78 19.1494C107.418 19.1494 106.634 19.9581 106.634 21.0364C106.634 22.2158 107.554 22.7213 108.644 23.1931C109.631 23.6311 110.312 23.9681 110.312 24.7769C110.312 25.5519 109.665 26.0237 108.678 26.0237C107.894 26.0237 107.145 25.6867 106.805 25.4171L106.464 26.0237C106.907 26.3607 107.724 26.7313 108.678 26.7313ZM115.694 26.6976C116.886 26.6976 117.703 26.2933 118.18 25.9563L117.839 25.3497C117.43 25.653 116.647 26.0237 115.728 26.0237C113.991 26.0237 113.275 24.5073 113.275 22.8561V22.6876H118.316C118.316 22.5528 118.316 22.418 118.316 22.2832C118.316 20.4299 117.294 19.1494 115.557 19.1494C113.616 19.1494 112.424 20.8005 112.424 22.8561C112.424 24.9454 113.48 26.6976 115.694 26.6976ZM113.309 22.0474C113.514 20.8005 114.263 19.8233 115.523 19.8233C116.92 19.8233 117.464 20.9353 117.499 22.0474H113.309ZM121.688 26.6976C122.573 26.6976 123.39 26.2596 123.901 25.6193C123.901 25.8889 123.969 26.2933 124.004 26.5291H124.787C124.685 26.2259 124.651 25.6867 124.651 25.0801V21.4408C124.651 19.8907 123.799 19.1494 122.301 19.1494C121.347 19.1494 120.564 19.4526 119.917 20.0592L120.359 20.5984C120.972 20.0255 121.551 19.8233 122.267 19.8233C123.356 19.8233 123.867 20.3625 123.867 21.5419V22.3506H123.527C121.824 22.3506 119.678 22.8898 119.678 24.8106C119.644 25.9563 120.462 26.6976 121.688 26.6976ZM121.79 26.0237C121.143 26.0237 120.462 25.5856 120.462 24.8106C120.462 23.4627 121.858 22.9909 123.493 22.9909H123.833V24.9117C123.288 25.6193 122.607 26.0237 121.79 26.0237ZM127.103 26.5291H127.886V21.5082C128.09 21.0701 128.737 19.8907 129.759 19.8907C130.066 19.8907 130.236 19.9581 130.372 19.9918L130.577 19.2504C130.44 19.2167 130.202 19.1157 129.861 19.1157C128.84 19.1157 128.193 19.9918 127.92 20.531V19.2841H127.103V26.5291ZM134.289 26.6976C135.379 26.6976 136.162 26.2933 136.537 25.9563L136.196 25.3497C135.89 25.653 135.174 25.99 134.323 25.99C132.688 25.99 131.973 24.4736 131.973 22.8561C131.973 21.2049 132.722 19.7896 134.323 19.7896C135.14 19.7896 135.685 20.0929 136.094 20.4299L136.503 19.857C136.094 19.52 135.413 19.1157 134.323 19.1157C132.45 19.1157 131.122 20.5984 131.122 22.8898C131.156 24.8443 132.177 26.6976 134.289 26.6976ZM138.274 26.5291H139.057V21.2723C139.329 20.8679 140.215 19.857 141.305 19.857C142.395 19.857 142.803 20.531 142.803 21.5756V26.5291H143.587V21.4071C143.587 20.0929 142.974 19.1494 141.475 19.1494C140.249 19.1494 139.397 19.9581 139.057 20.4636V15.6448H138.274V26.5291Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M74.452 48.7688V47.96H70.876V48.7688H72.1702V52.5766H73.1578V48.7688H74.452ZM77.8918 52.5766V50.2178C77.8918 49.6112 77.6194 49.1394 76.8701 49.1394C76.3252 49.1394 75.9846 49.4427 75.8143 49.6449V47.6231H74.8948V52.6103H75.8143V50.2852C75.8824 50.1841 76.1549 49.8471 76.5295 49.8471C76.8701 49.8471 76.9723 50.0156 76.9723 50.3526V52.5429H77.8918V52.5766ZM79.4244 51.0939H81.6041C81.7062 49.8471 81.1954 49.1057 80.1396 49.1057C79.186 49.1057 78.4367 49.7797 78.4367 50.858C78.4367 51.9364 79.0838 52.644 80.2077 52.644C80.9229 52.644 81.2635 52.4418 81.4678 52.307L81.1613 51.7005C80.991 51.7679 80.7186 51.9363 80.2758 51.9363C79.7309 51.97 79.4585 51.5994 79.4244 51.0939ZM79.4244 50.4537C79.4925 50.0156 79.6969 49.746 80.1055 49.746C80.5483 49.746 80.6845 50.0493 80.6845 50.4537H79.4244ZM87.9047 52.5766V47.96H87.0192V50.3863C87.0192 50.7569 87.0533 51.0939 87.0533 51.1276C87.0533 51.1276 86.8489 50.7569 86.5765 50.3526L84.9076 47.96H83.8519V52.5766H84.7374V49.9482C84.7374 49.6449 84.7033 49.3416 84.7033 49.3416C84.7033 49.3416 84.8736 49.6786 85.146 50.0493L86.9511 52.6103H87.9047V52.5766ZM89.4713 51.0939H91.651C91.7532 49.8471 91.2423 49.1057 90.1865 49.1057C89.2329 49.1057 88.4837 49.7797 88.4837 50.858C88.4837 51.9364 89.1308 52.644 90.2547 52.644C90.9699 52.644 91.3104 52.4418 91.5148 52.307L91.2083 51.7005C91.038 51.7679 90.7655 51.9363 90.3228 51.9363C89.7779 51.97 89.5054 51.5994 89.4713 51.0939ZM89.4713 50.4537C89.5395 50.0156 89.7438 49.746 90.1525 49.746C90.5952 49.746 90.7315 50.0493 90.7315 50.4537H89.4713ZM96.8959 49.2068H95.9763L95.4314 51.3635L94.8524 49.2068H94.001L93.422 51.3635L92.9111 49.2068H91.9235L92.8771 52.5766H93.7285L94.4437 50.3189L95.1589 52.5766H96.0104L96.8959 49.2068ZM102.447 47.96H101.494L100.506 49.9145L99.5183 47.96H98.4284L99.961 50.8243V52.5766H100.949V50.8243L102.447 47.96ZM105.478 50.858C105.478 49.9819 104.933 49.1057 103.741 49.1057C102.549 49.1057 102.039 50.0156 102.039 50.8917C102.039 51.7679 102.549 52.644 103.741 52.644C104.967 52.644 105.478 51.7005 105.478 50.858ZM104.491 50.8917C104.491 51.532 104.286 51.9363 103.775 51.9363C103.265 51.9363 103.026 51.4646 103.026 50.858C103.026 50.2515 103.196 49.7797 103.741 49.7797C104.252 49.7797 104.491 50.2515 104.491 50.8917ZM108.271 49.2068C108.203 49.1731 108.067 49.1057 107.794 49.1057C107.351 49.1057 107.079 49.409 106.943 49.6449V49.1731H106.023V52.5429H106.943V50.42C107.011 50.2515 107.283 49.9145 107.692 49.9145C107.896 49.9145 107.999 49.9482 108.033 49.9819L108.271 49.2068ZM109.599 50.9254L110.689 52.5766H111.779L110.485 50.7232L111.745 49.2068H110.723L109.599 50.5547V47.5894H108.68V52.5766H109.599V50.9254ZM117.16 49.409C117.16 48.4318 116.377 47.96 115.389 47.96H113.856V52.5766H114.844V50.9254H115.287C116.445 50.9254 117.16 50.42 117.16 49.409ZM116.172 49.409C116.172 49.9145 115.9 50.1841 115.287 50.1841H114.844V48.7014H115.321C115.934 48.7014 116.172 48.971 116.172 49.409ZM117.637 49.2068V51.5657C117.637 52.1722 117.909 52.644 118.659 52.644C119.238 52.644 119.578 52.3407 119.748 52.1048C119.748 52.2396 119.782 52.4755 119.817 52.5429H120.736C120.702 52.3407 120.634 52.0037 120.634 51.5657V49.1731H119.714V51.4309C119.646 51.4983 119.374 51.869 118.999 51.869C118.659 51.869 118.556 51.7005 118.556 51.3635V49.1731H117.637V49.2068ZM121.417 47.5894V52.3744C121.587 52.4418 122.03 52.644 122.814 52.644C123.835 52.644 124.619 52.0038 124.619 50.858C124.619 49.6786 124.04 49.1057 123.154 49.1057C122.78 49.1057 122.473 49.3079 122.337 49.4427V47.5894H121.417ZM122.371 50.083C122.439 50.0156 122.643 49.8134 122.95 49.8134C123.461 49.8134 123.665 50.1841 123.665 50.8243C123.665 51.532 123.358 51.9026 122.848 51.9026C122.575 51.9026 122.439 51.8353 122.371 51.8353V50.083ZM126.185 47.5894H125.266V52.5766H126.185V47.5894ZM128.058 49.2068H127.105V52.5766H128.058V49.2068ZM128.161 48.1959C128.161 47.8926 127.922 47.6568 127.582 47.6568C127.241 47.6568 127.003 47.8926 127.003 48.1959C127.003 48.4992 127.241 48.7351 127.582 48.7351C127.922 48.7688 128.161 48.4992 128.161 48.1959ZM131.6 52.3407L131.328 51.7342C131.226 51.8016 130.987 51.9363 130.579 51.9363C130 51.9363 129.727 51.4646 129.727 50.858C129.727 50.2515 130 49.8134 130.545 49.8134C130.885 49.8134 131.09 49.9145 131.26 50.0156L131.566 49.3753C131.396 49.2742 131.09 49.1057 130.511 49.1057C129.489 49.1057 128.706 49.746 128.706 50.8917C128.706 51.9363 129.387 52.644 130.476 52.644C131.124 52.644 131.43 52.4418 131.6 52.3407ZM136.505 52.5766V51.8016H134.768V47.9937H133.78V52.6103H136.505V52.5766ZM138.003 49.2068H137.05V52.5766H138.003V49.2068ZM138.105 48.1959C138.105 47.8926 137.867 47.6568 137.526 47.6568C137.186 47.6568 136.947 47.8926 136.947 48.1959C136.947 48.4992 137.186 48.7351 137.526 48.7351C137.867 48.7688 138.105 48.4992 138.105 48.1959ZM138.889 47.5894V52.3744C139.059 52.4418 139.502 52.644 140.285 52.644C141.307 52.644 142.09 52.0038 142.09 50.858C142.09 49.6786 141.511 49.1057 140.626 49.1057C140.251 49.1057 139.944 49.3079 139.808 49.4427V47.5894H138.889ZM139.842 50.083C139.91 50.0156 140.115 49.8134 140.421 49.8134C140.932 49.8134 141.136 50.1841 141.136 50.8243C141.136 51.532 140.83 51.9026 140.319 51.9026C140.047 51.9026 139.91 51.8353 139.842 51.8353V50.083ZM144.917 49.2068C144.849 49.1731 144.713 49.1057 144.44 49.1057C143.997 49.1057 143.725 49.409 143.589 49.6449V49.1731H142.669V52.5429H143.589V50.42C143.657 50.2515 143.929 49.9145 144.338 49.9145C144.542 49.9145 144.644 49.9482 144.678 49.9819L144.917 49.2068ZM148.05 52.5766C148.016 52.3744 147.948 52.0374 147.948 51.5657V50.3526C147.948 49.4427 147.505 49.1057 146.586 49.1057C145.87 49.1057 145.394 49.409 145.189 49.5775L145.598 50.1504C145.734 50.0493 146.041 49.8471 146.483 49.8471C146.926 49.8471 147.028 50.0156 147.028 50.3189V50.5211H146.892C145.973 50.5211 145.087 50.8243 145.087 51.7342C145.087 52.3407 145.53 52.6777 146.109 52.6777C146.586 52.6777 146.926 52.4081 147.062 52.2396C147.062 52.3407 147.097 52.5092 147.131 52.6103H148.05V52.5766ZM147.028 51.6668C146.926 51.7679 146.722 51.97 146.415 51.97C146.211 51.97 146.007 51.869 146.007 51.6331C146.007 51.2287 146.381 51.0939 146.926 51.0939H147.062V51.6668H147.028ZM150.979 49.2068C150.911 49.1731 150.775 49.1057 150.502 49.1057C150.06 49.1057 149.787 49.409 149.651 49.6449V49.1731H148.731V52.5429H149.651V50.42C149.719 50.2515 149.991 49.9145 150.4 49.9145C150.604 49.9145 150.707 49.9482 150.741 49.9819L150.979 49.2068ZM152.375 52.5092L152.239 52.8462C152.103 53.2169 151.933 53.4527 151.456 53.4527C151.252 53.4527 151.183 53.419 151.115 53.419L150.979 54.1604C151.047 54.1941 151.217 54.2278 151.49 54.2278C152.409 54.2278 152.784 53.756 153.091 52.981L154.487 49.2405H153.533L152.852 51.4646H152.818L152.069 49.2405H151.081L152.375 52.5092Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M55.2745 46.3745L58.8165 49.9127L60.6556 48.0931L57.0795 44.5885L60.0085 41.6905L58.1694 39.9045L49.8594 48.1268L58.2375 56.3827L60.0766 54.5967L53.5035 48.1268L55.2745 46.3745Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.613032 41.6925L7.15206 48.1287L5.38107 49.8473L1.8391 46.3427L0 48.1287L3.57603 51.667L0.578975 54.6324L2.41808 56.4183L10.7621 48.1287L2.41808 39.8728L0.613032 41.6925Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M16.0748 56.9915L30.3108 71.0772L44.5808 56.9578L46.3859 55.1719L30.3448 39.3003L28.5398 41.0863L42.7417 55.1719L30.3108 67.4715L16.1088 53.3859H16.0748L4.80176 64.5398L6.64086 66.3595L16.0748 56.9915Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M30.3093 74.5128L16.0733 60.4272L7.93359 68.5146L9.73864 70.3006L16.0733 64.0328L17.8103 65.7514L11.9183 71.5811L13.7234 73.3671L19.6153 67.5374L21.3522 69.2559L16.5161 74.041L18.3552 75.8607L23.1913 71.0756L24.9283 72.7942L21.9312 75.7596L23.7703 77.5456L26.7333 74.5802L30.3093 78.1184L33.8854 74.6139L36.8484 77.5793L38.6875 75.7596L35.6904 72.7942L37.4614 71.0756L42.2975 75.8607L44.1026 74.041L39.2664 69.2559L41.0034 67.5374L46.8953 73.3671L48.7344 71.5811L42.8425 65.7514L44.5453 64.0328L50.88 70.3006L52.7191 68.4809L46.3844 62.2131L48.1214 60.4946L54.0133 66.3243L55.8184 64.5046L48.9728 57.7314L48.1214 56.8889L30.3093 74.5128Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M48.1359 49.8297L46.3057 51.6406L56.4201 61.6482L58.2503 59.8373L48.1359 49.8297Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M28.709 62.417L30.3097 64.0344L39.2668 55.172L37.4617 53.386L25.0308 41.0864L30.3437 35.8632L44.5457 49.9151H44.5797L58.3049 36.335L56.4998 34.5153L44.5797 46.3095L30.3437 32.2239L21.3866 41.0864L35.6226 55.172L30.3097 60.4288L17.9128 48.1292L16.0737 46.3432L2.31445 59.957L4.15356 61.743L16.0737 49.9488L28.709 62.417Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4.17984 34.5475L2.34961 36.3584L12.5363 46.4375L14.3665 44.6266L4.17984 34.5475Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M30.3469 21.7436L44.5829 35.8292L52.6886 27.8092L50.8835 25.9895L44.5829 32.2235L42.846 30.505L48.7039 24.7427L46.8648 22.923L41.0409 28.719L39.27 27.0004L44.038 22.2827L42.233 20.4631L37.4649 25.1807L35.728 23.4622L38.6569 20.5642L36.8178 18.7782L33.8889 21.6425L32.152 19.9239H32.186L30.3469 18.1379L26.7709 21.6762L23.876 18.7782L22.0369 20.5642L24.9658 23.4622L23.2289 25.1807L18.4949 20.5305L16.6899 22.3164L21.3898 27.0004L19.6529 28.719L13.795 22.923L11.99 24.7427L17.8478 30.505L16.0768 32.2235L9.77622 25.9895L7.97117 27.8092L14.2718 34.0432L12.5349 35.7618L6.64294 29.9658L4.83789 31.7518L12.5349 39.3675L30.3469 21.7436Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M30.3466 25.179L14.2715 41.0842L16.0765 42.8702L30.3125 56.9558L32.1516 55.1698L17.9156 41.0842L30.3466 28.7846L44.5826 42.8702L55.7875 31.7837L53.9484 29.9977L44.5826 39.2646L30.3466 25.179Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M77.6833 8.1284C77.6833 6.30873 76.4572 5.66847 75.129 5.06191C74.0732 4.59015 73.2899 4.35427 73.2899 3.57922C73.2899 2.90527 73.8008 2.56829 74.6181 2.56829C75.4696 2.56829 76.2188 2.93897 76.5594 3.17485L77.4109 1.72585C77.0022 1.42257 76.1167 0.917108 74.516 0.917108C72.745 0.917108 71.3146 1.96174 71.3146 3.64662C71.3146 5.23041 72.2341 5.97175 73.4261 6.57831C74.5841 7.15117 75.6399 7.38705 75.6399 8.26319C75.6399 8.90344 75.0609 9.40892 74.0732 9.40892C72.9153 9.40892 72.166 8.83605 71.9617 8.66756L71.0762 10.1166C71.5189 10.4535 72.5406 11.0938 74.1413 11.0938C76.3551 11.0264 77.6833 9.91438 77.6833 8.1284ZM84.3586 10.3861L83.7455 9.07194C83.5071 9.20673 83.0303 9.51 82.1789 9.51C80.9528 9.51 80.3738 8.53278 80.3738 7.21857C80.3738 5.90436 80.9869 4.99452 82.1448 4.99452C82.86 4.99452 83.3368 5.2304 83.6434 5.43259L84.2905 4.08468C83.9499 3.8488 83.2347 3.51183 82.0767 3.51183C79.897 3.51183 78.2623 4.85973 78.2623 7.28596C78.2623 9.51 79.6927 11.0264 82.0086 11.0264C83.3709 11.0264 84.018 10.622 84.3586 10.3861ZM91.6469 10.8579V5.83697C91.6469 4.52276 91.0679 3.51183 89.4672 3.51183C88.2752 3.51183 87.594 4.15208 87.2194 4.55645V0.276855H85.2441V10.8579H87.2194V6.03915C87.3556 5.83697 87.9346 5.12931 88.7179 5.12931C89.4331 5.12931 89.6715 5.49999 89.6715 6.20764V10.8579H91.6469ZM99.9228 7.25226C99.9228 5.39889 98.7649 3.54552 96.2446 3.54552C93.7244 3.54552 92.6345 5.49999 92.6345 7.31966C92.6345 9.17303 93.7244 11.0601 96.2446 11.0601C98.7989 11.0264 99.9228 9.03823 99.9228 7.25226ZM97.8113 7.28596C97.8113 8.63386 97.4026 9.5437 96.2787 9.5437C95.1548 9.5437 94.712 8.56648 94.712 7.21857C94.712 5.87067 95.0867 4.96082 96.2106 4.96082C97.3345 4.96082 97.8113 5.97175 97.8113 7.28596ZM106.905 4.65755C106.632 3.9836 106.087 3.51183 105.031 3.51183C103.873 3.51183 103.226 4.15208 102.852 4.55645V3.68032H100.91V10.8579H102.886V6.03915C103.022 5.83697 103.499 5.16301 104.248 5.16301C104.827 5.16301 105.1 5.53368 105.1 6.24133V10.8579H107.075V5.97175C107.347 5.63478 107.79 5.16301 108.437 5.16301C109.084 5.16301 109.289 5.53368 109.289 6.24133V10.8579H111.264V5.83697C111.264 4.52276 110.719 3.51183 109.186 3.51183C108.165 3.51183 107.484 3.9836 106.905 4.65755ZM112.626 0.276855V10.4535C112.967 10.622 113.954 11.0264 115.589 11.0264C117.769 11.0264 119.438 9.6448 119.438 7.21857C119.438 4.75864 118.178 3.51183 116.373 3.51183C115.555 3.51183 114.942 3.9162 114.602 4.25317V0.276855H112.626ZM114.602 5.60108C114.738 5.46629 115.181 5.06191 115.828 5.06191C116.883 5.06191 117.36 5.87067 117.36 7.21857C117.36 8.70127 116.713 9.51 115.589 9.51C115.044 9.51 114.738 9.37521 114.602 9.34152V5.60108ZM120.425 3.71401V8.73496C120.425 10.0492 121.004 11.0601 122.605 11.0601C123.797 11.0601 124.546 10.4198 124.921 9.91438C124.921 10.2177 125.023 10.6894 125.057 10.8579H126.998C126.896 10.4198 126.794 9.71219 126.794 8.80235V3.71401H124.819V8.49908C124.683 8.66756 124.104 9.40892 123.32 9.40892C122.605 9.40892 122.367 9.03824 122.367 8.33059V3.71401H120.425ZM133.163 3.71401C132.993 3.61292 132.72 3.51183 132.175 3.51183C131.256 3.51183 130.643 4.11839 130.336 4.65755V3.68032H128.361V10.8579H130.336V6.34243C130.506 6.00545 131.017 5.2641 131.903 5.2641C132.311 5.2641 132.55 5.36519 132.652 5.43259L133.163 3.71401ZM137.863 3.71401C137.488 3.57922 137.045 3.54552 136.569 3.54552C134.559 3.54552 133.367 4.59015 133.367 6.14024C133.367 7.08378 133.844 7.82512 134.661 8.29689C134.219 8.53277 133.844 8.97084 133.844 9.64479C133.844 10.1503 134.082 10.4872 134.491 10.7231C133.776 11.0938 133.265 11.6666 133.265 12.4754C133.265 13.7559 134.457 14.3962 136.432 14.3962C138.816 14.3962 140.383 13.3178 140.383 11.8014C140.383 9.67849 138.476 9.67849 136.977 9.61109C135.922 9.5437 135.513 9.4763 135.513 9.10563C135.513 8.90344 135.649 8.76866 135.785 8.66756C136.058 8.70126 136.33 8.73496 136.637 8.73496C138.646 8.73496 139.77 7.69033 139.77 6.14024C139.77 5.73587 139.668 5.3315 139.498 4.99452H140.451V3.71401H137.863ZM136.603 7.45445C135.785 7.45445 135.309 6.94899 135.309 6.14024C135.309 5.2978 135.785 4.82604 136.603 4.82604C137.42 4.82604 137.897 5.2978 137.897 6.14024C137.897 6.94899 137.42 7.45445 136.603 7.45445ZM135.751 11.0938C136.058 11.1275 136.398 11.1612 136.739 11.1949C137.795 11.2623 138.476 11.2286 138.476 12.0036C138.476 12.6102 137.795 13.0483 136.603 13.0483C135.581 13.0483 135.206 12.6439 135.206 12.071C135.172 11.6667 135.377 11.3297 135.751 11.0938ZM151.69 10.0155L150.839 8.56648C150.328 8.93715 149.681 9.30782 148.591 9.30782C146.65 9.30782 145.696 7.75772 145.696 5.90435C145.696 4.08468 146.684 2.63569 148.557 2.63569C149.476 2.63569 150.089 2.87157 150.634 3.20854L151.554 1.69215C150.771 1.18669 149.885 0.917108 148.591 0.917108C145.253 0.917108 143.482 3.30964 143.482 5.97175C143.482 8.63387 145.185 11.0601 148.557 11.0601C150.021 11.0264 151.213 10.4535 151.69 10.0155ZM153.938 7.72403H158.536C158.774 5.06192 157.684 3.51183 155.402 3.51183C153.393 3.51183 151.826 4.96083 151.826 7.21857C151.826 9.51001 153.189 11.0264 155.607 11.0264C157.105 11.0264 157.82 10.5883 158.297 10.3524L157.65 9.07194C157.31 9.24043 156.731 9.5774 155.777 9.5774C154.585 9.5774 154.04 8.83606 153.938 7.72403ZM153.938 6.40982C154.074 5.46629 154.551 4.92712 155.368 4.92712C156.288 4.92712 156.594 5.60108 156.628 6.40982H153.938ZM166.096 10.8579V5.83697C166.096 4.52276 165.517 3.51183 163.917 3.51183C162.725 3.51183 162.01 4.15208 161.601 4.59015V3.68032H159.66V10.8579H161.635V6.03915C161.771 5.83697 162.35 5.12931 163.133 5.12931C163.849 5.12931 164.087 5.49999 164.087 6.20764V10.8579H166.096ZM168.072 5.16301V8.80235C168.072 10.184 168.651 11.0264 170.354 11.0264C171.273 11.0264 171.886 10.7905 172.159 10.622L171.682 9.17303C171.546 9.27412 171.171 9.44261 170.728 9.44261C170.183 9.44261 170.013 9.13933 170.013 8.43168V5.16301H171.716V3.71401H170.013V1.62476H168.038V3.71401H166.88V5.16301H168.072ZM174.475 7.72403H179.072C179.311 5.06192 178.221 3.51183 175.939 3.51183C173.93 3.51183 172.363 4.96083 172.363 7.21857C172.363 9.51001 173.725 11.0264 176.143 11.0264C177.642 11.0264 178.357 10.5883 178.834 10.3524L178.187 9.07194C177.846 9.24043 177.267 9.5774 176.314 9.5774C175.122 9.5774 174.543 8.83606 174.475 7.72403ZM174.475 6.40982C174.611 5.46629 175.088 4.92712 175.905 4.92712C176.825 4.92712 177.131 5.60108 177.165 6.40982H174.475ZM184.998 3.71401C184.828 3.61292 184.556 3.51183 184.011 3.51183C183.091 3.51183 182.512 4.11839 182.172 4.65755V3.68032H180.23V10.8579H182.206V6.34243C182.376 6.00545 182.887 5.2641 183.772 5.2641C184.181 5.2641 184.419 5.36519 184.521 5.43259L184.998 3.71401Z"
    })), $0422a6ce4ea03acc$var$hU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 67 67",
        fill: "#000000",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M60.9072 31.3658L64.81 35.2569L66.8365 33.2558L62.8961 29.4018L66.1234 26.2148L64.097 24.2507L54.9404 33.2928L64.172 42.372L66.1985 40.4079L58.9558 33.2928L60.9072 31.3658Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.675483 26.2157L7.88065 33.2938L5.92925 35.1837L2.02645 31.3297L0 33.2938L3.94033 37.1848L0.637957 40.4459L2.66441 42.41L11.8585 33.2938L2.66441 24.2146L0.675483 26.2157Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M17.7144 43.0401L33.4006 58.5303L49.1244 43.003L51.1133 41.039L33.4382 23.5847L31.4492 25.5488L47.098 41.039L33.4006 54.5651L17.7519 39.0749H17.7144L5.29297 51.341L7.31942 53.3422L17.7144 43.0401Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M33.3974 62.3117L17.7111 46.8215L8.74219 55.7154L10.7311 57.6794L17.7111 50.7867L19.625 52.6766L13.1328 59.0876L15.1218 61.0517L21.6139 54.6407L23.5278 56.5306L18.199 61.7929L20.2254 63.794L25.5543 58.5318L27.4681 60.4217L24.1658 63.6828L26.1922 65.6469L29.4571 62.3858L33.3974 66.2768L37.3377 62.4228L40.6026 65.6839L42.629 63.6828L39.3266 60.4217L41.278 58.5318L46.6069 63.794L48.5958 61.7929L43.267 56.5306L45.1808 54.6407L51.673 61.0517L53.6994 59.0876L47.2073 52.6766L49.0836 50.7867L56.0636 57.6794L58.0901 55.6783L51.1101 48.7856L53.024 46.8956L59.5161 53.3066L61.5051 51.3055L53.9621 43.8569L53.024 42.9304L33.3974 62.3117Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M53.0411 35.1628L51.0244 37.1543L62.1692 48.1598L64.1859 46.1683L53.0411 35.1628Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M31.6351 49.008L33.3989 50.7868L43.2685 41.0406L41.2795 39.0765L27.5822 25.5504L33.4364 19.8065L49.0851 35.2596H49.1227L64.246 20.3253L62.2571 18.3241L49.1227 31.2944L33.4364 15.8042L23.5668 25.5504L39.2531 41.0406L33.3989 46.8216L19.7391 33.2955L17.7126 31.3314L2.55176 46.3028L4.57821 48.2669L17.7126 35.2966L31.6351 49.008Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4.60262 18.3608L2.58594 20.3523L13.8104 31.4364L15.827 29.4449L4.60262 18.3608Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M33.4368 4.27841L49.123 19.7686L58.0544 10.9488L56.0655 8.9477L49.123 15.8034L47.2091 13.9135L53.6638 7.57657L51.6373 5.57544L45.2202 11.9494L43.2688 10.0594L48.5226 4.87134L46.5337 2.87022L41.2799 8.05832L39.366 6.16837L42.5933 2.98139L40.5669 1.01733L37.3396 4.16724L35.4257 2.27729H35.4632L33.4368 0.313232L29.4964 4.20431L26.3066 1.01733L24.2802 2.98139L27.5075 6.16837L25.5936 8.05832L20.3774 2.94434L18.3885 4.9084L23.5672 10.0594L21.6533 11.9494L15.1987 5.57544L13.2098 7.57657L19.6644 13.9135L17.713 15.8034L10.7705 8.9477L8.78158 10.9488L15.7241 17.8045L13.8102 19.6945L7.31803 13.3205L5.3291 15.2846L13.8102 23.6597L33.4368 4.27841Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M33.4363 8.05688L15.7236 25.5482L17.7126 27.5122L33.3988 43.0024L35.4253 41.0384L19.739 25.5482L33.4363 12.0221L49.1226 27.5122L61.469 15.3202L59.4425 13.3562L49.1226 23.5471L33.4363 8.05688Z"
    })), $0422a6ce4ea03acc$var$mU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 67 67",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M60.9072 31.3658L64.81 35.2569L66.8365 33.2558L62.8961 29.4018L66.1234 26.2148L64.097 24.2507L54.9404 33.2928L64.172 42.372L66.1985 40.4079L58.9558 33.2928L60.9072 31.3658Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.675483 26.2157L7.88065 33.2938L5.92925 35.1837L2.02645 31.3297L0 33.2938L3.94033 37.1848L0.637957 40.4459L2.66441 42.41L11.8585 33.2938L2.66441 24.2146L0.675483 26.2157Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M17.7144 43.0401L33.4006 58.5303L49.1244 43.003L51.1133 41.039L33.4382 23.5847L31.4492 25.5488L47.098 41.039L33.4006 54.5651L17.7519 39.0749H17.7144L5.29297 51.341L7.31942 53.3422L17.7144 43.0401Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M33.3974 62.3117L17.7111 46.8215L8.74219 55.7154L10.7311 57.6794L17.7111 50.7867L19.625 52.6766L13.1328 59.0876L15.1218 61.0517L21.6139 54.6407L23.5278 56.5306L18.199 61.7929L20.2254 63.794L25.5543 58.5318L27.4681 60.4217L24.1658 63.6828L26.1922 65.6469L29.4571 62.3858L33.3974 66.2768L37.3377 62.4228L40.6026 65.6839L42.629 63.6828L39.3266 60.4217L41.278 58.5318L46.6069 63.794L48.5958 61.7929L43.267 56.5306L45.1808 54.6407L51.673 61.0517L53.6994 59.0876L47.2073 52.6766L49.0836 50.7867L56.0636 57.6794L58.0901 55.6783L51.1101 48.7856L53.024 46.8956L59.5161 53.3066L61.5051 51.3055L53.9621 43.8569L53.024 42.9304L33.3974 62.3117Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M53.0411 35.1628L51.0244 37.1543L62.1692 48.1598L64.1859 46.1683L53.0411 35.1628Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M31.6351 49.008L33.3989 50.7868L43.2685 41.0406L41.2795 39.0765L27.5822 25.5504L33.4364 19.8065L49.0851 35.2596H49.1227L64.246 20.3253L62.2571 18.3241L49.1227 31.2944L33.4364 15.8042L23.5668 25.5504L39.2531 41.0406L33.3989 46.8216L19.7391 33.2955L17.7126 31.3314L2.55176 46.3028L4.57821 48.2669L17.7126 35.2966L31.6351 49.008Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4.60262 18.3608L2.58594 20.3523L13.8104 31.4364L15.827 29.4449L4.60262 18.3608Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M33.4368 4.27841L49.123 19.7686L58.0544 10.9488L56.0655 8.9477L49.123 15.8034L47.2091 13.9135L53.6638 7.57657L51.6373 5.57544L45.2202 11.9494L43.2688 10.0594L48.5226 4.87134L46.5337 2.87022L41.2799 8.05832L39.366 6.16837L42.5933 2.98139L40.5669 1.01733L37.3396 4.16724L35.4257 2.27729H35.4632L33.4368 0.313232L29.4964 4.20431L26.3066 1.01733L24.2802 2.98139L27.5075 6.16837L25.5936 8.05832L20.3774 2.94434L18.3885 4.9084L23.5672 10.0594L21.6533 11.9494L15.1987 5.57544L13.2098 7.57657L19.6644 13.9135L17.713 15.8034L10.7705 8.9477L8.78158 10.9488L15.7241 17.8045L13.8102 19.6945L7.31803 13.3205L5.3291 15.2846L13.8102 23.6597L33.4368 4.27841Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M33.4363 8.05688L15.7236 25.5482L17.7126 27.5122L33.3988 43.0024L35.4253 41.0384L19.739 25.5482L33.4363 12.0221L49.1226 27.5122L61.469 15.3202L59.4425 13.3562L49.1226 23.5471L33.4363 8.05688Z",
        fill: "#C54B38"
    })), $0422a6ce4ea03acc$var$vU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 67 67",
        fill: "#ffffff",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M60.9072 31.3658L64.81 35.2569L66.8365 33.2558L62.8961 29.4018L66.1234 26.2148L64.097 24.2507L54.9404 33.2928L64.172 42.372L66.1985 40.4079L58.9558 33.2928L60.9072 31.3658Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.675483 26.2157L7.88065 33.2938L5.92925 35.1837L2.02645 31.3297L0 33.2938L3.94033 37.1848L0.637957 40.4459L2.66441 42.41L11.8585 33.2938L2.66441 24.2146L0.675483 26.2157Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M17.7144 43.0401L33.4006 58.5303L49.1244 43.003L51.1133 41.039L33.4382 23.5847L31.4492 25.5488L47.098 41.039L33.4006 54.5651L17.7519 39.0749H17.7144L5.29297 51.341L7.31942 53.3422L17.7144 43.0401Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M33.3974 62.3117L17.7111 46.8215L8.74219 55.7154L10.7311 57.6794L17.7111 50.7867L19.625 52.6766L13.1328 59.0876L15.1218 61.0517L21.6139 54.6407L23.5278 56.5306L18.199 61.7929L20.2254 63.794L25.5543 58.5318L27.4681 60.4217L24.1658 63.6828L26.1922 65.6469L29.4571 62.3858L33.3974 66.2768L37.3377 62.4228L40.6026 65.6839L42.629 63.6828L39.3266 60.4217L41.278 58.5318L46.6069 63.794L48.5958 61.7929L43.267 56.5306L45.1808 54.6407L51.673 61.0517L53.6994 59.0876L47.2073 52.6766L49.0836 50.7867L56.0636 57.6794L58.0901 55.6783L51.1101 48.7856L53.024 46.8956L59.5161 53.3066L61.5051 51.3055L53.9621 43.8569L53.024 42.9304L33.3974 62.3117Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M53.0411 35.1628L51.0244 37.1543L62.1692 48.1598L64.1859 46.1683L53.0411 35.1628Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M31.6351 49.008L33.3989 50.7868L43.2685 41.0406L41.2795 39.0765L27.5822 25.5504L33.4364 19.8065L49.0851 35.2596H49.1227L64.246 20.3253L62.2571 18.3241L49.1227 31.2944L33.4364 15.8042L23.5668 25.5504L39.2531 41.0406L33.3989 46.8216L19.7391 33.2955L17.7126 31.3314L2.55176 46.3028L4.57821 48.2669L17.7126 35.2966L31.6351 49.008Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4.60262 18.3608L2.58594 20.3523L13.8104 31.4364L15.827 29.4449L4.60262 18.3608Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M33.4368 4.27841L49.123 19.7686L58.0544 10.9488L56.0655 8.9477L49.123 15.8034L47.2091 13.9135L53.6638 7.57657L51.6373 5.57544L45.2202 11.9494L43.2688 10.0594L48.5226 4.87134L46.5337 2.87022L41.2799 8.05832L39.366 6.16837L42.5933 2.98139L40.5669 1.01733L37.3396 4.16724L35.4257 2.27729H35.4632L33.4368 0.313232L29.4964 4.20431L26.3066 1.01733L24.2802 2.98139L27.5075 6.16837L25.5936 8.05832L20.3774 2.94434L18.3885 4.9084L23.5672 10.0594L21.6533 11.9494L15.1987 5.57544L13.2098 7.57657L19.6644 13.9135L17.713 15.8034L10.7705 8.9477L8.78158 10.9488L15.7241 17.8045L13.8102 19.6945L7.31803 13.3205L5.3291 15.2846L13.8102 23.6597L33.4368 4.27841Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M33.4363 8.05688L15.7236 25.5482L17.7126 27.5122L33.3988 43.0024L35.4253 41.0384L19.739 25.5482L33.4363 12.0221L49.1226 27.5122L61.469 15.3202L59.4425 13.3562L49.1226 23.5471L33.4363 8.05688Z"
    })), $0422a6ce4ea03acc$var$gU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 185 79",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M72.3064 33.4369C72.647 33.4369 72.9194 33.1673 72.9194 32.8304C72.9194 32.4934 72.647 32.2238 72.3064 32.2238C71.9999 32.2238 71.6934 32.4934 71.6934 32.8304C71.7274 33.1673 71.9999 33.4369 72.3064 33.4369ZM71.9318 42.1646H72.7491V34.9533H71.9318V42.1646ZM74.6904 42.1646H75.4737V36.9078C75.9165 36.2338 76.802 35.4925 77.7215 35.4925C78.8114 35.4925 79.2201 36.1664 79.2201 37.2111V42.1646H80.0034V37.0426C80.0034 35.7284 79.3903 34.7848 77.8918 34.7848C76.8701 34.7848 76.0187 35.3914 75.4737 36.099V34.9533H74.6904V42.1646ZM84.3968 42.1646H86.7127C89.0286 42.1646 90.4931 41.3559 90.4931 39.3677C90.4931 37.9187 89.4373 37.0763 88.1772 36.8404V36.8067C89.3011 36.5371 90.0503 35.7621 90.0503 34.5826C90.0503 32.7967 88.7561 32.089 86.7468 32.089H84.4309V42.1646H84.3968ZM85.2142 41.457V37.2111H86.7468C88.7221 37.2111 89.6416 38.0198 89.6416 39.4014C89.6416 40.8504 88.688 41.4907 86.7127 41.4907H85.2142V41.457ZM85.2142 36.5034V32.7967H86.6446C88.3475 32.7967 89.1989 33.3358 89.1989 34.6163C89.1989 35.8631 88.3815 36.5034 86.6446 36.5034H85.2142ZM92.1619 42.1646H92.9452V31.2803H92.1619V42.1646ZM96.7937 42.3331C97.6792 42.3331 98.4966 41.895 99.0074 41.2548C99.0074 41.5244 99.0755 41.9287 99.1096 42.1646H99.8929C99.7908 41.8613 99.7226 41.3222 99.7226 40.7156V37.0763C99.7226 35.5262 98.8712 34.7848 97.3727 34.7848C96.4191 34.7848 95.6357 35.0881 94.9887 35.6947L95.4314 36.2338C96.0444 35.661 96.6234 35.4588 97.3386 35.4588C98.4285 35.4588 98.9393 35.9979 98.9393 37.1774V37.9861H98.5987C96.8959 37.9861 94.7503 38.5253 94.7503 40.446C94.7503 41.5917 95.5676 42.3331 96.7937 42.3331ZM96.8959 41.6591C96.2488 41.6591 95.5676 41.2211 95.5676 40.446C95.5676 39.0981 96.964 38.6264 98.5987 38.6264H98.9393V40.5471C98.4285 41.2548 97.7132 41.6591 96.8959 41.6591ZM104.354 42.3331C105.444 42.3331 106.228 41.9287 106.602 41.5918L106.262 40.9852C105.955 41.2885 105.24 41.6254 104.389 41.6254C102.754 41.6254 102.039 40.1091 102.039 38.4916C102.039 36.8404 102.788 35.4251 104.389 35.4251C105.206 35.4251 105.751 35.7284 106.159 36.0653L106.568 35.4925C106.16 35.1555 105.478 34.7511 104.389 34.7511C102.515 34.7511 101.187 36.2338 101.187 38.5253C101.221 40.4797 102.277 42.3331 104.354 42.3331ZM112.29 42.1646H113.277L109.872 38.1209L113.107 34.9533H112.12L108.918 38.1209L112.29 42.1646ZM108.067 42.1646H108.85V31.2803H108.067V42.1646ZM121.656 42.3331C122.984 42.3331 124.04 41.895 124.653 41.3222L124.244 40.7156C123.631 41.2548 122.78 41.5918 121.69 41.5918C119.101 41.5918 117.637 39.4351 117.637 37.0426C117.637 34.6837 119.101 32.5608 121.656 32.5608C122.609 32.5608 123.358 32.8304 123.972 33.2347L124.414 32.5945C123.699 32.1227 122.848 31.8531 121.69 31.8531C118.625 31.8531 116.785 34.3131 116.785 37.0426C116.785 39.8732 118.59 42.3331 121.656 42.3331ZM128.365 42.3331C129.591 42.3331 130.442 41.5244 130.783 40.9852C130.783 41.3896 130.851 41.9287 130.885 42.1646H131.703C131.634 41.895 131.566 41.3559 131.566 40.783V34.9533H130.783V40.1764C130.545 40.6145 129.625 41.6254 128.535 41.6254C127.411 41.6254 127.037 40.9515 127.037 39.8732V34.9533H126.253V40.0417C126.253 41.3559 126.832 42.3331 128.365 42.3331ZM134.121 42.1646H134.904V31.2803H134.121V42.1646ZM139.366 42.3331C140.047 42.3331 140.558 42.0635 140.762 41.895L140.455 41.2885C140.319 41.3896 139.876 41.6254 139.434 41.6254C138.787 41.6254 138.548 41.2211 138.548 40.4797V35.5599H140.421V34.9196H138.548V32.8641H137.765V34.9196H136.539V35.5599H137.765V40.5134C137.765 41.6928 138.276 42.3331 139.366 42.3331ZM144.372 42.3331C145.598 42.3331 146.449 41.5244 146.79 40.9852C146.79 41.3896 146.858 41.9287 146.892 42.1646H147.71C147.641 41.895 147.573 41.3559 147.573 40.783V34.9533H146.79V40.1764C146.552 40.6145 145.632 41.6254 144.542 41.6254C143.418 41.6254 143.044 40.9515 143.044 39.8732V34.9533H142.26V40.0417C142.26 41.3559 142.839 42.3331 144.372 42.3331ZM150.128 42.1646H150.911V37.1437C151.115 36.7056 151.762 35.5262 152.784 35.5262C153.091 35.5262 153.261 35.5936 153.397 35.6273L153.602 34.8859C153.465 34.8522 153.227 34.7511 152.886 34.7511C151.865 34.7511 151.217 35.661 150.945 36.1664V34.9196H150.162V42.1646H150.128ZM157.484 42.3331C158.676 42.3331 159.493 41.9287 159.97 41.5918L159.63 40.9852C159.221 41.2885 158.438 41.6591 157.518 41.6591C155.781 41.6591 155.066 40.1427 155.066 38.4916V38.3231H160.106C160.106 38.1883 160.106 38.0535 160.106 37.9187C160.106 36.0653 159.085 34.7848 157.348 34.7848C155.407 34.7848 154.215 36.436 154.215 38.4916C154.215 40.5471 155.236 42.3331 157.484 42.3331ZM155.1 37.6828C155.304 36.436 156.054 35.4588 157.314 35.4588C158.71 35.4588 159.289 36.5708 159.289 37.6828H155.1Z",
        fill: "#010101"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M72.1 26.5291H72.8833V19.9581H74.7905V19.3178H72.8833V18.1721C72.8833 16.8579 73.4282 16.184 74.5521 16.184C74.9949 16.184 75.3014 16.2851 75.4717 16.3861L75.676 15.6785C75.4717 15.5774 75.097 15.4763 74.5521 15.4763C72.9514 15.4763 72.1 16.4535 72.1 18.1047V19.3178H70.8398V19.9581H72.1V26.5291ZM78.8774 26.6976C81.1593 26.6976 82.215 24.7095 82.215 22.8898C82.215 21.1038 81.1593 19.1494 78.8774 19.1494C76.5956 19.1494 75.6079 21.1038 75.6079 22.9235C75.6079 24.7432 76.5956 26.6976 78.8774 26.6976ZM78.9115 26.0237C77.2426 26.0237 76.4593 24.541 76.4593 22.8898C76.4593 21.2723 77.2086 19.8233 78.8774 19.8233C80.5462 19.8233 81.4317 21.306 81.4317 22.9235C81.3977 24.5747 80.5803 26.0237 78.9115 26.0237ZM83.7476 26.5291H84.5309V21.5082C84.7353 21.0701 85.3824 19.8907 86.4041 19.8907C86.7106 19.8907 86.8809 19.9581 87.0171 19.9918L87.2215 19.2504C87.0852 19.2167 86.8468 19.1157 86.5063 19.1157C85.4845 19.1157 84.8375 19.9918 84.565 20.531V19.2841H83.7817V26.5291H83.7476ZM92.1939 26.5291H93.0453V21.643H93.3178C93.9308 21.643 94.1011 21.7441 95.1228 23.1257L97.609 26.5291H98.6307L95.804 22.7213C95.225 21.98 95.0206 21.7104 94.8163 21.6093H94.9525C96.7235 21.5419 97.9496 20.6994 97.9496 19.0483C97.9496 17.3634 96.6895 16.4535 94.646 16.4535H92.2279V26.5291H92.1939ZM93.0112 20.969V17.1612H94.4757C96.1445 17.1612 97.03 17.8014 97.03 19.0483C97.03 20.2951 96.1786 20.969 94.5438 20.969H93.0112ZM102.615 26.6976C103.807 26.6976 104.625 26.2933 105.102 25.9563L104.761 25.3497C104.352 25.653 103.569 26.0237 102.65 26.0237C100.913 26.0237 100.197 24.5073 100.197 22.8561V22.6876H105.238C105.238 22.5528 105.238 22.418 105.238 22.2832C105.238 20.4299 104.216 19.1494 102.479 19.1494C100.538 19.1494 99.3459 20.8005 99.3459 22.8561C99.3459 24.9454 100.402 26.6976 102.615 26.6976ZM100.231 22.0474C100.436 20.8005 101.185 19.8233 102.445 19.8233C103.842 19.8233 104.386 20.9353 104.42 22.0474H100.231ZM108.678 26.7313C110.176 26.7313 111.13 25.9563 111.13 24.7095C111.13 23.5301 110.108 23.0246 108.984 22.5191C108.133 22.1484 107.418 21.8452 107.418 21.0027C107.418 20.2951 107.894 19.8233 108.78 19.8233C109.529 19.8233 110.108 20.1266 110.449 20.3962L110.857 19.8233C110.517 19.5537 109.802 19.1494 108.78 19.1494C107.418 19.1494 106.634 19.9581 106.634 21.0364C106.634 22.2158 107.554 22.7213 108.644 23.1931C109.631 23.6311 110.312 23.9681 110.312 24.7769C110.312 25.5519 109.665 26.0237 108.678 26.0237C107.894 26.0237 107.145 25.6867 106.805 25.4171L106.464 26.0237C106.907 26.3607 107.724 26.7313 108.678 26.7313ZM115.694 26.6976C116.886 26.6976 117.703 26.2933 118.18 25.9563L117.839 25.3497C117.43 25.653 116.647 26.0237 115.728 26.0237C113.991 26.0237 113.275 24.5073 113.275 22.8561V22.6876H118.316C118.316 22.5528 118.316 22.418 118.316 22.2832C118.316 20.4299 117.294 19.1494 115.557 19.1494C113.616 19.1494 112.424 20.8005 112.424 22.8561C112.424 24.9454 113.48 26.6976 115.694 26.6976ZM113.309 22.0474C113.514 20.8005 114.263 19.8233 115.523 19.8233C116.92 19.8233 117.464 20.9353 117.499 22.0474H113.309ZM121.688 26.6976C122.573 26.6976 123.39 26.2596 123.901 25.6193C123.901 25.8889 123.969 26.2933 124.004 26.5291H124.787C124.685 26.2259 124.651 25.6867 124.651 25.0801V21.4408C124.651 19.8907 123.799 19.1494 122.301 19.1494C121.347 19.1494 120.564 19.4526 119.917 20.0592L120.359 20.5984C120.972 20.0255 121.551 19.8233 122.267 19.8233C123.356 19.8233 123.867 20.3625 123.867 21.5419V22.3506H123.527C121.824 22.3506 119.678 22.8898 119.678 24.8106C119.644 25.9563 120.462 26.6976 121.688 26.6976ZM121.79 26.0237C121.143 26.0237 120.462 25.5856 120.462 24.8106C120.462 23.4627 121.858 22.9909 123.493 22.9909H123.833V24.9117C123.288 25.6193 122.607 26.0237 121.79 26.0237ZM127.103 26.5291H127.886V21.5082C128.09 21.0701 128.737 19.8907 129.759 19.8907C130.066 19.8907 130.236 19.9581 130.372 19.9918L130.577 19.2504C130.44 19.2167 130.202 19.1157 129.861 19.1157C128.84 19.1157 128.193 19.9918 127.92 20.531V19.2841H127.103V26.5291ZM134.289 26.6976C135.379 26.6976 136.162 26.2933 136.537 25.9563L136.196 25.3497C135.89 25.653 135.174 25.99 134.323 25.99C132.688 25.99 131.973 24.4736 131.973 22.8561C131.973 21.2049 132.722 19.7896 134.323 19.7896C135.14 19.7896 135.685 20.0929 136.094 20.4299L136.503 19.857C136.094 19.52 135.413 19.1157 134.323 19.1157C132.45 19.1157 131.122 20.5984 131.122 22.8898C131.156 24.8443 132.177 26.6976 134.289 26.6976ZM138.274 26.5291H139.057V21.2723C139.329 20.8679 140.215 19.857 141.305 19.857C142.395 19.857 142.803 20.531 142.803 21.5756V26.5291H143.587V21.4071C143.587 20.0929 142.974 19.1494 141.475 19.1494C140.249 19.1494 139.397 19.9581 139.057 20.4636V15.6448H138.274V26.5291Z",
        fill: "#010101"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M74.452 48.7688V47.96H70.876V48.7688H72.1702V52.5766H73.1578V48.7688H74.452ZM77.8918 52.5766V50.2178C77.8918 49.6112 77.6194 49.1394 76.8701 49.1394C76.3252 49.1394 75.9846 49.4427 75.8143 49.6449V47.6231H74.8948V52.6103H75.8143V50.2852C75.8824 50.1841 76.1549 49.8471 76.5295 49.8471C76.8701 49.8471 76.9723 50.0156 76.9723 50.3526V52.5429H77.8918V52.5766ZM79.4244 51.0939H81.6041C81.7062 49.8471 81.1954 49.1057 80.1396 49.1057C79.186 49.1057 78.4367 49.7797 78.4367 50.858C78.4367 51.9364 79.0838 52.644 80.2077 52.644C80.9229 52.644 81.2635 52.4418 81.4678 52.307L81.1613 51.7005C80.991 51.7679 80.7186 51.9363 80.2758 51.9363C79.7309 51.97 79.4585 51.5994 79.4244 51.0939ZM79.4244 50.4537C79.4925 50.0156 79.6969 49.746 80.1055 49.746C80.5483 49.746 80.6845 50.0493 80.6845 50.4537H79.4244ZM87.9047 52.5766V47.96H87.0192V50.3863C87.0192 50.7569 87.0533 51.0939 87.0533 51.1276C87.0533 51.1276 86.8489 50.7569 86.5765 50.3526L84.9076 47.96H83.8519V52.5766H84.7374V49.9482C84.7374 49.6449 84.7033 49.3416 84.7033 49.3416C84.7033 49.3416 84.8736 49.6786 85.146 50.0493L86.9511 52.6103H87.9047V52.5766ZM89.4713 51.0939H91.651C91.7532 49.8471 91.2423 49.1057 90.1865 49.1057C89.2329 49.1057 88.4837 49.7797 88.4837 50.858C88.4837 51.9364 89.1308 52.644 90.2547 52.644C90.9699 52.644 91.3104 52.4418 91.5148 52.307L91.2083 51.7005C91.038 51.7679 90.7655 51.9363 90.3228 51.9363C89.7779 51.97 89.5054 51.5994 89.4713 51.0939ZM89.4713 50.4537C89.5395 50.0156 89.7438 49.746 90.1525 49.746C90.5952 49.746 90.7315 50.0493 90.7315 50.4537H89.4713ZM96.8959 49.2068H95.9763L95.4314 51.3635L94.8524 49.2068H94.001L93.422 51.3635L92.9111 49.2068H91.9235L92.8771 52.5766H93.7285L94.4437 50.3189L95.1589 52.5766H96.0104L96.8959 49.2068ZM102.447 47.96H101.494L100.506 49.9145L99.5183 47.96H98.4284L99.961 50.8243V52.5766H100.949V50.8243L102.447 47.96ZM105.478 50.858C105.478 49.9819 104.933 49.1057 103.741 49.1057C102.549 49.1057 102.039 50.0156 102.039 50.8917C102.039 51.7679 102.549 52.644 103.741 52.644C104.967 52.644 105.478 51.7005 105.478 50.858ZM104.491 50.8917C104.491 51.532 104.286 51.9363 103.775 51.9363C103.265 51.9363 103.026 51.4646 103.026 50.858C103.026 50.2515 103.196 49.7797 103.741 49.7797C104.252 49.7797 104.491 50.2515 104.491 50.8917ZM108.271 49.2068C108.203 49.1731 108.067 49.1057 107.794 49.1057C107.351 49.1057 107.079 49.409 106.943 49.6449V49.1731H106.023V52.5429H106.943V50.42C107.011 50.2515 107.283 49.9145 107.692 49.9145C107.896 49.9145 107.999 49.9482 108.033 49.9819L108.271 49.2068ZM109.599 50.9254L110.689 52.5766H111.779L110.485 50.7232L111.745 49.2068H110.723L109.599 50.5547V47.5894H108.68V52.5766H109.599V50.9254ZM117.16 49.409C117.16 48.4318 116.377 47.96 115.389 47.96H113.856V52.5766H114.844V50.9254H115.287C116.445 50.9254 117.16 50.42 117.16 49.409ZM116.172 49.409C116.172 49.9145 115.9 50.1841 115.287 50.1841H114.844V48.7014H115.321C115.934 48.7014 116.172 48.971 116.172 49.409ZM117.637 49.2068V51.5657C117.637 52.1722 117.909 52.644 118.659 52.644C119.238 52.644 119.578 52.3407 119.748 52.1048C119.748 52.2396 119.782 52.4755 119.817 52.5429H120.736C120.702 52.3407 120.634 52.0037 120.634 51.5657V49.1731H119.714V51.4309C119.646 51.4983 119.374 51.869 118.999 51.869C118.659 51.869 118.556 51.7005 118.556 51.3635V49.1731H117.637V49.2068ZM121.417 47.5894V52.3744C121.587 52.4418 122.03 52.644 122.814 52.644C123.835 52.644 124.619 52.0038 124.619 50.858C124.619 49.6786 124.04 49.1057 123.154 49.1057C122.78 49.1057 122.473 49.3079 122.337 49.4427V47.5894H121.417ZM122.371 50.083C122.439 50.0156 122.643 49.8134 122.95 49.8134C123.461 49.8134 123.665 50.1841 123.665 50.8243C123.665 51.532 123.358 51.9026 122.848 51.9026C122.575 51.9026 122.439 51.8353 122.371 51.8353V50.083ZM126.185 47.5894H125.266V52.5766H126.185V47.5894ZM128.058 49.2068H127.105V52.5766H128.058V49.2068ZM128.161 48.1959C128.161 47.8926 127.922 47.6568 127.582 47.6568C127.241 47.6568 127.003 47.8926 127.003 48.1959C127.003 48.4992 127.241 48.7351 127.582 48.7351C127.922 48.7688 128.161 48.4992 128.161 48.1959ZM131.6 52.3407L131.328 51.7342C131.226 51.8016 130.987 51.9363 130.579 51.9363C130 51.9363 129.727 51.4646 129.727 50.858C129.727 50.2515 130 49.8134 130.545 49.8134C130.885 49.8134 131.09 49.9145 131.26 50.0156L131.566 49.3753C131.396 49.2742 131.09 49.1057 130.511 49.1057C129.489 49.1057 128.706 49.746 128.706 50.8917C128.706 51.9363 129.387 52.644 130.476 52.644C131.124 52.644 131.43 52.4418 131.6 52.3407ZM136.505 52.5766V51.8016H134.768V47.9937H133.78V52.6103H136.505V52.5766ZM138.003 49.2068H137.05V52.5766H138.003V49.2068ZM138.105 48.1959C138.105 47.8926 137.867 47.6568 137.526 47.6568C137.186 47.6568 136.947 47.8926 136.947 48.1959C136.947 48.4992 137.186 48.7351 137.526 48.7351C137.867 48.7688 138.105 48.4992 138.105 48.1959ZM138.889 47.5894V52.3744C139.059 52.4418 139.502 52.644 140.285 52.644C141.307 52.644 142.09 52.0038 142.09 50.858C142.09 49.6786 141.511 49.1057 140.626 49.1057C140.251 49.1057 139.944 49.3079 139.808 49.4427V47.5894H138.889ZM139.842 50.083C139.91 50.0156 140.115 49.8134 140.421 49.8134C140.932 49.8134 141.136 50.1841 141.136 50.8243C141.136 51.532 140.83 51.9026 140.319 51.9026C140.047 51.9026 139.91 51.8353 139.842 51.8353V50.083ZM144.917 49.2068C144.849 49.1731 144.713 49.1057 144.44 49.1057C143.997 49.1057 143.725 49.409 143.589 49.6449V49.1731H142.669V52.5429H143.589V50.42C143.657 50.2515 143.929 49.9145 144.338 49.9145C144.542 49.9145 144.644 49.9482 144.678 49.9819L144.917 49.2068ZM148.05 52.5766C148.016 52.3744 147.948 52.0374 147.948 51.5657V50.3526C147.948 49.4427 147.505 49.1057 146.586 49.1057C145.87 49.1057 145.394 49.409 145.189 49.5775L145.598 50.1504C145.734 50.0493 146.041 49.8471 146.483 49.8471C146.926 49.8471 147.028 50.0156 147.028 50.3189V50.5211H146.892C145.973 50.5211 145.087 50.8243 145.087 51.7342C145.087 52.3407 145.53 52.6777 146.109 52.6777C146.586 52.6777 146.926 52.4081 147.062 52.2396C147.062 52.3407 147.097 52.5092 147.131 52.6103H148.05V52.5766ZM147.028 51.6668C146.926 51.7679 146.722 51.97 146.415 51.97C146.211 51.97 146.007 51.869 146.007 51.6331C146.007 51.2287 146.381 51.0939 146.926 51.0939H147.062V51.6668H147.028ZM150.979 49.2068C150.911 49.1731 150.775 49.1057 150.502 49.1057C150.06 49.1057 149.787 49.409 149.651 49.6449V49.1731H148.731V52.5429H149.651V50.42C149.719 50.2515 149.991 49.9145 150.4 49.9145C150.604 49.9145 150.707 49.9482 150.741 49.9819L150.979 49.2068ZM152.375 52.5092L152.239 52.8462C152.103 53.2169 151.933 53.4527 151.456 53.4527C151.252 53.4527 151.183 53.419 151.115 53.419L150.979 54.1604C151.047 54.1941 151.217 54.2278 151.49 54.2278C152.409 54.2278 152.784 53.756 153.091 52.981L154.487 49.2405H153.533L152.852 51.4646H152.818L152.069 49.2405H151.081L152.375 52.5092Z",
        fill: "#010101"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M55.2745 46.3745L58.8165 49.9127L60.6556 48.0931L57.0795 44.5885L60.0085 41.6905L58.1694 39.9045L49.8594 48.1268L58.2375 56.3827L60.0766 54.5967L53.5035 48.1268L55.2745 46.3745Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.613032 41.6925L7.15206 48.1287L5.38107 49.8473L1.8391 46.3427L0 48.1287L3.57603 51.667L0.578975 54.6324L2.41808 56.4183L10.7621 48.1287L2.41808 39.8728L0.613032 41.6925Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M16.0748 56.9915L30.3108 71.0772L44.5808 56.9578L46.3859 55.1719L30.3448 39.3003L28.5398 41.0863L42.7417 55.1719L30.3108 67.4715L16.1088 53.3859H16.0748L4.80176 64.5398L6.64086 66.3595L16.0748 56.9915Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M30.3093 74.5128L16.0733 60.4272L7.93359 68.5146L9.73864 70.3006L16.0733 64.0328L17.8103 65.7514L11.9183 71.5811L13.7234 73.3671L19.6153 67.5374L21.3522 69.2559L16.5161 74.041L18.3552 75.8607L23.1913 71.0756L24.9283 72.7942L21.9312 75.7596L23.7703 77.5456L26.7333 74.5802L30.3093 78.1184L33.8854 74.6139L36.8484 77.5793L38.6875 75.7596L35.6904 72.7942L37.4614 71.0756L42.2975 75.8607L44.1026 74.041L39.2664 69.2559L41.0034 67.5374L46.8953 73.3671L48.7344 71.5811L42.8425 65.7514L44.5453 64.0328L50.88 70.3006L52.7191 68.4809L46.3844 62.2131L48.1214 60.4946L54.0133 66.3243L55.8184 64.5046L48.9728 57.7314L48.1214 56.8889L30.3093 74.5128Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M48.1359 49.8297L46.3057 51.6406L56.4201 61.6482L58.2503 59.8373L48.1359 49.8297Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M28.709 62.417L30.3097 64.0344L39.2668 55.172L37.4617 53.386L25.0308 41.0864L30.3437 35.8632L44.5457 49.9151H44.5797L58.3049 36.335L56.4998 34.5153L44.5797 46.3095L30.3437 32.2239L21.3866 41.0864L35.6226 55.172L30.3097 60.4288L17.9128 48.1292L16.0737 46.3432L2.31445 59.957L4.15356 61.743L16.0737 49.9488L28.709 62.417Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4.17984 34.5475L2.34961 36.3584L12.5363 46.4375L14.3665 44.6266L4.17984 34.5475Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M30.3469 21.7436L44.5829 35.8292L52.6886 27.8092L50.8835 25.9895L44.5829 32.2235L42.846 30.505L48.7039 24.7427L46.8648 22.923L41.0409 28.719L39.27 27.0004L44.038 22.2827L42.233 20.4631L37.4649 25.1807L35.728 23.4622L38.6569 20.5642L36.8178 18.7782L33.8889 21.6425L32.152 19.9239H32.186L30.3469 18.1379L26.7709 21.6762L23.876 18.7782L22.0369 20.5642L24.9658 23.4622L23.2289 25.1807L18.4949 20.5305L16.6899 22.3164L21.3898 27.0004L19.6529 28.719L13.795 22.923L11.99 24.7427L17.8478 30.505L16.0768 32.2235L9.77622 25.9895L7.97117 27.8092L14.2718 34.0432L12.5349 35.7618L6.64294 29.9658L4.83789 31.7518L12.5349 39.3675L30.3469 21.7436Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M30.3466 25.179L14.2715 41.0842L16.0765 42.8702L30.3125 56.9558L32.1516 55.1698L17.9156 41.0842L30.3466 28.7846L44.5826 42.8702L55.7875 31.7837L53.9484 29.9977L44.5826 39.2646L30.3466 25.179Z",
        fill: "#C54B38"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M77.6833 8.1284C77.6833 6.30873 76.4572 5.66847 75.129 5.06191C74.0732 4.59015 73.2899 4.35427 73.2899 3.57922C73.2899 2.90527 73.8008 2.56829 74.6181 2.56829C75.4696 2.56829 76.2188 2.93897 76.5594 3.17485L77.4109 1.72585C77.0022 1.42257 76.1167 0.917108 74.516 0.917108C72.745 0.917108 71.3146 1.96174 71.3146 3.64662C71.3146 5.23041 72.2341 5.97175 73.4261 6.57831C74.5841 7.15117 75.6399 7.38705 75.6399 8.26319C75.6399 8.90344 75.0609 9.40892 74.0732 9.40892C72.9153 9.40892 72.166 8.83605 71.9617 8.66756L71.0762 10.1166C71.5189 10.4535 72.5406 11.0938 74.1413 11.0938C76.3551 11.0264 77.6833 9.91438 77.6833 8.1284ZM84.3586 10.3861L83.7455 9.07194C83.5071 9.20673 83.0303 9.51 82.1789 9.51C80.9528 9.51 80.3738 8.53278 80.3738 7.21857C80.3738 5.90436 80.9869 4.99452 82.1448 4.99452C82.86 4.99452 83.3368 5.2304 83.6434 5.43259L84.2905 4.08468C83.9499 3.8488 83.2347 3.51183 82.0767 3.51183C79.897 3.51183 78.2623 4.85973 78.2623 7.28596C78.2623 9.51 79.6927 11.0264 82.0086 11.0264C83.3709 11.0264 84.018 10.622 84.3586 10.3861ZM91.6469 10.8579V5.83697C91.6469 4.52276 91.0679 3.51183 89.4672 3.51183C88.2752 3.51183 87.594 4.15208 87.2194 4.55645V0.276855H85.2441V10.8579H87.2194V6.03915C87.3556 5.83697 87.9346 5.12931 88.7179 5.12931C89.4331 5.12931 89.6715 5.49999 89.6715 6.20764V10.8579H91.6469ZM99.9228 7.25226C99.9228 5.39889 98.7649 3.54552 96.2446 3.54552C93.7244 3.54552 92.6345 5.49999 92.6345 7.31966C92.6345 9.17303 93.7244 11.0601 96.2446 11.0601C98.7989 11.0264 99.9228 9.03823 99.9228 7.25226ZM97.8113 7.28596C97.8113 8.63386 97.4026 9.5437 96.2787 9.5437C95.1548 9.5437 94.712 8.56648 94.712 7.21857C94.712 5.87067 95.0867 4.96082 96.2106 4.96082C97.3345 4.96082 97.8113 5.97175 97.8113 7.28596ZM106.905 4.65755C106.632 3.9836 106.087 3.51183 105.031 3.51183C103.873 3.51183 103.226 4.15208 102.852 4.55645V3.68032H100.91V10.8579H102.886V6.03915C103.022 5.83697 103.499 5.16301 104.248 5.16301C104.827 5.16301 105.1 5.53368 105.1 6.24133V10.8579H107.075V5.97175C107.347 5.63478 107.79 5.16301 108.437 5.16301C109.084 5.16301 109.289 5.53368 109.289 6.24133V10.8579H111.264V5.83697C111.264 4.52276 110.719 3.51183 109.186 3.51183C108.165 3.51183 107.484 3.9836 106.905 4.65755ZM112.626 0.276855V10.4535C112.967 10.622 113.954 11.0264 115.589 11.0264C117.769 11.0264 119.438 9.6448 119.438 7.21857C119.438 4.75864 118.178 3.51183 116.373 3.51183C115.555 3.51183 114.942 3.9162 114.602 4.25317V0.276855H112.626ZM114.602 5.60108C114.738 5.46629 115.181 5.06191 115.828 5.06191C116.883 5.06191 117.36 5.87067 117.36 7.21857C117.36 8.70127 116.713 9.51 115.589 9.51C115.044 9.51 114.738 9.37521 114.602 9.34152V5.60108ZM120.425 3.71401V8.73496C120.425 10.0492 121.004 11.0601 122.605 11.0601C123.797 11.0601 124.546 10.4198 124.921 9.91438C124.921 10.2177 125.023 10.6894 125.057 10.8579H126.998C126.896 10.4198 126.794 9.71219 126.794 8.80235V3.71401H124.819V8.49908C124.683 8.66756 124.104 9.40892 123.32 9.40892C122.605 9.40892 122.367 9.03824 122.367 8.33059V3.71401H120.425ZM133.163 3.71401C132.993 3.61292 132.72 3.51183 132.175 3.51183C131.256 3.51183 130.643 4.11839 130.336 4.65755V3.68032H128.361V10.8579H130.336V6.34243C130.506 6.00545 131.017 5.2641 131.903 5.2641C132.311 5.2641 132.55 5.36519 132.652 5.43259L133.163 3.71401ZM137.863 3.71401C137.488 3.57922 137.045 3.54552 136.569 3.54552C134.559 3.54552 133.367 4.59015 133.367 6.14024C133.367 7.08378 133.844 7.82512 134.661 8.29689C134.219 8.53277 133.844 8.97084 133.844 9.64479C133.844 10.1503 134.082 10.4872 134.491 10.7231C133.776 11.0938 133.265 11.6666 133.265 12.4754C133.265 13.7559 134.457 14.3962 136.432 14.3962C138.816 14.3962 140.383 13.3178 140.383 11.8014C140.383 9.67849 138.476 9.67849 136.977 9.61109C135.922 9.5437 135.513 9.4763 135.513 9.10563C135.513 8.90344 135.649 8.76866 135.785 8.66756C136.058 8.70126 136.33 8.73496 136.637 8.73496C138.646 8.73496 139.77 7.69033 139.77 6.14024C139.77 5.73587 139.668 5.3315 139.498 4.99452H140.451V3.71401H137.863ZM136.603 7.45445C135.785 7.45445 135.309 6.94899 135.309 6.14024C135.309 5.2978 135.785 4.82604 136.603 4.82604C137.42 4.82604 137.897 5.2978 137.897 6.14024C137.897 6.94899 137.42 7.45445 136.603 7.45445ZM135.751 11.0938C136.058 11.1275 136.398 11.1612 136.739 11.1949C137.795 11.2623 138.476 11.2286 138.476 12.0036C138.476 12.6102 137.795 13.0483 136.603 13.0483C135.581 13.0483 135.206 12.6439 135.206 12.071C135.172 11.6667 135.377 11.3297 135.751 11.0938ZM151.69 10.0155L150.839 8.56648C150.328 8.93715 149.681 9.30782 148.591 9.30782C146.65 9.30782 145.696 7.75772 145.696 5.90435C145.696 4.08468 146.684 2.63569 148.557 2.63569C149.476 2.63569 150.089 2.87157 150.634 3.20854L151.554 1.69215C150.771 1.18669 149.885 0.917108 148.591 0.917108C145.253 0.917108 143.482 3.30964 143.482 5.97175C143.482 8.63387 145.185 11.0601 148.557 11.0601C150.021 11.0264 151.213 10.4535 151.69 10.0155ZM153.938 7.72403H158.536C158.774 5.06192 157.684 3.51183 155.402 3.51183C153.393 3.51183 151.826 4.96083 151.826 7.21857C151.826 9.51001 153.189 11.0264 155.607 11.0264C157.105 11.0264 157.82 10.5883 158.297 10.3524L157.65 9.07194C157.31 9.24043 156.731 9.5774 155.777 9.5774C154.585 9.5774 154.04 8.83606 153.938 7.72403ZM153.938 6.40982C154.074 5.46629 154.551 4.92712 155.368 4.92712C156.288 4.92712 156.594 5.60108 156.628 6.40982H153.938ZM166.096 10.8579V5.83697C166.096 4.52276 165.517 3.51183 163.917 3.51183C162.725 3.51183 162.01 4.15208 161.601 4.59015V3.68032H159.66V10.8579H161.635V6.03915C161.771 5.83697 162.35 5.12931 163.133 5.12931C163.849 5.12931 164.087 5.49999 164.087 6.20764V10.8579H166.096ZM168.072 5.16301V8.80235C168.072 10.184 168.651 11.0264 170.354 11.0264C171.273 11.0264 171.886 10.7905 172.159 10.622L171.682 9.17303C171.546 9.27412 171.171 9.44261 170.728 9.44261C170.183 9.44261 170.013 9.13933 170.013 8.43168V5.16301H171.716V3.71401H170.013V1.62476H168.038V3.71401H166.88V5.16301H168.072ZM174.475 7.72403H179.072C179.311 5.06192 178.221 3.51183 175.939 3.51183C173.93 3.51183 172.363 4.96083 172.363 7.21857C172.363 9.51001 173.725 11.0264 176.143 11.0264C177.642 11.0264 178.357 10.5883 178.834 10.3524L178.187 9.07194C177.846 9.24043 177.267 9.5774 176.314 9.5774C175.122 9.5774 174.543 8.83606 174.475 7.72403ZM174.475 6.40982C174.611 5.46629 175.088 4.92712 175.905 4.92712C176.825 4.92712 177.131 5.60108 177.165 6.40982H174.475ZM184.998 3.71401C184.828 3.61292 184.556 3.51183 184.011 3.51183C183.091 3.51183 182.512 4.11839 182.172 4.65755V3.68032H180.23V10.8579H182.206V6.34243C182.376 6.00545 182.887 5.2641 183.772 5.2641C184.181 5.2641 184.419 5.36519 184.521 5.43259L184.998 3.71401Z",
        fill: "#010101"
    })), $0422a6ce4ea03acc$var$yU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 185 79",
        fill: "#ffffff",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M72.3064 33.4369C72.647 33.4369 72.9194 33.1673 72.9194 32.8304C72.9194 32.4934 72.647 32.2238 72.3064 32.2238C71.9999 32.2238 71.6934 32.4934 71.6934 32.8304C71.7274 33.1673 71.9999 33.4369 72.3064 33.4369ZM71.9318 42.1646H72.7491V34.9533H71.9318V42.1646ZM74.6904 42.1646H75.4737V36.9078C75.9165 36.2338 76.802 35.4925 77.7215 35.4925C78.8114 35.4925 79.2201 36.1664 79.2201 37.2111V42.1646H80.0034V37.0426C80.0034 35.7284 79.3903 34.7848 77.8918 34.7848C76.8701 34.7848 76.0187 35.3914 75.4737 36.099V34.9533H74.6904V42.1646ZM84.3968 42.1646H86.7127C89.0286 42.1646 90.4931 41.3559 90.4931 39.3677C90.4931 37.9187 89.4373 37.0763 88.1772 36.8404V36.8067C89.3011 36.5371 90.0503 35.7621 90.0503 34.5826C90.0503 32.7967 88.7561 32.089 86.7468 32.089H84.4309V42.1646H84.3968ZM85.2142 41.457V37.2111H86.7468C88.7221 37.2111 89.6416 38.0198 89.6416 39.4014C89.6416 40.8504 88.688 41.4907 86.7127 41.4907H85.2142V41.457ZM85.2142 36.5034V32.7967H86.6446C88.3475 32.7967 89.1989 33.3358 89.1989 34.6163C89.1989 35.8631 88.3815 36.5034 86.6446 36.5034H85.2142ZM92.1619 42.1646H92.9452V31.2803H92.1619V42.1646ZM96.7937 42.3331C97.6792 42.3331 98.4966 41.895 99.0074 41.2548C99.0074 41.5244 99.0755 41.9287 99.1096 42.1646H99.8929C99.7908 41.8613 99.7226 41.3222 99.7226 40.7156V37.0763C99.7226 35.5262 98.8712 34.7848 97.3727 34.7848C96.4191 34.7848 95.6357 35.0881 94.9887 35.6947L95.4314 36.2338C96.0444 35.661 96.6234 35.4588 97.3386 35.4588C98.4285 35.4588 98.9393 35.9979 98.9393 37.1774V37.9861H98.5987C96.8959 37.9861 94.7503 38.5253 94.7503 40.446C94.7503 41.5917 95.5676 42.3331 96.7937 42.3331ZM96.8959 41.6591C96.2488 41.6591 95.5676 41.2211 95.5676 40.446C95.5676 39.0981 96.964 38.6264 98.5987 38.6264H98.9393V40.5471C98.4285 41.2548 97.7132 41.6591 96.8959 41.6591ZM104.354 42.3331C105.444 42.3331 106.228 41.9287 106.602 41.5918L106.262 40.9852C105.955 41.2885 105.24 41.6254 104.389 41.6254C102.754 41.6254 102.039 40.1091 102.039 38.4916C102.039 36.8404 102.788 35.4251 104.389 35.4251C105.206 35.4251 105.751 35.7284 106.159 36.0653L106.568 35.4925C106.16 35.1555 105.478 34.7511 104.389 34.7511C102.515 34.7511 101.187 36.2338 101.187 38.5253C101.221 40.4797 102.277 42.3331 104.354 42.3331ZM112.29 42.1646H113.277L109.872 38.1209L113.107 34.9533H112.12L108.918 38.1209L112.29 42.1646ZM108.067 42.1646H108.85V31.2803H108.067V42.1646ZM121.656 42.3331C122.984 42.3331 124.04 41.895 124.653 41.3222L124.244 40.7156C123.631 41.2548 122.78 41.5918 121.69 41.5918C119.101 41.5918 117.637 39.4351 117.637 37.0426C117.637 34.6837 119.101 32.5608 121.656 32.5608C122.609 32.5608 123.358 32.8304 123.972 33.2347L124.414 32.5945C123.699 32.1227 122.848 31.8531 121.69 31.8531C118.625 31.8531 116.785 34.3131 116.785 37.0426C116.785 39.8732 118.59 42.3331 121.656 42.3331ZM128.365 42.3331C129.591 42.3331 130.442 41.5244 130.783 40.9852C130.783 41.3896 130.851 41.9287 130.885 42.1646H131.703C131.634 41.895 131.566 41.3559 131.566 40.783V34.9533H130.783V40.1764C130.545 40.6145 129.625 41.6254 128.535 41.6254C127.411 41.6254 127.037 40.9515 127.037 39.8732V34.9533H126.253V40.0417C126.253 41.3559 126.832 42.3331 128.365 42.3331ZM134.121 42.1646H134.904V31.2803H134.121V42.1646ZM139.366 42.3331C140.047 42.3331 140.558 42.0635 140.762 41.895L140.455 41.2885C140.319 41.3896 139.876 41.6254 139.434 41.6254C138.787 41.6254 138.548 41.2211 138.548 40.4797V35.5599H140.421V34.9196H138.548V32.8641H137.765V34.9196H136.539V35.5599H137.765V40.5134C137.765 41.6928 138.276 42.3331 139.366 42.3331ZM144.372 42.3331C145.598 42.3331 146.449 41.5244 146.79 40.9852C146.79 41.3896 146.858 41.9287 146.892 42.1646H147.71C147.641 41.895 147.573 41.3559 147.573 40.783V34.9533H146.79V40.1764C146.552 40.6145 145.632 41.6254 144.542 41.6254C143.418 41.6254 143.044 40.9515 143.044 39.8732V34.9533H142.26V40.0417C142.26 41.3559 142.839 42.3331 144.372 42.3331ZM150.128 42.1646H150.911V37.1437C151.115 36.7056 151.762 35.5262 152.784 35.5262C153.091 35.5262 153.261 35.5936 153.397 35.6273L153.602 34.8859C153.465 34.8522 153.227 34.7511 152.886 34.7511C151.865 34.7511 151.217 35.661 150.945 36.1664V34.9196H150.162V42.1646H150.128ZM157.484 42.3331C158.676 42.3331 159.493 41.9287 159.97 41.5918L159.63 40.9852C159.221 41.2885 158.438 41.6591 157.518 41.6591C155.781 41.6591 155.066 40.1427 155.066 38.4916V38.3231H160.106C160.106 38.1883 160.106 38.0535 160.106 37.9187C160.106 36.0653 159.085 34.7848 157.348 34.7848C155.407 34.7848 154.215 36.436 154.215 38.4916C154.215 40.5471 155.236 42.3331 157.484 42.3331ZM155.1 37.6828C155.304 36.436 156.054 35.4588 157.314 35.4588C158.71 35.4588 159.289 36.5708 159.289 37.6828H155.1Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M72.1 26.5291H72.8833V19.9581H74.7905V19.3178H72.8833V18.1721C72.8833 16.8579 73.4282 16.184 74.5521 16.184C74.9949 16.184 75.3014 16.2851 75.4717 16.3861L75.676 15.6785C75.4717 15.5774 75.097 15.4763 74.5521 15.4763C72.9514 15.4763 72.1 16.4535 72.1 18.1047V19.3178H70.8398V19.9581H72.1V26.5291ZM78.8774 26.6976C81.1593 26.6976 82.215 24.7095 82.215 22.8898C82.215 21.1038 81.1593 19.1494 78.8774 19.1494C76.5956 19.1494 75.6079 21.1038 75.6079 22.9235C75.6079 24.7432 76.5956 26.6976 78.8774 26.6976ZM78.9115 26.0237C77.2426 26.0237 76.4593 24.541 76.4593 22.8898C76.4593 21.2723 77.2086 19.8233 78.8774 19.8233C80.5462 19.8233 81.4317 21.306 81.4317 22.9235C81.3977 24.5747 80.5803 26.0237 78.9115 26.0237ZM83.7476 26.5291H84.5309V21.5082C84.7353 21.0701 85.3824 19.8907 86.4041 19.8907C86.7106 19.8907 86.8809 19.9581 87.0171 19.9918L87.2215 19.2504C87.0852 19.2167 86.8468 19.1157 86.5063 19.1157C85.4845 19.1157 84.8375 19.9918 84.565 20.531V19.2841H83.7817V26.5291H83.7476ZM92.1939 26.5291H93.0453V21.643H93.3178C93.9308 21.643 94.1011 21.7441 95.1228 23.1257L97.609 26.5291H98.6307L95.804 22.7213C95.225 21.98 95.0206 21.7104 94.8163 21.6093H94.9525C96.7235 21.5419 97.9496 20.6994 97.9496 19.0483C97.9496 17.3634 96.6895 16.4535 94.646 16.4535H92.2279V26.5291H92.1939ZM93.0112 20.969V17.1612H94.4757C96.1445 17.1612 97.03 17.8014 97.03 19.0483C97.03 20.2951 96.1786 20.969 94.5438 20.969H93.0112ZM102.615 26.6976C103.807 26.6976 104.625 26.2933 105.102 25.9563L104.761 25.3497C104.352 25.653 103.569 26.0237 102.65 26.0237C100.913 26.0237 100.197 24.5073 100.197 22.8561V22.6876H105.238C105.238 22.5528 105.238 22.418 105.238 22.2832C105.238 20.4299 104.216 19.1494 102.479 19.1494C100.538 19.1494 99.3459 20.8005 99.3459 22.8561C99.3459 24.9454 100.402 26.6976 102.615 26.6976ZM100.231 22.0474C100.436 20.8005 101.185 19.8233 102.445 19.8233C103.842 19.8233 104.386 20.9353 104.42 22.0474H100.231ZM108.678 26.7313C110.176 26.7313 111.13 25.9563 111.13 24.7095C111.13 23.5301 110.108 23.0246 108.984 22.5191C108.133 22.1484 107.418 21.8452 107.418 21.0027C107.418 20.2951 107.894 19.8233 108.78 19.8233C109.529 19.8233 110.108 20.1266 110.449 20.3962L110.857 19.8233C110.517 19.5537 109.802 19.1494 108.78 19.1494C107.418 19.1494 106.634 19.9581 106.634 21.0364C106.634 22.2158 107.554 22.7213 108.644 23.1931C109.631 23.6311 110.312 23.9681 110.312 24.7769C110.312 25.5519 109.665 26.0237 108.678 26.0237C107.894 26.0237 107.145 25.6867 106.805 25.4171L106.464 26.0237C106.907 26.3607 107.724 26.7313 108.678 26.7313ZM115.694 26.6976C116.886 26.6976 117.703 26.2933 118.18 25.9563L117.839 25.3497C117.43 25.653 116.647 26.0237 115.728 26.0237C113.991 26.0237 113.275 24.5073 113.275 22.8561V22.6876H118.316C118.316 22.5528 118.316 22.418 118.316 22.2832C118.316 20.4299 117.294 19.1494 115.557 19.1494C113.616 19.1494 112.424 20.8005 112.424 22.8561C112.424 24.9454 113.48 26.6976 115.694 26.6976ZM113.309 22.0474C113.514 20.8005 114.263 19.8233 115.523 19.8233C116.92 19.8233 117.464 20.9353 117.499 22.0474H113.309ZM121.688 26.6976C122.573 26.6976 123.39 26.2596 123.901 25.6193C123.901 25.8889 123.969 26.2933 124.004 26.5291H124.787C124.685 26.2259 124.651 25.6867 124.651 25.0801V21.4408C124.651 19.8907 123.799 19.1494 122.301 19.1494C121.347 19.1494 120.564 19.4526 119.917 20.0592L120.359 20.5984C120.972 20.0255 121.551 19.8233 122.267 19.8233C123.356 19.8233 123.867 20.3625 123.867 21.5419V22.3506H123.527C121.824 22.3506 119.678 22.8898 119.678 24.8106C119.644 25.9563 120.462 26.6976 121.688 26.6976ZM121.79 26.0237C121.143 26.0237 120.462 25.5856 120.462 24.8106C120.462 23.4627 121.858 22.9909 123.493 22.9909H123.833V24.9117C123.288 25.6193 122.607 26.0237 121.79 26.0237ZM127.103 26.5291H127.886V21.5082C128.09 21.0701 128.737 19.8907 129.759 19.8907C130.066 19.8907 130.236 19.9581 130.372 19.9918L130.577 19.2504C130.44 19.2167 130.202 19.1157 129.861 19.1157C128.84 19.1157 128.193 19.9918 127.92 20.531V19.2841H127.103V26.5291ZM134.289 26.6976C135.379 26.6976 136.162 26.2933 136.537 25.9563L136.196 25.3497C135.89 25.653 135.174 25.99 134.323 25.99C132.688 25.99 131.973 24.4736 131.973 22.8561C131.973 21.2049 132.722 19.7896 134.323 19.7896C135.14 19.7896 135.685 20.0929 136.094 20.4299L136.503 19.857C136.094 19.52 135.413 19.1157 134.323 19.1157C132.45 19.1157 131.122 20.5984 131.122 22.8898C131.156 24.8443 132.177 26.6976 134.289 26.6976ZM138.274 26.5291H139.057V21.2723C139.329 20.8679 140.215 19.857 141.305 19.857C142.395 19.857 142.803 20.531 142.803 21.5756V26.5291H143.587V21.4071C143.587 20.0929 142.974 19.1494 141.475 19.1494C140.249 19.1494 139.397 19.9581 139.057 20.4636V15.6448H138.274V26.5291Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M74.452 48.7688V47.96H70.876V48.7688H72.1702V52.5766H73.1578V48.7688H74.452ZM77.8918 52.5766V50.2178C77.8918 49.6112 77.6194 49.1394 76.8701 49.1394C76.3252 49.1394 75.9846 49.4427 75.8143 49.6449V47.6231H74.8948V52.6103H75.8143V50.2852C75.8824 50.1841 76.1549 49.8471 76.5295 49.8471C76.8701 49.8471 76.9723 50.0156 76.9723 50.3526V52.5429H77.8918V52.5766ZM79.4244 51.0939H81.6041C81.7062 49.8471 81.1954 49.1057 80.1396 49.1057C79.186 49.1057 78.4367 49.7797 78.4367 50.858C78.4367 51.9364 79.0838 52.644 80.2077 52.644C80.9229 52.644 81.2635 52.4418 81.4678 52.307L81.1613 51.7005C80.991 51.7679 80.7186 51.9363 80.2758 51.9363C79.7309 51.97 79.4585 51.5994 79.4244 51.0939ZM79.4244 50.4537C79.4925 50.0156 79.6969 49.746 80.1055 49.746C80.5483 49.746 80.6845 50.0493 80.6845 50.4537H79.4244ZM87.9047 52.5766V47.96H87.0192V50.3863C87.0192 50.7569 87.0533 51.0939 87.0533 51.1276C87.0533 51.1276 86.8489 50.7569 86.5765 50.3526L84.9076 47.96H83.8519V52.5766H84.7374V49.9482C84.7374 49.6449 84.7033 49.3416 84.7033 49.3416C84.7033 49.3416 84.8736 49.6786 85.146 50.0493L86.9511 52.6103H87.9047V52.5766ZM89.4713 51.0939H91.651C91.7532 49.8471 91.2423 49.1057 90.1865 49.1057C89.2329 49.1057 88.4837 49.7797 88.4837 50.858C88.4837 51.9364 89.1308 52.644 90.2547 52.644C90.9699 52.644 91.3104 52.4418 91.5148 52.307L91.2083 51.7005C91.038 51.7679 90.7655 51.9363 90.3228 51.9363C89.7779 51.97 89.5054 51.5994 89.4713 51.0939ZM89.4713 50.4537C89.5395 50.0156 89.7438 49.746 90.1525 49.746C90.5952 49.746 90.7315 50.0493 90.7315 50.4537H89.4713ZM96.8959 49.2068H95.9763L95.4314 51.3635L94.8524 49.2068H94.001L93.422 51.3635L92.9111 49.2068H91.9235L92.8771 52.5766H93.7285L94.4437 50.3189L95.1589 52.5766H96.0104L96.8959 49.2068ZM102.447 47.96H101.494L100.506 49.9145L99.5183 47.96H98.4284L99.961 50.8243V52.5766H100.949V50.8243L102.447 47.96ZM105.478 50.858C105.478 49.9819 104.933 49.1057 103.741 49.1057C102.549 49.1057 102.039 50.0156 102.039 50.8917C102.039 51.7679 102.549 52.644 103.741 52.644C104.967 52.644 105.478 51.7005 105.478 50.858ZM104.491 50.8917C104.491 51.532 104.286 51.9363 103.775 51.9363C103.265 51.9363 103.026 51.4646 103.026 50.858C103.026 50.2515 103.196 49.7797 103.741 49.7797C104.252 49.7797 104.491 50.2515 104.491 50.8917ZM108.271 49.2068C108.203 49.1731 108.067 49.1057 107.794 49.1057C107.351 49.1057 107.079 49.409 106.943 49.6449V49.1731H106.023V52.5429H106.943V50.42C107.011 50.2515 107.283 49.9145 107.692 49.9145C107.896 49.9145 107.999 49.9482 108.033 49.9819L108.271 49.2068ZM109.599 50.9254L110.689 52.5766H111.779L110.485 50.7232L111.745 49.2068H110.723L109.599 50.5547V47.5894H108.68V52.5766H109.599V50.9254ZM117.16 49.409C117.16 48.4318 116.377 47.96 115.389 47.96H113.856V52.5766H114.844V50.9254H115.287C116.445 50.9254 117.16 50.42 117.16 49.409ZM116.172 49.409C116.172 49.9145 115.9 50.1841 115.287 50.1841H114.844V48.7014H115.321C115.934 48.7014 116.172 48.971 116.172 49.409ZM117.637 49.2068V51.5657C117.637 52.1722 117.909 52.644 118.659 52.644C119.238 52.644 119.578 52.3407 119.748 52.1048C119.748 52.2396 119.782 52.4755 119.817 52.5429H120.736C120.702 52.3407 120.634 52.0037 120.634 51.5657V49.1731H119.714V51.4309C119.646 51.4983 119.374 51.869 118.999 51.869C118.659 51.869 118.556 51.7005 118.556 51.3635V49.1731H117.637V49.2068ZM121.417 47.5894V52.3744C121.587 52.4418 122.03 52.644 122.814 52.644C123.835 52.644 124.619 52.0038 124.619 50.858C124.619 49.6786 124.04 49.1057 123.154 49.1057C122.78 49.1057 122.473 49.3079 122.337 49.4427V47.5894H121.417ZM122.371 50.083C122.439 50.0156 122.643 49.8134 122.95 49.8134C123.461 49.8134 123.665 50.1841 123.665 50.8243C123.665 51.532 123.358 51.9026 122.848 51.9026C122.575 51.9026 122.439 51.8353 122.371 51.8353V50.083ZM126.185 47.5894H125.266V52.5766H126.185V47.5894ZM128.058 49.2068H127.105V52.5766H128.058V49.2068ZM128.161 48.1959C128.161 47.8926 127.922 47.6568 127.582 47.6568C127.241 47.6568 127.003 47.8926 127.003 48.1959C127.003 48.4992 127.241 48.7351 127.582 48.7351C127.922 48.7688 128.161 48.4992 128.161 48.1959ZM131.6 52.3407L131.328 51.7342C131.226 51.8016 130.987 51.9363 130.579 51.9363C130 51.9363 129.727 51.4646 129.727 50.858C129.727 50.2515 130 49.8134 130.545 49.8134C130.885 49.8134 131.09 49.9145 131.26 50.0156L131.566 49.3753C131.396 49.2742 131.09 49.1057 130.511 49.1057C129.489 49.1057 128.706 49.746 128.706 50.8917C128.706 51.9363 129.387 52.644 130.476 52.644C131.124 52.644 131.43 52.4418 131.6 52.3407ZM136.505 52.5766V51.8016H134.768V47.9937H133.78V52.6103H136.505V52.5766ZM138.003 49.2068H137.05V52.5766H138.003V49.2068ZM138.105 48.1959C138.105 47.8926 137.867 47.6568 137.526 47.6568C137.186 47.6568 136.947 47.8926 136.947 48.1959C136.947 48.4992 137.186 48.7351 137.526 48.7351C137.867 48.7688 138.105 48.4992 138.105 48.1959ZM138.889 47.5894V52.3744C139.059 52.4418 139.502 52.644 140.285 52.644C141.307 52.644 142.09 52.0038 142.09 50.858C142.09 49.6786 141.511 49.1057 140.626 49.1057C140.251 49.1057 139.944 49.3079 139.808 49.4427V47.5894H138.889ZM139.842 50.083C139.91 50.0156 140.115 49.8134 140.421 49.8134C140.932 49.8134 141.136 50.1841 141.136 50.8243C141.136 51.532 140.83 51.9026 140.319 51.9026C140.047 51.9026 139.91 51.8353 139.842 51.8353V50.083ZM144.917 49.2068C144.849 49.1731 144.713 49.1057 144.44 49.1057C143.997 49.1057 143.725 49.409 143.589 49.6449V49.1731H142.669V52.5429H143.589V50.42C143.657 50.2515 143.929 49.9145 144.338 49.9145C144.542 49.9145 144.644 49.9482 144.678 49.9819L144.917 49.2068ZM148.05 52.5766C148.016 52.3744 147.948 52.0374 147.948 51.5657V50.3526C147.948 49.4427 147.505 49.1057 146.586 49.1057C145.87 49.1057 145.394 49.409 145.189 49.5775L145.598 50.1504C145.734 50.0493 146.041 49.8471 146.483 49.8471C146.926 49.8471 147.028 50.0156 147.028 50.3189V50.5211H146.892C145.973 50.5211 145.087 50.8243 145.087 51.7342C145.087 52.3407 145.53 52.6777 146.109 52.6777C146.586 52.6777 146.926 52.4081 147.062 52.2396C147.062 52.3407 147.097 52.5092 147.131 52.6103H148.05V52.5766ZM147.028 51.6668C146.926 51.7679 146.722 51.97 146.415 51.97C146.211 51.97 146.007 51.869 146.007 51.6331C146.007 51.2287 146.381 51.0939 146.926 51.0939H147.062V51.6668H147.028ZM150.979 49.2068C150.911 49.1731 150.775 49.1057 150.502 49.1057C150.06 49.1057 149.787 49.409 149.651 49.6449V49.1731H148.731V52.5429H149.651V50.42C149.719 50.2515 149.991 49.9145 150.4 49.9145C150.604 49.9145 150.707 49.9482 150.741 49.9819L150.979 49.2068ZM152.375 52.5092L152.239 52.8462C152.103 53.2169 151.933 53.4527 151.456 53.4527C151.252 53.4527 151.183 53.419 151.115 53.419L150.979 54.1604C151.047 54.1941 151.217 54.2278 151.49 54.2278C152.409 54.2278 152.784 53.756 153.091 52.981L154.487 49.2405H153.533L152.852 51.4646H152.818L152.069 49.2405H151.081L152.375 52.5092Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M55.2745 46.3745L58.8165 49.9127L60.6556 48.0931L57.0795 44.5885L60.0085 41.6905L58.1694 39.9045L49.8594 48.1268L58.2375 56.3827L60.0766 54.5967L53.5035 48.1268L55.2745 46.3745Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.613032 41.6925L7.15206 48.1287L5.38107 49.8473L1.8391 46.3427L0 48.1287L3.57603 51.667L0.578975 54.6324L2.41808 56.4183L10.7621 48.1287L2.41808 39.8728L0.613032 41.6925Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M16.0748 56.9915L30.3108 71.0772L44.5808 56.9578L46.3859 55.1719L30.3448 39.3003L28.5398 41.0863L42.7417 55.1719L30.3108 67.4715L16.1088 53.3859H16.0748L4.80176 64.5398L6.64086 66.3595L16.0748 56.9915Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M30.3093 74.5128L16.0733 60.4272L7.93359 68.5146L9.73864 70.3006L16.0733 64.0328L17.8103 65.7514L11.9183 71.5811L13.7234 73.3671L19.6153 67.5374L21.3522 69.2559L16.5161 74.041L18.3552 75.8607L23.1913 71.0756L24.9283 72.7942L21.9312 75.7596L23.7703 77.5456L26.7333 74.5802L30.3093 78.1184L33.8854 74.6139L36.8484 77.5793L38.6875 75.7596L35.6904 72.7942L37.4614 71.0756L42.2975 75.8607L44.1026 74.041L39.2664 69.2559L41.0034 67.5374L46.8953 73.3671L48.7344 71.5811L42.8425 65.7514L44.5453 64.0328L50.88 70.3006L52.7191 68.4809L46.3844 62.2131L48.1214 60.4946L54.0133 66.3243L55.8184 64.5046L48.9728 57.7314L48.1214 56.8889L30.3093 74.5128Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M48.1359 49.8297L46.3057 51.6406L56.4201 61.6482L58.2503 59.8373L48.1359 49.8297Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M28.709 62.417L30.3097 64.0344L39.2668 55.172L37.4617 53.386L25.0308 41.0864L30.3437 35.8632L44.5457 49.9151H44.5797L58.3049 36.335L56.4998 34.5153L44.5797 46.3095L30.3437 32.2239L21.3866 41.0864L35.6226 55.172L30.3097 60.4288L17.9128 48.1292L16.0737 46.3432L2.31445 59.957L4.15356 61.743L16.0737 49.9488L28.709 62.417Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4.17984 34.5475L2.34961 36.3584L12.5363 46.4375L14.3665 44.6266L4.17984 34.5475Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M30.3469 21.7436L44.5829 35.8292L52.6886 27.8092L50.8835 25.9895L44.5829 32.2235L42.846 30.505L48.7039 24.7427L46.8648 22.923L41.0409 28.719L39.27 27.0004L44.038 22.2827L42.233 20.4631L37.4649 25.1807L35.728 23.4622L38.6569 20.5642L36.8178 18.7782L33.8889 21.6425L32.152 19.9239H32.186L30.3469 18.1379L26.7709 21.6762L23.876 18.7782L22.0369 20.5642L24.9658 23.4622L23.2289 25.1807L18.4949 20.5305L16.6899 22.3164L21.3898 27.0004L19.6529 28.719L13.795 22.923L11.99 24.7427L17.8478 30.505L16.0768 32.2235L9.77622 25.9895L7.97117 27.8092L14.2718 34.0432L12.5349 35.7618L6.64294 29.9658L4.83789 31.7518L12.5349 39.3675L30.3469 21.7436Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M30.3466 25.179L14.2715 41.0842L16.0765 42.8702L30.3125 56.9558L32.1516 55.1698L17.9156 41.0842L30.3466 28.7846L44.5826 42.8702L55.7875 31.7837L53.9484 29.9977L44.5826 39.2646L30.3466 25.179Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M77.6833 8.1284C77.6833 6.30873 76.4572 5.66847 75.129 5.06191C74.0732 4.59015 73.2899 4.35427 73.2899 3.57922C73.2899 2.90527 73.8008 2.56829 74.6181 2.56829C75.4696 2.56829 76.2188 2.93897 76.5594 3.17485L77.4109 1.72585C77.0022 1.42257 76.1167 0.917108 74.516 0.917108C72.745 0.917108 71.3146 1.96174 71.3146 3.64662C71.3146 5.23041 72.2341 5.97175 73.4261 6.57831C74.5841 7.15117 75.6399 7.38705 75.6399 8.26319C75.6399 8.90344 75.0609 9.40892 74.0732 9.40892C72.9153 9.40892 72.166 8.83605 71.9617 8.66756L71.0762 10.1166C71.5189 10.4535 72.5406 11.0938 74.1413 11.0938C76.3551 11.0264 77.6833 9.91438 77.6833 8.1284ZM84.3586 10.3861L83.7455 9.07194C83.5071 9.20673 83.0303 9.51 82.1789 9.51C80.9528 9.51 80.3738 8.53278 80.3738 7.21857C80.3738 5.90436 80.9869 4.99452 82.1448 4.99452C82.86 4.99452 83.3368 5.2304 83.6434 5.43259L84.2905 4.08468C83.9499 3.8488 83.2347 3.51183 82.0767 3.51183C79.897 3.51183 78.2623 4.85973 78.2623 7.28596C78.2623 9.51 79.6927 11.0264 82.0086 11.0264C83.3709 11.0264 84.018 10.622 84.3586 10.3861ZM91.6469 10.8579V5.83697C91.6469 4.52276 91.0679 3.51183 89.4672 3.51183C88.2752 3.51183 87.594 4.15208 87.2194 4.55645V0.276855H85.2441V10.8579H87.2194V6.03915C87.3556 5.83697 87.9346 5.12931 88.7179 5.12931C89.4331 5.12931 89.6715 5.49999 89.6715 6.20764V10.8579H91.6469ZM99.9228 7.25226C99.9228 5.39889 98.7649 3.54552 96.2446 3.54552C93.7244 3.54552 92.6345 5.49999 92.6345 7.31966C92.6345 9.17303 93.7244 11.0601 96.2446 11.0601C98.7989 11.0264 99.9228 9.03823 99.9228 7.25226ZM97.8113 7.28596C97.8113 8.63386 97.4026 9.5437 96.2787 9.5437C95.1548 9.5437 94.712 8.56648 94.712 7.21857C94.712 5.87067 95.0867 4.96082 96.2106 4.96082C97.3345 4.96082 97.8113 5.97175 97.8113 7.28596ZM106.905 4.65755C106.632 3.9836 106.087 3.51183 105.031 3.51183C103.873 3.51183 103.226 4.15208 102.852 4.55645V3.68032H100.91V10.8579H102.886V6.03915C103.022 5.83697 103.499 5.16301 104.248 5.16301C104.827 5.16301 105.1 5.53368 105.1 6.24133V10.8579H107.075V5.97175C107.347 5.63478 107.79 5.16301 108.437 5.16301C109.084 5.16301 109.289 5.53368 109.289 6.24133V10.8579H111.264V5.83697C111.264 4.52276 110.719 3.51183 109.186 3.51183C108.165 3.51183 107.484 3.9836 106.905 4.65755ZM112.626 0.276855V10.4535C112.967 10.622 113.954 11.0264 115.589 11.0264C117.769 11.0264 119.438 9.6448 119.438 7.21857C119.438 4.75864 118.178 3.51183 116.373 3.51183C115.555 3.51183 114.942 3.9162 114.602 4.25317V0.276855H112.626ZM114.602 5.60108C114.738 5.46629 115.181 5.06191 115.828 5.06191C116.883 5.06191 117.36 5.87067 117.36 7.21857C117.36 8.70127 116.713 9.51 115.589 9.51C115.044 9.51 114.738 9.37521 114.602 9.34152V5.60108ZM120.425 3.71401V8.73496C120.425 10.0492 121.004 11.0601 122.605 11.0601C123.797 11.0601 124.546 10.4198 124.921 9.91438C124.921 10.2177 125.023 10.6894 125.057 10.8579H126.998C126.896 10.4198 126.794 9.71219 126.794 8.80235V3.71401H124.819V8.49908C124.683 8.66756 124.104 9.40892 123.32 9.40892C122.605 9.40892 122.367 9.03824 122.367 8.33059V3.71401H120.425ZM133.163 3.71401C132.993 3.61292 132.72 3.51183 132.175 3.51183C131.256 3.51183 130.643 4.11839 130.336 4.65755V3.68032H128.361V10.8579H130.336V6.34243C130.506 6.00545 131.017 5.2641 131.903 5.2641C132.311 5.2641 132.55 5.36519 132.652 5.43259L133.163 3.71401ZM137.863 3.71401C137.488 3.57922 137.045 3.54552 136.569 3.54552C134.559 3.54552 133.367 4.59015 133.367 6.14024C133.367 7.08378 133.844 7.82512 134.661 8.29689C134.219 8.53277 133.844 8.97084 133.844 9.64479C133.844 10.1503 134.082 10.4872 134.491 10.7231C133.776 11.0938 133.265 11.6666 133.265 12.4754C133.265 13.7559 134.457 14.3962 136.432 14.3962C138.816 14.3962 140.383 13.3178 140.383 11.8014C140.383 9.67849 138.476 9.67849 136.977 9.61109C135.922 9.5437 135.513 9.4763 135.513 9.10563C135.513 8.90344 135.649 8.76866 135.785 8.66756C136.058 8.70126 136.33 8.73496 136.637 8.73496C138.646 8.73496 139.77 7.69033 139.77 6.14024C139.77 5.73587 139.668 5.3315 139.498 4.99452H140.451V3.71401H137.863ZM136.603 7.45445C135.785 7.45445 135.309 6.94899 135.309 6.14024C135.309 5.2978 135.785 4.82604 136.603 4.82604C137.42 4.82604 137.897 5.2978 137.897 6.14024C137.897 6.94899 137.42 7.45445 136.603 7.45445ZM135.751 11.0938C136.058 11.1275 136.398 11.1612 136.739 11.1949C137.795 11.2623 138.476 11.2286 138.476 12.0036C138.476 12.6102 137.795 13.0483 136.603 13.0483C135.581 13.0483 135.206 12.6439 135.206 12.071C135.172 11.6667 135.377 11.3297 135.751 11.0938ZM151.69 10.0155L150.839 8.56648C150.328 8.93715 149.681 9.30782 148.591 9.30782C146.65 9.30782 145.696 7.75772 145.696 5.90435C145.696 4.08468 146.684 2.63569 148.557 2.63569C149.476 2.63569 150.089 2.87157 150.634 3.20854L151.554 1.69215C150.771 1.18669 149.885 0.917108 148.591 0.917108C145.253 0.917108 143.482 3.30964 143.482 5.97175C143.482 8.63387 145.185 11.0601 148.557 11.0601C150.021 11.0264 151.213 10.4535 151.69 10.0155ZM153.938 7.72403H158.536C158.774 5.06192 157.684 3.51183 155.402 3.51183C153.393 3.51183 151.826 4.96083 151.826 7.21857C151.826 9.51001 153.189 11.0264 155.607 11.0264C157.105 11.0264 157.82 10.5883 158.297 10.3524L157.65 9.07194C157.31 9.24043 156.731 9.5774 155.777 9.5774C154.585 9.5774 154.04 8.83606 153.938 7.72403ZM153.938 6.40982C154.074 5.46629 154.551 4.92712 155.368 4.92712C156.288 4.92712 156.594 5.60108 156.628 6.40982H153.938ZM166.096 10.8579V5.83697C166.096 4.52276 165.517 3.51183 163.917 3.51183C162.725 3.51183 162.01 4.15208 161.601 4.59015V3.68032H159.66V10.8579H161.635V6.03915C161.771 5.83697 162.35 5.12931 163.133 5.12931C163.849 5.12931 164.087 5.49999 164.087 6.20764V10.8579H166.096ZM168.072 5.16301V8.80235C168.072 10.184 168.651 11.0264 170.354 11.0264C171.273 11.0264 171.886 10.7905 172.159 10.622L171.682 9.17303C171.546 9.27412 171.171 9.44261 170.728 9.44261C170.183 9.44261 170.013 9.13933 170.013 8.43168V5.16301H171.716V3.71401H170.013V1.62476H168.038V3.71401H166.88V5.16301H168.072ZM174.475 7.72403H179.072C179.311 5.06192 178.221 3.51183 175.939 3.51183C173.93 3.51183 172.363 4.96083 172.363 7.21857C172.363 9.51001 173.725 11.0264 176.143 11.0264C177.642 11.0264 178.357 10.5883 178.834 10.3524L178.187 9.07194C177.846 9.24043 177.267 9.5774 176.314 9.5774C175.122 9.5774 174.543 8.83606 174.475 7.72403ZM174.475 6.40982C174.611 5.46629 175.088 4.92712 175.905 4.92712C176.825 4.92712 177.131 5.60108 177.165 6.40982H174.475ZM184.998 3.71401C184.828 3.61292 184.556 3.51183 184.011 3.51183C183.091 3.51183 182.512 4.11839 182.172 4.65755V3.68032H180.23V10.8579H182.206V6.34243C182.376 6.00545 182.887 5.2641 183.772 5.2641C184.181 5.2641 184.419 5.36519 184.521 5.43259L184.998 3.71401Z"
    })), $0422a6ce4ea03acc$var$LU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 512 148",
        fill: "#000000",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M25.0165 34.1611C24.5128 33.5446 24.4762 32.72 25.2323 32.4701L77.6336 15.1432C77.7755 15.0963 77.9266 15.0837 78.0743 15.1066C78.2221 15.1294 78.3623 15.187 78.4834 15.2746C78.6045 15.3622 78.7031 15.4774 78.7711 15.6105C78.8391 15.7437 78.8744 15.8911 78.8743 16.0406C78.8866 16.2848 78.9882 16.516 79.1597 16.6903C79.3313 16.8645 79.5609 16.9697 79.8049 16.9858C80.2191 17.0533 80.6399 17.0704 81.0582 17.0366C81.315 17.0388 81.5628 16.9423 81.7504 16.767C81.9381 16.5918 82.0513 16.3512 82.0667 16.0948C82.0667 16.0948 82.0642 10.8418 82.0642 10.5828C82.0673 10.3933 82.0166 10.2067 81.9178 10.0448C81.819 9.88297 81.6763 9.75251 81.5062 9.66865C81.2544 9.52519 80.9573 9.48328 80.6756 9.55146L21.9809 29.0226C19.7212 29.7537 19.3184 30.0273 19.3184 32.455L19.3377 132.219C19.336 132.314 19.3492 132.41 19.3769 132.501C20.5889 136.198 24.9238 137.89 24.9238 137.89C29.1795 139.505 31.3728 139.954 35.2278 138.617C35.2278 138.617 35.3131 39.0919 35.2627 38.6542C35.2555 38.5944 35.2294 38.5386 35.188 38.4949C35.1466 38.4512 35.0923 38.422 35.0331 38.4116C34.6234 38.3349 28.3174 38.2022 25.0164 34.1611"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M6.38207 25.4806C5.85345 24.8852 5.84181 24.0391 6.59791 23.7892L58.9992 6.46274C59.1411 6.41581 59.2922 6.40326 59.4399 6.42611C59.5877 6.44895 59.7279 6.50656 59.849 6.59417C59.9702 6.68179 60.0688 6.79691 60.1367 6.93008C60.2047 7.06324 60.2401 7.21064 60.24 7.36014C60.2496 7.60516 60.3503 7.83778 60.5223 8.01256C60.6943 8.18734 60.9253 8.29174 61.1701 8.30537C61.5853 8.36351 62.0053 8.3804 62.4238 8.35578C62.6809 8.35931 62.9294 8.26332 63.1174 8.08788C63.3053 7.91244 63.4182 7.67113 63.4324 7.4144C63.4324 7.4144 63.4298 2.33669 63.4298 2.01185C63.4349 1.81901 63.3924 1.62789 63.3059 1.45542C63.2195 1.28295 63.0919 1.13446 62.9344 1.02311C62.8055 0.934369 62.6588 0.87479 62.5046 0.848525C62.3503 0.82226 62.1922 0.82994 62.0413 0.871032L3.34647 20.3422C1.08679 21.0733 1.00195 21.3923 1.00195 23.82L1.00801 123.924C1.01106 124.02 1.0242 124.114 1.04721 124.207C1.97728 127.945 6.28944 129.21 6.28944 129.21C10.5451 130.825 12.7384 131.274 16.5934 129.936C16.5934 129.936 16.6787 30.411 16.6283 29.9737C16.6211 29.9141 16.595 29.8583 16.5537 29.8147C16.5124 29.771 16.4583 29.7417 16.3991 29.7312C15.989 29.6545 9.81354 29.3452 6.38202 25.4806"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M112.969 28.1385C112.969 27.9889 112.933 27.8415 112.865 27.7084C112.797 27.5753 112.698 27.4602 112.577 27.3727C112.455 27.2852 112.315 27.2278 112.167 27.2051C112.02 27.1825 111.868 27.1952 111.727 27.2424L65.072 42.7443C53.0654 46.29 52.4644 46.7006 48.636 45.2918C46.7723 44.68 45.1112 43.5704 43.8323 42.083C43.3451 41.4531 43.3433 40.6415 44.0995 40.3916L96.5007 23.0646C96.6427 23.0178 96.7938 23.0053 96.9415 23.0282C97.0893 23.0512 97.2295 23.1088 97.3506 23.1965C97.4717 23.2841 97.5703 23.3992 97.6383 23.5324C97.7062 23.6656 97.7416 23.813 97.7415 23.9625C97.7508 24.2076 97.8513 24.4405 98.0234 24.6154C98.1955 24.7902 98.4267 24.8945 98.6717 24.9077C99.0857 24.9617 99.5037 24.9785 99.9207 24.9577C100.179 24.9642 100.429 24.8694 100.619 24.6936C100.808 24.5177 100.921 24.2748 100.934 24.0168C100.934 24.0168 100.931 18.7405 100.931 18.5983C100.952 18.3934 100.91 18.1871 100.811 18.0068C100.711 17.8266 100.559 17.6812 100.374 17.5902C100.252 17.5108 100.115 17.4592 99.9714 17.439C99.8277 17.4189 99.6814 17.4306 99.5428 17.4734L40.848 36.9445C38.5884 37.6756 38.1855 37.9492 38.1855 40.3765L38.2049 137.856C38.2049 137.952 38.2088 138.898 38.2071 138.994C38.1481 142.149 41.8622 143.905 43.6251 144.693C46.8789 146.305 50.6291 146.6 54.0951 145.517L112.331 126.605C112.517 126.541 112.678 126.421 112.793 126.26C112.907 126.1 112.969 125.908 112.969 125.711V106.996C112.969 106.849 112.934 106.704 112.868 106.572C112.801 106.44 112.705 106.326 112.587 106.238C112.468 106.15 112.331 106.092 112.186 106.066C112.041 106.041 111.892 106.05 111.751 106.093L65.0501 121.4C64.9054 121.442 64.7531 121.451 64.6048 121.425C64.4564 121.399 64.316 121.339 64.1941 121.251C64.0723 121.162 63.9722 121.047 63.9016 120.914C63.8309 120.781 63.7915 120.634 63.7865 120.483V103.949C63.7865 103.746 63.8518 103.549 63.9727 103.386C64.0936 103.223 64.2636 103.104 64.4577 103.045L112.251 87.3894C112.832 87.1761 112.969 87.077 112.969 86.5807L112.932 67.4697C112.917 67.3319 112.871 67.1994 112.797 67.0822C112.722 66.965 112.623 66.8662 112.505 66.7933C112.387 66.7204 112.254 66.6754 112.116 66.6616C111.978 66.6478 111.838 66.6656 111.708 66.7136L64.9368 82.2036C64.3336 82.3776 63.7865 81.7654 63.7865 81.1368L63.858 64.5354C63.8579 64.3354 63.9214 64.1405 64.0392 63.9788C64.1571 63.8171 64.3232 63.697 64.5137 63.6359L112.409 47.7333C112.8 47.6079 112.964 47.0525 112.964 46.642L112.969 28.1385Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M193.94 91.6295C193.983 94.8939 193.331 98.13 192.029 101.124C190.79 103.934 188.906 106.413 186.53 108.36C183.938 110.433 180.969 111.986 177.788 112.934C174.053 114.057 170.168 114.604 166.268 114.555C163.391 114.582 160.52 114.311 157.699 113.744C155.392 113.274 153.126 112.615 150.926 111.776C149.156 111.103 147.451 110.269 145.832 109.286C144.644 108.568 143.503 107.775 142.416 106.913L149.363 95.5661C149.826 95.8752 150.521 96.3576 151.447 97.0134C152.54 97.7622 153.703 98.4022 154.92 98.924C156.496 99.6071 158.122 100.168 159.784 100.603C161.787 101.124 163.85 101.377 165.92 101.355C169.857 101.355 172.887 100.487 175.009 98.7502C175.994 98.0182 176.794 97.0668 177.347 95.9714C177.9 94.8761 178.19 93.667 178.193 92.4401C178.235 90.8677 177.723 89.3308 176.746 88.0978C175.676 86.8139 174.381 85.735 172.925 84.9137C171.15 83.8924 169.314 82.9837 167.425 82.193C165.341 81.3063 163.18 80.2835 160.941 79.1247C158.646 78.0237 156.44 76.7462 154.342 75.3039C152.394 73.97 150.64 72.3724 149.131 70.5568C147.623 68.7091 146.447 66.6131 145.658 64.3625C144.758 61.6971 144.328 58.8961 144.384 56.0836C144.331 52.9985 145.006 49.9443 146.353 47.1681C147.636 44.5799 149.451 42.2916 151.679 40.4528C154.014 38.5475 156.684 37.0948 159.552 36.1691C162.691 35.1458 165.976 34.6375 169.278 34.6637C172.091 34.6336 174.902 34.8662 177.672 35.3585C179.853 35.7562 182.001 36.3174 184.098 37.0373C185.705 37.5825 187.256 38.2803 188.729 39.1213C189.963 39.8556 191.005 40.5311 191.855 41.1476L185.256 52.61C184.561 52.1471 183.713 51.6455 182.709 51.1051C181.591 50.516 180.43 50.0127 179.235 49.5998C177.832 49.1112 176.402 48.7053 174.951 48.384C173.393 48.0352 171.801 47.8604 170.204 47.863C167.544 47.7211 164.908 48.4309 162.678 49.8893C161.756 50.5742 161.019 51.478 160.534 52.5191C160.049 53.5602 159.831 54.7057 159.899 55.8522C159.85 57.2286 160.235 58.5857 161 59.7311C161.818 60.8552 162.839 61.817 164.01 62.5675C165.443 63.5046 166.954 64.318 168.525 64.9992C170.262 65.7716 172.134 66.6208 174.141 67.5465C176.688 68.7042 179.158 69.9393 181.551 71.2516C183.877 72.5145 186.003 74.1141 187.861 75.9987C189.891 78.0491 191.477 80.4944 192.523 83.1832C193.569 85.8719 194.051 88.7468 193.94 91.6295Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M220.454 40.2215C220.46 41.4297 220.222 42.6267 219.754 43.7408C219.287 44.8549 218.599 45.8632 217.733 46.7054C216.858 47.6125 215.804 48.3279 214.638 48.8062C213.472 49.2846 212.22 49.5154 210.96 49.4842C209.708 49.5193 208.463 49.2899 207.305 48.8111C206.148 48.3323 205.105 47.6148 204.244 46.7054C203.392 45.8553 202.718 44.8443 202.261 43.7311C201.804 42.6179 201.572 41.4249 201.581 40.2215C201.566 39.0344 201.795 37.8569 202.253 36.7616C202.711 35.6663 203.388 34.6766 204.244 33.8534C205.122 32.9747 206.171 32.2851 207.326 31.8271C208.481 31.3691 209.718 31.1524 210.96 31.1903C212.21 31.1561 213.454 31.3744 214.617 31.832C215.781 32.2895 216.841 32.977 217.733 33.8534C218.603 34.6684 219.294 35.6554 219.762 36.7516C220.23 37.8478 220.466 39.0294 220.454 40.2215ZM203.202 113.165V56.7787H218.717V113.165L203.202 113.165Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M275.449 64.3045C277.615 61.73 280.199 59.5381 283.092 57.8206C286.287 56.0978 289.884 55.2584 293.512 55.3889C296.11 55.3101 298.695 55.7837 301.096 56.7786C303.041 57.6281 304.75 58.9396 306.074 60.5994C307.389 62.3094 308.318 64.2846 308.795 66.3885C309.352 68.7795 309.624 71.2279 309.605 73.6829V113.165H294.207V76.8093C294.344 74.5918 293.842 72.3816 292.76 70.4411C291.793 68.9758 290.037 68.2424 287.492 68.2409C286.304 68.2326 285.125 68.4486 284.018 68.8777C282.981 69.2781 282.006 69.824 281.123 70.4987C280.299 71.1329 279.525 71.8298 278.808 72.5832C278.113 73.3176 277.496 73.9929 276.955 74.6091V113.165H261.556V76.8092C261.556 73.9543 261.035 71.8122 259.992 70.383C258.951 68.9557 257.272 68.2417 254.956 68.2409C253.614 68.2303 252.287 68.5274 251.078 69.1095C249.95 69.6432 248.899 70.3244 247.951 71.1354C247.139 71.8284 246.402 72.6046 245.751 73.4513C245.172 74.2238 244.729 74.8027 244.42 75.1882V113.165H229.021V56.7786H244.072V63.7254C244.767 62.9549 245.616 62.0674 246.62 61.0628C247.694 60.0053 248.901 59.0907 250.209 58.3416C251.713 57.4803 253.304 56.7817 254.956 56.2576C256.905 55.6527 258.936 55.3595 260.977 55.389C264.99 55.389 268.136 56.1995 270.414 57.8206C272.691 59.4429 274.441 61.6972 275.449 64.3045Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M371.897 84.9138C371.951 89.0406 371.325 93.1482 370.044 97.0715C368.928 100.487 367.159 103.652 364.834 106.392C362.634 108.949 359.909 111.002 356.845 112.412C353.646 113.864 350.168 114.595 346.655 114.555C343.811 114.667 340.974 114.194 338.319 113.165C336.662 112.49 335.104 111.595 333.687 110.502V138.522H318.289V56.7786H333.341V62.6834C335.036 60.626 337.097 58.899 339.419 57.5891C342.351 56.0202 345.649 55.2607 348.972 55.3889C356.15 55.3889 361.766 57.9363 365.818 63.031C369.87 68.1253 371.896 75.4195 371.897 84.9138ZM355.571 84.9138C355.571 79.5881 354.645 75.3814 352.792 72.2937C351.949 70.8157 350.713 69.6004 349.221 68.7828C347.729 67.9652 346.039 67.5773 344.34 67.6623C342.995 67.6404 341.659 67.8761 340.403 68.3567C339.308 68.7876 338.261 69.3309 337.277 69.9778C336.446 70.5154 335.687 71.1575 335.02 71.8884C334.44 72.5451 333.996 73.0661 333.688 73.4514V98.8079C334.859 99.7732 336.12 100.626 337.451 101.355C339.297 102.283 341.35 102.721 343.414 102.629C345.198 102.707 346.972 102.315 348.557 101.492C350.142 100.669 351.483 99.444 352.445 97.9397C354.529 94.8137 355.571 90.4718 355.571 84.9138Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M380.929 113.165V29.801H396.328V113.165H380.929Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M402.811 56.7786H419.252L431.757 93.9451H432.336L443.799 56.7786H459.661L436.389 119.186C435.266 122.256 433.911 125.237 432.336 128.102C430.984 130.58 429.222 132.811 427.126 134.701C425.041 136.52 422.622 137.916 420.005 138.812C416.809 139.845 413.463 140.335 410.105 140.259C408.206 140.297 406.307 140.161 404.432 139.854C403.043 139.582 402.04 139.37 401.422 139.217L403.621 127.06C404.184 127.256 404.767 127.392 405.358 127.465C406.588 127.605 407.826 127.662 409.063 127.638C413 127.638 415.856 126.75 417.631 124.975C419.571 122.927 421.034 120.476 421.915 117.797L423.999 112.007L402.811 56.7786Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M466.725 113.165V36.053H511.186V49.4841H482.818V66.8518H507.827V79.5881H482.818V99.7341H511.996V113.165H466.725Z"
    })), $0422a6ce4ea03acc$var$bU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 512 148",
        fill: "#ffffff",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M25.0165 34.1611C24.5128 33.5446 24.4762 32.72 25.2323 32.4701L77.6336 15.1432C77.7755 15.0963 77.9266 15.0837 78.0743 15.1066C78.2221 15.1294 78.3623 15.187 78.4834 15.2746C78.6045 15.3622 78.7031 15.4774 78.7711 15.6105C78.8391 15.7437 78.8744 15.8911 78.8743 16.0406C78.8866 16.2848 78.9882 16.516 79.1597 16.6903C79.3313 16.8645 79.5609 16.9697 79.8049 16.9858C80.2191 17.0533 80.6399 17.0704 81.0582 17.0366C81.315 17.0388 81.5628 16.9423 81.7504 16.767C81.9381 16.5918 82.0513 16.3512 82.0667 16.0948C82.0667 16.0948 82.0642 10.8418 82.0642 10.5828C82.0673 10.3933 82.0166 10.2067 81.9178 10.0448C81.819 9.88297 81.6763 9.75251 81.5062 9.66865C81.2544 9.52519 80.9573 9.48328 80.6756 9.55146L21.9809 29.0226C19.7212 29.7537 19.3184 30.0273 19.3184 32.455L19.3377 132.219C19.336 132.314 19.3492 132.41 19.3769 132.501C20.5889 136.198 24.9238 137.89 24.9238 137.89C29.1795 139.505 31.3728 139.954 35.2278 138.617C35.2278 138.617 35.3131 39.0919 35.2627 38.6542C35.2555 38.5944 35.2294 38.5386 35.188 38.4949C35.1466 38.4512 35.0923 38.422 35.0331 38.4116C34.6234 38.3349 28.3174 38.2022 25.0164 34.1611"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M6.38207 25.4806C5.85345 24.8852 5.84181 24.0391 6.59791 23.7892L58.9992 6.46274C59.1411 6.41581 59.2922 6.40326 59.4399 6.42611C59.5877 6.44895 59.7279 6.50656 59.849 6.59417C59.9702 6.68179 60.0688 6.79691 60.1367 6.93008C60.2047 7.06324 60.2401 7.21064 60.24 7.36014C60.2496 7.60516 60.3503 7.83778 60.5223 8.01256C60.6943 8.18734 60.9253 8.29174 61.1701 8.30537C61.5853 8.36351 62.0053 8.3804 62.4238 8.35578C62.6809 8.35931 62.9294 8.26332 63.1174 8.08788C63.3053 7.91244 63.4182 7.67113 63.4324 7.4144C63.4324 7.4144 63.4298 2.33669 63.4298 2.01185C63.4349 1.81901 63.3924 1.62789 63.3059 1.45542C63.2195 1.28295 63.0919 1.13446 62.9344 1.02311C62.8055 0.934369 62.6588 0.87479 62.5046 0.848525C62.3503 0.82226 62.1922 0.82994 62.0413 0.871032L3.34647 20.3422C1.08679 21.0733 1.00195 21.3923 1.00195 23.82L1.00801 123.924C1.01106 124.02 1.0242 124.114 1.04721 124.207C1.97728 127.945 6.28944 129.21 6.28944 129.21C10.5451 130.825 12.7384 131.274 16.5934 129.936C16.5934 129.936 16.6787 30.411 16.6283 29.9737C16.6211 29.9141 16.595 29.8583 16.5537 29.8147C16.5124 29.771 16.4583 29.7417 16.3991 29.7312C15.989 29.6545 9.81354 29.3452 6.38202 25.4806"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M112.969 28.1385C112.969 27.9889 112.933 27.8415 112.865 27.7084C112.797 27.5753 112.698 27.4602 112.577 27.3727C112.455 27.2852 112.315 27.2278 112.167 27.2051C112.02 27.1825 111.868 27.1952 111.727 27.2424L65.072 42.7443C53.0654 46.29 52.4644 46.7006 48.636 45.2918C46.7723 44.68 45.1112 43.5704 43.8323 42.083C43.3451 41.4531 43.3433 40.6415 44.0995 40.3916L96.5007 23.0646C96.6427 23.0178 96.7938 23.0053 96.9415 23.0282C97.0893 23.0512 97.2295 23.1088 97.3506 23.1965C97.4717 23.2841 97.5703 23.3992 97.6383 23.5324C97.7062 23.6656 97.7416 23.813 97.7415 23.9625C97.7508 24.2076 97.8513 24.4405 98.0234 24.6154C98.1955 24.7902 98.4267 24.8945 98.6717 24.9077C99.0857 24.9617 99.5037 24.9785 99.9207 24.9577C100.179 24.9642 100.429 24.8694 100.619 24.6936C100.808 24.5177 100.921 24.2748 100.934 24.0168C100.934 24.0168 100.931 18.7405 100.931 18.5983C100.952 18.3934 100.91 18.1871 100.811 18.0068C100.711 17.8266 100.559 17.6812 100.374 17.5902C100.252 17.5108 100.115 17.4592 99.9714 17.439C99.8277 17.4189 99.6814 17.4306 99.5428 17.4734L40.848 36.9445C38.5884 37.6756 38.1855 37.9492 38.1855 40.3765L38.2049 137.856C38.2049 137.952 38.2088 138.898 38.2071 138.994C38.1481 142.149 41.8622 143.905 43.6251 144.693C46.8789 146.305 50.6291 146.6 54.0951 145.517L112.331 126.605C112.517 126.541 112.678 126.421 112.793 126.26C112.907 126.1 112.969 125.908 112.969 125.711V106.996C112.969 106.849 112.934 106.704 112.868 106.572C112.801 106.44 112.705 106.326 112.587 106.238C112.468 106.15 112.331 106.092 112.186 106.066C112.041 106.041 111.892 106.05 111.751 106.093L65.0501 121.4C64.9054 121.442 64.7531 121.451 64.6048 121.425C64.4564 121.399 64.316 121.339 64.1941 121.251C64.0723 121.162 63.9722 121.047 63.9016 120.914C63.8309 120.781 63.7915 120.634 63.7865 120.483V103.949C63.7865 103.746 63.8518 103.549 63.9727 103.386C64.0936 103.223 64.2636 103.104 64.4577 103.045L112.251 87.3894C112.832 87.1761 112.969 87.077 112.969 86.5807L112.932 67.4697C112.917 67.3319 112.871 67.1994 112.797 67.0822C112.722 66.965 112.623 66.8662 112.505 66.7933C112.387 66.7204 112.254 66.6754 112.116 66.6616C111.978 66.6478 111.838 66.6656 111.708 66.7136L64.9368 82.2036C64.3336 82.3776 63.7865 81.7654 63.7865 81.1368L63.858 64.5354C63.8579 64.3354 63.9214 64.1405 64.0392 63.9788C64.1571 63.8171 64.3232 63.697 64.5137 63.6359L112.409 47.7333C112.8 47.6079 112.964 47.0525 112.964 46.642L112.969 28.1385Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M193.94 91.6295C193.983 94.8939 193.331 98.13 192.029 101.124C190.79 103.934 188.906 106.413 186.53 108.36C183.938 110.433 180.969 111.986 177.788 112.934C174.053 114.057 170.168 114.604 166.268 114.555C163.391 114.582 160.52 114.311 157.699 113.744C155.392 113.274 153.126 112.615 150.926 111.776C149.156 111.103 147.451 110.269 145.832 109.286C144.644 108.568 143.503 107.775 142.416 106.913L149.363 95.5661C149.826 95.8752 150.521 96.3576 151.447 97.0134C152.54 97.7622 153.703 98.4022 154.92 98.924C156.496 99.6071 158.122 100.168 159.784 100.603C161.787 101.124 163.85 101.377 165.92 101.355C169.857 101.355 172.887 100.487 175.009 98.7502C175.994 98.0182 176.794 97.0668 177.347 95.9714C177.9 94.8761 178.19 93.667 178.193 92.4401C178.235 90.8677 177.723 89.3308 176.746 88.0978C175.676 86.8139 174.381 85.735 172.925 84.9137C171.15 83.8924 169.314 82.9837 167.425 82.193C165.341 81.3063 163.18 80.2835 160.941 79.1247C158.646 78.0237 156.44 76.7462 154.342 75.3039C152.394 73.97 150.64 72.3724 149.131 70.5568C147.623 68.7091 146.447 66.6131 145.658 64.3625C144.758 61.6971 144.328 58.8961 144.384 56.0836C144.331 52.9985 145.006 49.9443 146.353 47.1681C147.636 44.5799 149.451 42.2916 151.679 40.4528C154.014 38.5475 156.684 37.0948 159.552 36.1691C162.691 35.1458 165.976 34.6375 169.278 34.6637C172.091 34.6336 174.902 34.8662 177.672 35.3585C179.853 35.7562 182.001 36.3174 184.098 37.0373C185.705 37.5825 187.256 38.2803 188.729 39.1213C189.963 39.8556 191.005 40.5311 191.855 41.1476L185.256 52.61C184.561 52.1471 183.713 51.6455 182.709 51.1051C181.591 50.516 180.43 50.0127 179.235 49.5998C177.832 49.1112 176.402 48.7053 174.951 48.384C173.393 48.0352 171.801 47.8604 170.204 47.863C167.544 47.7211 164.908 48.4309 162.678 49.8893C161.756 50.5742 161.019 51.478 160.534 52.5191C160.049 53.5602 159.831 54.7057 159.899 55.8522C159.85 57.2286 160.235 58.5857 161 59.7311C161.818 60.8552 162.839 61.817 164.01 62.5675C165.443 63.5046 166.954 64.318 168.525 64.9992C170.262 65.7716 172.134 66.6208 174.141 67.5465C176.688 68.7042 179.158 69.9393 181.551 71.2516C183.877 72.5145 186.003 74.1141 187.861 75.9987C189.891 78.0491 191.477 80.4944 192.523 83.1832C193.569 85.8719 194.051 88.7468 193.94 91.6295Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M220.454 40.2215C220.46 41.4297 220.222 42.6267 219.754 43.7408C219.287 44.8549 218.599 45.8632 217.733 46.7054C216.858 47.6125 215.804 48.3279 214.638 48.8062C213.472 49.2846 212.22 49.5154 210.96 49.4842C209.708 49.5193 208.463 49.2899 207.305 48.8111C206.148 48.3323 205.105 47.6148 204.244 46.7054C203.392 45.8553 202.718 44.8443 202.261 43.7311C201.804 42.6179 201.572 41.4249 201.581 40.2215C201.566 39.0344 201.795 37.8569 202.253 36.7616C202.711 35.6663 203.388 34.6766 204.244 33.8534C205.122 32.9747 206.171 32.2851 207.326 31.8271C208.481 31.3691 209.718 31.1524 210.96 31.1903C212.21 31.1561 213.454 31.3744 214.617 31.832C215.781 32.2895 216.841 32.977 217.733 33.8534C218.603 34.6684 219.294 35.6554 219.762 36.7516C220.23 37.8478 220.466 39.0294 220.454 40.2215ZM203.202 113.165V56.7787H218.717V113.165L203.202 113.165Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M275.449 64.3045C277.615 61.73 280.199 59.5381 283.092 57.8206C286.287 56.0978 289.884 55.2584 293.512 55.3889C296.11 55.3101 298.695 55.7837 301.096 56.7786C303.041 57.6281 304.75 58.9396 306.074 60.5994C307.389 62.3094 308.318 64.2846 308.795 66.3885C309.352 68.7795 309.624 71.2279 309.605 73.6829V113.165H294.207V76.8093C294.344 74.5918 293.842 72.3816 292.76 70.4411C291.793 68.9758 290.037 68.2424 287.492 68.2409C286.304 68.2326 285.125 68.4486 284.018 68.8777C282.981 69.2781 282.006 69.824 281.123 70.4987C280.299 71.1329 279.525 71.8298 278.808 72.5832C278.113 73.3176 277.496 73.9929 276.955 74.6091V113.165H261.556V76.8092C261.556 73.9543 261.035 71.8122 259.992 70.383C258.951 68.9557 257.272 68.2417 254.956 68.2409C253.614 68.2303 252.287 68.5274 251.078 69.1095C249.95 69.6432 248.899 70.3244 247.951 71.1354C247.139 71.8284 246.402 72.6046 245.751 73.4513C245.172 74.2238 244.729 74.8027 244.42 75.1882V113.165H229.021V56.7786H244.072V63.7254C244.767 62.9549 245.616 62.0674 246.62 61.0628C247.694 60.0053 248.901 59.0907 250.209 58.3416C251.713 57.4803 253.304 56.7817 254.956 56.2576C256.905 55.6527 258.936 55.3595 260.977 55.389C264.99 55.389 268.136 56.1995 270.414 57.8206C272.691 59.4429 274.441 61.6972 275.449 64.3045Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M371.897 84.9138C371.951 89.0406 371.325 93.1482 370.044 97.0715C368.928 100.487 367.159 103.652 364.834 106.392C362.634 108.949 359.909 111.002 356.845 112.412C353.646 113.864 350.168 114.595 346.655 114.555C343.811 114.667 340.974 114.194 338.319 113.165C336.662 112.49 335.104 111.595 333.687 110.502V138.522H318.289V56.7786H333.341V62.6834C335.036 60.626 337.097 58.899 339.419 57.5891C342.351 56.0202 345.649 55.2607 348.972 55.3889C356.15 55.3889 361.766 57.9363 365.818 63.031C369.87 68.1253 371.896 75.4195 371.897 84.9138ZM355.571 84.9138C355.571 79.5881 354.645 75.3814 352.792 72.2937C351.949 70.8157 350.713 69.6004 349.221 68.7828C347.729 67.9652 346.039 67.5773 344.34 67.6623C342.995 67.6404 341.659 67.8761 340.403 68.3567C339.308 68.7876 338.261 69.3309 337.277 69.9778C336.446 70.5154 335.687 71.1575 335.02 71.8884C334.44 72.5451 333.996 73.0661 333.688 73.4514V98.8079C334.859 99.7732 336.12 100.626 337.451 101.355C339.297 102.283 341.35 102.721 343.414 102.629C345.198 102.707 346.972 102.315 348.557 101.492C350.142 100.669 351.483 99.444 352.445 97.9397C354.529 94.8137 355.571 90.4718 355.571 84.9138Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M380.929 113.165V29.801H396.328V113.165H380.929Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M402.811 56.7786H419.252L431.757 93.9451H432.336L443.799 56.7786H459.661L436.389 119.186C435.266 122.256 433.911 125.237 432.336 128.102C430.984 130.58 429.222 132.811 427.126 134.701C425.041 136.52 422.622 137.916 420.005 138.812C416.809 139.845 413.463 140.335 410.105 140.259C408.206 140.297 406.307 140.161 404.432 139.854C403.043 139.582 402.04 139.37 401.422 139.217L403.621 127.06C404.184 127.256 404.767 127.392 405.358 127.465C406.588 127.605 407.826 127.662 409.063 127.638C413 127.638 415.856 126.75 417.631 124.975C419.571 122.927 421.034 120.476 421.915 117.797L423.999 112.007L402.811 56.7786Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M466.725 113.165V36.053H511.186V49.4841H482.818V66.8518H507.827V79.5881H482.818V99.7341H511.996V113.165H466.725Z"
    })), $0422a6ce4ea03acc$var$wU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 682 196",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M32.4537 44.8212C31.7824 43.9986 31.7335 42.8999 32.7417 42.5666L102.608 19.4645C103.424 19.1952 104.264 19.8031 104.262 20.6605C104.261 21.3498 104.821 21.8151 105.504 21.9204C106.032 22.0031 106.612 22.0404 107.174 21.9884C107.901 21.9204 108.52 21.4618 108.52 20.7325C108.52 20.7325 108.516 13.7286 108.516 13.3833C108.516 13.0073 108.352 12.4433 107.772 12.1647C107.448 12.0073 107.037 11.8847 106.664 12.0087L28.4064 37.9694C25.3935 38.944 24.8564 39.3093 24.8564 42.5452L24.8831 175.561C24.8831 175.687 24.8964 175.818 24.9351 175.938C26.5511 180.867 32.3309 183.122 32.3309 183.122C38.0055 185.277 40.9294 185.875 46.0693 184.091C46.0693 184.091 46.1836 51.3944 46.1159 50.8117C46.0972 50.6464 45.9727 50.5184 45.8102 50.4877C45.2639 50.3851 36.8564 50.2091 32.4549 44.8212",
        fill: "#1B385E"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M7.60886 33.2467C6.90421 32.4533 6.88861 31.3254 7.89632 30.992L77.7634 7.88995C78.578 7.62062 79.418 8.22862 79.418 9.08727C79.4167 9.77658 79.974 10.2606 80.658 10.3472C81.1713 10.4112 81.7819 10.4592 82.3286 10.4139C83.0552 10.3552 83.6739 9.88857 83.6739 9.15926C83.6739 9.15926 83.6699 2.38876 83.6699 1.95544C83.6699 1.47812 83.4379 0.871475 83.0099 0.638138C82.5552 0.390152 82.1926 0.311478 81.8193 0.435486L3.56163 26.3962C0.548639 27.3708 0.0117188 27.7361 0.0117188 30.972L0.0370518 163.987C0.0370518 164.114 0.0533175 164.243 0.0898499 164.363C1.56008 169.285 7.48539 171.549 7.48539 171.549C13.1592 173.702 16.0838 174.3 21.2237 172.518C21.2237 172.518 21.337 39.8212 21.27 39.2372C21.2513 39.0732 21.126 38.9452 20.9633 38.9145C20.4169 38.8118 12.1829 38.3999 7.60792 33.2467",
        fill: "#57AC35"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M149.72 36.7906C149.72 35.932 148.881 35.3253 148.065 35.596L85.8607 56.2648C69.8518 60.9914 69.0505 61.5394 63.9466 59.6607C61.0818 58.6074 58.8494 57.0715 57.5417 55.3822C56.8917 54.5435 56.8897 53.4609 57.898 53.1276L127.764 30.0255C128.58 29.7575 129.42 30.3641 129.418 31.2228C129.417 31.9121 129.974 32.4001 130.658 32.4828C131.182 32.5468 131.761 32.5854 132.324 32.5494C133.054 32.5041 133.676 32.0268 133.674 31.2948L133.672 24.071C133.672 23.5163 133.572 23.1243 132.929 22.727C132.593 22.5203 132.194 22.447 131.821 22.571L53.5626 48.5317C50.5497 49.5063 50.0127 49.8716 50.0127 53.1076L50.0388 183.078C50.0388 183.205 50.0428 184.467 50.0404 184.594C49.9618 188.8 54.9136 191.141 57.2642 192.192C61.1172 193.915 66.083 195.074 71.2242 193.292L148.869 168.075C149.378 167.901 149.72 167.423 149.72 166.885V141.932C149.72 141.088 148.905 140.483 148.096 140.727L85.8305 161.137C85.0225 161.382 84.1452 160.758 84.1452 159.914V137.869C84.1452 137.313 84.5092 136.824 85.0398 136.664L148.764 115.79C149.537 115.506 149.72 115.374 149.72 114.711L149.672 89.232C149.672 88.5014 148.845 87.9907 148.04 88.2227L85.6785 108.876C84.8745 109.107 84.1452 108.292 84.1452 107.453L84.2412 85.3188C84.2412 84.7708 84.5945 84.2868 85.1145 84.1201L148.974 62.9167C149.494 62.7487 149.714 62.0087 149.714 61.4607L149.72 36.7906",
        fill: "#656263"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M257.68 121.443C257.68 126.074 256.832 130.295 255.133 134.101C253.435 137.911 250.989 141.125 247.8 143.751C244.61 146.375 240.723 148.408 236.146 149.847C231.565 151.287 226.443 152.009 220.785 152.009C216.564 152.009 212.757 151.647 209.361 150.929C205.965 150.208 202.955 149.335 200.331 148.304C197.705 147.277 195.44 146.17 193.538 144.985C191.632 143.804 190.115 142.747 188.984 141.82L198.245 126.692C198.864 127.104 199.791 127.748 201.025 128.622C202.26 129.498 203.804 130.346 205.656 131.17C207.509 131.994 209.671 132.739 212.14 133.407C214.61 134.077 217.336 134.411 220.321 134.411C225.57 134.411 229.609 133.253 232.441 130.938C235.27 128.622 236.686 125.819 236.686 122.524C236.686 120.26 236.041 118.331 234.757 116.734C233.467 115.141 231.77 113.725 229.661 112.489C227.551 111.254 225.107 110.046 222.329 108.862C219.55 107.679 216.668 106.314 213.684 104.77C210.492 103.226 207.56 101.529 204.884 99.677C202.207 97.8237 199.891 95.7158 197.937 93.3465C195.982 90.9812 194.438 88.2293 193.306 85.088C192.172 81.9494 191.608 78.2709 191.608 74.0496C191.608 69.6257 192.482 65.6632 194.232 62.1633C195.982 58.666 198.347 55.6794 201.333 53.2088C204.317 50.7395 207.817 48.8369 211.83 47.4983C215.845 46.161 220.168 45.4904 224.798 45.4904C229.017 45.4904 232.749 45.7997 235.991 46.417C239.232 47.0343 242.088 47.7823 244.559 48.6556C247.028 49.5316 249.087 50.4569 250.734 51.4342C252.379 52.4128 253.768 53.3128 254.901 54.1355L246.102 69.4191C245.176 68.8018 244.042 68.1338 242.707 67.4125C241.367 66.6938 239.823 66.0232 238.075 65.4045C236.323 64.7872 234.421 64.2472 232.363 63.7846C230.303 63.3206 228.195 63.0899 226.034 63.0899C221.813 63.0899 218.469 63.9912 216 65.7912C213.529 67.5938 212.294 70.2431 212.294 73.7416C212.294 75.8016 212.781 77.5229 213.761 78.9135C214.737 80.3028 216.076 81.5628 217.774 82.6947C219.473 83.8294 221.48 84.9094 223.796 85.9373C226.111 86.9667 228.605 88.0986 231.282 89.3333C234.679 90.8772 237.971 92.5238 241.162 94.2731C244.351 96.0238 247.156 98.133 249.576 100.602C251.992 103.073 253.949 105.981 255.441 109.325C256.932 112.67 257.68 116.71 257.68 121.443ZM270.029 150.157V74.9763H290.715V150.157H270.029ZM293.031 52.9008C293.031 56.1954 291.82 59.0753 289.403 61.5459C286.985 64.0152 283.974 65.2512 280.373 65.2512C276.769 65.2512 273.785 64.0152 271.418 61.5459C269.05 59.0753 267.868 56.1954 267.868 52.9008C267.868 49.6076 269.05 46.7783 271.418 44.4104C273.785 42.0438 276.769 40.8598 280.373 40.8598C283.974 40.8598 286.985 42.0438 289.403 44.4104C291.82 46.7783 293.031 49.6076 293.031 52.9008ZM366.356 85.0107C369.445 81.4094 372.841 78.5269 376.546 76.3656C380.252 74.2043 384.882 73.1243 390.439 73.1243C394.454 73.1243 397.824 73.7416 400.551 74.9763C403.278 76.2109 405.491 77.9095 407.188 80.0708C408.887 82.2321 410.095 84.8054 410.816 87.7893C411.535 90.7759 411.897 94.0171 411.897 97.5144V150.157H391.366V101.684C391.366 97.9784 390.723 95.1491 389.437 93.1932C388.147 91.2385 385.809 90.2599 382.413 90.2599C380.765 90.2599 379.221 90.5439 377.781 91.1079C376.338 91.6745 375.053 92.3959 373.921 93.2692C372.788 94.1451 371.76 95.0718 370.835 96.0491C369.908 97.0277 369.083 97.9277 368.364 98.7504V150.157H347.832V101.684C347.832 97.877 347.138 95.0211 345.747 93.1145C344.359 91.2119 342.121 90.2599 339.033 90.2599C337.181 90.2599 335.455 90.6452 333.862 91.4172C332.265 92.1892 330.875 93.0905 329.693 94.1185C328.509 95.1491 327.532 96.1784 326.761 97.2064C325.988 98.2357 325.396 99.0077 324.985 99.5223V150.157H304.453V74.9763H324.521V84.2387C325.448 83.2107 326.58 82.0268 327.918 80.6881C329.254 79.3522 330.852 78.1415 332.703 77.0602C334.557 75.9789 336.665 75.0536 339.033 74.2816C341.399 73.5097 344.074 73.1243 347.06 73.1243C352.411 73.1243 356.605 74.2043 359.643 76.3656C362.677 78.5269 364.915 81.4094 366.356 85.0107ZM473.184 112.489C473.184 105.389 471.949 99.7797 469.479 95.6624C467.008 91.5479 463.251 89.4879 458.21 89.4879C456.254 89.4879 454.506 89.7959 452.96 90.4132C451.416 91.0319 450.027 91.7532 448.793 92.5745C447.558 93.3998 446.555 94.2491 445.783 95.1224C445.01 95.9984 444.417 96.6931 444.007 97.2064V131.014C445.343 132.148 447.017 133.28 449.025 134.411C451.031 135.544 453.679 136.109 456.975 136.109C462.224 136.109 466.236 134.024 469.016 129.856C471.795 125.688 473.184 119.899 473.184 112.489ZM494.951 112.489C494.951 118.459 494.126 123.863 492.481 128.699C490.834 133.537 488.517 137.679 485.534 141.125C482.548 144.575 478.997 147.251 474.883 149.153C470.765 151.057 466.236 152.009 461.296 152.009C456.667 152.009 452.96 151.393 450.182 150.157C447.403 148.921 445.343 147.74 444.007 146.606V183.964H423.476V74.9763H443.545V82.8494C445.602 80.2788 448.303 78.0135 451.648 76.0576C454.992 74.103 459.236 73.1243 464.385 73.1243C473.956 73.1243 481.444 76.5202 486.846 83.3121C492.249 90.1052 494.951 99.8303 494.951 112.489ZM506.992 150.157V39.0065H527.524V150.157H506.992ZM536.168 74.9763H558.088L574.761 124.531H575.533L590.817 74.9763H611.966L580.937 158.184C579.288 162.609 577.488 166.571 575.533 170.071C573.577 173.568 571.261 176.501 568.587 178.871C565.908 181.236 562.744 183.063 559.092 184.351C555.438 185.636 551.038 186.281 545.894 186.281C542.702 186.281 540.181 186.1 538.329 185.74C536.477 185.379 535.137 185.096 534.316 184.892L537.248 168.682C537.762 168.887 538.534 169.067 539.564 169.223C540.592 169.377 542.238 169.453 544.505 169.453C549.753 169.453 553.559 168.27 555.927 165.902C558.294 163.534 560.196 160.345 561.639 156.333L564.418 148.613L536.168 74.9763ZM621.384 150.157V47.3423H680.664V65.2512H642.841V88.4079H676.185V105.389H642.841V132.25H681.744V150.157H621.384Z",
        fill: "#1B385E"
    })), $0422a6ce4ea03acc$var$HU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 84 111",
        fill: "#000000",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M5.48333 30.3546C5.48333 30.7465 5.425 31.0781 5.27916 31.4097C5.13333 31.7111 4.95833 31.9824 4.69583 32.1935C4.43333 32.4045 4.14166 32.5853 3.7625 32.7059C3.38333 32.8265 2.975 32.8868 2.5375 32.8868C2.1875 32.8868 1.89583 32.8567 1.63333 32.7964C1.37083 32.7361 1.10833 32.6758 0.904166 32.5853C0.7 32.4949 0.525 32.4045 0.35 32.314C0.204167 32.2236 0.0875 32.1332 0 32.0427L0.729166 30.7766C0.7875 30.8068 0.845833 30.8671 0.9625 30.9273C1.05 30.9876 1.19583 31.0781 1.34167 31.1384C1.4875 31.1987 1.6625 31.2589 1.86667 31.3192C2.07083 31.3795 2.275 31.4097 2.50833 31.4097C2.91667 31.4097 3.2375 31.3192 3.47083 31.1082C3.70417 30.9273 3.82083 30.6862 3.82083 30.4149C3.82083 30.234 3.7625 30.0531 3.675 29.9325C3.55833 29.812 3.44167 29.6914 3.26667 29.5708C3.09167 29.4804 2.91667 29.3598 2.68333 29.2694C2.45 29.1789 2.21667 29.0583 1.98333 28.9377C1.72083 28.8172 1.4875 28.6664 1.28333 28.5157C1.07917 28.365 0.875 28.1841 0.729166 28.0032C0.583333 27.8224 0.4375 27.5812 0.35 27.3099C0.2625 27.0386 0.204167 26.7371 0.204167 26.4055C0.204167 26.0438 0.2625 25.7122 0.408333 25.4107C0.554166 25.1093 0.729166 24.8681 0.9625 24.6571C1.19583 24.4461 1.4875 24.2954 1.80833 24.1748C2.12917 24.0542 2.47917 23.9939 2.85833 23.9939C3.20833 23.9939 3.5 24.024 3.7625 24.0843C4.025 24.1446 4.25833 24.2049 4.4625 24.2652C4.66667 24.3255 4.8125 24.4159 4.95833 24.5064C5.10417 24.5968 5.19167 24.6571 5.27916 24.7174L4.57917 25.9835C4.49167 25.9232 4.40416 25.8629 4.31667 25.8026C4.2 25.7423 4.08333 25.682 3.9375 25.6217C3.79167 25.5615 3.64583 25.5313 3.47083 25.5012C3.29583 25.471 3.15 25.4409 2.975 25.4409C2.625 25.4409 2.3625 25.5012 2.15833 25.6519C1.95417 25.8026 1.86667 26.0136 1.86667 26.3151C1.86667 26.496 1.89583 26.6165 1.98333 26.7371C2.07083 26.8577 2.15833 26.9481 2.30417 27.0386C2.45 27.129 2.59583 27.2195 2.8 27.3099C2.975 27.4003 3.17917 27.4908 3.4125 27.5812C3.675 27.7018 3.9375 27.8525 4.2 28.0032C4.4625 28.154 4.66667 28.3348 4.87083 28.5157C5.075 28.6966 5.22083 28.9679 5.3375 29.2392C5.425 29.6311 5.48333 29.9627 5.48333 30.3546Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M11.1714 25.7122V32.7361H9.39219V25.7122H7.11719V24.2351H13.4172V25.7122H11.1714Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M18.3456 27.6717C18.2872 27.4908 18.2289 27.3099 18.1706 27.1592C18.1122 26.9783 18.0831 26.8276 18.0247 26.707C17.9956 26.5865 17.9664 26.4659 17.9372 26.3754C17.9081 26.285 17.9081 26.2247 17.9081 26.1946H17.8789C17.8789 26.2247 17.8497 26.285 17.8206 26.3754C17.7914 26.4659 17.7622 26.5865 17.7331 26.707C17.7039 26.8578 17.6456 27.0085 17.5872 27.1592C17.5289 27.3099 17.4706 27.4908 17.4122 27.6717L16.7122 29.6914H19.0164L18.3456 27.6717ZM15.6914 32.7361H13.9414L17.0914 24.2351H18.7831L22.0206 32.7361H20.1247L19.5414 31.1384H16.2456L15.6914 32.7361Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M27.1835 32.7361H25.521L22.3418 24.2351H24.2085L25.9585 29.3297C26.0168 29.4804 26.046 29.6613 26.1043 29.812C26.1626 29.9627 26.1918 30.1135 26.2501 30.2642C26.2793 30.4149 26.3376 30.5054 26.3376 30.5958C26.3668 30.6862 26.3668 30.7465 26.3668 30.7465H26.396C26.396 30.7465 26.396 30.6862 26.4251 30.5958C26.4543 30.5054 26.4835 30.3848 26.5126 30.2642C26.5418 30.1135 26.6001 29.9929 26.6585 29.812C26.7168 29.6613 26.746 29.4804 26.8043 29.3297L28.4668 24.2351H30.2168L27.1835 32.7361Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M36.2551 26.7975C36.2551 26.4056 36.1384 26.1041 35.9051 25.9233C35.6717 25.7424 35.3217 25.6218 34.8259 25.6218H33.9509V27.9731H34.9134C35.3801 27.9731 35.7301 27.8827 35.9342 27.6717C36.1384 27.4607 36.2551 27.1592 36.2551 26.7975ZM36.7217 32.7361L35.2051 30.3245C35.0301 30.0833 34.9134 29.8723 34.7967 29.7517C34.6801 29.601 34.5926 29.5106 34.5051 29.4201C34.4176 29.3598 34.3592 29.2995 34.2717 29.2694C34.2134 29.2393 34.1259 29.2393 34.0092 29.2393H33.8926V32.7361H32.1426V24.2351H34.8842C35.8467 24.2351 36.6051 24.4461 37.1301 24.8682C37.6551 25.2902 37.9176 25.8931 37.9176 26.707C37.9176 27.0688 37.8592 27.3702 37.7426 27.6114C37.6259 27.8827 37.4801 28.0937 37.3051 28.2746C37.1301 28.4555 36.9259 28.6062 36.6926 28.7268C36.4592 28.8474 36.2259 28.9077 35.9634 28.9679V28.9981C36.0801 29.0885 36.2259 29.2091 36.3717 29.39C36.5176 29.5709 36.7217 29.8422 36.9259 30.2039L38.5301 32.7361H36.7217Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M46.5222 28.4856C46.5222 28.0937 46.4639 27.732 46.3764 27.3702C46.2889 27.0085 46.143 26.707 45.9389 26.4357C45.7347 26.1644 45.5014 25.9534 45.2097 25.8026C44.918 25.6519 44.568 25.5615 44.1597 25.5615C43.7514 25.5615 43.4014 25.6519 43.0805 25.8026C42.7889 25.9534 42.5264 26.1644 42.3222 26.4357C42.118 26.707 41.9722 27.0085 41.8847 27.3702C41.7972 27.732 41.7389 28.0937 41.7389 28.4856C41.7389 28.8775 41.7972 29.2694 41.8847 29.6311C41.9722 29.9929 42.118 30.3245 42.3222 30.5958C42.5264 30.8671 42.7597 31.0781 43.0805 31.259C43.3722 31.4097 43.7514 31.5001 44.1597 31.5001C44.568 31.5001 44.918 31.4097 45.2389 31.259C45.5305 31.1083 45.793 30.8972 45.9972 30.6259C46.2014 30.3546 46.3472 30.0532 46.4347 29.6914C46.4639 29.2694 46.5222 28.9076 46.5222 28.4856ZM48.3597 28.4554C48.3597 29.0282 48.2722 29.601 48.0972 30.1134C47.9222 30.6561 47.6597 31.1083 47.3097 31.5303C46.9597 31.9523 46.5222 32.2538 45.9972 32.5251C45.4722 32.7662 44.8597 32.8868 44.1889 32.8868C43.4889 32.8868 42.8764 32.7662 42.3514 32.5251C41.8264 32.2839 41.3597 31.9523 41.0097 31.5604C40.6597 31.1685 40.368 30.6862 40.193 30.1737C39.9889 29.6311 39.9014 29.0885 39.9014 28.5157C39.9014 27.943 39.9889 27.3702 40.193 26.8577C40.368 26.3151 40.6597 25.8629 41.0097 25.4409C41.3597 25.0189 41.7972 24.7174 42.3514 24.4762C42.8764 24.2351 43.4889 24.1145 44.1889 24.1145C44.8889 24.1145 45.5014 24.2351 46.0264 24.4762C46.5514 24.7174 46.9889 25.049 47.368 25.4409C47.718 25.8328 48.0097 26.3151 48.1847 26.8276C48.2722 27.3401 48.3597 27.8827 48.3597 28.4554Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M55.5341 30.3551C55.5341 30.747 55.4758 31.0786 55.3299 31.4102C55.1841 31.7116 55.0091 31.9829 54.7466 32.1939C54.4841 32.405 54.1924 32.5858 53.8133 32.7064C53.4341 32.827 53.0258 32.8873 52.5883 32.8873C52.2383 32.8873 51.9466 32.8571 51.6841 32.7969C51.4216 32.7366 51.1591 32.6763 50.9549 32.5858C50.7508 32.4954 50.5758 32.405 50.4008 32.3145C50.2549 32.2241 50.1383 32.1337 50.0508 32.0432L50.7799 30.7771C50.8383 30.8073 50.8966 30.8675 51.0133 30.9278C51.1008 30.9881 51.2466 31.0786 51.3924 31.1389C51.5383 31.1991 51.7133 31.2594 51.9174 31.3197C52.1216 31.38 52.3258 31.4102 52.5591 31.4102C52.9674 31.4102 53.2883 31.3197 53.5216 31.1087C53.7549 30.9278 53.8716 30.6867 53.8716 30.4154C53.8716 30.2345 53.8133 30.0536 53.7258 29.933C53.6091 29.8125 53.4924 29.6919 53.3174 29.5713C53.1424 29.4809 52.9674 29.3603 52.7341 29.2698C52.5008 29.1794 52.2674 29.0588 52.0341 28.9382C51.7716 28.8177 51.5383 28.6669 51.3341 28.5162C51.1299 28.3655 50.9258 28.1846 50.7799 28.0037C50.6341 27.8229 50.4883 27.5817 50.4008 27.3104C50.3133 27.0391 50.2549 26.7376 50.2549 26.406C50.2549 26.0443 50.3133 25.7127 50.4591 25.4112C50.6049 25.1098 50.7799 24.8686 51.0133 24.6576C51.2466 24.4466 51.5383 24.2958 51.8591 24.1753C52.1799 24.0547 52.5299 23.9944 52.9091 23.9944C53.2591 23.9944 53.5508 24.0245 53.8133 24.0848C54.0758 24.1451 54.3091 24.2054 54.5133 24.2657C54.7174 24.326 54.8633 24.4164 55.0091 24.5069C55.1549 24.5973 55.2424 24.6576 55.3299 24.7179L54.6299 25.984C54.5424 25.9237 54.4549 25.8634 54.3674 25.8031C54.2508 25.7428 54.1341 25.6825 53.9883 25.6222C53.8424 25.5619 53.6966 25.5318 53.5216 25.5017C53.3466 25.4715 53.2008 25.4414 53.0258 25.4414C52.6758 25.4414 52.4133 25.5017 52.2091 25.6524C52.0049 25.8031 51.9174 26.0141 51.9174 26.3156C51.9174 26.4965 51.9466 26.617 52.0341 26.7376C52.1216 26.8582 52.2091 26.9486 52.3549 27.0391C52.5008 27.1295 52.6466 27.2199 52.8508 27.3104C53.0258 27.4008 53.2299 27.4913 53.4633 27.5817C53.7258 27.7023 53.9883 27.853 54.2508 28.0037C54.5133 28.1545 54.7174 28.3353 54.9216 28.5162C55.1258 28.7272 55.2716 28.9684 55.3883 29.2397C55.4758 29.6316 55.5341 29.9632 55.5341 30.3551Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84 62.187H0V63.9957H84V62.187Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84 39.1272H0V40.9359H84V39.1272Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84 108.31H0V110.119H84V108.31Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84 85.25H0V87.0587H84V85.25Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M5.54167 55.7964L2.33333 51.0636C2.1 50.732 1.89583 50.4305 1.75 50.1894C1.60417 49.9482 1.54583 49.7975 1.51667 49.7975H1.54583C1.54583 49.7975 1.54583 49.8578 1.54583 49.9181C1.54583 49.9784 1.54583 50.0688 1.575 50.1894C1.575 50.3099 1.575 50.4004 1.60417 50.5511C1.60417 50.6717 1.60417 50.8224 1.60417 50.943V55.7964H0V47.2954H1.75L4.725 51.6966C4.84167 51.8775 4.95833 52.0584 5.075 52.2091C5.19167 52.39 5.27917 52.5407 5.3375 52.6613C5.425 52.7819 5.48333 52.9025 5.5125 52.9929C5.57083 53.0833 5.57083 53.1135 5.57083 53.1135H5.6C5.6 53.1135 5.6 53.0532 5.6 52.9929C5.6 52.9025 5.6 52.812 5.57083 52.6914C5.57083 52.5709 5.57083 52.4201 5.54167 52.2694C5.54167 52.1187 5.54167 51.9679 5.54167 51.7871V47.2954H7.11667V55.7964H5.54167Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M11.8418 47.2954H10.0918V55.7964H11.8418V47.2954Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M18.4063 50.732C18.3479 50.5511 18.2896 50.3702 18.2313 50.2195C18.1729 50.0386 18.1438 49.8879 18.0854 49.7673C18.0563 49.6468 18.0271 49.5262 17.9979 49.4357C17.9688 49.3453 17.9688 49.285 17.9688 49.2549H17.9396C17.9396 49.285 17.9104 49.3453 17.8813 49.4357C17.8521 49.5262 17.8229 49.6468 17.7938 49.7673C17.7646 49.9181 17.7063 50.0688 17.6479 50.2195C17.5896 50.3702 17.5313 50.5511 17.4729 50.732L16.7729 52.7517H19.0771L18.4063 50.732ZM15.7813 55.7964H14.0312L17.1813 47.2954H18.8729L22.1104 55.7964H20.2146L19.6604 54.1987H16.3354L15.7813 55.7964Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M28.174 49.8578C28.174 49.4659 28.0574 49.1644 27.824 48.9836C27.5907 48.8027 27.2407 48.6821 26.7157 48.6821H25.8407V51.0334H26.8032C27.2699 51.0334 27.6199 50.943 27.824 50.732C28.0574 50.521 28.174 50.2195 28.174 49.8578ZM28.6407 55.7964L27.124 53.3848C26.949 53.1436 26.8324 52.9326 26.7157 52.812C26.599 52.6613 26.5115 52.5709 26.424 52.4804C26.3365 52.4201 26.2782 52.3598 26.1907 52.3297C26.1324 52.2995 26.0449 52.2995 25.9282 52.2995H25.8115V55.7964H24.0615V47.2954H26.8032C27.7657 47.2954 28.524 47.5064 29.049 47.9285C29.574 48.3505 29.8365 48.9534 29.8365 49.7673C29.8365 50.1291 29.7782 50.4305 29.6615 50.6717C29.5449 50.943 29.399 51.154 29.224 51.3349C29.049 51.5158 28.8449 51.6665 28.6115 51.7871C28.3782 51.9077 28.1449 51.9679 27.8824 52.0282V52.0584C27.999 52.1488 28.1449 52.2694 28.2907 52.4503C28.4365 52.6311 28.6407 52.9025 28.8449 53.2642L30.449 55.7964H28.6407Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M38.7628 55.043C38.6461 55.1335 38.5294 55.254 38.3544 55.3445C38.1794 55.4349 37.9753 55.5555 37.7711 55.6459C37.5378 55.7364 37.3044 55.7966 37.0419 55.8569C36.7794 55.9172 36.4878 55.9474 36.1961 55.9474C35.4961 55.9474 34.8836 55.8268 34.3586 55.5856C33.8336 55.3445 33.3961 55.0129 33.0461 54.621C32.6961 54.1989 32.4336 53.7468 32.2586 53.2041C32.0836 52.6615 31.9961 52.1189 31.9961 51.5461C31.9961 50.9734 32.0836 50.4006 32.2586 49.8881C32.4336 49.3455 32.6961 48.8933 33.0753 48.5015C33.4253 48.1096 33.8919 47.778 34.4169 47.5368C34.9419 47.2956 35.5544 47.175 36.2544 47.175C36.8086 47.175 37.2753 47.2353 37.6544 47.3559C38.0336 47.4765 38.4128 47.6272 38.7336 47.8684L37.9461 49.1948C37.7128 49.0441 37.4794 48.9235 37.1878 48.833C36.9253 48.7426 36.6044 48.7125 36.2253 48.7125C35.8461 48.7125 35.4961 48.7728 35.2044 48.9235C34.9128 49.0742 34.6503 49.2852 34.4753 49.5264C34.2711 49.7977 34.1253 50.0992 34.0378 50.4308C33.9211 50.7624 33.8919 51.1542 33.8919 51.5461C33.8919 51.9682 33.9503 52.3299 34.0378 52.6917C34.1253 53.0534 34.2711 53.3549 34.4753 53.6262C34.6794 53.8975 34.9128 54.1085 35.2336 54.2592C35.5253 54.41 35.8753 54.5004 36.2836 54.5004C36.7211 54.5004 37.1003 54.4401 37.3919 54.2894C37.6836 54.1688 37.9461 54.0181 38.1503 53.8372L38.7628 55.043Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M46.3147 55.7964V52.1187H42.6105V55.7964H40.8896V47.2954H42.6105V50.6415H46.3147V47.2954H48.0355V55.7964H46.3147Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M56.9617 51.5461C56.9617 51.1542 56.9033 50.7925 56.8158 50.4308C56.7283 50.069 56.5825 49.7676 56.3783 49.4962C56.1742 49.2249 55.9408 49.0139 55.6492 48.8632C55.3575 48.7125 55.0075 48.622 54.5992 48.622C54.1908 48.622 53.8408 48.7125 53.52 48.8632C53.2283 49.0139 52.9658 49.2249 52.7617 49.4962C52.5575 49.7676 52.4117 50.069 52.3242 50.4308C52.2367 50.7925 52.1783 51.1542 52.1783 51.5461C52.1783 51.938 52.2367 52.3299 52.3242 52.6917C52.4117 53.0534 52.5575 53.385 52.7617 53.6563C52.9658 53.9276 53.1992 54.1386 53.52 54.3195C53.8117 54.4702 54.1908 54.5607 54.5992 54.5607C55.0075 54.5607 55.3575 54.4702 55.6783 54.3195C55.97 54.1688 56.2325 53.9578 56.4367 53.6865C56.6408 53.4152 56.7867 53.1137 56.8742 52.752C56.9033 52.3299 56.9617 51.9682 56.9617 51.5461ZM58.7992 51.516C58.7992 52.0888 58.7117 52.6615 58.5367 53.174C58.3617 53.7166 58.0992 54.1688 57.7492 54.5908C57.3992 55.0129 56.9617 55.3143 56.4367 55.5856C55.9117 55.8268 55.2992 55.9474 54.6283 55.9474C53.9283 55.9474 53.3158 55.8268 52.7908 55.5856C52.2658 55.3445 51.7992 55.0129 51.4492 54.621C51.0992 54.2291 50.8075 53.7468 50.6325 53.2343C50.4283 52.6917 50.3408 52.1491 50.3408 51.5763C50.3408 51.0035 50.4283 50.4308 50.6325 49.9183C50.8075 49.3757 51.0992 48.9235 51.4492 48.5015C51.7992 48.0794 52.2367 47.778 52.7908 47.5368C53.3158 47.2956 53.9283 47.175 54.6283 47.175C55.3283 47.175 55.9408 47.2956 56.4658 47.5368C56.9908 47.778 57.4283 48.1096 57.8075 48.5015C58.1867 48.8933 58.4492 49.3757 58.6242 49.8881C58.7117 50.4006 58.7992 50.9432 58.7992 51.516Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M66.0331 53.4161C66.0331 53.808 65.9748 54.1396 65.829 54.4712C65.6831 54.7727 65.5081 55.044 65.2456 55.255C64.9831 55.466 64.6915 55.6469 64.3123 55.7675C63.9331 55.888 63.5248 55.9483 63.0873 55.9483C62.7373 55.9483 62.4456 55.9182 62.1831 55.8579C61.9206 55.7976 61.6581 55.7373 61.454 55.6469C61.2498 55.5564 61.0748 55.466 60.8998 55.3756C60.754 55.2851 60.6373 55.1947 60.5498 55.1043L61.279 53.8382C61.3373 53.8683 61.3956 53.9286 61.5123 53.9889C61.5998 54.0492 61.7456 54.1396 61.8915 54.1999C62.0373 54.2602 62.2123 54.3205 62.4165 54.3808C62.6206 54.4411 62.8248 54.4712 63.0581 54.4712C63.4665 54.4712 63.7873 54.3808 64.0206 54.1698C64.254 53.9889 64.3706 53.7477 64.3706 53.4764C64.3706 53.2955 64.3123 53.1147 64.2248 52.9941C64.1373 52.8735 63.9915 52.7529 63.8165 52.6323C63.6415 52.5419 63.4665 52.4213 63.2331 52.3309C62.9998 52.2404 62.7665 52.1199 62.5331 51.9993C62.2706 51.8787 62.0373 51.728 61.8331 51.5772C61.629 51.4265 61.4248 51.2456 61.279 51.0648C61.1331 50.8839 60.9873 50.6427 60.8998 50.3714C60.8123 50.1001 60.754 49.7987 60.754 49.4671C60.754 49.1053 60.8123 48.7737 60.9581 48.4723C61.104 48.1708 61.279 47.9296 61.5123 47.7186C61.7456 47.5076 62.0373 47.3569 62.3581 47.2363C62.679 47.1157 63.029 47.0554 63.4081 47.0554C63.7581 47.0554 64.0498 47.0856 64.3123 47.1459C64.5748 47.2061 64.8081 47.2664 65.0123 47.3267C65.2165 47.387 65.3623 47.4775 65.5081 47.5679C65.654 47.6583 65.7415 47.7186 65.829 47.7789L65.129 49.045C65.0415 48.9847 64.954 48.9244 64.8665 48.8943C64.7498 48.834 64.6331 48.7737 64.4873 48.7134C64.3415 48.6531 64.1956 48.623 64.0206 48.5928C63.8456 48.5627 63.6998 48.5325 63.5248 48.5325C63.1748 48.5325 62.9123 48.5928 62.7081 48.7436C62.504 48.8943 62.4165 49.1053 62.4165 49.4068C62.4165 49.5876 62.4456 49.7082 62.5331 49.8288C62.6206 49.9494 62.7081 50.0398 62.854 50.1303C62.9998 50.2207 63.1456 50.3111 63.3498 50.4016C63.5248 50.492 63.729 50.5824 63.9623 50.6729C64.2248 50.7935 64.4873 50.9442 64.7498 51.0949C65.0123 51.2456 65.2165 51.4265 65.4206 51.6074C65.6248 51.8184 65.7706 52.0596 65.8873 52.3309C66.004 52.6022 66.0331 53.0242 66.0331 53.4161Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M1.75 71.8341V73.9141H4.375V75.3309H1.75V78.8579H0V70.3569H4.725V71.8341H1.75Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M13.1824 74.6082C13.1824 74.2163 13.124 73.8545 13.0365 73.4928C12.949 73.131 12.8032 72.8296 12.599 72.5583C12.3949 72.287 12.1615 72.0759 11.8699 71.9252C11.5782 71.7745 11.2282 71.684 10.8199 71.684C10.4115 71.684 10.0615 71.7745 9.74069 71.9252C9.44902 72.0759 9.18652 72.287 8.98236 72.5583C8.77819 72.8296 8.63236 73.131 8.54486 73.4928C8.45736 73.8545 8.39902 74.2163 8.39902 74.6082C8.39902 75.0001 8.45736 75.3919 8.54486 75.7537C8.63236 76.1154 8.77819 76.447 8.98236 76.7184C9.18652 76.9897 9.41986 77.2007 9.74069 77.3815C10.0324 77.5323 10.4115 77.6227 10.8199 77.6227C11.2282 77.6227 11.5782 77.5323 11.899 77.3815C12.2199 77.2308 12.4532 77.0198 12.6574 76.7485C12.8615 76.4772 13.0074 76.1757 13.0949 75.814C13.124 75.3919 13.1824 75.0302 13.1824 74.6082ZM15.0199 74.578C15.0199 75.1508 14.9324 75.7235 14.7574 76.236C14.5824 76.7786 14.3199 77.2308 13.9699 77.6529C13.6199 78.0749 13.1824 78.3764 12.6574 78.6477C12.1324 78.8888 11.5199 79.0094 10.849 79.0094C10.149 79.0094 9.53652 78.8888 9.01152 78.6477C8.48652 78.4065 8.01986 78.0749 7.66986 77.683C7.31986 77.2911 7.02819 76.8088 6.85319 76.2963C6.64902 75.7537 6.56152 75.2111 6.56152 74.6383C6.56152 74.0655 6.64902 73.4928 6.85319 72.9803C7.02819 72.4377 7.31986 71.9855 7.66986 71.5635C8.01986 71.1414 8.45736 70.84 9.01152 70.5988C9.53652 70.3576 10.149 70.2371 10.849 70.2371C11.549 70.2371 12.1615 70.3576 12.6865 70.5988C13.2115 70.84 13.649 71.1716 14.0282 71.5635C14.4074 71.9554 14.6699 72.4377 14.8449 72.9502C14.9324 73.4626 15.0199 74.0053 15.0199 74.578Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M24.0923 75.3921C24.0923 76.5677 23.8006 77.442 23.2465 78.075C22.6923 78.7081 21.8465 79.0095 20.709 79.0095C19.5131 79.0095 18.6382 78.7081 18.0548 78.1353C17.4715 77.5324 17.209 76.6883 17.209 75.5729V70.3578H18.959V75.4222C18.959 76.1457 19.1048 76.6883 19.3673 77.0199C19.6298 77.3515 20.0965 77.5324 20.7673 77.5324C21.3798 77.5324 21.8173 77.3515 22.109 76.9898C22.4006 76.628 22.5173 76.1457 22.5173 75.5127V70.3276H24.1215V75.3921H24.0923Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M32.3452 78.8579L29.1369 74.1251C28.9036 73.7935 28.6994 73.4921 28.5536 73.2509C28.4077 73.0097 28.3494 72.859 28.3202 72.859H28.2911C28.2911 72.859 28.2911 72.9193 28.2911 72.9796C28.2911 73.0399 28.2911 73.1303 28.3202 73.2509C28.3202 73.3715 28.3202 73.4619 28.3494 73.6126C28.3494 73.7332 28.3494 73.8839 28.3494 74.0045V78.8579H26.7744V70.3569H28.5244L31.4994 74.7582C31.6161 74.939 31.7327 75.1199 31.8494 75.2706C31.9661 75.4515 32.0536 75.6022 32.1119 75.7228C32.1994 75.8434 32.2577 75.964 32.2869 76.0544C32.3452 76.1449 32.3452 76.175 32.3452 76.175H32.3744C32.3744 76.175 32.3744 76.1147 32.3744 76.0544C32.3744 75.964 32.3744 75.8735 32.3452 75.753C32.3452 75.6324 32.3452 75.4817 32.3161 75.3309C32.3161 75.1802 32.3161 75.0295 32.3161 74.8486V70.3569H33.8911V78.8579H32.3452Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M42.2622 74.5471C42.2622 73.5825 42.0288 72.8892 41.5622 72.4671C41.0955 72.0149 40.3663 71.8039 39.4038 71.8039H38.6455V77.411H39.4622C40.3955 77.411 41.0955 77.1698 41.5622 76.6875C42.0288 76.2051 42.2622 75.4817 42.2622 74.5471ZM44.0997 74.4869C44.0997 75.0898 44.0122 75.6625 43.808 76.2051C43.6038 76.7478 43.3413 77.1999 42.933 77.5918C42.5538 77.9837 42.058 78.2852 41.4455 78.5264C40.833 78.7374 40.133 78.8579 39.3163 78.8579H36.8955V70.3569H39.3747C40.1913 70.3569 40.8913 70.4474 41.4747 70.6584C42.058 70.8694 42.5538 71.1407 42.933 71.5025C43.3122 71.8642 43.6038 72.3164 43.7788 72.7987C44.0122 73.3112 44.0997 73.8839 44.0997 74.4869Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M49.5244 73.7935C49.4661 73.6126 49.4077 73.4318 49.3494 73.281C49.2911 73.1002 49.2619 72.9494 49.2036 72.8289C49.1744 72.7083 49.1452 72.5877 49.1161 72.4973C49.0869 72.4068 49.0869 72.3465 49.0869 72.3164H49.0577C49.0577 72.3465 49.0286 72.4068 48.9994 72.4973C48.9702 72.5877 48.9411 72.7083 48.9119 72.8289C48.8827 72.9796 48.8244 73.1303 48.7661 73.281C48.7077 73.4318 48.6494 73.6126 48.5911 73.7935L47.8911 75.8133H50.1952L49.5244 73.7935ZM46.8994 78.8579H45.1494L48.2994 70.3569H49.9911L53.2286 78.8579H51.3327L50.7786 77.2602H47.4827L46.8994 78.8579Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M57.6344 71.8341V78.8579H55.8844V71.8341H53.6094V70.3569H59.9094V71.8341H57.6344Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M63.8457 70.3569H62.0957V78.8579H63.8457V70.3569Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M72.7694 74.6082C72.7694 74.2163 72.7111 73.8545 72.6236 73.4928C72.5361 73.131 72.3902 72.8296 72.1861 72.5583C71.9819 72.287 71.7486 72.0759 71.4569 71.9252C71.1652 71.7745 70.8152 71.684 70.4069 71.684C69.9986 71.684 69.6486 71.7745 69.3277 71.9252C69.0361 72.0759 68.7736 72.287 68.5694 72.5583C68.3652 72.8296 68.2194 73.131 68.1319 73.4928C68.0444 73.8545 67.9861 74.2163 67.9861 74.6082C67.9861 75.0001 68.0444 75.3919 68.1319 75.7537C68.2194 76.1154 68.3652 76.447 68.5694 76.7184C68.7736 76.9897 69.0069 77.2007 69.3277 77.3815C69.6194 77.5323 69.9986 77.6227 70.4069 77.6227C70.8152 77.6227 71.1652 77.5323 71.4861 77.3815C71.7777 77.2308 72.0402 77.0198 72.2444 76.7485C72.4486 76.4772 72.5944 76.1757 72.6819 75.814C72.7402 75.3919 72.7694 75.0302 72.7694 74.6082ZM74.6361 74.578C74.6361 75.1508 74.5486 75.7235 74.3736 76.236C74.1986 76.7786 73.9361 77.2308 73.5861 77.6529C73.2361 78.0749 72.7986 78.3764 72.2736 78.6477C71.7486 78.8888 71.1361 79.0094 70.4652 79.0094C69.7652 79.0094 69.1527 78.8888 68.6277 78.6477C68.1027 78.4065 67.6361 78.0749 67.2861 77.683C66.9361 77.2911 66.6444 76.8088 66.4694 76.2963C66.2652 75.7537 66.1777 75.2111 66.1777 74.6383C66.1777 74.0655 66.2652 73.4928 66.4694 72.9803C66.6444 72.4377 66.9361 71.9855 67.2861 71.5635C67.6361 71.1414 68.0736 70.84 68.6277 70.5988C69.1527 70.3576 69.7652 70.2371 70.4652 70.2371C71.1652 70.2371 71.7777 70.3576 72.3027 70.5988C72.8277 70.84 73.2652 71.1716 73.6444 71.5635C74.0236 71.9554 74.2861 72.4377 74.4611 72.9502C74.5194 73.4626 74.6361 74.0053 74.6361 74.578Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.3951 78.8579L79.1867 74.1251C78.9534 73.7935 78.7492 73.4921 78.6034 73.2509C78.4576 73.0097 78.3992 72.859 78.3701 72.859H78.3409C78.3409 72.859 78.3409 72.9193 78.3409 72.9796C78.3409 73.0399 78.3409 73.1303 78.3701 73.2509C78.3701 73.3715 78.3701 73.4619 78.3992 73.6126C78.3992 73.7332 78.3992 73.8839 78.3992 74.0045V78.8579H76.8242V70.3569H78.5742L81.5492 74.7582C81.6659 74.939 81.7826 75.1199 81.8992 75.2706C82.0159 75.4515 82.1034 75.6022 82.1617 75.7228C82.2492 75.8434 82.3076 75.964 82.3367 76.0544C82.3951 76.1449 82.3951 76.175 82.3951 76.175H82.4242C82.4242 76.175 82.4242 76.1147 82.4242 76.0544C82.4242 75.964 82.4242 75.8735 82.3951 75.753C82.3951 75.6324 82.3951 75.4817 82.3659 75.3309C82.3659 75.1802 82.3659 75.0295 82.3659 74.8486V70.3569H83.9409V78.8579H82.3951Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0 101.92V93.4189H1.75V100.473H4.8125V101.92H0Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M8.86719 93.4189H7.11719V101.92H8.86719V93.4189Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M16.0128 99.4179C16.0128 99.026 15.8961 98.7245 15.6628 98.5135C15.4294 98.3025 15.0503 98.2121 14.5544 98.2121H13.5628V100.563H14.4669C14.9628 100.563 15.3419 100.473 15.6044 100.292C15.8961 100.111 16.0128 99.8098 16.0128 99.4179ZM15.7211 95.8004C15.7211 95.1071 15.2836 94.7755 14.4086 94.7755H13.5628V96.8857H14.3794C14.8461 96.8857 15.1961 96.7952 15.4003 96.6144C15.6336 96.4636 15.7211 96.1923 15.7211 95.8004ZM17.7919 99.5686C17.7919 99.9907 17.7044 100.383 17.5586 100.684C17.3836 100.985 17.1794 101.227 16.8878 101.407C16.5961 101.588 16.2753 101.739 15.8669 101.799C15.4586 101.89 15.0503 101.92 14.5836 101.92H11.8711V93.4189H14.6128C14.9919 93.4189 15.3419 93.4491 15.6919 93.5094C16.0419 93.5697 16.3336 93.6903 16.5961 93.8711C16.8586 94.0219 17.0628 94.263 17.2086 94.5343C17.3544 94.8056 17.4419 95.1372 17.4419 95.5291C17.4419 96.0717 17.2961 96.5239 17.0336 96.8254C16.7711 97.1268 16.4211 97.368 15.9836 97.4886V97.5187C16.2169 97.5489 16.4503 97.6393 16.6836 97.7297C16.8878 97.8202 17.0919 97.9709 17.2669 98.1518C17.4419 98.3327 17.5586 98.5135 17.6461 98.7547C17.7336 98.9657 17.7919 99.237 17.7919 99.5686Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M24.2668 95.9813C24.2668 95.5894 24.1501 95.288 23.9168 95.1071C23.6835 94.9262 23.3335 94.8056 22.8085 94.8056H21.9335V97.157H22.896C23.3626 97.157 23.7126 97.0665 23.9168 96.8555C24.1793 96.6445 24.2668 96.3431 24.2668 95.9813ZM24.7335 101.92L23.2168 99.5083C23.0418 99.2672 22.9251 99.0561 22.8085 98.9356C22.6918 98.7848 22.6043 98.6944 22.5168 98.604C22.4293 98.5437 22.371 98.4834 22.2835 98.4532C22.2251 98.4231 22.1376 98.4231 22.021 98.4231H21.9043V101.92H20.1543V93.4189H22.896C23.8585 93.4189 24.6168 93.63 25.1418 94.052C25.6668 94.474 25.9293 95.0769 25.9293 95.8909C25.9293 96.2526 25.871 96.5541 25.7543 96.7952C25.6376 97.0665 25.4918 97.2776 25.3168 97.4584C25.1418 97.6393 24.9376 97.79 24.7043 97.9106C24.471 98.0312 24.2376 98.0915 23.9751 98.1518V98.1819C24.0918 98.2724 24.2376 98.393 24.3835 98.5738C24.5293 98.7547 24.7335 99.026 24.9376 99.3877L26.5418 101.92H24.7335Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M32.4639 96.8555C32.4055 96.6747 32.3472 96.4938 32.2889 96.3431C32.2305 96.1622 32.2014 96.0115 32.143 95.8909C32.1139 95.7703 32.0847 95.6497 32.0555 95.5593C32.0264 95.4688 32.0264 95.4085 32.0264 95.3784H31.9972C31.9972 95.4085 31.968 95.4688 31.9389 95.5593C31.9097 95.6497 31.8805 95.7703 31.8514 95.8909C31.8222 96.0416 31.7639 96.1923 31.7055 96.3431C31.6472 96.4938 31.5889 96.6747 31.5305 96.8555L30.8305 98.8753H33.1347L32.4639 96.8555ZM29.8389 101.92H28.0889L31.2389 93.4189H32.9305L36.168 101.92H34.2722L33.718 100.322H30.4222L29.8389 101.92Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M42.2053 95.9813C42.2053 95.5894 42.0886 95.288 41.8553 95.1071C41.6219 94.9262 41.2719 94.8056 40.7761 94.8056H39.9011V97.157H40.8636C41.3303 97.157 41.6803 97.0665 41.8844 96.8555C42.0886 96.6445 42.2053 96.3431 42.2053 95.9813ZM42.6719 101.92L41.1553 99.5083C40.9803 99.2672 40.8636 99.0561 40.7469 98.9356C40.6303 98.7848 40.5428 98.6944 40.4553 98.604C40.3678 98.5437 40.3094 98.4834 40.2219 98.4532C40.1636 98.4231 40.0761 98.4231 39.9594 98.4231H39.8428V101.92H38.0928V93.4189H40.8344C41.7969 93.4189 42.5553 93.63 43.0803 94.052C43.6053 94.474 43.8678 95.0769 43.8678 95.8909C43.8678 96.2526 43.8094 96.5541 43.6928 96.7952C43.5761 97.0665 43.4303 97.2776 43.2553 97.4584C43.0803 97.6393 42.8761 97.79 42.6428 97.9106C42.4094 98.0312 42.1761 98.0915 41.9136 98.1518V98.1819C42.0303 98.2724 42.1761 98.393 42.3219 98.5738C42.4678 98.7547 42.6719 99.026 42.8761 99.3877L44.4803 101.92H42.6719Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M49.7877 98.7246V101.92H48.0377V98.7246L45.3252 93.4189H47.2502L49.0002 97.0364L50.7502 93.4189H52.4419L49.7877 98.7246Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84 17.8442H55.5333V3.22364L28.4667 17.8442H0V16.0656H28L57.2542 0.118652V16.0656H84V17.8442Z"
    })), $0422a6ce4ea03acc$var$xU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 84 111",
        fill: "#ffffff",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M5.48333 30.3546C5.48333 30.7465 5.425 31.0781 5.27916 31.4097C5.13333 31.7111 4.95833 31.9824 4.69583 32.1935C4.43333 32.4045 4.14166 32.5853 3.7625 32.7059C3.38333 32.8265 2.975 32.8868 2.5375 32.8868C2.1875 32.8868 1.89583 32.8567 1.63333 32.7964C1.37083 32.7361 1.10833 32.6758 0.904166 32.5853C0.7 32.4949 0.525 32.4045 0.35 32.314C0.204167 32.2236 0.0875 32.1332 0 32.0427L0.729166 30.7766C0.7875 30.8068 0.845833 30.8671 0.9625 30.9273C1.05 30.9876 1.19583 31.0781 1.34167 31.1384C1.4875 31.1987 1.6625 31.2589 1.86667 31.3192C2.07083 31.3795 2.275 31.4097 2.50833 31.4097C2.91667 31.4097 3.2375 31.3192 3.47083 31.1082C3.70417 30.9273 3.82083 30.6862 3.82083 30.4149C3.82083 30.234 3.7625 30.0531 3.675 29.9325C3.55833 29.812 3.44167 29.6914 3.26667 29.5708C3.09167 29.4804 2.91667 29.3598 2.68333 29.2694C2.45 29.1789 2.21667 29.0583 1.98333 28.9377C1.72083 28.8172 1.4875 28.6664 1.28333 28.5157C1.07917 28.365 0.875 28.1841 0.729166 28.0032C0.583333 27.8224 0.4375 27.5812 0.35 27.3099C0.2625 27.0386 0.204167 26.7371 0.204167 26.4055C0.204167 26.0438 0.2625 25.7122 0.408333 25.4107C0.554166 25.1093 0.729166 24.8681 0.9625 24.6571C1.19583 24.4461 1.4875 24.2954 1.80833 24.1748C2.12917 24.0542 2.47917 23.9939 2.85833 23.9939C3.20833 23.9939 3.5 24.024 3.7625 24.0843C4.025 24.1446 4.25833 24.2049 4.4625 24.2652C4.66667 24.3255 4.8125 24.4159 4.95833 24.5064C5.10417 24.5968 5.19167 24.6571 5.27916 24.7174L4.57917 25.9835C4.49167 25.9232 4.40416 25.8629 4.31667 25.8026C4.2 25.7423 4.08333 25.682 3.9375 25.6217C3.79167 25.5615 3.64583 25.5313 3.47083 25.5012C3.29583 25.471 3.15 25.4409 2.975 25.4409C2.625 25.4409 2.3625 25.5012 2.15833 25.6519C1.95417 25.8026 1.86667 26.0136 1.86667 26.3151C1.86667 26.496 1.89583 26.6165 1.98333 26.7371C2.07083 26.8577 2.15833 26.9481 2.30417 27.0386C2.45 27.129 2.59583 27.2195 2.8 27.3099C2.975 27.4003 3.17917 27.4908 3.4125 27.5812C3.675 27.7018 3.9375 27.8525 4.2 28.0032C4.4625 28.154 4.66667 28.3348 4.87083 28.5157C5.075 28.6966 5.22083 28.9679 5.3375 29.2392C5.425 29.6311 5.48333 29.9627 5.48333 30.3546Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M11.1714 25.7122V32.7361H9.39219V25.7122H7.11719V24.2351H13.4172V25.7122H11.1714Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M18.3456 27.6717C18.2872 27.4908 18.2289 27.3099 18.1706 27.1592C18.1122 26.9783 18.0831 26.8276 18.0247 26.707C17.9956 26.5865 17.9664 26.4659 17.9372 26.3754C17.9081 26.285 17.9081 26.2247 17.9081 26.1946H17.8789C17.8789 26.2247 17.8497 26.285 17.8206 26.3754C17.7914 26.4659 17.7622 26.5865 17.7331 26.707C17.7039 26.8578 17.6456 27.0085 17.5872 27.1592C17.5289 27.3099 17.4706 27.4908 17.4122 27.6717L16.7122 29.6914H19.0164L18.3456 27.6717ZM15.6914 32.7361H13.9414L17.0914 24.2351H18.7831L22.0206 32.7361H20.1247L19.5414 31.1384H16.2456L15.6914 32.7361Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M27.1835 32.7361H25.521L22.3418 24.2351H24.2085L25.9585 29.3297C26.0168 29.4804 26.046 29.6613 26.1043 29.812C26.1626 29.9627 26.1918 30.1135 26.2501 30.2642C26.2793 30.4149 26.3376 30.5054 26.3376 30.5958C26.3668 30.6862 26.3668 30.7465 26.3668 30.7465H26.396C26.396 30.7465 26.396 30.6862 26.4251 30.5958C26.4543 30.5054 26.4835 30.3848 26.5126 30.2642C26.5418 30.1135 26.6001 29.9929 26.6585 29.812C26.7168 29.6613 26.746 29.4804 26.8043 29.3297L28.4668 24.2351H30.2168L27.1835 32.7361Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M36.2551 26.7975C36.2551 26.4056 36.1384 26.1041 35.9051 25.9233C35.6717 25.7424 35.3217 25.6218 34.8259 25.6218H33.9509V27.9731H34.9134C35.3801 27.9731 35.7301 27.8827 35.9342 27.6717C36.1384 27.4607 36.2551 27.1592 36.2551 26.7975ZM36.7217 32.7361L35.2051 30.3245C35.0301 30.0833 34.9134 29.8723 34.7967 29.7517C34.6801 29.601 34.5926 29.5106 34.5051 29.4201C34.4176 29.3598 34.3592 29.2995 34.2717 29.2694C34.2134 29.2393 34.1259 29.2393 34.0092 29.2393H33.8926V32.7361H32.1426V24.2351H34.8842C35.8467 24.2351 36.6051 24.4461 37.1301 24.8682C37.6551 25.2902 37.9176 25.8931 37.9176 26.707C37.9176 27.0688 37.8592 27.3702 37.7426 27.6114C37.6259 27.8827 37.4801 28.0937 37.3051 28.2746C37.1301 28.4555 36.9259 28.6062 36.6926 28.7268C36.4592 28.8474 36.2259 28.9077 35.9634 28.9679V28.9981C36.0801 29.0885 36.2259 29.2091 36.3717 29.39C36.5176 29.5709 36.7217 29.8422 36.9259 30.2039L38.5301 32.7361H36.7217Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M46.5222 28.4856C46.5222 28.0937 46.4639 27.732 46.3764 27.3702C46.2889 27.0085 46.143 26.707 45.9389 26.4357C45.7347 26.1644 45.5014 25.9534 45.2097 25.8026C44.918 25.6519 44.568 25.5615 44.1597 25.5615C43.7514 25.5615 43.4014 25.6519 43.0805 25.8026C42.7889 25.9534 42.5264 26.1644 42.3222 26.4357C42.118 26.707 41.9722 27.0085 41.8847 27.3702C41.7972 27.732 41.7389 28.0937 41.7389 28.4856C41.7389 28.8775 41.7972 29.2694 41.8847 29.6311C41.9722 29.9929 42.118 30.3245 42.3222 30.5958C42.5264 30.8671 42.7597 31.0781 43.0805 31.259C43.3722 31.4097 43.7514 31.5001 44.1597 31.5001C44.568 31.5001 44.918 31.4097 45.2389 31.259C45.5305 31.1083 45.793 30.8972 45.9972 30.6259C46.2014 30.3546 46.3472 30.0532 46.4347 29.6914C46.4639 29.2694 46.5222 28.9076 46.5222 28.4856ZM48.3597 28.4554C48.3597 29.0282 48.2722 29.601 48.0972 30.1134C47.9222 30.6561 47.6597 31.1083 47.3097 31.5303C46.9597 31.9523 46.5222 32.2538 45.9972 32.5251C45.4722 32.7662 44.8597 32.8868 44.1889 32.8868C43.4889 32.8868 42.8764 32.7662 42.3514 32.5251C41.8264 32.2839 41.3597 31.9523 41.0097 31.5604C40.6597 31.1685 40.368 30.6862 40.193 30.1737C39.9889 29.6311 39.9014 29.0885 39.9014 28.5157C39.9014 27.943 39.9889 27.3702 40.193 26.8577C40.368 26.3151 40.6597 25.8629 41.0097 25.4409C41.3597 25.0189 41.7972 24.7174 42.3514 24.4762C42.8764 24.2351 43.4889 24.1145 44.1889 24.1145C44.8889 24.1145 45.5014 24.2351 46.0264 24.4762C46.5514 24.7174 46.9889 25.049 47.368 25.4409C47.718 25.8328 48.0097 26.3151 48.1847 26.8276C48.2722 27.3401 48.3597 27.8827 48.3597 28.4554Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M55.5341 30.3551C55.5341 30.747 55.4758 31.0786 55.3299 31.4102C55.1841 31.7116 55.0091 31.9829 54.7466 32.1939C54.4841 32.405 54.1924 32.5858 53.8133 32.7064C53.4341 32.827 53.0258 32.8873 52.5883 32.8873C52.2383 32.8873 51.9466 32.8571 51.6841 32.7969C51.4216 32.7366 51.1591 32.6763 50.9549 32.5858C50.7508 32.4954 50.5758 32.405 50.4008 32.3145C50.2549 32.2241 50.1383 32.1337 50.0508 32.0432L50.7799 30.7771C50.8383 30.8073 50.8966 30.8675 51.0133 30.9278C51.1008 30.9881 51.2466 31.0786 51.3924 31.1389C51.5383 31.1991 51.7133 31.2594 51.9174 31.3197C52.1216 31.38 52.3258 31.4102 52.5591 31.4102C52.9674 31.4102 53.2883 31.3197 53.5216 31.1087C53.7549 30.9278 53.8716 30.6867 53.8716 30.4154C53.8716 30.2345 53.8133 30.0536 53.7258 29.933C53.6091 29.8125 53.4924 29.6919 53.3174 29.5713C53.1424 29.4809 52.9674 29.3603 52.7341 29.2698C52.5008 29.1794 52.2674 29.0588 52.0341 28.9382C51.7716 28.8177 51.5383 28.6669 51.3341 28.5162C51.1299 28.3655 50.9258 28.1846 50.7799 28.0037C50.6341 27.8229 50.4883 27.5817 50.4008 27.3104C50.3133 27.0391 50.2549 26.7376 50.2549 26.406C50.2549 26.0443 50.3133 25.7127 50.4591 25.4112C50.6049 25.1098 50.7799 24.8686 51.0133 24.6576C51.2466 24.4466 51.5383 24.2958 51.8591 24.1753C52.1799 24.0547 52.5299 23.9944 52.9091 23.9944C53.2591 23.9944 53.5508 24.0245 53.8133 24.0848C54.0758 24.1451 54.3091 24.2054 54.5133 24.2657C54.7174 24.326 54.8633 24.4164 55.0091 24.5069C55.1549 24.5973 55.2424 24.6576 55.3299 24.7179L54.6299 25.984C54.5424 25.9237 54.4549 25.8634 54.3674 25.8031C54.2508 25.7428 54.1341 25.6825 53.9883 25.6222C53.8424 25.5619 53.6966 25.5318 53.5216 25.5017C53.3466 25.4715 53.2008 25.4414 53.0258 25.4414C52.6758 25.4414 52.4133 25.5017 52.2091 25.6524C52.0049 25.8031 51.9174 26.0141 51.9174 26.3156C51.9174 26.4965 51.9466 26.617 52.0341 26.7376C52.1216 26.8582 52.2091 26.9486 52.3549 27.0391C52.5008 27.1295 52.6466 27.2199 52.8508 27.3104C53.0258 27.4008 53.2299 27.4913 53.4633 27.5817C53.7258 27.7023 53.9883 27.853 54.2508 28.0037C54.5133 28.1545 54.7174 28.3353 54.9216 28.5162C55.1258 28.7272 55.2716 28.9684 55.3883 29.2397C55.4758 29.6316 55.5341 29.9632 55.5341 30.3551Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84 62.187H0V63.9957H84V62.187Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84 39.1272H0V40.9359H84V39.1272Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84 108.31H0V110.119H84V108.31Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84 85.25H0V87.0587H84V85.25Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M5.54167 55.7964L2.33333 51.0636C2.1 50.732 1.89583 50.4305 1.75 50.1894C1.60417 49.9482 1.54583 49.7975 1.51667 49.7975H1.54583C1.54583 49.7975 1.54583 49.8578 1.54583 49.9181C1.54583 49.9784 1.54583 50.0688 1.575 50.1894C1.575 50.3099 1.575 50.4004 1.60417 50.5511C1.60417 50.6717 1.60417 50.8224 1.60417 50.943V55.7964H0V47.2954H1.75L4.725 51.6966C4.84167 51.8775 4.95833 52.0584 5.075 52.2091C5.19167 52.39 5.27917 52.5407 5.3375 52.6613C5.425 52.7819 5.48333 52.9025 5.5125 52.9929C5.57083 53.0833 5.57083 53.1135 5.57083 53.1135H5.6C5.6 53.1135 5.6 53.0532 5.6 52.9929C5.6 52.9025 5.6 52.812 5.57083 52.6914C5.57083 52.5709 5.57083 52.4201 5.54167 52.2694C5.54167 52.1187 5.54167 51.9679 5.54167 51.7871V47.2954H7.11667V55.7964H5.54167Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M11.8418 47.2954H10.0918V55.7964H11.8418V47.2954Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M18.4063 50.732C18.3479 50.5511 18.2896 50.3702 18.2313 50.2195C18.1729 50.0386 18.1438 49.8879 18.0854 49.7673C18.0563 49.6468 18.0271 49.5262 17.9979 49.4357C17.9688 49.3453 17.9688 49.285 17.9688 49.2549H17.9396C17.9396 49.285 17.9104 49.3453 17.8813 49.4357C17.8521 49.5262 17.8229 49.6468 17.7938 49.7673C17.7646 49.9181 17.7063 50.0688 17.6479 50.2195C17.5896 50.3702 17.5313 50.5511 17.4729 50.732L16.7729 52.7517H19.0771L18.4063 50.732ZM15.7813 55.7964H14.0312L17.1813 47.2954H18.8729L22.1104 55.7964H20.2146L19.6604 54.1987H16.3354L15.7813 55.7964Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M28.174 49.8578C28.174 49.4659 28.0574 49.1644 27.824 48.9836C27.5907 48.8027 27.2407 48.6821 26.7157 48.6821H25.8407V51.0334H26.8032C27.2699 51.0334 27.6199 50.943 27.824 50.732C28.0574 50.521 28.174 50.2195 28.174 49.8578ZM28.6407 55.7964L27.124 53.3848C26.949 53.1436 26.8324 52.9326 26.7157 52.812C26.599 52.6613 26.5115 52.5709 26.424 52.4804C26.3365 52.4201 26.2782 52.3598 26.1907 52.3297C26.1324 52.2995 26.0449 52.2995 25.9282 52.2995H25.8115V55.7964H24.0615V47.2954H26.8032C27.7657 47.2954 28.524 47.5064 29.049 47.9285C29.574 48.3505 29.8365 48.9534 29.8365 49.7673C29.8365 50.1291 29.7782 50.4305 29.6615 50.6717C29.5449 50.943 29.399 51.154 29.224 51.3349C29.049 51.5158 28.8449 51.6665 28.6115 51.7871C28.3782 51.9077 28.1449 51.9679 27.8824 52.0282V52.0584C27.999 52.1488 28.1449 52.2694 28.2907 52.4503C28.4365 52.6311 28.6407 52.9025 28.8449 53.2642L30.449 55.7964H28.6407Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M38.7628 55.043C38.6461 55.1335 38.5294 55.254 38.3544 55.3445C38.1794 55.4349 37.9753 55.5555 37.7711 55.6459C37.5378 55.7364 37.3044 55.7966 37.0419 55.8569C36.7794 55.9172 36.4878 55.9474 36.1961 55.9474C35.4961 55.9474 34.8836 55.8268 34.3586 55.5856C33.8336 55.3445 33.3961 55.0129 33.0461 54.621C32.6961 54.1989 32.4336 53.7468 32.2586 53.2041C32.0836 52.6615 31.9961 52.1189 31.9961 51.5461C31.9961 50.9734 32.0836 50.4006 32.2586 49.8881C32.4336 49.3455 32.6961 48.8933 33.0753 48.5015C33.4253 48.1096 33.8919 47.778 34.4169 47.5368C34.9419 47.2956 35.5544 47.175 36.2544 47.175C36.8086 47.175 37.2753 47.2353 37.6544 47.3559C38.0336 47.4765 38.4128 47.6272 38.7336 47.8684L37.9461 49.1948C37.7128 49.0441 37.4794 48.9235 37.1878 48.833C36.9253 48.7426 36.6044 48.7125 36.2253 48.7125C35.8461 48.7125 35.4961 48.7728 35.2044 48.9235C34.9128 49.0742 34.6503 49.2852 34.4753 49.5264C34.2711 49.7977 34.1253 50.0992 34.0378 50.4308C33.9211 50.7624 33.8919 51.1542 33.8919 51.5461C33.8919 51.9682 33.9503 52.3299 34.0378 52.6917C34.1253 53.0534 34.2711 53.3549 34.4753 53.6262C34.6794 53.8975 34.9128 54.1085 35.2336 54.2592C35.5253 54.41 35.8753 54.5004 36.2836 54.5004C36.7211 54.5004 37.1003 54.4401 37.3919 54.2894C37.6836 54.1688 37.9461 54.0181 38.1503 53.8372L38.7628 55.043Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M46.3147 55.7964V52.1187H42.6105V55.7964H40.8896V47.2954H42.6105V50.6415H46.3147V47.2954H48.0355V55.7964H46.3147Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M56.9617 51.5461C56.9617 51.1542 56.9033 50.7925 56.8158 50.4308C56.7283 50.069 56.5825 49.7676 56.3783 49.4962C56.1742 49.2249 55.9408 49.0139 55.6492 48.8632C55.3575 48.7125 55.0075 48.622 54.5992 48.622C54.1908 48.622 53.8408 48.7125 53.52 48.8632C53.2283 49.0139 52.9658 49.2249 52.7617 49.4962C52.5575 49.7676 52.4117 50.069 52.3242 50.4308C52.2367 50.7925 52.1783 51.1542 52.1783 51.5461C52.1783 51.938 52.2367 52.3299 52.3242 52.6917C52.4117 53.0534 52.5575 53.385 52.7617 53.6563C52.9658 53.9276 53.1992 54.1386 53.52 54.3195C53.8117 54.4702 54.1908 54.5607 54.5992 54.5607C55.0075 54.5607 55.3575 54.4702 55.6783 54.3195C55.97 54.1688 56.2325 53.9578 56.4367 53.6865C56.6408 53.4152 56.7867 53.1137 56.8742 52.752C56.9033 52.3299 56.9617 51.9682 56.9617 51.5461ZM58.7992 51.516C58.7992 52.0888 58.7117 52.6615 58.5367 53.174C58.3617 53.7166 58.0992 54.1688 57.7492 54.5908C57.3992 55.0129 56.9617 55.3143 56.4367 55.5856C55.9117 55.8268 55.2992 55.9474 54.6283 55.9474C53.9283 55.9474 53.3158 55.8268 52.7908 55.5856C52.2658 55.3445 51.7992 55.0129 51.4492 54.621C51.0992 54.2291 50.8075 53.7468 50.6325 53.2343C50.4283 52.6917 50.3408 52.1491 50.3408 51.5763C50.3408 51.0035 50.4283 50.4308 50.6325 49.9183C50.8075 49.3757 51.0992 48.9235 51.4492 48.5015C51.7992 48.0794 52.2367 47.778 52.7908 47.5368C53.3158 47.2956 53.9283 47.175 54.6283 47.175C55.3283 47.175 55.9408 47.2956 56.4658 47.5368C56.9908 47.778 57.4283 48.1096 57.8075 48.5015C58.1867 48.8933 58.4492 49.3757 58.6242 49.8881C58.7117 50.4006 58.7992 50.9432 58.7992 51.516Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M66.0331 53.4161C66.0331 53.808 65.9748 54.1396 65.829 54.4712C65.6831 54.7727 65.5081 55.044 65.2456 55.255C64.9831 55.466 64.6915 55.6469 64.3123 55.7675C63.9331 55.888 63.5248 55.9483 63.0873 55.9483C62.7373 55.9483 62.4456 55.9182 62.1831 55.8579C61.9206 55.7976 61.6581 55.7373 61.454 55.6469C61.2498 55.5564 61.0748 55.466 60.8998 55.3756C60.754 55.2851 60.6373 55.1947 60.5498 55.1043L61.279 53.8382C61.3373 53.8683 61.3956 53.9286 61.5123 53.9889C61.5998 54.0492 61.7456 54.1396 61.8915 54.1999C62.0373 54.2602 62.2123 54.3205 62.4165 54.3808C62.6206 54.4411 62.8248 54.4712 63.0581 54.4712C63.4665 54.4712 63.7873 54.3808 64.0206 54.1698C64.254 53.9889 64.3706 53.7477 64.3706 53.4764C64.3706 53.2955 64.3123 53.1147 64.2248 52.9941C64.1373 52.8735 63.9915 52.7529 63.8165 52.6323C63.6415 52.5419 63.4665 52.4213 63.2331 52.3309C62.9998 52.2404 62.7665 52.1199 62.5331 51.9993C62.2706 51.8787 62.0373 51.728 61.8331 51.5772C61.629 51.4265 61.4248 51.2456 61.279 51.0648C61.1331 50.8839 60.9873 50.6427 60.8998 50.3714C60.8123 50.1001 60.754 49.7987 60.754 49.4671C60.754 49.1053 60.8123 48.7737 60.9581 48.4723C61.104 48.1708 61.279 47.9296 61.5123 47.7186C61.7456 47.5076 62.0373 47.3569 62.3581 47.2363C62.679 47.1157 63.029 47.0554 63.4081 47.0554C63.7581 47.0554 64.0498 47.0856 64.3123 47.1459C64.5748 47.2061 64.8081 47.2664 65.0123 47.3267C65.2165 47.387 65.3623 47.4775 65.5081 47.5679C65.654 47.6583 65.7415 47.7186 65.829 47.7789L65.129 49.045C65.0415 48.9847 64.954 48.9244 64.8665 48.8943C64.7498 48.834 64.6331 48.7737 64.4873 48.7134C64.3415 48.6531 64.1956 48.623 64.0206 48.5928C63.8456 48.5627 63.6998 48.5325 63.5248 48.5325C63.1748 48.5325 62.9123 48.5928 62.7081 48.7436C62.504 48.8943 62.4165 49.1053 62.4165 49.4068C62.4165 49.5876 62.4456 49.7082 62.5331 49.8288C62.6206 49.9494 62.7081 50.0398 62.854 50.1303C62.9998 50.2207 63.1456 50.3111 63.3498 50.4016C63.5248 50.492 63.729 50.5824 63.9623 50.6729C64.2248 50.7935 64.4873 50.9442 64.7498 51.0949C65.0123 51.2456 65.2165 51.4265 65.4206 51.6074C65.6248 51.8184 65.7706 52.0596 65.8873 52.3309C66.004 52.6022 66.0331 53.0242 66.0331 53.4161Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M1.75 71.8341V73.9141H4.375V75.3309H1.75V78.8579H0V70.3569H4.725V71.8341H1.75Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M13.1824 74.6082C13.1824 74.2163 13.124 73.8545 13.0365 73.4928C12.949 73.131 12.8032 72.8296 12.599 72.5583C12.3949 72.287 12.1615 72.0759 11.8699 71.9252C11.5782 71.7745 11.2282 71.684 10.8199 71.684C10.4115 71.684 10.0615 71.7745 9.74069 71.9252C9.44902 72.0759 9.18652 72.287 8.98236 72.5583C8.77819 72.8296 8.63236 73.131 8.54486 73.4928C8.45736 73.8545 8.39902 74.2163 8.39902 74.6082C8.39902 75.0001 8.45736 75.3919 8.54486 75.7537C8.63236 76.1154 8.77819 76.447 8.98236 76.7184C9.18652 76.9897 9.41986 77.2007 9.74069 77.3815C10.0324 77.5323 10.4115 77.6227 10.8199 77.6227C11.2282 77.6227 11.5782 77.5323 11.899 77.3815C12.2199 77.2308 12.4532 77.0198 12.6574 76.7485C12.8615 76.4772 13.0074 76.1757 13.0949 75.814C13.124 75.3919 13.1824 75.0302 13.1824 74.6082ZM15.0199 74.578C15.0199 75.1508 14.9324 75.7235 14.7574 76.236C14.5824 76.7786 14.3199 77.2308 13.9699 77.6529C13.6199 78.0749 13.1824 78.3764 12.6574 78.6477C12.1324 78.8888 11.5199 79.0094 10.849 79.0094C10.149 79.0094 9.53652 78.8888 9.01152 78.6477C8.48652 78.4065 8.01986 78.0749 7.66986 77.683C7.31986 77.2911 7.02819 76.8088 6.85319 76.2963C6.64902 75.7537 6.56152 75.2111 6.56152 74.6383C6.56152 74.0655 6.64902 73.4928 6.85319 72.9803C7.02819 72.4377 7.31986 71.9855 7.66986 71.5635C8.01986 71.1414 8.45736 70.84 9.01152 70.5988C9.53652 70.3576 10.149 70.2371 10.849 70.2371C11.549 70.2371 12.1615 70.3576 12.6865 70.5988C13.2115 70.84 13.649 71.1716 14.0282 71.5635C14.4074 71.9554 14.6699 72.4377 14.8449 72.9502C14.9324 73.4626 15.0199 74.0053 15.0199 74.578Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M24.0923 75.3921C24.0923 76.5677 23.8006 77.442 23.2465 78.075C22.6923 78.7081 21.8465 79.0095 20.709 79.0095C19.5131 79.0095 18.6382 78.7081 18.0548 78.1353C17.4715 77.5324 17.209 76.6883 17.209 75.5729V70.3578H18.959V75.4222C18.959 76.1457 19.1048 76.6883 19.3673 77.0199C19.6298 77.3515 20.0965 77.5324 20.7673 77.5324C21.3798 77.5324 21.8173 77.3515 22.109 76.9898C22.4006 76.628 22.5173 76.1457 22.5173 75.5127V70.3276H24.1215V75.3921H24.0923Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M32.3452 78.8579L29.1369 74.1251C28.9036 73.7935 28.6994 73.4921 28.5536 73.2509C28.4077 73.0097 28.3494 72.859 28.3202 72.859H28.2911C28.2911 72.859 28.2911 72.9193 28.2911 72.9796C28.2911 73.0399 28.2911 73.1303 28.3202 73.2509C28.3202 73.3715 28.3202 73.4619 28.3494 73.6126C28.3494 73.7332 28.3494 73.8839 28.3494 74.0045V78.8579H26.7744V70.3569H28.5244L31.4994 74.7582C31.6161 74.939 31.7327 75.1199 31.8494 75.2706C31.9661 75.4515 32.0536 75.6022 32.1119 75.7228C32.1994 75.8434 32.2577 75.964 32.2869 76.0544C32.3452 76.1449 32.3452 76.175 32.3452 76.175H32.3744C32.3744 76.175 32.3744 76.1147 32.3744 76.0544C32.3744 75.964 32.3744 75.8735 32.3452 75.753C32.3452 75.6324 32.3452 75.4817 32.3161 75.3309C32.3161 75.1802 32.3161 75.0295 32.3161 74.8486V70.3569H33.8911V78.8579H32.3452Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M42.2622 74.5471C42.2622 73.5825 42.0288 72.8892 41.5622 72.4671C41.0955 72.0149 40.3663 71.8039 39.4038 71.8039H38.6455V77.411H39.4622C40.3955 77.411 41.0955 77.1698 41.5622 76.6875C42.0288 76.2051 42.2622 75.4817 42.2622 74.5471ZM44.0997 74.4869C44.0997 75.0898 44.0122 75.6625 43.808 76.2051C43.6038 76.7478 43.3413 77.1999 42.933 77.5918C42.5538 77.9837 42.058 78.2852 41.4455 78.5264C40.833 78.7374 40.133 78.8579 39.3163 78.8579H36.8955V70.3569H39.3747C40.1913 70.3569 40.8913 70.4474 41.4747 70.6584C42.058 70.8694 42.5538 71.1407 42.933 71.5025C43.3122 71.8642 43.6038 72.3164 43.7788 72.7987C44.0122 73.3112 44.0997 73.8839 44.0997 74.4869Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M49.5244 73.7935C49.4661 73.6126 49.4077 73.4318 49.3494 73.281C49.2911 73.1002 49.2619 72.9494 49.2036 72.8289C49.1744 72.7083 49.1452 72.5877 49.1161 72.4973C49.0869 72.4068 49.0869 72.3465 49.0869 72.3164H49.0577C49.0577 72.3465 49.0286 72.4068 48.9994 72.4973C48.9702 72.5877 48.9411 72.7083 48.9119 72.8289C48.8827 72.9796 48.8244 73.1303 48.7661 73.281C48.7077 73.4318 48.6494 73.6126 48.5911 73.7935L47.8911 75.8133H50.1952L49.5244 73.7935ZM46.8994 78.8579H45.1494L48.2994 70.3569H49.9911L53.2286 78.8579H51.3327L50.7786 77.2602H47.4827L46.8994 78.8579Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M57.6344 71.8341V78.8579H55.8844V71.8341H53.6094V70.3569H59.9094V71.8341H57.6344Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M63.8457 70.3569H62.0957V78.8579H63.8457V70.3569Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M72.7694 74.6082C72.7694 74.2163 72.7111 73.8545 72.6236 73.4928C72.5361 73.131 72.3902 72.8296 72.1861 72.5583C71.9819 72.287 71.7486 72.0759 71.4569 71.9252C71.1652 71.7745 70.8152 71.684 70.4069 71.684C69.9986 71.684 69.6486 71.7745 69.3277 71.9252C69.0361 72.0759 68.7736 72.287 68.5694 72.5583C68.3652 72.8296 68.2194 73.131 68.1319 73.4928C68.0444 73.8545 67.9861 74.2163 67.9861 74.6082C67.9861 75.0001 68.0444 75.3919 68.1319 75.7537C68.2194 76.1154 68.3652 76.447 68.5694 76.7184C68.7736 76.9897 69.0069 77.2007 69.3277 77.3815C69.6194 77.5323 69.9986 77.6227 70.4069 77.6227C70.8152 77.6227 71.1652 77.5323 71.4861 77.3815C71.7777 77.2308 72.0402 77.0198 72.2444 76.7485C72.4486 76.4772 72.5944 76.1757 72.6819 75.814C72.7402 75.3919 72.7694 75.0302 72.7694 74.6082ZM74.6361 74.578C74.6361 75.1508 74.5486 75.7235 74.3736 76.236C74.1986 76.7786 73.9361 77.2308 73.5861 77.6529C73.2361 78.0749 72.7986 78.3764 72.2736 78.6477C71.7486 78.8888 71.1361 79.0094 70.4652 79.0094C69.7652 79.0094 69.1527 78.8888 68.6277 78.6477C68.1027 78.4065 67.6361 78.0749 67.2861 77.683C66.9361 77.2911 66.6444 76.8088 66.4694 76.2963C66.2652 75.7537 66.1777 75.2111 66.1777 74.6383C66.1777 74.0655 66.2652 73.4928 66.4694 72.9803C66.6444 72.4377 66.9361 71.9855 67.2861 71.5635C67.6361 71.1414 68.0736 70.84 68.6277 70.5988C69.1527 70.3576 69.7652 70.2371 70.4652 70.2371C71.1652 70.2371 71.7777 70.3576 72.3027 70.5988C72.8277 70.84 73.2652 71.1716 73.6444 71.5635C74.0236 71.9554 74.2861 72.4377 74.4611 72.9502C74.5194 73.4626 74.6361 74.0053 74.6361 74.578Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.3951 78.8579L79.1867 74.1251C78.9534 73.7935 78.7492 73.4921 78.6034 73.2509C78.4576 73.0097 78.3992 72.859 78.3701 72.859H78.3409C78.3409 72.859 78.3409 72.9193 78.3409 72.9796C78.3409 73.0399 78.3409 73.1303 78.3701 73.2509C78.3701 73.3715 78.3701 73.4619 78.3992 73.6126C78.3992 73.7332 78.3992 73.8839 78.3992 74.0045V78.8579H76.8242V70.3569H78.5742L81.5492 74.7582C81.6659 74.939 81.7826 75.1199 81.8992 75.2706C82.0159 75.4515 82.1034 75.6022 82.1617 75.7228C82.2492 75.8434 82.3076 75.964 82.3367 76.0544C82.3951 76.1449 82.3951 76.175 82.3951 76.175H82.4242C82.4242 76.175 82.4242 76.1147 82.4242 76.0544C82.4242 75.964 82.4242 75.8735 82.3951 75.753C82.3951 75.6324 82.3951 75.4817 82.3659 75.3309C82.3659 75.1802 82.3659 75.0295 82.3659 74.8486V70.3569H83.9409V78.8579H82.3951Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0 101.92V93.4189H1.75V100.473H4.8125V101.92H0Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M8.86719 93.4189H7.11719V101.92H8.86719V93.4189Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M16.0128 99.4179C16.0128 99.026 15.8961 98.7245 15.6628 98.5135C15.4294 98.3025 15.0503 98.2121 14.5544 98.2121H13.5628V100.563H14.4669C14.9628 100.563 15.3419 100.473 15.6044 100.292C15.8961 100.111 16.0128 99.8098 16.0128 99.4179ZM15.7211 95.8004C15.7211 95.1071 15.2836 94.7755 14.4086 94.7755H13.5628V96.8857H14.3794C14.8461 96.8857 15.1961 96.7952 15.4003 96.6144C15.6336 96.4636 15.7211 96.1923 15.7211 95.8004ZM17.7919 99.5686C17.7919 99.9907 17.7044 100.383 17.5586 100.684C17.3836 100.985 17.1794 101.227 16.8878 101.407C16.5961 101.588 16.2753 101.739 15.8669 101.799C15.4586 101.89 15.0503 101.92 14.5836 101.92H11.8711V93.4189H14.6128C14.9919 93.4189 15.3419 93.4491 15.6919 93.5094C16.0419 93.5697 16.3336 93.6903 16.5961 93.8711C16.8586 94.0219 17.0628 94.263 17.2086 94.5343C17.3544 94.8056 17.4419 95.1372 17.4419 95.5291C17.4419 96.0717 17.2961 96.5239 17.0336 96.8254C16.7711 97.1268 16.4211 97.368 15.9836 97.4886V97.5187C16.2169 97.5489 16.4503 97.6393 16.6836 97.7297C16.8878 97.8202 17.0919 97.9709 17.2669 98.1518C17.4419 98.3327 17.5586 98.5135 17.6461 98.7547C17.7336 98.9657 17.7919 99.237 17.7919 99.5686Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M24.2668 95.9813C24.2668 95.5894 24.1501 95.288 23.9168 95.1071C23.6835 94.9262 23.3335 94.8056 22.8085 94.8056H21.9335V97.157H22.896C23.3626 97.157 23.7126 97.0665 23.9168 96.8555C24.1793 96.6445 24.2668 96.3431 24.2668 95.9813ZM24.7335 101.92L23.2168 99.5083C23.0418 99.2672 22.9251 99.0561 22.8085 98.9356C22.6918 98.7848 22.6043 98.6944 22.5168 98.604C22.4293 98.5437 22.371 98.4834 22.2835 98.4532C22.2251 98.4231 22.1376 98.4231 22.021 98.4231H21.9043V101.92H20.1543V93.4189H22.896C23.8585 93.4189 24.6168 93.63 25.1418 94.052C25.6668 94.474 25.9293 95.0769 25.9293 95.8909C25.9293 96.2526 25.871 96.5541 25.7543 96.7952C25.6376 97.0665 25.4918 97.2776 25.3168 97.4584C25.1418 97.6393 24.9376 97.79 24.7043 97.9106C24.471 98.0312 24.2376 98.0915 23.9751 98.1518V98.1819C24.0918 98.2724 24.2376 98.393 24.3835 98.5738C24.5293 98.7547 24.7335 99.026 24.9376 99.3877L26.5418 101.92H24.7335Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M32.4639 96.8555C32.4055 96.6747 32.3472 96.4938 32.2889 96.3431C32.2305 96.1622 32.2014 96.0115 32.143 95.8909C32.1139 95.7703 32.0847 95.6497 32.0555 95.5593C32.0264 95.4688 32.0264 95.4085 32.0264 95.3784H31.9972C31.9972 95.4085 31.968 95.4688 31.9389 95.5593C31.9097 95.6497 31.8805 95.7703 31.8514 95.8909C31.8222 96.0416 31.7639 96.1923 31.7055 96.3431C31.6472 96.4938 31.5889 96.6747 31.5305 96.8555L30.8305 98.8753H33.1347L32.4639 96.8555ZM29.8389 101.92H28.0889L31.2389 93.4189H32.9305L36.168 101.92H34.2722L33.718 100.322H30.4222L29.8389 101.92Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M42.2053 95.9813C42.2053 95.5894 42.0886 95.288 41.8553 95.1071C41.6219 94.9262 41.2719 94.8056 40.7761 94.8056H39.9011V97.157H40.8636C41.3303 97.157 41.6803 97.0665 41.8844 96.8555C42.0886 96.6445 42.2053 96.3431 42.2053 95.9813ZM42.6719 101.92L41.1553 99.5083C40.9803 99.2672 40.8636 99.0561 40.7469 98.9356C40.6303 98.7848 40.5428 98.6944 40.4553 98.604C40.3678 98.5437 40.3094 98.4834 40.2219 98.4532C40.1636 98.4231 40.0761 98.4231 39.9594 98.4231H39.8428V101.92H38.0928V93.4189H40.8344C41.7969 93.4189 42.5553 93.63 43.0803 94.052C43.6053 94.474 43.8678 95.0769 43.8678 95.8909C43.8678 96.2526 43.8094 96.5541 43.6928 96.7952C43.5761 97.0665 43.4303 97.2776 43.2553 97.4584C43.0803 97.6393 42.8761 97.79 42.6428 97.9106C42.4094 98.0312 42.1761 98.0915 41.9136 98.1518V98.1819C42.0303 98.2724 42.1761 98.393 42.3219 98.5738C42.4678 98.7547 42.6719 99.026 42.8761 99.3877L44.4803 101.92H42.6719Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M49.7877 98.7246V101.92H48.0377V98.7246L45.3252 93.4189H47.2502L49.0002 97.0364L50.7502 93.4189H52.4419L49.7877 98.7246Z"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M84 17.8442H55.5333V3.22364L28.4667 17.8442H0V16.0656H28L57.2542 0.118652V16.0656H84V17.8442Z"
    })), $0422a6ce4ea03acc$var$VU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 324 265",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M21.5527 153.725C20.5563 153.666 18.0984 153.607 16.2236 153.607C14.3488 153.607 11.8909 153.666 10.8944 153.725C10.8354 153.725 10.7763 153.548 10.8354 153.489C12.9464 152.67 13.8247 151.503 13.8247 146.595V115.528H10.3113C4.56888 115.528 2.17003 116.812 0.236194 122.068C0.177145 122.127 0 122.068 0 122.009C0.236194 118.621 0.236191 114.886 0.118094 112.841C0.118094 112.723 0.177141 112.664 0.295238 112.664C1.46883 112.723 5.68341 112.782 8.43655 112.782H24.018C26.7711 112.782 30.9857 112.723 32.1593 112.664C32.2774 112.664 32.3364 112.723 32.3364 112.841C32.2183 114.886 32.2183 118.621 32.4545 122.009C32.4545 122.068 32.2774 122.127 32.2183 122.068C30.2845 116.812 27.8857 115.528 22.1432 115.528H18.6298V146.595C18.6298 151.503 19.5081 152.67 21.6191 153.489C21.6708 153.548 21.6118 153.725 21.5527 153.725Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M21.5527 153.725C20.5563 153.666 18.0984 153.607 16.2236 153.607C14.3488 153.607 11.8909 153.666 10.8944 153.725C10.8354 153.725 10.7763 153.548 10.8354 153.489C12.9464 152.67 13.8247 151.503 13.8247 146.595V115.528H10.3113C4.56888 115.528 2.17003 116.812 0.236194 122.068C0.177145 122.127 0 122.068 0 122.009C0.236194 118.621 0.236191 114.886 0.118094 112.841C0.118094 112.723 0.177141 112.664 0.295238 112.664C1.46883 112.723 5.68341 112.782 8.43655 112.782H24.018C26.7711 112.782 30.9857 112.723 32.1593 112.664C32.2774 112.664 32.3364 112.723 32.3364 112.841C32.2183 114.886 32.2183 118.621 32.4545 122.009C32.4545 122.068 32.2774 122.127 32.2183 122.068C30.2845 116.812 27.8857 115.528 22.1432 115.528H18.6298V146.595C18.6298 151.503 19.5081 152.67 21.6191 153.489C21.6708 153.548 21.6118 153.725 21.5527 153.725Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M51.2464 115.536H43.9835V132.298H51.2464C57.7491 132.298 60.613 129.73 60.613 123.891C60.6204 118.046 57.7491 115.536 51.2464 115.536ZM56.5165 134.395L62.9011 146.249C64.835 149.865 66.6507 151.445 68.8134 151.445C69.3374 151.445 69.9869 151.268 69.9869 151.268C70.046 151.268 70.1641 151.445 70.1641 151.504C69.5219 152.847 67.8243 154.073 65.5952 154.073C62.4287 154.073 60.613 152.434 58.2732 148.057L51.3645 135.037H43.9835V146.596C43.9835 151.504 44.8618 152.67 46.9728 153.49C47.0318 153.549 46.9728 153.726 46.9137 153.726C45.9173 153.667 43.4594 153.608 41.5846 153.608C39.7098 153.608 37.4291 153.667 36.4326 153.726C36.3736 153.726 36.3145 153.549 36.3736 153.49C38.3074 152.67 39.1858 151.622 39.1858 146.891V119.559C39.1858 114.827 38.3074 113.779 36.3736 112.96C36.3145 112.901 36.3736 112.724 36.4326 112.724C36.4326 112.724 38.1893 112.783 42.5811 112.783H51.3055C60.6204 112.783 65.6543 116.348 65.6543 123.707C65.6543 129.722 62.4361 133.288 56.5165 134.395Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M51.2464 115.536H43.9835V132.298H51.2464C57.7491 132.298 60.613 129.73 60.613 123.891C60.6204 118.046 57.7491 115.536 51.2464 115.536ZM56.5165 134.395L62.9011 146.249C64.835 149.865 66.6507 151.445 68.8134 151.445C69.3374 151.445 69.9869 151.268 69.9869 151.268C70.046 151.268 70.1641 151.445 70.1641 151.504C69.5219 152.847 67.8243 154.073 65.5952 154.073C62.4287 154.073 60.613 152.434 58.2732 148.057L51.3645 135.037H43.9835V146.596C43.9835 151.504 44.8618 152.67 46.9728 153.49C47.0318 153.549 46.9728 153.726 46.9137 153.726C45.9173 153.667 43.4594 153.608 41.5846 153.608C39.7098 153.608 37.4291 153.667 36.4326 153.726C36.3736 153.726 36.3145 153.549 36.3736 153.49C38.3074 152.67 39.1858 151.622 39.1858 146.891V119.559C39.1858 114.827 38.3074 113.779 36.3736 112.96C36.3145 112.901 36.3736 112.724 36.4326 112.724C36.4326 112.724 38.1893 112.783 42.5811 112.783H51.3055C60.6204 112.783 65.6543 116.348 65.6543 123.707C65.6543 129.722 62.4361 133.288 56.5165 134.395Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M104.139 153.784C102.965 153.725 98.7507 153.666 95.9975 153.666H80.5933C76.2015 153.666 74.4448 153.725 74.4448 153.725C74.3858 153.725 74.3267 153.548 74.3858 153.489C76.3196 152.67 77.198 151.622 77.198 146.89V119.558C77.198 114.827 76.3196 113.779 74.3858 112.96C74.3267 112.9 74.3858 112.723 74.4448 112.723C74.4448 112.723 76.2015 112.782 80.5933 112.782H94.4697C97.2228 112.782 101.437 112.723 102.611 112.664C102.729 112.664 102.788 112.723 102.788 112.841C102.67 114.709 102.67 118.038 102.906 121.189C102.906 121.248 102.729 121.308 102.67 121.248C100.795 116.635 97.8649 115.528 92.5949 115.528H81.9957V131.235H89.4948C95.0011 131.235 96.8168 130.298 98.1011 127.382C98.1602 127.323 98.3373 127.382 98.3373 127.441C98.2192 128.489 98.1602 130.711 98.1602 132.578C98.1602 134.446 98.2192 136.668 98.3373 137.716C98.3373 137.775 98.1602 137.834 98.1011 137.775C96.8095 134.852 94.9937 133.922 89.4948 133.922H81.9957V150.913H93.5323C99.8578 150.913 102.257 149.857 104.191 144.602C104.25 144.543 104.427 144.602 104.427 144.661C104.191 148.049 104.191 151.555 104.309 153.6C104.309 153.725 104.25 153.784 104.139 153.784Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M104.139 153.784C102.965 153.725 98.7507 153.666 95.9975 153.666H80.5933C76.2015 153.666 74.4448 153.725 74.4448 153.725C74.3858 153.725 74.3267 153.548 74.3858 153.489C76.3196 152.67 77.198 151.622 77.198 146.89V119.558C77.198 114.827 76.3196 113.779 74.3858 112.96C74.3267 112.9 74.3858 112.723 74.4448 112.723C74.4448 112.723 76.2015 112.782 80.5933 112.782H94.4697C97.2228 112.782 101.437 112.723 102.611 112.664C102.729 112.664 102.788 112.723 102.788 112.841C102.67 114.709 102.67 118.038 102.906 121.189C102.906 121.248 102.729 121.308 102.67 121.248C100.795 116.635 97.8649 115.528 92.5949 115.528H81.9957V131.235H89.4948C95.0011 131.235 96.8168 130.298 98.1011 127.382C98.1602 127.323 98.3373 127.382 98.3373 127.441C98.2192 128.489 98.1602 130.711 98.1602 132.578C98.1602 134.446 98.2192 136.668 98.3373 137.716C98.3373 137.775 98.1602 137.834 98.1011 137.775C96.8095 134.852 94.9937 133.922 89.4948 133.922H81.9957V150.913H93.5323C99.8578 150.913 102.257 149.857 104.191 144.602C104.25 144.543 104.427 144.602 104.427 144.661C104.191 148.049 104.191 151.555 104.309 153.6C104.309 153.725 104.25 153.784 104.139 153.784Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M133.126 138.661L125.863 120.969L118.6 138.661H133.126ZM135.296 153.726C135.237 153.667 135.237 153.438 135.237 153.438C137.754 152.501 138.337 151.216 136.056 145.732L134.3 141.466H117.493L115.972 145.142C113.751 150.515 113.802 152.146 117.146 153.438C117.146 153.438 117.146 153.674 117.087 153.726C116.031 153.667 113.92 153.608 111.935 153.608C110.178 153.608 108.008 153.667 106.783 153.726C106.724 153.667 106.724 153.438 106.724 153.438C109.359 152.213 110.532 150.515 112.754 145.142L126.638 111.388C126.697 111.329 126.933 111.329 126.992 111.388L141.223 145.725C143.511 151.275 144.33 152.264 146.375 153.431C146.375 153.431 146.375 153.667 146.316 153.718C145.024 153.659 143.208 153.6 140.751 153.6C138.344 153.608 136.411 153.667 135.296 153.726Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M133.126 138.661L125.863 120.969L118.6 138.661H133.126ZM135.296 153.726C135.237 153.667 135.237 153.438 135.237 153.438C137.754 152.501 138.337 151.216 136.056 145.732L134.3 141.466H117.493L115.972 145.142C113.751 150.515 113.802 152.146 117.146 153.438C117.146 153.438 117.146 153.674 117.087 153.726C116.031 153.667 113.92 153.608 111.935 153.608C110.178 153.608 108.008 153.667 106.783 153.726C106.724 153.667 106.724 153.438 106.724 153.438C109.359 152.213 110.532 150.515 112.754 145.142L126.638 111.388C126.697 111.329 126.933 111.329 126.992 111.388L141.223 145.725C143.511 151.275 144.33 152.264 146.375 153.431C146.375 153.431 146.375 153.667 146.316 153.718C145.024 153.659 143.208 153.6 140.751 153.6C138.344 153.608 136.411 153.667 135.296 153.726Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M170.141 113.491C170.783 113.491 171.426 113.255 171.78 113.026C171.839 113.026 172.016 113.085 172.016 113.144C172.016 116.126 172.252 119.042 172.717 122.024C172.717 122.083 172.54 122.142 172.481 122.083C169.787 117.064 165.801 114.665 161.528 114.665C157.372 114.665 154.501 117.233 154.501 121.086C154.501 125.699 157.719 126.984 164.104 129.966C169.256 132.357 175.234 135.339 175.234 142.462C175.234 149.703 170.2 154.552 162.347 154.552C156.198 154.552 152.449 151.747 150.515 151.747C149.991 151.747 149.46 151.924 149.113 152.153C149.054 152.153 148.876 152.094 148.935 152.035C149.467 149.171 149.755 146.079 150.05 142.167C150.05 142.108 150.286 142.108 150.286 142.108C151.984 147.828 155.615 151.799 162.524 151.799C168.089 151.799 170.961 148.529 170.961 143.975C170.961 139.244 168.266 137.664 161.587 134.571C156.376 132.18 150.227 129.604 150.227 122.658C150.227 116.119 155.32 111.912 161.646 111.912C165.462 111.912 167.979 113.491 170.141 113.491Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M170.141 113.491C170.783 113.491 171.426 113.255 171.78 113.026C171.839 113.026 172.016 113.085 172.016 113.144C172.016 116.126 172.252 119.042 172.717 122.024C172.717 122.083 172.54 122.142 172.481 122.083C169.787 117.064 165.801 114.665 161.528 114.665C157.372 114.665 154.501 117.233 154.501 121.086C154.501 125.699 157.719 126.984 164.104 129.966C169.256 132.357 175.234 135.339 175.234 142.462C175.234 149.703 170.2 154.552 162.347 154.552C156.198 154.552 152.449 151.747 150.515 151.747C149.991 151.747 149.46 151.924 149.113 152.153C149.054 152.153 148.876 152.094 148.935 152.035C149.467 149.171 149.755 146.079 150.05 142.167C150.05 142.108 150.286 142.108 150.286 142.108C151.984 147.828 155.615 151.799 162.524 151.799C168.089 151.799 170.961 148.529 170.961 143.975C170.961 139.244 168.266 137.664 161.587 134.571C156.376 132.18 150.227 129.604 150.227 122.658C150.227 116.119 155.32 111.912 161.646 111.912C165.462 111.912 167.979 113.491 170.141 113.491Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M183.444 138.366V119.559C183.444 114.827 182.566 113.779 180.632 112.96C180.573 112.901 180.632 112.724 180.691 112.724C181.687 112.783 183.968 112.842 185.843 112.842C187.718 112.842 189.998 112.783 190.995 112.724C191.054 112.724 191.113 112.901 191.054 112.96C189.12 113.779 188.242 114.827 188.242 119.559V138.476C188.242 147.644 192.279 151.15 199.66 151.15C206.746 151.15 210.791 147.12 210.791 138.07V120.843C210.791 115.824 210.031 113.957 207.396 112.96C207.337 112.901 207.396 112.724 207.455 112.724C208.51 112.783 210.326 112.842 212.319 112.842C214.371 112.842 216.186 112.783 217.183 112.724C217.242 112.724 217.301 112.901 217.242 112.96C214.607 113.957 213.847 115.824 213.847 120.843V138.248C213.847 149.578 207.816 154.538 198.797 154.538C189.474 154.545 183.444 149.578 183.444 138.366Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M183.444 138.366V119.559C183.444 114.827 182.566 113.779 180.632 112.96C180.573 112.901 180.632 112.724 180.691 112.724C181.687 112.783 183.968 112.842 185.843 112.842C187.718 112.842 189.998 112.783 190.995 112.724C191.054 112.724 191.113 112.901 191.054 112.96C189.12 113.779 188.242 114.827 188.242 119.559V138.476C188.242 147.644 192.279 151.15 199.66 151.15C206.746 151.15 210.791 147.12 210.791 138.07V120.843C210.791 115.824 210.031 113.957 207.396 112.96C207.337 112.901 207.396 112.724 207.455 112.724C208.51 112.783 210.326 112.842 212.319 112.842C214.371 112.842 216.186 112.783 217.183 112.724C217.242 112.724 217.301 112.901 217.242 112.96C214.607 113.957 213.847 115.824 213.847 120.843V138.248C213.847 149.578 207.816 154.538 198.797 154.538C189.474 154.545 183.444 149.578 183.444 138.366Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M238.379 115.536H231.116V132.298H238.379C244.881 132.298 247.752 129.73 247.752 123.891C247.745 118.046 244.874 115.536 238.379 115.536ZM243.649 134.395L250.033 146.249C251.967 149.865 253.783 151.445 255.945 151.445C256.47 151.445 257.119 151.268 257.119 151.268C257.178 151.268 257.296 151.445 257.296 151.504C256.654 152.847 254.956 154.073 252.727 154.073C249.561 154.073 247.752 152.434 245.405 148.057L238.497 135.037H231.116V146.596C231.116 151.504 231.994 152.67 234.105 153.49C234.164 153.549 234.105 153.726 234.046 153.726C233.049 153.667 230.591 153.608 228.717 153.608C226.842 153.608 224.561 153.667 223.565 153.726C223.506 153.726 223.447 153.549 223.506 153.49C225.439 152.67 226.318 151.622 226.318 146.891V119.559C226.318 114.827 225.439 113.779 223.506 112.96C223.447 112.901 223.506 112.724 223.565 112.724C223.565 112.724 225.321 112.783 229.713 112.783H238.438C247.752 112.783 252.786 116.348 252.786 123.707C252.786 129.722 249.561 133.288 243.649 134.395Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M238.379 115.536H231.116V132.298H238.379C244.881 132.298 247.752 129.73 247.752 123.891C247.745 118.046 244.874 115.536 238.379 115.536ZM243.649 134.395L250.033 146.249C251.967 149.865 253.783 151.445 255.945 151.445C256.47 151.445 257.119 151.268 257.119 151.268C257.178 151.268 257.296 151.445 257.296 151.504C256.654 152.847 254.956 154.073 252.727 154.073C249.561 154.073 247.752 152.434 245.405 148.057L238.497 135.037H231.116V146.596C231.116 151.504 231.994 152.67 234.105 153.49C234.164 153.549 234.105 153.726 234.046 153.726C233.049 153.667 230.591 153.608 228.717 153.608C226.842 153.608 224.561 153.667 223.565 153.726C223.506 153.726 223.447 153.549 223.506 153.49C225.439 152.67 226.318 151.622 226.318 146.891V119.559C226.318 114.827 225.439 113.779 223.506 112.96C223.447 112.901 223.506 112.724 223.565 112.724C223.565 112.724 225.321 112.783 229.713 112.783H238.438C247.752 112.783 252.786 116.348 252.786 123.707C252.786 129.722 249.561 133.288 243.649 134.395Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M291.728 153.784C290.554 153.725 286.34 153.666 283.586 153.666H268.182C263.79 153.666 262.034 153.725 262.034 153.725C261.975 153.725 261.916 153.548 261.975 153.489C263.908 152.67 264.787 151.622 264.787 146.89V119.558C264.787 114.827 263.908 113.779 261.975 112.96C261.916 112.9 261.975 112.723 262.034 112.723C262.034 112.723 263.79 112.782 268.182 112.782H282.066C284.819 112.782 289.034 112.723 290.207 112.664C290.325 112.664 290.384 112.723 290.384 112.841C290.266 114.709 290.266 118.038 290.502 121.189C290.502 121.248 290.325 121.308 290.266 121.248C288.391 116.635 285.461 115.528 280.191 115.528H269.592V131.235H277.091C282.597 131.235 284.413 130.298 285.697 127.382C285.756 127.323 285.934 127.382 285.934 127.441C285.815 128.489 285.756 130.711 285.756 132.578C285.756 134.446 285.815 136.668 285.934 137.716C285.934 137.775 285.756 137.834 285.697 137.775C284.406 134.852 282.59 133.922 277.091 133.922H269.592V150.913H281.129C287.454 150.913 289.853 149.857 291.787 144.602C291.846 144.543 292.023 144.602 292.023 144.661C291.787 148.049 291.787 151.555 291.905 153.6C291.905 153.725 291.846 153.784 291.728 153.784Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M291.728 153.784C290.554 153.725 286.34 153.666 283.586 153.666H268.182C263.79 153.666 262.034 153.725 262.034 153.725C261.975 153.725 261.916 153.548 261.975 153.489C263.908 152.67 264.787 151.622 264.787 146.89V119.558C264.787 114.827 263.908 113.779 261.975 112.96C261.916 112.9 261.975 112.723 262.034 112.723C262.034 112.723 263.79 112.782 268.182 112.782H282.066C284.819 112.782 289.034 112.723 290.207 112.664C290.325 112.664 290.384 112.723 290.384 112.841C290.266 114.709 290.266 118.038 290.502 121.189C290.502 121.248 290.325 121.308 290.266 121.248C288.391 116.635 285.461 115.528 280.191 115.528H269.592V131.235H277.091C282.597 131.235 284.413 130.298 285.697 127.382C285.756 127.323 285.934 127.382 285.934 127.441C285.815 128.489 285.756 130.711 285.756 132.578C285.756 134.446 285.815 136.668 285.934 137.716C285.934 137.775 285.756 137.834 285.697 137.775C284.406 134.852 282.59 133.922 277.091 133.922H269.592V150.913H281.129C287.454 150.913 289.853 149.857 291.787 144.602C291.846 144.543 292.023 144.602 292.023 144.661C291.787 148.049 291.787 151.555 291.905 153.6C291.905 153.725 291.846 153.784 291.728 153.784Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M318.907 113.491C319.549 113.491 320.191 113.255 320.546 113.026C320.605 113.026 320.782 113.085 320.782 113.144C320.782 116.126 321.018 119.042 321.483 122.024C321.483 122.083 321.306 122.142 321.247 122.083C318.553 117.064 314.567 114.665 310.293 114.665C306.138 114.665 303.267 117.233 303.267 121.086C303.267 125.699 306.485 126.984 312.869 129.966C318.021 132.357 324 135.339 324 142.462C324 149.703 318.966 154.552 311.113 154.552C304.964 154.552 301.215 151.747 299.281 151.747C298.757 151.747 298.225 151.924 297.878 152.153C297.819 152.153 297.642 152.094 297.701 152.035C298.225 149.171 298.521 146.079 298.816 142.167C298.816 142.108 299.052 142.108 299.052 142.108C300.75 147.828 304.381 151.799 311.29 151.799C316.855 151.799 319.726 148.529 319.726 143.975C319.726 139.244 317.032 137.664 310.352 134.571C305.141 132.18 298.993 129.604 298.993 122.658C298.993 116.119 304.086 111.912 310.412 111.912C314.22 111.912 316.744 113.491 318.907 113.491Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M318.907 113.491C319.549 113.491 320.191 113.255 320.546 113.026C320.605 113.026 320.782 113.085 320.782 113.144C320.782 116.126 321.018 119.042 321.483 122.024C321.483 122.083 321.306 122.142 321.247 122.083C318.553 117.064 314.567 114.665 310.293 114.665C306.138 114.665 303.267 117.233 303.267 121.086C303.267 125.699 306.485 126.984 312.869 129.966C318.021 132.357 324 135.339 324 142.462C324 149.703 318.966 154.552 311.113 154.552C304.964 154.552 301.215 151.747 299.281 151.747C298.757 151.747 298.225 151.924 297.878 152.153C297.819 152.153 297.642 152.094 297.701 152.035C298.225 149.171 298.521 146.079 298.816 142.167C298.816 142.108 299.052 142.108 299.052 142.108C300.75 147.828 304.381 151.799 311.29 151.799C316.855 151.799 319.726 148.529 319.726 143.975C319.726 139.244 317.032 137.664 310.352 134.571C305.141 132.18 298.993 129.604 298.993 122.658C298.993 116.119 304.086 111.912 310.412 111.912C314.22 111.912 316.744 113.491 318.907 113.491Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M43.5654 89.5545C43.5875 89.4881 43.7056 89.3848 43.7794 89.3848C44.2001 89.5545 45.4918 89.8793 46.5252 90.0638C46.5916 90.1007 46.5621 90.3517 46.4957 90.3886C45.049 90.5584 44.3847 91.1636 43.9049 92.9572L43.5949 94.1234L52.216 96.4337C53.5889 96.8027 54.1793 96.6994 54.8289 95.8801C54.8732 95.858 55.0872 95.9465 55.0946 96.0056C54.9101 96.5518 54.7108 97.2308 54.5115 97.9763C54.3122 98.7292 54.1498 99.4083 54.0317 99.9766C54.0022 100.028 53.766 99.9987 53.7365 99.9545C53.5815 98.9285 53.1239 98.5447 51.751 98.1756L43.1299 95.8653L42.8199 97.0316C42.3401 98.8252 42.6132 99.6814 43.7794 100.552C43.8163 100.619 43.7204 100.855 43.6466 100.848C42.6575 100.493 41.3806 100.124 40.9303 100.065C40.8639 100.028 40.8122 99.8806 40.827 99.8142C40.982 99.5042 41.2772 98.6849 41.757 96.9061L42.9306 92.5143C43.3956 90.7576 43.5432 89.9088 43.5654 89.5545Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M43.5654 89.5545C43.5875 89.4881 43.7056 89.3848 43.7794 89.3848C44.2001 89.5545 45.4918 89.8793 46.5252 90.0638C46.5916 90.1007 46.5621 90.3517 46.4957 90.3886C45.049 90.5584 44.3847 91.1636 43.9049 92.9572L43.5949 94.1234L52.216 96.4337C53.5889 96.8027 54.1793 96.6994 54.8289 95.8801C54.8732 95.858 55.0872 95.9465 55.0946 96.0056C54.9101 96.5518 54.7108 97.2308 54.5115 97.9763C54.3122 98.7292 54.1498 99.4083 54.0317 99.9766C54.0022 100.028 53.766 99.9987 53.7365 99.9545C53.5815 98.9285 53.1239 98.5447 51.751 98.1756L43.1299 95.8653L42.8199 97.0316C42.3401 98.8252 42.6132 99.6814 43.7794 100.552C43.8163 100.619 43.7204 100.855 43.6466 100.848C42.6575 100.493 41.3806 100.124 40.9303 100.065C40.8639 100.028 40.8122 99.8806 40.827 99.8142C40.982 99.5042 41.2772 98.6849 41.757 96.9061L42.9306 92.5143C43.3956 90.7576 43.5432 89.9088 43.5654 89.5545Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M52.1178 86.1002L55.1809 87.3254C56.4504 87.8347 57.0409 87.8199 57.72 87.1409C57.7643 87.1187 57.9709 87.2442 57.9709 87.2959C57.7274 87.7978 57.469 88.4104 57.1885 89.0969C56.9154 89.7833 56.6866 90.4107 56.5095 90.9421C56.4726 90.9864 56.2438 90.9347 56.2216 90.8831C56.1995 89.9235 55.7861 89.5028 54.5092 88.9935L47.512 86.1961C46.2424 85.6868 45.6519 85.7016 44.9729 86.3806C44.9286 86.4028 44.7219 86.2773 44.7219 86.2256C44.9655 85.7237 45.2238 85.1111 45.5043 84.4246C45.7774 83.7382 46.0062 83.1108 46.1834 82.5794C46.2203 82.5351 46.4491 82.5868 46.4712 82.6384C46.4934 83.598 46.9067 84.0187 48.1836 84.528L51.1287 85.7089L53.6087 79.5015L50.6637 78.3205C49.3941 77.8112 48.8037 77.826 48.1246 78.505C48.0803 78.5272 47.8736 78.4017 47.8736 78.35C48.1172 77.8481 48.3756 77.2281 48.656 76.5491C48.9291 75.8626 49.1579 75.2352 49.3351 74.7038C49.372 74.6595 49.6008 74.7112 49.623 74.7628C49.6451 75.7224 50.0584 76.1431 51.3354 76.6524L58.3326 79.4498C59.6022 79.9591 60.1926 79.9443 60.8717 79.2579C60.916 79.2358 61.1227 79.3612 61.1227 79.4129C60.8791 79.9148 60.6207 80.5274 60.3403 81.2139C60.0672 81.9003 59.8383 82.5277 59.6612 83.0591C59.6243 83.1034 59.3955 83.0518 59.3733 83.0001C59.3512 82.0406 58.9379 81.6198 57.6609 81.1106L54.5978 79.8853L52.1178 86.1002Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M52.1178 86.1002L55.1809 87.3254C56.4504 87.8347 57.0409 87.8199 57.72 87.1409C57.7643 87.1187 57.9709 87.2442 57.9709 87.2959C57.7274 87.7978 57.469 88.4104 57.1885 89.0969C56.9154 89.7833 56.6866 90.4107 56.5095 90.9421C56.4726 90.9864 56.2438 90.9347 56.2216 90.8831C56.1995 89.9235 55.7861 89.5028 54.5092 88.9935L47.512 86.1961C46.2424 85.6868 45.6519 85.7016 44.9729 86.3806C44.9286 86.4028 44.7219 86.2773 44.7219 86.2256C44.9655 85.7237 45.2238 85.1111 45.5043 84.4246C45.7774 83.7382 46.0062 83.1108 46.1834 82.5794C46.2203 82.5351 46.4491 82.5868 46.4712 82.6384C46.4934 83.598 46.9067 84.0187 48.1836 84.528L51.1287 85.7089L53.6087 79.5015L50.6637 78.3205C49.3941 77.8112 48.8037 77.826 48.1246 78.505C48.0803 78.5272 47.8736 78.4017 47.8736 78.35C48.1172 77.8481 48.3756 77.2281 48.656 76.5491C48.9291 75.8626 49.1579 75.2352 49.3351 74.7038C49.372 74.6595 49.6008 74.7112 49.623 74.7628C49.6451 75.7224 50.0584 76.1431 51.3354 76.6524L58.3326 79.4498C59.6022 79.9591 60.1926 79.9443 60.8717 79.2579C60.916 79.2358 61.1227 79.3612 61.1227 79.4129C60.8791 79.9148 60.6207 80.5274 60.3403 81.2139C60.0672 81.9003 59.8383 82.5277 59.6612 83.0591C59.6243 83.1034 59.3955 83.0518 59.3733 83.0001C59.3512 82.0406 58.9379 81.6198 57.6609 81.1106L54.5978 79.8853L52.1178 86.1002Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M62.3914 76.9182C62.3471 76.9551 62.1257 76.8739 62.1109 76.8296C62.1774 75.8774 61.7935 75.3829 60.4502 74.6448L54.3903 71.3307C52.9067 70.5188 52.2351 70.4598 51.4822 71.0133C51.4305 71.0281 51.246 70.8805 51.2534 70.8288C51.5117 70.3933 51.9029 69.7216 52.2351 69.109L54.2058 65.4997C55.0842 63.8906 55.4385 63.0934 55.5418 62.7613C55.5787 62.6949 55.7189 62.6284 55.7854 62.6506C56.1544 62.9163 57.0992 63.4108 58.0587 63.8316C58.1104 63.8832 58.0218 64.1194 57.948 64.1416C56.6932 63.994 55.9846 64.4663 55.1432 66.0016L53.5858 68.8507L57.6823 71.0945L58.7378 69.1607C59.2987 68.1347 59.4095 67.3745 58.8485 66.5921C58.819 66.533 58.9814 66.3116 59.033 66.3264C59.343 66.5183 59.9999 66.8947 60.4354 67.1383C60.8783 67.3819 61.55 67.7288 61.8747 67.8838C61.9116 67.928 61.8157 68.179 61.7493 68.1864C60.7897 68.1347 60.2066 68.6366 59.6457 69.67L58.5902 71.5964L62.7826 73.892L64.436 70.8731C65.3365 69.2271 65.3069 68.4152 64.3105 67.2342C64.2883 67.1604 64.4433 66.9538 64.5098 66.9759C65.4693 67.5811 66.4584 68.1052 66.9308 68.2971C66.9972 68.334 67.0267 68.4964 66.9972 68.5554C66.8201 68.8064 66.4805 69.3452 65.3881 71.3529L63.2993 75.1836C62.9745 75.7815 62.6202 76.4679 62.3914 76.9182Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M62.3914 76.9182C62.3471 76.9551 62.1257 76.8739 62.1109 76.8296C62.1774 75.8774 61.7935 75.3829 60.4502 74.6448L54.3903 71.3307C52.9067 70.5188 52.2351 70.4598 51.4822 71.0133C51.4305 71.0281 51.246 70.8805 51.2534 70.8288C51.5117 70.3933 51.9029 69.7216 52.2351 69.109L54.2058 65.4997C55.0842 63.8906 55.4385 63.0934 55.5418 62.7613C55.5787 62.6949 55.7189 62.6284 55.7854 62.6506C56.1544 62.9163 57.0992 63.4108 58.0587 63.8316C58.1104 63.8832 58.0218 64.1194 57.948 64.1416C56.6932 63.994 55.9846 64.4663 55.1432 66.0016L53.5858 68.8507L57.6823 71.0945L58.7378 69.1607C59.2987 68.1347 59.4095 67.3745 58.8485 66.5921C58.819 66.533 58.9814 66.3116 59.033 66.3264C59.343 66.5183 59.9999 66.8947 60.4354 67.1383C60.8783 67.3819 61.55 67.7288 61.8747 67.8838C61.9116 67.928 61.8157 68.179 61.7493 68.1864C60.7897 68.1347 60.2066 68.6366 59.6457 69.67L58.5902 71.5964L62.7826 73.892L64.436 70.8731C65.3365 69.2271 65.3069 68.4152 64.3105 67.2342C64.2883 67.1604 64.4433 66.9538 64.5098 66.9759C65.4693 67.5811 66.4584 68.1052 66.9308 68.2971C66.9972 68.334 67.0267 68.4964 66.9972 68.5554C66.8201 68.8064 66.4805 69.3452 65.3881 71.3529L63.2993 75.1836C62.9745 75.7815 62.6202 76.4679 62.3914 76.9182Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M77.8315 53.5276L64.8261 53.8819L70.2216 58.1038C71.5724 59.1593 72.2145 59.3586 73.1962 58.8936C73.2479 58.8862 73.4103 59.056 73.3881 59.115C73.115 59.4324 72.6722 59.9712 72.3031 60.4436C71.934 60.916 71.5207 61.477 71.2771 61.8165C71.2255 61.846 71.0188 61.7353 71.0188 61.6836C71.2329 60.6134 70.8859 60.0451 69.5352 58.9896L64.1249 54.7602C63.0472 53.9188 62.3977 53.749 61.5563 54.1476C61.5046 54.155 61.3422 53.9778 61.3644 53.9261C61.6448 53.594 62.0729 53.0847 62.4494 52.5976C62.8849 52.044 63.1211 51.7045 63.4163 51.269C63.4606 51.2395 63.6156 51.2468 63.6746 51.2911C64.0216 51.8373 64.6046 52.0661 65.6823 52.0366L74.7019 51.8595L69.8747 48.0877C68.524 47.0322 67.8818 46.8256 66.9002 47.298C66.8485 47.3053 66.6861 47.1282 66.7083 47.0765C66.974 46.7591 67.4242 46.2203 67.7933 45.7479C68.1623 45.2829 68.5757 44.7146 68.8192 44.375C68.8635 44.3455 69.0702 44.4563 69.0776 44.5079C68.8635 45.5782 69.2104 46.1465 70.5612 47.202L78.0603 53.0626C78.0899 53.129 77.9201 53.4981 77.8315 53.5276Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M77.8315 53.5276L64.8261 53.8819L70.2216 58.1038C71.5724 59.1593 72.2145 59.3586 73.1962 58.8936C73.2479 58.8862 73.4103 59.056 73.3881 59.115C73.115 59.4324 72.6722 59.9712 72.3031 60.4436C71.934 60.916 71.5207 61.477 71.2771 61.8165C71.2255 61.846 71.0188 61.7353 71.0188 61.6836C71.2329 60.6134 70.8859 60.0451 69.5352 58.9896L64.1249 54.7602C63.0472 53.9188 62.3977 53.749 61.5563 54.1476C61.5046 54.155 61.3422 53.9778 61.3644 53.9261C61.6448 53.594 62.0729 53.0847 62.4494 52.5976C62.8849 52.044 63.1211 51.7045 63.4163 51.269C63.4606 51.2395 63.6156 51.2468 63.6746 51.2911C64.0216 51.8373 64.6046 52.0661 65.6823 52.0366L74.7019 51.8595L69.8747 48.0877C68.524 47.0322 67.8818 46.8256 66.9002 47.298C66.8485 47.3053 66.6861 47.1282 66.7083 47.0765C66.974 46.7591 67.4242 46.2203 67.7933 45.7479C68.1623 45.2829 68.5757 44.7146 68.8192 44.375C68.8635 44.3455 69.0702 44.4563 69.0776 44.5079C68.8635 45.5782 69.2104 46.1465 70.5612 47.202L78.0603 53.0626C78.0899 53.129 77.9201 53.4981 77.8315 53.5276Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M80.6099 50.2652C80.5582 50.2947 80.3663 50.1545 80.3663 50.1028C80.6911 49.2097 80.4623 48.6266 79.3699 47.5416L74.4689 42.6848C73.2658 41.4965 72.6384 41.2529 71.76 41.5777C71.7083 41.5777 71.5681 41.3858 71.5902 41.3341C71.9593 40.9872 72.5203 40.4484 73.0148 39.9538L75.9082 37.0309C77.1999 35.7245 77.7608 35.0602 77.9527 34.765C78.0044 34.7133 78.1594 34.6911 78.2184 34.728C78.4989 35.0823 79.2666 35.8204 80.0711 36.4921C80.108 36.5585 79.9604 36.7578 79.8792 36.7578C78.7204 36.2633 77.9011 36.5216 76.6684 37.769L74.3877 40.0719L77.7018 43.3565L79.2518 41.7917C80.0785 40.9577 80.3885 40.2565 80.0711 39.356C80.0563 39.2895 80.2704 39.1272 80.322 39.1493C80.5656 39.415 81.0897 39.9612 81.4513 40.3155C81.813 40.6698 82.3592 41.1939 82.6323 41.4301C82.6618 41.4817 82.4921 41.6958 82.433 41.6884C81.5252 41.371 80.824 41.6958 80.0047 42.5298L78.4546 44.0946L81.8499 47.453L84.2709 45.0099C85.5921 43.6813 85.7914 42.8841 85.1566 41.4743C85.1566 41.4005 85.3559 41.2455 85.4224 41.2824C86.1752 42.1313 86.9871 42.9063 87.3783 43.2236C87.43 43.2753 87.4153 43.4377 87.3636 43.4894C87.12 43.6813 86.655 44.102 85.0385 45.7332L81.968 48.8333C81.4809 49.3352 80.9494 49.8961 80.6099 50.2652Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M80.6099 50.2652C80.5582 50.2947 80.3663 50.1545 80.3663 50.1028C80.6911 49.2097 80.4623 48.6266 79.3699 47.5416L74.4689 42.6848C73.2658 41.4965 72.6384 41.2529 71.76 41.5777C71.7083 41.5777 71.5681 41.3858 71.5902 41.3341C71.9593 40.9872 72.5203 40.4484 73.0148 39.9538L75.9082 37.0309C77.1999 35.7245 77.7608 35.0602 77.9527 34.765C78.0044 34.7133 78.1594 34.6911 78.2184 34.728C78.4989 35.0823 79.2666 35.8204 80.0711 36.4921C80.108 36.5585 79.9604 36.7578 79.8792 36.7578C78.7204 36.2633 77.9011 36.5216 76.6684 37.769L74.3877 40.0719L77.7018 43.3565L79.2518 41.7917C80.0785 40.9577 80.3885 40.2565 80.0711 39.356C80.0563 39.2895 80.2704 39.1272 80.322 39.1493C80.5656 39.415 81.0897 39.9612 81.4513 40.3155C81.813 40.6698 82.3592 41.1939 82.6323 41.4301C82.6618 41.4817 82.4921 41.6958 82.433 41.6884C81.5252 41.371 80.824 41.6958 80.0047 42.5298L78.4546 44.0946L81.8499 47.453L84.2709 45.0099C85.5921 43.6813 85.7914 42.8841 85.1566 41.4743C85.1566 41.4005 85.3559 41.2455 85.4224 41.2824C86.1752 42.1313 86.9871 42.9063 87.3783 43.2236C87.43 43.2753 87.4153 43.4377 87.3636 43.4894C87.12 43.6813 86.655 44.102 85.0385 45.7332L81.968 48.8333C81.4809 49.3352 80.9494 49.8961 80.6099 50.2652Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M80.5847 32.543C80.533 32.5357 80.4149 32.329 80.4518 32.2847C80.7766 32.0559 81.4704 31.5687 82.024 31.1333C82.6514 30.6461 83.3305 30.0778 83.6478 29.8121C83.6995 29.7973 83.8767 29.9597 83.8693 30.0113C83.3378 30.6756 83.3083 31.3178 84.7329 32.2404L90.837 36.2041L88.7851 29.3101L88.667 29.2437C87.1169 28.2989 86.6962 28.1735 86.0172 28.3506C85.9655 28.3432 85.8474 28.1366 85.8843 28.0923C86.2091 27.8635 86.9029 27.3763 87.4565 26.9408C88.0839 26.4537 88.7629 25.8853 89.0803 25.6196C89.132 25.5975 89.3091 25.7672 89.3017 25.8189C88.7851 26.4684 88.726 27.1106 90.2022 28.0185L96.4023 31.8418L94.0921 25.1472C93.6344 23.7891 92.9701 23.3684 91.7818 23.8998C91.7301 23.8924 91.6194 23.6858 91.6489 23.6415C92.0032 23.3905 92.7561 22.8296 93.2654 22.431C93.7378 22.0693 94.3209 21.5895 94.6087 21.346C94.6604 21.3238 94.8375 21.4936 94.8302 21.5453C94.4611 22.2169 94.4094 22.8296 94.9852 24.4829L98.4543 34.7057C98.4469 34.7574 98.1369 35.0009 98.0704 35.0009L90.1063 30.1294L92.7856 39.0901C92.7782 39.1417 92.4682 39.3853 92.4018 39.3853L83.205 33.4878C81.6845 32.5209 81.249 32.3733 80.5847 32.543Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M80.5847 32.543C80.533 32.5357 80.4149 32.329 80.4518 32.2847C80.7766 32.0559 81.4704 31.5687 82.024 31.1333C82.6514 30.6461 83.3305 30.0778 83.6478 29.8121C83.6995 29.7973 83.8767 29.9597 83.8693 30.0113C83.3378 30.6756 83.3083 31.3178 84.7329 32.2404L90.837 36.2041L88.7851 29.3101L88.667 29.2437C87.1169 28.2989 86.6962 28.1735 86.0172 28.3506C85.9655 28.3432 85.8474 28.1366 85.8843 28.0923C86.2091 27.8635 86.9029 27.3763 87.4565 26.9408C88.0839 26.4537 88.7629 25.8853 89.0803 25.6196C89.132 25.5975 89.3091 25.7672 89.3017 25.8189C88.7851 26.4684 88.726 27.1106 90.2022 28.0185L96.4023 31.8418L94.0921 25.1472C93.6344 23.7891 92.9701 23.3684 91.7818 23.8998C91.7301 23.8924 91.6194 23.6858 91.6489 23.6415C92.0032 23.3905 92.7561 22.8296 93.2654 22.431C93.7378 22.0693 94.3209 21.5895 94.6087 21.346C94.6604 21.3238 94.8375 21.4936 94.8302 21.5453C94.4611 22.2169 94.4094 22.8296 94.9852 24.4829L98.4543 34.7057C98.4469 34.7574 98.1369 35.0009 98.0704 35.0009L90.1063 30.1294L92.7856 39.0901C92.7782 39.1417 92.4682 39.3853 92.4018 39.3853L83.205 33.4878C81.6845 32.5209 81.249 32.3733 80.5847 32.543Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M113.49 25.2803C112.966 25.5165 112.332 25.8339 111.653 26.1956C110.966 26.5572 110.353 26.9042 109.866 27.2068C109.807 27.2142 109.667 27.0296 109.682 26.978C110.331 26.166 110.302 25.5682 109.63 24.3134L108.257 21.7374L103.423 19.1024C101.873 18.2535 101.445 18.0321 100.647 18.069C100.596 18.0543 100.522 17.8328 100.559 17.7885C100.913 17.6188 101.695 17.2423 102.338 16.9028C103.024 16.5411 103.733 16.1204 104.094 15.9064C104.153 15.899 104.294 16.0835 104.279 16.1352C103.806 16.7109 103.806 17.2054 105.106 17.9214L108.84 19.9955L109.217 16.0614C109.342 14.6885 108.966 14.0537 107.829 14.253C107.777 14.2383 107.704 14.0168 107.741 13.9725C108.117 13.7954 108.981 13.3525 109.542 13.0573C110.08 12.7694 110.553 12.4963 110.878 12.3044C110.937 12.297 111.077 12.4816 111.062 12.5332C110.678 12.9613 110.582 13.6256 110.39 15.4857L109.852 20.8738L111.232 23.4646C111.903 24.7194 112.376 25.081 113.417 24.9998C113.454 25.022 113.535 25.2434 113.49 25.2803Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M113.49 25.2803C112.966 25.5165 112.332 25.8339 111.653 26.1956C110.966 26.5572 110.353 26.9042 109.866 27.2068C109.807 27.2142 109.667 27.0296 109.682 26.978C110.331 26.166 110.302 25.5682 109.63 24.3134L108.257 21.7374L103.423 19.1024C101.873 18.2535 101.445 18.0321 100.647 18.069C100.596 18.0543 100.522 17.8328 100.559 17.7885C100.913 17.6188 101.695 17.2423 102.338 16.9028C103.024 16.5411 103.733 16.1204 104.094 15.9064C104.153 15.899 104.294 16.0835 104.279 16.1352C103.806 16.7109 103.806 17.2054 105.106 17.9214L108.84 19.9955L109.217 16.0614C109.342 14.6885 108.966 14.0537 107.829 14.253C107.777 14.2383 107.704 14.0168 107.741 13.9725C108.117 13.7954 108.981 13.3525 109.542 13.0573C110.08 12.7694 110.553 12.4963 110.878 12.3044C110.937 12.297 111.077 12.4816 111.062 12.5332C110.678 12.9613 110.582 13.6256 110.39 15.4857L109.852 20.8738L111.232 23.4646C111.903 24.7194 112.376 25.081 113.417 24.9998C113.454 25.022 113.535 25.2434 113.49 25.2803Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M124.912 13.4407C123.606 10.134 121.524 8.82754 119.037 9.80922C116.571 10.7835 115.929 13.1307 117.228 16.43C118.535 19.7368 120.616 21.0432 123.104 20.0615C125.569 19.0946 126.211 16.7474 124.912 13.4407ZM115.398 17.1903C113.981 13.6031 115.339 10.1192 118.66 8.81277C122.011 7.49156 125.318 9.07111 126.735 12.6805C128.152 16.2676 126.794 19.7515 123.473 21.058C120.122 22.3866 116.822 20.7996 115.398 17.1903Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M124.912 13.4407C123.606 10.134 121.524 8.82754 119.037 9.80922C116.571 10.7835 115.929 13.1307 117.228 16.43C118.535 19.7368 120.616 21.0432 123.104 20.0615C125.569 19.0946 126.211 16.7474 124.912 13.4407ZM115.398 17.1903C113.981 13.6031 115.339 10.1192 118.66 8.81277C122.011 7.49156 125.318 9.07111 126.735 12.6805C128.152 16.2676 126.794 19.7515 123.473 21.058C120.122 22.3866 116.822 20.7996 115.398 17.1903Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M133.974 5.22554L131.442 5.88245L132.719 10.7835L135.251 10.1266C137.133 9.63941 137.731 8.71677 137.288 7.00437C136.838 5.28458 135.841 4.73839 133.974 5.22554ZM130.18 8.18534C129.752 6.54675 129.339 6.02269 128.416 5.85292C128.372 5.83078 128.349 5.59459 128.394 5.55768C128.888 5.44697 129.641 5.26982 130.32 5.09267L133.723 4.20695C136.565 3.46884 138.631 4.32504 139.192 6.47293C139.643 8.2001 138.816 9.6837 137.022 10.5768L139.163 12.9461C140.004 13.8835 140.528 14.2673 141.281 14.0754C141.562 14.0016 141.805 13.8097 141.953 13.6399C142.004 13.6104 142.189 13.6695 142.196 13.7211C142.226 14.4002 141.835 15.3228 140.816 15.5885C139.51 15.9281 138.58 15.0719 137.598 13.9647L135.192 11.219L132.977 11.7947L133.716 14.6216C134.062 15.9428 134.424 16.4078 135.376 16.5555C135.421 16.5776 135.443 16.8138 135.398 16.8507C134.852 16.954 134.195 17.109 133.479 17.2936C132.763 17.4781 132.121 17.6626 131.59 17.8398C131.531 17.8324 131.442 17.6183 131.464 17.5741C132.225 16.9836 132.313 16.4005 131.966 15.0793L130.18 8.18534Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M133.974 5.22554L131.442 5.88245L132.719 10.7835L135.251 10.1266C137.133 9.63941 137.731 8.71677 137.288 7.00437C136.838 5.28458 135.841 4.73839 133.974 5.22554ZM130.18 8.18534C129.752 6.54675 129.339 6.02269 128.416 5.85292C128.372 5.83078 128.349 5.59459 128.394 5.55768C128.888 5.44697 129.641 5.26982 130.32 5.09267L133.723 4.20695C136.565 3.46884 138.631 4.32504 139.192 6.47293C139.643 8.2001 138.816 9.6837 137.022 10.5768L139.163 12.9461C140.004 13.8835 140.528 14.2673 141.281 14.0754C141.562 14.0016 141.805 13.8097 141.953 13.6399C142.004 13.6104 142.189 13.6695 142.196 13.7211C142.226 14.4002 141.835 15.3228 140.816 15.5885C139.51 15.9281 138.58 15.0719 137.598 13.9647L135.192 11.219L132.977 11.7947L133.716 14.6216C134.062 15.9428 134.424 16.4078 135.376 16.5555C135.421 16.5776 135.443 16.8138 135.398 16.8507C134.852 16.954 134.195 17.109 133.479 17.2936C132.763 17.4781 132.121 17.6626 131.59 17.8398C131.531 17.8324 131.442 17.6183 131.464 17.5741C132.225 16.9836 132.313 16.4005 131.966 15.0793L130.18 8.18534Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M148.67 14.083C148.109 14.12 147.444 14.1938 146.714 14.2897C145.983 14.3857 145.319 14.4964 144.772 14.6071C144.713 14.5997 144.647 14.3709 144.684 14.3266C145.511 13.8321 145.666 13.2637 145.488 11.9056L144.477 4.43599C144.293 3.07787 143.99 2.57596 143.06 2.31763C143.023 2.2881 143.023 2.0519 143.075 2.02238C143.636 1.98547 144.293 1.91166 145.031 1.81571C145.761 1.71975 146.418 1.60904 146.972 1.49833C147.031 1.50571 147.097 1.73451 147.061 1.7788C146.234 2.27333 146.079 2.84167 146.263 4.19979L146.802 8.16343L150.515 3.43954C151.43 2.25857 151.497 1.54261 150.485 1.3138C150.441 1.28428 150.448 1.04808 150.5 1.01855C150.928 0.981646 151.969 0.85617 152.633 0.767597C153.275 0.679025 154.08 0.553547 154.486 0.479736C154.538 0.487117 154.611 0.715934 154.574 0.76022C153.829 1.06284 153.312 1.67547 152.058 3.2624L149.828 6.03768L154.176 10.8944C155.305 12.1418 155.63 12.4961 156.368 12.7471C156.412 12.7766 156.405 13.0128 156.353 13.0423C155.955 13.0792 155.099 13.1604 154.383 13.2564C153.593 13.3597 152.759 13.5147 152.353 13.5885C152.294 13.5811 152.227 13.3523 152.264 13.308C152.921 12.9242 153.098 12.4666 152.153 11.3963L148.699 7.47698L147.001 9.59536L147.282 11.6694C147.466 13.0275 147.769 13.5295 148.699 13.7878C148.721 13.8247 148.714 14.0609 148.67 14.083Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M148.67 14.083C148.109 14.12 147.444 14.1938 146.714 14.2897C145.983 14.3857 145.319 14.4964 144.772 14.6071C144.713 14.5997 144.647 14.3709 144.684 14.3266C145.511 13.8321 145.666 13.2637 145.488 11.9056L144.477 4.43599C144.293 3.07787 143.99 2.57596 143.06 2.31763C143.023 2.2881 143.023 2.0519 143.075 2.02238C143.636 1.98547 144.293 1.91166 145.031 1.81571C145.761 1.71975 146.418 1.60904 146.972 1.49833C147.031 1.50571 147.097 1.73451 147.061 1.7788C146.234 2.27333 146.079 2.84167 146.263 4.19979L146.802 8.16343L150.515 3.43954C151.43 2.25857 151.497 1.54261 150.485 1.3138C150.441 1.28428 150.448 1.04808 150.5 1.01855C150.928 0.981646 151.969 0.85617 152.633 0.767597C153.275 0.679025 154.08 0.553547 154.486 0.479736C154.538 0.487117 154.611 0.715934 154.574 0.76022C153.829 1.06284 153.312 1.67547 152.058 3.2624L149.828 6.03768L154.176 10.8944C155.305 12.1418 155.63 12.4961 156.368 12.7471C156.412 12.7766 156.405 13.0128 156.353 13.0423C155.955 13.0792 155.099 13.1604 154.383 13.2564C153.593 13.3597 152.759 13.5147 152.353 13.5885C152.294 13.5811 152.227 13.3523 152.264 13.308C152.921 12.9242 153.098 12.4666 152.153 11.3963L148.699 7.47698L147.001 9.59536L147.282 11.6694C147.466 13.0275 147.769 13.5295 148.699 13.7878C148.721 13.8247 148.714 14.0609 148.67 14.083Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M166.79 1.18096L166.665 6.61343L168.945 6.6651C170.916 6.70939 171.75 5.92699 171.794 4.0522C171.839 2.1405 171.005 1.27692 169.071 1.23264L166.79 1.18096ZM167.742 12.6364C167.779 12.6733 167.735 12.9095 167.683 12.9242C167.1 12.8726 166.391 12.843 165.609 12.8209C164.864 12.8061 164.184 12.8061 163.624 12.8283C163.572 12.8061 163.542 12.5699 163.579 12.533C164.48 12.1714 164.731 11.6325 164.76 10.2449L164.93 3.04837C164.967 1.33597 164.709 0.708582 163.867 0.287861C163.83 0.250956 163.874 0.0147621 163.926 0C164.435 0.0295243 165.218 0.06643 165.926 0.0811922L169.115 0.154996C172.067 0.221426 173.854 1.70503 173.802 4.03744C173.75 6.36986 171.876 7.78702 168.923 7.71321L166.642 7.66154L166.583 10.1932C166.546 11.6399 166.79 12.1935 167.742 12.6364Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M166.79 1.18096L166.665 6.61343L168.945 6.6651C170.916 6.70939 171.75 5.92699 171.794 4.0522C171.839 2.1405 171.005 1.27692 169.071 1.23264L166.79 1.18096ZM167.742 12.6364C167.779 12.6733 167.735 12.9095 167.683 12.9242C167.1 12.8726 166.391 12.843 165.609 12.8209C164.864 12.8061 164.184 12.8061 163.624 12.8283C163.572 12.8061 163.542 12.5699 163.579 12.533C164.48 12.1714 164.731 11.6325 164.76 10.2449L164.93 3.04837C164.967 1.33597 164.709 0.708582 163.867 0.287861C163.83 0.250956 163.874 0.0147621 163.926 0C164.435 0.0295243 165.218 0.06643 165.926 0.0811922L169.115 0.154996C172.067 0.221426 173.854 1.70503 173.802 4.03744C173.75 6.36986 171.876 7.78702 168.923 7.71321L166.642 7.66154L166.583 10.1932C166.546 11.6399 166.79 12.1935 167.742 12.6364Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M185.818 9.49218L186.401 4.90853C186.615 3.21827 186.467 2.56136 185.559 1.95611C185.53 1.9192 185.596 1.69039 185.648 1.67562C186.054 1.74944 186.748 1.85278 187.338 1.92659C187.929 2.0004 188.623 2.0742 189.036 2.10373C189.088 2.12587 189.095 2.36207 189.051 2.39898C188.025 2.76065 187.715 3.35113 187.501 5.04878L186.918 9.63241C186.489 12.9687 184.533 14.5334 181.323 14.1201C177.986 13.692 176.466 11.7065 176.894 8.35549L177.544 3.24042C177.713 1.8823 177.551 1.32133 176.724 0.834184C176.695 0.797278 176.761 0.568473 176.813 0.553711C177.359 0.657046 178.016 0.760372 178.747 0.856326C179.477 0.95228 180.142 1.01872 180.695 1.04824C180.747 1.07038 180.754 1.30657 180.71 1.34348C179.787 1.6092 179.492 2.11111 179.315 3.46923L178.666 8.5843C178.341 11.116 179.359 12.5184 181.714 12.8137C184.157 13.1163 185.493 12.0386 185.818 9.49218Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M185.818 9.49218L186.401 4.90853C186.615 3.21827 186.467 2.56136 185.559 1.95611C185.53 1.9192 185.596 1.69039 185.648 1.67562C186.054 1.74944 186.748 1.85278 187.338 1.92659C187.929 2.0004 188.623 2.0742 189.036 2.10373C189.088 2.12587 189.095 2.36207 189.051 2.39898C188.025 2.76065 187.715 3.35113 187.501 5.04878L186.918 9.63241C186.489 12.9687 184.533 14.5334 181.323 14.1201C177.986 13.692 176.466 11.7065 176.894 8.35549L177.544 3.24042C177.713 1.8823 177.551 1.32133 176.724 0.834184C176.695 0.797278 176.761 0.568473 176.813 0.553711C177.359 0.657046 178.016 0.760372 178.747 0.856326C179.477 0.95228 180.142 1.01872 180.695 1.04824C180.747 1.07038 180.754 1.30657 180.71 1.34348C179.787 1.6092 179.492 2.11111 179.315 3.46923L178.666 8.5843C178.341 11.116 179.359 12.5184 181.714 12.8137C184.157 13.1163 185.493 12.0386 185.818 9.49218Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M196.219 9.79456C198.035 10.2669 198.98 9.7798 199.378 8.22977C199.792 6.64285 199.186 5.74236 197.385 5.27735L195.252 4.72377L194.086 9.24098L196.219 9.79456ZM195.149 15.5296C196.979 16.002 197.968 15.5149 198.374 13.928C198.802 12.2894 198.16 11.3741 196.345 10.9091L193.835 10.2596L192.639 14.8875L195.149 15.5296ZM189.584 15.227C189.532 15.1975 189.561 14.9613 189.606 14.9318C190.543 14.762 190.934 14.2675 191.318 12.7839L193.045 6.09665C193.466 4.45805 193.363 3.79376 192.639 3.19589C192.61 3.15161 192.706 2.93756 192.765 2.93018C193.252 3.0778 193.997 3.28446 194.676 3.4616L197.681 4.23662C200.456 4.95258 201.858 6.59856 201.371 8.48812C201.017 9.84623 199.888 10.636 198.264 10.7172C199.939 11.5808 200.699 12.8946 200.301 14.4299C199.777 16.4744 197.703 17.279 194.891 16.5556L191.525 15.6847C190.831 15.5149 190.078 15.3377 189.584 15.227Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M196.219 9.79456C198.035 10.2669 198.98 9.7798 199.378 8.22977C199.792 6.64285 199.186 5.74236 197.385 5.27735L195.252 4.72377L194.086 9.24098L196.219 9.79456ZM195.149 15.5296C196.979 16.002 197.968 15.5149 198.374 13.928C198.802 12.2894 198.16 11.3741 196.345 10.9091L193.835 10.2596L192.639 14.8875L195.149 15.5296ZM189.584 15.227C189.532 15.1975 189.561 14.9613 189.606 14.9318C190.543 14.762 190.934 14.2675 191.318 12.7839L193.045 6.09665C193.466 4.45805 193.363 3.79376 192.639 3.19589C192.61 3.15161 192.706 2.93756 192.765 2.93018C193.252 3.0778 193.997 3.28446 194.676 3.4616L197.681 4.23662C200.456 4.95258 201.858 6.59856 201.371 8.48812C201.017 9.84623 199.888 10.636 198.264 10.7172C199.939 11.5808 200.699 12.8946 200.301 14.4299C199.777 16.4744 197.703 17.279 194.891 16.5556L191.525 15.6847C190.831 15.5149 190.078 15.3377 189.584 15.227Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M203.754 19.2573C203.097 19.0137 202.366 18.7554 201.887 18.593C201.842 18.5561 201.894 18.3273 201.938 18.3051C202.868 18.2313 203.341 17.7515 203.931 16.1646L206.426 9.49214C206.906 8.20783 206.876 7.62472 206.182 6.96043C206.16 6.91614 206.278 6.70947 206.337 6.70947C206.847 6.93829 207.467 7.18924 208.16 7.44758C208.884 7.72068 209.555 7.94949 210.102 8.11926C210.146 8.15616 210.094 8.38498 210.05 8.40712C209.009 8.45879 208.581 8.87951 208.087 10.2155L204.957 18.5708L207.673 19.5894C209.43 20.2463 210.235 20.1061 211.26 18.9473C211.327 18.9178 211.556 19.0359 211.548 19.1097C211.083 20.1504 210.707 21.1985 210.581 21.693C210.559 21.7595 210.397 21.8185 210.33 21.789C210.057 21.6487 209.482 21.3904 207.334 20.5933L203.754 19.2573Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M203.754 19.2573C203.097 19.0137 202.366 18.7554 201.887 18.593C201.842 18.5561 201.894 18.3273 201.938 18.3051C202.868 18.2313 203.341 17.7515 203.931 16.1646L206.426 9.49214C206.906 8.20783 206.876 7.62472 206.182 6.96043C206.16 6.91614 206.278 6.70947 206.337 6.70947C206.847 6.93829 207.467 7.18924 208.16 7.44758C208.884 7.72068 209.555 7.94949 210.102 8.11926C210.146 8.15616 210.094 8.38498 210.05 8.40712C209.009 8.45879 208.581 8.87951 208.087 10.2155L204.957 18.5708L207.673 19.5894C209.43 20.2463 210.235 20.1061 211.26 18.9473C211.327 18.9178 211.556 19.0359 211.548 19.1097C211.083 20.1504 210.707 21.1985 210.581 21.693C210.559 21.7595 210.397 21.8185 210.33 21.789C210.057 21.6487 209.482 21.3904 207.334 20.5933L203.754 19.2573Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M216.547 24.3722C216.562 24.4165 216.429 24.6157 216.377 24.6084C215.868 24.3279 215.24 24.0179 214.539 23.6857C213.838 23.3536 213.196 23.0731 212.657 22.8591C212.613 22.8222 212.686 22.5933 212.731 22.5786C213.772 22.6081 214.229 22.2317 214.834 20.94L217.964 14.2896C218.569 12.998 218.569 12.4075 217.883 11.6251C217.868 11.5734 217.993 11.3815 218.053 11.3889C218.562 11.6694 219.189 11.9794 219.89 12.3115C220.592 12.6437 221.234 12.9241 221.773 13.1382C221.817 13.1751 221.743 13.4039 221.699 13.426C220.658 13.3965 220.2 13.773 219.595 15.0646L216.466 21.715C215.86 22.9919 215.86 23.5898 216.547 24.3722Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M216.547 24.3722C216.562 24.4165 216.429 24.6157 216.377 24.6084C215.868 24.3279 215.24 24.0179 214.539 23.6857C213.838 23.3536 213.196 23.0731 212.657 22.8591C212.613 22.8222 212.686 22.5933 212.731 22.5786C213.772 22.6081 214.229 22.2317 214.834 20.94L217.964 14.2896C218.569 12.998 218.569 12.4075 217.883 11.6251C217.868 11.5734 217.993 11.3815 218.053 11.3889C218.562 11.6694 219.189 11.9794 219.89 12.3115C220.592 12.6437 221.234 12.9241 221.773 13.1382C221.817 13.1751 221.743 13.4039 221.699 13.426C220.658 13.3965 220.2 13.773 219.595 15.0646L216.466 21.715C215.86 22.9919 215.86 23.5898 216.547 24.3722Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M230.961 17.8474C232.327 18.652 232.748 19.5008 233.419 19.892C233.604 20.0027 233.803 19.9879 233.98 19.9289C234.069 19.9584 234.187 20.1134 234.202 20.1651C233.648 21.1172 233.161 22.0841 232.748 23.1175C232.711 23.1765 232.474 23.1249 232.452 23.0511C232.548 21.1025 231.84 19.6041 230.423 18.77C228.23 17.4857 225.994 18.4527 224.208 21.501C222.421 24.5494 222.687 27.0221 224.909 28.3285C226.385 29.1921 228.127 29.1109 229.832 28.0554C229.906 28.0333 230.076 28.2178 230.031 28.2769C229.278 29.1331 228.607 30.0336 227.994 30.9267C227.942 30.9414 227.78 30.9045 227.706 30.8455C227.655 30.6462 227.551 30.5059 227.315 30.3657C226.68 29.9893 225.728 30.0409 224.348 29.229C221.3 27.4428 220.532 23.8335 222.473 20.5194C224.414 17.2126 227.987 16.1055 230.961 17.8474Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M230.961 17.8474C232.327 18.652 232.748 19.5008 233.419 19.892C233.604 20.0027 233.803 19.9879 233.98 19.9289C234.069 19.9584 234.187 20.1134 234.202 20.1651C233.648 21.1172 233.161 22.0841 232.748 23.1175C232.711 23.1765 232.474 23.1249 232.452 23.0511C232.548 21.1025 231.84 19.6041 230.423 18.77C228.23 17.4857 225.994 18.4527 224.208 21.501C222.421 24.5494 222.687 27.0221 224.909 28.3285C226.385 29.1921 228.127 29.1109 229.832 28.0554C229.906 28.0333 230.076 28.2178 230.031 28.2769C229.278 29.1331 228.607 30.0336 227.994 30.9267C227.942 30.9414 227.78 30.9045 227.706 30.8455C227.655 30.6462 227.551 30.5059 227.315 30.3657C226.68 29.9893 225.728 30.0409 224.348 29.229C221.3 27.4428 220.532 23.8335 222.473 20.5194C224.414 17.2126 227.987 16.1055 230.961 17.8474Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M236.254 37.0233C235.708 36.5804 235.095 36.108 234.689 35.8054C234.66 35.7537 234.778 35.5544 234.829 35.5471C235.737 35.7685 236.335 35.4659 237.398 34.152L241.886 28.6236C242.749 27.5607 242.904 26.9924 242.462 26.1436C242.454 26.0919 242.631 25.9369 242.683 25.9517C243.096 26.3281 243.598 26.7636 244.174 27.2286C244.779 27.7158 245.333 28.1439 245.805 28.4834C245.835 28.535 245.717 28.7343 245.665 28.7417C244.661 28.4612 244.13 28.7196 243.229 29.8267L237.612 36.7576L239.863 38.588C241.317 39.769 242.129 39.8871 243.465 39.1195C243.539 39.1121 243.716 39.2966 243.687 39.3631C242.919 40.1971 242.225 41.0755 241.952 41.5036C241.908 41.5626 241.738 41.5626 241.686 41.5183C241.472 41.2969 241.007 40.8688 239.229 39.4295L236.254 37.0233Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M236.254 37.0233C235.708 36.5804 235.095 36.108 234.689 35.8054C234.66 35.7537 234.778 35.5544 234.829 35.5471C235.737 35.7685 236.335 35.4659 237.398 34.152L241.886 28.6236C242.749 27.5607 242.904 26.9924 242.462 26.1436C242.454 26.0919 242.631 25.9369 242.683 25.9517C243.096 26.3281 243.598 26.7636 244.174 27.2286C244.779 27.7158 245.333 28.1439 245.805 28.4834C245.835 28.535 245.717 28.7343 245.665 28.7417C244.661 28.4612 244.13 28.7196 243.229 29.8267L237.612 36.7576L239.863 38.588C241.317 39.769 242.129 39.8871 243.465 39.1195C243.539 39.1121 243.716 39.2966 243.687 39.3631C242.919 40.1971 242.225 41.0755 241.952 41.5036C241.908 41.5626 241.738 41.5626 241.686 41.5183C241.472 41.2969 241.007 40.8688 239.229 39.4295L236.254 37.0233Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M247.103 46.2719C247.103 46.3235 246.919 46.4712 246.867 46.4416C246.476 46.0135 245.981 45.5116 245.42 44.9802C244.859 44.4414 244.343 43.969 243.9 43.5925C243.87 43.5409 244.011 43.349 244.062 43.349C245.036 43.7107 245.597 43.4966 246.587 42.4706L251.694 37.171C252.683 36.1451 252.875 35.5767 252.477 34.6172C252.477 34.5655 252.668 34.4253 252.713 34.4474C253.104 34.8755 253.599 35.3774 254.159 35.9089C254.72 36.4477 255.237 36.9201 255.68 37.2965C255.71 37.3482 255.569 37.5401 255.518 37.5401C254.543 37.1784 253.982 37.3925 252.993 38.4184L247.886 43.718C246.897 44.7514 246.705 45.3123 247.103 46.2719Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M247.103 46.2719C247.103 46.3235 246.919 46.4712 246.867 46.4416C246.476 46.0135 245.981 45.5116 245.42 44.9802C244.859 44.4414 244.343 43.969 243.9 43.5925C243.87 43.5409 244.011 43.349 244.062 43.349C245.036 43.7107 245.597 43.4966 246.587 42.4706L251.694 37.171C252.683 36.1451 252.875 35.5767 252.477 34.6172C252.477 34.5655 252.668 34.4253 252.713 34.4474C253.104 34.8755 253.599 35.3774 254.159 35.9089C254.72 36.4477 255.237 36.9201 255.68 37.2965C255.71 37.3482 255.569 37.5401 255.518 37.5401C254.543 37.1784 253.982 37.3925 252.993 38.4184L247.886 43.718C246.897 44.7514 246.705 45.3123 247.103 46.2719Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M257.738 47.9991C258.971 49.4162 260.019 49.5491 261.23 48.501C262.47 47.4234 262.477 46.3383 261.267 44.9359L259.827 43.2752L256.306 46.3383L257.738 47.9991ZM253.605 52.1177C254.845 53.5423 255.93 53.6973 257.17 52.627C258.447 51.5125 258.44 50.4053 257.207 48.9881L255.502 47.0322L251.9 50.1617L253.605 52.1177ZM249.191 48.7077C249.169 48.656 249.324 48.4715 249.376 48.4789C250.247 48.8701 250.844 48.6855 252.003 47.6817L257.214 43.1571C258.491 42.0426 258.779 41.4373 258.521 40.5368C258.528 40.4852 258.727 40.3597 258.772 40.3892C259.089 40.7804 259.584 41.3783 260.049 41.9097L262.078 44.2495C263.961 46.4122 264.175 48.5601 262.706 49.837C261.643 50.7596 260.263 50.767 258.882 49.9108C259.776 51.5715 259.657 53.0846 258.454 54.1254C256.86 55.5056 254.697 54.9963 252.793 52.8042L250.512 50.1765C250.062 49.6524 249.538 49.0841 249.191 48.7077Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M257.738 47.9991C258.971 49.4162 260.019 49.5491 261.23 48.501C262.47 47.4234 262.477 46.3383 261.267 44.9359L259.827 43.2752L256.306 46.3383L257.738 47.9991ZM253.605 52.1177C254.845 53.5423 255.93 53.6973 257.17 52.627C258.447 51.5125 258.44 50.4053 257.207 48.9881L255.502 47.0322L251.9 50.1617L253.605 52.1177ZM249.191 48.7077C249.169 48.656 249.324 48.4715 249.376 48.4789C250.247 48.8701 250.844 48.6855 252.003 47.6817L257.214 43.1571C258.491 42.0426 258.779 41.4373 258.521 40.5368C258.528 40.4852 258.727 40.3597 258.772 40.3892C259.089 40.7804 259.584 41.3783 260.049 41.9097L262.078 44.2495C263.961 46.4122 264.175 48.5601 262.706 49.837C261.643 50.7596 260.263 50.767 258.882 49.9108C259.776 51.5715 259.657 53.0846 258.454 54.1254C256.86 55.5056 254.697 54.9963 252.793 52.8042L250.512 50.1765C250.062 49.6524 249.538 49.0841 249.191 48.7077Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M270.23 56.5244L268.746 54.3691L264.568 57.2403L266.052 59.3956C267.152 60.9973 268.222 61.2482 269.683 60.2518C271.152 59.2332 271.322 58.1113 270.23 56.5244ZM266.155 53.9631C267.55 53.0036 267.905 52.4352 267.75 51.5126C267.757 51.4609 267.971 51.3576 268.015 51.3945C268.288 51.8226 268.709 52.4721 269.108 53.0479L271.101 55.9486C272.761 58.3696 272.658 60.6061 270.835 61.8609C269.366 62.8721 267.691 62.599 266.237 61.2113L264.738 64.0309C264.148 65.138 263.963 65.7654 264.399 66.4076C264.561 66.6438 264.827 66.8135 265.033 66.8874C265.078 66.9243 265.085 67.1162 265.033 67.1457C264.399 67.404 263.402 67.345 262.812 66.4888C262.044 65.3743 262.539 64.208 263.24 62.909L265.004 59.713L263.705 57.8234L261.299 59.4768C260.169 60.2518 259.859 60.7537 260.044 61.6985C260.036 61.7501 259.822 61.8535 259.778 61.8166C259.49 61.3368 259.129 60.7758 258.708 60.1632C258.287 59.5506 257.896 59.0118 257.549 58.5763C257.534 58.5246 257.704 58.3622 257.756 58.3696C258.568 58.8863 259.143 58.7682 260.273 57.9932L266.155 53.9631Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M270.23 56.5244L268.746 54.3691L264.568 57.2403L266.052 59.3956C267.152 60.9973 268.222 61.2482 269.683 60.2518C271.152 59.2332 271.322 58.1113 270.23 56.5244ZM266.155 53.9631C267.55 53.0036 267.905 52.4352 267.75 51.5126C267.757 51.4609 267.971 51.3576 268.015 51.3945C268.288 51.8226 268.709 52.4721 269.108 53.0479L271.101 55.9486C272.761 58.3696 272.658 60.6061 270.835 61.8609C269.366 62.8721 267.691 62.599 266.237 61.2113L264.738 64.0309C264.148 65.138 263.963 65.7654 264.399 66.4076C264.561 66.6438 264.827 66.8135 265.033 66.8874C265.078 66.9243 265.085 67.1162 265.033 67.1457C264.399 67.404 263.402 67.345 262.812 66.4888C262.044 65.3743 262.539 64.208 263.24 62.909L265.004 59.713L263.705 57.8234L261.299 59.4768C260.169 60.2518 259.859 60.7537 260.044 61.6985C260.036 61.7501 259.822 61.8535 259.778 61.8166C259.49 61.3368 259.129 60.7758 258.708 60.1632C258.287 59.5506 257.896 59.0118 257.549 58.5763C257.534 58.5246 257.704 58.3622 257.756 58.3696C258.568 58.8863 259.143 58.7682 260.273 57.9932L266.155 53.9631Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M272.487 73.8696L276.029 69.5665L270.501 70.0831L272.487 73.8696ZM266.574 72.1055C266.56 72.1572 266.338 72.231 266.294 72.1941C266.095 71.7734 265.762 71.1091 265.445 70.5039C265.157 69.9577 264.832 69.3819 264.626 69.0203C264.618 68.9612 264.81 68.821 264.855 68.8357C265.489 69.2343 266.124 69.3524 267.814 69.1974L278.805 68.26C278.864 68.2895 279.041 68.6291 279.034 68.6881L272.014 77.3535C270.885 78.7411 270.678 79.2726 270.656 79.8926C270.641 79.9442 270.42 80.0181 270.376 79.9811C270.139 79.4497 269.918 78.9994 269.571 78.3278C269.217 77.6561 268.818 76.9328 268.516 76.4382C268.508 76.3792 268.7 76.2389 268.744 76.2537C269.379 76.8368 269.977 76.9328 271.143 75.5082L271.785 74.748L269.394 70.1865L268.737 70.2455C267.084 70.3931 266.441 70.8286 266.574 72.1055Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M272.487 73.8696L276.029 69.5665L270.501 70.0831L272.487 73.8696ZM266.574 72.1055C266.56 72.1572 266.338 72.231 266.294 72.1941C266.095 71.7734 265.762 71.1091 265.445 70.5039C265.157 69.9577 264.832 69.3819 264.626 69.0203C264.618 68.9612 264.81 68.821 264.855 68.8357C265.489 69.2343 266.124 69.3524 267.814 69.1974L278.805 68.26C278.864 68.2895 279.041 68.6291 279.034 68.6881L272.014 77.3535C270.885 78.7411 270.678 79.2726 270.656 79.8926C270.641 79.9442 270.42 80.0181 270.376 79.9811C270.139 79.4497 269.918 78.9994 269.571 78.3278C269.217 77.6561 268.818 76.9328 268.516 76.4382C268.508 76.3792 268.7 76.2389 268.744 76.2537C269.379 76.8368 269.977 76.9328 271.143 75.5082L271.785 74.748L269.394 70.1865L268.737 70.2455C267.084 70.3931 266.441 70.8286 266.574 72.1055Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M283.825 82.4538L282.88 80.018L278.156 81.8486L279.101 84.2843C279.802 86.1 280.784 86.5872 282.43 85.9524C284.091 85.3029 284.519 84.2548 283.825 82.4538ZM280.444 79.0216C282.024 78.409 282.496 77.9366 282.563 77.0066C282.585 76.9623 282.814 76.9106 282.851 76.9549C283.02 77.4347 283.279 78.158 283.53 78.8149L284.799 82.0921C285.862 84.8305 285.242 86.9858 283.175 87.7829C281.507 88.4251 279.942 87.7756 278.85 86.0927L276.746 88.4915C275.912 89.4289 275.588 90.0046 275.868 90.7206C275.971 90.9937 276.193 91.2151 276.377 91.3332C276.414 91.3775 276.37 91.5694 276.318 91.5842C275.647 91.6875 274.687 91.407 274.303 90.4327C273.816 89.1706 274.562 88.152 275.543 87.0522L277.994 84.3434L277.167 82.2102L274.443 83.2657C273.167 83.7602 272.746 84.1736 272.709 85.1331C272.687 85.1774 272.458 85.2291 272.421 85.1848C272.251 84.6534 272.03 84.0186 271.764 83.3322C271.498 82.6457 271.24 82.0257 271.004 81.5164C271.004 81.4574 271.203 81.3393 271.255 81.3614C271.927 82.0478 272.517 82.07 273.794 81.5755L280.444 79.0216Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M283.825 82.4538L282.88 80.018L278.156 81.8486L279.101 84.2843C279.802 86.1 280.784 86.5872 282.43 85.9524C284.091 85.3029 284.519 84.2548 283.825 82.4538ZM280.444 79.0216C282.024 78.409 282.496 77.9366 282.563 77.0066C282.585 76.9623 282.814 76.9106 282.851 76.9549C283.02 77.4347 283.279 78.158 283.53 78.8149L284.799 82.0921C285.862 84.8305 285.242 86.9858 283.175 87.7829C281.507 88.4251 279.942 87.7756 278.85 86.0927L276.746 88.4915C275.912 89.4289 275.588 90.0046 275.868 90.7206C275.971 90.9937 276.193 91.2151 276.377 91.3332C276.414 91.3775 276.37 91.5694 276.318 91.5842C275.647 91.6875 274.687 91.407 274.303 90.4327C273.816 89.1706 274.562 88.152 275.543 87.0522L277.994 84.3434L277.167 82.2102L274.443 83.2657C273.167 83.7602 272.746 84.1736 272.709 85.1331C272.687 85.1774 272.458 85.2291 272.421 85.1848C272.251 84.6534 272.03 84.0186 271.764 83.3322C271.498 82.6457 271.24 82.0257 271.004 81.5164C271.004 81.4574 271.203 81.3393 271.255 81.3614C271.927 82.0478 272.517 82.07 273.794 81.5755L280.444 79.0216Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M277.367 100.663C277.256 100.095 277.094 99.4083 276.902 98.6628C276.703 97.9099 276.511 97.2383 276.334 96.6847C276.341 96.6256 276.555 96.5371 276.599 96.5592C277.242 97.3785 277.832 97.4892 279.205 97.1275L282.032 96.3894L285.715 92.3003C286.896 90.9865 287.213 90.6248 287.361 89.8424C287.391 89.7981 287.627 89.776 287.656 89.8203C287.737 90.2115 287.922 91.0529 288.107 91.7541C288.298 92.507 288.549 93.2968 288.668 93.6953C288.66 93.7544 288.446 93.843 288.402 93.8208C287.952 93.2303 287.472 93.1122 286.475 94.212L283.589 97.3637L287.332 98.6407C288.638 99.0835 289.347 98.8621 289.42 97.7033C289.45 97.659 289.679 97.6368 289.716 97.6811C289.804 98.0871 290.033 99.0318 290.188 99.6445C290.343 100.235 290.498 100.759 290.609 101.121C290.601 101.18 290.387 101.268 290.343 101.246C290.018 100.774 289.391 100.523 287.627 99.9028L282.504 98.124L279.663 98.8621C278.282 99.2238 277.825 99.6002 277.662 100.634C277.633 100.685 277.397 100.707 277.367 100.663Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M277.367 100.663C277.256 100.095 277.094 99.4083 276.902 98.6628C276.703 97.9099 276.511 97.2383 276.334 96.6847C276.341 96.6256 276.555 96.5371 276.599 96.5592C277.242 97.3785 277.832 97.4892 279.205 97.1275L282.032 96.3894L285.715 92.3003C286.896 90.9865 287.213 90.6248 287.361 89.8424C287.391 89.7981 287.627 89.776 287.656 89.8203C287.737 90.2115 287.922 91.0529 288.107 91.7541C288.298 92.507 288.549 93.2968 288.668 93.6953C288.66 93.7544 288.446 93.843 288.402 93.8208C287.952 93.2303 287.472 93.1122 286.475 94.212L283.589 97.3637L287.332 98.6407C288.638 99.0835 289.347 98.8621 289.42 97.7033C289.45 97.659 289.679 97.6368 289.716 97.6811C289.804 98.0871 290.033 99.0318 290.188 99.6445C290.343 100.235 290.498 100.759 290.609 101.121C290.601 101.18 290.387 101.268 290.343 101.246C290.018 100.774 289.391 100.523 287.627 99.9028L282.504 98.124L279.663 98.8621C278.282 99.2238 277.825 99.6002 277.662 100.634C277.633 100.685 277.397 100.707 277.367 100.663Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M55.7724 173.197C55.7946 173.263 55.7429 173.411 55.6765 173.448C55.2262 173.522 53.9493 173.898 52.9676 174.274C52.8938 174.274 52.7905 174.046 52.8274 173.979C53.9788 173.093 54.2446 172.23 53.7353 170.444L53.4031 169.285L44.819 171.721C43.4461 172.112 42.9958 172.503 42.863 173.529C42.8408 173.573 42.6046 173.603 42.5677 173.558C42.4422 172.99 42.2725 172.311 42.0584 171.566C41.8444 170.82 41.6377 170.148 41.4458 169.602C41.4458 169.543 41.6599 169.447 41.7115 169.469C42.3684 170.274 42.9589 170.37 44.3318 169.979L52.916 167.543L52.5838 166.384C52.0745 164.598 51.4029 164 49.9562 163.852C49.8897 163.815 49.8528 163.564 49.9193 163.528C50.9526 163.328 52.2369 162.981 52.6576 162.804C52.7315 162.804 52.8495 162.9 52.8717 162.967C52.8938 163.313 53.0636 164.17 53.5655 165.934L54.8055 170.303C55.3074 172.075 55.6101 172.887 55.7724 173.197Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M55.7724 173.197C55.7946 173.263 55.7429 173.411 55.6765 173.448C55.2262 173.522 53.9493 173.898 52.9676 174.274C52.8938 174.274 52.7905 174.046 52.8274 173.979C53.9788 173.093 54.2446 172.23 53.7353 170.444L53.4031 169.285L44.819 171.721C43.4461 172.112 42.9958 172.503 42.863 173.529C42.8408 173.573 42.6046 173.603 42.5677 173.558C42.4422 172.99 42.2725 172.311 42.0584 171.566C41.8444 170.82 41.6377 170.148 41.4458 169.602C41.4458 169.543 41.6599 169.447 41.7115 169.469C42.3684 170.274 42.9589 170.37 44.3318 169.979L52.916 167.543L52.5838 166.384C52.0745 164.598 51.4029 164 49.9562 163.852C49.8897 163.815 49.8528 163.564 49.9193 163.528C50.9526 163.328 52.2369 162.981 52.6576 162.804C52.7315 162.804 52.8495 162.9 52.8717 162.967C52.8938 163.313 53.0636 164.17 53.5655 165.934L54.8055 170.303C55.3074 172.075 55.6101 172.887 55.7724 173.197Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M51.9607 182.615L48.9419 183.943C47.6871 184.497 47.2885 184.925 47.2959 185.885C47.2811 185.929 47.0449 185.995 47.008 185.951C46.8161 185.427 46.5652 184.807 46.2625 184.135C45.9673 183.456 45.6794 182.858 45.4211 182.356C45.4137 182.297 45.613 182.172 45.6647 182.194C46.3659 182.851 46.9564 182.851 48.2111 182.297L55.1051 179.264C56.3598 178.71 56.7584 178.282 56.751 177.315C56.7732 177.271 57.002 177.204 57.0389 177.249C57.2308 177.773 57.4818 178.393 57.7844 179.064C58.0796 179.744 58.3675 180.341 58.6258 180.843C58.6332 180.902 58.4339 181.028 58.3822 181.006C57.681 180.349 57.0906 180.356 55.8358 180.902L52.935 182.179L55.6291 188.298L58.5299 187.021C59.7847 186.468 60.1832 186.04 60.1759 185.073C60.1906 185.021 60.4194 184.962 60.4637 185.006C60.6556 185.53 60.9066 186.15 61.2018 186.829C61.4971 187.508 61.7849 188.106 62.0433 188.608C62.0506 188.667 61.8514 188.793 61.7997 188.771C61.0985 188.114 60.508 188.121 59.2532 188.667L52.3593 191.701C51.1045 192.254 50.7059 192.683 50.7133 193.649C50.6912 193.694 50.4624 193.76 50.4255 193.716C50.2336 193.192 49.9826 192.572 49.68 191.893C49.3847 191.214 49.0969 190.616 48.8385 190.114C48.8312 190.055 49.0304 189.929 49.0821 189.952C49.7833 190.608 50.3738 190.601 51.6286 190.055L54.6474 188.726L51.9607 182.615Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M51.9607 182.615L48.9419 183.943C47.6871 184.497 47.2885 184.925 47.2959 185.885C47.2811 185.929 47.0449 185.995 47.008 185.951C46.8161 185.427 46.5652 184.807 46.2625 184.135C45.9673 183.456 45.6794 182.858 45.4211 182.356C45.4137 182.297 45.613 182.172 45.6647 182.194C46.3659 182.851 46.9564 182.851 48.2111 182.297L55.1051 179.264C56.3598 178.71 56.7584 178.282 56.751 177.315C56.7732 177.271 57.002 177.204 57.0389 177.249C57.2308 177.773 57.4818 178.393 57.7844 179.064C58.0796 179.744 58.3675 180.341 58.6258 180.843C58.6332 180.902 58.4339 181.028 58.3822 181.006C57.681 180.349 57.0906 180.356 55.8358 180.902L52.935 182.179L55.6291 188.298L58.5299 187.021C59.7847 186.468 60.1832 186.04 60.1759 185.073C60.1906 185.021 60.4194 184.962 60.4637 185.006C60.6556 185.53 60.9066 186.15 61.2018 186.829C61.4971 187.508 61.7849 188.106 62.0433 188.608C62.0506 188.667 61.8514 188.793 61.7997 188.771C61.0985 188.114 60.508 188.121 59.2532 188.667L52.3593 191.701C51.1045 192.254 50.7059 192.683 50.7133 193.649C50.6912 193.694 50.4624 193.76 50.4255 193.716C50.2336 193.192 49.9826 192.572 49.68 191.893C49.3847 191.214 49.0969 190.616 48.8385 190.114C48.8312 190.055 49.0304 189.929 49.0821 189.952C49.7833 190.608 50.3738 190.601 51.6286 190.055L54.6474 188.726L51.9607 182.615Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M53.4906 199.34C53.4758 199.281 53.6603 199.134 53.7046 199.141C54.4944 199.672 55.1218 199.584 56.4209 198.779L62.3036 195.163C63.7503 194.277 64.1267 193.723 64.0234 192.793C64.0381 192.742 64.2522 192.653 64.2965 192.69C64.5474 193.133 64.9386 193.797 65.3003 194.395L67.4556 197.894C68.4151 199.458 68.9318 200.16 69.1753 200.411C69.2123 200.47 69.2049 200.625 69.1532 200.684C68.7399 200.876 67.8468 201.444 67.0053 202.071C66.9315 202.093 66.7691 201.894 66.7913 201.82C67.5441 200.809 67.4851 199.953 66.5698 198.462L64.8722 195.701L60.8938 198.145L62.0452 200.019C62.6579 201.016 63.2631 201.488 64.2226 201.392C64.2891 201.392 64.3998 201.643 64.3629 201.687C64.0455 201.865 63.3886 202.241 62.9605 202.507C62.5324 202.772 61.8976 203.178 61.595 203.385C61.5359 203.4 61.3662 203.186 61.3957 203.127C61.9124 202.322 61.7721 201.562 61.1521 200.566L60.0007 198.691L55.9337 201.193L57.7347 204.123C58.7164 205.717 59.4397 206.101 60.9602 205.821C61.034 205.836 61.1374 206.072 61.0857 206.123C60.0819 206.655 59.1371 207.26 58.7385 207.57C58.6795 207.607 58.5171 207.555 58.4802 207.496C58.3473 207.216 58.0521 206.662 56.849 204.714L54.5608 201.001C54.1918 200.418 53.7711 199.761 53.4906 199.34Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M53.4906 199.34C53.4758 199.281 53.6603 199.134 53.7046 199.141C54.4944 199.672 55.1218 199.584 56.4209 198.779L62.3036 195.163C63.7503 194.277 64.1267 193.723 64.0234 192.793C64.0381 192.742 64.2522 192.653 64.2965 192.69C64.5474 193.133 64.9386 193.797 65.3003 194.395L67.4556 197.894C68.4151 199.458 68.9318 200.16 69.1753 200.411C69.2123 200.47 69.2049 200.625 69.1532 200.684C68.7399 200.876 67.8468 201.444 67.0053 202.071C66.9315 202.093 66.7691 201.894 66.7913 201.82C67.5441 200.809 67.4851 199.953 66.5698 198.462L64.8722 195.701L60.8938 198.145L62.0452 200.019C62.6579 201.016 63.2631 201.488 64.2226 201.392C64.2891 201.392 64.3998 201.643 64.3629 201.687C64.0455 201.865 63.3886 202.241 62.9605 202.507C62.5324 202.772 61.8976 203.178 61.595 203.385C61.5359 203.4 61.3662 203.186 61.3957 203.127C61.9124 202.322 61.7721 201.562 61.1521 200.566L60.0007 198.691L55.9337 201.193L57.7347 204.123C58.7164 205.717 59.4397 206.101 60.9602 205.821C61.034 205.836 61.1374 206.072 61.0857 206.123C60.0819 206.655 59.1371 207.26 58.7385 207.57C58.6795 207.607 58.5171 207.555 58.4802 207.496C58.3473 207.216 58.0521 206.662 56.849 204.714L54.5608 201.001C54.1918 200.418 53.7711 199.761 53.4906 199.34Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M76.2832 211.711L72.2457 215.254L73.7293 216.945C75.0136 218.406 76.1429 218.495 77.538 217.269C78.9625 216.022 79.0216 214.834 77.7594 213.402L76.2832 211.711ZM68.5921 220.074C68.5921 220.126 68.3854 220.251 68.3412 220.222C67.9869 219.764 67.5366 219.225 67.0273 218.642C66.5402 218.089 66.0899 217.594 65.6914 217.203C65.6692 217.151 65.8242 216.967 65.8759 216.974C66.7395 217.387 67.3004 217.21 68.3338 216.302L73.6851 211.601C74.962 210.486 75.2425 209.874 74.9767 208.98C74.9767 208.929 75.176 208.803 75.2277 208.833C75.5451 209.224 76.047 209.822 76.512 210.346L78.5935 212.715C80.5199 214.907 80.638 217.203 78.9035 218.723C77.1689 220.244 74.8882 219.831 72.9617 217.638L71.4781 215.948L69.5959 217.601C68.5109 218.539 68.2673 219.085 68.5921 220.074Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M76.2832 211.711L72.2457 215.254L73.7293 216.945C75.0136 218.406 76.1429 218.495 77.538 217.269C78.9625 216.022 79.0216 214.834 77.7594 213.402L76.2832 211.711ZM68.5921 220.074C68.5921 220.126 68.3854 220.251 68.3412 220.222C67.9869 219.764 67.5366 219.225 67.0273 218.642C66.5402 218.089 66.0899 217.594 65.6914 217.203C65.6692 217.151 65.8242 216.967 65.8759 216.974C66.7395 217.387 67.3004 217.21 68.3338 216.302L73.6851 211.601C74.962 210.486 75.2425 209.874 74.9767 208.98C74.9767 208.929 75.176 208.803 75.2277 208.833C75.5451 209.224 76.047 209.822 76.512 210.346L78.5935 212.715C80.5199 214.907 80.638 217.203 78.9035 218.723C77.1689 220.244 74.8882 219.831 72.9617 217.638L71.4781 215.948L69.5959 217.601C68.5109 218.539 68.2673 219.085 68.5921 220.074Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M87.9019 230.533C90.2417 227.861 90.4557 225.41 88.4481 223.653C86.4552 221.904 84.0785 222.406 81.7313 225.078C79.3915 227.75 79.1774 230.2 81.1851 231.957C83.178 233.706 85.5621 233.205 87.9019 230.533ZM80.2182 223.794C82.7573 220.893 86.4773 220.509 89.164 222.864C91.8729 225.24 91.9762 228.901 89.4224 231.817C86.8759 234.718 83.1632 235.101 80.4765 232.747C77.7603 230.37 77.6569 226.709 80.2182 223.794Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M87.9019 230.533C90.2417 227.861 90.4557 225.41 88.4481 223.653C86.4552 221.904 84.0785 222.406 81.7313 225.078C79.3915 227.75 79.1774 230.2 81.1851 231.957C83.178 233.706 85.5621 233.205 87.9019 230.533ZM80.2182 223.794C82.7573 220.893 86.4773 220.509 89.164 222.864C91.8729 225.24 91.9762 228.901 89.4224 231.817C86.8759 234.718 83.1632 235.101 80.4765 232.747C77.7603 230.37 77.6569 226.709 80.2182 223.794Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M91.5992 241.169C91.0161 240.778 90.3666 240.357 89.9311 240.091C89.8942 240.047 89.9976 239.833 90.0492 239.825C90.9719 239.973 91.5402 239.611 92.485 238.209L96.4708 232.304C97.2384 231.167 97.3417 230.592 96.825 229.78C96.8177 229.728 96.98 229.558 97.0317 229.573C97.4746 229.913 98.0208 230.304 98.6334 230.717C99.2756 231.153 99.866 231.529 100.368 231.824C100.405 231.869 100.302 232.083 100.25 232.09C99.2239 231.898 98.7146 232.208 97.9174 233.389L92.9278 240.785L95.3341 242.409C96.8915 243.457 97.7034 243.509 98.9729 242.623C99.0467 242.608 99.2387 242.778 99.2091 242.852C98.5153 243.752 97.9027 244.69 97.6665 245.14C97.6222 245.199 97.4598 245.221 97.4008 245.177C97.1646 244.977 96.6627 244.594 94.7657 243.317L91.5992 241.169Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M91.5992 241.169C91.0161 240.778 90.3666 240.357 89.9311 240.091C89.8942 240.047 89.9976 239.833 90.0492 239.825C90.9719 239.973 91.5402 239.611 92.485 238.209L96.4708 232.304C97.2384 231.167 97.3417 230.592 96.825 229.78C96.8177 229.728 96.98 229.558 97.0317 229.573C97.4746 229.913 98.0208 230.304 98.6334 230.717C99.2756 231.153 99.866 231.529 100.368 231.824C100.405 231.869 100.302 232.083 100.25 232.09C99.2239 231.898 98.7146 232.208 97.9174 233.389L92.9278 240.785L95.3341 242.409C96.8915 243.457 97.7034 243.509 98.9729 242.623C99.0467 242.608 99.2387 242.778 99.2091 242.852C98.5153 243.752 97.9027 244.69 97.6665 245.14C97.6222 245.199 97.4598 245.221 97.4008 245.177C97.1646 244.977 96.6627 244.594 94.7657 243.317L91.5992 241.169Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M113.329 246.572C114.945 243.413 114.546 240.985 112.17 239.767C109.808 238.564 107.623 239.627 106.007 242.793C104.39 245.952 104.789 248.388 107.165 249.598C109.527 250.801 111.712 249.731 113.329 246.572ZM104.228 241.922C105.984 238.49 109.49 237.206 112.672 238.829C115.882 240.468 116.872 243.996 115.107 247.443C113.351 250.875 109.845 252.16 106.663 250.536C103.46 248.89 102.464 245.369 104.228 241.922Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M113.329 246.572C114.945 243.413 114.546 240.985 112.17 239.767C109.808 238.564 107.623 239.627 106.007 242.793C104.39 245.952 104.789 248.388 107.165 249.598C109.527 250.801 111.712 249.731 113.329 246.572ZM104.228 241.922C105.984 238.49 109.49 237.206 112.672 238.829C115.882 240.468 116.872 243.996 115.107 247.443C113.351 250.875 109.845 252.16 106.663 250.536C103.46 248.89 102.464 245.369 104.228 241.922Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M127.326 258.809L122.771 246.623L120.528 253.096C119.967 254.713 119.981 255.385 120.742 256.167C120.764 256.211 120.653 256.425 120.594 256.418C120.21 256.263 119.553 256.019 118.985 255.827C118.424 255.635 117.752 255.421 117.354 255.303C117.31 255.266 117.354 255.038 117.398 255.015C118.476 254.875 118.904 254.359 119.465 252.735L121.716 246.247C122.166 244.955 122.107 244.283 121.458 243.619C121.436 243.575 121.546 243.368 121.605 243.368C122.011 243.531 122.631 243.759 123.214 243.966C123.879 244.195 124.277 244.313 124.779 244.453C124.823 244.49 124.868 244.638 124.846 244.704C124.44 245.213 124.417 245.833 124.794 246.845L127.887 255.318L129.894 249.524C130.455 247.907 130.44 247.236 129.68 246.453C129.658 246.409 129.769 246.195 129.828 246.195C130.212 246.35 130.869 246.594 131.437 246.793C131.998 246.985 132.669 247.199 133.068 247.317C133.112 247.354 133.068 247.583 133.024 247.605C131.946 247.745 131.518 248.262 130.957 249.886L127.842 258.883C127.776 258.927 127.377 258.883 127.326 258.809Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M127.326 258.809L122.771 246.623L120.528 253.096C119.967 254.713 119.981 255.385 120.742 256.167C120.764 256.211 120.653 256.425 120.594 256.418C120.21 256.263 119.553 256.019 118.985 255.827C118.424 255.635 117.752 255.421 117.354 255.303C117.31 255.266 117.354 255.038 117.398 255.015C118.476 254.875 118.904 254.359 119.465 252.735L121.716 246.247C122.166 244.955 122.107 244.283 121.458 243.619C121.436 243.575 121.546 243.368 121.605 243.368C122.011 243.531 122.631 243.759 123.214 243.966C123.879 244.195 124.277 244.313 124.779 244.453C124.823 244.49 124.868 244.638 124.846 244.704C124.44 245.213 124.417 245.833 124.794 246.845L127.887 255.318L129.894 249.524C130.455 247.907 130.44 247.236 129.68 246.453C129.658 246.409 129.769 246.195 129.828 246.195C130.212 246.35 130.869 246.594 131.437 246.793C131.998 246.985 132.669 247.199 133.068 247.317C133.112 247.354 133.068 247.583 133.024 247.605C131.946 247.745 131.518 248.262 130.957 249.886L127.842 258.883C127.776 258.927 127.377 258.883 127.326 258.809Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M138.92 251.458C138.654 252.765 139.355 253.385 141.333 254.603C143.105 255.754 144.67 256.92 144.212 259.149C143.747 261.408 141.909 262.508 139.436 261.998C137.687 261.644 136.691 260.685 135.997 260.544C135.731 260.493 135.569 260.566 135.414 260.685C135.34 260.685 135.17 260.596 135.148 260.537C135.517 259.452 135.849 258.382 136.13 257.282C136.174 257.238 136.395 257.245 136.44 257.311C136.632 259.245 137.776 260.603 139.665 260.987C141.186 261.297 142.241 260.707 142.514 259.4C142.795 258.042 142.234 257.341 140.241 256.123C138.403 254.957 136.794 253.894 137.237 251.717C137.658 249.65 139.392 248.572 141.599 249.022C142.891 249.288 143.444 249.805 144.079 249.93C144.293 249.975 144.47 249.916 144.596 249.82C144.67 249.812 144.839 249.886 144.861 249.945C144.692 250.956 144.596 251.968 144.529 253.008C144.515 253.082 144.271 253.104 144.227 253.038C143.651 251.355 142.669 250.307 141.363 250.041C140.079 249.761 139.156 250.307 138.92 251.458Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M138.92 251.458C138.654 252.765 139.355 253.385 141.333 254.603C143.105 255.754 144.67 256.92 144.212 259.149C143.747 261.408 141.909 262.508 139.436 261.998C137.687 261.644 136.691 260.685 135.997 260.544C135.731 260.493 135.569 260.566 135.414 260.685C135.34 260.685 135.17 260.596 135.148 260.537C135.517 259.452 135.849 258.382 136.13 257.282C136.174 257.238 136.395 257.245 136.44 257.311C136.632 259.245 137.776 260.603 139.665 260.987C141.186 261.297 142.241 260.707 142.514 259.4C142.795 258.042 142.234 257.341 140.241 256.123C138.403 254.957 136.794 253.894 137.237 251.717C137.658 249.65 139.392 248.572 141.599 249.022C142.891 249.288 143.444 249.805 144.079 249.93C144.293 249.975 144.47 249.916 144.596 249.82C144.67 249.812 144.839 249.886 144.861 249.945C144.692 250.956 144.596 251.968 144.529 253.008C144.515 253.082 144.271 253.104 144.227 253.038C143.651 251.355 142.669 250.307 141.363 250.041C140.079 249.761 139.156 250.307 138.92 251.458Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M153.814 263.821C153.261 263.748 152.597 263.674 151.858 263.622C151.12 263.57 150.456 263.534 149.895 263.534C149.843 263.511 149.821 263.275 149.866 263.238C150.773 262.928 151.047 262.404 151.15 261.039L151.703 253.525C151.807 252.159 151.615 251.598 150.759 251.155C150.729 251.119 150.781 250.89 150.832 250.875C151.386 250.949 152.05 251.015 152.788 251.074C153.527 251.133 154.191 251.163 154.752 251.163C154.803 251.185 154.826 251.421 154.781 251.458C153.873 251.768 153.6 252.292 153.497 253.658L153.202 257.651L157.808 253.798C158.944 252.838 159.158 252.145 158.214 251.716C158.184 251.68 158.236 251.443 158.287 251.436C158.715 251.488 159.756 251.584 160.42 251.628C161.07 251.68 161.875 251.716 162.295 251.731C162.347 251.753 162.369 251.99 162.332 252.026C161.542 252.167 160.908 252.661 159.35 253.96L156.597 256.211L159.845 261.858C160.694 263.312 160.937 263.725 161.609 264.124C161.646 264.161 161.587 264.39 161.535 264.412C161.144 264.36 160.28 264.264 159.564 264.213C158.774 264.154 157.926 264.131 157.512 264.117C157.461 264.094 157.439 263.858 157.483 263.829C158.206 263.593 158.472 263.179 157.771 261.932L155.195 257.385L153.098 259.112L152.943 261.201C152.84 262.567 153.032 263.12 153.888 263.563C153.918 263.578 153.866 263.807 153.814 263.821Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M153.814 263.821C153.261 263.748 152.597 263.674 151.858 263.622C151.12 263.57 150.456 263.534 149.895 263.534C149.843 263.511 149.821 263.275 149.866 263.238C150.773 262.928 151.047 262.404 151.15 261.039L151.703 253.525C151.807 252.159 151.615 251.598 150.759 251.155C150.729 251.119 150.781 250.89 150.832 250.875C151.386 250.949 152.05 251.015 152.788 251.074C153.527 251.133 154.191 251.163 154.752 251.163C154.803 251.185 154.826 251.421 154.781 251.458C153.873 251.768 153.6 252.292 153.497 253.658L153.202 257.651L157.808 253.798C158.944 252.838 159.158 252.145 158.214 251.716C158.184 251.68 158.236 251.443 158.287 251.436C158.715 251.488 159.756 251.584 160.42 251.628C161.07 251.68 161.875 251.716 162.295 251.731C162.347 251.753 162.369 251.99 162.332 252.026C161.542 252.167 160.908 252.661 159.35 253.96L156.597 256.211L159.845 261.858C160.694 263.312 160.937 263.725 161.609 264.124C161.646 264.161 161.587 264.39 161.535 264.412C161.144 264.36 160.28 264.264 159.564 264.213C158.774 264.154 157.926 264.131 157.512 264.117C157.461 264.094 157.439 263.858 157.483 263.829C158.206 263.593 158.472 263.179 157.771 261.932L155.195 257.385L153.098 259.112L152.943 261.201C152.84 262.567 153.032 263.12 153.888 263.563C153.918 263.578 153.866 263.807 153.814 263.821Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M174.948 263.88C174.373 263.88 173.671 263.91 172.896 263.954C172.121 264.006 171.42 264.065 170.852 264.139C170.8 264.124 170.748 263.895 170.778 263.851C171.708 263.379 171.922 262.818 171.833 261.4L171.649 258.485L168.335 254.093C167.272 252.683 166.977 252.3 166.231 252.004C166.194 251.967 166.216 251.739 166.268 251.709C166.667 251.702 167.53 251.687 168.246 251.635C169.021 251.584 169.848 251.495 170.261 251.451C170.313 251.466 170.365 251.694 170.335 251.739C169.671 252.071 169.464 252.514 170.35 253.702L172.896 257.134L174.86 253.702C175.539 252.506 175.458 251.768 174.336 251.48C174.299 251.443 174.321 251.207 174.373 251.192C174.786 251.185 175.76 251.141 176.388 251.096C177 251.06 177.539 251.008 177.915 250.964C177.967 250.978 178.019 251.207 177.989 251.251C177.465 251.48 177.104 252.049 176.159 253.665L173.443 258.352L173.627 261.282C173.716 262.7 174.003 263.224 174.985 263.578C175.022 263.63 175 263.866 174.948 263.88Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M174.948 263.88C174.373 263.88 173.671 263.91 172.896 263.954C172.121 264.006 171.42 264.065 170.852 264.139C170.8 264.124 170.748 263.895 170.778 263.851C171.708 263.379 171.922 262.818 171.833 261.4L171.649 258.485L168.335 254.093C167.272 252.683 166.977 252.3 166.231 252.004C166.194 251.967 166.216 251.739 166.268 251.709C166.667 251.702 167.53 251.687 168.246 251.635C169.021 251.584 169.848 251.495 170.261 251.451C170.313 251.466 170.365 251.694 170.335 251.739C169.671 252.071 169.464 252.514 170.35 253.702L172.896 257.134L174.86 253.702C175.539 252.506 175.458 251.768 174.336 251.48C174.299 251.443 174.321 251.207 174.373 251.192C174.786 251.185 175.76 251.141 176.388 251.096C177 251.06 177.539 251.008 177.915 250.964C177.967 250.978 178.019 251.207 177.989 251.251C177.465 251.48 177.104 252.049 176.159 253.665L173.443 258.352L173.627 261.282C173.716 262.7 174.003 263.224 174.985 263.578C175.022 263.63 175 263.866 174.948 263.88Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M189.9 261.887C189.841 261.88 189.752 261.666 189.782 261.622C190.534 261.039 190.645 260.419 190.291 258.928L188.697 252.211C188.305 250.565 187.899 250.026 186.984 249.842C186.94 249.812 186.925 249.583 186.969 249.546C187.464 249.443 188.224 249.288 188.903 249.118L192.904 248.166C194.69 247.738 195.517 247.472 195.834 247.317C195.908 247.302 196.048 247.362 196.085 247.428C196.137 247.878 196.402 248.912 196.727 249.908C196.727 249.982 196.491 250.078 196.425 250.033C195.701 249 194.867 248.793 193.169 249.199L190.01 249.952L191.088 254.492L193.229 253.982C194.365 253.709 195.007 253.281 195.207 252.344C195.229 252.285 195.502 252.255 195.531 252.307C195.598 252.661 195.753 253.399 195.871 253.894C195.989 254.381 196.181 255.119 196.284 255.466C196.277 255.525 196.026 255.621 195.974 255.577C195.369 254.831 194.609 254.735 193.465 255.001L191.324 255.51L192.431 260.16L195.782 259.363C197.605 258.928 198.196 258.367 198.403 256.831C198.44 256.765 198.698 256.743 198.735 256.809C198.927 257.931 199.2 259.016 199.37 259.496C199.384 259.57 199.288 259.703 199.222 259.717C198.912 259.754 198.292 259.865 196.07 260.396L191.826 261.408C191.132 261.555 190.387 261.747 189.9 261.887Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M189.9 261.887C189.841 261.88 189.752 261.666 189.782 261.622C190.534 261.039 190.645 260.419 190.291 258.928L188.697 252.211C188.305 250.565 187.899 250.026 186.984 249.842C186.94 249.812 186.925 249.583 186.969 249.546C187.464 249.443 188.224 249.288 188.903 249.118L192.904 248.166C194.69 247.738 195.517 247.472 195.834 247.317C195.908 247.302 196.048 247.362 196.085 247.428C196.137 247.878 196.402 248.912 196.727 249.908C196.727 249.982 196.491 250.078 196.425 250.033C195.701 249 194.867 248.793 193.169 249.199L190.01 249.952L191.088 254.492L193.229 253.982C194.365 253.709 195.007 253.281 195.207 252.344C195.229 252.285 195.502 252.255 195.531 252.307C195.598 252.661 195.753 253.399 195.871 253.894C195.989 254.381 196.181 255.119 196.284 255.466C196.277 255.525 196.026 255.621 195.974 255.577C195.369 254.831 194.609 254.735 193.465 255.001L191.324 255.51L192.431 260.16L195.782 259.363C197.605 258.928 198.196 258.367 198.403 256.831C198.44 256.765 198.698 256.743 198.735 256.809C198.927 257.931 199.2 259.016 199.37 259.496C199.384 259.57 199.288 259.703 199.222 259.717C198.912 259.754 198.292 259.865 196.07 260.396L191.826 261.408C191.132 261.555 190.387 261.747 189.9 261.887Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M208.286 256.389C208.33 256.411 208.382 256.64 208.338 256.676C207.924 256.817 207.009 257.141 206.404 257.378C205.828 257.599 205.319 257.813 204.95 257.968C204.891 257.968 204.773 257.761 204.795 257.717C205.282 257.319 205.526 256.647 205.998 254.957L207.29 250.373L203.141 247.598C201.769 246.69 201.377 246.417 200.595 246.35C200.551 246.328 200.499 246.099 200.543 246.062C200.92 245.937 201.739 245.664 202.418 245.406C203.156 245.125 203.939 244.786 204.315 244.623C204.374 244.623 204.492 244.83 204.47 244.874C203.916 245.391 203.85 245.878 205.001 246.66L208.109 248.771L209.032 245.391C209.364 244.143 209.15 243.472 208.013 243.523C207.969 243.501 207.917 243.272 207.961 243.236C208.375 243.095 209.29 242.763 209.895 242.534C210.449 242.32 210.98 242.099 211.349 241.944C211.408 241.944 211.526 242.15 211.504 242.195C211.017 242.593 210.773 243.265 210.301 244.955L209.083 249.281L213.46 252.203C214.826 253.111 215.224 253.384 215.999 253.451C216.044 253.473 216.095 253.702 216.051 253.739C215.674 253.864 214.855 254.137 214.176 254.396C213.438 254.676 212.656 255.016 212.279 255.178C212.22 255.178 212.102 254.971 212.124 254.927C212.678 254.403 212.744 253.916 211.593 253.141L208.257 250.868L207.26 254.529C206.928 255.769 207.149 256.44 208.286 256.389Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M208.286 256.389C208.33 256.411 208.382 256.64 208.338 256.676C207.924 256.817 207.009 257.141 206.404 257.378C205.828 257.599 205.319 257.813 204.95 257.968C204.891 257.968 204.773 257.761 204.795 257.717C205.282 257.319 205.526 256.647 205.998 254.957L207.29 250.373L203.141 247.598C201.769 246.69 201.377 246.417 200.595 246.35C200.551 246.328 200.499 246.099 200.543 246.062C200.92 245.937 201.739 245.664 202.418 245.406C203.156 245.125 203.939 244.786 204.315 244.623C204.374 244.623 204.492 244.83 204.47 244.874C203.916 245.391 203.85 245.878 205.001 246.66L208.109 248.771L209.032 245.391C209.364 244.143 209.15 243.472 208.013 243.523C207.969 243.501 207.917 243.272 207.961 243.236C208.375 243.095 209.29 242.763 209.895 242.534C210.449 242.32 210.98 242.099 211.349 241.944C211.408 241.944 211.526 242.15 211.504 242.195C211.017 242.593 210.773 243.265 210.301 244.955L209.083 249.281L213.46 252.203C214.826 253.111 215.224 253.384 215.999 253.451C216.044 253.473 216.095 253.702 216.051 253.739C215.674 253.864 214.855 254.137 214.176 254.396C213.438 254.676 212.656 255.016 212.279 255.178C212.22 255.178 212.102 254.971 212.124 254.927C212.678 254.403 212.744 253.916 211.593 253.141L208.257 250.868L207.26 254.529C206.928 255.769 207.149 256.44 208.286 256.389Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M220.929 244.793L222.531 247.679C223.195 248.875 223.66 249.236 224.619 249.14C224.671 249.155 224.752 249.376 224.715 249.421C224.206 249.657 223.616 249.967 222.974 250.329C222.331 250.69 221.756 251.03 221.283 251.325C221.224 251.332 221.084 251.148 221.099 251.096C221.689 250.336 221.63 249.753 220.966 248.55L217.312 241.959C216.648 240.763 216.183 240.401 215.223 240.497C215.172 240.482 215.091 240.261 215.135 240.217C215.644 239.98 216.235 239.67 216.877 239.309C217.526 238.947 218.095 238.608 218.567 238.312C218.626 238.305 218.766 238.489 218.752 238.541C218.161 239.301 218.22 239.884 218.884 241.088L220.42 243.863L226.265 240.623L224.73 237.847C224.066 236.652 223.601 236.29 222.641 236.386C222.59 236.371 222.509 236.15 222.545 236.105C223.055 235.862 223.645 235.559 224.287 235.197C224.937 234.843 225.505 234.504 225.978 234.201C226.037 234.186 226.177 234.378 226.162 234.43C225.572 235.19 225.631 235.773 226.295 236.976L229.949 243.568C230.613 244.763 231.078 245.125 232.037 245.029C232.089 245.044 232.17 245.265 232.126 245.31C231.617 245.553 231.026 245.856 230.384 246.217C229.735 246.572 229.166 246.911 228.694 247.214C228.635 247.221 228.495 247.037 228.509 246.985C229.1 246.225 229.041 245.642 228.376 244.439L226.775 241.553L220.929 244.793Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M220.929 244.793L222.531 247.679C223.195 248.875 223.66 249.236 224.619 249.14C224.671 249.155 224.752 249.376 224.715 249.421C224.206 249.657 223.616 249.967 222.974 250.329C222.331 250.69 221.756 251.03 221.283 251.325C221.224 251.332 221.084 251.148 221.099 251.096C221.689 250.336 221.63 249.753 220.966 248.55L217.312 241.959C216.648 240.763 216.183 240.401 215.223 240.497C215.172 240.482 215.091 240.261 215.135 240.217C215.644 239.98 216.235 239.67 216.877 239.309C217.526 238.947 218.095 238.608 218.567 238.312C218.626 238.305 218.766 238.489 218.752 238.541C218.161 239.301 218.22 239.884 218.884 241.088L220.42 243.863L226.265 240.623L224.73 237.847C224.066 236.652 223.601 236.29 222.641 236.386C222.59 236.371 222.509 236.15 222.545 236.105C223.055 235.862 223.645 235.559 224.287 235.197C224.937 234.843 225.505 234.504 225.978 234.201C226.037 234.186 226.177 234.378 226.162 234.43C225.572 235.19 225.631 235.773 226.295 236.976L229.949 243.568C230.613 244.763 231.078 245.125 232.037 245.029C232.089 245.044 232.17 245.265 232.126 245.31C231.617 245.553 231.026 245.856 230.384 246.217C229.735 246.572 229.166 246.911 228.694 247.214C228.635 247.221 228.495 247.037 228.509 246.985C229.1 246.225 229.041 245.642 228.376 244.439L226.775 241.553L220.929 244.793Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M240.985 238.755C241.036 238.762 241.14 238.977 241.11 239.021C240.623 239.331 240.04 239.729 239.413 240.18C238.785 240.63 238.224 241.058 237.781 241.427C237.722 241.442 237.56 241.272 237.567 241.228C238.099 240.335 237.988 239.744 237.154 238.593L232.851 232.629C232.017 231.477 231.5 231.182 230.482 231.404C230.43 231.396 230.327 231.182 230.356 231.138C230.843 230.828 231.426 230.429 232.054 229.979C232.681 229.529 233.242 229.101 233.685 228.732C233.737 228.717 233.906 228.887 233.899 228.931C233.368 229.824 233.478 230.414 234.312 231.566L238.615 237.53C239.442 238.689 239.966 238.984 240.985 238.755Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M240.985 238.755C241.036 238.762 241.14 238.977 241.11 239.021C240.623 239.331 240.04 239.729 239.413 240.18C238.785 240.63 238.224 241.058 237.781 241.427C237.722 241.442 237.56 241.272 237.567 241.228C238.099 240.335 237.988 239.744 237.154 238.593L232.851 232.629C232.017 231.477 231.5 231.182 230.482 231.404C230.43 231.396 230.327 231.182 230.356 231.138C230.843 230.828 231.426 230.429 232.054 229.979C232.681 229.529 233.242 229.101 233.685 228.732C233.737 228.717 233.906 228.887 233.899 228.931C233.368 229.824 233.478 230.414 234.312 231.566L238.615 237.53C239.442 238.689 239.966 238.984 240.985 238.755Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M249.227 230.939C250.645 229.684 250.785 228.591 249.692 227.366C248.563 226.097 247.456 226.126 246.054 227.366L244.112 229.093L247.286 232.666L249.227 230.939ZM245.065 226.849C246.467 225.602 246.592 224.554 245.522 223.351C244.43 222.126 243.345 222.126 241.957 223.358L240.311 224.82L243.411 228.311L245.065 226.849ZM245.876 235.389C245.825 235.411 245.64 235.264 245.648 235.212C246.031 234.341 245.84 233.743 244.821 232.599L240.23 227.44C239.101 226.17 238.495 225.897 237.595 226.163C237.543 226.163 237.418 225.964 237.44 225.912C237.831 225.587 238.422 225.085 238.946 224.62L241.263 222.561C243.404 220.657 245.552 220.413 246.843 221.867C247.773 222.915 247.796 224.296 246.961 225.691C248.607 224.775 250.128 224.879 251.176 226.067C252.578 227.647 252.091 229.809 249.921 231.743L247.323 234.053C246.806 234.511 246.245 235.042 245.876 235.389Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M249.227 230.939C250.645 229.684 250.785 228.591 249.692 227.366C248.563 226.097 247.456 226.126 246.054 227.366L244.112 229.093L247.286 232.666L249.227 230.939ZM245.065 226.849C246.467 225.602 246.592 224.554 245.522 223.351C244.43 222.126 243.345 222.126 241.957 223.358L240.311 224.82L243.411 228.311L245.065 226.849ZM245.876 235.389C245.825 235.411 245.64 235.264 245.648 235.212C246.031 234.341 245.84 233.743 244.821 232.599L240.23 227.44C239.101 226.17 238.495 225.897 237.595 226.163C237.543 226.163 237.418 225.964 237.44 225.912C237.831 225.587 238.422 225.085 238.946 224.62L241.263 222.561C243.404 220.657 245.552 220.413 246.843 221.867C247.773 222.915 247.796 224.296 246.961 225.691C248.607 224.775 250.128 224.879 251.176 226.067C252.578 227.647 252.091 229.809 249.921 231.743L247.323 234.053C246.806 234.511 246.245 235.042 245.876 235.389Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M260.086 221.21C260.138 221.21 260.286 221.395 260.263 221.447C259.85 221.845 259.356 222.355 258.831 222.923C258.307 223.491 257.842 224.023 257.481 224.473C257.429 224.502 257.23 224.37 257.23 224.318C257.569 223.336 257.341 222.783 256.292 221.816L250.875 216.841C249.827 215.874 249.258 215.697 248.306 216.118C248.254 216.118 248.107 215.933 248.129 215.881C248.542 215.483 249.037 214.973 249.561 214.405C250.085 213.837 250.55 213.305 250.912 212.855C250.963 212.826 251.155 212.958 251.163 213.01C250.823 213.992 251.052 214.545 252.1 215.505L257.518 220.48C258.566 221.454 259.134 221.631 260.086 221.21Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M260.086 221.21C260.138 221.21 260.286 221.395 260.263 221.447C259.85 221.845 259.356 222.355 258.831 222.923C258.307 223.491 257.842 224.023 257.481 224.473C257.429 224.502 257.23 224.37 257.23 224.318C257.569 223.336 257.341 222.783 256.292 221.816L250.875 216.841C249.827 215.874 249.258 215.697 248.306 216.118C248.254 216.118 248.107 215.933 248.129 215.881C248.542 215.483 249.037 214.973 249.561 214.405C250.085 213.837 250.55 213.305 250.912 212.855C250.963 212.826 251.155 212.958 251.163 213.01C250.823 213.992 251.052 214.545 252.1 215.505L257.518 220.48C258.566 221.454 259.134 221.631 260.086 221.21Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M260.161 200.927C260.205 200.868 260.352 200.824 260.419 200.854C260.751 201.164 261.829 201.946 262.722 202.5C262.766 202.559 262.648 202.78 262.574 202.795C261.164 202.418 260.323 202.736 259.216 204.227L258.492 205.194L265.652 210.53C266.796 211.379 267.379 211.505 268.28 210.98C268.331 210.973 268.494 211.143 268.479 211.195C268.103 211.637 267.667 212.191 267.21 212.811C266.745 213.431 266.339 214.007 266.021 214.494C265.977 214.523 265.763 214.413 265.755 214.361C265.992 213.35 265.711 212.818 264.567 211.97L257.407 206.633L256.684 207.6C255.577 209.091 255.511 209.984 256.271 211.231C256.286 211.305 256.101 211.49 256.035 211.46C255.252 210.766 254.189 209.955 253.798 209.726C253.754 209.667 253.754 209.512 253.798 209.453C254.064 209.224 254.64 208.567 255.732 207.098L258.448 203.452C259.555 201.983 260.013 201.245 260.161 200.927Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M260.161 200.927C260.205 200.868 260.352 200.824 260.419 200.854C260.751 201.164 261.829 201.946 262.722 202.5C262.766 202.559 262.648 202.78 262.574 202.795C261.164 202.418 260.323 202.736 259.216 204.227L258.492 205.194L265.652 210.53C266.796 211.379 267.379 211.505 268.28 210.98C268.331 210.973 268.494 211.143 268.479 211.195C268.103 211.637 267.667 212.191 267.21 212.811C266.745 213.431 266.339 214.007 266.021 214.494C265.977 214.523 265.763 214.413 265.755 214.361C265.992 213.35 265.711 212.818 264.567 211.97L257.407 206.633L256.684 207.6C255.577 209.091 255.511 209.984 256.271 211.231C256.286 211.305 256.101 211.49 256.035 211.46C255.252 210.766 254.189 209.955 253.798 209.726C253.754 209.667 253.754 209.512 253.798 209.453C254.064 209.224 254.64 208.567 255.732 207.098L258.448 203.452C259.555 201.983 260.013 201.245 260.161 200.927Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M275.512 199.731C275.564 199.717 275.741 199.872 275.733 199.923C275.408 200.403 275.032 200.994 274.641 201.665C274.242 202.33 273.903 202.942 273.637 203.459C273.593 203.496 273.371 203.407 273.364 203.356C273.497 202.322 273.157 201.828 271.932 201.104L265.606 197.347C264.381 196.617 263.791 196.558 262.942 197.17C262.89 197.185 262.713 197.03 262.72 196.978C263.045 196.499 263.422 195.908 263.813 195.236C264.211 194.572 264.551 193.96 264.817 193.443C264.861 193.406 265.082 193.494 265.09 193.546C264.957 194.58 265.296 195.074 266.522 195.797L272.847 199.554C274.073 200.278 274.663 200.337 275.512 199.731Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M275.512 199.731C275.564 199.717 275.741 199.872 275.733 199.923C275.408 200.403 275.032 200.994 274.641 201.665C274.242 202.33 273.903 202.942 273.637 203.459C273.593 203.496 273.371 203.407 273.364 203.356C273.497 202.322 273.157 201.828 271.932 201.104L265.606 197.347C264.381 196.617 263.791 196.558 262.942 197.17C262.89 197.185 262.713 197.03 262.72 196.978C263.045 196.499 263.422 195.908 263.813 195.236C264.211 194.572 264.551 193.96 264.817 193.443C264.861 193.406 265.082 193.494 265.09 193.546C264.957 194.58 265.296 195.074 266.522 195.797L272.847 199.554C274.073 200.278 274.663 200.337 275.512 199.731Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M277.085 182.947C273.852 181.478 271.438 181.988 270.339 184.416C269.239 186.83 270.412 188.963 273.645 190.432C276.878 191.9 279.292 191.391 280.392 188.963C281.491 186.549 280.318 184.416 277.085 182.947ZM272.855 192.255C269.342 190.66 267.903 187.206 269.379 183.958C270.87 180.674 274.346 179.522 277.875 181.124C281.388 182.718 282.827 186.173 281.351 189.42C279.86 192.705 276.384 193.856 272.855 192.255Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M277.085 182.947C273.852 181.478 271.438 181.988 270.339 184.416C269.239 186.83 270.412 188.963 273.645 190.432C276.878 191.9 279.292 191.391 280.392 188.963C281.491 186.549 280.318 184.416 277.085 182.947ZM272.855 192.255C269.342 190.66 267.903 187.206 269.379 183.958C270.87 180.674 274.346 179.522 277.875 181.124C281.388 182.718 282.827 186.173 281.351 189.42C279.86 192.705 276.384 193.856 272.855 192.255Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M288.748 168.082L276.798 173.226L283.374 175.145C285.02 175.625 285.692 175.581 286.43 174.784C286.474 174.762 286.688 174.858 286.696 174.917C286.563 175.308 286.349 175.98 286.179 176.548C286.009 177.116 285.832 177.803 285.736 178.201C285.707 178.246 285.471 178.216 285.441 178.172C285.249 177.101 284.71 176.695 283.064 176.216L276.473 174.289C275.159 173.905 274.495 173.994 273.86 174.673C273.816 174.695 273.602 174.599 273.594 174.54C273.735 174.127 273.941 173.492 274.111 172.909C274.31 172.237 274.406 171.831 274.517 171.322C274.547 171.278 274.694 171.226 274.768 171.241C275.292 171.617 275.92 171.617 276.909 171.189L285.22 167.683L279.337 165.963C277.691 165.484 277.019 165.528 276.281 166.325C276.237 166.347 276.023 166.251 276.015 166.192C276.148 165.801 276.362 165.129 276.532 164.561C276.702 163.993 276.879 163.314 276.982 162.908C277.012 162.863 277.248 162.893 277.27 162.937C277.462 164.007 278.001 164.406 279.647 164.893L288.785 167.565C288.844 167.624 288.814 168.03 288.748 168.082Z",
        fill: "#05002F"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M288.748 168.082L276.798 173.226L283.374 175.145C285.02 175.625 285.692 175.581 286.43 174.784C286.474 174.762 286.688 174.858 286.696 174.917C286.563 175.308 286.349 175.98 286.179 176.548C286.009 177.116 285.832 177.803 285.736 178.201C285.707 178.246 285.471 178.216 285.441 178.172C285.249 177.101 284.71 176.695 283.064 176.216L276.473 174.289C275.159 173.905 274.495 173.994 273.86 174.673C273.816 174.695 273.602 174.599 273.594 174.54C273.735 174.127 273.941 173.492 274.111 172.909C274.31 172.237 274.406 171.831 274.517 171.322C274.547 171.278 274.694 171.226 274.768 171.241C275.292 171.617 275.92 171.617 276.909 171.189L285.22 167.683L279.337 165.963C277.691 165.484 277.019 165.528 276.281 166.325C276.237 166.347 276.023 166.251 276.015 166.192C276.148 165.801 276.362 165.129 276.532 164.561C276.702 163.993 276.879 163.314 276.982 162.908C277.012 162.863 277.248 162.893 277.27 162.937C277.462 164.007 278.001 164.406 279.647 164.893L288.785 167.565C288.844 167.624 288.814 168.03 288.748 168.082Z",
        fill: "#05002F"
    })), $0422a6ce4ea03acc$var$MU = ({ title: r, titleId: a, ...o })=>/* @__PURE__ */ $acw62.createElement("svg", {
        viewBox: "0 0 327 266",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": a,
        ...o
    }, r ? /* @__PURE__ */ $acw62.createElement("title", {
        id: a
    }, r) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M23.5527 154.725C22.5563 154.666 20.0984 154.607 18.2236 154.607C16.3488 154.607 13.8909 154.666 12.8944 154.725C12.8354 154.725 12.7763 154.548 12.8354 154.489C14.9464 153.67 15.8247 152.503 15.8247 147.595V116.528H12.3113C6.56888 116.528 4.17003 117.812 2.23619 123.068C2.17715 123.127 2 123.068 2 123.009C2.23619 119.621 2.23619 115.886 2.11809 113.841C2.11809 113.723 2.17714 113.664 2.29524 113.664C3.46883 113.723 7.68341 113.782 10.4366 113.782H26.018C28.7711 113.782 32.9857 113.723 34.1593 113.664C34.2774 113.664 34.3364 113.723 34.3364 113.841C34.2183 115.886 34.2183 119.621 34.4545 123.009C34.4545 123.068 34.2774 123.127 34.2183 123.068C32.2845 117.812 29.8857 116.528 24.1432 116.528H20.6298V147.595C20.6298 152.503 21.5081 153.67 23.6191 154.489C23.6708 154.548 23.6118 154.725 23.5527 154.725Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M23.5527 154.725C22.5563 154.666 20.0984 154.607 18.2236 154.607C16.3488 154.607 13.8909 154.666 12.8944 154.725C12.8354 154.725 12.7763 154.548 12.8354 154.489C14.9464 153.67 15.8247 152.503 15.8247 147.595V116.528H12.3113C6.56888 116.528 4.17003 117.812 2.23619 123.068C2.17715 123.127 2 123.068 2 123.009C2.23619 119.621 2.23619 115.886 2.11809 113.841C2.11809 113.723 2.17714 113.664 2.29524 113.664C3.46883 113.723 7.68341 113.782 10.4366 113.782H26.018C28.7711 113.782 32.9857 113.723 34.1593 113.664C34.2774 113.664 34.3364 113.723 34.3364 113.841C34.2183 115.886 34.2183 119.621 34.4545 123.009C34.4545 123.068 34.2774 123.127 34.2183 123.068C32.2845 117.812 29.8857 116.528 24.1432 116.528H20.6298V147.595C20.6298 152.503 21.5081 153.67 23.6191 154.489C23.6708 154.548 23.6118 154.725 23.5527 154.725Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M53.2464 116.536H45.9835V133.298H53.2464C59.7491 133.298 62.613 130.73 62.613 124.891C62.6204 119.046 59.7491 116.536 53.2464 116.536ZM58.5165 135.395L64.9011 147.249C66.835 150.865 68.6507 152.445 70.8134 152.445C71.3374 152.445 71.9869 152.268 71.9869 152.268C72.046 152.268 72.1641 152.445 72.1641 152.504C71.5219 153.847 69.8243 155.073 67.5952 155.073C64.4287 155.073 62.613 153.434 60.2732 149.057L53.3645 136.037H45.9835V147.596C45.9835 152.504 46.8618 153.67 48.9728 154.49C49.0318 154.549 48.9728 154.726 48.9137 154.726C47.9173 154.667 45.4594 154.608 43.5846 154.608C41.7098 154.608 39.4291 154.667 38.4326 154.726C38.3736 154.726 38.3145 154.549 38.3736 154.49C40.3074 153.67 41.1858 152.622 41.1858 147.891V120.559C41.1858 115.827 40.3074 114.779 38.3736 113.96C38.3145 113.901 38.3736 113.724 38.4326 113.724C38.4326 113.724 40.1893 113.783 44.5811 113.783H53.3055C62.6204 113.783 67.6543 117.348 67.6543 124.707C67.6543 130.722 64.4361 134.288 58.5165 135.395Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M53.2464 116.536H45.9835V133.298H53.2464C59.7491 133.298 62.613 130.73 62.613 124.891C62.6204 119.046 59.7491 116.536 53.2464 116.536ZM58.5165 135.395L64.9011 147.249C66.835 150.865 68.6507 152.445 70.8134 152.445C71.3374 152.445 71.9869 152.268 71.9869 152.268C72.046 152.268 72.1641 152.445 72.1641 152.504C71.5219 153.847 69.8243 155.073 67.5952 155.073C64.4287 155.073 62.613 153.434 60.2732 149.057L53.3645 136.037H45.9835V147.596C45.9835 152.504 46.8618 153.67 48.9728 154.49C49.0318 154.549 48.9728 154.726 48.9137 154.726C47.9173 154.667 45.4594 154.608 43.5846 154.608C41.7098 154.608 39.4291 154.667 38.4326 154.726C38.3736 154.726 38.3145 154.549 38.3736 154.49C40.3074 153.67 41.1858 152.622 41.1858 147.891V120.559C41.1858 115.827 40.3074 114.779 38.3736 113.96C38.3145 113.901 38.3736 113.724 38.4326 113.724C38.4326 113.724 40.1893 113.783 44.5811 113.783H53.3055C62.6204 113.783 67.6543 117.348 67.6543 124.707C67.6543 130.722 64.4361 134.288 58.5165 135.395Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M106.139 154.784C104.965 154.725 100.751 154.666 97.9975 154.666H82.5933C78.2015 154.666 76.4448 154.725 76.4448 154.725C76.3858 154.725 76.3267 154.548 76.3858 154.489C78.3196 153.67 79.198 152.622 79.198 147.89V120.558C79.198 115.827 78.3196 114.779 76.3858 113.96C76.3267 113.9 76.3858 113.723 76.4448 113.723C76.4448 113.723 78.2015 113.782 82.5933 113.782H96.4697C99.2228 113.782 103.437 113.723 104.611 113.664C104.729 113.664 104.788 113.723 104.788 113.841C104.67 115.709 104.67 119.038 104.906 122.189C104.906 122.248 104.729 122.308 104.67 122.248C102.795 117.635 99.8649 116.528 94.5949 116.528H83.9957V132.235H91.4948C97.0011 132.235 98.8168 131.298 100.101 128.382C100.16 128.323 100.337 128.382 100.337 128.441C100.219 129.489 100.16 131.711 100.16 133.578C100.16 135.446 100.219 137.668 100.337 138.716C100.337 138.775 100.16 138.834 100.101 138.775C98.8095 135.852 96.9937 134.922 91.4948 134.922H83.9957V151.913H95.5323C101.858 151.913 104.257 150.857 106.191 145.602C106.25 145.543 106.427 145.602 106.427 145.661C106.191 149.049 106.191 152.555 106.309 154.6C106.309 154.725 106.25 154.784 106.139 154.784Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M106.139 154.784C104.965 154.725 100.751 154.666 97.9975 154.666H82.5933C78.2015 154.666 76.4448 154.725 76.4448 154.725C76.3858 154.725 76.3267 154.548 76.3858 154.489C78.3196 153.67 79.198 152.622 79.198 147.89V120.558C79.198 115.827 78.3196 114.779 76.3858 113.96C76.3267 113.9 76.3858 113.723 76.4448 113.723C76.4448 113.723 78.2015 113.782 82.5933 113.782H96.4697C99.2228 113.782 103.437 113.723 104.611 113.664C104.729 113.664 104.788 113.723 104.788 113.841C104.67 115.709 104.67 119.038 104.906 122.189C104.906 122.248 104.729 122.308 104.67 122.248C102.795 117.635 99.8649 116.528 94.5949 116.528H83.9957V132.235H91.4948C97.0011 132.235 98.8168 131.298 100.101 128.382C100.16 128.323 100.337 128.382 100.337 128.441C100.219 129.489 100.16 131.711 100.16 133.578C100.16 135.446 100.219 137.668 100.337 138.716C100.337 138.775 100.16 138.834 100.101 138.775C98.8095 135.852 96.9937 134.922 91.4948 134.922H83.9957V151.913H95.5323C101.858 151.913 104.257 150.857 106.191 145.602C106.25 145.543 106.427 145.602 106.427 145.661C106.191 149.049 106.191 152.555 106.309 154.6C106.309 154.725 106.25 154.784 106.139 154.784Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M135.126 139.661L127.863 121.969L120.6 139.661H135.126ZM137.296 154.726C137.237 154.667 137.237 154.438 137.237 154.438C139.754 153.501 140.337 152.216 138.056 146.732L136.3 142.466H119.493L117.972 146.142C115.751 151.515 115.802 153.146 119.146 154.438C119.146 154.438 119.146 154.674 119.087 154.726C118.031 154.667 115.92 154.608 113.935 154.608C112.178 154.608 110.008 154.667 108.783 154.726C108.724 154.667 108.724 154.438 108.724 154.438C111.359 153.213 112.532 151.515 114.754 146.142L128.638 112.388C128.697 112.329 128.933 112.329 128.992 112.388L143.223 146.725C145.511 152.275 146.33 153.264 148.375 154.431C148.375 154.431 148.375 154.667 148.316 154.718C147.024 154.659 145.208 154.6 142.751 154.6C140.344 154.608 138.411 154.667 137.296 154.726Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M135.126 139.661L127.863 121.969L120.6 139.661H135.126ZM137.296 154.726C137.237 154.667 137.237 154.438 137.237 154.438C139.754 153.501 140.337 152.216 138.056 146.732L136.3 142.466H119.493L117.972 146.142C115.751 151.515 115.802 153.146 119.146 154.438C119.146 154.438 119.146 154.674 119.087 154.726C118.031 154.667 115.92 154.608 113.935 154.608C112.178 154.608 110.008 154.667 108.783 154.726C108.724 154.667 108.724 154.438 108.724 154.438C111.359 153.213 112.532 151.515 114.754 146.142L128.638 112.388C128.697 112.329 128.933 112.329 128.992 112.388L143.223 146.725C145.511 152.275 146.33 153.264 148.375 154.431C148.375 154.431 148.375 154.667 148.316 154.718C147.024 154.659 145.208 154.6 142.751 154.6C140.344 154.608 138.411 154.667 137.296 154.726Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M172.141 114.491C172.783 114.491 173.426 114.255 173.78 114.026C173.839 114.026 174.016 114.085 174.016 114.144C174.016 117.126 174.252 120.042 174.717 123.024C174.717 123.083 174.54 123.142 174.481 123.083C171.787 118.064 167.801 115.665 163.528 115.665C159.372 115.665 156.501 118.233 156.501 122.086C156.501 126.699 159.719 127.984 166.104 130.966C171.256 133.357 177.234 136.339 177.234 143.462C177.234 150.703 172.2 155.552 164.347 155.552C158.198 155.552 154.449 152.747 152.515 152.747C151.991 152.747 151.46 152.924 151.113 153.153C151.054 153.153 150.876 153.094 150.935 153.035C151.467 150.171 151.755 147.079 152.05 143.167C152.05 143.108 152.286 143.108 152.286 143.108C153.984 148.828 157.615 152.799 164.524 152.799C170.089 152.799 172.961 149.529 172.961 144.975C172.961 140.244 170.266 138.664 163.587 135.571C158.376 133.18 152.227 130.604 152.227 123.658C152.227 117.119 157.32 112.912 163.646 112.912C167.462 112.912 169.979 114.491 172.141 114.491Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M172.141 114.491C172.783 114.491 173.426 114.255 173.78 114.026C173.839 114.026 174.016 114.085 174.016 114.144C174.016 117.126 174.252 120.042 174.717 123.024C174.717 123.083 174.54 123.142 174.481 123.083C171.787 118.064 167.801 115.665 163.528 115.665C159.372 115.665 156.501 118.233 156.501 122.086C156.501 126.699 159.719 127.984 166.104 130.966C171.256 133.357 177.234 136.339 177.234 143.462C177.234 150.703 172.2 155.552 164.347 155.552C158.198 155.552 154.449 152.747 152.515 152.747C151.991 152.747 151.46 152.924 151.113 153.153C151.054 153.153 150.876 153.094 150.935 153.035C151.467 150.171 151.755 147.079 152.05 143.167C152.05 143.108 152.286 143.108 152.286 143.108C153.984 148.828 157.615 152.799 164.524 152.799C170.089 152.799 172.961 149.529 172.961 144.975C172.961 140.244 170.266 138.664 163.587 135.571C158.376 133.18 152.227 130.604 152.227 123.658C152.227 117.119 157.32 112.912 163.646 112.912C167.462 112.912 169.979 114.491 172.141 114.491Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M185.444 139.366V120.559C185.444 115.827 184.566 114.779 182.632 113.96C182.573 113.901 182.632 113.724 182.691 113.724C183.687 113.783 185.968 113.842 187.843 113.842C189.718 113.842 191.998 113.783 192.995 113.724C193.054 113.724 193.113 113.901 193.054 113.96C191.12 114.779 190.242 115.827 190.242 120.559V139.476C190.242 148.644 194.279 152.15 201.66 152.15C208.746 152.15 212.791 148.12 212.791 139.07V121.843C212.791 116.824 212.031 114.957 209.396 113.96C209.337 113.901 209.396 113.724 209.455 113.724C210.51 113.783 212.326 113.842 214.319 113.842C216.371 113.842 218.186 113.783 219.183 113.724C219.242 113.724 219.301 113.901 219.242 113.96C216.607 114.957 215.847 116.824 215.847 121.843V139.248C215.847 150.578 209.816 155.538 200.797 155.538C191.474 155.545 185.444 150.578 185.444 139.366Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M185.444 139.366V120.559C185.444 115.827 184.566 114.779 182.632 113.96C182.573 113.901 182.632 113.724 182.691 113.724C183.687 113.783 185.968 113.842 187.843 113.842C189.718 113.842 191.998 113.783 192.995 113.724C193.054 113.724 193.113 113.901 193.054 113.96C191.12 114.779 190.242 115.827 190.242 120.559V139.476C190.242 148.644 194.279 152.15 201.66 152.15C208.746 152.15 212.791 148.12 212.791 139.07V121.843C212.791 116.824 212.031 114.957 209.396 113.96C209.337 113.901 209.396 113.724 209.455 113.724C210.51 113.783 212.326 113.842 214.319 113.842C216.371 113.842 218.186 113.783 219.183 113.724C219.242 113.724 219.301 113.901 219.242 113.96C216.607 114.957 215.847 116.824 215.847 121.843V139.248C215.847 150.578 209.816 155.538 200.797 155.538C191.474 155.545 185.444 150.578 185.444 139.366Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M240.379 116.536H233.116V133.298H240.379C246.881 133.298 249.752 130.73 249.752 124.891C249.745 119.046 246.874 116.536 240.379 116.536ZM245.649 135.395L252.033 147.249C253.967 150.865 255.783 152.445 257.945 152.445C258.47 152.445 259.119 152.268 259.119 152.268C259.178 152.268 259.296 152.445 259.296 152.504C258.654 153.847 256.956 155.073 254.727 155.073C251.561 155.073 249.752 153.434 247.405 149.057L240.497 136.037H233.116V147.596C233.116 152.504 233.994 153.67 236.105 154.49C236.164 154.549 236.105 154.726 236.046 154.726C235.049 154.667 232.591 154.608 230.717 154.608C228.842 154.608 226.561 154.667 225.565 154.726C225.506 154.726 225.447 154.549 225.506 154.49C227.439 153.67 228.318 152.622 228.318 147.891V120.559C228.318 115.827 227.439 114.779 225.506 113.96C225.447 113.901 225.506 113.724 225.565 113.724C225.565 113.724 227.321 113.783 231.713 113.783H240.438C249.752 113.783 254.786 117.348 254.786 124.707C254.786 130.722 251.561 134.288 245.649 135.395Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M240.379 116.536H233.116V133.298H240.379C246.881 133.298 249.752 130.73 249.752 124.891C249.745 119.046 246.874 116.536 240.379 116.536ZM245.649 135.395L252.033 147.249C253.967 150.865 255.783 152.445 257.945 152.445C258.47 152.445 259.119 152.268 259.119 152.268C259.178 152.268 259.296 152.445 259.296 152.504C258.654 153.847 256.956 155.073 254.727 155.073C251.561 155.073 249.752 153.434 247.405 149.057L240.497 136.037H233.116V147.596C233.116 152.504 233.994 153.67 236.105 154.49C236.164 154.549 236.105 154.726 236.046 154.726C235.049 154.667 232.591 154.608 230.717 154.608C228.842 154.608 226.561 154.667 225.565 154.726C225.506 154.726 225.447 154.549 225.506 154.49C227.439 153.67 228.318 152.622 228.318 147.891V120.559C228.318 115.827 227.439 114.779 225.506 113.96C225.447 113.901 225.506 113.724 225.565 113.724C225.565 113.724 227.321 113.783 231.713 113.783H240.438C249.752 113.783 254.786 117.348 254.786 124.707C254.786 130.722 251.561 134.288 245.649 135.395Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M293.728 154.784C292.554 154.725 288.34 154.666 285.586 154.666H270.182C265.79 154.666 264.034 154.725 264.034 154.725C263.975 154.725 263.916 154.548 263.975 154.489C265.908 153.67 266.787 152.622 266.787 147.89V120.558C266.787 115.827 265.908 114.779 263.975 113.96C263.916 113.9 263.975 113.723 264.034 113.723C264.034 113.723 265.79 113.782 270.182 113.782H284.066C286.819 113.782 291.034 113.723 292.207 113.664C292.325 113.664 292.384 113.723 292.384 113.841C292.266 115.709 292.266 119.038 292.502 122.189C292.502 122.248 292.325 122.308 292.266 122.248C290.391 117.635 287.461 116.528 282.191 116.528H271.592V132.235H279.091C284.597 132.235 286.413 131.298 287.697 128.382C287.756 128.323 287.934 128.382 287.934 128.441C287.815 129.489 287.756 131.711 287.756 133.578C287.756 135.446 287.815 137.668 287.934 138.716C287.934 138.775 287.756 138.834 287.697 138.775C286.406 135.852 284.59 134.922 279.091 134.922H271.592V151.913H283.129C289.454 151.913 291.853 150.857 293.787 145.602C293.846 145.543 294.023 145.602 294.023 145.661C293.787 149.049 293.787 152.555 293.905 154.6C293.905 154.725 293.846 154.784 293.728 154.784Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M293.728 154.784C292.554 154.725 288.34 154.666 285.586 154.666H270.182C265.79 154.666 264.034 154.725 264.034 154.725C263.975 154.725 263.916 154.548 263.975 154.489C265.908 153.67 266.787 152.622 266.787 147.89V120.558C266.787 115.827 265.908 114.779 263.975 113.96C263.916 113.9 263.975 113.723 264.034 113.723C264.034 113.723 265.79 113.782 270.182 113.782H284.066C286.819 113.782 291.034 113.723 292.207 113.664C292.325 113.664 292.384 113.723 292.384 113.841C292.266 115.709 292.266 119.038 292.502 122.189C292.502 122.248 292.325 122.308 292.266 122.248C290.391 117.635 287.461 116.528 282.191 116.528H271.592V132.235H279.091C284.597 132.235 286.413 131.298 287.697 128.382C287.756 128.323 287.934 128.382 287.934 128.441C287.815 129.489 287.756 131.711 287.756 133.578C287.756 135.446 287.815 137.668 287.934 138.716C287.934 138.775 287.756 138.834 287.697 138.775C286.406 135.852 284.59 134.922 279.091 134.922H271.592V151.913H283.129C289.454 151.913 291.853 150.857 293.787 145.602C293.846 145.543 294.023 145.602 294.023 145.661C293.787 149.049 293.787 152.555 293.905 154.6C293.905 154.725 293.846 154.784 293.728 154.784Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M320.907 114.491C321.549 114.491 322.191 114.255 322.546 114.026C322.605 114.026 322.782 114.085 322.782 114.144C322.782 117.126 323.018 120.042 323.483 123.024C323.483 123.083 323.306 123.142 323.247 123.083C320.553 118.064 316.567 115.665 312.293 115.665C308.138 115.665 305.267 118.233 305.267 122.086C305.267 126.699 308.485 127.984 314.869 130.966C320.021 133.357 326 136.339 326 143.462C326 150.703 320.966 155.552 313.113 155.552C306.964 155.552 303.215 152.747 301.281 152.747C300.757 152.747 300.225 152.924 299.878 153.153C299.819 153.153 299.642 153.094 299.701 153.035C300.225 150.171 300.521 147.079 300.816 143.167C300.816 143.108 301.052 143.108 301.052 143.108C302.75 148.828 306.381 152.799 313.29 152.799C318.855 152.799 321.726 149.529 321.726 144.975C321.726 140.244 319.032 138.664 312.352 135.571C307.141 133.18 300.993 130.604 300.993 123.658C300.993 117.119 306.086 112.912 312.412 112.912C316.22 112.912 318.744 114.491 320.907 114.491Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M320.907 114.491C321.549 114.491 322.191 114.255 322.546 114.026C322.605 114.026 322.782 114.085 322.782 114.144C322.782 117.126 323.018 120.042 323.483 123.024C323.483 123.083 323.306 123.142 323.247 123.083C320.553 118.064 316.567 115.665 312.293 115.665C308.138 115.665 305.267 118.233 305.267 122.086C305.267 126.699 308.485 127.984 314.869 130.966C320.021 133.357 326 136.339 326 143.462C326 150.703 320.966 155.552 313.113 155.552C306.964 155.552 303.215 152.747 301.281 152.747C300.757 152.747 300.225 152.924 299.878 153.153C299.819 153.153 299.642 153.094 299.701 153.035C300.225 150.171 300.521 147.079 300.816 143.167C300.816 143.108 301.052 143.108 301.052 143.108C302.75 148.828 306.381 152.799 313.29 152.799C318.855 152.799 321.726 149.529 321.726 144.975C321.726 140.244 319.032 138.664 312.352 135.571C307.141 133.18 300.993 130.604 300.993 123.658C300.993 117.119 306.086 112.912 312.412 112.912C316.22 112.912 318.744 114.491 320.907 114.491Z",
        fill: "#D3BA81"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M45.5654 90.5545C45.5875 90.4881 45.7056 90.3848 45.7794 90.3848C46.2001 90.5545 47.4918 90.8793 48.5252 91.0638C48.5916 91.1007 48.5621 91.3517 48.4957 91.3886C47.049 91.5584 46.3847 92.1636 45.9049 93.9572L45.5949 95.1234L54.216 97.4337C55.5889 97.8027 56.1793 97.6994 56.8289 96.8801C56.8732 96.858 57.0872 96.9465 57.0946 97.0056C56.9101 97.5518 56.7108 98.2308 56.5115 98.9763C56.3122 99.7292 56.1498 100.408 56.0317 100.977C56.0022 101.028 55.766 100.999 55.7365 100.954C55.5815 99.9285 55.1239 99.5447 53.751 99.1756L45.1299 96.8653L44.8199 98.0316C44.3401 99.8252 44.6132 100.681 45.7794 101.552C45.8163 101.619 45.7204 101.855 45.6466 101.848C44.6575 101.493 43.3806 101.124 42.9303 101.065C42.8639 101.028 42.8122 100.881 42.827 100.814C42.982 100.504 43.2772 99.6849 43.757 97.9061L44.9306 93.5143C45.3956 91.7576 45.5432 90.9088 45.5654 90.5545Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M45.5654 90.5545C45.5875 90.4881 45.7056 90.3848 45.7794 90.3848C46.2001 90.5545 47.4918 90.8793 48.5252 91.0638C48.5916 91.1007 48.5621 91.3517 48.4957 91.3886C47.049 91.5584 46.3847 92.1636 45.9049 93.9572L45.5949 95.1234L54.216 97.4337C55.5889 97.8027 56.1793 97.6994 56.8289 96.8801C56.8732 96.858 57.0872 96.9465 57.0946 97.0056C56.9101 97.5518 56.7108 98.2308 56.5115 98.9763C56.3122 99.7292 56.1498 100.408 56.0317 100.977C56.0022 101.028 55.766 100.999 55.7365 100.954C55.5815 99.9285 55.1239 99.5447 53.751 99.1756L45.1299 96.8653L44.8199 98.0316C44.3401 99.8252 44.6132 100.681 45.7794 101.552C45.8163 101.619 45.7204 101.855 45.6466 101.848C44.6575 101.493 43.3806 101.124 42.9303 101.065C42.8639 101.028 42.8122 100.881 42.827 100.814C42.982 100.504 43.2772 99.6849 43.757 97.9061L44.9306 93.5143C45.3956 91.7576 45.5432 90.9088 45.5654 90.5545Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M54.1178 87.1002L57.1809 88.3254C58.4504 88.8347 59.0409 88.8199 59.72 88.1409C59.7643 88.1187 59.9709 88.2442 59.9709 88.2959C59.7274 88.7978 59.469 89.4104 59.1885 90.0969C58.9154 90.7833 58.6866 91.4107 58.5095 91.9421C58.4726 91.9864 58.2438 91.9347 58.2216 91.8831C58.1995 90.9235 57.7861 90.5028 56.5092 89.9935L49.512 87.1961C48.2424 86.6868 47.6519 86.7016 46.9729 87.3806C46.9286 87.4028 46.7219 87.2773 46.7219 87.2256C46.9655 86.7237 47.2238 86.1111 47.5043 85.4246C47.7774 84.7382 48.0062 84.1108 48.1834 83.5794C48.2203 83.5351 48.4491 83.5868 48.4712 83.6384C48.4934 84.598 48.9067 85.0187 50.1836 85.528L53.1287 86.7089L55.6087 80.5015L52.6637 79.3205C51.3941 78.8112 50.8037 78.826 50.1246 79.505C50.0803 79.5272 49.8736 79.4017 49.8736 79.35C50.1172 78.8481 50.3756 78.2281 50.656 77.5491C50.9291 76.8626 51.1579 76.2352 51.3351 75.7038C51.372 75.6595 51.6008 75.7112 51.623 75.7628C51.6451 76.7224 52.0584 77.1431 53.3354 77.6524L60.3326 80.4498C61.6022 80.9591 62.1926 80.9443 62.8717 80.2579C62.916 80.2358 63.1226 80.3612 63.1226 80.4129C62.8791 80.9148 62.6207 81.5274 62.3403 82.2139C62.0672 82.9003 61.8383 83.5277 61.6612 84.0591C61.6243 84.1034 61.3955 84.0518 61.3733 84.0001C61.3512 83.0406 60.9379 82.6198 59.6609 82.1106L56.5978 80.8853L54.1178 87.1002Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M54.1178 87.1002L57.1809 88.3254C58.4504 88.8347 59.0409 88.8199 59.72 88.1409C59.7643 88.1187 59.9709 88.2442 59.9709 88.2959C59.7274 88.7978 59.469 89.4104 59.1885 90.0969C58.9154 90.7833 58.6866 91.4107 58.5095 91.9421C58.4726 91.9864 58.2438 91.9347 58.2216 91.8831C58.1995 90.9235 57.7861 90.5028 56.5092 89.9935L49.512 87.1961C48.2424 86.6868 47.6519 86.7016 46.9729 87.3806C46.9286 87.4028 46.7219 87.2773 46.7219 87.2256C46.9655 86.7237 47.2238 86.1111 47.5043 85.4246C47.7774 84.7382 48.0062 84.1108 48.1834 83.5794C48.2203 83.5351 48.4491 83.5868 48.4712 83.6384C48.4934 84.598 48.9067 85.0187 50.1836 85.528L53.1287 86.7089L55.6087 80.5015L52.6637 79.3205C51.3941 78.8112 50.8037 78.826 50.1246 79.505C50.0803 79.5272 49.8736 79.4017 49.8736 79.35C50.1172 78.8481 50.3756 78.2281 50.656 77.5491C50.9291 76.8626 51.1579 76.2352 51.3351 75.7038C51.372 75.6595 51.6008 75.7112 51.623 75.7628C51.6451 76.7224 52.0584 77.1431 53.3354 77.6524L60.3326 80.4498C61.6022 80.9591 62.1926 80.9443 62.8717 80.2579C62.916 80.2358 63.1226 80.3612 63.1226 80.4129C62.8791 80.9148 62.6207 81.5274 62.3403 82.2139C62.0672 82.9003 61.8383 83.5277 61.6612 84.0591C61.6243 84.1034 61.3955 84.0518 61.3733 84.0001C61.3512 83.0406 60.9379 82.6198 59.6609 82.1106L56.5978 80.8853L54.1178 87.1002Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M64.3914 77.9182C64.3471 77.9551 64.1257 77.8739 64.1109 77.8296C64.1774 76.8774 63.7935 76.3829 62.4502 75.6448L56.3903 72.3307C54.9067 71.5188 54.2351 71.4598 53.4822 72.0133C53.4305 72.0281 53.246 71.8805 53.2534 71.8288C53.5117 71.3933 53.9029 70.7216 54.2351 70.109L56.2058 66.4997C57.0842 64.8906 57.4385 64.0934 57.5418 63.7613C57.5787 63.6949 57.7189 63.6284 57.7854 63.6506C58.1544 63.9163 59.0992 64.4108 60.0587 64.8316C60.1104 64.8832 60.0218 65.1194 59.948 65.1416C58.6932 64.994 57.9846 65.4663 57.1432 67.0016L55.5858 69.8507L59.6823 72.0945L60.7378 70.1607C61.2987 69.1347 61.4095 68.3745 60.8485 67.5921C60.819 67.533 60.9814 67.3116 61.033 67.3264C61.343 67.5183 61.9999 67.8947 62.4354 68.1383C62.8783 68.3819 63.55 68.7288 63.8747 68.8838C63.9116 68.928 63.8157 69.179 63.7493 69.1864C62.7897 69.1347 62.2066 69.6366 61.6457 70.67L60.5902 72.5964L64.7826 74.892L66.436 71.8731C67.3365 70.2271 67.3069 69.4152 66.3105 68.2342C66.2883 68.1604 66.4433 67.9538 66.5098 67.9759C67.4693 68.5811 68.4584 69.1052 68.9308 69.2971C68.9972 69.334 69.0267 69.4964 68.9972 69.5554C68.8201 69.8064 68.4805 70.3452 67.3881 72.3529L65.2993 76.1836C64.9745 76.7815 64.6202 77.4679 64.3914 77.9182Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M64.3914 77.9182C64.3471 77.9551 64.1257 77.8739 64.1109 77.8296C64.1774 76.8774 63.7935 76.3829 62.4502 75.6448L56.3903 72.3307C54.9067 71.5188 54.2351 71.4598 53.4822 72.0133C53.4305 72.0281 53.246 71.8805 53.2534 71.8288C53.5117 71.3933 53.9029 70.7216 54.2351 70.109L56.2058 66.4997C57.0842 64.8906 57.4385 64.0934 57.5418 63.7613C57.5787 63.6949 57.7189 63.6284 57.7854 63.6506C58.1544 63.9163 59.0992 64.4108 60.0587 64.8316C60.1104 64.8832 60.0218 65.1194 59.948 65.1416C58.6932 64.994 57.9846 65.4663 57.1432 67.0016L55.5858 69.8507L59.6823 72.0945L60.7378 70.1607C61.2987 69.1347 61.4095 68.3745 60.8485 67.5921C60.819 67.533 60.9814 67.3116 61.033 67.3264C61.343 67.5183 61.9999 67.8947 62.4354 68.1383C62.8783 68.3819 63.55 68.7288 63.8747 68.8838C63.9116 68.928 63.8157 69.179 63.7493 69.1864C62.7897 69.1347 62.2066 69.6366 61.6457 70.67L60.5902 72.5964L64.7826 74.892L66.436 71.8731C67.3365 70.2271 67.3069 69.4152 66.3105 68.2342C66.2883 68.1604 66.4433 67.9538 66.5098 67.9759C67.4693 68.5811 68.4584 69.1052 68.9308 69.2971C68.9972 69.334 69.0267 69.4964 68.9972 69.5554C68.8201 69.8064 68.4805 70.3452 67.3881 72.3529L65.2993 76.1836C64.9745 76.7815 64.6202 77.4679 64.3914 77.9182Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M79.8315 54.5276L66.8261 54.8819L72.2216 59.1038C73.5724 60.1593 74.2145 60.3586 75.1962 59.8936C75.2479 59.8862 75.4103 60.056 75.3881 60.115C75.115 60.4324 74.6722 60.9712 74.3031 61.4436C73.934 61.916 73.5207 62.477 73.2771 62.8165C73.2255 62.846 73.0188 62.7353 73.0188 62.6836C73.2329 61.6134 72.8859 61.0451 71.5352 59.9896L66.1249 55.7602C65.0472 54.9188 64.3977 54.749 63.5563 55.1476C63.5046 55.155 63.3422 54.9778 63.3644 54.9261C63.6448 54.594 64.0729 54.0847 64.4494 53.5976C64.8849 53.044 65.1211 52.7045 65.4163 52.269C65.4606 52.2395 65.6156 52.2468 65.6746 52.2911C66.0216 52.8373 66.6046 53.0661 67.6823 53.0366L76.7019 52.8595L71.8747 49.0877C70.524 48.0322 69.8818 47.8256 68.9002 48.298C68.8485 48.3053 68.6861 48.1282 68.7083 48.0765C68.974 47.7591 69.4242 47.2203 69.7933 46.7479C70.1623 46.2829 70.5757 45.7146 70.8192 45.375C70.8635 45.3455 71.0702 45.4563 71.0776 45.5079C70.8635 46.5782 71.2104 47.1465 72.5612 48.202L80.0603 54.0626C80.0899 54.129 79.9201 54.4981 79.8315 54.5276Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M79.8315 54.5276L66.8261 54.8819L72.2216 59.1038C73.5724 60.1593 74.2145 60.3586 75.1962 59.8936C75.2479 59.8862 75.4103 60.056 75.3881 60.115C75.115 60.4324 74.6722 60.9712 74.3031 61.4436C73.934 61.916 73.5207 62.477 73.2771 62.8165C73.2255 62.846 73.0188 62.7353 73.0188 62.6836C73.2329 61.6134 72.8859 61.0451 71.5352 59.9896L66.1249 55.7602C65.0472 54.9188 64.3977 54.749 63.5563 55.1476C63.5046 55.155 63.3422 54.9778 63.3644 54.9261C63.6448 54.594 64.0729 54.0847 64.4494 53.5976C64.8849 53.044 65.1211 52.7045 65.4163 52.269C65.4606 52.2395 65.6156 52.2468 65.6746 52.2911C66.0216 52.8373 66.6046 53.0661 67.6823 53.0366L76.7019 52.8595L71.8747 49.0877C70.524 48.0322 69.8818 47.8256 68.9002 48.298C68.8485 48.3053 68.6861 48.1282 68.7083 48.0765C68.974 47.7591 69.4242 47.2203 69.7933 46.7479C70.1623 46.2829 70.5757 45.7146 70.8192 45.375C70.8635 45.3455 71.0702 45.4563 71.0776 45.5079C70.8635 46.5782 71.2104 47.1465 72.5612 48.202L80.0603 54.0626C80.0899 54.129 79.9201 54.4981 79.8315 54.5276Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.6099 51.2652C82.5582 51.2947 82.3663 51.1545 82.3663 51.1028C82.6911 50.2097 82.4623 49.6266 81.3699 48.5416L76.4689 43.6848C75.2658 42.4965 74.6384 42.2529 73.76 42.5777C73.7083 42.5777 73.5681 42.3858 73.5902 42.3341C73.9593 41.9872 74.5203 41.4484 75.0148 40.9538L77.9082 38.0309C79.1999 36.7245 79.7608 36.0602 79.9527 35.765C80.0044 35.7133 80.1594 35.6911 80.2184 35.728C80.4989 36.0823 81.2666 36.8204 82.0711 37.4921C82.108 37.5585 81.9604 37.7578 81.8792 37.7578C80.7204 37.2633 79.9011 37.5216 78.6684 38.769L76.3877 41.0719L79.7018 44.3565L81.2518 42.7917C82.0785 41.9577 82.3885 41.2565 82.0711 40.356C82.0563 40.2895 82.2704 40.1272 82.322 40.1493C82.5656 40.415 83.0897 40.9612 83.4513 41.3155C83.813 41.6698 84.3592 42.1939 84.6323 42.4301C84.6618 42.4817 84.4921 42.6958 84.433 42.6884C83.5252 42.371 82.824 42.6958 82.0047 43.5298L80.4546 45.0946L83.8499 48.453L86.2709 46.0099C87.5921 44.6813 87.7914 43.8841 87.1566 42.4743C87.1566 42.4005 87.3559 42.2455 87.4224 42.2824C88.1752 43.1313 88.9871 43.9063 89.3783 44.2236C89.43 44.2753 89.4153 44.4377 89.3636 44.4894C89.12 44.6813 88.655 45.102 87.0385 46.7332L83.968 49.8333C83.4809 50.3352 82.9494 50.8961 82.6099 51.2652Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.6099 51.2652C82.5582 51.2947 82.3663 51.1545 82.3663 51.1028C82.6911 50.2097 82.4623 49.6266 81.3699 48.5416L76.4689 43.6848C75.2658 42.4965 74.6384 42.2529 73.76 42.5777C73.7083 42.5777 73.5681 42.3858 73.5902 42.3341C73.9593 41.9872 74.5203 41.4484 75.0148 40.9538L77.9082 38.0309C79.1999 36.7245 79.7608 36.0602 79.9527 35.765C80.0044 35.7133 80.1594 35.6911 80.2184 35.728C80.4989 36.0823 81.2666 36.8204 82.0711 37.4921C82.108 37.5585 81.9604 37.7578 81.8792 37.7578C80.7204 37.2633 79.9011 37.5216 78.6684 38.769L76.3877 41.0719L79.7018 44.3565L81.2518 42.7917C82.0785 41.9577 82.3885 41.2565 82.0711 40.356C82.0563 40.2895 82.2704 40.1272 82.322 40.1493C82.5656 40.415 83.0897 40.9612 83.4513 41.3155C83.813 41.6698 84.3592 42.1939 84.6323 42.4301C84.6618 42.4817 84.4921 42.6958 84.433 42.6884C83.5252 42.371 82.824 42.6958 82.0047 43.5298L80.4546 45.0946L83.8499 48.453L86.2709 46.0099C87.5921 44.6813 87.7914 43.8841 87.1566 42.4743C87.1566 42.4005 87.3559 42.2455 87.4224 42.2824C88.1752 43.1313 88.9871 43.9063 89.3783 44.2236C89.43 44.2753 89.4153 44.4377 89.3636 44.4894C89.12 44.6813 88.655 45.102 87.0385 46.7332L83.968 49.8333C83.4809 50.3352 82.9494 50.8961 82.6099 51.2652Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.5847 33.543C82.533 33.5357 82.4149 33.329 82.4518 33.2847C82.7766 33.0559 83.4704 32.5687 84.024 32.1333C84.6514 31.6461 85.3305 31.0778 85.6478 30.8121C85.6995 30.7973 85.8767 30.9597 85.8693 31.0113C85.3378 31.6756 85.3083 32.3178 86.7329 33.2404L92.837 37.2041L90.7851 30.3101L90.667 30.2437C89.1169 29.2989 88.6962 29.1735 88.0172 29.3506C87.9655 29.3432 87.8474 29.1366 87.8843 29.0923C88.2091 28.8635 88.9029 28.3763 89.4565 27.9408C90.0839 27.4537 90.7629 26.8853 91.0803 26.6196C91.132 26.5975 91.3091 26.7672 91.3017 26.8189C90.7851 27.4684 90.726 28.1106 92.2022 29.0185L98.4023 32.8418L96.0921 26.1472C95.6344 24.7891 94.9701 24.3684 93.7818 24.8998C93.7301 24.8924 93.6194 24.6858 93.6489 24.6415C94.0032 24.3905 94.7561 23.8296 95.2654 23.431C95.7378 23.0693 96.3209 22.5895 96.6087 22.346C96.6604 22.3238 96.8375 22.4936 96.8302 22.5453C96.4611 23.2169 96.4094 23.8296 96.9852 25.4829L100.454 35.7057C100.447 35.7574 100.137 36.0009 100.07 36.0009L92.1063 31.1294L94.7856 40.0901C94.7782 40.1417 94.4682 40.3853 94.4018 40.3853L85.205 34.4878C83.6845 33.5209 83.249 33.3733 82.5847 33.543Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M82.5847 33.543C82.533 33.5357 82.4149 33.329 82.4518 33.2847C82.7766 33.0559 83.4704 32.5687 84.024 32.1333C84.6514 31.6461 85.3305 31.0778 85.6478 30.8121C85.6995 30.7973 85.8767 30.9597 85.8693 31.0113C85.3378 31.6756 85.3083 32.3178 86.7329 33.2404L92.837 37.2041L90.7851 30.3101L90.667 30.2437C89.1169 29.2989 88.6962 29.1735 88.0172 29.3506C87.9655 29.3432 87.8474 29.1366 87.8843 29.0923C88.2091 28.8635 88.9029 28.3763 89.4565 27.9408C90.0839 27.4537 90.7629 26.8853 91.0803 26.6196C91.132 26.5975 91.3091 26.7672 91.3017 26.8189C90.7851 27.4684 90.726 28.1106 92.2022 29.0185L98.4023 32.8418L96.0921 26.1472C95.6344 24.7891 94.9701 24.3684 93.7818 24.8998C93.7301 24.8924 93.6194 24.6858 93.6489 24.6415C94.0032 24.3905 94.7561 23.8296 95.2654 23.431C95.7378 23.0693 96.3209 22.5895 96.6087 22.346C96.6604 22.3238 96.8375 22.4936 96.8302 22.5453C96.4611 23.2169 96.4094 23.8296 96.9852 25.4829L100.454 35.7057C100.447 35.7574 100.137 36.0009 100.07 36.0009L92.1063 31.1294L94.7856 40.0901C94.7782 40.1417 94.4682 40.3853 94.4018 40.3853L85.205 34.4878C83.6845 33.5209 83.249 33.3733 82.5847 33.543Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M115.49 26.2803C114.966 26.5165 114.332 26.8339 113.653 27.1956C112.966 27.5572 112.353 27.9042 111.866 28.2068C111.807 28.2142 111.667 28.0296 111.682 27.978C112.331 27.166 112.302 26.5682 111.63 25.3134L110.257 22.7374L105.423 20.1024C103.873 19.2535 103.445 19.0321 102.647 19.069C102.596 19.0543 102.522 18.8328 102.559 18.7885C102.913 18.6188 103.695 18.2423 104.338 17.9028C105.024 17.5411 105.733 17.1204 106.094 16.9064C106.153 16.899 106.294 17.0835 106.279 17.1352C105.806 17.7109 105.806 18.2054 107.106 18.9214L110.84 20.9955L111.217 17.0614C111.342 15.6885 110.966 15.0537 109.829 15.253C109.777 15.2383 109.704 15.0168 109.741 14.9725C110.117 14.7954 110.981 14.3525 111.542 14.0573C112.08 13.7694 112.553 13.4963 112.878 13.3044C112.937 13.297 113.077 13.4816 113.062 13.5332C112.678 13.9613 112.582 14.6256 112.39 16.4857L111.852 21.8738L113.232 24.4646C113.903 25.7194 114.376 26.081 115.417 25.9998C115.454 26.022 115.535 26.2434 115.49 26.2803Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M115.49 26.2803C114.966 26.5165 114.332 26.8339 113.653 27.1956C112.966 27.5572 112.353 27.9042 111.866 28.2068C111.807 28.2142 111.667 28.0296 111.682 27.978C112.331 27.166 112.302 26.5682 111.63 25.3134L110.257 22.7374L105.423 20.1024C103.873 19.2535 103.445 19.0321 102.647 19.069C102.596 19.0543 102.522 18.8328 102.559 18.7885C102.913 18.6188 103.695 18.2423 104.338 17.9028C105.024 17.5411 105.733 17.1204 106.094 16.9064C106.153 16.899 106.294 17.0835 106.279 17.1352C105.806 17.7109 105.806 18.2054 107.106 18.9214L110.84 20.9955L111.217 17.0614C111.342 15.6885 110.966 15.0537 109.829 15.253C109.777 15.2383 109.704 15.0168 109.741 14.9725C110.117 14.7954 110.981 14.3525 111.542 14.0573C112.08 13.7694 112.553 13.4963 112.878 13.3044C112.937 13.297 113.077 13.4816 113.062 13.5332C112.678 13.9613 112.582 14.6256 112.39 16.4857L111.852 21.8738L113.232 24.4646C113.903 25.7194 114.376 26.081 115.417 25.9998C115.454 26.022 115.535 26.2434 115.49 26.2803Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M126.912 14.4407C125.606 11.134 123.524 9.82754 121.037 10.8092C118.571 11.7835 117.929 14.1307 119.228 17.43C120.535 20.7368 122.616 22.0432 125.104 21.0615C127.569 20.0946 128.211 17.7474 126.912 14.4407ZM117.398 18.1903C115.981 14.6031 117.339 11.1192 120.66 9.81277C124.011 8.49156 127.318 10.0711 128.735 13.6805C130.152 17.2676 128.794 20.7515 125.473 22.058C122.122 23.3866 118.822 21.7996 117.398 18.1903Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M126.912 14.4407C125.606 11.134 123.524 9.82754 121.037 10.8092C118.571 11.7835 117.929 14.1307 119.228 17.43C120.535 20.7368 122.616 22.0432 125.104 21.0615C127.569 20.0946 128.211 17.7474 126.912 14.4407ZM117.398 18.1903C115.981 14.6031 117.339 11.1192 120.66 9.81277C124.011 8.49156 127.318 10.0711 128.735 13.6805C130.152 17.2676 128.794 20.7515 125.473 22.058C122.122 23.3866 118.822 21.7996 117.398 18.1903Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M135.974 6.22554L133.442 6.88245L134.719 11.7835L137.251 11.1266C139.133 10.6394 139.731 9.71677 139.288 8.00437C138.838 6.28458 137.841 5.73839 135.974 6.22554ZM132.18 9.18534C131.752 7.54675 131.339 7.02269 130.416 6.85292C130.372 6.83078 130.349 6.59459 130.394 6.55768C130.888 6.44697 131.641 6.26982 132.32 6.09267L135.723 5.20695C138.565 4.46884 140.631 5.32504 141.192 7.47293C141.643 9.2001 140.816 10.6837 139.022 11.5768L141.163 13.9461C142.004 14.8835 142.528 15.2673 143.281 15.0754C143.562 15.0016 143.805 14.8097 143.953 14.6399C144.004 14.6104 144.189 14.6695 144.196 14.7211C144.226 15.4002 143.835 16.3228 142.816 16.5885C141.51 16.9281 140.58 16.0719 139.598 14.9647L137.192 12.219L134.977 12.7947L135.716 15.6216C136.062 16.9428 136.424 17.4078 137.376 17.5555C137.421 17.5776 137.443 17.8138 137.398 17.8507C136.852 17.954 136.195 18.109 135.479 18.2936C134.763 18.4781 134.121 18.6626 133.59 18.8398C133.531 18.8324 133.442 18.6183 133.464 18.5741C134.225 17.9836 134.313 17.4005 133.966 16.0793L132.18 9.18534Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M135.974 6.22554L133.442 6.88245L134.719 11.7835L137.251 11.1266C139.133 10.6394 139.731 9.71677 139.288 8.00437C138.838 6.28458 137.841 5.73839 135.974 6.22554ZM132.18 9.18534C131.752 7.54675 131.339 7.02269 130.416 6.85292C130.372 6.83078 130.349 6.59459 130.394 6.55768C130.888 6.44697 131.641 6.26982 132.32 6.09267L135.723 5.20695C138.565 4.46884 140.631 5.32504 141.192 7.47293C141.643 9.2001 140.816 10.6837 139.022 11.5768L141.163 13.9461C142.004 14.8835 142.528 15.2673 143.281 15.0754C143.562 15.0016 143.805 14.8097 143.953 14.6399C144.004 14.6104 144.189 14.6695 144.196 14.7211C144.226 15.4002 143.835 16.3228 142.816 16.5885C141.51 16.9281 140.58 16.0719 139.598 14.9647L137.192 12.219L134.977 12.7947L135.716 15.6216C136.062 16.9428 136.424 17.4078 137.376 17.5555C137.421 17.5776 137.443 17.8138 137.398 17.8507C136.852 17.954 136.195 18.109 135.479 18.2936C134.763 18.4781 134.121 18.6626 133.59 18.8398C133.531 18.8324 133.442 18.6183 133.464 18.5741C134.225 17.9836 134.313 17.4005 133.966 16.0793L132.18 9.18534Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M150.67 15.083C150.109 15.12 149.444 15.1938 148.714 15.2897C147.983 15.3857 147.319 15.4964 146.772 15.6071C146.713 15.5997 146.647 15.3709 146.684 15.3266C147.511 14.8321 147.666 14.2637 147.488 12.9056L146.477 5.43599C146.293 4.07787 145.99 3.57596 145.06 3.31763C145.023 3.2881 145.023 3.0519 145.075 3.02238C145.636 2.98547 146.293 2.91166 147.031 2.81571C147.761 2.71975 148.418 2.60904 148.972 2.49833C149.031 2.50571 149.097 2.73451 149.061 2.7788C148.234 3.27333 148.079 3.84167 148.263 5.19979L148.802 9.16343L152.515 4.43954C153.43 3.25857 153.497 2.54261 152.485 2.3138C152.441 2.28428 152.448 2.04808 152.5 2.01855C152.928 1.98165 153.969 1.85617 154.633 1.7676C155.275 1.67902 156.08 1.55355 156.486 1.47974C156.538 1.48712 156.611 1.71593 156.574 1.76022C155.829 2.06284 155.312 2.67547 154.058 4.2624L151.828 7.03768L156.176 11.8944C157.305 13.1418 157.63 13.4961 158.368 13.7471C158.412 13.7766 158.405 14.0128 158.353 14.0423C157.955 14.0792 157.099 14.1604 156.383 14.2564C155.593 14.3597 154.759 14.5147 154.353 14.5885C154.294 14.5811 154.227 14.3523 154.264 14.308C154.921 13.9242 155.098 13.4666 154.153 12.3963L150.699 8.47698L149.001 10.5954L149.282 12.6694C149.466 14.0275 149.769 14.5295 150.699 14.7878C150.721 14.8247 150.714 15.0609 150.67 15.083Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M150.67 15.083C150.109 15.12 149.444 15.1938 148.714 15.2897C147.983 15.3857 147.319 15.4964 146.772 15.6071C146.713 15.5997 146.647 15.3709 146.684 15.3266C147.511 14.8321 147.666 14.2637 147.488 12.9056L146.477 5.43599C146.293 4.07787 145.99 3.57596 145.06 3.31763C145.023 3.2881 145.023 3.0519 145.075 3.02238C145.636 2.98547 146.293 2.91166 147.031 2.81571C147.761 2.71975 148.418 2.60904 148.972 2.49833C149.031 2.50571 149.097 2.73451 149.061 2.7788C148.234 3.27333 148.079 3.84167 148.263 5.19979L148.802 9.16343L152.515 4.43954C153.43 3.25857 153.497 2.54261 152.485 2.3138C152.441 2.28428 152.448 2.04808 152.5 2.01855C152.928 1.98165 153.969 1.85617 154.633 1.7676C155.275 1.67902 156.08 1.55355 156.486 1.47974C156.538 1.48712 156.611 1.71593 156.574 1.76022C155.829 2.06284 155.312 2.67547 154.058 4.2624L151.828 7.03768L156.176 11.8944C157.305 13.1418 157.63 13.4961 158.368 13.7471C158.412 13.7766 158.405 14.0128 158.353 14.0423C157.955 14.0792 157.099 14.1604 156.383 14.2564C155.593 14.3597 154.759 14.5147 154.353 14.5885C154.294 14.5811 154.227 14.3523 154.264 14.308C154.921 13.9242 155.098 13.4666 154.153 12.3963L150.699 8.47698L149.001 10.5954L149.282 12.6694C149.466 14.0275 149.769 14.5295 150.699 14.7878C150.721 14.8247 150.714 15.0609 150.67 15.083Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M168.79 2.18096L168.665 7.61343L170.945 7.6651C172.916 7.70939 173.75 6.92699 173.794 5.0522C173.839 3.1405 173.005 2.27692 171.071 2.23264L168.79 2.18096ZM169.742 13.6364C169.779 13.6733 169.735 13.9095 169.683 13.9242C169.1 13.8726 168.391 13.843 167.609 13.8209C166.864 13.8061 166.184 13.8061 165.624 13.8283C165.572 13.8061 165.542 13.5699 165.579 13.533C166.48 13.1714 166.731 12.6325 166.76 11.2449L166.93 4.04837C166.967 2.33597 166.709 1.70858 165.867 1.28786C165.83 1.25096 165.874 1.01476 165.926 1C166.435 1.02952 167.218 1.06643 167.926 1.08119L171.115 1.155C174.067 1.22143 175.854 2.70503 175.802 5.03744C175.75 7.36986 173.876 8.78702 170.923 8.71321L168.642 8.66154L168.583 11.1932C168.546 12.6399 168.79 13.1935 169.742 13.6364Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M168.79 2.18096L168.665 7.61343L170.945 7.6651C172.916 7.70939 173.75 6.92699 173.794 5.0522C173.839 3.1405 173.005 2.27692 171.071 2.23264L168.79 2.18096ZM169.742 13.6364C169.779 13.6733 169.735 13.9095 169.683 13.9242C169.1 13.8726 168.391 13.843 167.609 13.8209C166.864 13.8061 166.184 13.8061 165.624 13.8283C165.572 13.8061 165.542 13.5699 165.579 13.533C166.48 13.1714 166.731 12.6325 166.76 11.2449L166.93 4.04837C166.967 2.33597 166.709 1.70858 165.867 1.28786C165.83 1.25096 165.874 1.01476 165.926 1C166.435 1.02952 167.218 1.06643 167.926 1.08119L171.115 1.155C174.067 1.22143 175.854 2.70503 175.802 5.03744C175.75 7.36986 173.876 8.78702 170.923 8.71321L168.642 8.66154L168.583 11.1932C168.546 12.6399 168.79 13.1935 169.742 13.6364Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M187.818 10.4922L188.401 5.90853C188.615 4.21827 188.467 3.56136 187.559 2.95611C187.53 2.9192 187.596 2.69039 187.648 2.67562C188.054 2.74944 188.748 2.85278 189.338 2.92659C189.929 3.0004 190.623 3.0742 191.036 3.10373C191.088 3.12587 191.095 3.36207 191.051 3.39898C190.025 3.76065 189.715 4.35113 189.501 6.04878L188.918 10.6324C188.489 13.9687 186.533 15.5334 183.323 15.1201C179.986 14.692 178.466 12.7065 178.894 9.35549L179.544 4.24042C179.713 2.8823 179.551 2.32133 178.724 1.83418C178.695 1.79728 178.761 1.56847 178.813 1.55371C179.359 1.65705 180.016 1.76037 180.747 1.85633C181.477 1.95228 182.142 2.01872 182.695 2.04824C182.747 2.07038 182.754 2.30657 182.71 2.34348C181.787 2.6092 181.492 3.11111 181.315 4.46923L180.666 9.5843C180.341 12.116 181.359 13.5184 183.714 13.8137C186.157 14.1163 187.493 13.0386 187.818 10.4922Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M187.818 10.4922L188.401 5.90853C188.615 4.21827 188.467 3.56136 187.559 2.95611C187.53 2.9192 187.596 2.69039 187.648 2.67562C188.054 2.74944 188.748 2.85278 189.338 2.92659C189.929 3.0004 190.623 3.0742 191.036 3.10373C191.088 3.12587 191.095 3.36207 191.051 3.39898C190.025 3.76065 189.715 4.35113 189.501 6.04878L188.918 10.6324C188.489 13.9687 186.533 15.5334 183.323 15.1201C179.986 14.692 178.466 12.7065 178.894 9.35549L179.544 4.24042C179.713 2.8823 179.551 2.32133 178.724 1.83418C178.695 1.79728 178.761 1.56847 178.813 1.55371C179.359 1.65705 180.016 1.76037 180.747 1.85633C181.477 1.95228 182.142 2.01872 182.695 2.04824C182.747 2.07038 182.754 2.30657 182.71 2.34348C181.787 2.6092 181.492 3.11111 181.315 4.46923L180.666 9.5843C180.341 12.116 181.359 13.5184 183.714 13.8137C186.157 14.1163 187.493 13.0386 187.818 10.4922Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M198.219 10.7946C200.035 11.2669 200.98 10.7798 201.378 9.22977C201.792 7.64285 201.186 6.74236 199.385 6.27735L197.252 5.72377L196.086 10.241L198.219 10.7946ZM197.149 16.5296C198.979 17.002 199.968 16.5149 200.374 14.928C200.802 13.2894 200.16 12.3741 198.345 11.9091L195.835 11.2596L194.639 15.8875L197.149 16.5296ZM191.584 16.227C191.532 16.1975 191.561 15.9613 191.606 15.9318C192.543 15.762 192.934 15.2675 193.318 13.7839L195.045 7.09665C195.466 5.45805 195.363 4.79376 194.639 4.19589C194.61 4.15161 194.706 3.93756 194.765 3.93018C195.252 4.0778 195.997 4.28446 196.676 4.4616L199.681 5.23662C202.456 5.95258 203.858 7.59856 203.371 9.48812C203.017 10.8462 201.888 11.636 200.264 11.7172C201.939 12.5808 202.699 13.8946 202.301 15.4299C201.777 17.4744 199.703 18.279 196.891 17.5556L193.525 16.6847C192.831 16.5149 192.078 16.3377 191.584 16.227Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M198.219 10.7946C200.035 11.2669 200.98 10.7798 201.378 9.22977C201.792 7.64285 201.186 6.74236 199.385 6.27735L197.252 5.72377L196.086 10.241L198.219 10.7946ZM197.149 16.5296C198.979 17.002 199.968 16.5149 200.374 14.928C200.802 13.2894 200.16 12.3741 198.345 11.9091L195.835 11.2596L194.639 15.8875L197.149 16.5296ZM191.584 16.227C191.532 16.1975 191.561 15.9613 191.606 15.9318C192.543 15.762 192.934 15.2675 193.318 13.7839L195.045 7.09665C195.466 5.45805 195.363 4.79376 194.639 4.19589C194.61 4.15161 194.706 3.93756 194.765 3.93018C195.252 4.0778 195.997 4.28446 196.676 4.4616L199.681 5.23662C202.456 5.95258 203.858 7.59856 203.371 9.48812C203.017 10.8462 201.888 11.636 200.264 11.7172C201.939 12.5808 202.699 13.8946 202.301 15.4299C201.777 17.4744 199.703 18.279 196.891 17.5556L193.525 16.6847C192.831 16.5149 192.078 16.3377 191.584 16.227Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M205.754 20.2573C205.097 20.0137 204.366 19.7554 203.887 19.593C203.842 19.5561 203.894 19.3273 203.938 19.3051C204.868 19.2313 205.341 18.7515 205.931 17.1646L208.426 10.4921C208.906 9.20783 208.876 8.62472 208.182 7.96043C208.16 7.91614 208.278 7.70947 208.337 7.70947C208.847 7.93829 209.467 8.18924 210.16 8.44758C210.884 8.72068 211.555 8.94949 212.102 9.11926C212.146 9.15616 212.094 9.38498 212.05 9.40712C211.009 9.45879 210.581 9.87951 210.087 11.2155L206.957 19.5708L209.673 20.5894C211.43 21.2463 212.235 21.1061 213.26 19.9473C213.327 19.9178 213.556 20.0359 213.548 20.1097C213.083 21.1504 212.707 22.1985 212.581 22.693C212.559 22.7595 212.397 22.8185 212.33 22.789C212.057 22.6487 211.482 22.3904 209.334 21.5933L205.754 20.2573Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M205.754 20.2573C205.097 20.0137 204.366 19.7554 203.887 19.593C203.842 19.5561 203.894 19.3273 203.938 19.3051C204.868 19.2313 205.341 18.7515 205.931 17.1646L208.426 10.4921C208.906 9.20783 208.876 8.62472 208.182 7.96043C208.16 7.91614 208.278 7.70947 208.337 7.70947C208.847 7.93829 209.467 8.18924 210.16 8.44758C210.884 8.72068 211.555 8.94949 212.102 9.11926C212.146 9.15616 212.094 9.38498 212.05 9.40712C211.009 9.45879 210.581 9.87951 210.087 11.2155L206.957 19.5708L209.673 20.5894C211.43 21.2463 212.235 21.1061 213.26 19.9473C213.327 19.9178 213.556 20.0359 213.548 20.1097C213.083 21.1504 212.707 22.1985 212.581 22.693C212.559 22.7595 212.397 22.8185 212.33 22.789C212.057 22.6487 211.482 22.3904 209.334 21.5933L205.754 20.2573Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M218.547 25.3722C218.562 25.4165 218.429 25.6157 218.377 25.6084C217.868 25.3279 217.24 25.0179 216.539 24.6857C215.838 24.3536 215.196 24.0731 214.657 23.8591C214.613 23.8222 214.686 23.5933 214.731 23.5786C215.772 23.6081 216.229 23.2317 216.834 21.94L219.964 15.2896C220.569 13.998 220.569 13.4075 219.883 12.6251C219.868 12.5734 219.993 12.3815 220.053 12.3889C220.562 12.6694 221.189 12.9794 221.89 13.3115C222.592 13.6437 223.234 13.9241 223.773 14.1382C223.817 14.1751 223.743 14.4039 223.699 14.426C222.658 14.3965 222.2 14.773 221.595 16.0646L218.466 22.715C217.86 23.9919 217.86 24.5898 218.547 25.3722Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M218.547 25.3722C218.562 25.4165 218.429 25.6157 218.377 25.6084C217.868 25.3279 217.24 25.0179 216.539 24.6857C215.838 24.3536 215.196 24.0731 214.657 23.8591C214.613 23.8222 214.686 23.5933 214.731 23.5786C215.772 23.6081 216.229 23.2317 216.834 21.94L219.964 15.2896C220.569 13.998 220.569 13.4075 219.883 12.6251C219.868 12.5734 219.993 12.3815 220.053 12.3889C220.562 12.6694 221.189 12.9794 221.89 13.3115C222.592 13.6437 223.234 13.9241 223.773 14.1382C223.817 14.1751 223.743 14.4039 223.699 14.426C222.658 14.3965 222.2 14.773 221.595 16.0646L218.466 22.715C217.86 23.9919 217.86 24.5898 218.547 25.3722Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M232.961 18.8474C234.327 19.652 234.748 20.5008 235.419 20.892C235.604 21.0027 235.803 20.9879 235.98 20.9289C236.069 20.9584 236.187 21.1134 236.202 21.1651C235.648 22.1172 235.161 23.0841 234.748 24.1175C234.711 24.1765 234.474 24.1249 234.452 24.0511C234.548 22.1025 233.84 20.6041 232.423 19.77C230.23 18.4857 227.994 19.4527 226.208 22.501C224.421 25.5494 224.687 28.0221 226.909 29.3285C228.385 30.1921 230.127 30.1109 231.832 29.0554C231.906 29.0333 232.076 29.2178 232.031 29.2769C231.278 30.1331 230.607 31.0336 229.994 31.9267C229.942 31.9414 229.78 31.9045 229.706 31.8455C229.655 31.6462 229.551 31.5059 229.315 31.3657C228.68 30.9893 227.728 31.0409 226.348 30.229C223.3 28.4428 222.532 24.8335 224.473 21.5194C226.414 18.2126 229.987 17.1055 232.961 18.8474Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M232.961 18.8474C234.327 19.652 234.748 20.5008 235.419 20.892C235.604 21.0027 235.803 20.9879 235.98 20.9289C236.069 20.9584 236.187 21.1134 236.202 21.1651C235.648 22.1172 235.161 23.0841 234.748 24.1175C234.711 24.1765 234.474 24.1249 234.452 24.0511C234.548 22.1025 233.84 20.6041 232.423 19.77C230.23 18.4857 227.994 19.4527 226.208 22.501C224.421 25.5494 224.687 28.0221 226.909 29.3285C228.385 30.1921 230.127 30.1109 231.832 29.0554C231.906 29.0333 232.076 29.2178 232.031 29.2769C231.278 30.1331 230.607 31.0336 229.994 31.9267C229.942 31.9414 229.78 31.9045 229.706 31.8455C229.655 31.6462 229.551 31.5059 229.315 31.3657C228.68 30.9893 227.728 31.0409 226.348 30.229C223.3 28.4428 222.532 24.8335 224.473 21.5194C226.414 18.2126 229.987 17.1055 232.961 18.8474Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M238.254 38.0233C237.708 37.5804 237.095 37.108 236.689 36.8054C236.66 36.7537 236.778 36.5544 236.829 36.5471C237.737 36.7685 238.335 36.4659 239.398 35.152L243.886 29.6236C244.749 28.5607 244.904 27.9924 244.462 27.1436C244.454 27.0919 244.631 26.9369 244.683 26.9517C245.096 27.3281 245.598 27.7636 246.174 28.2286C246.779 28.7158 247.333 29.1439 247.805 29.4834C247.835 29.535 247.717 29.7343 247.665 29.7417C246.661 29.4612 246.13 29.7196 245.229 30.8267L239.612 37.7576L241.863 39.588C243.317 40.769 244.129 40.8871 245.465 40.1195C245.539 40.1121 245.716 40.2966 245.687 40.3631C244.919 41.1971 244.225 42.0755 243.952 42.5036C243.908 42.5626 243.738 42.5626 243.686 42.5183C243.472 42.2969 243.007 41.8688 241.229 40.4295L238.254 38.0233Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M238.254 38.0233C237.708 37.5804 237.095 37.108 236.689 36.8054C236.66 36.7537 236.778 36.5544 236.829 36.5471C237.737 36.7685 238.335 36.4659 239.398 35.152L243.886 29.6236C244.749 28.5607 244.904 27.9924 244.462 27.1436C244.454 27.0919 244.631 26.9369 244.683 26.9517C245.096 27.3281 245.598 27.7636 246.174 28.2286C246.779 28.7158 247.333 29.1439 247.805 29.4834C247.835 29.535 247.717 29.7343 247.665 29.7417C246.661 29.4612 246.13 29.7196 245.229 30.8267L239.612 37.7576L241.863 39.588C243.317 40.769 244.129 40.8871 245.465 40.1195C245.539 40.1121 245.716 40.2966 245.687 40.3631C244.919 41.1971 244.225 42.0755 243.952 42.5036C243.908 42.5626 243.738 42.5626 243.686 42.5183C243.472 42.2969 243.007 41.8688 241.229 40.4295L238.254 38.0233Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M249.103 47.2719C249.103 47.3235 248.919 47.4712 248.867 47.4416C248.476 47.0135 247.981 46.5116 247.42 45.9802C246.859 45.4414 246.343 44.969 245.9 44.5925C245.87 44.5409 246.011 44.349 246.062 44.349C247.036 44.7107 247.597 44.4966 248.587 43.4706L253.694 38.171C254.683 37.1451 254.875 36.5767 254.477 35.6172C254.477 35.5655 254.668 35.4253 254.713 35.4474C255.104 35.8755 255.599 36.3774 256.159 36.9089C256.72 37.4477 257.237 37.9201 257.68 38.2965C257.71 38.3482 257.569 38.5401 257.518 38.5401C256.543 38.1784 255.982 38.3925 254.993 39.4184L249.886 44.718C248.897 45.7514 248.705 46.3123 249.103 47.2719Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M249.103 47.2719C249.103 47.3235 248.919 47.4712 248.867 47.4416C248.476 47.0135 247.981 46.5116 247.42 45.9802C246.859 45.4414 246.343 44.969 245.9 44.5925C245.87 44.5409 246.011 44.349 246.062 44.349C247.036 44.7107 247.597 44.4966 248.587 43.4706L253.694 38.171C254.683 37.1451 254.875 36.5767 254.477 35.6172C254.477 35.5655 254.668 35.4253 254.713 35.4474C255.104 35.8755 255.599 36.3774 256.159 36.9089C256.72 37.4477 257.237 37.9201 257.68 38.2965C257.71 38.3482 257.569 38.5401 257.518 38.5401C256.543 38.1784 255.982 38.3925 254.993 39.4184L249.886 44.718C248.897 45.7514 248.705 46.3123 249.103 47.2719Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M259.738 48.9991C260.971 50.4162 262.019 50.5491 263.23 49.501C264.47 48.4234 264.477 47.3383 263.267 45.9359L261.827 44.2752L258.306 47.3383L259.738 48.9991ZM255.605 53.1177C256.845 54.5423 257.93 54.6973 259.17 53.627C260.447 52.5125 260.44 51.4053 259.207 49.9881L257.502 48.0322L253.9 51.1617L255.605 53.1177ZM251.191 49.7077C251.169 49.656 251.324 49.4715 251.376 49.4789C252.247 49.8701 252.844 49.6855 254.003 48.6817L259.214 44.1571C260.491 43.0426 260.779 42.4373 260.521 41.5368C260.528 41.4852 260.727 41.3597 260.772 41.3892C261.089 41.7804 261.584 42.3783 262.049 42.9097L264.078 45.2495C265.961 47.4122 266.175 49.5601 264.706 50.837C263.643 51.7596 262.263 51.767 260.882 50.9108C261.776 52.5715 261.657 54.0846 260.454 55.1254C258.86 56.5056 256.697 55.9963 254.793 53.8042L252.512 51.1765C252.062 50.6524 251.538 50.0841 251.191 49.7077Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M259.738 48.9991C260.971 50.4162 262.019 50.5491 263.23 49.501C264.47 48.4234 264.477 47.3383 263.267 45.9359L261.827 44.2752L258.306 47.3383L259.738 48.9991ZM255.605 53.1177C256.845 54.5423 257.93 54.6973 259.17 53.627C260.447 52.5125 260.44 51.4053 259.207 49.9881L257.502 48.0322L253.9 51.1617L255.605 53.1177ZM251.191 49.7077C251.169 49.656 251.324 49.4715 251.376 49.4789C252.247 49.8701 252.844 49.6855 254.003 48.6817L259.214 44.1571C260.491 43.0426 260.779 42.4373 260.521 41.5368C260.528 41.4852 260.727 41.3597 260.772 41.3892C261.089 41.7804 261.584 42.3783 262.049 42.9097L264.078 45.2495C265.961 47.4122 266.175 49.5601 264.706 50.837C263.643 51.7596 262.263 51.767 260.882 50.9108C261.776 52.5715 261.657 54.0846 260.454 55.1254C258.86 56.5056 256.697 55.9963 254.793 53.8042L252.512 51.1765C252.062 50.6524 251.538 50.0841 251.191 49.7077Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M272.23 57.5244L270.746 55.3691L266.568 58.2403L268.052 60.3956C269.152 61.9973 270.222 62.2482 271.683 61.2518C273.152 60.2332 273.322 59.1113 272.23 57.5244ZM268.155 54.9631C269.55 54.0036 269.905 53.4352 269.75 52.5126C269.757 52.4609 269.971 52.3576 270.015 52.3945C270.288 52.8226 270.709 53.4721 271.108 54.0479L273.101 56.9486C274.761 59.3696 274.658 61.6061 272.835 62.8609C271.366 63.8721 269.691 63.599 268.237 62.2113L266.738 65.0309C266.148 66.138 265.963 66.7654 266.399 67.4076C266.561 67.6438 266.827 67.8135 267.033 67.8874C267.078 67.9243 267.085 68.1162 267.033 68.1457C266.399 68.404 265.402 68.345 264.812 67.4888C264.044 66.3743 264.539 65.208 265.24 63.909L267.004 60.713L265.705 58.8234L263.299 60.4768C262.169 61.2518 261.859 61.7537 262.044 62.6985C262.036 62.7501 261.822 62.8535 261.778 62.8166C261.49 62.3368 261.129 61.7758 260.708 61.1632C260.287 60.5506 259.896 60.0118 259.549 59.5763C259.534 59.5246 259.704 59.3622 259.756 59.3696C260.568 59.8863 261.143 59.7682 262.273 58.9932L268.155 54.9631Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M272.23 57.5244L270.746 55.3691L266.568 58.2403L268.052 60.3956C269.152 61.9973 270.222 62.2482 271.683 61.2518C273.152 60.2332 273.322 59.1113 272.23 57.5244ZM268.155 54.9631C269.55 54.0036 269.905 53.4352 269.75 52.5126C269.757 52.4609 269.971 52.3576 270.015 52.3945C270.288 52.8226 270.709 53.4721 271.108 54.0479L273.101 56.9486C274.761 59.3696 274.658 61.6061 272.835 62.8609C271.366 63.8721 269.691 63.599 268.237 62.2113L266.738 65.0309C266.148 66.138 265.963 66.7654 266.399 67.4076C266.561 67.6438 266.827 67.8135 267.033 67.8874C267.078 67.9243 267.085 68.1162 267.033 68.1457C266.399 68.404 265.402 68.345 264.812 67.4888C264.044 66.3743 264.539 65.208 265.24 63.909L267.004 60.713L265.705 58.8234L263.299 60.4768C262.169 61.2518 261.859 61.7537 262.044 62.6985C262.036 62.7501 261.822 62.8535 261.778 62.8166C261.49 62.3368 261.129 61.7758 260.708 61.1632C260.287 60.5506 259.896 60.0118 259.549 59.5763C259.534 59.5246 259.704 59.3622 259.756 59.3696C260.568 59.8863 261.143 59.7682 262.273 58.9932L268.155 54.9631Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M274.487 74.8696L278.029 70.5665L272.501 71.0831L274.487 74.8696ZM268.574 73.1055C268.56 73.1572 268.338 73.231 268.294 73.1941C268.095 72.7734 267.762 72.1091 267.445 71.5039C267.157 70.9577 266.832 70.3819 266.626 70.0203C266.618 69.9612 266.81 69.821 266.855 69.8357C267.489 70.2343 268.124 70.3524 269.814 70.1974L280.805 69.26C280.864 69.2895 281.041 69.6291 281.034 69.6881L274.014 78.3535C272.885 79.7411 272.678 80.2726 272.656 80.8926C272.641 80.9442 272.42 81.018 272.376 80.9811C272.139 80.4497 271.918 79.9994 271.571 79.3278C271.217 78.6561 270.818 77.9328 270.516 77.4382C270.508 77.3792 270.7 77.2389 270.744 77.2537C271.379 77.8368 271.977 77.9328 273.143 76.5082L273.785 75.748L271.394 71.1865L270.737 71.2455C269.084 71.3931 268.441 71.8286 268.574 73.1055Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M274.487 74.8696L278.029 70.5665L272.501 71.0831L274.487 74.8696ZM268.574 73.1055C268.56 73.1572 268.338 73.231 268.294 73.1941C268.095 72.7734 267.762 72.1091 267.445 71.5039C267.157 70.9577 266.832 70.3819 266.626 70.0203C266.618 69.9612 266.81 69.821 266.855 69.8357C267.489 70.2343 268.124 70.3524 269.814 70.1974L280.805 69.26C280.864 69.2895 281.041 69.6291 281.034 69.6881L274.014 78.3535C272.885 79.7411 272.678 80.2726 272.656 80.8926C272.641 80.9442 272.42 81.018 272.376 80.9811C272.139 80.4497 271.918 79.9994 271.571 79.3278C271.217 78.6561 270.818 77.9328 270.516 77.4382C270.508 77.3792 270.7 77.2389 270.744 77.2537C271.379 77.8368 271.977 77.9328 273.143 76.5082L273.785 75.748L271.394 71.1865L270.737 71.2455C269.084 71.3931 268.441 71.8286 268.574 73.1055Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M285.825 83.4538L284.88 81.018L280.156 82.8486L281.101 85.2843C281.802 87.1 282.784 87.5872 284.43 86.9524C286.091 86.3029 286.519 85.2548 285.825 83.4538ZM282.444 80.0216C284.024 79.409 284.496 78.9366 284.563 78.0066C284.585 77.9623 284.814 77.9106 284.851 77.9549C285.02 78.4347 285.279 79.158 285.53 79.8149L286.799 83.0921C287.862 85.8305 287.242 87.9858 285.175 88.7829C283.507 89.4251 281.942 88.7756 280.85 87.0927L278.746 89.4915C277.912 90.4289 277.588 91.0046 277.868 91.7206C277.971 91.9937 278.193 92.2151 278.377 92.3332C278.414 92.3775 278.37 92.5694 278.318 92.5842C277.647 92.6875 276.687 92.407 276.303 91.4327C275.816 90.1706 276.562 89.152 277.543 88.0522L279.994 85.3434L279.167 83.2102L276.443 84.2657C275.167 84.7602 274.746 85.1736 274.709 86.1331C274.687 86.1774 274.458 86.2291 274.421 86.1848C274.251 85.6534 274.03 85.0186 273.764 84.3322C273.498 83.6457 273.24 83.0257 273.004 82.5164C273.004 82.4574 273.203 82.3393 273.255 82.3614C273.927 83.0478 274.517 83.07 275.794 82.5755L282.444 80.0216Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M285.825 83.4538L284.88 81.018L280.156 82.8486L281.101 85.2843C281.802 87.1 282.784 87.5872 284.43 86.9524C286.091 86.3029 286.519 85.2548 285.825 83.4538ZM282.444 80.0216C284.024 79.409 284.496 78.9366 284.563 78.0066C284.585 77.9623 284.814 77.9106 284.851 77.9549C285.02 78.4347 285.279 79.158 285.53 79.8149L286.799 83.0921C287.862 85.8305 287.242 87.9858 285.175 88.7829C283.507 89.4251 281.942 88.7756 280.85 87.0927L278.746 89.4915C277.912 90.4289 277.588 91.0046 277.868 91.7206C277.971 91.9937 278.193 92.2151 278.377 92.3332C278.414 92.3775 278.37 92.5694 278.318 92.5842C277.647 92.6875 276.687 92.407 276.303 91.4327C275.816 90.1706 276.562 89.152 277.543 88.0522L279.994 85.3434L279.167 83.2102L276.443 84.2657C275.167 84.7602 274.746 85.1736 274.709 86.1331C274.687 86.1774 274.458 86.2291 274.421 86.1848C274.251 85.6534 274.03 85.0186 273.764 84.3322C273.498 83.6457 273.24 83.0257 273.004 82.5164C273.004 82.4574 273.203 82.3393 273.255 82.3614C273.927 83.0478 274.517 83.07 275.794 82.5755L282.444 80.0216Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M279.367 101.663C279.256 101.095 279.094 100.408 278.902 99.6628C278.703 98.9099 278.511 98.2383 278.334 97.6847C278.341 97.6256 278.555 97.5371 278.599 97.5592C279.242 98.3785 279.832 98.4892 281.205 98.1275L284.032 97.3894L287.715 93.3003C288.896 91.9865 289.213 91.6248 289.361 90.8424C289.391 90.7981 289.627 90.776 289.656 90.8203C289.737 91.2115 289.922 92.0529 290.107 92.7541C290.298 93.507 290.549 94.2968 290.668 94.6953C290.66 94.7544 290.446 94.843 290.402 94.8208C289.952 94.2303 289.472 94.1122 288.475 95.212L285.589 98.3637L289.332 99.6407C290.638 100.084 291.347 99.8621 291.42 98.7033C291.45 98.659 291.679 98.6368 291.716 98.6811C291.804 99.0871 292.033 100.032 292.188 100.644C292.343 101.235 292.498 101.759 292.609 102.121C292.601 102.18 292.387 102.268 292.343 102.246C292.018 101.774 291.391 101.523 289.627 100.903L284.504 99.124L281.663 99.8621C280.282 100.224 279.825 100.6 279.662 101.634C279.633 101.685 279.397 101.707 279.367 101.663Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M279.367 101.663C279.256 101.095 279.094 100.408 278.902 99.6628C278.703 98.9099 278.511 98.2383 278.334 97.6847C278.341 97.6256 278.555 97.5371 278.599 97.5592C279.242 98.3785 279.832 98.4892 281.205 98.1275L284.032 97.3894L287.715 93.3003C288.896 91.9865 289.213 91.6248 289.361 90.8424C289.391 90.7981 289.627 90.776 289.656 90.8203C289.737 91.2115 289.922 92.0529 290.107 92.7541C290.298 93.507 290.549 94.2968 290.668 94.6953C290.66 94.7544 290.446 94.843 290.402 94.8208C289.952 94.2303 289.472 94.1122 288.475 95.212L285.589 98.3637L289.332 99.6407C290.638 100.084 291.347 99.8621 291.42 98.7033C291.45 98.659 291.679 98.6368 291.716 98.6811C291.804 99.0871 292.033 100.032 292.188 100.644C292.343 101.235 292.498 101.759 292.609 102.121C292.601 102.18 292.387 102.268 292.343 102.246C292.018 101.774 291.391 101.523 289.627 100.903L284.504 99.124L281.663 99.8621C280.282 100.224 279.825 100.6 279.662 101.634C279.633 101.685 279.397 101.707 279.367 101.663Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M57.7724 174.197C57.7946 174.263 57.7429 174.411 57.6765 174.448C57.2262 174.522 55.9493 174.898 54.9676 175.274C54.8938 175.274 54.7905 175.046 54.8274 174.979C55.9788 174.093 56.2446 173.23 55.7353 171.444L55.4031 170.285L46.819 172.721C45.4461 173.112 44.9958 173.503 44.863 174.529C44.8408 174.573 44.6046 174.603 44.5677 174.558C44.4422 173.99 44.2725 173.311 44.0584 172.566C43.8444 171.82 43.6377 171.148 43.4458 170.602C43.4458 170.543 43.6599 170.447 43.7115 170.469C44.3684 171.274 44.9589 171.37 46.3318 170.979L54.916 168.543L54.5838 167.384C54.0745 165.598 53.4029 165 51.9562 164.852C51.8897 164.815 51.8528 164.564 51.9193 164.528C52.9526 164.328 54.2369 163.981 54.6576 163.804C54.7314 163.804 54.8495 163.9 54.8717 163.967C54.8938 164.313 55.0636 165.17 55.5655 166.934L56.8055 171.303C57.3074 173.075 57.6101 173.887 57.7724 174.197Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M57.7724 174.197C57.7946 174.263 57.7429 174.411 57.6765 174.448C57.2262 174.522 55.9493 174.898 54.9676 175.274C54.8938 175.274 54.7905 175.046 54.8274 174.979C55.9788 174.093 56.2446 173.23 55.7353 171.444L55.4031 170.285L46.819 172.721C45.4461 173.112 44.9958 173.503 44.863 174.529C44.8408 174.573 44.6046 174.603 44.5677 174.558C44.4422 173.99 44.2725 173.311 44.0584 172.566C43.8444 171.82 43.6377 171.148 43.4458 170.602C43.4458 170.543 43.6599 170.447 43.7115 170.469C44.3684 171.274 44.9589 171.37 46.3318 170.979L54.916 168.543L54.5838 167.384C54.0745 165.598 53.4029 165 51.9562 164.852C51.8897 164.815 51.8528 164.564 51.9193 164.528C52.9526 164.328 54.2369 163.981 54.6576 163.804C54.7314 163.804 54.8495 163.9 54.8717 163.967C54.8938 164.313 55.0636 165.17 55.5655 166.934L56.8055 171.303C57.3074 173.075 57.6101 173.887 57.7724 174.197Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M53.9607 183.615L50.9419 184.943C49.6871 185.497 49.2885 185.925 49.2959 186.885C49.2811 186.929 49.0449 186.995 49.008 186.951C48.8161 186.427 48.5652 185.807 48.2625 185.135C47.9673 184.456 47.6794 183.858 47.4211 183.356C47.4137 183.297 47.613 183.172 47.6647 183.194C48.3659 183.851 48.9564 183.851 50.2111 183.297L57.1051 180.264C58.3598 179.71 58.7584 179.282 58.751 178.315C58.7732 178.271 59.002 178.204 59.0389 178.249C59.2308 178.773 59.4818 179.393 59.7844 180.064C60.0796 180.744 60.3675 181.341 60.6258 181.843C60.6332 181.902 60.4339 182.028 60.3822 182.006C59.681 181.349 59.0906 181.356 57.8358 181.902L54.935 183.179L57.6291 189.298L60.5299 188.021C61.7847 187.468 62.1832 187.04 62.1759 186.073C62.1906 186.021 62.4194 185.962 62.4637 186.006C62.6556 186.53 62.9066 187.15 63.2018 187.829C63.4971 188.508 63.7849 189.106 64.0433 189.608C64.0506 189.667 63.8514 189.793 63.7997 189.771C63.0985 189.114 62.508 189.121 61.2532 189.667L54.3593 192.701C53.1045 193.254 52.7059 193.683 52.7133 194.649C52.6912 194.694 52.4624 194.76 52.4255 194.716C52.2336 194.192 51.9826 193.572 51.68 192.893C51.3847 192.214 51.0969 191.616 50.8385 191.114C50.8312 191.055 51.0304 190.929 51.0821 190.952C51.7833 191.608 52.3738 191.601 53.6286 191.055L56.6474 189.726L53.9607 183.615Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M53.9607 183.615L50.9419 184.943C49.6871 185.497 49.2885 185.925 49.2959 186.885C49.2811 186.929 49.0449 186.995 49.008 186.951C48.8161 186.427 48.5652 185.807 48.2625 185.135C47.9673 184.456 47.6794 183.858 47.4211 183.356C47.4137 183.297 47.613 183.172 47.6647 183.194C48.3659 183.851 48.9564 183.851 50.2111 183.297L57.1051 180.264C58.3598 179.71 58.7584 179.282 58.751 178.315C58.7732 178.271 59.002 178.204 59.0389 178.249C59.2308 178.773 59.4818 179.393 59.7844 180.064C60.0796 180.744 60.3675 181.341 60.6258 181.843C60.6332 181.902 60.4339 182.028 60.3822 182.006C59.681 181.349 59.0906 181.356 57.8358 181.902L54.935 183.179L57.6291 189.298L60.5299 188.021C61.7847 187.468 62.1832 187.04 62.1759 186.073C62.1906 186.021 62.4194 185.962 62.4637 186.006C62.6556 186.53 62.9066 187.15 63.2018 187.829C63.4971 188.508 63.7849 189.106 64.0433 189.608C64.0506 189.667 63.8514 189.793 63.7997 189.771C63.0985 189.114 62.508 189.121 61.2532 189.667L54.3593 192.701C53.1045 193.254 52.7059 193.683 52.7133 194.649C52.6912 194.694 52.4624 194.76 52.4255 194.716C52.2336 194.192 51.9826 193.572 51.68 192.893C51.3847 192.214 51.0969 191.616 50.8385 191.114C50.8312 191.055 51.0304 190.929 51.0821 190.952C51.7833 191.608 52.3738 191.601 53.6286 191.055L56.6474 189.726L53.9607 183.615Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M55.4906 200.34C55.4758 200.281 55.6603 200.134 55.7046 200.141C56.4944 200.672 57.1218 200.584 58.4209 199.779L64.3036 196.163C65.7503 195.277 66.1267 194.723 66.0234 193.793C66.0381 193.742 66.2522 193.653 66.2965 193.69C66.5474 194.133 66.9386 194.797 67.3003 195.395L69.4556 198.894C70.4151 200.458 70.9318 201.16 71.1753 201.411C71.2123 201.47 71.2049 201.625 71.1532 201.684C70.7399 201.876 69.8468 202.444 69.0053 203.071C68.9315 203.093 68.7691 202.894 68.7913 202.82C69.5441 201.809 69.4851 200.953 68.5698 199.462L66.8722 196.701L62.8938 199.145L64.0452 201.019C64.6579 202.016 65.2631 202.488 66.2226 202.392C66.2891 202.392 66.3998 202.643 66.3629 202.687C66.0455 202.865 65.3886 203.241 64.9605 203.507C64.5324 203.772 63.8976 204.178 63.595 204.385C63.5359 204.4 63.3662 204.186 63.3957 204.127C63.9124 203.322 63.7721 202.562 63.1521 201.566L62.0007 199.691L57.9337 202.193L59.7347 205.123C60.7164 206.717 61.4397 207.101 62.9602 206.821C63.034 206.836 63.1374 207.072 63.0857 207.123C62.0819 207.655 61.1371 208.26 60.7385 208.57C60.6795 208.607 60.5171 208.555 60.4802 208.496C60.3473 208.216 60.0521 207.662 58.849 205.714L56.5608 202.001C56.1918 201.418 55.7711 200.761 55.4906 200.34Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M55.4906 200.34C55.4758 200.281 55.6603 200.134 55.7046 200.141C56.4944 200.672 57.1218 200.584 58.4209 199.779L64.3036 196.163C65.7503 195.277 66.1267 194.723 66.0234 193.793C66.0381 193.742 66.2522 193.653 66.2965 193.69C66.5474 194.133 66.9386 194.797 67.3003 195.395L69.4556 198.894C70.4151 200.458 70.9318 201.16 71.1753 201.411C71.2123 201.47 71.2049 201.625 71.1532 201.684C70.7399 201.876 69.8468 202.444 69.0053 203.071C68.9315 203.093 68.7691 202.894 68.7913 202.82C69.5441 201.809 69.4851 200.953 68.5698 199.462L66.8722 196.701L62.8938 199.145L64.0452 201.019C64.6579 202.016 65.2631 202.488 66.2226 202.392C66.2891 202.392 66.3998 202.643 66.3629 202.687C66.0455 202.865 65.3886 203.241 64.9605 203.507C64.5324 203.772 63.8976 204.178 63.595 204.385C63.5359 204.4 63.3662 204.186 63.3957 204.127C63.9124 203.322 63.7721 202.562 63.1521 201.566L62.0007 199.691L57.9337 202.193L59.7347 205.123C60.7164 206.717 61.4397 207.101 62.9602 206.821C63.034 206.836 63.1374 207.072 63.0857 207.123C62.0819 207.655 61.1371 208.26 60.7385 208.57C60.6795 208.607 60.5171 208.555 60.4802 208.496C60.3473 208.216 60.0521 207.662 58.849 205.714L56.5608 202.001C56.1918 201.418 55.7711 200.761 55.4906 200.34Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M78.2832 212.711L74.2457 216.254L75.7293 217.945C77.0136 219.406 78.1429 219.495 79.538 218.269C80.9625 217.022 81.0216 215.834 79.7594 214.402L78.2832 212.711ZM70.5921 221.074C70.5921 221.126 70.3854 221.251 70.3412 221.222C69.9869 220.764 69.5366 220.225 69.0273 219.642C68.5402 219.089 68.0899 218.594 67.6914 218.203C67.6692 218.151 67.8242 217.967 67.8759 217.974C68.7395 218.387 69.3004 218.21 70.3338 217.302L75.6851 212.601C76.962 211.486 77.2425 210.874 76.9767 209.98C76.9767 209.929 77.176 209.803 77.2277 209.833C77.5451 210.224 78.047 210.822 78.512 211.346L80.5935 213.715C82.5199 215.907 82.638 218.203 80.9035 219.723C79.1689 221.244 76.8882 220.831 74.9617 218.638L73.4781 216.948L71.5959 218.601C70.5109 219.539 70.2673 220.085 70.5921 221.074Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M78.2832 212.711L74.2457 216.254L75.7293 217.945C77.0136 219.406 78.1429 219.495 79.538 218.269C80.9625 217.022 81.0216 215.834 79.7594 214.402L78.2832 212.711ZM70.5921 221.074C70.5921 221.126 70.3854 221.251 70.3412 221.222C69.9869 220.764 69.5366 220.225 69.0273 219.642C68.5402 219.089 68.0899 218.594 67.6914 218.203C67.6692 218.151 67.8242 217.967 67.8759 217.974C68.7395 218.387 69.3004 218.21 70.3338 217.302L75.6851 212.601C76.962 211.486 77.2425 210.874 76.9767 209.98C76.9767 209.929 77.176 209.803 77.2277 209.833C77.5451 210.224 78.047 210.822 78.512 211.346L80.5935 213.715C82.5199 215.907 82.638 218.203 80.9035 219.723C79.1689 221.244 76.8882 220.831 74.9617 218.638L73.4781 216.948L71.5959 218.601C70.5109 219.539 70.2673 220.085 70.5921 221.074Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M89.9019 231.533C92.2417 228.861 92.4557 226.41 90.4481 224.653C88.4552 222.904 86.0785 223.406 83.7313 226.078C81.3915 228.75 81.1774 231.2 83.1851 232.957C85.178 234.706 87.5621 234.205 89.9019 231.533ZM82.2182 224.794C84.7573 221.893 88.4773 221.509 91.164 223.864C93.8729 226.24 93.9762 229.901 91.4224 232.817C88.8759 235.718 85.1632 236.101 82.4765 233.747C79.7603 231.37 79.6569 227.709 82.2182 224.794Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M89.9019 231.533C92.2417 228.861 92.4557 226.41 90.4481 224.653C88.4552 222.904 86.0785 223.406 83.7313 226.078C81.3915 228.75 81.1774 231.2 83.1851 232.957C85.178 234.706 87.5621 234.205 89.9019 231.533ZM82.2182 224.794C84.7573 221.893 88.4773 221.509 91.164 223.864C93.8729 226.24 93.9762 229.901 91.4224 232.817C88.8759 235.718 85.1632 236.101 82.4765 233.747C79.7603 231.37 79.6569 227.709 82.2182 224.794Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M93.5992 242.169C93.0161 241.778 92.3666 241.357 91.9311 241.091C91.8942 241.047 91.9976 240.833 92.0492 240.825C92.9719 240.973 93.5402 240.611 94.485 239.209L98.4708 233.304C99.2384 232.167 99.3417 231.592 98.825 230.78C98.8177 230.728 98.98 230.558 99.0317 230.573C99.4746 230.913 100.021 231.304 100.633 231.717C101.276 232.153 101.866 232.529 102.368 232.824C102.405 232.869 102.302 233.083 102.25 233.09C101.224 232.898 100.715 233.208 99.9174 234.389L94.9278 241.785L97.3341 243.409C98.8915 244.457 99.7034 244.509 100.973 243.623C101.047 243.608 101.239 243.778 101.209 243.852C100.515 244.752 99.9027 245.69 99.6665 246.14C99.6222 246.199 99.4598 246.221 99.4008 246.177C99.1646 245.977 98.6627 245.594 96.7657 244.317L93.5992 242.169Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M93.5992 242.169C93.0161 241.778 92.3666 241.357 91.9311 241.091C91.8942 241.047 91.9976 240.833 92.0492 240.825C92.9719 240.973 93.5402 240.611 94.485 239.209L98.4708 233.304C99.2384 232.167 99.3417 231.592 98.825 230.78C98.8177 230.728 98.98 230.558 99.0317 230.573C99.4746 230.913 100.021 231.304 100.633 231.717C101.276 232.153 101.866 232.529 102.368 232.824C102.405 232.869 102.302 233.083 102.25 233.09C101.224 232.898 100.715 233.208 99.9174 234.389L94.9278 241.785L97.3341 243.409C98.8915 244.457 99.7034 244.509 100.973 243.623C101.047 243.608 101.239 243.778 101.209 243.852C100.515 244.752 99.9027 245.69 99.6665 246.14C99.6222 246.199 99.4598 246.221 99.4008 246.177C99.1646 245.977 98.6627 245.594 96.7657 244.317L93.5992 242.169Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M115.329 247.572C116.945 244.413 116.546 241.985 114.17 240.767C111.808 239.564 109.623 240.627 108.007 243.793C106.39 246.952 106.789 249.388 109.165 250.598C111.527 251.801 113.712 250.731 115.329 247.572ZM106.228 242.922C107.984 239.49 111.49 238.206 114.672 239.829C117.882 241.468 118.872 244.996 117.107 248.443C115.351 251.875 111.845 253.16 108.663 251.536C105.46 249.89 104.464 246.369 106.228 242.922Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M115.329 247.572C116.945 244.413 116.546 241.985 114.17 240.767C111.808 239.564 109.623 240.627 108.007 243.793C106.39 246.952 106.789 249.388 109.165 250.598C111.527 251.801 113.712 250.731 115.329 247.572ZM106.228 242.922C107.984 239.49 111.49 238.206 114.672 239.829C117.882 241.468 118.872 244.996 117.107 248.443C115.351 251.875 111.845 253.16 108.663 251.536C105.46 249.89 104.464 246.369 106.228 242.922Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M129.326 259.809L124.771 247.623L122.528 254.096C121.967 255.713 121.981 256.385 122.742 257.167C122.764 257.211 122.653 257.425 122.594 257.418C122.21 257.263 121.553 257.019 120.985 256.827C120.424 256.635 119.752 256.421 119.354 256.303C119.31 256.266 119.354 256.038 119.398 256.015C120.476 255.875 120.904 255.359 121.465 253.735L123.716 247.247C124.166 245.955 124.107 245.283 123.458 244.619C123.436 244.575 123.546 244.368 123.605 244.368C124.011 244.531 124.631 244.759 125.214 244.966C125.879 245.195 126.277 245.313 126.779 245.453C126.823 245.49 126.868 245.638 126.846 245.704C126.44 246.213 126.417 246.833 126.794 247.845L129.887 256.318L131.894 250.524C132.455 248.907 132.44 248.236 131.68 247.453C131.658 247.409 131.769 247.195 131.828 247.195C132.212 247.35 132.869 247.594 133.437 247.793C133.998 247.985 134.669 248.199 135.068 248.317C135.112 248.354 135.068 248.583 135.024 248.605C133.946 248.745 133.518 249.262 132.957 250.886L129.842 259.883C129.776 259.927 129.377 259.883 129.326 259.809Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M129.326 259.809L124.771 247.623L122.528 254.096C121.967 255.713 121.981 256.385 122.742 257.167C122.764 257.211 122.653 257.425 122.594 257.418C122.21 257.263 121.553 257.019 120.985 256.827C120.424 256.635 119.752 256.421 119.354 256.303C119.31 256.266 119.354 256.038 119.398 256.015C120.476 255.875 120.904 255.359 121.465 253.735L123.716 247.247C124.166 245.955 124.107 245.283 123.458 244.619C123.436 244.575 123.546 244.368 123.605 244.368C124.011 244.531 124.631 244.759 125.214 244.966C125.879 245.195 126.277 245.313 126.779 245.453C126.823 245.49 126.868 245.638 126.846 245.704C126.44 246.213 126.417 246.833 126.794 247.845L129.887 256.318L131.894 250.524C132.455 248.907 132.44 248.236 131.68 247.453C131.658 247.409 131.769 247.195 131.828 247.195C132.212 247.35 132.869 247.594 133.437 247.793C133.998 247.985 134.669 248.199 135.068 248.317C135.112 248.354 135.068 248.583 135.024 248.605C133.946 248.745 133.518 249.262 132.957 250.886L129.842 259.883C129.776 259.927 129.377 259.883 129.326 259.809Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M140.92 252.458C140.654 253.765 141.355 254.385 143.333 255.603C145.105 256.754 146.67 257.92 146.212 260.149C145.747 262.408 143.909 263.508 141.436 262.998C139.687 262.644 138.691 261.685 137.997 261.544C137.731 261.493 137.569 261.566 137.414 261.685C137.34 261.685 137.17 261.596 137.148 261.537C137.517 260.452 137.849 259.382 138.13 258.282C138.174 258.238 138.395 258.245 138.44 258.311C138.632 260.245 139.776 261.603 141.665 261.987C143.186 262.297 144.241 261.707 144.514 260.4C144.795 259.042 144.234 258.341 142.241 257.123C140.403 255.957 138.794 254.894 139.237 252.717C139.658 250.65 141.392 249.572 143.599 250.022C144.891 250.288 145.444 250.805 146.079 250.93C146.293 250.975 146.47 250.916 146.596 250.82C146.67 250.812 146.839 250.886 146.861 250.945C146.692 251.956 146.596 252.968 146.529 254.008C146.515 254.082 146.271 254.104 146.227 254.038C145.651 252.355 144.669 251.307 143.363 251.041C142.079 250.761 141.156 251.307 140.92 252.458Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M140.92 252.458C140.654 253.765 141.355 254.385 143.333 255.603C145.105 256.754 146.67 257.92 146.212 260.149C145.747 262.408 143.909 263.508 141.436 262.998C139.687 262.644 138.691 261.685 137.997 261.544C137.731 261.493 137.569 261.566 137.414 261.685C137.34 261.685 137.17 261.596 137.148 261.537C137.517 260.452 137.849 259.382 138.13 258.282C138.174 258.238 138.395 258.245 138.44 258.311C138.632 260.245 139.776 261.603 141.665 261.987C143.186 262.297 144.241 261.707 144.514 260.4C144.795 259.042 144.234 258.341 142.241 257.123C140.403 255.957 138.794 254.894 139.237 252.717C139.658 250.65 141.392 249.572 143.599 250.022C144.891 250.288 145.444 250.805 146.079 250.93C146.293 250.975 146.47 250.916 146.596 250.82C146.67 250.812 146.839 250.886 146.861 250.945C146.692 251.956 146.596 252.968 146.529 254.008C146.515 254.082 146.271 254.104 146.227 254.038C145.651 252.355 144.669 251.307 143.363 251.041C142.079 250.761 141.156 251.307 140.92 252.458Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M155.814 264.821C155.261 264.748 154.597 264.674 153.858 264.622C153.12 264.57 152.456 264.534 151.895 264.534C151.843 264.511 151.821 264.275 151.866 264.238C152.773 263.928 153.047 263.404 153.15 262.039L153.703 254.525C153.807 253.159 153.615 252.598 152.759 252.155C152.729 252.119 152.781 251.89 152.832 251.875C153.386 251.949 154.05 252.015 154.788 252.074C155.527 252.133 156.191 252.163 156.752 252.163C156.803 252.185 156.826 252.421 156.781 252.458C155.873 252.768 155.6 253.292 155.497 254.658L155.202 258.651L159.808 254.798C160.944 253.838 161.158 253.145 160.214 252.716C160.184 252.68 160.236 252.443 160.287 252.436C160.715 252.488 161.756 252.584 162.42 252.628C163.07 252.68 163.875 252.716 164.295 252.731C164.347 252.753 164.369 252.99 164.332 253.026C163.542 253.167 162.908 253.661 161.35 254.96L158.597 257.211L161.845 262.858C162.694 264.312 162.937 264.725 163.609 265.124C163.646 265.161 163.587 265.39 163.535 265.412C163.144 265.36 162.28 265.264 161.564 265.213C160.774 265.154 159.926 265.131 159.512 265.117C159.461 265.094 159.439 264.858 159.483 264.829C160.206 264.593 160.472 264.179 159.771 262.932L157.195 258.385L155.098 260.112L154.943 262.201C154.84 263.567 155.032 264.12 155.888 264.563C155.918 264.578 155.866 264.807 155.814 264.821Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M155.814 264.821C155.261 264.748 154.597 264.674 153.858 264.622C153.12 264.57 152.456 264.534 151.895 264.534C151.843 264.511 151.821 264.275 151.866 264.238C152.773 263.928 153.047 263.404 153.15 262.039L153.703 254.525C153.807 253.159 153.615 252.598 152.759 252.155C152.729 252.119 152.781 251.89 152.832 251.875C153.386 251.949 154.05 252.015 154.788 252.074C155.527 252.133 156.191 252.163 156.752 252.163C156.803 252.185 156.826 252.421 156.781 252.458C155.873 252.768 155.6 253.292 155.497 254.658L155.202 258.651L159.808 254.798C160.944 253.838 161.158 253.145 160.214 252.716C160.184 252.68 160.236 252.443 160.287 252.436C160.715 252.488 161.756 252.584 162.42 252.628C163.07 252.68 163.875 252.716 164.295 252.731C164.347 252.753 164.369 252.99 164.332 253.026C163.542 253.167 162.908 253.661 161.35 254.96L158.597 257.211L161.845 262.858C162.694 264.312 162.937 264.725 163.609 265.124C163.646 265.161 163.587 265.39 163.535 265.412C163.144 265.36 162.28 265.264 161.564 265.213C160.774 265.154 159.926 265.131 159.512 265.117C159.461 265.094 159.439 264.858 159.483 264.829C160.206 264.593 160.472 264.179 159.771 262.932L157.195 258.385L155.098 260.112L154.943 262.201C154.84 263.567 155.032 264.12 155.888 264.563C155.918 264.578 155.866 264.807 155.814 264.821Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M176.948 264.88C176.373 264.88 175.671 264.91 174.896 264.954C174.121 265.006 173.42 265.065 172.852 265.139C172.8 265.124 172.748 264.895 172.778 264.851C173.708 264.379 173.922 263.818 173.833 262.4L173.649 259.485L170.335 255.093C169.272 253.683 168.977 253.3 168.231 253.004C168.194 252.967 168.216 252.739 168.268 252.709C168.667 252.702 169.53 252.687 170.246 252.635C171.021 252.584 171.848 252.495 172.261 252.451C172.313 252.466 172.365 252.694 172.335 252.739C171.671 253.071 171.464 253.514 172.35 254.702L174.896 258.134L176.86 254.702C177.539 253.506 177.458 252.768 176.336 252.48C176.299 252.443 176.321 252.207 176.373 252.192C176.786 252.185 177.76 252.141 178.388 252.096C179 252.06 179.539 252.008 179.915 251.964C179.967 251.978 180.019 252.207 179.989 252.251C179.465 252.48 179.104 253.049 178.159 254.665L175.443 259.352L175.627 262.282C175.716 263.7 176.003 264.224 176.985 264.578C177.022 264.63 177 264.866 176.948 264.88Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M176.948 264.88C176.373 264.88 175.671 264.91 174.896 264.954C174.121 265.006 173.42 265.065 172.852 265.139C172.8 265.124 172.748 264.895 172.778 264.851C173.708 264.379 173.922 263.818 173.833 262.4L173.649 259.485L170.335 255.093C169.272 253.683 168.977 253.3 168.231 253.004C168.194 252.967 168.216 252.739 168.268 252.709C168.667 252.702 169.53 252.687 170.246 252.635C171.021 252.584 171.848 252.495 172.261 252.451C172.313 252.466 172.365 252.694 172.335 252.739C171.671 253.071 171.464 253.514 172.35 254.702L174.896 258.134L176.86 254.702C177.539 253.506 177.458 252.768 176.336 252.48C176.299 252.443 176.321 252.207 176.373 252.192C176.786 252.185 177.76 252.141 178.388 252.096C179 252.06 179.539 252.008 179.915 251.964C179.967 251.978 180.019 252.207 179.989 252.251C179.465 252.48 179.104 253.049 178.159 254.665L175.443 259.352L175.627 262.282C175.716 263.7 176.003 264.224 176.985 264.578C177.022 264.63 177 264.866 176.948 264.88Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M191.9 262.887C191.841 262.88 191.752 262.666 191.782 262.622C192.534 262.039 192.645 261.419 192.291 259.928L190.697 253.211C190.305 251.565 189.899 251.026 188.984 250.842C188.94 250.812 188.925 250.583 188.969 250.546C189.464 250.443 190.224 250.288 190.903 250.118L194.904 249.166C196.69 248.738 197.517 248.472 197.834 248.317C197.908 248.302 198.048 248.362 198.085 248.428C198.137 248.878 198.402 249.912 198.727 250.908C198.727 250.982 198.491 251.078 198.425 251.033C197.701 250 196.867 249.793 195.169 250.199L192.01 250.952L193.088 255.492L195.229 254.982C196.365 254.709 197.007 254.281 197.207 253.344C197.229 253.285 197.502 253.255 197.531 253.307C197.598 253.661 197.753 254.399 197.871 254.894C197.989 255.381 198.181 256.119 198.284 256.466C198.277 256.525 198.026 256.621 197.974 256.577C197.369 255.831 196.609 255.735 195.465 256.001L193.324 256.51L194.431 261.16L197.782 260.363C199.605 259.928 200.196 259.367 200.403 257.831C200.44 257.765 200.698 257.743 200.735 257.809C200.927 258.931 201.2 260.016 201.37 260.496C201.384 260.57 201.288 260.703 201.222 260.717C200.912 260.754 200.292 260.865 198.07 261.396L193.826 262.408C193.132 262.555 192.387 262.747 191.9 262.887Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M191.9 262.887C191.841 262.88 191.752 262.666 191.782 262.622C192.534 262.039 192.645 261.419 192.291 259.928L190.697 253.211C190.305 251.565 189.899 251.026 188.984 250.842C188.94 250.812 188.925 250.583 188.969 250.546C189.464 250.443 190.224 250.288 190.903 250.118L194.904 249.166C196.69 248.738 197.517 248.472 197.834 248.317C197.908 248.302 198.048 248.362 198.085 248.428C198.137 248.878 198.402 249.912 198.727 250.908C198.727 250.982 198.491 251.078 198.425 251.033C197.701 250 196.867 249.793 195.169 250.199L192.01 250.952L193.088 255.492L195.229 254.982C196.365 254.709 197.007 254.281 197.207 253.344C197.229 253.285 197.502 253.255 197.531 253.307C197.598 253.661 197.753 254.399 197.871 254.894C197.989 255.381 198.181 256.119 198.284 256.466C198.277 256.525 198.026 256.621 197.974 256.577C197.369 255.831 196.609 255.735 195.465 256.001L193.324 256.51L194.431 261.16L197.782 260.363C199.605 259.928 200.196 259.367 200.403 257.831C200.44 257.765 200.698 257.743 200.735 257.809C200.927 258.931 201.2 260.016 201.37 260.496C201.384 260.57 201.288 260.703 201.222 260.717C200.912 260.754 200.292 260.865 198.07 261.396L193.826 262.408C193.132 262.555 192.387 262.747 191.9 262.887Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M210.286 257.389C210.33 257.411 210.382 257.64 210.338 257.676C209.924 257.817 209.009 258.141 208.404 258.378C207.828 258.599 207.319 258.813 206.95 258.968C206.891 258.968 206.773 258.761 206.795 258.717C207.282 258.319 207.526 257.647 207.998 255.957L209.29 251.373L205.141 248.598C203.769 247.69 203.377 247.417 202.595 247.35C202.551 247.328 202.499 247.099 202.543 247.062C202.92 246.937 203.739 246.664 204.418 246.406C205.156 246.125 205.939 245.786 206.315 245.623C206.374 245.623 206.492 245.83 206.47 245.874C205.916 246.391 205.85 246.878 207.001 247.66L210.109 249.771L211.032 246.391C211.364 245.143 211.15 244.472 210.013 244.523C209.969 244.501 209.917 244.272 209.961 244.236C210.375 244.095 211.29 243.763 211.895 243.534C212.449 243.32 212.98 243.099 213.349 242.944C213.408 242.944 213.526 243.15 213.504 243.195C213.017 243.593 212.773 244.265 212.301 245.955L211.083 250.281L215.46 253.203C216.826 254.111 217.224 254.384 217.999 254.451C218.044 254.473 218.095 254.702 218.051 254.739C217.674 254.864 216.855 255.137 216.176 255.396C215.438 255.676 214.656 256.016 214.279 256.178C214.22 256.178 214.102 255.971 214.124 255.927C214.678 255.403 214.744 254.916 213.593 254.141L210.257 251.868L209.26 255.529C208.928 256.769 209.149 257.44 210.286 257.389Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M210.286 257.389C210.33 257.411 210.382 257.64 210.338 257.676C209.924 257.817 209.009 258.141 208.404 258.378C207.828 258.599 207.319 258.813 206.95 258.968C206.891 258.968 206.773 258.761 206.795 258.717C207.282 258.319 207.526 257.647 207.998 255.957L209.29 251.373L205.141 248.598C203.769 247.69 203.377 247.417 202.595 247.35C202.551 247.328 202.499 247.099 202.543 247.062C202.92 246.937 203.739 246.664 204.418 246.406C205.156 246.125 205.939 245.786 206.315 245.623C206.374 245.623 206.492 245.83 206.47 245.874C205.916 246.391 205.85 246.878 207.001 247.66L210.109 249.771L211.032 246.391C211.364 245.143 211.15 244.472 210.013 244.523C209.969 244.501 209.917 244.272 209.961 244.236C210.375 244.095 211.29 243.763 211.895 243.534C212.449 243.32 212.98 243.099 213.349 242.944C213.408 242.944 213.526 243.15 213.504 243.195C213.017 243.593 212.773 244.265 212.301 245.955L211.083 250.281L215.46 253.203C216.826 254.111 217.224 254.384 217.999 254.451C218.044 254.473 218.095 254.702 218.051 254.739C217.674 254.864 216.855 255.137 216.176 255.396C215.438 255.676 214.656 256.016 214.279 256.178C214.22 256.178 214.102 255.971 214.124 255.927C214.678 255.403 214.744 254.916 213.593 254.141L210.257 251.868L209.26 255.529C208.928 256.769 209.149 257.44 210.286 257.389Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M222.929 245.793L224.531 248.679C225.195 249.875 225.66 250.236 226.619 250.14C226.671 250.155 226.752 250.376 226.715 250.421C226.206 250.657 225.616 250.967 224.974 251.329C224.331 251.69 223.756 252.03 223.283 252.325C223.224 252.332 223.084 252.148 223.099 252.096C223.689 251.336 223.63 250.753 222.966 249.55L219.312 242.959C218.648 241.763 218.183 241.401 217.223 241.497C217.172 241.482 217.091 241.261 217.135 241.217C217.644 240.98 218.235 240.67 218.877 240.309C219.526 239.947 220.095 239.608 220.567 239.312C220.626 239.305 220.766 239.489 220.752 239.541C220.161 240.301 220.22 240.884 220.884 242.088L222.42 244.863L228.265 241.623L226.73 238.847C226.066 237.652 225.601 237.29 224.641 237.386C224.59 237.371 224.509 237.15 224.545 237.105C225.055 236.862 225.645 236.559 226.287 236.197C226.937 235.843 227.505 235.504 227.978 235.201C228.037 235.186 228.177 235.378 228.162 235.43C227.572 236.19 227.631 236.773 228.295 237.976L231.949 244.568C232.613 245.763 233.078 246.125 234.037 246.029C234.089 246.044 234.17 246.265 234.126 246.31C233.617 246.553 233.026 246.856 232.384 247.217C231.735 247.572 231.166 247.911 230.694 248.214C230.635 248.221 230.495 248.037 230.509 247.985C231.1 247.225 231.041 246.642 230.376 245.439L228.775 242.553L222.929 245.793Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M222.929 245.793L224.531 248.679C225.195 249.875 225.66 250.236 226.619 250.14C226.671 250.155 226.752 250.376 226.715 250.421C226.206 250.657 225.616 250.967 224.974 251.329C224.331 251.69 223.756 252.03 223.283 252.325C223.224 252.332 223.084 252.148 223.099 252.096C223.689 251.336 223.63 250.753 222.966 249.55L219.312 242.959C218.648 241.763 218.183 241.401 217.223 241.497C217.172 241.482 217.091 241.261 217.135 241.217C217.644 240.98 218.235 240.67 218.877 240.309C219.526 239.947 220.095 239.608 220.567 239.312C220.626 239.305 220.766 239.489 220.752 239.541C220.161 240.301 220.22 240.884 220.884 242.088L222.42 244.863L228.265 241.623L226.73 238.847C226.066 237.652 225.601 237.29 224.641 237.386C224.59 237.371 224.509 237.15 224.545 237.105C225.055 236.862 225.645 236.559 226.287 236.197C226.937 235.843 227.505 235.504 227.978 235.201C228.037 235.186 228.177 235.378 228.162 235.43C227.572 236.19 227.631 236.773 228.295 237.976L231.949 244.568C232.613 245.763 233.078 246.125 234.037 246.029C234.089 246.044 234.17 246.265 234.126 246.31C233.617 246.553 233.026 246.856 232.384 247.217C231.735 247.572 231.166 247.911 230.694 248.214C230.635 248.221 230.495 248.037 230.509 247.985C231.1 247.225 231.041 246.642 230.376 245.439L228.775 242.553L222.929 245.793Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M242.985 239.755C243.036 239.762 243.14 239.977 243.11 240.021C242.623 240.331 242.04 240.729 241.413 241.18C240.785 241.63 240.224 242.058 239.781 242.427C239.722 242.442 239.56 242.272 239.567 242.228C240.099 241.335 239.988 240.744 239.154 239.593L234.851 233.629C234.017 232.477 233.5 232.182 232.482 232.404C232.43 232.396 232.327 232.182 232.356 232.138C232.843 231.828 233.426 231.429 234.054 230.979C234.681 230.529 235.242 230.101 235.685 229.732C235.737 229.717 235.906 229.887 235.899 229.931C235.368 230.824 235.478 231.414 236.312 232.566L240.615 238.53C241.442 239.689 241.966 239.984 242.985 239.755Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M242.985 239.755C243.036 239.762 243.14 239.977 243.11 240.021C242.623 240.331 242.04 240.729 241.413 241.18C240.785 241.63 240.224 242.058 239.781 242.427C239.722 242.442 239.56 242.272 239.567 242.228C240.099 241.335 239.988 240.744 239.154 239.593L234.851 233.629C234.017 232.477 233.5 232.182 232.482 232.404C232.43 232.396 232.327 232.182 232.356 232.138C232.843 231.828 233.426 231.429 234.054 230.979C234.681 230.529 235.242 230.101 235.685 229.732C235.737 229.717 235.906 229.887 235.899 229.931C235.368 230.824 235.478 231.414 236.312 232.566L240.615 238.53C241.442 239.689 241.966 239.984 242.985 239.755Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M251.227 231.939C252.645 230.684 252.785 229.591 251.692 228.366C250.563 227.097 249.456 227.126 248.054 228.366L246.112 230.093L249.286 233.666L251.227 231.939ZM247.065 227.849C248.467 226.602 248.592 225.554 247.522 224.351C246.43 223.126 245.345 223.126 243.957 224.358L242.311 225.82L245.411 229.311L247.065 227.849ZM247.876 236.389C247.825 236.411 247.64 236.264 247.648 236.212C248.031 235.341 247.84 234.743 246.821 233.599L242.23 228.44C241.101 227.17 240.495 226.897 239.595 227.163C239.543 227.163 239.418 226.964 239.44 226.912C239.831 226.587 240.422 226.085 240.946 225.62L243.263 223.561C245.404 221.657 247.552 221.413 248.843 222.867C249.773 223.915 249.796 225.296 248.961 226.691C250.607 225.775 252.128 225.879 253.176 227.067C254.578 228.647 254.091 230.809 251.921 232.743L249.323 235.053C248.806 235.511 248.245 236.042 247.876 236.389Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M251.227 231.939C252.645 230.684 252.785 229.591 251.692 228.366C250.563 227.097 249.456 227.126 248.054 228.366L246.112 230.093L249.286 233.666L251.227 231.939ZM247.065 227.849C248.467 226.602 248.592 225.554 247.522 224.351C246.43 223.126 245.345 223.126 243.957 224.358L242.311 225.82L245.411 229.311L247.065 227.849ZM247.876 236.389C247.825 236.411 247.64 236.264 247.648 236.212C248.031 235.341 247.84 234.743 246.821 233.599L242.23 228.44C241.101 227.17 240.495 226.897 239.595 227.163C239.543 227.163 239.418 226.964 239.44 226.912C239.831 226.587 240.422 226.085 240.946 225.62L243.263 223.561C245.404 221.657 247.552 221.413 248.843 222.867C249.773 223.915 249.796 225.296 248.961 226.691C250.607 225.775 252.128 225.879 253.176 227.067C254.578 228.647 254.091 230.809 251.921 232.743L249.323 235.053C248.806 235.511 248.245 236.042 247.876 236.389Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M262.086 222.21C262.138 222.21 262.286 222.395 262.263 222.447C261.85 222.845 261.356 223.355 260.831 223.923C260.307 224.491 259.842 225.023 259.481 225.473C259.429 225.502 259.23 225.37 259.23 225.318C259.569 224.336 259.341 223.783 258.292 222.816L252.875 217.841C251.827 216.874 251.258 216.697 250.306 217.118C250.254 217.118 250.107 216.933 250.129 216.881C250.542 216.483 251.037 215.973 251.561 215.405C252.085 214.837 252.55 214.305 252.912 213.855C252.963 213.826 253.155 213.958 253.163 214.01C252.823 214.992 253.052 215.545 254.1 216.505L259.518 221.48C260.566 222.454 261.134 222.631 262.086 222.21Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M262.086 222.21C262.138 222.21 262.286 222.395 262.263 222.447C261.85 222.845 261.356 223.355 260.831 223.923C260.307 224.491 259.842 225.023 259.481 225.473C259.429 225.502 259.23 225.37 259.23 225.318C259.569 224.336 259.341 223.783 258.292 222.816L252.875 217.841C251.827 216.874 251.258 216.697 250.306 217.118C250.254 217.118 250.107 216.933 250.129 216.881C250.542 216.483 251.037 215.973 251.561 215.405C252.085 214.837 252.55 214.305 252.912 213.855C252.963 213.826 253.155 213.958 253.163 214.01C252.823 214.992 253.052 215.545 254.1 216.505L259.518 221.48C260.566 222.454 261.134 222.631 262.086 222.21Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M262.161 201.927C262.205 201.868 262.352 201.824 262.419 201.854C262.751 202.164 263.829 202.946 264.722 203.5C264.766 203.559 264.648 203.78 264.574 203.795C263.164 203.418 262.323 203.736 261.216 205.227L260.492 206.194L267.652 211.53C268.796 212.379 269.379 212.505 270.28 211.98C270.331 211.973 270.494 212.143 270.479 212.195C270.103 212.637 269.667 213.191 269.21 213.811C268.745 214.431 268.339 215.007 268.021 215.494C267.977 215.523 267.763 215.413 267.755 215.361C267.992 214.35 267.711 213.818 266.567 212.97L259.407 207.633L258.684 208.6C257.577 210.091 257.511 210.984 258.271 212.231C258.286 212.305 258.101 212.49 258.035 212.46C257.252 211.766 256.189 210.955 255.798 210.726C255.754 210.667 255.754 210.512 255.798 210.453C256.064 210.224 256.64 209.567 257.732 208.098L260.448 204.452C261.555 202.983 262.013 202.245 262.161 201.927Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M262.161 201.927C262.205 201.868 262.352 201.824 262.419 201.854C262.751 202.164 263.829 202.946 264.722 203.5C264.766 203.559 264.648 203.78 264.574 203.795C263.164 203.418 262.323 203.736 261.216 205.227L260.492 206.194L267.652 211.53C268.796 212.379 269.379 212.505 270.28 211.98C270.331 211.973 270.494 212.143 270.479 212.195C270.103 212.637 269.667 213.191 269.21 213.811C268.745 214.431 268.339 215.007 268.021 215.494C267.977 215.523 267.763 215.413 267.755 215.361C267.992 214.35 267.711 213.818 266.567 212.97L259.407 207.633L258.684 208.6C257.577 210.091 257.511 210.984 258.271 212.231C258.286 212.305 258.101 212.49 258.035 212.46C257.252 211.766 256.189 210.955 255.798 210.726C255.754 210.667 255.754 210.512 255.798 210.453C256.064 210.224 256.64 209.567 257.732 208.098L260.448 204.452C261.555 202.983 262.013 202.245 262.161 201.927Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M277.512 200.731C277.564 200.717 277.741 200.872 277.733 200.923C277.408 201.403 277.032 201.994 276.641 202.665C276.242 203.33 275.903 203.942 275.637 204.459C275.593 204.496 275.371 204.407 275.364 204.356C275.497 203.322 275.157 202.828 273.932 202.104L267.606 198.347C266.381 197.617 265.791 197.558 264.942 198.17C264.89 198.185 264.713 198.03 264.72 197.978C265.045 197.499 265.422 196.908 265.813 196.236C266.211 195.572 266.551 194.96 266.817 194.443C266.861 194.406 267.082 194.494 267.09 194.546C266.957 195.58 267.296 196.074 268.522 196.797L274.847 200.554C276.073 201.278 276.663 201.337 277.512 200.731Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M277.512 200.731C277.564 200.717 277.741 200.872 277.733 200.923C277.408 201.403 277.032 201.994 276.641 202.665C276.242 203.33 275.903 203.942 275.637 204.459C275.593 204.496 275.371 204.407 275.364 204.356C275.497 203.322 275.157 202.828 273.932 202.104L267.606 198.347C266.381 197.617 265.791 197.558 264.942 198.17C264.89 198.185 264.713 198.03 264.72 197.978C265.045 197.499 265.422 196.908 265.813 196.236C266.211 195.572 266.551 194.96 266.817 194.443C266.861 194.406 267.082 194.494 267.09 194.546C266.957 195.58 267.296 196.074 268.522 196.797L274.847 200.554C276.073 201.278 276.663 201.337 277.512 200.731Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M279.085 183.947C275.852 182.478 273.438 182.988 272.339 185.416C271.239 187.83 272.412 189.963 275.645 191.432C278.878 192.9 281.292 192.391 282.392 189.963C283.491 187.549 282.318 185.416 279.085 183.947ZM274.855 193.255C271.342 191.66 269.903 188.206 271.379 184.958C272.87 181.674 276.346 180.522 279.875 182.124C283.388 183.718 284.827 187.173 283.351 190.42C281.86 193.705 278.384 194.856 274.855 193.255Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M279.085 183.947C275.852 182.478 273.438 182.988 272.339 185.416C271.239 187.83 272.412 189.963 275.645 191.432C278.878 192.9 281.292 192.391 282.392 189.963C283.491 187.549 282.318 185.416 279.085 183.947ZM274.855 193.255C271.342 191.66 269.903 188.206 271.379 184.958C272.87 181.674 276.346 180.522 279.875 182.124C283.388 183.718 284.827 187.173 283.351 190.42C281.86 193.705 278.384 194.856 274.855 193.255Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M290.748 169.082L278.798 174.226L285.374 176.145C287.02 176.625 287.692 176.581 288.43 175.784C288.474 175.762 288.688 175.858 288.696 175.917C288.563 176.308 288.349 176.98 288.179 177.548C288.009 178.116 287.832 178.803 287.736 179.201C287.707 179.246 287.471 179.216 287.441 179.172C287.249 178.101 286.71 177.695 285.064 177.216L278.473 175.289C277.159 174.905 276.495 174.994 275.86 175.673C275.816 175.695 275.602 175.599 275.594 175.54C275.735 175.127 275.941 174.492 276.111 173.909C276.31 173.237 276.406 172.831 276.517 172.322C276.547 172.278 276.694 172.226 276.768 172.241C277.292 172.617 277.92 172.617 278.909 172.189L287.22 168.683L281.337 166.963C279.691 166.484 279.019 166.528 278.281 167.325C278.237 167.347 278.023 167.251 278.015 167.192C278.148 166.801 278.362 166.129 278.532 165.561C278.702 164.993 278.879 164.314 278.982 163.908C279.012 163.863 279.248 163.893 279.27 163.937C279.462 165.007 280.001 165.406 281.647 165.893L290.785 168.565C290.844 168.624 290.814 169.03 290.748 169.082Z",
        fill: "white"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M290.748 169.082L278.798 174.226L285.374 176.145C287.02 176.625 287.692 176.581 288.43 175.784C288.474 175.762 288.688 175.858 288.696 175.917C288.563 176.308 288.349 176.98 288.179 177.548C288.009 178.116 287.832 178.803 287.736 179.201C287.707 179.246 287.471 179.216 287.441 179.172C287.249 178.101 286.71 177.695 285.064 177.216L278.473 175.289C277.159 174.905 276.495 174.994 275.86 175.673C275.816 175.695 275.602 175.599 275.594 175.54C275.735 175.127 275.941 174.492 276.111 173.909C276.31 173.237 276.406 172.831 276.517 172.322C276.547 172.278 276.694 172.226 276.768 172.241C277.292 172.617 277.92 172.617 278.909 172.189L287.22 168.683L281.337 166.963C279.691 166.484 279.019 166.528 278.281 167.325C278.237 167.347 278.023 167.251 278.015 167.192C278.148 166.801 278.362 166.129 278.532 165.561C278.702 164.993 278.879 164.314 278.982 163.908C279.012 163.863 279.248 163.893 279.27 163.937C279.462 165.007 280.001 165.406 281.647 165.893L290.785 168.565C290.844 168.624 290.814 169.03 290.748 169.082Z",
        fill: "white"
    })), $0422a6ce4ea03acc$var$EU = {
    appleAppStoreBlack: $0422a6ce4ea03acc$var$Ez,
    appleAppStoreWhite: $0422a6ce4ea03acc$var$Sz,
    bplBlack: $0422a6ce4ea03acc$var$kz,
    bplWhite: $0422a6ce4ea03acc$var$Tz,
    cleverBadgeColor: $0422a6ce4ea03acc$var$_z,
    cleverColor: $0422a6ce4ea03acc$var$Dz,
    cleverWhite: $0422a6ce4ea03acc$var$Rz,
    digitalCollectionsBlack: $0422a6ce4ea03acc$var$Zz,
    digitalCollectionsWhite: $0422a6ce4ea03acc$var$Oz,
    firstbookColor: $0422a6ce4ea03acc$var$Nz,
    firstbookColorNegative: $0422a6ce4ea03acc$var$Pz,
    googlePlayBlack: $0422a6ce4ea03acc$var$Bz,
    lpaBlack: $0422a6ce4ea03acc$var$Az,
    lpaColor: $0422a6ce4ea03acc$var$Fz,
    lpaWhite: $0422a6ce4ea03acc$var$jz,
    mlnBlack: $0422a6ce4ea03acc$var$zz,
    mlnColor: $0422a6ce4ea03acc$var$Uz,
    mlnWhite: $0422a6ce4ea03acc$var$Iz,
    nycdoeBlack: $0422a6ce4ea03acc$var$$z,
    nycdoeColor: $0422a6ce4ea03acc$var$Yz,
    nycdoeWhite: $0422a6ce4ea03acc$var$Wz,
    nycpsBlack: $0422a6ce4ea03acc$var$Qz,
    nycpsColor: $0422a6ce4ea03acc$var$qz,
    nycpsWhite: $0422a6ce4ea03acc$var$Gz,
    nyplFullBlack: $0422a6ce4ea03acc$var$Xz,
    nyplFullWhite: $0422a6ce4ea03acc$var$Kz,
    nyplLionBlack: $0422a6ce4ea03acc$var$Jz,
    nyplLionWhite: $0422a6ce4ea03acc$var$eU,
    nyplTextBlack: $0422a6ce4ea03acc$var$tU,
    nyplTextWhite: $0422a6ce4ea03acc$var$nU,
    openebooksColor: $0422a6ce4ea03acc$var$rU,
    openebooksNegative: $0422a6ce4ea03acc$var$aU,
    openebooksWithTextColor: $0422a6ce4ea03acc$var$iU,
    openebooksWithTextNegative: $0422a6ce4ea03acc$var$oU,
    qplAltBlack: $0422a6ce4ea03acc$var$lU,
    qplAltWhite: $0422a6ce4ea03acc$var$sU,
    qplBlack: $0422a6ce4ea03acc$var$uU,
    qplColor: $0422a6ce4ea03acc$var$cU,
    qplWhite: $0422a6ce4ea03acc$var$dU,
    reservoirIconColor: $0422a6ce4ea03acc$var$CU,
    reservoirVerticalColor: $0422a6ce4ea03acc$var$fU,
    schomburgBlack: $0422a6ce4ea03acc$var$pU,
    schomburgCircleBlack: $0422a6ce4ea03acc$var$hU,
    schomburgCircleColor: $0422a6ce4ea03acc$var$mU,
    schomburgCircleWhite: $0422a6ce4ea03acc$var$vU,
    schomburgColor: $0422a6ce4ea03acc$var$gU,
    schomburgWhite: $0422a6ce4ea03acc$var$yU,
    simplyeBlack: $0422a6ce4ea03acc$var$LU,
    simplyeWhite: $0422a6ce4ea03acc$var$bU,
    simplyeColor: $0422a6ce4ea03acc$var$wU,
    snflBlack: $0422a6ce4ea03acc$var$HU,
    snflWhite: $0422a6ce4ea03acc$var$xU,
    treasuresColor: $0422a6ce4ea03acc$var$VU,
    treasuresColorNegative: $0422a6ce4ea03acc$var$MU
}, $0422a6ce4ea03acc$export$e6ff31bff12b7ff4 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    var Z, O;
    const { children: o, className: s, decorative: i = !1, id: p, name: C, size: v = "medium", sizeBasedOn: y = "width", title: L = `${C} logo`, ...M } = r, E = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Logo", {
        size: v,
        sizeBasedOn: y
    }), k = {
        "aria-hidden": i,
        className: s,
        id: p,
        role: "img",
        title: L,
        ...M
    };
    let _ = null;
    if (C && o) return console.warn("NYPL Reservoir Logo: Pass either a `name` prop or an `svg` element child. Do not pass both."), null;
    if (!C && !o) return console.warn("NYPL Reservoir Logo: Pass a logo `name` prop or an SVG child to `Logo` to ensure a logo appears."), null;
    if (C) {
        const B = $0422a6ce4ea03acc$var$EU[C];
        return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $6a96cde036d65913$export$f04a61298a47a40f), {
            as: B,
            ref: a,
            ...k,
            __css: E
        });
    }
    return o.type === "svg" || ((Z = o.props) == null ? void 0 : Z.type) === "svg" || ((O = o.props) == null ? void 0 : O.mdxType) === "svg" ? _ = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(o, {
        ...k,
        ref: a
    }) : console.warn("NYPL Reservoir Logo: An `svg` element must be passed to the `Logo` component as its child."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        ref: a,
        __css: E,
        children: _
    });
}));
class $0422a6ce4ea03acc$export$f2000d8ab0cc6761 {
    constructor(){
        $0422a6ce4ea03acc$var$Nu(this, "mediaQueries", {});
        $0422a6ce4ea03acc$var$Nu(this, "prevMatchMap", /* @__PURE__ */ new Map());
        $0422a6ce4ea03acc$var$Nu(this, "mediaQueryList");
        Object.defineProperty(window, "matchMedia", {
            writable: !0,
            configurable: !0,
            value: (a)=>(this.mediaQueryList = {
                    matches: this.evalQuery(a),
                    media: a,
                    onchange: null,
                    addListener: (o)=>{
                        this.addListener(a, o);
                    },
                    removeListener: (o)=>{
                        this.removeListener(a, o);
                    },
                    addEventListener: (o, s)=>{
                        o === "change" && this.addListener(a, s);
                    },
                    removeEventListener: (o, s)=>{
                        o === "change" && this.removeListener(a, s);
                    },
                    dispatchEvent: jest.fn()
                }, this.mediaQueryList)
        }), window.addEventListener("resize", ()=>this.handleResize());
    }
    // eslint-disable-next-line class-methods-use-this
    compileQuery(a) {
        function o(i) {
            switch(i){
                case "cm":
                    return 37.7952;
                case "em":
                case "rem":
                    return 16;
                case "in":
                case "dppx":
                    return 96;
                case "mm":
                    return 3.77952;
                case "pc":
                    return 16;
                case "pt":
                    return 96 / 72;
                case "px":
                default:
                    return 1;
            }
        }
        const s = (i, p, C)=>String(+p * o(C));
        return "try { return !!(%s) } catch(e) { return false }".replace("%s", a.split(/\s*,\s*/g).map((i)=>i.replace(/^\s*only\s+/, "").replace(/^\s*not\s*(.+)/, "!($1)").replace(/(?:min-)([\w.]+)\s*:\s*/g, "media.$1 >= ").replace(/(?:max-)([\w.]+)\s*:\s*/g, "media.$1 <= ").replace(/([\w.]+)\s*:\s*/g, "media.$1 === ").replace(/\s*all|screen\s*/g, "true").replace(/\s*print\s*/g, "false").replace(/[\s()]+or[\s()]+/g, " || ").replace(/\s*and\s*/g, " && ").replace(/dpi/g, "").replace(/(\d+)(cm|em|in|dppx|mm|pc|pt|px|rem)/g, s).replace(/^(.*)$/, "($1)")).join(" || "));
    }
    evalQuery(a) {
        return !!new Function("media", this.compileQuery(a))({
            width: window.innerWidth,
            height: window.innerHeight,
            orientation: window.screen.orientation ? window.screen.orientation.type.replace(/^(landscape|portrait).*$/, "$1") : "landscape"
        });
    }
    /**
   *
   * Adds a listener function for the window resize event
   * @private
   */ handleResize() {
        for (const [a, o] of Object.entries(this.mediaQueries)){
            const s = this.evalQuery(a);
            if (this.prevMatchMap.get(a) !== s) {
                this.prevMatchMap.set(a, s);
                const i = {
                    matches: s,
                    media: a
                };
                o.forEach((p)=>{
                    p == null || p.call(this.mediaQueryList, i);
                });
            }
        }
    }
    addListener(a, o) {
        this.mediaQueries[a] || (this.mediaQueries[a] = []);
        const s = this.mediaQueries[a];
        s.indexOf(o) === -1 && (s.push(o), this.prevMatchMap.has(a) || this.prevMatchMap.set(a, this.evalQuery(a)));
    }
    removeListener(a, o) {
        if (!this.mediaQueries[a]) return;
        const s = this.mediaQueries[a], i = s.indexOf(o);
        i === -1 && (s.splice(i, 1), s.length === 0 && this.prevMatchMap.has(a) && this.prevMatchMap.delete(a));
    }
    /**
   * Returns an array listing the media queries for which the matchMedia has registered listeners
   * @public
   */ getMediaQueries() {
        return Object.keys(this.mediaQueries);
    }
    /**
   * Returns a copy of the array of listeners for the specified media query
   * @public
   */ getListeners(a) {
        return this.mediaQueries[a] ? this.mediaQueries[a].slice() : [];
    }
    /**
   * Clears all registered media queries and their listeners
   * @public
   */ clear() {
        this.mediaQueries = {};
    }
    /**
   * Clears all registered media queries and their listeners,
   * and destroys the implementation of `window.matchMedia`
   * @public
   */ destroy() {
        this.clear(), delete window.matchMedia;
    }
}
const $0422a6ce4ea03acc$export$d9b273488cd8ce6f = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)(({ className: r, id: a, labelText: o, listAlignment: s = "left", selectedItem: i, highlightColor: p = "blogs", showBorder: C = !0, showLabel: v = !0, listItemsData: y, ...L }, M)=>{
    const E = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Menu", {
        highlightColor: p,
        showBorder: C,
        showLabel: v
    }), [k, _] = (0, $acw62.useState)(i), Z = (P, $)=>{
        $ && $(P), _(P);
    };
    y ? i && !y.map((P)=>P.id).includes(k) ? console.warn("NYPL Reservoir Menu: The `selectedItem` prop does not match any of the menu items.") : new Set(y.map((P)=>P.id)).size !== y.length ? console.warn("NYPL Reservoir Menu: The `id` values for the list items are not all unique.") : y.some((P)=>!P.type || !(P.type === "group" || P.type === "action" || P.type === "divider")) ? console.warn("NYPL Reservoir Menu: A `type` value is required for each list item.") : y.some((P)=>!P.id || P.id === "") ? console.warn("NYPL Reservoir Menu: An `id` value is required for each list item.") : y.some((P)=>(P.type === "action" || P.type === "group") && (!P.label || P.label.trim() === "")) ? console.warn("NYPL Reservoir Menu: A `label` value is required for all list actions and groups.") : y.some((P)=>P.type === "action" && !P.onClick) ? console.warn("NYPL Reservoir Menu: An `onClick` function is required for all actions.") : y.some((P)=>P.type === "group" && (!P.children || P.children.length === 0)) && console.warn("NYPL Reservoir Menu: A `children` array is required for all list groups.") : console.warn("NYPL Reservoir Menu: The `listItemsData` prop is required.");
    const O = (P)=>P ? P.type === "icon" ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
            name: P.name,
            size: "medium"
        }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$3e431a229df88919, {
            src: P.src,
            alt: P.alt,
            size: "xxxsmall",
            sx: {
                borderRadius: "24px"
            }
        }) : null, B = (P)=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $a5c35d2b61ef6439$export$266a769812832828), {
            sx: E.menuButton,
            "aria-label": v ? "" : o,
            backgroundColor: P ? "ui.link.primary-05 !important" : "unset",
            children: [
                v && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                    children: [
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                            as: "span",
                            sx: {
                                paddingRight: "xs"
                            },
                            children: o
                        }),
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                            name: "arrow",
                            iconRotation: P ? "rotate180" : "rotate0",
                            size: "xsmall"
                        })
                    ]
                }),
                !v && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                    name: "navigationMoreVert",
                    size: "large"
                })
            ]
        }), z = (P = [])=>P.reduce(($, W)=>{
            if (W.type === "divider") return [
                ...$,
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $c13511f8b7e83bea$export$acb07b4664ac227c), {
                    sx: E.dividerItem
                }, W.id)
            ];
            if (W.type === "group") return [
                ...$,
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2663798dec8fa87a$export$22a631d1f72787bb), {
                    sx: E.groupItem,
                    title: W.label
                }, W.id),
                ...z(W.children)
            ];
            const l1 = k === W.id, u1 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $598b741191098976$export$2ce376c2cc3355c8), {
                isFocusable: !0,
                "data-testid": l1 ? "selected-item" : "",
                onClick: ()=>Z(W.id, W.onClick),
                ref: l1 ? I : null,
                sx: {
                    ...E.actionItem,
                    ...l1 && E.selected
                },
                children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                    },
                    children: [
                        O(W.media),
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                            children: W.label
                        })
                    ]
                })
            }, W.id);
            return [
                ...$,
                u1
            ];
        }, []), I = (0, $acw62.useRef)();
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        ref: M,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $ecb323b85332da3d$export$d9b273488cd8ce6f), {
            id: a,
            initialFocusRef: k ? I : null,
            ...L,
            children: ({ isOpen: P })=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2231dd843a1dfd59$export$f51f4c4ede09e011), {
                    flexDirection: s === "right" ? "row-reverse" : "row",
                    children: [
                        B(P),
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $ce1d48c66e9cd398$export$d4c4e98c5044dc8), {
                            "data-testid": "menuList",
                            sx: E.menuList,
                            children: z(y)
                        })
                    ]
                })
        })
    });
}));
function $0422a6ce4ea03acc$var$Zo(r) {
    return r === "default";
}
const $0422a6ce4ea03acc$var$gc = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((r)=>{
    const { bodyContent: a, closeButtonLabel: o = "Close", headingText: s, confirmButtonLabel: i = "Confirm", onCancel: p, onConfirm: C, onClose: v, type: y = "default", id: L, isOpen: M, ...E } = r, k = "xl", _ = "full", { isLargerThanMobile: Z } = $0422a6ce4ea03acc$export$f67a0166accba89c(), O = Z ? k : _, B = $0422a6ce4ea03acc$var$Yr({
        title: s,
        id: L,
        headingSize: "heading4"
    });
    return (!$0422a6ce4ea03acc$var$Zo(y) && v || $0422a6ce4ea03acc$var$Zo(y) && (p || C)) && console.warn("NYPL Reservoir Modal: A combination of `onClose`, `onConfirm`, `onCancel`, and `confirmButtonLabel` props have been passed, but they can not be used as they are currently configured. Either pass the `onClose` prop (with the default type) or pass the `onCancel`, `onConfirm`, and `confirmButtonLabel` props (with the confirmation type)."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$x.Fragment, {
        children: $0422a6ce4ea03acc$var$Zo(y) ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $4410258333ca5546$export$2b77a92f1a5ad772), {
            id: L,
            isOpen: M,
            onClose: v,
            scrollBehavior: "inside",
            size: O,
            ...E,
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $006bfa297e893b21$export$8948f78d83984c69), {}),
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $d3f1b418b5859157$export$6da19a24bf249f17), {
                    children: [
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $fae03f3c1cb3a345$export$f50a68e3694789ee), {
                            children: B
                        }),
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2e9ac767eb870fd0$export$edf9108895ba774f), {}),
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $0caf763c70514c51$export$cb540d8b0ef7906c), {
                            children: a
                        }),
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $c1a0e057d30d876e$export$519437715052e656), {
                            children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$69b1032f2ecdf404, {
                                children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                                    id: "modal-close-btn",
                                    onClick: v,
                                    children: o
                                })
                            })
                        })
                    ]
                })
            ]
        }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $4410258333ca5546$export$2b77a92f1a5ad772), {
            id: L,
            isOpen: M,
            onClose: p,
            scrollBehavior: "inside",
            size: O,
            ...E,
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $006bfa297e893b21$export$8948f78d83984c69), {}),
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $d3f1b418b5859157$export$6da19a24bf249f17), {
                    children: [
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $fae03f3c1cb3a345$export$f50a68e3694789ee), {
                            children: B
                        }),
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2e9ac767eb870fd0$export$edf9108895ba774f), {}),
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $0caf763c70514c51$export$cb540d8b0ef7906c), {
                            children: a
                        }),
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $c1a0e057d30d876e$export$519437715052e656), {
                            children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$69b1032f2ecdf404, {
                                children: [
                                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                                        buttonType: "secondary",
                                        id: "modal-cancel-btn",
                                        onClick: p,
                                        children: o
                                    }),
                                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                                        id: "modal-confirm-btn",
                                        onClick: C,
                                        children: i
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}), $0422a6ce4ea03acc$export$fb10b32cfe19f1e = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)(({ buttonText: r, id: a, modalProps: o, ...s }, i)=>{
    const { isOpen: p, onOpen: C, onClose: v } = (0, $8b7bde38f2a271a2$export$6e3e27031a30522f)(), y = ()=>{
        o.onClose && o.onClose(), v();
    }, L = ()=>{
        o.onCancel && o.onCancel(), v();
    }, M = ()=>{
        o.onConfirm && o.onConfirm(), v();
    };
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                id: "modal-open-btn",
                onClick: C,
                ref: i,
                children: r
            }),
            $0422a6ce4ea03acc$var$Zo(o.type) ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$gc, {
                bodyContent: o.bodyContent,
                headingText: o.headingText,
                id: o.id,
                type: o.type,
                isOpen: p,
                onClose: y,
                closeButtonLabel: o.closeButtonLabel,
                ...s
            }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$gc, {
                bodyContent: o.bodyContent,
                headingText: o.headingText,
                closeButtonLabel: o.closeButtonLabel,
                confirmButtonLabel: o.confirmButtonLabel,
                onConfirm: M,
                onCancel: L,
                id: o.id,
                type: o.type,
                isOpen: p,
                ...s
            })
        ]
    });
}));
function $0422a6ce4ea03acc$export$33ffd74ebf07f060() {
    const { isOpen: r, onClose: a, onOpen: o } = (0, $8b7bde38f2a271a2$export$6e3e27031a30522f)(), s = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)(({ bodyContent: i, closeButtonLabel: p, headingText: C, confirmButtonLabel: v, onCancel: y, onConfirm: L, onClose: M, type: E, id: k, ..._ })=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$x.Fragment, {
            children: $0422a6ce4ea03acc$var$Zo(E) ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$gc, {
                bodyContent: i,
                headingText: C,
                id: k,
                type: E,
                isOpen: r,
                onClose: M,
                closeButtonLabel: p,
                ..._
            }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$gc, {
                bodyContent: i,
                headingText: C,
                closeButtonLabel: p,
                confirmButtonLabel: v,
                onConfirm: L,
                onCancel: y,
                id: k,
                type: E,
                isOpen: r,
                ..._
            })
        }));
    return {
        onClose: a,
        onOpen: o,
        Modal: s
    };
}
const $0422a6ce4ea03acc$var$SU = (0, $acw62.forwardRef)((r, a)=>{
    const { isOpen: o, multiSelectId: s, multiSelectLabelText: i, accordionButtonRef: p, onClear: C, selectedItemsString: v, selectedItemsCount: y } = r;
    let L = `remove ${y} ${v} selected from ${i}`;
    const M = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("MultiSelectItemsCountButton", {
        isOpen: o
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
        id: `ms-count-button-${s}`,
        buttonType: "pill",
        size: "small",
        "aria-label": L,
        "data-testid": "multi-select-close-button-testid",
        onClick: ()=>{
            var E;
            C && C(), (E = p.current) == null || E.focus();
        },
        __css: M,
        children: [
            y,
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                align: "right",
                id: `ms-count-icon-${s}`,
                marginLeft: "xs",
                name: "close",
                size: "xsmall",
                title: "Remove selected items"
            })
        ]
    });
}), $0422a6ce4ea03acc$export$1e7dfd31545b5809 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    var I2;
    const { id: o, isBlockElement: s = !1, isDefaultOpen: i = !1, isSearchable: p = !1, defaultItemsVisible: C = 5, items: v, listOverflow: y = "scroll", buttonText: L, closeOnBlur: M = !1, onChange: E, onClear: k, onMixedStateChange: _, selectedItems: Z, width: O = "full", ...B } = r, [z, I] = (0, $acw62.useState)(!1), P = (0, $acw62.useRef)(), $ = (0, $acw62.useRef)(), W = (0, $acw62.useRef)(), l1 = (T1)=>{
        if (T1.type === "mousedown") {
            const j1 = $.current;
            j1 && !j1.contains(T1.target) ? I(!0) : I(!1);
        }
    }, u1 = (T1)=>{
        if (T1.key === "Tab") {
            const j1 = $.current;
            setTimeout(()=>{
                j1 && !j1.contains(document.activeElement) ? I(!0) : I(!1);
            }, 0);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (M) return document.addEventListener("mousedown", l1), document.addEventListener("keydown", u1), ()=>{
            document.removeEventListener("mousedown", l1), document.removeEventListener("keydown", u1);
        };
    }, [
        M
    ]);
    const E1 = y === "expand" ? "unset" : p ? "270px" : "215px", H1 = v.length > C && y === "expand", B1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>H1 ? v.slice(0, C) : v, [
        H1,
        v,
        C
    ]), [h1, k1] = (0, $acw62.useState)(B1), [I1, D1] = (0, $acw62.useState)(!0), s2 = ((I2 = Z[o]) == null ? void 0 : I2.items.length) || 0, f1 = `item${s2 === 1 ? "" : "s"}`, M1 = `${L}, ${s2} ${f1} currently selected`, g1 = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("MultiSelect", {
        isBlockElement: s,
        width: O
    }), K1 = (T1, j1)=>Z[T1] ? !!Z[T1].items.find((N2)=>N2 === j1) : !1, G1 = (T1, j1)=>{
        let N2 = j1.children.map((_2)=>_2.id);
        return Z[T1] !== void 0 ? N2.every((_2)=>{
            var R3;
            return Z[T1].items.includes(_2) && !((R3 = j1.children.find((he)=>he.id === _2)) != null && R3.isDisabled);
        }) : !1;
    }, R1 = (T1, j1)=>{
        let N2 = j1.children.map((_2)=>_2.id);
        return Z[T1] !== void 0 && N2.length > 0 && N2.some((_2)=>{
            var R3;
            return Z[T1].items.includes(_2) && !((R3 = j1.children.find((he)=>he.id === _2)) != null && R3.isDisabled);
        }) ? !G1(T1, j1) : !1;
    }, E2 = (T1)=>(T1.children.every((j1)=>j1.isDisabled) ? T1.isDisabled = !0 : T1.isDisabled = !1, T1.isDisabled), a3 = ()=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            marginTop: "xs",
            children: "No options found"
        }), H2 = (T1)=>{
        const j1 = T1.target.value.trim().toLowerCase();
        if (!j1) {
            k1(I1 ? B1 : v);
            return;
        }
        const N2 = v.filter((_2)=>_2.children ? _2.name.toLowerCase().includes(j1) ? !0 : _2.children.some((R3)=>R3.name.toLowerCase().includes(j1)) : _2.name.toLowerCase().includes(j1));
        k1(N2);
    }, A2 = ()=>{
        k1(I1 ? B1 : v);
    }, u2 = ()=>{
        D1((T1)=>!T1), setTimeout(()=>{
            W.current && W.current.focus();
        }, 1);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        k1(I1 ? B1 : v);
    }, [
        I1,
        B1,
        v
    ]);
    const o2 = ()=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
            buttonType: "text",
            fontSize: "desktop.button.default",
            id: `view-all-text-btn-${o}`,
            ref: W,
            onClick: u2,
            __css: g1.viewAllButton,
            children: I1 ? "View all" : "View less"
        }), P2 = (T1)=>T1.children ? [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$48513f6b9f8ce62d, {
                id: T1.id,
                labelText: T1.name,
                name: T1.name,
                ..._ !== void 0 ? {
                    isChecked: G1(o, T1),
                    isIndeterminate: R1(o, T1),
                    onChange: _,
                    isDisabled: E2(T1)
                } : {
                    isChecked: K1(o, T1.id),
                    isDisabled: E2(T1),
                    onChange: E
                }
            }, T1.id),
            ...T1.children.map((j1)=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$48513f6b9f8ce62d, {
                    marginInlineStart: "0",
                    id: j1.id,
                    labelText: j1.name,
                    name: j1.name,
                    isDisabled: j1.isDisabled,
                    isChecked: K1(o, j1.id),
                    onChange: E,
                    __css: g1.menuChildren
                }, j1.id))
        ] : [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$48513f6b9f8ce62d, {
                id: T1.id,
                labelText: T1.name,
                name: T1.name,
                isDisabled: T1.isDisabled,
                isChecked: K1(o, T1.id),
                onChange: E
            }, T1.id)
        ], G2 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        title: L,
        __css: s2 > 0 ? g1.buttonTextLabel : null,
        children: L
    }), V3 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        children: [
            p && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$c86715117507e8e5, {
                id: `multi-select-text-input-${o}`,
                labelText: `Search ${L}`,
                isClearable: !0,
                isClearableCallback: A2,
                placeholder: "Search",
                onChange: H2,
                showLabel: !1,
                showRequiredLabel: !1,
                type: "text",
                __css: g1.menuSearchInputBox,
                marginBottom: "s"
            }),
            h1.length === 0 ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx(a3, {}) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
                children: [
                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$4aa08d5625cb8ead, {
                        id: `multi-select-checkbox-group-${o}`,
                        layout: "column",
                        isFullWidth: !0,
                        isRequired: !1,
                        labelText: "Multi select checkbox group label",
                        showLabel: !1,
                        name: "multi-select-checkbox-group",
                        children: h1.map((T1)=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$x.Fragment, {
                                children: P2(T1)
                            }))
                    }),
                    H1 && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx(o2, {})
                ]
            })
        ]
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        id: o,
        __css: g1.base,
        ...B,
        ref: $,
        onClick: ()=>I(!1),
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$a766cd26d0d69044, {
                accordionData: [
                    {
                        accordionType: "default",
                        // Pass the ref for interaction with the accordion button.
                        buttonInteractionRef: P,
                        label: G2,
                        panel: V3
                    }
                ],
                ariaLabel: M1,
                id: `multi-select-accordion-${o}`,
                isDefaultOpen: i,
                isAlwaysRendered: !0,
                userClickedOutside: z,
                panelMaxHeight: E1,
                sx: {
                    ...g1.accordionStyles
                }
            }),
            s2 > 0 && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$SU, {
                id: `ms-${o}-menu-button`,
                multiSelectId: o,
                multiSelectLabelText: L,
                isOpen: i,
                selectedItemsString: f1,
                selectedItemsCount: s2,
                onClear: k,
                accordionButtonRef: P
            })
        ]
    });
}), // Pass all custom props to Chakra and override, for width prop.
{
    shouldForwardProp: ()=>!0
}), $0422a6ce4ea03acc$export$e7827b3f4abbdc7b = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { className: o = "", id: s, labelText: i, layout: p = "row", multiSelectWidth: C = "full", showLabel: v = !0, renderMultiSelect: y, ...L } = r, { isLargerThanMobile: M } = $0422a6ce4ea03acc$export$f67a0166accba89c(), E = M ? p : "column", k = M ? C : "full", _ = E === "column";
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$e154be390aa0e14, {
        id: `multiselect-group-${s}`,
        legendText: i,
        isLegendHidden: !v,
        ...L,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $ec37ab1d016e4ce2$export$694e0d28c7ffc90c), {
            className: o,
            columnGap: "xs",
            "data-testid": `multiselect-group-${s}`,
            direction: E,
            id: s,
            ref: a,
            rowGap: "xs",
            spacing: "xs",
            wrap: p === "row" && C === "fitContent" ? "wrap" : null,
            sx: {
                "> div": {
                    _notFirst: {
                        mx: "0"
                    }
                }
            },
            children: y({
                isBlockElement: _,
                multiSelectWidth: k
            })
        })
    });
})), $0422a6ce4ea03acc$export$68f5e1453c188a82 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { className: o, currentPage: s, getPageHref: i, id: p, initialPage: C = 1, onPageChange: v, pageCount: y, ...L } = r, M = (0, $acw62.useRef)(s), [E, k] = (0, $acw62.useState)(C), _ = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Pagination", {}), Z = E - 1, O = E + 1;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        v && s && s !== M.current && (k(s), M.current = s);
    }, [
        s,
        v
    ]), y <= 1) return null;
    i && v && console.warn("NYPL Reservoir Pagination: Props for both `getPageHref` and `onPageChange` are passed. The component will default to using `getPageHref`."), i && s && console.warn("NYPL Reservoir Pagination: The `currentPage` prop does not work with the `getPageHref` prop. Use `currentPage` with `onPageChange` instead.");
    const B = typeof i < "u" && typeof i == "function", z = (m1, L1)=>{
        m1.preventDefault && m1.preventDefault(), E !== L1 && (k(L1), v && v(L1));
    }, I = (m1)=>{
        E > 1 && z(m1, Z);
    }, P = (m1)=>{
        E < y && z(m1, O);
    }, $ = (m1, L1)=>{
        const E1 = E === L1, H1 = E1 ? {
            color: "ui.typography.body",
            pointerEvent: "none",
            _dark: {
                color: "dark.ui.typography.body"
            }
        } : {}, h1 = {
            items: {
                href: B ? i(L1) : "#",
                attributes: {
                    "aria-label": `Page ${L1}`,
                    "aria-current": E1 ? "page" : null,
                    onClick: B ? void 0 : (k1)=>z(k1, L1)
                },
                text: L1
            },
            previous: {
                href: B ? i(Z) : "#",
                attributes: {
                    "aria-label": "Previous page",
                    onClick: B ? void 0 : I
                },
                text: "Previous"
            },
            next: {
                href: B ? i(O) : "#",
                attributes: {
                    "aria-label": "Next page",
                    onClick: B ? void 0 : P
                },
                text: "Next"
            }
        }[m1];
        return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$a6c7ac8248d6e38a, {
            href: h1.href,
            id: `${p}-${h1.text}`,
            ...h1.attributes,
            __css: {
                ..._.link,
                ...H1
            },
            children: h1.text
        });
    }, W = (m1)=>{
        const L1 = Math.max(// Start at three if the current page is near the beginning.
        3, Math.min(// If the current page is in the middle, start the range
        // one number before the current page.
        m1 - 1, // If the current page is near the end, show the last five items.
        y - 4)), E1 = Math.min(// If the current page is near the end, end the range
        // two place before the last page number.
        y - 2, Math.max(// If the current page is in the middle, end the range
        // one number after the current page.
        m1 + 1, // If the current page is near the end, show the first five items.
        5));
        return (y < 4 ? // Get a short array with 2 or 3 items: [1, 2] or [1, 2, 3]
        Array.from({
            length: y
        }, (h1, k1)=>k1 + 1) : // Otherwise, create the longer array of items.
        [
            // Always display the first page.
            1,
            // The second item will be 2 or an ellipse.
            L1 > 3 ? "ellipse-start" : 2,
            // The middle range of page numbers to display.
            // Add +1 to the end since range() doesn't include the last number.
            ...$0422a6ce4ea03acc$var$m_(L1, E1 + 1),
            // The next to last item will be the next to last
            // number or an ellipse.
            E1 < y - 2 ? "ellipse-end" : y - 1,
            // Always display the last page.
            y
        ]).map((h1)=>{
            const k1 = typeof h1 == "number" ? $("items", h1) : "...";
            return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("li", {
                children: k1
            }, h1);
        });
    }, l1 = E !== 1 && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("li", {
        children: $("previous")
    }, "previous"), u1 = E !== y && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("li", {
        children: $("next")
    }, "next");
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "nav",
        id: p,
        "aria-label": "Pagination",
        role: "navigation",
        className: o,
        ref: a,
        __css: _,
        ...L,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$54c2e3dc7acea9f5, {
            type: "ul",
            inline: !0,
            noStyling: !0,
            id: `${p}-list`,
            children: [
                l1,
                W(E),
                u1
            ]
        })
    });
})), $0422a6ce4ea03acc$export$2b776f7e7ee60dbd = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { darkMode: o = !1, id: s, indicatorType: i = "linear", isIndeterminate: p = !1, labelText: C, showLabel: v = !0, size: y = "default", value: L = 0, ...M } = r, E = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("ProgressIndicator", {
        darkMode: o,
        size: y
    });
    let k = L;
    s || console.warn("NYPL Reservoir Progress Indicator: This component's required `id` prop was not passed."), (k < 0 || k > 100) && (console.warn("NYPL Reservoir ProgressIndicator: An invalid value was passed for the `value` prop, so 0 will be used. A valid value should be a number between 0 and 100."), k = 0);
    const _ = {
        id: s,
        // If the label is visually shown, associate it with the progress indicator.
        // Otherwise, the `aria-label` will be added.
        "aria-label": v ? void 0 : C,
        "aria-labelledby": v ? `${s}-label` : void 0,
        // If `isIndeterminate` is true, then it overrides the `value` prop.
        isIndeterminate: p || void 0,
        value: p ? void 0 : k
    }, Z = (O)=>O === "circular" ? (y === "small" && (_["aria-label"] = C), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            __css: E.circularContainer,
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $c7f03658e6c561bf$export$9e72f56a493060bf), {
                    ..._,
                    sx: E.circular,
                    children: v && !p && y !== "small" && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $100bfeedca20d10e$export$9a43740be2ad09b0), {
                        children: [
                            k,
                            "%"
                        ]
                    })
                }),
                v && y !== "small" && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$b04be29aa201d4f5, {
                    id: `${s}-label`,
                    htmlFor: s,
                    children: C
                })
            ]
        })) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
            children: [
                v && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$b04be29aa201d4f5, {
                    id: `${s}-label`,
                    htmlFor: s,
                    children: C
                }),
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                    __css: E.linearContainer,
                    children: [
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2f26c604918a6e30$export$b25a304ec7d746bb), {
                            ..._,
                            sx: E.linear
                        }),
                        v && !p && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                            __css: E.linearPercentage,
                            children: [
                                k,
                                "%"
                            ]
                        })
                    ]
                })
            ]
        });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        ref: a,
        __css: E,
        ...M,
        children: Z(i)
    });
})), $0422a6ce4ea03acc$export$ef9b1a59e592288f = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { children: o, className: s, helperText: i, id: p, invalidText: C, isDisabled: v = !1, isInvalid: y = !1, isRequired: L = !1, labelPosition: M = "default", labelText: E, name: k, onChange: _, placeholder: Z, selectType: O = "default", showHelperInvalidText: B = !0, showLabel: z = !0, showRequiredLabel: I = !0, value: P = "", ...$ } = r, [W, l1] = (0, $acw62.useState)(0), u1 = (0, $acw62.useRef)(null), m1 = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("CustomSelect", {
        variant: O,
        labelPosition: M
    }), L1 = C || "There is an error related to this field.", H1 = $0422a6ce4ea03acc$var$Uo({
        footnote: y ? L1 : i,
        id: p,
        labelText: E,
        name: "Select",
        showLabel: z
    }), B1 = _ ? {
        onChange: _,
        value: P
    } : {}, h1 = 8, k1 = (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)(y ? "ui.error.primary" : "ui.black", y ? "dark.ui.error.primary" : "dark.ui.typography.body");
    return p || console.warn("NYPL Reservoir Select: This component's required `id` prop was not passed."), (0, $acw62.useEffect)(()=>{
        if (M === "inline") {
            if (u1.current) {
                const I1 = u1.current.clientWidth + h1;
                l1(I1);
            }
        } else l1(0);
    }, [
        M
    ]), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$g7, {
        className: s,
        helperText: i,
        helperTextStyles: {
            marginStart: {
                sm: "auto",
                md: `${W}px`
            }
        },
        id: p,
        invalidText: L1,
        isInvalid: y,
        showHelperInvalidText: B,
        __css: m1,
        ...$,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            __css: M === "inline" && m1.inline,
            children: [
                z && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                    ref: u1,
                    children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$b04be29aa201d4f5, {
                        htmlFor: p,
                        id: `${p}-label`,
                        isInlined: !0,
                        isRequired: I && L,
                        children: E
                    })
                }),
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $27de7712fe1667a2$export$ef9b1a59e592288f), {
                    id: p,
                    variant: "outline",
                    isRequired: L,
                    isDisabled: v,
                    isInvalid: y,
                    name: k,
                    placeholder: Z,
                    ref: a,
                    ...B1,
                    ...H1,
                    icon: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                        color: k1,
                        id: `${p}-icon`,
                        name: "arrow",
                        size: "medium"
                    }),
                    __css: m1.select,
                    children: o
                })
            ]
        })
    });
})), $0422a6ce4ea03acc$export$79d13b60110f33be = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { action: o, buttonOnClick: s, className: i, descriptionText: p, headingText: C, helperText: v, id: y, invalidText: L, isDisabled: M = !1, isInvalid: E = !1, isRequired: k = !1, labelText: _, method: Z, noBrandButtonType: O = !1, onSubmit: B, selectProps: z, textInputElement: I, textInputProps: P, ...$ } = r, W = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("SearchBar", {}), l1 = {
        helperText: "",
        isDisabled: M,
        isInvalid: E,
        isRequired: k,
        showHelperInvalidText: !1,
        showLabel: !1
    }, u1 = E ? L : v, m1 = u1 ? `${_} - ${u1}` : _, E1 = `${(P == null ? void 0 : P.placeholder) || "Search terms"} ${k ? "(Required)" : ""}`, H1 = O ? "noBrand" : "primary", B1 = {
        borderLeftRadius: "none",
        borderRightRadius: {
            base: "none",
            md: "sm"
        },
        lineHeight: "1.70",
        marginBottom: "auto",
        maxWidth: {
            base: "unset",
            md: "80px"
        }
    };
    y || console.warn("NYPL Reservoir SearchBar: This component's required `id` prop was not passed.");
    const h1 = z && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$ef9b1a59e592288f, {
        id: (z == null ? void 0 : z.id) || `searchbar-select-${y}`,
        labelText: z == null ? void 0 : z.labelText,
        name: z == null ? void 0 : z.name,
        onChange: z == null ? void 0 : z.onChange,
        selectType: "searchbar",
        value: z == null ? void 0 : z.value,
        __css: W.select,
        ...l1,
        children: z == null ? void 0 : z.optionsData.map((s2)=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("option", {
                value: s2.value,
                children: s2.text
            }, s2.value))
    }), k1 = P && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$c86715117507e8e5, {
        "aria-describedby": u1 ? `${y}-helperText` : void 0,
        className: "textInput",
        defaultValue: P == null ? void 0 : P.defaultValue,
        id: (P == null ? void 0 : P.id) || `searchbar-textinput-${y}`,
        isClearable: P == null ? void 0 : P.isClearable,
        isClearableCallback: P == null ? void 0 : P.isClearableCallback,
        labelText: P == null ? void 0 : P.labelText,
        name: P == null ? void 0 : P.name,
        max: P == null ? void 0 : P.max,
        maxLength: P == null ? void 0 : P.maxLength,
        min: P == null ? void 0 : P.min,
        onChange: P == null ? void 0 : P.onChange,
        pattern: P == null ? void 0 : P.pattern,
        placeholder: E1,
        textInputType: h1 ? "searchBarSelect" : "searchBar",
        type: "text",
        value: P == null ? void 0 : P.value,
        ...l1
    }), I1 = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
        buttonType: H1,
        id: `searchbar-button-${y}`,
        isDisabled: M,
        onClick: s,
        type: "submit",
        sx: B1,
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                align: "left",
                id: `searchbar-icon-${y}`,
                name: "search",
                size: "small"
            }),
            "Search"
        ]
    }), D1 = I || k1;
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$g7, {
        descriptionText: p,
        headingText: C,
        helperText: v,
        id: y,
        invalidText: L,
        isInvalid: E,
        ref: a,
        ...$,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            as: "form",
            id: `searchbar-form-${y}`,
            className: i,
            role: "search",
            "aria-label": m1,
            onSubmit: B,
            method: Z,
            action: o,
            __css: W,
            children: [
                h1,
                D1,
                I1
            ]
        })
    });
})), $0422a6ce4ea03acc$export$27a22c945b52f415 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { className: o, contentSize: s = 3, headingSize: i = 1, imageAspectRatio: p = "square", id: C, isBordered: v = !1, layout: y = "column", showButton: L = !1, showContent: M = !0, showHeading: E = !0, showImage: k = !0, width: _, ...Z } = r, O = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("SkeletonLoader", {
        isBordered: v,
        imageAspectRatio: p,
        showImage: k,
        variant: y
    }), B = (z, I = 1, P = "80%")=>new Array(I).fill(null).map(($, W)=>{
            const l1 = W === I - 1 ? P : "100%", u1 = W === I - 1 && z === "content" ? "0" : void 0;
            return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $11a53ac53074bf5a$export$8f31e4c4a37b8e9c), {
                width: l1,
                sx: O.loader,
                children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                    __css: O[z],
                    style: {
                        marginBottom: u1
                    }
                })
            }, `${z}-${W}`);
        });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        className: o,
        id: C,
        ref: a,
        __css: O.base,
        style: {
            width: _
        },
        ...Z,
        children: [
            k && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $11a53ac53074bf5a$export$8f31e4c4a37b8e9c), {
                sx: O.loader,
                children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                    __css: {
                        ...O.element,
                        ...O.image
                    }
                })
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                className: y,
                __css: O.container,
                children: [
                    E && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                        __css: O.section,
                        children: B("heading", i, "80%")
                    }),
                    M && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                        __css: O.section,
                        children: B("content", s, "30%")
                    }),
                    L && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                        __css: {
                            ...O.section,
                            ...O.button
                        },
                        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $11a53ac53074bf5a$export$8f31e4c4a37b8e9c), {
                            borderRadius: "16px",
                            sx: O.loader,
                            children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                                __css: O.button
                            })
                        })
                    })
                ]
            })
        ]
    });
})), $0422a6ce4ea03acc$export$2a63a94e44788d9 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { className: o, id: s, target: i = "#mainContent", ...p } = r, C = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("SkipNavigation");
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "nav",
        "aria-label": "Skip Navigation",
        className: o,
        id: s,
        ref: a,
        __css: C,
        ...p,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$54c2e3dc7acea9f5, {
            inline: !0,
            noStyling: !0,
            type: "ul",
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("li", {
                    children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$a6c7ac8248d6e38a, {
                        href: i,
                        isUnderlined: !1,
                        children: "Skip to Main Content"
                    })
                }),
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("li", {
                    children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$a6c7ac8248d6e38a, {
                        href: "https://www.nypl.org/accessibility",
                        isUnderlined: !1,
                        children: "Click to learn about accessibility at the Library"
                    })
                })
            ]
        })
    });
})), $0422a6ce4ea03acc$export$472062a354075cee = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { className: o, defaultValue: s = 0, helperText: i, id: p, invalidText: C, isDisabled: v = !1, isInvalid: y = !1, isRangeSlider: L = !1, isRequired: M = !1, labelText: E, max: k = 100, min: _ = 0, name: Z, onChange: O, onChangeEnd: B, showBoxes: z = !0, showHelperInvalidText: I = !0, showLabel: P = !0, showRequiredLabel: $ = !0, showValues: W = !0, step: l1 = 1, // For the RangeSlider, if the defaultValue is not an array, then we set
    // the defaultValue to an array with the min and max values.
    // We need to set the default value correctly for both types of sliders.
    value: u1 = L && typeof s == "number" ? [
        _,
        k
    ] : s, ...m1 } = r;
    p || console.warn("NYPL Reservoir Slider: This component's required `id` prop was not passed."), O && B && console.warn("NYPL Reservoir Slider: Both `onChange` and `onChangeEnd` props were passed.");
    const [L1, E1] = $0422a6ce4ea03acc$var$fc(u1), H1 = (0, $b80b1cf263c5808a$export$20f3076712c8dfa)().colorMode === "dark";
    let B1 = y;
    L && L1[0] > L1[1] && (B1 = !0, console.warn("NYPL Reservoir Slider: The RangeSlider's first value is greater than the second value.")), _ > k && (B1 = !0, console.warn("NYPL Reservoir Slider: The `min` prop is greater than the `max` prop."));
    const h1 = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("CustomSlider", {
        isDarkMode: H1,
        isDisabled: v,
        isInvalid: B1,
        showBoxes: z,
        showValues: W
    }), k1 = {
        // Don't focus on the thumbs for every small change.
        focusThumbOnChange: !1,
        id: p,
        isDisabled: v,
        max: k,
        min: _,
        name: Z,
        onChange: (f1)=>{
            E1(f1), O && O(f1);
        },
        onChangeEnd: (f1)=>{
            B && B(f1);
        },
        step: l1,
        // Additional margins so slider thumbs don't overflow past the
        // edge when the value boxes or min/max values are hidden.
        sx: h1.sliderContainer
    }, I1 = {
        isDisabled: v,
        isInvalid: B1,
        isRequired: M,
        max: k,
        min: _,
        // Never show the label or helper text for the `TextInput` component.
        showHelperInvalidText: !1,
        showLabel: !1,
        step: l1,
        type: "number"
    }, D1 = (f1)=>{
        const M1 = {
            start: {
                // We only want the value for this box in the `isRangeSlider` case.
                value: L ? L1[0].toString() : "",
                onChange: (K1)=>{
                    const R1 = [
                        parseInt(K1.target.value, 10) ? parseInt(K1.target.value, 10) : 0,
                        L1[1]
                    ];
                    E1(R1), O && O && O(R1), B && B && B(R1);
                },
                ...I1
            },
            end: {
                // This text input *always* shows. In the default case, we only
                // keep track of one value. For the `isRangeSlider` case, we keep
                // track of an array but only want the second value.
                value: L ? L1[1].toString() : L1.toString(),
                onChange: (K1)=>{
                    let G1 = parseInt(K1.target.value, 10) ? parseInt(K1.target.value, 10) : 0;
                    G1 > k && (G1 = k);
                    const R1 = L ? [
                        L1[0],
                        G1
                    ] : G1;
                    E1(R1), O && O && O(R1), B && B && B(R1);
                },
                ...I1
            }
        }, g1 = L ? `${E} - ${f1} value` : `${E} - value`;
        return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$c86715117507e8e5, {
            id: `${p}-textInput-${f1}`,
            labelText: g1,
            __css: {
                ...h1.textInput,
                // Specific margins for each text input to
                // push the elements inside.
                marginRight: f1 === "start" ? "s" : null,
                marginLeft: f1 === "end" ? "s" : null
            },
            ...M1[f1]
        });
    }, s2 = ()=>L ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $82cc94754f1df116$export$826424dabc3dd705), {
            "aria-label": [
                `${E} - slider handle for start value`,
                `${E} - slider handle for end value`
            ],
            value: L1,
            size: "lg",
            ...k1,
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $82cc94754f1df116$export$e77a5f64f3997375), {
                    sx: h1.track,
                    children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $82cc94754f1df116$export$8f071f12eca431ca), {
                        sx: h1.filledTrack
                    })
                }),
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $82cc94754f1df116$export$99fcec41170e54d4), {
                    index: 0,
                    sx: h1.thumb
                }),
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $82cc94754f1df116$export$99fcec41170e54d4), {
                    index: 1,
                    sx: h1.thumb
                })
            ]
        }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $ebf149b92c8644d9$export$472062a354075cee), {
            "aria-label": `${E} - slider handle`,
            value: L1,
            size: "lg",
            ...k1,
            children: [
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $ebf149b92c8644d9$export$105594979f116971), {
                    sx: h1.track,
                    children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $ebf149b92c8644d9$export$73137d74280e0c3e), {
                        sx: h1.filledTrack
                    })
                }),
                /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $ebf149b92c8644d9$export$2c1b491743890dec), {
                    sx: h1.thumb
                })
            ]
        });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$g7, {
        className: o,
        helperText: i,
        id: p,
        invalidText: C,
        isInvalid: B1,
        ref: a,
        showHelperInvalidText: I,
        __css: h1,
        ...m1,
        children: [
            P && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$b04be29aa201d4f5, {
                id: `${p}-label`,
                htmlFor: z ? `${p}-textInput-${L ? "start" : "end"}` : "",
                isRequired: $ && M,
                children: E
            }),
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                __css: h1.container,
                children: [
                    z && L && D1("start"),
                    W && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                        __css: h1.leftValue,
                        children: _
                    }),
                    s2(),
                    W && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                        __css: h1.rightValue,
                        children: k
                    }),
                    z && D1("end")
                ]
            })
        ]
    });
})), $0422a6ce4ea03acc$export$5720c1871db44880 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { children: o, className: s, id: i, level: p, type: C, ...v } = r, L = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("StatusBadge", {
        variant: p || C || "low"
    });
    return o || console.warn("NYPL Reservoir StatusBadge: No children were passed."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        id: i,
        className: s,
        ref: a,
        __css: L,
        ...v,
        children: o
    });
})), $0422a6ce4ea03acc$var$_U = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((r)=>{
    const { additionalFigureStyles: a, additionalImageStyles: o, additionalWrapperStyles: s, alt: i, aspectRatio: p, caption: C, component: v, credit: y, size: L, src: M } = r;
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$3e431a229df88919, {
        additionalFigureStyles: a,
        additionalImageStyles: o,
        additionalWrapperStyles: s,
        alt: i,
        component: v,
        aspectRatio: p,
        size: L,
        caption: C,
        credit: y,
        src: M
    });
}), $0422a6ce4ea03acc$export$96a5d2b62b34e850 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { calloutText: o, className: s, headingText: i, id: p, imageProps: C = {
        alt: "",
        aspectRatio: "square",
        caption: void 0,
        component: void 0,
        credit: void 0,
        position: "left",
        size: "medium",
        src: ""
    }, bodyContent: v, ...y } = r, L = C.src || C.component, M = C.caption || C.credit, E = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("StructuredContent", {
        hasFigureImage: M,
        imageAspectRatio: C.aspectRatio,
        imagePosition: C.position
    }), k = typeof v == "string" ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("div", {
        className: "structuredcontent-body",
        dangerouslySetInnerHTML: {
            __html: v
        }
    }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        className: "structuredcontent-body",
        children: v
    }), _ = $0422a6ce4ea03acc$var$Yr({
        title: i,
        id: p
    }), Z = o ? typeof o == "string" ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$a8a3e93435678ff9, {
        id: `${p}-callout`,
        level: "h3",
        size: "heading5",
        children: o
    }) : o : void 0, O = $0422a6ce4ea03acc$var$Yr({
        title: Z
    });
    return L && !C.alt && console.warn("NYPL Reservoir StructuredContent: The `imageProps.alt` prop is required when using an image."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        id: p,
        className: s,
        ref: a,
        __css: E,
        ...y,
        children: [
            _,
            O,
            L && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$_U, {
                additionalFigureStyles: E.imageFigure,
                additionalImageStyles: E.image,
                additionalWrapperStyles: E.imageWrapper,
                alt: C.alt,
                component: C.component,
                aspectRatio: C.aspectRatio,
                caption: C.caption,
                credit: C.credit,
                size: C.size,
                src: C.src ? C.src : void 0
            }),
            k
        ]
    });
})), $0422a6ce4ea03acc$export$22a81bdd3a723b46 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { children: o, className: s, id: i, listItems: p = [], style: C = "capped", textSize: v = "default" } = r, y = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("StyledList", {
        textSize: v,
        variant: C
    });
    let L;
    return o && p.length > 0 ? (console.warn("NYPL Reservoir StyledList: Pass in either `<li>` children or use the `listItems` data prop. Do not use both."), null) : ($0422a6ce4ea03acc$var$Yw(o, "ul", "StyledList"), L = o || p.map((M, E)=>/* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("li", {
            children: M
        }, E)), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "ul",
        className: s,
        id: i,
        ref: a,
        __css: y,
        children: L
    }));
})), $0422a6ce4ea03acc$var$DU = (r)=>{
    const a = (0, $acw62.useRef)();
    return (0, $acw62.useEffect)(()=>{
        var s;
        const o = (s = a == null ? void 0 : a.current) == null ? void 0 : s.querySelector("[role=tab][aria-selected=true]");
        o == null || o.scrollIntoView({
            block: "nearest"
        });
    }, [
        r
    ]), a;
}, $0422a6ce4ea03acc$var$RU = (r)=>{
    window.location.hash = r;
}, $0422a6ce4ea03acc$var$ZU = (r, a)=>{
    const o = [], s = [];
    return r != null && r.length ? ((r == null ? void 0 : r.length) > 6 && console.warn("NYPL Reservoir Tabs: it is recommended to use no more than six tabs. If more than six tabs are needed, consider other navigational patterns."), r.forEach((i, p)=>{
        let C;
        const v = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $1a8ec37cc1f6cf4a$export$3e41faf802a29e71), {
            fontSize: {
                base: "mobile.subtitle.subtitle1",
                md: "desktop.subtitle.subtitle1"
            },
            onClick: a ? ()=>$0422a6ce4ea03acc$var$RU(`tab${p + 1}`) : void 0,
            children: i.label
        }, p);
        typeof i.content == "string" ? C = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $4febbf79f6d1a688$export$3d96ec278d3efce4), {
            dangerouslySetInnerHTML: {
                __html: i.content
            }
        }, p) : C = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $4febbf79f6d1a688$export$3d96ec278d3efce4), {
            children: i.content
        }, p), o.push(v), s.push(C);
    }), {
        tabs: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $55182a1454ef598e$export$e51a686c67fdaa2d), {
                children: o
            }, "list")
        ],
        panels: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $291041ce3d9db291$export$5dae8d435677f210), {
                children: s
            }, "panels")
        ]
    }) : {
        tabs: [],
        panels: []
    };
}, $0422a6ce4ea03acc$var$OU = (r)=>{
    const a = [], o = [];
    return r != null && r.length ? (r.forEach((s)=>{
        (s.type === (0, $55182a1454ef598e$export$e51a686c67fdaa2d) || s.props.mdxType === "TabList") && (a.push(s), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(s.props.children) > 6 && console.warn("NYPL Reservoir Tabs: It is recommended to use no more than six tabs. If more than six tabs are needed, consider other navigational patterns.")), (s.type === (0, $291041ce3d9db291$export$5dae8d435677f210) || s.props.mdxType === "TabPanels") && o.push(s);
    }), {
        tabs: a,
        panels: o
    }) : {
        tabs: [],
        panels: []
    };
}, $0422a6ce4ea03acc$export$b2539bed5023c21c = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    var $;
    const { children: o, defaultIndex: s = 0, id: i, onChange: p, tabsData: C, useHash: v = !1, ...y } = r, [L, M] = (0, $acw62.useState)(s), E = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Tabs", {}), { tabs: k, panels: _ } = C ? $0422a6ce4ea03acc$var$ZU(C, v) : $0422a6ce4ea03acc$var$OU(o);
    (k.length === 0 || _.length === 0) && console.warn("NYPL Reservoir Tabs: Pass data in the `contentData` props or as children.");
    const Z = k[0] ? ($ = k[0]) == null ? void 0 : $.props : k.props, O = ()=>{
        const W = L === 0 ? Z.children.length - 1 : L - 1;
        M(W);
    }, B = ()=>{
        const W = L === Z.children.length - 1 ? 0 : L + 1;
        M(W);
    }, z = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
        "aria-label": "Scroll tabs left",
        id: `tabs-previous-${i}`,
        onClick: O,
        __css: {
            ...E.buttonArrows,
            left: "0"
        },
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
            iconRotation: "rotate90",
            id: `tabs-previous-icon-${i}`,
            name: "arrow",
            size: "small",
            title: "previous arrow"
        })
    }), I = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
        "aria-label": "Scroll tabs right",
        id: `tabs-next-${i}`,
        onClick: B,
        __css: {
            ...E.buttonArrows,
            right: "0"
        },
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
            iconRotation: "rotate270",
            id: `tabs-next-icon-${i}`,
            name: "arrow",
            size: "small",
            title: "next arrow"
        })
    });
    o && C != null && C.length && console.warn("NYPL Reservoir Tabs: Only pass children or data in the `contentData` prop. Do not pass both.");
    const P = $0422a6ce4ea03acc$var$DU(L);
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $ebab1f9480413523$export$b2539bed5023c21c), {
        defaultIndex: s,
        id: i,
        isLazy: !0,
        index: L,
        onChange: (W)=>{
            p !== void 0 && p(W), M(W);
        },
        ref: a,
        variant: "enclosed",
        ...y,
        children: [
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                __css: E.tablistWrapper,
                sx: {
                    "&::-webkit-scrollbar": {
                        display: "none"
                    }
                },
                children: [
                    z,
                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                        __css: E.carouselParent,
                        ref: P,
                        children: k
                    }),
                    I
                ]
            }),
            _
        ]
    });
})), $0422a6ce4ea03acc$var$Ww = ({ label: r, children: a })=>{
    const s = typeof r == "string" ? r : r.props.children;
    return s.length > 20 && typeof s == "string" ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$28c660c63b792dea, {
        content: s,
        children: a
    }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$x.Fragment, {
        children: a
    });
}, $0422a6ce4ea03acc$var$NU = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((r)=>{
    const { tagSetData: a = [] } = r, o = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("TagSetExplore");
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$x.Fragment, {
        children: a.map((s, i)=>(typeof s.label == "string" && console.warn("NYPL Reservoir TagSet: Explore tags require all `label` props to be React components."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$Ww, {
                label: s.label,
                children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                    "data-testid": "explore-tags",
                    id: `ts-explore-${s.id}-${i}`,
                    __css: o,
                    children: [
                        s.iconName ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                            align: "left",
                            "data-testid": "ts-icon",
                            name: s.iconName,
                            size: "small"
                        }) : null,
                        /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                            children: s.label
                        })
                    ]
                })
            }, i)))
    });
}), $0422a6ce4ea03acc$var$PU = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((r)=>{
    const { id: a, isDismissible: o = !1, onClick: s, tagSetData: i = [] } = r, p = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("TagSetFilter", {
        isDismissible: o
    }), C = (L)=>{
        s && s(L);
    }, v = (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("ui.gray.x-dark", "dark.ui.typography.body"), y = (0, $b80b1cf263c5808a$export$d18f2ef57b0d7644)("ui.typography.body", "dark.ui.typography.body");
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
        children: [
            i.map((L, M)=>(typeof L.label != "string" && console.warn("NYPL Reservoir TagSet: Filter tags require all `label` props to be strings."), o && L.iconName && console.warn("NYPL Reservoir TagSet: Filter tags will not render icons when `isDismissible` is set to true."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$Ww, {
                    label: L.label,
                    children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                        "aria-label": o ? `${L.label}, click to remove filter` : void 0,
                        "data-testid": "filter-tags",
                        id: `ts-filter-${L.id}-${M}`,
                        onClick: o ? ()=>C(L) : void 0,
                        sx: p.base,
                        children: [
                            !o && L.iconName ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                                align: "left",
                                color: y,
                                "data-testid": "ts-icon",
                                name: L.iconName,
                                size: "small"
                            }) : null,
                            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
                                children: L.label
                            }),
                            o ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$f04a61298a47a40f, {
                                "data-testid": "filter-close-icon",
                                align: "right",
                                name: "close",
                                size: "small",
                                color: v,
                                width: "12px"
                            }) : null
                        ]
                    })
                }, M))),
            i.length > 1 && o ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$353f5b6fc5456de1, {
                buttonType: "text",
                "data-testid": "filter-clear-all",
                id: `ts-filter-clear-all-${a}`,
                onClick: ()=>C({
                        id: "clear-filters",
                        label: "Clear filters"
                    }),
                size: "small",
                children: "Clear filters"
            }) : null
        ]
    });
});
function $0422a6ce4ea03acc$var$jp(r) {
    return r === "filter";
}
const $0422a6ce4ea03acc$export$3a13a368ca72d8bd = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { className: o, id: s, isDismissible: i = !1, onClick: p, tagSetData: C = [], type: v = "filter", ...y } = r, L = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("TagSet", {});
    return $0422a6ce4ea03acc$var$jp(v) || (i && console.warn("NYPL Reservoir TagSet: The `isDismissible` prop will be ignored when the `type` prop is set to 'explore'."), p && console.warn("NYPL Reservoir TagSet: The `onClick` prop will be ignored when the `type` prop is set to 'explore'.")), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs((0, $2231dd843a1dfd59$export$f51f4c4ede09e011), {
        className: o,
        id: s,
        ref: a,
        __css: L,
        ...y,
        children: [
            !$0422a6ce4ea03acc$var$jp(v) && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$NU, {
                tagSetData: C,
                type: v
            }),
            $0422a6ce4ea03acc$var$jp(v) && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$PU, {
                id: s,
                isDismissible: i,
                onClick: p,
                tagSetData: C,
                type: v
            })
        ]
    });
})), $0422a6ce4ea03acc$export$14416b8d99d47caa = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const o = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Template", {});
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        id: r.id,
        ref: a,
        __css: o,
        ...r,
        children: r.children
    });
})), $0422a6ce4ea03acc$export$e22eaed4dbcf9e01 = (r)=>{
    const a = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("TemplateBreakout", {});
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: a,
        children: r.children
    });
}, $0422a6ce4ea03acc$export$25dc9db1b0a2be61 = ({ children: r, renderHeaderElement: a = !0 })=>{
    const o = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("TemplateBreakout", {});
    let s = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: o,
        children: r
    });
    return a && ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(r, (i)=>{
        var p;
        ((i == null ? void 0 : i.type) === "header" || ((p = i == null ? void 0 : i.props) == null ? void 0 : p.mdxType) === "header") && console.warn("NYPL Reservoir TemplateHeader: An HTML `header` element was passed in. Set `renderHeaderElement` to `false` to avoid nested HTML `header` elements.");
    }), s = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "header",
        __css: o,
        children: r
    })), s;
}, $0422a6ce4ea03acc$export$3443d76483b4d87b = (r)=>{
    const a = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("TemplateBreakout", {});
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: a,
        children: r.children
    });
}, $0422a6ce4ea03acc$export$708b164b8f6d17b5 = (r)=>{
    const { children: a, id: o = "mainContent", sidebar: s = "none" } = r, i = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("TemplateContent", {
        variant: s
    }), p = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(a, (C)=>{
        var y, L;
        let v = C;
        return (C && (C == null ? void 0 : C.type) === $0422a6ce4ea03acc$export$86cdf353b53b7dd4 || C != null && C.props && ((y = C.props) == null ? void 0 : y.mdxType) === "TemplateContentPrimary" || (C == null ? void 0 : C.type) === $0422a6ce4ea03acc$export$5f844d3fe472074b || C != null && C.props && ((L = C.props) == null ? void 0 : L.mdxType) === "TemplateContentSidebar") && (v = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(C, {
            sidebar: s
        })), v;
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "main",
        id: o,
        __css: i,
        children: p
    });
}, $0422a6ce4ea03acc$export$8ebe92208645b401 = (r)=>{
    const a = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("TemplateContentTopBottom", {});
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: a,
        children: r.children
    });
}, $0422a6ce4ea03acc$var$IU = (r)=>{
    const a = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("TemplateContentTopBottom", {});
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: a,
        children: r.children
    });
}, $0422a6ce4ea03acc$export$86cdf353b53b7dd4 = (r)=>{
    const { sidebar: a } = r, o = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("TemplateContentPrimary", {
        variant: a
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: o,
        children: r.children
    });
}, $0422a6ce4ea03acc$export$5f844d3fe472074b = (r)=>{
    const { sidebar: a } = r, o = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("TemplateContentSidebar", {
        variant: a
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: o,
        children: r.children
    });
}, $0422a6ce4ea03acc$export$b4c8f0bdb2e80cea = ({ children: r, renderFooterElement: a = !0 })=>{
    const o = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("TemplateBreakout", {});
    let s = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: o,
        children: r
    });
    return a && ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(r, (i)=>{
        var p;
        ((i == null ? void 0 : i.type) === "footer" || ((p = i == null ? void 0 : i.props) == null ? void 0 : p.mdxType) === "footer") && console.warn("NYPL Reservoir TemplateFooter: An HTML `footer` element was passed in. Set `renderFooterElement` to `false` to avoid nested HTML `footer` elements.");
    }), s = /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "footer",
        __css: o,
        children: r
    })), s;
}, $0422a6ce4ea03acc$export$71380cf1ff238ad8 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { aboveHeader: o, breakout: s, contentId: i = "mainContent", contentBottom: p, contentPrimary: C, contentSidebar: v, contentTop: y, footer: L, header: M, id: E, sidebar: k = "none", renderFooterElement: _ = !0, renderHeaderElement: Z = !0, renderSkipNavigation: O = !1, ...B } = r, z = o && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$e22eaed4dbcf9e01, {
        children: o
    }), I = y && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$8ebe92208645b401, {
        children: y
    }), P = C && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$86cdf353b53b7dd4, {
        children: C
    }), $ = p && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$IU, {
        children: p
    }), W = v && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$5f844d3fe472074b, {
        children: v
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$var$x.Fragment, {
        children: [
            O ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$2a63a94e44788d9, {}) : null,
            /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$14416b8d99d47caa, {
                id: E,
                ref: a,
                ...B,
                children: [
                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$3443d76483b4d87b, {
                        children: [
                            z,
                            (M || s) && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$25dc9db1b0a2be61, {
                                renderHeaderElement: Z,
                                children: [
                                    M,
                                    s
                                ]
                            })
                        ]
                    }),
                    /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsxs($0422a6ce4ea03acc$export$708b164b8f6d17b5, {
                        id: i,
                        sidebar: k,
                        children: [
                            I,
                            k === "left" && W,
                            P,
                            k === "right" && W,
                            $
                        ]
                    }),
                    L && /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$export$b4c8f0bdb2e80cea, {
                        renderFooterElement: _,
                        children: L
                    })
                ]
            })
        ]
    });
})), $0422a6ce4ea03acc$var$YU = ()=>{}, $0422a6ce4ea03acc$export$bea8ebba691c5813 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { defaultChecked: o = !1, helperText: s, id: i, invalidText: p, isChecked: C, isDisabled: v = !1, isInvalid: y = !1, isRequired: L = !1, labelText: M, name: E, onChange: k = $0422a6ce4ea03acc$var$YU, size: _ = "default", ...Z } = r, O = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("Toggle", {
        isDisabled: v,
        size: _
    }), B = (0, $6225152922b2fd2b$export$b863f77547fbcb03)("Switch", {
        size: _
    }), I = $0422a6ce4ea03acc$var$Uo({
        footnote: y ? p : s,
        id: i,
        labelText: M,
        name: "Toggle",
        showLabel: !0
    });
    return i || console.warn("NYPL Reservoir Toggle: This component's required `id` prop was not passed."), /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$g7, {
        helperText: s,
        helperTextStyles: O.helperErrorText,
        id: i,
        invalidText: p,
        isInvalid: y,
        ...Z,
        children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
            __css: O,
            children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $674e168e57385803$export$b5d5cf8927ab7262), {
                id: i,
                isDisabled: v,
                isInvalid: y,
                isRequired: L,
                name: E || "default",
                ref: a,
                size: _ === "default" ? "lg" : "sm",
                lineHeight: "1.5",
                ...C !== void 0 ? {
                    isChecked: C,
                    onChange: k
                } : {
                    defaultChecked: o
                },
                ...I,
                __css: B,
                children: M
            })
        })
    });
})), $0422a6ce4ea03acc$export$123806994ad8a16f = (r = 0, a = 100)=>{
    const [o, s] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), i = ()=>{
        s((y)=>y === 0 ? r - 1 : y - 1);
    }, p = ()=>{
        s((y)=>y === r - 1 ? 0 : y + 1);
    }, C = ()=>{
        s(0);
    }, v = {
        transition: "all .5s",
        marginStart: `-${o * a}%`
    };
    return {
        prevSlide: i,
        nextSlide: p,
        carouselStyle: v,
        goToStart: C
    };
}, $0422a6ce4ea03acc$export$56d1b54bd40d01ad = (r, a)=>{
    (0, $acw62.useEffect)(()=>{
        const o = (s)=>{
            const i = s.key || s.keyCode;
            (i === "Escape" || i === "Esc" || i === 27) && r(!1);
        };
        return window.addEventListener("keydown", o), ()=>window.removeEventListener("keydown", o);
    }, []), (0, $6d85c847103c013b$export$71b2224f1ce5e08e)({
        ref: a,
        handler: ()=>r(!1)
    });
};
function $0422a6ce4ea03acc$export$efbfa63d6e989c0e(r) {
    const [a, o] = (0, $acw62.useState)(r !== void 0 ? r : {});
    return {
        selectedItems: a,
        setSelectedItems: (v)=>o(v),
        onChange: (v, y)=>{
            let L;
            a.hasOwnProperty(y) ? (L = a[y].items.slice(), a[y].items.indexOf(v) > -1 ? L = L.filter((M)=>M !== v) : L.push(v)) : (L = [], L.push(v)), o({
                ...a,
                [y]: {
                    items: L
                }
            });
        },
        onMixedStateChange: (v, y, L)=>{
            const M = L.filter((_)=>_.id === v)[0].children.map((_)=>({
                    id: _.id,
                    isDisabled: _.isDisabled
                })), E = M.map((_)=>_.id);
            let k;
            a[y] !== void 0 ? M.filter((Z)=>!Z.isDisabled).map((Z)=>Z.id).every((Z)=>a[y].items.includes(Z)) ? k = a[y].items.filter((Z)=>!E.map((O)=>O).includes(Z)) : k = [
                ...M.filter((Z)=>!Z.isDisabled && !a[y].items.includes(Z.id)).map((Z)=>Z.id),
                ...a[y].items
            ] : k = M.filter((_)=>!_.isDisabled).map((_)=>_.id), o({
                ...a,
                [y]: {
                    items: k
                }
            });
        },
        onClear: (v)=>{
            let y = {};
            for (let L of Object.keys(a))L !== v && (y[L] = a[L]);
            o(y);
        },
        onClearAll: ()=>o({})
    };
}
function $0422a6ce4ea03acc$export$252b14e4257d168a() {
    const r = (0, $5f6bf330f809db0e$export$93d4e7f90805808f)();
    return !r || Object.keys(r).length === 0 ? (console.warn("NYPL Reservoir useNYPLTheme: hook must be used inside of `<DSProvider />`."), {}) : {
        // base, sm, md, lg, xl, 2xl
        breakpoints: r.breakpoints,
        colors: {
            // primary, secondary
            brand: r.colors.brand,
            // dark mode colors:
            // ui.disabled, ui.error, ui.focus, ui.link,
            // ui.status, ui.success, ui.test, ui.warning,
            // ui.bg, ui.border, ui.typography
            dark: r.colors.dark,
            // blogs, books-and-more, education, locations,
            // research, research-library, whats-on
            section: r.colors.section,
            transparent: r.colors.transparent,
            // black, white, gray, disabled, error, focus, link,
            // status, success, test, warning, bg, border, typography
            ui: r.colors.ui
        },
        fontSizes: {
            "-3": r.fontSizes[-3],
            "-2": r.fontSizes[-2],
            "-1": r.fontSizes[-1],
            0: r.fontSizes[0],
            1: r.fontSizes[1],
            2: r.fontSizes[2],
            3: r.fontSizes[3],
            4: r.fontSizes[4],
            // default
            breadcrumbs: r.fontSizes.breadcrumbs,
            // small, default, large
            button: r.fontSizes.button,
            // body, breadcrumbs, button, caption, default
            // heading, helper, label, overline, subtitle
            desktop: r.fontSizes.desktop,
            // primary, secondary, tertiary, callout
            heading: r.fontSizes.heading,
            // default
            helper: r.fontSizes.helper,
            // default, secondary
            label: r.fontSizes.label,
            // body, breadcrumbs, button, caption, default
            // heading, helper, label, overline, subtitle
            mobile: r.fontSizes.mobile,
            // default, caption, tag, mini
            text: r.fontSizes.text
        },
        fontWeights: {
            light: r.fontWeights.light,
            regular: r.fontWeights.regular,
            medium: r.fontWeights.medium,
            semibold: r.fontWeights.semibold,
            bold: r.fontWeights.bold,
            // default, body1, body2
            body: r.fontWeights.body,
            // default, lastChild
            breadcrumbs: r.fontWeights.breadcrumbs,
            // default
            button: r.fontWeights.button,
            caption: r.fontWeights.caption,
            default: r.fontWeights.default,
            // display1, heading1, heading2, heading3, heading4,
            // heading5, heading6
            // deprecated: primary, secondary, tertiary, callout
            heading: r.fontWeights.heading,
            // default
            helper: r.fontWeights.helper,
            // default, secondary
            label: r.fontWeights.label,
            // overline1, overline2
            overline: r.fontWeights.overline,
            // subtitle1, subtitle2
            subtitle: r.fontWeights.subtitle,
            // default, caption, tag, mini
            text: r.fontWeights.text
        },
        fonts: {
            body: r.fonts.body,
            heading: r.fonts.heading
        },
        radii: r.radii,
        space: {
            xxs: r.space.xxs,
            xs: r.space.xs,
            s: r.space.s,
            m: r.space.m,
            l: r.space.l,
            xl: r.space.xl,
            xxl: r.space.xxl,
            xxxl: r.space.xxxl
        }
    };
}
function $0422a6ce4ea03acc$export$42c02f33970a2afa() {
    const [r, a] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        width: 0,
        height: 0
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const o = ()=>{
            a({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        return o(), window.addEventListener("resize", o), ()=>{
            window.removeEventListener("resize", o);
        };
    }, []), r;
}
const $0422a6ce4ea03acc$export$f503bc85d719e8b0 = (0, $7a77d8ad783bc3e2$export$7cd122d781af9fa4)((0, $acw62.forwardRef)((r, a)=>{
    const { aspectRatio: o, className: s, descriptionText: i, embedCode: p, headingText: C, helperText: v, id: y, iframeTitle: L, showHelperInvalidText: M = !0, videoId: E, videoType: k, ..._ } = r, Z = k === "vimeo" ? L || "Vimeo video player" : L || "YouTube video player", O = k === "vimeo" ? `https://player.vimeo.com/video/${E}?autoplay=0&loop=0` : `https://www.youtube.com/embed/${E}?disablekb=1&autoplay=0&fs=1&modestbranding=0`, B = L ? `${L}` : "Video player", z = p && p.includes("<iframe") && !p.includes("title=") ? p.replace("<iframe ", `<iframe title="${B}" `) : p, I = "<strong>Error:</strong> This video player has not been configured properly. Please contact the site administrator.";
    let P = !1;
    !z && !k && !E ? (console.warn("NYPL Reservoir VideoPlayer: Pass in either the `embedCode` prop or both the `videoType` and `videoId` props; none were passed."), P = !0) : !z && !k ? (console.warn("NYPL Reservoir VideoPlayer: The `videoType` prop is also required. Only the `videoId` prop was set."), P = !0) : !z && !E ? (console.warn("NYPL Reservoir VideoPlayer: The `videoId` prop is also required. Only the `videoType` prop was set."), P = !0) : z && (k || E) && (console.warn("NYPL Reservoir VideoPlayer: Pass in either the `embedCode` prop or both the `videoType` and `videoId` props; all were set."), P = !0), E && (E.includes("://") || E.includes("http") || E.includes(".") || E.includes("youtube") || E.includes("vimeo")) && (console.warn("NYPL Reservoir VideoPlayer: The `videoId` prop is not configured properly."), P = !0), z && (!z.includes("vimeo.com") && !z.includes("youtube.com") || !z.includes("<iframe") || !z.includes("</iframe")) && (console.warn("NYPL Reservoir VideoPlayer: The `embedCode` prop is not configured properly."), P = !0);
    const W = (0, $6225152922b2fd2b$export$31cdfe60c085d76f)("VideoPlayer", {
        variant: P ? "invalid" : o
    }), l1 = z ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
        dangerouslySetInnerHTML: {
            __html: z
        }
    }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        as: "iframe",
        src: O,
        title: Z,
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture",
        allowFullScreen: !0,
        __css: W.iframe
    });
    return /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        className: s,
        "data-testid": "video-player-component",
        id: y,
        ref: a,
        __css: W.base,
        ..._,
        children: P ? /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx("span", {
            dangerouslySetInnerHTML: {
                __html: I
            }
        }) : /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx($0422a6ce4ea03acc$var$g7, {
            headingText: C || void 0,
            descriptionText: i || void 0,
            helperText: v && M ? v : void 0,
            id: `${y}-componentWrapper`,
            children: /* @__PURE__ */ $0422a6ce4ea03acc$var$x.jsx((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                __css: W.inside,
                children: l1
            })
        })
    });
}));


var $ee943623255de168$exports = {};

(function(global, factory) {
    factory($ee943623255de168$exports, (parcelRequire("acw62")));
})($ee943623255de168$exports, function(exports1, React) {
    "use strict";
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === "function") return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});



parcelRequire("acw62");

const $e3ca3f5e1802bbd9$var$ErrorFallback = ({ error: error })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$14834abbfce3b8cd), {
        id: "error-fallback",
        notificationContent: error.message,
        notificationHeading: "Something went wrong:",
        notificationType: "warning"
    });
};
var $e3ca3f5e1802bbd9$export$2e2bcd8739ae039 = $e3ca3f5e1802bbd9$var$ErrorFallback;




var $acw62 = parcelRequire("acw62");
var $666bc8f27f76152a$exports = {};
(function(global, factory) {
    $666bc8f27f76152a$exports = factory();
})($666bc8f27f76152a$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + converter.write(value, key) + stringifiedAttributes;
        }
        function get(key) {
            if (typeof document === "undefined" || arguments.length && !key) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var foundKey = decodeURIComponent(parts[0]);
                    jar[foundKey] = converter.read(value, foundKey);
                    if (key === foundKey) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(key, attributes) {
                set(key, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});




parcelRequire("acw62");

const $e665cb98c2500a79$var$ActionBar = ({ logout: logout, isSimpleList: isSimpleList, setIsSimpleList: setIsSimpleList })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2231dd843a1dfd59$export$f51f4c4ede09e011), {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$bea8ebba691c5813), {
                id: "librariesView",
                isChecked: isSimpleList,
                labelText: "View simple list",
                onChange: ()=>setIsSimpleList(!isSimpleList)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $405d81ccc3b181e4$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$353f5b6fc5456de1), {
                id: "logout",
                onClick: logout,
                children: "Log Out"
            })
        ]
    });
var $e665cb98c2500a79$export$2e2bcd8739ae039 = $e665cb98c2500a79$var$ActionBar;


const $9ecda7333d28e490$export$eed606b4351295d7 = `${"https://libraryregistry.librarysimplified.org/admin"}/log_in/jwt`;
const $9ecda7333d28e490$export$6c953e829e7f40b1 = `${"https://libraryregistry.librarysimplified.org/admin"}/refresh_token`;
const $9ecda7333d28e490$export$c71182b17e18bf57 = `${"https://libraryregistry.librarysimplified.org/admin"}/libraries/qa`;
const $9ecda7333d28e490$export$5d4fd42acd6c93b1 = `${"https://libraryregistry.librarysimplified.org/admin"}/libraries/registration`;



parcelRequire("acw62");

const $e1131a681a58b314$var$Header = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$887967f05dc521ae), {
        backgroundColor: "brand.primary",
        heading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$a8a3e93435678ff9), {
            id: "search-and-filter-heading",
            level: "one",
            text: "Library Registry Interface"
        }),
        heroType: "tertiary"
    });
};
var $e1131a681a58b314$export$2e2bcd8739ae039 = $e1131a681a58b314$var$Header;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");

const $7233a37c679405df$var$LibraryDetailsGrid = ({ content: content })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$54c2e3dc7acea9f5), {
        type: "dl",
        children: Object.keys(content).map((key)=>[
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                    children: key
                }, `${key}-0`),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                    children: content[key] || "None available"
                }, `${key}-1`)
            ])
    });
var $7233a37c679405df$export$2e2bcd8739ae039 = $7233a37c679405df$var$LibraryDetailsGrid;



parcelRequire("acw62");

const $b88086507b7cc5eb$var$StageSelect = ({ error: error, handleStageChange: handleStageChange, stage: stage, uuid: uuid, value: value })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0422a6ce4ea03acc$export$ef9b1a59e592288f), {
        id: `${stage}-${uuid}`,
        invalidText: error,
        isInvalid: error ? true : false,
        labelText: stage === "libraryStage" ? "Library Stage" : "Registry Stage",
        name: stage,
        onChange: (e)=>handleStageChange(stage, e.target.value),
        value: value,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                value: "testing",
                children: "Testing"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                value: "production",
                children: "Production"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                value: "cancelled",
                children: "Cancelled"
            })
        ]
    });
};
var $b88086507b7cc5eb$export$2e2bcd8739ae039 = $b88086507b7cc5eb$var$StageSelect;




var $acw62 = parcelRequire("acw62");
const $423101a32235d694$export$3e90a26ba68b9c65 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $423101a32235d694$export$e5cf4eff53e7947d = ({ children: children })=>{
    const [accessToken, setAccessToken] = (0, $acw62.useState)("");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($423101a32235d694$export$3e90a26ba68b9c65.Provider, {
        value: {
            accessToken: accessToken,
            setAccessToken: setAccessToken
        },
        children: children
    });
};
const $423101a32235d694$var$useTokenContext = ()=>{
    const context = (0, $acw62.useContext)($423101a32235d694$export$3e90a26ba68b9c65);
    if (typeof context === "undefined") throw new Error("useLibraries must be used within a LibraryProvider");
    return context;
};
var $423101a32235d694$export$2e2bcd8739ae039 = $423101a32235d694$var$useTokenContext;





var $acw62 = parcelRequire("acw62");
const $ad363a0571a68163$export$36cc305486645fc = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $ad363a0571a68163$export$1787108ab39b2917 = ({ children: children })=>{
    const [updatedLibrary, setUpdatedLibrary] = (0, $acw62.useState)();
    const [libraries, setLibraries] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (updatedLibrary) {
            // Find the index of the library with the same uuid as the one
            // that was recently updated.
            const indexOfElementToReplace = libraries.findIndex((library)=>library.uuid === updatedLibrary.uuid);
            // Replace the library at that index with the updatedLibrary.
            const updatedLibraries = libraries.slice();
            updatedLibraries.splice(indexOfElementToReplace, 1, updatedLibrary);
            // Set libraries to the updated list.
            setLibraries(updatedLibraries);
        }
    }, [
        updatedLibrary
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad363a0571a68163$export$36cc305486645fc.Provider, {
        value: {
            libraries: libraries,
            setLibraries: setLibraries,
            setUpdatedLibrary: setUpdatedLibrary
        },
        children: children
    });
};
const $ad363a0571a68163$var$useLibrariesContext = ()=>{
    const context = (0, $acw62.useContext)($ad363a0571a68163$export$36cc305486645fc);
    if (typeof context === "undefined") throw new Error("useLibraries must be used within a LibraryProvider");
    return context;
};
var $ad363a0571a68163$export$2e2bcd8739ae039 = $ad363a0571a68163$var$useLibrariesContext;


const $f2e22d429108d902$var$LibraryDetails = ({ library: library })=>{
    const { uuid: uuid, basic_info: basicInfo, urls_and_contact: urlsAndContact, areas: areas, stages: stages } = library;
    const [libraryStageError, setLibraryStageError] = (0, $acw62.useState)("");
    const [registryStageError, setRegistryStageError] = (0, $acw62.useState)("");
    const { accessToken: accessToken } = (0, $423101a32235d694$export$2e2bcd8739ae039)();
    const { setUpdatedLibrary: setUpdatedLibrary } = (0, $ad363a0571a68163$export$2e2bcd8739ae039)();
    const getEmailData = ()=>{
        const emailData = [];
        for(const key in urlsAndContact)if (key.split("_")[1] === "email") emailData.push([
            key.split("_").join(" "),
            urlsAndContact[key] || "None available"
        ]);
        return emailData;
    };
    const libraryTabsData = [
        {
            label: "Basic Information",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7233a37c679405df$export$2e2bcd8739ae039), {
                content: basicInfo
            })
        },
        {
            label: "Contact & URLs",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7233a37c679405df$export$2e2bcd8739ae039), {
                content: urlsAndContact
            })
        },
        {
            label: "Areas",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7233a37c679405df$export$2e2bcd8739ae039), {
                content: areas
            })
        }
    ];
    const fetchUpdatedLibrary = (stage)=>{
        const errorMessage = "We're having trouble displaying the updated stage. Try refreshing the page.";
        fetch(`${"https://libraryregistry.librarysimplified.org/admin"}/libraries/${uuid}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then((response)=>{
            if (response.ok) return response.json();
            else {
                stage === "libraryStage" ? setLibraryStageError(errorMessage) : setRegistryStageError(errorMessage);
                throw new Error("There was an issue fetching the recently updated library.");
            }
        }).then((response)=>{
            // Setting the updatedLibrary in LibrariesContext triggers a useEffect
            // which updates the libraries in Context to include the updatedLibrary.
            setUpdatedLibrary(response);
        }).catch((err)=>console.log(err.message));
    };
    const handleStageChange = (stage, value)=>{
        // The UPDATE_LIBRARY_STAGE endpoint expects the 'Library Stage' and the
        // 'Registry Stage' values, even if only one is being updated.
        const body = new FormData();
        body.append("uuid", uuid);
        body.append("Library Stage", stage === "libraryStage" ? value : stages.library_stage);
        body.append("Registry Stage", stage === "registryStage" ? value : stages.registry_stage);
        const errorMessage = "Library did not update. Please try again.";
        fetch((0, $9ecda7333d28e490$export$5d4fd42acd6c93b1), {
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
            method: "POST",
            body: body
        }).then((response)=>{
            if (response.ok) {
                // Reset errors in state to empty strings just in case they are set
                // to an old error.
                setLibraryStageError("");
                setRegistryStageError("");
                // If the POST request is successful, we'll follow it with a GET request
                // to fetch the library that was just updated.
                fetchUpdatedLibrary(stage);
            } else {
                stage === "libraryStage" ? setLibraryStageError(errorMessage) : setRegistryStageError(errorMessage);
                throw new Error("There was an issue updating this library.");
            }
        }).catch((err)=>console.log(err.message));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$a7fed597f4b8afd8), {
                id: `registry-form-${uuid}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0422a6ce4ea03acc$export$b534bc812df080fd), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$56e87bf42978147a), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b88086507b7cc5eb$export$2e2bcd8739ae039), {
                                error: libraryStageError,
                                handleStageChange: handleStageChange,
                                stage: "libraryStage",
                                value: stages.library_stage,
                                uuid: uuid
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$56e87bf42978147a), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b88086507b7cc5eb$export$2e2bcd8739ae039), {
                                error: registryStageError,
                                handleStageChange: handleStageChange,
                                stage: "registryStage",
                                value: stages.registry_stage,
                                uuid: uuid
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$54ec01a60f47d33d), {
                columnHeaders: [
                    "",
                    ""
                ],
                tableData: getEmailData(),
                useRowHeaders: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
                paddingTop: "m",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$b2539bed5023c21c), {
                    id: `tabs-${uuid}`,
                    tabsData: libraryTabsData
                })
            })
        ]
    });
};
var $f2e22d429108d902$export$2e2bcd8739ae039 = $f2e22d429108d902$var$LibraryDetails;



const $d0356446b016a3d0$var$LibrariesList = ({ error: error, isSimpleList: isSimpleList })=>{
    // isLoading is a flag used to render the SkeletonLoader while the app tries to
    // refresh the accessToken.
    const [isLoadingLibraries, setIsLoadingLibraries] = (0, $acw62.useState)(true);
    const { libraries: libraries } = (0, $ad363a0571a68163$export$2e2bcd8739ae039)();
    const returnListData = (0, $acw62.useCallback)(()=>{
        const listData = [];
        libraries.map((library)=>{
            const { name: name, number_of_patrons: number_of_patrons } = library.basic_info;
            const libraryNameandCount = [
                name,
                number_of_patrons
            ];
            listData.push(libraryNameandCount);
        });
        return listData;
    }, [
        libraries
    ]);
    (0, $acw62.useEffect)(()=>{
        // Once we have libraries, the SkeletonLoader should no longer display.
        if (libraries.length) setIsLoadingLibraries(false);
        else setIsLoadingLibraries(true);
    }, [
        libraries.length
    ]);
    // If there's an error, the SkeletonLoader should not be displayed.
    (0, $acw62.useEffect)(()=>{
        if (error) setIsLoadingLibraries(false);
    }, [
        error
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$5f1af8db9871e1d6), {
            __css: {
                color: "ui.error.primary"
            },
            children: error
        }) : isLoadingLibraries ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$27a22c945b52f415), {
            headingSize: 20,
            showContent: false,
            showImage: false
        }) : isSimpleList ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$54ec01a60f47d33d), {
            columnHeaders: [
                "Library Name",
                "Patron Count"
            ],
            columnHeadersBackgroundColor: "section.blogs.primary",
            tableData: returnListData()
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$54c2e3dc7acea9f5), {
            noStyling: true,
            type: "ul",
            children: libraries.map((library)=>{
                const { name: name } = library.basic_info;
                const { registry_stage: registryStage } = library.stages;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$a766cd26d0d69044), {
                        accordionData: [
                            {
                                accordionType: registryStage === "production" ? "default" : registryStage === "testing" ? "warning" : "error",
                                label: name,
                                panel: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2e22d429108d902$export$2e2bcd8739ae039), {
                                    library: library
                                })
                            }
                        ],
                        id: name
                    })
                }, library.uuid);
            })
        })
    });
};
var $d0356446b016a3d0$export$2e2bcd8739ae039 = $d0356446b016a3d0$var$LibrariesList;




var $acw62 = parcelRequire("acw62");




const $f47439b00a856a18$var$backgroundStyles = {
    background: "section.blogs.primary",
    margin: "auto",
    marginTop: "xxl",
    paddingBottom: "xl",
    paddingTop: "l",
    width: "400px"
};
const $f47439b00a856a18$var$formFieldStyles = {
    margin: "auto",
    width: "75%"
};
const $f47439b00a856a18$var$errorStyles = {
    color: "ui.error.primary",
    paddingTop: "xs",
    textAlign: "center"
};
const $f47439b00a856a18$var$LoginForm = ({ error: error, setError: setError })=>{
    const [username, setUsername] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const { setAccessToken: setAccessToken } = (0, $423101a32235d694$export$2e2bcd8739ae039)();
    const login = (e)=>{
        e.preventDefault();
        // Create a FormData object to store the username and password for sending
        // with the login request.
        const body = new FormData();
        body.append("username", username);
        body.append("password", password);
        fetch((0, $9ecda7333d28e490$export$eed606b4351295d7), {
            method: "POST",
            body: body
        }).then((response)=>{
            if (response.ok) {
                // Reset setError to an empty string just in case it is set to an old
                // error.
                setError("");
                return response.json();
            }
            if (response.status >= 400 && response.status < 502) // This error will be displayed to the user.
            setError("Your username or password is incorrect. Please try again.");
            throw new Error("There was a problem authenticating this user in LoginForm.tsx.");
        }).then((data)=>{
            // After a successful request, store the two tokens received in their
            // their appropriate places: the access token in context and the refresh
            // token in cookies.
            setAccessToken(data.access_token);
            (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).set("refreshToken", data.refresh_token, {
                sameSite: "lax",
                secure: true
            });
        }).catch((err)=>console.log(err.message));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2032f24e0e9145ee$export$e71c4d32a2263218), {
        __css: $f47439b00a856a18$var$backgroundStyles,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$a8a3e93435678ff9), {
                level: "two",
                size: "tertiary",
                __css: {
                    textAlign: "center"
                },
                children: "Log In"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0422a6ce4ea03acc$export$a7fed597f4b8afd8), {
                id: "login",
                onSubmit: (e)=>login(e),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$56e87bf42978147a), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$c86715117507e8e5), {
                            id: "username",
                            isRequired: true,
                            labelText: "Username",
                            onChange: (e)=>setUsername(e.target.value),
                            showRequiredLabel: false,
                            type: "text",
                            __css: $f47439b00a856a18$var$formFieldStyles
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$56e87bf42978147a), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$c86715117507e8e5), {
                            id: "password",
                            isRequired: true,
                            labelText: "Password",
                            onChange: (e)=>setPassword(e.target.value),
                            showRequiredLabel: false,
                            type: "password",
                            __css: $f47439b00a856a18$var$formFieldStyles
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$56e87bf42978147a), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$353f5b6fc5456de1), {
                            id: "submit",
                            type: "submit",
                            __css: $f47439b00a856a18$var$formFieldStyles,
                            children: "Submit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$75f76bb17920f318), {
                ariaAtomic: false,
                ariaLive: "assertive",
                id: "loginError",
                text: error && error,
                __css: $f47439b00a856a18$var$errorStyles
            })
        ]
    });
};
var $f47439b00a856a18$export$2e2bcd8739ae039 = $f47439b00a856a18$var$LoginForm;




const $c747204b81311f93$var$RegistryAdmin = ()=>{
    // Error feedback displayed to the user, if necessary.
    const [error, setError] = (0, $acw62.useState)("");
    // If isLoading is true, a SkeletonLoader is displayed. isLoading is set to
    // false after fetch calls are completed.
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    // isSimpleList determines whether the libraries will be rendered as accordions
    // with full details (false), or as a table of names and patron counts (true).
    const [isSimpleList, setIsSimpleList] = (0, $acw62.useState)(false);
    const { accessToken: accessToken, setAccessToken: setAccessToken } = (0, $423101a32235d694$export$2e2bcd8739ae039)();
    const { setLibraries: setLibraries } = (0, $ad363a0571a68163$export$2e2bcd8739ae039)();
    // The logout function resets the accessToken to an empty string and deletes
    // the refreshToken from cookie storage. This causes the LoginForm to be
    // displayed.
    const logout = ()=>{
        // Reset setError to an empty string just in case it is set to an old
        // error.
        setError("");
        setAccessToken("");
        (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).remove("refreshToken");
        setIsLoading(false);
    };
    const refresh = ()=>{
        // Look for the refreshToken cookie.
        const refreshToken = (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).get("refreshToken");
        // If a refreshToken exists, send it as a header to the refresh endpoint.
        if (refreshToken) fetch((0, $9ecda7333d28e490$export$6c953e829e7f40b1), {
            method: "POST",
            headers: {
                Authorization: `Bearer ${refreshToken}`
            }
        }).then((response)=>{
            if (response.ok) return response.json();
            else throw new Error("There was a problem refreshing this user's access token.");
        })// If the call is successful, save the new accessToken to tokenContext.
        // This will trigger the useEffect which will then call fetchLibraries.
        .then((data)=>{
            setAccessToken(data.access_token);
        })// If there's a problem refreshing, first log the error message. Then, use
        // the logout function to delete the accessToken (if one exists) and the
        // refreshToken. This will bring the user back to the LoginForm.
        .catch((err)=>{
            console.log(err.message);
            logout();
        });
        else // If no refreshToken exists, delete the accessToken (if there is one), and
        // setIsLoading to false so the user is brought back to the LoginForm.
        logout();
    };
    // Fetch the libraries with the accessToken.
    const fetchLibraries = ()=>{
        fetch((0, $9ecda7333d28e490$export$c71182b17e18bf57), {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then((response)=>{
            if (response.ok) {
                // Reset setError to an empty string just in case it is set to an old
                // error.
                setError("");
                return response.json();
            } else if (response.status === 401) // If the response status is 401, the accessToken may just be expired.
            // Try refreshing it.
            refresh();
            else setError("There was a problem fetching the libraries. Try refreshing the page, or logging in again.");
            throw new Error("There was a problem fetching libraries.");
        }).then((data)=>{
            setLibraries(data.libraries);
            setIsLoading(false);
        }).catch((err)=>{
            setIsLoading(false);
            console.log(err.message);
        });
    };
    // If a user refreshes the page, they will have lost their access token,
    // but may still have a refresh token in cookies, so try refreshing.
    // If there is an access token, fetch the libraries.
    (0, $acw62.useEffect)(()=>{
        if (!accessToken) refresh();
        else fetchLibraries();
    }, [
        accessToken
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$27a22c945b52f415), {
            "data-testid": "librariesSkeleton",
            showHeading: false,
            showContent: false
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$71380cf1ff238ad8), {
            header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1131a681a58b314$export$2e2bcd8739ae039), {}),
            contentTop: accessToken ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e665cb98c2500a79$export$2e2bcd8739ae039), {
                    logout: logout,
                    isSimpleList: isSimpleList,
                    setIsSimpleList: setIsSimpleList
                })
            }) : undefined,
            contentPrimary: accessToken ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0356446b016a3d0$export$2e2bcd8739ae039), {
                error: error,
                isSimpleList: isSimpleList
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f47439b00a856a18$export$2e2bcd8739ae039), {
                error: error,
                setError: setError
            })
        })
    });
};
var $c747204b81311f93$export$2e2bcd8739ae039 = $c747204b81311f93$var$RegistryAdmin;




function $3d74bff2846008b2$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee943623255de168$exports.ErrorBoundary), {
        FallbackComponent: (0, $e3ca3f5e1802bbd9$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0422a6ce4ea03acc$export$a1997ffb807ec042), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $423101a32235d694$export$e5cf4eff53e7947d), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad363a0571a68163$export$1787108ab39b2917), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c747204b81311f93$export$2e2bcd8739ae039), {})
                })
            })
        })
    });
}


// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("app"));
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d74bff2846008b2$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.36cbb227.js.map
